var mtg32 =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var MtgAppLecteur = __webpack_require__(2);
	var kernel = __webpack_require__(8);
	var DataInputStream = __webpack_require__(24);
	var DataOutputStream = __webpack_require__(195);
	__webpack_require__(273);
	// cet objet sera exporté dans www/mtg32jsmin.js, sous la var globale mtg32
	// par webpack.config.player.js (lancé via npm run build-player)
	module.exports = {
	  // c'est un constructeur en minuscule, mais ça reste comme ça
	  // pour garder une compatibilité ascendante
	  mtg32App: MtgAppLecteur,
	  // Transféré ici depuis kernel. Doit être gardé tel quel car utilisé par le player des manuels
	  /**
	   * Renvoie les dimensions d'une figure où chdoc est la chaîne Base64 décivant la figure.
	   * @param {type} chdoc
	   * @returns {Object}
	   */
	  getDimensions: function getDimensions(chdoc) {
	    var numeroVersion, natImageFond, nombreItems;
	    var ba = kernel.base64Decode(chdoc);
	    var inps = new DataInputStream(ba);
	    // On saute les 17 premiers octets qui contiennent une chaine
	    inps.skip(16);
	    numeroVersion = inps.readInt();
	    // Ligne suivante pour corriger un oubli dans la première version où le numéro de document
	    // était nul
	    if (numeroVersion === 0) numeroVersion = 5;
	    if (numeroVersion > DataInputStream.numeroVersionActif) {
	      // Amélioré version 4.4
	      throw new Error("IOException");
	    }
	    if (numeroVersion >= 6) inps.readFloat();
	    inps.readUTF(); // la langue dans laquelle a été créé le document
	    inps.skip(5);
	    natImageFond = inps.readByte();
	    if (natImageFond !== DataOutputStream.nat_noImage) {
	      inps.readBufferedImage();
	      if (numeroVersion > 10) {
	        inps.readInt();
	        inps.readInt();
	      }
	    }
	    // On lit un booléen indiquant si les codes d'items de menu correspondent à
	    // des items interdits ou non
	    inps.readBoolean();
	    // On charge l'éventuelle liste d'items de menus
	    nombreItems = inps.readInt();
	    if (nombreItems !== 0) {
	      for (var i = 0; i < nombreItems; i++) {
	        inps.readInt();
	      }
	    }
	    if (numeroVersion < 15) {
	      inps.readUTF();
	      inps.skip(5);
	    }
	    inps.readUTF();
	    var ob = {};
	    ob.x = inps.readInt();
	    ob.y = inps.readInt();
	    return ob;
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var Color = __webpack_require__(6);
	var Dimf = __webpack_require__(7);
	var InfoProx = __webpack_require__(13);
	var Nat = __webpack_require__(4);
	var Point = __webpack_require__(15);
	var Pointeur = __webpack_require__(16);
	var kernel = __webpack_require__(8);
	var CListeObjets = __webpack_require__(17);
	var CMathGraphDoc = __webpack_require__(193);
	var DataInputStream = __webpack_require__(24);
	
	module.exports = MtgAppLecteur;
	
	/**
	 * Classe permettant de gérer la création de figures MathGraph32 en JavaScript
	 * @constructor
	 * @param {boolean} bLoadTextes : true si on doit charger les textes suivant la langue
	 * et faux sinon. true par défaut.
	 * Lorsqu'une application mtgApp crée une instance de MtgAppLecteur (pour j3p par exemple)
	 * il ne faux pas recharger kernel.textes car cela a dékà été fait par mtgApp.
	 * @returns {MtgAppLecteur}
	 */
	function MtgAppLecteur(bLoadTextes) {
	  this.docs = [];
	  var lt = arguments.length === 0 ? true : bLoadTextes;
	  if (lt) {
	    var s = kernel.userLan();
	    switch (s) {
	      case "fr":
	        kernel.textes = __webpack_require__(270);
	        break;
	      case "es":
	        kernel.textes = __webpack_require__(271);
	        break;
	      default:
	        kernel.textes = __webpack_require__(272);
	    }
	  }
	}
	
	/*
	MtgAppLecteur.prototype.start = function(callBack) {
	  if (kernel.textes === undefined) {
	    textLoadLecteur.initTextes(callBack);
	  }
	  else callBack();
	}
	*/
	
	/**
	 * Ajoute le document par son id représenté par une chaîne chdoc en dataBase64
	 * @param {String} idDoc : L'id du comument ui sera celle du svg contenant la figure.
	 * @param {String} chdoc : Chaine base64 décrivant la figure (obtebue via MathGraph32 par
	 * le menu Edition - Copier le code de la figure (pour html)
	 * @param {Boolean} displayOnLoad : true si la figure doit être affichée dès le démarrage de la page.
	 * @param {Boolean} isActive : true si la figure répond dès le démarrage aux actions souris et clavier.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.addDoc = function (idDoc, chdoc, displayOnLoad, isActive) {
	  var svg, liste, li, i, nb, t, la;
	  svg = document.getElementById(idDoc);
	  if (svg === null) return;
	  if (svg.localName !== "svg") return;
	  //On rend tous les éléments du div parent non sélectionnables
	  var par = svg.parentNode;
	  // Ajout version mtgApp. Etait auparavant dans CEditeurFormule
	  if (par.style.position === "") par.style.position = "relative";
	  //
	
	  // kernel.disableSelection(par);
	  par.setAttribute("class", "text2jax_ignore"); // Ajout version 5.0.3
	  la = arguments.length;
	  var doc = new CMathGraphDoc(idDoc, la <= 2 ? true : displayOnLoad, la <= 3 ? true : isActive);
	  this.docs.push(doc);
	  var ba = kernel.base64Decode(chdoc);
	  var inps = new DataInputStream(ba);
	  doc.read(inps);
	  // Ajout version 4.9.2
	  /*
	  var r = kernel.cens("rect",{
	    width : "100%",
	    height : "100%",
	    fill : doc.couleurFond.rgb(),
	    "pointer-events" : "none"
	  });
	  svg.appendChild(r);
	  // L'image de fond éventuelle doit être affichée après l'éventuel rectangle servant à effacer la figure
	  // dans le cas d'une couleur de fond  qui n'est pas blanche
	  if (doc.imageFond !== null) {
	    var g = kernel.cens("image",{
	      x : 0,
	      y : 0,
	      width : doc.widthImageFond,
	      height : doc.heightImageFond,
	      "pointer-events" : "none"
	    });
	    g.setAttributeNS( "http://www.w3.org/1999/xlink", "href", "data:image/png;base64," + kernel.base64Encode(doc.imageFond,true));
	    // Modification version 5.1.2 pour que les traces éventuelles recouvrent l'imag de fonf
	    // svg.appendChild(g);
	    svg.insertBefore(g, doc.gTraces);
	  }
	  */
	  this.prepareTracesEtImageFond(svg, doc);
	  liste = new CListeObjets();
	  liste.ajoutePointsPunaises(doc.listePrincipale);
	  doc.listeARecalculer = new CListeObjets();
	  //Spécial JavaScript. Chaque document aura un membre pointCapture
	  doc.listeExclusion = liste;
	  var winit = parseInt(svg.getAttribute("width"));
	  var hinit = parseInt(svg.getAttribute("height"));
	  doc.dimf = new Dimf(winit, hinit);
	  // On crée un divdestiné à cotenir le svg servant à des affichages auxiliaires
	  var divSvgAux = kernel.ce("div", {
	    position: "absolute",
	    style: "position:absolute;left:0px;top:0px;width:" + winit + "px;height:" + hinit + "px;pointer-events:none"
	  });
	  par.appendChild(divSvgAux);
	
	  // On modifie si-nécessaire la dimension du svg destiné à afficher provisoirement les affichages de texte
	  // Si c'est la première figure, on le crée.
	  var svgAux = document.getElementById("mtgSvgAux");
	  if (svgAux === null) {
	    svgAux = kernel.cens("svg", {
	      id: "mtgSvgAux",
	      position: "absolute",
	      top: 0,
	      left: 0,
	      width: winit,
	      height: hinit,
	      visibility: "hidden"
	    });
	    divSvgAux.appendChild(svgAux);
	  } else {
	    /*
	    var w = parseInt(svgAux.getAttribute("width"));
	    var h = parseInt(svgAux.getAttribute("height"));
	    if (w < winit) svgAux.setAttribute("width", winit);
	    if (h < hinit) svgAux.setAttribute("height", hinit);
	    */
	    svgAux.setAttribute("width", winit);
	    svgAux.setAttribute("height", hinit);
	  }
	
	  t = this;
	  // On mémorise les gestioonaires de souris et de touch pour pouvoir éventuellement les détruire
	  this.onmdown = function (evt) {
	    t.onmousedown(evt);
	  };
	  this.onmmove = function (evt) {
	    t.onmousemove(evt);
	  };
	  this.onmup = function (evt) {
	    t.onmouseup(evt);
	  };
	  this.ontstart = function (evt) {
	    t.ontouchstart(evt);
	  };
	  this.ontmove = function (evt) {
	    t.ontouchmove(evt);
	  };
	  this.ontend = function (evt) {
	    t.ontouchend(evt);
	  };
	  this.ontcancel = function (evt) {
	    t.ontouchcancel(evt);
	  };
	  svg.addEventListener("mousedown", this.onmdown, false);
	  svg.addEventListener("mousemove", this.onmmove, false);
	  svg.addEventListener("mouseup", this.onmup, false);
	  svg.addEventListener("touchstart", this.ontstart, false);
	  svg.addEventListener("touchmove", this.ontmove, false);
	  svg.addEventListener("touchend", this.ontend, false);
	  svg.addEventListener("touchcancel", this.ontcancel, false);
	  // Pour chaque variable associée à un affichage de valeur avec boutons plus et moins on crée un div
	  li = doc.listePrincipale;
	  nb = 0;
	  for (i = li.longueur() - 1; i >= 0; i--) {
	    var el = li.get(i);
	    if (el.getNatureCalcul() === NatCal.NVariable) {
	      if (el.dialogueAssocie) {
	        el.creeDiv(nb);
	        nb++;
	      }
	    }
	  }
	};
	
	MtgAppLecteur.prototype.prepareTracesEtImageFond = function (svg, doc) {
	  var rect = kernel.cens("rect", {
	    width: "100%",
	    height: "100%",
	    fill: doc.couleurFond.rgb()
	  });
	  // Ligne suivante importante : Ce rectangle ne doit pas réagir aux événements souris
	  // Car sinon il y a problème lors de l'appel de display
	  rect.style.pointerEvents = "none";
	  svg.appendChild(rect);
	
	  doc.gTraces = kernel.cens("g", {
	    id: doc.idDoc + "Traces"
	  });
	  svg.appendChild(doc.gTraces);
	  if (doc.imageFond !== null) {
	    var g = kernel.cens("image", {
	      x: "0",
	      y: "0",
	      width: doc.widthImageFond,
	      height: doc.heightImageFond
	    });
	    g.setAttributeNS("http://www.w3.org/1999/xlink", "href", "data:image/png;base64," + kernel.base64Encode(doc.imageFond, true));
	    svg.insertBefore(g, doc.gTraces);
	  }
	};
	
	/**
	 * Fonction retirant le document d'id idDoc, retirant les gestionnaires d'événements qui lui sont associés
	 * et effaçant touts les éléments graphiques du svg associé
	 * @param {String} idDoc : L'id du document à retirer.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.removeDoc = function (idDoc) {
	  var svg, liste, ind;
	  svg = document.getElementById(idDoc);
	  if (svg !== null && svg.localName === "svg") {
	    while (svg.childNodes.length !== 0) {
	      svg.removeChild(svg.childNodes[0]);
	    }svg.removeEventListener("mousedown", this.onmdown, false);
	    svg.removeEventListener("mousemove", this.onmmove, false);
	    svg.removeEventListener("mouseup", this.onmup, false);
	    svg.removeEventListener("touchstart", this.ontstart, false);
	    svg.removeEventListener("touchmove", this.ontmove, false);
	    svg.removeEventListener("touchend", this.ontend, false);
	    svg.removeEventListener("touchcancel", this.ontcancel, false);
	  }
	  var doc = this.getDoc(idDoc);
	  if (doc !== null) {
	    liste = doc.listePrincipale;
	    if (svg !== null && svg.localName === "svg") liste.deleteComponents(svg); // Pour retirer les éditeurs et les boutons associés aux variables
	    liste.retireTout();
	    ind = this.indexOfDoc(idDoc);
	    this.docs.splice(ind, 1);
	  }
	};
	
	/**
	 * Fonction retirant tous les documents et effaçant le contenu de tous les svg contenant des figures.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.removeAllDoc = function () {
	  var nb = this.docs.length;
	  for (var i = 0; i < nb; i++) {
	    this.removeDoc(this.docs[0].idDoc);
	  }
	};
	
	/**
	 * Fonction recalculant toutes les figures et les affichant.
	 * @param {Boolean} brandom : Si true, les calculs aléatoires pas la fonction rand()
	 * sont réactualisés.
	 * Modifié pour qu'au premier démarrage on charge les textes de la langue utilisée
	 * @returns {undefined}
	 */
	/*
	MtgAppLecteur.prototype.calculateAndDisplayAll = function(brandom) {
	  if (kernel.textes === undefined) {
	    var self = this;
	    textLoadLecteur.initTextes(function() {
	      self.endCalculateAndDisplayAll(brandom)
	    });
	  }
	  else this.endCalculateAndDisplayAll(brandom);
	};
	*/
	MtgAppLecteur.prototype.calculateAndDisplayAll = function (brandom) {
	  var i, j;
	  for (i = 0; i < this.docs.length; i++) {
	    var doc = this.docs[i];
	    var liste = doc.listePrincipale;
	    var svg = document.getElementById(doc.idDoc);
	    var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	    this.prepareTracesEtImageFond(svg, doc);
	    var macroDem = liste.macroDemarrage;
	    if (macroDem !== null) {
	      // Ajout version 5.1
	      macroDem.setMacroLanceuse(null);
	      //
	      if (macroDem.className === "CMacroSuiteMacros") {
	        for (j = 0; j < macroDem.listeAssociee.longueur(); j++) {
	          macroDem.listeAssociee.get(j).execute(svg, dimf, doc.couleurFond, doc.opacity, false);
	        }
	      }
	      // Version 4.9.7 : Ajout d'un dernier paramètre pour que la macro ne crée pas d'élements graphiques
	      else liste.macroDemarrage.execute(svg, dimf, doc.couleurFond, doc.opacity, false);
	    }
	    liste.positionne(arguments.length === 0 ? false : brandom, dimf);
	    liste.setReady4MathJax();
	    MathJax.Hub.Queue([this.callBack, svg, doc]);
	  }
	};
	
	/**
	 * Fonction de callback appelée lorsque MathJax a traité toues les formules
	 * en LaTeX et que la figure est prête pour affichage.
	 * @param {mtg32.MathGraphDoc} doc : le document à afficher.
	 * @param {svg} svg : Le svg contenant la figure.
	 * @param {Dimf} dimf : Les diemnsions du svg contenant la figure.
	 * @param {Boolean} bDispOnLoad : true si on doit afficher la figure après calculs.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.callBack = function (svg, doc) {
	  var liste = doc.listePrincipale;
	  liste.afficheTout(0, svg, true, doc.couleurFond, doc.opacity);
	};
	/**
	 * Fonction demandant la validation de tous les éditeurs de formule de la figure associée
	 * au document d'id idDoc.
	 * Si la formule qu'ils contiennent est incorrecte ils se trouvent encadrés de rouge.
	 * Renvoie true uniquement si aucun éditeur de formule ne contient de faute de syntaxe.
	 * @param {type} idDoc
	 * @returns {Boolean}
	 */
	MtgAppLecteur.prototype.fieldsValidation = function (idDoc) {
	  return this.getDoc(idDoc).listePrincipale.fieldsValidation();
	};
	/**
	 * Fonction renvoyant true si le premier champ d'édition de la figure associée au document d'id idDoc
	 * associé au calcul nomCalcul est non vide.
	 * @param {String} idDoc : l'id du document contenant la figure interrogée.
	 * @param {String} nomCalcul : Le nom du calcul auquel est associé l'éditeur.
	 * @returns {unresolved}
	 */
	MtgAppLecteur.prototype.fieldValidation = function (idDoc, nomCalcul) {
	  return this.getDoc(idDoc).listePrincipale.fieldValidation(nomCalcul);
	};
	/**
	 * Fonction renvoyant le contenu du premier éditeur de formule asssocié au calcul nomCalcul
	 * dans le dcument d'id idDoc.
	 * @param {String} idDoc
	 * @param {type} nomCalcul
	 * @returns {String}
	 */
	MtgAppLecteur.prototype.getFieldValue = function (idDoc, nomCalcul) {
	  return this.getDoc(idDoc).listePrincipale.getFieldValue(nomCalcul);
	};
	/**
	 * Fonction activant le premier éditeur de formule contenant une
	 * formule qui n'est pas correcte sur le plan syntaxique dans le document d'id idDoc.
	 * @param {String} idDoc
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.activateFirstInvalidField = function (idDoc) {
	  this.getDoc(idDoc).listePrincipale.activateFirstInvalidField();
	};
	/**
	 * Fonction activant le premier éditeur de formule vide ou contenant une
	 * formule qui n'est pas correcte sur le plan syntaxique dans le document d'id idDoc
	 * @param {String} idDoc
	 * @returns {unresolved}
	 */
	MtgAppLecteur.prototype.activateFirstInvalidOrEmptyField = function (idDoc) {
	  this.getDoc(idDoc).listePrincipale.activateFirstInvalidOrEmptyField();
	};
	/**
	 * Fonction donnant le focus au premier éditeur de formule qui ne contient rien
	 * dans le document d'id idDoc
	 * @param {String} idDoc
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.activateFirstEmptyField = function (idDoc) {
	  this.getDoc(idDoc).listePrincipale.activateFirstEmptyField();
	};
	/**
	 * Fonction donnant le focus au premierr éditeur de formule asscoié au calcul
	 * ou à la fonction nommé nomCalcul dans le document d'id idDoc.
	 * @param {String} idDoc
	 * @param {Srring} nomCalcul
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.activateField = function (idDoc, nomCalcul) {
	  this.getDoc(idDoc).listePrincipale.activateField(nomCalcul);
	};
	/**
	 * Fonction donnant à l'élément graphique du document d'id idDoc et dont le n° d'identification html est
	 * ind la couleur doonée^par les composantes RVB (entiers compris entre 0 et 255)
	 * @param {String} idDoc
	 * @param {Integer} ind
	 * @param {Integer} r : Composante rouge de la couleur (entre 0 et 255).
	 * @param {Integer} v : Composante verte de la couleur (entre 0 et 255).
	 * @param {Integer} b : Composante bleue de la couleur (entre 0 et 255).
	 * @returns {Boolean}
	 */
	MtgAppLecteur.prototype.setColor = function (idDoc, ind, r, v, b) {
	  var color = new Color(r, v, b);
	  var doc = this.getDoc(idDoc);
	  if (doc === null) return false;
	  var liste = doc.listePrincipale;
	  var el = liste.getById(ind);
	  if (el === null) return false;
	  if (!el.estDeNature(NatObj.NTtObj)) return false;
	  el.donneCouleur(color);
	  var svg = document.getElementById(idDoc);
	  MathJax.Hub.Queue([liste.callBack, el, svg, doc.couleurFond, doc.opacity, true]);
	};
	/**
	 * Fonction vidant tous les éditeurs de formule de la figure d'id idDoc
	 * @param {String} idDoc
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.setEditorsEmpty = function (idDoc) {
	  this.getDoc(idDoc).listePrincipale.setEditorsEmpty();
	};
	/**
	 * Fonction mettant dans l'éditeur la chaîne de caractères st et mettant à jour
	 * en conséquence l'affichage de formule LaTeX s'il est activé, dans le document d'id idDoc
	 * @param {String} idDoc
	 * @param {String} nomCalcul
	 * @param {String} st
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.setEditorValue = function (idDoc, nomCalcul, st) {
	  this.getDoc(idDoc).listePrincipale.setEditorValue(nomCalcul, st);
	};
	/**
	 * Fonction attribuant à un éditeur de formule une chaîne de carcatères contenant
	 * les caracères autorisés.
	 * Si cette chaîne est vide, tous les caractères seront autorisés.
	 * @param {type} idDoc
	 * @param {type} nomCalcul
	 * @param {type} st
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.setEditorCharset = function (idDoc, nomCalcul, st) {
	  var liste = this.getDoc(idDoc).listePrincipale;
	  for (var i = 0; i < liste.longueur(); i++) {
	    var elb = liste.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule && elb.calculAssocie.nomCalcul === nomCalcul) {
	      elb.charset = st;
	      break;
	    }
	  }
	};
	/**
	 * Fonction associant, dans le document d'id idDoc, au premier éditeur associé à nomCalcul
	 * une fonction de callBack qui sera appelée quand l'utilisateur valide par OK le contenu de l'éditeur.
	 * @param {String} idDoc
	 * @param {String} nomCalcul
	 * @param {function} f : La fonction de callBack
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.setEditorCallBackOK = function (idDoc, nomCalcul, f) {
	  this.getDoc(idDoc).listePrincipale.setEditorCallBackOK(nomCalcul, f);
	};
	/**
	 * Renvoie la valeur actuelle du calcul réel nommé nomCalcul dans le document d'id idDoc.
	 * Renvoie -1 si le calcul n'existe pas.
	 * @param {String} idDoc
	 * @param {String} nomCalcul
	 * @returns {Float}
	 */
	MtgAppLecteur.prototype.valueOf = function (idDoc, nomCalcul) {
	  return this.getDoc(idDoc).listePrincipale.valueOf(nomCalcul);
	};
	/**
	 * Fonction changeant, dans le document d'id idDoc, la formule du calcul ou de
	 * la fonction (réelle ou complexe) de nom nomCalcul.
	 * La nouvelle formule est contenue dans la chaîne de caractères formule.
	 * Renvoie true si la formule était valide et false sinon.
	 * @param {String} idDoc
	 * @param {String} nomCalcul
	 * @param {String} formule
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.giveFormula2 = function (idDoc, nomCalcul, formule) {
	  var doc = this.getDoc(idDoc);
	  if (doc !== null) this.getDoc(idDoc).listePrincipale.giveFormula2(nomCalcul, formule);
	};
	/**
	 * Renvoie la formule en ligne (avec des *) du calcul ou de la fonction nommé nomCalcul
	 * contenue dans le document d'id idDoc.
	 * @param {String} idDoc
	 * @param {String} nomCalcul
	 * @returns {String}
	 */
	MtgAppLecteur.prototype.getFormula = function (idDoc, nomCalcul) {
	  var doc = this.getDoc(idDoc);
	  if (doc !== null) return this.getDoc(idDoc).listePrincipale.getFormula(nomCalcul);
	  return "";
	};
	// Ajout version 4.9.3
	/**
	 * Fonction renvoyant la formule LaTeX représentant le calcul ou la fonction
	 * dont le nom est nomCalcul dans le document d'id idDoc.
	 * @param {String} idDoc
	 * @param {String} nomCalcul
	 * @returns {String}
	 */
	MtgAppLecteur.prototype.getLatexFormula = function (idDoc, nomCalcul) {
	  var doc = this.getDoc(idDoc);
	  if (doc !== null) return this.getDoc(idDoc).listePrincipale.getLatexFormula(nomCalcul);
	  return "";
	};
	/**
	 * Fonction donnant à tous les éditeur de formule de la fiure d'id idDoc
	 * la taille size.
	 * Utilisé dans j3p.
	 * @param {String} idDoc
	 * @param {String} size
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.setEditorsSize = function (idDoc, size) {
	  var doc, liste, i, el;
	  doc = this.getDoc(idDoc);
	  if (doc !== null) {
	    liste = this.getDoc(idDoc).listePrincipale;
	    for (i = 0; i < liste.longueur(); i++) {
	      el = liste.get(i);
	      if (el.getNature() === NatObj.NEditeurFormule) {
	        el.editeur.style.fontSize = size;
	        el.latex.x_nom = el.x_nom + el.divi.clientWidth;
	        el.latex.y_nom = el.y_nom + el.editeur.clientHeight / 2;
	      }
	    }
	  }
	};
	/**
	 * Fonction recalculant la figure d'identifiant idDoc
	 * @param {String} idDoc
	 * @param {String} brandom
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.calculate = function (idDoc, brandom) {
	  var doc = this.getDoc(idDoc);
	  var svg = document.getElementById(idDoc);
	  var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	  if (doc !== null) doc.listePrincipale.positionne(brandom, dimf);
	};
	/**
	 * Fonction affichant la figure d'identifiant idDoc après avoir retiré tous
	 * les éléments graphiques du svg de la figure.
	 * @param {type} idDoc
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.display = function (idDoc) {
	  var doc = this.getDoc(idDoc);
	  var self = this;
	  if (doc !== null) {
	    // On retire d'abord tous les enfants du svg
	    var liste = doc.listePrincipale;
	    var svg = document.getElementById(idDoc);
	
	    MathJax.Hub.Queue(function () {
	      while (svg.childNodes.length !== 0) {
	        svg.removeChild(svg.childNodes[0]);
	      }
	      self.prepareTracesEtImageFond(svg, doc);
	    });
	    liste.setReady4MathJax();
	    // MathJax.Hub.Queue(new function() {liste.afficheTout(0, document.getElementById(doc.idDoc), true, doc.couleurFond, doc.opacity)});
	    /* Correction version WebPack
	    var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	    MathJax.Hub.Queue([this.callBack,doc,svg,dimf,true]);
	    */
	    MathJax.Hub.Queue([this.callBack, svg, doc]);
	  }
	};
	/**
	 * Fonction mettant à jour les éléments graphiques de la figure d'idDoc.
	 * @param {type} idDoc
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.updateDisplay = function (idDoc) {
	  var doc = this.getDoc(idDoc);
	  if (doc !== null) {
	    var liste = doc.listePrincipale;
	    var svg = document.getElementById(idDoc);
	    liste.update(svg, doc.couleurFond, doc.opacity, true);
	  }
	};
	/**
	 * Fonction exécutant la macro d'intitulé nameMacro dans la
	 * figure d'id idDoc.
	 * @param {String} idDoc
	 * @param {String} nameMacro
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.executeMacro = function (idDoc, nameMacro) {
	  var doc = this.getDoc(idDoc);
	  if (doc !== null) doc.listePrincipale.executeMacro(nameMacro);
	};
	/**
	 * Renvoie l'indice dlans le tableau this.docs du dooument d'id idDoc.
	 * @param {String} idDoc
	 * @returns {Integer}
	 */
	MtgAppLecteur.prototype.indexOfDoc = function (idDoc) {
	  for (var i = 0; i < this.docs.length; i++) {
	    if (this.docs[i].idDoc === idDoc) return i;
	  }
	  return -1;
	};
	/**
	 * Renvoie le document d'id idDoc du tableau this.docs.
	 * S'il n'y en a pas, renvoie null.
	 * @param {String} idDoc
	 * @returns {Array}
	 */
	MtgAppLecteur.prototype.getDoc = function (idDoc) {
	  var ind = this.indexOfDoc(idDoc);
	  return ind === -1 ? null : this.docs[ind];
	};
	/**
	 * Renvoie la liste CListeObjets contenant les objets du document d'id idDoc.
	 * @param {String} idDoc
	 * @returns {Array.listePrincipale}
	 */
	MtgAppLecteur.prototype.getList = function (idDoc) {
	  return this.getDoc(idDoc).listePrincipale;
	};
	/**
	 * Fonction renvoyant le code LaTeX de l'affichage LaTex d'indice ind dans la liste
	 * des objets créés (les indices commençant à zéro) dans le document d'id idDoc
	 * @param {String} idDoc
	 * @param {Integer} ind
	 * @returns {String}
	 */
	MtgAppLecteur.prototype.getLatexCode = function (idDoc, ind) {
	  var doc = this.getDoc(idDoc);
	  if (doc !== null) return doc.listePrincipale.getLatexCode(ind);
	  return "";
	};
	/**
	 * Rend la figure d'id idDoc réactive ou inative aux événements souris et clavier
	 * suivant la valeur du boolean ba.
	 * @param {String} idDoc
	 * @param {Boolean} ba
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.setActive = function (idDoc, ba) {
	  var doc = this.getDoc(idDoc);
	  if (doc !== null) {
	    doc.isActive = ba;
	    // Il faut aussi activer ou désactiver les champs d'édition de formule
	    var liste = doc.listePrincipale;
	    for (var i = 0; i < liste.longueur(); i++) {
	      var el = liste.get(i);
	      if (el.getNature() === NatObj.NEditeurFormule) el.editeur.readOnly = !ba;else {
	        if (el.getNatureCalcul() === NatCal.NVariable) {
	          if (el.dialogueAssocie) {
	            el.buttonplus.setAttribute("disabled", !ba);
	            el.buttonmoins.setAttribute("disabled", !ba);
	            el.buttonegal.setAttribute("disabled", !ba);
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * Fonction appelée lors des événements mouseMove sur la figure.
	 * @param {event} evt : evt.id conteint l'id de la figure sur laquelle agit l'événement.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.onmousemove = function (evt) {
	  var id = evt.target.id;
	  var doc = this.getDoc(id);
	  doc.hasMouse = true;
	  // if (doc.isActive && doc.pointCapture != null) {
	  if (doc.isActive) {
	    // var th = this;
	    // Ligne suivante modifiée version 4.9.9.4 car ralentit beaucoup chrome
	    // doc.listePrincipale.heapAddSetTimeOut(function(){th.mousemove(evt, doc)});
	    this.mousemove(evt, doc);
	    // Ajout version 4.9.2
	    if (doc.pointCapture !== null) {
	      evt.preventDefault();
	      evt.stopPropagation();
	    }
	  }
	};
	/**
	 * Fonction appelée lors des événements touchMove sur la figure.
	 * @param {event} evt : evt.id conteint l'id de la figure sur laquelle agit l'événement.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.ontouchmove = function (evt) {
	  var id = evt.target.id;
	  var doc = this.getDoc(id);
	  if (doc.isActive && doc.pointCapture !== null) {
	    // var th = this;
	    // Ligne suivante modifiée version 4.9.9.4 car ralentit beaucoup chrome
	    // doc.listePrincipale.heapAddSetTimeOut(function(){th.touchmove(evt)});
	    this.touchmove(evt);
	    // A revoir ne sert à rien
	    /*
	    if (doc.pointCapture !== null) { // Test rajouté version 4.9.9.4
	      evt.preventDefault();
	      evt.stopPropagation();
	    }
	    */
	  }
	};
	/**
	 * Fonction appelée lors des événements mouseDown sur la figure.
	 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.onmousedown = function (evt) {
	  var mac;
	  var id = evt.target.id;
	  var svg = document.getElementById(id);
	  var doc = this.getDoc(id);
	  if (!doc.isActive) return;
	  var liste = doc.listePrincipale;
	  var dimf = doc.dimf;
	  var couleurFond = doc.couleurFond;
	  var transp = doc.opacity;
	  // Sur les périphériques mobiles il peut y avoir deux événements générés quand on touche l'écran : onmousedown et ontouchstart
	  // Abandonné version MtgApp pour qu'on puisse sur PC tactile utiliser mouse et touch
	  if (doc.type === "touch") return;
	  doc.type = "mouse";
	  if (doc.pointCapture !== null) {
	    doc.pointCapture = null;
	    doc.listeARecalculer.retireTout();
	    return;
	  }
	  if (liste.macroEnCours !== null) {
	    mac = liste.macroEnCours.macroEnCours();
	    if (mac.className === "CMacroPause" && mac.dureePause === 0) {
	      mac.passageMacroSuiv(svg, dimf, couleurFond, transp);
	      return;
	    }
	    if (mac !== null && mac.className === "CMacroApparition" && mac.executionPossible()) {
	      mac.execute(svg, dimf, couleurFond, transp, true);
	      // Attention mac ne pointe plus forcément sur la macro en cours
	      if (liste.macroEnCours !== null && !liste.macroEnCours.macroEnCours().executionEnCours) liste.macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transp);
	      return;
	    }
	  }
	  var info = new InfoProx();
	  var tab = kernel.getMousePosition(evt);
	  var par = svg.parentNode;
	  var posdiv = kernel.getPosition2(par);
	  // var point = new Point(tab[0]-posdiv.x + par.offsetParent.scrollLeft, tab[1]-posdiv.y + par.offsetParent.scrollTop);
	  var point = new Point(tab[0] - posdiv[0], tab[1] - posdiv[1]);
	  var nbObjetsProches = liste.procheDePourCapture(Nat.or(NatObj.NPointMobile, NatObj.NMacro), point, info, doc.listeExclusion, true, "mouse");
	  if (nbObjetsProches > 0) {
	    if ((mac = info.infoParType[NatObj.indiceMacro].premierVoisin) !== null) {
	      if (mac.executionEnCours) {
	        mac.macroEnCours().termineAction(svg, dimf, couleurFond, transp);
	      } else {
	        if (liste.macroEnCours !== null) return;
	        // liste.deleteTraces(svg);
	        if (mac.executionPossible()) {
	          // Ajout version 4.8
	          liste.macroEnCours = mac;
	          // Ajout version 5.1
	          mac.setMacroLanceuse(null);
	          //
	          mac.initialise();
	          mac.execute(svg, dimf, couleurFond, transp, true);
	        }
	      }
	    } else {
	      if (!liste.documentProprietaire.modeTraceActive) liste.deleteTraces();
	      // liste.heapReset(mtg32.heapSizeWeb); // Plus utilisé verion 4.9.9.4
	      // doc.pointCapture = info.premierPointVoisin; // Modifi version 4.9.2
	      doc.pointCapture = info.dernierPointVoisin;
	      doc.listeARecalculer.retireTout();
	      doc.listeARecalculer.ajouteObjetsDependantsSauf(doc.pointCapture, doc.listePrincipale, null);
	    }
	  } else {
	    if (liste.macroEnCours !== null) {
	      if (liste.macroEnCours.className === "CMacroSuiteMacros") {
	        mac = liste.macroEnCours.macroEnCours();
	        if (mac.arretParClic()) {
	          mac.termineAction(svg, dimf, couleurFond, transp);
	          liste.macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transp);
	        }
	        // passageMacroSuiv redonne éventuellement un ordre paint() suivant la nature de la macro suivante
	      } else {
	        // Si la macro en cours est une macro d'apparition avec clic pour objet suivant
	        // on ne la désactive que si on est au dernier objet
	        mac = liste.macroEnCours.macroEnCours();
	        if (mac.className === "CMacroApparition" && mac.executionEnCours) {
	          // mac.actionDansPaint(cadre);
	          // cadre.paneFigure.repaint();
	          this.liste.update(svg, couleurFond, transp);
	        } else {
	          if (mac.arretParClic()) {
	            mac.termineAction(svg, dimf, couleurFond, transp);
	            // this.liste.macroEnCours = null;
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * Fonction de callBack appelée lors des événements mouseMove.
	 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.mousemove = function (evt) {
	  var point;
	  var id = evt.target.id;
	  var svg = document.getElementById(id);
	  var doc = this.getDoc(id);
	  var tab = kernel.getMousePosition(evt);
	  var par = svg.parentNode;
	  var posdiv = kernel.getPosition2(par);
	  var x = tab[0] - posdiv[0]; //  + par.offsetParent.scrollLeft;
	  var y = tab[1] - posdiv[1]; // + par.offsetParent.scrollTop;
	  if (doc.pointCapture === null) {
	    var info = new InfoProx();
	    point = new Point(x, y);
	    var nbObjetsProches = doc.listePrincipale.procheDePourCapture(NatObj.NPointMobile, point, info, doc.listeExclusion, true, "mouse");
	    document.body.style.cursor = nbObjetsProches > 0 ? "pointer" : "default";
	  } else {
	    var dimf = doc.dimf;
	    var couleurFond = doc.couleurFond;
	    var transp = doc.opacity;
	    if (Math.abs(x - doc.pointCapture.x) >= 1 || Math.abs(y - doc.pointCapture.y) >= 1) {
	      point = new Point();
	      var abs = new Pointeur();
	      var b = doc.pointCapture.testDeplacement(dimf, x, y, point, abs);
	      if (b) {
	        if (doc.pointCapture.estDeNature(NatObj.NPointCapturableNonLie)) {
	          doc.pointCapture.placeEn(point.x, point.y);
	        } else if (doc.pointCapture.estDeNature(NatObj.NPointLie)) {
	          doc.pointCapture.donneAbscisse(abs.getValue());
	        }
	      }
	      doc.listeARecalculer.positionne(false, dimf);
	      doc.listeARecalculer.update(svg, couleurFond, transp, true);
	    }
	  }
	};
	/**
	 * Fonction de callBack appelée lors des événements mouseUp.
	 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.ondeviceup = function (evt) {
	  var id = evt.target.id;
	  var svg = document.getElementById(id);
	  var doc = this.getDoc(id);
	  if (!doc.isActive) return;
	  if (doc.pointCapture !== null) {
	    doc.pointCapture = null;
	    doc.listeARecalculer.retireTout();
	    // Modifié version 5.0.3
	    // doc.listePrincipale.update(svg, doc.couleurFond, doc.opacity, true);
	    doc.listeARecalculer.update(svg, doc.couleurFond, doc.opacity, true);
	    document.body.style.cursor = "default";
	  }
	};
	/**
	 * Fonction de callBack appelée lors des événements touchStart.
	 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
	 * @param {type} evt
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.ontouchstart = function (evt) {
	  var mac;
	  var id = evt.target.id;
	  var svg = document.getElementById(id);
	  var doc = this.getDoc(id);
	  if (!doc.isActive) return;
	  var liste = doc.listePrincipale;
	  var dimf = doc.dimf;
	  var couleurFond = doc.couleurFond;
	  var transp = doc.opacity;
	  // Sur les périphériques mobiles il peut y avoir deux événements générés quand on touche l'écran : onmousedown et ontouchstart
	  // if (doc.type && (doc.type == "mouse")) return;
	  doc.type = "touch";
	  if (doc.pointCapture !== null) {
	    doc.pointCapture = null;
	    doc.listeARecalculer.retireTout();
	    return;
	  }
	  if (liste.macroEnCours !== null) {
	    mac = liste.macroEnCours.macroEnCours();
	    if (mac.className === "CMacroPause" && mac.dureePause === 0) {
	      mac.passageMacroSuiv(svg, dimf, couleurFond, transp);
	      return;
	    }
	    if (mac !== null && mac.className === "CMacroApparition" && mac.executionPossible()) {
	      mac.execute(svg, dimf, couleurFond, transp, true);
	      // Attention mac ne pointe plus forcément sur la macro en cours
	      if (!liste.macroEnCours.macroEnCours().executionEnCours) liste.macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transp);
	      return;
	    }
	  }
	  var info = new InfoProx();
	  var tab = kernel.getTouchPosition(evt);
	  var par = svg.parentNode;
	  // var offs = kernel.getOffset(par); // Version 4.9.9.4 : Ne pas appeler getOffset sur le svg mais sur le div parent
	  // Modification version MtgApp car ne marchait plus avec ascenseurs sur mobile
	  var offs = kernel.getPosition2(par);
	  // var posdiv = kernel.getPosition2(par);
	  // var point = new Point(tab[0]-posdiv.x + par.offsetParent.scrollLeft, tab[1]-posdiv.y + par.offsetParent.scrollTop);
	  // var point = new Point(tab[0]-par.offsetLeft, tab[1]-par.offsetTop);
	  // var point = new Point(tab[0]-offs[0], tab[1]-offs[1]);
	  // Modifié version mtgApp
	  var point = new Point(tab[0] - offs[0], tab[1] - offs[1]);
	  var nbObjetsProches = liste.procheDePourCapture(Nat.or(NatObj.NPointMobile, NatObj.NMacro), point, info, doc.listeExclusion, true, "touch");
	  if (nbObjetsProches > 0) {
	    if ((mac = info.infoParType[NatObj.indiceMacro].premierVoisin) !== null) {
	      if (mac.executionEnCours) {
	        mac.macroEnCours().termineAction(svg, dimf, couleurFond, transp);
	      } else {
	        if (liste.macroEnCours !== null) return;
	        if (!doc.modeTraceActive) liste.deleteTraces();
	        liste.macroEnCours = mac;
	        mac.initialise();
	        mac.execute(svg, dimf, couleurFond, transp, true);
	      }
	    } else {
	      if (!doc.modeTraceActive) liste.deleteTraces();
	      doc.pointCapture = info.dernierPointVoisin;
	      // liste.heapReset(mtg32.heapSizeMobile); // Plus utilisé version 4.9.9.4
	      // var ch = evt.target.id.substring(this.liste.id.length);
	      // doc.pointCapture = this.liste.get(ch);
	      doc.listeARecalculer.retireTout();
	      doc.listeARecalculer.ajouteObjetsDependantsSauf(doc.pointCapture, liste, null);
	      evt.preventDefault();
	      evt.stopPropagation();
	    }
	  } else {
	    if (liste.macroEnCours !== null) {
	      if (liste.macroEnCours.className === "CMacroSuiteMacros") {
	        mac = liste.macroEnCours.macroEnCours();
	        if (mac.arretParClic()) {
	          mac.termineAction(svg, dimf, couleurFond, transp);
	          liste.macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transp);
	        }
	        // passageMacroSuiv redonne éventuellement un ordre paint() suivant la nature de la macro suivante
	      } else {
	        // Si la macro en cours est une macro d'apparition avec clic pour objet suivant
	        // on ne la désactive que si on est au dernier objet
	        mac = liste.macroEnCours.macroEnCours();
	        if (mac.className === "CMacroApparition" && mac.executionEnCours) {
	          // mac.actionDansPaint(cadre);
	          // cadre.paneFigure.repaint();
	          liste.update(svg, couleurFond, transp);
	        } else {
	          if (mac.arretParClic()) {
	            mac.termineAction(svg, dimf, couleurFond, transp);
	            // this.liste.macroEnCours = null;
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * Fonction de callBack appelée lors des événements touchMove.
	 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.touchmove = function (evt) {
	  var id = evt.target.id;
	  var svg = document.getElementById(id);
	  var doc = this.getDoc(id);
	  if (doc.pointCapture !== null) {
	    var dimf = doc.dimf;
	    var couleurFond = doc.couleurFond;
	    var transp = doc.opacity;
	    var tab = kernel.getTouchPosition(evt);
	    var par = svg.parentNode;
	    // var offs = kernel.getOffset(par); // Version 4.9.9.4 : Ne pas appeler getOffset sur le svg mais sur le div parent
	    // Modification version MtgApp car ne marchait plus avec ascenseurs sur mobile
	    var offs = kernel.getPosition2(par);
	    // var posdiv = kernel.getPosition2(par);
	    // var x = tab[0] - par.offsetLeft; // + par.offsetParent.scrollLeft;
	    // var y = tab[1] - par.offsetTop; // + par.offsetParent.scrollTop;
	    // var x = tab[0] - offs[0]; // + par.offsetParent.scrollLeft;
	    // var y = tab[1] - offs[1]; // + par.offsetParent.scrollTop;
	    // Modifié version mtgApp
	    var x = tab[0] - offs[0]; // + par.offsetParent.scrollLeft;
	    var y = tab[1] - offs[1]; // + par.offsetParent.scrollTop;
	
	    if (Math.abs(x - doc.pointCapture.x) >= 1 || Math.abs(y - doc.pointCapture.y) >= 1) {
	      var point = new Point();
	      var abs = new Pointeur();
	      var b = doc.pointCapture.testDeplacement(dimf, x, y, point, abs);
	      if (b) {
	        if (doc.pointCapture.estDeNature(Nat.or(NatObj.NPointBase, NatObj.NPointBaseEnt, NatObj.NPointInterieurCercle, NatObj.NPointInterieurPolygone))) {
	          doc.pointCapture.placeEn(point.x, point.y);
	        } else if (doc.pointCapture.estDeNature(NatObj.NPointLie)) {
	          doc.pointCapture.donneAbscisse(abs.getValue());
	        }
	      }
	      doc.listeARecalculer.positionne(false, dimf);
	      doc.listeARecalculer.update(svg, couleurFond, transp, true);
	    }
	  }
	};
	/**
	 * Fonction de callBack appelée lors des événements touchEnd.
	 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.ontouchend = function (evt) {
	  /*
	  var id = evt.target.id;
	  var doc = this.getDoc(id);
	  doc.type = ""; // On autorise à nouveau tous les événements
	  */
	  this.ondeviceup(evt);
	};
	/**
	 * Fonction de callBack appelée lors des événements touchCancel.
	 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
	 * @returns {undefined}
	 */
	MtgAppLecteur.prototype.ontouchcancel = function (evt) {
	  this.ondeviceup(evt);
	};
	
	// Quand il y a à la fois des éléments mouse et touch générés, les événements touch sont toujours en premier
	// et les mouse en derniers
	// On met doc.type à "" pour autoriser à nouveau tous les types d'événements sur un mouseup
	MtgAppLecteur.prototype.onmouseup = function (evt) {
	  this.ondeviceup(evt);
	  var id = evt.target.id;
	  var doc = this.getDoc(id);
	  doc.type = ""; // On autorise à nouveau tous les événements
	};
	// Ajout version 4.9.7.
	// Renvoie un objet de type CListeObjets créé à partir d'une chaîne base64 d'une figure.
	// Sert à gérer des objets de type calcul sans gérer une figure
	/**
	 * Renvoie un objet de type CListeObjets créé à partir d'une chaîne base64 d'une figure.
	 * Sert à gérer des objets de type calcul sans gérer une figure.
	 * @param {String} code : Le code Base64 de la figure obtenu dans mtg32 par
	 * Edition - Copier le code de la figure.
	 * @returns {CListeObjets}
	 */
	MtgAppLecteur.prototype.createList = function (code) {
	  var doc = new CMathGraphDoc(null, false, false);
	  var ba = kernel.base64Decode(code);
	  var inps = new DataInputStream(ba);
	  doc.read(inps);
	  return doc.listePrincipale;
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by yvesb on 22/10/2016.
	 */
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Nat = __webpack_require__(4);
	
	/**
	 *
	 * @type NatObj
	 */
	var NatObj = {
	  NAucunObjet: new Nat(0, 0),
	  NPointBase: new Nat(1, 0),
	  NPoint: new Nat(1 << 1, 0), //2 puissance1=2
	  NPointLie: new Nat(1 << 2, 0),
	  NBarycentre: new Nat(1 << 3, 0),
	  NPointDansRepere: new Nat(1 << 4, 0),
	  NPointBaseEnt: new Nat(1 << 5, 0),
	  NPointParAffixe: new Nat(1 << 6, 0),
	  NPointLiePoint: new Nat(1 << 7, 0),
	  NMacro: new Nat(1 << 8, 0),
	  indiceMacro: 8,
	  NDroite: new Nat(1 << 9, 0),
	  NVecteur: new Nat(1 << 10, 0),
	  NSegment: new Nat(1 << 11, 0),
	  NDemiDroite: new Nat(1 << 12, 0),
	  NCercle: new Nat(1 << 13, 0),
	  NMarqueAngle: new Nat(1 << 14, 0),
	  NArc: new Nat(1 << 15, 0),
	  NPolygone: new Nat(1 << 16, 0),
	  NSurface: new Nat(1 << 17, 0),
	  NLieu: new Nat(1 << 18, 0),
	  NLieuDiscret: new Nat(1 << 19, 0),
	  NLigneBrisee: new Nat(1 << 20, 0),
	  NLieuObjet: new Nat(1 << 21, 0),
	  NImage: new Nat(1 << 22, 0),
	  NGrapheSuiteRec: new Nat(1 << 23, 0),
	  NGrapheSuiteRecComplexe: new Nat(1 << 24, 0),
	  NCommentaire: new Nat(1 << 25, 0),
	  NValeurAffichee: new Nat(1 << 26, 0),
	  NMarqueSegment: new Nat(1 << 27, 0),
	  NObjetDuplique: new Nat(1 << 28, 0),
	  NDemiPlan: new Nat(1 << 29, 0),
	  // Attention : Dans la version java, le repère est non graphique
	  // Il est considéré comme non graphique car dans les constructions il est choisi en premier dans
	  // les objets non graphiques
	  NRepere: new Nat(1 << 30, 0),
	  NTransformation: new Nat(0, 1), // JavaScript pas plus de 31 bits pour entier non signé
	  NBipoint: new Nat(0, 1 << 1), // 2^32. Pas de décalages de plus de 32 bits en javascript
	  NImplementationProto: new Nat(0, 1 << 2),
	  NPointInterieurPolygone: new Nat(0, 1 << 3),
	  NLatex: new Nat(0, 1 << 4),
	  NPointInterieurCercle: new Nat(0, 1 << 5),
	  NEditeurFormule: new Nat(0, 1 << 6), // Ajout version 4.5.2
	  NPointClone: new Nat(0, 1 << 7),
	  NDroiteClone: new Nat(0, 1 << 8),
	  NDemiDroiteClone: new Nat(0, 1 << 9),
	  NSegmentClone: new Nat(0, 1 << 10),
	  NCercleClone: new Nat(0, 1 << 11),
	  nombreTypesObjetsGraphiques: 42
	};
	
	NatObj.NTtPointSaufPointBase = Nat.or(NatObj.NPoint, NatObj.NPointLie, NatObj.NBarycentre, NatObj.NPointDansRepere, NatObj.NPointBaseEnt, NatObj.NPointParAffixe, NatObj.NPointLiePoint, NatObj.NPointInterieurPolygone, NatObj.NPointInterieurCercle);
	NatObj.NTtPoint = Nat.or(NatObj.NPointBase, NatObj.NTtPointSaufPointBase);
	/*
	NatObj.NToutPointSaufPointLie = Nat.or(NatObj.NPointBase , NatObj.NPoint , NatObj.NBarycentre ,
	  NatObj.NPointDansRepere , NatObj.NPointBaseEnt , NatObj.NPointParAffixe , NatObj.NPointLiePoint ,
	  NatObj.NPointInterieurPolygone , NatObj.NPointInterieurCercle);
	*/
	NatObj.NTtObj = Nat.or(NatObj.NTtPoint, NatObj.NMacro, NatObj.NDroite, NatObj.NVecteur, NatObj.NSegment, NatObj.NDemiDroite, NatObj.NCercle, NatObj.NMarqueAngle, NatObj.NArc, NatObj.NPolygone, NatObj.NSurface, NatObj.NLieu, NatObj.NLieuDiscret, NatObj.NLigneBrisee, NatObj.NLieuObjet, NatObj.NImage, NatObj.NGrapheSuiteRec, NatObj.NGrapheSuiteRecComplexe, NatObj.NCommentaire, NatObj.NLatex, NatObj.NValeurAffichee, NatObj.NMarqueSegment, NatObj.NObjetDuplique, NatObj.NDemiPlan, NatObj.NRepere, NatObj.NEditeurFormule);
	NatObj.NTtObjSaufDuplique = Nat.or(NatObj.NTtPoint, NatObj.NMacro, NatObj.NDroite, NatObj.NVecteur, NatObj.NSegment, NatObj.NDemiDroite, NatObj.NCercle, NatObj.NMarqueAngle, NatObj.NArc, NatObj.NPolygone, NatObj.NSurface, NatObj.NLieu, NatObj.NLieuDiscret, NatObj.NLigneBrisee, NatObj.NLieuObjet, NatObj.NImage, NatObj.NGrapheSuiteRec, NatObj.NGrapheSuiteRecComplexe, NatObj.NCommentaire, NatObj.NLatex, NatObj.NValeurAffichee, NatObj.NMarqueSegment, NatObj.NDemiPlan, NatObj.NRepere, NatObj.NEditeurFormule);
	NatObj.NTteDroite = Nat.or(NatObj.NDroite, NatObj.NSegment, NatObj.NDemiDroite, NatObj.NVecteur);
	NatObj.NTteDroiteSaufVect = Nat.or(NatObj.NDroite, NatObj.NSegment, NatObj.NDemiDroite);
	NatObj.NObjLigne = Nat.or(NatObj.NTteDroite, NatObj.NCercle, NatObj.NMarqueAngle, NatObj.NArc, NatObj.NPolygone, NatObj.NLieu, NatObj.NLigneBrisee, NatObj.NGrapheSuiteRec, NatObj.NGrapheSuiteRecComplexe);
	NatObj.NTtCercle = Nat.or(NatObj.NCercle, NatObj.NArc);
	NatObj.NObjNommable = Nat.or(NatObj.NTtPoint, NatObj.NDroite);
	NatObj.NPointMobile = Nat.or(NatObj.NPointBase, NatObj.NPointLie, NatObj.NPointBaseEnt, NatObj.NPointInterieurPolygone, NatObj.NPointInterieurCercle);
	NatObj.NAffLieAPoint = Nat.or(NatObj.NCommentaire, NatObj.NLatex, NatObj.NValeurAffichee, NatObj.NMacro, NatObj.NImage, NatObj.NEditeurFormule);
	NatObj.NTtObjPourLieu = Nat.or(NatObj.NTteDroite, NatObj.NCercle, NatObj.NArc, NatObj.NLieu, NatObj.NLieuDiscret, NatObj.NPolygone, NatObj.NLigneBrisee, NatObj.NValeurAffichee, NatObj.NCommentaire, NatObj.NLatex, NatObj.NTtPointSaufPointBase, NatObj.NLieuObjet);
	/*
	NatObj.NObjGraphiqueSourcePourConst = Nat.or(NatObj.NTtPoint , NatObj.NSegment , NatObj.NDroite
	  , NatObj.NDemiDroite , NatObj.NCercle , NatObj.NArc , NatObj.NPointDansRepere
	  , NatObj.NPointLiePoint , NatObj.NVecteur
	  , NatObj.NPolygone , NatObj.NLigneBrisee , NatObj.NPointParAffixe , NatObj.NLieu);
	*/
	NatObj.NPointCapturableNonLie = Nat.or(NatObj.NPointBase, NatObj.NPointBaseEnt, NatObj.NPointInterieurCercle, NatObj.NPointInterieurPolygone);
	NatObj.NComouLatex = Nat.or(NatObj.NCommentaire, NatObj.NLatex);
	
	// Après le rajout des macros qui sont des objets graphiques, il a
	// fallu créer un tableau de conversion qui, à la nature d'un objet
	// associe son numéro d'objet graphique, compris entre 0 et
	// NombreTypesDesignables - 1
	
	NatObj.nombreTypesDesignables = 34; // Modifié version 4.5.2
	
	NatObj.conversionNumeroNature = [NatObj.NPointBase, NatObj.NPoint, NatObj.NPointLie, NatObj.NBarycentre, NatObj.NPointDansRepere, NatObj.NPointBaseEnt, NatObj.NPointParAffixe, NatObj.NPointLiePoint, NatObj.NMacro, NatObj.NDroite, NatObj.NVecteur, NatObj.NSegment, NatObj.NDemiDroite, NatObj.NCercle, NatObj.NMarqueAngle, NatObj.NArc, NatObj.NPolygone, NatObj.NSurface, NatObj.NLieu, NatObj.NLieuDiscret, NatObj.NLigneBrisee, NatObj.NLieuObjet, NatObj.NImage, NatObj.NGrapheSuiteRec, NatObj.NGrapheSuiteRecComplexe, NatObj.NCommentaire, NatObj.NValeurAffichee, NatObj.NMarqueSegment, NatObj.NObjetDuplique, NatObj.NDemiPlan, NatObj.NPointInterieurPolygone, NatObj.NLatex, NatObj.NPointInterieurCercle, NatObj.NEditeurFormule];
	
	/** Fonction pas utilisée dans la version C++ renvoyant l'indice de la
	 nature de l'objet dont la nature est nat
	 *  Pour fonctionner correctement, nat ne doit pas être nul avant appel.
	 **/
	/**
	 * Du au fait que NPointInterieurPolygone est défini après des objets non graphiques
	 * @param indice
	 * @return
	 */
	
	NatObj.indiceNatureGraphique = function (indice) {
	  if (indice < 30) return indice;else return indice - 4;
	};
	NatObj.indiceDeNature = function (nat) {
	  if (!nat instanceof Nat) return false;
	  var natClone = nat.getClone();
	  var indnat = 0;
	  var typeTrouve = false;
	  while (!typeTrouve && indnat <= 30) {
	    if (natClone.low % 2 === 0) {
	      indnat++;
	      natClone.low >>= 1;
	    } else typeTrouve = true;
	  } //while
	  if (!typeTrouve) {
	    while (!typeTrouve && indnat <= 60) {
	      if (natClone.high % 2 === 0) {
	        indnat++;
	        natClone.high >>= 1;
	      } else typeTrouve = true;
	    } //while
	  }
	  return NatObj.indiceNatureGraphique(indnat);
	};
	
	module.exports = NatObj;

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	module.exports = Nat;
	/**
	 * Classe servant à définir la nature d'un objet simulant un entier sur 64 octets
	 * en utilisant deux entiers sur 32 octets.
	 * Chaque nature est caractérisée par un bit (de 0 à 63)
	 * @constructor
	 * @param {Integer} low : Les 32 premeirs bits
	 * @param {Integer} high : Les 32 derniers bits.
	 * @returns {Nat}
	 */
	function Nat(low, high) {
	  this.low = low;
	  this.high = high;
	}
	Nat.prototype.constructor = Nat;
	/**
	 * Fonction acceptant un nombre quelconque d'arguments et renvoyant un objet Nat
	 * formé du ET logique appliqué à tous les arguments.
	 * @returns {Nat}
	 */
	Nat.and = function () {
	  var a = 0xFFFFFFFF;
	  var b = 0xFFFFFFFF;
	  for (var i = 0; i < arguments.length; i++) {
	    var p = arguments[i];
	    a &= p.low;
	    b &= p.high;
	  }
	  return new Nat(a, b);
	};
	/**
	 * Fonction acceptant un nombre quelconque d'arguments et renvoyant un objet Nat
	 * formé du OU logique appliqué à tous les arguments.
	 * @returns {Nat}
	 */
	Nat.or = function () {
	  var a = 0x0000;
	  var b = 0x0000;
	  for (var i = 0; i < arguments.length; i++) {
	    var p = arguments[i];
	    a |= p.low;
	    b |= p.high;
	  }
	  return new Nat(a, b);
	};
	/**
	 * Renvoie true si low et high sont tous les deux nuls.
	 * @returns {Boolean}
	 */
	Nat.prototype.isZero = function () {
	  return this.low === 0 && this.high === 0;
	};
	/**
	 * Renvoie true si au moins un des deux low et high est non nul.
	 * @returns {Boolean}
	 */
	Nat.prototype.isNotZero = function () {
	  return !this.isZero();
	};
	/**
	 * Renvoie un clone de this
	 * @returns {Nat}
	 */
	Nat.prototype.getClone = function () {
	  return new Nat(this.low, this.high);
	};
	/**
	 * Renvoie true si les ET logique des 64 bits de this avec celui de nat
	 * est non nul.
	 * Sert à savoir si un objet est d'au moins un des types contenus dans nat.
	 * @param {Nature} nat
	 * @returns {Boolean}
	 */
	Nat.prototype.isOfNature = function (nat) {
	  if (!nat instanceof Object) return false;
	  if (!nat.constructor === Nat) return false;
	  return (nat.low & this.low) !== 0 || (nat.high & this.high) !== 0;
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by yvesb on 22/10/2016.
	 */
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Nat = __webpack_require__(4);
	
	/**
	 *
	 * @type NatCal
	 */
	var NatCal = {
	  NAucunCalcul: new Nat(0, 0),
	  NVariable: new Nat(1, 0),
	  NCalculReel: new Nat(1 << 1, 0),
	  NCalculReelConstant: new Nat(1 << 2, 0),
	  NSuiteRecurrenteReelle: new Nat(1 << 3, 0),
	  NSuiteRecurrenteComplexe: new Nat(1 << 4, 0),
	  NSolutionEquation: new Nat(1 << 5, 0),
	  NIntegrale: new Nat(1 << 6, 0),
	  NTestExistence: new Nat(1 << 7, 0),
	  NSommeIndicee: new Nat(1 << 8, 0),
	  NPartieReelle: new Nat(1 << 9, 0),
	  NPartieImaginaire: new Nat(1 << 10, 0),
	  NModule: new Nat(1 << 11, 0),
	  NArgument: new Nat(1 << 12, 0),
	  NMesureLongueur: new Nat(1 << 13, 0),
	  NMesureAngleNonOriente: new Nat(1 << 14, 0),
	  NMesureAngleOriente: new Nat(1 << 15, 0),
	  NMesureAbscisseSurDroite: new Nat(1 << 16, 0),
	  NMesureAbscisseRepere: new Nat(1 << 17, 0),
	  NMesureOrdonneeRepere: new Nat(1 << 18, 0),
	  NMesureLongueurLigne: new Nat(1 << 19, 0),
	  NMesureAirePolygone: new Nat(1 << 20, 0),
	  NCalculComplexe: new Nat(1 << 21, 0),
	  NFonction: new Nat(1 << 22, 0),
	  NDerivee: new Nat(1 << 23, 0),
	  NFonctionComplexe: new Nat(1 << 24, 0),
	  NMesureAffixe: new Nat(1 << 25, 0),
	  NRepere: new Nat(1 << 26, 0),
	  NMesureCoefDir: new Nat(1 << 27, 0),
	  NMesureProduitScalaire: new Nat(1 << 28, 0),
	  NProduitIndice: new Nat(1 << 29, 0),
	  NFonction2Var: new Nat(1 << 30, 0),
	  NFonction3Var: new Nat(0, 1 << 1), // JavaScript pas plus de 31 bits pour entier non signé
	  NFonctionComplexe2Var: new Nat(0, 1 << 2), // 2^33 // Pas de décalages de plus de 32 bits en javascript
	  NFonctionComplexe3Var: new Nat(0, 1 << 3), // 2^34
	  NMaximumFonction: new Nat(0, 1 << 4), // 2^35
	  NMinimumFonction: new Nat(0, 1 << 5), // 2^36
	  NAbscisseOrigineRep: new Nat(0, 1 << 6), // 2^37
	  NOrdonneeOrigineRep: new Nat(0, 1 << 7), // 2^38
	  NUnitexRep: new Nat(0, 1 << 8), // 2^39
	  NUniteyRep: new Nat(0, 1 << 9), // 2^40
	  NTestEquivalence: new Nat(0, 1 << 10), // 2^41
	  NDeriveePartielle: new Nat(0, 1 << 11), // 2^42
	  NTestDependanceVariable: new Nat(0, 1 << 12), // 2^43
	  NTestNatureOperateur: new Nat(0, 1 << 13), // 2^44
	  NSuiteRecurrenteComplexe2: new Nat(0, 1 << 14), // 2^45
	  NSuiteRecurrenteReelle2: new Nat(0, 1 << 15), // 2^46
	  NSuiteRecurrenteComplexe3: new Nat(0, 1 << 16), // 2^47
	  NSuiteRecurrenteReelle3: new Nat(0, 1 << 17), // 2^48
	  // Spécial JavaScript pour fonctions de 4 variables ou plus
	  // Abandonné
	  /*
	  NFonctionNVar             : new Nat(0, 1 << 18), // 2^49)
	  NFonctionComplexeNVar     : new Nat(0, 1 << 19), // 2^50)
	  // Rajout version 4.7.9
	  NTestFact                 : new Nat(0, 1 << 20), // 2^51)
	    nombreTypesObjetsCalcul : 50
	  */
	  NTestFact: new Nat(0, 1 << 18), // 2^49)
	
	  nombreTypesObjetsCalcul: 48
	
	};
	
	NatCal.NFoncPlusieursVar = Nat.or(NatCal.NFonction2Var, NatCal.NFonction3Var);
	NatCal.NFoncCPlusieursVar = Nat.or(NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var);
	NatCal.NFoncR1Var = Nat.or(NatCal.NFonction, NatCal.NDerivee);
	NatCal.NTteFoncR = Nat.or(NatCal.NFoncR1Var, NatCal.NFoncPlusieursVar, NatCal.NDeriveePartielle);
	NatCal.NTteFoncC = Nat.or(NatCal.NFonctionComplexe, NatCal.NFoncCPlusieursVar);
	NatCal.NTteFoncRouC = Nat.or(NatCal.NTteFoncR, NatCal.NTteFoncC);
	NatCal.NTteValR = Nat.or(NatCal.NVariable, NatCal.NCalculReel, NatCal.NCalculReelConstant, NatCal.NSolutionEquation, NatCal.NIntegrale, NatCal.NTestExistence, NatCal.NSommeIndicee, NatCal.NProduitIndice, NatCal.NPartieReelle, NatCal.NPartieImaginaire, NatCal.NModule, NatCal.NArgument, NatCal.NMesureLongueur, NatCal.NMesureAngleNonOriente, NatCal.NMesureAngleOriente, NatCal.NMesureAbscisseSurDroite, NatCal.NMesureAbscisseRepere, NatCal.NMesureOrdonneeRepere, NatCal.NMesureLongueurLigne, NatCal.NMesureAirePolygone, NatCal.NMesureCoefDir, NatCal.NMesureProduitScalaire, NatCal.NMaximumFonction, NatCal.NMinimumFonction, NatCal.NAbscisseOrigineRep, NatCal.NOrdonneeOrigineRep, NatCal.NUnitexRep, NatCal.NUniteyRep, NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable, NatCal.NTestNatureOperateur);
	NatCal.NTteValRSaufConst = Nat.or(NatCal.NVariable, NatCal.NCalculReel, NatCal.NSolutionEquation, NatCal.NIntegrale, NatCal.NTestExistence, NatCal.NSommeIndicee, NatCal.NProduitIndice, NatCal.NPartieReelle, NatCal.NPartieImaginaire, NatCal.NModule, NatCal.NArgument, NatCal.NMesureLongueur, NatCal.NMesureAngleNonOriente, NatCal.NMesureAngleOriente, NatCal.NMesureAbscisseSurDroite, NatCal.NMesureAbscisseRepere, NatCal.NMesureOrdonneeRepere, NatCal.NMesureLongueurLigne, NatCal.NMesureAirePolygone, NatCal.NMesureCoefDir, NatCal.NMesureProduitScalaire, NatCal.NMaximumFonction, NatCal.NMinimumFonction, NatCal.NAbscisseOrigineRep, NatCal.NOrdonneeOrigineRep, NatCal.NUnitexRep, NatCal.NUniteyRep, NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable, NatCal.NTestNatureOperateur);
	// Utilisé seulement dans l'applet :
	NatCal.NTtCalcRNommeSaufConst = Nat.or(NatCal.NVariable, NatCal.NCalculReel, NatCal.NSolutionEquation, NatCal.NIntegrale, NatCal.NTestExistence, NatCal.NSommeIndicee, NatCal.NProduitIndice, NatCal.NPartieReelle, NatCal.NPartieImaginaire, NatCal.NModule, NatCal.NArgument, NatCal.NMesureLongueurLigne, NatCal.NMesureAirePolygone, NatCal.NMesureCoefDir, NatCal.NMesureProduitScalaire, NatCal.NMaximumFonction, NatCal.NMinimumFonction, NatCal.NAbscisseOrigineRep, NatCal.NOrdonneeOrigineRep, NatCal.NUnitexRep, NatCal.NUniteyRep, NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable, NatCal.NTestNatureOperateur);
	
	NatCal.NTteValC = Nat.or(NatCal.NCalculComplexe, NatCal.NMesureAffixe);
	NatCal.NCalcRouC = Nat.or(NatCal.NCalculReel, NatCal.NCalculComplexe);
	NatCal.NTteValOuFoncR = Nat.or(NatCal.NTteValR, NatCal.NTteFoncR, NatCal.NSuiteRecurrenteReelle, NatCal.NSuiteRecurrenteReelle2, NatCal.NSuiteRecurrenteReelle3);
	NatCal.NTteValROuC = Nat.or(NatCal.NTteValR, NatCal.NTteValC);
	/*
	NatCal.NTteValRouCouFoncC = Nat.or(NatCal.NTteValROuC
	  , NatCal.NTteFoncC , NatCal.NSuiteRecurrenteComplexe
	  , NatCal.NSuiteRecurrenteComplexe2 , NatCal.NSuiteRecurrenteComplexe3);
	*/
	/*
	NatCal.NTteValRouCSaufConst = Nat.or(NatCal.NTteValRSaufConst, NatCal.NTteValC);
	*/
	
	NatCal.NTteValPourComDynSaufFonc = Nat.or(NatCal.NVariable, NatCal.NCalculReel, NatCal.NCalculReelConstant, NatCal.NCalculComplexe, NatCal.NSolutionEquation, NatCal.NIntegrale, NatCal.NTestExistence, NatCal.NSommeIndicee, NatCal.NProduitIndice, NatCal.NPartieReelle, NatCal.NPartieImaginaire, NatCal.NModule, NatCal.NArgument, NatCal.NMesureLongueurLigne, NatCal.NMesureAirePolygone, NatCal.NMesureCoefDir, NatCal.NMesureProduitScalaire, NatCal.NMaximumFonction, NatCal.NMinimumFonction, NatCal.NAbscisseOrigineRep, NatCal.NOrdonneeOrigineRep, NatCal.NUnitexRep, NatCal.NUniteyRep, NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable, NatCal.NTestNatureOperateur, NatCal.NMesureAbscisseSurDroite, NatCal.NMesureAbscisseRepere, NatCal.NMesureOrdonneeRepere, NatCal.NMesureAngleOriente, NatCal.NMesureAffixe);
	
	NatCal.NTteValRPourComDyn = Nat.or(NatCal.NVariable, NatCal.NCalculReel, NatCal.NCalculReelConstant, NatCal.NSolutionEquation, NatCal.NIntegrale, NatCal.NTestExistence, NatCal.NSommeIndicee, NatCal.NProduitIndice, NatCal.NPartieReelle, NatCal.NPartieImaginaire, NatCal.NModule, NatCal.NArgument, NatCal.NMesureLongueurLigne, NatCal.NMesureAirePolygone, NatCal.NMesureCoefDir, NatCal.NMesureProduitScalaire, NatCal.NMaximumFonction, NatCal.NMinimumFonction, NatCal.NAbscisseOrigineRep, NatCal.NOrdonneeOrigineRep, NatCal.NUnitexRep, NatCal.NUniteyRep, NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable, NatCal.NTestNatureOperateur, NatCal.NMesureAbscisseSurDroite, NatCal.NMesureAbscisseRepere, NatCal.NMesureOrdonneeRepere);
	
	NatCal.NTteValPourComDyn = Nat.or(NatCal.NTteValPourComDynSaufFonc, NatCal.NTteFoncRouC);
	NatCal.NFoncouSuiteR = Nat.or(NatCal.NTteFoncR, NatCal.NSuiteRecurrenteReelle, NatCal.NSuiteRecurrenteReelle2, NatCal.NSuiteRecurrenteReelle3);
	NatCal.NFoncouSuiteC = Nat.or(NatCal.NTteFoncC, NatCal.NSuiteRecurrenteComplexe, NatCal.NSuiteRecurrenteComplexe2, NatCal.NSuiteRecurrenteComplexe3);
	/*
	NatCal.NCalcouVarouFoncRouC = Nat.or(NatCal.NVariable , NatCal.NCalculReel
	  , NatCal.NCalculReelConstant , NatCal.NSolutionEquation , NatCal.NIntegrale
	  , NatCal.NTestExistence , NatCal.NSommeIndicee , NatCal.NProduitIndice
	  , NatCal.NPartieReelle , NatCal.NPartieImaginaire , NatCal.NModule
	  , NatCal.NArgument , NatCal.NCalculComplexe
	  , NatCal.NTteFoncRouC , NatCal.NSuiteRecurrenteReelle , NatCal.NSuiteRecurrenteReelle2
	  , NatCal.NSuiteRecurrenteReelle3, NatCal.NSuiteRecurrenteComplexe , NatCal.NSuiteRecurrenteComplexe2
	  , NatCal.NSuiteRecurrenteComplexe3 , NatCal.NMesureCoefDir , NatCal.NMesureProduitScalaire
	  , NatCal.NMaximumFonction , NatCal.NMinimumFonction , NatCal.NAbscisseOrigineRep
	  , NatCal.NOrdonneeOrigineRep , NatCal.NUnitexRep , NatCal.NUniteyRep , NatCal.NTestEquivalence
	  , NatCal.NTestFact, NatCal.NTestDependanceVariable , NatCal.NTestNatureOperateur);
	*/
	NatCal.NAutreCalcul = Nat.or(NatCal.NSolutionEquation, NatCal.NIntegrale, NatCal.NTestExistence, NatCal.NSommeIndicee, NatCal.NProduitIndice, NatCal.NPartieReelle, NatCal.NPartieImaginaire, NatCal.NModule, NatCal.NArgument, NatCal.NMesureLongueur, NatCal.NMesureAngleNonOriente, NatCal.NMesureAngleOriente, NatCal.NMesureAbscisseSurDroite, NatCal.NMesureAbscisseRepere, NatCal.NMesureOrdonneeRepere, NatCal.NMesureLongueurLigne, NatCal.NMesureAirePolygone, NatCal.NMesureCoefDir, NatCal.NMesureProduitScalaire, NatCal.NMaximumFonction, NatCal.NMinimumFonction, NatCal.NAbscisseOrigineRep, NatCal.NOrdonneeOrigineRep, NatCal.NUnitexRep, NatCal.NUniteyRep, NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable, NatCal.NTestNatureOperateur);
	NatCal.NTtCalcNomme = Nat.or(NatCal.NCalculReel, NatCal.NCalculReelConstant, NatCal.NCalculComplexe, NatCal.NTteFoncRouC, NatCal.NSuiteRecurrenteReelle, NatCal.NSuiteRecurrenteReelle2, NatCal.NSuiteRecurrenteReelle3, NatCal.NSuiteRecurrenteComplexe, NatCal.NSuiteRecurrenteComplexe2, NatCal.NSuiteRecurrenteComplexe3, NatCal.NVariable, NatCal.NSolutionEquation, NatCal.NIntegrale, NatCal.NTestExistence, NatCal.NSommeIndicee, NatCal.NProduitIndice, NatCal.NPartieReelle, NatCal.NPartieImaginaire, NatCal.NModule, NatCal.NArgument, NatCal.NMesureCoefDir, NatCal.NMesureLongueurLigne, NatCal.NMesureAirePolygone, NatCal.NMesureProduitScalaire, NatCal.NMaximumFonction, NatCal.NMinimumFonction, NatCal.NAbscisseOrigineRep, NatCal.NOrdonneeOrigineRep, NatCal.NUnitexRep, NatCal.NUniteyRep, NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable, NatCal.NTestNatureOperateur);
	NatCal.NCalcOuFoncNonConstante = Nat.or(NatCal.NCalculReel, NatCal.NCalculComplexe, NatCal.NTteFoncR, NatCal.NTteFoncC);
	// Modification pour la version 3.1.5. On peut aussi choisir une variable comme objet final
	// à condition qu'elle ait d'abord été choisie dans les objets sources.
	NatCal.NTtCalcouFoncRouC = Nat.or(NatCal.NCalculReelConstant, NatCal.NCalculReel, NatCal.NCalculComplexe, NatCal.NFonction, NatCal.NFoncPlusieursVar, NatCal.NFonctionComplexe, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var);
	NatCal.NCalcouFoncParFormule = Nat.or(NatCal.NCalcRouC, NatCal.NFonction, NatCal.NFoncPlusieursVar, NatCal.NFonctionComplexe, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var);
	NatCal.NTteSuiteRecR = Nat.or(NatCal.NSuiteRecurrenteReelle, NatCal.NSuiteRecurrenteReelle2, NatCal.NSuiteRecurrenteReelle3);
	NatCal.NTteSuiteRecC = Nat.or(NatCal.NSuiteRecurrenteComplexe, NatCal.NSuiteRecurrenteComplexe2, NatCal.NSuiteRecurrenteComplexe3);
	
	module.exports = NatCal;

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	module.exports = Color;
	/**
	 * Classe couleur
	 * @constructor
	 * @param {Integer} red Composante rouge
	 * @param {Integer} green Composante verte
	 * @param {Integer} blue Composante bleue
	 * @returns {undefined}
	 */
	function Color(red, green, blue) {
	  this.red = red;
	  this.green = green;
	  this.blue = blue;
	}
	/**
	 * Renvoie la couleur rouge
	 * @returns {Integer}
	 */
	Color.prototype.getRed = function () {
	  return this.red;
	};
	/**
	 * Renvoie la couleur verte
	 * @returns {Integer}
	 */
	Color.prototype.getGreen = function () {
	  return this.green;
	};
	/**
	 *
	 * @returns {Integer}Renvoie la couleur bleue
	 */
	Color.prototype.getBlue = function () {
	  return this.blue;
	};
	/**
	 * Fonction renvoyant le code couleur pour du LaTeX
	 * @returns {String}
	 */
	Color.prototype.rgb = function () {
	  return "rgb(" + this.red + "," + this.green + "," + this.blue + ")";
	};
	/**
	 * Fonctio renvoyant true si la couleur est blanche
	 * @returns {Boolean}
	 */
	Color.prototype.isWhite = function () {
	  return this.red === 255 && this.green === 255 && this.blue === 255;
	};
	Color.black = new Color(0, 0, 0);
	Color.blue = new Color(0, 0, 255);
	Color.red = new Color(255, 0, 0);
	Color.green = new Color(0, 255, 0);
	Color.white = new Color(255, 255, 255);
	Color.yellow = new Color(255, 255, 0);
	Color.gray = new Color(128, 128, 128);

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	module.exports = Dimf;
	/**
	 * Classe utilisée pour représenter les dimensions du svg contenant la figure.
	 * @constructor
	 * @param {Integer} x : Dimension horizontale
	 * @param {Integer} y : Dimension verticale
	 * @returns {Dimf}
	 */
	function Dimf(x, y) {
	  this.x = x;
	  this.y = y;
	}
	/**
	 * Fonction testant si le point de coordonnées (xtest,ytest) est dans la feenêtre
	 * @param {Float} xtest : Abscisse du test.
	 * @param {Float} ytest : Ordonnée du test.
	 * @returns {Boolean}
	 */
	Dimf.prototype.dansFenetre = function (xtest, ytest) {
	  return xtest >= 0 && xtest <= this.x && ytest >= 0 && ytest <= this.y;
	};
	
	/**
	 * Fonction renvyant true si le cercle de centre (cx,cy) et de rayon rayon est dans la fenêtre et false sinon.
	 * @param cx
	 * @param cy
	 * @param rayon
	 * @returns {boolean}
	 */
	Dimf.prototype.testCercleDansFen = function (cx, cy, rayon) {
	  var d1 = kernel.distancePointPoint(cx, cy, 0, 0);
	  var d2 = kernel.distancePointPoint(cx, cy, 0, this.y);
	  var d3 = kernel.distancePointPoint(cx, cy, this.x, 0);
	  var d4 = kernel.distancePointPoint(cx, cy, this.x, this.y);
	  if (rayon >= d1 && rayon >= d2 && rayon >= d3 && rayon >= d4) return false;
	  if (this.dansFenetre(cx, cy)) return true;
	  if (cx > this.x) {
	    if (cy > this.y) return rayon >= d4;else if (cy < 0) return rayon >= d3;else return rayon >= cx - this.x;
	  } else {
	    if (cx < 0) {
	      if (cy > this.y) return rayon >= d2;else if (cy < 0) return rayon >= d1;else return rayon >= -cx;
	    } else {
	      if (cy < 0) return rayon >= -cy;else return rayon >= cy - this.y;
	    }
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*!
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 * Version 5.4.0.0
	 */
	
	var PositionDroiteCercle = __webpack_require__(9);
	var PositionDroites = __webpack_require__(10);
	var PositionCercleCercle = __webpack_require__(11);
	var Vect = __webpack_require__(12);
	
	// import Point from '../types/Point'
	
	// mtg32.kernel remplacé par mtg32.k pour gagner de la place.
	var kernel = {
	  svgns: "http://www.w3.org/2000/svg",
	  ConvDegRad: Math.PI / 180,
	  ConvRadDeg: 180 / Math.PI,
	  uniteAngle: { radian: 0, degre: 1 },
	  _digit64: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+#",
	  _digit64_standard: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
	  erreurCalculException: "Erreur de calcul",
	  NombreMaxiTermesSuiteRec: 100000,
	  MIN_VALUE: -2147483648,
	  Max_VALUE: 2147483647,
	  // Ajout version 5.0.3 pour modification de testToile
	  SHORT_MIN_VALUE: -32768,
	  SHORT_MAX_VALUE: +32767
	};
	kernel.cos30 = Math.cos(30 * kernel.ConvDegRad);
	kernel.sin30 = 0.5;
	// Ajout version mtgApp pour gérer les écarns tactiles ou non //
	kernel.distMinForTouch = 20;
	kernel.distMinForMouse = 10;
	
	//
	/**
	 * Fonction de récupération des paramètres GET de la page
	 * @return Array Tableau associatif contenant les paramètres GET
	 */
	/*
	mtg32.extractUrlLang = function(){
		var t = location.search.substring(1).split('&');
		for (var i=0; i<t.length; i++){
			var x = t[i].split('=');
			if (x[0] === "lang") return x[1];
		}
		return ""; // Français par défaut
	};
	*/
	
	/**
	 * Fonction créant un élément de nom name dans le namespace http://www.w3.org/2000/svg
	 * avec les attributs de l'objet att passés en paramètre
	 * @param name
	 * @param att
	 * @returns {Element}
	 */
	kernel.cens = function (name, att) {
	  var element = document.createElementNS(kernel.svgns, name);
	  if (att) {
	    for (var o in att) {
	      if (att.hasOwnProperty(o)) element.setAttribute(o, att[o]);
	    }
	  }
	  return element;
	};
	
	/**
	 * Fonction créant un élément de nom name
	 * avec les attributs de l'objet att passés en paramètre
	 * @param name
	 * @param att
	 * @returns {Element}
	 */
	
	kernel.ce = function (name, att) {
	  var element = document.createElement(name);
	  if (arguments.length > 0) {
	    for (var o in att) {
	      if (att.hasOwnProperty(o)) element.setAttribute(o, att[o]);
	    }
	  }
	  return element;
	};
	
	kernel.userLan = function () {
	  /*
	  if (mtg32.extractUrlLang() === "") {
	    var ch = navigator.languages && navigator.languages[0] ||
	    navigator.language ||
	    navigator.userLanguage;
	    return ch.substring(0,2);
	  }
	  else return "fr";
	  */
	  var ch = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;
	  if (ch) return ch.substring(0, 2);else return "fr";
	};
	
	/*
	kernel.initTextes = function(bTextesComplets) {
	  const s = kernel.userLan()
	  if (s === "fr") kernel.textes = require('../textes/textes_fr')
	  else if(s === "es") kernel.textes = require('../textes/textes_es')
	  else kernel.textes = require('../textes/textes_en')
	  // remplacer needTextesComplets par le test pour savoir s'il faut ajouter le reste
	  if (bTextesComplets) {
	    let textesExt = {}
	    if (s === "fr") textesExt = require('../textes/textes_frAdd')
	    else if(s === "es") textesExt = require('../textes/textes_esAdd')
	    else textesExt = require('../textes/textes_enAdd')
	    // et on ajoute ça à textes
	    Object.assign(kernel.textes, textesExt)
	  }
	}
	*/
	
	/*
	kernel.initTextes = function(bTextesComplets, callBack) {
	  kernel.textes = {};
	  const s = kernel.userLan();
	  if (s === "fr") require.ensure(['../textes/textes_fr'], function () {
	    Object.assign(kernel.textes, require('../textes/textes_fr'));
	    if (bTextesComplets) require.ensure(['../textes/textes_frAdd'], function () {
	      Object.assign(kernel.textes, require('../textes/textes_frAdd'));
	      callBack();
	    });
	    else callBack();
	  })
	  else
	  if (s === "en") require.ensure(['../textes/textes_en'], function () {
	    Object.assign(kernel.textes, require('../textes/textes_en'));
	    if (bTextesComplets) require.ensure(['../textes/textes_enAdd'], function () {
	      Object.assign(kernel.textes, require('../textes/textes_enAdd'));
	      callBack();
	    });
	    else callBack();
	  })
	  else {
	    Object.assign(kernel.textes, require('../textes/textes_es'));
	    if (bTextesComplets) require.ensure(['../textes/textes_esAdd'], function () {
	      Object.assign(kernel.textes, require('../textes/textes_esAdd'));
	      callBack();
	    });
	    else callBack();
	  }
	}
	*/
	
	/**
	 * Renvoie la chaine de code ch suivant a langue utilisée par la navigateur.
	 * textes est une variable globale initialisée au début de l'apli
	 * @param {type} ch
	 * @returns {mtg32.textes_en|mtg32.textes_fr|mtg32.textes_es}
	 *
	 */
	kernel.getString = function (ch) {
	  return kernel.textes[ch] || "";
	};
	
	/**
	 * Fonction renvoyant true si la valeur absolue de x est inférieure à 10^-9
	 * @param {Float} x
	 * @returns {Boolean}
	 */
	kernel.zero = function (x) {
	  return Math.abs(x) < 1e-9;
	};
	/**
	 * Fonction renvoyant true si la valeur absolue de x est inférieure à 10^-13
	 * @param {Float} x
	 * @returns {Boolean}
	 */
	
	kernel.zero13 = function (x) {
	  return Math.abs(x) < 1e-13;
	};
	/**
	 * Renvoie une chaîne de caractères reprséentant le nombre number avec
	 * digits décimales.
	 * @param {Float} number
	 * @param {Integer} digits
	 * @returns {String}
	 */
	// Modifié version 5.1 pour tenir compte d'une écriture scientifique
	kernel.chaineNombre = function (number, digits) {
	  var ind, indexp, exp, nb;
	  if (number === 0) return "0";
	  if (number === Number.NEGATIVE_INFINITY) return "-∞";
	  if (number === Number.POSITIVE_INFINITY) return "∞";
	  var ch = number.toFixed(digits);
	  indexp = ch.indexOf("e");
	  if (indexp === -1) exp = "";else {
	    exp = ch.substring(indexp);
	    ch = ch.substring(0, indexp);
	    nb = parseFloat(ch);
	    ch = nb.toFixed(digits);
	  }
	  var i = ch.length - 1;
	  if ((ind = ch.indexOf('.', 0)) !== -1) {
	    while (i >= ind && (ch.charAt(i) === "0" || ch.charAt(i) === ".")) {
	      i--;
	    }ch = ch.substring(0, i + 1);
	  }
	  if (ch === "-0") return "0" + exp;
	  // else return ch; // Modification version 4.9.2. On rajoute un espace si le nombre est négatif après le signe -
	  if (ch.charAt(0) === "-") return "- " + ch.substring(1) + exp;else return ch + exp;
	};
	/**
	 * Fonction renvoyant une chaîne de caractères codant en base 64 le tableau de bytes ba.
	 * Si la dimension du tableau n'est pas un multiple de 3, un ou deux zéros lui sont ajoutés et la chaîne
	 * de caractères se termine par un ou deux caractères =
	 * @param {type} ba : Un tableau de caractères qui représentent des bytes
	 * @param {type} bstandard : Si true on encode de façon standard sinon avec encodage mathGraph32 avec / remplacé par  #
	 * @returns {String}
	 */
	kernel.base64Encode = function (ba, bstandard) {
	  // Il faut que la dimension du tableau de bytes soit un multiple de 3 (3 bytes seront codés sur 4 caractères)
	  // A noter que un ou deux bytes mis à zéro de plus seront peut-être codés. Pour chacun on mettra un signe = à la fin
	  // de la chaîne de caractères
	  var digit = bstandard ? kernel._digit64_standard : kernel._digit64;
	  var len = ba.length;
	  var r = len % 3;
	  var q = Math.floor((len - 1) / 3);
	  var q2 = q + 1;
	  if (r !== 0) {
	    var ba2 = new Array(q2 * 3);
	    for (var j = q * 3 + r; j < q2 * 3; j++) {
	      ba2[j] = 0;
	    }for (var k = 0; k < len; k++) {
	      ba2[k] = ba[k];
	    }ba = ba2;
	  }
	  var ch = "";
	  for (var i = 0; i < q2 * 3; i += 3) {
	    var n = ((ba[i] & 0xff) << 16) + ((ba[i + 1] & 0xff) << 8) + (ba[i + 2] & 0xff); // Les poids forts en premier
	    ch += digit.charAt(n >> 18 & 0x3f);
	    ch += digit.charAt(n >> 12 & 0x3f);
	    ch += digit.charAt(n >> 6 & 0x3f);
	    ch += digit.charAt(n & 0x3f);
	  }
	  // Revu version mtgApp
	  // var paddingCount = Math.floor((3 - r) % 3); // nul si r = 0 // 1 si r = 2 et 2 si r = 3 c'est le nombre de = à mettre à la fin
	  var paddingCount = (3 - r) % 3; // nul si r = 0 // 1 si r = 2 et 2 si r = 3 c'est le nombre de = à mettre à la fin
	  return ch.substring(0, (q + 1) * 4 - paddingCount) + "==".substring(0, paddingCount);
	};
	/**
	 * Fonction renvoyant un tableau d'entiers représentant des bytes d'un flux de bytes.
	 * @param {String} xmlString : une chaîne base64.
	 * @param {type} bstandard : Si true on décode de façon standard sinon avec encodage mathGraph32 avec / remplacé par  #
	 * @returns {Array} : Tableau de bytes.
	 */
	kernel.base64Decode = function (xmlString, bstandard) {
	  var digit = arguments.length === 1 ? kernel._digit64 : bstandard ? kernel._digit64_standard : kernel._digit64;
	  var paddingCount = 0;
	  var len = xmlString.length;
	  var indegal = xmlString.indexOf('=');
	  if (indegal !== -1) {
	    if (xmlString.charAt(len - 1) === '=') {
	      if (xmlString.charAt(len - 2) === '=') paddingCount = 2;else paddingCount = 1;
	    }
	    xmlString = xmlString.substring(0, indegal) + "AA".substring(2 - paddingCount); // On remplace les = par des An donc des zéros
	  } else paddingCount = 0;
	  // Ligne suivante modifiée JavaScript
	  var barray = new Array((Math.floor((xmlString.length - 1) / 4) + 1) * 3 - paddingCount);
	  var der = len - paddingCount;
	  var j = 0;
	  for (var i = 0; i < len; i += 4) {
	    var car1 = xmlString.charAt(i);
	    var car2 = xmlString.charAt(i + 1);
	    var car3 = xmlString.charAt(i + 2);
	    var car4 = xmlString.charAt(i + 3);
	    var n = (digit.indexOf(car1) << 18) + (digit.indexOf(car2) << 12) + (digit.indexOf(car3) << 6) + digit.indexOf(car4);
	    if (i + 3 < der) barray[j + 2] = n & 0xff;
	    if (i + 2 < der) barray[j + 1] = n >> 8 & 0xff;
	    barray[j] = n >> 16 & 0xff;
	    j += 3;
	  }
	  return barray;
	};
	/**
	 * Fonction renvoyant le PGCD de a et de b.
	 * Avant appel a et b doivent être entiers et non tous les deux nuls, positifs ou nuls
	 * @param {Integer} a : Entier positif
	 * @param {Integer} b : Entier positif
	 * @returns {Integer}
	 */
	kernel.pgcd = function (a, b) {
	  while (b !== 0) {
	    var r = a - b * Math.floor(a / b);
	    a = b;
	    b = r;
	  }
	  return a;
	};
	/**
	 * Fonction renvoyant le PPCM de a et de b
	 * Avant appel a et b doivent être entiers et non tous les deux nuls, positifs ou nuls
	 * @param {type} a
	 * @param {type} b
	 * @returns {Number}
	 */
	kernel.ppcm = function (a, b) {
	  if (a === 0 || b === 0) return 0;
	  var q = a / pgcd(a, b);
	  return Math.floor(q * b + 0.5);
	};
	/**
	 * Fonction renvoyant le coefficient du binôme Cnp
	 * Avant appel n et p doivent être entiers, n > 0,
	 * et p compris entre 0 et n
	 * @param {Integer} n
	 * @param {Integer} p
	 * @returns {Integer}
	 */
	kernel.ncr = function (n, p) {
	  if (p > n / 2) p = n - p;
	  if (p === 0) return 1;
	  var d = n / p;
	  var p1 = p;
	  for (var k = 1; k < p1; k++) {
	    p--;
	    n--;
	    var d1 = n / p;
	    d = d * d1;
	  }
	  return Math.floor(d + 0.5);
	};
	/**
	 * Fonction renvoyant le nombre de permutations à p éléments d'un ensemble à n éléments
	 * Avant appel n et p doivent être entiers, n > 0.
	 * @param {Integer} n
	 * @param {Integer} p
	 * @returns {Integer}
	 */
	kernel.npr = function (n, p) {
	  if (p === 0) return 1;
	  var d = n;
	  for (var k = 1; k < p; k++) {
	    n--;
	    d = d * n;
	  }
	  return d;
	};
	/**
	 * Fonction renvoyant true si un angle de mesure r est considéré comme
	 * presque nul (valeur absolue inféieure à 10^-7)
	 * @param {Float} r
	 * @returns {Boolean}
	 */
	kernel.zeroAngle = function (r) {
	  return Math.abs(r) < 1e-7;
	};
	/**
	 * Renvoie la mesure principale en radians d'un angle de mesure angrad.
	 * @param {Float} angrad
	 * @returns {Float}
	 */
	kernel.mesurePrincipale = function (angrad) {
	  if (kernel.zeroAngle(Math.abs(angrad) - Math.PI)) return Math.PI;
	  return angrad - 2 * Math.PI * Math.floor((angrad + Math.PI) / (2 * Math.PI));
	};
	/**
	 * Fonction renvoyant true si x et y sont des nombres compris entre le plus
	 * petit et le plus grand  entiers représentés sur 4 actets.
	 * @param {Float} x
	 * @param {Float} y
	 * @returns {Boolean}
	 */
	kernel.testToile = function (x, y) {
	  return x <= kernel.SHORT_MAX_VALUE && y <= kernel.SHORT_MAX_VALUE && x >= kernel.SHORT_MIN_VALUE && y >= kernel.SHORT_MIN_VALUE;
	};
	/**
	 * Renvoie true si les deu vecteurs e et v sont considérés comme colinéiares
	 * (à epsilon près).
	 * @param {Vect} u
	 * @param {Vect} v
	 * @returns {Boolean}
	 */
	kernel.colineaires = function (u, v) {
	  var n1 = u.norme();
	  var n2 = v.norme();
	  if (kernel.zero(n1) || kernel.zero(n2)) return true;else return kernel.zero((u.x * v.y - u.y * v.x) / n1 / n2);
	};
	/**
	 * Renvoie true si les deu vecteurs e et v sont considérés comme colinéiares
	 * et de même sens (à epsilon près).
	 * @param {Vect} u
	 * @param {Vect} v
	 * @returns {Boolean}
	 */
	kernel.colineairesMemeSens = function (u, v) {
	  return kernel.colineaires(u, v) && u.x * v.x + u.y * v.y >= 0;
	};
	/**
	 * Renvoie la distance entre deux points de coordonnées (x1,y1) et (x2,y2).
	 * @param {Float} x1
	 * @param {Float} y1
	 * @param {Float} x2
	 * @param {Float} y2
	 * @returns {Float}
	 */
	kernel.distancePointPoint = function (x1, y1, x2, y2) {
	  return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	};
	/**
	 * Renvoie le carré de la distance entre deux points de coordonnées (x1,y1) et (x2,y2).
	 * @param {Float} x1
	 * @param {Float} y1
	 * @param {Float} x2
	 * @param {Float} y2
	 * @returns {Float}
	 */
	kernel.distancePointPointCarre = function (x1, y1, x2, y2) {
	  return (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
	};
	
	/**
	 * Calcule l'intersection de deux droites et renvoie un entier du type mtg32.PositionDroites
	 * @param {Float} p1_x : Abscisse d'un point de la première droite
	 * @param {Float} p1_y : Ordonnée d'un point de la première droite
	 * @param {Vect} u1 : Vecteur directeur de la première droite.
	 * @param {Float} p2_x : Abscisse d'un point de la deuxième droite
	 * @param {Float} p2_y : Ordonnée d'un point de la deuxième droite
	 * @param {Vect} u2 : Vecteur directeur de la deuxième droite.
	 * @param {Point} pointInt : Contient au retour les coordonnées du point d'intersection.
	 * @returns {PositionDroites}
	 */
	kernel.intersection = function (p1_x, p1_y, u1, p2_x, p2_y, u2, pointInt) {
	  var d, k1, k2, position;
	
	  d = u1.x * u2.y - u2.x * u1.y;
	  // Modifié pour la version 1.9 : on teste la presque nullité du sinus et
	  // non du déterminant
	  if (kernel.zero(d / u1.norme() / u2.norme())) {
	    var w = new Vect(p1_x, p1_y, p2_x, p2_y);
	    // Il faut appeler colineaires() car w peut être nul
	    if (kernel.colineaires(u1, w)) position = PositionDroites.Confondues;else position = PositionDroites.Paralleles;
	  } else {
	    position = PositionDroites.Secantes;
	    k1 = u1.y * p1_x - u1.x * p1_y;
	    k2 = u2.y * p2_x - u2.x * p2_y;
	    pointInt.x = (u1.x * k2 - u2.x * k1) / d;
	    pointInt.y = (u1.y * k2 - u2.y * k1) / d;
	  }
	  return position;
	};
	/**
	 * Calcule l'intersection d'une droite et un cercle et renvoie un entier du type PositionDroiteCercle
	 * donnant la nature de cette intersection.
	 * @param {Float} px : Abscisse d'un point de la droite.
	 * @param {Float} py : Ordonnées d'un point de la droite.
	 * @param {mtg32.CVect} u : Un vecteur directeur de la droite.
	 * @param {Float} cx : Abscisse du cntre du cercle.
	 * @param {Float} cy : Ordonnée du cntre du cercle.
	 * @param {Float} R : Le rayon d cercle.
	 * @param {Point} point1 : Contient au retour les coordonnées du premier point d'intersection
	 * (si il y en a).
	 * @param {Point} point2 : Contient au retour les coordonnées du second point d'intersection
	 * (si il y en a).
	 * @returns {kernel.PositionDroiteCercle}
	 */
	kernel.intersectionDroiteCercle = function (px, py, u, cx, cy, R, point1, point2) {
	  var a, b, k1, k2, k3, k4, n2, distcentredroite, dis, t1, t2; // paramètre
	  a = u.x;
	  b = u.y;
	  k1 = px - cx;
	  k2 = py - cy;
	  k3 = a * k1 + b * k2;
	  k4 = a * k2 - b * k1;
	  n2 = a * a + b * b;
	  distcentredroite = Math.abs(a * k2 - b * k1) / Math.sqrt(n2);
	  if (kernel.zero(distcentredroite - R)) {
	    t1 = -k3 / n2;
	    point1.x = px + a * t1;
	    point1.y = py + b * t1;
	    point2.x = point1.x;
	    point2.y = point1.y;
	    return PositionDroiteCercle.Tangents;
	  }
	  if (distcentredroite > R) {
	    return PositionDroiteCercle.Vide;
	  } else {
	    dis = n2 * R * R - k4 * k4;
	    t1 = (Math.sqrt(dis) - k3) / n2; // formules du second degré
	    t2 = (-Math.sqrt(dis) - k3) / n2;
	    point1.x = px + a * t1;
	    point1.y = py + b * t1;
	    point2.x = px + a * t2;
	    point2.y = py + b * t2;
	    return PositionDroiteCercle.Secants;
	  }
	};
	// Idem pour l'intersection d'une droite et d'un cercle
	/**
	 * Calcule l'intersection de deux cercles et renvoie un entier du type PositionCercleCercle
	 * donnant la nature de cette intersection.
	 * @param {Float} c1x : Abscisse du centre du premier cercle.
	 * @param {Float} c1y : Ordonnée du centre du premier cercle.
	 * @param {Float} r1 : Rayon du premier cercle.
	 * @param {Float} c2x : Abscisse du centre du second cercle.
	 * @param {Float} c2y : Ordonnée du centre du second cercle.
	 * @param {Float} r2 : Rayon du second cercle.
	 * @param {type} point1
	 * @param {type} point2
	 * @returns {PositionCercleCercle}
	 */
	kernel.intersectionCercleCercle = function (c1x, c1y, r1, c2x, c2y, r2, point1, point2) {
	  var d, xi, yi, xh, yh, k;
	  var u = new Vect();
	  var v = new Vect();
	  // Modifié version 2.3.5
	  // if ((c1x == c2x) && (c1y == c2y))
	  if (kernel.zero(c1x - c2x) && kernel.zero(c1y - c2y)) {
	    if (kernel.zero(r1 - r2)) return PositionCercleCercle.Confondus;else return PositionCercleCercle.Vide;
	  } else {
	    xi = (c1x + c2x) / 2;
	    yi = (c1y + c2y) / 2; // coordonnées du milieu de M1M2;
	    var u0 = new Vect(c1x, c1y, c2x, c2y);
	    d = kernel.distancePointPoint(c1x, c1y, c2x, c2y);
	    u0.vecteurColineaire(1, u); // u colinéaire à M1M2 et même sens
	    k = (r1 * r1 - r2 * r2) / 2 / d;
	    xh = xi + k * u.x;
	    yh = yi + k * u.y;
	    u.getOrthogonal(v);
	    var positionDroites = kernel.intersectionDroiteCercle(xh, yh, v, c1x, c1y, r1, point1, point2);
	    switch (positionDroites) {
	      case PositionDroiteCercle.Tangents:
	        return PositionCercleCercle.Tangents;
	      case PositionDroiteCercle.Secants:
	        return PositionCercleCercle.Secants;
	      case PositionDroiteCercle.Vide:
	        return PositionCercleCercle.Vide;
	      default:
	        return PositionCercleCercle.Vide; // Pour satisfaire le compilateur
	    }
	  }
	};
	/**
	 * Renvoie dans res.x et res.y les coordonnées de l'intersection de deux droites sécantes
	 * On sait qu'elles sont sécantes avant appel.
	 * @param {Float} p1_x : Abscisse d'un point de la première droite
	 * @param {Float} p1_y : Ordonnée d'un point de la première droite
	 * @param {Vect} u1 : Vecteur directeur de la première droite.
	 * @param {Float} p2_x : Abscisse d'un point de la deuxième droite
	 * @param {Float} p2_y : Ordonnée d'un point de la deuxième droite
	 * @param {Vect} u2 : Vecteur directeur de la deuxième droite.
	 * @param {Object} res
	 * @returns {undefined}
	 */
	kernel.intersectionDroitesSecantes = function (p1_x, p1_y, u1, p2_x, p2_y, u2, res) {
	  var d, k1, k2;
	  d = u1.x * u2.y - u2.x * u1.y;
	  k1 = u1.y * p1_x - u1.x * p1_y;
	  k2 = u2.y * p2_x - u2.x * p2_y;
	  res.x = (u1.x * k2 - u2.x * k1) / d;
	  res.y = (u1.y * k2 - u2.y * k1) / d;
	};
	/**
	 * Renvoie dans res.x et res.y les coordonnées du projeté orthogonal du point
	 * de coordonnées (x1,y1) sur la droite passant par le point de coordonnées
	 * (p1_x,p1_y) et de vecteur directeur u.
	 * @param {Float} x1
	 * @param {Float} y1
	 * @param {Float} p1_x
	 * @param {Float} p1_y
	 * @param {Vect} u
	 * @param {Object} res
	 * @returns {undefined}
	 */
	kernel.projetteOrtho = function (x1, y1, p1_x, p1_y, u, res) {
	  var v = new Vect();
	  u.getOrthogonal(v);
	  kernel.intersectionDroitesSecantes(x1, y1, v, p1_x, p1_y, u, res);
	};
	/**
	 * Renvoie true si les poins de coordonnées (xa,ya), (xb,yb) et (xc,yc)
	 * sont considérés comme pratiquement alignés.
	 * @param {Float} xa
	 * @param {Float} ya
	 * @param {Float} xb
	 * @param {Float} yb
	 * @param {Float} xc
	 * @param {Float} yc
	 * @returns {Boolean}
	 */
	kernel.aligne = function (xa, ya, xb, yb, xc, yc) {
	  var k, nu, nv;
	  var u = new Vect();
	  var v = new Vect();
	
	  u.x = xb - xa;
	  u.y = yb - ya;
	  v.x = xc - xa;
	  v.y = yc - ya;
	  nu = u.norme();
	  nv = v.norme();
	  if (kernel.zero(nu) || kernel.zero(nv)) return true;else {
	    k = (u.x * v.y - v.x * u.y) / nu / nv;
	    return kernel.zero(k);
	  }
	};
	/**
	 * Renvoie true si le point de coordonnées (x,y) est considéré comme appartenant
	 * au segment dont les extrémités ont pour coordonnées (p1x,p1y) et (p2x,p2y).
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Float} p1x
	 * @param {Float} p1y
	 * @param {Float} p2x
	 * @param {Float} p2y
	 * @returns {Boolean}
	 */
	kernel.appartientSegment = function (x, y, p1x, p1y, p2x, p2y) {
	  var k, absx, absy;
	  var difx = p2x - p1x;
	  absx = Math.abs(difx);
	  var dify = p2y - p1y;
	  absy = Math.abs(dify);
	  if (kernel.zero(difx) && kernel.zero(dify)) return kernel.zero(x - p1x) && kernel.zero(y - p1y);else {
	    if (!kernel.aligne(p1x, p1y, p2x, p2y, x, y)) return false;else {
	      if (absy > absx) k = (y - p1y) / dify;else k = (x - p1x) / difx;
	      // Modification apportée pour la version 1.9.5 pour compter avec les erreurs d'arrondi
	      return k >= 0 && k <= 1 || kernel.zero(k) || kernel.zero(1 - k);
	    }
	  }
	};
	/**
	 * Fonction calculant les coefficients barycentriques d'un point sur un segment
	 * @param {Float} x : abscisse du point qui est sur le segment
	 * @param {Float} y : ordonnée du point qui est sur le segment
	 * @param {Float} x1 : Abscisse du point1 du segment
	 * @param {Float} y1 : Ordonnée du point1 du segment
	 * @param {Float} x2 : Abscisse du point2 du segment
	 * @param {Float} y2 : Ordonnée du point2 du segment
	 * @param {mtg32.Pointeur} a : Au retour, getValue() renvoie le premier coefficient barycentrique.
	 * @param {mtg32.Pointeur} b : Au retour, getValue() renvoie le second coefficient barycentrique.
	 * @returns {undefined}
	 */
	kernel.coefficientsPointSurSegment = function (x, y, x1, y1, x2, y2, a, b) {
	  var u = new Vect(x, y, x1, y1);
	  var v = new Vect(x, y, x2, y2);
	  var nu = u.norme();
	  var nv = v.norme();
	  var d = nu + nv;
	  a.setValue(nv / d);
	  b.setValue(nu / d);
	};
	/**
	 * Fonction renvoyant true seulement si le point de coordonnées (x; y)intérieur
	 * au triangle dont les sommets ont pour coordonnées (x1; y1), (x2, y2) et (x3, y3).
	 * Il peut être sur le côté M1M2 ou sur le côté M2M3.
	 * Sert pour déterminer la position d'un point lié à l'intérieur d'un polygone.
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Float} x1
	 * @param {Float} y1
	 * @param {Float} x2
	 * @param {Float} y2
	 * @param {Float} x3
	 * @param {Float} y3
	 * @returns {Boolean}
	 */
	kernel.estInterieurATriangle = function (x, y, x1, y1, x2, y2, x3, y3) {
	  if (kernel.appartientSegment(x, y, x1, y1, x2, y2) || kernel.appartientSegment(x, y, x2, y2, x3, y3)) return true;
	  var u = new Vect(x, y, x1, y1);
	  var v = new Vect(x, y, x2, y2);
	  var w = new Vect(x, y, x3, y3);
	  var ang = u.mesureAngleVecteurs(v) + v.mesureAngleVecteurs(w) + w.mesureAngleVecteurs(u);
	  var q = Math.abs(Math.round(ang / (2 * Math.PI)));
	  return q === 1;
	};
	/**
	 * Pour un point G intérieur à un triangle dont les sommets sont (x1,y1) (x2, y2) et (x3, y3), renvoie dans alpha
	 * beta et gamma les coordonnées barycentriques normalisées du point de coordonnées (x,y) (la somme des coeff est 1)
	 * G peut être éventuelleùent sur M1M2 ou sur M1M3
	 * @param {float} x
	 * @param {float} y
	 * @param {float} x1
	 * @param {float} y1
	 * @param {float} x2
	 * @param {float} y2
	 * @param {float} x3
	 * @param {float} y3
	 * @param {types.Pointeur} alpha
	 * @param {types.Pointeur} beta
	 * @param {types.Pointeur} gamma
	 * @returns {undefined}
	 */
	kernel.coefficientsPointInterieur = function (x, y, x1, y1, x2, y2, x3, y3, alpha, beta, gamma) {
	  if (kernel.appartientSegment(x, y, x1, y1, x2, y2)) {
	    kernel.coefficientsPointSurSegment(x, y, x1, y1, x2, y2, alpha, beta);
	    gamma.setValue(0);
	    return;
	  }
	  if (kernel.appartientSegment(x, y, x1, y1, x3, y3)) {
	    kernel.coefficientsPointSurSegment(x, y, x1, y1, x3, y3, alpha, gamma);
	    beta.setValue(0);
	    return;
	  }
	  var u = new Vect(x, y, x1, y1);
	  var v = new Vect(x2, y2, x3, y3);
	  //On calcule l'intersection de (AM) avec (BC)
	  var d = u.x * v.y - v.x * u.y; // d ne doit pas être nul car u et v ne sont pas colinéaires
	  // puisque le point est strictement intérieur au triangle
	  var k1 = u.y * x1 - u.x * y1;
	  var k2 = v.y * x2 - v.x * y2;
	  var xs = (u.x * k2 - v.x * k1) / d;
	  var ys = (u.y * k2 - v.y * k1) / d;
	  // xs et ys sont les coordonnées du point d'intersection H qui est sur le segment [BC]
	  var ga = u.norme();
	  var v1 = new Vect(xs, ys, x2, y2);
	  var hb = v1.norme();
	  var v2 = new Vect(xs, ys, x3, y3);
	  var hc = v2.norme();
	  var v3 = new Vect(xs, ys, x, y);
	  var gh = v3.norme();
	  var den1 = ga + gh;
	  var den2 = den1 * (hb + hc);
	  alpha.setValue(gh / den1);
	  beta.setValue(ga * hc / den2);
	  gamma.setValue(ga * hb / den2);
	};
	/**
	 * Fonction renvoyant dans point.x l'indice de la valeur maximale contenue dans le tableau
	 * de nombres tab et dans y l'indice de la valeur maximale.
	 * @param {int} c Le nombre d'éléments du tableau.
	 * @param {Array} tab : Un tableau de nombres
	 * @param {Object} point
	 * @returns {undefined}
	 */
	kernel.indiceMiniMaxi = function (c, tab, point) {
	  var imin, imax, min, max;
	
	  min = tab[0];
	  max = min;
	  imin = 0;
	  imax = 0;
	  for (var i = 1; i <= c; i++) {
	    if (tab[i] < min) {
	      imin = i;
	      min = tab[i];
	    }
	    if (tab[i] > max) {
	      imax = i;
	      max = tab[i];
	    }
	  }
	  point.x = imin;
	  point.y = imax;
	};
	/**
	 * Renvoie true si la différence entre angle1 et angle2 est en valeur absolue
	 * proche de pi/2 ou 3pi/2
	 * @param {float} angle1
	 * @param {float} angle2
	 * @returns {boolean}
	 */
	kernel.testAngleDroit = function (angle1, angle2) {
	  var dif = Math.abs(angle2 - angle1);
	  return kernel.zeroAngle(dif - Math.PI / 2) || kernel.zeroAngle(dif - 3 * Math.PI / 2);
	};
	/**
	 * Renvoie les coordonnées du pointeur souris de l'événement event
	 * @param {event} event
	 * @returns {Array} : Contient les coordonnées renvoyées.
	 */
	kernel.getMousePosition = function (event) {
	  var e = event || window.event;
	  var scroll = [document.documentElement && document.documentElement.scrollLeft || window.pageXOffset || self.pageXOffset || document.body.scrollLeft, document.documentElement && document.documentElement.scrollTop || window.pageYOffset || self.pageYOffset || document.body.scrollTop];
	  return [e.clientX + scroll[0] - document.body.clientLeft, e.clientY + scroll[1] - document.body.clientTop];
	};
	/**
	 * Renvoie les coordonnées du pointeur d'un périphériqu mobile de l'événement event
	 * @param {type} event
	 * @returns {Array} : Contient les coordonnées renvoyées.
	 */
	kernel.getTouchPosition = function (event) {
	  var e = event || window.event;
	  var scroll = [document.documentElement && document.documentElement.scrollLeft || window.pageXOffset || self.pageXOffset || document.body.scrollLeft, document.documentElement && document.documentElement.scrollTop || window.pageYOffset || self.pageYOffset || document.body.scrollTop];
	  return [e.targetTouches[0].clientX + scroll[0] - document.body.clientLeft, e.targetTouches[0].clientY + scroll[1] - document.body.clientTop];
	  // return [e.touches[0].pageX,e.touches[0].pageY];
	};
	/**
	 * Renvoie l'offset d'un élément du DOM par rapport à la fenêtre parente de niveau
	 * le plus élevé.
	 * @param {htmlElement} e
	 * @returns {Array} : Tableau contenant les coordonnées retournées.
	 */
	/**
	kernel.getOffset = function(e) {
	  var offleft = e.offsetLeft;
	  var offtop = e.offsetTop;
	  var parent = e.offsetParent;
	  while (parent != null) { // Ne pas être mettre un test !==
	    offleft += parent.offsetLeft;
	    offtop += parent.offsetTop;
	    parent = parent.offsetParent;
	  }
	  return [offleft,offtop];
	};
	 */
	/**
	 * Renvoie l'offset d'un élément du DOM par rapport à la fenêtre parente de niveau
	 * le plus élevé.
	 * @param {type} e : un div
	 * @returns {Object} x et y contiennent l'offset du div
	 */
	
	kernel.getPosition2 = function (e) {
	  if (e.getBoundingClientRect) return kernel.getOffsetRect(e);
	  var left = 0;
	  var top = 0;
	  while (e.offsetParent != undefined && e.offsetParent != null) {
	    left += e.offsetLeft + (e.clientLeft != null ? e.clientLeft : 0) - e.offsetParent.scrollLeft;
	    top += e.offsetTop + (e.clientTop != null ? e.clientTop : 0) - e.offsetParent.scrollTop;
	    e = e.offsetParent;
	  }
	  return [left, top];
	};
	
	kernel.getOffsetRect = function (elem) {
	  var box = elem.getBoundingClientRect();
	  var body = document.body;
	  var docElem = document.documentElement;
	
	  var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
	  var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
	
	  var clientTop = docElem.clientTop || body.clientTop || 0;
	  var clientLeft = docElem.clientLeft || body.clientLeft || 0;
	
	  var top = box.top + scrollTop - clientTop;
	  var left = box.left + scrollLeft - clientLeft;
	
	  return [Math.round(left), Math.round(top)];
	};
	/* Abandonné version 4.9.9.3
	mtg32.getPosition2FirstNonStatic = function(e){
	  var left = 0;
	  var top = 0;
	  // var pos = e.style.position;
	  while (((e.style.position == "" ) || (e.style.position == "static")) && e.offsetParent != undefined && e.offsetParent != null)
	  {
	    left += e.offsetLeft + (e.clientLeft != null ? e.clientLeft : 0);
	    top += e.offsetTop + (e.clientTop != null ? e.clientTop : 0);
	    e = e.offsetParent;
	  }
	  return {
	    x:left,
	    y:top
	  };
	}
	*/
	/**
	 * Rend les élements de el non sélectionnables à la souris.
	 * @param {htmlElement} el
	 * @returns {undefined}
	 */
	/** Abandonné et remplacé par une feuille de styles css
	kernel.disableSelection = function(el) {
	  var s = el.style;
	  s.userSelect = "none";
	  s.webkitUserSelect = "none";
	  s.MozUserSelect = "none";
	  el.setAttribute("unselectable", "on");
	};
	 */
	/* Abandonné version 4.9.2
	mtg32.getDiv4Start =  function(id) {
	  var div = document.createElement("div");
	  div.setAttribute("id", id);
	  div.setAttribute("style", "border:1px;font-size: 12px;visibility: hidden;");
	  div.innerHTML = "$$ \\textcolor{blue}{M} \\color[RGB]{0,0,0} \\alpha \\beta \\gamma \\delta \\varepsilon \\zeta \\eta \\theta \\kappa \\lambda \\mu \\nu \\xi \\pi \\rho \\sigma \\tau \\varphi \\chi \\psi \\omega \\Gamma \\Delta \\Xi \\Pi \\Sigma \\Phi \\Psi \\Omega \\le \\ge \\forall \\exists \\emptyset \\nabla \\notin \\in \\ni \\prod \\sum \\infty \\wedge \\vee \\cap \\cup \\int \\sim \\cong \\approx \\sim \\simeq \\ne \\equiv \\subset \\not\\subset \\supset \\ell \\perp \\oplus \\otimes \\uparrow \\leftarrow \\rightarrow \\downarrow \\leftrightarrow \\updownarrow \\Leftrightarrow \\Rightarrow \\Leftarrow \\nLeftrightarrow \\mapsto \\nRightarrow \\nLeftarrow \\hookleftarrow \\hookrightarrow \\circlearrowleft \\circlearrowright \\begin{array}{l}{x}\\\\ {1}\\\\ {\\left( \\frac{u}{v } \\right)=} \\\\ {f'(x)=\\frac{2\\left( {x-3 } \\right) - \\left( {2x } \\right)}{\\left( {x-3 } \\right)^2 }=\\frac{2x-6-2x }{\\left( { x-3 } \\right)^2}} \\\\ {\\text{donc }f'(x) = \\frac{-6 }{\\left( {x-3 } \\right)^2 } } \\end{array} \\left[{a}\\right] u^2 \\text{abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ() .éèêà} \\times - + a^2 \\int_{a}^{b} f'(t)dt \\vec{u} \\overrightarrow {AB} \\overline {AB} \\underline {AB} \\widehat{BAC} \\sin \\cos \\tan \\ln \\lim_{x \\to { }} \\left\\| {a} \\right\\| \\sum_{a}^{b} \\prod{a}^{b} \\lim_{x \\to {a}} \\begin{matrix}{a} & {b}\\\\{c} & {d}\\end{matrix} \\sqrt{\\frac{x^2}{x+1}} \\sqrt [3] {a} \\acute{e} \\grave{e} \\grave{a} \\grave{u} \\hat{e} \\hat{o} \\hat{a}  $$"
	  return div;
	}
	*/
	
	kernel.divComp = function (z1, z2, zRes) {
	  var a, b, c, d, r, den;
	  a = z1.x;
	  b = z1.y;
	  c = z2.x;
	  d = z2.y;
	  if (Math.abs(d) <= Math.abs(c)) {
	    r = d / c;
	    den = c + d * r;
	    zRes.x = (a + b * r) / den;
	    zRes.y = (b - a * r) / den;
	  } else {
	    r = c / d;
	    den = c * r + d;
	    zRes.x = (a * r + b) / den;
	    zRes.y = (b * r - a) / den;
	  }
	};
	
	/**
	 * Fonction renvoyant true si le point de coordonnées (x,y) est sur le cercle (ou descendant de cercle)
	 * @param cercle
	 * @param x
	 * @param y
	 * @return
	 */
	kernel.appartientCercle = function (cercle, x, y) {
	  return kernel.zero(kernel.distancePointPoint(x, y, cercle.centre_x, cercle.centre_y) - cercle.rayon);
	};
	
	kernel.descriptionNature = ["PointLibre", "PointCons", "PointLie", "Barycentre", "PointRep", "PointLibreEnt", "PointParAff", "PointLiePoint", "Macro", "Dte", "Vect", "Seg", "Ddte", "Cerc", "MarqueAng", "Arc", "Polygone", "Surf", "LieuPt", "LieuPtDis", "LigneBrisee", "LieuObj", "Image", "GrapheSuiteR", "GrapheSuiteComp", "Comment", "AffVal", "MarqueSeg", "ObjetDup", "DemiPlan", "PtIntPoly", "Latex", "PtIntCerc", "EditeurFor", "PtClone", "DteClone", "DdteClone", "SegClone", "CercClone"];
	
	module.exports = kernel;

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 *
	 * @type PositionDroiteCercle
	 */
	var PositionDroiteCercle = {
	  Secants: 0,
	  Tangents: 1,
	  Vide: 2
	};
	module.exports = PositionDroiteCercle;

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Sert à définir les différnetes positions relatives de deux droites.
	 * @type mtg32.PositionDroites
	 */
	var PositionDroites = {
	  Paralleles: 0,
	  Confondues: 1,
	  Secantes: 2
	};
	
	module.exports = PositionDroites;

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	* Sert à définir les différentes positions possibles cercle-cercle.
	* @type mtg32.PositionCercleCercle
	*/
	var PositionCercleCercle = {
	  Confondus: 0,
	  Vide: 1,
	  Secants: 2,
	  Tangents: 3
	};
	
	module.exports = PositionCercleCercle;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	// const kernel = require('../kernel/kernel') Ne fontionne pas (pb de dépendance cyclique)
	// Déplacé dans presqueNull
	
	module.exports = Vect;
	/**
	 * Classe représentant un vecteur de façon interne.
	 * Classe nommée VecteurDirecteur dans la version Java
	 * @constructor
	 * @returns {Vect}
	 */
	function Vect() {
	  // Si quatre arguments pour le constructeur, ce sont les coordonnées de l'origine et de l'extrémité'
	  if (arguments.length === 0) {
	    this.x = 0;
	    this.y = 0;
	  } else {
	    if (arguments.length === 4) {
	      this.x = arguments[2] - arguments[0];
	      this.y = arguments[3] - arguments[1];
	    } else {
	      // Sinon constructeur à partir de deux points
	      this.x = arguments[1].x - arguments[0].x;
	      this.y = arguments[1].y - arguments[0].y;
	    }
	  }
	}
	/**
	 * Fonction faisant de vect une copie de this.
	 * vect doit être un objet Vect
	 * @param {Vect} vect
	 * @returns {undefined}
	 */
	Vect.prototype.setCopy = function (vect) {
	  vect.x = this.x;
	  vect.y = this.y;
	};
	/**
	 * Fonction faisant de this un Vect d'origine x1 et d'extrémité x2
	 * si le nombre d'arguement est 2 et (x1,y1) et (x2,y2) si le nombre d'argumetns est4.
	 * @param {Float|CPt} x1
	 * @param {Float|CPt} y1
	 * @param {Float} x2
	 * @param {Flaot} y2
	 * @returns {undefined}
	 */
	Vect.prototype.setVecteur = function (x1, y1, x2, y2) {
	  if (arguments.length === 2) {
	    this.x = y1.x - x1.x;
	    this.y = y1.y - x1.y;
	  } else {
	    this.x = x2 - x1;
	    this.y = y2 - y1;
	  }
	};
	/**
	 * Renvoie la norme du vecteur.
	 * @returns {Number}
	 */
	Vect.prototype.norme = function () {
	  return Math.sqrt(this.x * this.x + this.y * this.y);
	};
	/**
	 * Rebvoie true si les deux coordonnées du vecteur sont nulles.
	 * @returns {Boolean}
	 */
	Vect.prototype.nul = function () {
	  return this.x === 0 && this.y === 0;
	};
	/**
	 * Renvoie true si le vecteur est "presque" nul.
	 * @returns {Boolean}
	 */
	Vect.prototype.presqueNul = function () {
	  var kernel = __webpack_require__(8);
	  return kernel.zero(this.x) && kernel.zero(this.y);
	};
	/**
	 * Fait de vect un vecteur orthogonal à this et de même norme.
	 * @param {Vect} vect
	 * @returns {undefined}
	 */
	Vect.prototype.getOrthogonal = function (vect) {
	  vect.y = this.x;
	  vect.x = -this.y;
	};
	// Fait du Vect v un Vect de norme norme, colinéaire à v et de même sens
	/**
	 * Fait du Vect v un Vect de norme normeSouhaitee, colinéaire à v et de même sens
	 * @param {Float} normeSouhaitee : nombre positif strictement.
	 * @param {Vect} v
	 * @returns {undefined}
	 */
	Vect.prototype.vecteurColineaire = function (normeSouhaitee, v) {
	  var norm = this.norme();
	  v.x = this.x / norm * normeSouhaitee;
	  v.y = this.y / norm * normeSouhaitee;
	};
	/**
	 * Renvoie la mesure en radians de l'angle polaire du vecteur this non null
	 * Renvoie 0 si le vecteur est nul.
	 * @returns {Float}
	 */
	Vect.prototype.angleRad = function () {
	  var angle;
	  if (this.x === 0 && this.y === 0) return 0;else {
	    if (this.x === 0) {
	      if (this.y > 0) angle = 3 * Math.PI / 2;else angle = Math.PI / 2;
	    } else {
	      if (this.x >= 0) angle = Math.atan(-this.y / this.x);else angle = Math.PI - Math.atan(this.y / this.x);
	      if (angle < 0) angle = angle + 2 * Math.PI;
	    }
	  }
	  return angle;
	};
	/**
	 * Fonction renvoyant la mesure en radians de l'angle orienté
	 * formé par les vecteurs u et v, cette mesure étant valable
	 * dans le repère observateur,  et étant l'opposée de celle
	 * valable dans le système de coordonnées utilisé par Windows
	 * @param {type} v
	 * @returns {Number}
	 */
	Vect.prototype.mesureAngleVecteurs = function (v) {
	  var prosca, deter, tangente, resul;
	  prosca = v.x * this.x + v.y * this.y;
	  deter = v.x * this.y - v.y * this.x;
	  if (prosca === 0) {
	    if (deter > 0) resul = Math.PI / 2;else resul = -Math.PI / 2;
	  } else {
	    tangente = deter / prosca;
	    if (prosca > 0) resul = Math.atan(tangente);else {
	      if (deter >= 0) resul = Math.atan(tangente) + Math.PI;else resul = Math.atan(tangente) - Math.PI;
	    }
	  }
	  return resul;
	};
	/**
	 * Fonction faisant de v un vecteur image de this par la rotation
	 * d'angle angle (donné en radian).
	 * @param {Float} angle
	 * @param {Vect} v
	 * @returns {undefined}
	 */
	Vect.prototype.tourne = function (angle, v) {
	  var kc, ks;
	  kc = Math.cos(angle);
	  ks = Math.sin(angle);
	  v.x = kc * this.x + ks * this.y;
	  v.y = kc * this.y - ks * this.x;
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var RInfoObjetsVoisins = __webpack_require__(14);
	var Nat = __webpack_require__(4);
	module.exports = InfoProx;
	/**
	 * Classe utilisée pour donner des informations sur les objets proches du pointeur souris.
	 * @constructor
	 * @returns {InfoProx}
	 */
	function InfoProx() {
	  this.infoParType = new Array(NatObj.nombreTypesDesignables);
	  for (var i = 0; i < NatObj.nombreTypesDesignables; i++) {
	    this.infoParType[i] = new RInfoObjetsVoisins();
	  }this.metAZero();
	}
	/**
	 * Réinitialise l'objet.
	 * @returns {undefined}
	 */
	InfoProx.prototype.metAZero = function () {
	  this.nombreObjetsProches = 0;
	  this.nombrePointsVoisins = 0;
	  this.typesProches = new Nat(0, 0);
	  this.premierPointVoisinRencontre = true;
	  this.premierPointVoisin = null;
	  this.dernierPointVoisin = null;
	  for (var ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
	    this.infoParType[ind].nombreVoisins = 0;
	    this.infoParType[ind].premierVoisin = null;
	    this.infoParType[ind].dernierVoisin = null;
	    this.infoParType[ind].premierVoisinRencontre = true;
	  }
	};
	/**
	 * Remet à zéro les infos sur les objets qui ne sont pas des points
	 * @returns {undefined}
	 */
	InfoProx.prototype.metAZeroObjetsNonPoints = function () {
	  for (var ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
	    if (!NatObj.conversionNumeroNature[ind].isOfNature(NatObj.NTtPoint)) {
	      this.infoParType[ind].nombreVoisins = 0;
	      this.infoParType[ind].premierVoisin = null;
	      this.infoParType[ind].dernierVoisin = null;
	      this.infoParType[ind].premierVoisinRencontre = true;
	    }
	  }
	};
	
	/**
	 * Renvoie un pointeur sur le premier point proche du pointeur souris.
	 * @returns {}
	 */
	InfoProx.prototype.premierVoisin = function () {
	  var elg = null;
	  for (var i = 0; i < NatObj.nombreTypesDesignables && elg === null; i++) {
	    if (this.infoParType[i].nombreVoisins > 0) elg = this.infoParType[i].premierVoisin;
	  }
	  return elg;
	};
	/**
	 * Renvoie un pointeur sur le dernier point proche du pointeur souris.
	 * @returns {}
	 */
	InfoProx.prototype.dernierVoisin = function () {
	  var elg = null;
	  for (var i = NatObj.nombreTypesDesignables - 1; i >= 0 && elg === null; i--) {
	    if (this.infoParType[i].nombreVoisins > 0) {
	      if (this.infoParType[i].dernierVoisin === null) elg = this.infoParType[i].premierVoisin;else elg = this.infoParType[i].dernierVoisin;
	    }
	  }
	  return elg;
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Objet dfinissant les objets voisins. Utilisé pour les déplacements de souris.
	 */
	module.exports = RInfoObjetsVoisins;
	
	function RInfoObjetsVoisins() {
	  this.premierVoisin = null;
	  this.dernierVoisin = null;
	  this.nombreVoisins = 0;
	  this.premierVoisinRencontre = null;
	}

/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	module.exports = Point;
	/**
	 * Classe représentant un point par ses coordonnées.
	 * Utilisé de façon interne.
	 * @constructor
	 * @param {Float} x
	 * @param {Float} y
	 * @returns {Point}
	 */
	function Point(x, y) {
	  if (arguments.length === 0) {
	    this.x = 0;
	    this.y = 0;
	  } else {
	    this.x = x;
	    this.y = y;
	  }
	}

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	module.exports = Pointeur;
	/**
	 * Objet servant à contenir un pointeur sur un autre objet.
	 * @constructor
	 * @param {Object} valInit
	 * @returns {Pointeur}
	 */
	function Pointeur(valInit) {
	  if (arguments.length === 0) this.pointeur = null;else this.pointeur = valInit;
	}
	// Modifié version new
	Pointeur.prototype.setValue = function (el) {
	  this.pointeur = el;
	};
	Pointeur.prototype.getValue = function () {
	  return this.pointeur;
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var Dimf = __webpack_require__(7);
	var Fonte = __webpack_require__(18);
	var Opef = __webpack_require__(19);
	var Opef2v = __webpack_require__(20);
	var Opef3v = __webpack_require__(21);
	var Opef4v = __webpack_require__(22);
	var Opef5v = __webpack_require__(23);
	var Pointeur = __webpack_require__(16);
	var kernel = __webpack_require__(8);
	var DataInputStream = __webpack_require__(24);
	var Nat = __webpack_require__(4);
	var factory = __webpack_require__(26);
	var CalcR = __webpack_require__(55);
	var CalcC = __webpack_require__(69);
	
	module.exports = CListeObjets;
	
	// Spécial JavaScript : une liste pourra avoir une id éventuelle qui sera celle de l'éventuel
	// document qui la possède. Tous les objets graphiques ajoutés dans le DOM auront une id qui sera celle
	// de la liste les possédant suivi de l'indice de l'objet dans la liste qui le possède
	// mtg32.heapSizeMobile = 2 ; // le nombre maxi de move qu'on peut empiler pour périph mobile. Lus utilisé version 4.9.9.4
	//mtg32.heapSizeWeb = 5; // le nombre maxi de move qu'on peut empiler pour navigateur
	/**
	 * Classe chargée de contenir  des objets numériques ou graphiques.
	 * Utilisée pour contenir la liste principale des objets de la figure.
	 * Peut aussi servir dans des objets de la liste.
	 * Chaque élément de la liste possède un membre index qui donne son indice dans la Liste, pour
	 * éviter les lenteurs de indexOf pour les listes avevc de nombreux objets.
	 * Chaque fois que l'ordre des objets de la liste est modifié, il faut donc appeler updateIndexes.
	 * Spécial JavaScript : une liste pourra avoir une id éventuelle qui sera celle de l'éventuel
	 * Tous les objets graphiques ajoutés dans le DOM auront une id qui sera celle
	 * de la liste les possédant suivi de l'indice de l'objet dans la liste qui le possède
	 * document qui la possède.
	 * @constructor
	 * @param {kernel.uniteAngle} uniteAngle : L'unité d'angle de la figure.
	 * @param {String} id : null ou l'id du svg associé pour la liste principale de la figure.
	 * @returns {CListeObjets}
	 */
	function CListeObjets(uniteAngle, id) {
	  this.col = []; // La liste effective des objets
	  this.macroDemarrage = null;
	  this.numeroVersion = DataInputStream.numeroVersionActif; // Rectifié version 4.8
	  if (arguments.length === 0) {
	    this.id = "";
	    this.uniteAngle = kernel.uniteAngle.degre;
	  } else {
	    if (typeof uniteAngle === "string") {
	      if (uniteAngle === "radian") this.uniteAngle = kernel.uniteAngle.radian;else this.uniteAngle = kernel.uniteAngle.degre;
	    } else this.uniteAngle = uniteAngle; // Pourra être une chaîne de caractères en JavaScript
	    if (arguments.length === 2) this.id = id;else this.id = "";
	  }
	  this.documentProprietaire = null;
	  this.pointeurLongueurUnite = null;
	  this.macroEnCours = null;
	  this.macroParDefaut = null;
	  // Spécial JavaScript pour gérer les traces
	  // this.traces = new Array(); PLus utilisé version 4.9.9.4
	  this.nbTraces = 0;
	  // this.heapMove = [];
	  // this.heapSize = mtg32.heapSizeWeb; PLus utilisé version 4.9.9.4
	}
	// On établit la distance considérée comme proche pour les outils de pointage suivant qu'on est sur périphérique mobile ou non
	// CListeObjets.distanceMiniPourEtreProche =  /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? 20 : 10;
	CListeObjets.nbMaxiTraces = 500; // Nombre maxi de traces
	// CListeObjets.prototype = Object.create(Array.prototype);
	CListeObjets.prototype.constructor = CListeObjets;
	CListeObjets.prototype.className = "CListeObjets";
	
	/**
	 * Ajout version mtgApp
	 * Si la liste est crée pour être interne à un document, this.documentProprietaire pointe sur ce document
	 * Sinon this.documentProprietaire reste null
	 * @param doc
	 */
	CListeObjets.prototype.associeA = function (doc) {
	  this.documentProprietaire = doc;
	};
	/**
	 * Ajoute l'élément elb à la liste.
	 * @param {type} elb
	 * @returns {undefined}
	 */
	CListeObjets.prototype.add = function (elb) {
	  if (elb.listeProprietaire === this) elb.index = this.longueur(); // Modifié version 4.8.0
	  this.col.push(elb);
	};
	/**
	 * On retire éventuellement les CComponent instanciés par les objets sur le MtgInternalFrame
	 * C'est le cas pour CEditeurFormule
	 */
	/**
	 * Retire l'élement d'indice ind de la liste.
	 * On retire éventuellement les composants du DOM instanciés par les objets (CEditeurFormule)
	 * @param {integer} ind : L'indice de l'objet
	 * @returns {Array}
	 */
	CListeObjets.prototype.remove = function (ind) {
	  // elb est un objet
	  var elb = this.get(ind);
	  var liste = elb.listeProprietaire;
	  if (liste !== null) {
	    var doc = liste.documentProprietaire;
	    if (doc !== null) {
	      elb.deleteComponent(); // Nom changé par rapport à version Java.
	    }
	  }
	  // Modifié version mtgApp
	  /*
	  var b = this.col.splice(ind,1);
	  if (b) this.updateIndexes();
	  */
	  if (elb === this.pointeurLongueurUnite) this.pointeurLongueurUnite = null;
	  this.col.splice(ind, 1);
	  // this.updateIndexes(); // Supprimé version mtgApp
	  // return b;
	};
	// Spécial JavaScrit : met l'objet d'indice index à objet
	/**
	 * Remplace l'élement de la liste d'indice index par objet
	 * @param {Integer} index
	 * @param {CElementBase} objet
	 * @returns {undefined}
	 */
	CListeObjets.prototype.set = function (index, objet) {
	  this.col[index] = objet;
	};
	/**
	 * Renvoie true si la liste contient l'objet ob
	 * @param {CElementBase} ob
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.contains = function (ob) {
	  return this.col.indexOf(ob) !== -1;
	};
	/**
	 * Renvoie l'indice de l'objet ob dans la liste et -1 s'il n'y figure pas.
	 * Si la liste est la liste propriétaire de ob, ob.index contient l'indice de ob.
	 * @param {CElementBase} elb
	 * @returns {Number}
	 */
	CListeObjets.prototype.indexOf = function (elb) {
	  if (elb === null) return -1;
	  if (elb.listeProprietaire === this) return elb.index;
	  for (var i = 0; i < this.col.length; i++) {
	    if (this.col[i] === elb) return i;
	  }
	  return -1;
	};
	/**
	 * Fonction renvoyant la longueur de la liste.
	 * @returns {Integer}
	 */
	CListeObjets.prototype.longueur = function () {
	  return this.col.length;
	};
	/**
	 * Renvoie l'élément elb de la liste d'indice indice saud si
	 * l'argument cla est spécifié, et si cet élément elb est un CElementGenerique
	 * (utilisé dans le simplémentations de constructions, renvoie un nouvel objet
	 * nouv de classe cla tel que nouv.elementGeneriqueAssocie = elb.
	 * @param {Integer} indice
	 * @param {String} cla : Un nom de classe d'objet desendant de CElementBase
	 * @returns {Array|CListeObjets.prototype.get.nouv|mtg32}
	 */
	CListeObjets.prototype.get = function (indice, cla) {
	  if (indice === -1) return null;
	  if (arguments.length === 1) return this.col[indice];
	  var nouv = null;
	  var elb = this.get(indice);
	  if (elb.className === "CElementGenerique") {
	    // On remplace le CElementGenerique par un nouvel objet de classe cla
	    nouv = factory(cla, this);
	    nouv.elementGeneriqueAssocie = elb;
	    // On leurre le prototype en lui renvoyant un pointeur sur un élément pas
	    // réellement implanté;
	    return nouv;
	  } else return this.col[indice];
	};
	/**
	 * Fonction renvoyant l'élement de la liste dont le numéro d'identification est ind
	 * ind est renvoyé par la version java de MathGraph32 soit par F5 (n° d'identification html)
	 * ou par Aide - Info sur objet graphique.
	 * @param {type} ind
	 * @returns {CElementBase}
	 */
	CListeObjets.prototype.getById = function (ind) {
	  var i, elb, ch;
	  ch = this.id + "#" + ind;
	  for (i = 0; i < this.longueur(); i++) {
	    elb = this.get(i);
	    if (elb.id === ch) return elb;
	  }
	  return null;
	};
	/**
	 * Fonction initialisant l'unité d'angle et pointeurLongueurUnite
	 * @param {kernel.uniteAngle} uniteAngle
	 * @param {type} pointeurLongueurUnite
	 * @returns {undefined}
	 */
	CListeObjets.prototype.initialise = function (uniteAngle, pointeurLongueurUnite) {
	  this.pointeurLongueurUnite = pointeurLongueurUnite;
	  this.uniteAngle = uniteAngle;
	};
	/**
	 * Fonction renvoyant true si au moins un des objets de la liste dépend de ptel
	 * @param {CElementBase} ptel
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.dependDe = function (ptel) {
	  var resultat = false;
	  for (var i = 0; i < this.col.length; i++) {
	    resultat = resultat || this.get(i).dependDe(ptel);
	  }return resultat;
	};
	/**
	 * Fonction renvoyant true si au moins un des objets de la liste dépend de ptel
	 * Utilisé pour les macros de boucle.
	 * @param {CElementBase} ptel
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.dependDePourBoucle = function (ptel) {
	  var resultat = false;
	  for (var i = 0; i < this.col.length && !resultat; i++) {
	    resultat = resultat || this.get(i).dependDePourBoucle(ptel);
	  }return resultat;
	};
	/**
	 * Fonction renvoyant true si au moins un des objets de la liste existe.
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.existeAuMoinsUnElement = function () {
	  var resultat = false;
	  for (var i = 0; i < this.col.length && !resultat; i++) {
	    resultat = resultat || this.get(i).existe;
	  }return resultat;
	};
	/**
	 * Fonction initialisant this.nombreIterations à 0 avant un calcul de façon à ne pas faire
	 * trop de boucles dans la produits et sommes indicés.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.initialiseNombreIterations = function () {
	  this.nombreIterations = 0;
	};
	/**
	 * Fonction ajoutant à this les éléments de la liste liste.
	 * @param {CListeObjets} liste
	 * @returns {undefined}
	 */
	CListeObjets.prototype.ajouteElementsDe = function (liste) {
	  for (var i = 0; i < liste.col.length; i++) {
	    this.add(liste.get(i));
	  }
	};
	/**
	 * Fonction ajoutant à this les points punaisés contenus dans list
	 * @param {CListeObjets} list
	 * @returns {undefined}
	 */
	CListeObjets.prototype.ajoutePointsPunaises = function (list) {
	  for (var i = 0; i < list.col.length; i++) {
	    var elb = list.get(i);
	    if (!elb.estElementIntermediaire() && elb.estDeNature(NatObj.NPointMobile)) if (!elb.estLibre()) this.add(elb);
	  }
	};
	/**
	 * Fonction ajoutant à this les éléments de list qui dépendent de ptel sauf exclu
	 * @param {CElementBase} ptel
	 * @param {CListeObjets} list
	 * @param {CElementBase} exclu
	 * @returns {undefined}
	 */
	CListeObjets.prototype.ajouteObjetsDependantsSauf = function (ptel, list, exclu) {
	  for (var i = 0; i < list.col.length; i++) {
	    var elb = list.get(i);
	    if (elb.dependDePourCapture(ptel) && elb !== exclu) this.add(elb);
	  }
	};
	/**
	 * Fonction donnant le statut visible à tous les éléments graphiques de la liste.
	 * @param {type} visible
	 * @returns {undefined}
	 */
	CListeObjets.prototype.montreTout = function (visible) {
	  for (var i = 0; i < this.col.length; i++) {
	    var elb = this.get(i);
	    if (elb.estDeNature(NatObj.NTtObj)) if (visible) elb.montre();else elb.cache();
	  }
	};
	/**
	 * Fonction retirant tous les objets de la liste.
	 * A ne pas utiliser pour la liste principale quand on veut détruire tous ses objets
	 * car les évntuels composants créés ne sont pas détruits.
	 * @returns
	 */
	/**
	 * Fonction retirant tous les objets de la liste.
	 * A ne pas utiliser pour la liste principale quand on veut détruire tous ses objets
	 * car les évntuels composants créés ne sont pas détruits.
	 * @param bdeletePointeurListe : Si présent et true, on retire l'association entre chaque élément et sa liste proprietaire
	 */
	CListeObjets.prototype.retireTout = function (bdeletePointeurListe) {
	  if (arguments.length !== 0 && bdeletePointeurListe) {
	    for (var i = 0; i < this.longueur(); i++) {
	      var el = this.get(i);
	      el.listeProprietaire = null;
	    }
	  }
	  this.col.splice(0, this.col.length);
	};
	/**
	 * Fonction rajoutant à listeCible des clones de tous les éléments de this
	 * @param {CListeObjets} listeCible
	 * @returns {undefined}
	 */
	CListeObjets.prototype.setCopy = function (listeCible) {
	  listeCible.documentProprietaire = this.documentProprietaire;
	  listeCible.id = this.id;
	  listeCible.uniteAngle = this.uniteAngle; // Avant le recalcul
	  for (var i = 0; i < this.col.length; i++) {
	    listeCible.add(this.get(i).getClone(this, listeCible));
	  }
	  if (this.pointeurLongueurUnite !== null) listeCible.pointeurLongueurUnite = listeCible.get(this.indexOf(this.pointeurLongueurUnite));else listeCible.pointeurLongueurUnite = null;
	  listeCible.etablitListesInternesMacros();
	};
	/**
	 * Cette fonction fait de la liste this dans listeProprietaireCible l'équivalent
	 * de ce qu'est listeSource dans listePropretaireSource.
	 * ListeProprietaireCible doit être une liste clonée.
	 * @param {CListeObjets} listeSource
	 * @param {CListeObjets} listeProprietaireSource
	 * @param {CListeObjets} listeProprietaireCible
	 * @returns {undefined}
	 */
	CListeObjets.prototype.setImage = function (listeSource, listeProprietaireSource, listeProprietaireCible) {
	  for (var i = 0; i < listeSource.col.length; i++) {
	    var elb = listeSource.get(i);
	    var indexSource = listeProprietaireSource.indexOf(elb);
	    var elbCible = listeProprietaireCible.get(indexSource, "CElementBase");
	    this.add(elbCible);
	  }
	  this.uniteAngle = listeSource.uniteAngle;
	  if (listeSource.pointeurLongueurUnite !== null) this.pointeurLongueurUnite = this.get(listeSource.indexOf(listeSource.pointeurLongueurUnite));
	};
	/**
	 * Fonction faisant de la liste en cours une copie de listeSource (en faisant
	 * en sorte que leurs objets aient les mêmes caractéristiques)
	 * @param {CListeObjets} listeSource
	 * @returns {undefined}
	 */
	CListeObjets.prototype.setClone = function (listeSource) {
	  var index = 0;
	  while (index < this.col.length && index < listeSource.col.length) {
	    var elbSource = listeSource.get(index);
	    var elb = this.get(index);
	    elb.setClone(elbSource);
	    index++;
	  }
	};
	/**
	 * Fonction recalculant tous les éléments de la liste sauf les calculs de dérivées
	 * ou test d'équivalence de calculs ou tests de factorisation.
	 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
	 * pour fournir de nouveaux résultats aléatoires.
	 * @param {Dimf} dimfen
	 * @returns {undefined}
	 */
	CListeObjets.prototype.positionne = function (infoRandom, dimfen) {
	  for (var i = 0; i < this.col.length; i++) {
	    this.get(i).positionne(infoRandom, dimfen);
	  }
	};
	/**
	 * Fonction recalculant tous les éléments de la liste y compris les calculs de dérivées
	 * ou test d'équivalence de calculs ou tests de factorisation.
	 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
	 * pour fournir de nouveaux résultats aléatoires.
	 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
	 * pour fournir de nouveaux résultats aléatoires.
	 * @param {Dimf} dimfen
	 * @returns {undefined}
	 */
	CListeObjets.prototype.positionneFull = function (infoRandom, dimfen) {
	  for (var i = 0; i < this.col.length; i++) {
	    this.get(i).positionneFull(infoRandom, dimfen);
	  }
	};
	// Fonction ne recalculant que les objets non graphiques de la figure.
	/**
	 * Fonction ne recalculant que les objets non graphiques de la figure, y compris les calculs de dérivées
	 * ou test d'équivalence de calculs ou tests de factorisation.
	 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
	 * pour fournir de nouveaux résultats aléatoires.
	 * @param {Dimf} dimfen
	 * @returns {undefined}
	 */
	CListeObjets.prototype.positionneFullNG = function (infoRandom, dimfen) {
	  for (var i = 0; i < this.col.length; i++) {
	    var el = this.get(i);
	    if (el.getNature() === NatObj.NAucunObjet) el.positionneFull(infoRandom, dimfen);
	  }
	};
	/**
	 * Fonction ne recalculant que les éléments de la figure qui dépendent de pt
	 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
	 * pour fournir de nouveaux résultats aléatoires.
	 * @param {Dimf} dimfen
	 * @param {type} pt
	 * @returns {undefined}
	 */
	CListeObjets.prototype.positionneDependantsDe = function (infoRandom, dimfen, pt) {
	  for (var i = 0; i < this.col.length; i++) {
	    var elb = this.get(i);
	    if (elb.dependDe(pt)) elb.positionne(infoRandom, dimfen);
	  }
	};
	/**
	 * Fonction recherchant les éléments graphiques de la figure qui sont proche de point
	 * sauf ceux qui sont compris dans listeExclusion.
	 * @param {Nat} typeCherche : Indique quels sont le ou les types d'objest cherchés.
	 * @param {type} point : Contient les coordonnées du pointeur souris.
	 * @param {InfoProx} info : Mémorise les infos sur les objets proches.
	 * @param {CListeObjets} listeExclusion : iste contenant les objets exclus de la recherche
	 * (par exemple les points punaisés).
	 * @param {type} prioritePoints : Si true on donne une priorité aux points dans la recherche.
	 * @param deviceType {String} : "mouse" pour un appel depuis un événement souris et "touch" pour un tactile
	 * @param bModifiableParMenu {boolean}  : true si on ne veut désigner que les éléments modifiables par un menu
	 * @param {boolean} bMemeMasque : true si on recherche aussi parmi les éléments masqués
	 * @returns {Number}
	 */
	CListeObjets.prototype.procheDe = function (typeCherche, point, info, listeExclusion, prioritePoints, deviceType, bmodifiableParMenu, bMemeMasque) {
	  var ind, indnat, nat, ptel, dis, b;
	  if (this.longueur() === 0) return 0;
	  var bModifParMenu = arguments.length < 7 ? false : bmodifiableParMenu;
	  var bmmMasque = arguments.length < 8 ? false : bMemeMasque;
	  info.metAZero();
	  // On traite tous les éléments de la liste
	  for (var i = 0; i < this.col.length; i++) {
	    ptel = this.get(i);
	    if (listeExclusion.indexOf(ptel) === -1) {
	      nat = ptel.getNature();
	      b = nat.isOfNature(typeCherche);
	      if (bModifParMenu) b = b && ptel.modifiableParMenu();
	      if (b) {
	        // ptelg = (CElementGraphique) ptel;
	        // if ((!ptel.masque || bmmMasque) && !ptel.estElementIntermediaire()) {
	        if (!ptel.estElementIntermediaire()) {
	          var distmin = deviceType === "touch" ? kernel.distMinForTouch : kernel.distMinForMouse;
	          dis = ptel.distancePoint(point.x, point.y, !bmmMasque, distmin);
	          if (dis !== -1 && dis < distmin) {
	            info.typesProches = Nat.or(info.typesProches, nat);
	            indnat = NatObj.indiceDeNature(nat);
	            info.infoParType[indnat].nombreVoisins++;
	            if (nat.isOfNature(NatObj.NTtPoint)) {
	              info.nombrePointsVoisins++;
	              if (info.premierPointVoisinRencontre) {
	                info.premierPointVoisin = ptel;
	                info.dernierPointVoisin = ptel;
	                info.premierPointVoisinRencontre = false;
	              } else info.dernierPointVoisin = ptel;
	            }
	            if (info.infoParType[indnat].premierVoisinRencontre) {
	              info.infoParType[indnat].premierVoisin = ptel;
	              info.infoParType[indnat].premierVoisinRencontre = false;
	            } else {
	              info.infoParType[indnat].dernierVoisin = ptel;
	            }
	          }
	        }
	      }
	    }
	  }
	  if (prioritePoints && info.nombrePointsVoisins > 0) {
	    info.metAZeroObjetsNonPoints();
	    info.typesProches = Nat.and(info.typesProches, NatObj.NTtPoint);
	  }
	  info.nombreObjetsProches = 0;
	  for (ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
	    info.nombreObjetsProches += info.infoParType[ind].nombreVoisins;
	  }
	  info.nombreTypesProches = 0;
	  for (ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
	    if (Nat.and(info.typesProches, NatObj.conversionNumeroNature[ind]).isNotZero()) info.nombreTypesProches++;
	  }
	  return info.nombreObjetsProches;
	};
	/**
	 * Fonction recherchant les éléments graphiques de la figure qui sont proche de point
	 * et qui sont capturables à la souris, sauf ceux qui sont compris dans listeExclusion.
	 * @param {Nat} typeCherche : Indique quels sont le ou les types d'objest cherchés.
	 * @param {type} point : Contient les coordonnées du pointeur souris.
	 * @param {InfoProx} info : Mémorise les infos sur les objets proches.
	 * @param {CListeObjets} listeExclusion : iste contenant les objets exclus de la recherche
	 * (par exemple les points punaisés).
	 * @param {type} prioritePoints : Si true on donne une priorité aux points dans la recherche.
	 * @param deviceType {String} : "mouse" pour un appel depuis un événement souris et "touch" pour un tactile
	 * @returns {Number}
	 */
	CListeObjets.prototype.procheDePourCapture = function (typeCherche, point, info, listeExclusion, prioritePoints, deviceType) {
	  var ind, indnat;
	  var nat;
	  var ptel;
	  var dis;
	  if (this.longueur() === 0) return 0;
	  info.metAZero();
	  // On traite tous les éléments de la liste
	  for (var i = 0; i < this.col.length; i++) {
	    ptel = this.get(i);
	    if (ptel.estCapturableSouris() && listeExclusion.indexOf(ptel) === -1) {
	      nat = ptel.getNature();
	      if (nat.isOfNature(typeCherche)) {
	        // Modification par rapport au C++
	        // ptelg = (CElementGraphique) ptel;
	        if (!ptel.masque && !ptel.estElementIntermediaire()) {
	          var distmin = deviceType === "touch" ? kernel.distMinForTouch : kernel.distMinForMouse;
	          dis = ptel.distancePoint(point.x, point.y, true, distmin);
	          if (dis !== -1 && dis < distmin) {
	            info.typesProches = Nat.or(info.typesProches, nat);
	            indnat = NatObj.indiceDeNature(nat);
	            info.infoParType[indnat].nombreVoisins++;
	            if (nat.isOfNature(NatObj.NTtPoint)) {
	              info.nombrePointsVoisins++;
	              if (info.premierPointVoisinRencontre) {
	                info.premierPointVoisin = ptel;
	                info.dernierPointVoisin = ptel;
	                info.premierPointVoisinRencontre = false;
	              } else info.dernierPointVoisin = ptel;
	            }
	
	            if (info.infoParType[indnat].premierVoisinRencontre) {
	              info.infoParType[indnat].premierVoisin = ptel;
	              info.infoParType[indnat].premierVoisinRencontre = false;
	            } else info.infoParType[indnat].dernierVoisin = ptel;
	          }
	        }
	      }
	    }
	  }
	
	  // Si prioritePoint est true, priorités aux objets points sauf si on est proche d'un repère
	  if (prioritePoints && info.nombrePointsVoisins > 0) {
	    info.metAZeroObjetsNonPoints(); // Ajouté version 2.7
	    info.typesProches = Nat.and(info.typesProches, NatObj.NTtPoint); // Car un repère se désigne par son origine ds la version java
	  }
	  info.nombreObjetsProches = 0;
	  for (ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
	    info.nombreObjetsProches += info.infoParType[ind].nombreVoisins;
	  }info.nombreTypesProches = 0;
	  for (ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
	    if (Nat.and(info.typesProches, NatObj.conversionNumeroNature[ind]).isNotZero()) info.nombreTypesProches++;
	  }
	  return info.nombreObjetsProches;
	};
	
	/**
	 * Renvoie un pointeur sur le calcul ou la fonction de nom nom dont le test nat & NatCal est non nul
	 * @param {mtg32.Nature} nat
	 * @param {String} nom
	 * @param {Integer} indiceMaxi : -1 pour une recherche dans toute la liste et sinon l'indice mai de la recherche.
	 * @returns {CElementBase} : Retourne null si la recherche n'a pas abouti.
	 */
	CListeObjets.prototype.pointeurParNatureCalcul = function (nat, nom, indiceMaxi) {
	  var indmax;
	  if (arguments.length <= 2) indmax = this.longueur() - 1;else indmax = indiceMaxi;
	  if (indmax === -1) indmax = this.longueur() - 1;
	  var i = 0;
	  var elb = null;
	  var trouve = false;
	  while (!trouve && i <= indmax) {
	    elb = this.get(i);
	    if (elb.estDeNatureCalcul(nat)) {
	      if (elb.getNom() === nom) trouve = true;else i++;
	    } else i++;
	  }
	  if (trouve) return elb;else return null;
	};
	/**
	 * Fonction appelant etablitListesInternes pour toutes les macros contenues dans la liste.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.etablitListesInternesMacros = function () {
	  for (var i = 0; i < this.col.length; i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NMacro) elb.etablitListesInternes();
	  }
	};
	/**
	 * Fonction renvoyant un pointeur sur la première macro dont l'intitulé est intitule.
	 * Renvoie null si la rechercha n'a pas abouti.
	 * @param {String} intitule : Intitulé de la macro recherchée.
	 * @returns {CMacro}
	 */
	CListeObjets.prototype.pointeurMacro = function (intitule) {
	  for (var i = 0; i < this.col.length; i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NMacro) {
	      if (elb.intitule === intitule) return elb;
	    }
	  }
	  return null;
	};
	/**
	 * Fonction recherchant dans la liste une valeur réelle (qui n'est pas un élément
	 * intermédiaire de construction) dont le nom commence par ch
	 * Si elle est trouvée, renvoie la longueur du nom désignant la valeur
	 * (par  exemple AOB pour une mesure d'angle ou le nom d'un calcul)
	 * et pointeurValeur.getValue() renvoie un pointeur sur cette valeur.
	 * @param {String} ch : La chaine recherchée
	 * @param {Pointeur} pointeurValeur
	 * @returns {Integer}
	 */
	CListeObjets.prototype.commenceParNomValeur = function (ch, pointeurValeur) {
	  var longueurNom = { x: 0 };
	  var longueurTrouvee = 0;
	  for (var i = 0; i < this.col.length; i++) {
	    var elb = this.get(i);
	    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(NatCal.NTteValR)) {
	      // ptv = (CValDyn) elb;
	      if (elb.chaineCommenceParNom(ch, longueurNom) && longueurNom.x > longueurTrouvee) {
	        longueurTrouvee = longueurNom.x;
	        pointeurValeur.setValue(elb);
	      }
	    }
	  }
	  return longueurTrouvee;
	};
	/**
	 * Fonction recherchant dans la liste une valeur réelle complexe (qui n'est pas
	 * un élément intermédiaire de construction) dont le nom commence par ch.
	 * Si elle est trouvée, renvoie la longueur du nom désignant la valeur
	 * (par  exemple AOB pour une mesure d'angle ou le nom d'un calcul)
	 * et pointeurValeur.getValue() renvoie un pointeur sur cette valeur.
	 * @param {String} ch : La chaine recherchée
	 * @param {Pointeur} pointeurValeur
	 * @returns {Integer}
	 */
	CListeObjets.prototype.commenceParNomValeurReelleOuComplexe = function (ch, pointeurValeur) {
	  var longueurNom = { x: 0 };
	  var longueurTrouvee = 0;
	  for (var i = 0; i < this.col.length; i++) {
	    var elb = this.get(i);
	    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(NatCal.NTteValROuC)) {
	      if (elb.chaineCommenceParNom(ch, longueurNom) && longueurNom.x > longueurTrouvee) {
	        longueurTrouvee = longueurNom.x;
	        pointeurValeur.setValue(elb);
	      }
	    }
	  }
	  return longueurTrouvee;
	};
	/**
	 * Fonction recherchant dans la liste une fonction ou une suite réelle définie
	 * par l'utilisateur (qui n'est pas un élément intermédiaire de construction)
	 * dont le nom commence par ch.
	 * Si elle est trouvée, renvoie la longueur du nom de la fonction ou suite trouvée
	 * et pointeurFonction.getValue() renvoie un pointeur sur la fonction.
	 * @param {String} ch
	 * @param {Pointeur} pointeurFonction
	 * @returns {Number}
	 */
	CListeObjets.prototype.commenceParNomFonctionUtilisateur = function (ch, pointeurFonction) {
	  // CCalculAncetre ptf;
	  var longueurNom = { x: 0 };
	  var longueurTrouvee = 0;
	  pointeurFonction.setValue(null);
	  for (var i = 0; i < this.col.length; i++) {
	    var elb = this.get(i);
	    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(Nat.or(NatCal.NTteFoncR, NatCal.NDerivee, NatCal.NTteSuiteRecR))) {
	      if (elb.chaineCommenceParNom(ch, longueurNom) && longueurNom.x > longueurTrouvee) {
	        longueurTrouvee = longueurNom.x;
	        pointeurFonction.setValue(elb);
	      }
	    }
	  }
	  return longueurTrouvee;
	};
	/**
	 * Fonction recherchant dans la liste une fonction ou une suite complexe définie
	 * par l'utilisateur (qui n'est pas un élément intermédiaire de construction)
	 * dont le nom commence par ch.
	 * Si elle est trouvée, renvoie la longueur du nom de la fonction ou suite trouvée
	 * et pointeurFonction.getValue() renvoie un pointeur sur la fonction.
	 * @param {String} ch
	 * @param {Pointeur} pointeurFonction
	 * @returns {Integer}
	 */
	CListeObjets.prototype.commenceParNomFonctionComplexeUtilisateur = function (ch, pointeurFonction) {
	  var longueurNom = { x: 0 };
	  var longueurTrouvee = 0;
	  pointeurFonction.setValue(null);
	  for (var i = 0; i < this.col.length; i++) {
	    var elb = this.get(i);
	    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(Nat.or(NatCal.NTteFoncRouC, NatCal.NTteSuiteRecC))) {
	      if (elb.chaineCommenceParNom(ch, longueurNom) && longueurNom.x > longueurTrouvee) {
	        longueurTrouvee = longueurNom.x;
	        pointeurFonction.setValue(elb);
	      }
	    }
	  }
	  return longueurTrouvee;
	};
	/**
	 * Fonction utilisée dans CCb  renvoyant 0 si la chaine pointée par ch ne
	 * pointe pas sur une chaine représentant une valeur ou une fonction mathématique prédéfinie ou
	 * une fonction définie par l'utilisateur ou un parametre.
	 * Les objets intermédiaires de constructions sont sautés dans la recherche.
	 * Sinon, elle renvoie  la longueur du nom le plus long trouve.
	 * Si ParametreTrouve.getValue est non null, c'est qu'on a trouvé le paramètre formel
	 * et parametreTrouve.getValue contient son indice dans le tableau parametreFormel,
	 * sinon, si PointeurValeur est différent de NULL, c'est qu'un a trouvé un nom de valeur ou de fonction
	 * définie par l'utilisateur (les suites étant considérées comme des
	 * fonctions) sinon c'est qu'on a trouvé un nom de fonction prédéfinie dont
	 * la nature est renvoyée dans nomFonction.
	 * Les calculs intermédiaires sont exclus de la recherhce.
	 * @param {String} ch : La chaîne recherchée.
	 * @param {Array} parametreFormel : null ou un tableau contenant les paramètres formels recherchés
	 * @param {Pointeur} pointeurValeur : Si on a trouvé une valeur, pointeurValeur.getValue()
	 * renvoie un pointeur sur celle-ci.
	 * @param {Pointeur} nomFonction : nomFonction.getValue() renvoie la longueur du nom de la fonction trouvée
	 * ou 0 si non trouvée.
	 * @param {Pointeur} parametreTrouve : parametreTrouve.getValue renvoie -1 si le paramètre n'a pas été trouvé
	 * ou sinon son indice dans le tableau parametreFormel
	 * @param {Pointeur} nombreVariables : Renvoie par getValue() le nombre de paramètres formels de la fonction trouvée.
	 * @returns {Integer}
	 */
	CListeObjets.prototype.commenceParNomFonctionOuValeurOuParametre = function (ch, parametreFormel, pointeurValeur, nomFonction, parametreTrouve, nombreVariables) {
	  var CCbGlob = __webpack_require__(31);
	  var longueurNomFonctionPredefinie;
	  var longueurNomValeur;
	  var pointeurSurValeur = new Pointeur(null);
	  var pointeurSurFonction = new Pointeur(null);
	  var longueurNomFonctionUtilisateur;
	  var indiceParametre = -1;
	  var longueurNomParametre = 0;
	  parametreTrouve.setValue(-1);
	  if (parametreFormel !== null) {
	    for (var i = 0; i < parametreFormel.length; i++) {
	      if (ch.indexOf(parametreFormel[i]) === 0 && parametreFormel[i].length > longueurNomParametre) {
	        longueurNomParametre = parametreFormel[i].length;
	        indiceParametre = i;
	        parametreTrouve.setValue(i); // Ligne rajoutée version 4.5.2
	      }
	    }
	  }
	  longueurNomFonctionPredefinie = CCbGlob.commenceParNomFonctionReellePredefinie(ch, nomFonction, nombreVariables);
	  longueurNomValeur = this.commenceParNomValeur(ch, pointeurSurValeur);
	  longueurNomFonctionUtilisateur = this.commenceParNomFonctionUtilisateur(ch, pointeurSurFonction);
	  if (longueurNomFonctionPredefinie === 0 && longueurNomValeur === 0 && longueurNomFonctionUtilisateur === 0 && longueurNomParametre === 0) {
	    return 0;
	  } else {
	    if (longueurNomParametre >= longueurNomFonctionPredefinie && longueurNomParametre >= longueurNomValeur && longueurNomParametre >= longueurNomFonctionUtilisateur) {
	      parametreTrouve.setValue(indiceParametre);
	      return longueurNomParametre;
	    } else {
	      parametreTrouve.setValue(-1);
	      if (longueurNomFonctionPredefinie > longueurNomValeur && longueurNomFonctionPredefinie > longueurNomFonctionUtilisateur && longueurNomFonctionPredefinie > longueurNomParametre) {
	        pointeurValeur.setValue(null);
	        return longueurNomFonctionPredefinie;
	      } else {
	        if (longueurNomValeur > longueurNomFonctionPredefinie && longueurNomValeur > longueurNomFonctionUtilisateur && longueurNomValeur > longueurNomParametre) {
	          pointeurValeur.setValue(pointeurSurValeur.getValue());
	          return longueurNomValeur;
	        } else {
	          if (longueurNomFonctionUtilisateur > longueurNomFonctionPredefinie && longueurNomFonctionUtilisateur > longueurNomValeur && longueurNomFonctionUtilisateur > longueurNomParametre) {
	            pointeurValeur.setValue(pointeurSurFonction.getValue());
	            nombreVariables.setValue(pointeurSurFonction.getValue().nombreVariables());
	            return longueurNomFonctionUtilisateur;
	          } else return 0;
	        }
	      }
	    }
	  }
	};
	/**
	 * Fonction utilisée dans CCb  renvoyant 0 si la chaine pointée par ch ne
	 * pointe pas sur une chaine représentant une valeur réelle ou complexe
	 * ou une fonction mathématique complexe prédéfinie ou
	 * une fonction complexe définie par l'utilisateur ou un parametre.
	 * Les objets intermédiaires de constructions sont sautés dans la recherche.
	 * Sinon, elle renvoie  la longueur du nom le plus long trouve.
	 * Si aucune fonction ou valeur ou paramètre n'est trouvé et si la chapine commence par la lettre i
	 * complexiTrouve.getValue() renvoie true, sinon false.
	 * Si ParametreTrouve.getValue est non null, c'est qu'on a trouvé le paramètre formel
	 * et parametreTrouve.getValue contient son indice dans le tableau parametreFormel,
	 * Sinon, si PointeurValeur est différent de NULL, c'est qu'un a trouvé un nom de valeur ou de fonction
	 * définie par l'utilisateur (les suites étant considérées comme des
	 * fonctions) sinon c'est qu'on a trouvé un nom de fonction prédéfinie dont
	 * la nature est renvoyée dans nomFonction.
	 * Les calculs intermédiaires sont exclus de la recherhce.
	 * @param {String} ch : La chaîne dans laquelle se fait la recherche
	 * @param {Array} parametreFormel : null ou un tableau contenant les paramètres formesl recherchés.
	 * @param {Pointeur} pointeurValeur : : Si on a trouvé une valeur, pointeurValeur.getValue()
	 * renvoie un pointeur sur celle-ci.
	 * @param {Pointeur} nomFonction : nomFonction.getValue() renvoie la longueur du nom de la fonction trouvée
	 * ou 0 si non trouvée.
	 * @param {Pointeur} parametreTrouve : parametreTrouve.getValue renvoie -1 si le paramètre n'a pas été trouvé
	 * ou sinon son indice dans le tableau parametreFormel
	 * @param {type} complexeiTrouve : complexeiTrouve.ggetValue renvoie true si aucune fonction
	 * ou valeur n'a été trouvée mais la chaîne commence par la lettre i.
	 * @param {Pointeur} nombreVariables : Renvoie par getValue() le nombre de paramètres formels de la fonction trouvée.
	 * @returns {Integer}
	 */
	CListeObjets.prototype.commenceParNomFonctionOuValeurOuParametreComplexe = function (ch, parametreFormel, pointeurValeur, nomFonction, parametreTrouve, complexeiTrouve, nombreVariables) {
	  var CCbGlob = __webpack_require__(31);
	  var longueurNomFonctionPredefinie;
	  var longueurNomValeur;
	  var pointeurSurValeur = new Pointeur();
	  var pointeurSurFonction = new Pointeur();
	  var longueurNomFonctionUtilisateur;
	  var indiceParametre = -1;
	  var longueurNomParametre = 0;
	
	  parametreTrouve.setValue(-1);
	  complexeiTrouve.setValue(false);
	  pointeurValeur.setValue(null);
	  if (parametreFormel !== null) {
	    for (var i = 0; i < parametreFormel.length; i++) {
	      if (ch.indexOf(parametreFormel[i]) === 0 && parametreFormel[i].length > longueurNomParametre) {
	        longueurNomParametre = parametreFormel[i].length;
	        indiceParametre = i;
	        parametreTrouve.setValue(i); // Ligne rajoutée version 4.5.2
	      }
	    }
	  }
	  longueurNomFonctionPredefinie = CCbGlob.commenceParNomFonctionComplexePredefinie(ch, nomFonction, nombreVariables);
	  longueurNomValeur = this.commenceParNomValeurReelleOuComplexe(ch, pointeurSurValeur);
	  longueurNomFonctionUtilisateur = this.commenceParNomFonctionComplexeUtilisateur(ch, pointeurSurFonction);
	  if (longueurNomFonctionPredefinie === 0 && longueurNomValeur === 0 && longueurNomFonctionUtilisateur === 0 && longueurNomParametre === 0) {
	    if (ch.indexOf("i") === 0) {
	      complexeiTrouve.setValue(true);
	      return 1;
	    } else return 0;
	  } else {
	    if (longueurNomParametre >= longueurNomFonctionPredefinie && longueurNomParametre >= longueurNomValeur && longueurNomParametre >= longueurNomFonctionUtilisateur) {
	      parametreTrouve.setValue(indiceParametre);
	      return longueurNomParametre;
	    } else {
	      parametreTrouve.setValue(-1); // Correction bug version 46
	      if (longueurNomFonctionPredefinie > longueurNomValeur && longueurNomFonctionPredefinie > longueurNomFonctionUtilisateur && longueurNomFonctionPredefinie > longueurNomParametre) {
	        return longueurNomFonctionPredefinie;
	      } else {
	        if (longueurNomValeur > longueurNomFonctionPredefinie && longueurNomValeur > longueurNomFonctionUtilisateur && longueurNomValeur > longueurNomParametre) {
	          // On teste si on fait référence à un calcul ou une variable nommé i.
	          // Si c'est le cas, on donne priorité au complexe i
	          if (longueurNomValeur === 1 && ch.indexOf("i") === 0) {
	            complexeiTrouve.setValue(true);
	            return 1;
	          } else {
	            pointeurValeur.setValue(pointeurSurValeur.getValue());
	            return longueurNomValeur;
	          }
	        } else {
	          if (longueurNomFonctionUtilisateur > longueurNomFonctionPredefinie && longueurNomFonctionUtilisateur > longueurNomValeur && longueurNomFonctionUtilisateur > longueurNomParametre) {
	            nombreVariables.setValue(pointeurSurFonction.getValue().nombreVariables());
	            pointeurValeur.setValue(pointeurSurFonction.getValue());
	            return longueurNomFonctionUtilisateur;
	          } else return 0;
	        }
	      }
	    }
	  }
	};
	/**
	 * Fonction ajoutant à la liste this des clones de ptelg, au nombre de nombreCopies.
	 * Utilisé dans les leiu d'objets.
	 * @param {CElementGraphique} ptelg
	 * @param {type} nombreCopies
	 * @returns {undefined}
	 */
	CListeObjets.prototype.ajouteClonesDe = function (ptelg, nombreCopies) {
	  for (var i = 0; i < nombreCopies; i++) {
	    var el = ptelg.creeClone();
	    el.impProto = null; // Pour qu'un élément cloné d'un élément intermédiaire ne soit pas considéré comme obbjet intermémdiaire
	    this.add(el);
	  }
	};
	
	CListeObjets.prototype.initialiseDependances = function () {
	  for (var i = 0; i < this.col.length; i++) {
	    var elb = this.get(i);
	    elb.initialisePourDependance();
	  }
	};
	
	/**
	 * Fonction chargeant la liste depuis un fux de données binaires.
	 * @param {DataInputStream} inps
	 * @returns {undefined}
	 */
	CListeObjets.prototype.read = function (inps) {
	  try {
	    // On lit d'abord l'unité d'angle
	    this.uniteAngle = inps.readInt();
	    // On lit d'abord le nombre d'objets de la liste
	    this.nombreObjets = inps.readInt();
	    for (var i = 0; i < this.nombreObjets; i++) {
	      var elb = inps.readObject(this);
	      elb.index = i; // Rajouté version 4.8.0
	      this.add(elb);
	      // Spécial JavaScript : chaque élément graphique a une id qui est l'id de la liste
	      // qui le possède suivi de son indice dans la liste à partir de 0
	      if (this.className !== "CPrototype") elb.id = this.id + "#" + i;
	    }
	    var indiceLongueurUnite = inps.readInt();
	    if (indiceLongueurUnite === -1) this.pointeurLongueurUnite = null;else this.pointeurLongueurUnite = this.get(indiceLongueurUnite);
	    // Inutile dans l'applet
	    var indiceMacroParDefaut = inps.readInt();
	    if (indiceMacroParDefaut !== -1) this.macroParDefaut = this.get(indiceMacroParDefaut);else this.macroParDefaut = null;
	    // Nouveau version 4.8
	    if (this.numeroVersion < 12) this.macroDemarrage = null;else {
	      var indiceMacroDemarrage = inps.readInt();
	      if (indiceMacroDemarrage === -1) this.macroDemarrage = null;else this.macroDemarrage = this.get(indiceMacroDemarrage);
	    }
	    this.etablitListesInternesMacros();
	  } catch (e) {
	    throw new Error("IOException");
	  }
	};
	/**
	 * Fonction renvoyant true seulement si nom est valide pour un nouveau nom de calcul ou de fonction
	 * N'affiche pas de message en cas d'erreur
	 * les paramètres formels de fonctions sont autorisés
	 * @param {String} chNom
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.validationNomCalculSansMessage = function (chNom) {
	  var CCbGlob = __webpack_require__(31);
	  if (chNom.length === 0 || !this.validationNomVariableOuCalcul(chNom)) return false;
	  if (chNom === "i") return false;
	  if (CCbGlob.egalNomFonctionReelleOuComplexePredefinie(chNom)) return false;
	  return !this.egalNomValeurOuFonctionOuMesure(chNom, this.longueur() - 1);
	};
	/**
	 * Fonction renvoyant true si ch est un nom valide pour une variable ou un calcul
	 * @param {String} ch
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.validationNomVariableOuCalcul = function (ch) {
	  var fini = false;
	  while (ch.length !== 1 && !fini) {
	    if (ch.charAt(1) !== ' ') fini = true;else ch = ch.substring(1);
	  }
	  if (ch.length === 0) return false;
	  var premierCar = ch.charAt(0);
	  if (!Fonte.lettre(premierCar)) return false;else {
	    var carPrecedent = premierCar;
	    var valable = true;
	    for (var i = 1; i <= ch.length - 1 && valable; i++) {
	      var carEnCours = ch.charAt(i);
	      // Cas d'une lettre
	      if (Fonte.lettre(carEnCours)) {
	        if (Fonte.chiffre(carPrecedent) || Fonte.prime(carPrecedent)) valable = false;
	      } else if (Fonte.prime(carEnCours)) {
	        if (Fonte.chiffre(carPrecedent) || Fonte.prime(carPrecedent)) valable = false;
	      } else {
	        if (!Fonte.chiffre(carEnCours)) valable = false;
	        carPrecedent = carEnCours;
	      }
	    }
	    return valable;
	  }
	};
	/**
	 * Fonction enregistrant la liste dans un flus de données binaires.
	 * @param {DataOutputStream} oups
	 * @returns {undefined}
	 */
	CListeObjets.prototype.write = function (oups) {
	  oups.writeInt(this.uniteAngle);
	  oups.writeInt(this.col.length);
	  for (var i = 0; i < this.col.length; i++) {
	    oups.writeObject(this.get(i));
	  }
	  var indiceLongueurUnite;
	  if (this.pointeurLongueurUnite === null) indiceLongueurUnite = -1;else indiceLongueurUnite = this.indexOf(this.pointeurLongueurUnite);
	  oups.writeInt(indiceLongueurUnite);
	  // Inutile pour l'applet
	  var indiceMacroParDefaut;
	  if (this.macroParDefaut === null) indiceMacroParDefaut = -1;else indiceMacroParDefaut = this.indexOf(this.macroParDefaut);
	  oups.writeInt(indiceMacroParDefaut);
	  var indiceMacroDemarrage;
	  if (this.macroDemarrage === null) indiceMacroDemarrage = -1;else indiceMacroDemarrage = this.indexOf(this.macroDemarrage);
	  oups.writeInt(indiceMacroDemarrage);
	};
	// Pour le chargement des constructions
	CListeObjets.prototype.readPourProtoDepuisFlux = function (inps) {
	  var nombreObjets = inps.readInt();
	  for (var i = 0; i < nombreObjets; i++) {
	    var elb = inps.readObject(this);
	    elb.index = i; // Rajouté version 4.8.0
	    this.add(elb);
	  }
	};
	/**
	 * Fonction utilsiée pour enregistrer un prototype (construction) dans un flux de données bianires.
	 * @param {DataOutputStream} oups
	 * @returns {undefined}
	 */
	CListeObjets.prototype.writePourProtoDepuisFlux = function (oups) {
	  oups.writeInt(this.col.length);
	  for (var i = 0; i < this.col.length; i++) {
	    oups.writeObject(this.get(i));
	  }
	};
	/**
	 * Fonction renvoyant true si chaine contient le nom d'une variable ou calcul
	 * ou fonction réelle ou complexe définie par l'utilisateur.
	 * L'élément excle est sauté dans la recherche.
	 * @param {String} chaine
	 * @param {Iteger} indiceMaxiDansListe : L'indice de recherche mai dans la liste.
	 * @param {CElementBase} exclu : null ou l'élément exclu de la recherche.
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.egalNomValeurOuFonctionOuMesure = function (chaine, indiceMaxiDansListe, exclu) {
	  var trouve = false;
	  if (arguments.length <= 2) exclu = false;
	  for (var i = 0; !trouve && i <= indiceMaxiDansListe; i++) {
	    var elb = this.get(i);
	    if (elb !== exclu) {
	      // Modifié version 4.7.5
	      if (elb.estDeNatureCalcul(Nat.or(NatCal.NTteValROuC, NatCal.NTteFoncR, NatCal.NTteFoncC, NatCal.NDerivee, NatCal.NTteSuiteRecR, NatCal.NTteSuiteRecC)) && !elb.estElementIntermediaire()) {
	        if (elb.chaineEgaleANom(chaine)) trouve = true;
	      }
	    }
	  }
	  return trouve;
	};
	/**
	 * Renvoie true si la syntaxe de chaineCalcul est correcte pour un calcul réel.
	 * Si indiceMaxi est égal à -1 ou absent la recherche se fait jusqu'à la fin de la liste.
	 * @param {String} chaineCalcul : La chaîne dont on analyse la syntaxe.
	 * @param {Array} variable : un tableau contenant des noms de varaibel formelles
	 * @param {Pointeur} indiceErreur : getValue() renvoie l'indice dans la
	 * chaîne d'une éventuelle faute de syntaxe trouvée
	 * @param {Integer} indiceMaxi
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.verifieSyntaxe = function (chaineCalcul, variable, indiceErreur, indiceMaxi) {
	  var CalcR = __webpack_require__(55);
	  if (arguments.length <= 3) indiceMaxi = this.longueur() - 1;
	  if (arguments.length <= 2) indiceErreur = new Pointeur(0);
	  if (arguments.length === 1) variable = null;
	  return CalcR.verifieSyntaxe(this, chaineCalcul, indiceErreur, indiceMaxi, variable);
	};
	/**
	 * Renvoie true si la syntaxe de chaineCalcul est correcte pour un calcul complexe.
	 * Si indiceMaxi est égal à -1 ou absent la recherche se fait jusqu'à la fin de la liste.
	 * @param {String} chaineCalcul : La chaîne dont on analyse la syntaxe.
	 * @param {Array} variable : un tableau contenant des noms de varaibel formelles
	 * @param {Pointeur} indiceErreur : getValue() renvoie l'indice dans la
	 * chaîne d'une éventuelle faute de syntaxe trouvée
	 * @param {Integer} indiceMaxi
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.verifieSyntaxeComplexe = function (chaineCalcul, variable, indiceErreur, indiceMaxi) {
	  var CalcC = __webpack_require__(69);
	  if (arguments.length <= 3) indiceMaxi = this.longueur() - 1;
	  if (arguments.length <= 2) indiceErreur = new Pointeur(0);
	  if (arguments.length === 1) variable = null;
	  return CalcC.verifieSyntaxeComplexe(this, chaineCalcul, indiceErreur, indiceMaxi, variable);
	};
	/**
	 * Fonction changeant la formule du calcul ou de la fonction (réelle ou complexe) de nom nomCalcul
	 * La nouvelle formule est contenue dans la chaîne de caractères formule.
	 * Renvoie true si la formule était valide et false sinon.
	 * Créée pour être utilisé par un utilisateur externe
	 * @param {String} nomCalcul
	 * @param {String} formule
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.giveFormula2 = function (nomCalcul, formule) {
	  if (typeof formule === "number") formule = String(formule);
	  var variable = null;
	  var indiceErreur = new Pointeur(0);
	  var calcul = this.pointeurParNatureCalcul(NatCal.NTtCalcouFoncRouC, nomCalcul);
	  if (calcul === null) return false;
	  if (calcul.estDeNatureCalcul(NatCal.NTteFoncRouC)) variable = calcul.chaineVariable;
	  var reel = calcul.estDeNatureCalcul(Nat.or(NatCal.NCalculReel, NatCal.NFonction, NatCal.NFoncPlusieursVar));
	  if (reel ? this.verifieSyntaxe(formule, variable, indiceErreur, this.longueur - 1) : this.verifieSyntaxeComplexe(formule, variable, indiceErreur, this.longueur - 1)) {
	    calcul.chaineCalcul = formule;
	    var len = formule.length - 1;
	    calcul.calcul = reel ? CalcR.ccb(formule, this, 0, len, variable) : CalcC.ccbComp(formule, this, 0, len, variable);
	    return true;
	  } else return false;
	};
	/**
	 * Fonction renvoyant true si la chaine ch commence par le nom d'une fonction
	 * prédéfinie (réelle ou complexe) suivi d'une parenthèse.
	 * Si oui, longNom.getValue() renvoie la longueur du nom.
	 * La recherche commence à l'indice indstart
	 * @param {String} pChaine : La chaîne dans laquelle se fait la recherche.
	 * @param {Integer} indstart
	 * @param {Pointeur} longNom
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.commenceParNomFonctionPredefinieSuivieParOuvr = function (pChaine, indstart, longNom) {
	  var ch = pChaine.substring(indstart).toLowerCase();
	  var i;
	  // On commence par les fonctions de quatre variables car integrale commence par int une autre fonction
	  for (i = 0; i < Opef4v.nomsFoncs4Var.length; i++) {
	    longNom.setValue(Opef4v.nomsFonctions4Var(i).length);
	    if (ch.indexOf(Opef4v.nomsFonctions4Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef.nomsFoncs.length; i++) {
	    longNom.setValue(Opef.nomsFonctions(i).length);
	    if (ch.indexOf(Opef.nomsFonctions(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef2v.nomsFoncs2Var.length; i++) {
	    longNom.setValue(Opef2v.nomsFonctions2Var(i).length);
	    if (ch.indexOf(Opef2v.nomsFonctions2Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef3v.nomsFoncs3Var.length; i++) {
	    longNom.setValue(Opef3v.nomsFonctions3Var(i).length);
	    if (ch.indexOf(Opef3v.nomsFonctions3Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef5v.nomsFoncs5Var.length; i++) {
	    longNom.setValue(Opef5v.nomsFonctions5Var(i).length);
	    if (ch.indexOf(Opef5v.nomsFonctions5Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  // Inutile de regarder les noms des fonctions complexes de plus de deux variables car c'est le même que les fonctions réelles
	  for (i = 0; i < Opef.nomsFoncsComplexes.length; i++) {
	    longNom.setValue(Opef.nomsFonctionsComplexes(i).length);
	    if (ch.indexOf(Opef.nomsFonctionsComplexes(i).toLowerCase() + "(") === 0) return true;
	  }
	  return false;
	};
	/**
	 * Fonction renvoyant true si la chaine ch commence par le nom d'une fonction
	 * utilisateur (réelle ou complexe) suivi d'une parenthèse.
	 * Si oui, longNom.getValue() renvoie la longueur du nom.
	 * La recherche commence à l'indice indstart
	 * @param {String} pChaine : La chaîne dans laquelle se fait la recherche.
	 * @param {Integer} indstart
	 * @param {Pointeur} longNom
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.commenceParNomFonctionUtilisateurSuivieParOuvr = function (pChaine, indstart, longNom) {
	  var i, elb, nom;
	  var ch = pChaine.substring(indstart).toLowerCase();
	  for (i = 0; i < this.longueur(); i++) {
	    elb = this.get(i);
	    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(Nat.or(NatCal.NTteFoncR, NatCal.NDerivee, NatCal.NSuiteRecurrenteReelle, NatCal.NTteFoncC, NatCal.NSuiteRecurrenteComplexe))) {
	      // ptf = (CCalculAncetre) elb;
	      nom = elb.getNom();
	      if (ch.indexOf(nom + "(") === 0) {
	        longNom.setValue(nom.length);
	        return true;
	      }
	    }
	  }
	  return false;
	};
	/**
	 * Fonction assumant que la chaîne ch n'utilise que des calculs ou fonctions utilisateurs
	 * dont le nom ne comporte qu'une lettre suivie éventuellement de chiffres ou de ' ou de ".
	 * Elle rajoute les signes de multiplication sous-entendus.
	 * @param {String} ch : La chaine contenant la formule.
	 * @returns {String}
	 */
	CListeObjets.prototype.traiteSignesMult = function (ch) {
	  if (ch.length === 0) return ch;
	  var i, car;
	  var stb = "";
	  var lon = new Pointeur(0);
	  var carprecedent = '(';
	  for (i = 0; i < ch.length; i++) {
	    car = ch.charAt(i);
	    if (Fonte.chiffreOuPointDecimal(car) || car === ')' || car === '+' || car === '-' || car === '*' || car === '/' || car === '^' || car === '\'' || car === '\"' || car === '²') {
	      carprecedent = car;
	      stb = stb + car;
	    } else {
	      if (ch.indexOf("pi", i) === i) {
	        if (Fonte.chiffreOuPointDecimal(carprecedent) || Fonte.lettreOuPrime(carprecedent) || carprecedent === ')') stb = stb + "*pi";else stb = stb + "pi";
	        carprecedent = ')';
	        i++;
	      } else {
	        if (this.commenceParNomFonctionPredefinieSuivieParOuvr(ch, i, lon)) {
	          if (Fonte.chiffreOuPointDecimal(carprecedent) || Fonte.lettreOuPrime(carprecedent) || carprecedent === ')') stb = stb + "*" + ch.substring(i, i + lon.getValue() + 1);else stb = stb + ch.substring(i, i + lon.getValue() + 1);
	          i += lon.getValue();
	          carprecedent = '(';
	        } else {
	          if (this.commenceParNomFonctionUtilisateurSuivieParOuvr(ch, i, lon)) {
	            if (Fonte.chiffreOuPointDecimal(carprecedent) || Fonte.lettreOuPrime(carprecedent) || carprecedent === ')') stb = stb + "*" + ch.substring(i, i + lon.getValue() + 1);else stb = stb + ch.substring(i, i + lon.getValue() + 1);
	            i += lon.getValue();
	            carprecedent = '(';
	          } else {
	            // Si lettre suivie d'une autre lettre
	            if (Fonte.lettreOuPrime(carprecedent) && Fonte.lettre(car)) stb = stb + '*';
	            // Si chiffre suivi d'une lettre
	            else if (Fonte.chiffreOuCarre(carprecedent) && Fonte.lettre(car)) stb = stb + '*';
	              // Si chiffre ou lettre suivi d'une parenthèse on rajoute un signe de multiplication
	              else if ((Fonte.chiffreOuCarre(carprecedent) || Fonte.lettreOuPrime(carprecedent)) && car === '(') stb = stb + '*';
	                // Si parenthèse fermante suivie d'un chiffre ou une lettre ou une parenthèse ouvrante on rajoute un signe de multiplication
	                else if (carprecedent === ')' && (Fonte.lettre(car) || Fonte.chiffre(car) || car === '(')) stb = stb + '*';
	            stb = stb + car;
	            carprecedent = car;
	          }
	        }
	      }
	    }
	  }
	  return stb;
	};
	// Spécial JavaScript : Affichage et aout dans le DOM des objets de la liste
	// Attention : paramètre ideb supplémentaire par rapport à la version Java
	/**
	 * Spécial JavaScript : Affichage et ajout dans le DOM des svg elements qui représentent
	 * les objets de la liste.
	 * Attention : paramètre ideb supplémentaire par rapport à la version Java
	 * @param {Integer} ideb : L'indice du premier carcatère à afficher.
	 * @param {svg} svg : Le svg dans lequel se fait l'affichage de la figure.
	 * @param {Boolean} masquage : true si les éléments masqués ne sont pas affichés
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Number} transparence : Définit le coefficient de transparence utilisé pour les surfaces
	 * (qui se règle par un curseur sous la palette de couleurs dans MathGraph32).
	 * @returns {undefined}
	 */
	CListeObjets.prototype.afficheTout = function (ideb, svg, masquage, couleurFond, transparence) {
	  for (var i = ideb; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.estDeNature(NatObj.NTtObj) && !elb.estElementIntermediaire()) elb.creeAffichage(svg, masquage, couleurFond, transparence);
	  }
	};
	
	/**
	 * Spécial JavaScript : fonction mettant à jour certains éléments associés à des éléments du DOM
	 * @param {svg} svg : Le svg qui contient la figure.
	 * @param {mtg32.Color} couleurFond
	 * @param {Number} transparence : Définit le coefficient de transparence utilisé pour les surfaces
	 * @param {Boolean} masquage : true si les éléments masqués ne sont pas affichés
	 * @returns {undefined}
	 */
	CListeObjets.prototype.update = function (svg, couleurFond, transparence, masquage) {
	  this.setReady4MathJaxUpdate();
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    MathJax.Hub.Queue([this.callBack, elb, svg, couleurFond, transparence, masquage]);
	  }
	};
	/**
	 * Spécial JavaScript : fonction mettant à jour certains éléments associés à des éléments du DOM
	 * @param {CElementBase} : Ne seront mis à jours que les éléments dépendant de elb
	 * @param {svg} svg : Le svg qui contient la figure.
	 * @param {mtg32.Color} couleurFond
	 * @param {Number} transparence : Définit le coefficient de transparence utilisé pour les surfaces
	 * @param {Boolean} masquage : true si les éléments masqués ne sont pas affichés
	 * @returns {undefined}
	 */
	
	CListeObjets.prototype.updateDependants = function (el, svg, couleurFond, transparence, masquage) {
	  this.setDependantsReady4MathJaxUpdate(el);
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.dependDe(el)) MathJax.Hub.Queue([this.callBack, elb, svg, couleurFond, transparence, masquage]);
	  }
	};
	
	/**
	 * Fonction de callBack appelée par certians objets après u'ils aient été traités
	 * par MathJax (les affichages de LaTeX)
	 * @param {CElementGraphique} elb : L'objet dont l'affichage doit être remis à jour.
	 * @param {svg} svg : Le svg qui contient la figure.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de la figure.
	 * @param {Number} transparence : Définit le coefficient de transparence utilisé pour les surfaces
	 * (qui se règle par un curseur sous la palette de couleurs dans MathGraph32).
	 * @param {Boolean} masquage : true si les éléments masqués ne sont pas affichés
	 * @returns {undefined}
	 */
	CListeObjets.prototype.callBack = function (elb, svg, couleurFond, transparence, masquage) {
	  var hasg, gname;
	  if (elb.estDeNature(NatObj.NTtObj)) {
	    // Il faut tester que la liste propiétaire de l'élément n'est pas null car
	    // si des objets visuels sont actifs et qu'on choisit, avant de finir d'utiliser l'outil ,
	    // de faire un annuler-refaire, elg n'a plus d'implémentation graphique dans le SVG de la figure
	    if (!elb.estElementIntermediaire() && elb.listeProprietaire !== null) {
	      hasg = elb.hasg(masquage);
	      if (elb.hasgElement) {
	        // Si l'objet avait une implémentation graphique dans le svg
	        if (hasg) {
	          elb.update(svg, couleurFond, transparence);
	          elb.updateTrace(svg, couleurFond, transparence); // Pour les points marqués pour la trace
	          if (elb.estDeNature(NatObj.NObjNommable) && elb.nom !== "" && !elb.nomMasque) elb.updateNamePosition();
	          // elb.hasgElement = true; // Supprimé version mtgApp. Inutile
	        } else {
	          var newg = kernel.cens("g"); // Un g vide
	          svg.replaceChild(newg, elb.g);
	          newg.setAttribute("id", elb.id);
	          elb.g = newg;
	          elb.hasgElement = false;
	          if (elb.estDeNature(NatObj.NObjNommable) && elb.nom !== "" && !elb.nomMasque) {
	            gname = kernel.cens("g");
	            svg.replaceChild(gname, elb.gname);
	            elb.gname = gname;
	          }
	        }
	      } else {
	        if (hasg && !(masquage && elb.masque)) {
	          var g = elb.createg(svg, couleurFond, transparence);
	          svg.replaceChild(g, elb.g);
	          g.setAttribute("id", elb.id);
	          elb.g = g;
	          elb.hasgElement = true;
	          if (elb.estDeNature(NatObj.NObjNommable) && elb.nom !== "" && !elb.nomMasque) elb.updateName(svg, masquage);
	          elb.updateTrace(svg, couleurFond, transparence); // Pour les points marqués pour la trace
	        }
	      }
	    }
	  }
	};
	/**
	 * Fonction renvoyant true si les points pt1 et pt2 sont par définition sur une droite
	 * parallèle à droite.
	 * @param {CPt} pt1 : Le premier point testé.
	 * @param {CPt} pt2 : Le secondd point testé.
	 * @param {CDroiteAncetre} droite
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.sontParDefinitionSurParallele = function (pt1, pt2, droite) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.estDeNature(NatObj.NTteDroiteSaufVect)) {
	      if (pt1.appartientDroiteParDefinition(elb) && pt2.appartientDroiteParDefinition(elb) && (elb.estParalleleParDefinition(droite) || droite.estParalleleParDefinition(elb))) return true;
	    }
	  }
	  return false;
	};
	/**
	 * Fonction utilisé dans les listes d'objets.
	 * Recrée les liste d'objets dans les lieux d'objest dépendant
	 * @param {mtg32.CLeiuObjetAncetre} lieu
	 * @returns {undefined}
	 */
	CListeObjets.prototype.recreeListesCopiesLieuxObjetsDependantDe = function (lieu) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NLieuObjet && elb !== lieu && elb.dependDe(lieu)) {
	      elb.recreeListeCopieObjets();
	    }
	  }
	};
	/**
	 * Fonction mettant à jour tous les éléments de la liste qui ont une fonction
	 * metAJour redéfinie.
	 * Utilisée pour mettre à jour par exemple les lieux de points et lieux d'objets
	 * ou certaines macros.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.metAJour = function () {
	  for (var i = 0; i < this.longueur(); i++) {
	    var el = this.get(i);
	    el.metAJour();
	  }
	};
	/**
	 * Fonction mettant à jour les objets de la figure qui nécessitent de l'être
	 * et qui dépendent de elb à l'exclusion des éditeurs de formule.
	 * @param {type} elb
	 * @returns {undefined}
	 */
	CListeObjets.prototype.metAJourObjetsDependantDeSaufEditeursFormule = function (elb) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var el = this.get(i);
	    if (!el.estDeNature(NatObj.NEditeurFormule) && el.dependDe(elb)) el.metAJour();
	  }
	};
	/**
	 * Fonction renvoyant un pointeur sur l'objet calcul de nature calcul nature
	 * et dont le nom est nom. Renvoie null la recherche est infructueuse.
	 * @param {String} nom : Le nom du calcul cherché
	 * @param {mtg32.Nature} nature : la nature de calcul recherchée
	 * @returns {CCalculAncetre}
	 */
	CListeObjets.prototype.pointeurObjetCalcul = function (nom, nature) {
	  var indiceMaxi = this.longueur() - 1;
	  var elb = null;
	  for (var i = 0; i <= indiceMaxi; i++) {
	    elb = this.get(i);
	    if (elb.estDeNatureCalcul(nature)) if (elb.nomCalcul === nom) return elb;
	  }
	  return null;
	};
	/**
	 * Fonction conçue pour être utilisée de façon externe.
	 * Renvoie la valeur actuelle du calcul réel nommé nomCalcul.
	 * Renvoie -1 si le calcul n'existe pas.
	 * Utilisé prinipalement dans les exercices de calcul de j3p.
	 * @param {String} nomCalcul : Le nom du calcul dont on demande la valeur.
	 * @returns {Number}
	 */
	CListeObjets.prototype.valueOf = function (nomCalcul) {
	  var calcul = this.pointeurObjetCalcul(nomCalcul, NatCal.NTtCalcRNommeSaufConst);
	  if (calcul === null) return -1;else {
	    if (!calcul.existe) return -1;else return calcul.rendValeur();
	  }
	};
	/**
	 * Fonction conçue pour être utilisée de façon externe.
	 * Renvoie la formule en ligne (avec des *) du calcul ou de la fonction nommé nomCalcul
	 * @param {String} nomCalcul
	 * @returns {String}
	 */
	CListeObjets.prototype.getFormula = function (nomCalcul) {
	  var calcul = this.pointeurObjetCalcul(nomCalcul, NatCal.NCalcouFoncParFormule);
	  if (calcul === null) return -1;else {
	    if (!calcul.existe) return "";
	    // Remanié version 4.9.9.3
	    // else return calcul.chaineCalcul;
	    var varFor = calcul.variableFormelle();
	    return calcul.calcul.chaineCalcul(varFor);
	  }
	};
	/**
	 * Fonction renvoyant la formule LaTeX représentant le calcul ou la fonction
	 * dont le nom est nomCalcul.
	 * @param {String} nomCalcul : Le nom du calcul dont on veut la formule
	 * @returns {String}
	 */
	CListeObjets.prototype.getLatexFormula = function (nomCalcul) {
	  var calcul = this.pointeurObjetCalcul(nomCalcul, NatCal.NCalcouFoncParFormule);
	  if (calcul === null) return "";else {
	    var varFor = calcul.variableFormelle();
	    return calcul.calcul.chaineLatexSansPar(varFor);
	  }
	};
	// Ajout version 4.9.7
	/**
	 * Fonction utilisée dans j3p.
	 * Renvoie le code LaTeX contenu dans l'affichage LaTeX ne rang ind dans la lsite
	 * parmis les affichages LaTeX de la liste.
	 * @param {Integer} ind : L'indice de l'affichage LaTeX parmis tous les affichages LaTeX.
	 * @returns {String}
	 */
	CListeObjets.prototype.getLatexCode = function (ind) {
	  var j = 0;
	  for (var i = 0; i < this.longueur(); i++) {
	    var el = this.get(i);
	    if (el.getNature() === NatObj.NLatex) {
	      if (j === ind) return el.chaineLatex;
	      j++;
	    }
	  }
	  return "";
	};
	/**
	 * Fonction conçue pour être utilisée de façon externe.
	 * Renvoie la formule LaTeX normalisée représentant le calcul ou la fonction
	 * une fois que les valeurs utilsées dans la formule ont été remplacées
	 * et que les simplifications de normalisation ont été effectuées :
	 * Suppression des additions de 0, ddes multiplications ou divisions par 1.
	 * @param {String} nomCalcul : Le calcul ou la fonction réelle ou complexe
	 * dont on demande la formule;
	 * @returns {String}
	 */
	CListeObjets.prototype.getForSimp = function (nomCalcul) {
	  var calcul = this.pointeurObjetCalcul(nomCalcul, NatCal.NCalcouFoncParFormule);
	  if (calcul === null) return "";else {
	    var varFor = calcul.variableFormelle();
	    return calcul.calcul.calculAvecValeursRemplacees().calculNormalise(true, false, false).chaineLatexSansPar(varFor);
	  }
	};
	/**
	 * Fonction exécutant la macro dont l'intitulé ets nameMacro.
	 * @param {type} nameMacro
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.executeMacro = function (nameMacro) {
	  var macroAExecuter = this.pointeurMacro(nameMacro);
	  if (macroAExecuter === null) return false;
	  // Ajout version 5.0
	  macroAExecuter.setMacroLanceuse(null);
	  //
	  if (macroAExecuter.executionPossible()) {
	    this.macroEnCours = macroAExecuter;
	    macroAExecuter.initialise();
	    var svg = document.getElementById(this.id);
	    var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	    var doc = this.documentProprietaire;
	    macroAExecuter.execute(svg, dimf, doc.couleurFond, doc.opacity, true);
	    return true;
	  } else return false;
	};
	/**
	 * Fonction demandant la validation de tous les éditeurs de formule de la figure
	 * Si la formule qu'ils contiennent est incorrecte ils se trouvent encadrés de rouge.
	 * Renvoie true uniquement si aucun éditeur de formule ne contient de faute de syntaxe.
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.fieldsValidation = function () {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule) {
	      if (!elb.validation(false)) return false;
	    }
	  }
	  return true;
	};
	/**
	 * Fonction renvoyant true si le contenu du permier éditeur de formule
	 * ssocié au calcul nomCalcul est correct au point syntaxique et non vide
	 * @param {String} nomCalcul
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.fieldValidation = function (nomCalcul) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule && elb.calculAssocie.nomCalcul === nomCalcul) {
	      return elb.validation(false) && elb.editeur.value.length !== 0;
	    }
	  }
	  return false;
	};
	// Fonction renvoyant le contenu du premier éditeur de formule asssocié au calcul nomCalcul
	/**
	 * Fonction renvoyant le contenu du premier éditeur de formule asssocié au calcul nomCalcul
	 * @param {String} nomCalcul
	 * @returns {String}
	 */
	CListeObjets.prototype.getFieldValue = function (nomCalcul) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule && elb.calculAssocie.nomCalcul === nomCalcul) return elb.editeur.value;
	  }
	  return "error";
	};
	/**
	 * Fonction donnant le focus au premier éditeur de formule qui ne contient rien.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.activateFirstEmptyField = function () {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule) {
	      if (elb.editeur.value.length === 0) {
	        elb.editeur.focus();
	        break;
	      }
	    }
	  }
	};
	/**
	 * Fonction activant le premier éditeur de formule contenant une
	 * formule qui n'est pas correcte sur le plan syntaxique.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.activateFirstInvalidField = function () {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule) {
	      if (!elb.validation(false)) {
	        elb.editeur.focus();
	        break;
	      }
	    }
	  }
	};
	/**
	 * Fonction activant le premier éditeur de formule vide ou contenant une
	 * formule qui n'est pas correcte sur le plan syntaxique.
	 * @returns {undefined}
	 */
	
	CListeObjets.prototype.activateFirstInvalidOrEmptyField = function () {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule) {
	      if (elb.editeur.value.length === 0 || !elb.validation(false)) {
	        elb.editeur.focus();
	        break;
	      }
	    }
	  }
	};
	/**
	 * Fonctiondonnant le focus au premier éditeur de formule associé au calcul
	 * ou à la fonction nommé nomCalcul.
	 * @param {String} nomCalcul
	 * @returns {undefined}
	 */
	CListeObjets.prototype.activateField = function (nomCalcul) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule && elb.calculAssocie.nomCalcul === nomCalcul) {
	      elb.editeur.focus();
	      break;
	    }
	  }
	};
	// Fonction vidant tous les champs d'édition
	/**
	 * Fonction vidant tous les éditeurs de formule de la figure.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.setEditorsEmpty = function () {
	  var svg = document.getElementById(this.id);
	  var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule) {
	      elb.editeur.value = "";
	      if (elb.affichageFormule) {
	        elb.latex.chaineCommentaire = elb.preCodeLaTeX;
	        elb.latex.positionne(false, dimf);
	        elb.latex.setReady4MathJax();
	        MathJax.Hub.Queue([elb.callBack, elb, svg]);
	      }
	    }
	  }
	};
	/**
	 * Fonction associant au premier éditeur de formule associé à calcul ou une fonction
	 * nommé nomCalcul une fonction de callBack qui sera appelée quand l'utilisateur
	 * valide par OK le contenu de l'éditeur.
	 * Utilisé dans j3p ou d'autres modules externes.
	 * @param {String} nomCalcul
	 * @param {function} f
	 * @returns {undefined}
	 */
	CListeObjets.prototype.setEditorCallBackOK = function (nomCalcul, f) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule && elb.calculAssocie.nomCalcul === nomCalcul) {
	      elb.callBackOK = f;
	      break;
	    }
	  }
	};
	// Ajout version 4.9.3
	/**
	 * Fonctionmettant dans le premier éditeur de formule associé à nomCalcul
	 * la chaine st.
	 * @param {String} nomCalcul
	 * @param {String} st
	 * @returns {undefined}
	 */
	CListeObjets.prototype.setEditorValue = function (nomCalcul, st) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NEditeurFormule && elb.calculAssocie.nomCalcul === nomCalcul) {
	      elb.setEditorValue(st);
	      break;
	    }
	  }
	};
	//
	// Ajoute au tableau des traces un élément graphique
	/**
	 * Spécial JavaScript : Ajoute au tableau des traces un élément graphique
	 * @param {svg.Element} tr : le svg element qu'on ajoute
	 * @returns {undefined}
	 */
	CListeObjets.prototype.addTrace = function (tr) {
	  var gt = this.documentProprietaire.gTraces;
	  if (this.nbTraces < CListeObjets.nbMaxiTraces) {
	    // this.traces.push(tr); // Supprimé version 4.9.2
	    gt.appendChild(tr);
	    this.nbTraces++;
	  } else {
	    // gt.removeChild(this.traces.shift()); // Modifié version 4.9.2
	    gt.removeChild(gt.childNodes[0]);
	    // this.traces.push(tr); // Supprimé verison 4.9.2
	    gt.appendChild(tr);
	  }
	};
	/**
	 * Ajoute au tableau des traces les éléments graphiques d'une liste d'objets
	 * @param {type} list
	 * @returns {undefined}
	 */
	CListeObjets.prototype.addTraces = function (list) {
	  var gt = this.documentProprietaire.gTraces;
	  for (var i = 0; i < list.longueur(); i++) {
	    var el = list.get(i);
	    if (el.existe && el.hasg(false)) {
	      // false pour que même les éléments masqués laissent une trace
	      var g = el.createg();
	      if (el !== null) {
	        if (this.nbTraces < CListeObjets.nbMaxiTraces) {
	          // this.traces.push(g); // Supprimé version 4.9.2
	          gt.appendChild(g);
	          this.nbTraces++;
	        } else {
	          // gt.removeChild(this.traces.shift());  // Modifié version 4.9.2
	          gt.removeChild(gt.childNodes[0]);
	          // this.traces.push(g); // Supprimé version 4.9.2
	          gt.appendChild(g);
	        }
	      }
	    }
	  }
	};
	/**
	 * Fonction retirant toutes les traces de la figure.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.deleteTraces = function () {
	  var gt = this.documentProprietaire.gTraces;
	  //Modifié version 4.9.2. Inutile de mémoriser les traces dans un tableau
	  // while (this.traces.length != 0) gt.removeChild(this.traces.shift());
	  while (gt.childNodes.length !== 0) {
	    gt.removeChild(gt.childNodes[0]);
	  }this.nbTraces = 0;
	};
	/**
	 * Fonction initialisant les traces de la figure si le mode trace
	 * de la figure est activé.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.initialiseTraces = function () {
	  if (!this.documentProprietaire.modeTraceActive) this.deleteTraces();
	};
	/**
	 * Spécial version JavaScript : les objets qui créent un composant ajouté dans le DOM
	 * dans le div parent du SVG détruisent ces objets
	 *
	 */
	/**
	 * Fonction demandant aux éléments de la figure qui ont créé un objet dans le DOM
	 * (à savoit les éditeurs de formules) de détruire ces composants.
	 * @param {svg} svg : Le svg qui contient la figure.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.deleteComponents = function (svg) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    elb.deleteComponent(svg); // Modifié version mtgApp
	  }
	};
	
	CListeObjets.prototype.createComponents = function (svg) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    elb.createComponent(svg); // Modifié version mtgApp
	  }
	};
	
	/**
	 * Fonction renvoyant true si la liste contient un point ou un droite
	 * autre que element ayant pour nom st.
	 * @param {CElementBase} element
	 * @param {String} st : Le nom recherché.
	 * @param {Boolean} intermPermis : Si true on rehcerhce aussi dans les objets intermédiaires de constructions
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.existePointOuDroiteMemeNom = function (element, st, intermPermis) {
	  var interm = arguments.length <= 2 ? false : intermPermis;
	  var i, elb;
	  for (i = 0; i < this.longueur(); i++) {
	    elb = this.get(i);
	    if ((interm || !elb.estElementIntermediaire()) && elb.estDeNature(Nat.or(NatObj.NTtPoint, NatObj.NDroite))) {
	      if (elb !== element) {
	        if (elb.nom === st) return true;
	      }
	    }
	  }
	  return false;
	};
	// Ajout version 4.8
	/**
	 * Fonction renvoyant true si la liste contient une focntion réelle ou complexe
	 * ou un paramètre de fonction à une variable égal à chaine.
	 * @param {type} chaine
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.egalNomParametreFonction = function (chaine) {
	  for (var i = 0; i < this.longeur; i++) {
	    var elb = this.get(i);
	    if (elb.getNatureCalcul() === NatCal.NFonction) {
	      if (chaine.toLowerCase() === elb.chaineVariable) return true;
	    } else {
	      if (elb.getNatureCalcul() === NatCal.NFonctionComplexe) {
	        if (chaine.toLowerCase() === elb.chaineVariable) return true;
	      }
	    }
	  }
	  return false;
	};
	
	// Ajout version 4.8
	/**
	 * Fonction générant un nom de calcul commençant par la chaîne ch
	 * Si bchiffreImpose est résent et true, on impose que ch soit suivie d'un chiffre à partir de 1
	 * @param ch
	 * @param bchiffreImpose
	 * @returns {string}
	 */
	CListeObjets.prototype.genereNomPourCalcul = function (ch, bchiffreImpose) {
	  var CCbGlob = __webpack_require__(31);
	  var b = arguments.length === 2 ? bchiffreImpose : false;
	  var i, nomGenere;
	  // Modifié version 4.8
	  for (i = b ? 1 : 0;; i++) {
	    nomGenere = ch;
	    if (i !== 0) nomGenere += i;
	    if (!this.egalNomValeurOuFonctionOuMesure(nomGenere, this.longueur() - 1, null) && !this.egalNomParametreFonction(nomGenere) && !CCbGlob.egalNomFonctionReelleOuComplexePredefinie(nomGenere)) return nomGenere.toString();
	  }
	  // return "";
	};
	
	/**
	 * Spécial version mtgApp
	 * Remplace dans les CCOmmentaire et CLatex utilisant des affichages dynamiques ancienNom par nouveauNom
	 * @param ancienNom
	 * @param nouveauNom
	 */
	CListeObjets.prototype.remplaceNomValeurDynamiqueDansCommentairesOuLatex = function (ancienNom, nouveauNom) {
	  var i, elb;
	  for (i = 0; i < this.longueur(); i++) {
	    elb = this.get(i);
	    if (elb.estDeNature(NatObj.NComouLatex)) elb.remplaceNomValeurDynamique(ancienNom, nouveauNom);
	  }
	};
	/**
	 * Fonction mettant à jour tous les éléments de la liste er les positionant
	 * @param infoRandom
	 * @param dimfen : Dimf
	 */
	CListeObjets.prototype.metAJourEtPositionne = function (infoRandom, dimfen) {
	  var i, el;
	  for (i = 0; i < this.longueur(); i++) {
	    el = this.get(i);
	    el.metAJour();
	    el.positionne(infoRandom, dimfen);
	  }
	};
	
	// Ajout version 4.8
	/**
	 * Fonction reconstruisant les chaînes de calcul de tous les calculs ou
	 * fonctions utilisateur.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.reconstruitChainesCalcul = function () {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.estDeNatureCalcul(NatCal.NCalcOuFoncNonConstante)) elb.reconstruitChaineCalcul();
	  }
	};
	/**
	 * Fonction renvoyant l'élément final de construction d'indice ind de la liste.
	 * La recherche se fait à partir de inddeb.
	 * Utilisé dans le constructions itératives.
	 * @param {Integer} inddeb
	 * @param {Integer} ind
	 * @returns {CElementBase}
	 */
	CListeObjets.prototype.getFinal = function (inddeb, ind) {
	  var el = null;
	  var i = inddeb;
	  var j = -1;
	  while (j !== ind) {
	    el = this.get(i);
	    if (el.estElementFinal) {
	      if (el.estDeNature(NatObj.NTtObj) || !el.estDeNatureCalcul(NatCal.NAucunCalcul)) j++;
	    }
	    i++;
	  }
	  return el;
	};
	/**
	 * Fonction affectant à chaque élément de la liste son indice dans la liste.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.updateIndexes = function () {
	  for (var i = 0; i < this.longueur(); i++) {
	    var el = this.get(i);
	    // Attention : Les surfaces utilisant un quadrillage utilsiennt un pattern qui dépend de l'index de l'élément
	    el.index = i;
	    if (el.estDeNature(NatObj.NSurface)) {
	      if (el.pattern !== null) el.pattern.childNodes[0].setAttribute("id", i + "mtg32pattern");
	    }
	  }
	};
	
	// Ajout version 4.9.2
	/**
	 * Fonction demandant à chaque objet pour lequel c'est nécéssaire de se préparer
	 * pour le traitement par MathJax qui sera fait via une fonction de callback.
	 * @param bMemeMasques : Si true et présent, appelé même quand l'objet est masqué (sert pour la boîte de dialogue de protoccole)
	 * @param bMemeIntermediaires : Si true et présent appeké aussi pour les pobjets intermédiaires.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.setReady4MathJax = function (bMemeMasques, bMemeIntermediaires) {
	  var memeMasques = arguments.length === 0 ? false : bMemeMasques;
	  var memeIntermediaires = arguments === 2 ? bMemeIntermediaires : false;
	  for (var i = 0; i < this.longueur(); i++) {
	    var el = this.get(i);
	    if (el.existe && (!el.estElementIntermediaire() || memeIntermediaires)) el.setReady4MathJax(memeMasques);
	  }
	};
	/**
	 * Fonction demandant à chaque objet pour lequel c'est nécéssaire de se préparer
	 * pour le traitement par MathJax qui sera fait via une fonction de callback.
	 * Appelée quand on met à jour l'affichage de la figure.
	 * @returns {undefined}
	 */
	CListeObjets.prototype.setReady4MathJaxUpdate = function () {
	  for (var i = 0; i < this.longueur(); i++) {
	    var el = this.get(i);
	    if (el.existe && !el.estElementIntermediaire()) el.setReady4MathJaxUpdate();
	  }
	};
	/**
	 * Fonction demandant à chaque objet dépendant de elb pour lequel c'est nécéssaire de se préparer
	 * pour le traitement par MathJax qui sera fait via une fonction de callback.
	 * Appelée quand on met à jour l'affichage de la figure.
	 * @param{CElementBase}elb
	 * @returns {undefined}
	 */
	CListeObjets.prototype.setDependantsReady4MathJaxUpdate = function (elb) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var el = this.get(i);
	    if (el.existe && !el.estElementIntermediaire() && el.dependDe(elb)) el.setReady4MathJaxUpdate();
	  }
	};
	
	/**
	 * Fonction zoomant a figure sur le point de coordonnées (xcnetr,ycentre)
	 * avec le rapport rapport.
	 * @param {Float} xcentre
	 * @param {Float} ycentre
	 * @param {Float} rapport
	 * @returns {undefined}
	 */
	CListeObjets.prototype.zoom = function (xcentre, ycentre, rapport) {
	  var i,
	      origineUnite = null;
	  if (this.pointeurLongueurUnite !== null) {
	    var pt1 = this.pointeurLongueurUnite.point1;
	    if (pt1.getNature() === NatObj.NPointBase) origineUnite = pt1;
	  }
	  for (i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.getNature() === NatObj.NPointBase && elb !== origineUnite) {
	      if (elb.estLibre()) elb.zoom(xcentre, ycentre, rapport);
	    } else {
	      if (elb.getNature() === NatObj.NDroite) {
	        if (elb.className === "CDroiteDirectionFixe") {
	          if (elb.impProto !== null) {
	            if (!elb.impProto.nomProto === "MathGraph32 Cursor") elb.zoom(rapport);
	          } else elb.zoom(rapport);
	        }
	      }
	    }
	  }
	};
	/**
	 * Fonction recalculant tous les éléments de type calcul de la figure
	 * y compris les calculs de dérivées et lles test d'équivalence de formule
	 * et les test de factorisation.
	 * @param {type} infoRandom
	 * @returns {undefined}
	 */
	CListeObjets.prototype.calculateNG = function (infoRandom) {
	  var dimfen = new Dimf(600, 600);
	  this.positionneFullNG(infoRandom, dimfen);
	};
	
	CListeObjets.prototype.existeCalculOuVariableOuFonctionOuParametreNomCommencantPar = function (st, indFin) {
	  var i, elb;
	  for (i = 0; i <= indFin; i++) {
	    elb = this.get(i);
	    if (elb.estDeNatureCalcul(NatCal.NTteValROuC) && !elb.estElementIntermediaire()) {
	      if (elb.nomCommencePar(st)) return true;
	    }
	  }
	  return false;
	};
	/**
	 * Fonction renvoyant true si la liste contient un point ou une droite dotn le nom
	 * commence par st.
	 * La recherche se fait jusqu'à l'indice indfin.
	 * @param {String} st
	 * @param {Integer} indFin
	 * @returns {Boolean}
	 */
	CListeObjets.prototype.existePointOuDroiteNomCommencantPar = function (st, indFin) {
	  var i, elb;
	  for (i = 0; i < indFin; i++) {
	    elb = this.get(i);
	    if (!elb.estElementIntermediaire() && elb.estDeNature(Nat.or(NatObj.NTtPoint, NatObj.NDroite))) {
	      if (elb.nom.length !== 0) {
	        if (elb.nom.indexOf(st) === 0) return true;
	      }
	    }
	  }
	  return false;
	};
	/**
	 * Fonction générant un nom de Calcul ou fonction libre commençant par debNom.
	 * La recherche de noms existants s'arrête à indfin.
	 * @param {Integer} debNom
	 * @param {Integer} indFin
	 * @returns {String}
	 */
	CListeObjets.prototype.genereDebutNomPourCalcul = function (debNom, indFin) {
	  var i, j;
	  if (!this.existeCalculOuVariableOuFonctionOuParametreNomCommencantPar(debNom, indFin)) return debNom;
	  var ch = "abcdefghijklmnopqrstuvwxyz";
	  var nomGenere = debNom;
	  // Modifié version 4.8
	  for (i = 0;; i++) {
	    for (j = 0; j < ch.length; j++) {
	      nomGenere = nomGenere.substring(0, debNom.length);
	      nomGenere += ch.charAt(j);
	      if (i !== 0) nomGenere += i;
	      if (!this.existeCalculOuVariableOuFonctionOuParametreNomCommencantPar(nomGenere.toString(), indFin)) return nomGenere;
	    }
	  }
	};
	/**
	 * Fonction générant un nom de point libre commençant par debNom.
	 * La recherche de noms existants s'arrête à indfin.
	 * @param {type} indFin
	 * @returns {String}
	 */
	CListeObjets.prototype.genereDebutNomPourPoint = function (indFin) {
	  var i, j, nomGenere;
	  var ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	  // Modifié version 4.8
	  for (i = 0;; i++) {
	    for (j = 0; j < ch.length; j++) {
	      nomGenere = ch.charAt(j);
	      if (i !== 0) nomGenere += i;
	      if (!this.existePointOuDroiteNomCommencantPar(nomGenere, indFin)) return nomGenere;
	    }
	  }
	};
	/**
	 * Fonction utilisée dans les implémentations récursiives de constructions.
	 * @param {Integer} inddeb
	 * @param {CPrototype} proto
	 * @returns {undefined}
	 */
	CListeObjets.prototype.traiteImplementationsProtoSuccessivesRecur = function (inddeb, proto) {
	  var i, j, ptgen, elb, nomCalcul, nomPoint, nomp, nomc, k, elg2, oldName, newName, e, nomGen;
	  var lon = this.longueur();
	  var type = Nat.or(NatObj.NTtPoint, NatObj.NDroite, NatObj.NDroiteClone);
	  // On commence par renommer les points ou droites qui sont utilisés comme sources qui sont nommés dans le prototype
	  for (i = 0; i < proto.nbObjSources; i++) {
	    ptgen = proto.get(i);
	    elb = ptgen.elementAssocie;
	    if (elb.estDeNature(type)) {
	      nomGen = ptgen.nom;
	      // On regarde si l'élément correspondant était nommé.
	      if (nomGen.length !== 0 && elb.rendNom().length === 0) {
	        elb.donneNom(this.genereDebutNomPourPoint(inddeb - 1));
	      }
	    }
	  }
	  nomCalcul = this.genereDebutNomPourCalcul("", inddeb - 1);
	  nomPoint = this.genereDebutNomPourPoint(inddeb - 1);
	  nomp = 1;
	  // int nomc = 1; // Modifié version 4.9.9
	  nomc = 0;
	  k = 0;
	  for (i = inddeb + 1; i < lon; i++) {
	    elb = this.get(i);
	    if (elb.estDeNature(NatObj.NImplementationProto)) k = -1;else {
	      if (elb.estDeNature(type)) {
	        elg2 = proto.get(proto.nbObjSources + k);
	        if (!elg2.rendNom().length === 0) elb.donneNom(nomPoint + nomp++);
	      } else {
	        if (elb.estDeNatureCalcul(NatCal.NTtCalcNomme)) {
	          // CValeurDynamique vald = (CValeurDynamique) elb;
	          oldName = elb.getNom();
	          newName = nomCalcul + nomc++;
	          elb.donneNom(newName);
	          // Ajout version 4.9.9. On remet à jour les CCommentaire ou CLateX qui uitiliseraient un affichage dynamique de la valeur
	          for (j = i + 1; j < lon; j++) {
	            e = this.get(j);
	            if (e.estDeNature(NatObj.NImplementationProto)) break;
	            if (e.estDeNature(NatObj.NComouLatex)) {
	              if (e.listeValeursDynamiquesUtilisees.size !== 0) if (e.remplaceNomValeurDynamique(oldName, newName)) e.determineDependances();
	              e.setReady4MathJax();
	            }
	          }
	        }
	        // Correction version 4.9.9
	        // if (elb.estDeNatureCalcul(NatureCalcul.NCalcOuFoncNonConstante)) {
	        //  elb.reconstruitChaineCalcul();
	        // }
	      }
	    }
	    k++;
	  }
	};
	/**
	 * Fonction utilisée dans les implémentations itératives de constructions.
	 * @param {Integer} inddeb
	 * @param {CPrototype} proto
	 * @param {Integer} nbObjImp
	 * @returns {undefined}
	 */
	CListeObjets.prototype.traiteImplementationsProtoSuccessivesIter = function (inddeb, proto, nbObjImp) {
	  var i, ptgen, elb, nomGen, nbfn, k, ch, elg, j, deb, elb2, n, oldName, newName, m, e, vald2;
	  var lon = this.longueur();
	  var type = Nat.or(NatObj.NTtPoint, NatObj.NDroite, NatObj.NDroiteClone);
	  // On commence par renommer les points ou droites qui sont utilisés comme sources qui sont nommés dans le prototype
	  for (i = 0; i < proto.nbObjSources; i++) {
	    ptgen = proto.get(i);
	    elb = ptgen.elementAssocie;
	    if (elb.estDeNature(type)) {
	      nomGen = ptgen.nom;
	      if (nomGen.length !== 0 && elb.rendNom().length === 0) {
	        elb.donneNom(this.genereDebutNomPourPoint(inddeb - 1));
	      }
	    }
	  }
	  // Ensuite on génère des noms pour tous les objets implémentés noms ou droites qui ont un nom
	  // On compte le nombre d'objets finaux nommés
	  nbfn = 0;
	  for (k = proto.nbObjSources; k < proto.longueur(); k++) {
	    elb = proto.get(k);
	    if (elb.estDeNature(type)) {
	      if (elb.rendNom().length !== 0) nbfn++;
	    }
	  }
	  ch = this.genereDebutNomPourPoint(inddeb - 1); // Le début du nom généré qui sera le même pour tous
	  // les objets de même type
	  k = 0;
	  for (i = 0; i < nbObjImp; i++) {
	    elb = this.get(inddeb + 1 + i);
	    if (elb.estDeNature(type)) {
	      elg = proto.get(proto.nbObjSources + i);
	      if (elg.rendNom().length !== 0) {
	        k++;
	        elb.donneNom(ch + k);
	        j = 1;
	        deb = inddeb + 1 + i + j * (nbObjImp + 1);
	        while (deb < lon) {
	          elb2 = this.get(deb);
	          n = k + j * nbfn;
	          elb2.donneNom(ch + n);
	          j++;
	          deb = inddeb + 1 + i + j * (nbObjImp + 1);
	        }
	      }
	    } else {
	      if (elb.estDeNatureCalcul(NatCal.NTtCalcNomme)) {
	        ch = this.genereDebutNomPourCalcul(Fonte.premiersCaracteresNonChiffresNonPrime(elb.getNom()), inddeb - 1);
	        oldName = elb.getNom();
	        j = 0;
	        deb = inddeb + 1 + i + j * (nbObjImp + 1);
	        while (deb < lon) {
	          vald2 = this.get(deb);
	          oldName = vald2.getNom();
	          newName = ch + j + 1;
	          vald2.donneNom(newName);
	          for (m = deb + 1; m < lon; m++) {
	            e = this.get(m);
	            if (e.estDeNature(NatObj.NImplementationProto)) break;
	            if (e.estDeNature(NatObj.NComouLatex)) {
	              if (e.listeValeursDynamiquesUtilisees.size !== 0) if (e.remplaceNomValeurDynamique(oldName, newName)) e.determineDependances();
	              e.setReady4MathJax();
	            }
	          }
	          j++;
	          deb = inddeb + 1 + i + j * (nbObjImp + 1);
	        }
	      }
	    }
	  }
	  // On reconstitue les formules des calculs ou fonctions
	  for (i = inddeb + 1; i < lon; i++) {
	    elb = this.get(i);
	    if (elb.estDeNatureCalcul(NatCal.NCalcOuFoncNonConstante)) elb.reconstruitChaineCalcul();
	  }
	  // On met à jour les éléments ajoutés et on les met à jour
	  for (i = inddeb + 1; i < lon; i++) {
	    elb = this.get(i);
	    elb.metAJour();
	  }
	};
	
	/**
	 * Spécial mtgApp : Crée en bas et à droite de la figure des patits dialogues
	 * associés aux variables pour lesquelles c'est requis.
	 */
	CListeObjets.prototype.creePaneVariables = function () {
	  var nb = 0;
	  for (var i = this.longueur() - 1; i >= 0; i--) {
	    var el = this.get(i);
	    if (el.getNatureCalcul() === NatCal.NVariable) {
	      if (el.dialogueAssocie) {
	        el.creeDiv(nb);
	        nb++;
	      }
	    }
	  }
	};
	
	CListeObjets.prototype.genereNomPourPoint = function (intermPermis) {
	  var interm = arguments.length === 0 ? false : intermPermis;
	  var ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	  var nomGenere;
	  for (var i = 0;; i++) {
	    for (var j = 0; j < ch.length; j++) {
	      nomGenere = ch.charAt(j);
	      if (i !== 0) nomGenere += String(i);
	      if (!this.existePointOuDroiteMemeNom(null, nomGenere, interm)) return nomGenere;
	    }
	  }
	};
	
	/**
	 * Spécial version mtgApp
	 * Renvoie un nom généré pour un point ou une droite qui commence par car
	 * @param car
	 * @returns {*}
	 */
	CListeObjets.prototype.genereNomPourPointOuDroite = function (car, bchiffreImpose) {
	  var nomGenere;
	  var b = arguments.length === 2 ? bchiffreImpose : false;
	  for (var i = b ? 1 : 0;; i++) {
	    nomGenere = car;
	    if (i !== 0) nomGenere += i;
	    if (!this.existePointOuDroiteMemeNom(null, nomGenere.toString())) return nomGenere;
	  }
	};
	
	/**
	 * Spécial version mtgApp.
	 * Renvoie true si la liste contient un objet graphique non intermédiaire de nom st
	 * autre que el
	 * @param el : CElementGraphique
	 * @param st : String
	 * @returns {boolean}
	 */
	CListeObjets.prototype.existeMemeNomNonIntermediaire = function (el, st) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.estDeNature(NatObj.NTtObjSaufDuplique) && !elb.estElementIntermediaire() && elb !== el) {
	      if (elb.nom === st) return true;
	    }
	  }
	  return false;
	};
	
	/**
	 *
	 * @param valeur
	 * @param st
	 * @param intermPermis
	 * @returns {boolean}
	 */
	CListeObjets.prototype.existeCalculOuVariableOuFonctionOuParametreMemeNom = function (valeur, st, intermPermis) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.estDeNatureCalcul(NatCal.NTtCalcNomme) && (!elb.estElementIntermediaire() || intermPermis) && elb !== valeur) {
	      // CValeurDynamique ptv = (CValeurDynamique) elb;
	      if (elb.getNom() === st) return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * Spéciail version mtgApp
	 * Met à jour dans tous les commentaires les affichages dynamiques
	 */
	CListeObjets.prototype.determineDependancesCommentaires = function () {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    if (elb.estDeNature(NatObj.NComouLatex)) elb.determineDependances();
	  }
	};
	
	/**
	 * Fonction remplaçant dans tous les objets de la liste l'objet ancienPoint
	 * par l'objet nouveauPoint
	 */
	CListeObjets.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  for (var i = 0; i < this.longueur(); i++) {
	    var elb = this.get(i);
	    elb.remplacePoint(ancienPoint, nouveauPoint);
	  }
	  // Les listes gérées de façon internes par les macros doivent être mises à jour
	  this.etablitListesInternesMacros();
	};

/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Classe pour gérer les traitements des fontes et chaînes de caractères
	 * @type Fonte
	 */
	var Fonte = {
	  Normal: 0,
	  Gras: 1,
	  Italique: 2,
	  Underline: 4, // Ajout version 5.0
	  grecLatex: ["\\alpha ", "\\beta ", "\\gamma ", "\\delta ", "\\varepsilon ", "\\zeta ", "\\eta ", "\\theta ", "\\kappa ", "\\lambda ", "\\mu ", "\\nu ", "\\xi ", "\\pi ", "\\rho ", "\\sigma ", "\\tau ", "\\varphi ", "\\chi ", "\\psi ", "\\omega ", "\\Gamma ", "\\Delta ", "\\Xi ", "\\Pi ", "\\Sigma ", "\\Phi ", "\\Chi ", "\\Psi ", "\\Omega"],
	  estNomGrec: function estNomGrec(ch) {
	    var ch2 = "\\" + ch + " ";
	    for (var i = 0; i < Fonte.grecLatex.length; i++) {
	      if (Fonte.grecLatex[i] === ch2) return true;
	    }
	    return false;
	  },
	  /**
	   * Fonction renvoyant true si carac est un e chaîne de carctère formée de une lettre
	   * gérée par le logiciel.
	   * @param {String} carac
	   * @returns {Boolean}
	   */
	  lettre: function lettre(carac) {
	    var car = carac.charCodeAt(0);
	    var res = car >= 'a'.charCodeAt(0) && car <= 'z'.charCodeAt(0) || car >= 'A'.charCodeAt(0) && car <= 'Z'.charCodeAt(0);
	    // Lettres grecques acceptées par le logiciel
	    res = res || car >= 0x3b1 && car <= 0x3b1 + 7;
	    res = res || car === 0x3b1 + 10;
	    res = res || car === 0x3b1 + 11;
	    res = res || car === 0x3b1 + 13;
	    res = res || car >= 0x3b1 + 15 && car <= 0x3b1 + 19;
	    res = res || car >= 0x3b1 + 21 && car <= 0x3b1 + 24;
	    res = res || car >= 0x391 + 2 && car <= 0x391 + 3;
	    res = res || car === 0x391 + 15;
	    res = res || car >= 0x391 + 18 && car <= 0x391 + 19;
	    res = res || car >= 0x391 + 21 && car <= 0x391 + 24;
	    return res;
	  },
	  /**
	   * Renvoie true si car est un caractère ' ou "
	   * @param {String} car
	   * @returns {Boolean}
	   */
	  prime: function prime(car) {
	    return car === "'" || car === '"';
	  },
	  /**
	   * Revoie true si car est une chaine de caractères à un chiffre
	   * @param {String} car
	   * @returns {Boolean}
	   */
	  chiffre: function chiffre(car) {
	    return car.charCodeAt(0) >= '0'.charCodeAt(0) && car.charCodeAt(0) <= '9'.charCodeAt(0);
	  },
	  /**
	   * Revoie true si car est une chaine de caractères à un chiffre ou ²
	   * @param {String} car
	   * @returns {Boolean}
	   */
	  chiffreOuCarre: function chiffreOuCarre(car) {
	    return car === '²' || Fonte.chiffre(car);
	  },
	  /**
	   * Revoie true si car est une chaine de caractères à un chiffre ou un point décimal
	   * @param {String} car
	   * @returns {Boolean}
	   */
	  chiffreOuPointDecimal: function chiffreOuPointDecimal(car) {
	    return car === '.' || Fonte.chiffre(car);
	  },
	  /**
	   * Revoie true si car est une chaine de caractères à uune lettre ou ' ou "
	   * @param {String} car
	   * @returns {Boolean}
	   */
	  lettreOuPrime: function lettreOuPrime(car) {
	    return Fonte.lettre(car) || car === '\'' || car === '\"';
	  },
	  /**
	   * Fonction renvoyant la taille réelle de caractères par un indice de taille
	   * @param {type} indiceDeTaille
	   * @returns {Number}
	   */
	  taille: function taille(indiceDeTaille) {
	    switch (indiceDeTaille) {
	      case 0:
	        // Taille 8
	        return 9;
	      case 1:
	        // Taille 9
	        return 10;
	      case 2:
	        // Taille 11
	        return 12;
	      case 3:
	        // Taille 12
	        return 14;
	      case 4:
	        // Taille 14
	        return 17;
	      // Ajouts version 4.7.5.2
	      default:
	        return 2 * indiceDeTaille + 9;
	      // default : return (int)(coef*13);
	    }
	  },
	  /**
	   * Fonction renvoyant les premiers caractères de ch qui ne sont pas des chiffres
	   * @param {type} ch
	   * @returns {String}
	   */
	  premiersCaracteresNonChiffres: function premiersCaracteresNonChiffres(ch) {
	    var len = ch.length;
	    var i = 0;
	    while (i < len) {
	      if (Fonte.chiffre(ch.charAt(i))) break;else i++;
	    }
	    if (i === len) return ch;else return ch.substring(0, i);
	  },
	
	  /**
	   * Renvoie la taiile utilisée en LaTeX par  taille
	   * @param {int} taille La taille de police
	   * @returns {number}
	   */
	  tailleLatex: function tailleLatex(taille) {
	    return taille - 1;
	  },
	  /**
	   * Renvoie true si ch représente un nombre décimal
	   * @param {string} ch
	   * @returns {boolean}
	   */
	  estDecimalCorrect: function estDecimalCorrect(ch) {
	    var ptdec = false;
	    for (var i = 0; i < ch.length; i++) {
	      var car = ch.charAt(i);
	      if (car === ".") {
	        if (ptdec) return false;else ptdec = true;
	      } else if (!Fonte.chiffre(car)) return false;
	    }
	    return true;
	  },
	  /**
	   * Fonctions renvoyant les premeirs caractères ni chiffres ni ' ni " de ch
	   * @param {string} ch
	   * @returns {string}
	   */
	  premiersCaracteresNonChiffresNonPrime: function premiersCaracteresNonChiffresNonPrime(ch) {
	    var len = ch.length;
	    var i = 0;
	    while (i < len) {
	      if (Fonte.chiffre(ch.charAt(i)) || Fonte.prime(ch.charAt(i))) break;else i++;
	    }
	    if (i === len) return ch;else return ch.substring(0, i);
	  },
	  // Ajout version 5.0
	  styleEcriture: function styleEcriture(st) {
	    var ch = "";
	    if ((st & Fonte.Gras) !== 0) ch += "font-weight:bold;";
	    if ((st & Fonte.Italique) !== 0) ch += "font-style:italic;";
	    if ((st & Fonte.Underline) !== 0) ch += "text-decoration:underline";
	    return ch;
	  },
	  validationNomPoint: function validationNomPoint(chaine) {
	    if (chaine.length === 0) return true;
	    var premierCar = chaine.charAt(0);
	    if (!Fonte.lettre(premierCar)) return false;
	    // Le premier caractère est bien une lettre
	    var carPrecedent = premierCar;
	    var valable = true;
	    for (var i = 1; i < chaine.length; i++) {
	      var carEnCours = chaine.charAt(i);
	      // Cas d'une lettre
	      if (Fonte.lettre(carEnCours)) {
	        if (Fonte.chiffre(carPrecedent) || Fonte.prime(carPrecedent) || Fonte.lettre(carPrecedent)) valable = false;
	      } else {
	        if (Fonte.prime(carEnCours)) {
	          if (Fonte.chiffre(carPrecedent) || Fonte.prime(carPrecedent)) valable = false;
	        } else {
	          if (!Fonte.chiffre(carEnCours)) valable = false;
	        }
	      }
	      carPrecedent = carEnCours;
	    }
	    return valable;
	  },
	  validationNomDroite: function validationNomDroite(chaine) {
	    // On autorise les noms de droites entre parenthèses
	    if (chaine.indexOf("(") === 0 && chaine.charAt(chaine.length - 1) === ")") return Fonte.validationNomPoint(chaine.substring(1, chaine.length - 1));else return Fonte.validationNomPoint(chaine);
	  }
	};
	
	module.exports = Fonte;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	
	/**
	 * Définit les opérateurs de fonctions à une variable réelle ou complexe.
	 * @type Opef
	 */
	var Opef = {
	  Abso: 0,
	  Raci: 1,
	  Enti: 2,
	  Sinu: 3,
	  Cosi: 4,
	  Tang: 5,
	  Logn: 6,
	  Expo: 7,
	  ATan: 8,
	  ACos: 9,
	  ASin: 10,
	  Cosh: 11,
	  Sinh: 12,
	  Tanh: 13,
	  ArgCh: 14,
	  ArgSh: 15,
	  ArgTh: 16,
	  Rand: 17,
	  Raci2: 18,
	  fact: 19,
	  // Deux nouveaux opérateurs pour la version 4.6 : Left et Right
	  Left: 20,
	  Right: 21,
	
	  indPremiereFoncComplexe: 64,
	
	  Abs: 64,
	  Sin: 65,
	  Cos: 66,
	  Tan: 67,
	  Log: 68,
	  Exp: 69,
	  Ch: 70,
	  Sh: 71,
	  Th: 72,
	  Rnd: 73,
	  Conj: 74,
	  Arg: 75,
	  Re: 76,
	  Im: 77,
	  Rac: 78,
	  Rac2: 79,
	  EntiC: 80,
	  ACosC: 81,
	  ASinC: 82,
	  ATanC: 83,
	  ArgChC: 84,
	  ArgShC: 85,
	  ArgThC: 86,
	  factC: 87,
	  LeftC: 88,
	  RightC: 89,
	  /**
	   * Renvoie true si les deux opérateurs sont équivalents.
	   * Tient compte du fait qu'il y a deux opérateurs pour la racine  carrée.
	   * @param {Integer} b1
	   * @param {Integer} b2
	   * @returns {Boolean}
	   */
	  estEquivalent: function estEquivalent(b1, b2) {
	    return b1 === b2 || b1 === Opef.Raci && b2 === Opef.Raci2 || b1 === Opef.Raci2 && b2 === Opef.Raci || b1 === Opef.Rac && b2 === Opef.Rac2 || b1 === Opef.Rac2 && b2 === Opef.Rac;
	  },
	  nomsFoncs: ["abs", "sqrt", "intgr", "sin", "cos", "tan", "ln", "exp", "arctan", "arccos", "arcsin", "ch", "sh", "th", "argch", "argsh", "argth", "rand", "rac", "fact", "left", "right"],
	  nomsFonctions: function nomsFonctions(i) {
	    return kernel.getString(Opef.nomsFoncs[i]);
	  },
	
	  nomsFoncsComplexes: ["abs", "sin", "cos", "tan", "ln", "exp", "ch", "sh", "th", "rand", "conj", "arg", "re", "im", "sqrt", "rac", "intgr", "arccos", "arcsin", "arctan", "argch", "argsh", "argth", "fact", "left", "right"],
	  nomsFonctionsComplexes: function nomsFonctionsComplexes(i) {
	    return kernel.getString(Opef.nomsFoncsComplexes[i]);
	  },
	
	  syntaxeNomsFoncs: ["infoabs", "infosqrt", "infointgr", "infosin", "infocos", "infotan", "infoln", "infoexp", "infoarctan", "infoarccos", "infoarcsin", "infoch", "infosh", "infoth", "infoargch", "infoargsh", "infoargth", "inforand", "inforac", "infofact", "infoLeft", "infoRight"],
	  syntaxeNomsFonctions: function syntaxeNomsFonctions(i) {
	    return kernel.getString(Opef.syntaxeNomsFoncs[i]);
	  },
	
	  syntaxeNomsFoncsComplexes: ["infoabs", "infosin", "infocos", "infotan", "infoln", "infoexp", "infoch", "infosh", "infoth", "inforand", "infoconj", "infoarg", "infore", "infoim", "infosqrt", "inforac", "infointgr", "infoarccos", "infoarcsin", "infoarctan", "infoargch", "infoargsh", "infoargth", "infofact", "infoLeft", "infoRight"],
	  syntaxeNomsFonctionsComplexes: function syntaxeNomsFonctionsComplexes(i) {
	    return kernel.getString(Opef.syntaxeNomsFoncsComplexes[i]);
	  }
	
	};
	
	module.exports = Opef;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	
	/**
	 * Définit les opérateurs de fonctions à deux variables réelles ou complexes.
	 * @type mtg32.Opef2v
	 */
	var Opef2v = {
	  maxi: 0,
	  mini: 1,
	  gcd: 2,
	  lcm: 3,
	  ncr: 4,
	  npr: 5,
	  mod: 6,
	
	  // On garde de la marge pour de futures fonctions réelles
	  indicePremiereFonctionComplexe: 64,
	  // Début des fonctions complexes
	  maxiC: 64,
	  miniC: 65,
	  gcdC: 66,
	  lcmC: 67,
	  ncrC: 68,
	  nprC: 69,
	  modC: 70,
	
	  nomsFoncs2Var: ["maxi", "mini", "gcd", "lcm", "ncr", "npr", "mod"],
	  nomsFonctions2Var: function nomsFonctions2Var(i) {
	    return kernel.getString(Opef2v.nomsFoncs2Var[i]);
	  },
	
	  nomsFoncsComplexes2Var: ["maxi", "mini", "gcd", "lcm", "ncr", "npr", "mod"],
	  nomsFonctionsComplexes2Var: function nomsFonctionsComplexes2Var(i) {
	    return kernel.getString(Opef2v.nomsFoncsComplexes2Var[i]);
	  },
	
	  syntaxeNomsFoncs2Var: ["infomaxi", "infomini", "infogcd", "infolcm", "infoncr", "infonpr", "infomod"],
	  syntaxeNomsFonctions2Var: function syntaxeNomsFonctions2Var(i) {
	    return kernel.getString(Opef2v.syntaxeNomsFoncs2Var[i]);
	  },
	
	  syntaxeNomsFoncsComplexes2Var: ["infomaxi", "infomini", "infogcd", "infolcm", "infoncr", "infonpr", "infomod"],
	  syntaxeNomsFonctionsComplexes2Var: function syntaxeNomsFonctionsComplexes2Var(i) {
	    return kernel.getString(Opef2v.syntaxeNomsFoncsComplexes2Var[i]);
	  }
	
	};
	
	module.exports = Opef2v;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	
	/**
	 * Définit les opérateurs de fonctions à trois variables réelles ou complexes.
	 * La seule fonction à 3 variables est le test si.
	 * @type Opef3v
	 */
	
	var Opef3v = {
	  si: 0,
	
	  indicePremiereFonctionComplexe: 64,
	  nombreFonctionsComplexes3Var: 1,
	  siC: 64,
	  nomsFoncs3Var: ["si"],
	  nomsFonctions3Var: function nomsFonctions3Var(i) {
	    return kernel.getString(Opef3v.nomsFoncs3Var[i]);
	  },
	
	  nomsFoncsComplexes3Var: ["si"],
	  nomsFonctionsComplexes3Var: function nomsFonctionsComplexes3Var(i) {
	    return kernel.getString(Opef3v.nomsFoncsComplexes3Var[i]);
	  },
	  syntaxeNomsFoncs3Var: ["infosi"],
	  syntaxeNomsFonctions3Var: function syntaxeNomsFonctions3Var(i) {
	    return kernel.getString(Opef3v.syntaxeNomsFoncs3Var[i]);
	  },
	
	  syntaxeNomsFoncsComplexes3Var: ["infosi"],
	  syntaxeNomsFonctionsComplexes3Var: function syntaxeNomsFonctionsComplexes3Var(i) {
	    return kernel.getString(Opef3v.syntaxeNomsFoncsComplexes3Var[i]);
	  }
	
	};
	module.exports = Opef3v;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	
	/**
	 * Définit les opérateurs de fonctions à qattre variables réelles ou complexes.
	 * La seule fonction à 4 variables est l'intégrale.
	 * @type Opef4v
	 */
	var Opef4v = {
	  integrale: 0,
	
	  indicePremiereFonctionComplexe: 64,
	  integraleC: 64,
	
	  nomsFoncs4Var: ["integrale"],
	  nomsFonctions4Var: function nomsFonctions4Var(i) {
	    return kernel.getString(Opef4v.nomsFoncs4Var[i]);
	  },
	  nomsFoncsComplexes4Var: ["integrale"],
	  nomsFonctionsComplexes4Var: function nomsFonctionsComplexes4Var(i) {
	    return kernel.getString(Opef4v.nomsFoncsComplexes4Var[i]);
	  },
	  syntaxeNomsFoncs4Var: ["infointegrale"],
	  syntaxeNomsFonctions4Var: function syntaxeNomsFonctions4Var(i) {
	    return kernel.getString(Opef4v.syntaxeNomsFoncs4Var[i]);
	  },
	  syntaxeNomsFoncsComplexes4Var: ["infointegrale"],
	  syntaxeNomsFonctionsComplexes4Var: function syntaxeNomsFonctionsComplexes4Var(i) {
	    return kernel.getString(Opef4v.syntaxeNomsFoncsComplexes4Var[i]);
	  }
	};
	
	module.exports = Opef4v;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	var kernel = __webpack_require__(8);
	
	/**
	 * Définit les opérateurs de fonctions à Cinq variables réelles ou complexes.
	 * @type mtg32.Opef4v
	 */
	
	var Opef5v = {
	  somme: 0,
	  produit: 1,
	
	  indicePremiereFonctionComplexe: 64,
	  nombreFonctionsComplexes5Var: 2,
	
	  sommeC: 64,
	  produitC: 65,
	
	  nomsFoncs5Var: ["somme", "produit"],
	  nomsFonctions5Var: function nomsFonctions5Var(i) {
	    return kernel.getString(Opef5v.nomsFoncs5Var[i]);
	  },
	  nomsFoncsComplexes5Var: ["somme", "produit"],
	  nomsFonctionsComplexes5Var: function nomsFonctionsComplexes5Var(i) {
	    return kernel.getString(Opef5v.nomsFoncsComplexes5Var[i]);
	  },
	
	  syntaxeNomsFoncs5Var: ["infosomme", "infoproduit"],
	  syntaxeNomsFonctions5Var: function syntaxeNomsFonctions5Var(i) {
	    return kernel.getString(Opef5v.syntaxeNomsFoncs5Var[i]);
	  },
	  syntaxeNomsFoncsComplexes5Var: ["infosomme", "infoproduit"],
	  syntaxeNomsFonctionsComplexes5Var: function syntaxeNomsFonctionsComplexes5Var(i) {
	    return kernel.getString(Opef5v.syntaxeNomsFoncsComplexes5Var[i]);
	  }
	};
	module.exports = Opef5v;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	  * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	// lui utilise la syntaxe d'export es6, c'est l'export par défaut qu'on veut
	// const BinaryParser = require('../../outilsExternes/binaryParser/binary-parser').default
	var BinaryParser = __webpack_require__(25).default;
	// import Utf8Utils from '../outilsExternes/Utf8Utils/Utf8Utils'
	// import classe from '../classes/classe'
	var factory = __webpack_require__(26);
	// const utf8 = require('utf8')
	var utf8 = __webpack_require__(196);
	
	module.exports = DataInputStream;
	
	/**
	 * Classe servant à charger une figure depuis un flux binaire base 64
	 * contenu dans un tableau de bytes
	 * @constructor
	 * @param {Array} ba
	 * @returns {undefined}
	 */
	function DataInputStream(ba) {
	  this.ba = ba;
	  this.listeNomsClasse = [];
	  // Spécial JavaScript : pour pouvoir enregistrer la figure dans le flux, il faut aussi connaître le préfixe
	  // du nom de classe qui est utilisé en Java
	  // this.listePrefixes = []; // Abandonné version 5.2 car le prefix est toujours objets !
	  this.listeNumerosVersion = [];
	  this.bp = new BinaryParser(true, true);
	  this.indiceEnCours = 0;
	}
	DataInputStream.inputStreamError = "Erreur de flux";
	DataInputStream.numeroVersionActif = 17; // Changé version 5.4
	
	/**
	 * Saute nbBytes dans la lecture du tableau de bytes
	 * @param {Integer} nbBytes
	 * @returns {undefined}
	 */
	DataInputStream.prototype.skip = function (nbBytes) {
	  this.indiceEnCours += nbBytes;
	};
	/**
	 * Lit un boolean depuis le tableau de bytes
	 * @returns {Boolean}
	 */
	DataInputStream.prototype.readBoolean = function () {
	  if (this.indiceEnCours >= this.ba.length) throw new Error(DataInputStream.inputStreamError);
	  return this.ba[this.indiceEnCours++] === 1;
	};
	/**
	 * Lit un byte depuis le tableau de bytes
	 * @returns {Array}
	 */
	DataInputStream.prototype.readByte = function () {
	  if (this.indiceEnCours >= this.ba.length) throw new Error(DataInputStream.inputStreamError);
	  return this.ba[this.indiceEnCours++];
	};
	/**
	 * Lit un integer sur 4 octets depuis le tableau de bytes
	 * @returns {Integer}
	 */
	DataInputStream.prototype.readInt = function () {
	  var b1 = this.readByte();
	  var b2 = this.readByte();
	  var b3 = this.readByte();
	  var b4 = this.readByte();
	  return b1 << 24 & 0xFF000000 | b2 << 16 & 0x00FF0000 | b3 << 8 & 0x0000FF00 | b4;
	};
	/**
	 * Lit un entier sur deux octets depuis le tableau de bytes.
	 * @returns {Integer}
	 */
	DataInputStream.prototype.readShortInt = function () {
	  var b1 = this.readByte();
	  var b2 = this.readByte();
	  return b1 << 8 & 0x0000FF00 | b2;
	};
	/**
	 * Lit un double depuis le tableau de bytes
	 * @returns {Double}
	 */
	DataInputStream.prototype.readDouble = function () {
	  var ch = String.fromCharCode(this.readByte(), this.readByte(), this.readByte(), this.readByte(), this.readByte(), this.readByte(), this.readByte(), this.readByte());
	  return this.bp.toDouble(ch);
	};
	/**
	 * Lit un float depuis e tableau de bytes.
	 * @returns {Float}
	 */
	DataInputStream.prototype.readFloat = function () {
	  var ch = String.fromCharCode(this.readByte(), this.readByte(), this.readByte(), this.readByte());
	  return this.bp.toFloat(ch);
	};
	/**
	 * Lit une chaîne UTF depuis le tableau de bytes
	 * @returns {String}
	 */
	DataInputStream.prototype.readUTF = function () {
	  var len = this.readShortInt(this.ba);
	  // var ret = Utf8Utils.decode(this.ba.slice(this.indiceEnCours, this.indiceEnCours + len));
	  // @FIXME, on recupère un tableau, utf8.decode veut une string
	  // Marche quand même !
	  var ret = utf8.decode(this.ba.slice(this.indiceEnCours, this.indiceEnCours + len));
	  this.indiceEnCours += len;
	  return ret;
	};
	/**
	 * Lit un objet depuis le tableau de bytes.
	 * @param {type} liste
	 * @returns {mtg32|DataInputStream.prototype.readObject.ob}
	 */
	DataInputStream.prototype.readObject = function (liste) {
	  var ob, nomClasse, numVer, s, ind;
	  s = this.readInt();
	  if (s === -1) {
	    numVer = this.readInt();
	    nomClasse = this.readUTF();
	    ind = nomClasse.indexOf(".", 0);
	    if (ind !== -1) {
	      nomClasse = nomClasse.substring(ind + 1);
	    }
	    this.listeNomsClasse.push(nomClasse);
	    this.listeNumerosVersion.push(numVer);
	  } else {
	    nomClasse = this.listeNomsClasse[s];
	    numVer = this.listeNumerosVersion[s];
	  }
	  /* Modifié new
	  if (!mtg32[nomClasse]) throw new Error("Erreur chargement objet");
	  ob = new mtg32[nomClasse](liste);
	  */
	  // ob = classe(nomClasse, liste);
	  ob = factory(nomClasse, liste);
	  if (ob === null) throw new Error("Erreur chargement objet");
	  ob.nVersion = numVer;
	  ob.read(this, liste);
	  return ob;
	};
	/**
	 * Lit une image depuis le tableau de bytes.
	 * L'image est renvoyée sous forme d'un tableau d'entiers
	 * @returns {Array}
	 */
	DataInputStream.prototype.readBufferedImage = function () {
	  var size = this.readInt();
	  var bar = [];
	  for (var i = 0; i < size; i++) {
	    bar[i] = this.readByte();
	  } // var res =  kernel.base64Encode(bar, true); // Encodage standard
	  return bar;
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Code based on
	 * Jonas Raoni Soares Silva
	 * http://jsfromhell.com/classes/binary-parser [rev. #1]
	 */
	
	/* eslint-disable one-var, semi, eqeqeq, no-cond-assign */
	
	/**
	 * Fonction servant à encoder des entiers ou float dans ou depuis un flux de données binaires.
	 * @constructor
	 */
	function BinaryParser(bigEndian, allowExceptions) {
	  this.bigEndian = bigEndian;
	  this.allowExceptions = allowExceptions;
	}
	
	BinaryParser.prototype.encodeFloat = function (number, precisionBits, exponentBits) {
	  var bias = Math.pow(2, exponentBits - 1) - 1,
	      minExp = -bias + 1,
	      maxExp = bias,
	      minUnnormExp = minExp - precisionBits,
	      status = isNaN(n = parseFloat(number)) || n == -Infinity || n == +Infinity ? n : 0,
	      exp = 0,
	      len = 2 * bias + 1 + precisionBits + 3,
	      bin = new Array(len),
	      signal = (n = status !== 0 ? 0 : n) < 0,
	      n = Math.abs(n),
	      intPart = Math.floor(n),
	      floatPart = n - intPart,
	      i,
	      lastBit,
	      rounded,
	      j,
	      result,
	      r;
	  for (i = len; i; bin[--i] = 0) {}
	  for (i = bias + 2; intPart && i; bin[--i] = intPart % 2, intPart = Math.floor(intPart / 2)) {}
	  for (i = bias + 1; floatPart > 0 && i; (bin[++i] = ((floatPart *= 2) >= 1) - 0) && --floatPart) {}
	  for (i = -1; ++i < len && !bin[i];) {}
	  if (bin[(lastBit = precisionBits - 1 + (i = (exp = bias + 1 - i) >= minExp && exp <= maxExp ? i + 1 : bias + 1 - (exp = minExp - 1))) + 1]) {
	    if (!(rounded = bin[lastBit])) {
	      for (j = lastBit + 2; !rounded && j < len; rounded = bin[j++]) {}
	    }
	    for (j = lastBit + 1; rounded && --j >= 0; (bin[j] = !bin[j] - 0) && (rounded = 0)) {}
	  }
	  for (i = i - 2 < 0 ? -1 : i - 3; ++i < len && !bin[i];) {}
	
	  (exp = bias + 1 - i) >= minExp && exp <= maxExp ? ++i : exp < minExp && (exp != bias + 1 - len && exp < minUnnormExp && this.warn('encodeFloat::float underflow'), i = bias + 1 - (exp = minExp - 1)); // eslint-disable-line eqeqeq
	  (intPart || status !== 0) && (this.warn(intPart ? 'encodeFloat::float overflow' : 'encodeFloat::' + status), exp = maxExp + 1, i = bias + 2, status == -Infinity ? signal = 1 : isNaN(status) && (bin[i] = 1));
	  for (n = Math.abs(exp + bias), j = exponentBits + 1, result = ''; --j; result = n % 2 + result, n = n >>= 1) {}
	  for (n = 0, j = 0, i = (result = (signal ? '1' : '0') + result + bin.slice(i, i + precisionBits).join('')).length, r = []; i; n += (1 << j) * result.charAt(--i), j == 7 && (r[r.length] = String.fromCharCode(n), n = 0), j = (j + 1) % 8) {}
	  r[r.length] = n ? String.fromCharCode(n) : '';
	  return (this.bigEndian ? r.reverse() : r).join('');
	};
	BinaryParser.prototype.encodeInt = function (number, bits, signed) {
	  var max = Math.pow(2, bits),
	      r = [];
	  (number >= max || number < -(max >> 1)) && this.warn('encodeInt::overflow') && (number = 0);
	  number < 0 && (number += max);
	  for (; number; r[r.length] = String.fromCharCode(number % 256), number = Math.floor(number / 256)) {}
	  for (bits = -(-bits >> 3) - r.length; bits--; r[r.length] = '\0') {}
	  return (this.bigEndian ? r.reverse() : r).join('');
	};
	BinaryParser.prototype.decodeFloat = function (data, precisionBits, exponentBits) {
	  var b = ((b = new this.Buffer(this.bigEndian, data)).checkBuffer(precisionBits + exponentBits + 1), b),
	      bias = Math.pow(2, exponentBits - 1) - 1,
	      signal = b.readBits(precisionBits + exponentBits, 1),
	      exponent = b.readBits(precisionBits, exponentBits),
	      significand = 0,
	      divisor = 2,
	      curByte = b.buffer.length + (-precisionBits >> 3) - 1,
	      byteValue,
	      startBit,
	      mask;
	  do {
	    for (byteValue = b.buffer[++curByte], startBit = precisionBits % 8 || 8, mask = 1 << startBit; mask >>= 1; byteValue & mask && (significand += 1 / divisor), divisor *= 2) {}
	  } while (precisionBits -= startBit);
	  return exponent == (bias << 1) + 1 ? significand ? NaN : signal ? -Infinity : +Infinity : (1 + signal * -2) * (exponent || significand ? !exponent ? Math.pow(2, -bias + 1) * significand : Math.pow(2, exponent - bias) * (1 + significand) : 0);
	};
	BinaryParser.prototype.decodeInt = function (data, bits, signed) {
	  var b = new this.Buffer(this.bigEndian, data),
	      x = b.readBits(0, bits),
	      max = Math.pow(2, bits);
	  return signed && x >= max / 2 ? x - max : x;
	};
	
	BinaryParser.prototype.warn = function (msg) {
	  if (this.allowExceptions) throw new Error(msg);
	  return 1;
	};
	BinaryParser.prototype.toSmall = function (data) {
	  return this.decodeInt(data, 8, true);
	};
	BinaryParser.prototype.fromSmall = function (number) {
	  return this.encodeInt(number, 8, true);
	};
	BinaryParser.prototype.toByte = function (data) {
	  return this.decodeInt(data, 8, false);
	};
	BinaryParser.prototype.fromByte = function (number) {
	  return this.encodeInt(number, 8, false);
	};
	BinaryParser.prototype.toShort = function (data) {
	  return this.decodeInt(data, 16, true);
	};
	BinaryParser.prototype.fromShort = function (number) {
	  return this.encodeInt(number, 16, true);
	};
	BinaryParser.prototype.toWord = function (data) {
	  return this.decodeInt(data, 16, false);
	};
	BinaryParser.prototype.fromWord = function (number) {
	  return this.encodeInt(number, 16, false);
	};
	BinaryParser.prototype.toInt = function (data) {
	  return this.decodeInt(data, 32, true);
	};
	BinaryParser.prototype.fromInt = function (number) {
	  return this.encodeInt(number, 32, true);
	};
	BinaryParser.prototype.toDWord = function (data) {
	  return this.decodeInt(data, 32, false);
	};
	BinaryParser.prototype.fromDWord = function (number) {
	  return this.encodeInt(number, 32, false);
	};
	BinaryParser.prototype.toFloat = function (data) {
	  return this.decodeFloat(data, 23, 8);
	};
	BinaryParser.prototype.fromFloat = function (number) {
	  return this.encodeFloat(number, 23, 8);
	};
	BinaryParser.prototype.toDouble = function (data) {
	  return this.decodeFloat(data, 52, 11);
	};
	BinaryParser.prototype.fromDouble = function (number) {
	  return this.encodeFloat(number, 52, 11);
	};
	
	/**
	 * @param bigEndian
	 * @param buffer
	 * @constructor
	 */
	function Buffer(bigEndian, buffer) {
	  this.bigEndian = bigEndian || 0;
	  this.buffer = [];
	  this.setBuffer(buffer);
	}
	BinaryParser.prototype.Buffer = Buffer;
	
	Buffer.prototype.readBits = function (start, length) {
	  // shl fix: Henri Torgemane ~1996 (compressed by Jonas Raoni)
	  function shl(a, b) {
	    for (++b; --b; a = ((a %= 0x7fffffff + 1) & 0x40000000) == 0x40000000 ? a * 2 : (a - 0x40000000) * 2 + 0x7fffffff + 1) {}
	    return a;
	  }
	  if (start < 0 || length <= 0) return 0;
	  this.checkBuffer(start + length);
	  for (var offsetLeft, offsetRight = start % 8, curByte = this.buffer.length - (start >> 3) - 1, lastByte = this.buffer.length + (-(start + length) >> 3), diff = curByte - lastByte, sum = (this.buffer[curByte] >> offsetRight & (1 << (diff ? 8 - offsetRight : length)) - 1) + (diff && (offsetLeft = (start + length) % 8) ? (this.buffer[lastByte++] & (1 << offsetLeft) - 1) << (diff-- << 3) - offsetRight : 0); diff; sum += shl(this.buffer[lastByte++], (diff-- << 3) - offsetRight)) {}
	  return sum;
	};
	Buffer.prototype.setBuffer = function (data) {
	  if (data) {
	    for (var l, i = l = data.length, b = this.buffer = new Array(l); i; b[l - i] = data.charCodeAt(--i)) {}
	    this.bigEndian && b.reverse();
	  }
	};
	Buffer.prototype.hasNeededBits = function (neededBits) {
	  return this.buffer.length >= -(-neededBits >> 3);
	};
	Buffer.prototype.checkBuffer = function (neededBits) {
	  if (!this.hasNeededBits(neededBits)) throw new Error('checkBuffer::missing bytes');
	};
	
	exports.default = BinaryParser;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Renvoie un objet instancié
	 * @param {string} className Le nom de la classe, il doit y avoir un fichier du même nom dans le dossier objets
	 * @param {*} [...args] Les arguments à passer au constructeur
	 * @returns {*} Objet de la classe className auquel on a filé les arguments qui suivent className
	 * args doit être passé sous forme d'un Array (ou un paramètre)
	 */
	module.exports = function factory(className, args) {
	  // cette syntaxe peut pas marcher
	  // return new Constructor.apply(this, args)
	  // mais on peut créer un nouveau constructeur sans argument qui renvoie le bon objet instancié
	  // http://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
	  // Il y a plus court et plus rapide : https://jsperf.com/dynamic-arguments-to-the-constructor
	  try {
	    var cnstor = __webpack_require__(27)("./" + className);
	    return new (Function.prototype.bind.apply(cnstor, [null].concat(Array.prototype.slice.call(arguments, 1))))();
	  } catch (error) {
	    console.error(error.stack);
	    return null;
	  }
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./CAbscisseOrigineRep": 28,
		"./CAbscisseOrigineRep.js": 28,
		"./CAffichageLieAPoint": 36,
		"./CAffichageLieAPoint.js": 36,
		"./CAppelFonction": 42,
		"./CAppelFonction.js": 42,
		"./CAppelFonctionComplexe": 67,
		"./CAppelFonctionComplexe.js": 67,
		"./CAppelFonctionComplexeNVar": 70,
		"./CAppelFonctionComplexeNVar.js": 70,
		"./CAppelFonctionInterne": 62,
		"./CAppelFonctionInterne.js": 62,
		"./CAppelFonctionInterneNVar": 63,
		"./CAppelFonctionInterneNVar.js": 63,
		"./CAppelFonctionNVar": 44,
		"./CAppelFonctionNVar.js": 44,
		"./CArcDeCercle": 72,
		"./CArcDeCercle.js": 72,
		"./CArcDeCercleAncetre": 74,
		"./CArcDeCercleAncetre.js": 74,
		"./CArcDeCercleDirect": 81,
		"./CArcDeCercleDirect.js": 81,
		"./CArcDeCercleImage": 82,
		"./CArcDeCercleImage.js": 82,
		"./CArcDeCercleIndirect": 83,
		"./CArcDeCercleIndirect.js": 83,
		"./CArgument": 89,
		"./CArgument.js": 89,
		"./CAutrePointIntersectionCercles": 91,
		"./CAutrePointIntersectionCercles.js": 91,
		"./CAutrePointIntersectionDroiteCercle": 92,
		"./CAutrePointIntersectionDroiteCercle.js": 92,
		"./CBarycentre": 93,
		"./CBarycentre.js": 93,
		"./CBipoint": 95,
		"./CBipoint.js": 95,
		"./CBissectrice": 97,
		"./CBissectrice.js": 97,
		"./CCalcConst": 101,
		"./CCalcConst.js": 101,
		"./CCalcul": 54,
		"./CCalcul.js": 54,
		"./CCalculAncetre": 35,
		"./CCalculAncetre.js": 35,
		"./CCalculComplexe": 102,
		"./CCalculComplexe.js": 102,
		"./CCb": 43,
		"./CCb.js": 43,
		"./CCbNull": 61,
		"./CCbNull.js": 61,
		"./CCentreCercle": 103,
		"./CCentreCercle.js": 103,
		"./CCentreGravite": 104,
		"./CCentreGravite.js": 104,
		"./CCercle": 75,
		"./CCercle.js": 75,
		"./CCercleClone": 105,
		"./CCercleClone.js": 105,
		"./CCercleImage": 106,
		"./CCercleImage.js": 106,
		"./CCercleOA": 107,
		"./CCercleOA.js": 107,
		"./CCercleOR": 108,
		"./CCercleOR.js": 108,
		"./CCommentaire": 41,
		"./CCommentaire.js": 41,
		"./CConstante": 45,
		"./CConstante.js": 45,
		"./CConstantei": 46,
		"./CConstantei.js": 46,
		"./CDemiDroite": 109,
		"./CDemiDroite.js": 109,
		"./CDemiDroiteClone": 110,
		"./CDemiDroiteClone.js": 110,
		"./CDemiDroiteImage": 111,
		"./CDemiDroiteImage.js": 111,
		"./CDemiDroiteOA": 112,
		"./CDemiDroiteOA.js": 112,
		"./CDemiPlan": 113,
		"./CDemiPlan.js": 113,
		"./CDerivee": 117,
		"./CDerivee.js": 117,
		"./CDeriveePartielle": 118,
		"./CDeriveePartielle.js": 118,
		"./CDroite": 98,
		"./CDroite.js": 98,
		"./CDroiteAB": 120,
		"./CDroiteAB.js": 120,
		"./CDroiteAncetre": 99,
		"./CDroiteAncetre.js": 99,
		"./CDroiteClone": 121,
		"./CDroiteClone.js": 121,
		"./CDroiteDirectionFixe": 122,
		"./CDroiteDirectionFixe.js": 122,
		"./CDroiteImage": 123,
		"./CDroiteImage.js": 123,
		"./CDroiteOm": 124,
		"./CDroiteOm.js": 124,
		"./CDroiteParEq": 125,
		"./CDroiteParEq.js": 125,
		"./CDroiteParallele": 126,
		"./CDroiteParallele.js": 126,
		"./CDroitePerpendiculaire": 127,
		"./CDroitePerpendiculaire.js": 127,
		"./CEditeurFormule": 128,
		"./CEditeurFormule.js": 128,
		"./CEditeurFormuleOld": 129,
		"./CEditeurFormuleOld.js": 129,
		"./CElementBase": 33,
		"./CElementBase.js": 33,
		"./CElementGenerique": 130,
		"./CElementGenerique.js": 130,
		"./CElementGraphique": 39,
		"./CElementGraphique.js": 39,
		"./CElementLigne": 77,
		"./CElementLigne.js": 77,
		"./CFonc": 53,
		"./CFonc.js": 53,
		"./CFoncComplexe": 68,
		"./CFoncComplexe.js": 68,
		"./CFoncComplexeNVar": 131,
		"./CFoncComplexeNVar.js": 131,
		"./CFoncNVar": 119,
		"./CFoncNVar.js": 119,
		"./CFonction": 47,
		"./CFonction.js": 47,
		"./CFonction2Var": 48,
		"./CFonction2Var.js": 48,
		"./CFonction3Var": 49,
		"./CFonction3Var.js": 49,
		"./CGrandArcDeCercle": 84,
		"./CGrandArcDeCercle.js": 84,
		"./CGrapheSuiteRec": 132,
		"./CGrapheSuiteRec.js": 132,
		"./CGrapheSuiteRecComplexe": 135,
		"./CGrapheSuiteRecComplexe.js": 135,
		"./CHomothetie": 136,
		"./CHomothetie.js": 136,
		"./CImage": 137,
		"./CImage.js": 137,
		"./CImplementationProto": 64,
		"./CImplementationProto.js": 64,
		"./CIntCercleCercle": 138,
		"./CIntCercleCercle.js": 138,
		"./CIntDroiteCercle": 139,
		"./CIntDroiteCercle.js": 139,
		"./CIntDroiteDroite": 140,
		"./CIntDroiteDroite.js": 140,
		"./CIntegrale": 141,
		"./CIntegrale.js": 141,
		"./CIntegraleDansFormule": 56,
		"./CIntegraleDansFormule.js": 56,
		"./CInversion": 142,
		"./CInversion.js": 142,
		"./CLatex": 40,
		"./CLatex.js": 40,
		"./CLieuDeBase": 143,
		"./CLieuDeBase.js": 143,
		"./CLieuDePoints": 146,
		"./CLieuDePoints.js": 146,
		"./CLieuDiscretDeBase": 147,
		"./CLieuDiscretDeBase.js": 147,
		"./CLieuDiscretParPointLie": 148,
		"./CLieuDiscretParPointLie.js": 148,
		"./CLieuDiscretParVariable": 149,
		"./CLieuDiscretParVariable.js": 149,
		"./CLieuObjetAncetre": 150,
		"./CLieuObjetAncetre.js": 150,
		"./CLieuObjetParPtLie": 151,
		"./CLieuObjetParPtLie.js": 151,
		"./CLieuObjetParVariable": 152,
		"./CLieuObjetParVariable.js": 152,
		"./CLieuParVariable": 153,
		"./CLieuParVariable.js": 153,
		"./CLigneBrisee": 154,
		"./CLigneBrisee.js": 154,
		"./CLignePolygonaleAncetre": 155,
		"./CLignePolygonaleAncetre.js": 155,
		"./CListeObjets": 17,
		"./CListeObjets.js": 17,
		"./CLongueur": 156,
		"./CLongueur.js": 156,
		"./CMacro": 157,
		"./CMacro.js": 157,
		"./CMacroAffectationPointLie": 158,
		"./CMacroAffectationPointLie.js": 158,
		"./CMacroAffectationValeurVariable": 159,
		"./CMacroAffectationValeurVariable.js": 159,
		"./CMacroAffichantTout": 160,
		"./CMacroAffichantTout.js": 160,
		"./CMacroAnimationAvecTrace": 161,
		"./CMacroAnimationAvecTrace.js": 161,
		"./CMacroAnimationPointLie": 163,
		"./CMacroAnimationPointLie.js": 163,
		"./CMacroApparition": 164,
		"./CMacroApparition.js": 164,
		"./CMacroAvecListe": 162,
		"./CMacroAvecListe.js": 162,
		"./CMacroBoucleAvecAnimation": 165,
		"./CMacroBoucleAvecAnimation.js": 165,
		"./CMacroBoucleAvecTrace": 166,
		"./CMacroBoucleAvecTrace.js": 166,
		"./CMacroClignotement": 167,
		"./CMacroClignotement.js": 167,
		"./CMacroConstructionIterative": 168,
		"./CMacroConstructionIterative.js": 168,
		"./CMacroConstructionRecursive": 171,
		"./CMacroConstructionRecursive.js": 171,
		"./CMacroDecrementationVariable": 172,
		"./CMacroDecrementationVariable.js": 172,
		"./CMacroDisparition": 174,
		"./CMacroDisparition.js": 174,
		"./CMacroIncrementationVariable": 173,
		"./CMacroIncrementationVariable.js": 173,
		"./CMacroJouantSon": 175,
		"./CMacroJouantSon.js": 175,
		"./CMacroModeTraceActivation": 176,
		"./CMacroModeTraceActivation.js": 176,
		"./CMacroModeTraceDesactivation": 177,
		"./CMacroModeTraceDesactivation.js": 177,
		"./CMacroModificationVariable": 178,
		"./CMacroModificationVariable.js": 178,
		"./CMacroPause": 179,
		"./CMacroPause.js": 179,
		"./CMacroSuiteMacros": 180,
		"./CMacroSuiteMacros.js": 180,
		"./CMacroTraceAuto": 181,
		"./CMacroTraceAuto.js": 181,
		"./CMacroTraceAutoParVariable": 182,
		"./CMacroTraceAutoParVariable.js": 182,
		"./CMarqueAngleAncetre": 183,
		"./CMarqueAngleAncetre.js": 183,
		"./CMarqueAngleDroit": 187,
		"./CMarqueAngleDroit.js": 187,
		"./CMarqueAngleGeometrique": 188,
		"./CMarqueAngleGeometrique.js": 188,
		"./CMarqueAngleOriente": 189,
		"./CMarqueAngleOriente.js": 189,
		"./CMarqueAngleOrienteDirecte": 191,
		"./CMarqueAngleOrienteDirecte.js": 191,
		"./CMarqueAngleOrienteIndirecte": 192,
		"./CMarqueAngleOrienteIndirecte.js": 192,
		"./CMarqueSegment": 186,
		"./CMarqueSegment.js": 186,
		"./CMathGraphDoc": 193,
		"./CMathGraphDoc.js": 193,
		"./CMaxFonc": 197,
		"./CMaxFonc.js": 197,
		"./CMediatrice": 198,
		"./CMediatrice.js": 198,
		"./CMesureAbscisse": 199,
		"./CMesureAbscisse.js": 199,
		"./CMesureAffixe": 200,
		"./CMesureAffixe.js": 200,
		"./CMesureAire": 201,
		"./CMesureAire.js": 201,
		"./CMesureAngleGeometrique": 202,
		"./CMesureAngleGeometrique.js": 202,
		"./CMesureAngleOriente": 203,
		"./CMesureAngleOriente.js": 203,
		"./CMesureCoefDir": 204,
		"./CMesureCoefDir.js": 204,
		"./CMesureLongueurLigne": 205,
		"./CMesureLongueurLigne.js": 205,
		"./CMesureX": 206,
		"./CMesureX.js": 206,
		"./CMesureY": 207,
		"./CMesureY.js": 207,
		"./CMilieu": 208,
		"./CMilieu.js": 208,
		"./CMinFonc": 209,
		"./CMinFonc.js": 209,
		"./CModule": 210,
		"./CModule.js": 210,
		"./CMoinsUnaire": 50,
		"./CMoinsUnaire.js": 50,
		"./CNoeudPointeurSurPoint": 65,
		"./CNoeudPointeurSurPoint.js": 65,
		"./CNoeudPondere": 94,
		"./CNoeudPondere.js": 94,
		"./COb": 34,
		"./COb.js": 34,
		"./CObjetDuplique": 211,
		"./CObjetDuplique.js": 211,
		"./COperation": 51,
		"./COperation.js": 51,
		"./COrdonneeOrigineRep": 212,
		"./COrdonneeOrigineRep.js": 212,
		"./CPartieImaginaire": 213,
		"./CPartieImaginaire.js": 213,
		"./CPartieReelle": 90,
		"./CPartieReelle.js": 90,
		"./CPointAncetrePointsMobiles": 86,
		"./CPointAncetrePointsMobiles.js": 86,
		"./CPointBase": 85,
		"./CPointBase.js": 85,
		"./CPointBaseEnt": 214,
		"./CPointBaseEnt.js": 214,
		"./CPointClone": 215,
		"./CPointClone.js": 215,
		"./CPointDansBipoint": 96,
		"./CPointDansBipoint.js": 96,
		"./CPointDansRepere": 133,
		"./CPointDansRepere.js": 133,
		"./CPointImage": 216,
		"./CPointImage.js": 216,
		"./CPointInterieurCercle": 217,
		"./CPointInterieurCercle.js": 217,
		"./CPointInterieurPolygone": 218,
		"./CPointInterieurPolygone.js": 218,
		"./CPointLie": 219,
		"./CPointLie.js": 219,
		"./CPointLieBipoint": 220,
		"./CPointLieBipoint.js": 220,
		"./CPointLieCercle": 221,
		"./CPointLieCercle.js": 221,
		"./CPointLieDroite": 222,
		"./CPointLieDroite.js": 222,
		"./CPointLieLieuAncetre": 223,
		"./CPointLieLieuAncetre.js": 223,
		"./CPointLieLieuParPtLie": 224,
		"./CPointLieLieuParPtLie.js": 224,
		"./CPointLieLieuParVar": 225,
		"./CPointLieLieuParVar.js": 225,
		"./CPointLieLigne": 226,
		"./CPointLieLigne.js": 226,
		"./CPointLiePoint": 227,
		"./CPointLiePoint.js": 227,
		"./CPointParAbscisse": 228,
		"./CPointParAbscisse.js": 228,
		"./CPointParAffixe": 229,
		"./CPointParAffixe.js": 229,
		"./CPointParMultVect": 231,
		"./CPointParMultVect.js": 231,
		"./CPointParSommeVect": 232,
		"./CPointParSommeVect.js": 232,
		"./CPointProjete": 233,
		"./CPointProjete.js": 233,
		"./CPolygone": 169,
		"./CPolygone.js": 169,
		"./CProduit": 234,
		"./CProduit.js": 234,
		"./CProduitDansFormule": 60,
		"./CProduitDansFormule.js": 60,
		"./CProduitScalaire": 235,
		"./CProduitScalaire.js": 235,
		"./CPrototype": 194,
		"./CPrototype.js": 194,
		"./CPt": 87,
		"./CPt.js": 87,
		"./CPuissance": 52,
		"./CPuissance.js": 52,
		"./CRepere": 236,
		"./CRepere.js": 236,
		"./CResultatValeur": 59,
		"./CResultatValeur.js": 59,
		"./CResultatValeurComplexe": 71,
		"./CResultatValeurComplexe.js": 71,
		"./CRotation": 237,
		"./CRotation.js": 237,
		"./CSegment": 134,
		"./CSegment.js": 134,
		"./CSegmentClone": 238,
		"./CSegmentClone.js": 238,
		"./CSimilitude": 239,
		"./CSimilitude.js": 239,
		"./CSolutionEquation": 240,
		"./CSolutionEquation.js": 240,
		"./CSomme": 241,
		"./CSomme.js": 241,
		"./CSommeDansFormule": 58,
		"./CSommeDansFormule.js": 58,
		"./CSousListeObjets": 66,
		"./CSousListeObjets.js": 66,
		"./CSuiteRec": 242,
		"./CSuiteRec.js": 242,
		"./CSuiteRec2": 243,
		"./CSuiteRec2.js": 243,
		"./CSuiteRec3": 244,
		"./CSuiteRec3.js": 244,
		"./CSuiteRecComplexe": 245,
		"./CSuiteRecComplexe.js": 245,
		"./CSuiteRecComplexe2": 246,
		"./CSuiteRecComplexe2.js": 246,
		"./CSuiteRecComplexe3": 247,
		"./CSuiteRecComplexe3.js": 247,
		"./CSurface": 114,
		"./CSurface.js": 114,
		"./CSurfaceAncetre": 116,
		"./CSurfaceAncetre.js": 116,
		"./CSurfaceDeuxLieux": 248,
		"./CSurfaceDeuxLieux.js": 248,
		"./CSurfaceDisque": 249,
		"./CSurfaceDisque.js": 249,
		"./CSurfaceLieu": 250,
		"./CSurfaceLieu.js": 250,
		"./CSurfaceLieuDeuxPoints": 251,
		"./CSurfaceLieuDeuxPoints.js": 251,
		"./CSurfaceLieuDroite": 252,
		"./CSurfaceLieuDroite.js": 252,
		"./CSurfacePolygone": 170,
		"./CSurfacePolygone.js": 170,
		"./CSurfaceSecteurCirculaire": 253,
		"./CSurfaceSecteurCirculaire.js": 253,
		"./CSymetrieAxiale": 254,
		"./CSymetrieAxiale.js": 254,
		"./CSymetrieCentrale": 255,
		"./CSymetrieCentrale.js": 255,
		"./CTestDependanceVariable": 256,
		"./CTestDependanceVariable.js": 256,
		"./CTestEqNatOp": 257,
		"./CTestEqNatOp.js": 257,
		"./CTestEquivalence": 258,
		"./CTestEquivalence.js": 258,
		"./CTestExistence": 259,
		"./CTestExistence.js": 259,
		"./CTestFact": 260,
		"./CTestFact.js": 260,
		"./CTransParVect": 261,
		"./CTransParVect.js": 261,
		"./CTransformation": 100,
		"./CTransformation.js": 100,
		"./CTranslation": 262,
		"./CTranslation.js": 262,
		"./CTranslationParCoord": 263,
		"./CTranslationParCoord.js": 263,
		"./CUnitexRep": 264,
		"./CUnitexRep.js": 264,
		"./CUniteyRep": 265,
		"./CUniteyRep.js": 265,
		"./CValDyn": 29,
		"./CValDyn.js": 29,
		"./CValeur": 80,
		"./CValeur.js": 80,
		"./CValeurAffichee": 266,
		"./CValeurAffichee.js": 266,
		"./CValeurAngle": 79,
		"./CValeurAngle.js": 79,
		"./CValeurComp": 230,
		"./CValeurComp.js": 230,
		"./CVariableBornee": 267,
		"./CVariableBornee.js": 267,
		"./CVariableFormelle": 57,
		"./CVariableFormelle.js": 57,
		"./CVecteur": 269,
		"./CVecteur.js": 269
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 27;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CValDyn = __webpack_require__(29);
	var CCalculAncetre = __webpack_require__(35);
	
	module.exports = CAbscisseOrigineRep;
	
	/**
	 * Objet représentant l'abscisse à l'origine d'un repère
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : la liste propriétaire
	 * @param {CImplementationProt} impProto : L'implémentation de construction propriétaire (peut être null)
	 * @param {boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {String} nomCalcul : Le nom du calcul représentant cette abscisse à l'origine
	 * @param {Crepere} rep : Pointe sur le repère associé
	 * @returns {undefined}
	 */
	function CAbscisseOrigineRep(listeProprietaire, impProto, estElementFinal, nomCalcul, rep) {
	  if (arguments.length === 0) return; // Ajout version WebPack
	  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.rep = rep;
	    this.abscisseOrigine = 0;
	  }
	}
	CAbscisseOrigineRep.prototype = new CCalculAncetre();
	CAbscisseOrigineRep.prototype.constructor = CAbscisseOrigineRep;
	CAbscisseOrigineRep.prototype.superClass = "CCalculAncetre";
	CAbscisseOrigineRep.prototype.className = "CAbscisseOrigineRep";
	
	/** inheritDoc */
	CAbscisseOrigineRep.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CAbscisseOrigineRep(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CRepere"));
	};
	
	CAbscisseOrigineRep.prototype.getNatureCalcul = function () {
	  return NatCal.NAbscisseOrigineRep;
	};
	
	CAbscisseOrigineRep.prototype.setClone = function (ptel) {
	  this.abscisseOrigine = ptel.abscisseOrigine;
	};
	
	CAbscisseOrigineRep.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.rep.o);
	  liste.add(this.rep.i);
	  liste.add(this.rep.j);
	};
	
	CAbscisseOrigineRep.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.rep.dependDe(p));
	};
	
	CAbscisseOrigineRep.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.rep.dependDePourBoucle(p);
	};
	
	CAbscisseOrigineRep.prototype.rendValeur = function () {
	  return this.abscisseOrigine;
	};
	CAbscisseOrigineRep.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.rep.existe;
	  this.abscisseOrigine = this.rep.valAbscisseOrigine;
	};
	CAbscisseOrigineRep.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.rep === p.rep;
	  } else return false;
	};
	
	CAbscisseOrigineRep.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.rep = list.get(ind1, "CRepere");
	};
	CAbscisseOrigineRep.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.rep);
	  oups.writeInt(ind1);
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Complexe = __webpack_require__(30);
	var kernel = __webpack_require__(8);
	var CElementBase = __webpack_require__(33);
	
	module.exports = CValDyn;
	
	/**
	 * Classe ancêtre de tous les objets représentant un objet numérique, calcul ou mesure.
	 * @constructor
	 * @extends CElementBase
	 * @param {CListeObjets} listeProprietaire
	 * @param {CImplementationProto} impProto : null ou pointeur sur la construction propriétaire
	 * @param {Boolean} estElementFinal
	 * @returns {undefined}
	 */
	function CValDyn(listeProprietaire, impProto, estElementFinal) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CElementBase.call(this, listeProprietaire);else CElementBase.call(this, listeProprietaire, impProto, estElementFinal);
	    this.z1 = new Complexe();
	  }
	}
	CValDyn.prototype = new CElementBase();
	CValDyn.prototype.constructor = CValDyn;
	CValDyn.prototype.superClass = "CElementBase";
	CValDyn.prototype.className = "CValDyn";
	
	/** inheritDoc */
	CValDyn.prototype.getNature = function () {
	  return NatObj.NAucunObjet;
	};
	// Méthode à redéfinir pour les descendants renvoyant la valeur. Ne sert pas ici
	/**
	 * Fonction renvoyant la valeur du calcul (réelle).
	 * Doit être redéfini pour les descendants
	 * @returns {number}
	 */
	CValDyn.prototype.rendValeur = function () {
	  return 0;
	};
	/**
	 * Fonction renvoyant la valeur du calcul complexe dans zRes.
	 * Doit être redéfini pour les descendants
	 * @param {Complexe} zRes
	
	 */
	CValDyn.prototype.rendValeurComplexe = function (zRes) {
	  zRes.x = this.rendValeur();
	  zRes.y = 0;
	};
	/**
	 * Renvoie la valeur du calcul réel sous forme d'une chaîne
	 * @param {int} nbDecimales : le nombre de décimales souhaité
	 * @returns {string}
	 */
	CValDyn.prototype.rendChaineValeur = function (nbDecimales) {
	  return kernel.chaineNombre(this.rendValeur(), nbDecimales);
	};
	/**
	 * Renvoie la valeur du calcul complexe sous forme d'une chaîne
	 * @param {int} nbDecimales
	 * @returns {string}
	 */
	CValDyn.prototype.rendChaineValeurComplexe = function (nbDecimales) {
	  this.rendValeurComplexe(this.z1);
	  return this.z1.chaineValeurComplexe(nbDecimales);
	};
	/**
	 * Renvoie la valeur du calcul réel sous forme d'une chaîne
	 * @param {int} nbDecimales
	 * @returns {string}
	 */
	CValDyn.prototype.rendChaineValeurPourCommentaire = function (nbDecimales) {
	  return this.rendChaineValeur(nbDecimales);
	};
	/**
	 * Renvoie true si ch est égale au nom de a valeur
	 * @param {string} ch
	 * @returns {boolean}
	 */
	CValDyn.prototype.chaineEgaleANom = function (ch) {
	  return this.getNom() === ch;
	};
	// Ne sera redéfini que pour les calculs et les variables
	/**
	 * Renvoie le nom de la valeur
	 * Ne sera redéfini que pour les calculs et les variables
	 * @returns {string}
	 */
	CValDyn.prototype.getNom = function () {
	  return "";
	};
	/**
	 * Renvoie true si ch commence par le nom de la valeur
	 * @param {Sstring} ch
	 * @param {Object} longueurNom : Contient dans x au retour la longueur du nom
	 * si la chaine commence bien par ch
	 * @returns {boolean}
	 */
	CValDyn.prototype.chaineCommenceParNom = function (ch, longueurNom) {
	  var chaineNom = this.getNom();
	  longueurNom.x = chaineNom.length;
	  var longueurChaine2 = ch.length;
	  if (longueurChaine2 < longueurNom.x) return false;else return chaineNom === ch.substring(0, longueurNom.x);
	};
	/**
	 * Renvoie true si l'objet est une fonction ou une suite
	 * @returns {boolean}
	 */
	CValDyn.prototype.estFonctionOuSuite = function () {
	  return false;
	};
	/**
	 * Renvoie true si le résultat de la valeur est constant
	 * A redéfinir pour les descendants
	 * @returns {boolean}
	 */
	CValDyn.prototype.estConstant = function () {
	  return false;
	};
	/**
	 * Renvoie le membre de gauche de l'opérateur dans le cas d'une calcul avec opération
	 * @returns {CCb}
	 */
	CValDyn.prototype.membreGauche = function () {
	  return null;
	};
	/**
	 * Renvoie le membre de droite de l'opérateur dans le cas d'une calcul avec opération
	 * @returns {CCb}
	 */
	CValDyn.prototype.membreDroit = function () {
	  return null;
	};
	/**
	 * Renvoie true si le nom de la valeur commence par st
	 * @param {String} st
	 * @returns {Boolean}
	 */
	CValDyn.prototype.nomCommencePar = function (st) {
	  return this.getNom().indexOf(st) === 0;
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	// CCb est requis dans Complexe.prototype.expComp, pour l'être à l'exécution
	// sinon on a des pbs de dépendances cycliques que webpack n'arrive pas à résoudre
	// Remplacé par CCbGlob
	
	module.exports = Complexe;
	
	/**
	 * Classe représentant un nombre complexe pour les calculs dans MathGraph32.
	 * this.x est la partie réelle.
	 * this.y est la partie imaginaire.
	 * @constructor
	 * @returns {Complexe}
	 */
	function Complexe() {
	  if (arguments.length === 0) {
	    this.x = 0;
	    this.y = 0;
	  } else if (arguments.length === 1) {
	    // Construction à partir d'un autre complexe
	    this.x = arguments[0].x;
	    this.y = arguments[0].y;
	  } else {
	    // Construction par donnée de partie réelle et imaginaire
	    this.x = arguments[0];
	    this.y = arguments[1];
	  }
	}
	/**
	 * Fonction donnant une valeur à un nombre complee.
	 * Avec un paramètre : Le paramètre est lui-même un Complexe
	 * Avec deux paramètres : On donne une valeur à la partir réelle
	 * et à la partie imaginaire.
	 * @returns {undefined}
	 */
	Complexe.prototype.set = function () {
	  if (arguments.length === 2) {
	    // Construction par partie réelle et imaginaire
	    this.x = arguments[0];
	    this.y = arguments[1];
	  } else {
	    // Construction à partir d'un autre complexe
	    this.x = arguments[0].x;
	    this.y = arguments[0].y;
	  }
	};
	/**
	 * Fonction renvoyant true si la valeur réelle ou imaginaire de this n'est pas définie.
	 * @returns {Boolean}
	 */
	Complexe.prototype.isNanOrInfinite = function () {
	  return !isFinite(this.x) || !isFinite(this.y);
	};
	/**
	 * Fonction renvoyant l'argument principal du complexe s'il est non nul.
	 * La réponse tient compte du paramètre uniteAngle
	 * @param {integer} uniteAngle: 0 pour le radian, 1 pour le degré.
	 * @returns {Float} : L'argument principal.
	 */
	Complexe.prototype.argument = function (uniteAngle) {
	  var resul;
	  if (this.x === 0) {
	    if (this.y > 0) resul = Math.PI / 2;else resul = -Math.PI / 2;
	  } else {
	    var tangente = this.y / this.x;
	    if (this.x > 0) resul = Math.atan(tangente);else {
	      if (this.y >= 0) resul = Math.atan(tangente) + Math.PI;else resul = Math.atan(tangente) - Math.PI;
	    }
	  }
	  if (uniteAngle === kernel.uniteAngle.radian) return resul;else return resul * kernel.ConvRadDeg;
	};
	/**
	 * Renvoie le module du nombre complexe.
	 * @returns {Number}
	 */
	Complexe.prototype.module = function () {
	  return Math.sqrt(this.x * this.x + this.y * this.y);
	};
	/**
	 * Renvoie dans le complexe res la somme de this avec z1.
	 * @param {Complexe} z1
	 * @param {Complexe} res
	 * @returns {undefined}
	 */
	Complexe.prototype.sommeComp = function (z1, res) {
	  res.x = this.x + z1.x;
	  res.y = this.y + z1.y;
	};
	/**
	 * Renvoie dans le complexe z1 la différence de this avec z1.
	 * @param {Complexe} z1
	 * @param {Complexe} res
	 * @returns {undefined}
	 */
	Complexe.prototype.differenceComp = function (z1, res) {
	  res.x = this.x - z1.x;
	  res.y = this.y - z1.y;
	};
	/**
	 * Renvoie dans le complexe res le produit de this avec z1.
	 * @param {Complexe} z1
	 * @param {Complexe} res
	 * @returns {undefined}
	 */
	Complexe.prototype.produitComp = function (z1, res) {
	  res.x = this.x * z1.x - this.y * z1.y;
	  res.y = this.x * z1.y + z1.x * this.y;
	};
	/**
	 * Renvoie le carré du module du complexe.
	 * @returns {Float}
	 */
	Complexe.prototype.moduleCarre = function () {
	  return this.x * this.x + this.y * this.y;
	};
	Complexe.prototype.sinComp = function (uniteAngle, res) {
	  // On utilise la formule sinz = 1/(2i)(exp(iz)-exp(-iz))
	  var c1 = new Complexe(-this.y, this.x);
	  // c1 contient iz
	  var c2 = new Complexe(this.y, -this.x);
	  // c2 contient -iz
	  var c3 = new Complexe();
	  c1.expComp(uniteAngle, c3); // C3 contient exp(iz)
	  var c4 = new Complexe();
	  c2.expComp(uniteAngle, c4); // C4 contient exp(-iz)
	  var c5 = new Complexe();
	  c3.differenceComp(c4, c5);
	  // On divise c5 par 2i, donc on le multiplie par -0.5*i
	  res.x = 0.5 * c5.y;
	  res.y = -0.5 * c5.x;
	};
	Complexe.prototype.cosComp = function (uniteAngle, res) {
	  // On utilise la formule sinz = 1/2(exp(iz)+exp(-iz))
	  var c1 = new Complexe(-this.y, this.x);
	  // c1 contient iz
	  var c2 = new Complexe(this.y, -this.x);
	  // c2 contient -iz
	  var c3 = new Complexe();
	  c1.expComp(uniteAngle, c3); // C3 contient exp(iz)
	  var c4 = new Complexe();
	  c2.expComp(uniteAngle, c4); // C4 contient exp(-iz)
	  var c5 = new Complexe();
	  c3.sommeComp(c4, c5);
	  res.x = 0.5 * c5.x;
	  res.y = 0.5 * c5.y;
	};
	
	Complexe.prototype.tanComp = function (uniteAngle, res) {
	  // On utilise la formule 1/i*(exp(2iz-1)/(exp(2iz+1))
	  var c1 = new Complexe(-2 * this.y, 2 * this.x); // c1 contient 2ic
	  // c1 contient 2ic
	  var c2 = new Complexe();
	  c1.expComp(uniteAngle, c2); // c2 contient exp(2ic)
	  var c3 = new Complexe(c2.x + 1, c2.y); // c3 contient exp(2c) + 1
	  c2.x = c2.x - 1; // z1 contient exp(2c) - 1
	  var c4 = new Complexe();
	  // c2.quotientComp(c3, c4)
	  kernel.divComp(c2, c3, c4);
	  res.set(c4.y, -c4.x);
	};
	Complexe.prototype.shComp = function (uniteAngle, res) {
	  var c1 = new Complexe(-this.x, -this.y);
	  // c1 contient -this
	  var c2 = new Complexe();
	  this.expComp(uniteAngle, c2); // c2 contient expComp(this)
	  var c3 = new Complexe();
	  c1.expComp(uniteAngle, c3); // C3 contient  expComp(-this)
	  c2.differenceComp(c3, res);
	  res.x /= 2;
	  res.y /= 2;
	};
	Complexe.prototype.chComp = function (uniteAngle, res) {
	  var c1 = new Complexe(-this.x, -this.y);
	  // c1 contient -this
	  var c2 = new Complexe();
	  this.expComp(uniteAngle, c2); // c2 contient expComp(this)
	  var c3 = new Complexe();
	  c1.expComp(uniteAngle, c3); // c3 contient expComp(-this)
	  c2.sommeComp(c3, res);
	  res.x /= 2;
	  res.y /= 2;
	};
	Complexe.prototype.thComp = function (uniteAngle, res) {
	  var c1 = new Complexe();
	  this.expComp(uniteAngle, c1);
	  var c2 = new Complexe(-this.x, -this.y);
	  var c3 = new Complexe();
	  c2.expComp(uniteAngle, c3);
	  var num = new Complexe();
	  c1.differenceComp(c3, num);
	  var den = new Complexe();
	  c1.sommeComp(c3, den);
	  kernel.divComp(num, den, res);
	};
	
	/**
	 * Renvoie l'exponentielle complexe de this en tenant compte de uniteAngle.
	 * @param {Integer} uniteAngle
	 * @param {Complexe} res
	 * @returns {undefined}
	 */
	Complexe.prototype.expComp = function (uniteAngle, res) {
	  var CCbGlob = __webpack_require__(31);
	  if (uniteAngle === kernel.uniteAngle.radian) {
	    res.x = Math.exp(this.x) * CCbGlob.cosinus(this.y);
	    res.y = Math.exp(this.x) * CCbGlob.sinus(this.y);
	  } else {
	    res.x = Math.exp(this.x) * CCbGlob.cosinus(this.y * kernel.ConvDegRad);
	    res.y = Math.exp(this.x) * CCbGlob.sinus(this.y * kernel.ConvDegRad);
	  }
	};
	/**
	 * Renvoie le logarithme complexe de this en tenant compte de uniteAngle.
	 * @param {Integer} uniteAngle : 0 pour radian, 1 pour degré.
	 * @param {Complexe} res
	 * @returns {undefined}
	 */
	Complexe.prototype.lnComp = function (uniteAngle, res) {
	  var r = this.module();
	  res.x = Math.log(r);
	  res.y = this.argument(uniteAngle);
	};
	/**
	 * Renvoie dans res this élevé à la puissnace b (b complexe)
	 * @param {Complexe} b
	 * @param {Complexe} res
	 * @returns {undefined}
	 */
	Complexe.prototype.puisComp = function (b, res) {
	  var c1 = new Complexe();
	  this.lnComp(kernel.uniteAngle.radian, c1); // c1 contient ln(this)
	  var c2 = new Complexe();
	  b.produitComp(c1, c2); // c2 contient b*ln(this)
	  c2.expComp(kernel.uniteAngle.radian, res);
	};
	/**
	 * Elévation d'un complexe à une puissance entière d'exposant
	 * strictement positif, inférieur ou égal à 255 et non nul
	 * On utilise l'algorithme optimisé n'utilisant que des produits.
	 * Le résultat est renvoyé dans res.
	 * @param {Integer} exposant
	 * @param {Complexe} res
	 * @returns {undefined}
	 */
	Complexe.prototype.puisCompExpEnt = function (exposant, res) {
	  res.x = 1;
	  res.y = 0;
	  var tampon = new Complexe(this.x, this.y);
	  // Version n'utilisant que des décalages de bits pour optimisation
	  var b = 128;
	  var indfin = 7;
	  var x1, y1;
	  while ((b & exposant) === 0) {
	    indfin--;
	    b = b >> 1;
	  }
	  for (var i = 0; i <= indfin; i++) {
	    if (exposant % 2 !== 0) {
	      // On n'appele pas produitComp qui créerait un nouvel objet Complexe
	      x1 = res.x * tampon.x - res.y * tampon.y;
	      y1 = res.x * tampon.y + res.y * tampon.x;
	      res.x = x1;
	      res.y = y1;
	    }
	    exposant >>= 1;
	    // On élève tampon au carré
	    x1 = tampon.x * tampon.x - tampon.y * tampon.y;
	    y1 = 2 * tampon.x * tampon.y;
	    tampon.x = x1;
	    tampon.y = y1;
	  }
	};
	/**
	 * Renvoie une chaîne de caractères représentant le complexe this.
	 * @returns {String}
	 */
	Complexe.prototype.toString = function () {
	  var y = this.y;
	  if (y === 0) return this.x.toString();
	  if (y < 0) return this.x.toString() + this.y.toString() + "i";
	  return this.x.toString() + "+" + this.y.toString() + "i";
	};
	
	Complexe.prototype.chaineValeurComplexe = function (nbDecimales) {
	  var ch1 = kernel.chaineNombre(this.x, nbDecimales);
	  var ch2 = kernel.chaineNombre(this.y, nbDecimales);
	  if (ch2 === "0") return ch1;else {
	    if (ch1 === "0") {
	      if (ch2 === "-1") ch2 = "-";else if (ch2 === "1") ch2 = "";
	      return ch2 + " i";
	    } else {
	      if (ch2 === "1") return ch1 + " + i";else {
	        if (ch2 === "-1") ch2 = "-";
	        if (ch2.charAt(0) === '-') return ch1 + " - " + ch2.substring(1) + " i";else return ch1 + " + " + ch2 + " i";
	      }
	    }
	  }
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by yvesb on 12/12/2016.
	 */
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @version 5.1.2
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Opef = __webpack_require__(19);
	var Opef2v = __webpack_require__(20);
	var Opef3v = __webpack_require__(21);
	var Opef4v = __webpack_require__(22);
	var Opef5v = __webpack_require__(23);
	var Ope = __webpack_require__(32);
	
	var CCbGlob = {
	  nombreMaxiIterations: 200000, // Nombre maxi d'itérations total dans les boucles
	  nombreSubdivisionsPourSimpson: 200, // Pour calcul intégrale par Simpson
	  nombreMaxParentheses: 64, // Nombre maxi de parenthèses imbriquées
	  // Constantes définissant les opérations de base
	  Nombre: 0,
	  Addition: 1,
	  Multiplication: 2,
	  Puissance: 3,
	  Fonction: 4,
	  Valeur: 5,
	  ParOuvrante: 6,
	  ParFermante: 7,
	  // CCb.Inferieur = 8; // Inutile
	  Inegalite: 9,
	  Blanc: 10,
	  Carre: 11,
	  Virgule: 12,
	  // Constantes ajoutées version 4.6 pour éviter des appels à getClass
	  // Ces constantes définissent mes natures des objets de type CCb
	  natAppelFonction: 1,
	  natAppelFonctionInterne: 1 << 1,
	  natAppelFonctionInterneNVar: 1 << 2,
	  natAppelFonctionNVar: 1 << 3,
	  natConstante: 1 << 4,
	  natConstantei: 1 << 5,
	  natFonction: 1 << 6,
	  natFonction2Var: 1 << 7,
	  natFonction3Var: 1 << 8,
	  natIntegraleDansFormule: 1 << 9,
	  natMoinsUnaire: 1 << 10,
	  natOperation: 1 << 11,
	  // natPointeurFonction	:	1 << 12, Supprimé version mtgApp. Inutile
	  natPuissance: 1 << 13,
	  natResultatValeur: 1 << 14,
	  natResultatValeurComplexe: 1 << 15,
	  natSommeDansFormule: 1 << 16,
	  natProduitDansFormule: 1 << 17,
	  natVariableFormelle: 1 << 18,
	
	  //
	  /**
	   * Fonction appelée dans le cas ou pRecherche est l'indice dans chaine d'une
	   * parenthèse fermante et renvoyant l'indice de la parenthèse
	   * ouvrante correspondante. La recherche se fait donc de la fin de la chapine vers le début.
	   * Elle ne doit être appelée que si pdebut<=pRecherche et si pRecherche pointe sur une
	   * parenthèse fermante et si la syntaxe est correcte au point de vue parenthèses.
	   * @param {String} chaine : La chaîne dans laquelle se fait la recherche
	   * @param {Integer} pdebut : L'indice d'arrêt de la recherhce dans la chaîne..
	   * @param {type} pRecherche : L'indice de début de recherche dans la chaîne qui doit
	   * être l'indice d'une parenthèse fermante.
	   * @returns {Number}
	   */
	  parentheseOuvrante: function parentheseOuvrante(chaine, pdebut, pRecherche) {
	    var p;
	    var ch;
	    var somme;
	
	    somme = 0;
	    p = pRecherche;
	    do {
	      ch = chaine.charAt(p);
	      if (ch === ')') somme--;else {
	        if (ch === '(') somme++;
	      }
	      p = p - 1;
	    } while (somme !== 0 && p >= pdebut);
	    return p + 1;
	  },
	  /**
	   * Fonction appelée dans le cas ou pDebut est l'indice dans chaine d'une
	   * parenthèse ouvrante et renvoyant l'indice de la parenthèse
	   * fermante correspondante.
	   * @param {String} chaine : La chaîne dans laquelle se fait la recherche
	   * @param {Integer} pdebut : l'indice de début de la racherche dans la chaîne.
	   * @returns {Integer}
	   */
	  parentheseFermante: function parentheseFermante(chaine, pdebut) {
	    var p;
	    var ch;
	    var somme;
	
	    somme = 1;
	    p = pdebut + 1;
	    while (p < chaine.length) {
	      ch = chaine.charAt(p);
	      if (ch === '(') somme++;else {
	        if (ch === ')') somme--;
	      }
	      if (somme === 0) break;
	      p++;
	    }
	    if (somme === 0) return p;else return -1; // On renvoie -1 si pas trouvé
	  },
	  /**
	   * Fonction renvoyant l'indice de la parenthèse fermante correspondant à une
	   * virgule. Avant appel pDebut pointe sur le caractère suivant la virgule.
	   * La chaîne doit être correcte sur le plan syntaxique acant appel
	   * @param {String} chaine : La chaîne dans laquelle se fait la recherche
	   * @param {Integer} pDebut : Indice du début de la recherche.
	   * @returns {Integer}
	   */
	  parentheseFermanteApresVirgule: function parentheseFermanteApresVirgule(chaine, pDebut) {
	    var car;
	    var somme = 1;
	    var i;
	    for (i = pDebut; i < chaine.length; i++) {
	      car = chaine.charAt(i);
	      if (car === '(') somme++;else if (car === ')') {
	        somme--;
	        if (somme === 0) return i;
	      }
	    }
	    return i; // Pour satisfaire le compilateur mais on ne doit pas arriver ici
	  },
	  /**
	   * Fonction renvoyant l'indice dans la chaîne ch du caractère suivant la virgule n° i
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche
	   * @param {Integer} inddeb : L'indice dans la chaîne du début de la recherche
	   * @param {Integer} virg : L'indice de la virguel recherchée.
	   * @returns {Integer}
	   */
	  indiceCaractereVirgule: function indiceCaractereVirgule(ch, inddeb, virg) {
	    var i = inddeb;
	    var nbvirg = 0;
	    if (virg === 0 || i > ch.length) return ch.length - 1;
	    var parentheses = 1;
	    while (i < ch.length && parentheses >= 1 && nbvirg <= virg) {
	      var car = ch.charAt(i);
	      if (car === '(') parentheses++;
	      if (car === ')') parentheses--;
	      if (car === ',' && parentheses === 1) nbvirg++;
	      i++;
	    }
	    return i;
	  },
	  /**
	   * Fonction renvoyant l'indice du premier caractère dans ch étant un opérateur logique & ou |
	   * Renvoie dans retour.x l'indice du caractère précédent l'opérateur logique
	   * et dans retour.y l'opérateur associé à cette inégalité (Ope.Or ou Ope.And).
	   * La recherche se fait de la fin de la chaine vers le début en sautant les parenthèses.
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche.
	   * @param {Integer} pdeb : Indice du début de la recherche.
	   * @param {Integer} pfin : Indice de la fin de la recherche.
	   * @param {Object} retour. Voir ci-dessus.
	   * @returns {Integer} : -1 si n'a pas trouvé d'opérateur logique sinon son indice dans ch.
	   */
	  premierOperateurLogique: function premierOperateurLogique(ch, pdeb, pfin, retour) {
	    var ptch;
	    var car;
	    var resultat;
	
	    ptch = pfin;
	    do {
	      car = ch.charAt(ptch);
	      resultat = ptch;
	      if (car === ')') ptch = CCbGlob.parentheseOuvrante(ch, pdeb, ptch);
	      ptch = ptch - 1;
	    } while (ptch >= pdeb && car !== '|' && car !== '&');
	    switch (car) {
	      case '&':
	        retour.x = resultat - 1;
	        retour.y = Ope.And;
	        return resultat;
	      case '|':
	        retour.x = resultat - 1;
	        retour.y = Ope.Or;
	        return resultat;
	      default:
	        return -1;
	    } // switch car
	  },
	
	  /**
	   * Fonction renvoyant l'indice de la première virgule suivant une parenthèse
	   * ouvrante Avant appel pDebut pointe sur le caractère suivant la parenthèse
	   * ouvrante. La chaîne doit être correcte sur le plan syntaxique acant appel
	   */
	  /**
	   * Fonction appelée dans VerifieSyntaxe pour un appel de fonctions à plusieurs
	   * variables. Renvoie le nombre de virgules trouvées pour un appel de paramètre.
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche.
	   * @param {Integer} inddeb : L'inidce du début de la recherche dans ch.
	   * @returns {Integer} : -1 si indeb >= ch.length sinon renvoie le nombre de virgules trouvées.
	   */
	  NombreVirgules: function NombreVirgules(ch, inddeb) {
	    var i = inddeb;
	    var nbvirg = 0;
	    if (i >= ch.length) return -1;
	    var parentheses = 1;
	    while (i < ch.length && parentheses >= 1) {
	      var car = ch.charAt(i);
	      if (car === '(') parentheses++;
	      if (car === ')') parentheses--;
	      if (car === ',' && parentheses === 1) nbvirg++;
	      i++;
	    }
	    return nbvirg;
	  },
	  /**
	   * Fonction vérifiant si item peut être suivi de itemSuivant
	   * sur le plan syntaxique.
	   * @param {Integer} item : le type de calcul actuel
	   * @param {Integer} itemSuivant : Le type de calcul dont on teste s'il peut suivre item
	   * @returns {Boolean}
	   */
	  autorisationSyntaxe: function autorisationSyntaxe(item, itemSuivant) {
	    switch (item) {
	      case CCbGlob.Nombre:
	        switch (itemSuivant) {
	          case CCbGlob.Addition:
	          case CCbGlob.Multiplication:
	          case CCbGlob.Puissance:
	          case CCbGlob.Carre:
	          case CCbGlob.ParFermante:
	          case CCbGlob.Inegalite:
	          case CCbGlob.Blanc:
	          case CCbGlob.Virgule:
	            return true;
	          default:
	            return false;
	        }
	      case CCbGlob.Addition:
	      case CCbGlob.Multiplication:
	        switch (itemSuivant) {
	          case CCbGlob.Nombre:
	          case CCbGlob.ParOuvrante:
	          case CCbGlob.Valeur:
	          case CCbGlob.Fonction:
	          case CCbGlob.Blanc:
	            return true;
	          default:
	            return false;
	        }
	      case CCbGlob.Puissance:
	        switch (itemSuivant) {
	          case CCbGlob.Nombre:
	          case CCbGlob.Valeur:
	          case CCbGlob.ParOuvrante:
	          case CCbGlob.Fonction:
	          case CCbGlob.Blanc:
	            return true;
	          default:
	            return false;
	        }
	      case CCbGlob.Fonction:
	        switch (itemSuivant) {
	          case CCbGlob.ParOuvrante:
	          case CCbGlob.Blanc:
	            return true;
	          default:
	            return false;
	        }
	      case CCbGlob.Valeur:
	      case CCbGlob.Carre:
	        switch (itemSuivant) {
	          case CCbGlob.Addition:
	          case CCbGlob.Multiplication:
	          case CCbGlob.Puissance:
	          case CCbGlob.Carre:
	          case CCbGlob.ParFermante:
	          case CCbGlob.Inegalite:
	          case CCbGlob.Blanc:
	          case CCbGlob.Virgule:
	            return true;
	          default:
	            return false;
	        }
	      case CCbGlob.ParOuvrante:
	        switch (itemSuivant) {
	          case CCbGlob.Addition:
	          case CCbGlob.ParOuvrante:
	          case CCbGlob.Nombre:
	          case CCbGlob.Valeur:
	          case CCbGlob.Fonction:
	          case CCbGlob.Blanc:
	            return true;
	          default:
	            return false;
	        }
	      case CCbGlob.ParFermante:
	        switch (itemSuivant) {
	          case CCbGlob.ParFermante:
	          case CCbGlob.Addition:
	          case CCbGlob.Multiplication:
	          case CCbGlob.Puissance:
	          case CCbGlob.Carre:
	          case CCbGlob.Inegalite:
	          case CCbGlob.Blanc:
	          case CCbGlob.Virgule:
	            return true;
	          default:
	            return false;
	        }
	      case CCbGlob.Inegalite:
	        switch (itemSuivant) {
	          case CCbGlob.Addition:
	          case CCbGlob.Nombre:
	          case CCbGlob.ParOuvrante:
	          case CCbGlob.Valeur:
	          case CCbGlob.Fonction:
	          case CCbGlob.Blanc:
	            return true;
	          default:
	            return false;
	        }
	      case CCbGlob.Virgule:
	        switch (itemSuivant) {
	          case CCbGlob.Addition:
	          case CCbGlob.Nombre:
	          case CCbGlob.ParOuvrante:
	          case CCbGlob.Valeur:
	          case CCbGlob.Fonction:
	          case CCbGlob.Blanc:
	            return true;
	          default:
	            return false;
	        }
	      default:
	        return false; // / normalement inutile
	    } // switch Item
	  },
	
	  /**
	   * Fonction renvoyant l'indice du premier caractère dans ch étant un opérateur logique & ou |
	   * Renvoie dans retour.x l'indice du caractère précédent l'opérateur logique
	   * et dans retour.y l'opérateur associé à cette inégalité (Ope.Or ou Ope.And).
	   * La recherche se fait de la fin de la chaine vers le début en sautant les parenthèses.
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche.
	   * @param {Integer} pdeb : Indice du début de la recherche.
	   * @param {Integer} pfin : Indice de la fin de la recherche.
	   * @param {Object} retour. Voir ci-dessus.
	   * @returns {Integer} : -1 si n'a pas trouvé d'opérateur logique sinon son indice dans ch.
	   */
	  c: function c(ch, pdeb, pfin, retour) {
	    var ptch;
	    var car;
	    var resultat;
	
	    ptch = pfin;
	    do {
	      car = ch.charAt(ptch);
	      resultat = ptch;
	      if (car === ')') ptch = CCbGlob.parentheseOuvrante(ch, pdeb, ptch);
	      ptch = ptch - 1;
	    } while (ptch >= pdeb && car !== '|' && car !== '&');
	    switch (car) {
	      case '&':
	        retour.x = resultat - 1;
	        retour.y = Ope.And;
	        return resultat;
	      case '|':
	        retour.x = resultat - 1;
	        retour.y = Ope.Or;
	        return resultat;
	      default:
	        return -1;
	    } // switch car
	  },
	  /**
	   * Fonction renvoyant l'indice dans la chaine ch de la première inégalité
	   * rencontrée et -1 s'il n'y en a pas.
	   * Renvoie dans retour.x l'indice du caractère précédent l'inégalité
	   * et dans retour.y l'opérateur associé à cette inégalité (défini dans mtg32.COperateur)
	   * La recherche se fait de la fin de la chaine vers le début en sautant les parenthèses.
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche
	   * @param {Integer} pdeb : L'indice du début de la recherche dans ch.
	   * @param {Integer} pfin : L'indice de la fin de la recherche dans ch
	   * @param {x,y} retour : C ci-dessus.
	   * @returns {Integer} :-1 si n'a pas trouvé d'inégalité sinon son indice dans ch.
	   */
	  premiereInegalite: function premiereInegalite(ch, pdeb, pfin, retour) {
	    var ptch;
	    var car, carPrecedent;
	    var resultat;
	
	    ptch = pfin;
	    do {
	      car = ch.charAt(ptch);
	      resultat = ptch;
	      if (car === ')') ptch = CCbGlob.parentheseOuvrante(ch, pdeb, ptch);
	      ptch = ptch - 1;
	    } while (ptch >= pdeb && car !== '=' && car !== '>' && car !== '<');
	    switch (car) {
	      case '<':
	        retour.x = resultat - 1;
	        retour.y = Ope.Inf;
	        return resultat;
	      case '>':
	        retour.x = resultat - 1;
	        retour.y = Ope.Sup;
	        if (ptch > pdeb) {
	          ptch = resultat - 1;
	          carPrecedent = ch.charAt(ptch);
	          if (carPrecedent === '<') {
	            retour.x = ptch - 1;
	            retour.y = Ope.Diff;
	          }
	        }
	        return resultat;
	      case '=':
	        if (ptch >= pdeb) {
	          ptch = resultat - 1;
	          carPrecedent = ch.charAt(ptch);
	          switch (carPrecedent) {
	            case '<':
	              retour.x = ptch - 1;
	              retour.y = Ope.InfOuEgal;
	              return resultat;
	            case '>':
	              retour.x = ptch - 1;
	              retour.y = Ope.SupOuEgal;
	              return resultat;
	            default:
	              retour.x = ptch;
	              retour.y = Ope.Egalite;
	              return resultat;
	          } // switch CarPrecedent
	        }
	      default:
	        return -1;
	    } // switch car
	  },
	  /**
	   * Fonction renvoyant l'indice du premier caractère dans ch étant un + ou  un -
	   * La recherche se fait de la fin de la chaine vers le début en sautant les parenthèses.
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche.
	   * @param {Integer} pdeb : L'indice du début de la recherche dans ch.
	   * @param {Integer} pfin : L'indice de la fin de la recherche dans ch.
	   * @returns {Integer} : -1 si n'a pas trouvé de + ou - ou sinon l'indice du caractère.
	   */
	  premiereSomme: function premiereSomme(ch, pdeb, pfin) {
	    var ptch;
	    var car;
	    var resultat;
	
	    ptch = pfin;
	    do {
	      car = ch.charAt(ptch);
	      resultat = ptch;
	      if (car === ')') ptch = CCbGlob.parentheseOuvrante(ch, pdeb, ptch);
	      ptch--;
	    } while (ptch >= pdeb && car !== '+' && car !== '-');
	    if (car === '+' || car === '-') return resultat;else return -1;
	  },
	  /**
	   * Fonction renvoyant l'indice du premier caractère qui soit un * ou un / dans la chaîne ch.
	   * La recherche se fait de la fin de la chaine vers le début en sautant les parenthèses.
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche.
	   * @param {Integer} pdeb : L'indice du début de recherche dans ch.
	   * @param {type} pfin : L'indice de la fin de recherche dans ch.
	   * @returns {Integer} : -1 si aucun * ou / n'a été trouvé, sinon l'indice de premier carcatère trouvé.
	   */
	  premierProduit: function premierProduit(ch, pdeb, pfin) {
	    var ptch;
	    var car;
	    var resultat;
	
	    ptch = pfin;
	    do {
	      car = ch.charAt(ptch);
	      resultat = ptch;
	      if (car === ')') ptch = CCbGlob.parentheseOuvrante(ch, pdeb, ptch);
	      ptch--;
	    } while (ptch >= pdeb && car !== '*' && car !== '/');
	    if (car === '*' || car === '/') return resultat;else return -1;
	  },
	  /**
	   * Fonction renvoyantl'indice du premier signe ^ou ² renontré dans la chaîne ch.
	   * La recherche se fait de la fin de la chaine vers le début en sautant les parenthèses.
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche.
	   * @param {Integer} pdeb : L'indice du début de la recherche dans ch.
	   * @param {type} pfin : L'indice de la fin de la recherche dans ch.
	   * @returns {Integer} : -1 si n'a pas trouvé de ^ou  de ², sinon l'indice du caractère.
	   */
	  premierePuissance: function premierePuissance(ch, pdeb, pfin) {
	    var ptch;
	    var car;
	    var resultat;
	
	    ptch = pfin;
	    do {
	      car = ch.charAt(ptch);
	      resultat = ptch;
	      if (car === ')') ptch = CCbGlob.parentheseOuvrante(ch, pdeb, ptch);
	      ptch--;
	    } while (ptch >= pdeb && car !== '^' && car !== '²');
	    if (car === '^' || car === '²') return resultat;else return -1;
	  },
	  /**
	   * Fonction renvoyant l'indice de la première virgule suivant une parenthèse
	   * ouvrante dan la chaîne chaine.
	   * Avant appel pDebut pointe sur le caractère suivant la parenthèse ouvrante.
	   * @param {String} chaine : La chaîne dans laquelle se fait la recherche.
	   * @param {Integer} pDebut : L'indice de début de la recherche.
	   * @returns {Integer} : chaine.length si pas de virgule trouvée, sinon l'indice de la première virgule.
	   */
	  premiereVirgule: function premiereVirgule(chaine, pDebut) {
	    var car;
	    var somme = 1;
	    var i;
	    for (i = pDebut; i < chaine.length; i++) {
	      car = chaine.charAt(i);
	      if (car === '(') somme++;else if (car === ')') somme--;else if (car === ',' && somme === 1) return i;
	    }
	    return i; // Pour satisfaire le compilateur mais on ne doit pas arriver ici
	  },
	  /**
	   * Fonction élevant un nombre à la puissance n sans utiiser d'exponentielle
	   * mais avec un algorithme optimisé n'utilisant que des multiplications.
	   * @param {float} c1 : L'opérande
	   * @param {Integer} exposant : l'exposant (compris entre 1 et 255)
	   * @returns {Number} : Le résultat.
	   */
	  puisExpEnt: function puisExpEnt(c1, exposant) {
	    var tampon = c1;
	    var res = 1;
	    // Version n'utilisant que des décalages de bits pour optimisation
	    var b = 128;
	    var indfin = 7;
	    while ((b & exposant) === 0) {
	      indfin--;
	      b = b >> 1;
	    }
	    for (var i = 0; i <= indfin; i++) {
	      if (exposant % 2 !== 0) {
	        res = res * tampon;
	      }
	      exposant >>= 1;
	      tampon = tampon * tampon;
	    }
	    return res;
	  },
	  /**
	   * Fonction calculant le sinus de x en se ramenant à un opérande compris entre 0 et 2pi
	   * pour une meilleure précision.
	   * @param {Float} x
	   * @returns {Float} : Le résultat.
	   */
	  sinus: function sinus(x) {
	    return Math.sin(x - Math.floor(x / (2 * Math.PI)) * 2 * Math.PI);
	  },
	  /**
	   * Fonction calculant le cosinus de x en se ramenant à un opérande compris entre 0 et 2pi
	   * pour une meilleure précision.
	   * @param {Float} x
	   * @returns {Float} : Le résultat.
	   */
	  cosinus: function cosinus(x) {
	    return Math.cos(x - Math.floor(x / (2 * Math.PI)) * 2 * Math.PI);
	  },
	  /**
	   * Fonction calculant la tangente de x en se ramenant à un opérande compris entre 0 et 2pi
	   * pour une meilleure précision.
	   * @param {Float} x
	   * @returns {Float} : Le résultat.
	   */
	  tangente: function tangente(x) {
	    return Math.tan(x - Math.floor(x / (2 * Math.PI)) * 2 * Math.PI);
	  },
	  /**
	   * Calcul d'une intégrale par la méthode de Simpson.
	   * @param {CCb} f : un Ccb représentant une fonction de n variables, la
	   * dernière étant la variable d'intégration.
	   * @param {type} va : un tableau représentant les paramètres passés à la fonction
	   * (le dernier sera en fait affecté dans la fonction).
	   * @param {type} a : la borne inférieure d'intégration.
	   * @param {type} b : la borne supérieure d'intégration.
	   * @param {Boolean} infoRandom : true si les caclusl aléatoires avec rand
	   * doivent être réactualisés.
	   * @returns {Number} : Le résultat arrpoché de l'intégrale.
	   */
	  integrale: function integrale(f, va, a, b, infoRandom) {
	    var s1, s2, s;
	    var t1, t2, pas;
	    var n = va.length;
	    var k;
	    if (a === b) return 0;
	    var nb = CCbGlob.nombreSubdivisionsPourSimpson; // Le nombre de subdivisions
	    pas = (b - a) / nb;
	    s = f.resultatFonction(infoRandom, a) + f.resultatFonction(infoRandom, b);
	    t1 = a;
	    t2 = a - pas / 2;
	    s1 = 0;
	    s2 = 0;
	    for (k = 1; k < nb; k++) {
	      t1 = t1 + pas;
	      va[n - 1] = t1;
	      s1 = s1 + f.resultatFonction(infoRandom, va);
	    }
	    for (k = 1; k <= nb; k++) {
	      t2 = t2 + pas;
	      va[n - 1] = t2;
	      s2 = s2 + f.resultatFonction(infoRandom, va);
	    }
	    return (b - a) * (s + 2 * s1 + 4 * s2) / (6 * nb);
	  },
	  /**
	   * Fonction recherchant si la chaîne ch commence par le nom d'une fonction réelle
	   * prédéfinie.
	   * Si oui, renvoie la longeur du nom de la fonction,  résultat.getValeur() renvoie l'indice
	   * du nom de la fonction dans le tableau définissant les noms de fonctions et
	   * combreVariables.getValeur() renvoie le nombre de variabels de la fonction.
	   * @param {String} ch : La chaîne à analyser.
	   * @param {Integer} resultat : La longueur du nom de la fonction si un nom a été trouvé
	   * sinon 0.
	   * @param {Integer} nombreVariables : Le nombre de vraiables de la fonction si une fonction a été trouvée.
	   * @returns {Integer} : La longueur du nom de la fonction si une fonction a été trouvée.
	   */
	  commenceParNomFonctionReellePredefinie: function commenceParNomFonctionReellePredefinie(ch, resultat, nombreVariables) {
	    var longueurNom = 0;
	    var i;
	    for (i = 0; i < Opef.nomsFoncs.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef.nomsFonctions(i).toLowerCase() + "(") === 0) {
	        if (Opef.nomsFonctions(i).length > longueurNom) {
	          nombreVariables.setValue(1);
	          resultat.setValue(i);
	          longueurNom = Opef.nomsFonctions(i).length;
	        }
	      }
	    }
	    for (i = 0; i < Opef2v.nomsFoncs2Var.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef2v.nomsFonctions2Var(i).toLowerCase() + "(") === 0) {
	        if (Opef2v.nomsFonctions2Var(i).length > longueurNom) {
	          nombreVariables.setValue(2);
	          resultat.setValue(i);
	          longueurNom = Opef2v.nomsFonctions2Var(i).length;
	        }
	      }
	    }
	    for (i = 0; i < Opef3v.nomsFoncs3Var.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef3v.nomsFonctions3Var(i).toLowerCase() + "(") === 0) {
	        if (Opef3v.nomsFonctions3Var(i).length > longueurNom) {
	          nombreVariables.setValue(3);
	          resultat.setValue(i);
	          longueurNom = Opef3v.nomsFonctions3Var(i).length;
	        }
	      }
	    }
	    for (i = 0; i < Opef4v.nomsFoncs4Var.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef4v.nomsFonctions4Var(i).toLowerCase() + "(") === 0) {
	        if (Opef4v.nomsFonctions4Var(i).length > longueurNom) {
	          nombreVariables.setValue(4);
	          resultat.setValue(i);
	          longueurNom = Opef4v.nomsFonctions4Var(i).length;
	        }
	      }
	    }
	    for (i = 0; i < Opef5v.nomsFoncs5Var.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef5v.nomsFonctions5Var(i).toLowerCase() + "(") === 0) {
	        if (Opef5v.nomsFonctions5Var(i).length > longueurNom) {
	          nombreVariables.setValue(5);
	          resultat.setValue(i);
	          longueurNom = Opef5v.nomsFonctions5Var(i).length;
	        }
	      }
	    }
	    return longueurNom;
	  },
	  /**
	   * Fonction recherchant si la chaîne ch commence par le nom d'une fonction complexe
	   * prédéfinie.
	   * Si oui, renvoie la longeur du nom de la fonction,  résultat.getValeur() renvoie l'indice
	   * du nom de la fonction dans le tableau définissant les noms de fonctions et
	   * combreVariables.getValeur() renvoie le nombre de variabels de la fonction.
	   * @param {String} ch : La chaîne à analyser.
	   * @param {Integer} resultat : La longueur du nom de la fonction si un nom a été trouvé
	   * sinon 0.
	   * @param {Integer} nombreVariables : Le nombre de vraiables de la fonction si une fonction a été trouvée.
	   * @returns {Integer} : La longueur du nom de la fonction si une fonction a été trouvée.
	   */
	  commenceParNomFonctionComplexePredefinie: function commenceParNomFonctionComplexePredefinie(ch, resultat, nombreVariables) {
	    var longueurNom = 0;
	    var i;
	    for (i = 0; i < Opef.nomsFoncsComplexes.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef.nomsFonctionsComplexes(i).toLowerCase() + "(") === 0) {
	        if (Opef.nomsFonctionsComplexes(i).length > longueurNom) {
	          nombreVariables.setValue(1);
	          resultat.setValue(i + Opef.indPremiereFoncComplexe);
	          longueurNom = Opef.nomsFonctionsComplexes(i).length;
	        }
	      }
	    }
	    for (i = 0; i < Opef2v.nomsFonctionsComplexes2Var.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef2v.nomsFonctionsComplexes2Var(i).toLowerCase() + "(") === 0) {
	        if (Opef2v.nomsFonctionsComplexes2Var(i).length > longueurNom) {
	          nombreVariables.setValue(2);
	          resultat.setValue(i + Opef2v.indicePremiereFonctionComplexe);
	          longueurNom = Opef2v.nomsFonctionsComplexes2Var(i).length;
	        }
	      }
	    }
	    for (i = 0; i < Opef3v.nomsFoncsComplexes3Var.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef3v.nomsFonctionsComplexes3Var(i).toLowerCase() + "(") === 0) {
	        if (Opef3v.nomsFonctionsComplexes3Var(i).length > longueurNom) {
	          nombreVariables.setValue(3);
	          resultat.setValue(i + Opef3v.indicePremiereFonctionComplexe);
	          longueurNom = Opef3v.nomsFonctionsComplexes3Var(i).length;
	        }
	      }
	    }
	    for (i = 0; i < Opef4v.nomsFoncsComplexes4Var.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef4v.nomsFonctionsComplexes4Var(i).toLowerCase() + "(") === 0) {
	        if (Opef4v.nomsFonctionsComplexes4Var(i).length > longueurNom) {
	          nombreVariables.setValue(4);
	          resultat.setValue(i + Opef4v.indicePremiereFonctionComplexe);
	          longueurNom = Opef4v.nomsFonctionsComplexes4Var(i).length;
	        }
	      }
	    }
	    for (i = 0; i < Opef5v.nomsFonctionsComplexes5Var.length; i++) {
	      if (ch.toLowerCase().indexOf(Opef5v.nomsFonctionsComplexes5Var(i).toLowerCase() + "(") === 0) {
	        if (Opef5v.nomsFonctionsComplexes5Var(i).length > longueurNom) {
	          nombreVariables.setValue(5);
	          resultat.setValue(i + Opef5v.indicePremiereFonctionComplexe);
	          longueurNom = Opef5v.nomsFonctionsComplexes5Var(i).length;
	        }
	      }
	    }
	    return longueurNom;
	  },
	  /**
	   * Fonction renvoyant true si chaine est le nom d'une fonction réelle
	   * @param {String} chaine
	   * @returns {Boolean}
	   */
	  egalNomFonctionReellePredefinie: function egalNomFonctionReellePredefinie(chaine) {
	    var i = 0;
	    while (i < Opef.nomsFoncs.length) {
	      if (chaine.toLowerCase() === Opef.nomsFonctions(i).toLowerCase()) return true;
	      i++;
	    }
	    i = 0;
	    while (i < Opef2v.nomsFoncs2Var.length) {
	      if (chaine.toLowerCase() === Opef2v.nomsFonctions2Var(i).toLowerCase()) return true;
	      i++;
	    }
	    i = 0;
	    while (i < Opef3v.nomsFoncs3Var.length) {
	      if (chaine.toLowerCase() === Opef3v.nomsFonctions3Var(i).toLowerCase()) return true;
	      i++;
	    }
	    i = 0;
	    while (i < Opef4v.nomsFoncs4Var.length) {
	      if (chaine.toLowerCase() === Opef4v.nomsFonctions4Var(i).toLowerCase()) return true;
	      i++;
	    }
	    i = 0;
	    while (i < Opef5v.nomsFoncs5Var.length) {
	      if (chaine.toLowerCase() === Opef5v.nomsFonctions5Var(i).toLowerCase()) return true;
	      i++;
	    }
	    return false;
	  },
	  /**
	   * Fonction renvoyant true si chaine est le nom d'une fonction complexe
	   * prédéfinie
	   * @param {type} chaine
	   * @returns {Boolean}
	   */
	  egalNomFonctionComplexePredefinie: function egalNomFonctionComplexePredefinie(chaine) {
	    var i = 0;
	    while (i < Opef.nomsFoncsComplexes.length) {
	      if (chaine.toLowerCase() === Opef.nomsFonctionsComplexes(i).toLowerCase()) return true;
	      i++;
	    }
	    i = 0;
	    while (i < Opef2v.nomsFoncs2Var.length) {
	      if (chaine.toLowerCase() === Opef2v.nomsFonctionsComplexes2Var(i).toLowerCase()) return true;
	      i++;
	    }
	    i = 0;
	    while (i < Opef3v.nomsFoncsComplexes3Var.length) {
	      if (chaine.toLowerCase() === Opef3v.nomsFonctionsComplexes3Var(i).toLowerCase()) return true;
	      i++;
	    }
	    i = 0;
	    while (i < Opef4v.nomsFoncsComplexes4Var.length) {
	      if (chaine.toLowerCase() === Opef4v.nomsFonctionsComplexes4Var(i).toLowerCase()) return true;
	      i++;
	    }
	    while (i < Opef5v.nomsFonctionsComplexes5Var.length) {
	      if (chaine.toLowerCase() === Opef5v.nomsFonctionsComplexes5Var(i).toLowerCase()) return true;
	      i++;
	    }
	    return false;
	  },
	  /**
	   * Fonction renvoyant true si chaine est le nom d'une fonction réelle ou
	   * complexe prédéfinie
	   * @param {String} chaine
	   * @returns {Boolean}
	   */
	  egalNomFonctionReelleOuComplexePredefinie: function egalNomFonctionReelleOuComplexePredefinie(chaine) {
	    return CCbGlob.egalNomFonctionReellePredefinie(chaine) || CCbGlob.egalNomFonctionComplexePredefinie(chaine);
	  }
	
	};
	
	module.exports = CCbGlob;

/***/ },
/* 32 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Classe définissant les natures des opérations utilisés par le logiciel.
	 * @type Ope
	 */
	var Ope = {
	  Plus: 0,
	  Moin: 1,
	  Mult: 2,
	  Divi: 3,
	  Inf: 4,
	  Sup: 5,
	  InfOuEgal: 6,
	  SupOuEgal: 7,
	  Egalite: 8,
	  Diff: 9,
	  And: 10,
	  Or: 11,
	  /**
	   * Renvoie true si l'opérateur est un opérateur de test
	   * @param {Integer} val
	   * @returns {Boolean}
	   */
	  estTest: function estTest(val) {
	    return val === Ope.Inf || val === Ope.Sup || val === Ope.InfOuEgal || val === Ope.SupOuEgal || val === Ope.Egalite || val === Ope.Diff || val === Ope.And || val === Ope.Or;
	  },
	  /**
	   * Renvoie la chaîne de caractères représentant l'opérateur.
	   * @param {Integer} val
	   * @returns {String}
	   */
	  chaineOperateur: function chaineOperateur(val) {
	    switch (val) {
	      case Ope.Plus:
	        return "+";
	      case Ope.Moin:
	        return "-";
	      case Ope.Mult:
	        return "*";
	      case Ope.Divi:
	        return "/";
	      case Ope.Inf:
	        return "<";
	      case Ope.Sup:
	        return ">";
	      case Ope.InfOuEgal:
	        return "<=";
	      case Ope.SupOuEgal:
	        return ">=";
	      case Ope.Egalite:
	        return "=";
	      case Ope.Diff:
	        return "<>";
	      case Ope.And:
	        return "&";
	      case Ope.Or:
	        return "|";
	      default:
	        return "";
	    }
	  },
	  /**
	   * Renvoie la chaîne de caractères représentant l'opérateur en LaTeX.
	   * @param {Integer} val
	   * @returns {String}
	   */
	  chaineOperateurLatex: function chaineOperateurLatex(val) {
	    switch (val) {
	      case Ope.InfOuEgal:
	        return "\\le ";
	      case Ope.SupOuEgal:
	        return "\\ge ";
	      case Ope.Diff:
	        return "\\ne ";
	      case Ope.And:
	        return "\\,\\&";
	      case Ope.Or:
	        return "\\,|";
	
	      default:
	        return Ope.chaineOperateur(val);
	    }
	  }
	};
	
	module.exports = Ope;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var COb = __webpack_require__(34);
	module.exports = CElementBase;
	
	/**
	 * Objet ancetre de tous les objets d'une figure, graphiques ou numériques.
	 * @constructor
	 * @extends COb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire
	 * @param {CImplementationProto} impProto : La construction propriétaire de l'objet (peut-être nnull)
	 * @param {boolean} estElementFinal : true si l'objet est un élément final de construction
	 * @returns {undefined}
	 */
	function CElementBase(listeProprietaire, impProto, estElementFinal) {
	  if (arguments.length === 0) return; // Ajout version WebPack
	  COb.call(this, listeProprietaire);
	  if (arguments.length !== 1) {
	    this.impProto = impProto;
	    this.estElementFinal = estElementFinal;
	  } else {
	    this.impProto = null;
	    this.estElementFinal = false;
	  }
	  // Eléments utilisés par certains descendants
	  this.elementGeneriqueAssocie = null;
	  this.dependDeElementTeste = false;
	  this.elementTestePourDependDe = null;
	  this.elementTestePourDependDePourRec = null;
	  this.index = -1;
	}
	CElementBase.prototype = new COb();
	CElementBase.prototype.constructor = CElementBase;
	CElementBase.prototype.superClass = "COb";
	CElementBase.prototype.className = "CElementBase";
	
	/**
	 * Fonction renvoyant la nature graphique de l'objet du type NatObj
	 * @returns {NatObj.NAucunObjet}
	 */
	CElementBase.prototype.getNature = function () {
	  return NatObj.NAucunObjet;
	};
	/**
	 * Fonction renvoyant la nature de calcul de l'objet du type NatCal
	 * @returns {NatCal.NAucunCalcul}
	 */
	CElementBase.prototype.getNatureCalcul = function () {
	  return NatCal.NAucunCalcul;
	};
	/**
	 * Fonction renvoyant true si la nature graphique de l'objet est d'un des
	 * types spécifiés dans nat (obtenu par l'opérateur | à partir de plusieurs
	 * long spécifiant une nature graphique
	 * @param {Nat} nat
	 * @returns {Boolean}
	 */
	CElementBase.prototype.estDeNature = function (nat) {
	  return this.getNature().isOfNature(nat);
	};
	/**
	 * Fonction renvoyant true si la nature calcul de l'objet est d'un des
	 * types spécifiés dans nat (obtenu par l'opérateur | à partir de plusieurs
	 * long spécifiant une nature graphique
	 * @param {Nat} nat
	 * @returns {Boolean}
	 */
	CElementBase.prototype.estDeNatureCalcul = function (nat) {
	  return this.getNatureCalcul().isOfNature(nat);
	};
	/**
	 * Ajout pour la version java. Pour une valeur numérique renverra la chaîne la
	 * représentant et pour un repère la chaîne le représentant (par exemple "(O,I,J)")
	 * A redéfinir pour ces objets
	 * @returns {String}
	 */
	CElementBase.prototype.getNom = function () {
	  return "";
	};
	/**
	 * Fonction chargée de mettre à jour l'objet quand un
	 * élément dont il dépend a été modifié. Devra être appelé par les lieux de
	 * points et lieux d'objets pour remettre à jour les liste qu'ils utilisent de
	 * façon interne. A redéfinir pour ces objets
	 * @returns {undefined}
	 */
	CElementBase.prototype.metAJour = function () {};
	/**
	 * Fonction ajoutant à liste les éléments qui ont généré l'objet. A redéfinir
	 * pour les descendants. Par exemple pour une droite passant par deux points,
	 * ajoutera à la liste un pointeur sur ces deux points.
	 * @param {CListeObjets} liste
	 * @returns {undefined}
	 */
	CElementBase.prototype.ajouteAntecedents = function (liste) {};
	/**
	 * Fonction servant à créer un clone de tout objet dans une autre liste
	 * A redéfinir pour les descendants.
	 * @param {CListeObjets} listeSource : La liste propriétaire de l'objet à cloner
	 * @param {CListeObjets} listeCible : La liste dans laquelle sera créé l'objet cloné
	 * @returns {CElementBase}
	 */
	CElementBase.prototype.getClone = function (listeSource, listeCible) {
	  return null;
	};
	/**
	 * Fonction servant à cloner l'état d'un objet identique au lieu de le
	 * positionner. Utilisé pour les lieux d'objets. Doit appeler la méthode
	 * de l'objet ancêtre au début.
	 * @param {CElementBase} ptel
	 * @returns {undefined}
	 */
	CElementBase.prototype.setClone = function (ptel) {
	  this.existe = ptel.existe;
	};
	/**
	 * Fonction calculant l'élément pour le positionner dans la figure.
	 * Doit en général appeler la méthode de l'objet ancêtre.
	 * @param {Boolean} infoRandom : true si les calculs aléatoires doivent être relancés
	 * @param {Dimf} dimfen : Dimensions du svg dans lequel la figure est dessinée
	 * @returns {undefined}
	 */
	CElementBase.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = true;
	};
	/**
	 * Fonction recalculant entièrement l'élément, y compris poue les dérivées et tests d'équivalences de formules et autres objets
	 * @param {boolean} infoRandom :
	 * @param mtg32.Dimf dimfen
	 * @returns {undefined}
	 */
	CElementBase.prototype.positionneFull = function (infoRandom, dimfen) {
	  this.positionne(infoRandom, dimfen);
	};
	/**
	 * Fonction initialisant la propriété servant à déterminer la recherche de dépendance
	 * @returns {undefined}
	 */
	CElementBase.prototype.initialisePourDependance = function () {
	  this.elementTestePourDependDe = null;
	};
	/**
	 * Fonction servant à mémoriser une dépendance d'objet
	 * @param {Boolean} resultat
	 * @returns {Boolean}
	 */
	CElementBase.prototype.memoriseDependance = function (resultat) {
	  this.dependDeElementTeste = resultat;
	  return resultat;
	};
	/**
	 * Fonction renvoyant true si this dépend de p
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CElementBase.prototype.dependDe = function (p) {
	  // Ajout version 3.4.2
	  this.elementTestePourDependDe = p;
	  var res = false;
	  // Modifié pour la version 2.5 pour qu'un objet final ou intermédiaire
	  // d'une implémentation de prototype dépende de cette implémentation
	  if (this.impProto !== null) {
	    if (this.impProto === p) res = true;
	  }
	  res = res || p === this;
	  return res;
	};
	/**
	 * Fonction renvoyant le même résultat que dependDe sauf pour certains objets
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CElementBase.prototype.dependDePourBoucle = function (p) {
	  return p === this;
	};
	/**
	 * Fonction renvoyant le même résultat que dependDe sauf pour certains objets
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CElementBase.prototype.dependDePourCapture = function (p) {
	  return this.dependDe(p);
	};
	/**
	 * Fonction renvoyant true si l'objet pointé par p est confondu avec this.
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CElementBase.prototype.confonduAvec = function (p) {
	  return this === p;
	};
	/**
	 * Fonction replaçant un pointeur sur un point par un autre point.
	 * Utilisée entre autres dans le reclassement d'objets.
	 * A redéfinir pour chacun des descendants maintenant un pointeur sur un point.
	 * @param {CPt} ancienPoint
	 * @param {CPt} nouveauPoint
	 * @returns {undefined}
	 */
	CElementBase.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {};
	/**
	 * Fonction renvoyant true si l'objet est un objet intermédiaire de construction
	 * @returns {Boolean}
	 */
	CElementBase.prototype.estElementIntermediaire = function () {
	  return !this.estElementFinal && this.impProto !== null;
	};
	/**
	 * Fonction qui renverra true si l'objet nécessite que el soit nommé
	 * @param {CElementGraphique} el
	 * @returns {Boolean}
	 */
	CElementBase.prototype.nomIndispensable = function (el) {
	  return false;
	};
	
	/**
	 * Renvoie true si un élément est capturable à la souris.
	 * Sera redéfini pour les lieux d'objets générés par un CCommentaire ou un CLatex de façon à ce que
	 * l'outil de capture permette de faire glisser un tel lieu en faisant glisser le CCommentaire ou
	 * le CLatex qui l'a généré.
	 * @returns {Boolean}
	 */
	CElementBase.prototype.estCapturableSouris = function () {
	  return true;
	};
	/**
	 * Fonction créant le composant CComponent instancié par l'objet
	 * Redéfini pour CEditeurFormule
	 * @returns {undefined}
	 */
	CElementBase.prototype.createComponent = function () {};
	/**
	 * Fonction retirant le composant CComponent instancié par l'objet
	 * Redéfini pour CEditeurFormule
	 * @returns {undefined}
	 */
	CElementBase.prototype.deleteComponent = function () {};
	/**
	 * Lecture de l'objet dans le flux
	 */
	/**
	 * Fonction lisant l'objet dans le flux de données binaires.
	 * Devra être appelée par tous les descendants.
	 * @param {DataInputStream} inps
	 * @param {CListeObjets} list : La liste propriétaire de tous les obejts en cours de génération
	 * @returns {undefined}
	 */
	CElementBase.prototype.read = function (inps, list) {
	  COb.prototype.read.call(this, inps, list);
	  this.estElementFinal = inps.readBoolean();
	  var ind1 = inps.readInt();
	  this.impProto = list.get(ind1);
	};
	/**
	 * Fonction enregistrant l'objet dans le flux de données binaires.
	 * Devra être appelée par tous les descendants.
	 * @param {DataOutputStream} oups
	 * @param {CListeObjets} list
	 * @returns {undefined}
	 */
	CElementBase.prototype.write = function (oups, list) {
	  oups.writeBoolean(this.estElementFinal);
	  var ind1;
	  if (this.impProto === null) ind1 = -1;else ind1 = list.indexOf(this.impProto);
	  oups.writeInt(ind1);
	};
	/**
	 * Fonction qui sera redéfinie pour CLaTeX et CLieuObjetAncetre
	 * Met sur la pile MathJax.hub.Queue de MathJax une fonction de callback qui demande à
	 * MathJax de préparer un affichage graphique pour ensuite récupérer son svg
	 * @returns {undefined}
	 */
	CElementBase.prototype.setReady4MathJax = function () {};
	/**
	 * Fonction qui sera redéfinie pour CLaTeX et CLieuObjetAncetre
	 * Met sur la pile MathJax.hub.Queue de MathJax une fonction de callback qui demande à
	 * MathJax de préparer un affichage graphique pour ensuite récupérer son svg
	 * @returns {undefined}
	 */
	CElementBase.prototype.setReady4MathJaxUpdate = function () {};

/***/ },
/* 34 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	module.exports = COb;
	/**
	 * Objet de base de MathGraph32. Contient un numéro de version
	 * Les classes hériteront toutes de COb et devront redéfinir numeroVersion
	 * dans leur protoype si elles utilisent un numéro de version différent
	 * @constructor
	 * @param {CListeObjets} listeProprietaire
	 * @returns {undefined}
	 */
	function COb(listeProprietaire) {
	  if (arguments.length === 0) return; // Ajout version WebPack
	  this.nVersion = this.numeroVersion();
	  this.listeProprietaire = listeProprietaire;
	}
	/**
	 * Fonction renvoyant le numéro de version de l'objet en accord avec la version Java
	 * @returns {Number}
	 */
	COb.prototype.numeroVersion = function () {
	  return 1;
	};
	/**
	 * Fonction lisant l'objet dans le flux binaire inps
	 * A redéfinir pour les descendants
	 * @param {DataInputStream} inps
	 * @param {CListeObjets} list
	 * @returns {undefined}
	 */
	COb.prototype.read = function (inps, list) {
	  this.listeProprietaire = list;
	};
	// Ne fait rien mais gardé quand même pour compatibilit java
	/**
	 * Fonction enregistrant l'objet dans le flux binaire oups
	 * A redéfinir pour les descendants
	 * @param {DataOutputStream} oups
	 * @param {CListeObjets} list
	 * @returns {undefined}
	 */
	COb.prototype.write = function (oups, list) {};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var CValDyn = __webpack_require__(29);
	
	module.exports = CCalculAncetre;
	
	/**
	 * @constructor
	 * @extends CValDyn
	 * Classe ancêtre de tous les objets de type calcul
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou pointeur sur la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément finla de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @returns {undefined}
	 */
	function CCalculAncetre(listeProprietaire, impProto, estElementFinal, nomCalcul) {
	  if (arguments.length === 0) CValDyn.call(this); // Ajout version WebPack
	  else {
	      if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else CValDyn.call(this, listeProprietaire, impProto, estElementFinal);
	      if (arguments.length >= 4) this.nomCalcul = nomCalcul;
	    }
	}
	CCalculAncetre.prototype = new CValDyn();
	CCalculAncetre.prototype.constructor = CCalculAncetre;
	CCalculAncetre.prototype.superClass = "CValDyn";
	CCalculAncetre.prototype.className = "CCalculAncetre";
	
	/**
	 * Renvoie le nom du calcul
	 * @returns {String}
	 */
	CCalculAncetre.prototype.getNom = function () {
	  return this.nomCalcul;
	};
	/**
	 * Donne un nom au calcul
	 * @param {String} nouveauNom
	 * @returns {undefined}
	 */
	CCalculAncetre.prototype.donneNom = function (nouveauNom) {
	  this.nomCalcul = nouveauNom;
	};
	/**
	 * Nombre de variables dans le cas d'une fonction, 0 sinon
	 * @returns {Number}
	 */
	CCalculAncetre.prototype.nombreVariables = function () {
	  return 0;
	};
	// A revoir javascript : sans doute inutile
	/**
	 * Dans le cas d'une fonction, renvoie l'image de parametre par la fonction
	 * @param {Boolean} infoRandom : si true les calculs aléatoires par rand sont relancés
	 * @param {type} parametre
	 * @returns {Number}
	 */
	CCalculAncetre.prototype.rendValeurFonction = function (infoRandom, parametre) {
	  return this.rendValeur();
	};
	// A revoir javascript : sans doute inutile
	/**
	 * Dans le cas d'une fonction, renvoie l'image de parametre par la fonction
	 * @param {Boolean} infoRandom : si true les calculs aléatoires par rand sont relancés
	 * @param {Array} parametre :  Tableau contenant le nom des paramètres.
	 * @param {Complexe} zRes : Contient le résultat de f(parametre)
	 * @returns {undefined}
	 */
	CCalculAncetre.prototype.rendValeurFonctionComplexe = function (infoRandom, parametre, zRes) {};
	
	CCalculAncetre.prototype.read = function (inps, list) {
	  CValDyn.prototype.read.call(this, inps, list);
	  this.nomCalcul = inps.readUTF();
	};
	
	CCalculAncetre.prototype.write = function (oups, list) {
	  CValDyn.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.nomCalcul);
	};
	/**
	 * Spécial JavaScript
	 * Renvoie la valeur du calcul
	 * @returns {Number}
	 */
	CCalculAncetre.prototype.valeur = function () {
	  return this.rendValeur();
	};
	/**
	 * Spécial JavaScript
	 * Renvoie la valeur complexe du calcul
	 * @returns {Number}
	 */
	CCalculAncetre.prototype.valeurComplexe = function () {
	  var res = new Complexe();
	  this.rendValeurComplexe(res);
	  return res;
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Color = __webpack_require__(6);
	var Fonte = __webpack_require__(18);
	var Pointeur = __webpack_require__(16);
	var Rect = __webpack_require__(37);
	var StyleEncadrement = __webpack_require__(38);
	var kernel = __webpack_require__(8);
	var CElementGraphique = __webpack_require__(39);
	// const CLatex = require('./CLatex')
	
	module.exports = CAffichageLieAPoint;
	
	/**
	 * Classe ancêtre de tous les éléments affichant quelque chose sur la figure.
	 * Version spéciale mtgApp car on doit pouvoir capturer un affichage même non encadré
	 * @constructor
	 * @extends CElementGraphique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de l'éditeur
	 * @param {Float} y_nom : L'ordonnée d'affichage de l'éditeur
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} encadrement : true si encadré.
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @returns {CAffichageLieAPoint}
	 */
	function CAffichageLieAPoint(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, encadrement, effacementFond, couleurFond, alignementHorizontal, alignementVertical) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CElementGraphique.call(this, listeProprietaire);else {
	      // A revoir car les deux derniers éléments qui sont enregistrés dans le flux sont inutiles
	      CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur, false, dec_x, dec_y, masque, "", 0);
	      this.x_nom = x_nom;
	      this.y_nom = y_nom;
	      this.pointLie = pointLie;
	      this.taillePolice = taillePolice;
	      this.encadrement = encadrement;
	      this.effacementFond = effacementFond;
	      this.couleurFond = couleurFond;
	      this.alignementHorizontal = alignementHorizontal;
	      this.alignementVertical = alignementVertical;
	    }
	  }
	  // Pour les LaTeX utilisés dans un CEditeurFormule, pointera sur le CEditeurFormule propriétaire
	  this.owner = null;
	  this.rectAff = new Rect(0, 0, 0, 0);
	  this.chaineLatex = "";
	  this.div = null; // Nécessaire pour les CLatex
	  /* Modifié version 5.0
	  this.style = "top:0px;left:0px;position:absolute;font-size:" + Fonte.taille(taillePolice)
	        +"px;visibility:hidden;"; // Inutile
	  this.styleLatex = "top:0px;left:0px;position:absolute;font-size:" + Fonte.tailleLatex(taillePolice)
	        +"px;visibility:hidden;";
	  */
	  /*
	  this.styleLatex = "top:0px;left:0px;position:absolute;font-size:" + Fonte.tailleLatex(taillePolice)
	        +"px;visibility:hidden;";
	  */
	}
	CAffichageLieAPoint.prototype = new CElementGraphique();
	CAffichageLieAPoint.prototype.constructor = CAffichageLieAPoint;
	CAffichageLieAPoint.prototype.superClass = "CElementGraphique";
	CAffichageLieAPoint.prototype.className = "CAffichageLieAPoint";
	
	CAffichageLieAPoint.alignementHorizontalGauche = 0;
	CAffichageLieAPoint.alignementHorizontalCentre = 1;
	CAffichageLieAPoint.alignementHorizontalDroit = 2;
	CAffichageLieAPoint.alignementVerticalHaut = 0;
	CAffichageLieAPoint.alignementVerticalCentre = 1;
	CAffichageLieAPoint.alignementVerticalBas = 2;
	
	CAffichageLieAPoint.prototype.getStyleLatex = function () {
	  return "top:0px;left:0px;position:absolute;font-size:" + Fonte.tailleLatex(this.taillePolice) + "px;visibility:hidden;";
	};
	
	CAffichageLieAPoint.prototype.setClone = function (ptel) {
	  CElementGraphique.prototype.setClone.call(this, ptel);
	  this.chaineAAfficher = ptel.chaineAAfficher;
	  this.taillePolice = ptel.taillePolice;
	  this.encadrement = ptel.encadrement;
	  this.effacementFond = ptel.effacementFond;
	  this.couleurFond = ptel.couleurFond;
	  // this.rectAff.setRec(ptel.rectAff); // Ne pas mettre
	};
	
	/**
	 * Ajout version 5.2 (numéro de version 16). Renverra true si l'objet possède deux éléments dec_x et dec_y doit être enregistré dans le flux
	 * Sera redéfini à true dans CAffichageLieAPoint
	 * @returns
	 */
	CAffichageLieAPoint.prototype.hasDec = function () {
	  return true;
	};
	
	CAffichageLieAPoint.prototype.ajouteAntecedents = function (liste) {
	  if (this.pointLie !== null) liste.add(this.pointLie);
	};
	
	CAffichageLieAPoint.prototype.dependDe = function (p) {
	  if (this.pointLie === null) return CElementGraphique.prototype.dependDe.call(this, p);else return CElementGraphique.prototype.dependDe.call(this, p) || this.pointLie.dependDe(p);
	};
	
	CAffichageLieAPoint.prototype.dependDePourBoucle = function (p) {
	  if (this.pointLie === null) return p === this;else return p === this || this.pointLie.dependDePourBoucle(p);
	};
	
	CAffichageLieAPoint.prototype.dependDePourCapture = function (p) {
	  return this.dependDe(p);
	};
	
	CAffichageLieAPoint.prototype.positionne = function (infoRandom, dimf) {
	  if (this.pointLie !== null) this.existe = this.pointLie.existe;else this.existe = true;
	  if (!this.existe) return;
	  if (this.pointLie !== null) {
	    /* Modifié version mtgApp à cause des lieux d'objets
	    if (this.pointLie.horsEcran) {
	      this.existe = false;
	      return;
	    }
	    */
	    this.x_nom = this.pointLie.x; //
	    this.y_nom = this.pointLie.y; //
	    if (!dimf.dansFenetre(this.x_nom, this.y_nom)) {
	      this.existe = false;
	      return;
	    }
	  }
	  this.chaineAAfficher = this.rendChaineAffichage();
	  var len = this.chaineAAfficher.length;
	  if (this.chaineAAfficher.charAt(0) === "$" && this.chaineAAfficher.charAt(len - 1) === "$") {
	    var ch = this.chaineAAfficher.substring(1, len - 1);
	    this.isToBeUpdated = this.chaineLatex !== ch;
	    this.chaineLatex = ch;
	  }
	};
	
	/**
	 * Fonction appelée soit ppour un CLaTeX soit pour un commentaire dont le texte commence et finit pat $
	 * et qui détruit this.div quand il est non nul qui est la div provisoirement créé pour être traité parr MathJax
	 */
	CAffichageLieAPoint.prototype.deleteDiv = function () {
	  if (this.div !== null) {
	    document.body.removeChild(this.div);
	    this.div = null;
	  }
	};
	
	CAffichageLieAPoint.prototype.distancePoint = function (xp, yp, masquage) {
	  if (!this.existe || masquage && this.masque) return -1;else {
	    if (this.rectAff.contains(xp, yp)) return 0;else return -1;
	  }
	};
	
	CAffichageLieAPoint.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointLie === ancienPoint) this.pointLie = nouveauPoint;
	};
	
	/**
	 * Fonction préparant l'affichage par MathJax en créant un div provisoire
	 * @param bMemeMasque : Si true la prépartion de fait même si l'affichage est caché (sert dans
	 * la boîte de dialogue de protocole)
	 */
	CAffichageLieAPoint.prototype.setReady4MathJax = function (bMemeMasque) {
	  var CLatex = __webpack_require__(40);
	  var len;
	  if (this.chaineAAfficher.charAt(0) === "$") {
	    len = this.chaineAAfficher.length;
	    if (this.chaineAAfficher.charAt(len - 1) === "$") CLatex.prototype.setReady4MathJax.call(this, bMemeMasque);
	  }
	};
	
	CAffichageLieAPoint.prototype.setReady4MathJaxUpdate = function () {
	  var CLatex = __webpack_require__(40);
	  var len;
	  if (this.chaineAAfficher.charAt(0) === "$") {
	    len = this.chaineAAfficher.length;
	    if (this.chaineAAfficher.charAt(len - 1) === "$") {
	      CLatex.prototype.setReady4MathJaxUpdate.call(this);
	    }
	  }
	};
	
	CAffichageLieAPoint.prototype.createg = function (svg) {
	  var CLatex = __webpack_require__(40);
	  var g, t, style, ind, ch, haut, h, anchor, len, nblig, y, ligaf, st, styleexp, ch2, v, sty;
	  len = this.chaineAAfficher.length;
	  // Ajout version mtgApp
	  if (len === 0) return kernel.cens("g");
	  //
	  this.oldx_nom = this.x_nom;
	  this.oldy_nom = this.y_nom;
	  this.olddec_x = this.dec_x;
	  this.olddec_y = this.dec_y;
	  if (this.chaineAAfficher.charAt(0) === "$") {
	    if (this.chaineAAfficher.charAt(len - 1) === "$") {
	      // this.chaineLatex = this.chaineAAfficher.substring(1, len - 1);
	      // this.style = "top:0px;left:0px;position:absolute;alignment-adjust:baseline;font-size: " +
	      //    Fonte.taille(this.taillePolice)+"px;visibility: hidden;";
	      return CLatex.prototype.createg.call(this);
	    }
	  }
	  this.chaineAffichee = this.chaineAAfficher;
	  // haut = Fonte.taille(this.taillePolice); Modifié version 5.0
	  haut = this.taillePolice;
	  g = kernel.cens("g");
	  // L'élément va être d'abord caché. S'il est encadré ou efface le fond on rajoutera un élément en tête
	  switch (this.alignementHorizontal) {
	    case CAffichageLieAPoint.alignementHorizontalGauche:
	      anchor = "start";
	      break;
	    case CAffichageLieAPoint.alignementHorizontalCentre:
	      anchor = "middle";
	      break;
	    case CAffichageLieAPoint.alignementHorizontalDroit:
	      anchor = "End";
	  }
	  // On compte le nombre de lignes
	  nblig = 1;
	  ind = -1;
	  while ((ind = this.chaineAAfficher.indexOf("\n", ind + 1)) !== -1) {
	    nblig++;
	  }h = nblig === 1 ? haut : haut + (nblig - 1) * (haut + 2);
	  y = this.y_nom + this.dec_y;
	  if (this.chaineAAfficher.search(/#H|#L/) !== -1) {
	    v = haut / 3;
	    h += v;
	    y += v;
	  }
	  switch (this.alignementVertical) {
	    case CAffichageLieAPoint.alignementVerticalCentre:
	      y -= h / 2 + 1;
	      break;
	    case CAffichageLieAPoint.alignementVerticalBas:
	      y -= h + 2;
	  }
	  // Modifié version 4.9.2.3
	  // ligaf = y + haut - 1;
	  ligaf = y + haut - 2;
	  // this.rectAff.height = h;
	  // Modifié version 4.9.9.4
	  // style = "text-anchor:" + anchor + ";font-size:" + haut +"px;" + "fill:" + this.couleur.rgb()+";";
	  // Modifié version 5.1.4 : IL faur préciser une fonte pour les textes
	  sty = "font-family:'Times New Roman',Times,serif;text-anchor:" + anchor + ";fill:" + this.color + ";";
	  style = sty + ";font-size:" + haut + "px;";
	  // Ajout version 5.0
	  styleexp = sty + ";font-size:" + String(Math.round(haut * 2 / 3)) + "px;";
	  //
	  // Modification version 5.0 : Une variable globale mémorisant le stye d'écriture : italique, gras, souligne ou une combinaison de ces styles
	  st = new Pointeur(Fonte.Normal);
	  if (this.chaineAAfficher.indexOf("\n") === -1) {
	    t = CAffichageLieAPoint.createLine(this.chaineAAfficher, haut, style, styleexp, this.x_nom + this.dec_x, ligaf, st);
	    g.appendChild(t);
	  } else {
	    ch = this.chaineAAfficher;
	    // h = haut;
	    while ((ind = ch.indexOf("\n")) !== -1) {
	      ch2 = ch.substring(0, ind);
	      t = CAffichageLieAPoint.createLine(ch2, haut, style, styleexp, this.x_nom + this.dec_x, ligaf, st);
	      g.appendChild(t);
	      // Modification version 5.0 pour traiter exposants et indices
	      ligaf += haut + (ch2.search(/#H|#L/) !== -1 ? haut / 3 + 2 : 2);
	      ch = ch.substring(ind + 1);
	    }
	    t = CAffichageLieAPoint.createLine(ch, haut, style, styleexp, this.x_nom + this.dec_x, ligaf, st);
	    g.appendChild(t);
	  }
	  // this.rectAff.x = this.x_nom + this.dec_x - 1;
	  // this.rectAff.y = y - 1;
	  /* Modification version mtgApp
	  if (this.effacementFond || (this.encadrement !== StyleEncadrement.Sans)) {
	    // Comme on ne peut pas connaître des dimensions sur le svg de la chaîne, dans le cas où elle est encadrée ou efface
	    // le fond, il faut l'afficher une première fois pour connaître ses dimensions
	    g.setAttribute("visibility", "hidden");
	    svg.appendChild(g);
	    // this.rectAff.height = h + 7;
	    this.rectAff.height = h + 6;
	    this.rectAff.width = g.getBBox().width + 4;
	    // this.rectAff.x  = g.getBBox().x - 2;
	    this.rectAff.x  = g.getBBox().x;
	    // this.rectAff.y  = y - 2;
	    this.rectAff.y  = y;
	    svg.removeChild(g);
	    g.setAttribute("visibility", "visible");
	    this.creeRectangle(g);
	  }
	  */
	  g.setAttribute("visibility", "hidden");
	  var svgAux = document.getElementById("mtgSvgAux");
	  svgAux.appendChild(g);
	  this.rectAff.x = g.getBBox().x;
	  this.rectAff.y = y;
	  if (this.effacementFond || this.encadrement !== StyleEncadrement.Sans) {
	    this.rectAff.width = g.getBBox().width + 4;
	    this.rectAff.height = h + 6;
	    svgAux.removeChild(g);
	    g.setAttribute("visibility", "visible");
	    this.creeRectangle(g);
	  } else {
	    this.rectAff.width = g.getBBox().width;
	    this.rectAff.height = h;
	    svgAux.removeChild(g);
	    g.setAttribute("visibility", "visible");
	  }
	  //
	
	  g.setAttribute("pointer-events", "none");
	  return g;
	};
	/**
	 * Fonction créant une ligne de texte dans le cas d'un affichage de plusieurs lignes.
	 * Renvoie un élément du type text de svg.
	 * @param {String} ch : Le texte de la ligne.
	 * @paam {Integer} taille : La taille de la police utilisée
	 * @param {String} style : le style d'affichage.
	 * @param {Number} x : L'abscisse de début d'affichage.
	 * @param {Number} y : L'ordonnée de début d'affichage.
	 * @param {Pointeur} st : Contient le style d'écriture actif (combinaison entre normal, italique, gras et souligné)
	 * @returns {svg.text}
	 */
	CAffichageLieAPoint.createLine = function (ch, taille, style, styleexp, x, y, st) {
	  var cont, i, tspan, s, car, ind, diese, affspecial, dy, indpf;
	  var styleEc = st.getValue();
	  var t = kernel.cens("text", {
	    x: x,
	    y: y,
	    style: style
	  });
	  s = ch.split(/(#)/); // Parenthèses pour que le # soient dans le tableau
	  affspecial = false;
	  diese = false;
	  dy = 0;
	  for (i = 0; i < s.length; i++) {
	    if (s[i] === "#") {
	      if (!diese) {
	        affspecial = true;
	        diese = true;
	      } else {
	        tspan = kernel.cens("tspan", {
	          style: style + Fonte.styleEcriture(styleEc)
	        });
	        cont = document.createTextNode("#");
	        tspan.appendChild(cont);
	        t.appendChild(tspan);
	        diese = false;
	      }
	    } else {
	      if (s[i].length !== 0) {
	        diese = false;
	        car = s[i].charAt(0);
	        ind = 1;
	        if (affspecial) {
	          if (car === "I" || car === "N" || car === "G" || car === "U") {
	            if (car === "I") {
	              styleEc |= Fonte.Italique;
	              ind = 1;
	            } else if (car === "N") {
	              styleEc = Fonte.Normal;
	              ind = 1;
	            } else if (car === "G") {
	              styleEc |= Fonte.Gras;
	              ind = 1;
	            } else if (car === "U") {
	              styleEc |= Fonte.Underline;
	              ind = 1;
	            }
	            if (ind !== s[i].length) {
	              tspan = kernel.cens("tspan", {
	                style: style + Fonte.styleEcriture(styleEc),
	                dy: dy + "px"
	
	              });
	              cont = document.createTextNode(s[i].substring(ind));
	              tspan.appendChild(cont);
	              t.appendChild(tspan);
	              affspecial = false;
	              dy = 0;
	              // if (dy != 0) dy = -dy; // Un seul niveau d'exposant ou d'indice
	            }
	          } else {
	            if (affspecial && (car === "H" || car === "L")) {
	              if (s[i].charAt(1) !== "(") {
	                ind = 0;
	                indpf = s[i].length;
	              } else {
	                ind = 2;
	                indpf = s[i].indexOf(")");
	                if (indpf === -1) indpf = s[i].length;
	                if (car === "H") dy = -taille / 3;else dy = taille / 3;
	              }
	              /* Modifié version mtgApp
	              tspan = document.createElementNS(kernel.svgns,"tspan");
	              tspan.setAttribute("style", styleexp+Fonte.styleEcriture(styleEc));
	              tspan.setAttribute("dy",dy+"px");
	              */
	              tspan = kernel.cens("tspan", {
	                style: styleexp + Fonte.styleEcriture(styleEc),
	                dy: dy + "px"
	              });
	
	              cont = document.createTextNode(s[i].substring(ind, indpf));
	              tspan.appendChild(cont);
	              t.appendChild(tspan);
	              affspecial = false;
	              dy = -dy; // Un seul niveau d'exposant ou d'indice
	              if (indpf < s[i].length - 1) {
	                // Si il reste de caractères après la parenthèse fermante, affichage normal
	                tspan = kernel.cens("tspan", {
	                  style: style + Fonte.styleEcriture(styleEc),
	                  dy: dy + "px"
	                });
	                cont = document.createTextNode(s[i].substring(indpf + 1));
	                tspan.appendChild(cont);
	                t.appendChild(tspan);
	                affspecial = false;
	                dy = 0;
	              }
	            } else {
	              tspan = kernel.cens("tspan", {
	                style: style + Fonte.styleEcriture(styleEc),
	                dy: dy + "px"
	              });
	              cont = document.createTextNode(s[i]);
	              tspan.appendChild(cont);
	              t.appendChild(tspan);
	              affspecial = false;
	              dy = 0;
	            }
	          }
	        } else {
	          tspan = kernel.cens("tspan", {
	            style: style + Fonte.styleEcriture(styleEc),
	            dy: dy + "px"
	          });
	          cont = document.createTextNode(s[i]);
	          tspan.appendChild(cont);
	          t.appendChild(tspan);
	          affspecial = false;
	          dy = 0;
	        }
	      } else affspecial = false;
	    }
	  }
	  st.setValue(styleEc);
	  t.setAttribute("pointer-events", "none");
	  return t;
	};
	
	CAffichageLieAPoint.prototype.trace = function (svg) {
	  // Attention : paramètre svg nécessaire
	  var g = this.createg(svg);
	  g.setAttribute("id", this.id);
	  // g.setAttribute("visibility", "hidden");
	  svg.appendChild(g);
	  this.g = g;
	};
	/**
	 * Dans le cas où l'affichage est encadré, crée un rect de svg qui sera inéséré
	 * dans le g element représentant l'objet juste avant l'affichage.
	 * @param {svg.rect} g
	 * @returns {undefined}
	 */
	CAffichageLieAPoint.prototype.creeRectangle = function (g) {
	  // var style = "shape-rendering:crispEdges;stroke-width:1px;";
	  var style = "stroke-width:0.5px;";
	  // Modifié version 4.9.9.4
	  // style += (this.encadrement === StyleEncadrement.Sans) ? "stroke:none;" : "stroke:" + this.couleur.rgb()+";";
	  style += this.encadrement === StyleEncadrement.Sans ? "stroke:none;" : "stroke:" + this.color + ";";
	  if (this.effacementFond) style += "fill:" + this.couleurFond.rgb() + ";";else style += "fill:none;";
	  var r = kernel.cens("rect", {
	    style: style,
	    x: this.rectAff.x - 2,
	    y: this.rectAff.y - 2,
	    width: this.rectAff.width + 3,
	    height: this.rectAff.height,
	    "pointer-events": "none"
	  });
	  g.insertBefore(r, g.childNodes[0]);
	  if (this.encadrement === StyleEncadrement.Effet3D) {
	    // Ajout d'un effet 3D
	    // var pol = document.createElementNS(kernel.svgns,"polygon"); // Modifié version mtgApp
	    style = "stroke-width:1px;stroke:" + this.color + ";fill:" + this.color + ";";
	    /* Modifié version mtgApp
	    pol.setAttribute("style", style);
	    */
	    var x = this.rectAff.x - 2;
	    var y = this.rectAff.y - 2;
	    var w = this.rectAff.width + 3; // Modifié version 4.9.9.4
	    var h = this.rectAff.height;
	    var s1 = String(x + w);
	    var s2 = String(y + h);
	    var s3 = String(x + w + 1);
	    var s4 = String(y + h + 1);
	    var pol = kernel.cens("polygon", {
	      style: style,
	      points: x + "," + s2 + " " + s1 + "," + s2 + " " + s1 + "," + y + " " + s3 + "," + String(y + 1) + " " + s3 + "," + s4 + " " + String(x + 1) + "," + s4
	    });
	    g.insertBefore(pol, g.childNodes[1]);
	  }
	};
	/**
	 * Fonction retirant de g le rectangle encadrant l'affichage lorsque celui-ci est présent
	 * et le remplaçant par un nouveau.
	 * @param {type} g
	 * @returns {undefined}
	 */
	CAffichageLieAPoint.prototype.remplaceRectangle = function (g) {
	  g.removeChild(g.childNodes[0]);
	  if (this.encadrement === StyleEncadrement.Effet3D) g.removeChild(g.childNodes[0]);
	  this.creeRectangle(g);
	};
	
	// Modifié version 5.0 : taille représente maintenant la taille réelle
	CAffichageLieAPoint.prototype.update = function (svg) {
	  var CLatex = __webpack_require__(40);
	  var t, g, len, nblig, ind, ligaf, y, h, haut, decalagex, decalagey, v;
	  if (this.chaineAAfficher.charAt(0) === "$") {
	    len = this.chaineAAfficher.length;
	    if (this.chaineAAfficher.charAt(len - 1) === "$") {
	      CLatex.prototype.update.call(this, svg);
	    }
	  } else {
	    decalagex = this.x_nom - this.oldx_nom + this.dec_x - this.olddec_x;
	    decalagey = this.y_nom - this.oldy_nom + this.dec_y - this.olddec_y;
	    this.olddec_x = this.dec_x;
	    this.olddec_y = this.dec_y;
	    this.oldx_nom = this.x_nom;
	    this.oldy_nom = this.y_nom;
	    var oldg = this.g;
	    // if (this.chaineAffichage === this.chaineAffichee) {
	    if (this.chaineAAfficher === this.chaineAffichee) {
	      // Inutile de recréer le composant on le déplace simplement
	      // haut = Fonte.taille(this.taillePolice); // Modifié version 5.0
	      haut = this.taillePolice;
	      nblig = 1;
	      ind = -1;
	      while ((ind = this.chaineAAfficher.indexOf("\n", ind + 1)) !== -1) {
	        nblig++;
	      }h = nblig === 1 ? haut : haut + (nblig - 1) * (haut + 2);
	      y = this.y_nom + this.dec_y;
	      // Ajout version 5.0
	      if (this.chaineAAfficher.search(/#H|#L/) !== -1) {
	        v = haut / 3;
	        h += v;
	        y += v;
	      }
	      //
	      switch (this.alignementVertical) {
	        case CAffichageLieAPoint.alignementVerticalCentre:
	          y -= h / 2 + 1;
	          break;
	        case CAffichageLieAPoint.alignementVerticalBas:
	          y -= h + 2;
	      }
	      // Modifié version 4.9.2.3
	      // ligaf = y + haut - 1;
	      ligaf = y + haut - 2;
	      var l = oldg.childNodes.length;
	      for (var i = 0; i < nblig; i++) {
	        t = oldg.childNodes[l - nblig + i];
	        t.setAttribute("x", this.x_nom + this.dec_x);
	        t.setAttribute("y", ligaf);
	        ligaf += haut + 2;
	      }
	      this.rectAff.x += decalagex;
	      this.rectAff.y += decalagey;
	      if (this.effacementFond || this.encadrement !== StyleEncadrement.Sans) {
	        //this.rectAff.height = oldg.getBBox().height + 4;
	        //this.rectAff.width = oldg.getBBox().width + 2;
	        this.remplaceRectangle(oldg);
	      }
	    } else {
	      g = this.createg(svg); // Paramètre nécessaire pour le CLatex
	      svg.replaceChild(g, oldg);
	      g.setAttribute("id", this.id);
	      this.g = g;
	    }
	  }
	  // Ajout version 5.0.1
	  if (this.pointLie !== null && !this.pointLie.dansFenetre) this.g.setAttribute("visibility", "hidden");else this.g.setAttribute("visibility", "visible");
	};
	
	CAffichageLieAPoint.prototype.reCreateDisplay = function (svg) {
	  var oldg = this.g;
	  var g = this.createg(svg); // Paramètre nécessaire pour le CLatex
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	
	// Spécial JavaScript
	/**
	 * Fonction renvoyant le code à rajouter au début du code LaTeX pour qu'un affichage LaTeX
	 * ait la couleur désirée.
	 * @returns {String}
	 */
	CAffichageLieAPoint.prototype.prelatex = function () {
	  // Modifié version 4.9.9.4
	  /*
	  return "\\color[RGB]{"+Math.floor(this.couleur.red) +"," + Math.floor(this.couleur.green) + "," +
	    Math.floor(this.couleur.blue) + "}";
	  */
	  return "\\color{" + this.color + "}";
	};
	
	CAffichageLieAPoint.prototype.read = function (inps, list) {
	  CElementGraphique.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  if (ind1 === -1) this.pointLie = null;else this.pointLie = list.get(ind1, "CPt");
	  this.taillePolice = inps.readByte();
	  // Modification version 5.0 : taillePolice est maintenant la taille réelle de la police
	  if (list.numeroVersion < 15) this.taillePolice = Fonte.taille(this.taillePolice);
	  if (this.listeProprietaire.numeroVersion < 11) {
	    this.x_nom = inps.readDouble();
	    this.y_nom = inps.readDouble();
	  } else {
	    if (this.pointLie === null) {
	      this.x_nom = inps.readDouble();
	      this.y_nom = inps.readDouble();
	    }
	  }
	  this.encadrement = inps.readByte();
	  this.effacementFond = inps.readBoolean();
	  // Modification pour le passage en version RVB à partir de la version 2.5 (n°5)
	  if (this.effacementFond) {
	    var r = inps.readByte();
	    var g = inps.readByte();
	    var b = inps.readByte();
	    this.couleurFond = new Color(r, g, b);
	  } else this.couleurFond = Color.white; // Ne sert pas
	  this.alignementHorizontal = inps.readInt();
	  this.alignementVertical = inps.readInt();
	  /*
	  this.styleLatex = "top:0px;left:0px;position:absolute;font-size:" + Fonte.tailleLatex(this.taillePolice)
	        +"px;visibility:hidden;";
	  */
	  this.chaineLatex = ""; // Ajout version 4.9.2
	};
	
	CAffichageLieAPoint.prototype.write = function (oups, list) {
	  CElementGraphique.prototype.write.call(this, oups, list);
	  var ind1;
	  if (this.pointLie === null) ind1 = -1;else ind1 = list.indexOf(this.pointLie);
	  oups.writeInt(ind1);
	  oups.writeByte(this.taillePolice);
	  if (this.pointLie === null) {
	    oups.writeDouble(this.x_nom);
	    oups.writeDouble(this.y_nom);
	  }
	  oups.writeByte(this.encadrement);
	  oups.writeBoolean(this.effacementFond);
	  if (this.effacementFond) {
	    oups.writeByte(this.couleurFond.getRed());
	    oups.writeByte(this.couleurFond.getGreen());
	    oups.writeByte(this.couleurFond.getBlue());
	  }
	  oups.writeInt(this.alignementHorizontal);
	  oups.writeInt(this.alignementVertical);
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	module.exports = Rect;
	/**
	 * Classe utilisée de façon interne pour représenter un rectangle.
	 * @constructor
	 * @param {Float} x : L'abscisse du bord supérieur gauche.
	 * @param {Float} y : L'ordonnée du bord supérieur gauche.
	 * @param {Float} width : La largeur du rectangle.
	 * @param {type} height : La hauteur du rectangle.
	 * @returns {Rect}
	 */
	function Rect(x, y, width, height) {
	  this.x = x;
	  this.y = y;
	  this.width = width;
	  this.height = height;
	}
	/*
	Rect.prototype.setRec = function(rx,ry,rwidth,rheight) {
	  if (arguments.length == 1) {
	    this.x = rx.x;
	    this.y = rx.y;
	    this.width = rx.width;
	    this.height = rx.height;
	  }
	  else {
	    this.x = rx;
	    this.y = ry;
	    this.width = rwidth;
	    this.height = rheight;
	  }
	};
	*/
	Rect.prototype.contains = function (xt, yt) {
	  return xt >= this.x && yt >= this.y && xt <= this.x + this.width && yt <= this.y + this.height;
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Sert à définir les différents types d'encadrement utilisés dans mtg32
	 * @type mtg32.StyleEncadrement
	 */
	var StyleEncadrement = {
	  Sans: 0,
	  Simple: 1,
	  Effet3D: 2
	};
	
	module.exports = StyleEncadrement;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CElementBase = __webpack_require__(33);
	var Color = __webpack_require__(6);
	var Fonte = __webpack_require__(18);
	var kernel = __webpack_require__(8);
	module.exports = CElementGraphique;
	/**
	 * @constructor
	 * @extends CElementBase
	 * Objet ancêtre de tous les objets graphiques.
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet
	 * @param {Boolean} estElementFinal : true si l'objet est un objet inal de construction
	 * @param {Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Le décalage horizontal du nom
	 * @param {Integer} dec_y : Le décalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : le nom éventuel de l'objet
	 * @param {Integer} tailleNom : l'indice donnant la taille du nom
	 * @returns {undefined}
	 */
	function CElementGraphique(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4 pour constructeur
	  if (arguments.length === 1) {
	    CElementBase.call(this, listeProprietaire);
	    this.nom = ""; // Sert pour le protocole de la figure
	  } else {
	    CElementBase.call(this, listeProprietaire, impProto, estElementFinal);
	    this.couleur = couleur;
	    this.nomMasque = nomMasque;
	    this.dec_x = dec_x;
	    this.dec_y = dec_y;
	    this.masque = masque;
	    this.nom = nom;
	    this.tailleNom = tailleNom;
	    // Rajout version 4.9.9.4
	    if (couleur !== null) this.color = couleur.rgb(); // Certains objets inclus dans d'autres
	    // peuvent ne pas avoir de couleur quand ils sont créés.
	  }
	  this.id = ""; // Spécial JavaScript
	  this.g = null; // Idem
	  this.gname = null;
	  // Ajout version 5.0.4 :Sert pour les objets dupliqués de CLatex
	  this.hasDuplicate = false;
	}
	CElementGraphique.prototype = new CElementBase();
	CElementGraphique.prototype.constructor = CElementGraphique;
	CElementGraphique.prototype.superClass = "CElementBase";
	CElementGraphique.prototype.className = "CElementGraphique";
	
	/**
	 * Fonction renvoyant un clode de l'objet
	 * @returns {CElementGraphique}
	 */
	CElementGraphique.prototype.creeClone = function () {
	  return this.getClone(this.listeProprietaire, this.listeProprietaire);
	};
	/**
	 * Fonction faisant de this un objet de mêmes caractéristiques que ptel
	 * ptel doit être un élément du même type que this
	 * @param {CElementBase} ptel
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.setClone = function (ptel) {
	  CElementBase.prototype.setClone.call(this, ptel);
	  this.x_nom = ptel.x_nom;
	  this.y_nom = ptel.y_nom;
	  this.dec_x = ptel.dec_x;
	  this.dec_y = ptel.dec_y;
	  this.masque = ptel.masque;
	};
	
	/**
	 * Ajout version 5.2 (numéro de version 16). Renverra true si l'objet possède un nom qui doit être enregistré dans le flux
	 * @returns {boolean}
	 */
	CElementGraphique.prototype.hasName = function () {
	  return false;
	};
	
	/**
	 * Ajout version 5.2 (numéro de version 16). Renverra true si l'objet possède deux éléments dec_x et dec_y doit être enregistré dans le flux
	 * Sera redéfini à true dans CAffichageLieAPoint
	 * @returns
	 */
	CElementGraphique.prototype.hasDec = function () {
	  return this.hasName();
	};
	
	/**
	 * Fonction rendant l'objet masqué
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.cache = function () {
	  this.masque = true;
	};
	/**
	 * Fonction rendant l'objet visible
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.montre = function () {
	  this.masque = false;
	};
	/**
	 * Fonction donnant à l'objet le nom nomInit
	 * @param {String} nomInit
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.donneNom = function (nomInit) {
	  this.nom = nomInit;
	};
	/**
	 * Renvoei le nom de l'objet
	 * @returns {String}
	 */
	CElementGraphique.prototype.rendNom = function () {
	  return this.nom;
	};
	/**
	 * Fonction plaçant le point ux coordonnées (x,y)
	 * @param {Number} xn
	 * @param {Number} yn
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.placeNom = function (xn, yn) {
	  this.x_nom = xn;
	  this.y_nom = yn;
	};
	/**
	 * Decale le nom de l'objet de (dec_xn, dec_yn)
	 * @param {Integer} dec_xn
	 * @param {Integer} dec_yn
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.decaleNom = function (dec_xn, dec_yn) {
	  this.dec_x = dec_xn;
	  this.dec_y = dec_yn;
	};
	// A revoir svg
	/**
	 * Fonction créant un élément svg représentant le nom de l'objet
	* @returns {SVGTextElement}
	 */
	CElementGraphique.prototype.createName = function () {
	  var nom = this.nom;
	  var taille = this.tailleNom; // Modifié version 5.0
	  var y = this.y_nom + this.dec_y + taille;
	  var text = kernel.cens("text", {
	    x: this.x_nom + this.dec_x,
	    y: y,
	    style: "text-anchor : left;" + "fill:" + this.couleur.rgb() + ";" + "font-size:" + taille + "px;",
	    id: this.id + "name",
	    "pointer-events": "none" // Ne marche pas avec chrome
	  });
	  // disableSelection(text);
	  // On recherche un éventuel indice
	  for (var i = 0; i < nom.length; i++) {
	    if (Fonte.chiffre(nom.charAt(i))) break;
	  }
	  var deb = nom.substring(0, i);
	  var span1 = kernel.cens("tspan");
	  var cont1 = document.createTextNode(deb);
	  span1.appendChild(cont1);
	  text.appendChild(span1);
	  if (i < nom.length) {
	    var fin = nom.substring(i);
	    var span2 = kernel.cens("tspan", {
	      "font-size": Math.floor(taille * 2 / 3) + "pt;",
	      dy: Math.floor(taille / 3)
	    });
	    var cont2 = document.createTextNode(fin);
	    span2.appendChild(cont2);
	    text.appendChild(span2);
	  }
	  // Ajout version mtgApp car la version mtgApp a besoin de connaître les dimensions d'affichage du nom
	  if (this.createNameAdd) this.createNameAdd(text);
	  //
	  return text;
	};
	/**
	 * Fonction ajoutant au svg svg le texte element représentant le nom de l'objet
	 * @param {svg} svg
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.afficheNom = function (svg) {
	  this.gname = this.createName();
	  svg.appendChild(this.gname);
	};
	
	CElementGraphique.prototype.updateNamePosition = function () {
	  this.gname.setAttribute("x", this.x_nom + this.dec_x);
	  this.gname.setAttribute("y", this.y_nom + this.dec_y + this.tailleNom);
	  // Les lignes suivantes ne concernent qua la version mtgApp
	  if (this.rectName) {
	    var bb = this.gname.getBBox();
	    this.rectName.x = bb.x;
	    this.rectName.y = bb.y;
	    this.rectName.width = bb.width;
	    this.rectName.height = bb.height;
	  }
	};
	
	/**
	 * Fonction mettant à jour le sgv text element représentant le nom de l'objet
	 * @param {svg} svg
	 * @param {Boolean} masquage
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.updateName = function (svg, masquage) {
	  if (this.nom === "") {
	    if (this.gname !== null) {
	      svg.removeChild(this.gname);
	      this.gname = null;
	    }
	  } else {
	    var gn = this.createName();
	    if (this.gname !== null) svg.replaceChild(gn, this.gname);else {
	      gn = this.createName();
	      // Ne pas utiliser ici kernelAdd qui utilise jquery alors que le player ne l'utilise pas
	      // kernelAdd.insertAfter(gn, this.g)
	      this.g.parentNode.insertBefore(gn, this.g.nextSibling);
	    }
	    this.gname = gn;
	    if (this.masque || masquage && this.nomMasque) this.gname.setAttribute("visibility", "hidden");
	  }
	
	  /*
	  var oldgname = this.gname;
	  var newgname = this.createName();
	  svg.replaceChild(newgname, oldgname);
	  this.gname = newgname;
	  */
	  /*
	   * Ne marche pas pour une raison que j'ignore. Après le premier affichage, le suivant se décale
	  var taille = Fonte.taille(this.tailleNom);
	  g.removeAttribute("x");
	  g.removeAttribute("y");
	  g.setAttribute("x", this.x);
	  g.setAttribute("y", this.y + this.dec_y + taille);
	  */
	};
	/**
	 * Fonction donnant la couleur coul à l'objet
	 * @param {Color} coul
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.donneCouleur = function (coul) {
	  this.couleur = coul;
	  this.color = coul.rgb(); // Ajout version 4.9.9.5
	};
	/**
	 * Fonction renvoyant la distance entre this et le point de coordonnnées (xp,yp).
	 * Si masquage est à true, renvoie la distance même si le point est masqué.
	 * A redéfinir pour les descendants
	 * @param {Number} xp
	 * @param {Number} yp
	 * @param {Boolean} masquage
	 * @returns {Number}
	 */
	CElementGraphique.prototype.distancePoint = function (xp, yp, masquage) {
	  return -1;
	};
	/**
	 * Fonction renvoyant la distance entre this et le point de coordonnnées (xp,yp)
	 * pour les objest de type surface.
	 * Si masquage est à true, renvoie la distance même si le point est masqué.
	 * A redéfinir pour les descendants
	 * @param {Number} xp
	 * @param {Number} yp
	 * @param {Boolean} masquage
	 * @returns {Number}
	 */
	
	CElementGraphique.prototype.distancePointPourSurface = function (xp, yp, masquage) {
	  return -1;
	};
	/**
	 * Fonction renvoyant, pour un point lié à un objet, l'abscisse maximale relative à cet objet
	 * @returns {Number}
	 */
	CElementGraphique.prototype.abscisseMaximale = function () {
	  return 1;
	};
	/**
	 * Fonction renvoyant, pour un point lié à un objet, l'abscisse minimale relative à cet objet
	 * @returns {Number}
	 */
	CElementGraphique.prototype.abscisseMinimale = function () {
	  return 0;
	};
	/**
	 * Fonction ajoutant à svg le svg element représentant l'objet (via trace())
	 * et donnant à cet élément l'attribut visible ou masqué suivant que
	 * l'objet est masqué ou non
	 * @param {svg} svg : Le svg dans lequel est tracée la figure
	 * @param {Boolean} masquage : true si on cache les objets cachés
	 * @param {Color} couleurFond
	 * @param {Number} transparence : la transparence de l'ojet (pour les surfaces)
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.affiche = function (svg, masquage, couleurFond, transparence) {
	  this.trace(svg, couleurFond, transparence);
	  if (this.g !== null && masquage && this.masque) this.g.setAttribute("visibility", "hidden");
	};
	/**
	 * Spécial JavaScript : Renverra true si l'objet est bien représenté graphiquement dans le svg
	 * Si le deuxième paramètre est à true, renvoie true même si l'objet est masqué
	 * @param {Boolean} masquage : true si les obejts masqués ne sont pas affichés
	 * @param {Boolean} memeMasque : CF ci-dessus
	 * @returns {Boolean}
	 */
	CElementGraphique.prototype.hasg = function (masquage) {
	  return this.existe && !(this.masque && masquage);
	};
	/**
	 * Fonction qui renverra true si l'objet exsite mas est hors fenêtre.
	 * Rajouté par rapport à la version Java car un objet dupliqué a besoin de savoir
	 * si l'élément qu'il duplique est ou non représenté dans le DOM par un sgv element.
	 * Utilisé dans cObjetDuplique
	 * @returns {Boolean}
	 */
	CElementGraphique.prototype.horsCadre = function () {
	  return false;
	};
	/**
	 * Fonction recréant le svg element représentant l'objet et remplaçant dans le svg
	 * svg l'ancien élément par le nouveau.
	 * Spécial JavaScript : A redéfinir pour les éléments dont il faut recalculer
	 * le svg élément quand ils sont dépacés ou modifiés.
	 * @param {svg} svg
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.update = function (svg) {};
	/**
	 * Fonction à redéfinir pour CPt (CPointAncetre en java)
	 * Sert pour le tracé des points marqués pour la trace.
	 * @param {svg} svg
	 * @returns {undefined}
	 */
	CElementGraphique.prototype.updateTrace = function (svg) {};
	/**
	 * Fonction renvoyant true si l'objet est à l'intérieur de la fenêtre définie par dimfen
	 * @param Dimf dimfen
	 * @returns {Boolean}
	 */
	CElementGraphique.prototype.dansFen = function (dimfen) {
	  return true;
	};
	/**
	 * Fonction renvoyant le nombre d'objets pour un lieu d'objets
	 * Redéfinit pour ls lieux de lieux
	 * @returns {Number}
	 */
	CElementGraphique.prototype.nombreObjetsPourLieuObjet = function () {
	  return 1;
	};
	
	CElementGraphique.prototype.read = function (inps, list) {
	  CElementBase.prototype.read.call(this, inps, list);
	  this.masque = inps.readBoolean();
	  var r = inps.readByte();
	  var g = inps.readByte();
	  var b = inps.readByte();
	  this.couleur = new Color(r, g, b);
	  // Rajout version 4.9.9.4
	  this.color = this.couleur.rgb();
	  //
	  if (this.hasName() || list.numeroVersion < 16) {
	
	    this.nomMasque = inps.readBoolean();
	    this.tailleNom = inps.readByte();
	    // Modification version 5.0 : taillePolice est maintenant la taille réelle de la police
	    if (list.numeroVersion < 15) this.tailleNom = Fonte.taille(this.tailleNom);
	    this.nom = inps.readUTF();
	  }
	  if (this.hasDec() || list.numeroVersion < 16) {
	    if (this.listeProprietaire.numeroVersion < 11) {
	      this.dec_x = inps.readDouble();
	      this.dec_y = inps.readDouble();
	    } else {
	      var by = inps.readByte();
	      if (by === 1) {
	        this.dec_x = 0;
	        this.dec_y = 0;
	      } else {
	        this.dec_x = inps.readDouble();
	        this.dec_y = inps.readDouble();
	      }
	    }
	  }
	};
	
	CElementGraphique.prototype.write = function (oups, list) {
	  CElementBase.prototype.write.call(this, oups, list);
	  oups.writeBoolean(this.masque);
	  oups.writeByte(this.couleur.getRed());
	  oups.writeByte(this.couleur.getGreen());
	  oups.writeByte(this.couleur.getBlue());
	  if (this.hasName()) {
	    oups.writeBoolean(this.nomMasque);
	    oups.writeByte(this.tailleNom);
	    oups.writeUTF(this.nom);
	  }
	  if (this.hasDec()) {
	    if (this.dec_x === 0 && this.dec_y === 0) oups.writeByte(1);else {
	      oups.writeByte(0);
	      oups.writeDouble(this.dec_x);
	      oups.writeDouble(this.dec_y);
	    }
	  }
	};
	/**
	 * Spécial version mtgApp : Crée l'élement associé à l'objet dans le DOM
	 * @param svg
	 * @param masquage
	 * @param couleurFond
	 * @param transparence
	 */
	CElementGraphique.prototype.creeAffichage = function (svg, masquage, couleurFond, transparence) {
	  if (this.hasg(masquage)) {
	    this.affiche(svg, masquage, couleurFond, transparence);
	    this.hasgElement = true;
	    if (this.estDeNature(NatObj.NObjNommable) && this.nom !== "" && !this.nomMasque) this.afficheNom(svg);
	    this.updateTrace(svg, couleurFond, transparence); // Pour les points marqués pour la trace
	  } else {
	    var newg = kernel.cens("g", {
	      id: this.id
	    }); // Un g vide
	    svg.appendChild(newg);
	    this.g = newg;
	    this.hasgElement = false;
	    if (this.estDeNature(NatObj.NObjNommable) && this.nom !== "" && !this.nomMasque) {
	      var gname = kernel.cens("g"); // Un g vide
	      this.gname = gname;
	      svg.appendChild(gname);
	    }
	  }
	};
	
	/**
	 * Fonction détruisant l'élément el et retirant son composant graphique s'il existe
	 * @param svg : Le svg de la figure
	 */
	CElementGraphique.prototype.removegElement = function (svg) {
	  if (this.g !== null) svg.removeChild(this.g);
	  if (this.gname !== null) svg.removeChild(this.gname);
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var Complexe = __webpack_require__(30);
	var Fonte = __webpack_require__(18);
	var Pointeur = __webpack_require__(16);
	var StyleEncadrement = __webpack_require__(38);
	var kernel = __webpack_require__(8);
	var CAffichageLieAPoint = __webpack_require__(36);
	var CCommentaire = __webpack_require__(41);
	var CListeObjets = __webpack_require__(17);
	var Nat = __webpack_require__(4);
	module.exports = CLatex;
	
	/**
	 * Classe représentant un affichage LaTeX sur la figure.
	 * @constructor
	 * @extends CCommentaire
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la cosntruction ppropriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La coileur d'écriture
	 * @param {Float} x_nom : L'abscisse d'affichage.
	 * @param {Float} y_nom : L'ordonnée d'affichage.
	 * @param {Integer} dec_x : Décalage horizontal d'affichage.
	 * @param {Integer} dec_y : Décalage vertical d'affichage.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {CPt} pointLie : null si l'affichage est libre ou pointe sur le point auquel il est lié.
	 * @param {Integer} taillePolice : Donne la taille de la police utilisée.
	 * @param {Boolean} encadrement : true si l'affichage est encadré.
	 * @param {Boolean} effacementFond : true si le fond doit être effacé avant écritrue.
	 * @param {mtg32.Color} couleurFond : La couleur de fond.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} chaineCommentaire : Contient le code LaTeX.
	 * @returns {CLatex}
	 */
	function CLatex(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, encadrement, effacementFond, couleurFond, alignementHorizontal, alignementVertical, chaineCommentaire) {
	  if (arguments.length === 1) CCommentaire.call(this, listeProprietaire);else {
	    CCommentaire.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, encadrement, effacementFond, couleurFond, alignementHorizontal, alignementVertical);
	    this.chaineCommentaire = chaineCommentaire;
	  }
	  // Spécial JavaScript : chaineAffichee = contiendra la chaîne utilisée lors de l'affichage précédent.
	  // Si c'est la même, update ne fera pas appel à createg mais on changera simplement des coordonnées d'affichage du composant.
	  this.chaineAffichee = "";
	  this.div = null;
	  // Ligne suivante rajoutée pour la version WebPack
	}
	CLatex.prototype = new CCommentaire();
	CLatex.prototype.constructor = CLatex;
	CLatex.prototype.superClass = "CCommentaire";
	CLatex.prototype.className = "CLatex";
	
	CLatex.errorVal = "Val Error";
	CLatex.errorFrac = "Frac Error";
	CLatex.errorIf = "If Error";
	CLatex.errorFor = "For Error";
	CLatex.errorCalc = "Calc Error";
	CLatex.errorCalcSimp = "CalcSimp Error";
	CLatex.errorForSimp = "ForSimp Error";
	
	CLatex.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var ptelb = new CLatex(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.encadrement, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.chaineCommentaire);
	  ptelb.listeValeursDynamiquesUtilisees = new CListeObjets(listeCible.uniteAngle, listeCible.pointeurLongueurUnite);
	  if (listeCible.className !== "CPrototype") ptelb.determineDependances();
	  return ptelb;
	};
	
	CLatex.prototype.getNature = function () {
	  return NatObj.NLatex;
	};
	
	CLatex.prototype.setClone = function (ptel) {
	  CAffichageLieAPoint.prototype.setClone.call(this, ptel);
	  this.chaineLatex = ptel.chaineLatex;
	};
	
	CLatex.prototype.rendChaineAffichage = function () {
	  return this.chaineLatex;
	};
	
	CLatex.prototype.determineDependances = function () {
	  var chaineAAnalyser, indicecommentaire, len, jdeb, j, indparf, ch, st, nomvaleur, pValeur, nomvaleur2, pValeur2;
	  chaineAAnalyser = this.chaineCommentaire.replace(/ /g, "");
	
	  this.listeValeursDynamiquesUtilisees.retireTout();
	  // Quand on recherche si c'est bien le nom d'une valeur valide
	  // Il ne faut pas que la valeur ait été définie après l'affichage de valeur
	  indicecommentaire = this.listeProprietaire.indexOf(this);
	  if (indicecommentaire === -1) indicecommentaire = this.listeProprietaire.longueur() - 1;
	  // On examine la chaine à la recherche de #Val(
	  len = chaineAAnalyser.length;
	  j = 0;
	  while ((jdeb = chaineAAnalyser.indexOf("\\Val{", j)) !== -1 && j < len) {
	    // On recherche la parenthèse fermante correspondante
	    indparf = chaineAAnalyser.indexOf('}', jdeb + 5);
	    if (indparf === -1) break;else {
	      // On crée une chaine formé de ce qu'il y a entre \Val( et la parenthèse fermante
	      ch = chaineAAnalyser.substring(jdeb + 5, indparf).trim();
	      // On retire les éventuels espaces de cete chaine
	      // On sépare cette chaine avec les virgules
	      st = ch.split(/\s*,\s*/);
	      if (st.length === 0) j = indparf + 1;else {
	        nomvaleur = st[0];
	        // On recherche si c'est bien le nom d'une valeur valide
	        // Il ne faut pas que la valeur ait été définie après l'affichage de valeur
	        // Très important : quand determineDependances est appelé
	        // par getClone() de CCommentaire, le commentaire n'a pas encoré été rajouté
	        // à la liste clone et ainsi indiceCommentaire renvoie -1.
	        // dans ce cas, indiceCommentaire doit valoir le nombre d'éléments actuels
	        // de la liste clone qui le possède
	        // Modifié version 4.7.2
	        // CValDyn pValeur = pointeurValeurOuFonction(nomvaleur,indicecommentaire);
	        pValeur = this.pointeur(NatCal.NTteValPourComDynSaufFonc, nomvaleur, indicecommentaire);
	        if (pValeur === null) j = indparf + 1;else {
	          this.listeValeursDynamiquesUtilisees.add(pValeur);
	          j = indparf + 1;
	        }
	      }
	    }
	  }
	  j = 0;
	  while ((jdeb = chaineAAnalyser.indexOf("\\For{", j)) !== -1 && j < len) {
	    // On recherche la parenthèse fermante correspondante
	    indparf = chaineAAnalyser.indexOf('}', jdeb + 5);
	    if (indparf === -1) break;else {
	      // On crée une chaine formé de ce qu'il y a entre \Val( et la parenthèse fermante
	      ch = chaineAAnalyser.substring(jdeb + 5, indparf).trim();
	      // On sépare cette chaine avec les virgules
	      st = ch.split(/\s*,\s*/);
	      if (st.length === 0) j = indparf + 1;else {
	        nomvaleur = st[0];
	        pValeur = this.pointeur(NatCal.NTteValPourComDyn, nomvaleur, indicecommentaire);
	        if (pValeur === null) j = indparf + 1;else {
	          this.listeValeursDynamiquesUtilisees.add(pValeur);
	          // Si la valeur n'existe pas, on ne l'inclut pas dans la chaîne à afficher
	          j = indparf + 1;
	        }
	      }
	    }
	  }
	  j = 0;
	  while ((jdeb = chaineAAnalyser.indexOf("\\Calc{", j)) !== -1 && j < len) {
	    // On recherche la parenthèse fermante correspondante
	    indparf = chaineAAnalyser.indexOf('}', jdeb + 6);
	    if (indparf === -1) break;else {
	      // On crée une chaine formé de ce qu'il y a entre \Val( et la parenthèse fermante
	      ch = chaineAAnalyser.substring(jdeb + 6, indparf).trim();
	      // On sépare cette chaine avec les virgules
	      st = ch.split(/\s*,\s*/);
	      if (st.length === 0) j = indparf + 1;else {
	        nomvaleur = st[0];
	        pValeur = this.pointeur(NatCal.NTteValPourComDyn, nomvaleur, indicecommentaire);
	        if (pValeur === null) j = indparf + 1;else {
	          this.listeValeursDynamiquesUtilisees.add(pValeur);
	          j = indparf + 1;
	        }
	      }
	    }
	  }
	  j = 0;
	  while ((jdeb = chaineAAnalyser.indexOf("\\ForSimp{", j)) !== -1 && j < len) {
	    // On recherche la parenthèse fermante correspondante
	    indparf = chaineAAnalyser.indexOf('}', jdeb + 9);
	    if (indparf === -1) break;else {
	      // On crée une chaine formé de ce qu'il y a entre \Val( et la parenthèse fermante
	      ch = chaineAAnalyser.substring(jdeb + 9, indparf).trim();
	      // On sépare cette chaine avec les virgules
	      st = ch.split(/\s*,\s*/);
	      if (st.length === 0) j = indparf + 1;else {
	        nomvaleur = st[0];
	        pValeur = this.pointeur(NatCal.NTteValPourComDyn, nomvaleur, indicecommentaire);
	        if (pValeur === null) j = indparf + 1;else {
	          this.listeValeursDynamiquesUtilisees.add(pValeur);
	          // Si la valeur n'existe pas, on ne l'inclut pas dans la chaîne à afficher
	          j = indparf + 1;
	        }
	      }
	    }
	  }
	  j = 0;
	  while ((jdeb = chaineAAnalyser.indexOf("\\CalcSimp{", j)) !== -1 && j < len) {
	    // On recherche la parenthèse fermante correspondante
	    indparf = chaineAAnalyser.indexOf('}', jdeb + 10);
	    if (indparf === -1) break;else {
	      // On crée une chaine formé de ce qu'il y a entre \Val( et la parenthèse fermante
	      ch = chaineAAnalyser.substring(jdeb + 10, indparf).trim();
	      st = ch.split(/\s*,\s*/);
	      if (st.length === 0) j = indparf + 1;else {
	        nomvaleur = st[0];
	        pValeur = this.pointeur(NatCal.NTteValPourComDyn, nomvaleur, indicecommentaire);
	        if (pValeur === null) j = indparf + 1;else {
	          this.listeValeursDynamiquesUtilisees.add(pValeur);
	          // Si la valeur n'existe pas, on ne l'inclut pas dans la chaîne à afficher
	          j = indparf + 1;
	        }
	      }
	    }
	  }
	  j = 0;
	  while ((jdeb = chaineAAnalyser.indexOf("\\FracRed{", j)) !== -1 && j < len) {
	    // On recherche la parenthèse fermante correspondante
	    indparf = chaineAAnalyser.indexOf('}', jdeb + 9);
	    if (indparf === -1) break;else {
	      // On crée une chaine formé de ce qu'il y a entre \FracRed{ et la parenthèse fermante
	      ch = chaineAAnalyser.substring(jdeb + 9, indparf).trim();
	      st = ch.split(/\s*,\s*/);
	      if (st.length === 0) j = indparf + 1;else {
	        nomvaleur = st[0];
	        pValeur = this.pointeur(NatCal.NTteValRPourComDyn, nomvaleur, indicecommentaire);
	        if (pValeur === null) j = indparf + 1;else {
	          if (st.length === 1) j = indparf + 1;else {
	            nomvaleur2 = st[1];
	            pValeur2 = this.pointeur(NatCal.NTteValRPourComDyn, nomvaleur2, indicecommentaire);
	            if (pValeur !== null) {
	              this.listeValeursDynamiquesUtilisees.add(pValeur);
	              this.listeValeursDynamiquesUtilisees.add(pValeur2);
	            }
	            j = indparf + 1;
	          }
	        }
	      }
	    }
	  }
	  j = 0;
	  while ((jdeb = chaineAAnalyser.indexOf("\\If{", j)) !== -1 && j < len) {
	    // On recherche la parenthèse fermante correspondante
	    indparf = chaineAAnalyser.indexOf('}', jdeb + 4);
	    if (indparf === -1) break;else {
	      // On crée une chaine formée de ce qu'il y a entre \if{ et la parenthèse fermante
	      ch = chaineAAnalyser.substring(jdeb + 4, indparf).trim();
	      pValeur = this.pointeur(NatCal.NTteValPourComDynSaufFonc, ch, indicecommentaire);
	      if (pValeur === null) j = indparf + 1;else {
	        this.listeValeursDynamiquesUtilisees.add(pValeur);
	        j = indparf + 1;
	      }
	    }
	  }
	};
	
	CLatex.prototype.positionne = function (infoRandom, dimf) {
	  // this.chaineLatex = this.chaineCommentaire;
	  if (this.listeValeursDynamiquesUtilisees.longueur() !== 0) {
	    var ch = this.traiteCodesLatex(this.chaineCommentaire);
	    this.isToBeUpdated = ch !== this.chaineLatex;
	    this.chaineLatex = ch;
	  } else {
	    this.chaineLatex = this.chaineCommentaire;
	    this.isToBeUpdated = false;
	  }
	  CAffichageLieAPoint.prototype.positionne.call(this, infoRandom, dimf);
	};
	
	/**
	 * Fonction préparant l'affichage par MathJax en créant un div provisoire
	 * @param {boolean} bMemeMasque : Si true la prépartion de fait même si l'affichage est caché (sert dans
	 * la boîte de dialogue de protocole)
	 */
	CLatex.prototype.setReady4MathJax = function (bMemeMasque) {
	  // Modifié version 5.0.4 pour tenir compte des objts dupliqués d'un CLaTeX
	  // qui est masqué
	  var memeMasque = arguments.length === 0 ? false : bMemeMasque;
	  if (!this.masque || this.hasDuplicate || memeMasque) {
	    this.div = kernel.ce("div", {
	      // style : this.styleLatex,
	      style: this.getStyleLatex(),
	      id: this.id + "prov",
	      class: "text2jax_ignore"
	    });
	    var ch = "$$" + this.prelatex() + this.chaineLatex + "$$";
	    this.div.appendChild(document.createTextNode(ch));
	    document.body.appendChild(this.div);
	    MathJax.Hub.Queue(["Typeset", MathJax.Hub, this.div]);
	  }
	};
	
	CLatex.prototype.createg = function () {
	  var w, h;
	  var g = kernel.cens("g");
	  try {
	    // Modifié version mtgApp
	    var c1 = this.div.childNodes[1];
	    if (c1 === undefined) {
	      this.deleteDiv();
	      return g;
	    }
	    var c2 = c1.childNodes[0];
	    if (c2 === undefined) {
	      this.deleteDiv();
	      return g;
	    }
	    var s = c2.childNodes[0];
	    if (s === undefined) {
	      this.deleteDiv();
	      return g;
	    }
	    // Pour gérer Chrome
	    while (s.tagName == "SPAN") {
	      s = s.childNodes[0];
	    } // Le test suivant est du à la compatibilité avec l'explorer
	    if (s.clientWidth !== 0 && s.clientHeight !== 0) {
	      w = s.clientWidth;
	      h = s.clientHeight;
	    } else {
	      // Modifié version 5.0.1
	      // var b = s.getBBox();
	      // ratio = b.height/b.width;
	      // w = this.div.clientWidth;
	      // h = w*ratio;
	      // Incompatible avec version 2.3 de MathJax
	      // w = s.width.animVal.value;
	      // h = s.height.animVal.value;
	      w = c2.clientWidth;
	      h = c2.clientHeight;
	    }
	    var t = Fonte.tailleLatex(this.taillePolice); // Modifié 5.0.2
	    if (h < t) h = t;
	    this.rectAff.width = w;
	    this.rectAff.height = h;
	    this.rectAff.x = this.x_nom + this.dec_x;
	    this.rectAff.y = this.y_nom + this.dec_y;
	    switch (this.alignementHorizontal) {
	      case CAffichageLieAPoint.alignementHorizontalCentre:
	        this.decHor = this.rectAff.width / 2;
	        break;
	      case CAffichageLieAPoint.alignementHorizontalDroit:
	        this.decHor = this.rectAff.width;
	        break;
	      default:
	        this.decHor = 0;
	    }
	    this.rectAff.x -= this.decHor;
	    switch (this.alignementVertical) {
	      case CAffichageLieAPoint.alignementVerticalCentre:
	        this.decVer = this.rectAff.height / 2;
	        break;
	      case CAffichageLieAPoint.alignementVerticalBas:
	        this.decVer = this.rectAff.height + 2;
	        break;
	      default:
	        this.decVer = 0;
	    }
	    this.rectAff.y -= this.decVer;
	    this.rectAff.width += 4;
	    this.rectAff.height += 4;
	
	    var clone = s.cloneNode(true);
	    clone.setAttribute("x", this.rectAff.x.toString() + "px");
	    clone.setAttribute("y", this.rectAff.y.toString() + "px");
	    clone.setAttribute("width", w + "px");
	    clone.setAttribute("height", h + "px");
	    clone.setAttribute("style", "");
	    g.appendChild(clone);
	    /*
	    s.setAttribute("x", (this.rectAff.x).toString()+"px");
	    s.setAttribute("y", (this.rectAff.y).toString()+"px");
	    s.setAttribute("width", w+"px");
	    s.setAttribute("height",h+"px");
	    s.setAttribute("style","");
	    g.appendChild(s.parentNode.removeChild(s));
	    */
	
	    // svg.appendChild(s);
	    // var v = document.getElementById(this.id + "prov");
	    if (this.effacementFond || this.encadrement !== StyleEncadrement.Sans) this.creeRectangle(g, this.couleurFond);
	    // document.body.removeChild(this.div);
	    this.deleteDiv();
	    g.setAttribute("pointer-events", "none");
	    // Ajout version 5.0.1 pour compatibilité avec l'explorer qui ne clipe pas correctement
	    // Supprimé version mtgAppcar pour des lieux d'objets de LaTeX liés à un point lié le point lié peut être hors-fenêtre
	    /*
	    if ((this.pointLie !== null) && !this.pointLie.dansFenetre)
	      g.setAttribute("visibility", "hidden");
	    else g.setAttribute("visibility", "visible");
	    */
	    g.setAttribute("visibility", "visible");
	    // Ajout version MtgApp pour pouvoir déplacer un CEditeurEquation
	    if (this.owner !== null) this.g = g;
	
	    //
	    return g;
	  } catch (e) {
	    this.deleteDiv();
	    return g; //Retourne un g vide en cas de problème
	  }
	};
	
	CLatex.prototype.setReady4MathJaxUpdate = function () {
	  if (this.isToBeUpdated || this.g.childNodes.length === 0) this.setReady4MathJax();
	};
	
	CLatex.prototype.update = function (svg) {
	  var oldg = this.g;
	  if (!this.isToBeUpdated && oldg.childNodes.length !== 0) {
	    var brect = this.effacementFond || this.encadrement !== StyleEncadrement.Sans;
	    // Modification version 5.0.1
	    var newx = this.x_nom + this.dec_x - this.decHor;
	    var newy = this.y_nom + this.dec_y - this.decVer;
	    if (newx !== this.rectAff.x || newy !== this.rectAff.y) {
	      this.rectAff.x = newx;
	      this.rectAff.y = newy;
	      // var s = oldg.childNodes[brect ? ((this.encadrement === StyleEncadrement.Simple) ?  1 : 2) : 0];
	      var s = oldg.childNodes[oldg.childNodes.length - 1];
	      s.setAttribute("x", newx.toString() + "px");
	      s.setAttribute("y", newy.toString() + "px");
	      if (brect) this.remplaceRectangle(oldg, this.couleurFond);
	      // Supprimé version 5.0.1
	      // svg.replaceChild(oldg, oldg); // Rajouté version 4.9.2 pour des pbs de raffraichissement sous Android Firefox
	    }
	  } else {
	    var g = this.createg();
	    svg.replaceChild(g, oldg);
	    g.setAttribute("id", this.id);
	    this.g = g;
	  }
	  // Ajout version 5.0.1
	  if (this.pointLie !== null && !this.pointLie.dansFenetre) this.g.setAttribute("visibility", "hidden");else this.g.setAttribute("visibility", "visible");
	};
	
	CLatex.prototype.parametres = function (nbArg, ch, debut, fin) {
	  var len, i, j, codePar, ind2, car, k;
	  ind2 = -1;
	  len = ch.length;
	  var chret = new Array(nbArg);
	  i = debut;
	  for (j = 0; j < nbArg; j++) {
	    if (i >= len) return null;
	    // On saute les espaces et les retours chariot
	    while ((ch.charAt(i) === ' ' || ch.charAt(i) === '\n') && i < len - 1) {
	      i++;
	    }if (ch.charAt(i) !== '{') {
	      return null;
	    }
	    codePar = 1;
	    ind2 = i + 1;
	    while (ind2 < len) {
	      car = ch.charAt(ind2);
	      if (car === '{') codePar++;else if (car === '}') codePar--;
	      if (codePar === 0) break;else ind2++;
	    }
	    if (codePar !== 0) return null;
	    // On retire les éventuels espaces de fin
	    k = ind2 - 1;
	    while (ch.charAt(k) === ' ') {
	      k--;
	    }chret[j] = ch.substring(i + 1, k + 1);
	    i = ind2 + 1;
	  }
	  fin.setValue(ind2);
	  return chret;
	};
	/**
	 * Fonction traitant les codes LaTeX spécifiques à MathGraph32.
	 * Pour plus de renseignements sur ces codes spéciaux, voir l'aide en ligne dans MathGraph32 (appuyer sur F1).
	 * @param {String} ch : La chaîne contenant les codes.
	 * @returns {String}
	 */
	CLatex.prototype.traiteCodesLatex = function (ch) {
	  var ideb, param, chremp, len;
	  var fin = new Pointeur(0);
	  // Les codes \If peuvent être imbriqués les uns dans les autres. Il faut les rechecher tant
	  // qu'il y en a et les traiter depuis le début.
	  while ((ideb = ch.indexOf("\\If", 0)) !== -1) {
	    param = this.parametres(3, ch, ideb + 3, fin);
	    if (param === null) {
	      ch = ch.substring(0, ideb) + CLatex.errorIf;
	      break;
	    } else {
	      chremp = this.traiteCodeIf(param);
	      len = ch.length;
	      if (fin.getValue() === len - 1) ch = ch.substring(0, ideb) + chremp;else ch = ch.substring(0, ideb) + chremp + ch.substring(fin.getValue() + 1, len);
	    }
	  }
	  // Traitement des codes \Val
	  while ((ideb = ch.indexOf("\\Val", 0)) !== -1) {
	    param = this.parametres(1, ch, ideb + 4, fin);
	    if (param === null) {
	      ch = ch.substring(0, ideb) + CLatex.errorVal;
	      break;
	    } else {
	      chremp = "";
	      try {
	        chremp = this.traiteCodeVal(param[0]);
	        len = ch.length;
	        if (fin.getValue() === len - 1) ch = ch.substring(0, ideb) + chremp;else ch = ch.substring(0, ideb) + chremp + ch.substring(fin.getValue() + 1, len);
	      } catch (e) {
	        ch = ch.substring(0, ideb) + CLatex.errorVal;
	      }
	    }
	  }
	  // Traitement des codes \FracRed
	  while ((ideb = ch.indexOf("\\FracRed", 0)) !== -1) {
	    param = this.parametres(1, ch, ideb + 8, fin);
	    if (param === null) {
	      ch = ch.substring(0, ideb) + CLatex.errorFrac;
	      break;
	    }
	    chremp = this.traiteCodeFracRed(param[0]);
	    len = ch.length;
	    if (fin.getValue() === len - 1) ch = ch.substring(0, ideb) + chremp;else ch = ch.substring(0, ideb) + chremp + ch.substring(fin.getValue() + 1, len);
	  }
	  // Traitement des codes \ForSimp. A faire iméprativement avant les \For
	  while ((ideb = ch.indexOf("\\ForSimp", 0)) !== -1) {
	    param = this.parametres(1, ch, ideb + 8, fin);
	    if (param === null) {
	      ch = ch.substring(0, ideb) + CLatex.errorForSimp;
	      break;
	    }
	    chremp = this.traiteCodeForSimp(param[0]);
	    len = ch.length;
	    if (fin.getValue() === len - 1) ch = ch.substring(0, ideb) + chremp;else ch = ch.substring(0, ideb) + chremp + ch.substring(fin.getValue() + 1, len);
	  }
	  // Traitement des codes \For
	  while ((ideb = ch.indexOf("\\For", 0)) !== -1) {
	    param = this.parametres(1, ch, ideb + 4, fin);
	    if (param === null) {
	      ch = ch.substring(0, ideb) + CLatex.errorFor;
	      break;
	    }
	    chremp = this.traiteCodeFor(param[0]);
	    len = ch.length;
	    if (fin.getValue() === len - 1) ch = ch.substring(0, ideb) + chremp;else ch = ch.substring(0, ideb) + chremp + ch.substring(fin.getValue() + 1, len);
	    ideb = fin.getValue() + 1;
	  }
	  // Traitement des codes \CalcSimp. A faire impérativement avant les \Calc
	  while ((ideb = ch.indexOf("\\CalcSimp", 0)) !== -1) {
	    param = this.parametres(1, ch, ideb + 9, fin);
	    if (param === null) {
	      ch = ch.substring(0, ideb) + CLatex.errorCalcSimp;
	      break;
	    }
	    chremp = this.traiteCodeCalcSimp(param[0]);
	    len = ch.length;
	    if (fin.getValue() === len - 1) ch = ch.substring(0, ideb) + chremp;else ch = ch.substring(0, ideb) + chremp + ch.substring(fin.getValue() + 1, len);
	  }
	  // Traitement des codes \Calc
	  while ((ideb = ch.indexOf("\\Calc", 0)) !== -1) {
	    param = this.parametres(1, ch, ideb + 5, fin);
	    if (param === null) {
	      ch = ch.substring(0, ideb) + CLatex.errorCalc;
	      break;
	    }
	    chremp = this.traiteCodeCalc(param[0]);
	    len = ch.length;
	    if (fin.getValue() === len - 1) ch = ch.substring(0, ideb) + chremp;else ch = ch.substring(0, ideb) + chremp + ch.substring(fin.getValue() + 1, len);
	  }
	  return ch;
	};
	/**
	 * Fonction traitant les codes \Val permettant d'insérer la représentation décimale
	 * d'un calcul réel ou complexe ou d'une variable dans l'affichage.
	 * @param {Array} param : Tableau de chaînes contenant les codes.
	 * @returns {String} : La chaîne traitée.
	 */
	CLatex.prototype.traiteCodeVal = function (param) {
	  // On sépare cette chaine avec les virgules
	  var st, nomvaleur, indfin, pValeur, chnbdec, nbdecimales, chplus, signePlusImpose, nombre;
	  var chnombre = "";
	  st = param.split(/\s*,\s*/);
	  if (st.length !== 0) {
	    nomvaleur = st[0];
	    indfin = this.listeValeursDynamiquesUtilisees.longueur() - 1;
	    pValeur = this.listeValeursDynamiquesUtilisees.pointeurParNatureCalcul(NatCal.NTteValPourComDynSaufFonc, nomvaleur, indfin);
	    if (pValeur !== null) {
	      // Si la valeur n'existe pas, on ne l'inclut pas dans la chaîne à afficher
	      if (pValeur.existe) {
	        if (st.length >= 2) {
	          chnbdec = st[1];
	          if (chnbdec === "+") {
	            chnombre = pValeur.rendChaineValeurPourCommentaire(2);
	            if (chnombre.indexOf("-") === 0) chnombre = " -" + chnombre.substring(1);else chnombre = " +" + chnombre;
	          } else {
	            // On retire les espaces de début
	            chnbdec = chnbdec.trim();
	            nbdecimales = parseInt(chnbdec);
	            chnombre = pValeur.rendChaineValeurPourCommentaire(nbdecimales) + " ";
	            // Si le troisième paramètre :
	            // commence par + : on impose un signe + devant l'affichage si le nombre est positif ou nul
	            // finit par un zéro : on impose un signe + devant l'affichage si le nombre est positif ou nul
	            // et on n'affiche rien si le nombre est nul
	            // finit par 1 : on n'affiche pas le nombre si le nombre est égal à 1 et on affiche un signe - sil est égal à -1
	            if (st.length >= 3) {
	              chplus = st[2];
	              // On retire les éventuels espaces de début
	              chplus = chplus.trim();
	              signePlusImpose = chplus.indexOf("+") === 0;
	              if (signePlusImpose) {
	                if (chnombre.indexOf("-") === 0) chnombre = " -" + chnombre.substring(1);else chnombre = " +" + chnombre;
	              }
	              if (chplus.indexOf("0") === chplus.length - 1) {
	                nombre = pValeur.rendValeur();
	                if (nombre === 0) return " ";
	              } else {
	                nombre = pValeur.rendValeur();
	                if (chplus.indexOf("1") === chplus.length - 1) {
	                  if (nombre === 1) return signePlusImpose ? " + " : " ";else if (nombre === -1) return " - ";
	                }
	              }
	            }
	          }
	        } else {
	          // Si le nombre de décimales n'est pas précisé, on en met deux par défaut
	          return pValeur.rendChaineValeurPourCommentaire(2);
	        }
	      }
	    }
	  } else return CLatex.errorVal;
	  return chnombre;
	};
	/**
	 * Fonction traitant les codes \FracRed permettant d'insérer une fraction
	 * qui est la fraction réduite représentant un quotient de deux entiers.
	 * @param {Array} param : Tableau de chaînes contenant les codes..
	 * @returns {String} : La chaîne traitée.
	 */
	CLatex.prototype.traiteCodeFracRed = function (param) {
	  var st, nomvaleur1, indfin, pValeurNum, num, nomvaleur2, pValeurDen, den, numabs, denabs, signePlusImpose, chsig, g, num1, den1, positif;
	  // On sépare cette chaine avec les virgules
	  var res = " ";
	  st = param.split(/\s*,\s*/);
	  if (st.length !== 0) {
	    nomvaleur1 = st[0];
	    // On recherche si c'est bien le nom d'une valeur valide
	    // Il ne faut pas que la valeur ait été définie après l'affichage de valeur
	    // Si c'est le nom d'une valeur utilisée, elle est comprise dans la
	    // liste listeValeursDynamiquesUtilisees
	    indfin = this.listeValeursDynamiquesUtilisees.longueur() - 1;
	    pValeurNum = this.listeValeursDynamiquesUtilisees.pointeurParNatureCalcul(NatCal.NTteValRPourComDyn, nomvaleur1, indfin);
	    if (pValeurNum === null) return CLatex.errorFrac;
	    if (pValeurNum.existe) {
	      num = pValeurNum.rendValeur(false);
	      if (st.length >= 2) {
	        nomvaleur2 = st[1];
	        pValeurDen = this.listeValeursDynamiquesUtilisees.pointeurParNatureCalcul(NatCal.NTteValRPourComDyn, nomvaleur2, indfin);
	        if (pValeurDen === null) return CLatex.errorFrac;
	        if (pValeurDen.existe) {
	          den = pValeurDen.rendValeur();
	          if (den === 0) return CLatex.errorFrac;
	          numabs = Math.abs(num);
	          denabs = Math.abs(den);
	          if (numabs !== Math.floor(numabs) || numabs > kernel.Max_VALUE || denabs !== Math.floor(denabs) || denabs > kernel.Max_VALUE || denabs === 0) return CLatex.errorFrac;else {
	            signePlusImpose = false;
	            chsig = "";
	            if (st.length >= 3) {
	              chsig = st[2];
	              if (chsig.indexOf("+") === 0) signePlusImpose = true;
	            }
	            if (num === 0 && chsig !== "" && chsig.charAt(chsig.length - 1) === "0") return " ";
	            g = kernel.pgcd(numabs, denabs);
	            num1 = numabs / g;
	            den1 = denabs / g;
	            positif = num * den >= 0;
	            if (kernel.zero13(den1 - 1)) {
	              if (kernel.zero13(num1 - 1) && chsig !== "" && chsig.charAt(chsig.length - 1) === "1") {
	                if (positif) return signePlusImpose ? " + " : " ";else return " - ";
	              }
	              res = kernel.chaineNombre(num1, 0);
	            } else res = " \\frac{" + kernel.chaineNombre(num1, 0) + "}{" + kernel.chaineNombre(den1, 0) + "} ";
	            if (positif && signePlusImpose) res = " +" + res;else if (!positif) res = " -" + res;
	            return res;
	          }
	        }
	      }
	    }
	  }
	  return res;
	};
	/**
	 * Fonction traitant les codes \If permettant d'avoir un affichage conditionnel
	 * La syntaxe est \If{Test}{Affichage si 1}{AffichageSinon}
	 * @param {Array} param : Tableau de chaînes contenant les codes.
	 * @returns {String} : La chaîne égale au résultat du test .
	 */
	CLatex.prototype.traiteCodeIf = function (param) {
	  var pValeurNum, num;
	  var indfin = this.listeValeursDynamiquesUtilisees.longueur() - 1;
	  // Modifié version 4.7.2
	  // CValDyn pValeurNum = latex.listeValeursDynamiquesUtilisees.pointeurValeurOuFonction(nomvaleur,indfin);
	  pValeurNum = this.listeValeursDynamiquesUtilisees.pointeurParNatureCalcul(NatCal.NTteValPourComDynSaufFonc, param[0], indfin);
	  if (pValeurNum === null) return CLatex.errorIf;
	  if (pValeurNum.existe) {
	    if (pValeurNum.getNatureCalcul() === NatCal.NCalculComplexe) {
	      var z = new Complexe();
	      pValeurNum.rendValeurComplexe(z);
	      if (z.x === 1 && z.y === 0) return param[1];else return param[2];
	    } else {
	      if (pValeurNum.estDeNatureCalcul(NatCal.NTteValRPourComDyn)) {
	        num = pValeurNum.rendValeur();
	        if (num === 1) return param[1];else return param[2];
	      } else return param[2];
	    }
	  } else return param[2];
	};
	/**
	 * Fonction traitant les codes \For permettant d'obtenir le codeLaTex d'un calcul ou une fonction.
	 * Les calculs ou variables utilisés dans la fonction ne sont pas remplacés par leur valeur.
	 * La syntaxe est \For{a} où a est le nom d'une calcul ou d'une fonction.
	 * @param {String} param : La chaîne à traiter.
	 * @returns {String} : La chaîne contenant le code LaTeX.
	 */
	CLatex.prototype.traiteCodeFor = function (param) {
	  var indfin, calcul, varFor;
	  indfin = this.listeValeursDynamiquesUtilisees.longueur() - 1;
	  calcul = this.listeValeursDynamiquesUtilisees.pointeurParNatureCalcul(NatCal.NTteValPourComDyn, param, indfin);
	  if (calcul !== null) {
	    varFor = calcul.variableFormelle();
	    return calcul.calcul.chaineLatexSansPar(varFor);
	  } else return CLatex.errorFor;
	};
	/**
	 * Fonction traitant les codes \Calc permettant d'afficher la formule d'un calcul ou une fonction
	 * Cette formule est rénvoyée telle qu'elle serait écrite (avec les signes * de multiplication).
	 * Le code renvoyé n'est pas un code LaTeX.
	 * Les calculs ou variables utilisés dans la formule ne sont pas remplacés par leur valeur.
	 * La syntaxe est \Calc{a} où a est le nom d'une calcul ou d'une fonction.
	 * @param {String} param : La chaîne contenant les codes.
	 * @returns {String} : La chaîne contenant la formule.
	 */
	CLatex.prototype.traiteCodeCalc = function (param) {
	  var indfin, calcul, varFor, nbv, k, chret, stb, i;
	  indfin = this.listeValeursDynamiquesUtilisees.longueur() - 1;
	  calcul = this.listeValeursDynamiquesUtilisees.pointeurParNatureCalcul(NatCal.NTteValPourComDyn, param, indfin);
	  if (calcul !== null) {
	    varFor = null;
	    if (calcul.estDeNatureCalcul(Nat.or(NatCal.NFonction, NatCal.NFonctionComplexe))) {
	      varFor = new Array(1);
	      varFor[0] = calcul.chaineVariable;
	    } else {
	      if (calcul.estDeNatureCalcul(Nat.or(NatCal.NFonction2Var, NatCal.NFonction3Var, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var))) {
	        nbv = calcul.nbVar;
	        varFor = new Array(nbv);
	        for (k = 0; k < nbv; k++) {
	          varFor[k] = calcul.chaineVariable[k];
	        }
	      }
	    }
	    // chret = "\\text{" + calcul.calcul.chaineCalculSansPar(varFor) + "}"; //.Modifié version 4.9.2.3
	    chret = calcul.calcul.chaineCalculSansPar(varFor);
	    // Il faut remplacer les caractères ^ par \^{}
	    stb = chret;
	    for (i = 0; i < stb.length; i++) {
	      if (stb.charAt(i) === '^') {
	        // stb.replace(i, i+1, "\\;\\^{}\\;");
	        // stb = stb.substring(0, i-1) + "\\;\\^{}\\;" + stb.substring(i+1); //.Modifié version 4.9.2.3
	        stb = stb.substring(0, i) + " \\;\\widehat{\\;\\;}\\; " + stb.substring(i + 1);
	        i = i + 8;
	      }
	    }
	    return stb.toString();
	  } else return CLatex.errorCalc;
	};
	/**
	 * Fonction traitant les codes \Calc permettant d'afficher la formule d'un calcul ou une fonction
	 * Cette formule est rénvoyée telle qu'elle serait écrite (avec les signes * de multiplication).
	 * Le code renvoyé n'est pas un code LaTeX.
	 * Les calculs ou variables utilisés dans la formule sont remplacés par leur valeur.
	 * L'expression du calcul est simplifiée le plus possible (par exemple les termes nuls d'une somme
	 * ne sont pas écrits, 1*x est remplacé par x).
	 * La syntaxe est \Calc{a} où a est le nom d'une calcul ou d'une fonction.
	 * @param {String} param : La chaîne contenant les codes.
	 * @returns {String} : La chaîne contenant la formule.
	 */
	CLatex.prototype.traiteCodeCalcSimp = function (param) {
	  var indfin, calcul, varFor, chret, stb, i;
	  indfin = this.listeValeursDynamiquesUtilisees.longueur() - 1;
	  calcul = this.listeValeursDynamiquesUtilisees.pointeurParNatureCalcul(NatCal.NTteValPourComDyn, param.toString(), indfin);
	  if (calcul !== null) {
	    varFor = calcul.variableFormelle();
	    chret = "\\text{" + calcul.calcul.calculAvecValeursRemplacees().calculNormalise(true, false, false).chaineCalculSansPar(varFor) + "}";
	    // Il faut remplacer les caractères ^ par \^{}
	    stb = chret;
	    for (i = 0; i < stb.length; i++) {
	      if (stb.charAt(i) === '^') {
	        stb = stb.substring(0, i - 1) + "\\;\\^{}\\;" + stb.substring(i + 1);
	        i = i + 8;
	      }
	    }
	    return stb.toString();
	  } else return CLatex.errorCalcSimp;
	};
	/**
	 * Fonction traitant les codes \For permettant d'obtenir le codeLaTex d'un calcul ou une fonction.
	 * Les calculs ou variables utilisés dans la fonction sont pas remplacés par leur valeur.
	 * L'expression du calcul est simplifiée le plus possible (par exemple les termes nuls d'une somme
	 * ne sont pas écrits, 1*x est remplacé par x).
	 * La syntaxe est \For{a} où a est le nom d'une calcul ou d'une fonction.
	 * @param {String} param : La chaîne à traiter.
	 * @returns {String} : La chaîne contenant le code LaTeX.
	 */
	
	CLatex.prototype.traiteCodeForSimp = function (param) {
	  var indfin, calcul, varFor;
	  indfin = this.listeValeursDynamiquesUtilisees.longueur() - 1;
	  calcul = this.listeValeursDynamiquesUtilisees.pointeurParNatureCalcul(NatCal.NTteValPourComDyn, param, indfin);
	  if (calcul !== null) {
	    varFor = calcul.variableFormelle();
	    return calcul.calcul.calculAvecValeursRemplacees().calculNormalise(true, false, false).chaineLatexSansPar(varFor);
	  } else return CLatex.errorForSimp;
	};
	/**
	 * Fonction renvoyant l'indice de l'accolade fermante acorrespondant à celle d'indice
	 * pdebut dans chaine.
	 * @param {String} chaine : La chaine dans laquelle se fait la recherche. Le caractère
	 * d'indice pdebut doit être un {
	 * @param {Integer} pdebut : L'indice du premier caractère de la recherche qui pointe sur une {
	 * @returns {Integer} : L'indice de la parenthèse fermante ou -1 s'il n'y en a pas.
	 */
	CLatex.accoladeFermante = function (chaine, pdebut) {
	  var p;
	  var ch;
	  var somme;
	
	  somme = 1;
	  p = pdebut + 1;
	  while (p < chaine.length) {
	    ch = chaine.charAt(p);
	    if (ch === '{') somme++;else {
	      if (ch === '}') somme--;
	    }
	    if (somme === 0) break;
	    p++;
	  }
	  if (somme === 0) return p;else return -1; // On renvoie -1 si pas trouvé
	};
	/**
	 * Fonction écrite pour pallier le mauvais rendu des accents en svg par MathJax.
	 * Remplace les caractères accentués utilsiés dans des \text par des codes LaTeX.
	 * @param {String} ch : La chaîne à traiter.
	 * @returns {String} : La cahîne traitée.
	 */
	CLatex.traiteAccents = function (ch) {
	  var indpf, st, i, car, car2, bool, ind;
	  var a = "éèàùâêôî";
	  var b = ["acute", "grave", "grave", "grave", "hat", "hat", "hat", "hat"];
	  var c = "eeauaeoi";
	  bool = false;
	  for (i = 0; i < a.length; i++) {
	    bool = bool || ch.indexOf(a.charAt(i)) !== 0;
	  }if (!bool || ch.indexOf("\\text{") === -1) return ch;
	  var res = "";
	  var inddeb = 0;
	  while ((ind = ch.indexOf("\\text{", inddeb)) !== -1 && inddeb < ch.length) {
	    indpf = CLatex.accoladeFermante(ch, ind + 6);
	    if (indpf === -1) break;
	    res = res + ch.substring(inddeb, ind);
	    st = ch.substring(ind + 6, indpf + 1);
	    for (i = 0; i < a.length; i++) {
	      car = a.charAt(i);
	      car2 = c.charAt(i);
	      if (st.charAt(0) === car) st = "\\" + b[i] + "{" + car2 + "}" + "\\text{" + st.substring(1);
	      if (st.charAt(st.length - 1) === car) st = st.substring(0, st.length - 1) + "\\" + b[i] + "{" + car2 + "}";
	      st = st.replace(new RegExp(car, "g"), "}\\" + b[i] + "{" + car2 + "} \\text{");
	    }
	    // Impossible de traite le c cédille
	    st = st.replace(new RegExp("ç", "g"), "c");
	    bool = false;
	    for (i = 0; i < a.length; i++) {
	      bool = bool || st.indexOf("\\" + b[i]) === 0;
	    }if (bool) res = res + st;else res = res + "\\text{" + st;
	    inddeb = indpf + 1;
	  }
	  if (inddeb < ch.length) res = res + ch.substring(inddeb);
	  return res;
	};
	
	CLatex.prototype.read = function (inps, list) {
	  CCommentaire.prototype.read.call(this, inps, list);
	  this.chaineCommentaire = CLatex.traiteAccents(this.chaineCommentaire);
	};
	/**
	 * Fonction remplaçant dans this.commentairre les appels dynamiques de calcul,
	 * fonction ou variable nommé ancienNom par nouveauNom.
	 * @param {String} ancienNom
	 * @param {String} nouveauNom
	 * @returns {Boolean} : la chaîne traitée.
	 */
	CLatex.prototype.remplaceNomValeurDynamique = function (ancienNom, nouveauNom) {
	  // On supprime d'abord tous les caractères espace suivant un { ou une virgule ou précédant une accolade
	  var buffer = this.chaineCommentaire;
	  var chaineInitiale = buffer;
	  var ind;
	  while ((ind = buffer.indexOf("\\Val{ ", 0)) !== -1) {
	    buffer.deleteCharAt(ind + 5);
	  }
	  while ((ind = buffer.indexOf("\\For{ ", 0)) !== -1) {
	    buffer.deleteCharAt(ind + 5);
	  }
	  while ((ind = buffer.indexOf("\\ForSimp{ ", 0)) !== -1) {
	    buffer.deleteCharAt(ind + 9);
	  }
	  while ((ind = buffer.indexOf("\\Calc{ ", 0)) !== -1) {
	    buffer.deleteCharAt(ind + 6);
	  }
	  while ((ind = buffer.indexOf("\\CalcSimp{ ", 0)) !== -1) {
	    buffer.deleteCharAt(ind + 10);
	  }
	  while ((ind = buffer.indexOf("\\FracRed{ ", 0)) !== -1) {
	    buffer.deleteCharAt(ind + 9);
	  }
	  var ch1 = "\\\\Val\\{" + ancienNom + "\\}";
	  var ch2 = "\\Val{" + nouveauNom + "}";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\Val{" + ancienNom + " ";
	  ch2 = "\\Val{" + nouveauNom + " ";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\Val{" + ancienNom + ",";
	  ch2 = "\\Val{" + nouveauNom + ",";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\For{" + ancienNom + "}";
	  ch2 = "\\For{" + nouveauNom + "}";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\For{" + ancienNom + " ";
	  ch2 = "\\For{" + nouveauNom + " ";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\ForSimp{" + ancienNom + "}";
	  ch2 = "\\ForSimp{" + nouveauNom + "}";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\ForSimp{" + ancienNom + " ";
	  ch2 = "\\ForSimp{" + nouveauNom + " ";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\Calc{" + ancienNom + "}";
	  ch2 = "\\Calc{" + nouveauNom + "}";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\Calc{" + ancienNom + " ";
	  ch2 = "\\Calc{" + nouveauNom + " ";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\CalcSimp{" + ancienNom + "}";
	  ch2 = "\\CalcSimp{" + nouveauNom + "}";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\CalcSimp{" + ancienNom + " ";
	  ch2 = "\\CalcSimp{" + nouveauNom + " ";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\FracRed{" + ancienNom + ",";
	  ch2 = "\\FracRed{" + nouveauNom + ",";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\FracRed{" + ancienNom + " ";
	  ch2 = "\\FracRed{" + nouveauNom + " ";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\If{" + ancienNom + "}";
	  ch2 = "\\If{" + nouveauNom + "}";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "\\\\If{" + ancienNom + " ";
	  ch2 = "\\If{" + nouveauNom + " ";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  this.chaineCommentaire = buffer;
	  this.remplaceNomValeurDynamiqueApresVirgule("\\FracRed{", ancienNom, nouveauNom);
	  return chaineInitiale !== this.chaineCommentaire;
	};
	/**
	 * Fonction recherchant dans les codes spéciaux utilisant une virgue ancienNom et le replaçant par nouveauNom.
	 * @param {String} code : contient  \FracRed qui est pour le moment le seul code avec virgules
	 * dont le deuxième argument peut être le nom d'un calcul ou une variable.
	 * @param {String} ancienNom : Le nom de calcul, variable ou fonction à remplacer.
	 * @param {String} nouveauNom : Le nom du calcul, variable ou fonction qui remplace.
	 * @returns {undefined}
	 */
	CLatex.prototype.remplaceNomValeurDynamiqueApresVirgule = function (code, ancienNom, nouveauNom) {
	  var ind = 0;
	  while ((ind = this.chaineCommentaire.indexOf(code, ind)) !== -1) {
	    // On recherche la première accolade fermante
	    var indacf = this.chaineCommentaire.indexOf('}', ind + code.length);
	    if (indacf !== -1) {
	      var left = this.chaineCommentaire.substring(0, ind + code.length - 1);
	      var right = this.chaineCommentaire.substring(indacf + 1);
	      var mid = this.chaineCommentaire.substring(ind + code.length - 1, indacf + 1);
	      var ch1 = "," + ancienNom + " ";
	      var ch2 = "," + nouveauNom + " ";
	      mid = mid.replace(new RegExp(ch1, "g"), ch2);
	      ch1 = "," + ancienNom + ",";
	      ch2 = "," + nouveauNom + ",";
	      mid = mid.replace(new RegExp(ch1, "g"), ch2);
	      ch1 = " " + ancienNom + ",";
	      ch2 = " " + nouveauNom + ",";
	      mid = mid.replace(new RegExp(ch1, "g"), ch2);
	      ch1 = " " + ancienNom + " ";
	      ch2 = " " + nouveauNom + " ";
	      mid = mid.replace(new RegExp(ch1, "g"), ch2);
	      ch1 = " " + ancienNom + "}";
	      ch2 = " " + nouveauNom + "}";
	      mid = mid.replace(new RegExp(ch1, "g"), ch2);
	      ch1 = "," + ancienNom + "}";
	      ch2 = "," + nouveauNom + "}";
	      mid = mid.replace(new RegExp(ch1, "g"), ch2);
	      this.chaineCommentaire = left + mid + right;
	    }
	    ind = ind + code.length - 1;
	  }
	};
	CLatex.prototype.chaineDesignation = function () {
	  return "desLatex";
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var Pointeur = __webpack_require__(16);
	var Nat = __webpack_require__(4);
	var CAffichageLieAPoint = __webpack_require__(36);
	var CListeObjets = __webpack_require__(17);
	
	module.exports = CCommentaire;
	
	/**
	 * Classe représentant un affichage de texte sur la figure.
	 * Si le texte est encadré de $ ce sera un affichage LaTeX.
	 * @constructor
	 * @extends CAffichageLieAPoint
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de l'éditeur
	 * @param {Float} y_nom : L'ordonnée d'affichage de l'éditeur
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} encadrement : true si encadré.
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} chaineCommentaire : Le texte à afficher. S'il est entouré de $ ce sera
	 * un affichage LaTeX.
	 * @returns {CCommentaire}
	 */
	function CCommentaire(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, encadrement, effacementFond, couleurFond, alignementHorizontal, alignementVertical, chaineCommentaire) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CAffichageLieAPoint.call(this, listeProprietaire);else {
	      CAffichageLieAPoint.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, encadrement, effacementFond, couleurFond, alignementHorizontal, alignementVertical);
	      this.chaineCommentaire = chaineCommentaire;
	    }
	    this.listeValeursDynamiquesUtilisees = new CListeObjets(listeProprietaire.uniteAngle, listeProprietaire.pointeurLongueurUnite);
	  }
	}
	CCommentaire.prototype = new CAffichageLieAPoint();
	CCommentaire.prototype.constructor = CCommentaire;
	CCommentaire.prototype.superClass = "CAffichageLieAPoint";
	CCommentaire.prototype.className = "CCommentaire";
	
	CCommentaire.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CCommentaire.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var ptelb = new CCommentaire(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.encadrement, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.chaineCommentaire);
	  ptelb.listeValeursDynamiquesUtilisees = new CListeObjets(listeCible.uniteAngle, listeCible.pointeurLongueurUnite);
	  if (listeCible.className !== "CPrototype") ptelb.determineDependances();
	  return ptelb;
	};
	
	CCommentaire.prototype.getNature = function () {
	  return NatObj.NCommentaire;
	};
	
	CCommentaire.prototype.donneChaine = function (chaine) {
	  this.chaineCommentaire = chaine;
	};
	/**
	 * Fonction plaçant l'affichage de texte aux coordonnées (x,y)
	 * @param {Float} x
	 * @param {Float} y
	 * @returns {undefined}
	 */
	CCommentaire.prototype.placeEn = function (x, y) {
	  this.x_nom = x;
	  this.y_nom = y;
	};
	
	CCommentaire.prototype.rendChaineAffichage = function () {
	  return this.chaineAffichage;
	};
	
	CCommentaire.prototype.ajouteAntecedents = function (liste) {
	  if (this.pointLie !== null) liste.add(this.pointLie);
	};
	/**
	 * Fonction renvoyant -1 si this.chaineCommentaire ne contient pas de soous-chaîne
	 * #Val ou \For et sinon renvoie l'indice du premier des deux rencontrés, formule.getValue()
	 * renvoyant true si c'est un #For qui a été trouvé et false sinon.
	 * @param{Integer} indDeb : L'indice du début de la recherche
	 * @param{mtg32.CPointeur} formule
	 **/
	CCommentaire.prototype.indicePremierValOuForm = function (indDeb, formule) {
	  var indVal = this.chaineCommentaire.indexOf("#Val(", indDeb);
	  var indFor = this.chaineCommentaire.indexOf("#For(", indDeb);
	  if (indVal === -1 && indFor === -1) return -1;
	  if ((indVal > indFor || indVal === -1) && indFor !== -1) {
	    formule.setValue(true);
	    return indFor;
	  } else {
	    formule.setValue(false);
	    return indVal;
	  }
	};
	/**
	 * Fonction faisant en sorte que this.listeValeursDynamiquesUtilisees contienne
	 * la liste de tous les objets dont dépend le coomentaire par des appels
	 * à #Val() ou #For()
	 * @returns {undefined}
	 */
	CCommentaire.prototype.determineDependances = function () {
	  var bformule, jdeb, j, len, indparf, indsaut, ch, nomvaleur, indicecommentaire, pValeur;
	  bformule = new Pointeur(true);
	  this.listeValeursDynamiquesUtilisees.retireTout();
	  // On examine la chaine à la recherche de #Val(
	  len = this.chaineCommentaire.length;
	  j = 0;
	  if (this.chaineCommentaire.indexOf("#Val(", j) === -1 && this.chaineCommentaire.indexOf("#For(", j) === -1) return;
	  while ((jdeb = this.indicePremierValOuForm(j, bformule)) !== -1 && j < len) {
	    // On recherche la parenthèse fermante correspondante
	    indparf = this.chaineCommentaire.indexOf(')', jdeb + 5);
	    if (indparf === -1) j = len + 1;else {
	      indsaut = this.chaineCommentaire.indexOf('\n', jdeb + 5);
	      if (indsaut !== -1 && indsaut < indparf) j = indsaut + 1;else {
	        // On crée une chaine formé de ce qu'il y a entre #Val( et la parenthèse fermante
	        ch = this.chaineCommentaire.substring(jdeb + 5, indparf);
	        // On retire les éventuels espaces de cete chaine
	        ch = ch.trim();
	        // On sépare cette chaine avec les virgules
	        var st = ch.split(/\s*,\s*/);
	        if (st.length === 0) j = indparf + 1;else {
	          nomvaleur = st[0];
	          // On recherche si c'est bien le nom d'une valeur valide
	          // Il ne faut pas que la valeur ait été définie après l'affichage de valeur
	          indicecommentaire = this.listeProprietaire.indexOf(this);
	          // Très important : quand determineDependances est appelé
	          // par getClone() de CCommentaire, le commentaire n'a pas encoré été rajouté
	          // à la liste clone et ainsi indiceCommentaire renvoie -1.
	          // dans ce cas, indiceCommentaire doit valoir le nombre d'éléments actuels
	          // de la liste clone qui le possède
	          if (indicecommentaire === -1) indicecommentaire = this.listeProprietaire.longueur() - 1;
	          pValeur = this.pointeur(NatCal.NTteValPourComDyn, nomvaleur, indicecommentaire);
	          if (pValeur === null) j = indparf + 1;else {
	            /** Corrigé version mtgApp
	            natc = pValeur.getNatureCalcul();
	            if ((bformule.getValue() && (Nat.and(natc, NatCal.NCalcRouC |
	                NatCal.NTteFoncRouC))) || !bformule.getValue())
	             */
	            if (bformule.getValue() && pValeur.estDeNatureCalcul(Nat.or(NatCal.NCalcRouC, NatCal.NTteFoncRouC)) || !bformule.getValue()) this.listeValeursDynamiquesUtilisees.add(pValeur);
	            // Si la valeur n'existe pas, on ne l'inclut pas dans la chaîne à afficher
	            j = indparf + 1;
	          }
	        }
	      }
	    }
	  }
	};
	
	CCommentaire.prototype.positionne = function (infoRandom, dimf) {
	  var bformule, len, jdeb, j, indparf, indsaut, ch, st, nomvaleur, indfin, pValeur, natc, chnombre, chnbdec, nbdecimales, chplus;
	  bformule = new Pointeur(true);
	  // On examine la chaine à la recherche de #Val(
	  len = this.chaineCommentaire.length;
	  var bufferAffichage = "";
	  j = 0;
	  if (this.chaineCommentaire.indexOf("#Val(", j) === -1 && this.chaineCommentaire.indexOf("#For(", j) === -1) {
	    this.chaineAffichage = this.chaineCommentaire;
	    CAffichageLieAPoint.prototype.positionne.call(this, infoRandom, dimf);
	    return;
	  }
	  while ((jdeb = this.indicePremierValOuForm(j, bformule)) !== -1 && j < len) {
	    bufferAffichage += this.chaineCommentaire.substring(j, jdeb);
	    // On recherche la parenthèse fermante correspondante
	    indparf = this.chaineCommentaire.indexOf(")", jdeb + 5);
	    if (indparf === -1) {
	      bufferAffichage += this.chaineCommentaire.substring(jdeb, len);
	      j = len + 1;
	    } else {
	      // On recherche aussi un éventuel retour à la ligne
	      indsaut = this.chaineCommentaire.indexOf('\n', jdeb + 5);
	      if (indsaut !== -1 && indsaut < indparf) {
	        bufferAffichage += this.chaineCommentaire.substring(jdeb, indsaut + 2);
	        j = indsaut + 1;
	      } else {
	        // On crée une chaine formé de ce qu'il y a entre #Val( et la parenthèse fermante
	        ch = this.chaineCommentaire.substring(jdeb + 5, indparf);
	        // On retire les éventuels espaces de cete chaine
	        ch = ch.trim();
	        // On sépare cette chaine avec les virgules
	        st = ch.split(/\s*,\s*/);
	        if (st.length === 0) {
	          // Pas de virgule
	          bufferAffichage += this.chaineCommentaire.substring(jdeb, indparf + 1);
	          j = indparf + 1;
	        } else {
	          nomvaleur = st[0];
	          // On recherche si c'est bien le nom d'une valeur valide
	          // Il ne faut pas que la valeur ait été définie après l'affichage de valeur
	          // Si c'est le nom d'une valeur utilisée, elle est comprise dans la
	          // liste listeValeursDynamiquesUtilisees
	          indfin = this.listeValeursDynamiquesUtilisees.longueur() - 1;
	          pValeur = this.listeValeursDynamiquesUtilisees.pointeurParNatureCalcul(NatCal.NTteValPourComDyn, nomvaleur, indfin);
	          if (pValeur === null) {
	            bufferAffichage += this.chaineCommentaire.substring(jdeb, indparf + 1);
	            j = indparf + 1;
	          } else {
	
	            // Si la valeur n'existe pas, on ne l'inclut pas dans la chaîne à afficher
	            if (pValeur.existe) {
	              if (bformule.getValue()) {
	                // L'affichage de formule n'a de sens que pour un calcul ou une fonction
	                natc = pValeur.getNatureCalcul();
	                if (Nat.and(natc, NatCal.NCalcRouC | NatCal.NTteFoncRouC)) bufferAffichage += pValeur.chaineCalcul;
	              } else {
	                chnombre = "";
	                if (st.length >= 2) {
	                  chnbdec = st[1];
	                  if (chnbdec === "+") {
	                    chnombre = pValeur.rendChaineValeurPourCommentaire(2);
	                    if (chnombre.indexOf("-") !== "0") chnombre = "+ " + chnombre;
	                  } else {
	                    // nbdec = parseInt(chnbdec);
	                    nbdecimales = parseInt(chnbdec);
	                    chnombre = pValeur.rendChaineValeurPourCommentaire(nbdecimales);
	                    if (st.length >= 3) {
	                      chplus = st[2];
	                      if (chplus === "+") if (chnombre.indexOf("-") !== 0) chnombre = "+ " + chnombre;
	                    }
	                  }
	                } else {
	                  // Si le nombre de décimales n'est pas précisé, on en met deux par défaut
	                  chnombre = pValeur.rendChaineValeurPourCommentaire(2);
	                }
	                bufferAffichage += chnombre;
	              }
	            }
	            j = indparf + 1;
	          }
	        }
	      }
	    }
	  }
	  if (j < len) bufferAffichage += this.chaineCommentaire.substring(j, len);
	  this.chaineAffichage = bufferAffichage;
	  CAffichageLieAPoint.prototype.positionne.call(this, infoRandom, dimf);
	};
	
	CCommentaire.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CAffichageLieAPoint.prototype.dependDe.call(this, p) || this.listeValeursDynamiquesUtilisees.dependDe(p));
	};
	
	CCommentaire.prototype.dependDePourBoucle = function (p) {
	  return p === this || CAffichageLieAPoint.prototype.dependDePourBoucle.call(this, p) || this.listeValeursDynamiquesUtilisees.dependDePourBoucle(p);
	};
	/**
	 * Fonction renvoyant un pointeur sur l'élément de type calcul de nature nat
	 * et ayant pour nom nom si le commentaire utilise ce calcul pour un affichage
	 * dynamique de valeur. Renvoie null s'il ne l'utilise pas.
	 * @param {Nat} nat
	 * @param {String} nom
	 * @param {Integer} indiceMaxi
	 * @returns {CValDyn}
	 */
	CCommentaire.prototype.pointeur = function (nat, nom, indiceMaxi) {
	  var i, elb, j;
	  // Si le CLatex est un objet final de construction on recherhe d'abord la valeur
	  // dans les objets intermédiaires ou finaux de cette construction
	  // Important : on ne peut pas utiliser impProto car lors de getClone appelé par CImplementationProto.implemente
	  // le membre impProto n'a pas encore été établi
	  // Modifié version 4.5 : Aussi à faire pour les objets intermédiaires car un CLatex ou un CCommentaire peut générer un lieu d'objets.
	  if (this.estElementFinal || this.estElementIntermediaire()) {
	    i = indiceMaxi;
	    while (i >= 0) {
	      elb = this.listeProprietaire.get(i);
	      if (elb.estElementFinal || elb.estElementIntermediaire()) {
	        if (elb.estDeNatureCalcul(nat)) {
	          if (elb.getNom() === nom) return elb;else i--;
	        } else i--;
	      } else break;
	    }
	  }
	  // Sinon on recherche dans tous les objets qui ne sont pas de objets intermédiaires de construction
	  i = 0;
	  j = 0;
	  while (i <= indiceMaxi) {
	    elb = this.listeProprietaire.get(j++);
	    // j++;
	    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(nat)) {
	      if (elb.getNom() === nom) return elb;else i++;
	    } else i++;
	  }
	  return null;
	};
	
	CCommentaire.prototype.chaineDesignation = function () {
	  return "desCommentaire";
	};
	
	CCommentaire.prototype.read = function (inps, list) {
	  var CLatex = __webpack_require__(40);
	
	  CAffichageLieAPoint.prototype.read.call(this, inps, list);
	  this.chaineCommentaire = CLatex.traiteAccents(inps.readUTF());
	  // Ajout version 5.0 pour traiter les $$ et ## représentés par un seul caractère
	  this.chaineCommentaire = this.chaineCommentaire.replace(/\$\$/g, "$");
	  // this.chaineCommentaire = this.chaineCommentaire.replace(/##/g,"#");
	  //
	  this.listeValeursDynamiquesUtilisees = new CListeObjets(list.uniteAngle, list.pointeurLongueurUnite);
	  if (this.listeProprietaire.className !== "CPrototype") this.determineDependances();
	};
	
	CCommentaire.prototype.write = function (oups, list) {
	  CAffichageLieAPoint.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.chaineCommentaire);
	};
	/**
	 * Fonction remmplaçant les appels dynamiques de la valeur nommée ancienNom par nouveauNom
	 * @param {type} ancienNom
	 * @param {type} nouveauNom
	 * @returns {CAffichageLieAPoint.remplaceNomValeurDynamique.modif|Boolean}
	 */
	CCommentaire.prototype.remplaceNomValeurDynamique = function (ancienNom, nouveauNom) {
	  // On supprime d'abord tous les caractères espace suivant une ( ou une virgule ou précédant une parenthèse
	  var ind;
	  var buffer = this.chaineCommentaire;
	  while ((ind = buffer.indexOf("#Val( ")) !== -1) {
	    buffer.deleteCharAt(ind + 5);
	  }
	  while ((ind = buffer.indexOf("#For( ")) !== -1) {
	    buffer.deleteCharAt(ind + 8);
	  }
	  var ch1 = "#Val\(" + ancienNom + "\)";
	  var ch2 = "#Val\(" + nouveauNom + "\)";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "#Val\\(" + ancienNom + " ";
	  ch2 = "#Val\\(" + nouveauNom + " ";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "#Val\\(" + ancienNom + ",";
	  ch2 = "#Val\\(" + nouveauNom + ",";
	  buffer = buffer.replace(new RegExp(ch1, "g"), ch2);
	  ch1 = "#For\\(" + ancienNom + "\)";
	  ch2 = "#For\\(" + nouveauNom + "\)";
	  buffer = buffer.replace(ch1, ch2);
	  ch1 = "#For\\(" + ancienNom + " ";
	  ch2 = "#For\\(" + nouveauNom + " ";
	  buffer = buffer.replace(ch1, ch2);
	  var modif = buffer !== this.chaineCommentaire;
	  this.chaineCommentaire = buffer;
	  return modif;
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	// const CFonc = require('./CFonc')
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	
	module.exports = CAppelFonction;
	
	/**
	 * Objet d'un arbre binaire de calcul représentant un appel de fonction réelle utilisateur.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CCalculAncetre} fonctionAssociee : Peut pointer sur une fonction ou une suite.
	 * @param {type} operande : L'opérande dont on cherche l'image.
	 * @returns {CAppelFonction}
	 */
	function CAppelFonction(listeProprietaire, fonctionAssociee, operande) {
	  if (arguments.length === 0) CCb.call(this); // Ajout version WebPack
	  else {
	      CCb.call(this, listeProprietaire);
	      this.fonctionAssociee = fonctionAssociee;
	      this.operande = operande;
	      this.z1loc = new Complexe(); // Ajout version 4.9.7
	    }
	}
	CAppelFonction.prototype = new CCb();
	CAppelFonction.prototype.constructor = CAppelFonction;
	CAppelFonction.prototype.superClass = "CCb";
	CAppelFonction.prototype.className = "CAppelFonction";
	
	CAppelFonction.prototype.nature = function () {
	  return CCbGlob.natAppelFonction;
	};
	
	CAppelFonction.prototype.getClone = function (listeSource, listeCible) {
	  var cloneOperande = this.operande.getClone(listeSource, listeCible);
	  // à revoir car la fonction a déjà été créée
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  return new CAppelFonction(listeCible, listeCible.get(ind1, "CCalculAncetre"), cloneOperande);
	};
	
	CAppelFonction.prototype.resultatComplexe = function (infoRandom, zRes) {
	  this.operande.resultatComplexe(infoRandom, this.z1loc);
	  this.fonctionAssociee.rendValeurFonctionComplexe(infoRandom, this.z1loc, zRes);
	};
	
	CAppelFonction.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  this.operande.resultatFonctionComplexe(infoRandom, valeurParametre, this.z1loc);
	  this.fonctionAssociee.rendValeurFonctionComplexe(infoRandom, this.z1loc, zRes);
	};
	
	CAppelFonction.prototype.existe = function (infoRandom) {
	  return this.fonctionAssociee.existe && this.operande.existe(infoRandom);
	};
	
	CAppelFonction.prototype.resultat = function (infoRandom) {
	  return this.fonctionAssociee.rendValeurFonction(infoRandom, this.operande.resultat(infoRandom));
	};
	
	CAppelFonction.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  return this.fonctionAssociee.rendValeurFonction(infoRandom, this.operande.resultatFonction(infoRandom, valeurParametre));
	};
	
	CAppelFonction.prototype.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  this.operande.initialisePourDependance();
	};
	
	CAppelFonction.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCb.prototype.dependDe.call(this, p) || this.fonctionAssociee.dependDe(p) || this.operande.dependDe(p));
	};
	
	CAppelFonction.prototype.dependDePourBoucle = function (p) {
	  return this.fonctionAssociee.dependDePourBoucle(p) || this.operande.dependDePourBoucle(p);
	};
	
	CAppelFonction.prototype.dependDeVariable = function (ind) {
	  return this.operande.dependDeVariable(ind);
	};
	
	CAppelFonction.prototype.deriveePossible = function (indiceVariable) {
	  var b = this.operande.deriveePossible(indiceVariable);
	  if (this.fonctionAssociee.className === "CSuiteRec") return b;else return b || this.fonctionAssociee.deriveePossible(indiceVariable);
	};
	
	CAppelFonction.prototype.getCopie = function () {
	  return new CAppelFonction(this.listeProprietaire, this.fonctionAssociee, this.operande.getCopie());
	};
	
	CAppelFonction.prototype.chaineCalcul = function (varFor) {
	  // ElimineParenthesesDebut(cha);
	  return this.fonctionAssociee.getNom() + "(" + this.operande.chaineCalculSansPar(varFor) + ")";
	};
	
	CAppelFonction.prototype.chaineLatex = function (varFor) {
	  var parouvLatex = "\\left(";
	  var parferLatex = "\\right)";
	  // ElimineParenthesesDebut(cha);
	  return this.fonctionAssociee.getNom() + parouvLatex + this.operande.chaineLatexSansPar(varFor) + parferLatex;
	};
	
	CAppelFonction.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.fonctionAssociee = list.get(ind1, "CCalculAncetre");
	  this.operande = inps.readObject(list);
	};
	
	CAppelFonction.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.fonctionAssociee);
	  oups.writeInt(ind1);
	  oups.writeObject(this.operande);
	};
	
	CAppelFonction.prototype.estConstant = function () {
	  return this.fonctionAssociee.estConstant() && this.operande.estConstant();
	};
	
	CAppelFonction.prototype.calculAvecValeursRemplacees = function () {
	  var CFonc = __webpack_require__(53);
	  var fon = this.fonctionAssociee.className === "CFonc" ? new CFonc(this.listeProprietaire, null, false, this.fonctionAssociee.nomCalcul, "", this.fonctionAssociee.chaineVariable, this.fonctionAssociee.calcul.calculAvecValeursRemplacees()) : this.fonctionAssociee;
	  return new CAppelFonction(this.listeProprietaire, fon, this.operande.calculAvecValeursRemplacees());
	};
	
	CAppelFonction.prototype.membreGauche = function () {
	  return this.fonctionAssociee.membreGauche();
	};
	
	CAppelFonction.prototype.membreDroit = function () {
	  return this.fonctionAssociee.membreDroit();
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	var COb = __webpack_require__(34);
	var Complexe = __webpack_require__(30);
	var Ope = __webpack_require__(32);
	var Opef = __webpack_require__(19);
	var kernel = __webpack_require__(8);
	var CCbGlob = __webpack_require__(31);
	
	// parmi toutes ces dépendances, on ne peut pas charger ici tous les objetTruc qui ont du
	// objetTruc.prototype = new CCb()
	// on commente ici et redéclare dans les méthodes qui les utilisent
	// et qui pourraient peut-être passer dans un module séparé
	
	// const CAppelFonction = require('./CAppelFonction')
	// const CAppelFonctionComplexe = require('./CAppelFonctionComplexe')
	// const CAppelFonctionNVar = require('./CAppelFonctionNVar')
	// const CAppelFonctionComplexeNVar = require('./CAppelFonctionComplexeNVar')
	// const CAppelFonctionInterne = require('./CAppelFonctionInterne')
	// const CAppelFonctionInterneNVar = require('./CAppelFonctionInterneNVar')
	// const CConstante = require('./CConstante')
	// const CConstantei = require('./CConstantei')
	// const CFonction = require('./CFonction')
	// const CFonction2Var = require('./CFonction2Var')
	// const CFonction3Var = require('./CFonction3Var')
	// const CIntegraleDansFormule = require('./CIntegraleDansFormule')
	// const CMoinsUnaire = require('./CMoinsUnaire')
	// const COp = require('./COperation')
	// const CProduitDansFormule = require('./CProduitDansFormule')
	// const CPuissance = require('./CPuissance')
	// const CResultatValeur = require('./CResultatValeur')
	// const CResultatValeurComplexe = require('./CResultatValeurComplexe')
	// const CVariableFormelle = require('./CVariableFormelle')
	// const CSommeDansFormule = require('./CSommeDansFormule')
	// const CCbNull = require('./CCbNull')
	
	module.exports = CCb;
	
	/**
	 * Classe ancêtre de tous les objets de type calcul pouvant être utilisés dans un
	 * arbre binaire de calcul.
	 * @constructor
	 * @extends COb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @returns {CCb}
	 */
	function CCb(listeProprietaire) {
	  if (arguments.length === 0) COb.call(this); // Ajout version WebPack
	  else {
	      COb.call(this, listeProprietaire);
	      // Ajout version 4.8 pour optimiser la fonction dependDe
	      this.elementTestePourDependDe = null;
	      this.dependDeElementTeste = false;
	    }
	}
	CCb.prototype = new COb();
	CCb.prototype.constructor = CCb;
	CCb.prototype.superClass = "COb";
	CCb.prototype.className = "CCb";
	
	// Ajout version 4.8
	/**
	 * Fonction mémorisant la dépendance de l'objet par rapport à une objet déjà testé
	 * @param {type} resultat
	 * @returns {Boolean}
	 */
	CCb.prototype.memoriseDependance = function (resultat) {
	  this.dependDeElementTeste = resultat;
	  return resultat;
	};
	
	/**
	 * Fonction rendant une chaîne de caractères représentant le calcul représenté
	 * par this qui est un arbre binaire de calcul.
	 * A redéfinir pour les desdendants.
	 * Utiliser plutôt chaineCalculSansPar car le résultat peut contenir des parenthèses.
	 * @param {Array} varFor : Un tableau représentant les variables formelles
	 * pour une fonction de plusieurs variables.
	 * @returns {String}
	 */
	CCb.prototype.chaineCalcul = function (varFor) {
	  return "";
	};
	/**
	 * Fonction rendant une chaîne de caractères sans parenthèses externes
	 * représentant le calcul représenté  * par this qui est un arbre binaire de calcul.
	 * A redéfinir pour les desdendants.
	 * @param {Array} varFor : Un tableau représentant les variables formelles
	 * pour une fonction de plusieurs variables.
	 * @returns {String}
	 */
	CCb.prototype.chaineCalculSansPar = function (varFor) {
	  return this.chaineCalcul(varFor);
	};
	/**
	 * Sert à reconstituer une formule LaTeX à partir de son arbre binaire
	 * conjointement à chaineLatexSansPar A redéfinir pour les descendants
	 */
	/**
	 * Fonction rendant une chaîne de caractères représentant en laTeX le calcul représenté
	 * par this qui est un arbre binaire de calcul.
	 * A redéfinir pour les desdendants.
	 * Utiliser plutôt chaineLatexSansPar car le résultat peut contenir des parenthèses.
	 * @param {Array} varFor : Un tableau représentant les variables formelles
	 * pour une fonction de plusieurs variables.
	 * @returns {String}
	 */
	CCb.prototype.chaineLatex = function (varFor) {
	  return this.chaineCalcul(varFor);
	};
	/**
	 * Sert à reconstituer une formule à partir de son arbre binaire conjointement
	 * à chaineCalcul A redéfinir pour les descendants
	 */
	/**
	 * Fonction rendant une chaîne de caractères sans parenthèses externes
	 * représentant en laTeX le calcul représenté
	 * par this qui est un arbre binaire de calcul.
	 * A redéfinir pour les desdendants.
	 * @param {Array} varFor : Un tableau représentant les variables formelles
	 * pour une fonction de plusieurs variables.
	 * @returns {String}
	 */
	CCb.prototype.chaineLatexSansPar = function (varFor) {
	  return this.chaineLatex(varFor);
	};
	/**
	 * Renvoie true si le calcul est constant (c'est-à-dire nn'utilise pas de valeurs
	 * dynamiques) sans faire appel à la fonction Rand().
	 * @returns {Boolean}
	 */
	CCb.prototype.estConstant = function () {
	  return false;
	};
	/**
	 * Fonction renvoyant true si this est un calcul constant renvoyant la valeur 0.
	 * Redéfinit dans CConstante.
	 * @returns {Boolean}
	 */
	CCb.prototype.estConstante0 = function () {
	  return false;
	};
	/**
	 * Fonction renvoyant true si le calcul existe.
	 * A redéfinir pour les descendants.
	 * existe prend un paramètre boolean infoRandom
	 * C'est dû à l'optimisation de la fonction de 3 variables si(test,
	 * valeurSiVrai, valeurSiFaux) qui nécessite de connaître la valeur
	 * du premier argument test pour savoir si le résultat existe ou non. Si test
	 * renvoie 1, existe renvoie valeurSiVrai.existe(inforRandom)
	 * et sinon ValeurSiFaux.existe(infoRandom)
	 * @returns {Boolean}
	 */
	CCb.prototype.existe = function () {
	  return true;
	};
	/**
	 * Fonction à redéfinir pour tous les descendants.
	 * Renvoie un clone de l'objet, listeSource étant la liste propriétaire de l'objet
	 * et listeCible la liste propriétaire du clone à créer.
	 * @param {CListeObjets} listeSource : La liste propriétaire de l'objet
	 * @param {CListeObjets} listeCible : La liste propriétaire de l'objet clone à céer.
	 * @returns {CCb}
	 */
	CCb.prototype.getClone = function (listeSource, listeCible) {
	  return null;
	};
	/**
	  * Fonction à redéfinir pour tous les descendants.
	  * Renvoie une copie conforme de l'objet dans sa liste propriétaire.
	  * Utilisé dans les calculs de dérivées.
	 * @returns {CCb}
	 */
	CCb.prototype.getCopie = function () {
	  return null;
	};
	// Revu par rapport à la version Java : Paramètre infoRandom supprimé car inutilisé
	/**
	 * Fonction utilisée pour savoir si une fonction utilisateur existe.
	 * Est différent de existe à cause de la fonction de 3 variables si(test, valeurSiVrai, valeurSiFaux)
	 * @returns {boolean}
	 */
	CCb.prototype.existePourFonc = function () {
	  return this.existe();
	};
	/**
	 * Fonction renvoyant dans le cas d'un opérateur le membre de gauche et sinon this.
	 * A redéfinir pour certians descendants.
	 * @returns {CCb}
	 */
	CCb.prototype.membreGauche = function () {
	  return this;
	};
	/**
	 * Fonction renvoyant dans le cas d'un opérateur le membre de droite et sinon this.
	 * A redéfinir pour certians descendants.
	 * @returns {CCb}
	 */
	CCb.prototype.membreDroit = function () {
	  return this;
	};
	/**
	 * Fonction servant pour les fonctions à savoir quel est le nombre de variables.
	 * @returns {Integer}
	 */
	CCb.prototype.nombreVariables = function () {
	  return 0;
	};
	/**
	 * Fonction renvoyant le résultat du calcul.
	 * A redéfinir pour les descendants.
	 * @param {Boolean } infoRandom :  true si les calculas aléatoires avec rand
	 * @returns {number}
	 */
	CCb.prototype.resultat = function (infoRandom) {
	  throw new Error("Appel de Ccb.resultat");
	};
	// Ajout pour la version 2.0 calculs sur les complexes.
	// Le résultat est renvoyé dans z
	/**
	 * Fonction renvoyant dans zRes le résultat d'un calcul complexe.
	 * A redéfinir pour les descendnats.
	 * @param {Boolean} infoRandom : true si les calculas aléatoires avec rand
	 * @param {Complexe} zRes : Le résultat complexe du calcul
	 * @returns {undefined}
	 */
	CCb.prototype.resultatComplexe = function (infoRandom, zRes) {
	  zRes.x = this.resultat(infoRandom); // Par défaut on suppose le calcul réel
	  zRes.y = 0;
	};
	/**
	 * Appelé lors des appels de fonctions pour fournir le résultat du calcul.
	 * A redéfinir pour les descendants.
	 * @param {Boolean} infoRandom : true si les calculas aléatoires avec rand
	 * @param {Array} valeurparametre : un tableau donnant les valeurs des paramètres pour une
	 * fonction de une ou plusieurs variabels.
	 * @returns {Number}
	 */
	CCb.prototype.resultatFonction = function (infoRandom, valeurparametre) {
	  return this.resultat(infoRandom);
	};
	/**
	 * Appelé lors des appels de fonctions pour fournir le résultat complexe du calcul.
	 * A redéfinir pour les descendants.
	* @param {Boolean} infoRandom : true si les calculas aléatoires avec rand
	 * @param {Array} valeurParametre : un tableau donnant les valeurs des paramètres pour une
	 * @param {type} zRes : Le complexe contenant le résultat.
	 * @returns {undefined}
	 */
	CCb.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  this.resultatComplexe(infoRandom, zRes);
	};
	
	CCb.prototype.initialisePourDependance = function () {
	  this.elementTestePourDependDe = null;
	  this.elementTestePourDependDePourRec = null;
	};
	
	/**
	 * Fonction renvoyant true si le calcul dépend de p.
	 * A redéfinir pour les descendants.
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CCb.prototype.dependDe = function (p) {
	  this.elementTestePourDependDe = p;
	  return false;
	};
	/**
	 * La fonction suivante renverra le même résultat que DependDe sauf dans le
	 * cas où le calcul fait réferrence à la fonction Rand de génération d'un
	 * nombre aléatoire
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CCb.prototype.dependDePourBoucle = function (p) {
	  return false;
	};
	/**
	 * Fonction renvoyant true si l'arbre pointé par this conteint un appel de variable
	 * formelle, ind étant l'indice de la variable pour une fonction de plusieurs variables.
	 * A redéfinir pour tous les descendants.
	 * @param {Integer} ind : Indice de la variable pour les fonctions à plusieurs variables.
	 * @returns {Boolean}
	 */
	CCb.prototype.dependDeVariable = function (ind) {
	  return this.operande.dependDeVariable(ind);
	};
	
	/**
	 * Fonction ajoutant à liste tous les operandes de
	 * multiplication issus d'un même noeud de multiplication.
	 * @param {Array} liste
	 * @returns {undefined}
	 */
	CCb.prototype.ajouteOperateursMult = function (liste) {
	  var nat = this.nature();
	  if (nat === CCbGlob.natOperation) {
	    if (this.Ope === Ope.Mult) {
	      // COperation op = (COperation) this;
	      this.operande1.ajouteOperateursMult(liste);
	      this.operande2.ajouteOperateursMult(liste);
	    } else liste.push(this);
	  } else liste.push(this);
	};
	/**
	 * Fonction ajoutant à liste tous les operandes d'addition
	 * issus d'un même noeud de multiplication.
	 * @param {Array} liste
	 * @returns {undefined}
	 */
	CCb.prototype.ajouteOperateursPlus = function (liste) {
	  var nat = this.nature();
	  if (nat === CCbGlob.natOperation) {
	    if (this.Ope === Ope.Plus) {
	      this.operande1.ajouteOperateursPlus(liste);
	      this.operande2.ajouteOperateursPlus(liste);
	    } else liste.push(this);
	  } else liste.push(this);
	};
	/**
	 * Fonction fournissant un calcul dans lequel tous les CResultatValeur
	 * et CResultatValeurComplexes sont remplacés par une constante dont la valeur
	 * est le résultat du CResultatValeur ou CResultatValeurComplexes.
	 * @returns {CCb}
	 */
	CCb.prototype.calculAvecValeursRemplacees = function () {
	  return this;
	};
	/**
	 * Renvoie un calcul normalisé équivalent au calcul this.
	 * Si rempval est true les appels à des CResultatValeur ou CResultatValeurComplexe
	 * sont remplacés par une constante.
	 * @param {Boolean} rempval
	 * @param {Boolean} sousdivnorm : Si true, les soustractions sont remplacées par des additions d'opposés
	 * @param {Boolean} rempDecParFrac : Si, true, les nombres décimaux (avec au plus 9 décimales) et la fraction irréductible
	 * qui les représentent sont considérés comme équivalents.
	 * et les divisions pas des multiplications par l'inverse.
	 * @returns {CCb}
	 */
	CCb.prototype.calculNormalise = function (rempval, sousdivnorm, rempDecParFrac) {
	  var CAppelFonction = __webpack_require__(42);
	  var CAppelFonctionNVar = __webpack_require__(44);
	  var CConstante = __webpack_require__(45);
	  var CConstantei = __webpack_require__(46);
	  var CFonction = __webpack_require__(47);
	  var CFonction2Var = __webpack_require__(48);
	  var CFonction3Var = __webpack_require__(49);
	  var CMoinsUnaire = __webpack_require__(50);
	  var COp = __webpack_require__(51);
	  var CPuissance = __webpack_require__(52);
	
	  var liste = this.listeProprietaire;
	  var nat = this.nature();
	  if (nat === CCbGlob.natOperation) {
	    // COperation op = (COperation) this;
	    var calcOperande1 = this.operande1.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    var calcOperande2 = this.operande2.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    var natop1 = calcOperande1.nature();
	    var natop2 = calcOperande2.nature();
	    if (this.Ope === Ope.Moin) {
	      // On remplace les a - 0 par a
	      if (rempval) {
	        if (natop2 === CCbGlob.natConstante) {
	          if (calcOperande2.valeur === 0) return calcOperande1;
	        }
	        // On remplace les 0 - a par - a ou par abs(a) si a est un moins unaire
	        if (natop1 === CCbGlob.natConstante) {
	          // CConstante resval = (CConstante) calcOperande1;
	          if (calcOperande1.valeur === 0) {
	            if (calcOperande2.nature() === CCbGlob.natMoinsUnaire) return calcOperande2.operande;
	            return new CMoinsUnaire(liste, calcOperande2);
	          }
	        }
	        // On remplace a - (-b) par a + b
	        if (natop2 === CCbGlob.natMoinsUnaire) {
	          // CMoinsUnaire mun = (CMoinsUnaire) calcOperande2;
	          // return new COperation(liste, calcOperande1, mun.operande, Ope.Plus); // Modifié version 4.7.2.5
	          return new COp(liste, calcOperande1, calcOperande2.operande, Ope.Plus).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	        }
	      }
	      // On remplace les a - b par a + (-b)
	      if (sousdivnorm) return new COp(liste, calcOperande1, new CMoinsUnaire(liste, calcOperande2), Ope.Plus);else return new COp(liste, calcOperande1, calcOperande2, Ope.Moin);
	    }
	    if (this.Ope === Ope.Divi) {
	      // Si on est en mode remplacement de valeurs et que le dénominateur est un résultat de valeur 1 on simplifie
	      if (rempval) {
	        if (natop2 === CCbGlob.natConstante) {
	          if (calcOperande2.valeur === 1) {
	            // Pour 1/1 on renvoie 1
	            if (natop1 === CCbGlob.natConstante) {
	              if (calcOperande1.valeur === 1) return new CConstante(liste, 1);
	            }
	            return calcOperande1;
	          }
	        }
	        // Si le numérateur est une constante qui vaut 1 on garde le quotient
	        if (natop1 === CCbGlob.natConstante) {
	          // CConstante resval = (CConstante) calcOperande1;
	          var r = calcOperande1.valeur;
	          if (r === 1) {
	            if (calcOperande2.nature() === CCbGlob.natMoinsUnaire) {
	              return new CMoinsUnaire(liste, new COp(liste, new CConstante(liste, 1), calcOperande2.operande, Ope.Divi).calculNormalise(rempval, sousdivnorm, rempDecParFrac));
	            } else return new COp(liste, new CConstante(liste, 1), calcOperande2, Ope.Divi);
	          }
	          // S'il vaut 0 on renvoie un CResultatValeur contenant 0
	          if (r === 0) return new CConstante(liste, 0);
	        }
	        // Si le numérateur ou le dénominateur sont des moins unaires on simplifie
	        if (natop1 === CCbGlob.natMoinsUnaire) {
	          // CMoinsUnaire mun1 = (CMoinsUnaire) calcOperande1;
	          if (natop2 === CCbGlob.natMoinsUnaire) {
	            // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
	            if (sousdivnorm) return new COp(liste, calcOperande1.operande, new COp(liste, new CConstante(liste, 1), calcOperande2.operande, Ope.Divi), Ope.Mult).calculNormalise(rempval, sousdivnorm, rempDecParFrac);else return new COp(liste, calcOperande1.operande, calcOperande2.operande, Ope.Divi).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	          }
	          if (sousdivnorm) return new CMoinsUnaire(liste, new COp(liste, calcOperande1.operande, new COp(liste, new CConstante(liste, 1), calcOperande2, Ope.Divi), Ope.Mult)).calculNormalise(rempval, sousdivnorm, rempDecParFrac);else return new CMoinsUnaire(liste, new COp(liste, calcOperande1.operande, calcOperande2, Ope.Divi).calculNormalise(rempval, sousdivnorm, rempDecParFrac));
	        }
	        if (natop2 === CCbGlob.natMoinsUnaire) {
	          // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
	          if (sousdivnorm) return new CMoinsUnaire(liste, new COp(liste, calcOperande1, new COp(liste, new CConstante(liste, 1), calcOperande2.operande, Ope.Divi), Ope.Mult)).calculNormalise(rempval, sousdivnorm, rempDecParFrac);else return new CMoinsUnaire(liste, new COp(liste, calcOperande1, calcOperande2.operande, Ope.Divi).calculNormalise(rempval, sousdivnorm, rempDecParFrac));
	        }
	      }
	      // On remplace (-a)/b par - (a/b)
	      // Si le numérateur ou le dénominateur sont des moins unaires on simplifie
	      if (natop1 === CCbGlob.natMoinsUnaire) {
	        // CMoinsUnaire mun1 = (CMoinsUnaire) calcOperande1;
	        var natnum = calcOperande1.operande.nature();
	        // Si le numérateur est une constante -1 on renvoie -(1/denominateur)
	        if (natnum === CCbGlob.natConstante) {
	          var c = calcOperande1.operande;
	          if (c.valeur === 1) return new CMoinsUnaire(liste, new COp(liste, new CConstante(liste, 1), calcOperande2, Ope.Divi));
	        }
	        if (sousdivnorm) return new CMoinsUnaire(liste, new COp(liste, calcOperande1.operande, new COp(liste, new CConstante(liste, 1), calcOperande2, Ope.Divi), Ope.Mult)).calculNormalise(rempval, sousdivnorm, rempDecParFrac);else return new CMoinsUnaire(liste, new COp(liste, calcOperande1.operande, calcOperande2, Ope.Divi)).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	      }
	      // Fin ajout version 4.7.2.5
	      // On remplace a / b par a * (1/b) sauf si a est une constante à 1
	      if (natop1 === CCbGlob.natConstante) {
	        // CConstante cons = (CConstante) calcOperande1;
	        if (calcOperande1.valeur === 1) return new COp(liste, calcOperande1, calcOperande2, Ope.Divi);
	      }
	      // Si l'opérande de gauche est un produit dont un des facteurs est une constante 1
	      // On le remplace par le facteur de gauche
	      if (natop1 === CCbGlob.natOperation) {
	        // COperation op1 = (COperation) calcOperande1;
	        if (calcOperande1.Ope === Ope.Mult) {
	          if (calcOperande1.operande1.nature() === CCbGlob.natConstante) {
	            if (calcOperande1.operande1.valeur === 1) return new COp(liste, calcOperande1.operande2, calcOperande2, Ope.Divi).calculNormalise(rempval, sousdivnorm, rempDecParFrac, rempDecParFrac);
	          }
	          if (calcOperande1.operande2.nature() === CCbGlob.natConstante) {
	            if (calcOperande1.operande2.valeur === 1) return new COp(liste, calcOperande1.operande1, calcOperande2, Ope.Divi).calculNormalise(rempval, sousdivnorm, rempDecParFrac, rempDecParFrac);
	          }
	        }
	      }
	      if (sousdivnorm) return new COp(liste, calcOperande1, new COp(liste, new CConstante(liste, 1), calcOperande2, Ope.Divi), Ope.Mult);else return new COp(liste, calcOperande1, calcOperande2, Ope.Divi);
	    }
	    if (this.Ope === Ope.Plus) {
	      if (rempval) {
	        if (natop1 === CCbGlob.natConstante) {
	          if (calcOperande1.valeur === 0) return calcOperande2;
	        }
	        if (natop2 === CCbGlob.natConstante) {
	          if (calcOperande2.valeur === 0) return calcOperande1;
	        }
	      }
	      if (sousdivnorm) return new COp(liste, calcOperande1, calcOperande2, Ope.Plus);else {
	        // On remplace a + (-b) par a - b
	        if (natop2 === CCbGlob.natMoinsUnaire) {
	          // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
	          return new COp(liste, calcOperande1, calcOperande2.operande, Ope.Moin).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	        }
	      }
	    }
	    if (this.Ope === Ope.Mult) {
	      if (rempval) {
	        // Il  faut faire "remonter" les moins unaires le plus haut possible
	        if (natop1 === CCbGlob.natMoinsUnaire) {
	          // CMoinsUnaire mun1 = (CMoinsUnaire) calcOperande1;
	          if (natop2 === CCbGlob.natMoinsUnaire) {
	            // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
	            return new COp(liste, calcOperande1.operande, calcOperande2.operande, Ope.Mult).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	          } else return new CMoinsUnaire(liste, new COp(liste, calcOperande1.operande, calcOperande2, Ope.Mult).calculNormalise(rempval, sousdivnorm, rempDecParFrac));
	        } else {
	          if (natop2 === CCbGlob.natMoinsUnaire) {
	            // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
	            return new CMoinsUnaire(liste, new COp(liste, calcOperande1, calcOperande2.operande, Ope.Mult).calculNormalise(rempval, sousdivnorm, rempDecParFrac));
	          }
	        }
	        if (natop1 === CCbGlob.natConstante) {
	          r = calcOperande1.valeur;
	          if (r === 1) return calcOperande2;
	          if (r === 0) return new CConstante(liste, 0);
	        }
	        if (natop2 === CCbGlob.natConstante) {
	          // CConstante resval2 = (CConstante) calcOperande2;
	          r = calcOperande2.valeur;
	          if (r === 1) return calcOperande1;
	          if (r === 0) return new CConstante(liste, 0);
	        }
	        return new COp(liste, calcOperande1, calcOperande2, Ope.Mult);
	      }
	    }
	    // Autres cas . Rien  à simplifier et on simplifie seulement les opérandes.
	    return new COp(liste, calcOperande1, calcOperande2, this.Ope);
	  }
	  if (nat === CCbGlob.natResultatValeur) {
	    // CResultatValeur rv = (CResultatValeur) this;
	    if (rempval) return new CConstante(liste, this.valeurAssociee.rendValeur());else return this;
	  }
	  if (nat === CCbGlob.natResultatValeurComplexe) {
	    // CResultatValeurComplexe rv = (CResultatValeurComplexe) this;
	    if (rempval) {
	      var z = new Complexe();
	      this.resultatComplexe(false, z);
	      if (z.y === 0) return new CConstante(liste, this.valeurAssociee.rendValeur());else return new COp(liste, new CConstante(liste, z.x), new COp(liste, new CConstante(liste, z.y), new CConstantei(liste), Ope.Mult), Ope.Plus);
	    } else return this;
	  }
	  if (nat === CCbGlob.natPuissance) {
	    // Amélioration version 4.7.9 : Remplace a^1 par a
	    var calcPui = this.exposant.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    var natexp = calcPui.nature();
	    if (natexp === CCbGlob.natConstante) {
	      var res = calcPui.valeur;
	      if (res === 1) return this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    }
	    return new CPuissance(liste, this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac), calcPui);
	  }
	  if (nat === CCbGlob.natFonction) {
	    // CFonction fon = (CFonction) this;
	    switch (this.Opef) {
	      case Opef.Left:
	      case Opef.LeftC:
	        return this.operande.membreGauche().calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	      case Opef.Right:
	      case Opef.RightC:
	        return this.operande.membreDroit().calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	      default:
	        return new CFonction(liste, this.Opef, this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac));
	    }
	  }
	  if (nat === CCbGlob.natAppelFonction) {
	    return new CAppelFonction(liste, this.fonctionAssociee, this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac));
	  }
	  if (nat === CCbGlob.natFonction2Var) {
	    var op = new Array(2);
	    op[0] = this.operande1.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    op[1] = this.operande2.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    return new CFonction2Var(liste, this.Opef, op[0], op[1]);
	  }
	  if (nat === CCbGlob.natFonction3Var) {
	    op = new Array(3);
	    op[0] = this.operande1.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    op[1] = this.operande2.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    op[2] = this.operande3.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    return new CFonction3Var(liste, this.Opef, op[0], op[1], op[2]);
	  }
	  if (nat === CCbGlob.natAppelFonctionNVar) {
	    op = new Array(this.nbVar);
	    for (var i = 0; i < this.nbVar; i++) {
	      op[i] = this.operande[i].calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    }return new CAppelFonctionNVar(liste, this.nbVar, this.fonctionAssociee, op);
	  }
	  if (nat === CCbGlob.natMoinsUnaire) {
	    // On remplace -(-b) par b
	    var calcOperande = this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	    if (rempval) {
	      natop1 = calcOperande.nature();
	      if (natop1 === CCbGlob.natMoinsUnaire) {
	        return calcOperande.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
	      }
	      if (natop1 === CCbGlob.natConstante) {
	        r = calcOperande.valeur;
	        if (r === 0) return new CConstante(liste, 0);
	      }
	    }
	    return new CMoinsUnaire(liste, calcOperande);
	  }
	  // Ajout version 5.1.3
	  if (rempDecParFrac && nat === CCbGlob.natConstante) {
	    // CConstante co  = (CConstante) this;
	    var va = this.valeur;
	    if (va === Math.floor(va)) return this;
	    var n = Math.floor(va * Math.pow(10, 9) + 0.5);
	    var d = 1000000000;
	    if (!kernel.zero13(va - n / Math.pow(10, 9))) return this;
	    var g = kernel.pgcd(n, 1000000000);
	    var num = n / g;
	    var den = d / g;
	    if (sousdivnorm) {
	      if (num === 1) return new COp(liste, new CConstante(liste, 1), new CConstante(liste, d / g), Ope.Divi);else return new COp(liste, new CConstante(liste, num), new COp(liste, new CConstante(liste, 1), new CConstante(liste, den), Ope.Divi), Ope.Mult);
	    } else return new COp(liste, new CConstante(liste, num), new CConstante(liste, den), Ope.Divi);
	  }
	
	  // Dans les autres cas on renvoie le même calcul
	  return this;
	};
	
	/**
	 * Fonction renvayant true si this est équivalent à calc
	 * Deux calculs sont équivalents s'ils contiennent les mêmes opérateurs
	 * sans tenier compte de l'odre des additions algébriques ou des multiplications.
	 * Avant appel, this et calc doivent avoir été normalisés de façon
	 * que this et calc ne contiennent que des additions et divisions.
	 * @param {CCb} calc : le calcul dont on teste l'équivalence avec this.
	 * @returns {Boolean}
	 */
	CCb.prototype.estEquivalentA = function (calc) {
	  var nat1 = this.nature();
	  var nat2 = calc.nature();
	  if (nat1 !== nat2) return false;
	  if (nat1 === CCbGlob.natConstante) {
	    return this.valeur === calc.valeur;
	  }
	  if (nat1 === CCbGlob.natMoinsUnaire) {
	    return this.operande.estEquivalentA(calc.operande);
	  }
	  if (nat1 === CCbGlob.natFonction) {
	    return Opef.estEquivalent(this.Opef, calc.Opef) && this.operande.estEquivalentA(calc.operande);
	  }
	  if (nat1 === CCbGlob.natAppelFonction) {
	    return this.fonctionAssociee === calc.fonctionAssociee && this.operande.estEquivalentA(calc.operande);
	  }
	  if (nat1 === CCbGlob.natFonction2Var) {
	    return this.Opef === calc.Opef && this.operande1.estEquivalentA(calc.operande1) && this.operande2.estEquivalentA(calc.operande2);
	  }
	  if (nat1 === CCbGlob.natFonction3Var) {
	    return this.Opef === calc.Opef && this.operande1.estEquivalentA(calc.operande1) && this.operande2.estEquivalentA(calc.operande2) && this.operande3.estEquivalentA(calc.operande3);
	  }
	  if (nat1 === CCbGlob.natAppelFonctionNVar) {
	    if (this.fonctionAssociee !== calc.fonctionAssociee) return false;
	    var op1 = new Array(this.nbVar);
	    for (var i = 0; i < this.nbVar; i++) {
	      op1[i] = this.operande[i];
	    }var op2 = new CCb[calc.nbVar]();
	    for (i = 0; i < calc.nbVar; i++) {
	      op2[i] = calc.operande[i];
	    }var res = true;
	    for (i = 0; i < this.nbVar; i++) {
	      res = res && op1[i].estEquivalentA(op2[i]);
	    }return res;
	  }
	  if (nat1 === CCbGlob.natVariableFormelle) {
	    // CVariableFormelle for1 = (CVariableFormelle) this;
	    // CVariableFormelle for2 = (CVariableFormelle) calc;
	    return this.indvar === calc.indvar;
	  }
	  if (nat1 === CCbGlob.natOperation) {
	    // COperation op1 = (COperation) this;
	    // COperation op2 = (COperation) calc;
	    var natop1 = this.Ope;
	    var natop2 = calc.Ope;
	    if (natop1 !== natop2) {
	      if (natop1 === Ope.InfOuEgal) {
	        // a <= b équivalent à b>= a)
	        if (natop2 === Ope.SupOuEgal) return this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1);else return false; // Rajouté version 4.7.2
	      } else {
	        if (natop1 === Ope.Inf) {
	          // a < b équivalent à b > a)
	          if (natop2 === Ope.Sup) return this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1);else return false; // Rajouté version 4.7.2
	        } else {
	          if (natop1 === Ope.SupOuEgal) {
	            // a >= b équivalent à b <= a)
	            if (natop2 === Ope.InfOuEgal) return this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1);else return false; // Rajouté version 4.7.2
	          } else {
	            if (natop1 === Ope.Sup) {
	              // a > b équivalent à b < a)
	              if (natop2 === Ope.Inf) return this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1);else return false; // Rajouté version 4.7.2
	            } else return false;
	          }
	        }
	      }
	    }
	    // Les deux opérateurs sont les mêmes
	    if (natop1 === Ope.Plus) {
	      // Il faut vérifier que tous les opérandes sous-jascents sont
	      // équivalents
	      var list1 = [];
	      var list2 = [];
	      this.ajouteOperateursPlus(list1);
	      calc.ajouteOperateursPlus(list2);
	      if (list1.length !== list2.length) return false;
	      for (i = 0; i < list1.length; i++) {
	        var c1 = list1[i];
	        var trouve = false;
	        for (var j = 0; j < list2.length; j++) {
	          var c2 = list2[j];
	          if (c1.estEquivalentA(c2)) {
	            trouve = true;
	            list2.splice(j, 1);
	            break;
	          }
	        }
	        if (!trouve) return false;else {
	          list1.splice(i, 1);
	          i--; // Car le terme d'indice i a été retiré
	        }
	      }
	      return true;
	    }
	    if (natop1 === Ope.Mult) {
	      // Il faut vérifier que tous les opérandes sous-jascents sont
	      // équivalents
	      list1 = [];
	      list2 = [];
	      this.ajouteOperateursMult(list1);
	      calc.ajouteOperateursMult(list2);
	      if (list1.length !== list2.length) return false;
	      for (i = 0; i < list1.length; i++) {
	        c1 = list1[i];
	        trouve = false;
	        for (j = 0; j < list2.length; j++) {
	          c2 = list2[j];
	          if (c1.estEquivalentA(c2)) {
	            trouve = true;
	            list2.splice(j, 1);
	            break;
	          }
	        }
	        if (!trouve) return false;else {
	          list1.splice(i, 1);
	          i--; // Car le terme d'indice i a été retiré
	        }
	      }
	      return true;
	    }
	    // a = b équivalent à b = a
	    if (natop1 === Ope.Egalite || natop1 === Ope.And || natop1 === Ope.Or) {
	      return this.operande1.estEquivalentA(calc.operande1) && this.operande2.estEquivalentA(calc.operande2) || this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1);
	    }
	    // Dans les autres cas (division comprise, pour être équivalent les
	    // opérandes respectifs
	    // doivent être équivalents
	    return this.operande1.estEquivalentA(calc.operande1) && this.operande2.estEquivalentA(calc.operande2);
	  }
	  if (nat1 === CCbGlob.natPuissance) {
	    return this.operande.estEquivalentA(calc.operande) && this.exposant.estEquivalentA(calc.exposant);
	  }
	  if (nat1 === CCbGlob.natConstantei) return true;
	  if (nat1 === CCbGlob.natResultatValeur) {
	    return this.valeurAssociee === calc.valeurAssociee; // Attention test d'identité en JavaScript
	  }
	  if (nat1 === CCbGlob.natResultatValeurComplexe) {
	    return this.valeurAssociee === calc.valeurAssociee;
	  }
	  return false;
	};
	/**
	 * Renvoie true si this est un produit factorisé par calc ou simplement équivalent à calc
	 * ou à son opposé.
	 * Avant appel, this et calc doivent être rendus normalisés pour pouvoir reconnaître
	 * les réductions au même dénominateur.
	 * @param {CCb} calc : Le calcul dont on etste si c'est un facteur commun à this.
	 * @returns {Boolean}
	 */
	CCb.prototype.estFactorisePar = function (calc) {
	  var nat1, nat2, natop1, natop2, list1, list2, i, j, c1, c2, trouve;
	  nat1 = this.nature();
	  if (nat1 === CCbGlob.natMoinsUnaire) {
	    return this.operande.estFactorisePar(calc);
	  } else {
	    if (nat1 === CCbGlob.natOperation) {
	      // COperation op1 = (COperation) this;
	      natop1 = this.Ope;
	      if (natop1 === Ope.InfOuEgal || natop1 === Ope.Inf || natop1 === Ope.SupOuEgal || natop1 === Ope.Sup || natop1 === Ope.Egalite || natop1 === Ope.Diff) {
	        return this.operande1.estFactorisePar(calc) && this.operande2.estConstante0() || this.operande2.estFactorisePar(calc) && this.operande1.estConstante0();
	      }
	      if (natop1 === Ope.Mult) {
	        // Il faut vérifier si un des facteurs du produit et des facteurs sous-jascents est équivalent à calc
	        list1 = [];
	        list2 = [];
	        this.ajouteOperateursMult(list1);
	        nat2 = calc.nature();
	        if (nat2 !== CCbGlob.natOperation) list2.push(calc);else {
	          natop2 = calc.Ope;
	          if (natop2 === Ope.Mult) calc.ajouteOperateursMult(list2);else list2.push(calc);
	        }
	        if (list1.length < list2.length) return false;
	        for (i = 0; i < list2.length; i++) {
	          c2 = list2[i];
	          trouve = false;
	          for (j = 0; j < list1.length; j++) {
	            c1 = list1[j];
	            if (c1.estEquivalentA(c2)) {
	              trouve = true;
	              list1.splice(j, 1);
	              break;
	            }
	          }
	          if (!trouve) return false;else {
	            list2.splice(i, 1);
	            i--; // Car le terme d'indice i a été retiré
	          }
	        }
	        return true;
	      }
	    }
	    return this.estEquivalentA(calc);
	  }
	};
	/**
	 * Fonction renvoyant true si le calcul est dérivable.
	 * A redéfinir pour les descendants pour lesquels ce n'est pas dérivabel.
	 * @returns {Boolean}
	 */
	CCb.prototype.deriveePossible = function () {
	  return true;
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CAppelFonctionNVar;
	/**
	 * Objet d'un arbre binaire de calcul représentant un appel de fonction réelle utilisateur
	 * à n variables.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {Integer} nbVar : Le nombre de variables de la fonction.
	 * @param {CFoncNVar} fonctionAssociee : La fonction appliquée à l'opérande.
	 * @param {Array} operande : Tableau de CCb représentant les opérandes.
	 * @returns {undefined}
	 */
	function CAppelFonctionNVar(listeProprietaire, nbVar, fonctionAssociee, operande) {
	  if (arguments.length === 0) return;
	  CCb.call(this, listeProprietaire);
	  this.nbVar = nbVar;
	  this.fonctionAssociee = fonctionAssociee;
	  this.operande = operande;
	}
	CAppelFonctionNVar.prototype = new CCb();
	CAppelFonctionNVar.prototype.constructor = CAppelFonctionNVar;
	CAppelFonctionNVar.prototype.superClass = "CCb";
	CAppelFonctionNVar.prototype.className = "CAppelFonctionNVar";
	
	CAppelFonctionNVar.prototype.nature = function () {
	  return CCbGlob.natAppelFonctionNVar;
	};
	
	CAppelFonctionNVar.prototype.getClone = function (listeSource, listeCible) {
	  var operandeClone = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    operandeClone[i] = this.operande[i].getClone(listeSource, listeCible);
	  } // à revoir car la fonction a déjà été créée
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  return new CAppelFonctionNVar(listeCible, this.nbVar, listeCible.get(ind1, "CFoncNVar"), operandeClone);
	};
	
	CAppelFonctionNVar.prototype.resultatComplexe = function (infoRandom, zRes) {
	  var z1 = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    z1[i] = new Complexe();
	  }for (i = 0; i < this.nbVar; i++) {
	    this.operande[i].resultatComplexe(infoRandom, z1[i]);
	  }this.fonctionAssociee.rendValeurFonctionComplexe(infoRandom, z1, zRes);
	};
	
	CAppelFonctionNVar.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  var z1 = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    z1[i] = new Complexe();
	  }for (i = 0; i < this.nbVar; i++) {
	    this.operande[i].resultatFonctionComplexe(infoRandom, valeurParametre, z1[i]);
	  }this.fonctionAssociee.rendValeurFonctionComplexe(infoRandom, z1, zRes);
	};
	
	CAppelFonctionNVar.prototype.existe = function (infoRandom) {
	  var res = this.fonctionAssociee.existe;
	  if (!res) return false;
	  for (var i = 0; i < this.nbVar; i++) {
	    res = res || this.operande[i].existe(infoRandom);
	  }return res;
	};
	
	CAppelFonctionNVar.prototype.resultat = function (infoRandom) {
	  var d = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    d[i] = this.operande[i].resultat(infoRandom);
	  }return this.fonctionAssociee.rendValeurFonction(infoRandom, d);
	};
	
	CAppelFonctionNVar.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  var d = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    d[i] = this.operande[i].resultatFonction(infoRandom, valeurParametre);
	  }return this.fonctionAssociee.rendValeurFonction(infoRandom, d);
	};
	
	CAppelFonctionNVar.prototype.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  for (var i = 0; i < this.nbVar; i++) {
	    this.operande[i].initialisePourDependance();
	  }
	};
	
	CAppelFonctionNVar.prototype.dependDe = function (p) {
	  var res = CCb.prototype.dependDe.call(this, p);
	  for (var i = 0; i < this.nbVar; i++) {
	    res = res || this.operande[i].dependDe(p);
	  }return this.memoriseDependance(this.fonctionAssociee.dependDe(p) || res);
	};
	
	CAppelFonctionNVar.prototype.dependDePourBoucle = function (p) {
	  var res = false;
	  for (var i = 0; i < this.nbVar; i++) {
	    res = res || this.operande[i].dependDePourBoucle(p);
	  }return this.fonctionAssociee.dependDePourBoucle(p) || res;
	};
	
	CAppelFonctionNVar.prototype.dependDeVariable = function (ind) {
	  var res = false;
	  for (var i = 0; i < this.nbVar; i++) {
	    res = res || this.fonctionAssociee.calcul.dependDeVariable(i) && this.operande[i].dependDeVariable(ind);
	  }
	  return res;
	};
	
	CAppelFonctionNVar.prototype.getCopie = function () {
	  var operandeCopie = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    operandeCopie[i] = this.operande[i].getCopie();
	  }return new CAppelFonctionNVar(this.listeProprietaire, this.nbVar, this.fonctionAssociee, operandeCopie);
	};
	
	CAppelFonctionNVar.prototype.chaineCalcul = function (varFor) {
	  var ch = this.fonctionAssociee.getNom() + "(";
	  for (var i = 0; i < this.nbVar - 1; i++) {
	    ch = ch + this.operande[i].chaineCalculSansPar(varFor) + ",";
	  }return ch + this.operande[this.nbVar - 1].chaineCalculSansPar(varFor) + ")";
	};
	
	CAppelFonctionNVar.prototype.chaineLatex = function (varFor) {
	  var ch = this.fonctionAssociee.getNom() + "(";
	  for (var i = 0; i < this.nbVar - 1; i++) {
	    ch = ch + this.operande[i].chaineLatexSansPar(varFor) + ",";
	  }return ch + this.operande[this.nbVar - 1].chaineLatexSansPar(varFor) + ")";
	};
	
	CAppelFonctionNVar.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.nbVar = inps.readInt();
	  var ind1 = inps.readInt();
	  this.fonctionAssociee = list.get(ind1, "CFoncNVar");
	  this.operande = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    this.operande[i] = inps.readObject(list);
	  }
	};
	
	CAppelFonctionNVar.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeInt(this.nbVar);
	  var ind1 = list.indexOf(this.fonctionAssociee);
	  oups.writeInt(ind1);
	  for (var i = 0; i < this.nbVar; i++) {
	    oups.writeObject(this.operande[i]);
	  }
	};
	
	CAppelFonctionNVar.prototype.estConstant = function () {
	  var res = this.fonctionAssociee.estConstant();
	  for (var i = 0; i < this.nbVar; i++) {
	    res = res && this.operande[i].estConstant();
	  }return res;
	};
	
	CAppelFonctionNVar.prototype.deriveePossible = function (indiceVariable) {
	  var b = true;
	  for (var i = 0; i < this.operande.length && b; i++) {
	    if (this.operande[i].dependDeVariable(indiceVariable)) b = this.fonctionAssociee.deriveePossible(i) && this.operande[i].deriveePossible(indiceVariable);
	  }return b;
	};
	
	CAppelFonctionNVar.prototype.calculAvecValeursRemplacees = function () {
	  var nbvar = this.fonctionAssociee.nombreVariables();
	  var tabcal = new Array(this.fonctionAssociee.nombreVariables());
	  for (var i = 0; i < nbvar; i++) {
	    tabcal[i] = this.operande[i].calculAvecValeursRemplacees();
	  }
	  return new CAppelFonctionNVar(this.listeProprietaire, nbvar, this.fonctionAssociee, tabcal);
	};
	
	CAppelFonctionNVar.prototype.membreGauche = function () {
	  return this.fonctionAssociee.membreGauche();
	};
	
	CAppelFonctionNVar.prototype.membreDroit = function () {
	  return this.fonctionAssociee.membreDroit();
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CConstante;
	
	/**
	 * Classe représentant une constante dans un arbre binaire de calcul.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {Number} valeur : La valeur rebdue par la constante.
	 * @returns {CConstante}
	 */
	function CConstante(listeProprietaire, valeur) {
	  CCb.call(this, listeProprietaire);
	  if (arguments.length !== 1) this.valeur = valeur;
	}
	CConstante.prototype = new CCb();
	CConstante.prototype.constructor = CConstante;
	CConstante.prototype.superClass = "CCb";
	CConstante.prototype.className = "CConstante";
	
	CConstante.prototype.nature = function () {
	  return CCbGlob.natConstante;
	};
	
	CConstante.prototype.getClone = function (listeSource, listeCible) {
	  return new CConstante(listeCible, this.valeur);
	};
	
	CConstante.prototype.getCopie = function () {
	  return new CConstante(this.listeProprietaire, this.valeur);
	};
	
	CConstante.prototype.dependDeVariable = function (ind) {
	  return false;
	};
	
	CConstante.prototype.resultat = function (infoRandom) {
	  return this.valeur;
	};
	
	CConstante.prototype.resultatComplexe = function (infoRandom, zRes) {
	  zRes.x = this.valeur; // Par défaut on suppose le calcul réel
	  zRes.y = 0;
	};
	
	CConstante.prototype.chaineCalcul = function (varFor) {
	  return kernel.chaineNombre(this.valeur, 12);
	};
	
	CConstante.prototype.estConstant = function () {
	  return true;
	};
	
	CConstante.prototype.estConstante0 = function () {
	  return this.valeur === 0;
	};
	
	CConstante.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.valeur = inps.readDouble();
	};
	
	CConstante.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeDouble(this.valeur);
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CConstantei;
	
	/**
	 * Classe représenant le nombre complexe i dans les arbres binaires de calcul.
	 * @constructor
	 * @extends CCb
	 * @param {mtg32.CListteObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @returns {CConstantei}
	 */
	function CConstantei(listeProprietaire) {
	  CCb.call(this, listeProprietaire);
	}
	CConstantei.prototype = new CCb();
	CConstantei.prototype.constructor = CConstantei;
	CConstantei.prototype.superClass = "CCb";
	CConstantei.prototype.className = "CConstantei";
	
	CConstantei.prototype.nature = function () {
	  return CCbGlob.natConstantei;
	};
	CConstantei.prototype.resultatComplexe = function (infoRandom, zRes) {
	  zRes.x = 0;
	  zRes.y = 1;
	};
	CConstantei.prototype.getClone = function (listeSource, listeCible) {
	  return new CConstantei(listeCible);
	};
	CConstantei.prototype.getCopie = function () {
	  return new CConstantei(this.listeProprietaire);
	};
	CConstantei.prototype.dependDeVariable = function (ind) {
	  return false;
	};
	CConstantei.prototype.chaineCalcul = function (varFor) {
	  return "i";
	};
	CConstantei.prototype.chaineLatex = function (varFor) {
	  return "i";
	};
	CConstantei.prototype.estConstant = function () {
	  return true;
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var Opef = __webpack_require__(19);
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CFonction;
	
	/**
	 * Classe représentant dans un arbre binaire de calcul un appel de fonction réelle
	 * à une variable prédéfinie.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {mtg32.OperateurFontion} Opef : Donne la nature de la fonction.
	 * @param {CCb} operande : La calcu donnant l'opérande.
	 * @returns {CFonction}
	 */
	function CFonction(listeProprietaire, Opef, operande) {
	  CCb.call(this, listeProprietaire);
	  if (arguments.length !== 1) {
	    this.Opef = Opef;
	    this.operande = operande;
	  }
	  this.dejaPositionne = false; // ne servira que pour un appel fonction Rand() de génération d'un nombre aléatoire.
	  this.valeurDejaPrise = 0; // Comme son nom l'indique pour les appels de random
	  this.valeurDejaPriseImaginaire = 0; // Partie imaginaire pour les fonctions complexes pour les appels de random
	  this.z1loc = new Complexe();
	}
	CFonction.prototype = new CCb();
	CFonction.prototype.constructor = CFonction;
	CFonction.prototype.superClass = "CCb";
	CFonction.prototype.className = "CFonction";
	
	CFonction.prototype.nature = function () {
	  return CCbGlob.natFonction;
	};
	CFonction.prototype.numeroVersion = function () {
	  return 2;
	};
	CFonction.prototype.nombreVariables = function () {
	  return 1;
	};
	CFonction.prototype.getClone = function (listeSource, listeCible) {
	  var cloneOperande = this.operande.getClone(listeSource, listeCible);
	  var ptcalc = new CFonction(listeCible, this.Opef, cloneOperande);
	  // Les trois lignes suivantes ajoutées version 4.4 pour que les valeurs rand ne changent pas dans l'annuler-refaire
	  ptcalc.dejaPositionne = this.dejaPositionne;
	  ptcalc.valeurDejaPrise = this.valeurDejaPrise;
	  ptcalc.valeurDejaPriseImaginaire = this.valeurDejaPriseImaginaire;
	  return ptcalc;
	};
	CFonction.prototype.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  this.operande.initialisePourDependance();
	};
	CFonction.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCb.prototype.dependDe.call(this, p) || this.operande.dependDe(p));
	};
	CFonction.prototype.dependDePourBoucle = function (p) {
	  if (this.Opef === Opef.Rand) {
	    // if (p instanceof CVariableBornee) return true;
	    if (p.className === "CVariableBornee") return true;else return this.operande.dependDePourBoucle(p);
	  } else return this.operande.dependDePourBoucle(p);
	};
	CFonction.prototype.existe = function (infoRandom) {
	  return this.operande.existe(infoRandom);
	};
	CFonction.prototype.resultatBase = function (infoRandom, x) {
	  switch (this.Opef) {
	    case Opef.Abso:
	      return Math.abs(x);
	    case Opef.Enti:
	      return Math.floor(x);
	    case Opef.Raci:
	    case Opef.Raci2:
	      if (x >= 0) return Math.sqrt(x);else throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	    case Opef.Sinu:
	      if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) return CCbGlob.sinus(x);else return CCbGlob.sinus(x * kernel.ConvDegRad);
	    case Opef.Cosi:
	      if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) return CCbGlob.cosinus(x);else return CCbGlob.cosinus(x * kernel.ConvDegRad);
	    case Opef.Tang:
	      if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) return CCbGlob.tangente(x);else {
	        return CCbGlob.tangente(x * kernel.ConvDegRad);
	      }
	    case Opef.Logn:
	      if (x > 0) return Math.log(x);else throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	    case Opef.Expo:
	      return Math.exp(x);
	    case Opef.ATan:
	      if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) return Math.atan(x);else return Math.atan(x) * kernel.ConvRadDeg;
	    case Opef.ACos:
	      if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) return Math.acos(x);else return Math.acos(x) * kernel.ConvRadDeg;
	    case Opef.ASin:
	      if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) return Math.asin(x);else return Math.asin(x) * kernel.ConvRadDeg;
	    case Opef.Cosh:
	      return (Math.exp(x) + Math.exp(-x)) / 2;
	    case Opef.Sinh:
	      return (Math.exp(x) - Math.exp(-x)) / 2;
	    case Opef.Tanh:
	      var a = Math.exp(x);
	      var b = Math.exp(-x);
	      return (a - b) / (a + b);
	    case Opef.ArgCh:
	      if (x >= 1) return Math.log(x + Math.sqrt(x * x - 1));else throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	    case Opef.ArgSh:
	      return Math.log(x + Math.sqrt(x * x + 1));
	    case Opef.ArgTh:
	      if (x > -1 && x < 1) return 0.5 * Math.log((1 + x) / (1 - x));else throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	    case Opef.Rand:
	      if (infoRandom) {
	        this.valeurDejaPrise = Math.random();
	        this.dejaPositionne = true;
	        return this.valeurDejaPrise;
	      } else {
	        if (!this.dejaPositionne) {
	          this.valeurDejaPrise = Math.random();
	          this.dejaPositionne = true;
	          return this.valeurDejaPrise;
	        } else return this.valeurDejaPrise;
	      }
	    case Opef.fact:
	      if (x < 0 || x !== Math.round(x)) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      if (x <= 32) {
	        var p = 1;
	        for (var i = 2; i <= x; i++) {
	          p = p * i;
	        }
	        return p;
	      } else {
	        var x1 = x;
	        var d = 1 + 1 / (12 * x1);
	        x1 *= x;
	        d += 1 / (288 * x1);
	        x1 *= x;
	        d -= 139 / (51840 * x1);
	        x1 *= x;
	        d -= 571 / (2488320 * x1);
	        x1 *= x;
	        d -= 163879 / (209018880 * x1);
	        return Math.exp(0.5 * Math.log(2 * Math.PI * x) + x * (Math.log(x) - 1)) * d;
	      }
	    default:
	      throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  } // switch Opef}
	};
	CFonction.prototype.resultat = function (infoRandom) {
	  switch (this.Opef) {
	    case Opef.Left:
	    case Opef.LeftC:
	      // Rajouté version 4.7.2
	      var mg = this.operande.membreGauche();
	      if (mg === null) {
	        throw new Erreur(kernel.erreurCalculExceptionkernel._digit64_standard);
	      } else return this.operande.membreGauche().resultat(infoRandom);
	    case Opef.Right:
	    case Opef.RightC:
	      // Rajouté version 4.7.2
	      var md = this.operande.membreDroit();
	      if (md === null) {
	        throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      }
	      return this.operande.membreDroit().resultat(infoRandom);
	    default:
	      var x1 = this.operande.resultat(infoRandom);
	      return this.resultatBase(infoRandom, x1);
	  }
	};
	CFonction.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  switch (Opef) {
	    case Opef.Left:
	    case Opef.LeftC:
	      // Rajouté version 4.7.2
	      var mg = this.operande.membreGauche();
	      if (mg === null) {
	        throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard());
	      }
	      return this.operande.membreGauche().resultatFonction(infoRandom, valeurParametre);
	    case Opef.Right:
	    case Opef.RightC:
	      // Rajouté version 4.7.2
	      var md = this.operande.membreDroit();
	      if (md === null) {
	        throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      }
	      return this.operande.membreDroit().resultatFonction(infoRandom, valeurParametre);
	    default:
	      var x1 = this.operande.resultatFonction(infoRandom, valeurParametre);
	      return this.resultatBase(infoRandom, x1);
	  }
	};
	
	CFonction.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  switch (this.Opef) {
	    case Opef.Left:
	    case Opef.LeftC:
	      // Rajouté version 4.7.2
	      var mg = this.operande.membreGauche();
	      if (mg === null) {
	        throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      }
	      return this.operande.membreGauche().resultatFonction(infoRandom, valeurParametre);
	    case Opef.Right:
	    case Opef.RightC:
	      // Rajouté version 4.7.2
	      var md = this.operande.membreDroit();
	      if (md === null) {
	        throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      }
	      return this.operande.membreDroit().resultatFonction(infoRandom, valeurParametre);
	    default:
	      var x1 = this.operande.resultatFonction(infoRandom, valeurParametre);
	      return this.resultatBase(infoRandom, x1);
	  }
	};
	CFonction.prototype.resultatComplexeBase = function (infoRandom, z, zRes) {
	  switch (this.Opef) {
	    case Opef.Abs:
	      zRes.y = 0;
	      zRes.x = z.module();
	      return;
	    case Opef.Abso:
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        zRes.x = Math.abs(z.x);
	        return;
	      }
	    case Opef.Sin:
	      z.sinComp(this.listeProprietaire.uniteAngle, zRes);
	      return;
	    case Opef.Sinu:
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) zRes.x = CCbGlob.sinus(z.x);else zRes.x = CCbGlob.sinus(z.x * kernel.ConvDegRad);
	        return;
	      }
	    case Opef.Cos:
	      z.cosComp(this.listeProprietaire.uniteAngle, zRes);
	      return;
	    case Opef.Cosi:
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) zRes.x = CCbGlob.cosinus(z.x);else zRes.x = CCbGlob.cosinus(z.x * kernel.ConvDegRad);
	        return;
	      }
	    case Opef.Tan:
	      z.tanComp(this.listeProprietaire.uniteAngle, zRes);
	      return;
	    case Opef.Tang:
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) zRes.x = CCbGlob.tangente(z.x);else zRes.x = CCb(z.x * kernel.ConvDegRad);
	        return;
	      }
	    case Opef.Log:
	      z.lnComp(this.listeProprietaire.uniteAngle, zRes);
	      return;
	    case Opef.Logn:
	      if (z.y !== 0 || z.x <= 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        zRes.x = Math.log(z.x);
	        return;
	      }
	    case Opef.Exp:
	      z.expComp(this.listeProprietaire.uniteAngle, zRes);
	      return;
	    case Opef.Expo:
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        zRes.x = Math.exp(z.x);
	        return;
	      }
	    case Opef.Ch:
	      z.chComp(this.listeProprietaire.uniteAngle, zRes);
	      return;
	    case Opef.Cosh:
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        zRes.x = (Math.exp(z.x) + Math.exp(-z.x)) / 2;
	        return;
	      }
	    case Opef.Sh:
	      z.shComp(this.listeProprietaire.uniteAngle, zRes);
	      return;
	    case Opef.Sinh:
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        zRes.x = (Math.exp(z.x) - Math.exp(-z.x)) / 2;
	        return;
	      }
	    case Opef.Th:
	      z.thComp(this.listeProprietaire.uniteAngle, zRes);
	      return;
	    case Opef.Tanh:
	      if (z.y !== 0) throw new Error(kernel.erreurCalculException);else {
	        zRes.y = 0;
	        var a = Math.exp(z.x);
	        var b = Math.exp(-z.x);
	        zRes.x = (a - b) / (a + b);
	        return;
	      }
	    case Opef.Rnd:
	      zRes.y = 0;
	      if (infoRandom) {
	        this.valeurDejaPrise = Math.random();
	        this.dejaPositionne = true;
	        zRes.x = this.valeurDejaPrise;
	      } else {
	        if (!this.dejaPositionne) {
	          this.valeurDejaPrise = Math.random();
	          this.dejaPositionne = true;
	          zRes.x = this.valeurDejaPrise;
	        } else zRes.x = this.valeurDejaPrise;
	      }
	      break;
	    case Opef.Conj:
	      zRes.x = z.x;
	      zRes.y = -z.y;
	      return;
	    case Opef.Arg:
	      if (z.x === 0 && z.y === 0) {
	        zRes.x = 0;
	        zRes.y = 0;
	        throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      } else {
	        zRes.x = z.argument(this.listeProprietaire.uniteAngle);
	        zRes.y = 0;
	        return;
	      }
	    case Opef.Re:
	      zRes.x = z.x;
	      zRes.y = 0;
	      return;
	    case Opef.Im:
	      zRes.x = z.y;
	      zRes.y = 0;
	      return;
	    case Opef.Rac:
	    case Opef.Rac2:
	    case Opef.Raci:
	    case Opef.Raci2:
	      zRes.x = 0;
	      zRes.y = 0;
	      if (z.y !== 0 || z.x < 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.x = Math.sqrt(z.x);
	        return;
	      }
	    case Opef.EntiC:
	    case Opef.Enti:
	      zRes.x = 0;
	      zRes.y = 0;
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.x = Math.floor(z.x);
	        return;
	      }
	    case Opef.ACosC:
	    case Opef.ACos:
	      // le résultat n'existe que si l'argument est réel
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) zRes.x = Math.acos(z.x);else zRes.x = Math.acos(z.x) * kernel.ConvRadDeg;
	        return;
	      }
	    case Opef.ASinC:
	    case Opef.ASin:
	      // le résultat n'existe que si l'argument est réel
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) zRes.x = Math.asin(z.x);else zRes.x = Math.asin(z.x) * kernel.ConvRadDeg;
	        return;
	      }
	    case Opef.ATanC:
	    case Opef.ATan:
	      // le résultat n'existe que si l'argument est réel
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) zRes.x = Math.atan(z.x);else zRes.x = Math.atan(z.x) * kernel.ConvRadDeg;
	        return;
	      }
	    case Opef.ArgChC:
	    case Opef.ArgCh:
	      // le résultat n'existe que si l'argument est réel
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        if (z.x >= 1) zRes.x = Math.log(z.x + Math.sqrt(z.x * z.x - 1));else throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      }
	      break;
	    case Opef.ArgShC:
	    case Opef.ArgSh:
	      // le résultat n'existe que si l'argument est réel
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        zRes.x = Math.log(z.x + Math.sqrt(z.x * z.x + 1));
	        return;
	      }
	    case Opef.ArgThC:
	      // le résultat n'existe que si l'argument est réel
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        if (z.x > -1 && z.x < 1) zRes.x = 0.5 * Math.log((1 + z.x) / (1 - z.x));else throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      }
	      break;
	    case Opef.factC:
	    case Opef.fact:
	      if (z.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        zRes.y = 0;
	        if (z.x < 0 || z.x !== Math.round(z.x)) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	        if (z.x <= 32) {
	          var p = 1;
	          for (var i = 2; i <= z.x; i++) {
	            p = p * i;
	          }
	          zRes.x = p;
	        } else {
	          var x = z.x;
	          var x1 = x;
	          var d = 1 + 1 / (12 * x1);
	          x1 *= x;
	          d += 1 / (288 * x1);
	          x1 *= x;
	          d -= 139 / (51840 * x1);
	          x1 *= x;
	          d -= 571 / (2488320 * x1);
	          x1 *= x;
	          d -= 163879 / (209018880 * x1);
	          zRes.x = Math.exp(0.5 * Math.log(2 * Math.PI * x) + x * (Math.log(x) - 1)) * d;
	        }
	      }
	  } // switch Opef}
	};
	CFonction.prototype.resultatComplexe = function (infoRandom, zRes) {
	  switch (this.Opef) {
	    case Opef.Left:
	    case Opef.LeftC:
	      // Rajouté version 4.7.2
	      this.operande.membreGauche().resultatComplexe(infoRandom, zRes);
	      break; // Rajouté version 4.7.2
	    case Opef.Right:
	    case Opef.RightC:
	      // Rajouté version 4.7.2
	      this.operande.membreDroit().resultatComplexe(infoRandom, zRes);
	      break; // Rajouté version 4.7.2
	    default:
	      this.operande.resultatComplexe(infoRandom, this.z1loc);
	      this.resultatComplexeBase(infoRandom, this.z1loc, zRes);
	  }
	};
	CFonction.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  switch (this.Opef) {
	    case Opef.Left:
	    case Opef.LeftC:
	      // Rajouté version 4.7.2
	      var mg = this.operande.membreGauche();
	      if (mg === null) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      mg.resultatFonctionComplexe(infoRandom, valeurParametre, zRes);
	      break; // Rajouté version 4.7.2
	    case Opef.Right:
	    case Opef.RightC:
	      // Rajouté version 4.7.2
	      var md = this.operande.membreDroit();
	      if (md === null) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      md.resultatFonctionComplexe(infoRandom, valeurParametre, zRes);
	      break; // Rajouté version 4.7.2
	    default:
	      this.operande.resultatFonctionComplexe(infoRandom, valeurParametre, this.z1loc);
	      this.resultatComplexeBase(infoRandom, this.z1loc, zRes);
	  }
	};
	CFonction.prototype.dependDeVariable = function (ind) {
	  switch (this.Opef) {
	    case Opef.Left:
	    case Opef.LeftC:
	      return this.operande.membreGauche().dependDeVariable(ind);
	    case Opef.Right:
	    case Opef.RightC:
	      return this.operande.membreDroit().dependDeVariable(ind);
	    default:
	      return this.operande.dependDeVariable(ind);
	  }
	};
	CFonction.prototype.getCopie = function () {
	  return new CFonction(this.listeProprietaire, this.Opef, this.operande.getCopie());
	};
	CFonction.prototype.chaineCalcul = function (varFor) {
	  var cha = this.operande.chaineCalculSansPar(varFor);
	  var parouv = "(";
	  var parfer = ")";
	
	  switch (this.Opef) {
	    case Opef.Abso:
	    case Opef.Abs:
	      return kernel.getString("abs") + parouv + cha + parfer;
	    case Opef.Enti:
	    case Opef.EntiC:
	      return kernel.getString("intgr") + parouv + cha + parfer;
	    case Opef.Raci:
	    case Opef.Rac:
	      return kernel.getString("sqrt") + parouv + cha + parfer;
	    case Opef.Raci2:
	    case Opef.Rac2:
	      return kernel.getString("rac") + parouv + cha + parfer;
	    case Opef.Sinu:
	    case Opef.Sin:
	      return kernel.getString("sin") + parouv + cha + parfer;
	    case Opef.Cosi:
	    case Opef.Cos:
	      return kernel.getString("cos") + parouv + cha + parfer;
	    case Opef.Tang:
	    case Opef.Tan:
	      return kernel.getString("tan") + parouv + cha + parfer;
	    case Opef.Logn:
	    case Opef.Log:
	      return kernel.getString("ln") + parouv + cha + parfer;
	    case Opef.Expo:
	    case Opef.Exp:
	      return kernel.getString("exp") + parouv + cha + parfer;
	    case Opef.ATan:
	    case Opef.ATanC:
	      return kernel.getString("arctan") + parouv + cha + parfer;
	    case Opef.ACos:
	    case Opef.ACosC:
	      return kernel.getString("arccos") + parouv + cha + parfer;
	    case Opef.ASin:
	    case Opef.ASinC:
	      return kernel.getString("arcsin") + parouv + cha + parfer;
	    case Opef.Cosh:
	    case Opef.Ch:
	      return kernel.getString("ch") + parouv + cha + parfer;
	    case Opef.Sinh:
	    case Opef.Sh:
	      return kernel.getString("sh") + parouv + cha + parfer;
	    case Opef.Tanh:
	    case Opef.Th:
	      return kernel.getString("th") + parouv + cha + parfer;
	    case Opef.fact:
	    case Opef.factC:
	      return kernel.getString("fact") + parouv + cha + parfer;
	    // Deux ajouts version 4.6
	    case Opef.Left:
	    case Opef.LeftC:
	      return kernel.getString("left") + parouv + cha + parfer;
	    case Opef.Right:
	    case Opef.RightC:
	      return kernel.getString("right") + parouv + cha + parfer;
	    // A revoir ici. Pour la version 1.5 j'ai oublie le ArgCh
	    case Opef.ArgCh:
	    case Opef.ArgChC:
	      return kernel.getString("argch") + parouv + cha + parfer;
	    case Opef.ArgSh:
	    case Opef.ArgShC:
	      return kernel.getString("argsh") + parouv + cha + parfer;
	    case Opef.ArgTh:
	    case Opef.ArgThC:
	      return kernel.getString("argth") + parouv + cha + parfer;
	    case Opef.Rand:
	    case Opef.Rnd:
	      return kernel.getString("rand") + parouv + cha + parfer;
	    case Opef.Conj:
	      return kernel.getString("conj") + parouv + cha + parfer;
	    case Opef.Arg:
	      return kernel.getString("arg") + parouv + cha + parfer;
	    case Opef.Re:
	      return kernel.getString("re") + parouv + cha + parfer;
	    case Opef.Im:
	      return kernel.getString("im") + parouv + cha + parfer;
	
	    default:
	      return "";
	  } // switch Opef}}
	};
	CFonction.prototype.chaineLatex = function (varFor) {
	  var parouvLatex = "\\left(";
	  var parferLatex = "\\right)";
	  var cha = this.operande.chaineLatexSansPar(varFor);
	
	  switch (this.Opef) {
	    case Opef.Abso:
	    case Opef.Abs:
	      return "\\left| {" + cha + "} \\right|";
	    case Opef.Enti:
	    case Opef.EntiC:
	      return kernel.getString("intgr") + parouvLatex + cha + parferLatex;
	    case Opef.Raci:
	    case Opef.Rac:
	      return "\\sqrt{" + cha + "}";
	    case Opef.Raci2:
	    case Opef.Rac2:
	      return "\\sqrt{" + cha + "}";
	    case Opef.Sinu:
	    case Opef.Sin:
	      return kernel.getString("sin") + parouvLatex + cha + parferLatex;
	    case Opef.Cosi:
	    case Opef.Cos:
	      return kernel.getString("cos") + parouvLatex + cha + parferLatex;
	    case Opef.Tang:
	    case Opef.Tan:
	      return kernel.getString("tan") + parouvLatex + cha + parferLatex;
	    case Opef.Logn:
	    case Opef.Log:
	      return kernel.getString("ln") + parouvLatex + cha + parferLatex;
	    case Opef.Expo:
	    case Opef.Exp:
	      return "e^" + "{" + cha + "}";
	    case Opef.ATan:
	    case Opef.ATanC:
	      return kernel.getString("arctan") + parouvLatex + cha + parferLatex;
	    case Opef.ACos:
	    case Opef.ACosC:
	      return kernel.getString("arccos") + parouvLatex + cha + parferLatex;
	    case Opef.ASin:
	    case Opef.ASinC:
	      return kernel.getString("arcsin") + parouvLatex + cha + parferLatex;
	    case Opef.Cosh:
	    case Opef.Ch:
	      return kernel.getString("ch") + parouvLatex + cha + parferLatex;
	    case Opef.Sinh:
	    case Opef.Sh:
	      return kernel.getString("sh") + parouvLatex + cha + parferLatex;
	    case Opef.Tanh:
	    case Opef.Th:
	      return kernel.getString("th") + parouvLatex + cha + parferLatex;
	    case Opef.fact:
	    case Opef.factC:
	      if ((this.operande.nature() & (CCbGlob.natIntegraleDansFormule | CCbGlob.natMoinsUnaire | CCbGlob.natOperation | CCbGlob.natSommeDansFormule)) !== 0) return parouvLatex + cha + parferLatex + "!";else return cha + "!"; // A revoir
	    // Deux ajouts version 4.6
	    case Opef.Left:
	    case Opef.LeftC:
	      return kernel.getString("Left") + parouvLatex + cha + parferLatex;
	    case Opef.Right:
	    case Opef.RightC:
	      return kernel.getString("Left") + parouvLatex + cha + parferLatex;
	    // A revoir ici. Pour la version 1.5 j'ai oublie le ArgCh
	    case Opef.ArgCh:
	    case Opef.ArgChC:
	      return kernel.getString("argch") + parouvLatex + cha + parferLatex;
	    case Opef.ArgSh:
	    case Opef.ArgShC:
	      return kernel.getString("argsh") + parouvLatex + cha + parferLatex;
	    case Opef.ArgTh:
	    case Opef.ArgThC:
	      return kernel.getString("argth") + parouvLatex + cha + parferLatex;
	    case Opef.Rand:
	    case Opef.Rnd:
	      return kernel.getString("rand") + parouvLatex + cha + parferLatex;
	    case Opef.Conj:
	      return "\\overline {" + cha + "}";
	    case Opef.Arg:
	      return kernel.getString("arg") + parouvLatex + cha + parferLatex;
	    case Opef.Re:
	      return kernel.getString("re") + parouvLatex + cha + parferLatex;
	    case Opef.Im:
	      return kernel.getString("im") + parouvLatex + cha + parferLatex;
	
	    default:
	      return "";
	  } // switch Opef}}
	};
	CFonction.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.Opef = inps.readByte();
	  // A partir de la version 3.0, décalage des indices de fonctions complexes
	  if (this.nVersion === 1 && this.Opef >= 19) this.Opef += 45;
	  this.operande = inps.readObject(list);
	  if (this.Opef === Opef.Rand) {
	    this.valeurDejaPrise = inps.readDouble();
	    this.dejaPositionne = true;
	  }
	};
	CFonction.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeByte(this.Opef);
	  oups.writeObject(this.operande);
	  if (this.Opef === Opef.Rand) {
	    oups.writeDouble(this.valeurDejaPrise);
	  }
	};
	CFonction.prototype.estConstant = function () {
	  return this.Opef !== Opef.Rand && this.operande.estConstant();
	};
	CFonction.prototype.deriveePossible = function (indiceVariable) {
	  return this.operande.deriveePossible(indiceVariable);
	};
	CFonction.prototype.calculAvecValeursRemplacees = function () {
	  return new CFonction(this.listeProprietaire, this.Opef, this.operande.calculAvecValeursRemplacees());
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var Opef2v = __webpack_require__(20);
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	
	module.exports = CFonction2Var;
	
	/**
	 * Classe représentant dans un arbre binaire de calcul un appel de fonction
	 * prédéfinie à deux variables : maxi, mini, gcd, lcm, ncr, npr ou mod.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {Integer} Opef : Entier donnant l'opérateur (voir OperateurFonction mtg32.Opef)
	 * @param {CCb} operande1 : Le premier opérande.
	 * @param {CCb} operande2 : Le deuxième opérande.
	 * @returns {CFonction2Var}
	 */
	function CFonction2Var(listeProprietaire, Opef, operande1, operande2) {
	  CCb.call(this, listeProprietaire);
	  if (arguments.length !== 1) {
	    this.Opef = Opef;
	    this.operande1 = operande1;
	    this.operande2 = operande2;
	  }
	  this.z1loc = new Complexe();
	  this.z2loc = new Complexe();
	}
	CFonction2Var.prototype = new CCb();
	CFonction2Var.prototype.constructor = CFonction2Var;
	CFonction2Var.prototype.superClass = "CCb";
	CFonction2Var.prototype.className = "CFonction2Var";
	
	CFonction2Var.prototype.nombreVariables = function () {
	  return 2;
	};
	
	CFonction2Var.prototype.nature = function () {
	  return CCbGlob.natFonction2Var;
	};
	
	CFonction2Var.prototype.getClone = function (listeSource, listeCible) {
	  var cloneOperande1 = this.operande1.getClone(listeSource, listeCible);
	  var cloneOperande2 = this.operande2.getClone(listeSource, listeCible);
	  return new CFonction2Var(listeCible, this.Opef, cloneOperande1, cloneOperande2);
	};
	
	CFonction2Var.prototype.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  this.operande1.initialisePourDependance();
	  this.operande2.initialisePourDependance();
	};
	
	CFonction2Var.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCb.prototype.dependDe.call(this, p) || this.operande1.dependDe(p) || this.operande2.dependDe(p));
	};
	
	CFonction2Var.prototype.dependDePourBoucle = function (p) {
	  return this.operande1.dependDePourBoucle(p) || this.operande2.dependDePourBoucle(p);
	};
	
	CFonction2Var.prototype.existe = function (infoRandom) {
	  return this.operande1.existe(infoRandom) && this.operande2.existe(infoRandom);
	};
	/**
	 * Renvoie le résultat de la fonction réelle prédéfinie appliquée
	 * aux opérandes x et y.
	 * @param {Boolean} infoRandom : true si les calculs aléatoires par rand
	 * soient réactualisés.
	 * @param {Float} x : Le premier opérande
	 * @param {Float} y : Le second opérande
	 * @returns {Float}
	 */
	CFonction2Var.prototype.resultatBase = function (infoRandom, x, y) {
	  switch (this.Opef) {
	    case Opef2v.maxi:
	      if (x > y) return x;else return y;
	    case Opef2v.mini:
	      if (x < y) return x;else return y;
	    case Opef2v.gcd:
	      if (x !== Math.floor(x) || y !== Math.floor(y) || x === 0 && y === 0 || x < 0 || y < 0) throw new Error(kernel.erreurCalculException);else return kernel.pgcd(x, y);
	    case Opef2v.lcm:
	      if (x !== Math.floor(x) || y !== Math.floor(y) || x < 0 || y < 0) throw new Error(kernel.erreurCalculException);else return kernel.ppcm(x, y);
	    case Opef2v.ncr:
	      if (x !== Math.floor(x) || y !== Math.floor(y) || x < 0 || y < 0 || y > x) throw new Error(kernel.erreurCalculException);else return kernel.ncr(x, y);
	    case Opef2v.npr:
	      if (x !== Math.floor(x) || y !== Math.floor(y) || x < 0 || y < 0 || y > x) throw new Error(kernel.erreurCalculException);else return kernel.npr(x, y);
	    case Opef2v.mod:
	      if (x !== Math.floor(x) || y !== Math.floor(y) || x < 0 || y <= 0) throw new Error(kernel.erreurCalculException);else return Math.floor(x - Math.floor(x / y) * y + 0.5);
	
	    default:
	      throw new Error(kernel.erreurCalculException);
	  }
	};
	
	CFonction2Var.prototype.resultat = function (infoRandom) {
	  var x1 = this.operande1.resultat(infoRandom);
	  var y1 = this.operande2.resultat(infoRandom);
	  return this.resultatBase(infoRandom, x1, y1);
	};
	
	CFonction2Var.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  var x1 = this.operande1.resultatFonction(infoRandom, valeurParametre);
	  var y1 = this.operande2.resultatFonction(infoRandom, valeurParametre);
	  return this.resultatBase(infoRandom, x1, y1);
	};
	/**
	 * Renvoie le résultat de la fonction réelle prédéfinie appliquée
	 * aux opérandes complexes z1 et z2.
	 * @param {Boolean} infoRandom : true si les calculs aléatoires par rand doivent
	 * être réactualisés.
	 * @param {Complexe} z1 : Le premier opérande.
	 * @param {Complexe} z2 : Le second opérande.
	 * @param {Complexe} zRes : Contient au retour le résultat.
	 * @returns {undefined}
	 */
	CFonction2Var.prototype.resultatComplexeBase = function (infoRandom, z1, z2, zRes) {
	  zRes.y = 0;
	  if (z1.y !== 0 || z2.y !== 0) throw new Error(kernel.erreurCalculException);
	  switch (this.Opef) {
	    case Opef2v.maxiC:
	      if (z1.x > z2.x) zRes.x = z1.x;else zRes.x = z2.x;
	      break;
	    case Opef2v.miniC:
	      if (z1.x < z2.x) zRes.x = z1.x;else zRes.x = z2.x;
	      break;
	    case Opef2v.gcdC:
	      if (z1.x !== Math.floor(z1.x) || z2.x !== Math.floor(z2.x) || z1.x === 0 && z2.x === 0 || z1.x < 0 || z1.x < 0) throw new Error(kernel.erreurCalculException);else zRes.x = kernel.pgcd(z1.x, z2.x);
	      break;
	    case Opef2v.lcmC:
	      if (z1.x !== Math.floor(z1.x) || z2.x !== Math.floor(z2.x) || z1.x < 0 || z2.x < 0) throw new Error(kernel.erreurCalculException);else zRes.x = kernel.ppcm(z1.x, z2.x);
	      break;
	    case Opef2v.ncrC:
	      if (z1.x !== Math.floor(z1.x) || z2.x !== Math.floor(z2.x) || z1.x < 0 || z2.x < 0 || z2.x > z1.x) throw new Error(kernel.erreurCalculException);else zRes.x = kernel.ncr(z1.x, z2.x);
	      break;
	    case Opef2v.nprC:
	      if (z1.x !== Math.floor(z1.x) || z2.x !== Math.floor(z2.x) || z1.x < 0 || z2.x < 0 || z2.x > z1.x) throw new Error(kernel.erreurCalculException);else zRes.x = kernel.npr(z1.x, z2.x);
	      break;
	    case Opef2v.modC:
	      if (z1.x !== Math.floor(z1.x) || z2.x !== Math.floor(z2.x) || z1.x < 0 || z2.x <= 0) throw new Error(kernel.erreurCalculException);else zRes.x = Math.floor(z1.x - Math.floor(z1.x / z2.x) * z2.x + 0.5);
	      break;
	    default:
	      throw new Error(kernel.erreurCalculException);
	  }
	};
	
	CFonction2Var.prototype.resultatComplexe = function (infoRandom, zRes) {
	  this.operande1.resultatComplexe(infoRandom, this.z1loc);
	  this.operande2.resultatComplexe(infoRandom, this.z2loc);
	  this.resultatComplexeBase(infoRandom, this.z1loc, this.z2loc, zRes);
	};
	
	CFonction2Var.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  this.operande1.resultatFonctionComplexe(infoRandom, valeurParametre, this.z1loc);
	  this.operande2.resultatFonctionComplexe(infoRandom, valeurParametre, this.z2loc);
	  this.resultatComplexeBase(infoRandom, this.z1loc, this.z2loc, zRes);
	};
	
	CFonction2Var.prototype.dependDeVariable = function (ind) {
	  return this.operande1.dependDeVariable(ind) || this.operande2.dependDeVariable(ind);
	};
	
	CFonction2Var.prototype.getCopie = function () {
	  return new CFonction2Var(this.listeProprietaire, this.Opef, this.operande1.getCopie(), this.operande2.getCopie());
	};
	
	CFonction2Var.prototype.chaineCalcul = function (varFor) {
	  var parouv = "(";
	  var parfer = ")";
	  var cha1 = this.operande1.chaineCalculSansPar(varFor);
	  var cha2 = this.operande2.chaineCalculSansPar(varFor);
	  var ch = parouv + cha1 + "," + cha2 + parfer;
	
	  switch (this.Opef) {
	    case Opef2v.maxi:
	    case Opef2v.maxiC:
	      return kernel.getString("maxi") + ch;
	    case Opef2v.mini:
	    case Opef2v.miniC:
	      return kernel.getString("mini") + ch;
	    case Opef2v.gcd:
	    case Opef2v.gcdC:
	      return kernel.getString("gcd") + ch;
	    case Opef2v.lcm:
	    case Opef2v.lcmC:
	      return kernel.getString("lcm") + ch;
	    case Opef2v.ncr:
	    case Opef2v.ncrC:
	      return kernel.getString("ncr") + ch;
	    case Opef2v.npr:
	    case Opef2v.nprC:
	      return kernel.getString("npr") + ch;
	    case Opef2v.mod:
	    case Opef2v.modC:
	      return kernel.getString("mod") + ch;
	    default:
	      return "";
	  }
	};
	
	CFonction2Var.prototype.chaineLatex = function (varFor) {
	  var parouvLatex = "\\left(";
	  var parferLatex = "\\right)";
	  var cha1 = this.operande1.chaineLatexSansPar(varFor);
	  var cha2 = this.operande2.chaineLatexSansPar(varFor);
	  var ch = parouvLatex + cha1 + "," + cha2 + parferLatex;
	
	  switch (this.Opef) {
	    case Opef2v.maxi:
	    case Opef2v.maxiC:
	      return kernel.getString("maxi") + ch;
	    case Opef2v.mini:
	    case Opef2v.miniC:
	      return kernel.getString("mini") + ch;
	    case Opef2v.gcd:
	    case Opef2v.gcdC:
	      return kernel.getString("gcd") + ch;
	    case Opef2v.lcm:
	    case Opef2v.lcmC:
	      return kernel.getString("lcm") + ch;
	    case Opef2v.ncr:
	    case Opef2v.ncrC:
	      return kernel.getString("ncr") + ch;
	    case Opef2v.npr:
	    case Opef2v.nprC:
	      return kernel.getString("npr") + ch;
	    case Opef2v.mod:
	    case Opef2v.modC:
	      return kernel.getString("mod") + ch;
	    default:
	      return "";
	  }
	};
	
	CFonction2Var.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.Opef = inps.readByte();
	  this.operande1 = inps.readObject(list);
	  this.operande2 = inps.readObject(list);
	};
	
	CFonction2Var.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeByte(this.Opef);
	  oups.writeObject(this.operande1);
	  oups.writeObject(this.operande2);
	};
	
	CFonction2Var.prototype.estConstant = function () {
	  return this.operande1.estConstant() && this.operande2.estConstant();
	};
	
	CFonction2Var.prototype.deriveePossible = function (indiceVariable) {
	  return this.operande1.deriveePossible(indiceVariable) && this.operande2.deriveePossible(indiceVariable);
	};
	
	CFonction2Var.prototype.calculAvecValeursRemplacees = function () {
	  return new CFonction2Var(this.listeProprietaire, this.Opef, this.operande1.calculAvecValeursRemplacees(), this.operande2.calculAvecValeursRemplacees());
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var Opef3v = __webpack_require__(21);
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CFonction3Var;
	
	/**
	 * @constructor
	 * @extends CCb
	 * Classe représentant dans un arbre binaire de calcul un appel de fonction
	 * prédéfinie à trois variables : la seule fonction est si
	 * dont la syntaxe est si(test, valeursivari, valeursifaux)
	 * Si test vaux 1, renvoie valeursivari et sinon valeur si faux.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste proprétaire
	 * @param {Integer} Opef : Voir Opef3v. Caractérise la fonction.
	 * @param {CCb} operande1 : Le premier opérande test (vrai si 1, faux si 0)
	 * @param {CCb} operande2 : Le deuxième opérande valeursivrai
	 * @param {CCb} operande3 : Le troisième opérande valeursifaux
	 * @returns {CFonction3Var}
	 */
	function CFonction3Var(listeProprietaire, Opef, operande1, operande2, operande3) {
	  CCb.call(this, listeProprietaire);
	  if (arguments.length !== 1) {
	    this.Opef = Opef;
	    this.operande1 = operande1;
	    this.operande2 = operande2;
	    this.operande3 = operande3;
	  }
	  this.z1loc = new Complexe();
	  this.z2loc = new Complexe();
	  this.z3loc = new Complexe();
	}
	CFonction3Var.prototype = new CCb();
	CFonction3Var.prototype.constructor = CFonction3Var;
	CFonction3Var.prototype.superClass = "CCb";
	CFonction3Var.prototype.className = "CFonction3Var";
	
	CFonction3Var.prototype.nombreVariables = function () {
	  return 3;
	};
	
	CFonction3Var.prototype.nature = function () {
	  return CCbGlob.natFonction3Var;
	};
	
	CFonction3Var.prototype.getClone = function (listeSource, listeCible) {
	  var cloneOperande1 = this.operande1.getClone(listeSource, listeCible);
	  var cloneOperande2 = this.operande2.getClone(listeSource, listeCible);
	  var cloneOperande3 = this.operande3.getClone(listeSource, listeCible);
	  return new CFonction3Var(listeCible, this.Opef, cloneOperande1, cloneOperande2, cloneOperande3);
	};
	
	CFonction3Var.prototype.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  this.operande1.initialisePourDependance();
	  this.operande2.initialisePourDependance();
	  this.operande3.initialisePourDependance();
	};
	
	CFonction3Var.prototype.dependDe = function (p) {
	  return this.memoriseDependance(CCb.prototype.dependDe.call(this, p) || this.operande1.dependDe(p) || this.operande2.dependDe(p) || this.operande3.dependDe(p));
	};
	
	CFonction3Var.prototype.dependDePourBoucle = function (p) {
	  return this.operande1.dependDePourBoucle(p) || this.operande2.dependDePourBoucle(p) || this.operande3.dependDePourBoucle(p);
	};
	/**
	 * Fonction renvoyant 1 si le calcul existe et 0 sinon.
	 * Cette fonction et particulière pour le si :
	 * Si operande1 existe et s'il renvoie la valeur 1 existe renverra true
	 * si et seulement operande2 existe et s'il renvoie une autre valeur existe
	 * renverra true ssi operande3 existe
	 * @param {Boolean} infoRandom : true si les calculs aléatoires pas rand doivent réinitialisés.
	 * @returns {Boolean}
	 */
	CFonction3Var.prototype.existe = function (infoRandom) {
	  if (!this.operande1.existe(infoRandom)) return false;
	  // Modifié version 4.8
	  if (this.operande1.className === "CResultatValeur") {
	    return this.operande1.resultat(infoRandom) === 1 ? this.operande2.existe(infoRandom) : this.operande3.existe(infoRandom);
	  } else {
	    if (this.operande1.className === "CResultatValeur") {
	      var z = new Complexe();
	      this.operande1.resultatComplexe(infoRandom, z);
	      if (z.y === 0 && z.x === 1) return this.operande2.existe(infoRandom);else return this.operande3.existe(infoRandom);
	    } else {
	      try {
	        var x1 = this.operande1.resultat(infoRandom);
	        if (x1 === 1) return this.operande2.existe(infoRandom);else return this.operande3.existe(infoRandom);
	      } catch (e) {
	        return false;
	      }
	    }
	  }
	};
	// Pour une fonction réelle ou complexe de une ou plusieurs variables, quand on teste son existence, on appelle
	// existe. Or CFonction3Var.existe, dans le cas d'une fonction si provoque un appel de calcul pour un calcul normal
	// qu'il faut éviter quand une fonction utilise un si et qu'on teste son existence
	
	CFonction3Var.prototype.existePourFonc = function () {
	  return this.operande1.existePourFonc() && this.operande2.existePourFonc() && this.operande3.existePourFonc();
	};
	
	CFonction3Var.prototype.resultat = function (infoRandom) {
	  var x1 = this.operande1.resultat(infoRandom);
	  if (x1 === 1) return this.operande2.resultat(infoRandom);else return this.operande3.resultat(infoRandom);
	};
	
	CFonction3Var.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  var x1 = this.operande1.resultatFonction(infoRandom, valeurParametre);
	  if (x1 === 1) return this.operande2.resultatFonction(infoRandom, valeurParametre);else return this.operande3.resultatFonction(infoRandom, valeurParametre);
	};
	
	CFonction3Var.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  var x1 = this.operande1.resultatFonction(infoRandom, valeurParametre);
	  if (x1 === 1) return this.operande2.resultatFonction(infoRandom, valeurParametre);else return this.operande3.resultatFonction(infoRandom, valeurParametre);
	};
	CFonction3Var.prototype.resultatComplexe = function (infoRandom, zRes) {
	  this.operande1.resultatComplexe(infoRandom, this.z1loc);
	  if (this.z1loc.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  if (this.z1loc.x === 1) {
	    this.operande2.resultatComplexe(infoRandom, this.z2loc);
	    zRes.x = this.z2loc.x;
	    zRes.y = this.z2loc.y;
	  } else {
	    this.operande3.resultatComplexe(infoRandom, this.z3loc);
	    zRes.x = this.z3loc.x;
	    zRes.y = this.z3loc.y;
	  }
	};
	
	CFonction3Var.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  this.operande1.resultatFonctionComplexe(infoRandom, valeurParametre, this.z1loc);
	  if (this.z1loc.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  if (this.z1loc.x === 1) {
	    this.operande2.resultatFonctionComplexe(infoRandom, valeurParametre, this.z2loc);
	    zRes.x = this.z2loc.x;
	    zRes.y = this.z2loc.y;
	  } else {
	    this.operande3.resultatFonctionComplexe(infoRandom, valeurParametre, this.z3loc);
	    zRes.x = this.z3loc.x;
	    zRes.y = this.z3loc.y;
	  }
	};
	
	CFonction3Var.prototype.dependDeVariable = function (ind) {
	  return this.operande1.dependDeVariable(ind) || this.operande2.dependDeVariable(ind) || this.operande3.dependDeVariable(ind);
	};
	
	CFonction3Var.prototype.getCopie = function () {
	  return new CFonction3Var(this.listeProprietaire, this.Opef, this.operande1.getCopie(), this.operande2.getCopie(), this.operande3.getCopie());
	};
	
	CFonction3Var.prototype.chaineCalcul = function (varFor) {
	  var cha1, cha2, cha3;
	  cha1 = this.operande1.chaineCalculSansPar(varFor);
	  cha2 = this.operande2.chaineCalculSansPar(varFor);
	  cha3 = this.operande3.chaineCalculSansPar(varFor);
	  var ch = "(" + cha1 + "," + cha2 + "," + cha3 + ")";
	
	  switch (this.Opef) {
	    case Opef3v.si:
	    case Opef3v.siC:
	      return kernel.getString("si") + ch;
	    default:
	      return "";
	  }
	};
	
	CFonction3Var.prototype.chaineLatex = function (varFor) {
	  var parouvLatex = "\\left(";
	  var parferLatex = "\\right)";
	  var cha1, cha2, cha3;
	  cha1 = this.operande1.chaineLatexSansPar(varFor);
	  cha2 = this.operande2.chaineLatexSansPar(varFor);
	  cha3 = this.operande3.chaineLatexSansPar(varFor);
	  var ch = parouvLatex + cha1 + "," + cha2 + "," + cha3 + parferLatex;
	
	  switch (this.Opef) {
	    case Opef3v.si:
	    case Opef3v.siC:
	      return kernel.getString("si") + ch;
	    default:
	      return "";
	  }
	};
	
	CFonction3Var.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.Opef = inps.readByte();
	  this.operande1 = inps.readObject(list);
	  this.operande2 = inps.readObject(list);
	  this.operande3 = inps.readObject(list);
	};
	
	CFonction3Var.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeByte(this.Opef);
	  oups.writeObject(this.operande1);
	  oups.writeObject(this.operande2);
	  oups.writeObject(this.operande3);
	};
	
	CFonction3Var.prototype.estConstant = function () {
	  return this.operande1.estConstant() && this.operande2.estConstant() && this.operande3.estConstant();
	};
	
	CFonction3Var.prototype.deriveePossible = function (indiceVariable) {
	  return this.operande1.deriveePossible(indiceVariable) && this.operande2.deriveePossible(indiceVariable) && this.operande3.deriveePossible(indiceVariable);
	};
	
	CFonction3Var.prototype.calculAvecValeursRemplacees = function () {
	  return new CFonction3Var(this.listeProprietaire, this.Opef, this.operande1.calculAvecValeursRemplacees(), this.operande2.calculAvecValeursRemplacees(), this.operande3.calculAvecValeursRemplacees());
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var Ope = __webpack_require__(32);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CMoinsUnaire;
	
	/**
	 * @constructor
	 * @extends CCb
	 * Classe représentant le moins unaire dans un arbre binaire de calcul
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CCb} operande : L'opérande (lui-même un CCb)
	 * @returns {CMoinsUnaire}
	 */
	function CMoinsUnaire(listeProprietaire, operande) {
	  CCb.call(this, listeProprietaire);
	  if (arguments.length !== 1) {
	    this.operande = operande;
	  }
	  this._c1 = new Complexe();
	}
	CMoinsUnaire.prototype = new CCb();
	CMoinsUnaire.prototype.constructor = CMoinsUnaire;
	CMoinsUnaire.prototype.superClass = "CCb";
	CMoinsUnaire.prototype.className = "CMoinsUnaire";
	
	CMoinsUnaire.prototype.nature = function () {
	  return CCbGlob.natMoinsUnaire;
	};
	
	CMoinsUnaire.prototype.getClone = function (listeSource, listeCible) {
	  var cloneOperande = this.operande.getClone(listeSource, listeCible);
	  return new CMoinsUnaire(listeCible, cloneOperande);
	};
	
	CMoinsUnaire.prototype.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  this.operande.initialisePourDependance();
	};
	
	CMoinsUnaire.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCb.prototype.dependDe.call(this, p) || this.operande.dependDe(p));
	};
	
	CMoinsUnaire.prototype.dependDePourBoucle = function (p) {
	  return this.operande.dependDePourBoucle(p);
	};
	
	CMoinsUnaire.prototype.existe = function (infoRandom) {
	  return this.operande.existe(infoRandom);
	};
	
	CMoinsUnaire.prototype.resultat = function (infoRandom) {
	  return -this.operande.resultat(infoRandom);
	};
	
	CMoinsUnaire.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  return -this.operande.resultatFonction(infoRandom, valeurParametre);
	};
	
	CMoinsUnaire.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  return -this.operande.resultatFonction(infoRandom, valeurParametre);
	};
	
	CMoinsUnaire.prototype.resultatComplexe = function (infoRandom, zRes) {
	  this.operande.resultatComplexe(infoRandom, this._c1);
	  zRes.x = -this._c1.x;
	  zRes.y = -this._c1.y;
	};
	
	CMoinsUnaire.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  this.operande.resultatFonctionComplexe(infoRandom, valeurParametre, this._c1);
	  zRes.x = -this._c1.x;
	  zRes.y = -this._c1.y;
	};
	
	CMoinsUnaire.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  this.operande.resultatFonctionComplexe(infoRandom, valeurParametre, this._c1);
	  zRes.x = -this._c1.x;
	  zRes.y = -this._c1.y;
	};
	
	CMoinsUnaire.prototype.dependDeVariable = function (ind) {
	  return this.operande.dependDeVariable(ind);
	};
	
	CMoinsUnaire.prototype.getCopie = function () {
	  return new CMoinsUnaire(this.listeProprietaire, this.operande.getCopie());
	};
	
	CMoinsUnaire.prototype.chaineCalcul = function (varFor) {
	  var ch;
	  if (this.operande.nature() === CCbGlob.natOperation) {
	    var op1 = this.operande.Ope;
	    if (op1 === Ope.Plus || op1 === Ope.Moin || Ope.estTest(op1)) ch = this.operande.chaineCalcul(varFor);else ch = this.operande.chaineCalculSansPar(varFor);
	  } else ch = this.operande.chaineCalcul(varFor);
	  return "(-" + ch + ")";
	};
	
	CMoinsUnaire.prototype.chaineCalculSansPar = function (varFor) {
	  var ch;
	  if (this.operande.nature() === CCbGlob.natOperation) {
	    var op1 = this.operande.Ope;
	    if (op1 === Ope.Plus || op1 === Ope.Moin || Ope.estTest(op1)) ch = this.operande.chaineCalcul(varFor);else ch = this.operande.chaineCalculSansPar(varFor);
	  } else ch = this.operande.chaineCalculSansPar(varFor);
	  return "-" + ch;
	};
	
	CMoinsUnaire.prototype.chaineLatex = function (varFor) {
	  var ch;
	  if (this.operande.nature() === CCbGlob.natOperation) {
	    var op1 = this.operande.Ope;
	    if (op1 === Ope.Mult || op1 === Ope.Divi || Ope.estTest(op1)) ch = this.operande.chaineLatexSansPar(varFor);else ch = this.operande.chaineLatex(varFor);
	  } else ch = this.operande.chaineLatex(varFor);
	  return "\\left(" + "-" + ch + "\\right)";
	};
	
	CMoinsUnaire.prototype.chaineLatexSansPar = function (varFor) {
	  var ch;
	  if (this.operande.nature() === CCbGlob.natOperation) {
	    var op1 = this.operande.Ope;
	    if (op1 === Ope.Mult || op1 === Ope.Divi || Ope.estTest(op1)) ch = this.operande.chaineLatexSansPar(varFor);else ch = this.operande.chaineLatex(varFor);
	  } else ch = this.operande.chaineLatexSansPar(varFor);
	  return "-" + ch;
	};
	
	CMoinsUnaire.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.operande = inps.readObject(list);
	};
	
	CMoinsUnaire.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeObject(this.operande);
	};
	
	CMoinsUnaire.prototype.estConstant = function () {
	  return this.operande.estConstant();
	};
	CMoinsUnaire.prototype.deriveePossible = function (indiceVariable) {
	  return this.operande.deriveePossible(indiceVariable);
	};
	CMoinsUnaire.prototype.calculAvecValeursRemplacees = function () {
	  return new CMoinsUnaire(this.listeProprietaire, this.operande.calculAvecValeursRemplacees());
	};
	
	CMoinsUnaire.prototype.membreGauche = function () {
	  if (this.operande.nature() === CCbGlob.natOperation) {
	    if (this.operande.Ope === Ope.Mult || this.operande.Ope === Ope.Divi) return new CMoinsUnaire(this.listeProprietaire, this.operande.operande1);
	  }
	  return CCb.prototype.membreGauche.call(this);
	};
	
	CMoinsUnaire.prototype.membreDroit = function () {
	  if (this.operande.nature() === CCbGlob.natOperation) {
	    if (this.operande.Ope === Ope.Mult || this.operande.Ope === Ope.Divi) return this.operande.operande2;
	  }
	  return CCb.prototype.membreDroit.call(this);
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var Fonte = __webpack_require__(18);
	var Ope = __webpack_require__(32);
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = COperation;
	
	/**
	 * @constructor
	 * @extends CCb
	 * Classe représentant une opération dans un arbre binaire de calcul.
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire
	 * @param {CCb} operande1 : L'opérande de gauche
	 * @param {CCb} operande2 : L'opérande de droite
	 * @param {Integer} Ope : Caractérise l'opérateur. Voir mtg32.Operateur.
	 * @returns {COperation}
	 */
	function COperation(listeProprietaire, operande1, operande2, Ope) {
	  CCb.call(this, listeProprietaire);
	  if (arguments.length === 1) CCb.call(this, listeProprietaire);else {
	    this.operande1 = operande1;
	    this.operande2 = operande2;
	    this.Ope = Ope;
	  }
	  this.c1 = new Complexe();
	  this.c2 = new Complexe();
	}
	COperation.prototype = new CCb();
	COperation.prototype.constructor = COperation;
	COperation.prototype.superClass = "CCb";
	COperation.prototype.className = "COperation";
	
	COperation.zeroComp = "0+0*i";
	
	COperation.prototype.nature = function () {
	  return CCbGlob.natOperation;
	};
	
	COperation.prototype.getClone = function (listeSource, listeCible) {
	  var cloneOperande1 = this.operande1.getClone(listeSource, listeCible);
	  var cloneOperande2 = this.operande2.getClone(listeSource, listeCible);
	  return new COperation(listeCible, cloneOperande1, cloneOperande2, this.Ope);
	};
	
	COperation.prototype.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  this.operande1.initialisePourDependance();
	  this.operande2.initialisePourDependance();
	};
	
	COperation.prototype.dependDe = function (p) {
	  return this.memoriseDependance(this.operande1.dependDe(p) || this.operande2.dependDe(p));
	};
	
	COperation.prototype.dependDePourBoucle = function (p) {
	  return this.operande1.dependDePourBoucle(p) || this.operande2.dependDePourBoucle(p);
	};
	
	COperation.prototype.existe = function (infoRandom) {
	  return this.operande1.existe(infoRandom) && this.operande2.existe(infoRandom);
	};
	/**
	 * Fonction renvoyant le résultat de l'opérateur appliqué aux nombres réels
	 * op1 (opérande de gauche) et op2 (opérande de droite).
	 * @param {Float} op1 : Opérande de gauche
	 * @param {Float} op2 : Opérande de droite
	 * @returns {Float} : Le résultat de l'opération
	 */
	COperation.prototype.resultatBase = function (op1, op2) {
	  var denom;
	  switch (this.Ope) {
	    case Ope.Plus:
	      return op1 + op2;
	    case Ope.Moin:
	      return op1 - op2;
	    case Ope.Mult:
	      return op1 * op2;
	    // à revoir pour gestion des exceptions
	    case Ope.Divi:
	      denom = op2;
	      if (denom === 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else return op1 / denom;
	    case Ope.Inf:
	      if (op1 < op2) return 1;else return 0;
	    case Ope.Sup:
	      if (op1 > op2) return 1;else return 0;
	    case Ope.InfOuEgal:
	      if (op1 <= op2) return 1;else return 0;
	    case Ope.SupOuEgal:
	      if (op1 >= op2) return 1;else return 0;
	    case Ope.Egalite:
	      if (op1 === op2) return 1;else return 0;
	    case Ope.Diff:
	      if (op1 !== op2) return 1;else return 0;
	    // Ajout version 4.9.5
	    case Ope.And:
	      if (op1 === 1 && op2 === 1) return 1;else return 0;
	    case Ope.Or:
	      if (op1 === 1 || op2 === 1) return 1;else return 0;
	
	    default:
	      return 0;
	  } // switch Ope
	};
	
	COperation.prototype.resultat = function (infoRandom) {
	  var o1 = this.operande1.resultat(infoRandom);
	  var o2 = this.operande2.resultat(infoRandom);
	  return this.resultatBase(o1, o2);
	};
	
	COperation.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  var o1 = this.operande1.resultatFonction(infoRandom, valeurParametre);
	  var o2 = this.operande2.resultatFonction(infoRandom, valeurParametre);
	  return this.resultatBase(o1, o2);
	};
	// op1 et op2 pointent sur deux complexes : les opérandes
	/**
	 * Fonction renvoyant le résultat de l'opérateur appliqué aux nombres complexes
	 * pointés par op1 (opérande de gauche) et op2 (opérande de droite).
	 * @param {Complexe} op1 : Opérande de gauche
	 * @param {Complexe} op2 : Opérande de droite
	 * @param {type} zRes : Le complexe dans lequel on met le résultat de l'opération.
	 * @returns {undefined}
	 */
	COperation.prototype.resultatComplexeBase = function (op1, op2, zRes) {
	  switch (this.Ope) {
	    case Ope.Plus:
	      zRes.x = op1.x + op2.x;
	      zRes.y = op1.y + op2.y;
	      return;
	    case Ope.Moin:
	      zRes.x = op1.x - op2.x;
	      zRes.y = op1.y - op2.y;
	      return;
	    case Ope.Mult:
	      zRes.x = op1.x * op2.x - op1.y * op2.y;
	      zRes.y = op1.x * op2.y + op1.y * op2.x;
	      return;
	    case Ope.Divi:
	      if (op2.x === 0 && op2.y === 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else kernel.divComp(op1, op2, zRes);
	      return;
	    case Ope.Inf:
	      // Si on est dans C, on n'accepte de comparer deux complexes
	      // que s'ils sont réels
	      zRes.x = 0;
	      zRes.y = 0;
	      if (op1.y !== 0 || op2.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        var mod1 = op1.x * op1.x + op1.y * op1.y;
	        var mod2 = op2.x * op2.x + op2.y * op2.y;
	        if (mod1 < mod2) zRes.x = 1;else zRes.x = 0;
	        return;
	      }
	    case Ope.Sup:
	      // Si on est dans C, on n'accepte de comparer deux complexes
	      // que s'ils sont réels
	      zRes.x = 0;
	      zRes.y = 0;
	      if (op1.y !== 0 || op2.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        if (op1.x > op2.x) zRes.x = 1;else zRes.x = 0;
	        return;
	      }
	    case Ope.InfOuEgal:
	      // Si on est dans C, on n'accepte de comparer deux complexes
	      // que s'ils sont réels
	      zRes.x = 0;
	      zRes.y = 0;
	      if (op1.y !== 0 || op2.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        if (op1.x <= op2.x) zRes.x = 1;else zRes.x = 0;
	        return;
	      }
	    case Ope.SupOuEgal:
	      // Si on est dans C, on n'accepte de comparer deux complexes
	      // que s'ils sont réels
	      zRes.x = 0;
	      zRes.y = 0;
	      if (op1.y !== 0 || op2.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        if (op1.x >= op2.x) zRes.x = 1;else zRes.x = 0;
	        return;
	      }
	    case Ope.Egalite:
	      zRes.y = 0;
	      if (op1.x === op2.x && op1.y === op2.y) zRes.x = 1;else zRes.x = 0;
	      return;
	    case Ope.Diff:
	      zRes.y = 0;
	      if (op1.x !== op2.x || op1.y !== op2.y) zRes.x = 1;else zRes.x = 0;
	      return;
	    // Ajout version 4.9.5
	    case Ope.And:
	      zRes.y = 0;
	      if (op1.y !== 0 || op2.y !== 0) zRes.x = 0; // aux si les opérandes ne sont pas réels
	      else {
	          if (op1.x === 1 && op2.x === 1) zRes.x = 1;else zRes.x = 0;
	        }
	      return;
	    case Ope.Or:
	      zRes.y = 0;
	      if (op1.y !== 0 || op2.y !== 0) zRes.x = 0; // Faux si les opérandes ne sont pas réels
	      else {
	          if (op1.x === 1 || op2.x === 1) zRes.x = 1;else zRes.x = 0;
	        }
	      return;
	
	  } // switch Ope
	};
	
	COperation.prototype.resultatComplexe = function (infoRandom, zRes) {
	  this.operande1.resultatComplexe(infoRandom, this.c1);
	  this.operande2.resultatComplexe(infoRandom, this.c2);
	  this.resultatComplexeBase(this.c1, this.c2, zRes);
	};
	
	COperation.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  this.operande1.resultatFonctionComplexe(infoRandom, valeurParametre, this.c1);
	  this.operande2.resultatFonctionComplexe(infoRandom, valeurParametre, this.c2);
	  this.resultatComplexeBase(this.c1, this.c2, zRes);
	};
	
	COperation.prototype.dependDeVariable = function (ind) {
	  return this.operande1.dependDeVariable(ind) || this.operande2.dependDeVariable(ind);
	};
	
	COperation.prototype.getCopie = function () {
	  return new COperation(this.listeProprietaire, this.operande1.getCopie(), this.operande2.getCopie(), this.Ope);
	};
	
	COperation.prototype.chaineCalcul = function (varFor) {
	  var ch1 = "",
	      ch2 = "",
	      ch = "";
	  var parouv = "(";
	  var parfer = ")";
	  switch (this.Ope) {
	    case Ope.Plus:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        var op1 = this.operande1.Ope;
	        if (op1 === Ope.Plus || op1 === Ope.Moin || op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      } else {
	        // else ch1 = operande1.chaineCalcul(varFor);
	        // Rajouté version 4.6
	        if (this.operande1.nature() === CCbGlob.natMoinsUnaire) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      }
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        var op2 = this.operande2.Ope;
	        if (op2 === Ope.Plus || op2 === Ope.Moin || op2 === Ope.Mult || op2 === Ope.Divi) ch2 = this.operande2.chaineCalculSansPar(varFor);else ch2 = this.operande2.chaineCalcul(varFor);
	      } else ch2 = this.operande2.chaineCalcul(varFor);
	      ch = parouv + ch1 + "+" + ch2 + parfer;
	      break;
	    case Ope.Moin:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        op1 = this.operande1.Ope;
	        if (op1 === Ope.Plus || op1 === Ope.Moin || op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      } else {
	        // ch1 = operande1.chaineCalcul(varFor);
	        // Rajouté version 4.6
	        if (this.operande1.nature() === CCbGlob.natMoinsUnaire) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      }
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        op2 = this.operande2.Ope;
	        if (op2 === Ope.Mult || op2 === Ope.Divi) ch2 = this.chaineCalculSansPar(varFor);else ch2 = this.operande2.chaineCalcul(varFor);
	      } else ch2 = this.operande2.chaineCalcul(varFor);
	      ch = parouv + ch1 + "-" + ch2 + parfer;
	      break;
	    case Ope.Mult:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        op1 = this.operande1.Ope;
	        if (op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      } else ch1 = this.operande1.chaineCalcul(varFor);
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        op2 = this.operande2.Ope;
	        if (op2 === Ope.Mult) ch2 = this.operande2.chaineCalculSansPar(varFor);else ch2 = this.operande2.chaineCalcul(varFor);
	      } else ch2 = this.operande2.chaineCalcul(varFor);
	      ch = parouv + ch1 + "*" + ch2 + parfer;
	      break;
	    case Ope.Divi:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        op1 = this.operande1.Ope;
	        if (op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      } else ch1 = this.operande1.chaineCalcul(varFor);
	      ch2 = this.operande2.chaineCalcul(varFor);
	      ch = parouv + ch1 + "/" + ch2 + parfer;
	      break;
	    case Ope.Inf:
	    case Ope.Sup:
	    case Ope.InfOuEgal:
	    case Ope.SupOuEgal:
	    case Ope.Egalite:
	    case Ope.Diff:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        // var oper1 = operande1;
	        if (Ope.estTest(this.operande1.Ope)) ch1 = this.operande1.chaineCalcul(varFor);else ch1 = this.operande1.chaineCalculSansPar(varFor);
	      } else ch1 = this.operande1.chaineCalculSansPar(varFor);
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        // var oper2 = operande2;
	        if (Ope.estTest(this.operande2.Ope)) ch2 = this.operande2.chaineCalcul(varFor);else ch2 = this.operande2.chaineCalculSansPar(varFor);
	      } else ch2 = this.operande2.chaineCalculSansPar(varFor);
	      ch = parouv + ch1 + Ope.chaineOperateur(this.Ope) + ch2 + parfer;
	      break;
	    case Ope.And:
	    case Ope.Or:
	      ch1 = this.operande1.chaineCalculSansPar(varFor);
	      var natop2 = this.operande2.nature();
	      if (natop2 === CCbGlob.natOperation) {
	        op2 = this.operande2.operateur;
	        if (op2 === Ope.And || op2 === Ope.Or) ch2 = this.operande2.chaineCalcul(varFor);else ch2 = this.operande2.chaineCalculSansPar(varFor);
	      } else ch2 = this.operande2.chaineCalculSansPar(varFor);
	      ch = parouv + ch1 + Ope.chaineOperateur(this.Ope) + ch2 + parfer;
	  } // switch Ope}
	  // Au cas où le calcul commençait par un moins unaire, la chaine commence par "0-"
	  if (ch.substring(0, 3) === "(0-") ch = parouv + "-" + ch.substring(3);
	  return ch;
	};
	COperation.prototype.chaineCalculSansPar = function (varFor) {
	  var ch1 = "",
	      ch2 = "",
	      ch = "";
	  switch (this.Ope) {
	    case Ope.Plus:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        var op1 = this.operande1.Ope;
	        if (op1 === Ope.Plus || op1 === Ope.Moin || op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      } else {
	        if (this.operande1.nature() === CCbGlob.natMoinsUnaire) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      }
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        var op2 = this.operande2.Ope;
	        if (op2 === Ope.Plus || op2 === Ope.Moin || op2 === Ope.Mult || op2 === Ope.Divi) ch2 = this.operande2.chaineCalculSansPar(varFor);else ch2 = this.operande2.chaineCalcul(varFor);
	      } else ch2 = this.operande2.chaineCalcul(varFor);
	      ch = ch1 + "+" + ch2;
	      break;
	    case Ope.Moin:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        op1 = this.operande1.Ope;
	        if (op1 === Ope.Plus || op1 === Ope.Moin || op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      } else {
	        if (this.operande1.nature() === CCbGlob.natMoinsUnaire) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      }
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        op2 = this.operande2.Ope;
	        if (op2 === Ope.Mult || op2 === Ope.Divi) ch2 = this.operande2.chaineCalculSansPar(varFor);else ch2 = this.operande2.chaineCalcul(varFor);
	      } else ch2 = this.operande2.chaineCalcul(varFor);
	      ch = ch1 + "-" + ch2;
	      break;
	    case Ope.Mult:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        op1 = this.operande1.Ope;
	        if (op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      } else ch1 = this.operande1.chaineCalcul(varFor);
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        op2 = this.operande2.Ope;
	        if (op2 === Ope.Mult) ch2 = this.operande2.chaineCalculSansPar(varFor);else ch2 = this.operande2.chaineCalcul(varFor);
	      } else ch2 = this.operande2.chaineCalcul(varFor);
	      ch = ch1 + "*" + ch2;
	      break;
	    case Ope.Divi:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        op1 = this.operande1.Ope;
	        if (op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineCalculSansPar(varFor);else ch1 = this.operande1.chaineCalcul(varFor);
	      } else ch1 = this.operande1.chaineCalcul(varFor);
	      ch2 = this.operande2.chaineCalcul(varFor);
	      ch = ch1 + "/" + ch2;
	      break;
	    // Modifié version 3.0
	    case Ope.Inf:
	    case Ope.Sup:
	    case Ope.InfOuEgal:
	    case Ope.SupOuEgal:
	    case Ope.Egalite:
	    case Ope.Diff:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        // var oper1 = operande1;
	        if (Ope.estTest(this.operande1.Ope)) ch1 = this.operande1.chaineCalcul(varFor);else ch1 = this.operande1.chaineCalculSansPar(varFor);
	      } else ch1 = this.operande1.chaineCalculSansPar(varFor);
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        // var oper2 = operande2;
	        if (Ope.estTest(this.operande2.Ope)) ch2 = this.operande2.chaineCalcul(varFor);else ch2 = this.operande2.chaineCalculSansPar(varFor);
	      } else ch2 = this.operande2.chaineCalculSansPar(varFor);
	      ch = ch1 + Ope.chaineOperateur(this.Ope) + ch2;
	      break;
	    case Ope.And:
	    case Ope.Or:
	      ch1 = this.operande1.chaineCalculSansPar(varFor);
	      var natop2 = this.operande2.nature();
	      if (natop2 === CCbGlob.natOperation) {
	        op2 = this.operande2.operateur;
	        if (op2 === Ope.And || op2 === Ope.Or) ch2 = this.operande2.chaineCalcul(varFor);else ch2 = this.operande2.chaineCalculSansPar(varFor);
	      } else ch2 = this.operande2.chaineCalculSansPar(varFor);
	      ch = ch1 + Ope.chaineOperateur(this.Ope) + ch2;
	
	  } // switch Ope}
	  // Pour un calcul complexe nul la chaîne renvoyée est "0+0*i" on renvoie alors "0"
	  if (ch === COperation.zeroComp) return "0";
	  // Au cas où le calcul commençait par un moins unaire, la chaine commence par "0-"
	  if (ch.substring(0, 2) === "0-") ch = ch.substring(1);
	
	  return ch;
	};
	
	COperation.prototype.chaineLatex = function (varFor) {
	  return "\\left(" + this.chaineLatexSansPar(varFor) + "\\right)";
	};
	
	COperation.prototype.chaineLatexSansPar = function (varFor) {
	  var ch1 = "",
	      ch2 = "",
	      ch = "";
	  switch (this.Ope) {
	    case Ope.Plus:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        var op1 = this.operande1.Ope;
	        if (op1 === Ope.Plus || op1 === Ope.Moin || op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineLatexSansPar(varFor);else ch1 = this.operande1.chaineLatex(varFor);
	      } else ch1 = this.operande1.chaineLatexSansPar(varFor);
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        var op2 = this.operande2.Ope;
	        if (op2 === Ope.Plus || op2 === Ope.Moin || op2 === Ope.Mult || op2 === Ope.Divi) ch2 = this.operande2.chaineLatexSansPar(varFor);else ch2 = this.operande2.chaineLatex(varFor);
	      } else ch2 = this.operande2.chaineLatex(varFor);
	      if (ch2.charAt(0) === "-") ch = ch1 + "-" + ch2.substring(1);else ch = ch1 + "+" + ch2;
	      break;
	    case Ope.Moin:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        op1 = this.operande1.Ope;
	        if (op1 === Ope.Plus || op1 === Ope.Moin || op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineLatexSansPar(varFor);else ch1 = this.operande1.chaineLatex(varFor);
	      } else {
	        if (this.operande1.nature() === CCbGlob.natMoinsUnaire) ch1 = this.operande1.chaineLatexSansPar(varFor);else ch1 = this.operande1.chaineLatex(varFor);
	      }
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        op2 = this.operande2.Ope;
	        if (op2 === Ope.Mult || op2 === Ope.Divi) ch2 = this.operande2.chaineLatexSansPar(varFor);else ch2 = this.operande2.chaineLatex(varFor);
	      } else ch2 = this.operande2.chaineLatex(varFor);
	      ch = ch1 + "-" + ch2;
	      break;
	    case Ope.Mult:
	      var bsignemult = false;
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        op1 = this.operande1.Ope;
	        if (op1 === Ope.Mult || op1 === Ope.Divi) ch1 = this.operande1.chaineLatexSansPar(varFor);else ch1 = this.operande1.chaineLatex(varFor);
	        // if (op1 == Ope.Divi) bsignemult = true; // Supprimé version 4.9.2
	      } else ch1 = this.operande1.chaineLatex(varFor);
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        op2 = this.operande2.Ope;
	        if (op2 === Ope.Mult || op2 === Ope.Divi) ch2 = this.operande2.chaineLatexSansPar(varFor);else ch2 = this.operande2.chaineLatex(varFor);
	        if (op2 === Ope.Divi) bsignemult = true;
	      } else ch2 = this.operande2.chaineLatex(varFor);
	      // ch = ch1 + "*" + ch2; // Sécial pour Latex, pas de signe multiplicatif
	      if (bsignemult || Fonte.chiffre(ch2.charAt(0))) ch = ch1 + "\\times " + ch2; // Espace de fin nécessaire
	      else ch = ch1 + ch2;
	      break;
	    case Ope.Divi:
	      var bfrac = true;
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        op1 = this.operande1.Ope;
	        if (op1 === Ope.Mult) {
	          bfrac = false;
	          var operandegauche1 = this.operande1.operande1;
	          if (operandegauche1.nature() === CCbGlob.natOperation) {
	            var opgauche1 = operandegauche1.Ope;
	            if (opgauche1 === Ope.Divi) {
	              bfrac = false;
	              ch1 = this.operande1.operande1.chaineLatexSansPar(varFor);
	              ch2 = "\\frac{" + this.operande1.operande2.chaineLatexSansPar(varFor) + "} {" + this.operande2.chaineLatexSansPar(varFor) + "}";
	            } else {
	              bfrac = true;
	              ch1 = this.operande1.chaineLatexSansPar(varFor);
	              ch2 = this.operande2.chaineLatexSansPar(varFor);
	            }
	          } else {
	            bfrac = true;
	            ch1 = this.operande1.chaineLatexSansPar(varFor);
	            ch2 = this.operande2.chaineLatexSansPar(varFor);
	          }
	        } else {
	          ch1 = this.operande1.chaineLatexSansPar(varFor);
	          ch2 = this.operande2.chaineLatexSansPar(varFor);
	        }
	      } else {
	        ch1 = this.operande1.chaineLatexSansPar(varFor);
	        ch2 = this.operande2.chaineLatexSansPar(varFor);
	      }
	      if (bfrac) ch = "\\frac{" + ch1 + "}{" + ch2 + "}";else ch = ch1 + "\\times" + ch2;
	      break;
	    // Modifié version 3.0
	    case Ope.Inf:
	    case Ope.Sup:
	    case Ope.InfOuEgal:
	    case Ope.SupOuEgal:
	    case Ope.Egalite:
	    case Ope.Diff:
	      if (this.operande1.nature() === CCbGlob.natOperation) {
	        // var oper1 = operande1;
	        if (Ope.estTest(this.operande1.Ope)) ch1 = this.operande1.chaineLatex(varFor);else ch1 = this.operande1.chaineLatexSansPar(varFor);
	      }
	      // else ch1 = operande1.chaineCalculSansPar(varFor); Correction défaut version 4.7.2
	      else ch1 = this.operande1.chaineLatexSansPar(varFor);
	      if (this.operande2.nature() === CCbGlob.natOperation) {
	        // var oper2 = operande2;
	        if (Ope.estTest(this.operande2.Ope)) ch2 = this.operande2.chaineLatex(varFor);else ch2 = this.operande2.chaineLatexSansPar(varFor);
	      } else ch2 = this.operande2.chaineLatexSansPar(varFor);
	
	      ch = ch1 + Ope.chaineOperateurLatex(this.Ope) + " " + ch2;
	      break;
	    case Ope.And:
	    case Ope.Or:
	      ch1 = this.operande1.chaineLatexSansPar(varFor);
	      var natop2 = this.operande2.nature();
	      if (natop2 === CCbGlob.natOperation) {
	        op2 = this.operande2.operateur;
	        if (op2 === Ope.And || op2 === Ope.Or) ch2 = this.operande2.chaineLatex(varFor);else ch2 = this.operande2.chaineLatexSansPar(varFor);
	      } else ch2 = this.operande2.chaineLatexSansPar(varFor);
	      ch = ch1 + Ope.chaineOperateurLatex(this.Ope) + ch2;
	
	  } // switch Ope}
	  // Pour un calcul complexe nul la chaîne renvoyée est "0+0*i" on renvoie alors "0"
	  if (ch === COperation.zeroComp) return "0";
	  // Au cas où le calcul commençait par un moins unaire, la chaine commence par "0-"
	  if (ch.substring(0, 2) === "0-") ch = ch.substring(1);
	
	  return ch;
	};
	
	COperation.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.Ope = inps.readByte();
	  this.operande1 = inps.readObject(list);
	  this.operande2 = inps.readObject(list);
	};
	
	COperation.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeByte(this.Ope);
	  oups.writeObject(this.operande1);
	  oups.writeObject(this.operande2);
	};
	
	COperation.prototype.estConstant = function () {
	  return this.operande1.estConstant() && this.operande2.estConstant();
	};
	
	COperation.prototype.deriveePossible = function (indiceVariable) {
	  return this.operande1.deriveePossible(indiceVariable) && this.operande2.deriveePossible(indiceVariable);
	};
	
	COperation.prototype.calculAvecValeursRemplacees = function () {
	  return new COperation(this.listeProprietaire, this.operande1.calculAvecValeursRemplacees(), this.operande2.calculAvecValeursRemplacees(), this.Ope);
	};
	
	COperation.prototype.membreGauche = function () {
	  return this.operande1;
	};
	
	COperation.prototype.membreDroit = function () {
	  return this.operande2;
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var Opef = __webpack_require__(19);
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CPuissance;
	
	/**
	 * Classe représentant une élévation à une puissance dans un arbre de calcul binaire.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CCb} operande
	 * @param {CCb} exposant
	 * @returns {CPuissance}
	 */
	function CPuissance(listeProprietaire, operande, exposant) {
	  CCb.call(this, listeProprietaire);
	  if (arguments.length !== 1) {
	    this.operande = operande;
	    this.exposant = exposant;
	  }
	  this.z1 = new Complexe();
	  this.ope1 = new Complexe();
	  this.exp1 = new Complexe();
	}
	CPuissance.prototype = new CCb();
	CPuissance.prototype.constructor = CPuissance;
	CPuissance.prototype.superClass = "CCb";
	CPuissance.prototype.className = "CPuissance";
	
	CPuissance.prototype.nature = function () {
	  return CCbGlob.natPuissance;
	};
	CPuissance.prototype.getClone = function (listeSource, listeCible) {
	  var cloneOperande = this.operande.getClone(listeSource, listeCible);
	  var cloneExposant = this.exposant.getClone(listeSource, listeCible);
	  // à revoir car la fonction a déjà été créée
	  return new CPuissance(listeCible, cloneOperande, cloneExposant);
	};
	CPuissance.prototype.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  this.operande.initialisePourDependance();
	  this.exposant.initialisePourDependance();
	};
	CPuissance.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCb.prototype.dependDe.call(this, p) || this.operande.dependDe(p) || this.exposant.dependDe(p));
	};
	CPuissance.prototype.dependDePourBoucle = function (p) {
	  return this.operande.dependDePourBoucle(p) || this.exposant.dependDePourBoucle(p);
	};
	CPuissance.prototype.existe = function (infoRandom) {
	  return this.operande.existe(infoRandom) && this.exposant.existe(infoRandom);
	};
	CPuissance.prototype.resultatBase = function (x, n) {
	  if (x === 0 && n !== 0) {
	    if (n > 0) return 0;else throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  }
	  if (n === 0) {
	    if (x === 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else return 1;
	  } else {
	    // Optimisation pour la version 2.0
	    // Pour un exposant entier compris entre 1 et 255
	    // on ne fait que des produits
	    if (n === Math.floor(n) && n > 0 && n < 256) return CCbGlob.puisExpEnt(x, n);else {
	      if (x < 0) {
	        if (n === Math.floor(n)) {
	          if (n === 2 * Math.floor(n / 2)) return Math.exp(n * Math.log(Math.abs(x)));else return -Math.exp(n * Math.log(Math.abs(x)));
	        } else throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      } else return Math.exp(n * Math.log(x));
	    }
	  }
	};
	CPuissance.prototype.resultat = function (infoRandom) {
	  var x1 = this.operande.resultat(infoRandom);
	  var n1 = this.exposant.resultat(infoRandom);
	  return this.resultatBase(x1, n1);
	};
	CPuissance.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  var x1 = this.operande.resultatFonction(infoRandom, valeurParametre);
	  var n1 = this.exposant.resultatFonction(infoRandom, valeurParametre);
	  return this.resultatBase(x1, n1);
	};
	CPuissance.prototype.resultatComplexeBase = function (ope, exp, zRes) {
	  var openull = ope.moduleCarre() === 0;
	  var expnull = exp.moduleCarre() === 0;
	  if (expnull) {
	    if (openull) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	      zRes.x = 1;
	      zRes.y = 0;
	    }
	  } else {
	    if (openull) {
	      zRes.x = 0;
	      zRes.y = 0;
	      // Si l'opérande est nul, on regarde si l'exposant est réel ou pas.
	      // S'il ne l'est pas, le résultat n'existe pas
	      if (exp.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);else {
	        if (exp.x <= 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	      }
	    } else {
	      // Si l'opérande n'est pas nul ni l'exposant
	      // On regarde si l'exposant est réel et strictemnt inférieur à 256.
	      // Si oui on utilise un algorithme n'utilisant que des produits
	      if (exp.y === 0 && exp.x === Math.floor(exp.x)) {
	        if (exp.x > 0 && exp.x < 256) {
	          var expent = exp.x;
	          ope.puisCompExpEnt(expent, zRes);
	        } else {
	          if (exp.x < 0 && exp.x > -256) {
	            expent = exp.x;
	            ope.puisCompExpEnt(-expent, this.z1);
	            this.z1.InverseComp(zRes);
	          } else ope.puisComp(exp, zRes);
	        }
	      } else ope.puisComp(exp, zRes);
	    }
	  }
	};
	CPuissance.prototype.resultatComplexe = function (infoRandom, zRes) {
	  this.operande.resultatComplexe(infoRandom, this.ope1);
	  this.exposant.resultatComplexe(infoRandom, this.exp1);
	  this.resultatComplexeBase(this.ope1, this.exp1, zRes);
	};
	CPuissance.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  this.operande.resultatFonctionComplexe(infoRandom, valeurParametre, this.ope1);
	  this.exposant.resultatFonctionComplexe(infoRandom, valeurParametre, this.exp1);
	  this.resultatComplexeBase(this.ope1, this.exp1, zRes);
	};
	CPuissance.prototype.dependDeVariable = function (ind) {
	  return this.operande.dependDeVariable(ind) || this.exposant.dependDeVariable(ind);
	};
	CPuissance.prototype.getCopie = function () {
	  return new CPuissance(this.listeProprietaire, this.operande.getCopie(), this.exposant.getCopie());
	};
	CPuissance.prototype.chaineCalcul = function (varFor) {
	  var chexp = this.exposant.chaineCalcul(varFor);
	  var natexp = this.exposant.nature();
	  var expestpuis = natexp === CCbGlob.natPuissance;
	  if (natexp === CCbGlob.natFonction) {
	    // CFonction fonc = (CFonction) exposant;
	    expestpuis = expestpuis || this.exposant.Opef === Opef.Exp || this.exposant.Opef === Opef.Expo;
	  }
	  if (expestpuis) chexp = "(" + chexp + ")";
	  var natop = this.operande.nature();
	  var opestpuis = natop === CCbGlob.natPuissance;
	  if (opestpuis) return "(" + this.operande.chaineCalcul(varFor) + ")^" + chexp;else return this.operande.chaineCalcul(varFor) + "^" + chexp;
	};
	CPuissance.prototype.chaineLatex = function (varFor) {
	  var parouvLatex = "\\left(";
	  var parferLatex = "\\right)";
	  var chexp = this.exposant.chaineLatexSansPar(varFor); // Parenthèses inutiles pour le LaTeX
	  var natop = this.operande.nature();
	  // Bug corrigé version 4.7.2.1
	  if ((natop & (CCbGlob.natPuissance | CCbGlob.natOperation | CCbGlob.natMoinsUnaire)) !== 0 || (natop & (CCbGlob.natFonction | CCbGlob.natFonction2Var | CCbGlob.natFonction3Var)) !== 0) return parouvLatex + this.operande.chaineLatexSansPar(varFor) + parferLatex + "^{" + chexp + "}";else return this.operande.chaineLatexSansPar(varFor) + "^{" + chexp + "}";
	};
	CPuissance.prototype.estConstant = function () {
	  return this.operande.estConstant() && this.exposant.estConstant();
	};
	CPuissance.prototype.deriveePossible = function (indiceVariable) {
	  return this.operande.deriveePossible(indiceVariable) && this.exposant.deriveePossible(indiceVariable);
	};
	CPuissance.prototype.calculAvecValeursRemplacees = function () {
	  return new CPuissance(this.listeProprietaire, this.operande.calculAvecValeursRemplacees(), this.exposant.calculAvecValeursRemplacees());
	};
	CPuissance.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.operande = inps.readObject(list);
	  this.exposant = inps.readObject(list);
	};
	CPuissance.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeObject(this.operande);
	  oups.writeObject(this.exposant);
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalcul = __webpack_require__(54);
	var CalcR = __webpack_require__(55);
	
	module.exports = CFonc;
	
	/**
	 * Fonction utilisateur réelle de une variable.
	 * @constructor
	 * @extends CCalcul
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet
	 * @param {Boolean} estElementFinal : true si l'objet est un objet inal de construction
	 * @param {String} nomCalcul : Le nom de la fonction.
	 * @param {String} chaineCalcul : La formule définissnt la focntion
	 * @param {String} chaineVariable : La varaible formelle utilisée pour la formule.
	 * @param {CCb} calcul : Arbre binaire repsentant le calcul.
	 * @returns {CFonc}
	 */
	// Attention : Ordre des deux derniers paramètres inversé par rapport version Java
	function CFonc(listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, chaineVariable, calcul) {
	  if (arguments.length !== 0) {
	    // 0 pour appel dans prototype
	    if (arguments.length === 1) CCalcul.call(this, listeProprietaire);else {
	      if (arguments.length === 3) CCalcul.call(this, listeProprietaire, impProto, estElementFinal);else {
	        this.chaineVariable = chaineVariable;
	        if (arguments.length <= 6) this.calcul = null;
	        if (calcul === null) CCalcul.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, CalcR.ccb(chaineCalcul, listeProprietaire, 0, chaineCalcul.length - 1, [chaineVariable]));else CCalcul.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, calcul);
	      }
	    }
	  }
	}
	CFonc.prototype = new CCalcul();
	CFonc.prototype.constructor = CFonc;
	CFonc.prototype.superClass = "CCalcul";
	CFonc.prototype.className = "CFonc";
	
	CFonc.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var calculClone = this.calcul.getClone(listeSource, listeCible);
	  return new CFonc(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, this.chaineCalcul, this.chaineVariable, calculClone);
	};
	CFonc.prototype.getNatureCalcul = function () {
	  return NatCal.NFonction;
	};
	CFonc.prototype.rendValeurFonctionComplexe = function (infoRandom, parametre, zRes) {
	  this.calcul.resultatFonctionComplexe(infoRandom, parametre, zRes);
	};
	// Spécial JavaScript. Lors de la création d'une fontion on crée automatiquement ici son calcul
	/**
	 * Crée l'arbre binaire de calcul associé et le met dans this.calcul.
	 * @returns {undefined}
	 */
	CFonc.prototype.creeCalcul = function () {
	  var va = new Array(1);
	  va[0] = this.chaineVariable;
	  this.calcul = CalcR.ccb(this.chaineCalcul, this.listeProprietaire, 0, this.chaineCalcul.length - 1, va);
	};
	/**
	 * Le nombre de variables de la fonction.
	 * Est redéfini pour les fonctions de plusieurs variables.
	 * @returns {Number}
	 */
	CFonc.prototype.nombreVariables = function () {
	  return 1;
	};
	CFonc.prototype.rendValeurFonction = function (infoRandom, parametre) {
	  return this.calcul.resultatFonction(infoRandom, parametre);
	};
	CFonc.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.calcul.existePourFonc();
	};
	CFonc.prototype.reconstruitChaineCalcul = function () {
	  var ch = new Array(1);
	  ch[0] = this.chaineVariable;
	  this.chaineCalcul = this.calcul.chaineCalculSansPar(ch);
	};
	CFonc.prototype.read = function (inps, list) {
	  CCalcul.prototype.read.call(this, inps, list);
	  this.chaineVariable = inps.readUTF();
	};
	CFonc.prototype.write = function (oups, list) {
	  CCalcul.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.chaineVariable);
	};
	CFonc.prototype.readSansCalcul = function (inps, list) {
	  CCalcul.prototype.readSansCalcul.call(this, inps, list);
	};
	CFonc.prototype.writeSansCalcul = function (oups, list) {
	  CCalcul.prototype.writeSansCalcul.call(this, oups, list);
	};
	CFonc.prototype.estFonctionOuSuite = function () {
	  return true;
	};
	/**
	 * Spécial JavaScript : Renvoie la chaîen LaTeX de la formule du calcul
	 */
	CFonc.prototype.chaineLatex = function () {
	  return this.calcul.chaineLatexSansPar(this.chaineVariable);
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Nat = __webpack_require__(4);
	var CCalculAncetre = __webpack_require__(35);
	var CalcR = __webpack_require__(55);
	var CImplementationProto = __webpack_require__(64);
	
	module.exports = CCalcul;
	
	/**
	 * Classe représentant un calcul réel
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire
	 * @param {Boolean} estElementFinal : true si l'objet est un objet intermédiaire de construction
	 * @param {String} nomCalcul :Le nom du calcul
	 * @param {String} chaineCalcul : La chaîne repréentant le calcul
	 * @param {CCb} calcul : L'arbre binaire contenant le calcul proprement dit
	 * @returns {undefined}
	 */
	function CCalcul(listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, calcul) {
	  if (arguments.length === 0) CCalculAncetre.call(this); // Rajouté version WebPack
	  else {
	      if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	        if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);else {
	          CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	          this.chaineCalcul = chaineCalcul;
	          if (arguments.length === 5) this.calcul = CalcR.ccb(chaineCalcul, this.listeProprietaire, 0, chaineCalcul.length - 1, null);else this.calcul = calcul;
	        }
	      }
	      this.resultat = 0; // Le résultat fourni par le calcul
	    }
	}
	CCalcul.prototype = new CCalculAncetre();
	CCalcul.prototype.constructor = CCalcul;
	CCalcul.prototype.superClass = "CCalculAncetre";
	CCalcul.prototype.className = "CCalcul";
	
	CCalcul.prototype.getClone = function (listeSource, listeCible) {
	  var calculClone = this.calcul.getClone(listeSource, listeCible);
	  var ind1 = listeSource.indexOf(this.impProto);
	  return new CCalcul(listeCible, listeCible.get(ind1, CImplementationProto.prototype.className), this.estElementFinal, this.nomCalcul, this.chaineCalcul, calculClone);
	};
	
	CCalcul.prototype.getNatureCalcul = function () {
	  return NatCal.NCalculReel;
	};
	
	CCalcul.prototype.getNom = function () {
	  return this.nomCalcul;
	};
	
	/**
	 * Fonction reconstruisant la chaîne représentant le calcul à partir de son arbre
	 * binaire de calcul
	 * @returns {undefined}
	 */
	CCalcul.prototype.reconstruitChaineCalcul = function () {
	  this.chaineCalcul = this.calcul.chaineCalculSansPar(null);
	};
	
	CCalcul.prototype.rendValeur = function () {
	  return this.resultat;
	};
	
	CCalcul.prototype.positionne = function (infoRandom) {
	  this.existe = this.calcul.existe(infoRandom);
	  if (!this.existe) return;
	  // A revoir en java pour la gestion des erreurs de calcul
	  // AnnuleErreurDeCalcul();	// Pour détecter une éventuelle erreur de
	  //                         // calcul lors de l'appel
	  try {
	    this.listeProprietaire.initialiseNombreIterations();
	    this.resultat = this.calcul.resultat(infoRandom);
	  } catch (e) {
	    this.existe = false;
	    this.resultat = 0;
	  }
	  if (!isFinite(this.resultat)) {
	    this.existe = false;
	  }
	};
	
	CCalcul.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.calcul.dependDe(p));
	};
	
	CCalcul.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.calcul.dependDePourBoucle(p);
	};
	
	CCalcul.prototype.getNom = function () {
	  return this.nomCalcul;
	};
	/** A revoir version JavaScript
	CCalcul.prototype.modifiableParMenu = function() {
	CCalcul.prototype.dialogueModification = function(frame) {
	*/
	/**
	 * Fonction creant l'arbre binaire de calcul pour l'objet
	 * @returns {undefined}
	 */
	CCalcul.prototype.creeCalcul = function () {
	  this.calcul = CalcR.ccb(this.chaineCalcul, this.listeProprietaire, 0, this.chaineCalcul.length - 1, null);
	};
	
	CCalcul.prototype.estConstant = function () {
	  if (this.calcul === null) return false;
	  return this.calcul.estConstant();
	};
	
	CCalcul.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  this.chaineCalcul = inps.readUTF();
	  this.calcul = inps.readObject(list);
	};
	
	CCalcul.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.chaineCalcul);
	  oups.writeObject(this.calcul);
	};
	/**
	 * Fonction lisant l'objet dans le flux inps sans lire l'arbre binaire de calcul
	 * @param {DataInputStream} inps
	 * @param {CListeObjets} list : La liste propriétaire en cours de construction
	 * @returns {undefined}
	 */
	CCalcul.prototype.readSansCalcul = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	};
	/**
	 * Fonction enrengistrant l'objet dans le flux oups sans lire l'arbre binaire de calcul
	 * @param {DataOutputStream} inps
	 * @param {CListeObjets} list : La liste propriétaire en cours de construction
	 * @returns {undefined}
	 */
	CCalcul.prototype.writeSansCalcul = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	};
	/**
	 * Renvoie true si on peut calculer la dérivée du calcul par rapport
	 * à la variable d'indice indiceVariable (dans le cas d'une fonction réelle)
	 * @param {type} indiceVariable
	 * @returns {Boolean}
	 */
	CCalcul.prototype.deriveePossible = function (indiceVariable) {
	  return this.calcul.deriveePossible(indiceVariable);
	};
	
	CCalcul.prototype.membreGauche = function () {
	  return this.calcul.membreGauche();
	};
	
	CCalcul.prototype.membreDroit = function () {
	  return this.calcul.membreDroit();
	};
	/**
	 * Spécial JavaScript : Renvoie la chaîne LaTeX de la formule du calcul
	 * @returns {String}
	 */
	CCalcul.prototype.chaineLatex = function () {
	  return this.calcul.chaineLatexSansPar(null);
	};
	/**
	 * Fonction renvoyant un tableau formé des noms des variables formelles d'une fonction de une ou plusieurs variables
	 * Utilisé seulement pour les fonctions réelles ou complexes d'une ou plusieurs variables
	 * @returns {Array} :Le tableau renvoyé
	 */
	CCalcul.prototype.variableFormelle = function () {
	  var varFor = null;
	  if (this.estDeNatureCalcul(Nat.or(NatCal.NFonction, NatCal.NFonctionComplexe))) {
	    // CFonc f = (CFonc) calculAssocie;
	    varFor = new Array(1);
	    varFor[0] = this.chaineVariable;
	  } else {
	    if (this.estDeNatureCalcul(Nat.or(NatCal.NFonction2Var, NatCal.NFonction3Var, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var))) {
	      // CFoncNVar fnv = (CFoncNVar) calculAssocie;
	      varFor = new Array(this.nbVar);
	      // Modifié version 4.9.3
	      // for (var k = 0; k < this.nbVar; k++) varFor[k] = new String(this.chaineVariable[k]);
	      for (var k = 0; k < this.nbVar; k++) {
	        varFor[k] = this.chaineVariable[k];
	      }
	    }
	  }
	  return varFor;
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by yvesb on 12/12/2016.
	 */
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @version 5.1.2
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	var CCbGlob = __webpack_require__(31);
	var Pointeur = __webpack_require__(16);
	var Ope = __webpack_require__(32);
	var Opef = __webpack_require__(19);
	var Opef3v = __webpack_require__(21);
	var Opef5v = __webpack_require__(23);
	var Fonte = __webpack_require__(18);
	var NatCal = __webpack_require__(5);
	var kernel = __webpack_require__(8);
	
	var CalcR = {
	  /**
	   * Fonction statique récursive créant un arbre binaire de calcul à partir de la chaîne
	   * de caractères ch représentant le calcul, la chaîne étant interprétée de pdebut à pfin.
	   * nomVariableFormelle est un array dont les éléments représentent les noms éventuels des variables
	   * formelles quand le calcul évalué représente une fonction.
	   * Le calcul renvoie un résultat réel.
	   * Fonction appelée creeCalculBase dans la version Java.
	   * @param {String} ch : La chaîne décrivant le  calcul.
	   * @param {CListeObjets} ptListe : La liste propriétaire du calcul à créer.
	   * @param {Integer} pdebut : L'indice du début de l'interprétationde la chaîne
	   * @param {Integer} pfin : : L'indice de la fin de l'interprétationde la chaîne
	   * @param {Array} nomVariableFormelle : Un tableau donnant les noms des variables
	   * formelles dans le cas où le calcul est utilisé à l'intérieur d'une focntion de
	   * une ou plusieurs variables.
	   * @returns {CCalculBase}
	   */
	  ccb: function ccb(ch, ptListe, pdebut, pfin, nomVariableFormelle) {
	    var CAppelFonction = __webpack_require__(42);
	    var CAppelFonctionNVar = __webpack_require__(44);
	    var CConstante = __webpack_require__(45);
	    var CFonction = __webpack_require__(47);
	    var CFonction2Var = __webpack_require__(48);
	    var CFonction3Var = __webpack_require__(49);
	    var CIntegraleDansFormule = __webpack_require__(56);
	    var CMoinsUnaire = __webpack_require__(50);
	    var CVariableFormelle = __webpack_require__(57);
	    var CSommeDansFormule = __webpack_require__(58);
	    var CResultatValeur = __webpack_require__(59);
	    var COp = __webpack_require__(51);
	    var CProduitDansFormule = __webpack_require__(60);
	    var CPuissance = __webpack_require__(52);
	    var CCbNull = __webpack_require__(61);
	
	    try {
	      // Spécial JavaScript car pas d'erreur levée par charAt si pdebut > pFin
	      if (pdebut > pfin) throw new Error();
	      var ptr;
	      var info = { x: 0, y: 0 }; // Contiendra dans x l'indice du caractère
	      // précédent et dans y l'opérateur trouvé
	      var car;
	      var op;
	      // Int nomF = new Int();
	      var nomF = new Pointeur(null);
	      var longNom;
	      var ptVa = new Pointeur(null);
	      var parametreTrouve = new Pointeur(0);
	      var nombreVar = new Pointeur(0);
	      // On élimine les blancs de début
	      car = ch.charAt(pdebut);
	      while (car === ' ' && pdebut < pfin) {
	        pdebut++;
	        car = ch.charAt(pdebut);
	      }
	      // Puis de fin
	      car = ch.charAt(pfin);
	      while (car === ' ' && pdebut < pfin) {
	        pfin--;
	        car = ch.charAt(pfin);
	      }
	      ptr = CCbGlob.premierOperateurLogique(ch, pdebut, pfin, info);
	      if (ptr !== -1) {
	        return new COp(ptListe, CalcR.ccb(ch, ptListe, pdebut, info.x, nomVariableFormelle), CalcR.ccb(ch, ptListe, ptr + 1, pfin, nomVariableFormelle), info.y);
	      }
	      // On recherche d'abord les opérateurs d'inégalités
	      ptr = CCbGlob.premiereInegalite(ch, pdebut, pfin, info);
	      if (ptr !== -1) {
	        return new COp(ptListe, CalcR.ccb(ch, ptListe, pdebut, info.x, nomVariableFormelle), CalcR.ccb(ch, ptListe, ptr + 1, pfin, nomVariableFormelle), info.y);
	      } else {
	        // On recherche ensuite les operateurs d'addition ou soustraction
	        ptr = CCbGlob.premiereSomme(ch, pdebut, pfin);
	        if (ptr !== -1) {
	          // On regarde d'abord si la chaine commence par un signe - ou
	          // un signe +
	          car = ch.charAt(ptr);
	          if (car === '+') op = Ope.Plus;else op = Ope.Moin;
	          if (ptr === pdebut) {
	            car = ch.charAt(ptr);
	            if (car === '+') {
	              return CalcR.ccb(ch, ptListe, pdebut + 1, pfin, nomVariableFormelle);
	            } else {
	              return new CMoinsUnaire(ptListe, CalcR.ccb(ch, ptListe, pdebut + 1, pfin, nomVariableFormelle));
	            }
	          } else {
	            return new COp(ptListe, CalcR.ccb(ch, ptListe, pdebut, ptr - 1, nomVariableFormelle), CalcR.ccb(ch, ptListe, ptr + 1, pfin, nomVariableFormelle), op);
	          }
	        } // if (ptr !== NULL)
	        else {
	            ptr = CCbGlob.premierProduit(ch, pdebut, pfin);
	            if (ptr !== -1) {
	              car = ch.charAt(ptr);
	              if (car === '*') op = Ope.Mult;else op = Ope.Divi;
	              return new COp(ptListe, CalcR.ccb(ch, ptListe, pdebut, ptr - 1, nomVariableFormelle), CalcR.ccb(ch, ptListe, ptr + 1, pfin, nomVariableFormelle), op);
	            } else {
	              // Le calcul ne contient ni addition, ni différence, ni produit
	              // ni quotient}
	              // Attention : par rapport à la version C++ 1.8, autorisation
	              // du symbole ² d'élévation au carré.
	              ptr = CCbGlob.premierePuissance(ch, pdebut, pfin);
	              if (ptr !== -1) {
	                if (ch.charAt(ptr) === '²') {
	                  return new CPuissance(ptListe, CalcR.ccb(ch, ptListe, pdebut, ptr - 1, nomVariableFormelle), new CConstante(ptListe, 2));
	                } else return new CPuissance(ptListe, CalcR.ccb(ch, ptListe, pdebut, ptr - 1, nomVariableFormelle), CalcR.ccb(ch, ptListe, ptr + 1, pfin, nomVariableFormelle));
	              } else {
	                // On regarde si la chaine commence par le nom d'une fonction
	                // ou d'une valeur déjà définie
	                longNom = ptListe.commenceParNomFonctionOuValeurOuParametre(ch.substring(pdebut), nomVariableFormelle, ptVa, nomF, parametreTrouve, nombreVar);
	                if (longNom > 0) {
	                  if (parametreTrouve.getValue() !== -1) return new CVariableFormelle(ptListe, parametreTrouve.getValue());else {
	                    if (ptVa.getValue() === null) {
	                      // Modification version 3.0. Il faut regarder si la fonction
	                      // est une fonction de plusieurs paramètres ou non
	                      // Ajouté version 4.7.4.1
	                      if (CCbGlob.parentheseFermante(ch, pdebut + longNom) === -1) throw new Error();
	
	                      if (nombreVar.getValue() === 1) return new CFonction(ptListe, nomF.getValue(), CalcR.ccb(ch, ptListe, pdebut + longNom, pfin, nomVariableFormelle));else {
	                        if (nombreVar.getValue() === 2) {
	                          var indicePremiereVirg = CCbGlob.premiereVirgule(ch, pdebut + longNom + 1);
	                          var operande1 = CalcR.ccb(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle);
	                          var indiceParF = CCbGlob.parentheseFermanteApresVirgule(ch, indicePremiereVirg + 1);
	                          // A revoir plus tard si on crée des fonctions de trois
	                          // variables ou plus
	                          var operande2 = CalcR.ccb(ch, ptListe, indicePremiereVirg + 1, indiceParF - 1, nomVariableFormelle);
	                          return new CFonction2Var(ptListe, nomF.getValue(), operande1, operande2);
	                        } else {
	                          if (nombreVar.getValue() === 3) {
	                            // 3 variables
	                            // var operande1;
	                            indicePremiereVirg = CCbGlob.premiereVirgule(ch, pdebut + longNom + 1);
	                            operande1 = CalcR.ccb(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle);
	                            var indiceDeuxiemeVirg = CCbGlob.premiereVirgule(ch, indicePremiereVirg + 1);
	                            operande2 = CalcR.ccb(ch, ptListe, indicePremiereVirg + 1, indiceDeuxiemeVirg - 1, nomVariableFormelle);
	                            indiceParF = CCbGlob.parentheseFermanteApresVirgule(ch, indiceDeuxiemeVirg + 1);
	                            // A revoir plus tard si on crée des fonctions de trois
	                            // variables ou plus
	                            var operande3 = CalcR.ccb(ch, ptListe, indiceDeuxiemeVirg + 1, indiceParF - 1, nomVariableFormelle);
	                            return new CFonction3Var(ptListe, nomF.getValue(), operande1, operande2, operande3);
	                          } else {
	                            if (nombreVar.getValue() === 4) {
	                              // Seule fonction à 4 variables : Cas d'une intégrale
	                              indicePremiereVirg = CCbGlob.premiereVirgule(ch, pdebut + longNom + 1);
	                              indiceDeuxiemeVirg = CCbGlob.premiereVirgule(ch, indicePremiereVirg + 1);
	                              var indiceTroisiemeVirg = CCbGlob.premiereVirgule(ch, indiceDeuxiemeVirg + 1);
	                              indiceParF = CCbGlob.parentheseFermanteApresVirgule(ch, indiceTroisiemeVirg + 1);
	                              var nomVariableSommation = ch.substring(indicePremiereVirg + 1, indiceDeuxiemeVirg);
	                              /* nomVariableSommation = Kernel
	                               .retireEspacesDebutEtFin(nomVariableSommation); */ // Modifié version 4.7.5.2
	                              nomVariableSommation = nomVariableSommation.trim();
	                              var n = 0;
	                              if (nomVariableFormelle !== null) n = nomVariableFormelle.length;
	                              // String[] nomVariableFormelle2 = new String[n + 1];
	                              var nomVariableFormelle2 = new Array(n + 1);
	                              // Code nettoyé version mtgApp
	                              for (var j = 0; j < n; j++) {
	                                nomVariableFormelle2[j] = nomVariableFormelle[j];
	                              } // nomVariableFormelle2[n+1] = new String(nomVariableSommation);
	                              nomVariableFormelle2[n] = nomVariableSommation;
	                              return new CIntegraleDansFormule(ptListe, CalcR.ccb(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle2), CalcR.ccb(ch, ptListe, indiceDeuxiemeVirg + 1, indiceTroisiemeVirg - 1, nomVariableFormelle), CalcR.ccb(ch, ptListe, indiceTroisiemeVirg + 1, indiceParF - 1, nomVariableFormelle), nomVariableSommation, false);
	                            } else {
	                              // fonctions à 5 variables : la somme indicée et
	                              // produit indicé
	                              indicePremiereVirg = CCbGlob.premiereVirgule(ch, pdebut + longNom + 1);
	                              indiceDeuxiemeVirg = CCbGlob.premiereVirgule(ch, indicePremiereVirg + 1);
	                              indiceTroisiemeVirg = CCbGlob.premiereVirgule(ch, indiceDeuxiemeVirg + 1);
	                              var indiceQuatriemeVirg = CCbGlob.premiereVirgule(ch, indiceTroisiemeVirg + 1);
	                              indiceParF = CCbGlob.parentheseFermanteApresVirgule(ch, indiceQuatriemeVirg + 1);
	                              nomVariableSommation = ch.substring(indicePremiereVirg + 1, indiceDeuxiemeVirg);
	                              /*nomVariableSommation = Kernel
	                               .retireEspacesDebutEtFin(nomVariableSommation);*/ // Modifié version 4.7.5.2
	                              nomVariableSommation = nomVariableSommation.trim();
	                              n = 0;
	                              if (nomVariableFormelle !== null) n = nomVariableFormelle.length;
	                              // String[] nomVariableFormelle2 = new String[n + 1];
	                              nomVariableFormelle2 = new Array(n + 1);
	                              for (j = 0; j < n; j++) {
	                                nomVariableFormelle2[j] = nomVariableFormelle[j];
	                              }nomVariableFormelle2[n] = nomVariableSommation;
	                              if (nomF.getValue() === Opef5v.somme) return new CSommeDansFormule(ptListe, CalcR.ccb(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle2), CalcR.ccb(ch, ptListe, indiceDeuxiemeVirg + 1, indiceTroisiemeVirg - 1, nomVariableFormelle2), CalcR.ccb(ch, ptListe, indiceTroisiemeVirg + 1, indiceQuatriemeVirg - 1, nomVariableFormelle2), CalcR.ccb(ch, ptListe, indiceQuatriemeVirg + 1, indiceParF - 1, nomVariableFormelle2), nomVariableSommation);else return new CProduitDansFormule(ptListe, CalcR.ccb(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle2), CalcR.ccb(ch, ptListe, indiceDeuxiemeVirg + 1, indiceTroisiemeVirg - 1, nomVariableFormelle2), CalcR.ccb(ch, ptListe, indiceTroisiemeVirg + 1, indiceQuatriemeVirg - 1, nomVariableFormelle2), CalcR.ccb(ch, ptListe, indiceQuatriemeVirg + 1, indiceParF - 1, nomVariableFormelle2), nomVariableSommation);
	                            }
	                          }
	                        }
	                      }
	                    } else {
	                      if (ptVa.getValue().estFonctionOuSuite()) {
	                        // Ajouté version 4.7.4.1
	                        if (CCbGlob.parentheseFermante(ch, pdebut + longNom) === -1) throw new Error();
	                        var calc = ptVa.getValue();
	                        var nbvar = calc.nombreVariables();
	                        if (nbvar === 1) return new CAppelFonction(ptListe, ptVa.getValue(), CalcR.ccb(ch, ptListe, pdebut + longNom, pfin, nomVariableFormelle));else {
	                          // Ccb[] tabcal = new Ccb[nbvar];
	                          var tabcal = new Array(nbvar);
	                          var deb = pdebut + longNom;
	                          var fin = 0;
	                          for (var i = 0; i < nbvar - 1; i++) {
	                            fin = CCbGlob.premiereVirgule(ch, deb + 1);
	                            tabcal[i] = CalcR.ccb(ch, ptListe, deb + 1, fin - 1, nomVariableFormelle);
	                            deb = fin;
	                          }
	                          deb++;
	                          fin = CCbGlob.parentheseFermanteApresVirgule(ch, deb);
	                          tabcal[nbvar - 1] = CalcR.ccb(ch, ptListe, deb, fin - 1, nomVariableFormelle);
	                          return new CAppelFonctionNVar(ptListe, nbvar, ptVa.getValue(), tabcal);
	                        }
	                      } else {
	                        return new CResultatValeur(ptListe, ptVa.getValue());
	                      }
	                    }
	                  }
	                } else {
	                  // Dans le cas où l'expression commence par une parenthèse
	                  // ouvrante, elle finit par une fermante et il suffit
	                  // d'évaluer ce que la parenthèse contient
	                  car = ch.charAt(pdebut);
	                  // Si le premier caractère est une parenthèse ouvrante
	                  // il faut faire attention car le dernier peut être
	                  // un espace.
	                  // Cela a donné un bug dans la version 16 bits
	                  if (car === '(') {
	                    if (CCbGlob.parentheseFermante(ch, pdebut) === -1) throw new Error();else return CalcR.ccb(ch, ptListe, pdebut + 1, CCbGlob.parentheseFermante(ch, pdebut) - 1, nomVariableFormelle);
	                  } else
	                    // Le résultat ne peut être que numérique}
	                    {
	                      var chaineNombre = ch.substring(pdebut, pfin + 1);
	                      if (chaineNombre.length === 0) throw new Error(); // Spécial JavaScript
	                      if (Fonte.estDecimalCorrect(chaineNombre)) {
	                        var f = parseFloat(chaineNombre);
	                        if (isNaN(f)) throw new Error();else return new CConstante(ptListe, f);
	                      } else return new CCbNull(chaineNombre);
	                    }
	                }
	              }
	            }
	          }
	      }
	    } catch (e) {
	      // Amélioration version 4.7.4.1 : Même si l'expression est incorrecte, on remplace les * de multiplication par des \times
	      // Supprimé version 4.9.3
	      var ch1 = ch.substring(pdebut, pfin + 1);
	      // Amélioration version 4.9.3
	      if (ch1.charAt(0) === "(" && ch1.length >= 1) {
	        // Cas d'une parenthèse ouvrante non fermée
	        return CalcR.ccb(ch, ptListe, pdebut + 1, pfin, nomVariableFormelle);
	      }
	      return new CCbNull(ch1);
	      // return new CCbNull(stb.toString());
	    }
	  },
	  /**
	   * Fonction récursive vérifiant la syntaxe de l'expression réelle contenue dans ch en
	   * tenant compte du fait qu'elle ne doit pas utiliser de valeur dont l'indice
	   * dans ptListe est strictement supérieur à indiceMaxiDansListe.
	   * Le calcul doit être réel.
	   * @param {CListeObjets} ptListe : La liste propriétaire du calcul analysé
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche syntaxique.
	   * @param {Pointeur} indiceErreur : getValeur renverra l'indice de l'erreur
	   * de syntaxe dans la chapine s'il y en a une.
	   * @param {Integer} indiceMaxiDansListe : L'indice maxi d'interprétation dans la chaîne ch.
	   * @param {Array } parametreFormel : Un tableau représentant les noms de la ou des variables formelles
	   * d'une fonction de une ou plusieurs variables.
	   * @returns {Boolean} : true si la syntaxe est correcte, false sinon.
	   */
	  verifieSyntaxe: function verifieSyntaxe(ptListe, ch, indiceErreur, indiceMaxiDansListe, parametreFormel) {
	    var i;
	    var indiceDansListe;
	    var pdebut;
	    var car, carSuivant;
	    var erreur;
	    var longueurCh;
	    var itemPrecedent;
	    var itemSuivant = 0;
	    var pointDecimalRencontre;
	    var sommeParentheses;
	    var longNom;
	    var nomF = new Pointeur();
	    var ptVa = new Pointeur();
	    var queDesBlancs;
	    var parametreTrouve = new Pointeur(0);
	    var nombreVariables = new Pointeur(0);
	    var nivPar = 0; // Niveau de parenthèses
	    var appelFonction = new Array(CCbGlob.nombreMaxParentheses + 1); // Tableau de booléens 64 niveaux de parenthèses imbriqués maxi
	    for (var j = 0; j <= CCbGlob.nombreMaxParentheses; j++) {
	      appelFonction[j] = false;
	    }erreur = false;
	    longueurCh = ch.length;
	    // On vérifie d'abord qu'il n'y a pas d'erreur de parenthèse
	    if (longueurCh === 0) {
	      indiceErreur.setValue(0);
	      return false;
	    }
	    i = 0;
	    sommeParentheses = 0;
	    while (i < longueurCh && sommeParentheses >= 0) {
	      car = ch.charAt(i);
	      switch (car) {
	        case '(':
	          sommeParentheses++;
	          break;
	        case ')':
	          sommeParentheses--;
	      } // switch
	      i++;
	    }
	    if (sommeParentheses !== 0) {
	      indiceErreur.setValue(i);
	      return false;
	    }
	    if (ch === ".") {
	      indiceErreur.setValue(0);
	      return false;
	    }
	    i = 0;
	    // Tout se passe au début comme si l'expression était précédée
	    // d'une parenthèse ouvrante
	    itemPrecedent = CCbGlob.ParOuvrante;
	    while (i < longueurCh && !erreur) {
	      car = ch.charAt(i);
	      pointDecimalRencontre = false;
	      if (Fonte.chiffre(car) || car === '.') {
	        while ((Fonte.chiffre(car) || car === '.') && i < longueurCh && !erreur) {
	          if (car === '.') {
	            if (pointDecimalRencontre) {
	              erreur = true;
	              indiceErreur.setValue(i - 1);
	              // IndiceMessageErreur = IDE_SYNTAXE1;
	            } else pointDecimalRencontre = true;
	          }
	          i++;
	          if (i < longueurCh) car = ch.charAt(i);
	        } // while
	        if (!erreur) itemSuivant = CCbGlob.Nombre;
	      } else // cas où le caractère en cours n'est pas un nombre
	        // le caractère en cours n'est pas un chiffre ou un point décimal}
	        {
	          pdebut = i;
	          // On regarde si cela commence par le nom d'une fonction ou
	          // une valeur déjà définie
	          longNom = ptListe.commenceParNomFonctionOuValeurOuParametre(ch.substring(pdebut), parametreFormel, ptVa, nomF, parametreTrouve, nombreVariables);
	          if (longNom > 0) {
	            if (parametreTrouve.getValue() !== -1) {
	              itemSuivant = CCbGlob.Valeur;
	              i = i + longNom;
	            } else {
	              appelFonction[nivPar + 1] = true;
	              if (ptVa.getValue() === null) {
	                if (i + longNom < ch.length && ch.charAt(i + longNom) !== '(') {
	                  erreur = true;
	                  indiceErreur.setValue(i + longNom);
	                } else {
	                  itemSuivant = CCbGlob.Fonction;
	                  // Ajout version 4.5.2 pour corriger un bug
	                  if (!CCbGlob.autorisationSyntaxe(itemPrecedent, itemSuivant)) {
	                    erreur = true;
	                    indiceErreur.setValue(i);
	                    break;
	                  }
	                  // Fin ajout
	                  // Il faut regarder si la fonction est de plusieurs variables
	                  var nvirg = CCbGlob.NombreVirgules(ch, i + longNom + 1);
	                  if (nvirg !== nombreVariables.getValue() - 1) {
	                    if (nvirg <= nombreVariables.getValue() - 1) indiceErreur.setValue(CCbGlob.indiceCaractereVirgule(ch, i + longNom + 1, nvirg));else indiceErreur.setValue(CCbGlob.indiceCaractereVirgule(ch, i + longNom + 1, nombreVariables.getValue() - 1) - 1);
	                    erreur = true;
	                  } else {
	                    // Si le nombre de variables est supérieur ou égal à 4, il
	                    // s'agit soit d'un calcul d'intégrale
	                    // soit d'une somme indicée pour laquelle la syntaxe est la
	                    // même
	                    if (nombreVariables.getValue() >= 4) {
	
	                      nivPar++;
	                      var indicePremVirg = CCbGlob.premiereVirgule(ch, i + longNom + 1);
	                      var chformuleASommer = ch.substring(i + longNom + 1, indicePremVirg);
	                      var indiceDeuxiemeVirg = CCbGlob.premiereVirgule(ch, indicePremVirg + 1);
	                      var nomVariableSommation = ch.substring(indicePremVirg + 1, indiceDeuxiemeVirg);
	                      // Il faut retirer les espaces de début et de fin
	                      // On vérifie si le nom de variable formelle pour la somme est valable
	                      nomVariableSommation = nomVariableSommation.trim();
	                      if (!ptListe.validationNomCalculSansMessage(nomVariableSommation) || ptListe.egalNomValeurOuFonctionOuMesure(nomVariableSommation, -1)) {
	                        erreur = true;
	                        indiceErreur.setValue(indiceDeuxiemeVirg);
	                      } else {
	                        // On vérifie si la syntaxe du calcul à sommer est
	                        // correct.
	                        // Pour cela on appelle à nouveau vérifieSyntaxe
	                        var indiceErreur2 = new Pointeur(0);
	                        var n = 0;
	                        if (parametreFormel !== null) n = parametreFormel.length;
	                        var parametreFormel2 = new Array(n + 1);
	                        for (j = 0; j < n; j++) {
	                          parametreFormel2[j] = parametreFormel[j];
	                        }parametreFormel2[n] = nomVariableSommation;
	                        if (!CalcR.verifieSyntaxe(ptListe, chformuleASommer, indiceErreur2, indiceMaxiDansListe, parametreFormel2)) {
	                          erreur = true;
	                          indiceErreur.setValue(i + longNom + 1 + indiceErreur2.getValue());
	                        } else {
	                          i = indiceDeuxiemeVirg + 1;
	                          itemPrecedent = CCbGlob.Valeur;
	                          itemSuivant = CCbGlob.Virgule;
	                        }
	                      }
	                    } else i += longNom;
	                  }
	                }
	              } else {
	                var vd = ptVa.getValue();
	                indiceDansListe = ptListe.indexOf(vd);
	                if (indiceDansListe > indiceMaxiDansListe) {
	                  erreur = true;
	                  indiceErreur.setValue(i);
	                } else {
	                  i += longNom;
	                  if (vd.estFonctionOuSuite()) {
	                    if (i < ch.length && ch.charAt(i) !== '(') {
	                      erreur = true;
	                      indiceErreur.setValue(i + longNom);
	                    } else {
	                      itemSuivant = CCbGlob.Fonction;
	                      var nbvar = vd.nombreVariables();
	                      if (nbvar >= 2) {
	                        nvirg = CCbGlob.NombreVirgules(ch, i + 1);
	                        if (nvirg !== nombreVariables.getValue() - 1) {
	                          if (nvirg <= nombreVariables.getValue() - 1) indiceErreur.setValue(CCbGlob.indiceCaractereVirgule(ch, i + 1, nvirg));else indiceErreur.setValue(CCbGlob.indiceCaractereVirgule(ch, i + 1, nombreVariables.getValue() - 1) - 1);
	                          erreur = true;
	                        }
	                      }
	                      // Bug corrigé version 4.6 : Il ne faut pas qu'un appel de fonction d'une variable comprenne des virgules
	                      else {
	                          if (CCbGlob.NombreVirgules(ch, i + 1) > 0) {
	                            indiceErreur.setValue(ch.indexOf(',', i + 1));
	                            erreur = true;
	                          }
	                        }
	                    }
	                  } else itemSuivant = CCbGlob.Valeur;
	                }
	              }
	            }
	          } else {
	            switch (car) {
	              case '+':
	              case '-':
	                itemSuivant = CCbGlob.Addition;
	                i++;
	                break;
	              case '*':
	              case '/':
	                itemSuivant = CCbGlob.Multiplication;
	                i++;
	                break;
	              case '(':
	                if (nivPar >= CCbGlob.nombreMaxParentheses - 1) {
	                  erreur = true;
	                  indiceErreur.setValue(i);
	                } else {
	                  itemSuivant = CCbGlob.ParOuvrante;
	                  i++;
	                  nivPar++;
	                }
	                break;
	              case ')':
	                appelFonction[nivPar] = false;
	                nivPar--;
	                itemSuivant = CCbGlob.ParFermante;
	                i++;
	                break;
	              case '^':
	                itemSuivant = CCbGlob.Puissance;
	                i++;
	                break;
	              // Ajout par rapport à la version C++ 1.8, autorisation du carré ²
	              case '²':
	                itemSuivant = CCbGlob.Carre;
	                i++;
	                break;
	              // ni nombre ni opérateur}
	              case '<':
	                itemSuivant = CCbGlob.Inegalite;
	                i++;
	                if (i <= longueurCh - 2) {
	                  carSuivant = ch.charAt(i);
	                  if (carSuivant === '=' || carSuivant === '>') i++;
	                }
	                break;
	              case '>':
	                itemSuivant = CCbGlob.Inegalite;
	                i++;
	                if (i <= longueurCh - 2) {
	                  carSuivant = ch.charAt(i);
	                  if (carSuivant === '=') i++;
	                }
	                break;
	              // Ajout version 4.9.5
	              case '&':
	              case '|':
	              case '=':
	                itemSuivant = CCbGlob.Inegalite;
	                i++;
	                break;
	              case ' ':
	                itemSuivant = CCbGlob.Blanc;
	                i++;
	                break;
	              case ',':
	                if (!appelFonction[nivPar]) {
	                  erreur = true;
	                  indiceErreur.setValue(i);
	                } else {
	                  itemSuivant = CCbGlob.Virgule;
	                  i++;
	                }
	                break;
	              default:
	                // switch Car
	                erreur = true;
	                indiceErreur.setValue(i - 1);
	            } // switch Car
	          } // else du if LongNom > 0
	        } // else du if Chiffre(Car) || (Car === '.'))
	      if (!erreur) {
	        if (CCbGlob.autorisationSyntaxe(itemPrecedent, itemSuivant)) {
	          if (itemSuivant !== CCbGlob.Blanc) itemPrecedent = itemSuivant;
	        } else {
	          erreur = true;
	          indiceErreur.setValue(i - 1);
	        }
	      }
	    } // while
	    // Il faut aussi regarder si la fin de l'expression est correcte
	    itemSuivant = CCbGlob.ParFermante;
	    if (!erreur) {
	      if (!CCbGlob.autorisationSyntaxe(itemPrecedent, itemSuivant)) {
	        erreur = true;
	        indiceErreur.setValue(longueurCh);
	      }
	    }
	    if (indiceErreur.getValue() < 0) indiceErreur.setValue(0);else if (indiceErreur.getValue() > longueurCh) indiceErreur.setValue(longueurCh);
	    // On regarde si la chaîne ne contient que des blancs
	    i = 0;
	    queDesBlancs = true;
	    while (i <= longueurCh - 1 && queDesBlancs) {
	      car = ch.charAt(i);
	      if (car !== ' ') queDesBlancs = false;else i++;
	    }
	    if (queDesBlancs) {
	      erreur = true;
	      indiceErreur.setValue(longueurCh);
	    }
	    return !erreur;
	  },
	
	  /**
	   * Procédure récursive créant l'objet Ccb représentant l'arbre de la
	   * dérivée d'une fonction.
	   * Sera utilisé au chargement d'un objet du type CDerivee ou CEdriveePartielle.
	   * @param {CCb} calc : Le calcul dont on veut calculer la dérivée ou dérivée partielle.
	   * @param {Integer} indiceVar : L'indice de la variable par rapport à laquelle on dérive.
	   * @returns {CCb} : L'arbre de calcul binaire représentant la dérivée.
	   */
	  creeDerivee: function creeDerivee(calc, indiceVar) {
	    var CAppelFonctionInterne = __webpack_require__(62);
	    var CAppelFonctionInterneNVar = __webpack_require__(63);
	    var CConstante = __webpack_require__(45);
	    var CFonction = __webpack_require__(47);
	    var CMoinsUnaire = __webpack_require__(50);
	    var CSommeDansFormule = __webpack_require__(58);
	    var COp = __webpack_require__(51);
	    var CPuissance = __webpack_require__(52);
	
	    var op1dep, op2dep;
	    var li = calc.listeProprietaire;
	    var natcalc = calc.nature();
	    if (natcalc === CCbGlob.natConstante) return new CConstante(li, 0);else if (natcalc === CCbGlob.natVariableFormelle) {
	      // Si l'indice de la variable formelle est le bon on renvoie 1 sinon 0
	      if (calc.indvar === indiceVar) return new CConstante(li, 1);else return new CConstante(li, 0);
	    } else if (natcalc === CCbGlob.natResultatValeur) return new CConstante(li, 0);else if (natcalc === CCbGlob.natAppelFonction) {
	      // Ici il y a un problème car l'appel de fonction peut être un appel
	      // à une suite récurrente. Cet appel est licite s'il ne fait pas appel
	      // à la variable formelle.
	      // Il faudra le vérifier avant d'autoriser le calcul d'une dérivée.
	      // Ici on suppose que c'est la cas
	      // Modifié version 4.6
	      //	CAppelFonction appfon = (CAppelFonction) calc;
	      // if (appfon.fonctionAssociee.getClass() === CSuiteRec.class) {
	      if (calc.fonctionAssociee.estDeNatureCalcul(NatCal.NSuiteRecurrenteReelle)) {
	        // L'appel de suite sans paramètre est considéré comme une constante
	        return new CConstante(li, 0);
	      } else // Cas d'une vraie fonction
	        {
	          var f = calc.fonctionAssociee;
	          // On regarde si l'appel de fonction est seulement de la forme
	          // f(paramètre)
	          if (calc.operande.nature() === CCbGlob.natVariableFormelle) {
	            var va = calc.operande;
	            if (va.indvar === indiceVar) return CalcR.creeDerivee(f.calcul, indiceVar);else {
	              var uder = CalcR.creeDerivee(calc.operande, indiceVar);
	              var uCopie = calc.operande.getCopie();
	              var fcalcder = CalcR.creeDerivee(f.calcul, indiceVar);
	              var appelfder = new CAppelFonctionInterne(fcalcder, uCopie);
	              return new COp(li, uder, appelfder, Ope.Mult);
	            }
	          } else {
	            // Dans ce cas il faut dériver comme une composée du type fou
	            uder = CalcR.creeDerivee(calc.operande, indiceVar);
	            uCopie = calc.operande.getCopie();
	            fcalcder = CalcR.creeDerivee(f.calcul, indiceVar);
	            appelfder = new CAppelFonctionInterne(fcalcder, uCopie);
	            return new COp(li, uder, appelfder, Ope.Mult);
	          }
	        }
	    } else if (natcalc === CCbGlob.natOperation) {
	      // var op = calc;
	      switch (calc.Ope) {
	        case Ope.Plus:
	          op1dep = calc.operande1.dependDeVariable(indiceVar);
	          op2dep = calc.operande2.dependDeVariable(indiceVar);
	          if (!op1dep) {
	            if (!op2dep) return new CConstante(li, 0);else return CalcR.creeDerivee(calc.operande2, indiceVar);
	          }
	          if (!op2dep) return CalcR.creeDerivee(calc.operande1, indiceVar);else return new COp(li, CalcR.creeDerivee(calc.operande1, indiceVar), CalcR.creeDerivee(calc.operande2, indiceVar), Ope.Plus);
	        case Ope.Moin:
	          op1dep = calc.operande1.dependDeVariable(indiceVar);
	          op2dep = calc.operande2.dependDeVariable(indiceVar);
	          if (!op1dep) {
	            if (!op2dep) return new CConstante(li, 0);else return new CMoinsUnaire(li, CalcR.creeDerivee(calc.operande2, indiceVar));
	          }
	          if (!op2dep) return CalcR.creeDerivee(calc.operande1, indiceVar);
	          return new COp(li, CalcR.creeDerivee(calc.operande1, indiceVar), CalcR.creeDerivee(calc.operande2, indiceVar), Ope.Moin);
	        case Ope.Mult:
	          {
	            // On regarde d'abord si les facteurs du produit dépendent de la
	            // variable
	            op1dep = calc.operande1.dependDeVariable(indiceVar);
	            op2dep = calc.operande2.dependDeVariable(indiceVar);
	            if (!op1dep) {
	              if (!op2dep) return new CConstante(li, 0);else return new COp(li, calc.operande1.getCopie(), CalcR.creeDerivee(calc.operande2, indiceVar), Ope.Mult);
	            }
	            if (!op2dep) return new COp(li, CalcR.creeDerivee(calc.operande1, indiceVar), calc.operande2.getCopie(), Ope.Mult);
	            // Formule u'v + uv'
	            else return new COp(li, new COp(li, CalcR.creeDerivee(calc.operande1, indiceVar), calc.operande2.getCopie(), Ope.Mult), new COp(li, CalcR.creeDerivee(calc.operande2, indiceVar), calc.operande1.getCopie(), Ope.Mult), Ope.Plus);
	          }
	        case Ope.Divi:
	          // Formule (u'v-uv')/v²
	          // On regarde d'abord si le dénominateur dépend de la variable
	          if (!calc.operande2.dependDeVariable(indiceVar)) return new COp(li, CalcR.creeDerivee(calc.operande1, indiceVar), calc.operande2.getCopie(), Ope.Divi);else return new COp(li, new COp(li, new COp(li, CalcR.creeDerivee(calc.operande1, indiceVar), calc.operande2.getCopie(), Ope.Mult), new COp(li, CalcR.creeDerivee(calc.operande2, indiceVar), calc.operande1.getCopie(), Ope.Mult), Ope.Moin), new CPuissance(li, calc.operande2.getCopie(), new CConstante(li, 2)), Ope.Divi);
	        case Ope.Inf:
	        case Ope.Sup:
	        case Ope.InfOuEgal:
	        case Ope.SupOuEgal:
	        case Ope.Egalite:
	        case Ope.Diff:
	        // Ajout version 4.9.5
	        case Ope.And:
	        case Ope.Or:
	          return new CConstante(li, 0);
	      }
	    } else if (natcalc === CCbGlob.natFonction) {
	      // var f = calc;
	      switch (calc.Opef) {
	        case Opef.Abso:
	          // La fonction valeur absolue n'étant pas dérivable en 0
	          // On va renvoyer comme formule
	          // 1/((operande>0)-(Operande<0))*(Operande)'
	          return new COp(li, new COp(li, new CConstante(li, 1), new COp(li, new COp(li, calc.operande.getCopie(), new CConstante(li, 0), Ope.Sup), new COp(li, calc.operande.getCopie(), new CConstante(li, 0), Ope.Inf), Ope.Moin), Ope.Divi), CalcR.creeDerivee(calc.operande, indiceVar), Ope.Mult);
	        case Opef.Enti:
	          // la dérivée existe et est nulle sauf en
	          // tout entier
	          // On renvoie donc comme formule 0/(operande<>int(operande))
	          return new COp(li, new CConstante(li, 0), new COp(li, calc.operande.getCopie(), new CFonction(li, Opef.Enti, calc.operande.getCopie()), Ope.Diff), Ope.Divi);
	        case Opef.Raci:
	        case Opef.Raci2:
	          // Formule u'/(2Racine(u))
	          return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new COp(li, new CConstante(li, 2), new CFonction(li, Opef.Raci, calc.operande.getCopie()), Ope.Mult), Ope.Divi);
	        case Opef.Sinu:
	          // La dérivée ne sera correcte que si on est
	          // en mode radian
	          // On applique la formule u'*cos(u)
	          if (li.uniteAngle === kernel.uniteAngle.radian) return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Cosi, calc.operande.getCopie()), Ope.Mult);else return new COp(li, new CConstante(li, kernel.ConvDegRad), new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Cosi, calc.operande.getCopie()), Ope.Mult), Ope.Mult);
	
	        case Opef.Cosi:
	          // On applique la formule -u'*sin(u)
	          if (li.uniteAngle === kernel.uniteAngle.radian) return new COp(li, new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Sinu, calc.operande.getCopie()), Ope.Mult), new CConstante(li, -1), Ope.Mult);else return new COp(li, new CConstante(li, kernel.ConvDegRad), new COp(li, new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Sinu, calc.operande.getCopie()), Ope.Mult), new CConstante(li, -1), Ope.Mult), Ope.Mult);
	
	        case Opef.Tang:
	          // On applique la formule u'/cos²(u)
	          if (li.uniteAngle === kernel.uniteAngle.radian) return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CPuissance(li, new CFonction(li, Opef.Cosi, calc.operande.getCopie()), new CConstante(li, 2)), Ope.Divi);else return new COp(li, new CConstante(li, kernel.ConvDegRad), new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CPuissance(li, new CFonction(li, Opef.Cosi, calc.operande.getCopie()), new CConstante(li, 2)), Ope.Divi), Ope.Mult);
	        case Opef.Logn:
	          // Formule u'/(u*(u>0))
	          return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new COp(li, calc.operande.getCopie(), new COp(li, calc.operande.getCopie(), new CConstante(li, 0), Ope.Sup), Ope.Mult), Ope.Divi);
	        case Opef.Expo:
	          // Formule u'*exp(u)
	          return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Expo, calc.operande.getCopie()), Ope.Mult);
	        case Opef.ATan:
	          // Formule u'/(1+u²)
	          if (li.uniteAngle === kernel.uniteAngle.radian) return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new COp(li, new CConstante(li, 1), new CPuissance(li, calc.operande.getCopie(), new CConstante(li, 2)), Ope.Plus), Ope.Divi);else return new COp(li, new CConstante(li, kernel.ConvRadDeg), new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new COp(li, new CConstante(li, 1), new CPuissance(li, calc.operande.getCopie(), new CConstante(li, 2)), Ope.Plus), Ope.Divi), Ope.Mult);
	        case Opef.ACos:
	          // Formule -u'/(rac(1-u²))
	          if (li.uniteAngle === kernel.uniteAngle.radian) return new COp(li, new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Raci, new COp(li, new CConstante(li, 1), new CPuissance(li, calc.operande.getCopie(), new CConstante(li, 2)), Ope.Moin)), Ope.Divi), new CConstante(li, -1), Ope.Mult);else return new COp(li, new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Raci, new COp(li, new CConstante(li, 1), new CPuissance(li, calc.operande.getCopie(), new CConstante(li, 2)), Ope.Moin)), Ope.Divi), new CConstante(li, -kernel.ConvRadDeg), Ope.Mult);
	        case Opef.ASin:
	          // Formule u'/(rac(1-u²))
	          if (li.uniteAngle === kernel.uniteAngle.radian) return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Raci, new COp(li, new CConstante(li, 1), new CPuissance(li, calc.operande.getCopie(), new CConstante(li, 2)), Ope.Moin)), Ope.Divi);else return new COp(li, new CConstante(li, kernel.ConvRadDeg), new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Raci, new COp(li, new CConstante(li, 1), new CPuissance(li, calc.operande.getCopie(), new CConstante(li, 2)), Ope.Moin)), Ope.Divi), Ope.Mult);
	        case Opef.Cosh:
	          // Formule u'*Sinh(u)
	          return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Sinh, calc.operande.getCopie()), Ope.Mult);
	        case Opef.Sinh:
	          // Formule u'*Cosh(u)
	          return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Cosh, calc.operande.getCopie()), Ope.Mult);
	        case Opef.Tanh:
	          // Formule u'/Cosh²(u)
	          return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CPuissance(li, new CFonction(li, Opef.Cosh, calc.operande.getCopie()), new CConstante(li, 2)), Ope.Divi);
	        case Opef.ArgCh:
	          // Formule u'/Rac(u²-1)
	          return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Raci, new COp(li, new CPuissance(li, calc.operande.getCopie(), new CConstante(li, 2)), new CConstante(li, 1), Ope.Moin)), Ope.Divi);
	        case Opef.ArgSh:
	          // Formule u'/(Rac(1+u²)
	          return new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new CFonction(li, Opef.Raci, new COp(li, new CPuissance(li, calc.operande.getCopie(), new CConstante(li, 2)), new CConstante(li, 1), Ope.Plus)), Ope.Divi);
	        case Opef.ArgTh:
	          // Formule (Abs(u)<1)*u'/(1-u²)
	          return new COp(li, new COp(li, new CFonction(li, Opef.Abso, calc.operande.getCopie()), new CConstante(li, 1), Ope.Inf), new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), new COp(li, new CConstante(li, 1), new CPuissance(li, calc.operande.getCopie(), new CConstante(li, 2)), Ope.Moin), Ope.Divi), Ope.Mult);
	        case Opef.Rand:
	          return new CConstante(li, 0);
	        // Rajouté version 4.7.2
	        case Opef.Left:
	          return CalcR.creeDerivee(calc.operande.membreGauche(), indiceVar);
	        case Opef.Right:
	          return CalcR.creeDerivee(calc.operande.membreDroit(), indiceVar);
	      }
	    } else if (natcalc === CCbGlob.natPuissance) {
	      // CPuissance pui = (CPuissance) calc;
	      // Si l'exposant ne dépend pas de la variable formelle on emploie la
	      // formule
	      // (u^n)' = nu'u^(n-1)
	      if (!calc.exposant.dependDeVariable(indiceVar)) {
	        if (!calc.operande.dependDeVariable(indiceVar)) return new CConstante(li, 0);else {
	          if (calc.exposant.nature() === CCbGlob.natConstante) {
	            var co = calc.exposant;
	            if (co.valeur === 0) return new new CConstante(li, 0)();else if (co.valeur === 1) return CalcR.creeDerivee(calc.operande, indiceVar);else return new COp(li, new COp(li, calc.exposant.getCopie(), CalcR.creeDerivee(calc.operande, indiceVar), Ope.Mult), new CPuissance(li, calc.operande.getCopie(), new CConstante(li, co.valeur - 1)), Ope.Mult);
	          } else return new COp(li, new COp(li, calc.exposant.getCopie(), CalcR.creeDerivee(calc.operande, indiceVar), Ope.Mult), new CPuissance(li, calc.operande.getCopie(), new COp(li, calc.exposant.getCopie(), new CConstante(li, 1), Ope.Moin)), Ope.Mult);
	        }
	      }
	      // Sinon on considère u^v comme exp(v*lnu) de dérivée
	      // (v'*lnu+v*u'/u)*u^v
	      else return new COp(li, new COp(li, new COp(li, CalcR.creeDerivee(calc.exposant, indiceVar), new CFonction(li, Opef.Logn, calc.operande.getCopie()), Ope.Mult), new COp(li, new COp(li, CalcR.creeDerivee(calc.operande, indiceVar), calc.operande.getCopie(), Ope.Divi), calc.exposant.getCopie(), Ope.Mult), Ope.Plus), new CPuissance(li, calc.operande.getCopie(), calc.exposant.getCopie()), Ope.Mult);
	    }
	    // Ajout version 4.6 : Nouvel opérateur moins unaire
	    else if (natcalc === CCbGlob.natMoinsUnaire) {
	        // CMoinsUnaire mun = (CMoinsUnaire) calc;
	        return new CMoinsUnaire(li, CalcR.creeDerivee(calc.operande, indiceVar));
	      }
	      // Ajout version 3.0 pour le cas d'un appel à une fonction utilisateur de
	      // plusieurs variables
	      // Pour une fonction du type f(t) = g[u(t),v(t)] on utilise la formule
	      // f'(t) = u'(t) g'u(u(t),v(t)) + v'(t) g'v(u(t),v(t))
	      else if (natcalc === CCbGlob.natAppelFonctionNVar) {
	          // Version 3.0 : seulement des fonctions jutilisateur de 2 ou 3 variables
	          // peuvent être créées.
	          // CAppelFonctionNVar appfon = (CAppelFonctionNVar) calc;
	          f = calc.fonctionAssociee;
	          var nvar = f.nbVar;
	          if (nvar === 2) {
	            uder = CalcR.creeDerivee(calc.operande[0], indiceVar); // Calcul
	            // de
	            // u'(t)
	            var vder = CalcR.creeDerivee(calc.operande[1], indiceVar); // Calcul
	            // de
	            // v'(t)
	            uCopie = calc.operande[0].getCopie();
	            var vCopie = calc.operande[1].getCopie();
	            var tabcal = new Array(2);
	            tabcal[0] = uCopie;
	            tabcal[1] = vCopie;
	            var fcalcderu = CalcR.creeDerivee(f.calcul, 0); // Dérivée partielle
	            // par rapport à la
	            // première variable u
	            var fcalcderv = CalcR.creeDerivee(f.calcul, 1); // Dérivée partielle
	            // par rapport à la
	            // deuxième variable v
	            var appelfderu = new CAppelFonctionInterneNVar(fcalcderu, tabcal);
	            var appelfderv = new CAppelFonctionInterneNVar(fcalcderv, tabcal);
	            /*
	            var prod1 = new COp(li, uder, appelfderu, Ope.Mult);
	            var prod2 = new COp(li, vder, appelfderv, Ope.Mult);
	            var sum1 = new COp(li, prod1, prod2, Ope.Plus);
	            */
	            var prod1, prod2;
	            if (uder.nature() === CCbGlob.natConstante) {
	              if (uder.valeur === 0) prod1 = new CConstante(li, 0);else prod1 = new COp(li, uder, appelfderu, Ope.Mult);
	            } else prod1 = new COp(li, uder, appelfderu, Ope.Mult);
	            if (vder.nature() === CCbGlob.natConstante) {
	              if (vder.valeur === 0) prod2 = new CConstante(li, 0);else prod2 = new COp(li, vder, appelfderv, Ope.Mult);
	            } else prod1 = new COp(li, uder, appelfderu, Ope.Mult);
	            return new COp(li, prod1, prod2, Ope.Plus);
	          } else {
	            uder = CalcR.creeDerivee(calc.operande[0], indiceVar); // Calcul de u'(t)'
	            vder = CalcR.creeDerivee(calc.operande[1], indiceVar); // Calcul de v'(t)'
	            var wder = CalcR.creeDerivee(calc.operande[2], indiceVar); // Calcul de w'(t)'
	            uCopie = calc.operande[0].getCopie();
	            vCopie = calc.operande[1].getCopie();
	            var wCopie = calc.operande[2].getCopie();
	            tabcal = new Array(3);
	            tabcal[0] = uCopie;
	            tabcal[1] = vCopie;
	            tabcal[2] = wCopie;
	            fcalcderu = CalcR.creeDerivee(f.calcul, 0); // Dérivée partielle
	            // par rapport à la
	            // première variable u
	            fcalcderv = CalcR.creeDerivee(f.calcul, 1); // Dérivée partielle
	            // par rapport à la
	            // deuxième variable v
	            var fcalcderw = CalcR.creeDerivee(f.calcul, 2); // Dérivée partielle
	            // par rapport à la
	            // troisième variable
	            // w
	            appelfderu = new CAppelFonctionInterneNVar(fcalcderu, tabcal);
	            appelfderv = new CAppelFonctionInterneNVar(fcalcderv, tabcal);
	            var appelfderw = new CAppelFonctionInterneNVar(fcalcderw, tabcal);
	            // prod1 = new COp(li, uder, appelfderu, Ope.Mult);
	            // prod2 = new COp(li, vder, appelfderv, Ope.Mult);
	            if (uder.nature() === CCbGlob.natConstante) {
	              if (uder.valeur === 0) prod1 = new CConstante(li, 0);else prod1 = new COp(li, uder, appelfderu, Ope.Mult);
	            } else prod1 = new COp(li, uder, appelfderu, Ope.Mult);
	            if (vder.nature() === CCbGlob.natConstante) {
	              if (vder.valeur === 0) prod2 = new CConstante(li, 0);else prod2 = new COp(li, vder, appelfderv, Ope.Mult);
	            } else prod2 = new COp(li, vder, appelfderv, Ope.Mult);
	            var sum1 = new COp(li, prod1, prod2, Ope.Plus);
	            // var prod3 = new COp(li, wder, appelfderw, Ope.Mult);
	            var prod3;
	            if (wder.nature() === CCbGlob.natConstante) {
	              if (wder.valeur === 0) prod3 = new CConstante(li, 0);else prod3 = new COp(li, wder, appelfderw, Ope.Mult);
	            } else prod3 = new COp(li, wder, appelfderw, Ope.Mult);
	            return new COp(li, sum1, prod3, Ope.Plus);
	          }
	        } else if (natcalc === CCbGlob.natAppelFonctionInterneNVar) {
	          // Version 3.0 : seulement des fonctions jutilisateur de 2 ou 3 variables
	          // peuvent être créées.
	          // var appfon = calc;
	          f = calc.fonctionInterne;
	          nvar = calc.operande.length;
	          if (nvar === 2) {
	            uder = CalcR.creeDerivee(calc.operande[0], indiceVar); // Calcul
	            // de
	            // u'(t)
	            vder = CalcR.creeDerivee(calc.operande[1], indiceVar); // Calcul
	            // de
	            // v'(t)
	            uCopie = calc.operande[0].getCopie();
	            vCopie = calc.operande[1].getCopie();
	            tabcal = new Array(2);
	            tabcal[0] = uCopie;
	            tabcal[1] = vCopie;
	            fcalcderu = CalcR.creeDerivee(f, 0); // Dérivée partielle par
	            // rapport à la première
	            // variable u
	            fcalcderv = CalcR.creeDerivee(f, 1); // Dérivée partielle par
	            // rapport à la deuxième
	            // variable v
	            appelfderu = new CAppelFonctionInterneNVar(fcalcderu, tabcal);
	            appelfderv = new CAppelFonctionInterneNVar(fcalcderv, tabcal);
	            prod1 = new COp(li, uder, appelfderu, Ope.Mult);
	            prod2 = new COp(li, vder, appelfderv, Ope.Mult);
	            sum1 = new COp(li, prod1, prod2, Ope.Plus);
	            return sum1;
	          } else {
	            uder = CalcR.creeDerivee(calc.operande[0], indiceVar); // Calcul
	            // de
	            // u'(t)
	            vder = CalcR.creeDerivee(calc.operande[1], indiceVar); // Calcul
	            // de
	            // v'(t)
	            wder = CalcR.creeDerivee(calc.operande[2], indiceVar); // Calcul
	            // de
	            // v'(t)
	            uCopie = calc.operande[0].getCopie();
	            vCopie = calc.operande[1].getCopie();
	            wCopie = calc.operande[2].getCopie();
	            tabcal = new Array(3);
	            tabcal[0] = uCopie;
	            tabcal[1] = vCopie;
	            tabcal[2] = wCopie;
	            fcalcderu = CalcR.creeDerivee(f, 0); // Dérivée partielle par rapport à la première variable u
	            fcalcderv = CalcR.creeDerivee(f, 1); // Dérivée partielle par rapport à la deuxième variable v
	            fcalcderw = CalcR.creeDerivee(f, 2); // Dérivée partielle par rapport à la troisième variable w
	            appelfderu = new CAppelFonctionInterneNVar(fcalcderu, tabcal);
	            appelfderv = new CAppelFonctionInterneNVar(fcalcderv, tabcal);
	            appelfderw = new CAppelFonctionInterneNVar(fcalcderw, tabcal);
	            prod1 = new COp(li, uder, appelfderu, Ope.Mult);
	            prod2 = new COp(li, vder, appelfderv, Ope.Mult);
	            sum1 = new COp(li, prod1, prod2, Ope.Plus);
	            prod3 = new COp(li, wder, appelfderw, Ope.Mult);
	            return new COp(li, sum1, prod3, Ope.Plus);
	          }
	        } else if (natcalc === CCbGlob.natFonction3Var) {
	          // CFonction3Var f = (CFonction3Var) calc;
	          switch (calc.Opef) {
	            // La fonction valeur absolue n'étant pas dérivable en 0
	            // On va renvoyer comme formule (operande1=1)*(Operande2)' +
	            // (operande1!==1)*(Operande3)'
	            case Opef3v.si:
	              return new COp(li, new COp(li, new COp(li, calc.operande1.getCopie(), new CConstante(li, 1), Ope.Egalite), CalcR.creeDerivee(calc.operande2, indiceVar), Ope.Mult), new COp(li, new COp(li, calc.operande1.getCopie(), new CConstante(li, 1), Ope.Diff), CalcR.creeDerivee(calc.operande3, indiceVar), Ope.Mult), Ope.Plus);
	            default:
	              return new CConstante(li, 0);
	          }
	        } else if (natcalc === CCbGlob.natSommeDansFormule) {
	          // CSommeDansFormule s = (CSommeDansFormule) calc;
	          return new CSommeDansFormule(li, CalcR.creeDerivee(calc.calculASommer, indiceVar), calc.indiceDebut.getCopie(), calc.indiceFin.getCopie(), calc.pas.getCopie(), calc.nomVariable);
	        } else
	          // Si on a autorisé un produit indicé c'est qu'il ne dépendait pas de la
	          // variable de dérivation
	          // donc la dérivée est null
	          if (natcalc === CCbGlob.natProduitDansFormule) return new CConstante(li, 0);
	    // Pour les autres types, on considère le calcul constant (fonction
	    // prédifinie de deux variables comme max() par exemple
	    return new CConstante(li, 0); // Pour satisfaire le compilateur
	  }
	
	};
	
	module.exports = CalcR;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var Ope = __webpack_require__(32);
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CIntegraleDansFormule;
	
	/**
	 * Classe représentant, dans un arbre binaire de calcul, le calcul approché
	 * d'une intégrale par la méthode de Simpson.
	 * C'est la seule fonction intégrée de MathGraph32 à 4 variables.
	 * La syntaxe est integrale(f,parametre,a,b)
	 * où f est la formule à intégrer (fonction de parametre),
	 * parametre est la variable d'intégration,
	 * a la borne inférieure d'intégration,
	 * b la borne supérieure d'intégration.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CCb} calculASommer : la formule de la fonction à intégrer.
	 * @param {CCb} bornea : La borne inférieure d'intégration.
	 * @param {CCb} borneb : La borne supérieure d'intégration.
	 * @param {String} nomVariable : Le nom de la variable d'intégration.
	 * @param {Boolean} dansFormuleComplexe : true si la calcul a lieu dans un calcul complexe, 0 sinon.
	 * @returns {CIntegraleDansFormule}
	 */
	function CIntegraleDansFormule(listeProprietaire, calculASommer, bornea, borneb, nomVariable, dansFormuleComplexe) {
	  CCb.call(this, listeProprietaire);
	  if (arguments.length !== 1) {
	    this.calculASommer = calculASommer;
	    this.bornea = bornea;
	    this.borneb = borneb;
	    this.nomVariable = nomVariable;
	    this.dansFormuleComplexe = dansFormuleComplexe;
	  }
	}
	
	CIntegraleDansFormule.prototype = new CCb();
	CIntegraleDansFormule.prototype.constructor = CIntegraleDansFormule;
	CIntegraleDansFormule.prototype.superClass = "CCb";
	CIntegraleDansFormule.prototype.className = "CIntegraleDansFormule";
	
	CIntegraleDansFormule.prototype.nature = function () {
	  return CCbGlob.natIntegraleDansFormule;
	};
	
	CIntegraleDansFormule.prototype.dependDeVariable = function (ind) {
	  return this.calculASommer.dependDeVariable(ind) || this.bornea.dependDeVariable(ind) || this.borneb.dependDeVariable(ind);
	};
	
	CIntegraleDansFormule.prototype.getClone = function (listeSource, listeCible) {
	  return new CIntegraleDansFormule(listeCible, this.calculASommer.getClone(listeSource, listeCible), this.bornea.getClone(listeSource, listeCible), this.borneb.getClone(listeSource, listeCible), this.nomVariable, this.dansFormuleComplexe);
	};
	
	CIntegraleDansFormule.prototype.getCopie = function () {
	  return new CIntegraleDansFormule(this.listeProprietaire, this.calculASommer.getCopie(), this.bornea.getCopie(), this.borneb.getCopie(), this.nomVariable, this.dansFormuleComplexe);
	};
	
	CIntegraleDansFormule.prototype.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  this.calculASommer.initialisePourDependance();
	  this.bornea.initialisePourDependance();
	  this.borneb.initialisePourDependance();
	};
	
	CIntegraleDansFormule.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCb.prototype.dependDe.call(this, p) || this.calculASommer.dependDe(p) || this.bornea.dependDe(p) || this.borneb.dependDe(p));
	};
	
	CIntegraleDansFormule.prototype.dependDePourBoucle = function (p) {
	  return this.calculASommer.dependDePourBoucle(p) || this.bornea.dependDePourBoucle(p) || this.borneb.dependDePourBoucle(p);
	};
	
	CIntegraleDansFormule.prototype.existe = function (infoRandom) {
	  return this.calculASommer.existe(infoRandom) && this.bornea.existe(infoRandom) && this.borneb.existe(infoRandom);
	};
	
	CIntegraleDansFormule.prototype.estConstant = function () {
	  return this.calculASommer.estConstant() && this.bornea.estConstant() && this.borneb.estConstant();
	};
	
	CIntegraleDansFormule.prototype.resultat = function (infoRandom) {
	  this.listeProprietaire.nombreIterations += CCbGlob.nombreSubdivisionsPourSimpson;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  // double[] val = new double[1];
	  var val = new Array(1);
	  var dbornea = this.bornea.resultat(infoRandom);
	  var dborneb = this.borneb.resultat(infoRandom);
	  return CCbGlob.integrale(this.calculASommer, val, dbornea, dborneb, infoRandom);
	};
	
	CIntegraleDansFormule.prototype.resultatComplexe = function (infoRandom, zRes) {
	  this.listeProprietaire.nombreIterations += CCbGlob.nombreSubdivisionsPourSimpson;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var val = new Zrray(1);
	  var cbornea = new Complexe();
	  this.bornea.resultatComplexe(infoRandom, cbornea);
	  if (cbornea.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dbornea = cbornea.x;
	  var cborneb = new Complexe();
	  this.borneb.resultatComplexe(infoRandom, cborneb);
	  if (cborneb.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dborneb = cborneb.x;
	  zRes.y = 0;
	  zRes.x = integrale(this.calculASommer, val, dbornea, dborneb, infoRandom);
	};
	
	CIntegraleDansFormule.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  var n, val, dbornea, dborneb;
	  this.listeProprietaire.nombreIterations += CCbGlob.nombreSubdivisionsPourSimpson;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  dbornea = this.bornea.resultatFonction(infoRandom, valeurParametre);
	  dborneb = this.borneb.resultatFonction(infoRandom, valeurParametre);
	  if (valeurParametre instanceof Array) {
	    n = valeurParametre.length;
	    val = new Array(n + 1);
	    for (var i = 0; i < n; i++) {
	      val[i] = valeurParametre[i];
	    }
	  } else {
	    val = new Array(2);
	    val[0] = valeurParametre;
	  }
	  return CCbGlob.integrale(this.calculASommer, val, dbornea, dborneb, infoRandom);
	};
	
	CIntegraleDansFormule.prototype.chaineCalcul = function (varFor) {
	  var varFor2;
	  if (this.dansFormuleComplexe) {
	    // Dans le cas d'un calcul d'intégrale dans un calcul complexe, les paramètres éventuels complexes
	    // n'ont pas pu être utilisés
	    varFor2 = new Array(1);
	    varFor2[0] = this.nomVariable;
	  } else {
	    var n = 0;
	    if (varFor === null) varFor2 = new Array(1);else {
	      n = varFor.length;
	      varFor2 = new Array(n + 1);
	    }
	    for (var i = 0; i < n; i++) {
	      varFor2[i] = varFor[i];
	    }varFor2[n] = this.nomVariable;
	  }
	  return kernel.getString("integrale") + "(" + this.calculASommer.chaineCalculSansPar(varFor2) + "," + this.nomVariable + "," + this.bornea.chaineCalculSansPar(varFor) + "," + this.borneb.chaineCalculSansPar(varFor) + ")";
	};
	
	CIntegraleDansFormule.prototype.chaineLatex = function (varFor) {
	  var varFor2, nat, ch;
	  if (this.dansFormuleComplexe) {
	    // Dans le cas d'un calcul d'intégrale dans un calcul complexe, les paramètres éventuels complexes
	    // n'ont pas pu êtree utilisés
	    varFor2 = new Array(1);
	    varFor2[0] = this.nomVariable;
	  } else {
	    var n = 0;
	    if (varFor === null) varFor2 = new Array(1);else {
	      n = varFor.length;
	      varFor2 = new Array(n + 1);
	    }
	    for (var i = 0; i < n; i++) {
	      varFor2[i] = varFor[i];
	    }varFor2[n] = this.nomVariable;
	  }
	  nat = this.calculASommer.nature();
	  if (nat === CCbGlob.natOperation) {
	    if (this.calculASommer.Ope === Ope.Plus || this.calculASommer.Ope === Ope.Moin) ch = this.calculASommer.chaineLatex(varFor2);else ch = this.calculASommer.chaineLatexSansPar(varFor2);
	  } else ch = this.calculASommer.chaineLatexSansPar(varFor2);
	  // String ch = calculASommer.chaineLatexSansPar(varFor2) + "d" + varFor2;
	  return "\\int_{" + this.bornea.chaineLatexSansPar(varFor) + "}" + "^{" + this.borneb.chaineLatexSansPar(varFor) + "}" + ch + "d" + varFor2[varFor2.length - 1];
	};
	
	CIntegraleDansFormule.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.nomVariable = inps.readUTF();
	  this.calculASommer = inps.readObject(list);
	  this.bornea = inps.readObject(list);
	  this.borneb = inps.readObject(list);
	};
	
	CIntegraleDansFormule.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.nomVariable);
	  oups.writeObject(this.calculASommer);
	  oups.writeObject(this.bornea);
	  oups.writeObject(this.borneb);
	};
	
	CIntegraleDansFormule.prototype.deriveePossible = function (indiceVariable) {
	  return !this.calculASommer.dependDeVariable(indiceVariable) && !this.bornea.dependDeVariable(indiceVariable) && !this.borneb.dependDeVariable(indiceVariable);
	};
	
	CIntegraleDansFormule.prototype.calculAvecValeursRemplacees = function () {
	  return new CIntegraleDansFormule(this.listeProprietaire, this.calculASommer.calculAvecValeursRemplacees(), this.bornea.calculAvecValeursRemplacees(), this.borneb.calculAvecValeursRemplacees(), this.nomVariable, this.dansFormuleComplexe);
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Fonte = __webpack_require__(18);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CVariableFormelle;
	
	/**
	 * Classe représentant une variable dormelle d'une fonction dans u arbre de calcul.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {type} indvar: L'indice de la variable (0 pour une fonction de une variable)
	 * @returns {CVariableBornee}
	 */
	function CVariableFormelle(listeProprietaire, indvar) {
	  CCb.call(this, listeProprietaire);
	  if (arguments.length !== 1) this.indvar = indvar;
	}
	CVariableFormelle.prototype = new CCb();
	CVariableFormelle.prototype.constructor = CVariableFormelle;
	CVariableFormelle.prototype.superClass = "CCb";
	CVariableFormelle.prototype.className = "CVariableFormelle";
	
	CVariableFormelle.prototype.nature = function () {
	  return CCbGlob.natVariableFormelle;
	};
	
	CVariableFormelle.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  if (valeurParametre instanceof Array) return valeurParametre[this.indvar];else return valeurParametre;
	};
	
	CVariableFormelle.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  if (valeurParametre instanceof Array) {
	    zRes.x = valeurParametre[this.indvar].x;
	    zRes.y = valeurParametre[this.indvar].y;
	  } else {
	    zRes.x = valeurParametre.x;
	    zRes.y = valeurParametre.y;
	  }
	};
	
	CVariableFormelle.prototype.getClone = function (listeSource, listeCible) {
	  return new CVariableFormelle(listeCible, this.indvar);
	};
	
	CVariableFormelle.prototype.dependDeVariable = function (ind) {
	  return this.indvar === ind;
	};
	
	CVariableFormelle.prototype.getCopie = function () {
	  return new CVariableFormelle(this.listeProprietaire, this.indvar);
	};
	
	CVariableFormelle.prototype.chaineCalcul = function (varFor) {
	  return varFor[this.indvar];
	};
	
	CVariableFormelle.prototype.chaineLatex = function (varFor) {
	  var ch = this.chaineCalcul(varFor);
	  if (Fonte.estNomGrec(ch)) return " \\" + ch + " ";else return ch;
	};
	
	CVariableFormelle.prototype.estConstant = function () {
	  return false;
	};
	
	CVariableFormelle.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CVariableFormelle.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  if (this.nVersion === 1) this.indvar = 0;else this.indvar = inps.readInt();
	};
	
	CVariableFormelle.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeInt(this.indvar);
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CSommeDansFormule;
	
	/**
	 * Classe représentant une somme indicée dans un arbre binaire de calcul.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CCb} calculASommer : Le calcul à sommer.
	 * @param {CCb} indiceDebut : L'indice de départ.
	 * @param {CCb} indiceFin : L'indice de fin.
	 * @param {indiceFin} pas :  Le pas à ajouter à l'indice pour chaque somme (1 la plupart du temps)
	 * @param {String} nomVariable : Le nom choisi pour la variable de sommation.
	 * @returns {CSommeDansFormule}
	 */
	function CSommeDansFormule(listeProprietaire, calculASommer, indiceDebut, indiceFin, pas, nomVariable) {
	  if (arguments.length === 1) CCb.call(this, listeProprietaire);else {
	    CCb.call(this, listeProprietaire);
	    this.calculASommer = calculASommer;
	    this.indiceDebut = indiceDebut;
	    this.indiceFin = indiceFin;
	    this.pas = pas;
	    this.nomVariable = nomVariable;
	  }
	}
	CSommeDansFormule.prototype = new CCb();
	CSommeDansFormule.prototype.constructor = CSommeDansFormule;
	CSommeDansFormule.prototype.superClass = "CCb";
	CSommeDansFormule.prototype.className = "CSommeDansFormule";
	
	CSommeDansFormule.prototype.nature = function () {
	  return CCbGlob.natSommeDansFormule;
	};
	
	CSommeDansFormule.prototype.dependDeVariable = function (ind) {
	  return this.calculASommer.dependDeVariable(ind) || this.indiceDebut.dependDeVariable(ind) || this.indiceFin.dependDeVariable(ind) || this.pas.dependDeVariable(ind);
	};
	
	CSommeDansFormule.prototype.getClone = function (listeSource, listeCible) {
	  return new CSommeDansFormule(listeCible, this.calculASommer.getClone(listeSource, listeCible), this.indiceDebut.getClone(listeSource, listeCible), this.indiceFin.getClone(listeSource, listeCible), this.pas.getClone(listeSource, listeCible), this.nomVariable);
	};
	
	CSommeDansFormule.prototype.getCopie = function () {
	  return new CSommeDansFormule(this.listeProprietaire, this.calculASommer.getCopie(), this.indiceDebut.getCopie(), this.indiceFin.getCopie(), this.pas.getCopie(), this.nomVariable);
	};
	
	CSommeDansFormule.initialisePourDependance = function () {
	  CCb.prototype.initialisePourDependance.call(this);
	  this.calculASommer.initialisePourDependance();
	  this.indiceDebut.initialisePourDependance();
	  this.indiceFin.initialisePourDependance();
	  this.pas.initialisePourDependance();
	};
	
	CSommeDansFormule.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCb.prototype.dependDe.call(this, p) || this.calculASommer.dependDe(p) || this.indiceDebut.dependDe(p) || this.indiceFin.dependDe(p) || this.pas.dependDe(p));
	};
	
	CSommeDansFormule.prototype.dependDePourBoucle = function (p) {
	  return this.calculASommer.dependDePourBoucle(p) || this.indiceDebut.dependDePourBoucle(p) || this.indiceFin.dependDePourBoucle(p) || this.pas.dependDePourBoucle(p);
	};
	
	CSommeDansFormule.prototype.existe = function (infoRandom) {
	  return this.calculASommer.existe(infoRandom) && this.indiceDebut.existe(infoRandom) && this.indiceFin.existe(infoRandom) && this.pas.existe(infoRandom);
	};
	
	CSommeDansFormule.prototype.estConstant = function () {
	  return this.calculASommer.estConstant() && this.indiceDebut.estConstant() && this.indiceFin.estConstant() && this.pas.estConstant();
	};
	/**
	 * Renvoie le résultat réel de la somme.
	 * @param {Boolean} infoRandom : true si les calculs aléatoires doivent être relancés
	 * @returns {Float}
	 */
	CSommeDansFormule.prototype.resultat = function (infoRandom) {
	  var val = new Array(1);
	  var MIN_VALUE = -2147483648;
	  var MAX_VALUE = 2147483647;
	  var dinddeb = this.indiceDebut.resultat(infoRandom);
	  if (dinddeb > MAX_VALUE || dinddeb < MIN_VALUE || dinddeb !== Math.floor(dinddeb)) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dindfin = this.indiceFin.resultat(infoRandom);
	  if (dindfin > MAX_VALUE || dindfin < MIN_VALUE || dindfin !== Math.floor(dindfin) || dindfin < dinddeb) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dpas = this.pas.resultat(infoRandom);
	  if (dpas > MAX_VALUE || dpas < MIN_VALUE || dpas !== Math.floor(dpas) || dpas <= 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  this.listeProprietaire.nombreIterations += (dindfin - dinddeb) / dpas;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var somme = 0;
	  for (var i = dinddeb; i <= dindfin; i += dpas) {
	    val[0] = i;
	    somme += this.calculASommer.resultatFonction(infoRandom, val);
	  }
	  return somme;
	};
	/**
	 * Renvoie le résultat complexe de la somme.
	 * @param {Boolean} infoRandom : true si les calculs aléatoires doivent être relancés
	 * @param {Complexe} zRes : Le complee contenant le résultatde la somme au retour.
	 * @returns {undefined}
	 */
	CSommeDansFormule.prototype.resultatComplexe = function (infoRandom, zRes) {
	  var MIN_VALUE = -2147483648;
	  var MAX_VALUE = 2147483647;
	  var val = new Array(1);
	  val[0] = new Complexe();
	  var inddeb = new Complexe();
	  this.indiceDebut.resultatComplexe(infoRandom, inddeb);
	  if (inddeb.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard());
	  var dinddeb = inddeb.x;
	  if (dinddeb > MAX_VALUE || dinddeb < MIN_VALUE || dinddeb !== Math.floor(dinddeb)) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var indfin = new Complexe();
	  this.indiceFin.resultatComplexe(infoRandom, indfin);
	  if (inddeb.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dindfin = indfin.x;
	  if (dindfin > MAX_VALUE || dindfin < MIN_VALUE || dindfin !== Math.floor(dindfin) || dindfin < dinddeb) throw Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var valpas = new Complexe();
	  this.pas.resultatComplexe(infoRandom, valpas);
	  if (valpas.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dvalpas = valpas.x;
	  if (dvalpas > MAX_VALUE || dvalpas < MIN_VALUE || dvalpas !== Math.floor(dvalpas) || dvalpas <= 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  this.listeProprietaire.nombreIterations += (dindfin - dinddeb) / dvalpas;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  zRes.x = 0;
	  zRes.y = 0;
	  var z = new Complexe(0, 0);
	  for (var i = inddeb.x; i <= indfin.x; i += valpas.x) {
	    val[0].x = i;
	    val[0].y = 0;
	    this.calculASommer.resultatFonctionComplexe(infoRandom, val, z);
	    zRes.x += z.x;
	    zRes.y += z.y;
	  }
	};
	
	CSommeDansFormule.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  var val, i, dpas, dinddeb, dindfin, somme;
	  var MIN_VALUE = -2147483648;
	  var MAX_VALUE = 2147483647;
	  if (valeurParametre instanceof Array) {
	    var n = valeurParametre.length;
	    val = new Array(n + 1);
	    for (i = 0; i < n; i++) {
	      val[i] = valeurParametre[i];
	    }
	  } else {
	    val = new Array(2);
	    val[0] = valeurParametre;
	  }
	  dinddeb = this.indiceDebut.resultatFonction(infoRandom, valeurParametre);
	  if (dinddeb > MAX_VALUE || dinddeb < MIN_VALUE || dinddeb !== Math.floor(dinddeb)) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  dindfin = this.indiceFin.resultatFonction(infoRandom, valeurParametre);
	  if (dindfin > MAX_VALUE || dindfin < MIN_VALUE || dindfin !== Math.floor(dindfin) || dindfin < dinddeb) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  dpas = this.pas.resultatFonction(infoRandom, valeurParametre);
	  if (dpas > MAX_VALUE || dpas < MIN_VALUE || dpas !== Math.floor(dpas) || dpas <= 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  this.listeProprietaire.nombreIterations += (dindfin - dinddeb) / dpas;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  // int inddeb = (int) dinddeb;
	  // int indfin = (int) dindfin;
	  // int valpas = (int) dpas;
	  somme = 0;
	  for (i = dinddeb; i <= dindfin; i += dpas) {
	    val[1] = i;
	    somme += this.calculASommer.resultatFonction(infoRandom, val);
	  }
	  return somme;
	};
	
	CSommeDansFormule.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  var i, val, dinddeb, dindfin, dvalpas, inddeb, indfin, z;
	  var MIN_VALUE = -2147483648;
	  var MAX_VALUE = 2147483647;
	  if (valeurParametre instanceof Array) {
	    var n = valeurParametre.length;
	    val = new Array(n + 1);
	    for (i = 0; i < n; i++) {
	      val[i] = new Complexe(valeurParametre[i]);
	    }val[n] = new Complexe();
	  } else {
	    val = new Array(2);
	    val[0] = valeurParametre;
	    val[1] = new Complexe();
	  }
	  inddeb = new Complexe();
	  this.indiceDebut.resultatFonctionComplexe(infoRandom, valeurParametre, inddeb);
	  if (inddeb.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  dinddeb = inddeb.x;
	  if (dinddeb > MAX_VALUE || dinddeb < MIN_VALUE || dinddeb !== Math.floor(dinddeb)) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  indfin = new Complexe();
	  this.indiceFin.resultatFonctionComplexe(infoRandom, valeurParametre, indfin);
	  if (indfin.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  dindfin = indfin.x;
	  if (dindfin > MAX_VALUE || dindfin < MIN_VALUE || dindfin !== Math.floor(dindfin) || dindfin < dinddeb) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var valpas = new Complexe();
	  this.pas.resultatFonctionComplexe(infoRandom, valeurParametre, valpas);
	  if (valpas.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  dvalpas = valpas.x;
	  if (dvalpas > MAX_VALUE || dvalpas < MIN_VALUE || dvalpas !== Math.floor(dvalpas) || dvalpas <= 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  this.listeProprietaire.nombreIterations += (dindfin - dinddeb) / dvalpas;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  zRes.x = 0;
	  zRes.y = 0;
	  z = new Complexe(0, 0);
	  for (i = inddeb.x; i <= indfin.y; i += valpas.x) {
	    val[n].x = i;
	    val[n].y = 0;
	    this.calculASommer.resultatFonctionComplexe(infoRandom, val, z);
	    zRes.x += z.x;
	    zRes.y += z.y;
	  }
	};
	
	CSommeDansFormule.prototype.chaineCalcul = function (varFor) {
	  var varFor2, i;
	  var n = 0;
	  if (varFor === null) varFor2 = new Array(1);else {
	    n = varFor.length;
	    varFor2 = new Array(n + 1);
	  }
	  for (i = 0; i < n; i++) {
	    varFor2[i] = varFor[i];
	  }varFor2[n] = this.nomVariable;
	  return kernel.getString("somme") + "(" + this.calculASommer.chaineCalculSansPar(varFor2) + "," + this.nomVariable + "," + this.indiceDebut.chaineCalculSansPar(varFor) + "," + this.indiceFin.chaineCalculSansPar(varFor) + "," + this.pas.chaineCalculSansPar(varFor) + ")";
	};
	
	CSommeDansFormule.prototype.chaineLatex = function (varFor) {
	  var varFor2, i, up;
	  var n = 0;
	  if (varFor === null) varFor2 = new Array(1);else {
	    n = varFor.length;
	    varFor2 = new Array(n + 1);
	  }
	  for (i = 0; i < n; i++) {
	    varFor2[i] = varFor[i];
	  }varFor2[n] = this.nomVariable;
	  up = "";
	  if (this.pas.nature() === CCbGlob.natConstante) {
	    if (this.pas.valeur === 1) up = this.indiceFin.chaineLatex(varFor);
	  }
	  if (up.length === 0) up = this.indiceFin.chaineLatex(varFor) + "\\text{ " + kernel.getString("step") + " }" + this.pas.chaineLatex(varFor);
	  return "\\sum\\limits_{" + this.nomVariable + "=" + this.indiceDebut.chaineLatexSansPar(varFor) + "}" + "^{" + up + "}" + "{" + this.calculASommer.chaineLatex(varFor2) + "}";
	};
	CSommeDansFormule.prototype.calculAvecValeursRemplacees = function () {
	  return new CSommeDansFormule(this.listeProprietaire, this.calculASommer.calculAvecValeursRemplacees(), this.indiceDebut.calculAvecValeursRemplacees(), this.indiceFin.calculAvecValeursRemplacees(), this.pas.calculAvecValeursRemplacees(), this.nomVariable);
	};
	CSommeDansFormule.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  this.nomVariable = inps.readUTF();
	  this.calculASommer = inps.readObject(list);
	  this.indiceDebut = inps.readObject(list);
	  this.indiceFin = inps.readObject(list);
	  this.pas = inps.readObject(list);
	};
	
	CSommeDansFormule.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.nomVariable);
	  oups.writeObject(this.calculASommer);
	  oups.writeObject(this.indiceDebut);
	  oups.writeObject(this.indiceFin);
	  oups.writeObject(this.pas);
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	var CConstante = __webpack_require__(45);
	var CMoinsUnaire = __webpack_require__(50);
	module.exports = CResultatValeur;
	
	/**
	 * Classe repésentant dans un arbre binaire le résultat d'un calcul ou d'une mesure réelle existant.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CValDyn} valeurAssociee : La valeur dont c'est le résultat.
	 * @returns {CResultatValeur}
	 */
	function CResultatValeur(listeProprietaire, valeurAssociee) {
	  if (arguments.length === 0) return; // Ajout version WebPack
	  CCb.call(this, listeProprietaire);
	  if (arguments.length !== 1) this.valeurAssociee = valeurAssociee;
	}
	CResultatValeur.prototype = new CCb();
	CResultatValeur.prototype.constructor = CResultatValeur;
	CResultatValeur.prototype.superClass = "CCb";
	CResultatValeur.prototype.className = "CResultatValeur";
	
	CResultatValeur.prototype.nature = function () {
	  return CCbGlob.natResultatValeur;
	};
	CResultatValeur.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.valeurAssociee);
	  return new CResultatValeur(listeCible, listeCible.get(ind1, "CValDyn"));
	};
	CResultatValeur.prototype.existe = function (infoRandom) {
	  return this.valeurAssociee.existe;
	};
	CResultatValeur.prototype.resultat = function (infoRandom) {
	  return this.valeurAssociee.rendValeur(infoRandom);
	};
	CResultatValeur.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCb.prototype.dependDe.call(this, p) || this.valeurAssociee.dependDe(p));
	};
	CResultatValeur.prototype.dependDePourBoucle = function (p) {
	  return this.valeurAssociee.dependDePourBoucle(p);
	};
	CResultatValeur.prototype.dependDeVariable = function (ind) {
	  return false;
	};
	CResultatValeur.prototype.getCopie = function () {
	  return new CResultatValeur(this.listeProprietaire, this.valeurAssociee);
	};
	CResultatValeur.prototype.chaineCalcul = function () {
	  return this.valeurAssociee.getNom();
	};
	CResultatValeur.prototype.chaineLatex = function () {
	  if (this.valeurAssociee.getNom() === "pi") return "\\pi "; // Espace à la fin nécesssaire
	  else return this.valeurAssociee.getNom();
	};
	CResultatValeur.prototype.read = function (inps, list) {
	  CCb.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.valeurAssociee = list.get(ind1, "CValDyn");
	};
	CResultatValeur.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.valeurAssociee);
	  oups.writeInt(ind1);
	};
	CResultatValeur.prototype.estConstant = function () {
	  return this.valeurAssociee.className === "CCalcConst";
	};
	CResultatValeur.prototype.calculAvecValeursRemplacees = function () {
	  var d = this.valeurAssociee.rendValeur(false);
	  if (d < 0) return new CMoinsUnaire(this.listeProprietaire, new CConstante(this.listeProprietaire, -d));else return new CConstante(this.listeProprietaire, d);
	};
	CResultatValeur.membreGauche = function () {
	  return this.valeurAssociee.membreGauche();
	};
	CResultatValeur.membreDroit = function () {
	  return this.valeurAssociee.membreDroit();
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var kernel = __webpack_require__(8);
	var CCbGlob = __webpack_require__(31);
	var CSommeDansFormule = __webpack_require__(58);
	module.exports = CProduitDansFormule;
	
	/**
	 * Classe représentant un produit indicé dans un arbre binaire de calcul.
	 * @constructor
	 * @extends CCb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CCb} calculASommer : Le calcul à multiplier
	 * @param {CCb} bornea : L'indice de départ.
	 * @param {CCb} borneb : L'indice de fin.
	 * @param {indiceFin} pas :  Le pas à ajouter à l'indice pour chaque somme (1 la plupart du temps)
	 * @param {String} nomVariable : Le nom choisi pour la variable de sommation.
	 * @returns {CProduitDansFormule}
	 */
	function CProduitDansFormule(listeProprietaire, calculASommer, bornea, borneb, pas, nomVariable) {
	  if (arguments.length === 1) CSommeDansFormule.call(this, listeProprietaire);else CSommeDansFormule.call(this, listeProprietaire, calculASommer, bornea, borneb, pas, nomVariable);
	}
	CProduitDansFormule.prototype = new CSommeDansFormule();
	CProduitDansFormule.prototype.constructor = CProduitDansFormule;
	CProduitDansFormule.prototype.superClass = "CSommeDansFormule";
	CProduitDansFormule.prototype.className = "CProduitDansFormule";
	
	CProduitDansFormule.prototype.nature = function () {
	  return CCbGlob.natProduitDansFormule;
	};
	
	CProduitDansFormule.prototype.getClone = function (listeSource, listeCible) {
	  return new CProduitDansFormule(listeCible, this.calculASommer.getClone(listeSource, listeCible), this.indiceDebut.getClone(listeSource, listeCible), this.indiceFin.getClone(listeSource, listeCible), this.pas.getClone(listeSource, listeCible), this.nomVariable);
	};
	
	CProduitDansFormule.prototype.getCopie = function () {
	  return new CProduitDansFormule(this.listeProprietaire, this.calculASommer.getCopie(), this.indiceDebut.getCopie(), this.indiceFin.getCopie(), this.pas.getCopie(), this.nomVariable);
	};
	/**
	 * Renvoie le résultat réel du produit.
	 * @param {Boolean} infoRandom : true si les calculs aléatoires doivent être relancés
	 * @returns {Float}
	 */
	CProduitDansFormule.prototype.resultat = function (infoRandom) {
	  var val = new Array(1);
	  var MIN_VALUE = kernel.MIN_VALUE;
	  var MAX_VALUE = kernel.Max_VALUE;
	  var dinddeb = this.indiceDebut.resultat(infoRandom);
	  if (dinddeb > MAX_VALUE || dinddeb < MIN_VALUE || dinddeb !== Math.floor(dinddeb)) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dindfin = this.indiceFin.resultat(infoRandom);
	  if (dindfin > MAX_VALUE || dindfin < MIN_VALUE || dindfin !== Math.floor(dindfin) || dindfin < dinddeb) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dpas = this.pas.resultat(infoRandom);
	  if (dpas > MAX_VALUE || dpas < MIN_VALUE || dpas !== Math.floor(dpas) || dpas <= 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  this.listeProprietaire.nombreIterations += (dindfin - dinddeb) / dpas;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculException);
	  var somme = 1;
	  for (var i = dinddeb; i <= dindfin; i += dpas) {
	    val[0] = i;
	    somme *= this.calculASommer.resultatFonction(infoRandom, val);
	  }
	  return somme;
	};
	/**
	 * Renvoie le résultat complexe du produit dans le complee zres.
	 * @param {Boolean} infoRandom : true si les calculs aléatoires doivent être relancés
	 * @param {Complexe} zRes
	 * @returns {undefined}
	 */
	CProduitDansFormule.prototype.resultatComplexe = function (infoRandom, zRes) {
	  var MIN_VALUE = kernel.MIN_VALUE;
	  var MAX_VALUE = kernel.Max_VALUE;
	  var val = new Array(1);
	  val[0] = new Complexe();
	  var inddeb = new Complexe();
	  this.indiceDebut.resultatComplexe(infoRandom, inddeb);
	  if (inddeb.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dinddeb = inddeb.x;
	  if (dinddeb > MAX_VALUE || dinddeb < MIN_VALUE || dinddeb !== Math.floor(dinddeb)) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var indfin = new Complexe();
	  this.indiceFin.resultatComplexe(infoRandom, indfin);
	  if (inddeb.y !== 0) throw new ErreurCalculException();
	  var dindfin = indfin.x;
	  if (dindfin > MAX_VALUE || dindfin < MIN_VALUE || dindfin !== Math.floor(dindfin) || dindfin < dinddeb) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var valpas = new Complexe();
	  this.pas.resultatComplexe(infoRandom, valpas);
	  if (valpas.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var dvalpas = valpas.x;
	  if (dvalpas > MAX_VALUE || dvalpas < MIN_VALUE || dvalpas !== Math.floor(dvalpas) || dvalpas <= 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  this.listeProprietaire.nombreIterations += (dindfin - dinddeb) / dvalpas;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  zRes.x = 1;
	  zRes.y = 0;
	  var z = new Complexe();
	  for (var i = inddeb.x; i <= indfin.x; i += valpas.x) {
	    val[0].x = i;
	    val[0].y = 0;
	    this.calculASommer.resultatFonctionComplexe(infoRandom, val, z);
	    zRes.produitComp(z, zRes);
	  }
	};
	
	CProduitDansFormule.prototype.resultatFonctionComplexe = function (infoRandom, valeurParametre, zRes) {
	  var i, val, dinddeb, dindfin, dvalpas, inddeb, indfin, z;
	  var MIN_VALUE = kernel.MIN_VALUE;
	  var MAX_VALUE = kernel.Max_VALUE;
	  if (valeurParametre instanceof Array) {
	    var n = valeurParametre.length;
	    val = new Array(n + 1);
	    for (i = 0; i < n; i++) {
	      val[i] = new Complexe(valeurParametre[i]);
	    }val[n] = new Complexe();
	  } else {
	    val = new Array(2);
	    val[0] = valeurParametre;
	    val[1] = new Complexe();
	  }
	  inddeb = new Complexe();
	  this.indiceDebut.resultatFonctionComplexe(infoRandom, valeurParametre, inddeb);
	  if (inddeb.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  dinddeb = inddeb.x;
	  if (dinddeb > MAX_VALUE || dinddeb < MIN_VALUE || dinddeb !== Math.floor(dinddeb)) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  indfin = new Complexe();
	  this.indiceFin.resultatFonctionComplexe(infoRandom, valeurParametre, indfin);
	  if (indfin.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  dindfin = indfin.x;
	  if (dindfin > MAX_VALUE || dindfin < MIN_VALUE || dindfin !== Math.floor(dindfin) || dindfin < dinddeb) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  var valpas = new Complexe();
	  this.pas.resultatFonctionComplexe(infoRandom, valeurParametre, valpas);
	  if (valpas.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  dvalpas = valpas.x;
	  if (dvalpas > MAX_VALUE || dvalpas < MIN_VALUE || dvalpas !== Math.floor(dvalpas) || dvalpas <= 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  this.listeProprietaire.nombreIterations += (dindfin - dinddeb) / dvalpas;
	  if (this.listeProprietaire.nombreIterations > CCbGlob.nombreMaxiIterations) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  zRes.x = 1;
	  zRes.y = 0;
	  z = new Complexe();
	  for (i = inddeb.x; i <= indfin.y; i += valpas.x) {
	    val[n].x = i;
	    val[n].y = 0;
	    this.calculASommer.resultatFonctionComplexe(infoRandom, val, z);
	    zRes.produitComp(z, zRes);
	  }
	};
	
	CProduitDansFormule.prototype.chaineCalcul = function (varFor) {
	  var varFor2, i;
	  var n = 0;
	  if (varFor === null) varFor2 = new Array(1);else {
	    n = varFor.length;
	    varFor2 = new Array(n + 1);
	  }
	  for (i = 0; i < n; i++) {
	    varFor2[i] = varFor[i];
	  }varFor2[n] = this.nomVariable;
	  return kernel.getString("produit") + "(" + this.calculASommer.chaineCalculSansPar(varFor2) + "," + this.nomVariable + "," + this.indiceDebut.chaineCalculSansPar(varFor) + "," + this.indiceFin.chaineCalculSansPar(varFor) + "," + this.pas.chaineCalculSansPar(varFor) + ")";
	};
	
	CProduitDansFormule.prototype.chaineLatex = function (varFor) {
	  var varFor2, i, up;
	  var n = 0;
	  if (varFor === null) varFor2 = new Array(1);else {
	    n = varFor.length;
	    varFor2 = new Array(n + 1);
	  }
	  for (i = 0; i < n; i++) {
	    varFor2[i] = varFor[i];
	  }varFor2[n] = this.nomVariable;
	  up = "";
	  if (this.pas.nature() === CCbGlob.natConstante) {
	    if (this.pas.valeur === 1) up = this.indiceFin.chaineLatex(varFor);
	  }
	  if (up.length === 0) up = this.indiceFin.chaineLatex(varFor) + "\\text{ " + kernel.getString("step") + " }" + this.pas.chaineLatex(varFor);
	  return "\\prod\\limits_{" + this.nomVariable + "=" + this.indiceDebut.chaineLatexSansPar(varFor) + "}" + "^{" + up + "}" + "{" + this.calculASommer.chaineLatex(varFor2) + "}";
	};
	
	CProduitDansFormule.prototype.deriveePossible = function (indiceVariable) {
	  return !this.calculASommer.dependDeVariable(indiceVariable) && !this.indiceDebut.dependDeVariable(indiceVariable) && !this.indiceFin.dependDeVariable(indiceVariable) && !this.pas.dependDeVariable(indiceVariable);
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * @constructor
	 * @extends CCb
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CCb = __webpack_require__(43);
	
	module.exports = CCbNull;
	
	/**
	 * @constructor
	 * @extends CCb
	 * Objet servant dans les éditeurs de formules en ligne.
	 * Lorsqu'une erreur de syntaxe est trouvée, on utilise cet objet pour compléter
	 * quand même l'arbre binaire de calcul.
	 * @param {String} chaine : La chaîne rprésentant le calcul.
	 * @returns {CCbNull}
	 */
	function CCbNull(chaine) {
	  CCb.call(this);
	  this.chaine = chaine;
	}
	CCbNull.prototype = new CCb();
	CCbNull.prototype.constructor = CCbNull;
	CCbNull.prototype.superClass = "CCb";
	CCbNull.prototype.className = "CCbNull";
	
	CCbNull.prototype.nature = function () {
	  return 0;
	};
	
	CCbNull.prototype.getClone = function () {
	  return null;
	};
	
	CCbNull.prototype.dependDeVariable = function () {
	  return false;
	};
	
	CCbNull.prototype.chaineCalcul = function () {
	  return this.chaine;
	};
	
	CCbNull.prototype.chaineLatex = function () {
	  return this.chaine;
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(31);
	module.exports = CAppelFonctionInterne;
	/**
	 * @constructor
	 * @extends CCb
	 * Objet d'un arbre binaire de calcul représentant un appel de fonction interne.
	 * Utilisé dans les calculs de dérivées et dérivées partielles.
	 * @param {CCb} fonctionInterne : Pointe sur la fonction à appliquer.
	 * @param {CCb} operande : Pointe sur l'opérande.
	 * @returns {CAppelFonctionInterne}
	 */
	function CAppelFonctionInterne(fonctionInterne, operande) {
	  CCb.call(this, fonctionInterne.listeProprietaire);
	  this.fonctionInterne = fonctionInterne;
	  this.operande = operande;
	}
	CAppelFonctionInterne.prototype = new CCb();
	CAppelFonctionInterne.prototype.constructor = CAppelFonctionInterne;
	CAppelFonctionInterne.prototype.superClass = "CCb";
	CAppelFonctionInterne.prototype.className = "CAppelFonctionInterne";
	
	CAppelFonctionInterne.prototype.nature = function () {
	  return CCbGlob.natAppelFonctionInterne;
	};
	
	CAppelFonctionInterne.prototype.resultat = function (infoRandom) {
	  return this.fonctionInterne.resultatFonction(infoRandom, this.operande.resultat(infoRandom));
	};
	
	CAppelFonctionInterne.prototype.resultatFonction = function (infoRandom, valeurparametre) {
	  return this.fonctionInterne.resultatFonction(infoRandom, this.operande.resultatFonction(infoRandom, valeurparametre));
	};
	
	CAppelFonctionInterne.prototype.getCopie = function () {
	  return new CAppelFonctionInterne(this.fonctionInterne.getCopie(), this.operande.getCopie());
	};
	
	CAppelFonctionInterne.prototype.dependDeVariable = function (ind) {
	  return this.operande.dependDeVariable(ind);
	};
	
	CAppelFonctionInterne.prototype.estConstant = function () {
	  return this.fonctionInterne.estConstant() && this.operande.estConstant();
	};
	CAppelFonctionInterne.prototype.deriveePossible = function (indiceVariable) {
	  return this.fonctionInterne.deriveePossible(indiceVariable) && this.operande.deriveePossible(indiceVariable);
	};
	
	CAppelFonctionInterne.prototype.calculAvecValeursRemplacees = function () {
	  return new CAppelFonctionInterne(this.fonctionInterne, this.operande.calculAvecValeursRemplacees());
	};
	
	CAppelFonctionInterne.prototype.membreGauche = function () {
	  return this.fonctionInterne.membreGauche();
	};
	
	CAppelFonctionInterne.prototype.membreDroit = function () {
	  return this.fonctionInterne.membreDroit();
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CCb = __webpack_require__(43);
	var CCbGlob = __webpack_require__(6);
	module.exports = CAppelFonctionInterneNVar;
	/**
	 * @constructor
	 * @extends CCb
	 * Objet d'un arbre binaire de calcul représentant un appel de fonction interne
	 * à n variables.
	 * Utilisé dans les calculs de dérivées et dérivées partielles.
	 * @param {CCb} fonctionInterne : Pointe sur la fonction à appliquer.
	 * @param {CCb} operande : Pointe sur l'opérande
	 * @returns {CAppelFonctionInterneNVar}
	 */
	function CAppelFonctionInterneNVar(fonctionInterne, operande) {
	  CCb.call(this, fonctionInterne.listeProprietaire);
	  this.fonctionInterne = fonctionInterne;
	  this.operande = operande;
	}
	CAppelFonctionInterneNVar.prototype = new CCb();
	CAppelFonctionInterneNVar.prototype.constructor = CAppelFonctionInterneNVar;
	CAppelFonctionInterneNVar.prototype.superClass = "CCb";
	CAppelFonctionInterneNVar.prototype.className = "CAppelFonctionInterneNVar";
	
	CAppelFonctionInterneNVar.prototype.nature = function () {
	  return CCbGlob.natAppelFonctionInterneNVar;
	};
	
	CAppelFonctionInterneNVar.prototype.resultat = function (infoRandom) {
	  var nvar = this.operande.length;
	  var d = new Array(nvar);
	  for (var i = 0; i < nvar; i++) {
	    d[i] = this.operande[i].resultat(infoRandom);
	  }return this.fonctionInterne.resultatFonction(infoRandom, d);
	};
	
	CAppelFonctionInterneNVar.prototype.resultatFonction = function (infoRandom, valeurParametre) {
	  var nvar = this.operande.length;
	  var d = new Array(nvar);
	  for (var i = 0; i < nvar; i++) {
	    d[i] = this.operande[i].resultatFonction(infoRandom, valeurParametre);
	  }return this.fonctionInterne.resultatFonction(infoRandom, d);
	};
	
	CAppelFonctionInterneNVar.prototype.getCopie = function () {
	  var nvar = this.operande.length;
	  var tab = new Array(nvar);
	  for (var i = 0; i < nvar; i++) {
	    tab[i] = this.operande[i].getCopie();
	  }return new CAppelFonctionInterneNVar(this.fonctionInterne.getCopie(), this.operande);
	};
	
	CAppelFonctionInterneNVar.prototype.dependDeVariable = function (ind) {
	  var res = false;
	  var nvar = this.operande.length;
	  for (var i = 0; i < nvar; i++) {
	    res = res || this.fonctionInterne.dependDeVariable(i) && this.operande[i].dependDeVariable(ind);
	  }
	  return res;
	};
	
	CAppelFonctionInterneNVar.prototype.estConstant = function () {
	  var res = false;
	  var nvar = this.operande.length;
	  for (var i = 0; i < nvar; i++) {
	    res = res || this.operande[i].estConstant();
	  }
	  return res;
	};
	
	CAppelFonctionInterneNVar.prototype.deriveePossible = function (indiceVariable) {
	  var b = true;
	  for (var i = 0; i < this.operande.length && b; i++) {
	    if (this.operande[i].dependDeVariable(indiceVariable)) b = this.fonctionInterne.deriveePossible(i) && this.operande[i].deriveePossible(indiceVariable);
	  }return b;
	};
	
	CAppelFonctionInterneNVar.prototype.calculAvecValeursRemplacees = function () {
	  var nbvar = this.fonctionInterne.nombreVariables();
	  var tabcal = new Array(this.fonctionInterne.nombreVariables());
	  for (var i = 0; i < nbvar; i++) {
	    tabcal[i] = this.operande[i].calculAvecValeursRemplacees();
	  }
	  return new CAppelFonctionInterneNVar(this.fonctionInterne, tabcal);
	};
	
	CAppelFonctionInterneNVar.prototype.membreGauche = function () {
	  return this.fonctionInterne.membreGauche();
	};
	
	CAppelFonctionInterneNVar.prototype.membreDroit = function () {
	  return this.fonctionInterne.membreDroit();
	};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var Fonte = __webpack_require__(18);
	var CElementBase = __webpack_require__(33);
	var CListeObjets = __webpack_require__(17);
	var CNoeudPointeurSurPoint = __webpack_require__(65);
	var CSousListeObjets = __webpack_require__(66);
	var Nat = __webpack_require__(4);
	module.exports = CImplementationProto;
	
	/**
	 * Classe reprétentant une implémentation de construction.
	 * this.listeSources contient des pointeurs sur les objets surces utilisés.
	 * @constructor
	 * @extends CElementBase
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {String} nomProto : Le nom de la construction.
	 * @param {Integer} nbIntermediaires : Le nombre d'objets intermédiares servant à construire
	 * les objets finaux.
	 * @param {Integer} nbFinaux : Le nombre d'objets finaux de la construction.
	 * @param {type} listeSourcesInit : Litse contenant des pointeurs sur tous les objets sources.
	 * @returns {CImplementationProto}
	 */
	function CImplementationProto(listeProprietaire, nomProto, nbIntermediaires, nbFinaux, listeSourcesInit) {
	  if (arguments.length === 1) CElementBase.call(this, listeProprietaire);else {
	    if (arguments.length === 2) {
	      // Constructeur utilisé lors de l'implémentation
	      CElementBase.call(this, listeProprietaire, null, false);
	      this.listeSources = new CSousListeObjets();
	      var proto = arguments[1]; // Le prototype associé
	      var nbSources = proto.nbObjSources;
	      for (var i = 0; i < nbSources; i++) {
	        this.listeSources.add(proto.get(i).elementAssocie);
	      }this.nomProto = proto.nom;
	      this.nbFinaux = proto.nbObjFinaux;
	      this.nbIntermediaires = proto.longueur() - nbSources - this.nbFinaux;
	    } else {
	      CElementBase.call(this, listeProprietaire, null, false);
	      this.nomProto = nomProto;
	      this.nbIntermediaires = nbIntermediaires;
	      this.nbFinaux = nbFinaux;
	      this.listeSources = listeSourcesInit;
	    }
	  }
	}
	CImplementationProto.prototype = new CElementBase();
	CImplementationProto.prototype.constructor = CImplementationProto;
	CImplementationProto.prototype.superClass = "CElementBase";
	CImplementationProto.prototype.className = "CImplementationProto";
	
	CImplementationProto.prototype.getClone = function (listeSource, listeCible) {
	  var listeSourcesClone = new CSousListeObjets();
	  listeSourcesClone.setImage(this.listeSources, listeSource, listeCible);
	  return new CImplementationProto(listeCible, this.nomProto, this.nbIntermediaires, this.nbFinaux, listeSourcesClone);
	};
	CImplementationProto.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CElementBase.prototype.dependDe.call(this, p) || this.listeSources.dependDe(p));
	};
	CImplementationProto.prototype.getNature = function () {
	  return NatObj.NImplementationProto;
	};
	CImplementationProto.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  this.listeSources.remplacePoint(ancienPoint, nouveauPoint);
	};
	CImplementationProto.prototype.determineNombreObjetsIntermediaires = function () {
	  var indimp = this.listeProprietaire.indexOf(this);
	  var nb = 0;
	  for (var i = indimp + 1; i < this.listeProprietaire.longueur(); i++) {
	    var elb = this.listeProprietaire.get(i);
	    if (elb.impProto === this && !elb.estElementFinal) nb++;else break;
	  }
	  this.nbIntermediaires = nb;
	};
	CImplementationProto.prototype.read = function (inps, list) {
	  CElementBase.prototype.read.call(this, inps, list);
	  this.nomProto = inps.readUTF();
	  this.nbIntermediaires = inps.readInt();
	  this.nbFinaux = inps.readInt();
	  this.listeSources = new CSousListeObjets();
	  this.listeSources.read(inps, list);
	};
	CImplementationProto.prototype.write = function (oups, list) {
	  CElementBase.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.nomProto);
	  oups.writeInt(this.nbIntermediaires);
	  oups.writeInt(this.nbFinaux);
	  this.listeSources.write(oups, this.listeProprietaire);
	};
	/**
	 * Fonction implémentant le prototype proto dans la la liste propriétaire de this
	 * @param dimf : mtg32.Dimf : Continet les dimensions de la figure
	 * @param listePourImp
	 * @param proto : CPrototype
	 * @param ideb :  Integer : le premier indice qu'on rajoute aux noms de calculs ou de points pour générer
	 * un nouveau nom
	 */
	CImplementationProto.prototype.implemente = function (dimf, proto, ideb) {
	  var i, ptgen, elb, ptp, val, gen, ancienNom, nouveauNom, clone;
	  var listeProprietaire = this.listeProprietaire;
	  var app = listeProprietaire.documentProprietaire.mtgApp;
	  var listeEltsAjoutes = new CListeObjets();
	  var listePointsOuDroitesARenommer = new CListeObjets();
	  var listeCalculsARenommer = new CListeObjets();
	  proto.setListePourImplementation(listeProprietaire);
	  listeProprietaire.add(this);
	  proto.indicePremierObjetPourImplementation = listeProprietaire.longueur();
	  // en recherchant dans la liste des éléments sources les points et droites qui ont un nom
	  // dans le prototype et on leur génère un nom pour que les éventuelles mesures
	  // et calculs l'utilisant aient leur formules réactualisées
	  for (i = 0; i < proto.nbObjSources; i++) {
	    ptgen = proto.get(i); // Renvoie un CElementGenerique
	    elb = ptgen.elementAssocie;
	    if (elb.estDeNature(Nat.or(NatObj.NTtPoint, NatObj.NDroite))) {
	      // CElementGraphique ptp = (CElementGraphique) elb;
	      var nomGen = ptgen.nom;
	      // On regarde si l'élément correspondant était nommé.
	      // Si oui on rajouté cet élément à la liste des points devant être
	      // nommés
	      if (nomGen.length !== 0 && elb.rendNom().length === 0) {
	        elb.donneNom(nomGen);
	        listePointsOuDroitesARenommer.add(elb);
	      }
	    }
	  }
	  // On implémente la liste d'objets sources gérée par l'implémentation de
	  // prototype
	  // Puis on ajoute des clones des objets intermédiaires et finaux du
	  // prototype
	  for (i = proto.nbObjSources; i < proto.longueur(); i++) {
	    elb = proto.get(i);
	    clone = elb.getClone(proto, this.listeProprietaire);
	    clone.estElementFinal = elb.estElementFinal;
	    clone.impProto = this; // Important
	    listeProprietaire.add(clone);
	    listeEltsAjoutes.add(clone);
	    if (clone.estDeNature(NatObj.NTtPoint)) {
	      // CPointAncetre ptp = (CPointAncetre) clone;
	      if (clone.rendNom().length !== 0) {
	        if (listeProprietaire.existeMemeNomNonIntermediaire(clone, clone.rendNom())) listePointsOuDroitesARenommer.add(clone);
	      }
	      // On donne la taille de nom par défaut aux points finaux
	      if (clone.estElementFinal) clone.tailleNom = app.getTaillePoliceNom();
	    } else {
	      if (clone.getNature() === NatObj.NDroite) {
	        // CDroite ptd = (CDroite) clone;
	        if (clone.rendNom().length !== 0) {
	          // Ajout version 4.8
	          if (listeProprietaire.existeMemeNomNonIntermediaire(clone, clone.rendNom())) listePointsOuDroitesARenommer.add(clone); // Ajout version 4.8
	        }
	      } else {
	        if (clone.estDeNatureCalcul(NatCal.NTtCalcNomme)) {
	          // CValeurDynamique vald = (CValeurDynamique) clone;
	          if (listeProprietaire.existeCalculOuVariableOuFonctionOuParametreMemeNom(null, clone.getNom(), false)) listeCalculsARenommer.add(clone);
	        }
	      }
	    }
	  }
	  listeEltsAjoutes.positionne(true, dimf);
	
	  // On renomme maintenant les points ou droites qui ont besoin d'être renommés
	  for (i = 0; i < listePointsOuDroitesARenommer.longueur(); i++) {
	    ptp = listePointsOuDroitesARenommer.get(i);
	    ancienNom = ptp.rendNom();
	    nouveauNom = listeProprietaire.genereNomPourPointOuDroite(ancienNom.charAt(0), ptp, ideb);
	    ptp.donneNom(nouveauNom);
	  }
	  // On renomme les calculs intermédiaires qui ont besoin d'être renommés
	  // en mettant à jour les affichages de commentaires dynamiques qui en
	  // dépendent
	  for (i = 0; i < listeCalculsARenommer.longueur(); i++) {
	    val = listeCalculsARenommer.get(i);
	    ancienNom = val.getNom();
	    // On génére un nouveau nom avec
	    // seulement les premiers caractères qui ne sont pas des chiffres
	    nouveauNom = listeProprietaire.genereNomPourCalcul(Fonte.premiersCaracteresNonChiffres(ancienNom), val, ideb);
	    listeEltsAjoutes.remplaceNomValeurDynamiqueDansCommentairesOuLatex(ancienNom, nouveauNom);
	    val.donneNom(nouveauNom);
	  }
	  // On reconstitue les formules des calculs ou fonctions intermédiaires et
	  // finaux dépendant des objets sources
	  for (i = 0; i < listeEltsAjoutes.longueur(); i++) {
	    elb = listeEltsAjoutes.get(i);
	    if (elb.estDeNatureCalcul(NatCal.NCalcOuFoncNonConstante)) {
	      // CCalcul calc = (CCalcul) elb;
	      elb.reconstruitChaineCalcul();
	    }
	  }
	  for (i = 0; i < proto.nbObjSources; i++) {
	    elb = proto.get(i).elementAssocie;
	    if (elb.estDeNatureCalcul(NatCal.NTteValPourComDyn)) {
	      gen = proto.get(i);
	      // CValeurDynamique val = (CValeurDynamique) elb;
	      listeEltsAjoutes.remplaceNomValeurDynamiqueDansCommentairesOuLatex(gen.nom, elb.getNom());
	    }
	  }
	  // On met à jour les commentaires des éléments rajoutés au cas où ils
	  // contiendraient
	  // des affichages de valeurs dynamiques
	  listeEltsAjoutes.determineDependancesCommentaires();
	  listeEltsAjoutes.metAJourEtPositionne(true, dimf); // Modifié version 4.8. True car on permet les calculs aléatoires dans les objets
	};
	/**
	 * Fonction implémentant la construction dans listePourImp pour une implémentation
	 * itérative. Appelé depuis CMacroConstructionIterative.
	 * @param {mtg32.Dimf} dimf : Dimensions du svg contenant la figure.
	 * @param {CListeObjets} listePourImp : La liste dans laquelle se fait l'implémentation.
	 * @param {CPrototype} proto : La construction à implémenter.
	 * @returns {undefined}
	 */
	CImplementationProto.prototype.implementePourIter = function (dimf, listePourImp, proto) {
	  var i, elb, clone;
	  var listeEltsAjoutes = new CListeObjets();
	  // nomProto = proto.nom; Supprimé version 4.8. Inutile
	  proto.setListePourImplementation(this.listeProprietaire);
	  // On ajoute l'objet implementationPrototype à la liste
	  this.listeProprietaire.add(this);
	  // Important que que les indices soient corrects
	  proto.indicePremierObjetPourImplementation = this.listeProprietaire.longueur();
	  // On implémente la liste d'objets sources gérée par l'implémentation de
	  // prototype
	  // Puis on ajoute des clones des objets intermédiaires et finaux du
	  // prototype
	  for (i = proto.nbObjSources; i < proto.longueur(); i++) {
	    elb = proto.get(i);
	    clone = elb.getClone(proto, this.listeProprietaire);
	    clone.estElementFinal = elb.estElementFinal;
	    clone.impProto = this; // Important
	    listePourImp.add(clone);
	    listeEltsAjoutes.add(clone);
	  }
	  listeEltsAjoutes.positionne(true, dimf);
	};
	/**
	 * Implémente la construction proto de façon récursive dans listePourImp.
	 * Utilisé pour les implémentations récursives
	 * @param {mtg32.CDimensionFenetre} dimf : Les dimensiosn du svg contenant la figure.
	 * @param {mtg32.CisteObjets} listePourImp : La lsite dans laquelle se fait l'implémentation.
	 * @param {CPrototype} proto : La construction à implémenter.
	 * @param {type} nbFinaux : Le nombre d'objets finaux de la construction.
	 * @returns {undefined}
	 */
	CImplementationProto.prototype.implementePourRecur = function (dimf, listePourImp, proto, nbFinaux) {
	  var i, elb, ptgen, nomGen, clone;
	  var listeEltsAjoutes = new CListeObjets();
	  // nomProto = proto.nom; Supprimé version 4.8. Inutile
	  proto.setListePourImplementation(this.listeProprietaire);
	  // On ajoute l'objet implementationPrototype à la liste
	  var imp = this.getClone(this.listeProprietaire, this.listeProprietaire);
	  imp.nomProto = proto.nom;
	  this.listeProprietaire.add(imp); // A revoir version logiciel : utiliser un clone
	  // Important que que les indices soient corrects
	  proto.indicePremierObjetPourImplementation = this.listeProprietaire.longueur();
	  // On implémente la liste d'objets sources gérée par l'implémentation de
	  // prototype
	  // en recherchant dans la liste des éléments sources les points et droites qui ont un nom
	  // dans le prototype et on leur génère un nom pour que les éventuelles mesures
	  // et calculs l'utilisant aient leur formules réactualisées
	  for (i = 0; i < proto.nbObjSources; i++) {
	    elb = proto.get(i).elementAssocie;
	    // listeSources.add(elb);
	    if (elb.estDeNature(Nat.or(NatObj.NTtPoint, NatObj.NDroite))) {
	      ptgen = proto.get(i);
	      nomGen = ptgen.nom;
	      // On regarde si l'élément correspondant était nommé.
	      if (nomGen.length !== 0 && elb.rendNom().length === 0) {
	        elb.donneNom(nomGen);
	      }
	    }
	  }
	  // Puis on ajoute des clones des objets intermédiaires et finaux du
	  // prototype à concurrence de nbFinaux
	  var nbFinauxTotal = 1;
	  for (i = proto.nbObjSources; i < proto.longueur() && nbFinauxTotal <= nbFinaux; i++) {
	    elb = proto.get(i);
	    clone = elb.getClone(proto, this.listeProprietaire);
	    var b = elb.estElementFinal;
	    clone.estElementFinal = b;
	    if (b) nbFinauxTotal++;
	    clone.impProto = imp; // Important
	    listePourImp.add(clone);
	    listeEltsAjoutes.add(clone);
	  }
	  listeEltsAjoutes.determineDependancesCommentaires(); // Spécial version mtgApp
	  listeEltsAjoutes.positionne(true, dimf);
	};
	
	/**
	 * Fonction impémentant la construction de façon récursive dans listePourImp
	 * @param {mtg32.Dimf} dimf
	 * @param {CListeObjets} listePourImp : La liste dans laquelle se fait limplémentation.
	 * @param {Array} tableProto : Un tableau contenant la construction à utiliser suivant
	 * la profondeur de récursion.
	 * @param {mtg2.CListeObjets} listeSourcesConst : La liste des objets sources communs à toutes
	 * les implémentations.
	 * @param {type} listeSourcesVar ; L liste de sobjets sources qui seront reconstruits à chaque
	 * implémentation.
	 * @param {Integer} pasRec : le pas de récursion qui est le nombre d'objets à sauter
	 * avant de réimplémenter la construction.
	 * @param {Integer} nbImp : Le nombre de fois que la construction doit être itérée pour un même niveau.
	 * @param {Boolean} creationNiveauMax : Si true suels les objets finaux de dernière génération sont créés en dehors
	 * de ceux servant pour la genération suivante.
	 * @param {type} profond : Le niveau de récursion (1 pour le niveau initial)
	 * @param {type} profondMax : Le niveau maximum de récursion autorisé
	 * @param {CListeObjets} listePoints : Lz liste des poiints finaux créés (our qu'on puisse si demandé les joindre)<.
	 * @returns {undefined}
	 */
	CImplementationProto.prototype.implementeRecursif = function (dimf, listePourImp, tableProto, listeSourcesConst, listeSourcesVar, pasRec, nbImp, creationNiveauMax, profond, profondMax, listePoints) {
	  var i, j, k, elb, listef, newlisteSourcesVar;
	  // On commence par implémenter une première fois la construction
	  var proto = tableProto[profond];
	  var ls = listeSourcesConst.longueur();
	  var sizeInit = listePourImp.longueur();
	  for (i = 0; i < ls; i++) {
	    proto.get(i).elementAssocie = listeSourcesConst.get(i);
	  }j = 0;
	  for (i = ls; i < proto.nbObjSources; i++) {
	    proto.get(i).elementAssocie = listeSourcesVar.get(j);
	    j++;
	  }
	  var nbObjFinaux = creationNiveauMax ? profond === profondMax ? proto.nbObjFinaux : listeSourcesVar.longueur() + pasRec * (nbImp - 1) : proto.nbObjFinaux;
	  this.implementePourRecur(dimf, listePourImp, proto, nbObjFinaux);
	  if (profond === profondMax) {
	    if (listePoints !== null) {
	      // On rajoute à listePoints les points de génération ultime
	      for (i = sizeInit; i < listePourImp.longueur(); i++) {
	        elb = listePourImp.get(i);
	        if (elb.estElementFinal && elb.estDeNature(NatObj.NTtPoint)) listePoints.push(new CNoeudPointeurSurPoint(listePourImp, elb));
	      }
	    }
	    return;
	  }
	  // On crée une liste formée de tous les éléments finaux créés par la première implémentation
	  listef = new CListeObjets();
	  for (i = sizeInit; i < listePourImp.longueur(); i++) {
	    elb = listePourImp.get(i);
	    if (elb.estElementFinal && (elb.estDeNature(NatObj.NTtObj) || !elb.estDeNatureCalcul(NatCal.NAucunCalcul))) listef.add(elb);
	  }
	  // On applique la récursion
	  for (k = 0; k < nbImp; k++) {
	    j = 0;
	    newlisteSourcesVar = new CListeObjets();
	    for (i = ls; i < proto.nbObjSources; i++) {
	      newlisteSourcesVar.add(listef.get(j + pasRec * k));
	      j++;
	    }
	    this.implementeRecursif(dimf, listePourImp, tableProto, listeSourcesConst, newlisteSourcesVar, pasRec, nbImp, creationNiveauMax, profond + 1, profondMax, listePoints);
	  }
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var COb = __webpack_require__(34);
	module.exports = CNoeudPointeurSurPoint;
	
	/**
	 * Classe servant à contenir un pointeur sur un point.
	 * Lorsqu'un tel objet est enregistré dans un flux binaire, c'est l'idice du point
	 * dans la liste qui est enregistré.
	 * @constructor
	 * @extends COb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet donc du point.
	 * @param {CPt} pointeurSurPoint : Le point.
	 * @returns {CNoeudPointeurSurPoint}
	 */
	function CNoeudPointeurSurPoint(listeProprietaire, pointeurSurPoint) {
	  COb.call(this, listeProprietaire);
	  this.pointeurSurPoint = pointeurSurPoint;
	}
	
	CNoeudPointeurSurPoint.prototype = new COb();
	CNoeudPointeurSurPoint.prototype.constructor = CNoeudPointeurSurPoint;
	CNoeudPointeurSurPoint.prototype.superClass = "COb";
	CNoeudPointeurSurPoint.prototype.className = "CNoeudPointeurSurPoint";
	
	CNoeudPointeurSurPoint.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointeurSurPoint);
	  return new CNoeudPointeurSurPoint(listeCible, listeCible.get(ind1, "CPt"));
	};
	CNoeudPointeurSurPoint.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointeurSurPoint === ancienPoint) this.pointeurSurPoint = nouveauPoint;
	};
	CNoeudPointeurSurPoint.prototype.read = function (inps, list) {
	  COb.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.pointeurSurPoint = list.get(ind1, "CPt");
	};
	CNoeudPointeurSurPoint.prototype.write = function (oups, list) {
	  var ind1 = list.indexOf(this.pointeurSurPoint);
	  oups.writeInt(ind1);
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CListeObjets = __webpack_require__(17);
	module.exports = CSousListeObjets;
	
	/**
	 * Classe utilisée pour gérer des listes d'objets internes à la liste ricipale de la figure.
	 * Cet objet difère de CListeObjets dans le fait qu'il n'enregistre pas des objets dans le flux
	 * mais seulement les indices des objets de la liste.
	 * @param {type} uniteAngle
	 * @param {type} id
	 * @returns {CSousListeObjets}
	 */
	function CSousListeObjets(uniteAngle, id) {
	  CListeObjets.call(this, uniteAngle, id);
	}
	// CListeObjets.prototype = Object.create(Array.prototype);
	CSousListeObjets.prototype = new CListeObjets();
	CSousListeObjets.prototype.constructor = CSousListeObjets;
	CSousListeObjets.prototype.className = "CSousListeObjets";
	
	CSousListeObjets.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  for (var i = 0; i < this.longueur; i++) {
	    var elb = this.get(i);
	    if (elb === ancienPoint) this.set(this.indexOf(ancienPoint), nouveauPoint);
	  }
	};
	CSousListeObjets.prototype.read = function (inps, listeProprietaire) {
	  var nombreObjets = inps.readInt();
	  for (var i = 0; i < nombreObjets; i++) {
	    var ind = inps.readInt();
	    var elb = listeProprietaire.get(ind);
	    this.add(elb);
	  }
	};
	CSousListeObjets.prototype.write = function (oups, listeProprietaire) {
	  var lon = this.longueur();
	  oups.writeInt(lon);
	  for (var i = 0; i < lon; i++) {
	    oups.writeInt(listeProprietaire.indexOf(this.get(i)));
	  }
	};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CFoncComplexe = __webpack_require__(68);
	var CAppelFonction = __webpack_require__(42);
	module.exports = CAppelFonctionComplexe;
	
	/**
	 * Objet d'un arbre binaire de calcul représentant un appel de fonction complexe utilisateur.
	 * @constructor
	 * @extends CAppelFonction
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {type} fonctionAssociee : Peut pointer sur une fonction ou une suite.
	 * @param {type} operande : L'opérande dont on cherche l'image.
	 * @returns {CAppelFonctionComplexe}
	 */
	function CAppelFonctionComplexe(listeProprietaire, fonctionAssociee, operande) {
	  CAppelFonction.call(this, listeProprietaire, fonctionAssociee, operande);
	  // this.z1loc = new mtg32.Complexe(); Version 4.9.7
	}
	CAppelFonctionComplexe.prototype = new CAppelFonction();
	CAppelFonctionComplexe.prototype.constructor = CAppelFonctionComplexe;
	CAppelFonctionComplexe.prototype.superClass = "CAppelFonction";
	CAppelFonctionComplexe.prototype.className = "CAppelFonctionComplexe";
	
	CAppelFonctionComplexe.prototype.getClone = function (listeSource, listeCible) {
	  var cloneOperande = this.operande.getClone(listeSource, listeCible);
	  // à revoir car la fonction a déjà été créée
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  return new CAppelFonctionComplexe(listeCible, listeCible.get(ind1, "CCalculAncetre"), cloneOperande);
	};
	
	CAppelFonctionComplexe.prototype.getCopie = function () {
	  return new CAppelFonctionComplexe(this.listeProprietaire, this.fonctionAssociee, this.operande.getCopie());
	};
	
	CAppelFonctionComplexe.prototype.calculAvecValeursRemplacees = function () {
	  var fon = this.fonctionAssociee.className === "CFonc" ? new CFoncComplexe(this.listeProprietaire, null, false, "", "", this.fonctionAssociee.chaineVariable, this.fonctionAssociee.calcul.calculAvecValeursRemplacees()) : this.fonctionAssociee;
	  return new CAppelFonction(this.listeProprietaire, fon, this.operande.calculAvecValeursRemplacees());
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CFonc = __webpack_require__(53);
	var CalcC = __webpack_require__(69);
	var CCalcul = __webpack_require__(54);
	module.exports = CFoncComplexe;
	
	/**
	 * Classe représentant une fonction complexe utilisateur à une variable.
	 * @constructor
	 * @extends CFonc
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet;
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet;
	 * @param {Boolean} estElementFinal : true si l'objet est un objet inal de construction;
	 * @param {String} nomCalcul : Le nom de la fonction.
	 * @param {String} chaineCalcul : La formule définissnt la focntion;
	 * @param {String} chaineVariable : La varaible formelle utilisée pour la formule.
	 * @param {CCb} calcul : Arbre binaire repsentant le calcul.
	 * @returns {CFoncComplexe}
	 */
	function CFoncComplexe(listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, chaineVariable, calcul) {
	  if (arguments.length === 1) CFonc.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalcul.call(this, listeProprietaire, impProto, estElementFinal);else {
	      this.chaineVariable = chaineVariable;
	      if (arguments.length <= 6) calcul = null;
	      if (calcul === null) CFonc.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, chaineVariable, CalcC.ccbComp(chaineCalcul, listeProprietaire, 0, chaineCalcul.length - 1, [chaineVariable]));else CCalcul.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, calcul);
	    }
	  }
	}
	CFoncComplexe.prototype = new CFonc();
	CFoncComplexe.prototype.constructor = CFoncComplexe;
	CFoncComplexe.prototype.superClass = "CFonc";
	CFoncComplexe.prototype.className = "CFoncComplexe";
	
	CFoncComplexe.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var calculClone = this.calcul.getClone(listeSource, listeCible);
	  return new CFoncComplexe(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, this.chaineCalcul, this.chaineVariable, calculClone);
	};
	CFoncComplexe.prototype.getNatureCalcul = function () {
	  return NatCal.NFonctionComplexe;
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by yvesb on 12/12/2016.
	 */
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @version 5.1.2
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	var CCbGlob = __webpack_require__(31);
	var Pointeur = __webpack_require__(16);
	var Ope = __webpack_require__(32);
	var Opef4v = __webpack_require__(22);
	var Opef5v = __webpack_require__(23);
	var Fonte = __webpack_require__(18);
	var CalcR = __webpack_require__(55);
	
	var CalcC = {
	  /**
	   * Fonction statique récursive créant un arbre binaire de calcul à partir de la chaîne
	   * de caractères ch représentant le calcul, la chaîne étant interprétée de pdebut à pfin.
	   * nomVariableFormelle est un array dont les éléments représentent les noms éventuels des variables
	   * formelles quand le calcul évalué représente une fonction.
	   * Le calcul renvoie un résultat complexe.
	   * @param {String} ch : La chaîne décrivant le  calcul.
	   * @param {CListeObjets} ptListe : La liste propriétaire du calcul à créer
	   * @param {Integer} pdebut : L'indice du début de l'interprétationde la chaîne
	   * @param {Integer} pfin : : L'indice de la fin de l'interprétationde la chaîne
	   * @param {Array} nomVariableFormelle : Un tableau donnant les noms des variables
	   * formelles dans le cas où le calcul est utilisé à l'intérieur d'une focntion de
	   * une ou plusieurs variables.
	   * @returns {CCalculBase}
	   */
	  ccbComp: function ccbComp(ch, ptListe, pdebut, pfin, nomVariableFormelle) {
	    var CAppelFonctionComplexe = __webpack_require__(67);
	    var CAppelFonctionComplexeNVar = __webpack_require__(70);
	    var CConstante = __webpack_require__(45);
	    var CConstantei = __webpack_require__(46);
	    var CFonction = __webpack_require__(47);
	    var CFonction2Var = __webpack_require__(48);
	    var CFonction3Var = __webpack_require__(49);
	    var CIntegraleDansFormule = __webpack_require__(56);
	    var CMoinsUnaire = __webpack_require__(50);
	    var CVariableFormelle = __webpack_require__(57);
	    var CSommeDansFormule = __webpack_require__(58);
	    var COp = __webpack_require__(51);
	    var CProduitDansFormule = __webpack_require__(60);
	    var CPuissance = __webpack_require__(52);
	    var CResultatValeurComplexe = __webpack_require__(71);
	    var CCbNull = __webpack_require__(61);
	
	    try {
	      // Spécial JavaScript car pas d'erreur levée par charAt si pdebut > pFin
	      if (pdebut > pfin) throw new Error();
	      var ptr;
	      var info = { x: 0, y: 0 }; // Contiendra dans x l'indice du caractère
	      // précédent
	      // et dans y l'opérateur trouvé (correspond au ptPrecedent et
	      // operateurInegalite
	      // de la version C++
	      // int ptPrecedent;
	      // int operateurInegalite;
	      var car;
	      var op;
	      var nomF = new Pointeur(null);
	      var longNom;
	      var ptVa = new Pointeur(null);
	      var parametreTrouve = new Pointeur(0);
	      var nombreVar = new Pointeur(0);
	      var complexeiTrouve = new Pointeur(false);
	
	      // On élimine les blancs de début
	      car = ch.charAt(pdebut);
	      while (car === ' ' && pdebut < pfin) {
	        pdebut++;
	        car = ch.charAt(pdebut);
	      }
	      // On recherche d'abord les opérateurs d'inégalités
	      ptr = CCbGlob.premierOperateurLogique(ch, pdebut, pfin, info);
	      if (ptr !== -1) {
	        return new COp(ptListe, CalcR.ccb(ch, ptListe, pdebut, info.x, nomVariableFormelle), CalcR.ccb(ch, ptListe, ptr + 1, pfin, nomVariableFormelle), info.y);
	      }
	      ptr = CCbGlob.premiereInegalite(ch, pdebut, pfin, info);
	      if (ptr !== -1) {
	        return new COp(ptListe, CalcC.ccbComp(ch, ptListe, pdebut, info.x, nomVariableFormelle), CalcC.ccbComp(ch, ptListe, ptr + 1, pfin, nomVariableFormelle), info.y);
	      } else {
	        // On recherche ensuite les operateurs d'addition ou soustraction
	        ptr = CCbGlob.premiereSomme(ch, pdebut, pfin);
	        if (ptr !== -1) {
	          // On regarde d'abord si la chaine commence par un signe - ou
	          // un signe +
	          car = ch.charAt(ptr);
	          if (car === '+') op = Ope.Plus;else op = Ope.Moin;
	          if (ptr === pdebut) {
	            car = ch.charAt(ptr);
	            if (car === '+') {
	              return CalcC.ccbComp(ch, ptListe, pdebut + 1, pfin, nomVariableFormelle);
	            } else {
	              return new CMoinsUnaire(ptListe, CalcC.ccbComp(ch, ptListe, pdebut + 1, pfin, nomVariableFormelle));
	            }
	          } else {
	            return new COp(ptListe, CalcC.ccbComp(ch, ptListe, pdebut, ptr - 1, nomVariableFormelle), CalcC.ccbComp(ch, ptListe, ptr + 1, pfin, nomVariableFormelle), op);
	          }
	        } // if (ptr !== NULL)
	        else {
	            ptr = CCbGlob.premierProduit(ch, pdebut, pfin);
	            if (ptr !== -1) {
	              car = ch.charAt(ptr);
	              if (car === '*') op = Ope.Mult;else op = Ope.Divi;
	              return new COp(ptListe, CalcC.ccbComp(ch, ptListe, pdebut, ptr - 1, nomVariableFormelle), CalcC.ccbComp(ch, ptListe, ptr + 1, pfin, nomVariableFormelle), op);
	            } else
	              // Le calcul ne contient ni addition, ni différence, ni produit
	              // ni quotient}
	              // Attention : par rapport à la version C++ 1.8, autorisation
	              // du symbole ² d'élévation au carré.
	              {
	                ptr = CCbGlob.premierePuissance(ch, pdebut, pfin);
	                if (ptr !== -1) {
	                  if (ch.charAt(ptr) === '²') {
	                    return new CPuissance(ptListe, CalcC.ccbComp(ch, ptListe, pdebut, ptr - 1, nomVariableFormelle), new CConstante(ptListe, 2));
	                  } else return new CPuissance(ptListe, CalcC.ccbComp(ch, ptListe, pdebut, ptr - 1, nomVariableFormelle), CalcC.ccbComp(ch, ptListe, ptr + 1, pfin, nomVariableFormelle));
	                } else {
	                  // On regarde si la chaine commence par le nom d'une fonction
	                  // ou d'une valeur déjà définie
	                  longNom = ptListe.commenceParNomFonctionOuValeurOuParametreComplexe(ch.substring(pdebut), nomVariableFormelle, ptVa, nomF, parametreTrouve, complexeiTrouve, nombreVar);
	                  if (longNom > 0) {
	                    if (complexeiTrouve.getValue()) {
	                      return new CConstantei(ptListe);
	                    } else {
	                      if (parametreTrouve.getValue() !== -1) {
	                        return new CVariableFormelle(ptListe, parametreTrouve.getValue());
	                      } else {
	                        if (ptVa.getValue() === null) {
	                          // Modification version 3.0. Il faut regarder si la fonction
	                          // est une fonction de plusieurs paramètres ou non
	                          // Ajouté version 4.7.4.1
	                          if (CCbGlob.parentheseFermante(ch, pdebut + longNom) === -1) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	                          if (nombreVar.getValue() === 1) return new CFonction(ptListe, nomF.getValue(), CalcC.ccbComp(ch, ptListe, pdebut + longNom, pfin, nomVariableFormelle));else {
	                            if (nombreVar.getValue() === 2) {
	                              var indicePremiereVirg = CCbGlob.premiereVirgule(ch, pdebut + longNom + 1);
	                              var operande1 = CalcC.ccbComp(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle);
	                              var indiceParF = CCbGlob.parentheseFermanteApresVirgule(ch, indicePremiereVirg + 1);
	                              // A revoir plus tard si on crée des fonctions de trois
	                              // variables ou plus
	                              var operande2 = CalcC.ccbComp(ch, ptListe, indicePremiereVirg + 1, indiceParF - 1, nomVariableFormelle);
	                              return new CFonction2Var(ptListe, nomF.getValue(), operande1, operande2);
	                            } else {
	                              if (nombreVar.getValue() === 3) {
	                                // 3 variables
	                                indicePremiereVirg = CCbGlob.premiereVirgule(ch, pdebut + longNom + 1);
	                                // Traitement de syntaxe particulier pour un calcul
	                                // d'intégrale de fonction, le premier argument devant
	                                // être le nom
	                                // d'une fonction prédéfinie
	                                operande1 = CalcC.ccbComp(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle);
	                                var indiceDeuxiemeVirg = CCbGlob.premiereVirgule(ch, indicePremiereVirg + 1);
	                                operande2 = CalcC.ccbComp(ch, ptListe, indicePremiereVirg + 1, indiceDeuxiemeVirg - 1, nomVariableFormelle);
	                                indiceParF = CCbGlob.parentheseFermanteApresVirgule(ch, indiceDeuxiemeVirg + 1);
	                                // A revoir plus tard si on crée des fonctions de
	                                // trois variables ou plus
	                                var operande3 = CalcC.ccbComp(ch, ptListe, indiceDeuxiemeVirg + 1, indiceParF - 1, nomVariableFormelle);
	                                return new CFonction3Var(ptListe, nomF.getValue(), operande1, operande2, operande3);
	                              }
	                              // Pas de calcul d'intégrale dans un calcul complexe
	                              else {
	                                  if (nombreVar.getValue() === 4) {
	                                    // Calcul d'intégrale
	                                    // Si les bornes ne sont pas réelles, c'est leur
	                                    // partie réelle qui sera utilisée
	                                    indicePremiereVirg = CCbGlob.premiereVirgule(ch, pdebut + longNom + 1);
	                                    indiceDeuxiemeVirg = CCbGlob.premiereVirgule(ch, indicePremiereVirg + 1);
	                                    var indiceTroisiemeVirg = CCbGlob.premiereVirgule(ch, indiceDeuxiemeVirg + 1);
	                                    indiceParF = CCbGlob.parentheseFermanteApresVirgule(ch, indiceTroisiemeVirg + 1);
	                                    var nomVariableSommation = ch.substring(indicePremiereVirg + 1, indiceDeuxiemeVirg);
	                                    /* nomVariableSommation = Kernel
	                                     .retireEspacesDebutEtFin(nomVariableSommation); */ // Modifié version 4.7.5.2
	                                    nomVariableSommation = nomVariableSommation.trim();
	                                    // Un seul paramètre autorisé pour un calcul
	                                    // d'intégrale dans un calcul complexe : la variable
	                                    // formelle
	                                    var nomVariableFormelle3 = new Array(1);
	                                    nomVariableFormelle3[0] = nomVariableSommation;
	                                    return new CIntegraleDansFormule(ptListe, CalcR.ccb(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle3), CalcC.ccbComp(ch, ptListe, indiceDeuxiemeVirg + 1, indiceTroisiemeVirg - 1, null), CalcC.ccbComp(ch, ptListe, indiceTroisiemeVirg + 1, indiceParF - 1, null), nomVariableSommation, true);
	                                  } else {
	                                    // Fonction à 5 variables : la somme indicée et le
	                                    // produit indicé
	                                    indicePremiereVirg = CCbGlob.premiereVirgule(ch, pdebut + longNom + 1);
	                                    indiceDeuxiemeVirg = CCbGlob.premiereVirgule(ch, indicePremiereVirg + 1);
	                                    indiceTroisiemeVirg = CCbGlob.premiereVirgule(ch, indiceDeuxiemeVirg + 1);
	                                    var indiceQuatriemeVirg = CCbGlob.premiereVirgule(ch, indiceTroisiemeVirg + 1);
	                                    indiceParF = CCbGlob.parentheseFermanteApresVirgule(ch, indiceQuatriemeVirg + 1);
	                                    nomVariableSommation = ch.substring(indicePremiereVirg + 1, indiceDeuxiemeVirg);
	                                    /* nomVariableSommation = Kernel
	                                     .retireEspacesDebutEtFin(nomVariableSommation); */
	                                    nomVariableSommation = nomVariableSommation.trim();
	                                    var n = 0;
	                                    if (nomVariableFormelle !== null) n = nomVariableFormelle.length;
	                                    var nomVariableFormelle2 = new Array(n + 1);
	                                    for (var j = 0; j < n; j++) {
	                                      nomVariableFormelle2[j] = nomVariableFormelle[j];
	                                    }nomVariableFormelle2[n] = nomVariableSommation;
	                                    if (nomF.getValue() === Opef5v.sommeC) return new CSommeDansFormule(ptListe, CalcC.ccbComp(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle2), CalcC.ccbComp(ch, ptListe, indiceDeuxiemeVirg + 1, indiceTroisiemeVirg - 1, nomVariableFormelle2), CalcC.ccbComp(ch, ptListe, indiceTroisiemeVirg + 1, indiceQuatriemeVirg - 1, nomVariableFormelle2), CalcC.ccbComp(ch, ptListe, indiceQuatriemeVirg + 1, indiceParF - 1, nomVariableFormelle2), nomVariableSommation);else return new CProduitDansFormule(ptListe, CalcC.ccbComp(ch, ptListe, pdebut + longNom + 1, indicePremiereVirg - 1, nomVariableFormelle2), CalcC.ccbComp(ch, ptListe, indiceDeuxiemeVirg + 1, indiceTroisiemeVirg - 1, nomVariableFormelle2), CalcC.ccbComp(ch, ptListe, indiceTroisiemeVirg + 1, indiceQuatriemeVirg - 1, nomVariableFormelle2), CalcC.ccbComp(ch, ptListe, indiceQuatriemeVirg + 1, indiceParF - 1, nomVariableFormelle2), nomVariableSommation);
	                                  }
	                                }
	                            }
	                          }
	                        } else {
	                          if (ptVa.getValue().estFonctionOuSuite()) {
	                            var calc = ptVa.getValue();
	                            var nbvar = calc.nombreVariables();
	                            if (nbvar === 1) return new CAppelFonctionComplexe(ptListe, ptVa.getValue(), CalcC.ccbComp(ch, ptListe, pdebut + longNom, pfin, nomVariableFormelle));else {
	                              var tabcal = new Array(nbvar);
	                              var deb = pdebut + longNom;
	                              var fin = 0;
	                              for (var i = 0; i < nbvar - 1; i++) {
	                                fin = CCbGlob.premiereVirgule(ch, deb + 1);
	                                tabcal[i] = CalcC.ccbComp(ch, ptListe, deb + 1, fin - 1, nomVariableFormelle);
	                                deb = fin;
	                              }
	                              deb++;
	                              fin = CCbGlob.parentheseFermanteApresVirgule(ch, deb);
	                              tabcal[nbvar - 1] = CalcC.ccbComp(ch, ptListe, deb, fin - 1, nomVariableFormelle);
	                              return new CAppelFonctionComplexeNVar(ptListe, nbvar, ptVa.getValue(), tabcal);
	                            }
	                          } else {
	                            return new CResultatValeurComplexe(ptListe, ptVa.getValue());
	                          }
	                        }
	                      }
	                    }
	                  } else {
	                    // Dans le cas où l'expression commence par une parenthèse
	                    // ouvrante, elle finit par une fermante et il suffit
	                    // d'évaluer ce que la parenthèse contient
	                    car = ch.charAt(pdebut);
	                    // Si le premier caractère est une parenthèse ouvrante
	                    // il faut faire attention car le dernier peut être
	                    // un espace.
	                    // Cela a donné un bug dans la version 16 bits
	                    if (car === '(') {
	                      if (CCbGlob.parentheseFermante(ch, pdebut) === -1) throw new Error();else return CalcC.ccbComp(ch, ptListe, pdebut + 1, CCbGlob.parentheseFermante(ch, pdebut) - 1, nomVariableFormelle);
	                    } else
	                      // Le résultat ne peut être que numérique}
	                      {
	                        var chaineNombre = "";
	                        var ptch = pdebut;
	                        while ((Fonte.chiffre(car) || car === '.') && ptch <= pfin) {
	                          car = ch.charAt(ptch);
	                          chaineNombre = chaineNombre + car;
	                          ptch++;
	                        }
	                        if (chaineNombre.length === 0) throw new Error(); // Spécial JavaScript
	                        var f = parseFloat(chaineNombre);
	                        if (isNaN(f)) throw new Error();else return new CConstante(ptListe, f);
	                      }
	                  }
	                }
	              }
	          }
	      }
	    } catch (e) {
	      // Amélioration version 4.7.4.1 : Même si l'expression est incorrecte, on remplace les * de multiplication par des \times
	      // Supprimé version 4.9.3
	      var ch1 = ch.substring(pdebut, pfin + 1);
	      // Amélioration version 4.9.3
	      if (ch1.charAt(0) === "(" && ch1.length >= 1) {
	        // Cas d'une parenthèse ouvrante non fermée
	        return CalcC.ccbComp(ch, ptListe, pdebut + 1, pfin, nomVariableFormelle);
	      }
	      //
	      return new CCbNull(ch1);
	    }
	  },
	  /**
	   * Fonction récursive vérifiant la syntaxe de l'expression réelle contenue dans ch en
	   * tenant compte du fait qu'elle ne doit pas utiliser de valeur dont l'indice
	   * dans ptListe est strictement supérieur à indiceMaxiDansListe.
	   * Le calcul est complexe mais peut utiliser des résultats réels.
	   * @param {CListeObjets} ptListe : La listeProprietaire du calcul analysé.
	   * @param {String} ch : La chaîne dans laquelle se fait la recherche.
	   * @param {Pointeur} indiceErreur : getValeur renverra l'indice de l'erreur
	   * de syntaxe dans la chapine s'il y en a une.
	   * @param {Integer} indiceMaxiDansListe : L'indice maxi d'interprétation dans la chaîne ch
	   * @param {Array } parametreFormel : Un tableau représentant les noms de la ou des variables formelles
	   * d'une fonction de une ou plusieurs variables.
	   * @returns {Boolean} : true si la syntaxe est correcte, false sinon.
	   */
	  verifieSyntaxeComplexe: function verifieSyntaxeComplexe(ptListe, ch, indiceErreur, indiceMaxiDansListe, parametreFormel) {
	    var i;
	    var indiceDansListe;
	    var pdebut;
	    var car, carSuivant;
	    var erreur;
	    var longueurCh;
	    var itemPrecedent;
	    var itemSuivant = 0;
	    var pointDecimalRencontre;
	    var sommeParentheses;
	    var longNom;
	    var nomF = new Pointeur();
	    var ptVa = new Pointeur();
	    var queDesBlancs;
	    var complexei = new Pointeur(false);
	    var parametreTrouve = new Pointeur(0);
	    var nombreVariables = new Pointeur(0);
	    var nivPar = 0; // Niveau de parenthèses
	    var appelFonction = new Array(CCbGlob.nombreMaxParentheses + 1); // 64 niveaux de parenthèses imbriqués maxi
	    for (var j = 0; j <= CCbGlob.nombreMaxParentheses; j++) {
	      appelFonction[j] = false;
	    }erreur = false;
	    longueurCh = ch.length;
	    // On vérifie d'abord qu'il n'y a pas d'erreur de parenthèse
	    if (longueurCh === 0) {
	      indiceErreur.setValue(0);
	      return false;
	    }
	    i = 0;
	    sommeParentheses = 0;
	    while (i < longueurCh && sommeParentheses >= 0) {
	      car = ch.charAt(i);
	      switch (car) {
	        case '(':
	          sommeParentheses++;
	          break;
	        case ')':
	          sommeParentheses--;
	      } // switch
	      i++;
	    }
	    if (sommeParentheses !== 0) {
	      indiceErreur.setValue(i);
	      return false;
	    }
	    if (ch === ".") {
	      indiceErreur.setValue(0);
	      return false;
	    }
	    i = 0;
	    itemPrecedent = CCbGlob.ParOuvrante;
	    while (i < longueurCh && !erreur) {
	      car = ch.charAt(i);
	      pointDecimalRencontre = false;
	      if (Fonte.chiffre(car) || car === '.') {
	        while ((Fonte.chiffre(car) || car === '.') && i < longueurCh && !erreur) {
	          if (car === '.') {
	            if (pointDecimalRencontre) {
	              erreur = true;
	              indiceErreur.setValue(i - 1);
	              // IndiceMessageErreur = IDE_SYNTAXE1;
	            } else pointDecimalRencontre = true;
	          }
	          i++;
	          if (i < longueurCh) car = ch.charAt(i);
	        } // while
	        if (!erreur) itemSuivant = CCbGlob.Nombre;
	      } else // cas où le caractère en cours n'est pas un nombre
	        // le caractère en cours n'est pas un chiffre ou un point décimal}
	        {
	          pdebut = i;
	          // On regarde si cela commence par le nom d'une fonction ou
	          // une valeur déjà définie
	          longNom = ptListe.commenceParNomFonctionOuValeurOuParametreComplexe(ch.substring(pdebut), parametreFormel, ptVa, nomF, parametreTrouve, complexei, nombreVariables);
	          if (longNom > 0) {
	            if (complexei.getValue()) {
	              itemSuivant = CCbGlob.Valeur;
	              i = i + longNom;
	            } else {
	              if (parametreTrouve.getValue() !== -1) {
	                itemSuivant = CCbGlob.Valeur;
	                i = i + longNom;
	              } else {
	                appelFonction[nivPar + 1] = true;
	                if (ptVa.getValue() === null) {
	                  if (i + longNom < ch.length && ch.charAt(i + longNom) !== '(') {
	                    erreur = true;
	                    indiceErreur.setValue(i + longNom);
	                  } else {
	                    itemSuivant = CCbGlob.Fonction;
	                    // Ajout version 4.5.2 pour corriger un bug
	                    if (!CCbGlob.autorisationSyntaxe(itemPrecedent, itemSuivant)) {
	                      erreur = true;
	                      indiceErreur.setValue(i);
	                      break;
	                    }
	                    //
	                    var nvirg = CCbGlob.NombreVirgules(ch, i + longNom + 1);
	                    if (nvirg !== nombreVariables.getValue() - 1) {
	                      if (nvirg <= nombreVariables.getValue() - 1) indiceErreur.setValue(CCbGlob.indiceCaractereVirgule(ch, i + longNom + 1, nvirg));else indiceErreur.setValue(CCbGlob.indiceCaractereVirgule(ch, i + longNom + 1, nombreVariables.getValue() - 1) - 1);
	                      erreur = true;
	                    } else {
	                      // Seule fonction complexe à 4 variables ou plus : le calcul
	                      // de somme indicée
	                      if (nombreVariables.getValue() >= 4) {
	                        nivPar++;
	                        var indicePremVirg = CCbGlob.premiereVirgule(ch, i + longNom + 1);
	                        var chformuleASommer = ch.substring(i + longNom + 1, indicePremVirg);
	                        var indiceDeuxiemeVirg = CCbGlob.premiereVirgule(ch, indicePremVirg + 1);
	                        var nomVariableSommation = ch.substring(indicePremVirg + 1, indiceDeuxiemeVirg);
	                        nomVariableSommation = nomVariableSommation.trim();
	                        if (!ptListe.validationNomCalculSansMessage(nomVariableSommation) || ptListe.egalNomValeurOuFonctionOuMesure(nomVariableSommation, -1)) {
	                          erreur = true;
	                          indiceErreur.setValue(indiceDeuxiemeVirg);
	                        } else {
	                          // On vérifie si la syntaxe du calcul à sommer est
	                          // correct.
	                          // Pour cela on appelle à nouveau vérifieSyntaxe
	                          var indiceErreur2 = new Pointeur(0);
	                          var n = 0;
	                          if (parametreFormel !== null) n = parametreFormel.length;
	                          var parametreFormel2 = new Array(n + 1);
	                          for (j = 0; j < n; j++) {
	                            parametreFormel2[j] = parametreFormel[j];
	                          }parametreFormel2[n] = nomVariableSommation;
	                          var b;
	                          if (nombreVariables.getValue() === 4 && nomF.getValue() === Opef4v.integraleC) {
	                            // Cas d'un calcul d'intégrale
	                            // Ne doit utiliser que fonctions ou valeurs réelles
	                            // On ne passe donc comme variable formelle que
	                            // nomVariableSommation
	                            var parametreFormel3 = new Array(1);
	                            parametreFormel3[0] = nomVariableSommation;
	                            b = CalcR.verifieSyntaxe(ptListe, chformuleASommer, indiceErreur2, indiceMaxiDansListe, parametreFormel3);
	                          } else b = CalcC.verifieSyntaxeComplexe(ptListe, chformuleASommer, indiceErreur2, indiceMaxiDansListe, parametreFormel2);
	                          if (!b) {
	                            erreur = true;
	                            indiceErreur.setValue(i + longNom + 1 + indiceErreur2.getValue());
	                          } else {
	                            i = indiceDeuxiemeVirg + 1;
	                            itemPrecedent = CCbGlob.Valeur;
	                            itemSuivant = CCbGlob.Virgule;
	                          }
	                        }
	                      } else i += longNom;
	                    }
	                  }
	                } else {
	                  var vd = ptVa.getValue();
	                  indiceDansListe = ptListe.indexOf(vd);
	                  if (indiceDansListe > indiceMaxiDansListe) {
	                    erreur = true;
	                    indiceErreur.setValue(i);
	                  } else {
	                    i += longNom;
	                    if (vd.estFonctionOuSuite()) {
	                      if (vd.estFonctionOuSuite()) {
	                        if (i < ch.length && ch.charAt(i) !== '(') {
	                          erreur = true;
	                          indiceErreur.setValue(i + longNom);
	                        } else {
	                          itemSuivant = CCbGlob.Fonction;
	                          var nbvar = vd.nombreVariables();
	                          if (nbvar >= 2) {
	                            nvirg = CCbGlob.NombreVirgules(ch, i + 1);
	                            if (nvirg !== nombreVariables.getValue() - 1) {
	                              if (nvirg <= nombreVariables.getValue() - 1) indiceErreur.setValue(CCbGlob.indiceCaractereVirgule(ch, i + 1, nvirg));else indiceErreur.setValue(CCbGlob.indiceCaractereVirgule(ch, i + 1, nombreVariables.getValue() - 1) - 1);
	                              erreur = true;
	                            }
	                          }
	                          // Bug corrigé version 4.6 : Il ne faut pas qu'un appel de fonction d'une variable comprenne des virgules
	                          else {
	                              if (CCbGlob.NombreVirgules(ch, i + 1) > 0) {
	                                indiceErreur.setValue(ch.indexOf(',', i + 1));
	                                erreur = true;
	                              }
	                            }
	                        }
	                      }
	                    } else itemSuivant = CCbGlob.Valeur;
	                  }
	                }
	              }
	            }
	          } else {
	            switch (car) {
	              case '+':
	              case '-':
	                itemSuivant = CCbGlob.Addition;
	                i++;
	                break;
	              case '*':
	              case '/':
	                itemSuivant = CCbGlob.Multiplication;
	                i++;
	                break;
	              case '(':
	                if (nivPar >= CCbGlob.nombreMaxParentheses - 1) {
	                  erreur = true;
	                  indiceErreur.setValue(i);
	                } else {
	                  itemSuivant = CCbGlob.ParOuvrante;
	                  i++;
	                  nivPar++;
	                }
	                break;
	              case ')':
	                appelFonction[nivPar] = false;
	                nivPar--;
	                itemSuivant = CCbGlob.ParFermante;
	                i++;
	                break;
	              case '^':
	                itemSuivant = CCbGlob.Puissance;
	                i++;
	                break;
	              // Ajout par rapport à la version C++ 1.8, autorisation du carré ²
	              case '²':
	                itemSuivant = CCbGlob.Carre;
	                i++;
	                break;
	              // ni nombre ni opérateur}
	              case '<':
	                itemSuivant = CCbGlob.Inegalite;
	                i++;
	                if (i <= longueurCh - 2) {
	                  carSuivant = ch.charAt(i);
	                  if (carSuivant === '=' || carSuivant === '>') i++;
	                }
	                break;
	              case '>':
	                itemSuivant = CCbGlob.Inegalite;
	                i++;
	                if (i <= longueurCh - 2) {
	                  carSuivant = ch.charAt(i);
	                  if (carSuivant === '=') i++;
	                }
	                break;
	              case '=':
	                itemSuivant = CCbGlob.Inegalite;
	                i++;
	                break;
	              case ' ':
	                itemSuivant = CCbGlob.Blanc;
	                i++;
	                break;
	              case ',':
	                if (!appelFonction[nivPar]) {
	                  erreur = true;
	                  indiceErreur.setValue(i);
	                } else {
	                  itemSuivant = Virgule;
	                  i++;
	                }
	                break;
	              default:
	                // switch Car
	                erreur = true;
	                indiceErreur.setValue(i - 1);
	            } // switch Car
	          } // else du if LongNom > 0
	        } // else du if Chiffre(Car) || (Car === '.'))
	      if (!erreur) {
	        if (CCbGlob.autorisationSyntaxe(itemPrecedent, itemSuivant)) {
	          if (itemSuivant !== CCbGlob.Blanc) itemPrecedent = itemSuivant;
	        } else {
	          erreur = true;
	          // IndiceMessageErreur = IDE_SYNTAXE1;
	          indiceErreur.setValue(i - 1);
	        }
	      }
	    } // while
	    // Il faut aussi regarder si la fin de l'expression est correcte
	    itemSuivant = CCbGlob.ParFermante;
	    if (!erreur) {
	      if (!CCbGlob.autorisationSyntaxe(itemPrecedent, itemSuivant)) {
	        erreur = true;
	        indiceErreur.setValue(longueurCh);
	      }
	    }
	    if (indiceErreur.getValue() < 0) indiceErreur.setValue(0);else if (indiceErreur.getValue() > longueurCh) indiceErreur.setValue(longueurCh);
	    i = 0;
	    queDesBlancs = true;
	    while (i <= longueurCh - 1 && queDesBlancs) {
	      car = ch.charAt(i);
	      if (car !== ' ') queDesBlancs = false;else i++;
	    }
	    if (queDesBlancs) {
	      // MessageBeep(0);
	      erreur = true;
	      indiceErreur.setValue(longueurCh);
	      // IndiceMessageErreur = IDE_SYNTAXE1;
	    }
	    // if (Erreur) MessageBeep(0);
	    return !erreur;
	  }
	};
	
	module.exports = CalcC;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CAppelFonctionNVar = __webpack_require__(44);
	module.exports = CAppelFonctionComplexeNVar;
	/**
	 * Objet d'un arbre binaire de calcul représentant un appel de fonction complexe utilisateur
	 * à n variables.
	 * @constructor
	 * @extends CAppelFonctionNVar
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {Integer} nbVar : Le nombre de variables de la fonction
	 * @param {CFoncNVar} fonctionAssociee : La fonction appliquée à l'opérande.
	 * @param {Array} operande : Tableau de CCb représentant les opérandes.
	 * @returns {CAppelFonctionComplexeNVar}
	 */
	function CAppelFonctionComplexeNVar(listeProprietaire, nbVar, fonctionAssociee, operande) {
	  CAppelFonctionNVar.call(this, listeProprietaire, nbVar, fonctionAssociee, operande);
	}
	CAppelFonctionComplexeNVar.prototype = new CAppelFonctionNVar();
	CAppelFonctionComplexeNVar.prototype.constructor = CAppelFonctionComplexeNVar;
	CAppelFonctionComplexeNVar.prototype.superClass = "CAppelFonctionNVar";
	CAppelFonctionComplexeNVar.prototype.className = "CAppelFonctionComplexeNVar";
	
	CAppelFonctionComplexeNVar.prototype.getClone = function (listeSource, listeCible) {
	  var operandeClone = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    operandeClone[i] = this.operande[i].getClone(listeSource, listeCible);
	  }var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  return new CAppelFonctionComplexeNVar(listeCible, this.nbVar, listeCible.get(ind1, "CAppelFonctionComplexeNVar"), operandeClone);
	};
	
	CAppelFonctionComplexeNVar.prototype.getCopie = function () {
	  var operandeCopie = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    operandeCopie[i] = this.operande[i].getCopie();
	  }return new CAppelFonctionComplexeNVar(this.listeProprietaire, this.nbVar, this.fonctionAssociee, operandeCopie);
	};
	
	CAppelFonctionComplexeNVar.prototype.calculAvecValeursRemplacees = function () {
	  var nbvar = this.fonctionAssociee.nombreVariables();
	  var tabcal = new Array(this.fonctionAssociee.nombreVariables());
	  for (var i = 0; i < nbvar; i++) {
	    tabcal[i] = this.operande[i].calculAvecValeursRemplacees();
	  }
	  return new CAppelFonctionComplexeNVar(this.listeProprietaire, nbvar, this.fonctionAssociee, tabcal);
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Complexe = __webpack_require__(30);
	var Ope = __webpack_require__(32);
	var CCbGlob = __webpack_require__(31);
	var CConstante = __webpack_require__(45);
	var CConstantei = __webpack_require__(46);
	var CMoinsUnaire = __webpack_require__(50);
	var CResultatValeur = __webpack_require__(59);
	var COp = __webpack_require__(51);
	
	module.exports = CResultatValeurComplexe;
	
	/**
	 * Classe représentant le résultat d'un calcul ou d'une mesure complexe existant.
	 * @constructor
	 * @extends CResultatValeur
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CValDyn} valeurAssociee : La valeur complexe dont c'est le résultat.
	 * @returns {CResultatValeurComplexe}
	 */
	function CResultatValeurComplexe(listeProprietaire, valeurAssociee) {
	  CResultatValeur.call(this, listeProprietaire);
	  if (arguments.length !== 1) this.valeurAssociee = valeurAssociee;
	}
	CResultatValeurComplexe.prototype = new CResultatValeur();
	CResultatValeurComplexe.prototype.constructor = CResultatValeurComplexe;
	CResultatValeurComplexe.prototype.superClass = "CResultatValeur";
	CResultatValeurComplexe.prototype.className = "CResultatValeurComplexe";
	
	CResultatValeurComplexe.prototype.nature = function () {
	  return CCbGlob.natResultatValeurComplexe;
	};
	CResultatValeurComplexe.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.valeurAssociee);
	  return new CResultatValeurComplexe(listeCible, listeCible.get(ind1, "CValDyn"));
	};
	CResultatValeurComplexe.prototype.resultatComplexe = function (infoRandom, zRes) {
	  // this.valeurAssociee.rendValeurComplexe(infoRandom, zRes);
	  this.valeurAssociee.rendValeurComplexe(zRes);
	};
	CResultatValeurComplexe.prototype.calculAvecValeursRemplacees = function () {
	  var z = new Complexe();
	  this.valeurAssociee.rendValeurComplexe(z);
	  var x = z.x;
	  var y = z.y;
	  var xcal, ycal;
	  if (x >= 0) xcal = new CConstante(this.listeProprietaire, x);else xcal = new CMoinsUnaire(this.listeProprietaire, new CConstante(this.listeProprietaire, Math.abs(x)));
	  if (y >= 0) ycal = new CConstante(this.listeProprietaire, y);else ycal = new CMoinsUnaire(this.listeProprietaire, new CConstante(this.listeProprietaire, Math.abs(y)));
	  if (y === 0) return xcal;
	  if (x === 0) return new COp(this.listeProprietaire, ycal, new CConstantei(this.listeProprietaire), Ope.Mult);
	  return new COp(this.listeProprietaire, xcal, new COp(this.listeProprietaire, ycal, new CConstantei(this.listeProprietaire), Ope.Mult), Ope.Plus);
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatArc = __webpack_require__(73);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CArcDeCercleAncetre = __webpack_require__(74);
	var CValeurAngle = __webpack_require__(79);
	module.exports = CArcDeCercle;
	
	/**
	 * Classe représentant un petit arc de cercle.
	 * Il peut être défini de deux façons :
	 * Par l'origine, un point donnant le début de l'ar et un point donnant la direction de la fin de l'arc.
	 * Ou par l'origine, un point donnant le début de l'arc et la valeur de l'angle au centre.
	 * @constructor
	 * @extends CArcDeCercleAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boollan} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CPt} o : Le centre de l'arc.
	 * @param {CPt} a : Le point donnant le début de l'arc.
	 * @param {CPt} pointFinArc : Le point donnant la fin de l'arc.
	 * Si null c'est que l'arc est défini par son angle au centre.
	 * @param {CValeurAngle} angleAuCentre : L'angle au centre (si pointFinArc est null)
	 * @returns {CArcDeCercle}
	 */
	function CArcDeCercle(listeProprietaire, impProto, estElementFinal, couleur, masque, style, o, a, pointFinArc, angleAuCentre) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CArcDeCercleAncetre.call(this, listeProprietaire);else {
	    CArcDeCercleAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.o = o;
	    this.a = a;
	    this.pointFinArc = pointFinArc;
	    this.angleAuCentre = angleAuCentre;
	  }
	}
	CArcDeCercle.prototype = new CArcDeCercleAncetre();
	CArcDeCercle.prototype.constructor = CArcDeCercle;
	CArcDeCercle.prototype.superClass = "CArcDeCercleAncetre";
	CArcDeCercle.prototype.className = "CArcDeCercle";
	
	CArcDeCercle.prototype.setClone = function (ptel) {
	  CArcDeCercleAncetre.prototype.setClone.call(this, ptel);
	  this.ang1 = ptel.ang1;
	  this.ang2 = ptel.ang2;
	  this.valeurAngleAuCentre = ptel.valeurAngleAuCentre;
	};
	CArcDeCercle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.o);
	  var ind2 = listeSource.indexOf(this.a);
	  var ptFinArc = null;
	  var angleAuCentreClone = null;
	  if (this.pointFinArc === null) angleAuCentreClone = this.angleAuCentre.getClone(listeSource, listeCible);else {
	    var ind3 = listeSource.indexOf(this.pointFinArc);
	    ptFinArc = listeCible.get(ind3, "CPt");
	    angleAuCentreClone = null;
	  }
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CArcDeCercle(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), ptFinArc, angleAuCentreClone);
	};
	CArcDeCercle.prototype.positionne = function (infoRandom, dimfen) {
	  var u;
	  if (this.pointFinArc === null) {
	    this.angleAuCentre.positionne(infoRandom, dimfen);
	    this.existe = this.o.existe && this.a.existe && this.angleAuCentre.existe;
	    if (!this.existe) return;
	    this.valeurAngleAuCentre = this.angleAuCentre.rendValeurRadian();
	    if (kernel.zeroAngle(this.valeurAngleAuCentre)) {
	      this.existe = false;
	      return;
	    }
	    u = new Vect(this.o, this.a);
	    this.rayon = u.norme();
	    this.centre_x = this.o.x;
	    this.centre_y = this.o.y;
	    this.origine_x = this.a.x;
	    this.origine_y = this.a.y;
	    this.ang1 = u.angleRad();
	    this.ang2 = this.ang1 + this.valeurAngleAuCentre;
	    if (this.ang2 < 0) this.ang2 = this.ang2 + 2 * Math.PI;
	    if (this.ang2 >= 2 * Math.PI) this.ang2 = this.ang2 - 2 * Math.PI;
	  } else {
	    this.existe = this.o.existe && this.a.existe && this.pointFinArc.existe;
	    if (!this.existe) return;
	    u = new Vect(this.o, this.a);
	    this.rayon = u.norme();
	    this.centre_x = this.o.x;
	    this.centre_y = this.o.y;
	    this.origine_x = this.a.x;
	    this.origine_y = this.a.y;
	    this.ang1 = u.angleRad();
	    var v = new Vect(this.o, this.pointFinArc);
	    this.ang2 = v.angleRad();
	    this.valeurAngleAuCentre = kernel.mesurePrincipale(this.ang2 - this.ang1);
	    if (kernel.zeroAngle(this.valeurAngleAuCentre)) {
	      this.existe = false;
	      return;
	    }
	  }
	  CArcDeCercleAncetre.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CArcDeCercle.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    if (this.pointFinArc === null) return this.o === p.o && this.a === p.a && this.angleAuCentre.confonduAvec(p.angleAuCentre);else return this.o === p.o && this.a === p.a && this.pointFinArc === p.pointFinArc;
	  } else return false;
	};
	CArcDeCercle.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.o);
	  liste.add(this.a);
	  if (this.pointFinArc !== null) liste.add(this.pointFinArc);
	};
	CArcDeCercle.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  if (this.pointFinArc === null) return this.memoriseDependance(CArcDeCercleAncetre.prototype.dependDe.call(this, p) || this.o.dependDe(p) || this.a.dependDe(p) || this.angleAuCentre.dependDe(p));else return this.memoriseDependance(CArcDeCercleAncetre.prototype.dependDe.call(this, p) || this.o.dependDe(p) || this.a.dependDe(p) || this.pointFinArc.dependDe(p));
	};
	CArcDeCercle.prototype.dependDePourBoucle = function (p) {
	  if (this.pointFinArc === null) return p === this || this.o.dependDePourBoucle(p) || this.a.dependDePourBoucle(p) || this.angleAuCentre.dependDePourBoucle(p);else return p === this || this.o.dependDePourBoucle(p) || this.a.dependDePourBoucle(p) || this.pointFinArc.dependDePourBoucle(p);
	};
	CArcDeCercle.prototype.createg = function () {
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  // style += "stroke:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	  style += "stroke:" + this.color + ";";
	  style += "fill:none";
	  return kernel.cens("path", {
	    d: this.path(),
	    style: style,
	    "pointer-events": "none"
	  });
	};
	CArcDeCercle.prototype.hasg = function (masquage) {
	  return this.existe && !(this.masque && masquage) && !this.horsFenetre;
	};
	CArcDeCercle.prototype.horsCadre = function () {
	  return this.horsFenetre;
	};
	CArcDeCercle.prototype.trace = function (svg) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CArcDeCercle.prototype.update = function () {
	  var g = this.g;
	  g.removeAttribute("d");
	  g.setAttribute("d", this.path());
	};
	/*
	 * Spécial JavaScript
	 * Renvoie le path pour définir le svg element associé.
	 */
	CArcDeCercle.prototype.path = function () {
	  var d;
	  var u = new Vect(this.centre_x, this.centre_y, this.origine_x, this.origine_y);
	  var v = new Vect();
	  u.tourne(this.valeurAngleAuCentre, v);
	  var xf = this.centre_x + v.x;
	  var yf = this.centre_y + v.y;
	  var sweepflag = this.valeurAngleAuCentre < 0 ? "1 " : "0 ";
	  d = "M " + this.origine_x.toString() + " " + this.origine_y + "A" + this.rayon + "," + this.rayon + " 0 0 " + sweepflag + xf.toString() + "," + yf.toString();
	  return d;
	};
	CArcDeCercle.prototype.surArc = function (xt, yt) {
	  var ang, ang1aux, ang2aux, dif, d;
	
	  var w = new Vect(this.centre_x, this.centre_y, xt, yt);
	  ang = w.angleRad();
	  if (kernel.zeroAngle(Math.abs(this.valeurAngleAuCentre) - Math.PI)) {
	    if (this.valeurAngleAuCentre > 0) {
	      // Cas d'un petit arc tracé dans le sens direct
	      if (this.ang1 <= Math.PI) return ang >= this.ang1 && ang <= this.ang1 + Math.PI;else return ang >= this.ang1 || ang <= this.ang1 - Math.PI;
	    } else {
	      if (this.ang1 <= Math.PI) return ang >= this.ang1 + Math.PI || ang <= this.ang1;else return ang <= this.ang1 && ang >= this.ang1 - Math.PI;
	    }
	  } else {
	    ang1aux = this.ang1;
	    ang2aux = this.ang2;
	    // On ordonne ang1Aux et ang2Aux dans l'ordre croissant
	    if (ang1aux > ang2aux) {
	      d = ang2aux;
	      ang2aux = ang1aux;
	      ang1aux = d;
	    }
	    dif = ang2aux - ang1aux;
	    if (dif < Math.PI) return ang >= ang1aux && ang <= ang2aux;else return ang <= ang1aux || ang >= ang2aux;
	  }
	};
	/**
	 * Fonction servant à positionner un point lié à un arc de cercle.
	 * Renvoie un nombre compris entre 0 et 1.
	 * @param {Float} ang : La valeur testée.
	 * @returns {Float}
	 */
	CArcDeCercle.prototype.abscisseCurviligne = function (ang) {
	  var difang;
	  if (this.valeurAngleAuCentre === 0) return 0;
	  difang = Math.abs(ang - this.ang1);
	  if (difang > Math.PI) difang = 2 * Math.PI - difang;
	  return difang / Math.abs(this.valeurAngleAuCentre);
	};
	CArcDeCercle.prototype.abscisseMinimale = function () {
	  return 0;
	};
	CArcDeCercle.prototype.abscisseMaximale = function () {
	  return 1;
	};
	/**
	 * Renvoie la nature de l'arc.
	 * @returns {NatArc}
	 */
	CArcDeCercle.prototype.natureArc = function () {
	  return NatArc.PetitArc;
	};
	CArcDeCercle.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.o === ancienPoint) this.o = nouveauPoint;
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	  if (this.pointFinArc === ancienPoint) this.pointFinArc = nouveauPoint;
	};
	CArcDeCercle.prototype.contientParDefinition = function (po) {
	  return this.a === po;
	};
	CArcDeCercle.prototype.chaineDesignation = function () {
	  return "desArc";
	};
	CArcDeCercle.prototype.read = function (inps, list) {
	  CArcDeCercleAncetre.prototype.read.call(this, inps, list);
	  this.angleAuCentre = null;
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.o = list.get(ind1, "CPt");
	  this.a = list.get(ind2, "CPt");
	  this.pointFinArc = null;
	  var ind3 = inps.readInt();
	  if (ind3 === -1) {
	    this.angleAuCentre = new CValeurAngle();
	    this.angleAuCentre.read(inps, list);
	  } else this.pointFinArc = list.get(ind3, "CPt");
	};
	CArcDeCercle.prototype.write = function (oups, list) {
	  CArcDeCercleAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.o);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.a);
	  oups.writeInt(ind2);
	  var ind3;
	  if (this.pointFinArc === null) ind3 = -1;else ind3 = list.indexOf(this.pointFinArc);
	  oups.writeInt(ind3);
	  if (this.pointFinArc === null) this.angleAuCentre.write(oups, list);
	};

/***/ },
/* 73 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Définition des natures des arcs de cercle.
	 * @type mtg32.NatArc
	 */
	var NatArc = {
	  ArcCercle: 0,
	  PetitArc: 1,
	  GrandArc: 2,
	  ArcDirect: 3,
	  ArcIndirect: 4
	};
	module.exports = NatArc;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CCercle = __webpack_require__(75);
	module.exports = CArcDeCercleAncetre;
	
	/**
	 * Classe ancêtre de tous les arcs de cercle.
	 * @constructor
	 * @extends CCercle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	* @returns {CArcDeCercleAncetre}
	 */
	function CArcDeCercleAncetre(listeProprietaire, impProto, estElementFinal, couleur, masque, style) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CCercle.call(this, listeProprietaire);else {
	    CCercle.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	  }
	  this.valeurAngleAuCentre = 0; // Nécessaire JavaScript pour CSurfaceSecteurCirculaire
	}
	CArcDeCercleAncetre.prototype = new CCercle();
	CArcDeCercleAncetre.prototype.constructor = CArcDeCercleAncetre;
	CArcDeCercleAncetre.prototype.superClass = "CCercle";
	CArcDeCercleAncetre.prototype.className = "CArcDeCercleAncetre";
	
	CArcDeCercleAncetre.prototype.setClone = function (ptel) {
	  CCercle.prototype.setClone.call(this, ptel);
	  this.origine_x = ptel.origine_x;
	  this.origine_y = ptel.origine_y;
	  this.valeurAngleAuCentre = ptel.valeurAngleAuCentre;
	};
	CArcDeCercleAncetre.prototype.getNature = function () {
	  return NatObj.NArc;
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatArc = __webpack_require__(73);
	var PositionCercleCercle = __webpack_require__(11);
	var PositionRelative = __webpack_require__(76);
	var kernel = __webpack_require__(8);
	var CElementLigne = __webpack_require__(77);
	module.exports = CCercle;
	
	/**
	 * Classe ancêtre de tous les cercles et arcs de cercle.
	 * @constructor
	 * @extends CElementLigne
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style de tracé.
	 * @returns {CCercle}
	 */
	function CCercle(listeProprietaire, impProto, estElementFinal, couleur, masque, style) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 16, style);
	}
	CCercle.prototype = new CElementLigne();
	CCercle.prototype.constructor = CCercle;
	CCercle.prototype.superClass = "CElementLigne";
	CCercle.prototype.className = "CCercle";
	
	CCercle.prototype.setClone = function (ptel) {
	  CElementLigne.prototype.setClone.call(this, ptel);
	  this.centre_x = ptel.centre_x;
	  this.centre_y = ptel.centre_y;
	  this.rayon = ptel.rayon;
	  /* Supprimé version 5.2. Ne sert pas
	  this.xCarre1 = ptel.xCarre1;
	  this.yCarre1 = ptel.yCarre1;
	  this.xCarre2 = ptel.xCarre2;
	  this.yCarre2 = ptel.yCarre2;
	  */
	  this.horsFenetre = ptel.horsFenetre;
	};
	/**
	 * Fonction renvoyant true si le point de coordonnées (xt,yt) est sur l'objet.
	 * true par défaut.
	 * A redéfinir pour les arcs de cercle.
	 * @param {Float} xt : l'abscisse du point testé.
	 * @param {Flaot} yt : L'ordonnée du point testé.
	 * @returns {Boolean}
	 */
	CCercle.prototype.surArc = function (xt, yt) {
	  return true; // true pour un vrai cercle
	};
	/**
	 * Fonction fournissant la position relative du cercle par rapport à elg
	 * @param {type} elg
	 * @param {type} bperpendiculaires : : renvoie par getValue true si des droites
	 * sont perpendiculaires. Ici false.
	 * @returns {PositionRelative}
	 */
	CCercle.prototype.positionRelative = function (elg, bperpendiculaires) {
	  if (elg.estDeNature(NatObj.NTtPoint)) {
	    bperpendiculaires.setValue(false);
	    if (kernel.appartientCercle(this, elg.x, elg.y) && this.surArc(elg.x, elg.y)) return PositionRelative.appartient;else return PositionRelative.nappartient;
	  } else {
	    if (elg.estDeNature(NatObj.NTtCercle)) {
	      bperpendiculaires.setValue(false);
	      // CCercle cercle = (CCercle) elg;
	      var point1 = {};
	      var point2 = {};
	      var position = kernel.intersectionCercleCercle(this.centre_x, this.centre_y, this.rayon, elg.centre_x, elg.centre_y, elg.rayon, point1, point2);
	      switch (position) {
	        case PositionCercleCercle.Vide:
	          return PositionRelative.vide;
	        case PositionCercleCercle.Confondus:
	          if (this.getNature() === NatObj.NCercle && elg.getNature() === NatObj.NCercle) return PositionRelative.confondus;else return PositionRelative.memeSupportCercle;
	        case PositionCercleCercle.Tangents:
	          if (this.surArc(this.point1.x, this.point1.y) && elg.surArc(this.point1.x, this.point1.y)) return PositionRelative.tangents;else return PositionRelative.vide;
	        case PositionCercleCercle.Secants:
	          var b1 = this.surArc(this.point1.x, this.point1.y) && elg.surArc(this.point1.x, this.point1.y);
	          var b2 = this.surArc(this.point2.x, this.point2.y) && elg.surArc(this.point2.x, this.point2.y);
	          if (b1 && b2) return PositionRelative.secants2Point;
	          if (b1 || b2) return PositionRelative.secants1Point;
	          return PositionRelative.vide;
	        default:
	          return PositionRelative.vide; // Pour satisfairele compilateur
	      }
	    } else return elg.positionRelative(this, bperpendiculaires);
	  }
	};
	CCercle.prototype.positionne = function (infoRandom, dimfen) {
	  // devra être appelée par tous les descendants de cercle.positionne
	  // pour vérifier que le rayon est positif
	  this.existe = this.rayon > 0;
	  if (this.existe) this.horsFenetre = !dimfen.testCercleDansFen(this.centre_x, this.centre_y, this.rayon);
	
	  /* Modifié version 5.2. Algotithme non correct
	  var rayon2 = this.rayon*this.rayon;
	  d1 = kernel.distancePointPointCarre(this.centre_x, this.centre_y, 0, 0);
	  d2 = kernel.distancePointPointCarre(this.centre_x, this.centre_y, 0, dimfen.y);
	  d3 = kernel.distancePointPointCarre(this.centre_x, this.centre_y, dimfen.x, 0);
	  d4 = kernel.distancePointPointCarre(this.centre_x, this.centre_y, dimfen.x, dimfen.y);
	  if ((rayon2 >= d1) && (rayon2 >= d2) && (rayon2 >= d3) && (rayon2 >= d4)) {
	    this.horsFenetre = true;
	    return;
	  }
	  if (!dimfen.dansFenetre(this.centre_x, this.centre_y)) {
	    // On calcule les distances du centre aux quatre côtés de la fenêtre.
	    // Si le rayon est inférieur à la plus petite des quatre, le cercle n'est pas visible
	    d1 = Math.abs(this.centre_y);
	    d2 = Math.abs(this.centre_y - dimfen.y);
	    d3 = Math.abs(this.centre_x);
	    d4 = Math.abs(this.centre_x - dimfen.x);
	    if ((this.rayon <= d1) && (this.rayon <= d2) && (this.rayon <= d3) && (this.rayon <= d4)) {
	      this.horsFenetre = true;
	      return;
	    }
	  }
	  /* Supprimé version 5.2. Ne sert pas
	  this.xCarre1 = this.centre_x - this.rayon;
	  this.yCarre1 = this.centre_y - this.rayon;
	  this.xCarre2 = this.centre_x + this.rayon;
	  this.yCarre2 = this.centre_y + this.rayon;
	  */
	  // this.horsFenetre = false;
	};
	CCercle.prototype.createg = function () {
	  /* Modifié version mtgApp
	  var g = document.createElementNS(kernel.svgns,"circle");
	  g.setAttribute("cx",this.centre_x);
	  g.setAttribute("cy",this.centre_y);
	  g.setAttribute("r",this.rayon);
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:"+stroke+";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:"+strokewidth+";";
	  style += "stroke:"+this.color+";";
	  style += "fill:none";
	  g.setAttribute("style", style);
	  g.setAttribute("pointer-events", "none");
	  return g;
	  */
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  style += "stroke:" + this.color + ";";
	  style += "fill:none";
	
	  return kernel.cens("circle", {
	    cx: this.centre_x,
	    cy: this.centre_y,
	    r: this.rayon,
	    style: style,
	    "pointer-events": "none"
	  });
	};
	CCercle.prototype.hasg = function (masquage) {
	  return this.existe && !this.horsFenetre && !(this.masque && masquage);
	};
	CCercle.prototype.horsCadre = function () {
	  return this.horsFenetre;
	};
	CCercle.prototype.trace = function (svg, couleurFond, transparence) {
	  // if ((kernel.testToile(this.xCarre1,this.yCarre1)) && (kernel.testToile(this.xCarre2,this.yCarre2))){
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CCercle.prototype.update = function (svg) {
	  var g = this.g;
	  g.removeAttribute("cx");
	  g.removeAttribute("cy");
	  g.removeAttribute("r");
	  g.setAttribute("cx", this.centre_x);
	  g.setAttribute("cy", this.centre_y);
	  g.setAttribute("r", this.rayon);
	};
	CCercle.prototype.abscisseMinimale = function () {
	  return 0;
	};
	CCercle.prototype.abscisseMaximale = function () {
	  return 2 * Math.PI;
	};
	CCercle.prototype.abscisseCurviligne = function (ang) {
	  return ang;
	};
	CCercle.prototype.natureArc = function () {
	  return NatArc.ArcCercle;
	};
	CCercle.prototype.dansFen = function () {
	  return !this.horsFenetre;
	};
	CCercle.prototype.getNature = function () {
	  return NatObj.NCercle;
	};
	// Utilis version mtgApp
	CCercle.prototype.setRayon = function (ray) {
	  this.rayon = ray;
	};
	CCercle.prototype.contientParDefinition = function (po) {
	  return false;
	};
	CCercle.prototype.pointInterieur = function (x, y) {
	  return kernel.distancePointPoint(x, y, this.centre_x, this.centre_y) <= this.rayon;
	};
	CCercle.prototype.chaineDesignation = function () {
	  return "desCercle";
	};

/***/ },
/* 76 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Constantes définissant les différentes positions relatives de deux objets.
	 */
	var PositionRelative = {
	  appartient: 0,
	  nappartient: 1,
	  paralleles: 2,
	  confondus: 3,
	  secants: 4,
	  secants1Point: 5,
	  secants2Point: 6,
	  tangents: 7,
	  vide: 8,
	  memeSupportDroite: 9,
	  memeSupportCercle: 10
	};
	module.exports = PositionRelative;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var StyleTrait = __webpack_require__(78);
	var CElementGraphique = __webpack_require__(39);
	module.exports = CElementLigne;
	
	/**
	 * Classe ancêtre de tous les éléments qui se tracent comme une ligne, fermée ou non.
	 * @constructor
	 * @extends CElementGraphique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {mtg32.CImpementationProto} impProto : null ou la construction proprétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur de tracé
	 * @param {Boolean} nomMasque : true si le nom est masqué.
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y ; Décalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masqué
	 * @param {String} nom : Le nom.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {StyleTrait} style : Le style de trait utilisé.
	 * @returns {CElementLigne}
	 */
	function CElementLigne(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) {
	    CElementGraphique.call(this, listeProprietaire);
	    // Ajout version 5.0
	    this.style = new StyleTrait(listeProprietaire); // Le style de trait doit connaître la liste pour adapter son style aux écarns HD
	    //
	  } else {
	    CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom);
	    this.style = style;
	    // Modification version 4.9.9.4
	    /* Modifié version 5.0
	    this.stroke = StyleTrait.stroke(this.style);
	    this.strokewidth = StyleTrait.strokeWidth(this.style);
	    */
	    /* Inutile version 5.0
	    if (this.style) { // Test àa cause des objets internes non dessiné qui n'ont pas de style
	       this.stroke = style.stroke;
	       this.strokewidth = style.strokeWidth;
	     }
	     */
	  }
	}
	CElementLigne.prototype = new CElementGraphique();
	CElementLigne.prototype.constructor = CElementLigne;
	CElementLigne.prototype.superClass = "CElementGraphique";
	CElementLigne.prototype.className = "CElementLigne";
	
	/**
	 * Doone à l'objet le style de trait style
	 * @param {StyleTrait} style
	 * @returns {undefined}
	 */
	CElementLigne.prototype.donneStyle = function (style) {
	  this.style = style;
	};
	
	CElementLigne.prototype.read = function (inps, list) {
	  CElementGraphique.prototype.read.call(this, inps, list);
	  if (list.numeroVersion < 15) this.style.readOld(inps, list, true);else this.style.read(inps, list);
	};
	CElementLigne.prototype.write = function (oups, list) {
	  CElementGraphique.prototype.write.call(this, oups, list);
	  this.style.write(oups);
	};

/***/ },
/* 78 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	module.exports = StyleTrait;
	/**
	 * Définition des styles de traits utilisés.
	 * Modifié version 5.0 pour que le style de trait soit un objet ayant un style de trait et une couleur
	 * @type StyleTrait.StyleTrait
	 */
	function StyleTrait(liste, style, strokeWidth) {
	  this.liste = liste; // La liste propriétaire
	  if (arguments.length !== 1) {
	    this.style = style;
	    this.strokeWidth = strokeWidth;
	    this.stroke = this.getStroke();
	  }
	}
	StyleTrait.straitFin = 0;
	StyleTrait.straitPointille = 1;
	StyleTrait.straitEpais = 2;
	StyleTrait.straitTrait = 3;
	StyleTrait.straitPointPoint = 4;
	StyleTrait.straitTresEpais = 5;
	StyleTrait.straitPointilleEpais = 6;
	// Nouvelles constantes version 5.0 pour les styles de trait
	StyleTrait.styleTraitContinu = 0;
	StyleTrait.styleTraitPointille = 1;
	StyleTrait.styleTraitTrait = 2;
	StyleTrait.styleTraitPointPoint = 3;
	StyleTrait.styleTraitPointPointPoint = 4;
	StyleTrait.styleTraitTraitLongTrait = 5;
	//
	StyleTrait.prototype.getStroke = function () {
	  switch (this.style) {
	    case StyleTrait.styleTraitContinu:
	      return "";
	    case StyleTrait.styleTraitPointille:
	      return "3 3";
	    case StyleTrait.styleTraitTrait:
	      return "10 10";
	    case StyleTrait.styleTraitPointPoint:
	      return "10 3 3 3 3 3";
	    case StyleTrait.styleTraitPointPointPoint:
	      return "10 3 3 3 3 3 3 3";
	    case StyleTrait.styleTraitTraitLongTrait:
	      return "10 3 5 3";
	    default:
	      return "";
	  }
	};
	// Style de trait fin pointillé utilisé par plusieurs outils
	StyleTrait.stfp = function (list) {
	  return new StyleTrait(list, StyleTrait.styleTraitPointille, 1);
	};
	// Styles de trait fin continue utilisé dans plusieurs outils
	StyleTrait.stfc = function (list) {
	  return new StyleTrait(list, StyleTrait.styleTraitContinu, 1);
	};
	StyleTrait.stfc2 = function (list) {
	  return new StyleTrait(list, StyleTrait.styleTraitContinu, 2);
	};
	StyleTrait.prototype.read = function (inps, liste) {
	  this.liste = liste;
	  this.style = inps.readByte();
	  this.stroke = this.getStroke();
	  this.strokeWidth = inps.readByte();
	};
	StyleTrait.prototype.write = function (oups) {
	  oups.writeByte(this.style);
	  oups.writeByte(this.strokeWidth);
	};
	StyleTrait.prototype.readOld = function (inps, liste, bbyte) {
	  this.liste = liste;
	  var oldstyle = bbyte ? inps.readByte() : inps.readInt();
	  switch (oldstyle) {
	    case StyleTrait.straitFin:
	      this.style = StyleTrait.styleTraitContinu;
	      this.strokeWidth = 1;
	      break;
	    case StyleTrait.straitPointille:
	      this.style = StyleTrait.styleTraitPointille;
	      this.strokeWidth = 1;
	      break;
	    case StyleTrait.straitEpais:
	      this.style = StyleTrait.styleTraitContinu;
	      this.strokeWidth = 2;
	      break;
	    case StyleTrait.straitTrait:
	      this.style = StyleTrait.styleTraitTrait;
	      this.strokeWidth = 1;
	      break;
	    case StyleTrait.straitPointPoint:
	      this.style = StyleTrait.styleTraitPointPoint;
	      this.strokeWidth = 1;
	      break;
	    case StyleTrait.straitTresEpais:
	      this.style = StyleTrait.styleTraitContinu;
	      this.strokeWidth = 3;
	      break;
	    case StyleTrait.straitPointilleEpais:
	      this.style = StyleTrait.styleTraitPointille;
	      this.strokeWidth = 2;
	      break;
	    default:
	      this.style = StyleTrait.styleTraitContinu;
	      this.strokeWidth = 1;
	  }
	  this.stroke = this.getStroke();
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CValeur = __webpack_require__(80);
	module.exports = CValeurAngle;
	// Modifié par rapport à la verion Java : hérite de CValeur
	
	/**
	 * Classe représentant une valeur dynamique d'angle définie par un calcul sur des objets
	 * numériques de la figure.
	 * @constructor
	 * @extends CValeur
	 * @param {CListeObjets} listeProprietaire
	 * @param {CCb} calcul : pointe sur le calcul donnant le résultat
	 * @returns {CValeurAngle}
	 */
	function CValeurAngle(listeProprietaire, calcul) {
	  CValeur.call(this, listeProprietaire, calcul);
	}
	CValeurAngle.prototype = new CValeur();
	CValeurAngle.prototype.constructor = CValeurAngle;
	CValeurAngle.prototype.superClass = "CValeur";
	CValeurAngle.prototype.className = "CValeurAngle";
	
	CValeurAngle.prototype.getClone = function (listeSource, listeCible) {
	  var calculClone = this.calcul.getClone(listeSource, listeCible);
	  return new CValeurAngle(listeCible, calculClone, this.valeur);
	};
	CValeurAngle.prototype.rendValeurRadian = function () {
	  var val = this.valeur;
	  if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.degre) val = val * kernel.ConvDegRad;
	  val = kernel.mesurePrincipale(val);
	  return val;
	};

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var COb = __webpack_require__(34);
	var CConstante = __webpack_require__(45);
	module.exports = CValeur;
	
	/**
	 * Classe représentant une valeur dynamique définie par un calcul sur des objets
	 * numériques de la figure.
	 * Appelée CValeurAssocieeAVariable dans la version Java.
	 * Si le cacul associé est constant (ne dépend d'aucun objet dynamique),
	 * le calcul n'est fait qu'une fois et le résultat est stocké dans this.valeur
	 * sinon le calcul est refait à chaque recalcul de la figure
	 * et le résultat stocké dans this.valeur.
	 * Par exemple, un cercle défini par centre et rayon a son rayon de type CValeur.
	 * @constructor
	 * @extends COb
	 * @param {CListeObjets} listeProprietaire
	 * @param {CCb} calcul : pointe sur le calcul donnant le résultat
	 * @returns {CValeur}
	 */
	function CValeur(listeProprietaire, calcul) {
	    if (arguments.length !== 0) {
	        // Si 0, Constructeur pour chargement depuis flux
	        if (arguments.length === 1) {
	            if (arguments[0].className === "CListeObjets") COb.call(this, listeProprietaire);else {
	                // Construction à partir d'un autre CValeur
	                var cvaav = arguments[0];
	                COb.call(this, cvaav.listeProprietaire);
	                if (this.calcul !== null) this.calcul = cvaav.calcul.getClone(listeProprietaire, listeProprietaire);
	                this.estConstant = cvaav.estConstant;
	                if (this.estConstant) this.valeur = cvaav.valeur;
	                this.existe = cvaav.existe;
	                this.dejaPositionne = cvaav.dejaPositionne;
	            }
	        } else {
	            if (typeof calcul === "number") {
	                // Construction par liste et valeur numérique
	                var liste = arguments[0];
	                var nombre = arguments[1];
	                COb.call(this, liste);
	                this.calcul = new CConstante(liste, nombre);
	                this.valeur = nombre;
	                this.dejaPositionne = true;
	                this.estConstant = true;
	                this.existe = true;
	            } else {
	                COb.call(this, listeProprietaire);
	                this.calcul = calcul;
	                this.dejaPositionne = false;
	            }
	        }
	    }
	}
	CValeur.prototype = new COb();
	CValeur.prototype.constructor = CValeur;
	CValeur.prototype.superClass = "COb";
	CValeur.prototype.className = "CValeur";
	
	/**
	 * Fonction donnant à l'objet une valeur constante et créant le calcul
	 * constant correspondant
	 * @param {Number} val
	 * @returns {undefined}
	 */
	CValeur.prototype.donneValeur = function (val) {
	    this.valeur = val;
	    this.calcul = new CConstante(this.listeProprietaire, this.valeur);
	    this.dejaPositionne = true;
	    this.estConstant = true;
	    this.existe = true;
	};
	CValeur.prototype.initialisePourDependance = function () {
	    this.calcul.initialisePourDependance();
	};
	/**
	 * Fonction renvoyant true si le calcul depend de p
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CValeur.prototype.dependDe = function (p) {
	    return this.calcul.dependDe(p);
	};
	/**
	 * Fonction renvoyant true ii le calcul depend de p pour les boucles de macro
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CValeur.prototype.dependDePourBoucle = function (p) {
	    return this.calcul.dependDePourBoucle(p);
	};
	/**
	 * Fonction recalculant le calcul associé et affectant la valeur du résultat à this.valeur
	 * this.existe est mis à true si le calcul existe
	 * @param {Boolean} infoRandom : true pour que les éventuels appels à la fonction
	 * rand soient réactualisés.
	 * @param mtg32.Dimf dimfen
	 * @returns {undefined}
	 */
	CValeur.prototype.positionne = function (infoRandom) {
	    if (!this.dejaPositionne) {
	        if (this.calcul.estConstant()) {
	            this.estConstant = true;
	            this.existe = this.calcul.existe(infoRandom);
	            if (!this.existe) return;
	            try {
	                this.listeProprietaire.initialiseNombreIterations();
	                this.valeur = this.calcul.resultat(infoRandom);
	            } catch (e) {
	                this.existe = false;
	                this.valeur = 0;
	            }
	            if (!isFinite(this.valeur)) this.existe = false;
	        } else this.estConstant = false;
	        this.dejaPositionne = true;
	    }
	    if (!this.estConstant) {
	        this.existe = this.calcul.existe(infoRandom);
	        if (!this.existe) return;
	        try {
	            this.listeProprietaire.initialiseNombreIterations();
	            this.valeur = this.calcul.resultat(infoRandom);
	        } catch (e) {
	            this.existe = false;
	            this.valeur = 0;
	        }
	        if (!isFinite(this.valeur)) this.existe = false;
	    }
	};
	/**
	 * Fonction renvoyant true si p est aussi un CValeurAssoceAVariable
	 * constant ayant la même valeur ou si le calcul est un résultat de valeur
	 * pointant sur la même valeur que this.
	 * @param {COb} p
	 * @returns {Boolean}
	 */
	CValeur.prototype.confonduAvec = function (p) {
	    if (!this.dejaPositionne) this.positionne(false, null);
	    if (!p.dejaPositionne) p.positionne(false, null);
	    if (this.estConstant && p.estConstant) return this.valeur === p.valeur;else {
	        if (this.calcul.className === "CResultatValeur" && p.calcul.className === "CResultatValeur") return this.calcul.valeurAssociee === p.calcul.valeurAssociee;else return false;
	    }
	};
	/**
	 * Renvoie la valeur du calcul associé
	 * @param {Boolean} infoRandom : true si on réactualise les calculs aléatoires
	 * avec rand.
	 * @returns {Number}
	 */
	CValeur.prototype.rendValeur = function () {
	    return this.valeur; ///Cas d'une constante
	};
	/**
	 * Fonction renvoyant une chaîne de caractères représentant le calcul associé.
	 * @returns {unresolved}
	 */
	CValeur.prototype.chaineInfo = function () {
	    return this.calcul.chaineCalculSansPar(null);
	};
	/**
	 * Fonction lisant l'objet depuis un flux de données binaire.
	 * @param {DataInputStream} inps
	 * @param {CListeObjets} list
	 * @returns {undefined}
	 */
	CValeur.prototype.read = function (inps, list) {
	    COb.prototype.read.call(this, inps, list);
	    this.calcul = inps.readObject(list);
	};
	/**
	 * Fonction rnregistrant l'objet dans un flux de données binaire.
	 * @param {DataInputStream} inps
	 * @param {CListeObjets} list
	 * @returns {undefined}
	 */
	CValeur.prototype.write = function (oups, list) {
	    COb.prototype.write.call(this, oups, list);
	    oups.writeObject(this.calcul);
	};
	/**
	 * Fonction renvoyant true si le calcul associé est constant, c'est à dire ne
	 * dépend d'aucun objet dynamique
	 * @returns {Boolean}
	 */
	CValeur.prototype.estConstant = function () {
	    return this.estConstant;
	};
	/**
	 * Fonction renvoyant un cmone de l'objet
	 * @param {CListeObjets} listeSource
	 * @param {CListeObjets} listeCible
	 * @returns {CValeur}
	 */
	CValeur.prototype.getClone = function (listeSource, listeCible) {
	    var calculClone = this.calcul.getClone(listeSource, listeCible);
	    var va = new CValeur(listeCible, calculClone, this.valeur);
	    va.dejaPositionne = this.dejaPositionne;
	    va.estConstant = this.estConstant;
	    va.valeur = this.valeur;
	    va.existe = this.existe;
	    return va;
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatArc = __webpack_require__(73);
	var Vect = __webpack_require__(12);
	var CArcDeCercle = __webpack_require__(72);
	module.exports = CArcDeCercleDirect;
	
	/**
	 * Classe représentant un arc de cercle tracé dans le sens direct.
	 * Il peut être défini de deux façons :
	 * Par l'origine, un point donnant le début de l'ar et un point donnant la direction de la fin de l'arc.
	 * Ou par l'origine, un point donnant le début de l'arc et la valeur de l'angle au centre.
	 * @constructor
	 * @extends CArcDeCercle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CPt} o : Le centre de l'arc.
	 * @param {CPt} a : Le point donnant le début de l'arc.
	 * @param {CPt} pointFinArc : Le point donnant la fin de l'arc.
	 * Si null c'est que l'arc est défini par son angle au centre.
	 * @param {CValeurAngle} angleAuCentre : L'angle au centre (si pointFinArc est null)
	 * @returns {CArcDeCercleDirect}
	 */
	function CArcDeCercleDirect(listeProprietaire, impProto, estElementFinal, couleur, masque, style, o, a, pointFinArc, angleAuCentre) {
	  if (arguments.length === 1) CArcDeCercle.call(this, listeProprietaire);else {
	    CArcDeCercle.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.o = o;
	    this.a = a;
	    this.pointFinArc = pointFinArc;
	    this.angleAuCentre = angleAuCentre;
	  }
	}
	CArcDeCercleDirect.prototype = new CArcDeCercle();
	CArcDeCercleDirect.prototype.constructor = CArcDeCercleDirect;
	CArcDeCercleDirect.prototype.superClass = "CArcDeCercle";
	CArcDeCercleDirect.prototype.className = "CArcDeCercleDirect";
	
	CArcDeCercleDirect.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.o);
	  var ind2 = listeSource.indexOf(this.a);
	  var ptFinArc = null;
	  var angleAuCentreClone = null;
	  if (this.pointFinArc === null) angleAuCentreClone = this.angleAuCentre.getClone(listeSource, listeCible);else {
	    var ind3 = listeSource.indexOf(this.pointFinArc);
	    ptFinArc = listeCible.get(ind3, "CPt");
	  }
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CArcDeCercleDirect(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), ptFinArc, angleAuCentreClone);
	};
	CArcDeCercleDirect.prototype.path = function () {
	  var u = new Vect(this.centre_x, this.centre_y, this.origine_x, this.origine_y);
	  var v = new Vect();
	  u.tourne(this.valeurAngleAuCentre, v);
	  var xf = this.centre_x + v.x;
	  var yf = this.centre_y + v.y;
	  var largearcflag = this.valeurAngleAuCentre >= 0 ? "0 " : "1 ";
	  return "M " + this.origine_x.toString() + " " + this.origine_y + "A" + this.rayon + "," + this.rayon + " 0 " + largearcflag + " 0 " + xf.toString() + "," + yf.toString();
	};
	CArcDeCercleDirect.prototype.abscisseCurviligne = function (ang) {
	  var angrot, difang;
	  angrot = this.valeurAngleAuCentre;
	  if (angrot === 0) return 0;
	  if (angrot < 0) angrot = angrot + 2 * Math.PI;
	  difang = ang - this.ang1;
	  if (difang < 0) difang = difang + 2 * Math.PI;
	  return difang / angrot;
	};
	CArcDeCercleDirect.prototype.surArc = function (xt, yt) {
	  var ang;
	  var w = new Vect(this.centre_x, this.centre_y, xt, yt);
	  ang = w.angleRad();
	  if (this.ang1 <= this.ang2) return ang >= this.ang1 && ang <= this.ang2;else return ang <= this.ang2 || ang >= this.ang1;
	};
	CArcDeCercleDirect.prototype.natureArc = function () {
	  return NatArc.ArcDirect;
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatArc = __webpack_require__(73);
	var Pointeur = __webpack_require__(16);
	var Vect = __webpack_require__(12);
	var CArcDeCercleAncetre = __webpack_require__(74);
	var CArcDeCercleDirect = __webpack_require__(81);
	var CArcDeCercleIndirect = __webpack_require__(83);
	var CArcDeCercle = __webpack_require__(72);
	var CGrandArcDeCercle = __webpack_require__(84);
	var CPointBase = __webpack_require__(85);
	module.exports = CArcDeCercleImage;
	
	/**
	 * Classe représentant un arc de cercle image d'un autre arc par une transformation.
	 * @constructor
	 * @extends CArcDeCercleAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CArcDeCercleAncetre} antecedent : l'arc dont this est l'image.
	 * @param {CTransformation} transformation : La transformation utilisée.
	 * @returns {CArcDeCercleImage}
	 */
	function CArcDeCercleImage(listeProprietaire, impProto, estElementFinal, couleur, masque, style, antecedent, transformation) {
	  if (arguments.length === 1) CArcDeCercleAncetre.call(this, listeProprietaire);else {
	    CArcDeCercleAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.antecedent = antecedent;
	    this.transformation = transformation;
	    this.ptCentre = new CPointBase();
	    this.ptOrigine = new CPointBase();
	    this.ptExtremite = new CPointBase();
	    this.creeArcInterne();
	  }
	}
	CArcDeCercleImage.prototype = new CArcDeCercleAncetre();
	CArcDeCercleImage.prototype.constructor = CArcDeCercleImage;
	CArcDeCercleImage.prototype.superClass = "CArcDeCercleAncetre";
	CArcDeCercleImage.prototype.className = "CArcDeCercleImage";
	
	CArcDeCercleImage.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.antecedent);
	  var ind2 = listeSource.indexOf(this.transformation);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CArcDeCercleImage(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CArcDeCercleAncetre"), listeCible.get(ind2, "CTransformation"));
	};
	CArcDeCercleImage.prototype.creeArcInterne = function () {
	  if (this.transformation.className === "CSymetrieAxiale") {
	    switch (this.antecedent.natureArc()) {
	      case NatArc.PetitArc:
	        this.arc = new CArcDeCercle(this.listeProprietaire, null, false, this.couleur, this.masque, this.style, this.ptCentre, this.ptOrigine, this.ptExtremite, null);
	        break;
	      case NatArc.GrandArc:
	        this.arc = new CGrandArcDeCercle(this.listeProprietaire, null, false, this.couleur, this.masque, this.style, this.ptCentre, this.ptOrigine, this.ptExtremite, null);
	        break;
	      case NatArc.ArcDirect:
	        this.arc = new CArcDeCercleIndirect(this.listeProprietaire, null, false, this.couleur, this.masque, this.style, this.ptCentre, this.ptOrigine, this.ptExtremite, null);
	        break;
	      case NatArc.ArcIndirect:
	        this.arc = new CArcDeCercleDirect(this.listeProprietaire, null, false, this.couleur, this.masque, this.style, this.ptCentre, this.ptOrigine, this.ptExtremite, null);
	    }
	  } else // Conservation des angles orientés
	    {
	      switch (this.antecedent.natureArc()) {
	        case NatArc.PetitArc:
	          this.arc = new CArcDeCercle(this.listeProprietaire, null, false, this.couleur, this.masque, this.style, this.ptCentre, this.ptOrigine, this.ptExtremite, null);
	          break;
	        case NatArc.GrandArc:
	          this.arc = new CGrandArcDeCercle(this.listeProprietaire, null, false, this.couleur, this.masque, this.style, this.ptCentre, this.ptOrigine, this.ptExtremite, null);
	          break;
	        case NatArc.ArcDirect:
	          this.arc = new CArcDeCercleDirect(this.listeProprietaire, null, false, this.couleur, this.masque, this.style, this.ptCentre, this.ptOrigine, this.ptExtremite, null);
	          break;
	        case NatArc.ArcIndirect:
	          this.arc = new CArcDeCercleIndirect(this.listeProprietaire, null, false, this.couleur, this.masque, this.style, this.ptCentre, this.ptOrigine, this.ptExtremite, null);
	      }
	    }
	};
	CArcDeCercleImage.prototype.path = function () {
	  return this.arc.path();
	};
	CArcDeCercleImage.prototype.setClone = function (ptel) {
	  CArcDeCercleAncetre.prototype.setClone.call(this, ptel);
	  this.arc.setClone(ptel.arc);
	};
	CArcDeCercleImage.prototype.donneCouleur = function (coul) {
	  CArcDeCercleAncetre.prototype.donneCouleur.call(this, coul);
	  this.arc.donneCouleur(coul);
	};
	CArcDeCercleImage.prototype.donneStyle = function (nouveauStyle) {
	  CArcDeCercleAncetre.prototype.donneStyle.call(this, nouveauStyle);
	  this.arc.donneStyle(nouveauStyle);
	};
	CArcDeCercleImage.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CArcDeCercleAncetre.prototype.dependDe.call(this, p) || this.antecedent.dependDe(p) || this.transformation.dependDe(p));
	};
	CArcDeCercleImage.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.antecedent.dependDePourBoucle(p) || this.transformation.dependDePourBoucle(p);
	};
	CArcDeCercleImage.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.transformation.existe && this.antecedent.existe;
	  if (!this.existe) return;
	  var pointim = {};
	  this.transformation.transformePoint(this.antecedent.centre_x, this.antecedent.centre_y, pointim);
	  var x = pointim.x;
	  var y = pointim.y;
	  this.ptCentre.placeEn(x, y);
	  this.transformation.transformePoint(this.antecedent.origine_x, this.antecedent.origine_y, pointim);
	  this.ptOrigine.placeEn(pointim.x, pointim.y);
	  var pointeur = new Pointeur(0);
	  this.transformation.transformeAngle(this.antecedent.valeurAngleAuCentre, pointeur);
	  var ang = pointeur.getValue();
	  var u = new Vect(this.ptCentre, this.ptOrigine);
	  var v = new Vect();
	  u.tourne(ang, v);
	  this.ptExtremite.placeEn(x + v.x, y + v.y);
	  this.arc.positionne(infoRandom, dimfen);
	  // L'arc doit refléter les membres de l'arc interne qu'il maintient
	  this.centre_x = this.arc.centre_x;
	  this.centre_y = this.arc.centre_y;
	  this.origine_x = this.arc.origine_x;
	  this.origine_y = this.arc.origine_y;
	  this.rayon = this.arc.rayon;
	  this.valeurAngleAuCentre = ang;
	  // this.arc.valeurAngleAuCentre = ang;
	};
	CArcDeCercleImage.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.antecedent === p.antecedent && this.transformation.confonduAvec(p.transformation);
	  } else return false;
	};
	CArcDeCercleImage.prototype.abscisseMaximale = function () {
	  return this.arc.abscisseMaximale();
	};
	CArcDeCercleImage.prototype.abscisseMinimale = function () {
	  return this.arc.abscisseMinimale();
	};
	CArcDeCercleImage.prototype.abscisseCurviligne = function (ang) {
	  return this.arc.abscisseCurviligne(ang);
	};
	CArcDeCercleImage.prototype.surArc = function (xt, yt) {
	  return this.arc.surArc(xt, yt);
	};
	CArcDeCercleImage.prototype.natureArc = function () {
	  return this.arc.natureArc();
	};
	CArcDeCercleImage.prototype.cache = function () {
	  CArcDeCercleAncetre.prototype.cache.call(this);
	  this.arc.cache();
	};
	CArcDeCercleImage.prototype.montre = function () {
	  CArcDeCercleAncetre.prototype.montre.call(this);
	  this.arc.montre();
	};
	CArcDeCercleImage.prototype.createg = function () {
	  return this.arc.createg();
	};
	CArcDeCercleImage.prototype.hasg = function (masquage) {
	  return this.existe && !(this.masque && masquage) && !this.arc.horsFenetre;
	};
	CArcDeCercleImage.prototype.horsCadre = function () {
	  return this.arc.horsFenetre;
	};
	CArcDeCercleImage.prototype.trace = function (svg) {
	  var g = this.arc.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CArcDeCercleImage.prototype.update = function () {
	  var g = this.g;
	  g.removeAttribute("d");
	  g.setAttribute("d", this.arc.path());
	};
	CArcDeCercleImage.prototype.contientParDefinition = function (po) {
	  if (po.estPointImage()) {
	    return this.transformation === po.transformation && this.antecedent.contientParDefinition(po.antecedent);
	  } else return true;
	};
	CArcDeCercleImage.prototype.ajouteAntecedents = function (liste, app) {
	  liste.add(this.antecedent);
	  this.transformation.ajouteAntecedents(liste, app);
	};
	CArcDeCercleImage.prototype.read = function (inps, list) {
	  CArcDeCercleAncetre.prototype.read.call(this, inps, list);
	  this.ptCentre = new CPointBase();
	  this.ptOrigine = new CPointBase();
	  this.ptExtremite = new CPointBase();
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.transformation = list.get(ind1, "CTransformation");
	  this.antecedent = list.get(ind2, "CArcDeCercleAncetre");
	  this.creeArcInterne();
	};
	CArcDeCercleImage.prototype.write = function (oups, list) {
	  CArcDeCercleAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.transformation);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.antecedent);
	  oups.writeInt(ind2);
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatArc = __webpack_require__(73);
	var Vect = __webpack_require__(12);
	var CArcDeCercle = __webpack_require__(72);
	module.exports = CArcDeCercleIndirect;
	
	/**
	 * Classe représentant un arc de cercle tracé dans le sens indirect.
	 * Il peut être défini de deux façons :
	 * Par l'origine, un point donnant le début de l'ar et un point donnant la direction de la fin de l'arc.
	 * Ou par l'origine, un point donnant le début de l'arc et la valeur de l'angle au centre.
	 * @constructor
	 * @extends CArcDeCercle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CPt} o : Le centre de l'arc.
	 * @param {CPt} a : Le point donnant le début de l'arc.
	 * @param {CPt} pointFinArc : Le point donnant la fin de l'arc.
	 * Si null c'est que l'arc est défini par son angle au centre.
	 * @param {CValeurAngle} angleAuCentre : L'angle au centre (si pointFinArc est null)
	  * @returns {CArcDeCercleIndirect}
	 */
	function CArcDeCercleIndirect(listeProprietaire, impProto, estElementFinal, couleur, masque, style, o, a, pointFinArc, angleAuCentre) {
	  if (arguments.length === 1) CArcDeCercle.call(this, listeProprietaire);else {
	    CArcDeCercle.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.o = o;
	    this.a = a;
	    this.pointFinArc = pointFinArc;
	    this.angleAuCentre = angleAuCentre;
	  }
	}
	CArcDeCercleIndirect.prototype = new CArcDeCercle();
	CArcDeCercleIndirect.prototype.constructor = CArcDeCercleIndirect;
	CArcDeCercleIndirect.prototype.superClass = "CArcDeCercle";
	CArcDeCercleIndirect.prototype.className = "CArcDeCercleIndirect";
	
	CArcDeCercleIndirect.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.o);
	  var ind2 = listeSource.indexOf(this.a);
	  var ptFinArc = null;
	  var angleAuCentreClone = null;
	  if (this.pointFinArc === null) angleAuCentreClone = this.angleAuCentre.getClone(listeSource, listeCible);else {
	    var ind3 = listeSource.indexOf(this.pointFinArc);
	    ptFinArc = listeCible.get(ind3, "CPt");
	  }
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CArcDeCercleIndirect(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), ptFinArc, angleAuCentreClone);
	};
	CArcDeCercleIndirect.prototype.path = function () {
	  var u = new Vect(this.centre_x, this.centre_y, this.origine_x, this.origine_y);
	  var v = new Vect();
	  u.tourne(this.valeurAngleAuCentre, v);
	  var xf = this.centre_x + v.x;
	  var yf = this.centre_y + v.y;
	  var largearcflag = this.valeurAngleAuCentre >= 0 ? "1" : "0";
	  return "M " + this.origine_x.toString() + " " + this.origine_y + "A" + this.rayon + "," + this.rayon + " 0 " + largearcflag + " 1 " + xf.toString() + "," + yf.toString();
	};
	CArcDeCercleIndirect.prototype.abscisseCurviligne = function (ang) {
	  var angrot, difang;
	  angrot = this.valeurAngleAuCentre;
	  if (angrot === 0) return 0;
	  angrot = -angrot;
	  if (angrot < 0) angrot = angrot + 2 * Math.PI;
	  difang = ang - this.ang2;
	  if (difang < 0) difang = difang + 2 * Math.PI;
	  return difang / angrot;
	};
	CArcDeCercleIndirect.prototype.surArc = function (xt, yt) {
	  var ang;
	  var w = new Vect(this.centre_x, this.centre_y, xt, yt);
	  ang = w.angleRad();
	  if (this.ang2 <= this.ang1) return ang >= this.ang2 && ang <= this.ang1;else return ang <= this.ang1 || ang >= this.ang2;
	};
	CArcDeCercleIndirect.prototype.natureArc = function () {
	  return NatArc.ArcIndirect;
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatArc = __webpack_require__(73);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CArcDeCercle = __webpack_require__(72);
	module.exports = CGrandArcDeCercle;
	
	/**
	 * Classe représentant un grand arc de cercle défini par son centre, le point de départ et soit
	 * un point donnant la dircetion de fin soit la valeur de l'angle au centre.
	 * @constructor
	 * @extends CArcDeCercle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boollan} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CPt} o : Le centre de l'arc.
	 * @param {CPt} a : Le point donnant le début de l'arc.
	 * @param {CPt} pointFinArc : Le point donnant la fin de l'arc.
	 * Si null c'est que l'arc est défini par son angle au centre.
	 * @param {CValeurAngle} angleAuCentre : L'angle au centre (si pointFinArc est null)
	 * @returns {CGrandArcDeCercle}
	 */
	function CGrandArcDeCercle(listeProprietaire, impProto, estElementFinal, couleur, masque, style, o, a, pointFinArc, angleAuCentre) {
	  if (arguments.length === 1) CArcDeCercle.call(this, listeProprietaire);else {
	    CArcDeCercle.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.o = o;
	    this.a = a;
	    this.pointFinArc = pointFinArc;
	    this.angleAuCentre = angleAuCentre;
	  }
	}
	CGrandArcDeCercle.prototype = new CArcDeCercle();
	CGrandArcDeCercle.prototype.constructor = CGrandArcDeCercle;
	CGrandArcDeCercle.prototype.superClass = "CArcDeCercle";
	CGrandArcDeCercle.prototype.className = "CGrandArcDeCercle";
	
	CGrandArcDeCercle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.o);
	  var ind2 = listeSource.indexOf(this.a);
	  var ptFinArc = null;
	  var angleAuCentreClone = null;
	  if (this.pointFinArc === null) angleAuCentreClone = this.angleAuCentre.getClone(listeSource, listeCible);else {
	    var ind3 = listeSource.indexOf(this.pointFinArc);
	    ptFinArc = listeCible.get(ind3, "CPt");
	    angleAuCentreClone = null;
	  }
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CGrandArcDeCercle(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), ptFinArc, angleAuCentreClone);
	};
	CGrandArcDeCercle.prototype.path = function () {
	  var d;
	  var u = new Vect(this.centre_x, this.centre_y, this.origine_x, this.origine_y);
	  var v = new Vect();
	  u.tourne(this.valeurAngleAuCentre, v);
	  var xf = this.centre_x + v.x;
	  var yf = this.centre_y + v.y;
	  var sweepflag = this.valeurAngleAuCentre < 0 ? "0 " : "1 ";
	  d = "M " + this.origine_x.toString() + " " + this.origine_y + "A" + this.rayon + "," + this.rayon + " 0 1 " + sweepflag + xf.toString() + "," + yf.toString();
	  return d;
	};
	CGrandArcDeCercle.prototype.surArc = function (xt, yt) {
	  var ang, ang1aux, ang2aux, dif, d;
	
	  var w = new Vect(this.centre_x, this.centre_y, xt, yt);
	  ang = w.angleRad();
	  ang1aux = this.ang1;
	  ang2aux = this.ang2;
	  if (ang1aux > ang2aux) {
	    d = ang2aux;
	    ang2aux = ang1aux;
	    ang1aux = d;
	  }
	  dif = ang2aux - ang1aux;
	  if (kernel.zeroAngle(dif - Math.PI)) {
	    if (this.ang1 >= this.ang2) return ang >= this.ang2 && ang <= this.ang1;else {
	      return ang >= this.ang2 || ang <= this.ang1;
	    }
	  } else {
	    if (dif < Math.PI) {
	      return ang <= ang1aux || ang >= ang2aux;
	    } else {
	      return ang >= ang1aux && ang <= ang2aux;
	    }
	  }
	};
	CGrandArcDeCercle.prototype.abscisseCurviligne = function (ang) {
	  var difang;
	  if (this.valeurAngleAuCentre === 0) return 0;
	  if (this.valeurAngleAuCentre >= 0) {
	    if (ang <= this.ang1) difang = this.ang1 - ang;else difang = 2 * Math.PI - ang + this.ang1;
	  } else {
	    if (ang >= this.ang1) difang = ang - this.ang1;else difang = 2 * Math.PI - this.ang1 + ang;
	  }
	  return difang / (2 * Math.PI - Math.abs(this.valeurAngleAuCentre));
	};
	CGrandArcDeCercle.prototype.natureArc = function () {
	  return NatArc.GrandArc;
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CPointAncetrePointsMobiles = __webpack_require__(86);
	var kernel = __webpack_require__(8);
	var CPt = __webpack_require__(87);
	module.exports = CPointBase;
	
	/**
	 * Classe représentant un point libre sur la figure pouvant être déplacé n'importe où.
	 * @constructor
	 * @extends CPointAncetrePointsMobiles
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si le point n'est pas punaisé
	 * @param {Number} x : abscisse du point dans le svg
	 * @param {Number} y : ordonnee du point sans le svg
	 * @returns {undefined}
	 */
	function CPointBase(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, x, y) {
	  // Ajout version 4.9.9.4
	  if (arguments.length === 0) {
	    CPointAncetrePointsMobiles.call(this, null);
	  } else {
	    //
	    if (arguments.length === 1) CPointAncetrePointsMobiles.call(this, listeProprietaire);else {
	      CPointAncetrePointsMobiles.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre);
	      this.x = x;
	      this.y = y;
	    }
	  }
	  // Ligne suivante nécessaire pour les points utilisés de façon interne
	  this.dansFenetre = true;
	}
	CPointBase.prototype = new CPointAncetrePointsMobiles();
	CPointBase.prototype.constructor = CPointBase;
	CPointBase.prototype.superClass = "CPointAncetrePointsMobiles";
	CPointBase.prototype.className = "CPointBase";
	
	CPointBase.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  return new CPointBase(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, this.pointLibre, this.x, this.y);
	};
	
	CPointBase.prototype.getNature = function () {
	  return NatObj.NPointBase;
	};
	
	CPointBase.prototype.positionne = function (infoRandom, dimfen) {
	  CPt.prototype.positionne.call(this, infoRandom, dimfen);
	  this.existe = true;
	};
	
	CPointBase.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  pointr.x = xtest;
	  pointr.y = ytest;
	  return this.testFenetre(dimfen, xtest, ytest);
	};
	
	CPointBase.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return kernel.zero(p.x - this.x) && kernel.zero(p.y - this.y);
	  } else return false;
	};
	
	/**
	 * Zoome les coordonnées du point d'un facteur rapport par rapport au point
	 * de coordonnées (xcentre, ycentre)
	 * @param {Number} xcentre
	 * @param {Number} ycentre
	 * @param {Number} rapport
	 * @returns {undefined}
	 */
	CPointBase.prototype.zoom = function (xcentre, ycentre, rapport) {
	  this.x = xcentre + rapport * (this.x - xcentre);
	  this.y = ycentre + rapport * (this.y - ycentre);
	};
	// Non adapaté JavaScript : adaptePourHauteResolution(double coef)
	// Pour cet objet x et y ne sont pas calculés mais lus dans le flux d'objets
	
	CPointBase.prototype.read = function (inps, list) {
	  CPointAncetrePointsMobiles.prototype.read.call(this, inps, list);
	  this.x = inps.readDouble();
	  this.y = inps.readDouble();
	};
	
	CPointBase.prototype.write = function (oups, list) {
	  CPointAncetrePointsMobiles.prototype.write.call(this, oups, list);
	  oups.writeDouble(this.x);
	  oups.writeDouble(this.y);
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CPt = __webpack_require__(87);
	module.exports = CPointAncetrePointsMobiles;
	
	/**
	 * Classe ancêtre de tous les points mobiles., point libres ou liés.
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si le point n'est pas punaisé
	 * @returns {undefined}
	 */
	function CPointAncetrePointsMobiles(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.pointLibre = pointLibre;
	  }
	}
	CPointAncetrePointsMobiles.prototype = new CPt();
	CPointAncetrePointsMobiles.prototype.constructor = CPointAncetrePointsMobiles;
	CPointAncetrePointsMobiles.prototype.superClass = "CPt";
	CPointAncetrePointsMobiles.prototype.className = "CPointAncetrePointsMobiles";
	/**
	 * Renvoie this.pointLibre qui est true si le point n'est pas punaisé.
	 * @returns {Boolean}
	 */
	CPointAncetrePointsMobiles.prototype.estLibre = function () {
	  return this.pointLibre;
	};
	/** @inheritedDoc */
	CPointAncetrePointsMobiles.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  this.pointLibre = inps.readBoolean();
	};
	/** @inheritedDoc */
	CPointAncetrePointsMobiles.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  oups.writeBoolean(this.pointLibre);
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CElementGraphique = __webpack_require__(39);
	var MotifPoint = __webpack_require__(88);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	module.exports = CPt;
	/**
	 * Classe ancetre de tous les points.
	 * @constructor
	 * @extends CElementGraphique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @returns {undefined}
	 */
	function CPt(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CElementGraphique.call(this, listeProprietaire);else {
	    CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom);
	    this.motif = motif;
	    this.marquePourTrace = marquePourTrace;
	  }
	}
	CPt.prototype = new CElementGraphique();
	CPt.prototype.constructor = CPt;
	CPt.prototype.superClass = "CElementGraphique";
	CPt.prototype.className = "CPt";
	
	CPt.prototype.setClone = function (ptel) {
	  CElementGraphique.prototype.setClone.call(this, ptel);
	  this.x = ptel.x;
	  this.y = ptel.y;
	  this.horsEcran = ptel.horsEcran;
	  this.dansFenetre = ptel.dansFenetre;
	  this.marquePourTrace = ptel.marquePourTrace;
	};
	
	/**
	 * Ajout version 5.2 (numéro de version 16). Renverra true si l'objet possède un nom qui doit être enregistré dans le flux
	 * @returns {boolean}
	 */
	CPt.prototype.hasName = function () {
	  return true;
	};
	
	CPt.prototype.getNature = function () {
	  return NatObj.NPoint;
	};
	/**
	 * Renvoie true si le point est un point libre
	 * Redefini pour CPointAncetrePointsMobiles et ses desecndants
	 * @returns {Boolean}
	 */
	CPt.prototype.estLibre = function () {
	  return false; // Spécial JavaScript
	};
	/**
	 * Renvoie true si les coordonnées du point sont comprises entre -2147483648 et 2147483647
	 * @returns {Boolean}
	 */
	CPt.prototype.testToile = function () {
	  return kernel.testToile(this.x, this.y);
	};
	
	/**
	 * Renvoie true si le point de coordonnées (x,y) est dans la fenêtre dimfen
	 * @param {types.Dimf} dimfen
	 * @param {number} x
	 * @param {number} y
	 * @returns {boolean}
	 */
	CPt.prototype.testFenetre = function (dimfen, x, y) {
	  return dimfen.dansFenetre(x, y);
	};
	/**
	 * Renvoie true si le point est contenu dans la fenêtre dimfen
	 * @param {types.Dimf} dimf
	 * @returns {boolean}
	 */
	CPt.prototype.dansFen = function (dimf) {
	  return this.dansFenetre;
	};
	/**
	 * Renvoie le svg element représentant le point
	 * @returns {svgElement}
	 */
	CPt.prototype.createg = function () {
	  var line1, line2, g, k0, k3, k5;
	  var style = "";
	  var coul = this.color;
	  style += "stroke:" + coul + ";";
	  // Amélioration version 5.0 : ON tient compte des figures de haute résolution pour la taille des croix
	  switch (this.motif) {
	    case MotifPoint.pave:
	      style += "stroke-width:1;";
	      style += "fill:" + coul + ";";
	      g = kernel.cens("rect", {
	        x: this.x - 2,
	        y: this.y - 2,
	        width: 4,
	        height: 4,
	        style: style
	      });
	      break;
	    case MotifPoint.rond:
	      style += "stroke-width:1;";
	      style += "fill:" + coul + ";";
	      g = kernel.cens("circle", {
	        cx: this.x,
	        cy: this.y,
	        // r: 3, // Modifé version 5.4
	        r: 2.5,
	        style: style
	      });
	      break;
	    case MotifPoint.croix:
	      k3 = 3;
	      style += "stroke-width:1.5;";
	      g = kernel.cens("g");
	      line1 = kernel.cens("line", {
	        style: style,
	        x1: this.x - k3,
	        y1: this.y,
	        x2: this.x + k3,
	        y2: this.y
	      });
	      line2 = kernel.cens("line", {
	        style: style,
	        x1: this.x,
	        y1: this.y - k3,
	        x2: this.x,
	        y2: this.y + k3
	      });
	      g.appendChild(line1);
	      g.appendChild(line2);
	      break;
	    case MotifPoint.multi:
	      k3 = 3;
	      style += "stroke-width:1.5;";
	      g = kernel.cens("g");
	      line1 = kernel.cens("line", {
	        style: style,
	        x1: this.x - k3,
	        y1: this.y - k3,
	        x2: this.x + k3,
	        y2: this.y + k3
	      });
	      line2 = kernel.cens("line", {
	        style: style,
	        x1: this.x + k3,
	        y1: this.y - k3,
	        x2: this.x - k3,
	        y2: this.y + k3
	      });
	      g.appendChild(line1);
	      g.appendChild(line2);
	      break;
	    case MotifPoint.petitRond:
	      style += "stroke-width:1;";
	      style += "fill:" + coul + ";";
	      g = kernel.cens("circle", {
	        cx: this.x,
	        cy: this.y,
	        // r: 2, // Modifié version 5.4
	        r: 1.5,
	        style: style
	      });
	      break;
	    case MotifPoint.losange:
	      k3 = 3;
	      style += "stroke-width:1;";
	      style += "fill:" + coul + ";";
	      g = kernel.cens("polygon", {
	        points: this.x + " " + (this.y - k3).toString() + "," + (this.x - k3).toString() + " " + this.y + "," + this.x + " " + (this.y + k3).toString() + "," + (this.x + k3).toString() + " " + this.y,
	        style: style
	      });
	      break;
	    case MotifPoint.pixel:
	    case MotifPoint.quadrillage:
	      k0 = 0.5;
	      style += "stroke-width:1;";
	      style += "fill:" + coul + ";";
	      g = kernel.cens("circle", {
	        cx: this.x,
	        cy: this.y,
	        r: k0,
	        style: style
	      });
	      break;
	    case MotifPoint.grandRond:
	      style += "stroke-width:1;";
	      style += "fill:" + coul + ";";
	      g = kernel.cens("circle", {
	        cx: this.x,
	        cy: this.y,
	        // r: 4, // Modifié version 5.4
	        r: 3.5,
	        style: style
	      });
	      break;
	    case MotifPoint.grandMult:
	      k5 = 5;
	      style += "stroke-width:1.5;";
	      g = kernel.cens("g");
	      line1 = kernel.cens("line", {
	        style: style,
	        x1: this.x - k5,
	        y1: this.y - k5,
	        x2: this.x + k5,
	        y2: this.y + k5
	      });
	      line2 = kernel.cens("line", {
	        style: style,
	        x1: this.x + k5,
	        y1: this.y - k5,
	        x2: this.x - k5,
	        y2: this.y + k5
	      });
	      g.appendChild(line1);
	      g.appendChild(line2);
	  }
	  // if (!this.dansFenetre) g.setAttribute("visibility", "hidden");
	  g.setAttribute("pointer-events", "none");
	  return g;
	};
	
	CPt.prototype.hasg = function (masquage) {
	  return this.existe && this.dansFenetre && !(this.masque && masquage);
	};
	/**
	 * Rajoute au svg le svg Element représentant le point
	 * @param {svg} svg
	 * @returns {undefined}
	 */
	CPt.prototype.trace = function (svg) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	  if (this.listeProprietaire.documentProprietaire.modeTraceActive && this.marquePourTrace) this.listeProprietaire.addTrace(this.createg());
	};
	// Spécial JavaScript : Met à jour dans le DOM l'élément associé
	
	CPt.prototype.update = function (svg) {
	  var oldg = this.g;
	  var g = this.createg();
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	
	CPt.prototype.updateTrace = function (svg) {
	  if (this.marquePourTrace && this.listeProprietaire.documentProprietaire.modeTraceActive) this.listeProprietaire.addTrace(this.createg());
	};
	// Spécial JavaScript
	
	CPt.prototype.distancePoint = function (xp, yp, masquage) {
	  if (!this.existe || masquage && this.masque) return -1;else {
	    var u = new Vect(this.x, this.y, xp, yp);
	    return u.norme();
	  }
	};
	
	CPt.prototype.afficheNom = function (svg) {
	  if (this.existe && !this.horsEcran) {
	    CElementGraphique.prototype.afficheNom.call(this, svg);
	  }
	};
	/**
	 * Etablit la position du nom du point
	 * @returns {undefined}
	 */
	CPt.prototype.positionneNom = function () {
	  this.placeNom(this.x, this.y);
	};
	
	CPt.prototype.positionne = function (infoRandom, dimfen) {
	  this.horsEcran = !this.testToile();
	  this.dansFenetre = this.testFenetre(dimfen, this.x, this.y); // Ajouté version 4.6.4
	  this.positionneNom();
	};
	/**
	 * Doone au point le motif mot du type MotifPoint
	 * @param {MotifPoint} mot
	 * @returns {undefined}
	 */
	CPt.prototype.donneMotif = function (mot) {
	  this.motif = mot;
	};
	// Attention : deux PlaceEn en java imossible en JavaScipt
	/**
	 * Place le point aux ccordonnées (xn,yn)
	 * @param {Nuber} xn
	 * @param {Number} yn
	 * @returns {undefined}
	 */
	CPt.prototype.placeEn = function (xn, yn) {
	  this.existe = true;
	  this.x = xn;
	  this.y = yn;
	  this.placeNom(xn, yn);
	};
	// A revoir doit pouvoir être supprimé car redéfini pour les points qui peuvent être bougés
	/**
	 * Fonction renvoyant true si le point put être déplacé aux coordonnées (xtest,ytest)
	 * et renvoie dans pointr les coordonnées de la destination finale du point
	 * @param {DimensionFenetre} dimfen
	 * @param {Number} xtest
	 * @param {Number} ytest
	 * @param {Object} pointr
	 * @returns {Boolean}
	 */
	CPt.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr) {
	  pointr.x = xtest;
	  pointr.y = ytest;
	  return this.testFenetre(dimfen, xtest, ytest);
	};
	/**
	 * Fonction renvoyant true si le point est sur droite.
	 * droite peut pointer sur une droite, une demi-droite, un segment ou un vecteur
	 * @param {CDroiteAncetre} droite
	 * @returns {Boolean}
	 */
	CPt.prototype.surDroite = function (droite) {
	  if (!this.existe) return false;
	  var vec = new Vect();
	  vec.x = this.x - droite.point_x;
	  vec.y = this.y - droite.point_y;
	  return kernel.colineaires(droite.vect, vec) && droite.appartientA(this.x, this.y);
	};
	/**
	 * Renvoie true si les coordonnées du point sont les mêmes que celles de pt
	 * @param {CPt} pt
	 * @returns {Boolean}
	 */
	CPt.prototype.egal = function (pt) {
	  return this.x === pt.x && this.y === pt.y;
	};
	/**
	 * Renvoie true si les coordonnées du point sont presque confondues avec celles de a
	 * @param {CPt} a
	 * @returns {boolean}
	 */
	CPt.prototype.presqueEgal = function (a) {
	  return kernel.zero(this.x - a.x) && kernel.zero(this.y - a.y);
	};
	/**
	 * Renvoie true si le point appartient à droite de par sa construction
	 * droite peut pointer sur une droite, demi-droite, segment ou vecteur
	 * @param {CDroiteAncetre} droite
	 * @returns {boolean}
	 */
	CPt.prototype.appartientDroiteParDefinition = function (droite) {
	  return droite.contientParDefinition(this);
	};
	/**
	 * Renvoie true si le point appartient à cercle de par sa construction
	 * cercle peut pointer sur un cercle ou un arc de cercle
	 * @param {CCercle} cercle
	 * @returns {Boolean}
	 */
	CPt.prototype.appartientCercleParDefinition = function (cercle) {
	  return cercle.contientParDefinition(this);
	};
	/**
	 * Renvoie true si le point est un point image par une transformation
	 * @returns {Boolean}
	 */
	CPt.prototype.estPointImage = function () {
	  return false;
	};
	
	CPt.prototype.chaineDesignation = function () {
	  return "designationPoint";
	};
	
	CPt.prototype.read = function (inps, list) {
	  CElementGraphique.prototype.read.call(this, inps, list);
	  this.motif = inps.readByte();
	  this.marquePourTrace = inps.readBoolean();
	};
	
	CPt.prototype.write = function (oups, list) {
	  CElementGraphique.prototype.write.call(this, oups, list);
	  oups.writeByte(this.motif);
	  oups.writeBoolean(this.marquePourTrace);
	};

/***/ },
/* 88 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Définition des motifs de points utilisés.
	 * @type MotifPoint
	 */
	var MotifPoint = {
	  pave: 0,
	  rond: 1,
	  croix: 2,
	  multi: 3,
	  encadre: 4,
	  petitRond: 5,
	  losange: 6,
	  pixel: 7,
	  grandRond: 8,
	  grandMult: 9,
	  quadrillage: 10
	};
	module.exports = MotifPoint;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CPartieReelle = __webpack_require__(90);
	module.exports = CArgument;
	
	/**
	 * Objet calcul donnant comme résultat l'argument principal d'un calcul complexe.
	 * @constructor
	 * @extends CPartieReelle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul
	 * @param {CValDyn} complexeAssocie : Le complexe dont on calcule l'agument.
	 * @returns {CArgument}
	 */
	function CArgument(listeProprietaire, impProto, estElementFinal, nomCalcul, complexeAssocie) {
	  if (arguments.length === 1) CPartieReelle.call(this, listeProprietaire);else CPartieReelle.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, complexeAssocie);
	}
	CArgument.prototype = new CPartieReelle();
	CArgument.prototype.constructor = CArgument;
	CArgument.prototype.superClass = "CPartieReelle";
	CArgument.prototype.className = "CArgument";
	
	CArgument.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.complexeAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CArgument(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CValDyn"));
	};
	CArgument.prototype.getNatureCalcul = function () {
	  return NatCal.NArgument;
	};
	CArgument.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.complexeAssocie.existe;
	  if (!this.existe) return;
	  this.complexeAssocie.rendValeurComplexe(this.z1);
	  this.existe = this.z1.x !== 0 || this.z1.y !== 0;
	  if (this.existe) this.resultat = this.z1.argument(this.listeProprietaire.uniteAngle);
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Complexe = __webpack_require__(30);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CPartieReelle;
	
	/**
	 * Objet calcul donnant comme résultat la partie réelle d'un calcul complexe.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul
	 * @param {CValDyn} complexeAssocie : Le complexe dont on calcule la partie réelle.
	 * @returns {CPartieReelle}
	 */
	function CPartieReelle(listeProprietaire, impProto, estElementFinal, nomCalcul, complexeAssocie) {
	  if (arguments.length === 0) return; // Ajout version WebPack
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.complexeAssocie = complexeAssocie;
	  }
	  this.resultat = 0;
	  this.z1 = new Complexe();
	}
	CPartieReelle.prototype = new CCalculAncetre();
	CPartieReelle.prototype.constructor = CPartieReelle;
	CPartieReelle.prototype.superClass = "CCalculAncetre";
	CPartieReelle.prototype.className = "CPartieReelle";
	
	CPartieReelle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.complexeAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPartieReelle(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CValDyn.class"));
	};
	CPartieReelle.prototype.getNatureCalcul = function () {
	  return NatCal.NPartieReelle;
	};
	CPartieReelle.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.complexeAssocie.dependDe(p));
	};
	CPartieReelle.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.complexeAssocie.dependDePourBoucle(p);
	};
	CPartieReelle.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.complexeAssocie.existe;
	  if (!this.existe) return;
	  this.complexeAssocie.rendValeurComplexe(this.z1);
	  this.resultat = this.z1.x;
	};
	CPartieReelle.prototype.rendValeur = function () {
	  return this.resultat;
	};
	CPartieReelle.prototype.confonduAvec = function (p) {
	  // CPartieReelle pt;
	  if (p.className === this.className) {
	    return this.complexeAssocie === p.complexeAssocie;
	  } else return false;
	};
	CPartieReelle.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.complexeAssocie = list.get(ind1, "CValDyn");
	};
	CPartieReelle.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.complexeAssocie);
	  oups.writeInt(ind1);
	};
	CPartieReelle.prototype.estConstant = function () {
	  return this.complexeAssocie.estConstant();
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Point = __webpack_require__(15);
	var PositionCercleCercle = __webpack_require__(11);
	var kernel = __webpack_require__(8);
	var CPt = __webpack_require__(87);
	
	module.exports = CAutrePointIntersectionCercles;
	
	/**
	 * Classe représentant un deuxième point d'intersection de deux cercles ou arcs de cercle
	 * autre q'un point donné.
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CCercle} c1 : Le premier cercle ou arc de cercle.
	 * @param {CCercle} c2 : Le deuième cercle ou arc de cercle.
	 * @param {CPt} pointExclu : Le point qu'on exclut de l'intersection.
	 * @returns {CAutrePointIntersectionCercles}
	 */
	function CAutrePointIntersectionCercles(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, c1, c2, pointExclu) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.c1 = c1;
	    this.c2 = c2;
	    this.pointExclu = pointExclu;
	  }
	  this.pointInt1 = new Point();
	  this.pointInt2 = new Point();
	}
	CAutrePointIntersectionCercles.prototype = new CPt();
	CAutrePointIntersectionCercles.prototype.constructor = CAutrePointIntersectionCercles;
	CAutrePointIntersectionCercles.prototype.superClass = "CPt";
	CAutrePointIntersectionCercles.prototype.className = "CAutrePointIntersectionCercles";
	
	CAutrePointIntersectionCercles.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.c1);
	  var ind2 = listeSource.indexOf(this.c2);
	  var ind3 = listeSource.indexOf(this.pointExclu);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CAutrePointIntersectionCercles(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CCercle"), listeCible.get(ind2, "CCercle"), listeCible.get(ind3, "CPt"));
	};
	CAutrePointIntersectionCercles.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.c1.dependDe(p) || this.c2.dependDe(p) || this.pointExclu.dependDe(p));
	};
	CAutrePointIntersectionCercles.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.c1.dependDePourBoucle(p) || this.c2.dependDePourBoucle(p) || this.pointExclu.dependDePourBoucle(p);
	};
	CAutrePointIntersectionCercles.prototype.positionne = function (infoRandom, dimfen) {
	  var position, x1, y1, x2, y2;
	  var point1Defini = false;
	  var point2Defini = false;
	  this.existe = this.c1.existe && this.c2.existe;
	  if (!this.existe) return;
	  position = kernel.intersectionCercleCercle(this.c1.centre_x, this.c1.centre_y, this.c1.rayon, this.c2.centre_x, this.c2.centre_y, this.c2.rayon, this.pointInt1, this.pointInt2);
	  x1 = this.pointInt1.x;
	  y1 = this.pointInt1.y;
	  x2 = this.pointInt2.x;
	  y2 = this.pointInt2.y;
	  switch (position) {
	    case PositionCercleCercle.Vide:
	    case PositionCercleCercle.Confondus:
	      this.existe = false;
	      break;
	    case PositionCercleCercle.Secants:
	      point1Defini = this.c1.surArc(x1, y1) && this.c2.surArc(x1, y1);
	      point2Defini = this.c1.surArc(x2, y2) && this.c2.surArc(x2, y2);
	      break;
	    case PositionCercleCercle.Tangents:
	      if (this.c1.surArc(x1, y1) && this.c2.surArc(x1, y1)) {
	        this.existe = true;
	        CPt.prototype.placeEn.call(this, x1, y1);
	        CPt.prototype.positionne.call(this, infoRandom, dimfen);
	        return;
	      } else {
	        this.existe = false;
	        return;
	      }
	  }
	  // On ne peut arriver ici que si les deux cercles sont sécants}
	  if (!point1Defini && !point2Defini) {
	    this.existe = false;
	    return;
	  }
	  if (point1Defini && !point2Defini) {
	    if (kernel.distancePointPoint(x1, y1, this.pointExclu.x, this.pointExclu.y) < 0.0001) {
	      this.existe = false;
	      return;
	    } else {
	      CPt.prototype.placeEn.call(this, x1, y1);
	      CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	      return;
	    }
	  }
	  if (point2Defini && !point1Defini) {
	    if (kernel.distancePointPoint(x2, y2, this.pointExclu.x, this.pointExclu.y) < 0.0001) {
	      this.existe = false;
	      return;
	    } else {
	      CPt.prototype.placeEn.call(this, x2, y2);
	      CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	      return;
	    }
	  }
	  if (kernel.zero(kernel.distancePointPoint(x1, y1, this.pointExclu.x, this.pointExclu.y))) CPt.prototype.placeEn.call(this, x2, y2);else CPt.prototype.placeEn.call(this, x1, y1);
	  CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	};
	CAutrePointIntersectionCercles.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.pointExclu === p.pointExclu && (this.c1 === p.c1 && this.c2 === p.c2 || this.c1 === p.c2 && this.c2 === p.c1);
	  } else return false;
	};
	CAutrePointIntersectionCercles.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointExclu === ancienPoint) this.pointExclu = nouveauPoint;
	};
	CAutrePointIntersectionCercles.prototype.appartientCercleParDefinition = function (cercle) {
	  return CPt.prototype.appartientCercleParDefinition.call(this, cercle) || cercle === this.c1 || cercle === this.c2;
	};
	CAutrePointIntersectionCercles.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.c1 = list.get(ind1, "CCercle");
	  this.c2 = list.get(ind2, "CCercle");
	  this.pointExclu = list.get(ind3, "CPt");
	};
	CAutrePointIntersectionCercles.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.c1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.c2);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.pointExclu);
	  oups.writeInt(ind3);
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Point = __webpack_require__(15);
	var PositionDroiteCercle = __webpack_require__(9);
	var kernel = __webpack_require__(8);
	var CPt = __webpack_require__(87);
	
	module.exports = CAutrePointIntersectionDroiteCercle;
	
	/**
	 * Classe représentant un deuxième point d'intersection d'une droite (ou demi-droie ou segment)
	 * avec un cercle (ou arc de cercle).
	 * autre q'un point donné.
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CCercle} c : Le cercle ou arc de cercle
	 * @param {CDroiteAncetre} d : La droite ou demi-droite ou segment
	 * @param {type} pointExclu : Le point exclu de ll'intersection
	 * @returns {CAutrePointIntersectionDroiteCercle}
	 */
	function CAutrePointIntersectionDroiteCercle(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, c, d, pointExclu) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.c = c;
	    this.d = d;
	    this.pointExclu = pointExclu;
	  }
	  this.pointInt1 = new Point();
	  this.pointInt2 = new Point();
	}
	CAutrePointIntersectionDroiteCercle.prototype = new CPt();
	CAutrePointIntersectionDroiteCercle.prototype.constructor = CAutrePointIntersectionDroiteCercle; // Corrigé new
	CAutrePointIntersectionDroiteCercle.prototype.superClass = "CPt";
	CAutrePointIntersectionDroiteCercle.prototype.className = "CAutrePointIntersectionCercles";
	
	CAutrePointIntersectionDroiteCercle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.c);
	  var ind2 = listeSource.indexOf(this.d);
	  var ind3 = listeSource.indexOf(this.pointExclu);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CAutrePointIntersectionDroiteCercle(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CCercle"), listeCible.get(ind2, "CDroiteAncetre"), listeCible.get(ind3, "CPt"));
	};
	CAutrePointIntersectionDroiteCercle.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.c.dependDe(p) || this.d.dependDe(p) || this.pointExclu.dependDe(p));
	};
	CAutrePointIntersectionDroiteCercle.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.c.dependDePourBoucle(p) || this.d.dependDePourBoucle(p) || this.pointExclu.dependDePourBoucle(p);
	};
	CAutrePointIntersectionDroiteCercle.prototype.positionne = function (infoRandom, dimfen) {
	  var position, x1, y1, x2, y2;
	  var point1Defini = false;
	  var point2Defini = false;
	
	  this.existe = this.c.existe && this.d.existe;
	  if (!this.existe) return;
	  position = kernel.intersectionDroiteCercle(this.d.point_x, this.d.point_y, this.d.vect, this.c.centre_x, this.c.centre_y, this.c.rayon, this.pointInt1, this.pointInt2);
	  x1 = this.pointInt1.x;
	  y1 = this.pointInt1.y;
	  x2 = this.pointInt2.x;
	  y2 = this.pointInt2.y;
	  switch (position) {
	    case PositionDroiteCercle.Vide:
	      this.existe = false;
	      return;
	    case PositionDroiteCercle.Secants:
	      point1Defini = this.c.surArc(x1, y1) && this.d.appartientA(x1, y1);
	      point2Defini = this.c.surArc(x2, y2) && this.d.appartientA(x2, y2);
	      break;
	    case PositionDroiteCercle.Tangents:
	      if (this.c.surArc(x1, y1) && this.d.appartientA(x1, y1)) {
	        this.existe = true;
	        CPt.prototype.placeEn.call(this, x1, y1);
	        CPt.prototype.positionne.call(this, infoRandom, dimfen);
	        return;
	      } else {
	        this.existe = false;
	        return;
	      }
	  }
	  // On ne peut arriver ici que si la droite et le cercle sont sécants
	  if (!point1Defini && !point2Defini) {
	    this.existe = false;
	    return;
	  }
	  if (point1Defini && !point2Defini) {
	    if (kernel.distancePointPoint(x1, y1, this.pointExclu.x, this.pointExclu.y) < 0.0001) {
	      this.existe = false;
	      return;
	    } else {
	      CPt.prototype.placeEn.call(this, x1, y1);
	      CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	      return;
	    }
	  }
	  if (point2Defini && !point1Defini) {
	    if (kernel.distancePointPoint(x2, y2, this.pointExclu.x, this.pointExclu.y) < 0.0001) {
	      this.existe = false;
	      return;
	    } else {
	      CPt.prototype.placeEn.call(this, x2, y2);
	      CPt.prototype.positionne.call(this, infoRandom, dimfen);
	      return;
	    }
	  }
	  // Les 2 points sont forcéments définis
	  if (kernel.zero(kernel.distancePointPoint(x1, y1, this.pointExclu.x, this.pointExclu.y))) CPt.prototype.placeEn.call(this, x2, y2);else CPt.prototype.placeEn.call(this, x1, y1);
	  CPt.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CAutrePointIntersectionDroiteCercle.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.c);
	  liste.add(this.d);
	};
	CAutrePointIntersectionDroiteCercle.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.c === p.c && this.d === p.d && this.pointExclu === p.pointExclu;
	  } else return false;
	};
	CAutrePointIntersectionDroiteCercle.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointExclu === ancienPoint) this.pointExclu = nouveauPoint;
	};
	CAutrePointIntersectionDroiteCercle.prototype.appartientDroiteParDefinition = function (droite) {
	  return CPt.appartientDroiteParDefinition.call(this, droite) || droite === this.d;
	};
	CAutrePointIntersectionDroiteCercle.prototype.appartientCercleParDefinition = function (cercle) {
	  return CPt.appartientCercleParDefinition.call(this, cercle) || cercle === this.c;
	};
	
	CAutrePointIntersectionDroiteCercle.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.c = list.get(ind1, "CCercle");
	  this.d = list.get(ind2, "CDroiteAB");
	  this.pointExclu = list.get(ind3, "CPt");
	};
	CAutrePointIntersectionDroiteCercle.prototype.write = function (oups, list) {
	  CPt.protoype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.c);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.d);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.pointExclu);
	  oups.writeInt(ind3);
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CPt = __webpack_require__(87);
	var CNoeudPondere = __webpack_require__(94);
	
	module.exports = CBarycentre;
	
	/**
	 * Classe représentant un barycentre de n points pondérés.
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Array} col : Array de CNoeudPondere contenant les points et leurs coefficients.
	 * @returns {CBarycentre}
	 */
	function CBarycentre(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, col) {
	  if (arguments.length === 1) {
	    CPt.call(this, listeProprietaire);
	    this.col = [];
	  } else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.col = col;
	  }
	}
	CBarycentre.prototype = new CPt();
	CBarycentre.prototype.constructor = CBarycentre;
	CBarycentre.prototype.superClass = "CPt";
	CBarycentre.prototype.className = "CBarycentre";
	
	CBarycentre.prototype.getClone = function (listeSource, listeCible) {
	  var colClone = [];
	  for (var i = 0; i < this.col.length; i++) {
	    var noeud = this.col[i];
	    var noeudClone = noeud.getClone(listeSource, listeCible);
	    colClone.push(noeudClone);
	  }
	  var ind1 = listeSource.indexOf(this.impProto);
	  return new CBarycentre(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, colClone);
	};
	CBarycentre.prototype.ajouteAntecedents = function (liste) {
	  // Pour chacun des points pondérés, on créé un commentaire associé qui affichera le coefficient
	  // Tous ces commentaires seront rajoutés à la liste des objets clignotants
	  var nbPoints = this.col.length;
	  for (var i = 0; i < nbPoints; i++) {
	    var noeud = this.col[i];
	    var point = noeud.pointAssocie;
	    liste.add(point);
	    /** A revoir JavaScript
	    var com = new CCommentaire(listeProprietaire, null, false, mtg32.Color.blue, 0, 0, 0, 10, false, point, 2,
	        mtg32.StyleEncadrement.Simple, true,  new mtg32.Color(230,230,246), noeud.poids.chaineInfo(),
	        CAffichageLieAPoint.alignementHorizontalCentre, CAffichageLieAPoint.alignementVerticalHaut);
	    com.positionne(false, frame.cadreActif().dimf);
	    liste.add(com);
	    */
	  }
	};
	CBarycentre.prototype.initialisePourDependance = function () {
	  CPt.prototype.initialisePourDependance.call(this);
	  for (var i = 0; i < this.col.length; i++) {
	    var noeud = this.col[i];
	    noeud.initialisePourDependance();
	  }
	};
	
	CBarycentre.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  var resultat = false;
	  for (var i = 0; i < this.col.length && !resultat; i++) {
	    var noeud = this.col[i];
	    resultat = resultat || noeud.pointAssocie.dependDe(p) || noeud.poids.dependDe(p);
	  }
	  return this.memoriseDependance(resultat || CPt.prototype.dependDe.call(this, p));
	};
	CBarycentre.prototype.dependDePourBoucle = function (p) {
	  var resultat = false;
	  for (var i = 0; i < this.col.length && !resultat; i++) {
	    var noeud = this.col[i];
	    resultat = resultat || noeud.pointAssocie.dependDePourBoucle(p) || noeud.poids.dependDePourBoucle(p);
	  }
	  return p === this || resultat;
	};
	CBarycentre.prototype.positionne = function (infoRandom, dimfen) {
	  var mt, xg, yg;
	
	  this.existe = true;
	  mt = 0;
	  xg = 0;
	  yg = 0;
	  for (var i = 0; i < this.col.length; i++) {
	    var noeud = this.col[i];
	    noeud.poids.positionne(infoRandom, dimfen);
	    this.existe = this.existe && noeud.pointAssocie.existe && noeud.poids.existe;
	    if (!this.existe) return;
	    var p = noeud.poids.rendValeur();
	    mt = mt + p;
	    xg = xg + p * noeud.pointAssocie.x;
	    yg = yg + p * noeud.pointAssocie.y;
	  }
	  if (mt === 0) this.existe = false;else {
	    xg = xg / mt;
	    yg = yg / mt;
	    CPt.prototype.placeEn.call(this, xg, yg);
	    CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajouté verion 4.6.4
	  }
	};
	CBarycentre.prototype.confonduAvec = function (p) {
	  var i, j, nbElementsCommuns, no1, no2;
	  if (p.className === this.className) {
	    if (this.col.length !== p.col.length) return false;else {
	      nbElementsCommuns = 0;
	      // On crée une copie de col
	      var colClone = [];
	      for (i = 0; i < this.col.length; i++) {
	        var noeud = this.col[i];
	        var noeudClone = noeud.getClone(this.listeProprietaire, this.listeProprietaire);
	        colClone.add(noeudClone);
	      }
	      for (i = 0; i < p.col.length; i++) {
	        no1 = p.col[i];
	        for (j = 0; j < colClone.length; j++) {
	          no2 = colClone[j];
	          if (no2.pointAssocie === no1.pointAssocie && no2.poids.confonduAvec(no1.poids)) {
	            nbElementsCommuns++;
	            colClone.splice(j, 1);
	          }
	        }
	      }
	      return nbElementsCommuns === this.col.length;
	    }
	  } else return false;
	};
	CBarycentre.prototype.getNature = function () {
	  return NatObj.NBarycentre;
	};
	CBarycentre.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  for (var i = 0; i < this.col.length; i++) {
	    var noeud = new CNoeudPondere();
	    noeud.remplacePoint(ancienPoint, nouveauPoint);
	  }
	};
	CBarycentre.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  // On lit d'abord le nombre d'objets de la liste
	  var nombreObjets = inps.readInt();
	  for (var i = 0; i < nombreObjets; i++) {
	    var noeud = new CNoeudPondere();
	    noeud.read(inps, list);
	    this.col.push(noeud);
	  }
	};
	CBarycentre.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var nombreObjets = this.col.length;
	  oups.writeInt(nombreObjets);
	  for (var i = 0; i < this.col.length; i++) {
	    var noeud = this.col[i];
	    noeud.write(oups, list);
	  }
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var COb = __webpack_require__(34);
	var CValeur = __webpack_require__(80);
	module.exports = CNoeudPondere;
	
	/**
	 * Classe utilisée pour définir les points pondérés dans les barycentres.
	 * @constructor
	 * @extends COb
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CPt} pointAssocie : Le point.
	 * @param {CValeur} poids : Le coefficient du point pondéré.
	 * @returns {CNoeudPondere}
	 */
	function CNoeudPondere(listeProprietaire, pointAssocie, poids) {
	  if (arguments.length === 1) COb.call(this, listeProprietaire);else {
	    COb.call(this, listeProprietaire);
	    this.pointAssocie = pointAssocie;
	    this.poids = poids;
	  }
	}
	CNoeudPondere.prototype = new COb();
	CNoeudPondere.prototype.constructor = CNoeudPondere;
	CNoeudPondere.prototype.superClass = "COb";
	CNoeudPondere.prototype.className = "CNoeudPondere";
	
	CNoeudPondere.prototype.getClone = function (listeSource, listeCible) {
	  var poidsClone = this.poids.getClone(listeSource, listeCible);
	  var ind1 = listeSource.indexOf(this.pointAssocie);
	  return new CNoeudPondere(listeCible, listeCible.get(ind1, "CPt"), poidsClone);
	};
	CNoeudPondere.prototype.positionne = function (infoRandom, dimfen) {
	  this.poids.positionne(infoRandom, dimfen);
	  this.existe = this.poids.existe;
	};
	CNoeudPondere.prototype.initialisePourDependance = function () {
	  this.poids.initialisePourDependance();
	};
	CNoeudPondere.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointAssocie === ancienPoint) this.pointAssocie = nouveauPoint;
	};
	CNoeudPondere.prototype.read = function (inps, list) {
	  COb.prototype.read.call(this, inps, list);
	  this.poids = new CValeur();
	  this.poids.read(inps, list);
	  var ind1 = inps.readInt();
	  this.pointAssocie = list.get(ind1, "CPt");
	};
	CNoeudPondere.prototype.write = function (oups, list) {
	  COb.prototype.write.call(this, oups, list);
	  this.poids.write(oups, list);
	  var ind1 = list.indexOf(this.pointAssocie);
	  oups.writeInt(ind1);
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CElementBase = __webpack_require__(33);
	var CPointDansBipoint = __webpack_require__(96);
	
	module.exports = CBipoint;
	
	/**
	 * Classe représentant un couple de points utilisée pour les intersections
	 * droite-cercle ou cercle-cercle.
	 * @constructor
	 * @extends CElementBase
	 * @param {type} listeProprietaire
	 * @param {type} impProto
	 * @param {type} estElementFinal
	 * @returns {CBipoint}
	 */
	function CBipoint(listeProprietaire, impProto, estElementFinal) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CElementBase.call(this, listeProprietaire);else {
	    CElementBase.call(this, listeProprietaire, impProto, estElementFinal);
	  }
	  this.point1 = new CPointDansBipoint();
	  this.point2 = new CPointDansBipoint();
	}
	CBipoint.prototype = new CElementBase();
	CBipoint.prototype.constructor = CBipoint;
	CBipoint.prototype.superClass = "CElementBase";
	CBipoint.prototype.className = "CBipoint";
	
	CBipoint.prototype.getNature = function () {
	  return NatObj.NBipoint;
	};
	CBipoint.prototype.setClone = function (ptel) {
	  CElementBase.prototype.setClone.call(this, ptel);
	  ptel.point1.existe = this.point1.existe;
	  ptel.point1.x = this.point1.x;
	  ptel.point1.y = this.point1.y;
	  ptel.point2.existe = this.point2.existe;
	  ptel.point2.x = this.point2.x;
	  ptel.point2.y = this.point2.y;
	};
	CBipoint.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.point1.existe || this.point2.existe;
	};
	/**
	 * Fonction qui renvoie un des deux éléments dont il représente l'intersection.
	 * @param {Integer} indice : L'indice de l'élément (0 ou 1)
	 * @returns {unresolved}
	 */
	CBipoint.prototype.elementAssocie = function (indice) {
	  return null;
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Color = __webpack_require__(6);
	var MotifPoint = __webpack_require__(88);
	var CPt = __webpack_require__(87);
	module.exports = CPointDansBipoint;
	
	/**
	 * Classe représentant un poitn dans un bipoint c'est-à-dire un point
	 * dans une intersection de deux cercles ou d'un cercle et une droite
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @returns {undefined}
	 */
	function CPointDansBipoint(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace) {
	  if (arguments.length === 0) {
	    CPt.call(this, null, null, false, new Color(0, 0, 0), false, 0, 0, false, "", 2, MotifPoint.petitRond, false);
	  } else {
	    if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	      CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    }
	  }
	}
	CPointDansBipoint.prototype = new CPt();
	CPointDansBipoint.prototype.constructor = CPointDansBipoint;
	CPointDansBipoint.prototype.superClass = "CPt";
	CPointDansBipoint.prototype.className = "CPointDansBipoint";
	
	CPointDansBipoint.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  return new CPointDansBipoint(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace);
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CDroite = __webpack_require__(98);
	
	module.exports = CBissectrice;
	
	/**
	 * Classe bissectrice donnée par les trois sommes de l'angle.
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {CPt} b : Le premier point de l'angle.
	 * @param {CPt} a : Le sommet de l'angle.
	 * @param {CPt} c : Le troisième point de l'angle.
	 * @returns {CBissectrice}
	 */
	function CBissectrice(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, b, a, c) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.b = b;
	    this.a = a;
	    this.c = c;
	  }
	  this.longueurVecteurDirecteur = 0.1;
	}
	CBissectrice.prototype = new CDroite();
	CBissectrice.prototype.constructor = CBissectrice;
	CBissectrice.prototype.superClass = "CDroite";
	CBissectrice.prototype.className = "CBissectrice";
	
	CBissectrice.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.b);
	  var ind2 = listeSource.indexOf(this.a);
	  var ind3 = listeSource.indexOf(this.c);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CBissectrice(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CPt.class"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"));
	};
	CBissectrice.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.b);
	  liste.add(this.a);
	  liste.add(this.c);
	};
	CBissectrice.prototype.positionne = function (infoRandom, dimfen) {
	  var u = new Vect();
	  var v = new Vect();
	  var u1 = new Vect();
	  var v1 = new Vect();
	
	  this.existe = this.a.existe && this.b.existe && this.c.existe && !this.a.egal(this.b) && !this.a.egal(this.c);
	  if (!this.existe) return;
	  this.point_x = this.a.x;
	  this.point_y = this.a.y;
	  u.setVecteur(this.a, this.b);
	  v.setVecteur(this.a, this.c);
	  // Correction d'un bug figurant jusque dans la version 2.5 du C++
	  if (kernel.zeroAngle(Math.abs(u.mesureAngleVecteurs(v)) - Math.PI)) {
	    u.tourne(Math.PI / 2, v);
	    v.vecteurColineaire(this.longueurVecteurDirecteur, this.vect);
	  } else {
	    u.vecteurColineaire(1, u1);
	    v.vecteurColineaire(1, v1);
	    var w = new Vect();
	    w.x = u1.x + v1.x;
	    w.y = u1.y + v1.y;
	    w.vecteurColineaire(this.longueurVecteurDirecteur, this.vect);
	  }
	  CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CBissectrice.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.b === p.b && this.a === p.a && this.c === p.c || this.b === p.c && this.a === p.a && this.c === p.b;
	  } else return false;
	};
	CBissectrice.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.b.dependDe(p) || this.a.dependDe(p) || this.c.dependDe(p));
	};
	CBissectrice.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.b.dependDePourBoucle(p) || this.a.dependDePourBoucle(p) || this.c.dependDePourBoucle(p);
	};
	CBissectrice.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	  if (this.b === ancienPoint) this.b = nouveauPoint;
	  if (this.c === ancienPoint) this.c = nouveauPoint;
	};
	CBissectrice.prototype.contientParDefinition = function (po) {
	  return this.a === po;
	};
	CBissectrice.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.b = list.get(ind1, "CPt");
	  this.a = list.get(ind2, "CPt");
	  this.c = list.get(ind3, "CPt");
	};
	CBissectrice.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.b);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.a);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.c);
	  oups.writeInt(ind3);
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDroiteAncetre = __webpack_require__(99);
	module.exports = CDroite;
	
	/**
	 * Classe ancêtre de toutes les droites.
	 * @constructor
	 * @extends CDroiteAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @returns {CDroite}
	 */
	function CDroite(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom) {
	  if (arguments.length === 0) return;
	  if (arguments.length === 1) CDroiteAncetre.call(this, listeProprietaire);else {
	    CDroiteAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style);
	    this.abscisseNom = abscisseNom;
	  }
	}
	CDroite.prototype = new CDroiteAncetre();
	CDroite.prototype.constructor = CDroite;
	CDroite.prototype.superClass = "CDroiteAncetre";
	CDroite.prototype.className = "CDroite";
	
	CDroite.abscisseNomParDefaut = 0.95;
	
	CDroite.prototype.positionneNom = function () {
	  this.placeNom(this.xext1 + this.abscisseNom * (this.xext2 - this.xext1), this.yext1 + this.abscisseNom * (this.yext2 - this.yext1));
	};
	
	CDroite.prototype.chaineDesignation = function () {
	  return "desDroite";
	};
	
	CDroite.prototype.read = function (inps, list) {
	  CDroiteAncetre.prototype.read.call(this, inps, list);
	  // Version 4.7.6.1 : Si le nom est vide on n'enregistre pas abscisseNom
	  if (this.listeProprietaire.numeroVersion < 11) this.abscisseNom = inps.readDouble();else {
	    if (this.nom.length === 0) this.abscisseNom = CDroite.abscisseNomParDefaut;else this.abscisseNom = inps.readDouble();
	  }
	};
	
	CDroite.prototype.write = function (oups, list) {
	  CDroiteAncetre.prototype.write.call(this, oups, list);
	  if (this.nom.length !== 0) oups.writeDouble(this.abscisseNom);
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Point = __webpack_require__(15);
	var PositionDroiteCercle = __webpack_require__(9);
	var PositionDroites = __webpack_require__(10);
	var PositionRelative = __webpack_require__(76);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CElementLigne = __webpack_require__(77);
	var CTransformation = __webpack_require__(100);
	module.exports = CDroiteAncetre;
	
	/**
	 * Classe ancêtre de toutes les objets de type segment, droite, demi-droite.
	 * @constructor
	 * @extends CElementGraphique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé
	 * @returns {CDroiteAncetre}
	 */
	// Modifié version mtgApp
	function CDroiteAncetre(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	      CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style);
	    }
	    this.vect = new Vect();
	    this.pointr = new Point();
	  }
	}
	CDroiteAncetre.prototype = new CElementLigne();
	CDroiteAncetre.prototype.constructor = CDroiteAncetre;
	CDroiteAncetre.prototype.superClass = "CElementLigne";
	CDroiteAncetre.prototype.className = "CDroiteAncetre";
	
	CDroiteAncetre.prototype.setClone = function (ptel) {
	  CElementLigne.prototype.setClone.call(this, ptel);
	  this.xext1 = ptel.xext1;
	  this.yext1 = ptel.yext1;
	  this.xext2 = ptel.xext2;
	  this.yext2 = ptel.yext2;
	  this.point_x = ptel.point_x;
	  this.point_y = ptel.point_y;
	  ptel.vect.setCopy(this.vect);
	  // Ajout version 3.1.8
	  this.horsFenetre = ptel.horsFenetre;
	};
	
	/**
	 * Ajout version 5.2 (numéro de version 16). Renverra true si l'objet possède un nom qui doit être enregistré dans le flux
	 * @returns {boolean}
	 */
	CDroiteAncetre.prototype.hasName = function () {
	  return true;
	};
	
	CDroiteAncetre.prototype.appartientA = function (x, y) {
	  return this.existe;
	};
	/**
	 * Fonction fournissant la position relative de la droite this par rapport à elg
	 * @param {type} elg
	 * @param {mtg32.Pointeur} bperpendiculaires : renvoie par getValue true si les droites
	 * sont perpendiculaires.
	 * @returns {PositionRelative}
	 */
	CDroiteAncetre.prototype.positionRelative = function (elg, bperpendiculaires) {
	  bperpendiculaires.setValue(false);
	  if (elg.estDeNature(NatObj.NTtPoint)) {
	    var vec = new Vect(elg.x, elg.y, this.point_x, this.point_y);
	    if (kernel.colineaires(this.vect, vec) && this.appartientA(elg.x, elg.y)) return PositionRelative.appartient;else return PositionRelative.nappartient;
	  } else {
	    if (elg.estDeNature(NatObj.NTteDroite)) {
	      // On regarde d'abord si les droites sont perpendiculaires
	      if (kernel.zero(this.vect.x * elg.vect.x + this.vect.y * elg.vect.y)) bperpendiculaires.setValue(true);
	      var pointInt = {};
	      var positionDroites = kernel.intersection(this.point_x, this.point_y, this.vect, elg.point_x, elg.point_y, elg.vect, pointInt);
	      switch (positionDroites) {
	        case PositionDroites.Confondues:
	          if (getNature() === NatObj.NDroite && elg.getNature() === NatObj.NDroite) return PositionRelative.confondus;else return PositionRelative.memeSupportDroite;
	        case PositionDroites.Secantes:
	          if (appartientA(pointInt.x, pointInt.y) && elg.appartientA(pointInt.x, pointInt.y)) return PositionRelative.secants;else return PositionRelative.vide;
	        case PositionDroites.Paralleles:
	          return PositionRelative.paralleles;
	        default:
	          return PositionRelative.vide; // Pour satisfaire le compilateur
	      }
	    } else {
	      if (elg.estDeNature(NatObj.NTtCercle)) {
	        // Cas d'un cercle ou un arc de cercle
	        var point1 = {};
	        var point2 = {};
	        var positionDroiteCercle = kernel.intersectionDroiteCercle(this.point_x, this.point_y, this.vect, elg.centre_x, elg.centre_y, elg.rayon, point1, point2);
	        switch (positionDroiteCercle) {
	          case PositionDroiteCercle.Vide:
	            return PositionRelative.vide;
	          case PositionDroiteCercle.Secants:
	            {
	              var b1 = this.appartientA(point1.x, point1.y) && elg.surArc(point1.x, point1.y);
	              var b2 = appartientA(point2.x, point2.y) && elg.surArc(point2.x, point2.y);
	              if (b1 && b2) return PositionRelative.secants2Point;
	              if (b1 || b2) return PositionRelative.secants1Point;
	              return PositionRelative.vide;
	            }
	          case PositionDroiteCercle.Tangents:
	            {
	              b1 = this.appartientA(point1.x, point1.y) && elg.surArc(point1.x, point1.y);
	              if (b1) return PositionRelative.tangents;else return PositionRelative.vide;
	            }
	          default:
	            return PositionRelative.vide; // Pour satisfaire le compilateur
	        }
	      } else return PositionRelative.vide; // Pour satisfaire le compilateur
	    }
	  }
	};
	/**
	 * Fonction recalculant la droite.
	 * A la sortie :
	 * this.horsFenetre est true si la droite n'est pas visible dans dimfen
	 * (this.xext1,this.yext1) et (this.xext2,this.yext2) contiennent les coordonnées
	 * des deux points effectifs à tracer pour avoir sur la figure la repésentation
	 * graphique de la droite.
	 * @param {Boolean} infoRandom : Pas utilisé ici.
	 * @param {CDimensionFenetre} dimfen : Dimensions du svg contenant la figure.
	 * @returns {undefined}
	 */
	CDroiteAncetre.prototype.positionne = function (infoRandom, dimfen) {
	  var a, xa, ya, xb, yb, xc, yc, xd, yd;
	  this.existe = !this.vect.nul();
	  if (!this.existe) return;
	  this.horsFenetre = false;
	  if (this.vect.x === 0) {
	    if (this.point_x < 0 || this.point_x > dimfen.x) {
	      this.horsFenetre = true;
	      return;
	    }
	    this.xext1 = this.point_x;
	    this.yext1 = 0;
	    this.xext2 = this.point_x;
	    this.yext2 = dimfen.y;
	    this.positionneNom();
	    return;
	  }
	  if (this.vect.y === 0) {
	    if (this.point_y < 0 || this.point_y > dimfen.y) {
	      this.horsFenetre = true;
	      return;
	    }
	    this.xext1 = 0;
	    this.yext1 = this.point_y;
	    this.xext2 = dimfen.x;
	    this.yext2 = this.point_y;
	    this.positionneNom();
	    return;
	  }
	  var indicePoint = 0;
	  a = this.vect.y / this.vect.x;
	  xa = 0;
	  ya = this.point_y + a * (xa - this.point_x);
	  if (ya >= 0 && ya <= dimfen.y) {
	    indicePoint++;
	    this.xext1 = xa;
	    this.yext1 = ya;
	  }
	  xb = dimfen.x;
	  yb = a * (xb - this.point_x) + this.point_y;
	  if (yb >= 0 && yb <= dimfen.y) {
	    indicePoint++;
	    if (indicePoint === 1) {
	      this.xext1 = xb;
	      this.yext1 = yb;
	    } else {
	      this.xext2 = xb;
	      this.yext2 = yb;
	      this.positionneNom();
	      return;
	    }
	  }
	  yc = 0;
	  xc = (yc - this.point_y) / a + this.point_x;
	  if (xc > 0 && xc < dimfen.x) {
	    indicePoint++;
	    if (indicePoint === 1) {
	      this.xext1 = xc;
	      this.yext1 = yc;
	    } else {
	      this.xext2 = xc;
	      this.yext2 = yc;
	      this.positionneNom();
	      return;
	    }
	  }
	  yd = dimfen.y;
	  xd = (yd - this.point_y) / a + this.point_x;
	  if (xd > 0 && xd <= dimfen.x) {
	    indicePoint++;
	    if (indicePoint === 2) {
	      this.xext2 = xd;
	      this.yext2 = yd;
	      this.positionneNom();
	    } else {
	      this.horsFenetre = true;
	    }
	  }
	  // Ligne suivante corrigée version 4.1
	  else this.horsFenetre = true;
	  if (this.horsFenetre) {
	    this.xext1 = 0;
	    this.yext1 = ya;
	    this.xext2 = xb;
	    this.yext2 = yb;
	  }
	};
	
	CDroiteAncetre.prototype.createg = function () {
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  // style += "stroke:"+this.couleur.rgb()+";"; Modifié verion 4.9.9.4
	  style += "stroke:" + this.color + ";";
	  return kernel.cens("line", {
	    x1: this.xext1,
	    y1: this.yext1,
	    x2: this.xext2,
	    y2: this.yext2,
	    style: style,
	    "pointer-events": "none"
	  });
	};
	
	CDroiteAncetre.prototype.hasg = function (masquage, memeMasque) {
	  return this.existe && !this.horsFenetre && !(this.masque && masquage);
	};
	CDroiteAncetre.prototype.horsCadre = function () {
	  return this.horsFenetre;
	};
	CDroiteAncetre.prototype.trace = function (svg) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	
	CDroiteAncetre.prototype.update = function (svg) {
	  var g = this.g;
	  g.removeAttribute("x1");
	  g.removeAttribute("y1");
	  g.removeAttribute("x2");
	  g.removeAttribute("y2");
	  g.setAttribute("x1", this.xext1);
	  g.setAttribute("y1", this.yext1);
	  g.setAttribute("x2", this.xext2);
	  g.setAttribute("y2", this.yext2);
	};
	
	CDroiteAncetre.prototype.abscisseMinimale = function () {
	  if (this.vect.x === 0 && this.vect.y === 0) return 0;
	  if (Math.abs(this.vect.x) >= Math.abs(this.vect.y)) return (this.xext1 - this.point_x) / this.vect.x;else return (this.yext1 - this.point_y) / this.vect.y;
	};
	
	CDroiteAncetre.prototype.abscisseMaximale = function () {
	  if (this.vect.x === 0 && this.vect.y === 0) return 0;
	  if (Math.abs(this.vect.x) >= Math.abs(this.vect.y)) return (this.xext2 - this.point_x) / this.vect.x;else return (this.yext2 - this.point_y) / this.vect.y;
	};
	
	CDroiteAncetre.prototype.dansFen = function (dimfen) {
	  return !this.horsFenetre;
	};
	
	CDroiteAncetre.prototype.getNature = function () {
	  return NatObj.NDroite;
	};
	/**
	 * Foction renvoyant true si la droite contient par définition le point po,
	 * par exemple pour une droite CDroiteAB si a = po ou b = po;
	 * A redfinir pour les descendants.
	 * @param {CPt} po
	 * @returns {Boolean}
	 */
	CDroiteAncetre.prototype.contientParDefinition = function (po) {
	  return false;
	};
	/**
	 * Fonction renvoyant true si la droite est parallèle par définition à dte
	 * @param {CDroiteAncetre} dte
	 * @returns {Boolean}
	 */
	CDroiteAncetre.prototype.estParalleleParDefinition = function (dte) {
	  return dte === this;
	};
	/**
	 * Fonction renvoyant true si la droite est perpendiculaire par définition à dte
	 * @param {CDroiteAncetre} dte
	 * @returns {Boolean}
	 */
	CDroiteAncetre.prototype.estPerpendiculaireParDefinition = function (dte) {
	  return false;
	};
	/**
	 * Fonction renvoyant true si les deux points pt1 et pt2 forment une droite dont
	 * on sait que par définition qu'elle est parallèle à this.
	 * @param {CPt} pt1
	 * @param {CPt} pt2
	 * @returns {Boolean}
	 */
	CDroiteAncetre.prototype.formentDroiteParallele = function (pt1, pt2) {
	  var trans;
	  if (pt1.estPointImage() && pt2.estPointImage()) {
	    if (pt1.transformation === pt2.transformation && (pt1.transformation.natureTransformation() & (CTransformation.translation | CTransformation.homothetie | CTransformation.symetrieCentrale)) !== 0) return this.listeProprietaire.sontParDefinitionSurParallele(pt1.antecedent, pt2.antecedent, this);else return false;
	  } else {
	    // On regarde d'abord si pt2 est l'image d'un point de this par une translation  dont l'origine est sur this
	    // et l'extrémité est pt1 ou si pt2 est l'image de pt1 par une translation dont le Vect a son origine et son extrémité
	    // qui sont sur this
	    if (pt2.estPointImage()) {
	      // CPointImage ptim = (CPointImage) pt2;
	      if (pt2.transformation.natureTransformation() === CTransformation.translation) {
	        trans = pt2.transformation;
	        return trans.ex === pt1 && trans.or.appartientDroiteParDefinition(this) && pt2.antecedent.appartientDroiteParDefinition(this) || pt2.antecedent === pt1 && this.listeProprietaire.sontParDefinitionSurParallele(trans.or, trans.ex, this);
	      } else return false;
	    }
	    // On regarde ensuite si pt1 est l'image d'un point de this par une translation  dont l'origine est sur this
	    // et l'extrémité est pt2 ou si pt1 est l'image de pt2 par une translation dont le Vect a son origine et son extrémité
	    // qui sont sur this
	    if (pt1.estPointImage()) {
	      // CPointImage ptim = (CPointImage) pt1;
	      if (pt1.transformation.natureTransformation() === CTransformation.translation) {
	        trans = pt1.transformation;
	        return trans.ex === pt2 && trans.or.appartientDroiteParDefinition(this) && pt1.antecedent.appartientDroiteParDefinition(this) || pt1.antecedent === pt2 && this.listeProprietaire.sontParDefinitionSurParallele(trans.or, trans.ex, this);
	      } else return false;
	    } else return false;
	  }
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CElementBase = __webpack_require__(33);
	module.exports = CTransformation;
	
	/**
	 * Classe ancêtre de toutes les transformations géométriques.
	 * @constructor
	 * @extends CElementBase
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @returns {CTransformation}
	 */
	function CTransformation(listeProprietaire, impProto, estElementFinal) {
	  if (arguments.length === 0) return; // Ajout version WebPack
	  if (arguments.length === 1) CElementBase.call(this, listeProprietaire);else {
	    CElementBase.call(this, listeProprietaire, impProto, estElementFinal);
	  }
	}
	CTransformation.prototype = new CElementBase();
	CTransformation.prototype.constructor = CTransformation;
	CTransformation.prototype.superClass = "CElementBase";
	CTransformation.prototype.className = "CTransformation";
	
	CTransformation.translation = 1;
	CTransformation.rotation = 2;
	CTransformation.symetrieCentrale = 3;
	CTransformation.symetrieAxiale = 4;
	CTransformation.homothetie = 5;
	CTransformation.similitude = 6;
	CTransformation.inversion = 7;
	CTransformation.translationParCoord = 8;
	
	CTransformation.prototype.getNature = function () {
	  return NatObj.NTransformation;
	};
	/**
	 * Fonction renvoyant true si l'imag du point point par this existe.
	 * @param {CPt} point
	 * @returns {Boolean}
	 */
	CTransformation.prototype.pointAUneImage = function (point) {
	  return true;
	};
	/**
	 * Au retoour, pointeur.getValue renvoie la valeur de l'image de l'angle ang
	 * par la transformation.
	 * Par défaut pointeur.getValue() renverra la valeur de ang car les transformations utilisées
	 * sont des isométries directes.
	 * Doit être redéfini pour la symétrie axiale.
	 * @param {Float} ang
	 * @param {mtg32.Pointeur} pointeur
	 * @returns {undefined}
	 */
	CTransformation.prototype.transformeAngle = function (ang, pointeur) {
	  pointeur.setValue(ang);
	};
	/**
	 * Renvoie l'image de la longueur L par la transformation.
	 * Par défaut conserve les longueurs. A modifier pour homothéties et simmilitudes.
	 * @param {Float} l : La longueur à transformer (positive)
	 * @returns {Float}
	 */
	CTransformation.prototype.transformeLongueur = function (l) {
	  return l;
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalcul = __webpack_require__(54);
	
	module.exports = CCalcConst;
	
	/**
	 * @constructor
	 * @extends CCalcul
	 * Classe représentant dans un arbre binaire un calcul constant réel.
	 * Jusqu'à présent seulement utilisé pour la cosntante pi
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si est élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul constant
	 * @param {String} chaineCalcul : La chaîne représentant le calcul constant
	 * @param {CCb} calcul : Arbre binaire contenant le calcul constant
	 * @returns {CCalcConst}
	 */
	function CCalcConst(listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, calcul) {
	  if (arguments.length === 1) CCalcul.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalcul.call(this, listeProprietaire, impProto, estElementFinal);else {
	      CCalcul.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, calcul);
	      this.calculeValeurConstante();
	    }
	  }
	}
	CCalcConst.prototype = new CCalcul();
	CCalcConst.prototype.constructor = CCalcConst;
	CCalcConst.prototype.superClass = "CCalcul";
	CCalcConst.prototype.className = "CCalcConst";
	
	CCalcConst.prototype.getClone = function (listeSource, listeCible) {
	  var calculClone = this.calcul.getClone(listeSource, listeCible);
	  var ind1 = listeSource.indexOf(this.impProto);
	  return new CCalcConst(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, this.chaineCalcul, calculClone);
	};
	
	CCalcConst.prototype.getNatureCalcul = function () {
	  return NatCal.NCalculReelConstant;
	};
	
	// Rajouté version MtgApp
	CCalcConst.prototype.positionne = function () {
	  this.existe = true;
	};
	/**
	 * Calcule la valeur de la cosntante qui ne peut être que pi dans cette version
	 * @returns {undefined}
	 */
	CCalcConst.prototype.calculeValeurConstante = function () {
	  // Les paramètres passés n'ont aucune importance.
	  // On calcule la valeur de la cosntante qui ne peut être que pi dans cette version
	  CCalcul.prototype.positionne.call(this, false);
	};
	
	CCalcConst.prototype.read = function (inps, list) {
	  CCalcul.prototype.read.call(this, inps, list);
	  this.calculeValeurConstante();
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Complexe = __webpack_require__(30);
	var CCalculAncetre = __webpack_require__(35);
	var CalcC = __webpack_require__(69);
	var CCalcul = __webpack_require__(54);
	
	module.exports = CCalculComplexe;
	
	/**
	 * Classe représentant un calcul complexe
	 * @constructor
	 * @extends CCalcul
	 * @param {mtg32.CListeObet} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet intermédiaire de construction.
	 * @param {String} nomCalcul : Le nom du calcul
	 * @param {String} chaineCalcul : La chaîne repréentant le calcul
	 * @param {CCb} calcul : L'arbre binaire contenant le calcul proprement dit
	 * @returns {undefined}
	 */
	function CCalculComplexe(listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, calcul) {
	  if (arguments.length === 1) CCalcul.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalcul.call(this, listeProprietaire, impProto, estElementFinal);else {
	      CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	      this.chaineCalcul = chaineCalcul;
	      if (arguments.length === 5) this.calcul = CalcC.ccbComp(chaineCalcul, this.listeProprietaire, 0, chaineCalcul.length - 1, null);else this.calcul = calcul;
	    }
	  }
	  this.resultatComplexe = new Complexe();
	}
	
	CCalculComplexe.prototype = new CCalcul();
	CCalculComplexe.prototype.constructor = CCalculComplexe;
	CCalculComplexe.prototype.superClass = "CCalcul";
	CCalculComplexe.prototype.className = "CCalculComplexe";
	
	CCalculComplexe.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var calculClone = this.calcul.getClone(listeSource, listeCible);
	  return new CCalculComplexe(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, this.chaineCalcul, calculClone);
	};
	
	CCalculComplexe.prototype.getNatureCalcul = function () {
	  return NatCal.NCalculComplexe;
	};
	
	CCalculComplexe.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.calcul.existe(infoRandom);
	  if (!this.existe) return;
	  try {
	    this.listeProprietaire.initialiseNombreIterations();
	    this.calcul.resultatComplexe(infoRandom, this.resultatComplexe);
	  } catch (e) {
	    this.existe = false;
	  }
	  if (!isFinite(this.resultatComplexe.x) || !isFinite(this.resultatComplexe.y)) this.existe = false;
	};
	
	CCalculComplexe.prototype.rendValeurComplexe = function (zRes) {
	  zRes.set(this.resultatComplexe);
	};
	
	CCalculComplexe.prototype.rendChaineValeurPourCommentaire = function (nbDecimales) {
	  return this.rendChaineValeurComplexe(nbDecimales);
	};
	/**
	 * Spécial JavaScript : Renvoie la chaîne LaTeX de la formule du calcul
	 */
	CCalculComplexe.prototype.chaineLatex = function () {
	  return this.calcul.chaineLatexSansPar(null);
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CPt = __webpack_require__(87);
	module.exports = CCentreCercle;
	
	/**
	 * Objet point représentant le centre d'un cercle. Utilisé pour certaines constructions.
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CCercle} cercleAssocie : Le cercle dont on veut le centre.
	 * @returns {CCentreCercle}
	 */
	function CCentreCercle(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, cercleAssocie) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.cercleAssocie = cercleAssocie;
	  }
	}
	CCentreCercle.prototype = new CPt();
	CCentreCercle.prototype.constructor = CCentreCercle;
	CCentreCercle.prototype.superClass = "CPt";
	CCentreCercle.prototype.className = "CCentreCercle";
	
	CCentreCercle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.cercleAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CCentreCercle(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CCercle"));
	};
	CCentreCercle.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.cercleAssocie.dependDe(p));
	};
	CCentreCercle.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.cercleAssocie.dependDePourBoucle(p);
	};
	CCentreCercle.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.cercleAssocie.existe;
	  if (this.existe) {
	    CPt.prototype.placeEn.call(this, this.cercleAssocie.centre_x, this.cercleAssocie.centre_y);
	    CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	  }
	};
	CCentreCercle.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.cercleAssocie);
	};
	CCentreCercle.prototype.confonduAvec = function (p) {
	  if (p.className === this.classname) return this.cercleAssocie === p.cercleAssocie;else return false;
	};
	CCentreCercle.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.cercleAssocie = list.get(ind1, "CCercle");
	};
	CCentreCercle.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.cercleAssocie);
	  oups.writeInt(ind1);
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CPt = __webpack_require__(87);
	module.exports = CCentreGravite;
	
	/**
	 * Classe représentant le centre de gravité d'un triangle donné par 3 points.
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {Color} couleur : La couleur de l'objet
	 * @param {boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {int} dec_x : Decalage horizontal du nom
	 * @param {int} dec_y : Decalage vertical du nom
	 * @param {boolean} masque : true si l'objet est masque
	 * @param {string} nom : Le nom eventuel de l'objet
	 * @param {int} tailleNom : taille du nom (voir Fonte)
	 * @param {MotifPoint} motif : Le motif du point.
	 * @param {boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CPt} point1 : Le premier sommet du triangle.
	 * @param {CPt} point2 : Le second sommet du triangle.
	 * @param {CPt} point3 : Le troisième sommet du triangle.
	 * @constructor
	 */
	function CCentreGravite(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, point1, point2, point3) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.point1 = point1;
	    this.point2 = point2;
	    this.point3 = point3;
	  }
	}
	CCentreGravite.prototype = new CPt();
	CCentreGravite.prototype.constructor = CCentreGravite;
	CCentreGravite.prototype.superClass = "CPt";
	CCentreGravite.prototype.className = "CCentreGravite";
	
	CCentreGravite.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.point1);
	  var ind2 = listeSource.indexOf(this.point2);
	  var ind3 = listeSource.indexOf(this.point3);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CCentreGravite(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"), this.marquePourTrace);
	};
	CCentreGravite.prototype.ajouteAntecedents = function (frame, liste) {
	  liste.add(this.point1);
	  liste.add(this.point2);
	  liste.add(this.point3);
	};
	CCentreGravite.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.point1.dependDe(p) || this.point2.dependDe(p) || this.point3.dependDe(p));
	};
	CCentreGravite.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.point1.dependDePourBoucle(p) || this.point2.dependDePourBoucle(p) || this.point3.dependDePourBoucle(p);
	};
	CCentreGravite.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.point1.existe && this.point2.existe && this.point3.existe;
	  if (this.existe) {
	    CPt.prototype.placeEn.call(this, (this.point1.x + this.point2.x + this.point3.x) / 3, (this.point1.y + this.point2.y + this.point3.y) / 3);
	    CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajouté version 4.6.4
	  }
	};
	CCentreGravite.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.point1 === p.point1 && this.point2 === p.point2 && this.point3 === p.point3 || this.point1 === p.point1 && this.point2 === p.point3 && this.point3 === p.point2 || this.point1 === p.point2 && this.point2 === p.point3 && this.point3 === p.point1 || this.point1 === p.point2 && this.point2 === p.point1 && this.point3 === p.point3 || this.point1 === p.point3 && this.point2 === p.point2 && this.point3 === p.point1 || this.point1 === p.point3 && this.point2 === p.point1 && this.point3 === p.point2;
	  } else return false;
	};
	CCentreGravite.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.point1 === ancienPoint) this.point1 = nouveauPoint;
	  if (this.point2 === ancienPoint) this.point2 = nouveauPoint;
	  if (this.point3 === ancienPoint) this.point3 = nouveauPoint;
	};
	CCentreGravite.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.point1 = list.get(ind1, "CPt");
	  this.point2 = list.get(ind2, "CPt");
	  this.point3 = list.get(ind3, "CPt");
	};
	CCentreGravite.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.point1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.point2);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.point3);
	  oups.writeInt(ind3);
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CElementLigne = __webpack_require__(77);
	var CCercle = __webpack_require__(75);
	module.exports = CCercleClone;
	
	/**
	 * Classe représentant un clone d'un cercle déjà créé (pas un arc de cercle).
	 * Il est identique mais peut avoir ses propres attributs graphiques.
	 * @constructor
	 * @extends CCercle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la consruction proprietaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boolean} masque : true si l'objet est masqué
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CCercle} cercle : Le cercle dont l'objet est le clone;
	 * @returns {CCercleClone}
	 */
	function CCercleClone(listeProprietaire, impProto, estElementFinal, couleur, masque, style, cercle) {
	  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	    CCercle.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.cercle = cercle;
	  }
	}
	CCercleClone.prototype = new CCercle();
	CCercleClone.prototype.constructor = CCercleClone;
	CCercleClone.prototype.superClass = "CCercle";
	CCercleClone.prototype.className = "CCercleClone";
	
	CCercleClone.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.cercle);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CCercleClone(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CCercle"));
	};
	CCercleClone.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCercle.prototype.dependDe.call(this, p) || this.cercle.dependDe(p));
	};
	CCercleClone.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.cercle.dependDePourBoucle(p);
	};
	CCercleClone.prototype.positionne = function () {
	  var b = this.masque;
	  this.setClone(this.cercle);
	  this.masque = b;
	};
	CCercleClone.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.cercle);
	};
	CCercleClone.prototype.read = function (inps, list) {
	  CCercle.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.cercle = list.get(ind1, "CCercle");
	};
	CCercleClone.prototype.write = function (oups, list) {
	  CCercle.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.cercle);
	  oups.writeInt(ind1);
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CElementLigne = __webpack_require__(77);
	var CCercle = __webpack_require__(75);
	module.exports = CCercleImage;
	
	/**
	 * Classe représentant un cercle image d'un autre par une transformation.
	 * @constructor
	 * @extends CCercle
	 * @param {CListeObjets} listeProprietaire : La liste popriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction proprietaire.
	 * @param {Boolean} estElementFinal : true si élémnet final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boolean} masque : true si l'objet est masqué
	 * @param {mtg32.StyleTrait} style : Le stye lde tracé
	 * @param {CCercle} antecedent : Le cercle dont this est l'image.
	 * @param {CTransformation} transformation : La transformation utilisée.
	 * @returns {CCercleImage}
	 */
	function CCercleImage(listeProprietaire, impProto, estElementFinal, couleur, masque, style, antecedent, transformation) {
	  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	    CCercle.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.antecedent = antecedent;
	    this.transformation = transformation;
	  }
	}
	CCercleImage.prototype = new CCercle();
	CCercleImage.prototype.constructor = CCercleImage;
	CCercleImage.prototype.superClass = "CCercle";
	CCercleImage.prototype.className = "CCercleImage";
	
	CCercleImage.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.antecedent);
	  var ind2 = listeSource.indexOf(this.transformation);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CCercleImage(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CCercle"), listeCible.get(ind2, "CTransformation"));
	};
	CCercleImage.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCercle.prototype.dependDe.call(this, p) || this.antecedent.dependDe(p) || this.transformation.dependDe(p));
	};
	CCercleImage.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.antecedent.dependDePourBoucle(p) || this.transformation.dependDePourBoucle(p);
	};
	CCercleImage.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.transformation.existe && this.antecedent.existe;
	  if (!this.existe) return;
	  var point1 = {};
	  this.transformation.transformePoint(this.antecedent.centre_x, this.antecedent.centre_y, point1);
	  this.centre_x = point1.x;
	  this.centre_y = point1.y;
	  this.rayon = this.transformation.transformeLongueur(this.antecedent.rayon);
	  CCercle.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CCercleImage.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.antecedent === p.antecedent && this.transformation.confonduAvec(p.transformation);else return false;
	};
	CCercleImage.prototype.ajouteAntecedents = function (liste, app) {
	  liste.add(this.antecedent);
	  this.transformation.ajouteAntecedents(liste, app);
	};
	CCercleImage.prototype.contientParDefinition = function (po) {
	  if (po.estPointImage()) return this.transformation === po.transformation && po.antecedent.appartientCercleParDefinition(this.antecedent);else return true;
	};
	CCercleImage.prototype.read = function (inps, list) {
	  CCercle.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.antecedent = list.get(ind1, "CCercle");
	  this.transformation = list.get(ind2, "CTransformation");
	};
	CCercleImage.prototype.write = function (oups, list) {
	  CCercle.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.antecedent);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.transformation);
	  oups.writeInt(ind2);
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var CElementLigne = __webpack_require__(77);
	var CCercle = __webpack_require__(75);
	module.exports = CCercleOA;
	var CTransformation = __webpack_require__(100);
	
	/**
	 * Cercle donné par son centre et un point du cercle.
	 * @constructor
	 * @extends CCercle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la consruction proprietaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boolean} masque : true si l'objet est masqué
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CPt} o : le cntre du cercle.
	 * @param {CPt} a : un point du cercle.
	 * @returns {CCercleOA}
	 */
	function CCercleOA(listeProprietaire, impProto, estElementFinal, couleur, masque, style, o, a) {
	  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	    CCercle.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.o = o;
	    this.a = a;
	  }
	}
	CCercleOA.prototype = new CCercle();
	CCercleOA.prototype.constructor = CCercleOA;
	CCercleOA.prototype.superClass = "CCercle";
	CCercleOA.prototype.className = "CCercleOA";
	
	CCercleOA.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.o);
	  var ind2 = listeSource.indexOf(this.a);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CCercleOA(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"));
	};
	CCercleOA.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.o);
	};
	CCercleOA.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCercle.prototype.dependDe.call(this, p) || this.o.dependDe(p) || this.a.dependDe(p));
	};
	CCercleOA.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.o.dependDePourBoucle(p) || this.a.dependDePourBoucle(p);
	};
	CCercleOA.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.o.existe && this.a.existe;
	  if (!this.existe) return;
	  var u = new Vect();
	  u.x = this.a.x - this.o.x;
	  u.y = this.a.y - this.o.y;
	  this.rayon = u.norme();
	  this.centre_x = this.o.x;
	  this.centre_y = this.o.y;
	  CCercle.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CCercleOA.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.o === p.o && this.a === p.a;
	  } else return false;
	};
	CCercleOA.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.o === ancienPoint) this.o = nouveauPoint;
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	};
	CCercleOA.prototype.read = function (inps, list) {
	  CCercle.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.o = list.get(ind1, "CPt");
	  this.a = list.get(ind2, "CPt");
	};
	CCercleOA.prototype.write = function (oups, list) {
	  CCercle.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.o);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.a);
	  oups.writeInt(ind2);
	};
	CCercleOA.prototype.contientParDefinition = function (po) {
	  if (this.a === po) return true;
	  if (po.estPointImage()) {
	    if (po.transformation.natureTransformation() === CTransformation.rotation) {
	      var rot = po.transformation;
	      return po.antecedent.appartientCercleParDefinition(this) && rot.centre === this.o;
	    } else return false;
	  } else return false;
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CElementLigne = __webpack_require__(77);
	var CCercle = __webpack_require__(75);
	var CTransformation = __webpack_require__(100);
	var CValeur = __webpack_require__(80);
	module.exports = CCercleOR;
	
	/**
	 * Cercle défini par son centre et un calcul donnant son rayon.
	 * @constructor
	 * @extends CCercle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la consruction proprietaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur
	 * @param {Boolean} masque : true si l'objet est masqué
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CPt} o : Le centre du cercle.
	 * @param {CValeur} r : Calcul donnant le rayon.
	 * @param {Boolean} inPixels : Si true le rayon est en pixels et n'utilise pas la
	 * longueur unité de la figure.
	 * @returns {CCercleOR}
	 */
	function CCercleOR(listeProprietaire, impProto, estElementFinal, couleur, masque, style, o, r, inPixels) {
	  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	    CCercle.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.o = o;
	    this.r = r;
	    this.inPixels = inPixels;
	  }
	  this.coefMult = 1;
	}
	CCercleOR.prototype = new CCercle();
	CCercleOR.prototype.constructor = CCercleOR;
	CCercleOR.prototype.superClass = "CCercle";
	CCercleOR.prototype.className = "CCercleOR";
	
	CCercleOR.prototype.numeroVersion = function () {
	  return 2;
	};
	CCercleOR.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.o);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var rClone = this.r.getClone(listeSource, listeCible);
	  return new CCercleOR(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), rClone, this.inPixels);
	};
	CCercleOR.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.o);
	};
	CCercleOR.prototype.initialisePourDependance = function () {
	  CCercle.prototype.initialisePourDependance.call(this);
	  this.r.initialisePourDependance();
	};
	CCercleOR.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCercle.prototype.dependDe.call(this, p) || this.o.dependDe(p) || this.r.dependDe(p) || this.listeProprietaire.pointeurLongueurUnite.dependDe(p));
	};
	CCercleOR.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.o.dependDePourBoucle(p) || this.r.dependDePourBoucle(p) || this.listeProprietaire.pointeurLongueurUnite.dependDePourBoucle(p);
	};
	CCercleOR.prototype.positionne = function (infoRandom, dimfen) {
	  this.r.positionne(infoRandom, dimfen);
	  var plongUnite = this.listeProprietaire.pointeurLongueurUnite;
	  // Modification version 4.6.3
	  this.existe = this.o.existe && this.r.existe;
	  if (!this.inPixels) this.existe = this.existe && plongUnite.existe;
	  if (this.existe) {
	    this.centre_x = this.o.x;
	    this.centre_y = this.o.y;
	    if (this.inPixels) this.rayon = this.r.rendValeur() * this.coefMult;else this.rayon = this.r.rendValeur() * this.listeProprietaire.pointeurLongueurUnite.rendLongueur();
	    CCercle.prototype.positionne.call(this, infoRandom, dimfen);
	  }
	};
	CCercleOR.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.o === p.o && this.r.confonduAvec(p.r);
	  } else return false;
	};
	CCercleOR.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.o === ancienPoint) this.o = nouveauPoint;
	};
	CCercleOR.prototype.read = function (inps, list) {
	  CCercle.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.o = list.get(ind1, "CPt");
	  this.r = new CValeur();
	  this.r.read(inps, list);
	  this.inPixels = inps.readBoolean();
	};
	CCercleOR.prototype.write = function (oups, list) {
	  CCercle.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.o);
	  oups.writeInt(ind1);
	  this.r.write(oups, list);
	  oups.writeBoolean(this.inPixels);
	};
	CCercleOR.prototype.contientParDefinition = function (po) {
	  if (this.o === po) return true;
	  if (po.estPointImage()) {
	    // CPointImage ptim = (CPointImage) po;
	    if (po.transformation.natureTransformation() === CTransformation.rotation) {
	      var rot = po.transformation;
	      return po.antecedent.appartientCercleParDefinition(this) && rot.centre === this.o;
	    } else return false;
	  } else return false;
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CDroiteAncetre = __webpack_require__(99);
	module.exports = CDemiDroite;
	
	/**
	 * Classe ancêtre des demi-droites.
	 * @constructor
	 * @extends CDroiteAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style de tracé.
	 * @returns {CDemiDroite}
	 */
	function CDemiDroite(listeProprietaire, impProto, estElementFinal, couleur, masque, style) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CDroiteAncetre.call(this, listeProprietaire);else {
	    CDroiteAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, false, 0, 0, masque, "", 16, style);
	  }
	}
	CDemiDroite.prototype = new CDroiteAncetre();
	CDemiDroite.prototype.constructor = CDemiDroite;
	CDemiDroite.prototype.superClass = "CDroiteAncetre";
	CDemiDroite.prototype.className = "CDemiDroite";
	
	CDemiDroite.prototype.positionne = function (infoRandom, dimfen) {
	  var u, v;
	  CDroiteAncetre.prototype.positionne.call(this, infoRandom, dimfen);
	  // Si la droite est hors-fenêtre, la demi-droite l'est aussi
	  if (this.horsFenetre) return;
	  // Si l'origine de la demi-droite  est dans la fenêtre
	  if (dimfen.dansFenetre(this.point_x, this.point_y)) {
	    u = new Vect(this.point_x, this.point_y, this.xext1, this.yext1);
	    if (u.presqueNul()) {
	      v = new Vect(this.point_x, this.point_y, this.xext2, this.yext2);
	      if (kernel.colineairesMemeSens(v, this.vect)) {
	        this.xext1 = this.point_x;
	        this.yext1 = this.point_y;
	      } else {
	        this.xext2 = this.xext1;
	        this.yext2 = this.yext1;
	        this.xext1 = this.point_x;
	        this.yext1 = this.point_y;
	      }
	    } else {
	      if (kernel.colineairesMemeSens(u, this.vect)) {
	        this.xext2 = this.xext1;
	        this.yext2 = this.yext1;
	        this.xext1 = this.point_x;
	        this.yext1 = this.point_y;
	      } else {
	        this.xext1 = this.point_x;
	        this.yext1 = this.point_y;
	      }
	    }
	  } else {
	    // Si l'origine est hors-fenêtre
	    u = new Vect(this.point_x, this.point_y, this.xext1, this.yext1);
	    if (!kernel.colineairesMemeSens(u, this.vect)) this.horsFenetre = true;
	  }
	};
	CDemiDroite.prototype.abscisseMaximale = function () {
	  if (this.horsFenetre) return this.abscisseMinimale();else return CDroiteAncetre.prototype.abscisseMaximale.call(this);
	};
	// Pour ne rien faire lorsque CDroite.positionne appelle positionneNom()
	CDemiDroite.prototype.positionneNom = function () {};
	CDemiDroite.prototype.appartientA = function (x, y) {
	  if (!this.existe) return false;else {
	    if (kernel.zero(this.vect.x)) {
	      return (y - this.point_y) * this.vect.y >= 0;
	    } else {
	      return (x - this.point_x) * this.vect.x >= 0;
	    }
	  }
	};
	CDemiDroite.prototype.getNature = function () {
	  return NatObj.NDemiDroite;
	};
	CDemiDroite.prototype.chaineDesignation = function () {
	  return "desDemiDroite";
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDemiDroite = __webpack_require__(109);
	module.exports = CDemiDroiteClone;
	
	/**
	 * Demi-droite clonant une demi-droite déjà créée.
	 * Elle est la réplique exace de la demi-droite colnée mais puet avoir ses
	 * propres caractéristiques graphiques.
	 * Utilisé pour les constructions récursives et itératives.
	 * @constructor
	 * @extends CDemiDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style de tracé.
	 * @param {CDemiDroite} droite : La demi-droite dont this est le clone.
	 * @returns {CDemiDroiteClone}
	 */
	function CDemiDroiteClone(listeProprietaire, impProto, estElementFinal, couleur, masque, style, droite) {
	  if (arguments.length === 1) CDemiDroite.call(this, listeProprietaire);else {
	    CDemiDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.droite = droite;
	  }
	}
	CDemiDroiteClone.prototype = new CDemiDroite();
	CDemiDroiteClone.prototype.constructor = CDemiDroiteClone;
	CDemiDroiteClone.prototype.superClass = "CDemiDroite";
	CDemiDroiteClone.prototype.className = "CDemiDroiteClone";
	
	CDemiDroiteClone.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.droite);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CDemiDroiteClone(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.style, listeCible.get(ind1, "CDemiDroite"));
	};
	CDemiDroiteClone.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.droite);
	};
	CDemiDroiteClone.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDemiDroite.prototype.dependDe.call(this, p) || this.droite.dependDe(p));
	};
	CDemiDroiteClone.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.droite.dependDePourBoucle(p);
	};
	CDemiDroiteClone.prototype.positionne = function () {
	  var b = this.masque;
	  this.setClone(this.droite);
	  this.masque = b;
	};
	CDemiDroiteClone.prototype.read = function (inps, list) {
	  CDemiDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.droite = list.get(ind1, "CDemiDroite");
	};
	CDemiDroiteClone.prototype.write = function (oups, list) {
	  CDemiDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.droite);
	  oups.writeInt(ind1);
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDemiDroite = __webpack_require__(109);
	var CTransformation = __webpack_require__(100);
	module.exports = CDemiDroiteImage;
	
	/**
	 * Classe représentant une demi-droite image d'une autre par une transformation.
	 * @constructor
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style de tracé.
	 * @param {CDemiDroite} droite : La demi-droite dont this est le clone.
	 * @param {CDemiDroite} antecedent : La demi-droite dont this est l'image.
	 * @param {CTransformation} transformation : La transformation utilisée.
	 * @returns {CDemiDroiteImage}
	 */
	function CDemiDroiteImage(listeProprietaire, impProto, estElementFinal, couleur, masque, style, antecedent, transformation) {
	  if (arguments.length === 1) CDemiDroite.call(this, listeProprietaire);else {
	    CDemiDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.antecedent = antecedent;
	    this.transformation = transformation;
	  }
	}
	CDemiDroiteImage.prototype = new CDemiDroite();
	CDemiDroiteImage.prototype.constructor = CDemiDroiteImage;
	CDemiDroiteImage.prototype.superClass = "CDemiDroite";
	CDemiDroiteImage.prototype.className = "CDemiDroiteImage";
	
	CDemiDroiteImage.prototype.ajouteAntecedents = function (liste, app) {
	  liste.add(this.antecedent);
	  this.transformation.ajouteAntecedents(liste, app);
	};
	CDemiDroiteImage.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.antecedent);
	  var ind2 = listeSource.indexOf(this.transformation);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CDemiDroiteImage(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CDemiDroite"), listeCible.get(ind2, "CTransformation"));
	};
	CDemiDroiteImage.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDemiDroite.prototype.dependDe.call(this, p) || this.antecedent.dependDe(p) || this.transformation.dependDe(p));
	};
	CDemiDroiteImage.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.antecedent.dependDePourBoucle(p) || this.transformation.dependDePourBoucle(p);
	};
	CDemiDroiteImage.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.transformation.existe && this.antecedent.existe;
	  if (!this.existe) return;
	  var point1 = {};
	  this.transformation.transformePoint(this.antecedent.point_x, this.antecedent.point_y, point1);
	  this.point_x = point1.x;
	  this.point_y = point1.y;
	  this.transformation.transformeVecteur(this.antecedent.vect, this.vect);
	  CDemiDroite.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CDemiDroiteImage.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.antecedent === p.antecedent && this.transformation.confonduAvec(p.transformation);else return false;
	};
	CDemiDroiteImage.prototype.contientParDefinition = function (po) {
	  if (po.estPointImage()) return this.transformation === po.transformation && po.antecedent.appartientDroiteParDefinition(this.antecedent);else return false;
	};
	CDemiDroiteImage.prototype.estParalleleParDefinition = function (dte) {
	  return dte === this || (this.transformation.natureTransformation() & (CTransformation.translation | CTransformation.homothetie | CTransformation.symetrieCentrale)) !== 0 && (this.antecedent.estParalleleParDefinition(dte) || dte.estParalleleParDefinition(this.antecedent));
	};
	CDemiDroiteImage.prototype.read = function (inps, list) {
	  CDemiDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.antecedent = list.get(ind1, "CDemiDroite");
	  this.transformation = list.get(ind2, "CTransformation");
	};
	CDemiDroiteImage.prototype.write = function (oups, list) {
	  CDemiDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.antecedent);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.transformation);
	  oups.writeInt(ind2);
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDemiDroite = __webpack_require__(109);
	module.exports = CDemiDroiteOA;
	
	/**
	 * Demi-droite définir par son origine et un point.
	 * @constructor
	 * @extends CDemiDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style de tracé.
	 * @param {CPt} o : Le point origine de la demi-droite.
	 * @param {CPt} a : Un point appartenant à la demi-droite.
	 * @returns {CDemiDroiteOA}
	 */
	function CDemiDroiteOA(listeProprietaire, impProto, estElementFinal, couleur, masque, style, o, a) {
	  if (arguments.length === 1) CDemiDroite.call(this, listeProprietaire);else {
	    CDemiDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.o = o;
	    this.a = a;
	  }
	}
	CDemiDroiteOA.prototype = new CDemiDroite();
	CDemiDroiteOA.prototype.constructor = CDemiDroiteOA;
	CDemiDroiteOA.prototype.superClass = "CDemiDroite";
	CDemiDroiteOA.prototype.className = "CDemiDroiteOA";
	
	CDemiDroiteOA.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.o);
	  var ind2 = listeSource.indexOf(this.a);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CDemiDroiteOA(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"));
	};
	CDemiDroiteOA.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.o);
	  liste.add(this.a);
	};
	CDemiDroiteOA.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.o.existe && this.a.existe;
	  if (!this.existe) return;
	  this.point_x = this.o.x;
	  this.point_y = this.o.y;
	  this.vect.x = this.a.x - this.o.x;
	  this.vect.y = this.a.y - this.o.y;
	  CDemiDroite.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CDemiDroiteOA.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDemiDroite.prototype.dependDe.call(this, p) || this.o.dependDe(p) || this.a.dependDe(p));
	};
	CDemiDroiteOA.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.o.dependDePourBoucle(p) || this.a.dependDePourBoucle(p);
	};
	CDemiDroiteOA.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.o === p.o && this.a === p.a;
	  } else return false;
	};
	CDemiDroiteOA.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.o === ancienPoint) this.o = nouveauPoint;
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	};
	CDemiDroiteOA.prototype.read = function (inps, list) {
	  CDemiDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.o = list.get(ind1, "CPt");
	  this.a = list.get(ind2, "CPt");
	};
	CDemiDroiteOA.prototype.write = function (oups, list) {
	  CDemiDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.o);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.a);
	  oups.writeInt(ind2);
	};
	CDemiDroiteOA.prototype.contientParDefinition = function (po) {
	  return this.a === po || this.o === po;
	};
	CDemiDroiteOA.prototype.estParalleleParDefinition = function (dte) {
	  return dte === this || this.o.appartientDroiteParDefinition(dte) && this.a.appartientDroiteParDefinition(dte) || dte.formentDroiteParallele(this.o, this.a);
	};

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CSurface = __webpack_require__(114);
	module.exports = CDemiPlan;
	
	/**
	 *
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @constructor
	 * @extends CSurface
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 * @param {CLieuDeBase} bord : Le lieu de points bord de la surface.
	 * @param {CPt} pointDemiPlan : Un point appartenant au demi-plan.
	 * @returns {CDemiPlan}
	 */
	function CDemiPlan(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord, pointDemiPlan) {
	  if (arguments.length === 1) CSurface.call(this, listeProprietaire);else {
	    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
	    this.pointDemiPlan = pointDemiPlan;
	  }
	  this.absPtsBord = new Array(5);
	  this.ordPtsBord = new Array(5);
	}
	CDemiPlan.prototype = new CSurface();
	CDemiPlan.prototype.constructor = CDemiPlan;
	CDemiPlan.prototype.superClass = "CSurface";
	CDemiPlan.prototype.className = "CDemiPlan";
	
	CDemiPlan.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.bord);
	  var ind2 = listeSource.indexOf(this.pointDemiPlan);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CDemiPlan(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CDroiteAncetre"), listeCible.get(ind2, "CPt"));
	};
	CDemiPlan.prototype.setClone = function (ptel) {
	  CSurface.prototype.setClone.call(this, ptel);
	  this.nbPtsBord = ptel.nbPtsBord;
	  for (var i = 0; i < this.nbPtsBord; i++) {
	    this.absPtsBord[i] = ptel.absPtsBord[i];
	    this.ordPtsBord[i] = ptel.ordPtsBord[i];
	  }
	};
	CDemiPlan.prototype.confonduAvec = function (p) {
	  var res = CSurface.prototype.confonduAvec.call(this, p);
	  if (!res) return false;
	  res = res && this.pointDemiPlan === p.pointDemiPlan;
	  return res;
	};
	CDemiPlan.prototype.dansDemiPlan = function (x, y) {
	  return (this.a * x + this.b * y + this.c) * this.signePointDemiPlan >= 0;
	};
	CDemiPlan.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CSurface.prototype.dependDe.call(this, p) || this.pointDemiPlan.dependDe(p));
	};
	CDemiPlan.prototype.dependDePourBoucle = function (p) {
	  return CSurface.prototype.dependDePourBoucle.call(this, p) || this.pointDemiPlan.dependDePourBoucle(p);
	};
	CDemiPlan.prototype.dependDePourCapture = function (p) {
	  return CSurface.prototype.dependDePourCapture.call(this, p) || this.pointDemiPlan.dependDePourCapture(p);
	};
	CDemiPlan.prototype.positionne = function (infoRandom, dimfen) {
	  var i, j, xext1, xext2, yext1, yext2, x, y, dedans;
	  xext1 = this.bord.xext1;
	  xext2 = this.bord.xext2;
	  yext1 = this.bord.yext1;
	  yext2 = this.bord.yext2;
	  this.existe = this.pointDemiPlan.existe && this.bord.existe && !this.pointDemiPlan.surDroite(this.bord);
	  if (!this.existe) return;
	  // Une équation cartésienne du bord est ax+by+c = 0.
	  this.b = -this.bord.vect.x;
	  this.a = this.bord.vect.y;
	  this.c = -this.a * xext1 - this.b * yext1;
	  var s = this.a * this.pointDemiPlan.x + this.b * this.pointDemiPlan.y + this.c;
	  if (s > 0) this.signePointDemiPlan = 1;else {
	    if (s < 0) this.signePointDemiPlan = -1;else this.signePointDemiPlan = 0;
	  }
	  // Les coordonnées des 4 coins de la fenêtre
	  x = new Array(4);
	  y = new Array(4);
	  x[0] = 0;
	  y[0] = 0;
	  x[1] = dimfen.x;
	  y[1] = 0;
	  x[2] = dimfen.x;
	  y[2] = dimfen.y;
	  x[3] = 0;
	  y[3] = dimfen.y;
	  // Les résultats pour savoir s'ils sont ou non dans le demi-plan
	  dedans = new Array(4);
	  j = -1;
	  for (i = 0; i <= 3; i++) {
	    dedans[i] = this.dansDemiPlan(x[i], y[i]);
	    if (j === -1 && dedans[i]) j = i;
	  }
	  if (j === -1) {
	    this.existe = false;
	    return; // Aucun sommet dans le demi-plan
	  }
	  this.nbPtsBord = 0;
	  for (i = 0; i <= 3; i++) {
	    j = (j + 1) % 4;
	    if (dedans[j]) {
	      this.absPtsBord[this.nbPtsBord] = Math.round(x[j]);
	      this.ordPtsBord[this.nbPtsBord] = Math.round(y[j]);
	      this.nbPtsBord++;
	    } else {
	      if (j % 2 === 0) {
	        if (xext1 === x[j]) {
	          this.absPtsBord[this.nbPtsBord] = Math.round(xext1);
	          this.ordPtsBord[this.nbPtsBord] = Math.round(yext1);
	          this.nbPtsBord++;
	          this.absPtsBord[this.nbPtsBord] = Math.round(xext2);
	          this.ordPtsBord[this.nbPtsBord] = Math.round(yext2);
	          this.nbPtsBord++;
	        } else {
	          this.absPtsBord[this.nbPtsBord] = Math.round(xext2);
	          this.ordPtsBord[this.nbPtsBord] = Math.round(yext2);
	          this.nbPtsBord++;
	          this.absPtsBord[this.nbPtsBord] = Math.round(xext1);
	          this.ordPtsBord[this.nbPtsBord] = Math.round(yext1);
	          this.nbPtsBord++;
	        }
	      } else {
	        if (yext1 === y[j]) {
	          this.absPtsBord[this.nbPtsBord] = Math.round(xext1);
	          this.ordPtsBord[this.nbPtsBord] = Math.round(yext1);
	          this.nbPtsBord++;
	          this.absPtsBord[this.nbPtsBord] = Math.round(xext2);
	          this.ordPtsBord[this.nbPtsBord] = Math.round(yext2);
	          this.nbPtsBord++;
	        } else {
	          this.absPtsBord[this.nbPtsBord] = Math.round(xext2);
	          this.ordPtsBord[this.nbPtsBord] = Math.round(yext2);
	          this.nbPtsBord++;
	          this.absPtsBord[this.nbPtsBord] = Math.round(xext1);
	          this.ordPtsBord[this.nbPtsBord] = Math.round(yext1);
	          this.nbPtsBord++;
	        }
	      }
	      while (i <= 3) {
	        if (dedans[j]) {
	          this.absPtsBord[this.nbPtsBord] = Math.round(x[j]);
	          this.ordPtsBord[this.nbPtsBord] = Math.round(y[j]);
	          this.nbPtsBord++;
	        }
	        i++;
	        j = (j + 1) % 4;
	      }
	    }
	  }
	};
	/**
	 * Fonction renvoyant une chaîne de caractères utilisée dans le svg élément
	 * représentant la surface.
	 * @returns {String}
	 */
	CDemiPlan.prototype.creePoints = function () {
	  var i,
	      points = this.absPtsBord[0] + "," + this.ordPtsBord[0] + " ";
	  for (i = 1; i < this.nbPtsBord; i++) {
	    points += this.absPtsBord[i] + "," + this.ordPtsBord[i] + " ";
	  }
	  return points;
	};
	CDemiPlan.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointDemiPlan === ancienPoint) this.pointDemiPlan = nouveauPoint;
	};
	CDemiPlan.prototype.getNature = function () {
	  return NatObj.NDemiPlan;
	};
	CDemiPlan.prototype.chaineDesignation = function () {
	  return "desDemiPlan";
	};
	CDemiPlan.prototype.read = function (inps, list) {
	  CSurface.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.pointDemiPlan = list.get(ind1, "CPt");
	};
	CDemiPlan.prototype.write = function (oups, list) {
	  CSurface.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.pointDemiPlan);
	  oups.writeInt(ind1);
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var StyleRemplissage = __webpack_require__(115);
	var kernel = __webpack_require__(8);
	var CSurfaceAncetre = __webpack_require__(116);
	module.exports = CSurface;
	
	/**
	 * Classe ancêtre des surfaces définies par un bord.
	 * @constructor
	 * @extends CSurfaceAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 * @param {CElementGraphique} bord : Le bord de la surface.
	 * @returns {CSurface}
	 */
	function CSurface(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CSurfaceAncetre.call(this, listeProprietaire);else {
	    CSurfaceAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage);
	    this.bord = bord;
	  }
	  this.pattern = null;
	}
	CSurface.prototype = new CSurfaceAncetre();
	CSurface.prototype.constructor = CSurface;
	CSurface.prototype.superClass = "CSurfaceAncetre";
	CSurface.prototype.className = "CSurface";
	
	CSurface.prototype.confonduAvec = function (p) {
	  var res = CSurfaceAncetre.prototype.confonduAvec.call(this, p);
	  if (!res) return false;
	  res = res && this.bord === p.bord;
	  return res;
	};
	CSurface.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CSurfaceAncetre.prototype.dependDe.call(this, p) || this.bord.dependDe(p));
	};
	CSurface.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.bord.dependDePourBoucle(p);
	};
	CSurface.prototype.dependDePourCapture = function (p) {
	  return p === this || this.bord.dependDePourCapture(p);
	};
	CSurface.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.bord.existe;
	};
	// Spécial JavaScript : ne sera redéfini que pour CSurfaceDisque;
	// Chaque surface bordée par une polyline devra définir creePoints()
	CSurface.prototype.createg = function (svg, couleurFond, transparence) {
	  var opacity, style, color;
	  // color = this.couleur.rgb() Modifié version 4.9.9.4
	  color = this.color;
	  var pol = kernel.cens("polyline");
	  switch (this.styleRemplissage) {
	    case StyleRemplissage.quadrillagePleinTransp:
	    case StyleRemplissage.quadrillagePlein:
	      opacity = this.styleRemplissage === StyleRemplissage.quadrillagePleinTransp ? transparence : 1;
	      style = "stroke:none;";
	      style += "fill-opacity:" + opacity + ";";
	      style += "fill:" + color + ";";
	      pol.setAttribute("style", style);
	      break;
	    default:
	      style = "stroke:none;" + "fill:url(#" + this.index + "mtg32pattern);";
	      if (this.pattern === null) this.createPattern();
	      pol.setAttribute("style", style);
	  }
	  pol.setAttribute("points", this.creePoints());
	  // if (this.listeProprietaire != null) pol.setAttribute("id",this.id);
	  pol.setAttribute("pointer-events", "none");
	  return pol;
	};
	CSurface.prototype.trace = function (svg, couleurFond, transparence) {
	  var g = this.createg(svg, couleurFond, transparence);
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	// Spécial JavaScript : Update se sera redéfini que pour CSurfaceDisque
	CSurface.prototype.update = function (svg, couleurFond, transparence) {
	  var oldg = this.g;
	  var g = this.createg(svg, couleurFond, transparence);
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CSurface.prototype.read = function (inps, list) {
	  CSurfaceAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.bord = list.get(ind1, "CElementGraphique");
	};
	CSurface.prototype.write = function (oups, list) {
	  CSurfaceAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.bord);
	  oups.writeInt(ind1);
	};
	// Spécifique JavaScript
	CSurface.prototype.createPattern = function () {
	  var svg, p, path, d;
	  svg = document.getElementById(this.listeProprietaire.id);
	  this.pattern = kernel.cens("defs");
	  // pattern.setAttribute("id", this.id+"mtg32pattern");
	  p = kernel.cens("pattern");
	  path = kernel.cens("path");
	  p.setAttribute("patternUnits", "userSpaceOnUse");
	  p.setAttribute("x", "0");
	  p.setAttribute("y", "0");
	  p.setAttribute("width", "6");
	  p.setAttribute("height", "6");
	  // var style="fill:none; stroke:"+this.couleur.rgb()+"; stroke-width:0.5;"; Modifié version 4.9.9.4
	  var style = "fill:none; stroke:" + this.color + "; stroke-width:0.5;";
	  // p.setAttribute("style", style);
	  switch (this.styleRemplissage) {
	    case StyleRemplissage.quadrillageHorizontal:
	      d = "M 0 3 L 6 3";
	      break;
	    case StyleRemplissage.quadrillageVertical:
	      d = "M 3 0 L 3 6";
	      break;
	    case StyleRemplissage.quadrillage45Bas:
	      d = "M 0 0 L 6 6";
	      break;
	    case StyleRemplissage.quadrillage45Haut:
	      d = "M 6 0 L 0 6";
	      break;
	    case StyleRemplissage.quadrillageCroise:
	      d = "M 0 0 L 6 6 M 6 0 L 0 6";
	  }
	  path.setAttribute("d", d);
	  path.setAttribute("style", style);
	  p.appendChild(path);
	  p.setAttribute("id", this.index + "mtg32pattern");
	  this.pattern.appendChild(p);
	  svg.appendChild(this.pattern);
	};

/***/ },
/* 115 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	/**
	 * Sert à définir les différents types de remplissage.
	 * @type mtg32.StyleRemplissage
	 */
	var StyleRemplissage = {
	  quadrillageVertical: 0,
	  quadrillageHorizontal: 1,
	  quadrillage45Haut: 2,
	  quadrillage45Bas: 3,
	  quadrillagePlein: 4,
	  quadrillagePleinTransp: 5,
	  quadrillageCroise: 6
	};
	module.exports = StyleRemplissage;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CElementGraphique = __webpack_require__(39);
	module.exports = CSurfaceAncetre;
	
	/**
	 * Classe ancêtre de toutes les surfaces.
	 * @constructor
	 * @extends CElementGraphique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 */
	function CSurfaceAncetre(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CElementGraphique.call(this, listeProprietaire);else {
	    CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 16);
	    this.styleRemplissage = styleRemplissage;
	  }
	}
	CSurfaceAncetre.prototype = new CElementGraphique();
	CSurfaceAncetre.prototype.constructor = CSurfaceAncetre;
	CSurfaceAncetre.prototype.superClass = "CElementGraphique";
	CSurfaceAncetre.prototype.className = "CSurfaceAncetre";
	
	CSurfaceAncetre.prototype.getNature = function () {
	  return NatObj.NSurface;
	};
	CSurfaceAncetre.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.styleRemplissage === p.styleRemplissage;
	  } else return false;
	};
	CSurfaceAncetre.prototype.chaineDesignation = function () {
	  return "desSurface";
	};
	CSurfaceAncetre.prototype.peutGenererLieuObjet = function () {
	  return false;
	};
	CSurfaceAncetre.prototype.read = function (inps, list) {
	  CElementGraphique.prototype.read.call(this, inps, list);
	  this.styleRemplissage = inps.readInt();
	};
	CSurfaceAncetre.prototype.write = function (oups, list) {
	  CElementGraphique.prototype.write.call(this, oups, list);
	  oups.writeInt(this.styleRemplissage);
	};

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	var NatCal = __webpack_require__(5);
	var CFonc = __webpack_require__(53);
	var CConstante = __webpack_require__(45);
	var COp = __webpack_require__(51);
	var Ope = __webpack_require__(32);
	var CalcR = __webpack_require__(55);
	module.exports = CDerivee;
	
	/**
	 * Classe représentant une fonction qui est la dérivée d'un fonction utilisateur
	 * à une variable définie par l'utilisateur.
	 * Elle est calculée de façon formelle (mais non simplifiée).
	 * @constructor
	 * @extends CFonc
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {String} nomCalcul : Le nom de la fonction dérivée.
	 * @param {CFonc} fonctionAssociee : La fonction dont c'est la dérivée.
	 * @param {CCb} calcul : un calcul donnant la dérivée (peut être null).
	 * @returns {CDerivee}
	 */
	function CDerivee(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, calcul) {
	  var calc;
	  if (arguments.length === 1) CFonc.call(this, listeProprietaire);else {
	    if (arguments.length === 5) calc = null;else calc = calcul;
	    CFonc.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, "", calc);
	    this.fonctionAssociee = fonctionAssociee;
	    if (calc === null && fonctionAssociee !== null) this.creeCalcul();
	  }
	}
	CDerivee.prototype = new CFonc();
	CDerivee.prototype.constructor = CDerivee;
	CDerivee.prototype.superClass = "CFonc";
	CDerivee.prototype.className = "CDerivee";
	
	CDerivee.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var ind2 = listeSource.indexOf(this.fonctionAssociee);
	  var ptelb = new CDerivee(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind2, "CFonc"), null);
	  if (listeCible.className !== "CPrototype") ptelb.creeCalcul();
	  return ptelb;
	};
	CDerivee.prototype.reconstruitChaineCalcul = function () {
	  this.chaineCalcul = "";
	};
	CDerivee.prototype.metAJour = function () {
	  if (!this.fonctionAssociee.deriveePossible(0)) this.calcul = new COp(this.listeProprietaire, new CConstante(this.listeProprietaire, 1), new CConstante(this.listeProprietaire, 0), Ope.Divi);else this.creeCalcul();
	};
	CDerivee.prototype.getNatureCalcul = function () {
	  return NatCal.NDerivee;
	};
	CDerivee.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CFonc.prototype.dependDe.call(this, p) || this.fonctionAssociee.dependDe(p));
	};
	CDerivee.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.fonctionAssociee.dependDePourBoucle(p);
	};
	CDerivee.prototype.positionne = function () {
	  this.existe = this.fonctionAssociee.existe;
	};
	/**
	 * Fonction appelée pour les exercices de calcul et qui doit recalculer tous les éléments de la figure.
	 * Donc ici il faut recalculer la formule de la dérivée
	 * @returns {undefined}
	 */
	CDerivee.prototype.positionneFull = function () {
	  this.existe = this.fonctionAssociee.existe;
	  if (this.existe) {
	    if (!this.fonctionAssociee.deriveePossible(0)) this.calcul = new COp(this.listeProprietaire, new CConstante(this.listeProprietaire, 1), new CConstante(this.listeProprietaire, 0), Ope.Divi);else this.creeCalcul();
	  }
	};
	/**
	 * Calcula la dérivée et l'affecte à this.calcul
	 * @returns {undefined}
	 */
	CDerivee.prototype.creeCalcul = function () {
	  this.calcul = CalcR.creeDerivee(this.fonctionAssociee.calcul, 0);
	};
	CDerivee.prototype.read = function (inps, list) {
	  CFonc.prototype.readSansCalcul.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.fonctionAssociee = list.get(ind1, "CFonc");
	  if (list.className !== "CPrototype") {
	    if (!this.fonctionAssociee.deriveePossible(0)) this.calcul = new COp(this.listeProprietaire, new CConstante(this.listeProprietaire, 1), new CConstante(this.listeProprietaire, 0), Ope.Divi);else this.creeCalcul();
	  }
	};
	CDerivee.prototype.write = function (oups, list) {
	  CFonc.prototype.writeSansCalcul.call(this, oups, list);
	  var ind1 = list.indexOf(this.fonctionAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Ope = __webpack_require__(32);
	var CCalculAncetre = __webpack_require__(35);
	var CalcR = __webpack_require__(55);
	var CConstante = __webpack_require__(45);
	var COp = __webpack_require__(51);
	var CFoncNVar = __webpack_require__(119);
	module.exports = CDeriveePartielle;
	
	// Attention : Ordre des 3 derniers paramètres inversés par rapport à version Java
	/**
	 * Classe représentant une dérivée partielle d'une fonction utilisateur à 2 ou 3 variables
	 * par rapport à une de ses variables.
	 * @constructor
	 * @extends CFoncNVar
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {String} nomCalcul : Le nom de la fonction dérivée.
	 * @param {CFonc} fonctionAssociee : La fonction dont c'est la dérivée.
	 * @param {Integer} indiceVariableDerivation : Donne la variable par rapport à laquelle on dérivé (0 pour lapremière variable).
	 * @param {CCb} calcul : Le calcul de la dérivée (peut être null).
	 * @returns {CDeriveePartielle}
	 */
	function CDeriveePartielle(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, indiceVariableDerivation, calcul) {
	  if (arguments.length === 1) CFoncNVar.call(this, listeProprietaire);else {
	    if (arguments.length <= 6) calcul = null;
	    // Ne pas appeler le constructeur de CFoncNVar car calcul peut être null
	    /*
	    CFoncNVar.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul,
	      fonctionAssociee.chaineVariable, calcul)
	    ;*/
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.fonctionAssociee = fonctionAssociee;
	    this.indiceVariableDerivation = indiceVariableDerivation;
	    this.calcul = calcul;
	    if (fonctionAssociee !== null) {
	      this.nbVar = fonctionAssociee.nombreVariables();
	      if (calcul === null) this.creeCalcul();
	    }
	  }
	}
	CDeriveePartielle.prototype = new CFoncNVar();
	CDeriveePartielle.prototype.constructor = CDeriveePartielle;
	CDeriveePartielle.prototype.superClass = "CFoncNVar";
	CDeriveePartielle.prototype.className = "CDeriveePartielle";
	
	CDeriveePartielle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var ind2 = listeSource.indexOf(this.fonctionAssociee);
	  var ptelb = new CDeriveePartielle(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind2, "CFoncNVar"), this.indiceVariableDerivation, null);
	  if (listeCible.className !== "CPrototype") ptelb.creeCalcul();
	  return ptelb;
	};
	
	CDeriveePartielle.prototype.nombreVariables = function () {
	  return this.fonctionAssociee.nombreVariables();
	};
	CDeriveePartielle.prototype.reconstruitChaineCalcul = function () {
	  this.chaineCalcul = "";
	};
	CDeriveePartielle.prototype.metAJour = function () {
	  if (!this.fonctionAssociee.deriveePossible(this.indiceVariableDerivation)) this.calcul = new COp(this.listeProprietaire, new CConstante(this.listeProprietaire, 1), new CConstante(this.listeProprietaire, 0), Ope.Divi);else this.creeCalcul();
	};
	CDeriveePartielle.prototype.getNatureCalcul = function () {
	  return NatCal.NDeriveePartielle;
	};
	CDeriveePartielle.prototype.variableFormelle = function () {
	  return this.fonctionAssociee.variableFormelle();
	};
	CDeriveePartielle.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CFoncNVar.prototype.dependDe.call(this, p) || this.fonctionAssociee.dependDe(p));
	};
	CDeriveePartielle.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.fonctionAssociee.dependDePourBoucle(p);
	};
	CDeriveePartielle.prototype.confonduAvec = function (p) {
	  // CDeriveePartielle pt;
	  if (p.className === this.className()) {
	    // pt = (CDeriveePartielle) p;
	    return this.fonctionAssociee === p.fonctionAssociee && this.indiceVariableDerivation === p.indiceVariableDerivation;
	  } else return false;
	};
	CDeriveePartielle.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.fonctionAssociee.existe;
	};
	/**
	 * Fonction appelée pour les exercices de calcul et qui doit recalculer tous les éléments de la figure.
	 * Donc ici il faut recalculer la formule de la dérivée
	 * @returns {undefined}
	 */
	CDeriveePartielle.prototype.positionneFull = function () {
	  this.existe = this.fonctionAssociee.existe;
	  if (this.existe) {
	    if (!this.fonctionAssociee.deriveePossible(0)) if (!this.fonctionAssociee.deriveePossible(this.indiceVariableDerivation)) this.calcul = new COp(this.listeProprietaire, new CConstante(this.listeProprietaire, 1), new CConstante(this.listeProprietaire, 0), Ope.Divi);else this.creeCalcul();
	  }
	};
	
	/**
	 * Calcula la formule de la dérivée partielle et la met dans this.
	 * @returns {undefined}
	 */
	CDeriveePartielle.prototype.creeCalcul = function () {
	  this.calcul = CalcR.creeDerivee(this.fonctionAssociee.calcul, this.indiceVariableDerivation);
	};
	CDeriveePartielle.prototype.read = function (inps, list) {
	  CFoncNVar.prototype.readSansCalcul.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.fonctionAssociee = list.get(ind1, "CFoncNVar");
	  this.nbVar = this.fonctionAssociee.nbVar;
	  this.indiceVariableDerivation = inps.readInt();
	  if (list.classname !== "CPrototype") {
	    if (!this.fonctionAssociee.deriveePossible(this.indiceVariableDerivation)) this.calcul = new COp(this.listeProprietaire, new CConstante(this.listeProprietaire, 1), new CConstante(this.listeProprietaire, 0), Ope.Divi);else this.creeCalcul();
	  }
	};
	CDeriveePartielle.prototype.write = function (oups, list) {
	  CFoncNVar.prototype.writeSansCalcul.call(this, oups, list);
	  var ind1 = list.indexOf(this.fonctionAssociee);
	  oups.writeInt(ind1);
	  oups.writeInt(this.indiceVariableDerivation);
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CalcR = __webpack_require__(55);
	var CCalcul = __webpack_require__(54);
	module.exports = CFoncNVar;
	
	// Attention : Ordre des deux derniers paramètres inverses par rapport à version Java
	/**
	 * Fonction réelle de n variables.
	 * @constructor
	 * @extends CCalcul
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet
	 * @param {Boolean} estElementFinal : true si l'objet est un objet inal de construction
	 * @param {String} nomCalcul : Le nom de la fonction.
	 * @param {String} chaineCalcul : La formule définissnt la fonction
	 * @param {Arrray} chaineVariable : Un array de String donnant les variables formelles.
	 * @param {CCb} calcul : Un arbre binaire de calcul représentant la fonction.
	 * @returns {undefined}
	 */
	function CFoncNVar(listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, chaineVariable, calcul) {
	  var calc;
	  if (arguments.length === 0) return;
	  if (arguments.length === 1) CCalcul.call(this, listeProprietaire);else {
	    if (arguments.length <= 6) calc = null;else calc = calcul;
	    if (typeof chaineVariable === "number") {
	      // Constructeur sécial pour CDeriveePartielle
	      this.nbVar = chaineVariable;
	      this.chaineVariable = null;
	      CCalcul.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, calc);
	    } else {
	      this.chaineVariable = chaineVariable; // ChaineVariable est un Array de String
	      this.nbVar = chaineVariable.length;
	      if (calc === null && chaineCalcul.length !== 0) CCalcul.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, CalcR.ccb(chaineCalcul, listeProprietaire, 0, chaineCalcul.length - 1, chaineVariable));else CCalcul.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, calc);
	    }
	  }
	}
	CFoncNVar.prototype = new CCalcul();
	CFoncNVar.prototype.constructor = CFoncNVar;
	CFoncNVar.prototype.superClass = "CCalcul";
	CFoncNVar.prototype.className = "CFoncNVar";
	
	/**
	 * Fonction renvoyant un pointeur sur le tableau de chaînes représentant les variables de la fonction
	 * Devra être redéfini pour CDeriveePartielle
	 * @returns {Arrray|Array}
	 */
	CFoncNVar.prototype.chaineVariable = function () {
	  return this.chaineVariable;
	};
	CFoncNVar.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var calculClone = this.calcul.getClone(listeSource, listeCible);
	  return new CFoncNVar(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, this.chaineCalcul, this.chaineVariable, calculClone);
	};
	CFoncNVar.prototype.getNatureCalcul = function () {
	  switch (this.nbVar) {
	    case 2:
	      return NatCal.NFonction2Var;
	    case 3:
	      return NatCal.NFonction3Var;
	    default:
	      return NatCal.NFoncPlusieursVar;
	  }
	};
	CFoncNVar.prototype.nombreVariables = function () {
	  return this.nbVar;
	};
	CFoncNVar.prototype.rendValeurFonction = function (infoRandom, parametre) {
	  return this.calcul.resultatFonction(infoRandom, parametre);
	};
	CFoncNVar.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.calcul.existePourFonc();
	};
	CFoncNVar.prototype.reconstruitChaineCalcul = function () {
	  this.chaineCalcul = this.calcul.chaineCalculSansPar(this.chaineVariable);
	};
	CFoncNVar.prototype.read = function (inps, list) {
	  CCalcul.prototype.read.call(this, inps, list);
	  this.nbVar = inps.readInt();
	  this.chaineVariable = new Array(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    this.chaineVariable[i] = inps.readUTF();
	  }
	};
	CFoncNVar.prototype.write = function (oups, list) {
	  CCalcul.prototype.write.call(this, oups, list);
	  oups.writeInt(this.nbVar);
	  for (var i = 0; i < this.nbVar; i++) {
	    oups.writeUTF(this.chaineVariable[i]);
	  }
	};
	CFoncNVar.prototype.estFonctionOuSuite = function () {
	  return true;
	};
	CFoncNVar.prototype.rendValeurFonctionComplexe = function (infoRandom, parametre, zRes) {
	  this.calcul.resultatFonctionComplexe(infoRandom, parametre, zRes);
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDroite = __webpack_require__(98);
	module.exports = CDroiteAB;
	
	/**
	 * Droite définie par deux points a et b.
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {CPt} a : le premier point de la droite.
	 * @param {CPt} b : Le deuxième point de la droite.
	 * @returns {CDroiteAB}
	 */
	function CDroiteAB(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, a, b) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.a = a;
	    this.b = b;
	  }
	}
	CDroiteAB.prototype = new CDroite();
	CDroiteAB.prototype.constructor = CDroiteAB;
	CDroiteAB.prototype.superClass = "CDroite";
	CDroiteAB.prototype.className = "CDroiteAB";
	
	CDroiteAB.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.b);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CDroiteAB(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"));
	};
	
	CDroiteAB.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.a);
	  liste.add(this.b);
	};
	
	CDroiteAB.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.a.dependDe(p) || this.b.dependDe(p));
	};
	
	CDroiteAB.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.b.dependDePourBoucle(p);
	};
	
	CDroiteAB.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.a.existe && this.b.existe;
	  if (!this.existe) return;
	  this.point_x = this.a.x;
	  this.point_y = this.a.y;
	  this.vect.x = this.b.x - this.a.x;
	  this.vect.y = this.b.y - this.a.y;
	  CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CDroiteAB.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.a === p.a && this.b === p.b || this.b === p.a && this.a === p.b;else return false;
	};
	
	CDroiteAB.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	  if (this.b === ancienPoint) this.b = nouveauPoint;
	};
	
	CDroiteAB.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.a = list.get(ind1, "CPt");
	  this.b = list.get(ind2, "CPt");
	};
	
	CDroiteAB.prototype.contientParDefinition = function (po) {
	  return this.a === po || this.b === po;
	};
	
	CDroiteAB.prototype.estParalleleParDefinition = function (dte) {
	  return dte === this || this.a.appartientDroiteParDefinition(dte) && this.b.appartientDroiteParDefinition(dte) || dte.formentDroiteParallele(this.a, this.b);
	};
	
	CDroiteAB.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.a);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.b);
	  oups.writeInt(ind2);
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDroite = __webpack_require__(98);
	module.exports = CDroiteClone;
	
	/**
	 * Classe représentant une droite clone d'une autre droite.
	 * Il s'agit d'un autre objet avec exactement les mêmes cractéristiques géométriques.
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : tuue si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {CDroite} droite : La droite dont this est clone.
	 * @returns {CDroiteClone}
	 */
	function CDroiteClone(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, droite) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.droite = droite;
	  }
	}
	CDroiteClone.prototype = new CDroite();
	CDroiteClone.prototype.constructor = CDroiteClone;
	CDroiteClone.prototype.superClass = "CDroite";
	CDroiteClone.prototype.className = "CDroiteClone";
	
	CDroiteClone.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.droite);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CDroiteClone(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CDroite"));
	};
	
	CDroiteClone.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.droite.dependDe(p));
	};
	
	CDroiteClone.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.droite.dependDePourBoucle(p);
	};
	
	CDroiteClone.prototype.positionne = function () {
	  var b = this.masque;
	  this.setClone(this.droite);
	  this.masque = b;
	};
	
	CDroiteClone.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.droite);
	};
	
	CDroiteClone.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.droite = list.get(ind1, "CDroite");
	};
	
	CDroiteClone.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.droite);
	  oups.writeInt(ind1);
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDroite = __webpack_require__(98);
	module.exports = CDroiteDirectionFixe;
	
	/**
	 * Classe représentant une droite horizontale ou verticale et définie par un point.
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {CPt} a : Le point par lequel la droite
	 * @param {Boolean} droiteHorizontale : true pour une droite horizontale, fausse pour une verticale.
	 * @param {Number} longueurVecteur : Longuer du vecteur directeur.
	 * @returns {CDroiteDirectionFixe}
	 */
	function CDroiteDirectionFixe(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, a, droiteHorizontale, longueurVecteur) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.a = a;
	    this.droiteHorizontale = droiteHorizontale;
	    this.longueurVecteur = longueurVecteur;
	    if (droiteHorizontale) {
	      this.vect.x = longueurVecteur;
	      this.vect.y = 0;
	    } else {
	      this.vect.x = 0;
	      this.vect.y = longueurVecteur;
	    }
	  }
	}
	CDroiteDirectionFixe.prototype = new CDroite();
	CDroiteDirectionFixe.prototype.constructor = CDroiteDirectionFixe;
	CDroiteDirectionFixe.prototype.superClass = "CDroite";
	CDroiteDirectionFixe.prototype.className = "CDroiteDirectionFixe";
	
	CDroiteDirectionFixe.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CDroiteDirectionFixe(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CPt"), this.droiteHorizontale, this.longueurVecteur);
	};
	
	CDroiteDirectionFixe.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.droiteHorizontale === p.droiteHorizontale && this.a === p.A;
	  } else return false;
	};
	
	CDroiteDirectionFixe.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.a.dependDe(p));
	};
	
	CDroiteDirectionFixe.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p);
	};
	
	CDroiteDirectionFixe.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.a.existe;
	  if (!this.existe) return;
	  this.point_x = this.a.x;
	  this.point_y = this.a.y;
	  CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CDroiteDirectionFixe.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.a);
	};
	
	CDroiteDirectionFixe.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	};
	
	CDroiteDirectionFixe.prototype.zoom = function (rapport) {
	  this.longueurVecteur = this.longueurVecteur * rapport;
	  if (this.droiteHorizontale) this.vect.x = this.longueurVecteur;else this.vect.y = this.longueurVecteur;
	};
	
	CDroiteDirectionFixe.prototype.contientParDefinition = function (po) {
	  return this.a === po;
	};
	
	CDroiteDirectionFixe.prototype.estParalleleParDefinition = function (dte) {
	  return dte === this || dte.className === "CDroiteDirectionFixe" && (dte.droiteHorizontale = this.droiteHorizontale) || dte.estParalleleParDefinition(this);
	};
	
	CDroiteDirectionFixe.prototype.estPerpendiculaireParDefinition = function (dte) {
	  return dte.className === "CDroiteDirectionFixe" && dte.droiteHorizontale !== this.droiteHorizontale || dte.estParalleleParDefinition(this);
	};
	
	CDroiteDirectionFixe.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.a = list.get(ind1, "CPt");
	  this.droiteHorizontale = inps.readBoolean();
	  this.longueurVecteur = inps.readDouble();
	  if (this.droiteHorizontale) {
	    this.vect.x = this.longueurVecteur;
	    this.vect.y = 0;
	  } else {
	    this.vect.x = 0;
	    this.vect.y = this.longueurVecteur;
	  }
	};
	
	CDroiteDirectionFixe.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.a);
	  oups.writeInt(ind1);
	  oups.writeBoolean(this.droiteHorizontale);
	  oups.writeDouble(this.longueurVecteur);
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDroite = __webpack_require__(98);
	var CTransformation = __webpack_require__(100);
	module.exports = CDroiteImage;
	
	/**
	 * Droite image d'une autre par une transformation.
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé.
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {CDroite} antecedent : droite dont this est l'image.
	 * @param {type} transformation : La transformation utilisée.
	 * @returns {CDroiteImage}
	 */
	function CDroiteImage(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, antecedent, transformation) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.antecedent = antecedent;
	    this.transformation = transformation;
	  }
	}
	CDroiteImage.prototype = new CDroite();
	CDroiteImage.prototype.constructor = CDroiteImage;
	CDroiteImage.prototype.superClass = "CDroite";
	CDroiteImage.prototype.className = "CDroiteImage";
	
	CDroiteImage.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.antecedent);
	  var ind2 = listeSource.indexOf(this.transformation);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CDroiteImage(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CDroite"), listeCible.get(ind2, "CTransformation"));
	};
	
	CDroiteImage.prototype.ajouteAntecedents = function (liste, app) {
	  liste.add(this.antecedent);
	  this.transformation.ajouteAntecedents(liste, app);
	};
	
	CDroiteImage.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.antecedent.dependDe(p) || this.transformation.dependDe(p));
	};
	
	CDroiteImage.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.antecedent.dependDePourBoucle(p) || this.transformation.dependDePourBoucle(p);
	};
	
	CDroiteImage.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.transformation.existe && this.antecedent.existe;
	  if (!this.existe) return;
	  var point1 = {};
	  this.transformation.transformePoint(this.antecedent.point_x, this.antecedent.point_y, point1);
	  this.point_x = point1.x;
	  this.point_y = point1.y;
	  this.transformation.transformeVecteur(this.antecedent.vect, this.vect);
	  CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CDroiteImage.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.antecedent === p.antecedent && this.transformation.confonduAvec(p.transformation);
	  } else return false;
	};
	
	CDroiteImage.prototype.contientParDefinition = function (po) {
	  if (po.estPointImage()) {
	    return this.transformation === po.transformation && po.antecedent.appartientDroiteParDefinition(this.antecedent);
	  } else return false;
	};
	
	CDroiteImage.prototype.estParalleleParDefinition = function (dte) {
	  return dte === this || (this.transformation.natureTransformation() & (CTransformation.translation | CTransformation.homothetie | CTransformation.symetrieCentrale)) !== 0 && (this.antecedent.estParalleleParDefinition(dte) || dte.estParalleleParDefinition(antecedent));
	};
	
	CDroiteImage.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.antecedent = list.get(ind1, "CDroite");
	  this.transformation = list.get(ind2, "CTransformation");
	};
	
	CDroiteImage.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.antecedent);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.transformation);
	  oups.writeInt(ind2);
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDroite = __webpack_require__(98);
	var CValeur = __webpack_require__(80);
	module.exports = CDroiteOm;
	
	/**
	 * Droite définie par un point et son coefficient directeur dans un repère.
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé.
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {CRepere} rep :  Le repère dans lequel la droite est donnée.
	 * @param {CPt} o : Un point de la droite
	 * @param {type} m : Le coefficient directeur de la droite.
	 * @returns {CDroiteOm}
	 */
	function CDroiteOm(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, rep, o, m) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.rep = rep;
	    this.o = o;
	    this.m = m;
	  }
	}
	CDroiteOm.prototype = new CDroite();
	CDroiteOm.prototype.constructor = CDroiteOm;
	CDroiteOm.prototype.superClass = "CDroite";
	CDroiteOm.prototype.className = "CDroiteOm";
	
	CDroiteOm.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.o);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var mClone = this.m.getClone(listeSource, listeCible);
	  return new CDroiteOm(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CRepere"), listeCible.get(ind2, "CPt.class"), mClone);
	};
	
	CDroiteOm.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.o);
	};
	
	CDroiteOm.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.o.dependDe(p) || this.rep.dependDe(p) || this.m.dependDe(p));
	};
	
	CDroiteOm.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.o.dependDePourBoucle(p) || this.rep.dependDePourBoucle(p) || this.m.dependDePourBoucle(p);
	};
	
	CDroiteOm.prototype.positionne = function (infoRandom, dimfen) {
	  this.m.positionne(infoRandom, dimfen);
	  this.existe = this.rep.existe && this.o.existe && this.m.existe;
	  if (this.existe) {
	    this.point_x = this.o.x;
	    this.point_y = this.o.y;
	    var k = this.m.rendValeur(infoRandom);
	    var unitex = this.rep.unitex;
	    var unitey = this.rep.unitey;
	    this.vect.x = this.rep.u.x / unitex + k * this.rep.v.x / unitey;
	    this.vect.y = this.rep.u.y / unitex + k * this.rep.v.y / unitey;
	    CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	  }
	};
	
	CDroiteOm.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.rep === p.rep && this.o === p.o && this.m.confonduAvec(p.m);else return false;
	};
	
	CDroiteOm.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.o === ancienPoint) this.o = nouveauPoint;
	};
	
	CDroiteOm.prototype.contientParDefinition = function (po) {
	  return this.o === po;
	};
	
	CDroiteOm.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.rep = list.get(ind1, "CRepere");
	  this.o = list.get(ind2, "CPointAncetre");
	  this.m = new CValeur();
	  this.m.read(inps, list);
	};
	
	CDroiteOm.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.rep);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.o);
	  oups.writeInt(ind2);
	  this.m.write(oups, list);
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDroite = __webpack_require__(98);
	var CalcR = __webpack_require__(55);
	module.exports = CDroiteParEq;
	
	/**
	 * Droite définie par une équation cartésienne dans un repère.
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé.
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {CRepere} rep : Le repère dans lequel l'équation est donnée.
	 * @param {CCb} equation : Un calcul représentant l'équation de la droite (avec un test d'égalité).
	 * Ce calcul n'est pas forcément simplifié. Il est enregistré dans le flux binaire.
	 * @param {CCb} fonction : Une fonction de deux variables x et y avec une formule de
	 * la forme a*x+b*y+c = 0.Ce calcul est enregistré dans le flux binaire.
	 * @returns {CDroiteParEq}
	 */
	function CDroiteParEq(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, rep, equation, fonction) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.rep = rep;
	    this.equation = equation;
	    this.fonction = fonction;
	  }
	}
	CDroiteParEq.prototype = new CDroite();
	CDroiteParEq.prototype.constructor = CDroiteParEq;
	CDroiteParEq.prototype.superClass = "CDroite";
	CDroiteParEq.prototype.className = "CDroiteParEq";
	
	CDroiteParEq.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CDroiteParEq.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var equationClone = this.equation.getClone(listeSource, listeCible);
	  var fonctionClone = this.fonction.getClone(listeSource, listeCible);
	  var ptelb = new CDroiteParEq(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CRepere"), equationClone, fonctionClone);
	  if (listeCible.className !== "CPrototype") {
	    ptelb.calcula = CalcR.creeDerivee(fonctionClone, 0);
	    ptelb.calculb = CalcR.creeDerivee(fonctionClone, 1);
	    ptelb.bEquationValide = ptelb.equationValide();
	  }
	  return ptelb;
	};
	
	CDroiteParEq.prototype.metAJour = function () {
	  this.calcula = CalcR.creeDerivee(this.fonction, 0);
	  this.calculb = CalcR.creeDerivee(this.fonction, 1);
	  this.bEquationValide = this.equationValide();
	};
	
	CDroiteParEq.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.rep.dependDe(p) || this.equation.dependDe(p));
	};
	
	CDroiteParEq.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.rep.dependDePourBoucle(p) || this.equation.dependDePourBoucle(p);
	};
	
	CDroiteParEq.prototype.positionne = function (infoRandom, dimfen) {
	  var nor, unitex, unitey, x1, y1, param, d, par;
	  if (!this.bEquationValide) {
	    this.existe = false;
	    return;
	  }
	  this.existe = this.rep.existe && this.equation.existe(infoRandom);
	  if (this.existe) {
	    try {
	      this.listeProprietaire.initialiseNombreIterations();
	      // calcula et calculb sont des fonctions de deux variables
	      par = new Array(2);
	      par[0] = 1;
	      par[1] = 0;
	      this.a = this.calcula.resultatFonction(infoRandom, par);
	      par[0] = 0;
	      par[1] = 1;
	      this.b = this.calculb.resultatFonction(infoRandom, par);
	      if (this.a === 0 && this.b === 0) {
	        this.existe = false;
	        return;
	      }
	      // Le coefficient c est calculé comme l'image par la fonction de deux variables du couple (0;0)
	      param = new Array(2);
	      param[0] = 0;
	      param[1] = 0;
	      this.c = this.fonction.resultatFonction(infoRandom, param);
	    } catch (e) {
	      this.existe = false;
	      return;
	    }
	    if (!isFinite(this.a) || !isFinite(this.b) || !isFinite(this.c) || this.a === 0 && this.b === 0) {
	      this.existe = false;
	      return;
	    }
	    nor = Math.sqrt(this.a * this.a + this.b * this.b);
	    unitex = this.rep.unitex;
	    unitey = this.rep.unitey;
	    x1 = -this.b / nor / unitex;
	    y1 = this.a / nor / unitey;
	    this.vect.x = this.rep.u.x * x1 + this.rep.v.x * y1;
	    this.vect.y = this.rep.u.y * x1 + this.rep.v.y * y1;
	    if (this.b !== 0) {
	      d = -this.c / this.b / unitey;
	      if (Math.abs(d) > 1e5 && a !== 0) {
	        // Droite quasi parallèle à l'axe des ordonnées
	        // On cherche alors le point d'intersection avec l'axe des abscisses
	        d = -this.c / this.a / unitex;
	        this.point_x = this.rep.origine.x + d * this.rep.u.x;
	        this.point_y = this.rep.origine.y + d * this.rep.u.y;
	      }
	      // Sinon point d'intersection avec l'axe des ordonnées
	      else {
	          this.point_x = this.rep.origine.x + d * this.rep.v.x;
	          this.point_y = this.rep.origine.y + d * this.rep.v.y;
	        }
	    } else {
	      d = -this.c / this.a / unitex;
	      this.point_x = this.rep.origine.x + d * this.rep.u.x;
	      this.point_y = this.rep.origine.y + d * this.rep.u.y;
	    }
	    CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	  }
	};
	
	/**
	 * Fonction renvoyant true si l'équation de la droite est valide.
	 * @returns {Boolean}
	 */
	CDroiteParEq.prototype.equationValide = function () {
	  return (this.fonction.dependDeVariable(0) || this.fonction.dependDeVariable(1)) && !this.calcula.dependDeVariable(0) && !this.calcula.dependDeVariable(1) && !this.calculb.dependDeVariable(0) && !this.calculb.dependDeVariable(1);
	};
	
	CDroiteParEq.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.rep = list.get(ind1, "CRepere");
	  this.equation = inps.readObject(list);
	  this.fonction = inps.readObject(list);
	  if (list.className !== "CPrototype") {
	    this.calcula = CalcR.creeDerivee(this.fonction, 0); // Dérivée partielle par rapport à x
	    this.calculb = CalcR.creeDerivee(this.fonction, 1); // Dérivée partielle par rapport à y
	    this.bEquationValide = this.equationValide();
	  }
	};
	
	CDroiteParEq.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.rep);
	  oups.writeInt(ind1);
	  oups.writeObject(this.equation);
	  oups.writeObject(this.fonction);
	};

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDroite = __webpack_require__(98);
	module.exports = CDroiteParallele;
	
	/**
	 * Droite passant par un point et parallèle à une droite donnée (ou sement ou vecteur ou demi-droite).
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé.
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {CPt} a : un point de la droite.
	 * @param {CDroiteAncetre} d : La droite à laquelle this est parallèle.
	 * @returns {CDroiteParallele}
	 */
	function CDroiteParallele(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, a, d) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.a = a;
	    this.d = d;
	  }
	}
	CDroiteParallele.prototype = new CDroite();
	CDroiteParallele.prototype.constructor = CDroiteParallele;
	CDroiteParallele.prototype.superClass = "CDroite";
	CDroiteParallele.prototype.className = "CDroiteParallele";
	
	CDroiteParallele.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.d);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CDroiteParallele(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CDroiteAncetre"));
	};
	
	CDroiteParallele.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.a);
	  liste.add(this.d);
	};
	
	CDroiteParallele.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.a.dependDe(p) || this.d.dependDe(p));
	};
	
	CDroiteParallele.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.d.dependDePourBoucle(p);
	};
	
	CDroiteParallele.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.d.existe && this.a.existe;
	  if (!this.existe) return;
	  this.point_x = this.a.x;
	  this.point_y = this.a.y;
	  this.d.vect.setCopy(this.vect);
	  CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CDroiteParallele.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.a === p.a && this.d === p.d;else return false;
	};
	
	CDroiteParallele.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	};
	
	CDroiteParallele.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.a = list.get(ind1, "CPt");
	  this.d = list.get(ind2, "CDroiteAncetre");
	};
	
	CDroiteParallele.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.a);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.d);
	  oups.writeInt(ind2);
	};
	
	CDroiteParallele.prototype.contientParDefinition = function (po) {
	  return this.a === po;
	};
	
	CDroiteParallele.prototype.estParalleleParDefinition = function (dte) {
	  return dte === this || dte === this.d || this.d.estParalleleParDefinition(dte) || dte.estParalleleParDefinition(this.d);
	};
	
	CDroiteParallele.prototype.estPerpendiculaireParDefinition = function (dte) {
	  return this.d.estPerpendiculaireParDefinition(dte) || dte.estPerpendiculaireParDefinition(this.d);
	};

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CDroite = __webpack_require__(98);
	module.exports = CDroitePerpendiculaire;
	
	/**
	 * Droite passant par un point et perpendiculaire à une droite donnée (ou sement ou vecteur ou demi-droite).
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * pas les segments ni demi-droites.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé.
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {type} a
	 * @param {type} d
	 * @returns {CDroitePerpendiculaire}
	 */
	function CDroitePerpendiculaire(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, a, d) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.a = a;
	    this.d = d;
	  }
	}
	CDroitePerpendiculaire.prototype = new CDroite();
	CDroitePerpendiculaire.prototype.constructor = CDroitePerpendiculaire;
	CDroitePerpendiculaire.prototype.superClass = "CDroite";
	CDroitePerpendiculaire.prototype.className = "CDroitePerpendiculaire";
	
	CDroitePerpendiculaire.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.d);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CDroitePerpendiculaire(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CDroiteAncetre"));
	};
	
	CDroitePerpendiculaire.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.a);
	  liste.add(this.d);
	};
	CDroitePerpendiculaire.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.a.dependDe(p) || this.d.dependDe(p));
	};
	
	CDroitePerpendiculaire.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.d.dependDePourBoucle(p);
	};
	
	CDroitePerpendiculaire.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.a.existe && this.d.existe;
	  if (!this.existe) return;
	  this.point_x = this.a.x;
	  this.point_y = this.a.y;
	  this.d.vect.getOrthogonal(this.vect);
	  CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CDroitePerpendiculaire.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.a === p.a && this.d === p.d;else return false;
	};
	
	CDroitePerpendiculaire.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	};
	
	CDroitePerpendiculaire.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.a = list.get(ind1, "CPt");
	  this.d = list.get(ind2, "CDroiteAncetre");
	};
	
	CDroitePerpendiculaire.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.a);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.d);
	  oups.writeInt(ind2);
	};
	
	CDroitePerpendiculaire.prototype.contientParDefinition = function (po) {
	  return this.a === po;
	};
	
	CDroitePerpendiculaire.prototype.estParalleleParDefinition = function (dte) {
	  return this.d.estPerpendiculaireParDefinition(dte) || dte.estPerpendiculaireParDefinition(this.d);
	};
	
	CDroitePerpendiculaire.prototype.estPerpendiculaireParDefinition = function (dte) {
	  return this.d.estParalleleParDefinition(dte) || dte.estParalleleParDefinition(this.d);
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var Complexe = __webpack_require__(30);
	var Dimf = __webpack_require__(7);
	var Fonte = __webpack_require__(18);
	var Nat = __webpack_require__(4);
	var Opef = __webpack_require__(19);
	var Opef2v = __webpack_require__(20);
	var Opef3v = __webpack_require__(21);
	var Opef4v = __webpack_require__(22);
	var Opef5v = __webpack_require__(23);
	var Pointeur = __webpack_require__(16);
	var StyleEncadrement = __webpack_require__(38);
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CalcR = __webpack_require__(55);
	var CalcC = __webpack_require__(69);
	var CAffichageLieAPoint = __webpack_require__(36);
	module.exports = CEditeurFormule;
	var CLatex = __webpack_require__(40);
	
	/**
	 * Classe représentant un éditeur de formule permettant à l'utilisateur de modifier
	 * la formule d'un calcul sur la figure.
	 * On peut associer à l'éditeur une fonction de callBack nommée callBackOK qui
	 * sera appelée quand l'utilisateur aura validé sa réponse.
	 * @constructor
	 * @extends CAffichageLieAPoint
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de l'éditeur
	 * @param {Float} y_nom : L'ordonnée d'affichage de l'éditeur
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} encadrement : true si encadré.
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {mtg32.CCalcul} calculAssocie : Le calcul dont l'éditeur peut changer la formule.
	 * @param {String} enTete : Ce qui est affiiché devant l'éditeur proprement dit. Encadrer par des $
	 * pour obtenir un affichage LaTeX.
	 * @param {Integer} nbcol : Le nombre de colonnes de l'éditeur.
	 * @param {Boolean} affichageFormule : true si on affiche la formule à droite de l'éditeur.
	 * @param {String} preCodeLaTeX : Donne le code LaTeX de ce qu'il faut afficher entre l'éditeur
	 * et l'affichage de la formule quand cet affichage est demandé.
	 * @param {Boolean} variables1Car : true si on n'utilise que des calculs et variables dont les nomes sont de 1 caractère.
	 * Dans ce cas les signes de multiplications sont omis dans l'affichage de formule s'il est demané.
	 * @param {Boolean} affLaTeXPremierAffichage : true si la formule dit être affichée à droite de l'éditeur
	 * immédiatement après le chargement de la figure.
	 * @param {Boolean} affichageTempsReel : true si l'affichage de formule (en LaTeX) à droite
	 * de l'éditeur doit se faire au fur  * et à mesure que l'utilisateur tape auclavier.
	 * @returns {CEditeurFormule}
	 */
	function CEditeurFormule(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, taillePolice, encadrement, effacementFond, couleurFond, calculAssocie, enTete, nbcol, affichageFormule, preCodeLaTeX, variables1Car, affLaTeXPremierAffichage, affichageTempsReel) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CAffichageLieAPoint.call(this, listeProprietaire);else {
	      CAffichageLieAPoint.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, null, taillePolice, encadrement, effacementFond, couleurFond, CAffichageLieAPoint.alignementHorizontalDroit, CAffichageLieAPoint.alignementVerticalHaut);
	      this.calculAssocie = calculAssocie;
	      this.enTete = enTete;
	      this.nbcol = nbcol;
	      this.affichageFormule = affichageFormule;
	      this.preCodeLaTeX = preCodeLaTeX;
	      this.variables1Car = variables1Car;
	      this.affLaTeXPremierAffichage = affLaTeXPremierAffichage;
	      this.affichageTempsReel = affichageTempsReel;
	    }
	    this.indErr = new Pointeur(0);
	  }
	  this.callBackOK = null; // Ajout version 4.9.3
	}
	CEditeurFormule.prototype = new CAffichageLieAPoint();
	CEditeurFormule.prototype.constructor = CEditeurFormule;
	CEditeurFormule.prototype.superClass = "CAffichageLieAPoint";
	CEditeurFormule.prototype.className = "CEditeurFormule";
	
	CEditeurFormule.prototype.numeroVersion = function () {
	  return 4;
	};
	
	CEditeurFormule.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.calculAssocie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CEditeurFormule(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, this.taillePolice, this.encadrement, this.effacementFond, this.couleurFond, listeCible.get(ind1, "CCalcul"), this.enTete, this.nbcol, this.affichageFormule, this.preCodeLaTeX, this.variables1Car, this.affLaTeXPremierAffichage, this.affichageTempsReel);
	};
	
	CEditeurFormule.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CAffichageLieAPoint.prototype.dependDe.call(this, p) || this.calculAssocie.dependDe(p));
	};
	
	CEditeurFormule.prototype.dependDePourBoucle = function (p) {
	  return CAffichageLieAPoint.prototype.dependDePourBoucle.call(this, p) || this.calculAssocie.dependDePourBoucle(p);
	};
	/**
	 * Fournit la chaîne représentant l'en-tête à afficher devant l'éditeur proprement dit
	 * @returns {String}
	 */
	CEditeurFormule.prototype.rendChaineAffichage = function () {
	  var i;
	  if (this.enTete.length === 0) {
	    var ch = this.calculAssocie.nomCalcul;
	    if (this.calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NFonction, NatCal.NFonctionComplexe))) {
	      // CFonc fonc = (CFonc) calculAssocie;
	      ch = ch + CCb.parouv + this.calculAssocie.chaineVariable + CCb.parfer;
	    } else {
	      if (this.calculAssocie.estDeNatureCalcul(NatCal.NTteFoncRouC)) {
	        // CFoncNVar fonc = (CFoncNVar) calculAssocie;
	        ch = ch + "(";
	        for (i = 0; i < this.calculAssocie.nbVar; i++) {
	          ch = ch + this.calculAssocie.chaineVariable[i];
	          if (i !== this.calculAssocie.nbVar - 1) ch = ch + ',';
	        }
	        ch = ch + ")";
	      }
	    }
	    // if (!this.affichageFormule) ch = ch + " = ";
	    // else ch = ch + "\\;";
	    ch = ch + " = ";
	    // Modification version 4.7.2 : Affichage par défaut en LaTeX de l'en-tête
	    ch = "$" + ch + "$";
	    return ch;
	  } else return this.enTete;
	};
	
	CEditeurFormule.prototype.getNature = function () {
	  return NatObj.NEditeurFormule;
	};
	
	CEditeurFormule.prototype.montre = function () {
	  CAffichageLieAPoint.prototype.montre.call(this);
	  this.divi.style.visibility = "visible";
	  if (this.affichageFormule) {
	    if (this.glatex === undefined) {
	      this.glatex = this.latex.createg();
	      var listePr = this.listeProprietaire;
	      var svg = document.getElementById(listePr.id);
	      svg.appendChild(this.glatex);
	    }
	    this.glatex.setAttribute("visibility", "visible");
	  }
	};
	
	CEditeurFormule.prototype.cache = function () {
	  CAffichageLieAPoint.prototype.cache.call(this);
	  this.divi.style.visibility = "hidden";
	  if (this.affichageFormule && this.glatex) this.glatex.setAttribute("visibility", "hidden");
	};
	
	/**
	 * Fonction appelée pour l'événement onblur de l'éditeur.
	 * Attention this pointe sur le composant
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.onblur = function () {
	  var b = this.owner.validation(true);
	  if (b) this.owner.demarquePourErreur();else this.owner.marquePourErreur();
	};
	/**
	 * Fonction appelée par l'événement onkeyup de l'éditeur
	 * Attention this pointe sur le composant
	 * @param {Event} evt
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.onkeyup = function (evt) {
	  // Non traité si c'est la touche entrée ou une touche de déplacement de curseur
	  var kc = evt.keyCode;
	  // On sort si touche entrée ou déplacement à gauche ou à droite
	  if (evt.charCode === 0 && (kc === 13 || kc === 37 || kc === 39)) return;
	  // On regarde si un set de caractères autorisés a été spécifié :
	  var owner = this.owner;
	  var listePr = owner.listeProprietaire;
	  var svg = document.getElementById(listePr.id);
	  var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	  // var doc = listePr.documentProprietaire;
	  var chCalcul = owner.variables1Car ? listePr.traiteSignesMult(this.value) : this.value;
	  var indErr = owner.indErr;
	
	  var calculAssocie = owner.calculAssocie;
	  // On autorise d'utiliser un calcul non créé par l'utilisateur
	  var indDernier = listePr.indexOf(calculAssocie) - 1;
	  var varFor = calculAssocie.variableFormelle();
	  var bcomplexe = calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NCalculComplexe, NatCal.NFonctionComplexe, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var));
	  if (bcomplexe ? CalcC.verifieSyntaxeComplexe(listePr, chCalcul, indErr, indDernier, varFor) : CalcR.verifieSyntaxe(listePr, chCalcul, indErr, indDernier, varFor)) {
	    owner.demarquePourErreur();
	  }
	  if (owner.affichageFormule && owner.affichageTempsReel) {
	    var calc = bcomplexe ? CalcC.ccbComp(chCalcul, listePr, 0, chCalcul.length - 1, varFor) : CalcR.ccb(chCalcul, listePr, 0, chCalcul.length - 1, varFor);
	    // try rajouté version 4.7.3
	    // cadre.repaintFigureSansCalcul();
	
	    owner.latex.chaineCommentaire = owner.preCodeLaTeX + " " + calc.chaineLatexSansPar(varFor);
	    owner.latex.positionne(false, dimf);
	    owner.latex.setReady4MathJax();
	    /*
	     var newglatex = owner.latex.createg();
	     svg.replaceChild(newglatex, owner.glatex);
	     owner.glatex = newglatex;
	     */
	    MathJax.Hub.Queue([owner.callBack, owner, svg]);
	  }
	};
	/**
	 * Fonction appelée par l'événement onkeypress de l'éditeur
	 * Attention this pointe sur le composant
	 * @param {Event} evt
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.onkeypress = function (evt) {
	  var i, edit, ind, ch, owner, s, b;
	  var self = this;
	  owner = this.owner;
	  if (evt.keyCode === 13) {
	    evt.preventDefault(); // Pour compatibilité avec j3p
	    // evt.stopPropagation(); // Pour compatibilité avec j3p
	    b = owner.validation(true);
	    if (b) owner.demarquePourErreur();else owner.marquePourErreur();
	    // Ajout version 4.9.3
	    if (owner.callBackOK !== null && b && owner.editeur.value.length !== 0) owner.callBackOK.call();
	    //  evt.preventDefault(); // Supprimé version 5.2 pour que le clavier des périphériques mobile se replie
	    // Sinon avec clavier on garde le focus avec le point d'insertion à l'endroit de la faute
	    // Ci-dessous nécessaire d'utiliser la queue de MathJax car sinon on blur peut appeler la fonction
	    // validation() trop tôt
	    if (!owner.listeProprietaire.documentProprietaire.hasMouse) {
	      MathJax.Hub.Queue(function () {
	        self.blur();
	      });
	    }
	    return;
	  }
	  // On regarde si un set de caractères autorisés a été spécifié :
	  if (owner.charset && owner.charset !== "") {
	    if (evt.charCode !== 0 && owner.charset.indexOf(String.fromCharCode(evt.charCode)) === -1) {
	      evt.preventDefault();
	      return;
	    }
	  }
	  if (evt.charCode === 40) {
	    // On tape une parenthèse ouvrante
	    // Si l'expression est correcte au niveau des parenthèses et si le curseur n'est suivi
	    // que d'espaces ou de parenthèses fermantes, on rajoute une parenthèse fermante
	    edit = owner.editeur;
	    ind = edit.selectionStart;
	    ch = edit.value;
	    s = 0;
	    for (i = 0; i < ch.length; i++) {
	      if (ch.charAt(i) === "(") s++;else if (ch.charAt(i) === ")") s--;
	    }
	    b = true;
	    for (i = ind; i < ch.length; i++) {
	      if (ch.charAt(i) !== ")" || ch.charAt(i) !== ")") b = false;
	    }
	    if (s === 0 && b) {
	      edit.value = edit.value.substring(0, ind) + "()" + edit.value.substring(ind);
	      edit.selectionStart = ind + 1;
	      edit.selectionEnd = ind + 1;
	      evt.preventDefault();
	    }
	  }
	};
	/**
	 * Fonction de callBack appelée pour mettre à jour l'affichage LaTeX de
	 * la formule si celui-ci est activé..
	 * Lors de l'applet owner pointe sur this.
	 * @param {CEditeurFormule} owner
	 * @param {svg} svg
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.callBack = function (owner, svg) {
	  var newglatex = owner.latex.createg();
	  svg.replaceChild(newglatex, owner.glatex);
	  owner.glatex = newglatex;
	};
	/**
	 * Fonction encadrant l'éditeur de rouge en cas de faute de syntaxe
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.marquePourErreur = function () {
	  // this.form.style.border = "1px solid red"; // Modifié version mtgApp
	  this.editeur.style["background-color"] = "#FF9999";
	  this.editeur.setSelectionRange(this.indErr.getValue(), this.indErr.getValue());
	};
	/**
	 * Fonction retirant l'éventuel cadre rouge encadrant l'éditeur en cas de
	 * faute de syntaxe.
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.demarquePourErreur = function () {
	  // this.form.style.border = "none" // Modifié version mtgApp
	  this.editeur.style["background-color"] = "#FFFFFF";
	};
	/**
	 * Fonction créat un div contenant un formulaire et à l'intérieur de celui-ci
	 * un éditeur input contenant l'éditeur de formule.
	 * Ce div est rajouté au div propriétaire du svg contenant la figure.
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.creeEditeur = function () {
	  var svg, par, id;
	  // Modification version mtgApp : Le parent du svg de la figure est un svg. Il faudra tenir compte
	  // de son décalage par rapport au div parnet
	  id = this.listeProprietaire.id;
	  if (id === null) return; // Pour les figures servant seulement pour leurs objets de type calcul
	  this.divi = kernel.ce("div");
	  this.editeur = kernel.ce("input");
	
	  // this.editeur.onchange = this.onchange;
	  this.editeur.onblur = this.onblur;
	
	  this.editeur.owner = this;
	  // this.form.onsubmit = this.onsubmit;
	  if (this.affichageTempsReel) {
	    this.editeur.onkeyup = this.onkeyup;
	  }
	  this.editeur.onkeypress = this.onkeypress;
	  this.divi.appendChild(this.editeur);
	  this.editeur.setAttribute("type", "text");
	  this.editeur.setAttribute("size", this.nbcol);
	  // this.editeur.setAttribute("style","fontSize:"+Fonte.taille(this.taillePolice)+"px;")
	  this.editeur.style.fontSize = this.taillePolice + "px";
	  this.editeur.style.fontFamily = "TNR";
	  this.editeur.id = id + this.calculAssocie.nomCalcul; // Por les échanges avec J3P
	  /*
	   var bb = document.getElementById(this.listeProprietaire.id).getBoundingClientRect();
	   x = bb.left + this.x_nom + this.dec_x;
	   y = bb.top + this.y_nom + this.dec_y - 2;
	   */
	  svg = document.getElementById(id);
	  this.svg = svg; // On mémorise le svg pour que dans deleteComponent() on puisse retire le div qui conteient l'éditeur
	  // Modification version mtgApp : En utilisant les onglets dans mathematice, il y avait un bug
	  // En effet si le div parent n'est pas visible, this.div.cleintHeight par exemple renvoie 0
	  // On attache donc d'abord le div au document.body, puis on le retire pour le réattacher ensuite au div parent
	  document.body.appendChild(this.divi);
	
	  /* Modification version WebPack
	   //
	   // var pos = mtg32.getPosition2FirstNonStatic(par);
	   // x = pos.x + this.x_nom + this.dec_x + 1; Modifé version 4.9.2
	   // x = this.x_nom + this.dec_x + 2; Modifié version mtgApp
	   x = decx + this.x_nom + this.dec_x + 2;
	   // y = pos.y + this.y_nom + this.dec_y - 2; // Modifié pour J3P
	   // y = pos.y + this.y_nom + this.dec_y - 6 + this.editeur.clientHeight/2; // Modifié pour J3P
	   // Remodifié le &5-5-2014
	   // y = this.y_nom + this.dec_y - 4 + this.editeur.clientHeight/2; Modifié version MtgApp
	   y = decy + this.y_nom + this.dec_y - 4 + this.editeur.clientHeight/2;
	   // x = this.x_nom + this.dec_x;
	   // y = this.y_nom + this.dec_y - 2;
	   if (par.style.position === "") par.style.position = "relative";
	   var style= "left:"+x+"px;"+"top:"+y+"px;"+"position:absolute;margin:0px;visibility:"+(this.masque ? "hidden;" : "visible;");
	   // var style= "left:"+x+"px;"+"top:"+y+"px;" + "margin:0px;";
	   this.divi.setAttribute("style", style);
	   */
	  this.placeEditeur();
	  if (this.affichageFormule) {
	    this.latex = new CLatex(this.listeProprietaire, null, false, this.couleur, this.x_nom + this.divi.clientWidth + 3, this.y_nom + this.taillePolice / 2 + 2, this.dec_x, this.dec_y, false, null, this.taillePolice, StyleEncadrement.Sans, this.effacementFond, this.couleurFond, CAffichageLieAPoint.alignementHorizontalGauche, CAffichageLieAPoint.alignementVerticalCentre, this.preCodeLaTeX + " " + this.calculAssocie.calcul.chaineLatexSansPar(this.calculAssocie.variableFormelle()));
	    // Ligne suivante ajoutée version WebBack pour pouvoir déplacer un éditeur avec l'outil de capture
	    // Utilisé dans CEditeurFormule.placeNom()
	    this.latex.owner = this;
	  }
	  document.body.removeChild(this.divi);
	  par = svg.parentNode; // Le parent du svg doit être un div
	  // Modification version mtgApp : Dans le cas d'une mtgApp, le parent du svg de la figure est un autre svg
	  // et c'est son div parent qu'il faut utiliser
	  if (par.tagName.toLowerCase() !== "div") par = par.parentNode;
	  // Modifié version 4.9.9.3
	  par.appendChild(this.divi); //On attache l'éditeur au div parent du svg
	};
	
	CEditeurFormule.prototype.placeEditeur = function () {
	  var svg, par, style, x, y;
	  var decx = 0;
	  var decy = 0;
	  svg = document.getElementById(this.listeProprietaire.id);
	  par = svg.parentNode; // Le parent du svg doit être un div
	  // Modification version mtgApp : Dans le cas d'une mtgApp, le parent du svg de la figure est un autre svg
	  // et c'est son div parent qu'il faut utiliser
	  if (par.tagName.toLowerCase() !== "div") {
	    decx = parseInt(svg.getAttribute("x"));
	    decy = parseInt(svg.getAttribute("y"));
	    // par = par.parentNode;
	  }
	  //
	  // var pos = mtg32.getPosition2FirstNonStatic(par);
	  // x = pos.x + this.x_nom + this.dec_x + 1; Modifé version 4.9.2
	  // x = this.x_nom + this.dec_x + 2; Modifié version mtgApp
	  x = decx + this.x_nom + this.dec_x + 2;
	  // y = pos.y + this.y_nom + this.dec_y - 2; // Modifié pour J3P
	  // y = pos.y + this.y_nom + this.dec_y - 6 + this.editeur.clientHeight/2; // Modifié pour J3P
	  // Remodifié le &5-5-2014
	  // y = this.y_nom + this.dec_y - 4 + this.editeur.clientHeight/2; Modifié version MtgApp
	  // y = decy + this.y_nom + this.dec_y - 4 + this.editeur.clientHeight/2;
	  // Modification version WebPack
	  y = decy + this.y_nom + this.dec_y + this.taillePolice / 2 - this.editeur.clientHeight / 2 - 1;
	  // x = this.x_nom + this.dec_x;
	  // y = this.y_nom + this.dec_y - 2;
	  // if (par.style.position === "") par.style.position = "relative"; // Déplacé dans l'appli version mtgApp
	  style = "left:" + x + "px;" + "top:" + y + "px;" + "position:absolute;margin:0px;visibility:" + (this.masque ? "hidden;" : "visible;");
	  // var style= "left:"+x+"px;"+"top:"+y+"px;" + "margin:0px;";
	  this.divi.setAttribute("style", style);
	  // Modifié version 4.9.9.3
	};
	/**
	 * Fonction retirant le div contenant le composant formulaire contenant le input
	 */
	CEditeurFormule.prototype.deleteComponent = function () {
	  try {
	    //this.svg a été établit lors de l'appel à creeEditeur
	    var par = this.svg.parentNode;
	    // Modification version WepPack. Dans cette version le parent peut être un svg
	    if (par.tagName.toLowerCase() !== "div") par = par.parentNode;
	    par.removeChild(this.divi);
	  } catch (ex) {}
	};
	
	// Ajout version webPack
	CEditeurFormule.prototype.createComponent = function () {
	  this.creeEditeur();
	};
	
	CEditeurFormule.prototype.donneCouleur = function (color) {
	  CAffichageLieAPoint.prototype.donneCouleur.call(this, color);
	  if (this.affichageFormule) this.latex.donneCouleur(color);
	};
	
	CEditeurFormule.prototype.setReady4MathJax = function () {
	  CAffichageLieAPoint.prototype.setReady4MathJax.call(this);
	  if (this.affichageFormule) this.latex.setReady4MathJax();
	};
	
	CEditeurFormule.prototype.setReady4MathJaxUpdate = function () {
	  CAffichageLieAPoint.prototype.setReady4MathJaxUpdate.call(this);
	  if (this.affichageFormule) {
	    this.latex.setReady4MathJax(); // Spécial pour cet objet
	  }
	};
	/**
	 * Fonction mettant dans l'éditeur la chaîne de caractères st et mettant à jour
	 * en conséquence l'affichage de formule LaTeX s'il est activé.
	 * @param {type} st
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.setEditorValue = function (st) {
	  this.editeur.value = st;
	  var liste = this.listeProprietaire;
	  var ch = this.variables1Car ? liste.traiteSignesMult(st) : st;
	  var svg = document.getElementById(liste.id);
	  var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	  var varFor = this.calculAssocie.variableFormelle();
	  var bcomplexe = this.calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NCalculComplexe, NatCal.NFonctionComplexe, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var));
	  if (this.affichageFormule) {
	    var calc = bcomplexe ? CalcC.ccbComp(ch, liste, 0, ch.length - 1, varFor) : CalcR.ccb(ch, liste, 0, ch.length - 1, varFor);
	    this.latex.chaineCommentaire = this.preCodeLaTeX + " " + calc.chaineLatexSansPar(varFor);
	    this.latex.positionne(false, dimf);
	    this.latex.setReady4MathJax();
	    MathJax.Hub.Queue([this.callBack, this, svg]);
	  }
	};
	
	CEditeurFormule.prototype.positionne = function (infoRandom, dimfen) {
	  CAffichageLieAPoint.prototype.positionne.call(this, infoRandom, dimfen);
	  if (this.affichageFormule) this.latex.positionne(infoRandom, dimfen);
	};
	
	CEditeurFormule.prototype.trace = function (svg, couleurFond, transparence) {
	  CAffichageLieAPoint.prototype.trace.call(this, svg, couleurFond, transparence);
	  if (this.affichageFormule) {
	    // this.latex.positionne();
	    this.glatex = this.latex.createg();
	    if (!this.affLaTeXPremierAffichage) this.glatex.setAttribute("visibility", "hidden");
	    svg.appendChild(this.glatex);
	  }
	};
	/**
	 * Fonction applelé pour valider ou non sur le plan syntaxique le contenu de l'éditeur.
	 * @param {Boolean} redraw : Di true on réactualise l'affichage de la formule.
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.validation = function (redraw) {
	  var txt, listePr, calculAssocie, chCalcul, indDernier, varFor, bcomplexe, v, calc;
	  listePr = this.listeProprietaire;
	  txt = this.editeur.value;
	  if (txt.length === 0) return true;
	  // String chCalcul = getText(); // Modifié version 4.6
	  chCalcul = this.variables1Car ? listePr.traiteSignesMult(txt) : txt;
	  // Spécial version Applet !
	  calculAssocie = this.calculAssocie;
	  // On autorise d'utiliser un calcul non créé par l'utilisateur
	  indDernier = listePr.indexOf(calculAssocie) - 1;
	  varFor = calculAssocie.variableFormelle();
	  bcomplexe = calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NCalculComplexe, NatCal.NFonctionComplexe, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var));
	  if (bcomplexe ? CalcC.verifieSyntaxeComplexe(listePr, chCalcul, this.indErr, indDernier, varFor) : CalcR.verifieSyntaxe(listePr, chCalcul, this.indErr, indDernier, varFor)) {
	    calc = bcomplexe ? CalcC.ccbComp(chCalcul, listePr, 0, chCalcul.length - 1, varFor) : CalcR.ccb(chCalcul, listePr, 0, chCalcul.length - 1, varFor);
	    if (calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NCalculReel, NatCal.NCalculComplexe))) {
	      try {
	        calc.listeProprietaire.initialiseNombreIterations();
	        if (bcomplexe) {
	          v = new Complexe();
	          calc.resultatComplexe(false, v);
	        } else {
	          calc.resultat(false);
	        }
	      } catch (e) {
	        this.indErr.setValue(txt.length);
	        return false;
	      }
	    }
	    calculAssocie.calcul = calc;
	    // Modification version 4.5.2 : Quand la chaîne de calcul sera reconstruite elle pourra être différente de celle ici entrée
	    // On la change tout de suite
	    calculAssocie.chaineCalcul = calculAssocie.calcul.chaineCalculSansPar(varFor);
	    //
	    // Modification bug version 4.7.1 : On remet à jour les objets dépendant, en particulier les calculs de dérivées
	    // Modifié version 4.7.2
	    // Modifié version 4.7.3
	    listePr.metAJourObjetsDependantDeSaufEditeursFormule(calculAssocie);
	    // On recalcule la figure et on la réaffiche
	    if (redraw) {
	      var svg = document.getElementById(listePr.id);
	      var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	      // listePr.positionne(false, dimf);
	      var doc = listePr.documentProprietaire;
	      // Ajout version 5.2. Indispensable
	      // listePr.setReady4MathJaxUpdate();
	      //
	      // listePr.update(svg, doc.couleurFond, doc.opacity, true);
	      listePr.positionneDependantsDe(false, dimf, calculAssocie);
	      listePr.updateDependants(calculAssocie, svg, doc.couleurFond, doc.opacity, true);
	
	      if (this.affichageFormule) {
	        this.latex.chaineCommentaire = this.preCodeLaTeX + " " + this.calculAssocie.calcul.chaineLatexSansPar(varFor);
	        this.latex.positionne(false, dimf);
	        // Modification version 4.9.2
	        this.latex.setReady4MathJax();
	        var t = this;
	        MathJax.Hub.Queue([this.callBack, t, svg]);
	      }
	    }
	    return true;
	  } else {
	    this.adapteIndiceErreur();
	    return false;
	  }
	};
	/**
	 * Fonction renvoyant true si car est une chaine de un caractère contenant soit
	 * un chiffre soit un caractère ²
	 * @param {String} car
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.chiffreOuCarre = function (car) {
	  return car === '²' || Fonte.chiffre(car);
	};
	/**
	 * Fonction renvoyant true si car est une chaine de un caractère contenant soit
	 * un chiffre soit le point décimal .
	 * @param {String} car
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.chiffreOuPointDecimal = function (car) {
	  return car === '.' || Fonte.chiffre(car);
	};
	/**
	 * Fonction renvoyant true si car est une chaine de un caractère contenant soit
	 * une lettre soit un caractère ' ou "
	 * @param {String} car
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.lettreOuPrime = function (car) {
	  return Fonte.lettre(car) || car === '\'' || car === '\"';
	};
	/**
	 * Fonction renvoyant true si pChaine commence à partir de l'indice indsart
	 * soit par le nom d'une fonction prédéfinie suivi d'une parenthèse ouvrante.
	 * @param {String} pChaine
	 * @param {Integer} indstart
	 * @param {Pointeur} longNom : Au retour longNom.getValue() renvoie la longueur
	 * du nom de la fonction si la recherche a été positive.
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.commenceParNomFonctionPredefinieSuivieParOuvr = function (pChaine, indstart, longNom) {
	  var ch = pChaine.substring(indstart).toLowerCase();
	  var i;
	  // On commence par les fonctions de quatre variables car integrale commence par int une autre fonction
	  for (i = 0; i < Opef4v.nomsFoncs4Var.length; i++) {
	    longNom.setValue(Opef4v.nomsFonctions4Var(i).length);
	    if (ch.indexOf(Opef4v.nomsFonctions4Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef.nomsFoncs.length; i++) {
	    longNom.setValue(Opef.nomsFonctions(i).length);
	    if (ch.indexOf(Opef.nomsFonctions(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef2v.nomsFoncs2Var.length; i++) {
	    longNom.setValue(Opef2v.nomsFonctions2Var(i).length);
	    if (ch.indexOf(Opef2v.nomsFonctions2Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef3v.nomsFoncs3Var.length; i++) {
	    longNom.setValue(Opef3v.nomsFonctions3Var(i).length);
	    if (ch.indexOf(Opef3v.nomsFonctions3Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef5v.nomsFoncs5Var.length; i++) {
	    longNom.setValue(Opef5v.nomsFonctions5Var(i).length);
	    if (ch.indexOf(Opef5v.nomsFonctions5Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  // Inutile de regarder les noms des fonctions complexes de plus de deux variables car c'est le même que les fonctions réelles
	  for (i = 0; i < Opef.nomsFoncsComplexes.length; i++) {
	    longNom.setValue(Opef.nomsFonctionsComplexes(i).length);
	    if (ch.indexOf(Opef.nomsFonctionsComplexes(i).toLowerCase() + "(") === 0) return true;
	  }
	  return false;
	};
	/**
	 * Fonction renvoyant true si, à partir de l'indice indstart, pChaine commence
	 * par un nom de fonction prédéfinie suivi d'une parenthèse ouvrante.
	 * @param {String} pChaine : La chaîne analysée.
	 * @param {Integer} indstart : L'indice du début de la recherche.
	 * @param {Integer} longNom : Renvoie par getValue() la longueur du nom de la fonction
	 * si la recherche a été positive.
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.commenceParNomFonctionUtilisateurSuivieParOuvr = function (pChaine, indstart, longNom) {
	  var i, elb, nom;
	  var liste = this.listeProprietaire;
	  var ch = pChaine.substring(indstart).toLowerCase();
	
	  for (i = 0; i < liste.longueur(); i++) {
	    elb = liste.get(i);
	    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(Nat.or(NatCal.NTteFoncR, NatCal.NDerivee, NatCal.NSuiteRecurrenteReelle, NatCal.NTteFoncC, NatCal.NSuiteRecurrenteComplexe))) {
	      nom = elb.getNom();
	      if (ch.indexOf(nom + "(") === 0) {
	        longNom.setValue(nom.length);
	        return true;
	      }
	    }
	  }
	  return false;
	};
	/**
	 * Fonction mettant, dans le cas d'une erreur de syntaxe, dans this .indErr l'indice
	 * de l'erreur dans la chaîne de caractères de l'éditeur, dans le cas où
	 * les signes de multiplication implicites sont utilisés.
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.adapteIndiceErreur = function () {
	  var lon = new Pointeur(0);
	  if (this.variables1Car) {
	    var ch = this.editeur.value;
	    var carprecedent = '(';
	    var k = 0; // Représente l'indice dans la chaîne à laquelle ont été rajoutés des éventuels signs de multiplication
	    var i = 0; // Reprsente l'indice dans la chaîe qui a été entrée avec des multiplications implicites.
	    var len = ch.length;
	    while (k <= this.indErr.getValue() && i < len) {
	      var car = ch.charAt(i);
	      if (this.chiffreOuPointDecimal(car) || car === ')' || car === '+' || car === '-' || car === '*' || car === '/' || car === '^' || car === '\'' || car === '\"' || car === '²') {
	        carprecedent = car;
	        i++;
	        k++;
	      } else {
	        if (ch.indexOf("pi", i) === 0) {
	          k += 2;
	          if (!(this.chiffreOuPointDecimal(carprecedent) || lettreOuPrime(carprecedent) || carprecedent === ')')) k++;
	          carprecedent = ')';
	          i += 2;
	        } else {
	          if (this.commenceParNomFonctionPredefinieSuivieParOuvr(ch, i, lon)) {
	            k += lon.getValue();
	            if (this.chiffreOuPointDecimal(carprecedent) || this.lettreOuPrime(carprecedent) || carprecedent === ')') k++;
	            i += lon.getValue();
	            carprecedent = '(';
	          } else {
	            if (this.commenceParNomFonctionUtilisateurSuivieParOuvr(ch, i, lon)) {
	              k += lon.getValue();
	              if (this.chiffreOuPointDecimal(carprecedent) || this.lettreOuPrime(carprecedent) || carprecedent === ')') k++;
	              i += lon.getValue();
	              carprecedent = '(';
	            } else {
	              k++;
	              i++;
	              // Si lettre suivie d'une autre lettre
	              if (this.lettreOuPrime(carprecedent) && Fonte.lettre(car)) k++;
	              // Si chiffre suivi d'une lettre
	              else if (this.chiffreOuCarre(carprecedent) && Fonte.lettre(car)) k++;
	                // Si chiffre ou lettre suivi d'une parenthèse on rajoute un signe de multiplication
	                else if ((this.chiffreOuCarre(carprecedent) || this.lettreOuPrime(carprecedent)) && car === '(') k++;
	                  // Si parenthèse fermante suivie d'un chiffre ou une lettre ou une parenthèse ouvrante on rajoute un signe de multiplication
	                  else if (carprecedent === ')' && (Fonte.lettre(car) || Fonte.chiffre(car) || car === '(')) k++;
	              carprecedent = car;
	            }
	          }
	        }
	      }
	    }
	    this.indErr.setValue(i);
	  }
	};
	
	CEditeurFormule.prototype.chaineDesignation = function () {
	  return "desEditeur";
	};
	
	CEditeurFormule.prototype.read = function (inps, list) {
	  CAffichageLieAPoint.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.calculAssocie = list.get(ind1, "CFonc");
	  this.enTete = CLatex.traiteAccents(inps.readUTF());
	  this.nbcol = inps.readInt();
	  this.variables1Car = inps.readBoolean();
	  this.affichageFormule = inps.readBoolean();
	  this.preCodeLaTeX = inps.readUTF();
	  this.affLaTeXPremierAffichage = inps.readBoolean();
	  this.affichageTempsReel = inps.readBoolean();
	  // A revoir JavaScript
	  /*
	   if (listeProprietaire.bCreationComposants) {
	   mtgFormulaEditor = new MtgFormulaEditor(this);
	   mtgFormulaEditor.setVisible(!masque);
	   mtgFormulaEditor.setForeground(couleur);
	   }
	   */
	  // Ajout version 4.7.1
	  if (list.className !== "CPrototype") this.creeEditeur();
	  // Ajout version 4.9.3
	  this.callBackOK = null;
	};
	
	CEditeurFormule.prototype.write = function (oups, list) {
	  CAffichageLieAPoint.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.calculAssocie);
	  oups.writeInt(ind1);
	  oups.writeUTF(this.enTete);
	  oups.writeInt(this.nbcol);
	  oups.writeBoolean(this.variables1Car);
	  // Ajout version 4.7.2
	  oups.writeBoolean(this.affichageFormule);
	  oups.writeUTF(this.preCodeLaTeX);
	  oups.writeBoolean(this.affLaTeXPremierAffichage);
	  oups.writeBoolean(this.affichageTempsReel);
	};
	
	/**
	 * Fonction à appeler depuis un autre code JavaScript.
	 * Quant l'utilisateur validera sa formule dans l'éditeur
	 * par la touche Entée, a fonction f possédée par le code appelant sera allors appelée.
	 * @param {type} f
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.setCallBackOK = function (f) {
	  this.callBackOK = f;
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var Complexe = __webpack_require__(30);
	var Dimf = __webpack_require__(7);
	var Fonte = __webpack_require__(18);
	var Nat = __webpack_require__(4);
	var Opef = __webpack_require__(19);
	var Opef2v = __webpack_require__(20);
	var Opef3v = __webpack_require__(21);
	var Opef4v = __webpack_require__(22);
	var Opef5v = __webpack_require__(23);
	var Pointeur = __webpack_require__(16);
	var StyleEncadrement = __webpack_require__(38);
	var kernel = __webpack_require__(8);
	var CCb = __webpack_require__(43);
	var CalcR = __webpack_require__(55);
	var CalcC = __webpack_require__(69);
	var CAffichageLieAPoint = __webpack_require__(36);
	module.exports = CEditeurFormule;
	var CLatex = __webpack_require__(40);
	
	/**
	 * Classe représentant un éditeur de formule permettant à l'utilisateur de modifier
	 * la formule d'un calcul sur la figure.
	 * On peut associer à l'éditeur une fonction de callBack nommée callBackOK qui
	 * sera appelée quand l'utilisateur aura validé sa réponse.
	 * @constructor
	 * @extends CAffichageLieAPoint
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de l'éditeur
	 * @param {Float} y_nom : L'ordonnée d'affichage de l'éditeur
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} encadrement : true si encadré.
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {mtg32.CCalcul} calculAssocie : Le calcul dont l'éditeur peut changer la formule.
	 * @param {String} enTete : Ce qui est affiiché devant l'éditeur proprement dit. Encadrer par des $
	 * pour obtenir un affichage LaTeX.
	 * @param {Integer} nbcol : Le nombre de colonnes de l'éditeur.
	 * @param {Boolean} affichageFormule : true si on affiche la formule à droite de l'éditeur.
	 * @param {String} preCodeLaTeX : Donne le code LaTeX de ce qu'il faut afficher entre l'éditeur
	 * et l'affichage de la formule quand cet affichage est demandé.
	 * @param {Boolean} variables1Car : true si on n'utilise que des calculs et variables dont les nomes sont de 1 caractère.
	 * Dans ce cas les signes de multiplications sont omis dans l'affichage de formule s'il est demané.
	 * @param {Boolean} affLaTeXPremierAffichage : true si la formule dit être affichée à droite de l'éditeur
	 * immédiatement après le chargement de la figure.
	 * @param {Boolean} affichageTempsReel : true si l'affichage de formule (en LaTeX) à droite
	 * de l'éditeur doit se faire au fur  * et à mesure que l'utilisateur tape auclavier.
	 * @returns {CEditeurFormule}
	 */
	function CEditeurFormule(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, taillePolice, encadrement, effacementFond, couleurFond, calculAssocie, enTete, nbcol, affichageFormule, preCodeLaTeX, variables1Car, affLaTeXPremierAffichage, affichageTempsReel) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CAffichageLieAPoint.call(this, listeProprietaire);else {
	      CAffichageLieAPoint.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, null, taillePolice, encadrement, effacementFond, couleurFond, CAffichageLieAPoint.alignementHorizontalDroit, CAffichageLieAPoint.alignementVerticalHaut);
	      this.calculAssocie = calculAssocie;
	      this.enTete = enTete;
	      this.nbcol = nbcol;
	      this.affichageFormule = affichageFormule;
	      this.preCodeLaTeX = preCodeLaTeX;
	      this.variables1Car = variables1Car;
	      this.affLaTeXPremierAffichage = affLaTeXPremierAffichage;
	      this.affichageTempsReel = affichageTempsReel;
	    }
	    this.indErr = new Pointeur(0);
	  }
	  this.callBackOK = null; // Ajout version 4.9.3
	}
	CEditeurFormule.prototype = new CAffichageLieAPoint();
	CEditeurFormule.prototype.constructor = CEditeurFormule;
	CEditeurFormule.prototype.superClass = "CAffichageLieAPoint";
	CEditeurFormule.prototype.className = "CEditeurFormule";
	
	CEditeurFormule.prototype.numeroVersion = function () {
	  return 4;
	};
	
	CEditeurFormule.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.calculAssocie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CEditeurFormule(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, this.taillePolice, this.encadrement, this.effacementFond, this.couleurFond, listeCible.get(ind1, "CCalcul"), this.enTete, this.nbcol, this.affichageFormule, this.preCodeLaTeX, this.variables1Car, this.affLaTeXPremierAffichage, this.affichageTempsReel);
	};
	
	CEditeurFormule.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CAffichageLieAPoint.prototype.dependDe.call(this, p) || this.calculAssocie.dependDe(p));
	};
	
	CEditeurFormule.prototype.dependDePourBoucle = function (p) {
	  return CAffichageLieAPoint.prototype.dependDePourBoucle.call(this, p) || this.calculAssocie.dependDePourBoucle(p);
	};
	/**
	 * Fournit la chaîne représentant l'en-tête à afficher devant l'éditeur proprement dit
	 * @returns {String}
	 */
	CEditeurFormule.prototype.rendChaineAffichage = function () {
	  var i;
	  if (this.enTete.length === 0) {
	    var ch = this.calculAssocie.nomCalcul;
	    if (this.calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NFonction, NatCal.NFonctionComplexe))) {
	      // CFonc fonc = (CFonc) calculAssocie;
	      ch = ch + CCb.parouv + this.calculAssocie.chaineVariable + CCb.parfer;
	    } else {
	      if (this.calculAssocie.estDeNatureCalcul(NatCal.NTteFoncRouC)) {
	        // CFoncNVar fonc = (CFoncNVar) calculAssocie;
	        ch = ch + "(";
	        for (i = 0; i < this.calculAssocie.nbVar; i++) {
	          ch = ch + this.calculAssocie.chaineVariable[i];
	          if (i !== this.calculAssocie.nbVar - 1) ch = ch + ',';
	        }
	        ch = ch + ")";
	      }
	    }
	    // if (!this.affichageFormule) ch = ch + " = ";
	    // else ch = ch + "\\;";
	    ch = ch + " = ";
	    // Modification version 4.7.2 : Affichage par défaut en LaTeX de l'en-tête
	    ch = "$" + ch + "$";
	    return ch;
	  } else return this.enTete;
	};
	
	CEditeurFormule.prototype.getNature = function () {
	  return NatObj.NEditeurFormule;
	};
	
	CEditeurFormule.prototype.montre = function () {
	  CAffichageLieAPoint.prototype.montre.call(this);
	  this.divi.style.visibility = "visible";
	  if (this.affichageFormule) {
	    if (this.glatex === undefined) {
	      this.glatex = this.latex.createg();
	      var listePr = this.listeProprietaire;
	      var svg = document.getElementById(listePr.id);
	      svg.appendChild(this.glatex);
	    }
	    this.glatex.setAttribute("visibility", "visible");
	  }
	};
	
	CEditeurFormule.prototype.cache = function () {
	  CAffichageLieAPoint.prototype.cache.call(this);
	  this.divi.style.visibility = "hidden";
	  if (this.affichageFormule && this.glatex) this.glatex.setAttribute("visibility", "hidden");
	};
	
	/**
	 * Fonction appelée pour l'événement onblur de l'éditeur.
	 * Attention this pointe sur le composant
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.onblur = function () {
	  var b = this.owner.validation(true);
	  if (b) this.owner.demarquePourErreur();else this.owner.marquePourErreur();
	};
	/**
	 * Fonction appelée par l'événement onkeyup de l'éditeur
	 * Attention this pointe sur le composant
	 * @param {Event} evt
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.onkeyup = function (evt) {
	  // Non traité si c'est la touche entrée ou une touche de déplacement de curseur
	  var kc = evt.keyCode;
	  // On sort si touche entrée ou déplacement à gauche ou à droite
	  if (evt.charCode === 0 && (kc === 13 || kc === 37 || kc === 39)) return;
	  // On regarde si un set de caractères autorisés a été spécifié :
	  var owner = this.owner;
	  var listePr = owner.listeProprietaire;
	  var svg = document.getElementById(listePr.id);
	  var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	  // var doc = listePr.documentProprietaire;
	  var chCalcul = owner.variables1Car ? listePr.traiteSignesMult(this.value) : this.value;
	  var indErr = owner.indErr;
	
	  var calculAssocie = owner.calculAssocie;
	  // On autorise d'utiliser un calcul non créé par l'utilisateur
	  var indDernier = listePr.indexOf(calculAssocie) - 1;
	  var varFor = calculAssocie.variableFormelle();
	  var bcomplexe = calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NCalculComplexe, NatCal.NFonctionComplexe, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var));
	  if (bcomplexe ? CalcC.verifieSyntaxeComplexe(listePr, chCalcul, indErr, indDernier, varFor) : CalcR.verifieSyntaxe(listePr, chCalcul, indErr, indDernier, varFor)) {
	    owner.demarquePourErreur();
	  }
	  if (owner.affichageFormule && owner.affichageTempsReel) {
	    var calc = bcomplexe ? CalcC.ccbComp(chCalcul, listePr, 0, chCalcul.length - 1, varFor) : CalcR.ccb(chCalcul, listePr, 0, chCalcul.length - 1, varFor);
	    // try rajouté version 4.7.3
	    // cadre.repaintFigureSansCalcul();
	
	    owner.latex.chaineCommentaire = owner.preCodeLaTeX + " " + calc.chaineLatexSansPar(varFor);
	    owner.latex.positionne(false, dimf);
	    owner.latex.setReady4MathJax();
	    /*
	     var newglatex = owner.latex.createg();
	     svg.replaceChild(newglatex, owner.glatex);
	     owner.glatex = newglatex;
	     */
	    MathJax.Hub.Queue([owner.callBack, owner, svg]);
	  }
	};
	/**
	 * Fonction appelée par l'événement onkeypress de l'éditeur
	 * Attention this pointe sur le composant
	 * @param {Event} evt
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.onkeypress = function (evt) {
	  var i, edit, ind, ch, owner, s, b;
	  owner = this.owner;
	  if (evt.keyCode === 13) {
	    evt.preventDefault(); // Pour compatibilité avec j3p
	    // evt.stopPropagation(); // Pour compatibilité avec j3p
	    b = owner.validation(true);
	    if (b) owner.demarquePourErreur();else owner.marquePourErreur();
	    // Ajout version 4.9.3
	    if (owner.callBackOK !== null && b && owner.editeur.value.length !== 0) owner.callBackOK.call();
	    //  evt.preventDefault(); // Supprimé version 5.2 pour que le clavier des périphériques mobile se replie
	    // Sinon avec clavier on garde le focus avec le point d'insertion à l'endroit de la faute
	    if (!owner.listeProprietaire.documentProprietaire.hasMouse) this.blur();
	    return;
	  }
	  // On regarde si un set de caractères autorisés a été spécifié :
	  if (owner.charset && owner.charset !== "") {
	    if (evt.charCode !== 0 && owner.charset.indexOf(String.fromCharCode(evt.charCode)) === -1) {
	      evt.preventDefault();
	      return;
	    }
	  }
	  if (evt.charCode === 40) {
	    // On tape une parenthèse ouvrante
	    // Si l'expression est correcte au niveau des parenthèses et si le curseur n'est suivi
	    // que d'espaces ou de parenthèses fermantes, on rajoute une parenthèse fermante
	    edit = owner.editeur;
	    ind = edit.selectionStart;
	    ch = edit.value;
	    s = 0;
	    for (i = 0; i < ch.length; i++) {
	      if (ch.charAt(i) === "(") s++;else if (ch.charAt(i) === ")") s--;
	    }
	    b = true;
	    for (i = ind; i < ch.length; i++) {
	      if (ch.charAt(i) !== ")" || ch.charAt(i) !== ")") b = false;
	    }
	    if (s === 0 && b) {
	      edit.value = edit.value.substring(0, ind) + "()" + edit.value.substring(ind);
	      edit.selectionStart = ind + 1;
	      edit.selectionEnd = ind + 1;
	      evt.preventDefault();
	    }
	  }
	};
	/**
	 * Fonction de callBack appelée pour mettre à jour l'affichage LaTeX de
	 * la formule si celui-ci est activé..
	 * Lors de l'applet owner pointe sur this.
	 * @param {CEditeurFormule} owner
	 * @param {svg} svg
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.callBack = function (owner, svg) {
	  var newglatex = owner.latex.createg();
	  svg.replaceChild(newglatex, owner.glatex);
	  owner.glatex = newglatex;
	};
	/**
	 * Fonction encadrant l'éditeur de rouge en cas de faute de syntaxe
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.marquePourErreur = function () {
	  // this.form.style.border = "1px solid red"; // Modifié version mtgApp
	  this.editeur.style["background-color"] = "#FF9999";
	  this.editeur.setSelectionRange(this.indErr.getValue(), this.indErr.getValue());
	};
	/**
	 * Fonction retirant l'éventuel cadre rouge encadrant l'éditeur en cas de
	 * faute de syntaxe.
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.demarquePourErreur = function () {
	  // this.form.style.border = "none" // Modifié version mtgApp
	  this.editeur.style["background-color"] = "#FFFFFF";
	};
	/**
	 * Fonction créat un div contenant un formulaire et à l'intérieur de celui-ci
	 * un éditeur input contenant l'éditeur de formule.
	 * Ce div est rajouté au div propriétaire du svg contenant la figure.
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.creeEditeur = function () {
	  var svg, par, id;
	  // Modification version mtgApp : Le parent du svg de la figure est un svg. Il faudra tenir compte
	  // de son décalage par rapport au div parnet
	  id = this.listeProprietaire.id;
	  if (id === null) return; // Pour les figures servant seulement pour leurs objets de type calcul
	  this.divi = kernel.ce("div");
	  this.editeur = kernel.ce("input");
	
	  // this.editeur.onchange = this.onchange;
	  this.editeur.onblur = this.onblur;
	
	  this.editeur.owner = this;
	  // this.form.onsubmit = this.onsubmit;
	  if (this.affichageTempsReel) {
	    this.editeur.onkeyup = this.onkeyup;
	  }
	  this.editeur.onkeypress = this.onkeypress;
	  this.divi.appendChild(this.editeur);
	  this.editeur.setAttribute("type", "text");
	  this.editeur.setAttribute("size", this.nbcol);
	  // this.editeur.setAttribute("style","fontSize:"+Fonte.taille(this.taillePolice)+"px;")
	  this.editeur.style.fontSize = this.taillePolice + "px";
	  this.editeur.style.fontFamily = "TNR";
	  this.editeur.id = id + this.calculAssocie.nomCalcul; // Por les échanges avec J3P
	  /*
	   var bb = document.getElementById(this.listeProprietaire.id).getBoundingClientRect();
	   x = bb.left + this.x_nom + this.dec_x;
	   y = bb.top + this.y_nom + this.dec_y - 2;
	   */
	  svg = document.getElementById(id);
	  this.svg = svg; // On mémorise le svg pour que dans deleteComponent() on puisse retire le div qui conteient l'éditeur
	  // Modification version mtgApp : En utilisant les onglets dans mathematice, il y avait un bug
	  // En effet si le div parent n'est pas visible, this.div.cleintHeight par exemple renvoie 0
	  // On attache donc d'abord le div au document.body, puis on le retire pour le réattacher ensuite au div parent
	  document.body.appendChild(this.divi);
	
	  /* Modification version WebPack
	   //
	   // var pos = mtg32.getPosition2FirstNonStatic(par);
	   // x = pos.x + this.x_nom + this.dec_x + 1; Modifé version 4.9.2
	   // x = this.x_nom + this.dec_x + 2; Modifié version mtgApp
	   x = decx + this.x_nom + this.dec_x + 2;
	   // y = pos.y + this.y_nom + this.dec_y - 2; // Modifié pour J3P
	   // y = pos.y + this.y_nom + this.dec_y - 6 + this.editeur.clientHeight/2; // Modifié pour J3P
	   // Remodifié le &5-5-2014
	   // y = this.y_nom + this.dec_y - 4 + this.editeur.clientHeight/2; Modifié version MtgApp
	   y = decy + this.y_nom + this.dec_y - 4 + this.editeur.clientHeight/2;
	   // x = this.x_nom + this.dec_x;
	   // y = this.y_nom + this.dec_y - 2;
	   if (par.style.position === "") par.style.position = "relative";
	   var style= "left:"+x+"px;"+"top:"+y+"px;"+"position:absolute;margin:0px;visibility:"+(this.masque ? "hidden;" : "visible;");
	   // var style= "left:"+x+"px;"+"top:"+y+"px;" + "margin:0px;";
	   this.divi.setAttribute("style", style);
	   */
	  this.placeEditeur();
	  if (this.affichageFormule) {
	    this.latex = new CLatex(this.listeProprietaire, null, false, this.couleur, this.x_nom + this.divi.clientWidth + 3, this.y_nom + this.taillePolice / 2 + 2, this.dec_x, this.dec_y, false, null, this.taillePolice, StyleEncadrement.Sans, this.effacementFond, this.couleurFond, CAffichageLieAPoint.alignementHorizontalGauche, CAffichageLieAPoint.alignementVerticalCentre, this.preCodeLaTeX + " " + this.calculAssocie.calcul.chaineLatexSansPar(this.calculAssocie.variableFormelle()));
	    // Ligne suivante ajoutée version WebBack pour pouvoir déplacer un éditeur avec l'outil de capture
	    // Utilisé dans CEditeurFormule.placeNom()
	    this.latex.owner = this;
	  }
	  document.body.removeChild(this.divi);
	  par = svg.parentNode; // Le parent du svg doit être un div
	  // Modification version mtgApp : Dans le cas d'une mtgApp, le parent du svg de la figure est un autre svg
	  // et c'est son div parent qu'il faut utiliser
	  if (par.tagName.toLowerCase() !== "div") par = par.parentNode;
	  // Modifié version 4.9.9.3
	  par.appendChild(this.divi); //On attache l'éditeur au div parent du svg
	};
	
	CEditeurFormule.prototype.placeEditeur = function () {
	  var svg, par, style, x, y;
	  var decx = 0;
	  var decy = 0;
	  svg = document.getElementById(this.listeProprietaire.id);
	  par = svg.parentNode; // Le parent du svg doit être un div
	  // Modification version mtgApp : Dans le cas d'une mtgApp, le parent du svg de la figure est un autre svg
	  // et c'est son div parent qu'il faut utiliser
	  if (par.tagName.toLowerCase() !== "div") {
	    decx = parseInt(svg.getAttribute("x"));
	    decy = parseInt(svg.getAttribute("y"));
	    // par = par.parentNode;
	  }
	  //
	  // var pos = mtg32.getPosition2FirstNonStatic(par);
	  // x = pos.x + this.x_nom + this.dec_x + 1; Modifé version 4.9.2
	  // x = this.x_nom + this.dec_x + 2; Modifié version mtgApp
	  x = decx + this.x_nom + this.dec_x + 2;
	  // y = pos.y + this.y_nom + this.dec_y - 2; // Modifié pour J3P
	  // y = pos.y + this.y_nom + this.dec_y - 6 + this.editeur.clientHeight/2; // Modifié pour J3P
	  // Remodifié le &5-5-2014
	  // y = this.y_nom + this.dec_y - 4 + this.editeur.clientHeight/2; Modifié version MtgApp
	  // y = decy + this.y_nom + this.dec_y - 4 + this.editeur.clientHeight/2;
	  // Modification version WebPack
	  y = decy + this.y_nom + this.dec_y + this.taillePolice / 2 - this.editeur.clientHeight / 2 - 1;
	  // x = this.x_nom + this.dec_x;
	  // y = this.y_nom + this.dec_y - 2;
	  // if (par.style.position === "") par.style.position = "relative"; // Déplacé dans l'appli version mtgApp
	  style = "left:" + x + "px;" + "top:" + y + "px;" + "position:absolute;margin:0px;visibility:" + (this.masque ? "hidden;" : "visible;");
	  // var style= "left:"+x+"px;"+"top:"+y+"px;" + "margin:0px;";
	  this.divi.setAttribute("style", style);
	  // Modifié version 4.9.9.3
	};
	/**
	 * Fonction retirant le div contenant le composant formulaire contenant le input
	 */
	CEditeurFormule.prototype.deleteComponent = function () {
	  try {
	    //this.svg a été établit lors de l'appel à creeEditeur
	    var par = this.svg.parentNode;
	    // Modification version WepPack. Dans cette version le parent peut être un svg
	    if (par.tagName.toLowerCase() !== "div") par = par.parentNode;
	    par.removeChild(this.divi);
	  } catch (ex) {}
	};
	
	// Ajout version webPack
	CEditeurFormule.prototype.createComponent = function () {
	  this.creeEditeur();
	};
	
	CEditeurFormule.prototype.donneCouleur = function (color) {
	  CAffichageLieAPoint.prototype.donneCouleur.call(this, color);
	  if (this.affichageFormule) this.latex.donneCouleur(color);
	};
	
	CEditeurFormule.prototype.setReady4MathJax = function () {
	  CAffichageLieAPoint.prototype.setReady4MathJax.call(this);
	  if (this.affichageFormule) this.latex.setReady4MathJax();
	};
	
	CEditeurFormule.prototype.setReady4MathJaxUpdate = function () {
	  CAffichageLieAPoint.prototype.setReady4MathJaxUpdate.call(this);
	  if (this.affichageFormule) {
	    this.latex.setReady4MathJax(); // Spécial pour cet objet
	  }
	};
	/**
	 * Fonction mettant dans l'éditeur la chaîne de caractères st et mettant à jour
	 * en conséquence l'affichage de formule LaTeX s'il est activé.
	 * @param {type} st
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.setEditorValue = function (st) {
	  this.editeur.value = st;
	  var liste = this.listeProprietaire;
	  var ch = this.variables1Car ? liste.traiteSignesMult(st) : st;
	  var svg = document.getElementById(liste.id);
	  var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	  var varFor = this.calculAssocie.variableFormelle();
	  var bcomplexe = this.calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NCalculComplexe, NatCal.NFonctionComplexe, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var));
	  if (this.affichageFormule) {
	    var calc = bcomplexe ? CalcC.ccbComp(ch, liste, 0, ch.length - 1, varFor) : CalcR.ccb(ch, liste, 0, ch.length - 1, varFor);
	    this.latex.chaineCommentaire = this.preCodeLaTeX + " " + calc.chaineLatexSansPar(varFor);
	    this.latex.positionne(false, dimf);
	    this.latex.setReady4MathJax();
	    MathJax.Hub.Queue([this.callBack, this, svg]);
	  }
	};
	
	CEditeurFormule.prototype.positionne = function (infoRandom, dimfen) {
	  CAffichageLieAPoint.prototype.positionne.call(this, infoRandom, dimfen);
	  if (this.affichageFormule) this.latex.positionne(infoRandom, dimfen);
	};
	
	CEditeurFormule.prototype.trace = function (svg, couleurFond, transparence) {
	  CAffichageLieAPoint.prototype.trace.call(this, svg, couleurFond, transparence);
	  if (this.affichageFormule) {
	    // this.latex.positionne();
	    this.glatex = this.latex.createg();
	    if (!this.affLaTeXPremierAffichage) this.glatex.setAttribute("visibility", "hidden");
	    svg.appendChild(this.glatex);
	  }
	};
	/**
	 * Fonction applelé pour valider ou non sur le plan syntaxique le contenu de l'éditeur.
	 * @param {Boolean} redraw : Di true on réactualise l'affichage de la formule.
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.validation = function (redraw) {
	  var txt, listePr, calculAssocie, chCalcul, indDernier, varFor, bcomplexe, v, calc;
	  listePr = this.listeProprietaire;
	  txt = this.editeur.value;
	  if (txt.length === 0) return true;
	  // String chCalcul = getText(); // Modifié version 4.6
	  chCalcul = this.variables1Car ? listePr.traiteSignesMult(txt) : txt;
	  // Spécial version Applet !
	  calculAssocie = this.calculAssocie;
	  // On autorise d'utiliser un calcul non créé par l'utilisateur
	  indDernier = listePr.indexOf(calculAssocie) - 1;
	  varFor = calculAssocie.variableFormelle();
	  bcomplexe = calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NCalculComplexe, NatCal.NFonctionComplexe, NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var));
	  if (bcomplexe ? CalcC.verifieSyntaxeComplexe(listePr, chCalcul, this.indErr, indDernier, varFor) : CalcR.verifieSyntaxe(listePr, chCalcul, this.indErr, indDernier, varFor)) {
	    calc = bcomplexe ? CalcC.ccbComp(chCalcul, listePr, 0, chCalcul.length - 1, varFor) : CalcR.ccb(chCalcul, listePr, 0, chCalcul.length - 1, varFor);
	    if (calculAssocie.estDeNatureCalcul(Nat.or(NatCal.NCalculReel, NatCal.NCalculComplexe))) {
	      try {
	        calc.listeProprietaire.initialiseNombreIterations();
	        if (bcomplexe) {
	          v = new Complexe();
	          calc.resultatComplexe(false, v);
	        } else {
	          calc.resultat(false);
	        }
	      } catch (e) {
	        this.indErr.setValue(txt.length);
	        return false;
	      }
	    }
	    calculAssocie.calcul = calc;
	    // Modification version 4.5.2 : Quand la chaîne de calcul sera reconstruite elle pourra être différente de celle ici entrée
	    // On la change tout de suite
	    calculAssocie.chaineCalcul = calculAssocie.calcul.chaineCalculSansPar(varFor);
	    //
	    // Modification bug version 4.7.1 : On remet à jour les objets dépendant, en particulier les calculs de dérivées
	    // Modifié version 4.7.2
	    // Modifié version 4.7.3
	    listePr.metAJourObjetsDependantDeSaufEditeursFormule(calculAssocie);
	    // On recalcule la figure et on la réaffiche
	    if (redraw) {
	      var svg = document.getElementById(listePr.id);
	      var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	      listePr.positionne(false, dimf);
	      var doc = listePr.documentProprietaire;
	      // Ajout version 5.2. Indispensable
	      listePr.setReady4MathJaxUpdate();
	      //
	      listePr.update(svg, doc.couleurFond, doc.opacity, true);
	      if (this.affichageFormule) {
	        this.latex.chaineCommentaire = this.preCodeLaTeX + " " + this.calculAssocie.calcul.chaineLatexSansPar(varFor);
	        this.latex.positionne(false, dimf);
	        // Modification version 4.9.2
	        this.latex.setReady4MathJax();
	        var t = this;
	        MathJax.Hub.Queue([this.callBack, t, svg]);
	      }
	    }
	    return true;
	  } else {
	    this.adapteIndiceErreur();
	    return false;
	  }
	};
	/**
	 * Fonction renvoyant true si car est une chaine de un caractère contenant soit
	 * un chiffre soit un caractère ²
	 * @param {String} car
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.chiffreOuCarre = function (car) {
	  return car === '²' || Fonte.chiffre(car);
	};
	/**
	 * Fonction renvoyant true si car est une chaine de un caractère contenant soit
	 * un chiffre soit le point décimal .
	 * @param {String} car
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.chiffreOuPointDecimal = function (car) {
	  return car === '.' || Fonte.chiffre(car);
	};
	/**
	 * Fonction renvoyant true si car est une chaine de un caractère contenant soit
	 * une lettre soit un caractère ' ou "
	 * @param {String} car
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.lettreOuPrime = function (car) {
	  return Fonte.lettre(car) || car === '\'' || car === '\"';
	};
	/**
	 * Fonction renvoyant true si pChaine commence à partir de l'indice indsart
	 * soit par le nom d'une fonction prédéfinie suivi d'une parenthèse ouvrante.
	 * @param {String} pChaine
	 * @param {Integer} indstart
	 * @param {Pointeur} longNom : Au retour longNom.getValue() renvoie la longueur
	 * du nom de la fonction si la recherche a été positive.
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.commenceParNomFonctionPredefinieSuivieParOuvr = function (pChaine, indstart, longNom) {
	  var ch = pChaine.substring(indstart).toLowerCase();
	  var i;
	  // On commence par les fonctions de quatre variables car integrale commence par int une autre fonction
	  for (i = 0; i < Opef4v.nomsFoncs4Var.length; i++) {
	    longNom.setValue(Opef4v.nomsFonctions4Var(i).length);
	    if (ch.indexOf(Opef4v.nomsFonctions4Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef.nomsFoncs.length; i++) {
	    longNom.setValue(Opef.nomsFonctions(i).length);
	    if (ch.indexOf(Opef.nomsFonctions(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef2v.nomsFoncs2Var.length; i++) {
	    longNom.setValue(Opef2v.nomsFonctions2Var(i).length);
	    if (ch.indexOf(Opef2v.nomsFonctions2Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef3v.nomsFoncs3Var.length; i++) {
	    longNom.setValue(Opef3v.nomsFonctions3Var(i).length);
	    if (ch.indexOf(Opef3v.nomsFonctions3Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  for (i = 0; i < Opef5v.nomsFoncs5Var.length; i++) {
	    longNom.setValue(Opef5v.nomsFonctions5Var(i).length);
	    if (ch.indexOf(Opef5v.nomsFonctions5Var(i).toLowerCase() + "(") === 0) return true;
	  }
	  // Inutile de regarder les noms des fonctions complexes de plus de deux variables car c'est le même que les fonctions réelles
	  for (i = 0; i < Opef.nomsFoncsComplexes.length; i++) {
	    longNom.setValue(Opef.nomsFonctionsComplexes(i).length);
	    if (ch.indexOf(Opef.nomsFonctionsComplexes(i).toLowerCase() + "(") === 0) return true;
	  }
	  return false;
	};
	/**
	 * Fonction renvoyant true si, à partir de l'indice indstart, pChaine commence
	 * par un nom de fonction prédéfinie suivi d'une parenthèse ouvrante.
	 * @param {String} pChaine : La chaîne analysée.
	 * @param {Integer} indstart : L'indice du début de la recherche.
	 * @param {Integer} longNom : Renvoie par getValue() la longueur du nom de la fonction
	 * si la recherche a été positive.
	 * @returns {Boolean}
	 */
	CEditeurFormule.prototype.commenceParNomFonctionUtilisateurSuivieParOuvr = function (pChaine, indstart, longNom) {
	  var i, elb, nom;
	  var liste = this.listeProprietaire;
	  var ch = pChaine.substring(indstart).toLowerCase();
	
	  for (i = 0; i < liste.longueur(); i++) {
	    elb = liste.get(i);
	    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(Nat.or(NatCal.NTteFoncR, NatCal.NDerivee, NatCal.NSuiteRecurrenteReelle, NatCal.NTteFoncC, NatCal.NSuiteRecurrenteComplexe))) {
	      nom = elb.getNom();
	      if (ch.indexOf(nom + "(") === 0) {
	        longNom.setValue(nom.length);
	        return true;
	      }
	    }
	  }
	  return false;
	};
	/**
	 * Fonction mettant, dans le cas d'une erreur de syntaxe, dans this .indErr l'indice
	 * de l'erreur dans la chaîne de caractères de l'éditeur, dans le cas où
	 * les signes de multiplication implicites sont utilisés.
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.adapteIndiceErreur = function () {
	  var lon = new Pointeur(0);
	  if (this.variables1Car) {
	    var ch = this.editeur.value;
	    var carprecedent = '(';
	    var k = 0; // Représente l'indice dans la chaîne à laquelle ont été rajoutés des éventuels signs de multiplication
	    var i = 0; // Reprsente l'indice dans la chaîe qui a été entrée avec des multiplications implicites.
	    var len = ch.length;
	    while (k <= this.indErr.getValue() && i < len) {
	      var car = ch.charAt(i);
	      if (this.chiffreOuPointDecimal(car) || car === ')' || car === '+' || car === '-' || car === '*' || car === '/' || car === '^' || car === '\'' || car === '\"' || car === '²') {
	        carprecedent = car;
	        i++;
	        k++;
	      } else {
	        if (ch.indexOf("pi", i) === 0) {
	          k += 2;
	          if (!(this.chiffreOuPointDecimal(carprecedent) || lettreOuPrime(carprecedent) || carprecedent === ')')) k++;
	          carprecedent = ')';
	          i += 2;
	        } else {
	          if (this.commenceParNomFonctionPredefinieSuivieParOuvr(ch, i, lon)) {
	            k += lon.getValue();
	            if (this.chiffreOuPointDecimal(carprecedent) || this.lettreOuPrime(carprecedent) || carprecedent === ')') k++;
	            i += lon.getValue();
	            carprecedent = '(';
	          } else {
	            if (this.commenceParNomFonctionUtilisateurSuivieParOuvr(ch, i, lon)) {
	              k += lon.getValue();
	              if (this.chiffreOuPointDecimal(carprecedent) || this.lettreOuPrime(carprecedent) || carprecedent === ')') k++;
	              i += lon.getValue();
	              carprecedent = '(';
	            } else {
	              k++;
	              i++;
	              // Si lettre suivie d'une autre lettre
	              if (this.lettreOuPrime(carprecedent) && Fonte.lettre(car)) k++;
	              // Si chiffre suivi d'une lettre
	              else if (this.chiffreOuCarre(carprecedent) && Fonte.lettre(car)) k++;
	                // Si chiffre ou lettre suivi d'une parenthèse on rajoute un signe de multiplication
	                else if ((this.chiffreOuCarre(carprecedent) || this.lettreOuPrime(carprecedent)) && car === '(') k++;
	                  // Si parenthèse fermante suivie d'un chiffre ou une lettre ou une parenthèse ouvrante on rajoute un signe de multiplication
	                  else if (carprecedent === ')' && (Fonte.lettre(car) || Fonte.chiffre(car) || car === '(')) k++;
	              carprecedent = car;
	            }
	          }
	        }
	      }
	    }
	    this.indErr.setValue(i);
	  }
	};
	
	CEditeurFormule.prototype.chaineDesignation = function () {
	  return "desEditeur";
	};
	
	CEditeurFormule.prototype.read = function (inps, list) {
	  CAffichageLieAPoint.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.calculAssocie = list.get(ind1, "CFonc");
	  this.enTete = CLatex.traiteAccents(inps.readUTF());
	  this.nbcol = inps.readInt();
	  this.variables1Car = inps.readBoolean();
	  this.affichageFormule = inps.readBoolean();
	  this.preCodeLaTeX = inps.readUTF();
	  this.affLaTeXPremierAffichage = inps.readBoolean();
	  this.affichageTempsReel = inps.readBoolean();
	  // A revoir JavaScript
	  /*
	   if (listeProprietaire.bCreationComposants) {
	   mtgFormulaEditor = new MtgFormulaEditor(this);
	   mtgFormulaEditor.setVisible(!masque);
	   mtgFormulaEditor.setForeground(couleur);
	   }
	   */
	  // Ajout version 4.7.1
	  if (list.className !== "CPrototype") this.creeEditeur();
	  // Ajout version 4.9.3
	  this.callBackOK = null;
	};
	
	CEditeurFormule.prototype.write = function (oups, list) {
	  CAffichageLieAPoint.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.calculAssocie);
	  oups.writeInt(ind1);
	  oups.writeUTF(this.enTete);
	  oups.writeInt(this.nbcol);
	  oups.writeBoolean(this.variables1Car);
	  // Ajout version 4.7.2
	  oups.writeBoolean(this.affichageFormule);
	  oups.writeUTF(this.preCodeLaTeX);
	  oups.writeBoolean(this.affLaTeXPremierAffichage);
	  oups.writeBoolean(this.affichageTempsReel);
	};
	
	/**
	 * Fonction à appeler depuis un autre code JavaScript.
	 * Quant l'utilisateur validera sa formule dans l'éditeur
	 * par la touche Entée, a fonction f possédée par le code appelant sera allors appelée.
	 * @param {type} f
	 * @returns {undefined}
	 */
	CEditeurFormule.prototype.setCallBackOK = function (f) {
	  this.callBackOK = f;
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Nat = __webpack_require__(4);
	var CElementBase = __webpack_require__(33);
	var NatObj = __webpack_require__(3);
	module.exports = CElementGenerique;
	
	function CElementGenerique(listeProprietaire, impProto, estElementFinal) {
	  if (arguments.length === 1) CElementBase.call(this, listeProprietaire);else {
	    CElementBase.call(this, listeProprietaire, impProto, estElementFinal);
	  }
	  this.nom = "";
	  this.elementAssocie = null;
	  this.natureGraphique = 0;
	  this.natCal = 0;
	}
	CElementGenerique.prototype = new CElementBase();
	CElementGenerique.prototype.constructor = CElementGenerique;
	CElementGenerique.prototype.superClass = "CElementBase";
	CElementGenerique.prototype.className = "CElementGenerique";
	
	CElementGenerique.prototype.read = function (inps, list) {
	  this.nom = inps.readUTF();
	  var ind = inps.readInt();
	  var low = ind < 32 ? 1 << ind : 0;
	  var high = ind < 32 ? 0 : 1 << 32 - ind;
	  this.natureGraphique = new Nat(low, high);
	  ind = inps.readInt();
	  low = ind < 32 ? 1 << ind : 0;
	  high = ind < 32 ? 0 : 1 << 32 - ind;
	  this.natCal = new Nat(low, high);
	};
	
	CElementGenerique.prototype.write = function (oups, list) {
	  oups.writeUTF(this.nom);
	  oups.writeInt(this.indiceDeNature(this.natureGraphique));
	  oups.writeInt(this.indiceDeNature(this.natCal));
	};
	// A revoir version mtgApp
	/*
	CElementGenerique.prototype.adapteNature = function(indiceNatureC) {
	  this.natureGraphique = 0;
	  this.NatCal = 0;
	  switch (indiceNatureC) {
	  case 0 :
	    this.natureGraphique = mtg32.NatObj.NPointBase;
	    break;
	  case 1 :
	    this.natureGraphique = mtg32.NatObj.NPoint;
	    break;
	  case 2 :
	    this.natureGraphique = mtg32.NatObj.NPointLie;
	    break;
	  case 3 :
	    this.natureGraphique = mtg32.NatObj.NBarycentre;
	    break;
	  case 4 :
	    this.natureGraphique = mtg32.NatObj.NSegment;
	    break;
	  case 5 :
	    this.natureGraphique = mtg32.NatObj.NDroite;
	    break;
	  case 6 :
	    this.natureGraphique = mtg32.NatObj.NVecteur;
	    break;
	  case 7 :
	    this.natureGraphique = mtg32.NatObj.NDemiDroite;
	    break;
	  case 8 :
	    this.natureGraphique = mtg32.NatObj.NCercle;
	    break;
	  case 9 :
	    this.natureGraphique = mtg32.NatObj.NMarqueAngle;
	    break;
	  case 10 :
	    this.natureGraphique = mtg32.NatObj.NValeurAffichee;
	    break;
	  case 11 :
	    this.natureGraphique = mtg32.NatObj.NArc;
	    break;
	  case 12 :
	    this.natureGraphique = mtg32.NatObj.NLieu;
	    break;
	  case 13 :
	    // Attention : Dans la version java, le repère est à la fois graphique (car il doit être affiché) et non graphique
	    // Il est considéré comme non graphique car dans les constructions il est choisi en premier dans
	    // les objets non graphiques
	    this.natureGraphique = mtg32.NatObj.NRepere;
	    this.NatCal = NatCal.NRepere;
	    break;
	  case 14 :
	    this.natureGraphique = mtg32.NatObj.NPointDansRepere;
	    break;
	  case 15 :
	    this.natureGraphique = mtg32.NatObj.NCommentaire;
	    break;
	  case 16 :
	    this.natureGraphique = mtg32.NatObj.NPointLiePoint;
	    break;
	  case 17 :
	    this.natureGraphique = mtg32.NatObj.NPolygone;
	    break;
	  case 18 :
	    this.natureGraphique = mtg32.NatObj.NSurface;
	    break;
	  case 19 :
	    this.natureGraphique = mtg32.NatObj.NObjetDuplique;
	    break;
	  case 20 :
	    this.natureGraphique = mtg32.NatObj.NGrapheSuiteRec;
	    break;
	  case 21 :
	    this.natureGraphique = mtg32.NatObj.NBipoint;
	    break;
	  case 22 :
	    this.natureGraphique = mtg32.NatObj.NTransformation;
	    break;
	  case 23 :
	    this.natureGraphique = mtg32.NatObj.NValeurAffichee;
	    break;
	  case 24 :
	    this.NatCal = NatCal.NVariable;
	    break;
	  case 25 :
	    this.NatCal = NatCal.NCalculReel;
	    break;
	  case 26 :
	    this.NatCal = NatCal.NFonction;
	    break;
	  case 27 :
	    this.NatCal = NatCal.NSuiteRecurrenteReelle;
	    break;
	  case 28 :
	    this.natureGraphique = mtg32.NatObj.NMacro;
	    break;
	  case 29 :
	    this.natureGraphique = mtg32.NatObj.NDemiPlan;
	    break;
	  case 30 :
	    this.NatCal = NatCal.NAutreCalcul;
	    break;
	  case 31 :
	    this.natureGraphique = mtg32.NatObj.NLieuDiscret;
	    break;
	  case 32 :
	    this.natureGraphique = mtg32.NatObj.NLigneBrisee;
	    break;
	  case 33 :
	    this.natureGraphique = mtg32.NatObj.NMarqueSegment;
	    break;
	  case 34 :
	    this.natureGraphique = mtg32.NatObj.NImage;
	    break;
	  case 35 :
	    this.natureGraphique = mtg32.NatObj.NLieuObjet;
	    break;
	  case 36 :
	    this.NatCal = NatCal.NCalculComplexe;
	    break;
	  case 37 :
	    this.NatCal = NatCal.NFonctionComplexe;
	    break;
	  case 38 :
	    this.natureGraphique = mtg32.NatObj.NPointParAffixe;
	    break;
	  case 39 :
	    this.NatCal = NatCal.NSuiteRecurrenteComplexe;
	    break;
	  case 40 :
	    this.NatCal = NatCal.NMesureAffixe; // à revoir
	    break;
	  case 41 :
	    this.natureGraphique = mtg32.NatObj.NGrapheSuiteRecComplexe;
	    break;
	  }
	};
	*/
	CElementGenerique.prototype.getNature = function () {
	  return this.natureGraphique;
	};
	CElementGenerique.prototype.getNatureCalcul = function () {
	  return this.NatCal;
	};
	// A revoir JavaScript
	CElementGenerique.prototype.indiceDeNature = function (nature) {
	  return NatObj.indiceDeNature(nature);
	};
	CElementGenerique.prototype.indiceNatureGraphique = function (indice) {
	  if (indice < 30) return indice;else return indice - 4;
	};
	/*
	CElementGenerique.prototype.nature = function(indiceNature) {
	  if (indiceNature === -1) return 0;
	  return 1 << indiceNature;
	}
	*/

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CalcC = __webpack_require__(69);
	var CFoncNVar = __webpack_require__(119);
	module.exports = CFoncComplexeNVar;
	
	/**
	 * Fonction complexe de n variables.
	 * @constructor
	 * @extends CFoncNVar
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet;
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet;
	 * @param {Boolean} estElementFinal : true si l'objet est un objet inal de construction;
	 * @param {String} nomCalcul : Le nom de la fonction.
	 * @param {String} chaineCalcul : La formule définissnt la fonction;
	 * @param {Arrray} chaineVariable : Un array de String donnant les variables formelles.
	 * @param {CCb} calcul : Un arbre binaire de calcul représentant la fonction.
	 * @returns {CFoncComplexeNVar}
	 */
	// Attention : Ordre des deux derniers paramètres changé par rapport à Java
	function CFoncComplexeNVar(listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, chaineVariable, calcul) {
	  if (arguments.length <= 6) calcul = null;
	  if (arguments.length === 1) CFoncNVar.call(this, listeProprietaire);else {
	    if (calcul === null) CFoncNVar.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, chaineVariable, CalcC.ccbComp(chaineCalcul, listeProprietaire, 0, chaineCalcul.length - 1, chaineVariable));else CFoncNVar.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, chaineCalcul, chaineVariable, calcul);
	  }
	}
	CFoncComplexeNVar.prototype = new CFoncNVar();
	CFoncComplexeNVar.prototype.constructor = CFoncComplexeNVar;
	CFoncComplexeNVar.prototype.superClass = "CFoncNVar";
	CFoncComplexeNVar.prototype.className = "CFoncComplexeNVar";
	
	CFoncComplexeNVar.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var calculClone = this.calcul.getClone(listeSource, listeCible);
	  return new CFoncComplexeNVar(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, this.chaineCalcul, calculClone, this.chaineVariable);
	};
	CFoncComplexeNVar.prototype.getNatureCalcul = function () {
	  switch (this.nbVar) {
	    case 2:
	      return NatCal.NFonctionComplexe2Var;
	    case 3:
	      return NatCal.NFonctionComplexe3Var;
	    default:
	      return NatCal.NFonctionComplexeNVar;
	  }
	};
	/* Version 4.9.7 : Transféré dans CFoncComplexe
	CFoncComplexeNVar.prototype.rendValeurFonctionComplexe = function(infoRandom, parametre, zRes) {
	  this.calcul.resultatFonctionComplexe(infoRandom, parametre, zRes);
	}
	*/

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var kernel = __webpack_require__(8);
	var CElementLigne = __webpack_require__(77);
	var CPointDansRepere = __webpack_require__(133);
	module.exports = CGrapheSuiteRec;
	var CSegment = __webpack_require__(134);
	
	/**
	 * Classe représentant le graphe d'une suite réelle de la formue u(n+1)=f[u(n)]
	 * @constructor
	 * @extends CElementLigne
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur du graphe
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé pour le tracé.
	 * @param {CSuiteRec} suiteAssociee : La suite récurrente dont c'est le graphe
	 * @param {CRepere} repereAssocie : Le repère dans lequel est tracé le graphe.
	 * @param {Boolean} traitsDeRappelSurAbscisses : true si des traits "veticaux" sont utilisés pour le graphe.
	 * @returns {CGrapheSuiteRec}
	 */
	function CGrapheSuiteRec(listeProprietaire, impProto, estElementFinal, couleur, masque, style, suiteAssociee, repereAssocie, traitsDeRappelSurAbscisses) {
	  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	    CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 16, style);
	    this.suiteAssociee = suiteAssociee;
	    this.repereAssocie = repereAssocie;
	    this.traitsDeRappelSurAbscisses = traitsDeRappelSurAbscisses;
	  }
	
	  this.point1 = new CPointDansRepere(null, this.repereAssocie);
	  this.point2 = new CPointDansRepere(null, this.repereAssocie);
	  this.seg = new CSegment(this.point1, this.point2);
	}
	CGrapheSuiteRec.prototype = new CElementLigne();
	CGrapheSuiteRec.prototype.constructor = CGrapheSuiteRec;
	CGrapheSuiteRec.prototype.superClass = "CElementLigne";
	CGrapheSuiteRec.prototype.className = "CGrapheSuiteRec";
	
	CGrapheSuiteRec.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.suiteAssociee);
	  var ind2 = listeSource.indexOf(this.repereAssocie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CGrapheSuiteRec(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CSuiteRec"), listeCible.get(ind2, "CRepere"), this.traitsDeRappelSurAbscisses);
	};
	
	CGrapheSuiteRec.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CElementLigne.prototype.dependDe.call(this, p) || this.suiteAssociee.dependDe(p) || this.repereAssocie.dependDe(p));
	};
	CGrapheSuiteRec.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.suiteAssociee.dependDePourBoucle(p) || this.repereAssocie.dependDePourBoucle(p);
	};
	CGrapheSuiteRec.prototype.getNature = function () {
	  return NatObj.NGrapheSuiteRec;
	};
	CGrapheSuiteRec.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.repereAssocie === p.repereAssocie && this.suiteAssociee === p.suiteAssociee;
	  } else return false;
	};
	CGrapheSuiteRec.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.suiteAssociee.existe && this.repereAssocie.existe;
	  // Cette classe doit mémoriser dans positionne() la valeur de dimfen
	  this.dimf = dimfen;
	};
	CGrapheSuiteRec.prototype.hasg = function (masquage) {
	  return CElementLigne.prototype.hasg.call(this, masquage) && this.suiteAssociee.indiceDernierTermeExistant !== 0;
	};
	CGrapheSuiteRec.prototype.createg = function () {
	  var g, polyline, path;
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  style += "stroke:" + this.color + ";";
	  style += "fill:none";
	  polyline = kernel.cens("polyline", {
	    style: style,
	    points: this.getPointsForPolyline()
	  });
	  g = kernel.cens("g", {
	    style: style,
	    "pointer-events": "none"
	  });
	  g.appendChild(polyline);
	  if (this.traitsDeRappelSurAbscisses) {
	    path = kernel.cens("path", {
	      style: style,
	      d: this.getdForPath()
	    });
	    g.appendChild(path);
	  }
	  return g;
	};
	// Modifié version 5.0.3 pour gérer les coordonnées trop grandes
	// Et la variable i était globale !
	CGrapheSuiteRec.prototype.getPointsForPolyline = function () {
	  var p = "";
	  var i, x1, y1, x2, y2;
	  for (i = 1; i <= this.suiteAssociee.indiceDernierTermeExistant; i++) {
	    if (i === 1) {
	      this.point1.abs.donneValeur(this.suiteAssociee.valeurs[0]);
	      this.point1.ord.donneValeur(this.suiteAssociee.valeurs[1]);
	      this.point2.abs.donneValeur(this.suiteAssociee.valeurs[1]);
	      this.point2.ord.donneValeur(this.suiteAssociee.valeurs[1]);
	      this.point1.positionne(false, this.dimf);
	      this.point2.positionne(false, this.dimf);
	      x1 = this.point1.x;
	      y1 = this.point1.y;
	      x2 = this.point2.x;
	      y2 = this.point2.y;
	      if (!kernel.testToile(x1, y1) || !kernel.testToile(x2, y2)) return "";
	      p += x1 + "," + y1 + " " + x2 + "," + y2 + " ";
	    } else {
	      this.point1.abs.donneValeur(this.suiteAssociee.valeurs[i - 1]);
	      this.point1.ord.donneValeur(this.suiteAssociee.valeurs[i]);
	      this.point1.positionne(false, this.dimf);
	      x1 = this.point1.x;
	      y1 = this.point1.y;
	      this.point2.abs.donneValeur(this.suiteAssociee.valeurs[i]);
	      this.point2.ord.donneValeur(this.suiteAssociee.valeurs[i]);
	      this.point2.positionne(false, this.dimf);
	      x2 = this.point2.x;
	      y2 = this.point2.y;
	      if (!kernel.testToile(x1, y1) || !kernel.testToile(x2, y2)) return p;
	      p += x1 + "," + y1 + " " + x2 + "," + y2 + " ";
	    }
	  }
	  return p;
	};
	// Modifié version 5.0.3 pour gérer les coordonnées trop grandes
	// Et les variables i et d étaient globale !
	CGrapheSuiteRec.prototype.getdForPath = function () {
	  var d = "";
	  var i, x1, y1, x2, y2;
	  for (i = 0; i < this.suiteAssociee.indiceDernierTermeExistant; i++) {
	    this.point1.abs.donneValeur(this.suiteAssociee.valeurs[i]);
	    this.point1.ord.donneValeur(0);
	    this.point2.abs.donneValeur(this.suiteAssociee.valeurs[i]);
	    this.point2.ord.donneValeur(this.suiteAssociee.valeurs[i + 1]);
	    this.point1.positionne(false, this.dimf);
	    this.point2.positionne(false, this.dimf);
	    x1 = this.point1.x;
	    y1 = this.point1.y;
	    x2 = this.point2.x;
	    y2 = this.point2.y;
	    if (!kernel.testToile(x1, y1) || !kernel.testToile(x2, y2)) return d;
	    d = d + "M" + x1 + " " + y1 + "L" + x2 + " " + y2;
	  }
	  this.point1.abs.donneValeur(this.suiteAssociee.valeurs[i]);
	  this.point1.ord.donneValeur(0);
	  this.point2.abs.donneValeur(this.suiteAssociee.valeurs[i]);
	  this.point2.ord.donneValeur(this.suiteAssociee.valeurs[i]);
	  this.point1.positionne(false, this.dimf);
	  this.point2.positionne(false, this.dimf);
	  x1 = this.point1.x;
	  y1 = this.point1.y;
	  x2 = this.point2.x;
	  y2 = this.point2.y;
	  if (!kernel.testToile(x1, y1) || !kernel.testToile(x2, y2)) return d;
	  d += "M" + x1 + " " + y1 + "L" + x2 + " " + y2;
	  return d;
	};
	CGrapheSuiteRec.prototype.trace = function (svg) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CGrapheSuiteRec.prototype.update = function () {
	  var g = this.g;
	  var pol = g.childNodes[0];
	  pol.setAttribute("points", this.getPointsForPolyline());
	  if (this.traitsDeRappelSurAbscisses) {
	    g.childNodes[1].setAttribute("d", this.getdForPath());
	  }
	};
	CGrapheSuiteRec.prototype.chaineDesignation = function () {
	  return "desGrapheSuiteRec";
	};
	CGrapheSuiteRec.prototype.read = function (inps, list) {
	  CElementLigne.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.suiteAssociee = list.get(ind1, "CSuiteRec");
	  this.repereAssocie = list.get(ind2, "CRepere");
	  this.traitsDeRappelSurAbscisses = inps.readBoolean();
	  this.point1.rep = this.repereAssocie;
	  this.point2.rep = this.repereAssocie;
	};
	CGrapheSuiteRec.prototype.write = function (oups, list) {
	  CElementLigne.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.suiteAssociee);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.repereAssocie);
	  oups.writeInt(ind2);
	  oups.writeBoolean(this.traitsDeRappelSurAbscisses);
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Color = __webpack_require__(6);
	var Vect = __webpack_require__(12);
	var CPt = __webpack_require__(87);
	var CValeur = __webpack_require__(80);
	module.exports = CPointDansRepere;
	
	/**
	 * Classe représentant un point défini par ses coordonnées dans un repère.
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CRepere} rep : Le repère associé
	 * @param {CValeur} abs : L'abscisse
	 * @param {CValeur} ord : L'ordonnée
	 * @returns {undefined}
	 */
	function CPointDansRepere(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, rep, abs, ord) {
	  if (arguments.length === 1) {
	    CPt.call(this, listeProprietaire);
	    this.abs = new CValeur();
	    this.ord = new CValeur();
	  } else {
	    if (arguments.length === 2) {
	      //Spécial objets internes
	      CPt.call(this, arguments[0], null, false, Color.black, true, 0, 0, false, "", 2, 0, false);
	      this.rep = arguments[1];
	      this.abs = new CValeur();
	      this.ord = new CValeur();
	    } else {
	      CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	      this.rep = rep;
	      this.abs = abs;
	      this.ord = ord;
	    }
	  }
	}
	CPointDansRepere.prototype = new CPt();
	CPointDansRepere.prototype.constructor = CPointDansRepere;
	CPointDansRepere.prototype.superClass = "CPt";
	CPointDansRepere.prototype.className = "CPointDansRepere";
	
	CPointDansRepere.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var absClone = this.abs.getClone(listeSource, listeCible);
	  var ordClone = this.ord.getClone(listeSource, listeCible);
	  return new CPointDansRepere(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CRepere"), absClone, ordClone);
	};
	
	CPointDansRepere.prototype.initialisePourDependance = function () {
	  CPt.prototype.initialisePourDependance.call(this);
	  this.abs.initialisePourDependance();
	  this.ord.initialisePourDependance();
	};
	
	CPointDansRepere.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.rep.dependDe(p) || this.abs.dependDe(p) || this.ord.dependDe(p));
	};
	
	CPointDansRepere.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.rep.dependDePourBoucle(p) || this.abs.dependDePourBoucle(p) || this.ord.dependDePourBoucle(p);
	};
	
	CPointDansRepere.prototype.positionne = function (infoRandom, dimfen) {
	  this.abs.positionne(infoRandom, dimfen);
	  this.ord.positionne(infoRandom, dimfen);
	  this.existe = this.abs.existe && this.ord.existe && this.rep.existe;
	  if (!this.existe) return;
	  var k1 = this.abs.rendValeur();
	  var k2 = this.ord.rendValeur();
	  var vec = new Vect();
	  var unitex = this.rep.unitex;
	  var unitey = this.rep.unitey;
	
	  vec.x = k1 * this.rep.u.x / unitex + k2 * this.rep.v.x / unitey;
	  vec.y = k1 * this.rep.u.y / unitex + k2 * this.rep.v.y / unitey;
	  this.x = this.rep.origine.x + vec.x;
	  this.y = this.rep.origine.y + vec.y;
	  CPt.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CPointDansRepere.prototype.confonduAvec = function (p) {
	  if (p.className === this.classname) {
	    return this.rep === p.rep && this.abs.confonduAvec(p.abs) && this.ord.confonduAvec(p.ord);
	  } else return false;
	};
	
	CPointDansRepere.prototype.getNature = function () {
	  return NatObj.NPointDansRepere;
	};
	
	CPointDansRepere.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.rep.o);
	  liste.add(this.rep.i);
	  liste.add(this.rep.j);
	};
	
	CPointDansRepere.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.rep = list.get(ind1, "CRepere");
	  this.abs.read(inps, list);
	  this.ord.read(inps, list);
	};
	
	CPointDansRepere.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.rep);
	  oups.writeInt(ind1);
	  this.abs.write(oups, list);
	  this.ord.write(oups, list);
	};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CDroite = __webpack_require__(98);
	var Color = __webpack_require__(6);
	module.exports = CSegment;
	/**
	 * Classe représentant un segment défini par ses deux points extrémités.
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {Color} couleur : La couleur de l'objet.
	 * @param {boolean} masque : true si le nom de l'objet est masqué
	 * @param {StyleTrait} style : Le style du tracé.
	 * @param {CPt} point1 : La première extrémité.
	 * @param {CPt} point2 : La deuxième extrémité.
	 * @constructor
	 */
	function CSegment(listeProprietaire, impProto, estElementFinal, couleur, masque, style, point1, point2) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    if (arguments.length === 2) {
	      // Pour objets internes
	      CDroite.call(this, null, null, true, Color.black, false, 0, 0, false, "", 16, 0, 0);
	      this.point1 = arguments[0];
	      this.point2 = arguments[1];
	    } else {
	      CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, false, 0, 0, masque, "", 16, style, 0.9);
	      this.point1 = point1;
	      this.point2 = point2;
	    }
	  }
	}
	CSegment.prototype = new CDroite();
	CSegment.prototype.constructor = CSegment;
	CSegment.prototype.superClass = "CDroite";
	CSegment.prototype.className = "CSegment";
	
	// A revoir JavaScript
	//  public void donneExtremites(CPt pt1, CPt pt2) {
	//    point1 = pt1;
	//    point2 = pt2;
	//  }
	
	CSegment.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.point1);
	  var ind2 = listeSource.indexOf(this.point2);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CSegment(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"));
	};
	CSegment.prototype.setClone = function (ptel) {
	  CDroite.prototype.setClone.call(this, ptel);
	  this.x1 = ptel.x1;
	  this.y1 = ptel.y1;
	  this.x2 = ptel.x2;
	  this.y2 = ptel.y2;
	};
	CSegment.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.point1);
	  liste.add(this.point2);
	};
	CSegment.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.point1.dependDe(p) || this.point2.dependDe(p));
	};
	CSegment.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.point1.dependDePourBoucle(p) || this.point2.dependDePourBoucle(p);
	};
	CSegment.prototype.positionne = function (infoRandom, dimfen) {
	  var u1, u2;
	  this.existe = this.point1.existe && this.point2.existe;
	  if (!this.existe) return;
	  if (arguments.length === 0) {
	    // Spécial segments internes aux objets
	    this.point_x = this.point1.x;
	    this.point_y = this.point1.y;
	    this.vect.setVecteur(this.point1, this.point2);
	    this.xext1 = this.point1.x;
	    this.yext1 = this.point1.y;
	    this.xext2 = this.point2.x;
	    this.yext2 = this.point2.y;
	    this.x1 = this.xext1;
	    this.y1 = this.yext1;
	    this.x2 = this.xext2;
	    this.y2 = this.yext2;
	  } else {
	    // Ajout version 3.2.0. Utilisé dans appartientA
	    this.x1 = this.point1.x;
	    this.y1 = this.point1.y;
	    this.x2 = this.point2.x;
	    this.y2 = this.point2.y;
	
	    this.point_x = this.x1;
	    this.point_y = this.y1;
	    this.vect.setVecteur(this.point1, this.point2);
	    if (this.vect.nul()) {
	      this.existe = true;
	      this.horsFenetre = true;
	      return;
	    }
	    if (this.point1.dansFenetre && this.point2.dansFenetre) {
	      this.xext1 = this.x1;
	      this.yext1 = this.y1;
	      this.xext2 = this.x2;
	      this.yext2 = this.y2;
	      this.horsFenetre = false;
	    } else {
	      // Au moins un des deux points est hors-fenêtre
	      CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	      // Si la droite est hors fenetre le segment l'est aussi
	      if (this.horsFenetre) return;
	      if (this.point1.dansFenetre) {
	        // point2 n'est pas dans la fenêtre
	        u1 = new Vect(this.point1, this.point2);
	        u2 = new Vect(this.x1, this.y1, this.xext1, this.yext1);
	        if (u2.presqueNul()) {
	          this.horsFenetre = true;
	          return;
	        }
	        if (kernel.colineairesMemeSens(u1, u2)) {
	          this.xext2 = this.x1;
	          this.yext2 = this.y1;
	        } else {
	          this.xext1 = this.x1;
	          this.yext1 = this.y1;
	        }
	      } else {
	        if (this.point2.dansFenetre) {
	          // point1 n'est pas dans la fenêtre
	          u1 = new Vect(this.point2, this.point1);
	          u2 = new Vect(this.x2, this.y2, this.xext1, this.yext1);
	          if (u2.presqueNul()) {
	            this.horsFenetre = true;
	            return;
	          }
	          if (kernel.colineairesMemeSens(u1, u2)) {
	            this.xext2 = this.x2;
	            this.yext2 = this.y2;
	          } else {
	            this.xext1 = this.x2;
	            this.yext1 = this.y2;
	          }
	        } else {
	          // Si les deux points sont hors-fenêtre on regarde si un des points d'intersection
	          // de la droite avec le cadre de la fenêtre appartient au segment
	          // Correction d'un bug version 3.2.4 : il faut les deux tests car un des deux points peut être presque sur le bord
	          // if (!Kernel.appartientSegment(xext1, yext1, x1, y1, x2, y2)) horsFenetre = true;
	          if (!kernel.appartientSegment(this.xext1, this.yext1, this.x1, this.y1, this.x2, this.y2) || !kernel.appartientSegment(this.xext2, this.yext2, this.x1, this.y1, this.x2, this.y2)) this.horsFenetre = true;
	        }
	      }
	    }
	  }
	};
	CSegment.prototype.abscisseMinimale = function () {
	  // Cas d'un segment ayant ses extrémités confondues
	  if (this.vect.x === 0 && this.vect.y === 0) return 0;
	  if (Math.abs(this.vect.x) >= Math.abs(this.vect.y)) return (this.x1 - this.point_x) / this.vect.x;else return (this.y1 - this.point_y) / this.vect.y;
	};
	CSegment.prototype.abscisseMaximale = function () {
	  // Cas d'un segment ayant ses extrémités confondues
	  if (this.vect.x === 0 && this.vect.y === 0) return 0;
	  if (Math.abs(this.vect.x) >= Math.abs(this.vect.y)) return (this.x2 - this.point_x) / this.vect.x;else return (this.y2 - this.point_y) / this.vect.y;
	};
	// Ajout version 3.2.0
	// Pour ne rien faire lorsque CDroite.positionne appelle positionneNom()
	CSegment.prototype.positionneNom = function () {};
	CSegment.prototype.appartientA = function (x, y) {
	  if (!this.existe) return false;else return kernel.appartientSegment(x, y, this.x1, this.y1, this.x2, this.y2);
	};
	CSegment.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.point1 === p.point1 && this.point2 === p.point2 || this.point1 === p.point2 && this.point2 === p.point1;
	  } else return false;
	};
	CSegment.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.point1 === ancienPoint) this.point1 = nouveauPoint;
	  if (this.point2 === ancienPoint) this.point2 = nouveauPoint;
	};
	CSegment.prototype.getNature = function () {
	  return NatObj.NSegment;
	};
	CSegment.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.point1 = list.get(ind1, "CPt");
	  this.point2 = list.get(ind2, "CPt");
	};
	CSegment.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.point1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.point2);
	  oups.writeInt(ind2);
	};
	CSegment.prototype.contientParDefinition = function (po) {
	  return this.point1 === po || this.point2 === po;
	};
	CSegment.prototype.estParalleleParDefinition = function (dte) {
	  return dte === this || this.point1.appartientDroiteParDefinition(dte) && this.point2.appartientDroiteParDefinition(dte) || dte.formentDroiteParallele(this.point1, this.point2);
	};
	CSegment.prototype.chaineDesignation = function () {
	  return "desSegment";
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var kernel = __webpack_require__(8);
	var CElementLigne = __webpack_require__(77);
	var CPointDansRepere = __webpack_require__(133);
	var CValeur = __webpack_require__(80);
	var CSegment = __webpack_require__(134);
	module.exports = CGrapheSuiteRecComplexe;
	
	/**
	 * Graphe d'une suite récurrente complexe.
	 * @constructor
	 * @extends CElementLigne
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur du graphe
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé pour le tracé.
	 * @param {CSuiteRecComplexe} suiteAssociee : La suite récurrente donc c'est le graphe.
	 * @param {CRepere} repereAssocie : Le repère dans leque le graphe est tracé.
	 * @param {mtg32.MotifPoint} motif : Le style utilisé par les points du graphe.
	 * @param {Boolean} pointsRelies : Si true les points sont reliés par des segments.
	 * @returns {CGrapheSuiteRecComplexe}
	 */
	function CGrapheSuiteRecComplexe(listeProprietaire, impProto, estElementFinal, couleur, masque, style, suiteAssociee, repereAssocie, motif, pointsRelies) {
	  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	    CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 16, style);
	    this.suiteAssociee = suiteAssociee;
	    this.repereAssocie = repereAssocie;
	    this.motif = motif;
	    this.pointsRelies = pointsRelies;
	    this.point1 = new CPointDansRepere(listeProprietaire, null, false, couleur, true, 0, 0, false, "", 16, motif, false, repereAssocie, new CValeur(), new CValeur());
	    this.point2 = new CPointDansRepere(listeProprietaire, this.repereAssocie);
	    this.seg = new CSegment(this.point1, this.point2); // Sert pour distancePoint
	  }
	}
	CGrapheSuiteRecComplexe.prototype = new CElementLigne();
	CGrapheSuiteRecComplexe.prototype.constructor = CGrapheSuiteRecComplexe;
	CGrapheSuiteRecComplexe.prototype.superClass = "CElementLigne";
	CGrapheSuiteRecComplexe.prototype.className = "CGrapheSuiteRecComplexe";
	
	CGrapheSuiteRecComplexe.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.suiteAssociee);
	  var ind2 = listeSource.indexOf(this.repereAssocie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CGrapheSuiteRecComplexe(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CSuiteRecComplexe"), listeCible.get(ind2, "CRepere"), this.motif, this.pointsRelies);
	};
	
	CGrapheSuiteRecComplexe.prototype.donneCouleur = function (coul) {
	  CElementLigne.prototype.donneCouleur.call(this, coul);
	  this.point1.donneCouleur(coul);
	};
	
	CGrapheSuiteRecComplexe.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CElementLigne.prototype.dependDe.call(this, p) || this.suiteAssociee.dependDe(p) || this.repereAssocie.dependDe(p));
	};
	CGrapheSuiteRecComplexe.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.suiteAssociee.dependDePourBoucle(p) || this.repereAssocie.dependDePourBoucle(p);
	};
	CGrapheSuiteRecComplexe.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.suiteAssociee.existe && this.repereAssocie.existe;
	  this.dimf = dimfen;
	};
	CGrapheSuiteRecComplexe.prototype.hasg = function (masquage) {
	  return CElementLigne.prototype.hasg.call(this, masquage) && this.suiteAssociee.indiceDernierTermeExistant !== 0;
	};
	// Modifié version 5.0.3 pour te,ir compte des points dont les coordonnées sont trop grandes
	CGrapheSuiteRecComplexe.prototype.createg = function () {
	  var i, g, polyline, x, y;
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  // style += "stroke:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	  style += "stroke:" + this.color + ";";
	  style += "fill:none";
	  var p = "";
	  g = kernel.cens("g");
	  for (i = 0; i <= this.suiteAssociee.indiceDernierTermeExistant; i++) {
	    this.point1.abs.donneValeur(this.suiteAssociee.valeurs[i].x);
	    this.point1.ord.donneValeur(this.suiteAssociee.valeurs[i].y);
	    this.point1.positionne(false, this.dimf);
	    if (this.point1.hasg(false)) g.appendChild(this.point1.createg());
	    if (this.pointsRelies) {
	      // Modification version 5.0.3
	      x = this.point1.x;
	      y = this.point1.y;
	      if (!kernel.testToile(x, y)) break;
	      //
	      p += x + "," + y + " ";
	    }
	  }
	  polyline = kernel.cens("polyline", {
	    style: style,
	    points: p
	  });
	  g.appendChild(polyline);
	  g.setAttribute("pointer-events", "none");
	  return g;
	};
	CGrapheSuiteRecComplexe.prototype.trace = function (svg) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CGrapheSuiteRecComplexe.prototype.update = function (svg) {
	  var oldg = this.g;
	  var g = this.createg();
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CGrapheSuiteRecComplexe.prototype.getNature = function () {
	  return NatObj.NGrapheSuiteRecComplexe;
	};
	CGrapheSuiteRecComplexe.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.repereAssocie === p.repereAssocie && this.suiteAssociee === p.suiteAssociee;else return false;
	};
	CGrapheSuiteRecComplexe.prototype.chaineDesignation = function () {
	  return "desGrapheSuiteRec";
	};
	CGrapheSuiteRecComplexe.prototype.read = function (inps, list) {
	  CElementLigne.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.suiteAssociee = list.get(ind1, "CSuiteRecComplexe");
	  this.repereAssocie = list.get(ind2, "CRepere");
	  this.pointsRelies = inps.readBoolean();
	  this.motif = inps.readByte();
	  this.point1 = new CPointDansRepere(this.listeProprietaire, null, false, this.couleur, true, 0, 0, false, "", 16, this.motif, false, this.repereAssocie, new CValeur(), new CValeur());
	  this.point2 = new CPointDansRepere(this.listeProprietaire, this.repereAssocie);
	  this.seg = new CSegment(this.point1, this.point2); // Sert pour distancePOint
	};
	CGrapheSuiteRecComplexe.prototype.write = function (oups, list) {
	  CElementLigne.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.suiteAssociee);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.repereAssocie);
	  oups.writeInt(ind2);
	  oups.writeBoolean(this.pointsRelies);
	  oups.writeByte(this.motif);
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CTransformation = __webpack_require__(100);
	var CValeur = __webpack_require__(80);
	module.exports = CHomothetie;
	
	/**
	 * Classe représentant une homothétie (objet transformation).
	 * @constructor
	 * @extends CTransformation
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} centre : Le point centre de l'homothétie.
	 * @param {CValeur} rapport : Le rapport de l'homothétie
	 * @returns {CHomothetie}
	 */
	function CHomothetie(listeProprietaire, impProto, estElementFinal, centre, rapport) {
	  if (arguments.length === 1) CTransformation.call(this, listeProprietaire);else {
	    CTransformation.call(this, listeProprietaire, impProto, estElementFinal);
	    this.centre = centre;
	    this.rapport = rapport;
	  }
	}
	CHomothetie.prototype = new CTransformation();
	CHomothetie.prototype.constructor = CHomothetie;
	CHomothetie.prototype.superClass = "CTransformation";
	CHomothetie.prototype.className = "CHomothetie";
	
	/**
	 * Indique la nature de la transformation
	 * @returns {CTransformation.translation}
	 */
	CHomothetie.prototype.natureTransformation = function () {
	  return CTransformation.homothetie;
	};
	
	CHomothetie.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.centre);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var rapportClone = this.rapport.getClone(listeSource, listeCible);
	  return new CHomothetie(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt"), rapportClone);
	};
	CHomothetie.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CTransformation.prototype.dependDe.call(this, p) || this.centre.dependDe(p) || this.rapport.dependDe(p));
	};
	CHomothetie.prototype.initialisePourDependance = function () {
	  CTransformation.prototype.initialisePourDependance.call(this);
	  this.rapport.initialisePourDependance();
	};
	CHomothetie.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.centre.dependDePourBoucle(p) || this.rapport.dependDePourBoucle(p);
	};
	CHomothetie.prototype.positionne = function (infoRandom) {
	  this.rapport.positionne(infoRandom);
	  this.existe = this.centre.existe && this.rapport.existe;
	  if (this.existe) this.valeurRapport = this.rapport.rendValeur();
	};
	CHomothetie.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.centre === p.centre && this.rapport.confonduAvec(p.rapport);
	  } else return false;
	};
	/**
	 * Renvoie l'image de la longueur L par la transformation
	 * @param {float} l : La valeur de la longueur à transformr
	 * @returns {float}
	 */
	CHomothetie.prototype.transformeLongueur = function (l) {
	  return l * Math.abs(this.valeurRapport);
	};
	/**
	 * Renvoie dans pointr.x et pointr.y les coordonnées du point image du point de coordonnées (x,y).
	 * @param {float} x
	 * @param {float} y
	 * @param {Object} pointr
	 */
	CHomothetie.prototype.transformePoint = function (x, y, pointr) {
	  pointr.x = this.centre.x + this.valeurRapport * (x - this.centre.x);
	  pointr.y = this.centre.y + this.valeurRapport * (y - this.centre.y);
	};
	/**
	 * Renvoie dans le vecteur ur les coordonnées du vecteur image du vecteur u.
	 * @param {Vect} u
	 * @param {Vect} ur
	 * @returns {undefined}
	 */
	CHomothetie.prototype.transformeVecteur = function (u, ur) {
	  ur.x = this.valeurRapport * u.x;
	  ur.y = this.valeurRapport * u.y;
	};
	CHomothetie.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.centre === ancienPoint) this.centre = nouveauPoint;
	};
	CHomothetie.prototype.read = function (inps, list) {
	  CTransformation.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.centre = list.get(ind1, "CPt");
	  this.rapport = new CValeur();
	  this.rapport.read(inps, list);
	};
	CHomothetie.prototype.write = function (oups, list) {
	  CTransformation.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.centre);
	  oups.writeInt(ind1);
	  this.rapport.write(oups, list);
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var kernel = __webpack_require__(8);
	var StyleEncadrement = __webpack_require__(38);
	var CAffichageLieAPoint = __webpack_require__(36);
	module.exports = CImage;
	
	/**
	 * Classe représentant une image. Elle est chargée sous forme binaire.
	 * @constructor
	 * @extends CAffichageLieAPoint
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {boolean} estElementFinal : true si élément final de construction.
	 * @param {Color} couleur : La couleur de l'objet.
	 * @param x_nom : Abscisse d'affichage
	 * @param y_nom : Ordonnée d'affichage
	 * @param {int} dec_x : Décalage horizontal par rapport à x_nom
	 * @param {int} dec_y : Décalage vertical par rapport à y_nom
	 * @param {boolean} masque : true si l'objet est masqué.
	 * @param {CPt} pointLie : null ou le point auquel l'image est liée.
	 * @param {int} taillePolice : Indice donnant la taille de la police.
	 * @param {StyleEncadrement} encadrement
	 * @param {boolean} effacementFond : true si on efface le fond avant d'afficher l'image.
	 * @param {Color} couleurFond : La couleur de fond éventuelle.
	 * @param {int} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {int} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {string} natImage : chaîne contenant la nature de l'image : "png","jpg" ou "gif"
	 * @param {string} image : chaîne de caractères en Base64 contenant le code binaire de l'image.
	 * @constructor
	 */
	function CImage(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, encadrement, effacementFond, couleurFond, alignementHorizontal, alignementVertical, natImage, image) {
	  if (arguments.length === 1) CAffichageLieAPoint.call(this, listeProprietaire);else {
	    CAffichageLieAPoint.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, encadrement, effacementFond, couleurFond, alignementHorizontal, alignementVertical);
	    this.natImage = natImage;
	    this.image = image;
	  }
	}
	CImage.prototype = new CAffichageLieAPoint();
	CImage.prototype.constructor = CImage;
	CImage.prototype.superClass = "CAffichageLieAPoint";
	CImage.prototype.className = "CImage";
	
	CImage.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CImage.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var ptelb = new CImage(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.encadrement, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.natImage, this.image);
	  ptelb.width = this.width;
	  ptelb.height = this.height;
	  return ptelb;
	};
	CImage.prototype.positionne = function (infoRandom, dimfen) {
	  CAffichageLieAPoint.prototype.positionne.call(this, infoRandom, dimfen);
	  if (!this.existe) return;
	  this.rectAff.x = this.x_nom + this.dec_x;
	  this.rectAff.y = this.y_nom + this.dec_y;
	  // Modification version 4.5
	  switch (this.alignementHorizontal) {
	    case CAffichageLieAPoint.alignementHorizontalCentre:
	      this.rectAff.x -= this.width / 2;
	      break;
	    case CAffichageLieAPoint.alignementHorizontalDroit:
	      this.rectAff.x -= this.width;
	  }
	  switch (this.alignementVertical) {
	    case CAffichageLieAPoint.alignementVerticalCentre:
	      this.rectAff.y -= this.height / 2;
	      break;
	    case CAffichageLieAPoint.alignementVerticalBas:
	      this.rectAff.y -= this.height;
	  }
	};
	CImage.prototype.createg = function () {
	  var g, image;
	  g = kernel.cens("g");
	  this.rectAff.width = this.width + 3;
	  this.rectAff.height = this.height + 3;
	  image = kernel.cens("image", {
	    x: this.rectAff.x,
	    y: this.rectAff.y,
	    width: this.width,
	    height: this.height,
	    "pointer-events": "none"
	  });
	  var tab = ['png', 'gif', 'jpg'];
	  var ext = tab[this.natImage];
	  image.setAttributeNS("http://www.w3.org/1999/xlink", "href", "data:image/" + ext + ";base64," + kernel.base64Encode(this.image, true));
	  g.appendChild(image);
	  if (this.effacementFond || this.encadrement !== StyleEncadrement.Sans) this.creeRectangle(g);
	  return g;
	};
	CImage.prototype.update = function (svg) {
	  if (this.g !== null) {
	    var img = this.g.childNodes[this.g.childNodes.length - 1];
	    // g.removeAttribute("x");
	    // g.removeAttribute("y");
	    img.setAttribute("x", this.rectAff.x);
	    img.setAttribute("y", this.rectAff.y);
	    if (this.effacementFond || this.encadrement !== StyleEncadrement.Sans) this.remplaceRectangle(this.g, this.couleurFond);
	  }
	};
	CImage.prototype.ajouteAntecedents = function (liste) {
	  if (this.pointLie !== null) liste.add(this.pointLie);
	};
	CImage.prototype.getNature = function () {
	  return NatObj.NImage;
	};
	CImage.prototype.rendChaineAffichage = function () {
	  return "";
	};
	CImage.prototype.chaineDesignation = function () {
	  return "desImage";
	};
	CImage.prototype.read = function (inps, list) {
	  CAffichageLieAPoint.prototype.read.call(this, inps, list);
	  this.natImage = inps.readByte();
	  this.width = inps.readInt();
	  this.height = inps.readInt();
	  this.image = inps.readBufferedImage();
	};
	CImage.prototype.write = function (oups, list) {
	  CAffichageLieAPoint.prototype.write.call(this, oups, list);
	  oups.writeByte(this.natImage);
	  oups.writeInt(this.width);
	  oups.writeInt(this.height);
	  oups.writeBufferedImage(this.image, this.natImage);
	};

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Point = __webpack_require__(15);
	var PositionCercleCercle = __webpack_require__(11);
	var kernel = __webpack_require__(8);
	var CBipoint = __webpack_require__(95);
	module.exports = CIntCercleCercle;
	
	/**
	 * Classe représentant l'intersection de deux cercles (ou arcs de cercle).
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal :true si élément fial de construction.
	 * @param {CCercle} c1 : Le premier cercle ou arc de cercle.
	 * @param {CCercle} c2 : Le deuxième cercle ou arc de cercle.
	 * @returns {CIntCercleCercle}
	 */
	function CIntCercleCercle(listeProprietaire, impProto, estElementFinal, c1, c2) {
	  if (arguments.length === 1) CBipoint.call(this, listeProprietaire);else CBipoint.call(this, listeProprietaire, impProto, estElementFinal);
	  this.c1 = c1;
	  this.c2 = c2;
	  this.pointInt1 = new Point();
	  this.pointInt2 = new Point();
	}
	CIntCercleCercle.prototype = new CBipoint();
	CIntCercleCercle.prototype.constructor = CIntCercleCercle;
	CIntCercleCercle.prototype.superClass = "CBipoint";
	CIntCercleCercle.prototype.className = "CIntCercleCercle";
	
	CIntCercleCercle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.c1);
	  var ind2 = listeSource.indexOf(this.c2);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CIntCercleCercle(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CCercle"), listeCible.get(ind2, "CCercle"));
	};
	CIntCercleCercle.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.c1);
	  liste.add(this.c2);
	};
	CIntCercleCercle.prototype.positionne = function (infoRandom, dimfen) {
	  var position;
	  this.existe = this.c1.existe && this.c2.existe;
	  if (!this.existe) {
	    this.point1.existe = false;
	    this.point2.existe = false;
	    return;
	  }
	  position = kernel.intersectionCercleCercle(this.c1.centre_x, this.c1.centre_y, this.c1.rayon, this.c2.centre_x, this.c2.centre_y, this.c2.rayon, this.pointInt1, this.pointInt2);
	  var x1 = this.pointInt1.x;
	  var y1 = this.pointInt1.y;
	  var x2 = this.pointInt2.x;
	  var y2 = this.pointInt2.y;
	
	  switch (position) {
	    case PositionCercleCercle.Vide:
	    case PositionCercleCercle.Confondus:
	      this.point1.existe = false;
	      this.point2.existe = false;
	      break;
	    case PositionCercleCercle.Secants:
	      if (this.c1.surArc(x1, y1) && this.c2.surArc(x1, y1)) {
	        this.point1.existe = true;
	        this.point1.placeEn(x1, y1);
	        this.point1.positionne(infoRandom, dimfen); // Ajout versio 4.6.4
	      } else this.point1.existe = false;
	      if (this.c1.surArc(x2, y2) && this.c2.surArc(x2, y2)) {
	        this.point2.existe = true;
	        this.point2.placeEn(x2, y2);
	        this.point2.positionne(infoRandom, dimfen); // Ajout versio 4.6.4
	      } else this.point2.existe = false;
	      break;
	    case PositionCercleCercle.Tangents:
	      if (this.c1.surArc(x1, y1) && this.c2.surArc(x1, y1)) {
	        this.point1.existe = true;
	        this.point1.placeEn(x1, y1);
	        this.point1.positionne(infoRandom, dimfen); // Ajout versio 4.6.4
	      } else this.point1.existe = false;
	      this.point2.existe = false;
	      break;
	    default:
	  }
	  CBipoint.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CIntCercleCercle.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CBipoint.prototype.dependDe.call(this, p) || this.c1.dependDe(p) || this.c2.dependDe(p));
	};
	CIntCercleCercle.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.c1.dependDePourBoucle(p) || this.c2.dependDePourBoucle(p);
	};
	CIntCercleCercle.prototype.elementAssocie = function (indice) {
	  if (indice === 0) return this.c1;else return this.c2;
	};
	CIntCercleCercle.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.c1 === p.c1 && this.c2 === p.c2 || this.c1 === p.c2 && this.c2 === p.c1;
	  } else return false;
	};
	/**
	 * Renvoie true si cercle est un des deux cercles dont this est l'intersection
	 * @param {type} cercle
	 * @returns {Boolean}
	 */
	CIntCercleCercle.prototype.estDefiniPar = function (cercle) {
	  return cercle === this.c1 || cercle === this.c2;
	};
	CIntCercleCercle.prototype.read = function (inps, list) {
	  CBipoint.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.c1 = list.get(ind1, "CCercle");
	  this.c2 = list.get(ind2, "CCercle");
	};
	CIntCercleCercle.prototype.write = function (oups, list) {
	  CBipoint.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.c1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.c2);
	  oups.writeInt(ind2);
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Point = __webpack_require__(15);
	var PositionDroiteCercle = __webpack_require__(9);
	var kernel = __webpack_require__(8);
	var CBipoint = __webpack_require__(95);
	module.exports = CIntDroiteCercle;
	
	/**
	 * Classe représentant l'intersection d'uune droite (ou demi-droite) ou segment
	 * avec un cercle (ou arc de cercle).
	 * @constructor
	 * @extends CBipoint
	 * @param {type} listeProprietaire
	 * @param {type} impProto
	 * @param {type} estElementFinal
	 * @param {type} d
	 * @param {type} c
	 * @returns {CIntDroiteCercle}
	 */
	function CIntDroiteCercle(listeProprietaire, impProto, estElementFinal, d, c) {
	  if (arguments.length === 1) CBipoint.call(this, listeProprietaire);else CBipoint.call(this, listeProprietaire, impProto, estElementFinal);
	  this.d = d;
	  this.c = c;
	  this.pointInt1 = new Point();
	  this.pointInt2 = new Point();
	}
	CIntDroiteCercle.prototype = new CBipoint();
	CIntDroiteCercle.prototype.constructor = CIntDroiteCercle;
	CIntDroiteCercle.prototype.superClass = "CBipoint";
	CIntDroiteCercle.prototype.className = "CIntDroiteCercle";
	
	CIntDroiteCercle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.d);
	  var ind2 = listeSource.indexOf(this.c);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CIntDroiteCercle(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CDroiteAncetre"), listeCible.get(ind2, "CCercle"));
	};
	CIntDroiteCercle.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.d);
	  liste.add(this.c);
	};
	CIntDroiteCercle.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CBipoint.prototype.dependDe.call(this, p) || this.d.dependDe(p) || this.c.dependDe(p));
	};
	CIntDroiteCercle.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.d.dependDePourBoucle(p) || this.c.dependDePourBoucle(p);
	};
	CIntDroiteCercle.prototype.positionne = function (infoRandom, dimfen) {
	  var position;
	  this.existe = this.c.existe && this.d.existe;
	  if (!this.existe) {
	    this.point1.existe = false;
	    this.point2.existe = false;
	    return;
	  }
	  position = kernel.intersectionDroiteCercle(this.d.point_x, this.d.point_y, this.d.vect, this.c.centre_x, this.c.centre_y, this.c.rayon, this.pointInt1, this.pointInt2);
	  var x1 = this.pointInt1.x;
	  var y1 = this.pointInt1.y;
	  var x2 = this.pointInt2.x;
	  var y2 = this.pointInt2.y;
	
	  switch (position) {
	    case PositionDroiteCercle.Vide:
	      this.point1.existe = false;
	      this.point2.existe = false;
	      break;
	    case PositionDroiteCercle.Secants:
	      if (this.d.appartientA(x1, y1) && this.c.surArc(x1, y1)) {
	        this.point1.placeEn(x1, y1);
	        this.point1.positionne(infoRandom, dimfen); // Ajout version 4.6.4
	      } else this.point1.existe = false;
	      if (this.d.appartientA(x2, y2) && this.c.surArc(x2, y2)) {
	        this.point2.placeEn(x2, y2);
	        this.point2.positionne(infoRandom, dimfen); // Ajout version 4.6.4
	      } else this.point2.existe = false;
	      break;
	    case PositionDroiteCercle.Tangents:
	      if (this.d.appartientA(x1, y1) && this.c.surArc(x1, y1)) {
	        this.point1.existe = true;
	        this.point1.placeEn(x1, y1);
	        this.point1.positionne(infoRandom, dimfen); // Ajout version 4.6.4
	      } else this.point1.existe = false;
	      this.point2.existe = false;
	      break;
	  } // switch
	  CBipoint.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CIntDroiteCercle.prototype.elementAssocie = function (indice) {
	  if (indice === 0) return this.d;else return this.c;
	};
	CIntDroiteCercle.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.d === p.d && this.c === p.c;
	  } else return false;
	};
	// Fonction différente de la version java
	CIntDroiteCercle.prototype.estDefiniPar = function (dtecer) {
	  return dtecer === this.d || dtecer === this.c;
	};
	CIntDroiteCercle.prototype.read = function (inps, list) {
	  CBipoint.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.d = list.get(ind1, "CDroiteAncetre");
	  this.c = list.get(ind2, "CCercle");
	};
	CIntDroiteCercle.prototype.write = function (oups, list) {
	  CBipoint.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.d);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.c);
	  oups.writeInt(ind2);
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Point = __webpack_require__(15);
	var PositionDroites = __webpack_require__(10);
	var kernel = __webpack_require__(8);
	var CPt = __webpack_require__(87);
	module.exports = CIntDroiteDroite;
	
	/**
	 * Classe représentant le point d'intersection de deux droites (ou demi-droites ou segments).
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CDroiteAncetre} droite1 : La première droite (ou demi-droite ou segment)
	 * @param {CDroiteAncetre} droite2 : La deuxième droite (ou demi-droite ou segment)
	 * @returns {CIntDroiteDroite}
	 */
	function CIntDroiteDroite(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, droite1, droite2) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.droite1 = droite1;
	    this.droite2 = droite2;
	    this.pointInt = new Point();
	  }
	}
	CIntDroiteDroite.prototype = new CPt();
	CIntDroiteDroite.prototype.constructor = CIntDroiteDroite;
	CIntDroiteDroite.prototype.superClass = "CPt";
	CIntDroiteDroite.prototype.className = "CIntDroiteDroite";
	
	CIntDroiteDroite.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.droite1);
	  var ind2 = listeSource.indexOf(this.droite2);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CIntDroiteDroite(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CDroiteAncetre"), listeCible.get(ind2, "CDroiteAncetre"));
	};
	CIntDroiteDroite.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.droite1);
	  liste.add(this.droite2);
	};
	CIntDroiteDroite.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.droite1.dependDe(p) || this.droite2.dependDe(p));
	};
	CIntDroiteDroite.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.droite1.dependDePourBoucle(p) || this.droite2.dependDePourBoucle(p);
	};
	CIntDroiteDroite.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.droite1.existe && this.droite2.existe;
	  if (!this.existe) return;
	  var pos = kernel.intersection(this.droite1.point_x, this.droite1.point_y, this.droite1.vect, this.droite2.point_x, this.droite2.point_y, this.droite2.vect, this.pointInt);
	  if (pos !== PositionDroites.Secantes) {
	    this.existe = false;
	  } else {
	    var x = this.pointInt.x;
	    var y = this.pointInt.y;
	    if (this.droite1.appartientA(x, y) && this.droite2.appartientA(x, y)) {
	      CPt.prototype.placeEn.call(this, x, y);
	      CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	    } else this.existe = false;
	  }
	};
	CIntDroiteDroite.prototype.getNature = function () {
	  return NatObj.NPoint;
	};
	CIntDroiteDroite.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.droite1 === p.droite1 && this.droite2 === p.droite2 || this.droite1 === p.droite2 && this.droite2 === p.droite1;
	  } else return false;
	};
	CIntDroiteDroite.prototype.appartientDroiteParDefinition = function (droite) {
	  return CPt.prototype.appartientDroiteParDefinition.call(this, droite) || droite === this.droite1 || droite === this.droite2;
	};
	CIntDroiteDroite.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.droite1 = list.get(ind1, "CDroiteAncetre");
	  this.droite2 = list.get(ind2, "CDroiteAncetre");
	  this.pointInt = new Point();
	};
	CIntDroiteDroite.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.droite1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.droite2);
	  oups.writeInt(ind2);
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalculAncetre = __webpack_require__(35);
	var CCb = __webpack_require__(43);
	var CValeur = __webpack_require__(80);
	module.exports = CIntegrale;
	
	/**
	 * Objet de type calcul représentant le calcul approché d'une intégrale
	 * par la méthode de Simpson.
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CFonc} fonctionAssociee : La fonction utilisateur dont on calcule l'inntégrale.
	 * @param {CValeur} a : La borne inférieure d'intégration.
	 * @param {CValeur} b : La borne supérieure d'intégration.
	 * @param {CValeur} n : Le nombre de subdivisions seta 2n (dynamique).
	 * @returns {CIntegrale}
	 */
	function CIntegrale(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, a, b, n) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.a = a;
	    this.b = b;
	    this.fonctionAssociee = fonctionAssociee;
	  }
	  this.valeurIntegrale = 0;
	}
	CIntegrale.prototype = new CCalculAncetre();
	CIntegrale.prototype.constructor = CIntegrale;
	CIntegrale.prototype.superClass = "CCalculAncetre";
	CIntegrale.prototype.className = "CIntegrale";
	CIntegrale.valeurMaxiDen = 200;
	
	CIntegrale.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var aClone = this.a.getClone(listeSource, listeCible);
	  var bClone = this.b.getClone(listeSource, listeCible);
	  var nClone = this.n.getClone(listeSource, listeCible);
	  return new CIntegrale(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CFonc"), aClone, bClone, nClone);
	};
	CIntegrale.prototype.getNatureCalcul = function () {
	  return NatCal.NIntegrale;
	};
	CIntegrale.prototype.initialisePourDependance = function () {
	  CCalculAncetre.prototype.initialisePourDependance.call(this);
	  this.a.initialisePourDependance();
	  this.b.initialisePourDependance();
	  this.n.initialisePourDependance();
	};
	CIntegrale.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.a.dependDe(p) || this.b.dependDe(p) || this.n.dependDe(p) || this.fonctionAssociee.dependDe(p));
	};
	CIntegrale.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.b.dependDePourBoucle(p) || this.n.dependDePourBoucle(p) || this.fonctionAssociee.dependDePourBoucle(p);
	};
	CIntegrale.prototype.positionne = function (infoRandom, dimfen) {
	  var bornea, borneb;
	  var s1, s2, s;
	  var t1, t2, pas;
	  var k;
	  this.a.positionne(infoRandom, dimfen);
	  this.b.positionne(infoRandom, dimfen);
	  this.n.positionne(infoRandom, dimfen);
	  this.existe = this.a.existe && this.b.existe && this.n.existe;
	  if (!this.existe) return;
	  bornea = this.a.rendValeur();
	  borneb = this.b.rendValeur();
	  if (bornea === borneb) {
	    this.existe = true;
	    this.valeurIntegrale = 0;
	    return;
	  }
	  var dnbt = Math.floor(this.n.rendValeur() + 0.5);
	  this.existe = dnbt >= 1 && dnbt <= CIntegrale.valeurMaxiDen;
	  if (!this.existe) return;
	  // int n = (int) dnbt;
	  pas = (borneb - bornea) / dnbt;
	  try {
	    s = this.fonctionAssociee.rendValeurFonction(infoRandom, bornea) + this.fonctionAssociee.rendValeurFonction(infoRandom, borneb);
	  } catch (err) {
	    this.existe = false;
	    return;
	  }
	  t1 = bornea;
	  t2 = bornea - pas / 2;
	  s1 = 0;
	  s2 = 0;
	  try {
	    for (k = 1; k < dnbt; k++) {
	      t1 = t1 + pas;
	      s1 = s1 + this.fonctionAssociee.rendValeurFonction(infoRandom, t1);
	    }
	    for (k = 1; k <= dnbt; k++) {
	      t2 = t2 + pas;
	      s2 = s2 + this.fonctionAssociee.rendValeurFonction(infoRandom, t2);
	    }
	    this.valeurIntegrale = (borneb - bornea) * (s + 2 * s1 + 4 * s2) / (6 * dnbt);
	    this.existe = true;
	  } catch (err) {
	    this.existe = false;
	  }
	};
	CIntegrale.prototype.rendValeur = function () {
	  return this.valeurIntegrale;
	};
	CIntegrale.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.fonctionAssociee = list.get(ind1, "CFonc");
	  this.a = new CValeur();
	  this.a.read(inps, list);
	  this.b = new CValeur();
	  this.b.read(inps, list);
	  this.n = new CValeur();
	  this.n.read(inps, list);
	};
	CIntegrale.prototype.write = function (oups, list) {
	  CCb.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.fonctionAssociee);
	  oups.writeInt(ind1);
	  this.a.write(oups, list);
	  this.b.write(oups, list);
	  this.n.write(oups, list);
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var CTransformation = __webpack_require__(100);
	var CHomothetie = __webpack_require__(136);
	module.exports = CInversion;
	
	/**
	 * Classe représentant l'inversion (transformation).
	 * Cette transformation est spéciale car ne peut être appliquée qu'à un point.
	 * @constructor
	 * @extends CHomothetie
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} centre : Le centre de la similitude.
	 * @param {CValeur} rapport : Le rapport de l'inversion
	 * @returns {CInversion}
	 */
	function CInversion(listeProprietaire, impProto, estElementFinal, centre, rapport) {
	  if (arguments.length === 1) CHomothetie.call(this, listeProprietaire);else {
	    CHomothetie.call(this, listeProprietaire, impProto, estElementFinal, centre, rapport);
	  }
	}
	CInversion.prototype = new CHomothetie();
	CInversion.prototype.constructor = CInversion;
	CInversion.prototype.superClass = "CHomothetie";
	CInversion.prototype.className = "CInversion";
	
	/**
	 * Indique la nature de la transformation
	 * @returns {CTransformation.inversion}
	 */
	CInversion.prototype.natureTransformation = function () {
	  return CTransformation.inversion;
	};
	CInversion.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.centre);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var rapportClone = this.rapport.getClone(listeSource, listeCible);
	  return new CInversion(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt.class"), rapportClone);
	};
	CInversion.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  var resultat = CHomothetie.prototype.dependDe.call(this, p);
	  if (this.listeProprietaire.pointeurLongueurUnite === null) return this.memoriseDependance(resultat);else return this.memoriseDependance(resultat || this.listeProprietaire.pointeurLongueurUnite.dependDe(p));
	};
	CInversion.prototype.dependDePourBoucle = function (p) {
	  var resultat = CHomothetie.prototype.dependDe.call(this, p);
	  if (this.listeProprietaire.pointeurLongueurUnite === null) return resultat;else return resultat || this.listeProprietaire.pointeurLongueurUnite.dependDePourBoucle(p);
	};
	CInversion.prototype.positionne = function (infoRandom, dimfen) {
	  var pLongUnite, longueurUnite;
	  CHomothetie.prototype.positionne.call(this, infoRandom, dimfen);
	  // A noter : valeurRapport a été calculé dans Homothetie.positionne()
	  pLongUnite = this.listeProprietaire.pointeurLongueurUnite;
	  this.existe = this.existe && pLongUnite.existe;
	  if (!this.existe) return;
	  longueurUnite = pLongUnite.rendLongueur();
	  if (longueurUnite === 0) this.existe = false;
	};
	/**
	 * Renvoie dans pointr.x et pointr.y les coordonnées du point image du point de coordonnées (x,y).
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Object} pointr
	 * @returns {undefined}
	 */
	CInversion.prototype.transformePoint = function (x, y, pointr) {
	  // Le point image du point d'affixe z est le point d'affixe z'
	  // défini par z' - w = k(z - w)/|z - w|², mais le module de
	  // z - w doit être calculé relativement à la longueur unité
	  // (w désigant l'affixe du centre)
	  var pLongUnite, longueurUnite;
	
	  pLongUnite = this.listeProprietaire.pointeurLongueurUnite;
	  longueurUnite = pLongUnite.rendLongueur();
	
	  var u = new Vect(this.centre.x, this.centre.y, x, y);
	  var longueur = u.norme() / longueurUnite;
	  var d = longueur * longueur;
	  pointr.x = this.centre.x + this.valeurRapport * u.x / d;
	  pointr.y = this.centre.y + this.valeurRapport * u.y / d;
	};
	CInversion.prototype.pointAUneImage = function (point) {
	  return !point.egal(this.centre);
	};

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var InfoLieu = __webpack_require__(144);
	var InfoLigneLieu = __webpack_require__(145);
	var kernel = __webpack_require__(8);
	var CElementLigne = __webpack_require__(77);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CLieuDeBase;
	
	/**
	 * Classe ancêtre de tous les lieux de points reliés.
	 * @constructor
	 * @extends CElementLigne
	 * @param {CListeObjets} listeProprietaire : la liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Booelan} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Couleur} couleur : La couleur de l'objet
	 * @param {Booelan} masque : true si l'objet est masqué
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CPt} pointATracer : Le point qui laisse une trace.
	 * @param {InfoLieu} infoLieu
	 * @returns {CLieuDeBase}
	 */
	function CLieuDeBase(listeProprietaire, impProto, estElementFinal, couleur, masque, style, pointATracer, infoLieu) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	      CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 16, style);
	      this.pointATracer = pointATracer;
	      this.infoLieu = infoLieu;
	      this.abscissesCoordonneesPoints = new Array(infoLieu.nombreDePoints + 1);
	      this.ordonneesCoordonneesPoints = new Array(infoLieu.nombreDePoints + 1);
	      var nb = Math.floor(this.infoLieu.nombreDePoints / 2) + 2;
	      this.infoLignes = new Array(nb);
	      // Il faut initialiser chaque élément du tableau
	      for (var i = 0; i < nb; i++) {
	        this.infoLignes[i] = new InfoLigneLieu();
	      }
	      // Il faut créer la liste des éléments dont dépend le point à tracer
	      this.listeElementsAncetres = new CSousListeObjets();
	    }
	  }
	}
	CLieuDeBase.prototype = new CElementLigne();
	CLieuDeBase.prototype.constructor = CLieuDeBase;
	CLieuDeBase.prototype.superClass = "CElementLigne";
	CLieuDeBase.prototype.className = "CLieuDeBase";
	
	CLieuDeBase.prototype.setClone = function (ptel) {
	  CElementLigne.prototype.setClone.call(this, ptel);
	  this.nombreLignes = ptel.nombreLignes;
	  this.infoLieu.setCopy(ptel.infoLieu); // Il faut copier toutes les coordonnées
	  for (var j = 0; j < this.nombreLignes; j++) {
	    this.infoLignes[j].setCopy(ptel.infoLignes[j]);
	    for (var k = 0; k < this.infoLignes[j].nombrePoints; k++) {
	      this.abscissesCoordonneesPoints[this.infoLignes[j].indicePremierPoint + k] = ptel.abscissesCoordonneesPoints[this.infoLignes[j].indicePremierPoint + k];
	      this.ordonneesCoordonneesPoints[this.infoLignes[j].indicePremierPoint + k] = ptel.ordonneesCoordonneesPoints[this.infoLignes[j].indicePremierPoint + k];
	    }
	  }
	};
	CLieuDeBase.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CElementLigne.prototype.dependDe.call(this, p) || this.pointATracer.dependDe(p));
	};
	CLieuDeBase.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.pointATracer.dependDePourBoucle(p);
	};
	// Spécifique JavaScript
	CLieuDeBase.prototype.createg = function () {
	  var j, nombrePoints, indPremPoint, j, k, k1;
	  var style = "";
	  var styleRect;
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  // var coul = this.couleur.rgb(); // Modifié version 4.9.9.4
	  var coul = this.color;
	  style += "stroke-width:" + strokewidth + ";";
	  style += "stroke:" + coul + ";";
	  styleRect = style;
	  style += "fill:none";
	  styleRect += "fill:" + coul;
	  var g = kernel.cens("g");
	  // g.setAttribute("style", style); // Supprimé version mtgApp. Inutile
	
	  for (j = 0; j < this.nombreLignes; j++) {
	    nombrePoints = this.infoLignes[j].nombrePoints;
	    // Optimisé version 3.9 On trace maintenant les points isolés du lieu
	    indPremPoint = this.infoLignes[j].indicePremierPoint;
	    if (nombrePoints === 1) {
	      var r = kernel.cens("rect", {
	        x: this.abscissesCoordonneesPoints[indPremPoint],
	        y: this.ordonneesCoordonneesPoints[indPremPoint],
	        width: "1",
	        height: "1",
	        style: styleRect
	      });
	      g.appendChild(r);
	    } else {
	      // Il faut transférer les coordonnées de chaque ligne pour pouvoir la tracer en java
	      var points = "";
	      for (k = 0; k < nombrePoints; k++) {
	        k1 = indPremPoint + k;
	        points = points + this.abscissesCoordonneesPoints[k1] + ",";
	        points = points + this.ordonneesCoordonneesPoints[k1] + " ";
	      }
	      var pol = kernel.cens("polyline", {
	        style: style,
	        points: points
	      });
	      g.appendChild(pol);
	    }
	  }
	  g.setAttribute("pointer-events", "none");
	  return g;
	};
	CLieuDeBase.prototype.trace = function (svg, couleurFond, transparence) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CLieuDeBase.prototype.update = function (svg) {
	  var oldg = this.g;
	  var g = this.createg();
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	/**
	 * Renvoie true si le lieu de points n'est formé que d'une seule ligne.
	 * @returns {Boolean}
	 */
	CLieuDeBase.prototype.contientUneSeuleLigne = function () {
	  return this.nombreLignesDePlusieursPoints === 1;
	};
	/**
	 * Renvoie true si le lieu contient au moins une ligne.
	 * @returns {Boolean}
	 */
	CLieuDeBase.prototype.contientAuMoinsUneLigne = function () {
	  return this.nombreLignesDePlusieursPoints >= 1;
	};
	CLieuDeBase.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointATracer === ancienPoint) this.pointATracer = nouveauPoint;
	};
	CLieuDeBase.prototype.getNature = function () {
	  return NatObj.NLieu;
	};
	CLieuDeBase.prototype.dansFen = function (dimfen) {
	  if (!this.existe) return false;
	  var resultat = false;
	  for (var j = 0; j < this.nombreLignes && !resultat; j++) {
	    for (var k = this.infoLignes[j].indicePremierPoint; k <= this.infoLignes[j].indicePremierPoint + this.infoLignes[j].nombrePoints - 2; k++) {
	      resultat = resultat || dimfen.dansFenetre(this.abscissesCoordonneesPoints[k], this.ordonneesCoordonneesPoints[k]);
	    }
	  }
	  return resultat;
	};
	CLieuDeBase.prototype.chaineDesignation = function () {
	  return "desLieuPoint";
	};
	CLieuDeBase.prototype.read = function (inps, list) {
	  CElementLigne.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.pointATracer = list.get(ind1, "CPt");
	  this.infoLieu = new InfoLieu();
	  this.infoLieu.read(inps);
	  // Il faut créer les tableaux de coordonnées
	  // On réserve une coordonnée supplémentaire pour le cas d'un lieu fermé
	  this.abscissesCoordonneesPoints = new Array(this.infoLieu.nombreDePoints + 1);
	  this.ordonneesCoordonneesPoints = new Array(this.infoLieu.nombreDePoints + 1);
	  var nb = this.infoLieu.nombreDePoints / 2 + 2;
	  this.infoLignes = new Array(nb);
	  // Il faut initialiser chaque élément du tableau
	  for (var i = 0; i < nb; i++) {
	    this.infoLignes[i] = new InfoLigneLieu();
	  } // Il faut créer la liste des éléments dont dépend le point à tracer
	  this.listeElementsAncetres = new CSousListeObjets();
	};
	CLieuDeBase.prototype.write = function (oups, list) {
	  CElementLigne.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.pointATracer);
	  oups.writeInt(ind1);
	  this.infoLieu.write(oups, list);
	};

/***/ },
/* 144 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	module.exports = InfoLieu;
	/**
	 * Classe contenant des informations sur un lieu de points.
	 * @constructor
	 * @param {Integer} nombreDePoints : Le nombre de points du lieu
	 * @param {Boolean} fermeOuNon : true si le lieu est déclaré comme fermé
	 * @param {Boolean} gestionDiscontinuite : true si une gestion auto des discontinuités du lieu est activée
	 * @returns {InfoLieu}
	 */
	function InfoLieu(nombreDePoints, fermeOuNon, gestionDiscontinuite) {
	  if (arguments.length === 1) {
	    // Construction à partir d'un autre InfoLieu'
	    this.nombreDePoints = arguments[0].nombreDePoints;
	    this.fermeOuNon = arguments[0].fermeOuNon;
	    this.gestionDiscontinuite = arguments[0].gestionDiscontinuite;
	  } else {
	    this.nombreDePoints = nombreDePoints;
	    this.fermeOuNon = fermeOuNon;
	    this.gestionDiscontinuite = gestionDiscontinuite;
	  }
	}
	/**
	 * Fait de this une copie de infoLieu
	 * @param {InfoLieu} infoLieu
	 * @returns {undefined}
	 */
	InfoLieu.prototype.setCopy = function (infoLieu) {
	  this.nombreDePoints = infoLieu.nombreDePoints;
	  this.fermeOuNon = infoLieu.fermeOuNon;
	};
	/**
	 * Lit l'objet depuis un flux de données  binaire.
	 * @param {DataInputStream} inps : le flux
	 * @returns {undefined}
	 */
	InfoLieu.prototype.read = function (inps) {
	  this.nombreDePoints = inps.readInt();
	  this.fermeOuNon = inps.readBoolean();
	  this.gestionDiscontinuite = inps.readBoolean();
	};
	/**
	 * Enregistre l'objet dans un flux de données binaire.
	 * @param {DataOutputStream} oups
	 * @returns {undefined}
	 */
	InfoLieu.prototype.write = function (oups) {
	  oups.writeInt(this.nombreDePoints);
	  oups.writeBoolean(this.fermeOuNon);
	  oups.writeBoolean(this.gestionDiscontinuite);
	};

/***/ },
/* 145 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	module.exports = InfoLigneLieu;
	/**
	 * Classe utilisée pour décrire chaque portion d'un lieu de points.
	 * @constructor
	 * @returns {InfoLigneLieu}
	 */
	function InfoLigneLieu() {
	  this.indicePremierPoint = 0;
	  this.nombrePoints = 0;
	}
	/**
	 * Fait de this une copie de info
	 * @param {InfoLigneLieu} info
	 * @returns {undefined}
	 */
	InfoLigneLieu.prototype.setCopy = function (info) {
	  this.indicePremierPoint = info.indicePremierPoint;
	  this.nombrePoints = info.nombrePoints;
	};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var InfoLieu = __webpack_require__(144);
	var kernel = __webpack_require__(8);
	var CLieuDeBase = __webpack_require__(143);
	module.exports = CLieuDePoints;
	
	/**
	 * Classe représentant un lieu de points généré par les positions d'un point lié.
	 * @constructor
	 * @extends CLieuDeBase
	 * @param {CListeObjets} listeProprietaire : la liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Booelan} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Couleur} couleur : La couleur de l'objet
	 * @param {Booelan} masque : true si l'objet est masqué
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CPt} pointATracer : Le point qui laisse une trace.
	 * @param {InfoLieu} infoLieu
	 * @param {CPointLie} pointLieGenerateur : Le point dont les positions génèrent le lieu.
	 * @returns {CLieuDePoints}
	 */
	function CLieuDePoints(listeProprietaire, impProto, estElementFinal, couleur, masque, style, pointATracer, infoLieu, pointLieGenerateur) {
	  if (arguments.length === 1) CLieuDeBase.call(this, listeProprietaire);else {
	    CLieuDeBase.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, pointATracer, infoLieu);
	    this.pointLieGenerateur = pointLieGenerateur;
	  }
	}
	CLieuDePoints.prototype = new CLieuDeBase();
	CLieuDePoints.prototype.constructor = CLieuDePoints;
	CLieuDePoints.prototype.superClass = "CLieuDeBase";
	CLieuDePoints.prototype.className = "CLieuDePoints";
	
	CLieuDePoints.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CLieuDePoints.prototype.getClone = function (listeSource, listeCible) {
	  var infoLieuClone = new InfoLieu(this.infoLieu);
	
	  var ind1 = listeSource.indexOf(this.pointATracer);
	  var ind2 = listeSource.indexOf(this.pointLieGenerateur);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var ptelb = new CLieuDePoints(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), infoLieuClone, listeCible.get(ind2, "CPointLie"));
	  if (listeCible.className !== "CPrototype") ptelb.listeElementsAncetres.setImage(this.listeElementsAncetres, this.listeProprietaire, ptelb.listeProprietaire);
	  return ptelb;
	};
	CLieuDePoints.prototype.metAJour = function () {
	  CLieuDeBase.prototype.metAJour.call(this);
	  // Bug corrigé version 4.0 : il faut mettre à jour la liste d'éléments ancêtres car metAJour est appelé quand
	  // on modifie un obejt dont dépend cet objet
	  // if (nVersion == 1) etablitListeElementsAncetres();
	  this.etablitListeElementsAncetres();
	};
	CLieuDePoints.prototype.positionne = function (infoRandom, dimfen) {
	  var abscisseMini, abscisseMaxi, abscisse, abscisseInitiale, pas, abscisseFinale, nbValeurs, ligneEnCours, indiceLigneEnCours, nb, i, auMoinsUneLigne, j, ligneTrouvee, indicePointRajoute;
	  if (!this.pointLieGenerateur.existe) {
	    this.existe = false;
	    return;
	  }
	  abscisseMini = this.pointLieGenerateur.abscisseMinimale();
	  abscisseMaxi = this.pointLieGenerateur.abscisseMaximale();
	  if (abscisseMini === abscisseMaxi) {
	    this.existe = false;
	    return;
	  } else {
	    // On ordonne l'abscisse minimale et maximale
	    if (abscisseMini > abscisseMaxi) {
	      var w = abscisseMini;
	      abscisseMini = abscisseMaxi;
	      abscisseMaxi = w;
	    }
	  }
	  abscisseInitiale = this.pointLieGenerateur.abscisse;
	  // Modification pour la version 1.9.5
	  if (this.pointLieGenerateur.lieALigneFermee()) {
	    nbValeurs = this.infoLieu.nombreDePoints;
	    pas = (abscisseMaxi - abscisseMini) / nbValeurs;
	    abscisseFinale = abscisseMaxi - pas;
	  } else {
	    nbValeurs = this.infoLieu.nombreDePoints - 1;
	    pas = (abscisseMaxi - abscisseMini) / nbValeurs;
	    abscisseFinale = abscisseMaxi;
	  }
	  abscisse = abscisseMini;
	  ligneEnCours = false;
	  indiceLigneEnCours = -1;
	  nb = this.infoLieu.nombreDePoints - 1;
	  for (i = 0; i < this.infoLieu.nombreDePoints; i++) {
	    // Modifié version 3.9.1 pour éviter des erreurs d'arrondi
	    // Bug corrigé version 4.0
	    abscisse = i === 0 ? abscisseMini : i < nb ? abscisse + pas : abscisseFinale;
	    this.pointLieGenerateur.donneAbscisse(abscisse);
	    this.listeElementsAncetres.positionne(infoRandom, dimfen);
	    if (!this.pointATracer.existe) {
	      this.abscissesCoordonneesPoints[i] = kernel.Max_VALUE;
	      this.ordonneesCoordonneesPoints[i] = kernel.Max_VALUE;
	      if (ligneEnCours) {
	        this.infoLignes[indiceLigneEnCours].nombrePoints = i - this.infoLignes[indiceLigneEnCours].indicePremierPoint;
	        ligneEnCours = false;
	      }
	    } else {
	      if (!kernel.testToile(this.pointATracer.x, this.pointATracer.y)) {
	        if (ligneEnCours) {
	          this.infoLignes[indiceLigneEnCours].nombrePoints = i - this.infoLignes[indiceLigneEnCours].indicePremierPoint;
	          ligneEnCours = false;
	        }
	      } else {
	        if (ligneEnCours) {
	          if (this.infoLieu.gestionDiscontinuite) {
	            if (Math.abs(this.pointATracer.x - this.abscissesCoordonneesPoints[i - 1]) > dimfen.x || Math.abs(this.pointATracer.y - this.ordonneesCoordonneesPoints[i - 1]) > dimfen.y) {
	              this.infoLignes[indiceLigneEnCours].nombrePoints = i - this.infoLignes[indiceLigneEnCours].indicePremierPoint;
	              ligneEnCours = false;
	            } else {
	              this.abscissesCoordonneesPoints[i] = Math.round(this.pointATracer.x);
	              this.ordonneesCoordonneesPoints[i] = Math.round(this.pointATracer.y);
	              this.infoLignes[indiceLigneEnCours].nombrePoints++;
	            }
	          } else {
	            this.abscissesCoordonneesPoints[i] = Math.round(this.pointATracer.x);
	            this.ordonneesCoordonneesPoints[i] = Math.round(this.pointATracer.y);
	            this.infoLignes[indiceLigneEnCours].nombrePoints++;
	          }
	        } else {
	          this.abscissesCoordonneesPoints[i] = Math.round(this.pointATracer.x);
	          this.ordonneesCoordonneesPoints[i] = Math.round(this.pointATracer.y);
	          indiceLigneEnCours++;
	          ligneEnCours = true;
	          this.infoLignes[indiceLigneEnCours].indicePremierPoint = i;
	          this.infoLignes[indiceLigneEnCours].nombrePoints = 1;
	        }
	      }
	    }
	  } // for
	
	  // On  remet le point ancêtre à sa position initiale
	  this.pointLieGenerateur.donneAbscisse(abscisseInitiale);
	  this.listeElementsAncetres.positionne(infoRandom, dimfen);
	  this.nombreLignes = indiceLigneEnCours + 1;
	  // Si le lieu n'est formé d'aucune ligne ou s'il est formé
	  // de lignes avec un seul point, il n'existe pas
	  if (this.nombreLignes === 0) {
	    this.existe = false;
	    return;
	  }
	  auMoinsUneLigne = false;
	  this.indicePremiereLigne = -1;
	  this.nombreLignesDePlusieursPoints = 0;
	  for (j = 0; j <= indiceLigneEnCours; j++) {
	    ligneTrouvee = this.infoLignes[j].nombrePoints >= 2;
	    if (ligneTrouvee) {
	      this.nombreLignesDePlusieursPoints++;
	      if (!auMoinsUneLigne) this.indicePremiereLigne = j;
	      auMoinsUneLigne = true;
	    }
	  }
	  if (!auMoinsUneLigne) {
	    this.existe = false;
	    return;
	  }
	  // Si le lieu est déclaré comme fermé, il n'existera que s'il
	  // n'est formé que d'une seule ligne avec au moins deux points
	  if (this.infoLieu.fermeOuNon) {
	    indicePointRajoute = this.infoLignes[indiceLigneEnCours].indicePremierPoint + this.infoLignes[indiceLigneEnCours].nombrePoints;
	
	    this.abscissesCoordonneesPoints[indicePointRajoute] = this.abscissesCoordonneesPoints[this.infoLignes[this.indicePremiereLigne].indicePremierPoint];
	    this.ordonneesCoordonneesPoints[indicePointRajoute] = this.ordonneesCoordonneesPoints[this.infoLignes[this.indicePremiereLigne].indicePremierPoint];
	    // infoLignes[indicePremiereLigne].nombrePoints++;
	    this.infoLignes[indiceLigneEnCours].nombrePoints++;
	  }
	  this.existe = true;
	};
	CLieuDePoints.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.pointATracer === p.pointATracer && this.pointLieGenerateur === p.pointLieGenerateur;
	  } else return false;
	};
	CLieuDePoints.prototype.dependDePourCapture = function (p) {
	  // Un lieu de points n'a pas à être redessiné si on bouge le point
	  // lié qui l'a engendré}
	  return p === this || this.pointATracer.dependDe(p) && p !== this.pointLieGenerateur;
	};
	/**
	 * Fonction mettant dans this.listeElementsAncetres la liste de tous les objets de la liste
	 * propriétaire qui doivent être calculés lorsque le lieu est calculé.
	 * @returns {undefined}
	 */
	CLieuDePoints.prototype.etablitListeElementsAncetres = function () {
	  if (this.listeProprietaire.className !== "CPrototype") {
	    this.listeElementsAncetres.retireTout();
	    var indicePointATracer = this.listeProprietaire.indexOf(this.pointATracer);
	    var indicePointLieGenerateur = this.listeProprietaire.indexOf(this.pointLieGenerateur);
	    this.listeElementsAncetres.add(this.pointLieGenerateur);
	    for (var i = indicePointLieGenerateur + 1; i < indicePointATracer; i++) {
	      var ptelb = this.listeProprietaire.get(i);
	      if (this.pointATracer.dependDe(ptelb) && ptelb.dependDe(this.pointLieGenerateur)) this.listeElementsAncetres.add(ptelb);
	    }
	    this.listeElementsAncetres.add(this.pointATracer);
	  }
	};
	CLieuDePoints.prototype.read = function (inps, list) {
	  CLieuDeBase.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.pointLieGenerateur = list.get(ind1, "CPointLie");
	  this.listeElementsAncetres.read(inps, list);
	};
	CLieuDePoints.prototype.write = function (oups, list) {
	  CLieuDeBase.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.pointLieGenerateur);
	  oups.writeInt(ind1);
	  this.listeElementsAncetres.write(oups, this.listeProprietaire);
	};

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var kernel = __webpack_require__(8);
	var CElementGraphique = __webpack_require__(39);
	var CPointBase = __webpack_require__(85);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CLieuDiscretDeBase;
	
	/**
	 * Classe ancêtre de tous les lieux discrets (non reliés)
	 * @constructor
	 * @extends CElementGraphique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la liste propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Couleur} couleur : La couleur de l'objet.
	 * @param {Booelan} masque : true si l'objet est masqué
	 * @param {CPt} pointATracer : Le point qui laisse une trace.
	 * @param {Integer} nombreDePoints : Le nombre de points du lieu
	 * @param {mtg32.MotfiPoint} motif : Le motif utilisé pour la trace des points.
	 * @returns {CLieuDiscretDeBase}
	 */
	function CLieuDiscretDeBase(listeProprietaire, impProto, estElementFinal, couleur, masque, pointATracer, nombreDePoints, motif) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CElementGraphique.call(this, listeProprietaire);else {
	      CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 16);
	      this.pointATracer = pointATracer;
	      this.nombreDePoints = nombreDePoints;
	      this.motif = motif;
	      this.abscissesCoordonneesPoints = new Array(nombreDePoints);
	      this.ordonneesCoordonneesPoints = new Array(nombreDePoints);
	      // Il faut créer la liste des éléments dont dépend le point à tracer
	      this.listeElementsAncetres = new CSousListeObjets();
	    }
	    this.point1 = new CPointBase(listeProprietaire);
	    this.point1.donneMotif(motif);
	  }
	}
	CLieuDiscretDeBase.prototype = new CElementGraphique();
	CLieuDiscretDeBase.prototype.constructor = CLieuDiscretDeBase;
	CLieuDiscretDeBase.prototype.superClass = "CElementGraphique";
	CLieuDiscretDeBase.prototype.className = "CLieuDiscretDeBase";
	/**
	 * Fonction chanheant les caractéristiques du lieu
	 * @returns {undefined}
	 */
	CLieuDiscretDeBase.prototype.setClone = function (ptel) {
	  CElementGraphique.prototype.setClone.call(this, ptel);
	  this.motif = ptel.motif;
	  this.indiceDernierPointTrace = ptel.indiceDernierPointTrace;
	  // Il faut copier toutes les coordonnées
	  for (var i = 0; i < this.indiceDernierPointTrace; i++) {
	    this.abscissesCoordonneesPoints[i] = ptel.abscissesCoordonneesPoints[i];
	    this.ordonneesCoordonneesPoints[i] = ptel.ordonneesCoordonneesPoints[i];
	  }
	};
	CLieuDiscretDeBase.prototype.dependDe = function (p) {
	  return CElementGraphique.prototype.dependDe.call(this, p) || this.pointATracer.dependDe(p);
	};
	CLieuDiscretDeBase.prototype.createg = function () {
	  var g;
	  this.point1.donneMotif(this.motif);
	  this.point1.donneCouleur(this.couleur);
	  g = kernel.cens("g", {
	    "pointer-events": "none"
	  });
	  for (var i = 0; i <= this.indiceDernierPointTrace; i++) {
	    this.point1.placeEn(this.abscissesCoordonneesPoints[i], this.ordonneesCoordonneesPoints[i]);
	    g.appendChild(this.point1.createg());
	  }
	  return g;
	};
	CLieuDiscretDeBase.prototype.trace = function (svg, couleurFond, transparence) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CLieuDiscretDeBase.prototype.update = function (svg) {
	  var oldg = this.g;
	  var g = this.createg();
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CLieuDiscretDeBase.prototype.dansFen = function (dimfen) {
	  if (!this.existe) return false;
	  var resultat = false;
	  for (var i = 0; i <= this.indiceDernierPointTrace; i++) {
	    resultat = resultat || dimfen.dansFenetre(this.abscissesCoordonneesPoints[i], this.ordonneesCoordonneesPoints[i]);
	  }
	  return resultat;
	};
	CLieuDiscretDeBase.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointATracer === ancienPoint) this.pointATracer = nouveauPoint;
	};
	CLieuDiscretDeBase.prototype.getNature = function () {
	  return NatObj.NLieuDiscret;
	};
	CLieuDiscretDeBase.prototype.chaineDesignation = function () {
	  return "desLieuPoint";
	};
	CLieuDiscretDeBase.prototype.read = function (inps, list) {
	  CElementGraphique.prototype.read.call(this, inps, list);
	  this.point1 = new CPointBase(null);
	  var ind1 = inps.readInt();
	  this.pointATracer = list.get(ind1, "CPt.class");
	  this.nombreDePoints = inps.readInt();
	  this.motif = inps.readByte();
	  // Il faut créer les tableaux de coordonnées
	  // On réserve une coordonnée supplémentaire pour le cas d'un lieu fermé
	  this.abscissesCoordonneesPoints = new Array(this.nombreDePoints);
	  this.ordonneesCoordonneesPoints = new Array(this.nombreDePoints);
	  this.listeElementsAncetres = new CSousListeObjets();
	};
	CLieuDiscretDeBase.prototype.write = function (oups, list) {
	  CElementGraphique.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.pointATracer);
	  oups.writeInt(ind1);
	  oups.writeInt(this.nombreDePoints);
	  oups.writeByte(this.motif);
	};

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CLieuDiscretDeBase = __webpack_require__(147);
	module.exports = CLieuDiscretParPointLie;
	
	/**
	 * Classe représentant un lieu de points non reliés généré par un point lié.
	 * @constructor
	 * @extends CLieuDiscretDeBase
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la liste propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Couleur} couleur : La couleur de l'objet.
	 * @param {Booelan} masque : true si l'objet est masqué
	 * @param {CPt} pointATracer : Le point qui laisse une trace.
	 * @param {Integer} nombreDePoints : Le nombre de points du lieu
	 * @param {mtg32.MotfiPoint} motif : Le motif utilisé pour la trace des points.
	 * @param {CPointLie} pointLieGenerateur : Le point lié dont les positions génèrent le lieu.
	 * @returns {CLieuDiscretParPointLie}
	 */
	function CLieuDiscretParPointLie(listeProprietaire, impProto, estElementFinal, couleur, masque, pointATracer, nombreDePoints, motif, pointLieGenerateur) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CLieuDiscretDeBase.call(this, listeProprietaire);else {
	      CLieuDiscretDeBase.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, pointATracer, nombreDePoints, motif);
	      this.pointLieGenerateur = pointLieGenerateur;
	    }
	  }
	}
	CLieuDiscretParPointLie.prototype = new CLieuDiscretDeBase();
	CLieuDiscretParPointLie.prototype.constructor = CLieuDiscretParPointLie;
	CLieuDiscretParPointLie.prototype.superClass = "CLieuDiscretDeBase";
	CLieuDiscretParPointLie.prototype.className = "CLieuDiscretParPointLie";
	
	CLieuDiscretParPointLie.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CLieuDiscretParPointLie.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointATracer);
	  var ind2 = listeSource.indexOf(this.pointLieGenerateur);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var ptelb = new CLieuDiscretParPointLie(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, listeCible.get(ind1, "CPt"), this.nombreDePoints, this.motif, listeCible.get(ind2, "CPointLie"));
	  if (listeCible.className !== "CPrototype") {
	    ptelb.listeElementsAncetres.setImage(this.listeElementsAncetres, this.listeProprietaire, ptelb.listeProprietaire);
	  }
	  return ptelb;
	};
	CLieuDiscretParPointLie.prototype.metAJour = function () {
	  CLieuDiscretDeBase.prototype.metAJour.call(this);
	  this.etablitListeElementsAncetres();
	};
	CLieuDiscretParPointLie.prototype.dependDePourCapture = function (p) {
	  // Un lieu de points n'a pas à être redessiné si on bouge le point
	  // lié qui l'a engendré}
	  return p === this || this.pointATracer.dependDe(p) && p !== this.pointLieGenerateur;
	};
	CLieuDiscretParPointLie.prototype.positionne = function (infoRandom, dimfen) {
	  var abscisseMini, abscisseMaxi, abscisse, abscisseInitiale, pas, abscisseFinale;
	  if (!this.pointLieGenerateur.existe) {
	    this.existe = false;
	    return;
	  }
	  abscisseMini = this.pointLieGenerateur.abscisseMinimale();
	  abscisseMaxi = this.pointLieGenerateur.abscisseMaximale();
	  if (abscisseMini === abscisseMaxi) {
	    this.existe = false;
	    return;
	  } else {
	    // On range dans l'ordre croissant
	    if (abscisseMini > abscisseMaxi) {
	      var d = abscisseMini;
	      abscisseMini = abscisseMaxi;
	      abscisseMaxi = d;
	    }
	  }
	  abscisseInitiale = this.pointLieGenerateur.abscisse;
	  // Modification pour la version 1.9.5
	  var nbValeurs;
	  if (this.pointLieGenerateur.lieALigneFermee()) {
	    nbValeurs = this.nombreDePoints;
	    pas = (abscisseMaxi - abscisseMini) / nbValeurs;
	    abscisseFinale = abscisseMaxi - pas;
	  } else {
	    nbValeurs = this.nombreDePoints - 1;
	    pas = (abscisseMaxi - abscisseMini) / nbValeurs;
	    abscisseFinale = abscisseMaxi;
	  }
	  abscisse = abscisseMini - pas;
	  this.indiceDernierPointTrace = -1;
	  var nb = this.nombreDePoints - 1;
	  for (var i = 0; i < this.nombreDePoints; i++) {
	    abscisse = i === 0 ? abscisseMini : i === nb ? abscisseFinale : abscisse + pas;
	    this.pointLieGenerateur.donneAbscisse(abscisse);
	    this.listeElementsAncetres.positionne(infoRandom, dimfen);
	    if (this.pointATracer.existe) {
	      if (kernel.testToile(this.pointATracer.x, this.pointATracer.y)) {
	        this.indiceDernierPointTrace++;
	        this.abscissesCoordonneesPoints[this.indiceDernierPointTrace] = Math.round(this.pointATracer.x);
	        this.ordonneesCoordonneesPoints[this.indiceDernierPointTrace] = Math.round(this.pointATracer.y);
	      }
	    }
	  }
	  // On  remet le point ancêtre à sa position initiale
	  this.pointLieGenerateur.donneAbscisse(abscisseInitiale);
	  this.listeElementsAncetres.positionne(infoRandom, dimfen);
	  this.existe = this.indiceDernierPointTrace >= 0;
	};
	CLieuDiscretParPointLie.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.pointATracer === p.pointATracer && this.pointLieGenerateur === p.pointLieGenerateur;
	  } else return false;
	};
	/**
	 * Fonction mettant dans this.listeElementsAncetres la liste de tous les objets de la liste
	 * propriétaire qui doivent être calculés lorsque le lieu est calculé.
	 * @returns {undefined}
	 */
	CLieuDiscretParPointLie.prototype.etablitListeElementsAncetres = function () {
	  if (this.listeProprietaire.className !== "CPrototype") {
	    var indicePointATracer = this.listeProprietaire.indexOf(this.pointATracer);
	    var indicePointLieGenerateur = this.listeProprietaire.indexOf(this.pointLieGenerateur);
	    this.listeElementsAncetres.retireTout();
	    this.listeElementsAncetres.add(this.pointLieGenerateur);
	    this.listeElementsAncetres.add(this.pointLieGenerateur);
	    for (var i = indicePointLieGenerateur + 1; i < indicePointATracer; i++) {
	      var ptelb = this.listeProprietaire.get(i);
	      if (this.pointATracer.dependDe(ptelb) && ptelb.dependDe(this.pointLieGenerateur)) this.listeElementsAncetres.add(ptelb);
	    }
	    this.listeElementsAncetres.add(this.pointATracer);
	  }
	};
	CLieuDiscretParPointLie.prototype.read = function (inps, list) {
	  CLieuDiscretDeBase.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.pointLieGenerateur = list.get(ind1, "CPointLie");
	  this.listeElementsAncetres.read(inps, list);
	};
	CLieuDiscretParPointLie.prototype.write = function (oups, list) {
	  CLieuDiscretDeBase.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.pointLieGenerateur);
	  oups.writeInt(ind1);
	  this.listeElementsAncetres.write(oups, this.listeProprietaire);
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CLieuDiscretDeBase = __webpack_require__(147);
	module.exports = CLieuDiscretParVariable;
	
	/**
	 * Classe représentant un lieu de points non reliés généré par les valeurs d'une variable.
	 * @constructor
	 * @extends CLieuDiscretDeBase
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la liste propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Couleur} couleur : La couleur de l'objet.
	 * @param {Booelan} masque : true si l'objet est masqué
	 * @param {CPt} pointATracer : Le point qui laisse une trace.
	 * @param {Integer} nombreDePoints : Le nombre de points du lieu
	 * @param {mtg32.MotfiPoint} motif : Le motif utilisé pour la trace des points.
	 * @param {mtg32.VariableBornee} variableGeneratrice : La variable dont les valeurs génèrent le lieu.
	 * @returns {CLieuDiscretParVariable}
	 */
	function CLieuDiscretParVariable(listeProprietaire, impProto, estElementFinal, couleur, masque, pointATracer, nombreDePoints, motif, variableGeneratrice) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CLieuDiscretDeBase.call(this, listeProprietaire);else {
	      CLieuDiscretDeBase.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, pointATracer, nombreDePoints, motif);
	      this.variableGeneratrice = variableGeneratrice;
	    }
	  }
	}
	CLieuDiscretParVariable.prototype = new CLieuDiscretDeBase();
	CLieuDiscretParVariable.prototype.constructor = CLieuDiscretParVariable;
	CLieuDiscretParVariable.prototype.superClass = "CLieuDiscretDeBase";
	CLieuDiscretParVariable.prototype.className = "CLieuDiscretParVariable";
	
	CLieuDiscretParVariable.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CLieuDiscretParVariable.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointATracer);
	  var ind2 = listeSource.indexOf(this.variableGeneratrice);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var ptelb = new CLieuDiscretParVariable(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, listeCible.get(ind1, "CPt"), this.nombreDePoints, this.motif, listeCible.get(ind2, "CVariableBornee"));
	  if (listeCible.className !== "CPrototype") {
	    // this.listeElementsAncetres.setImage(ptelb.listeElementsAncetres, ptelb.listeProprietaire, this.listeProprietaire);
	    ptelb.listeElementsAncetres.setImage(this.listeElementsAncetres, this.listeProprietaire, ptelb.listeProprietaire);
	  }
	  return ptelb;
	};
	CLieuDiscretParVariable.prototype.metAJour = function () {
	  CLieuDiscretDeBase.prototype.metAJour.call(this);
	  this.etablitListeElementsAncetres();
	};
	CLieuDiscretParVariable.prototype.positionne = function (infoRandom, dimfen) {
	  var valeur, valeurMinimale, valeurMaximale, valeurInitiale, pas;
	  if (!this.variableGeneratrice.existe) {
	    this.existe = false;
	    return;
	  }
	  valeurMinimale = this.variableGeneratrice.valeurMini;
	  valeurMaximale = this.variableGeneratrice.valeurMaxi;
	  valeurInitiale = this.variableGeneratrice.valeurActuelle;
	  pas = (valeurMaximale - valeurMinimale) / (this.nombreDePoints - 1);
	  valeur = valeurMinimale;
	  this.indiceDernierPointTrace = -1;
	  var nb = this.nombreDePoints - 1;
	  for (var i = 0; i < this.nombreDePoints; i++) {
	    valeur = i === 0 ? valeurMinimale : i === nb ? valeurMaximale : valeur + pas;
	    this.variableGeneratrice.donneValeur(valeur);
	    this.listeElementsAncetres.positionne(infoRandom, dimfen);
	    if (this.pointATracer.existe) {
	      if (kernel.testToile(this.pointATracer.x, this.pointATracer.y)) {
	        this.indiceDernierPointTrace++;
	        this.abscissesCoordonneesPoints[this.indiceDernierPointTrace] = Math.round(this.pointATracer.x);
	        this.ordonneesCoordonneesPoints[this.indiceDernierPointTrace] = Math.round(this.pointATracer.y);
	      }
	    }
	  }
	
	  // On redonne à la variable génératrice sa valeur initiale
	  this.variableGeneratrice.donneValeur(valeurInitiale);
	  this.listeElementsAncetres.positionne(infoRandom, dimfen);
	  this.existe = this.indiceDernierPointTrace >= 0;
	};
	CLieuDiscretParVariable.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.pointATracer === p.pointATracer && this.variableGeneratrice === p.variableGeneratrice;
	  } else return false;
	};
	/**
	 * Fonction mettant dans this.listeElementsAncetres la liste de tous les objets de la liste
	 * propriétaire qui doivent être calculés lorsque le lieu est calculé.
	 * @returns {undefined}
	 */
	
	CLieuDiscretParVariable.prototype.etablitListeElementsAncetres = function () {
	  if (this.listeProprietaire.className !== "CPrototype") {
	    this.listeElementsAncetres.retireTout();
	    var indicePointATracer = this.listeProprietaire.indexOf(this.pointATracer);
	    var indiceVariableGeneratrice = this.listeProprietaire.indexOf(this.variableGeneratrice);
	    this.listeElementsAncetres.add(this.variableGeneratrice);
	    for (var i = indiceVariableGeneratrice + 1; i < indicePointATracer; i++) {
	      var ptelb = this.listeProprietaire.get(i);
	      if (this.pointATracer.dependDe(ptelb) && ptelb.dependDe(this.variableGeneratrice)) this.listeElementsAncetres.add(ptelb);
	    }
	    this.listeElementsAncetres.add(this.pointATracer);
	  }
	};
	CLieuDiscretParVariable.prototype.read = function (inps, list) {
	  CLieuDiscretDeBase.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.variableGeneratrice = list.get(ind1, "CVariableBornee");
	  this.listeElementsAncetres.read(inps, list);
	};
	CLieuDiscretParVariable.prototype.write = function (oups, list) {
	  CLieuDiscretDeBase.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.variableGeneratrice);
	  oups.writeInt(ind1);
	  this.listeElementsAncetres.write(oups, this.listeProprietaire);
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var kernel = __webpack_require__(8);
	var CElementGraphique = __webpack_require__(39);
	var CListeObjets = __webpack_require__(17);
	var CValeur = __webpack_require__(80);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CLieuObjetAncetre;
	
	/**
	 * Classe ancêtre de tous les lieux d'objets.
	 * @constructor
	 * @extends CElementGraphique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la liste propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Couleur} couleur : La couleur de l'objet.
	 * @param {Booelan} masque : true si l'objet est masqué
	 * @param {CElementGraphique} elementAssocie : L'objet qui laisse une trace.
	 * @param {CValeur} nombreTraces : Le nombre d'objets pour la trace (dynamique).
	 * @returns {CLieuObjetAncetre}
	 */
	function CLieuObjetAncetre(listeProprietaire, impProto, estElementFinal, couleur, masque, elementAssocie, nombreTraces) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CElementGraphique.call(this, listeProprietaire);else {
	      CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 2, 0, 0);
	      this.elementAssocie = elementAssocie;
	      this.nombreTraces = nombreTraces;
	      this.listeCopiesObjet = new CListeObjets(listeProprietaire.uniteAngle, listeProprietaire.pointeurLongueurUnite);
	    }
	    this.listeElementsAncetres = new CSousListeObjets();
	  }
	}
	CLieuObjetAncetre.prototype = new CElementGraphique();
	CLieuObjetAncetre.prototype.constructor = CLieuObjetAncetre;
	CLieuObjetAncetre.prototype.superClass = "CElementGraphique";
	CLieuObjetAncetre.prototype.className = "CLieuObjetAncetre";
	
	CLieuObjetAncetre.nombreMaxiPourLieuObjet = 100000;
	CLieuObjetAncetre.prototype.setClone = function (ptel) {
	  CElementGraphique.prototype.setClone.call(this, ptel);
	  for (var i = 0; i < this.listeCopiesObjet.longueur(); i++) {
	    var elb1 = this.listeCopiesObjet.get(i);
	    var elb2 = ptel.listeCopiesObjet.get(i);
	    elb1.setClone(elb2);
	  }
	};
	CLieuObjetAncetre.prototype.positionne = function (infoRandom, dimfen) {
	  CElementGraphique.prototype.positionne.call(this, infoRandom, dimfen);
	  this.nombreTraces.positionne(infoRandom, dimfen);
	  this.existe = this.existe && this.nombreTraces.existe;
	};
	CLieuObjetAncetre.prototype.metAJour = function () {
	  this.prepareListeCopiesObjet();
	  this.donneCouleur(this.couleur);
	};
	CLieuObjetAncetre.prototype.nombreObjetsPourLieuObjet = function () {
	  if (!this.nombreTraces.existe) return kernel.Max_VALUE;
	  var d = Math.round(this.nombreTraces.rendValeur()) * Math.round(this.elementAssocie.nombreObjetsPourLieuObjet());
	  if (d < 0 || d > kernel.Max_VALUE) d = kernel.Max_VALUE;
	  return d;
	};
	CLieuObjetAncetre.prototype.initialisePourDependance = function () {
	  CElementGraphique.prototype.initialisePourDependance.call(this);
	  this.nombreTraces.initialisePourDependance();
	};
	CLieuObjetAncetre.prototype.prepareListeCopiesObjet = function () {
	  // Il faut créer la liste des éléments dont dépend le point à tracer
	  // Pour cette liste, on fait pointer la longueur unité éventuelle sur la liste mère
	  this.listeCopiesObjet.retireTout();
	  var nbt = Math.round(this.nombreTraces.rendValeur());
	  if (nbt >= 2 && nbt <= CLieuObjetAncetre.nombreMaxiPourLieuObjet) {
	    this.listeCopiesObjet.ajouteClonesDe(this.elementAssocie, nbt);
	    // Ligne suivante ajoutée version 2.0
	    // Nécessaire pour les lieux de lieux d'objets car ce type d'objet mainient une liste
	    // qui est instanciée de façon dynamique
	    this.listeCopiesObjet.metAJour();
	  }
	  // La ligne suivante sert à donner aux objets clonés servant à la trace la couleur du lieu
	  // d'objet
	  this.donneCouleur(this.couleur);
	};
	CLieuObjetAncetre.prototype.dependDe = function (p) {
	  return CElementGraphique.prototype.dependDe.call(this, p) || this.elementAssocie.dependDe(p) || this.nombreTraces.dependDe(p);
	};
	CLieuObjetAncetre.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.elementAssocie.dependDePourBoucle(p) || this.nombreTraces.dependDePourBoucle(p);
	};
	CLieuObjetAncetre.prototype.cache = function () {
	  CElementGraphique.prototype.cache.call(this);
	  for (var i = 0; i < this.listeCopiesObjet.longueur(); i++) {
	    this.listeCopiesObjet.get(i).cache();
	  }
	};
	CLieuObjetAncetre.prototype.montre = function () {
	  CElementGraphique.prototype.montre.call(this);
	  for (var i = 0; i < this.listeCopiesObjet.longueur(); i++) {
	    this.listeCopiesObjet.get(i).montre();
	  }
	};
	CLieuObjetAncetre.prototype.createg = function (svg, couleurFond, transparence) {
	  var gcree;
	  var g = kernel.cens("g", {
	    "pointer-events": "none"
	  });
	  for (var i = 0; i < this.listeCopiesObjet.longueur(); i++) {
	    var elg = this.listeCopiesObjet.get(i);
	    if (elg.hasg(false)) {
	      gcree = elg.createg(svg, couleurFond, transparence);
	      elg.g = gcree;
	      g.appendChild(gcree); // A revoir
	    }
	    // g vide si l'objet n'existe pas
	  }
	  return g;
	};
	/*
	 * Spécial JvaScript : on mémorise le nombre d'objets tracés.
	 * Au prochain update, si le nombre d'objets est le même on n'appelera pas createg
	 * mais updateg pour chaque objet de la liste d'objest dupliqués.
	 */
	CLieuObjetAncetre.prototype.trace = function (svg, couleurFond, transparence) {
	  var g = this.createg(svg, couleurFond, transparence);
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CLieuObjetAncetre.prototype.update = function (svg, couleurFond, transparence) {
	  var oldg = this.g;
	  var g = this.createg(svg, couleurFond, transparence);
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CLieuObjetAncetre.prototype.getNature = function () {
	  return NatObj.NLieuObjet;
	};
	CLieuObjetAncetre.prototype.donneCouleur = function (coul) {
	  this.couleur = coul;
	  this.color = coul.rgb(); //
	  for (var i = 0; i < this.listeCopiesObjet.longueur(); i++) {
	    this.listeCopiesObjet.get(i).donneCouleur(coul);
	  }
	};
	CLieuObjetAncetre.prototype.ajusteListeCopieObjets = function () {
	  var nbt = Math.round(this.nombreTraces.rendValeur());
	  var ancien = this.listeCopiesObjet.longueur();
	  if (nbt < ancien) for (var i = 0; i < ancien - nbt; i++) {
	    this.listeCopiesObjet.remove(this.listeCopiesObjet.longueur() - 1);
	  } else {
	    this.listeCopiesObjet.ajouteClonesDe(this.elementAssocie, nbt - ancien);
	    this.listeCopiesObjet.metAJour();
	    this.donneCouleur(this.couleur);
	  }
	  this.listeProprietaire.recreeListesCopiesLieuxObjetsDependantDe(this);
	};
	CLieuObjetAncetre.prototype.recreeListeCopieObjets = function () {
	  var nbt = Math.round(this.nombreTraces.rendValeur());
	  this.listeCopiesObjet.retireTout();
	  this.listeCopiesObjet.ajouteClonesDe(this.elementAssocie, nbt);
	  this.listeCopiesObjet.metAJour();
	  this.donneCouleur(this.couleur);
	};
	CLieuObjetAncetre.prototype.read = function (inps, list) {
	  CElementGraphique.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.elementAssocie = list.get(ind1, "CElementGraphique");
	  this.nombreTraces = new CValeur();
	  this.nombreTraces.read(inps, list);
	  // Il faut créer la liste des éléments dont dépend le point à tracer
	  // Pour cette liste, on fait pointer la longueur unité éventuelle sur la liste mère
	  // Ligne suivante revue version 3.4.2
	  // listeElementsAncetres = new CListeObjets(list.uniteAngle, list.pointeurLongueurUnite);
	  if (list.className !== "CPrototype") {
	    this.listeCopiesObjet = new CListeObjets(list.uniteAngle, list.pointeurLongueurUnite);
	    // Comme le nombre d'objets est dynamique on ne peut pas savoir au chargement combien il y en a.
	    //On laisse la liste vide et cela sera mis à jour lorsque positionne() sera appelé
	    this.donneCouleur(this.couleur);
	  }
	};
	CLieuObjetAncetre.prototype.write = function (oups, list) {
	  CElementGraphique.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.elementAssocie);
	  oups.writeInt(ind1);
	  this.nombreTraces.write(oups, list);
	};
	CLieuObjetAncetre.prototype.setReady4MathJax = function () {
	  /*
	  for(var i = 0; i < this.listeCopiesObjet.longueur();i++){
	    this.listeCopiesObjet.get(i).setReady4MathJax();
	  }
	  */
	  this.listeCopiesObjet.setReady4MathJax();
	};
	CLieuObjetAncetre.prototype.setReady4MathJaxUpdate = function () {
	  /*
	    for(var i = 0; i < this.listeCopiesObjet.longueur();i++){
	    this.listeCopiesObjet.get(i).setReady4MathJax();
	  }
	  */
	  this.listeCopiesObjet.setReady4MathJax();
	};
	CLieuObjetAncetre.prototype.chaineDesignation = function () {
	  return "desLieuObjet";
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CLieuObjetAncetre = __webpack_require__(150);
	module.exports = CLieuObjetParPtLie;
	
	/**
	 * Classe représentant un lieu d'objets généré par les positions d'un point lié.
	 * @constructor
	 * @extends CLieuObjetAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la liste propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Couleur} couleur : La couleur de l'objet.
	 * @param {Booelan} masque : true si l'objet est masqué
	 * @param {CElementGraphique} elementAssocie : L'objet qui laisse une trace.
	 * @param {CValeur} nombreTraces : Le nombre d'objets pour la trace (dynamique).
	 * @param {CPointLie} pointLieGenerateur : Le point lié dont les positions génèrent le lieu.
	 * @returns {CLieuObjetParPtLie}
	 */
	function CLieuObjetParPtLie(listeProprietaire, impProto, estElementFinal, couleur, masque, elementAssocie, nombreTraces, pointLieGenerateur) {
	  if (arguments.length === 1) CLieuObjetAncetre.call(this, listeProprietaire);else {
	    CLieuObjetAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, elementAssocie, nombreTraces);
	    this.pointLieGenerateur = pointLieGenerateur;
	  }
	}
	CLieuObjetParPtLie.prototype = new CLieuObjetAncetre();
	CLieuObjetParPtLie.prototype.constructor = CLieuObjetParPtLie;
	CLieuObjetParPtLie.prototype.superClass = "CLieuObjetAncetre";
	CLieuObjetParPtLie.prototype.className = "CLieuObjetParPtLie";
	
	CLieuObjetParPtLie.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CLieuObjetParPtLie.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.elementAssocie);
	  var ind2 = listeSource.indexOf(this.pointLieGenerateur);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var nombreTracesClone = this.nombreTraces.getClone(listeSource, listeCible);
	
	  var ptelb = new CLieuObjetParPtLie(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, listeCible.get(ind1, "CElementGraphique"), nombreTracesClone, listeCible.get(ind2, "CPointLie"));
	  if (listeCible.className !== "CPrototype") ptelb.listeElementsAncetres.setImage(this.listeElementsAncetres, this.listeProprietaire, ptelb.listeProprietaire);
	  return ptelb;
	};
	CLieuObjetParPtLie.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.pointLieGenerateur);
	  liste.add(this.elementAssocie);
	};
	CLieuObjetParPtLie.prototype.metAJour = function () {
	  CLieuObjetAncetre.prototype.metAJour.call(this);
	  this.etablitListeElementsAncetres();
	};
	CLieuObjetParPtLie.prototype.dependDePourCapture = function (p) {
	  return this.pointLieGenerateur !== p && (p === this || this.elementAssocie.dependDe(p) || this.nombreTraces.dependDe(p));
	};
	CLieuObjetParPtLie.prototype.positionne = function (infoRandom, dimfen) {
	  var nbValeurs, abscisseMini, abscisseMaxi, abscisse, abscisseInitiale, pas, abscisseFinale, elementAssocieMasque, nb, i, ptelg;
	  var nbmax = CLieuObjetAncetre.nombreMaxiPourLieuObjet;
	  CLieuObjetAncetre.prototype.positionne.call(this, infoRandom, dimfen);
	  this.existe = this.existe && this.pointLieGenerateur.existe && this.nombreObjetsPourLieuObjet() <= nbmax;
	  if (!this.existe) return;
	  var dnbt = Math.round(this.nombreTraces.rendValeur());
	  this.existe = dnbt >= 2 && dnbt <= nbmax;
	  if (!this.existe) return;
	  // var nbt = (int) dnbt;
	
	  // Changement important de la version 2.5, le nombre de traces étant devenu dynamique
	  if (dnbt !== this.listeCopiesObjet.longueur()) this.ajusteListeCopieObjets();
	  abscisseMini = this.pointLieGenerateur.abscisseMinimale();
	  abscisseMaxi = this.pointLieGenerateur.abscisseMaximale();
	  if (abscisseMini === abscisseMaxi) {
	    this.existe = false;
	    return;
	  } else {
	    if (abscisseMini > abscisseMaxi) {
	      var w = abscisseMini;
	      abscisseMini = abscisseMaxi;
	      abscisseMaxi = w;
	    }
	  }
	  // Pour tenir compte des points liés liés à des lieux fermés
	  if (this.pointLieGenerateur.lieALigneFermee()) {
	    nbValeurs = dnbt;
	    pas = (abscisseMaxi - abscisseMini) / nbValeurs;
	    abscisseFinale = abscisseMaxi - pas;
	  } else {
	    nbValeurs = dnbt - 1;
	    pas = (abscisseMaxi - abscisseMini) / nbValeurs;
	    abscisseFinale = abscisseMaxi;
	  }
	  abscisseInitiale = this.pointLieGenerateur.abscisse;
	  abscisse = abscisseMini;
	  this.existe = false;
	  elementAssocieMasque = this.elementAssocie.masque;
	  this.elementAssocie.montre();
	  // Modifié version 3.9.1 pour éviter des erreurs d'arrondi
	  nb = dnbt - 1;
	  for (i = 0; i < dnbt; i++) {
	    abscisse = i === 0 ? abscisseMini : i === nb ? abscisseFinale : abscisse + pas;
	    this.pointLieGenerateur.donneAbscisse(abscisse);
	    this.listeElementsAncetres.positionne(infoRandom, dimfen);
	    this.existe = this.existe || this.elementAssocie.existe;
	    ptelg = this.listeCopiesObjet.get(i);
	    ptelg.setClone(this.elementAssocie);
	  }
	  this.elementAssocie.masque = elementAssocieMasque;
	  this.pointLieGenerateur.donneAbscisse(abscisseInitiale);
	  this.listeElementsAncetres.positionne(infoRandom, dimfen);
	};
	CLieuObjetParPtLie.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.pointLieGenerateur === p.pointLieGenerateur && this.elementAssocie === p.elementAssocie && this.nombreTraces.confonduAvec(p.nombreTraces);
	  } else return false;
	};
	/**
	 * Fonction mettant dans this.listeElementsAncetres la liste de tous les objets de la liste
	 * propriétaire qui doivent être calculés lorsque le lieu est calculé.
	 * @returns {undefined}
	 */
	CLieuObjetParPtLie.prototype.etablitListeElementsAncetres = function () {
	  if (this.listeProprietaire.className !== "CPrototype") {
	    this.listeElementsAncetres.retireTout();
	    var indiceElementAssocie = this.listeProprietaire.indexOf(this.elementAssocie);
	    var indicePointLieGenerateur = this.listeProprietaire.indexOf(this.pointLieGenerateur);
	    this.listeElementsAncetres.add(this.pointLieGenerateur);
	    for (var i = indicePointLieGenerateur + 1; i < indiceElementAssocie; i++) {
	      var ptelb = this.listeProprietaire.get(i);
	      if (this.elementAssocie.dependDe(ptelb) && ptelb.dependDe(this.pointLieGenerateur)) this.listeElementsAncetres.add(ptelb);
	    }
	    this.listeElementsAncetres.add(this.elementAssocie);
	  }
	};
	CLieuObjetParPtLie.prototype.read = function (inps, list) {
	  CLieuObjetAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.pointLieGenerateur = list.get(ind1, "CPointLie");
	  this.listeElementsAncetres.read(inps, list);
	};
	CLieuObjetParPtLie.prototype.write = function (oups, list) {
	  CLieuObjetAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.pointLieGenerateur);
	  oups.writeInt(ind1);
	  this.listeElementsAncetres.write(oups, this.listeProprietaire);
	};

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CLieuObjetAncetre = __webpack_require__(150);
	module.exports = CLieuObjetParVariable;
	
	/**
	 * Classe représentant un lieu d'objets généré par les valeurs d'une variable.
	 * @constructor
	 * @extends CLieuObjetAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la liste propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Couleur} couleur : La couleur de l'objet.
	 * @param {Booelan} masque : true si l'objet est masqué
	 * @param {CElementGraphique} elementAssocie : L'objet qui laisse une trace.
	 * @param {CValeur} nombreTraces : Le nombre d'ojbets pour la trace (dynamique).
	 * @param {CVariableBornee} variableGeneratrice : La variable dont les valeurs génèrent le lieu.
	 * @returns {CLieuObjetParVariable}
	 */
	function CLieuObjetParVariable(listeProprietaire, impProto, estElementFinal, couleur, masque, elementAssocie, nombreTraces, variableGeneratrice) {
	  if (arguments.length === 1) CLieuObjetAncetre.call(this, listeProprietaire);else {
	    CLieuObjetAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, elementAssocie, nombreTraces);
	    this.variableGeneratrice = variableGeneratrice;
	  }
	}
	CLieuObjetParVariable.prototype = new CLieuObjetAncetre();
	CLieuObjetParVariable.prototype.constructor = CLieuObjetParVariable;
	CLieuObjetParVariable.prototype.superClass = "CLieuObjetAncetre";
	CLieuObjetParVariable.prototype.className = "CLieuObjetParVariable";
	
	CLieuObjetParVariable.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CLieuObjetParVariable.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.elementAssocie);
	  var ind2 = listeSource.indexOf(this.variableGeneratrice);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var nombreTracesClone = this.nombreTraces.getClone(listeSource, listeCible);
	  var ptelb = new CLieuObjetParVariable(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, listeCible.get(ind1, "CElementGraphique"), nombreTracesClone, listeCible.get(ind2, "CVariableBornee"));
	  if (listeCible.className !== "CPrototype") {
	    ptelb.listeElementsAncetres.setImage(this.listeElementsAncetres, this.listeProprietaire, ptelb.listeProprietaire);
	  }
	  return ptelb;
	};
	CLieuObjetParVariable.prototype.metAJour = function () {
	  CLieuObjetAncetre.prototype.metAJour.call(this);
	  this.etablitListeElementsAncetres();
	};
	CLieuObjetParVariable.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.variableGeneratrice);
	  liste.add(this.elementAssocie);
	};
	CLieuObjetParVariable.prototype.positionne = function (infoRandom, dimfen) {
	  var valeur, valeurMinimale, valeurMaximale, valeurInitiale, pas, i, ptelg, dnbt, nb, elementAssocieMasque;
	  CLieuObjetAncetre.prototype.positionne.call(this, infoRandom, dimfen);
	  this.existe = this.existe && this.nombreObjetsPourLieuObjet() <= CLieuObjetAncetre.nombreMaxiPourLieuObjet;
	  dnbt = Math.round(this.nombreTraces.rendValeur());
	  this.existe = this.existe && dnbt >= 2 && dnbt <= CLieuObjetAncetre.nombreMaxiPourLieuObjet;
	  if (!this.existe) return;
	  // Changement important de la version 2.5, le nombre de traces étant devenu dynamique
	  if (dnbt !== this.listeCopiesObjet.longueur()) this.ajusteListeCopieObjets();
	  valeurMinimale = this.variableGeneratrice.valeurMini;
	  valeurMaximale = this.variableGeneratrice.valeurMaxi;
	  valeurInitiale = this.variableGeneratrice.valeurActuelle;
	  // Pour tenir compte des points liés liés à des lieux fermés
	  pas = (valeurMaximale - valeurMinimale) / (dnbt - 1);
	  valeur = valeurMinimale;
	
	  elementAssocieMasque = this.elementAssocie.masque;
	  this.elementAssocie.montre();
	  this.existe = false;
	  nb = dnbt - 1;
	  for (i = 0; i < dnbt; i++) {
	    // Optimisé version 4.0
	    valeur = i === 0 ? valeurMinimale : i === nb ? valeurMaximale : valeur + pas;
	    this.variableGeneratrice.donneValeur(valeur);
	    this.listeElementsAncetres.positionne(infoRandom, dimfen);
	    this.existe = this.existe || this.elementAssocie.existe;
	    ptelg = this.listeCopiesObjet.get(i);
	    ptelg.setClone(this.elementAssocie);
	    // Au cas où l'objet générateur du lieu serait caché
	    ptelg.montre();
	  }
	  this.elementAssocie.masque = elementAssocieMasque;
	  // On redonne à la variable génératrice sa valeur initiale
	  this.variableGeneratrice.donneValeur(valeurInitiale);
	  this.listeElementsAncetres.positionne(infoRandom, dimfen);
	};
	CLieuObjetParVariable.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.variableGeneratrice === p.variableGeneratrice && this.elementAssocie === p.elementAssocie && this.nombreTraces.confonduAvec(p.nombreTraces);
	  } else return false;
	};
	/**
	 * Fonction mettant dans this.listeElementsAncetres la liste de tous les objets de la liste
	 * propriétaire qui doivent être calculés lorsque le lieu est calculé.
	 * @returns {undefined}
	 */
	CLieuObjetParVariable.prototype.etablitListeElementsAncetres = function () {
	  if (this.listeProprietaire.className !== "CPrototype") {
	    this.listeElementsAncetres.retireTout();
	    var indicePointATracer = this.listeProprietaire.indexOf(this.elementAssocie);
	    var indiceVariableGeneratrice = this.listeProprietaire.indexOf(this.variableGeneratrice);
	    this.listeElementsAncetres.add(this.variableGeneratrice);
	    for (var i = indiceVariableGeneratrice + 1; i < indicePointATracer; i++) {
	      var ptelb = this.listeProprietaire.get(i);
	      if (this.elementAssocie.dependDe(ptelb) && ptelb.dependDe(this.variableGeneratrice)) this.listeElementsAncetres.add(ptelb);
	    }
	    this.listeElementsAncetres.add(this.elementAssocie);
	  }
	};
	CLieuObjetParVariable.prototype.read = function (inps, list) {
	  CLieuObjetAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.variableGeneratrice = list.get(ind1, "CVariableBornee");
	  this.listeElementsAncetres.read(inps, list);
	};
	CLieuObjetParVariable.prototype.write = function (oups, list) {
	  CLieuObjetAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.variableGeneratrice);
	  oups.writeInt(ind1);
	  this.listeElementsAncetres.write(oups, this.listeProprietaire);
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var InfoLieu = __webpack_require__(144);
	var kernel = __webpack_require__(8);
	var CLieuDeBase = __webpack_require__(143);
	module.exports = CLieuParVariable;
	
	/**
	 * Classe représentant un lieu de points généré par les valeurs d'une variable.
	 * @constructor
	 * @extends CLieuDeBase
	 * @param {CListeObjets} listeProprietaire : la liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Booelan} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Couleur} couleur : La couleur de l'objet
	 * @param {Booelan} masque : true si l'objet est masqué
	 * @param {mtg32.StyleTrait} style : le style de tracé.
	 * @param {CPt} pointATracer : Le point qui laisse une trace.
	 * @param {InfoLieu} infoLieu
	 * @param {CVariableBornee} variableGeneratrice : La variable dont les valeurs génèrent le lieu.
	 * @returns {CLieuParVariable}
	 */
	function CLieuParVariable(listeProprietaire, impProto, estElementFinal, couleur, masque, style, pointATracer, infoLieu, variableGeneratrice) {
	  if (arguments.length === 1) CLieuDeBase.call(this, listeProprietaire);else {
	    CLieuDeBase.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, pointATracer, infoLieu);
	    this.variableGeneratrice = variableGeneratrice;
	  }
	}
	CLieuParVariable.prototype = new CLieuDeBase();
	CLieuParVariable.prototype.constructor = CLieuParVariable;
	CLieuParVariable.prototype.superClass = "CLieuDeBase";
	CLieuParVariable.prototype.className = "CLieuParVariable";
	
	CLieuParVariable.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CLieuParVariable.prototype.getClone = function (listeSource, listeCible) {
	  var infoLieuClone = new InfoLieu(this.infoLieu);
	  var ind1 = listeSource.indexOf(this.pointATracer);
	  var ind2 = listeSource.indexOf(this.variableGeneratrice);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var ptelb = new CLieuParVariable(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), infoLieuClone, listeCible.get(ind2, "CVariableBornee"));
	  if (listeCible.className !== "CPrototype") ptelb.listeElementsAncetres.setImage(this.listeElementsAncetres, this.listeProprietaire, ptelb.listeProprietaire);
	  return ptelb;
	};
	CLieuParVariable.prototype.metAJour = function () {
	  CLieuDeBase.prototype.metAJour.call(this);
	  this.etablitListeElementsAncetres();
	};
	CLieuParVariable.prototype.positionne = function (infoRandom, dimfen) {
	  var valeur, valeurMinimale, valeurMaximale, valeurInitiale, pas, ligneEnCours, indiceLigneEnCours, nb, i, auMoinsUneLigne, j, ligneTrouvee, indicePointRajoute;
	
	  if (!this.variableGeneratrice.existe) {
	    this.existe = false;
	    return;
	  }
	  valeurMinimale = this.variableGeneratrice.valeurMini;
	  valeurMaximale = this.variableGeneratrice.valeurMaxi;
	  valeurInitiale = this.variableGeneratrice.valeurActuelle;
	  pas = (valeurMaximale - valeurMinimale) / (this.infoLieu.nombreDePoints - 1);
	  valeur = valeurMinimale - pas;
	  ligneEnCours = false;
	  indiceLigneEnCours = -1;
	  nb = this.infoLieu.nombreDePoints - 1;
	  for (i = 0; i < this.infoLieu.nombreDePoints; i++) {
	    // Optimisation version 4.0 pour éviter les erreurs d'arrondi
	    valeur = i === 0 ? valeurMinimale : i === nb ? valeurMaximale : valeur + pas;
	    this.variableGeneratrice.donneValeur(valeur);
	    this.listeElementsAncetres.positionne(infoRandom, dimfen);
	    if (!this.pointATracer.existe) {
	      if (ligneEnCours) {
	        this.infoLignes[indiceLigneEnCours].nombrePoints = i - infoLignes[indiceLigneEnCours].indicePremierPoint;
	        ligneEnCours = false;
	      }
	    } else {
	      if (!kernel.testToile(this.pointATracer.x, this.pointATracer.y)) {
	        if (ligneEnCours) {
	          this.infoLignes[indiceLigneEnCours].nombrePoints = i - this.infoLignes[indiceLigneEnCours].indicePremierPoint;
	          ligneEnCours = false;
	        }
	      } else {
	        if (ligneEnCours) {
	          if (this.infoLieu.gestionDiscontinuite) {
	            if (Math.abs(this.pointATracer.x - this.abscissesCoordonneesPoints[i - 1]) > dimfen.x || Math.abs(this.pointATracer.y - this.ordonneesCoordonneesPoints[i - 1]) > dimfen.y) {
	              this.infoLignes[indiceLigneEnCours].nombrePoints = i - this.infoLignes[indiceLigneEnCours].indicePremierPoint;
	              ligneEnCours = false;
	            } else {
	              this.abscissesCoordonneesPoints[i] = Math.round(this.pointATracer.x);
	              this.ordonneesCoordonneesPoints[i] = Math.round(this.pointATracer.y);
	              this.infoLignes[indiceLigneEnCours].nombrePoints++;
	            }
	          } else {
	            this.abscissesCoordonneesPoints[i] = Math.round(this.pointATracer.x);
	            this.ordonneesCoordonneesPoints[i] = Math.round(this.pointATracer.y);
	            this.infoLignes[indiceLigneEnCours].nombrePoints++;
	          }
	        } else {
	          this.abscissesCoordonneesPoints[i] = Math.round(this.pointATracer.x);
	          this.ordonneesCoordonneesPoints[i] = Math.round(this.pointATracer.y);
	          indiceLigneEnCours++;
	          ligneEnCours = true;
	          this.infoLignes[indiceLigneEnCours].indicePremierPoint = i;
	          this.infoLignes[indiceLigneEnCours].nombrePoints = 1;
	        }
	      }
	    }
	  }
	  // On redonne à la variable génératrice sa valeur initiale
	  this.variableGeneratrice.donneValeur(valeurInitiale);
	  this.listeElementsAncetres.positionne(infoRandom, dimfen);
	  this.nombreLignes = indiceLigneEnCours + 1;
	  // Si le lieu n'est formé d'aucune ligne ou s'il est formé
	  // de lignes avec un seul point, il n'existe pas
	  if (this.nombreLignes === 0) {
	    this.existe = false;
	    return;
	  }
	  auMoinsUneLigne = false;
	  this.indicePremiereLigne = -1;
	  this.nombreLignesDePlusieursPoints = 0;
	  for (j = 0; j <= indiceLigneEnCours; j++) {
	    ligneTrouvee = this.infoLignes[j].nombrePoints >= 2;
	    if (ligneTrouvee) {
	      this.nombreLignesDePlusieursPoints++;
	      if (!auMoinsUneLigne) this.indicePremiereLigne = j;
	      auMoinsUneLigne = true;
	    }
	  }
	  if (!auMoinsUneLigne) {
	    this.existe = false;
	    return;
	  }
	
	  if (this.infoLieu.fermeOuNon) {
	    indicePointRajoute = this.infoLignes[indiceLigneEnCours].indicePremierPoint + this.infoLignes[indiceLigneEnCours].nombrePoints;
	    this.abscissesCoordonneesPoints[indicePointRajoute] = this.abscissesCoordonneesPoints[this.infoLignes[this.indicePremiereLigne].indicePremierPoint];
	    this.ordonneesCoordonneesPoints[indicePointRajoute] = this.ordonneesCoordonneesPoints[this.infoLignes[this.indicePremiereLigne].indicePremierPoint];
	    this.infoLignes[indiceLigneEnCours].nombrePoints++;
	  }
	  this.existe = true;
	};
	CLieuParVariable.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.pointATracer === p.pointATracer && this.variableGeneratrice === p.variableGeneratrice;
	  } else return false;
	};
	CLieuParVariable.prototype.etablitListeElementsAncetres = function () {
	  if (this.listeProprietaire.className !== "CPrototype") {
	    this.listeElementsAncetres.retireTout();
	    var indicePointATracer = this.listeProprietaire.indexOf(this.pointATracer);
	    var indiceVariableGeneratrice = this.listeProprietaire.indexOf(this.variableGeneratrice);
	    this.listeElementsAncetres.add(this.variableGeneratrice);
	    for (var i = indiceVariableGeneratrice + 1; i < indicePointATracer; i++) {
	      var ptelb = this.listeProprietaire.get(i);
	      if (this.pointATracer.dependDe(ptelb) && ptelb.dependDe(this.variableGeneratrice)) this.listeElementsAncetres.add(ptelb);
	    }
	    this.listeElementsAncetres.add(this.pointATracer);
	  }
	};
	CLieuParVariable.prototype.read = function (inps, list) {
	  CLieuDeBase.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.variableGeneratrice = list.get(ind1, "CVariableBornee");
	  this.listeElementsAncetres.read(inps, list);
	};
	CLieuParVariable.prototype.write = function (oups, list) {
	  CLieuDeBase.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.variableGeneratrice);
	  oups.writeInt(ind1);
	  this.listeElementsAncetres.write(oups, this.listeProprietaire);
	};

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var kernel = __webpack_require__(8);
	var CLignePolygonaleAncetre = __webpack_require__(155);
	module.exports = CLigneBrisee;
	
	/**
	 * Classe représentant une ligne brisée.
	 * @constructor
	 * @extends CLignePolygonaleAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style du tracé.
	 * @param {Array} colPoints :  Tableau de CNoeudPointeurSurPoint qui donne les sommets.
	 * @returns {CLigneBrisee}
	 */
	function CLigneBrisee(listeProprietaire, impProto, estElementFinal, couleur, masque, style, colPoints) {
	  if (arguments.length === 1) CLignePolygonaleAncetre.call(this, listeProprietaire);else CLignePolygonaleAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, colPoints);
	}
	CLigneBrisee.prototype = new CLignePolygonaleAncetre();
	CLigneBrisee.prototype.constructor = CLigneBrisee;
	CLigneBrisee.prototype.superClass = "CLignePolygonaleAncetre";
	CLigneBrisee.prototype.className = "CLigneBrisee";
	
	CLigneBrisee.prototype.getClone = function (listeSource, listeCible) {
	  var colClone = new Array(this.nombrePoints);
	  for (var i = 0; i < this.nombrePoints; i++) {
	    var noeud = this.colPoints[i];
	    colClone[i] = noeud.getClone(listeSource, listeCible);
	  }
	  var ind1 = listeSource.indexOf(this.impProto);
	  return new CLigneBrisee(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, colClone);
	};
	CLigneBrisee.prototype.abscisseMinimale = function () {
	  return 0;
	};
	CLigneBrisee.prototype.abscisseMaximale = function () {
	  return 1;
	};
	CLigneBrisee.prototype.getNature = function () {
	  return NatObj.NLigneBrisee;
	};
	CLigneBrisee.prototype.confonduAvec = function (p) {
	  var ptp1, ptp2, i;
	
	  if (p.className !== "CLigneBrisee") return false;
	
	  var nombrePoints = this.nombrePoints;
	  if (nombrePoints !== p.nombrePoints) return false;
	  // On regarde si une ligne brisée formée des mêmes points
	  // a déjà été crée dans le même sens
	  var confondu = true;
	  for (i = 0; i < this.nombrePoints; i++) {
	    ptp1 = this.colPoints[i].pointeurSurPoint;
	    ptp2 = this.colPoints[i].pointeurSurPoint;
	    confondu = confondu && ptp1 === ptp2;
	  }
	  // ou dans le sens inverse
	  if (!confondu) {
	    confondu = true;
	    for (i = 0; i < nombrePoints; i++) {
	      ptp1 = this.colPoints[i].pointeurSurPoint;
	      ptp2 = p.collectionPoints[nombrePoints - i - 1].pointeurSurPoint;
	      confondu = confondu && ptp1 === ptp2;
	    }
	  }
	  return confondu;
	};
	CLigneBrisee.prototype.createg = function () {
	  var points = "";
	  // Pour un polygone, le dernier point est le même que le premier mais pas pour svg
	  for (var i = 0; i < this.nombrePoints; i++) {
	    points += this.abscissesCoordonneesPoints[i] + "," + this.ordonneesCoordonneesPoints[i] + " ";
	  }
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  // style += "stroke:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	  style += "stroke:" + this.color + ";";
	  style += "fill:none";
	  return kernel.cens("polyline", {
	    points: points,
	    style: style,
	    "pointer-events": "none"
	  });
	};
	// Version JavaScript : trace est spécifique pour CPolygone et CLigneBrisee
	CLigneBrisee.prototype.trace = function (svg, couleurFond, transparence) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CLigneBrisee.prototype.update = function (svg) {
	  var oldg = this.g;
	  var g = this.createg();
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CLigneBrisee.prototype.chaineDesignation = function () {
	  return "desLigneBrisee";
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CElementLigne = __webpack_require__(77);
	var CSegment = __webpack_require__(134);
	var CNoeudPointeurSurPoint = __webpack_require__(65);
	var CPointBase = __webpack_require__(85);
	module.exports = CLignePolygonaleAncetre;
	
	/**
	 * Classe ancetre des lignes brisées et polygones.
	 * @constructor
	 * @extends CElementLigne
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style du tracé.
	 * @param {Array} colPoints :  Tableau de CNoeudPointeurSurPoint qui donne les sommets.
	 * @returns {CLignePolygonaleAncetre}
	 */
	function CLignePolygonaleAncetre(listeProprietaire, impProto, estElementFinal, couleur, masque, style, colPoints) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	      CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 16, style);
	      this.colPoints = colPoints;
	      this.nombrePoints = colPoints.length;
	      this.abscissesCoordonneesPoints = new Array(this.nombrePoints);
	      this.ordonneesCoordonneesPoints = new Array(this.nombrePoints);
	    }
	    this.point1 = new CPointBase();
	    this.point2 = new CPointBase();
	    this.segment = new CSegment(this.point1, this.point2);
	  }
	}
	CLignePolygonaleAncetre.prototype = new CElementLigne();
	CLignePolygonaleAncetre.prototype.constructor = CLignePolygonaleAncetre;
	CLignePolygonaleAncetre.prototype.superClass = "CElementLigne";
	CLignePolygonaleAncetre.prototype.className = "CLignePolygonaleAncetre";
	
	/**
	 * Création des tableaux qui contiendront les coordonnées des sommets.
	 * @returns {undefined}
	 */
	CLignePolygonaleAncetre.prototype.prepareTableauxCoordonnees = function () {
	  this.nombrePoints = this.colPoints.length;
	  this.abscissesCoordonneesPoints = new Array(this.nombrePoints);
	  this.ordonneesCoordonneesPoints = new Array(this.nombrePoints);
	};
	CLignePolygonaleAncetre.prototype.setClone = function (ptel) {
	  CElementLigne.prototype.setClone.call(this, ptel);
	  this.nombrePoints = ptel.nombrePoints;
	  for (var i = 0; i < this.colPoints.length; i++) {
	    this.abscissesCoordonneesPoints[i] = ptel.abscissesCoordonneesPoints[i];
	    this.ordonneesCoordonneesPoints[i] = ptel.ordonneesCoordonneesPoints[i];
	  }
	};
	CLignePolygonaleAncetre.prototype.dependDePourBoucle = function (p) {
	  var resultat = p === this;
	  for (var i = 0; i < this.colPoints.length && !resultat; i++) {
	    var ptp = this.colPoints[i].pointeurSurPoint;
	    resultat = resultat || ptp.dependDePourBoucle(p);
	  }
	  return resultat;
	};
	CLignePolygonaleAncetre.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  var resultat = CElementLigne.prototype.dependDe.call(this, p);
	  for (var i = 0; i < this.colPoints.length && !resultat; i++) {
	    var ptp = this.colPoints[i].pointeurSurPoint;
	    resultat = resultat || ptp.dependDe(p);
	  }
	  return this.memoriseDependance(resultat);
	};
	CLignePolygonaleAncetre.prototype.positionne = function (infoRandom, dimfen) {
	  // Rajouté pour la version 1.9.5 car Trace ne doit plus faire référence à des pointeurs
	  this.existe = true;
	  for (var i = 0; i < this.nombrePoints; i++) {
	    var ptp = this.colPoints[i].pointeurSurPoint;
	    this.existe = this.existe && ptp.existe;
	    if (!this.existe) return;
	    this.existe = this.existe && !ptp.horsEcran;
	    if (this.existe) {
	      // Différence par rapport à Java : coordonnées pas forcément entières
	      this.abscissesCoordonneesPoints[i] = ptp.x;
	      this.ordonneesCoordonneesPoints[i] = ptp.y;
	    } else return;
	  } // while
	};
	/**
	 * Renvoie une chaînede caractères formée des noms des sommets
	 * @returns {CElementLigne.nomSommets.stb|String}
	 */
	CLignePolygonaleAncetre.prototype.nomSommets = function () {
	  var stb = "";
	  for (var i = 0; i < this.colPoints.length; i++) {
	    stb += this.colPoints[i].pointeurSurPoint.nom;
	  }return stb;
	};
	CLignePolygonaleAncetre.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  for (var i = 0; i < this.nombrePoints; i++) {
	    this.colPoints[i].remplacePoint(ancienPoint, nouveauPoint);
	  }
	};
	CLignePolygonaleAncetre.prototype.read = function (inps, list) {
	  CElementLigne.prototype.read.call(this, inps, list);
	  this.nombrePoints = inps.readInt();
	  this.colPoints = new Array(this.nombrePoints);
	  for (var i = 0; i < this.nombrePoints; i++) {
	    var noeud = new CNoeudPointeurSurPoint();
	    noeud.read(inps, list);
	    this.colPoints[i] = noeud;
	  }
	  // Modification pour la version 2.5.
	  // Certaines choses pas à faire pour le chargement d'un prototype
	  if (list.className !== "CPrototype") this.prepareTableauxCoordonnees();
	};
	CLignePolygonaleAncetre.prototype.write = function (oups, list) {
	  CElementLigne.prototype.write.call(this, oups, list);
	  oups.writeInt(this.nombrePoints);
	  for (var i = 0; i < this.nombrePoints; i++) {
	    this.colPoints[i].write(oups, list);
	  }
	};

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Vect = __webpack_require__(12);
	var CElementBase = __webpack_require__(33);
	var CValDyn = __webpack_require__(29);
	module.exports = CLongueur;
	
	/**
	 * Classe repréésentant une mesure de longueur dans la figure.
	 * Si c'est la longueur unité de la figure, this.listeProprietaire.pointeurLongueurUnite
	 * pointe sur cet objet et la valeur renvoyée est 1.
	 * @constructor
	 * @extends CValDyn
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} point1 : Première extrémité du segment mesuré.
	 * @param {CPt} point2 : Deuxième extrémité du segment mesuré.
	 * @returns {CLongueur}
	 */
	function CLongueur(listeProprietaire, impProto, estElementFinal, point1, point2) {
	  if (arguments.length === 1) CElementBase.call(this, listeProprietaire);else {
	    CElementBase.call(this, listeProprietaire, impProto, estElementFinal);
	    this.point1 = point1;
	    this.point2 = point2;
	  }
	}
	CLongueur.prototype = new CValDyn();
	CLongueur.prototype.constructor = CLongueur;
	CLongueur.prototype.superClass = "CValDyn";
	CLongueur.prototype.className = "CLongueur";
	
	CLongueur.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.point1);
	  var ind2 = listeSource.indexOf(this.point2);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CLongueur(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt.class"));
	};
	CLongueur.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureLongueur;
	};
	CLongueur.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.point1);
	  liste.add(this.point2);
	};
	CLongueur.prototype.setClone = function (ptel) {
	  this.longueur = ptel.longueur;
	};
	CLongueur.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  var resultat = CValDyn.prototype.dependDe.call(this, p) || this.point1.dependDe(p) || this.point2.dependDe(p);
	  if (this.listeProprietaire.pointeurLongueurUnite === this || this.listeProprietaire.pointeurLongueurUnite === null) return this.memoriseDependance(resultat);else return this.memoriseDependance(resultat || this.listeProprietaire.pointeurLongueurUnite.dependDe(p));
	};
	CLongueur.prototype.dependDePourBoucle = function (p) {
	  var resultat = p === this || this.point1.dependDePourBoucle(p) || this.point2.dependDePourBoucle(p);
	  if (this.listeProprietaire.pointeurLongueurUnite === this || this.listeProprietaire.pointeurLongueurUnite === null) return resultat;else return resultat || this.listeProprietaire.pointeurLongueurUnite.dependDePourBoucle(p);
	};
	CLongueur.prototype.nomIndispensable = function (el) {
	  return el === this.point1 || el === this.point2;
	};
	CLongueur.prototype.rendLongueur = function () {
	  var u = new Vect(this.point1, this.point2);
	  return u.norme();
	};
	CLongueur.prototype.positionne = function (infoRandom, dimfen) {
	  var pLongUnite, longueurUnite, u;
	  pLongUnite = this.listeProprietaire.pointeurLongueurUnite;
	  if (this === pLongUnite) {
	    this.existe = this.point1.existe && this.point2.existe && this.rendLongueur() !== 0;
	    this.longueur = 1;
	    return;
	  }
	  this.existe = this.point1.existe && this.point2.existe && pLongUnite.existe;
	  if (!this.existe) return;
	  longueurUnite = pLongUnite.rendLongueur();
	  if (longueurUnite === 0) {
	    this.existe = false;
	    return;
	  }
	  u = new Vect(this.point1, this.point2);
	  this.longueur = u.norme() / longueurUnite;
	};
	CLongueur.prototype.rendValeur = function () {
	  return this.longueur;
	};
	CLongueur.prototype.chaineCommenceParNom = function (pChaine, longueurNom) {
	  // Pour une longueur AB par exemple, le nom BA est équivalent
	  if (CValDyn.prototype.chaineCommenceParNom.call(this, pChaine, longueurNom)) {
	    return true;
	  } else {
	    var chaineNom = this.point2.nom + this.point1.nom;
	    longueurNom.x = chaineNom.length;
	    var longueurChaine2 = pChaine.length;
	    if (longueurChaine2 < longueurNom.x) return false;else return chaineNom === pChaine.substring(0, longueurNom.x);
	  }
	};
	CLongueur.prototype.chaineEgaleANom = function (ch) {
	  if (CValDyn.prototype.chaineEgaleANom.call(this, ch)) return true;
	  var ch2 = this.point2.rendNom() + this.point1.rendNom();
	  return ch === ch2;
	};
	CLongueur.prototype.getNom = function () {
	  return this.point1.nom + this.point2.nom;
	};
	CLongueur.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.point1 === p.point1 && this.point2 === p.point2 || this.point2 === p.point1 && this.point1 === p.point2;
	  } else return false;
	};
	CLongueur.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.point1 === ancienPoint) this.point1 = nouveauPoint;
	  if (this.point2 === ancienPoint) this.point2 = nouveauPoint;
	};
	/**
	 *
	 * Renvoie true si le nom de la valeur commence par la chaîne st
	 * @param st
	 * @return
	 */
	CLongueur.prototype.nomCommencePar = function (st) {
	  if (CValDyn.prototype.nomCommencePar.call(this, st)) return true;
	  var ch = this.point2.nom + this.point1.nom;
	  return ch.indexOf(st) === 0;
	};
	
	CLongueur.prototype.read = function (inps, list) {
	  CValDyn.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.point1 = list.get(ind1, "CPt");
	  this.point2 = list.get(ind2, "CPt");
	  if (list.pointeurLongueurUnite === null) list.pointeurLongueurUnite = this;
	};
	CLongueur.prototype.write = function (oups, list) {
	  CValDyn.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.point1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.point2);
	  oups.writeInt(ind2);
	};

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var StyleEncadrement = __webpack_require__(38);
	var CAffichageLieAPoint = __webpack_require__(36);
	var CLatex = __webpack_require__(40);
	module.exports = CMacro;
	
	/**
	 * Classe ancêtre de toutes les macros.
	 * @constructor
	 * @extends CAffichageLieAPoint
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @returns {CMacro}
	 */
	function CMacro(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CAffichageLieAPoint.call(this, listeProprietaire);else {
	      CAffichageLieAPoint.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, StyleEncadrement.Effet3D, effacementFond, couleurFond, alignementHorizontal, alignementVertical);
	      this.intitule = intitule;
	      this.commentaireMacro = commentaireMacro;
	      this.macroLanceuse = null; // Ajout version 5.1
	    }
	    this.executionEnCours = false;
	  }
	}
	CMacro.prototype = new CAffichageLieAPoint();
	CMacro.prototype.constructor = CMacro;
	CMacro.prototype.superClass = "CAffichageLieAPoint";
	CMacro.prototype.className = "CMacro";
	
	CMacro.sansAnimation = 0;
	CMacro.animationParTimer = 1;
	CMacro.animationParThread = 2;
	
	CMacro.prototype.getNature = function () {
	  return NatObj.NMacro;
	};
	CMacro.prototype.execute = function () {
	  this.executionEnCours = true;
	};
	// Ajout version 5.1
	/**
	 * Fonction servant à informer une macro qu'elle est lancée par une macro
	 * mac qui est nécessairement une CMacroSuiteMacro
	 * Sert lors de l'éxécution d'une macro enchaînant d'autres macros qui peuvent elles
	 * mêmes être des macros enchaînant d'autres macros.
	 * @param {type} mac
	 * @returns {undefined}
	 */
	CMacro.prototype.setMacroLanceuse = function (mac) {
	  this.macroLanceuse = mac;
	};
	CMacro.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  this.executionEnCours = false;
	  /* Modifié version 5.1
	  var mac = this.listeProprietaire.macroEnCours;
	  if ((mac !== null) && (mac.className === "CMacroSuiteMacros")) {
	    this.listeProprietaire .macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	  }
	  else this.listeProprietaire.macroEnCours = null;
	  */
	  if (this.macroLanceuse !== null) {
	    this.macroLanceuse.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	  } else this.listeProprietaire.macroEnCours = null;
	};
	CMacro.prototype.passageMacroSuiv = function (svg, dimf, couleurFond, transparence) {
	  /* Modification version 5.1
	  if (this.listeProprietaire.macroEnCours.className === "CMacroSuiteMacros") {
	    this.listeProprietaire.macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	  }
	  else this.listeProprietaire.macroEnCours = null;
	  */
	  if (this.macroLanceuse === null) {
	    this.listeProprietaire.macroEnCours = null;
	  } else {
	    this.macroLanceuse.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	  }
	};
	/**
	 * Fonctions à définir pour les descendants remettant à jour les listes
	 * utilisées par la macro.
	 * @returns {undefined}
	 */
	CMacro.prototype.etablitListesInternes = function () {};
	/* Pas utlisé pour le moment
	CMacro.prototype.trace = function(svg, couleurFond, transparence) {
	  // Les macros qui sont masquées ne doivent pas êre affichées quand on active l'iutil rideau
	  // de démasquage d'objet
	  if (this.masque) return;
	  CAffichageLieAPoint.prototype.trace.call(this, svg, couleurFond, transparence);
	}
	*/
	CMacro.prototype.rendChaineAffichage = function () {
	  var len = this.intitule.length;
	  if (this.intitule.charAt(0) === "$") {
	    if (this.intitule.charAt(this.len - 1) === "$") {
	      return "$\\Rightarrow " + this.intitule.substring(1, len - 1) + "$";
	    }
	  }
	  return "⇒" + this.intitule;
	};
	/**
	 * MacroEnCours renvoie this excepté pour les macros de type CMacroSuiteMacro
	 * @returns {CMacro.prototype}
	 */
	CMacro.prototype.macroEnCours = function () {
	  return this;
	};
	/**
	 * envoie le type d'animation utilisé par la macro quand elle est exécutée.
	 * Voir les types définis dans les premières lignes.
	 * @returns {Number}
	 */
	CMacro.prototype.typeAnimation = function () {
	  return CMacro.sansAnimation;
	};
	/**
	 * Renvoie la fréquence d'animation pour les macros d'animation.
	 * Doit être redéfini pour les macros utilisant une animation
	 * @returns {Number}
	 */
	CMacro.prototype.frequenceAnimation = function () {
	  return 0;
	};
	/**
	 * Renvoie true si l'exécution de la macro est possible.
	 * @returns {Boolean}
	 */
	CMacro.prototype.executionPossible = function () {
	  return true;
	};
	/**
	 * Fonction renvoyant true si la macro est prévue pour être arrêtée par un clic de souris.
	 * Si la réponse est true et si la macro est contneue dans une macro exécutant une suite de macros
	 * un clic de souris fera passer à la macro suivante.
	 * @returns {Boolean}
	 */
	CMacro.prototype.arretParClic = function () {
	  return false;
	};
	/**
	 * Renvoie faux par défaut. A redéfinir pour les descendants agissant sur une variable.
	 * @param {type} va
	 * @returns {Boolean}
	 */
	CMacro.prototype.agitSurVariable = function (va) {
	  return false;
	};
	/**
	 * Initialise la macro.
	 * @returns {undefined}
	 */
	CMacro.prototype.initialise = function () {
	  // Ajout version 5.1
	  this.listeProprietaire.macroEnCours = this;
	  //
	};
	/**
	 * Renvoie true si la macro affecte val ou un calcul dépendant de val à une variable.
	 * A redéfinir pour les macros d'affectation de valeur à variable, de modification de variable
	 * et d'exécution d'une suite de macros
	 * @param {type} val
	 * @returns {Boolean}
	 */
	CMacro.prototype.affecteValeurAVariable = function (val) {
	  return false;
	};
	/**
	 * Fonction à redéfinir pour les macros pouvant être exécutées en début ou fin de boucle
	 * pour les macros de boucle. Doit exécuter la macro mais sans action graphique sur la figure.
	 * @param {type} dimf
	 * @returns {undefined}
	 */
	CMacro.prototype.executeSimple = function (dimf) {};
	CMacro.prototype.chaineDesignation = function () {
	  return "desMacro";
	};
	CMacro.prototype.read = function (inps, list) {
	  CAffichageLieAPoint.prototype.read.call(this, inps, list);
	  this.intitule = CLatex.traiteAccents(inps.readUTF());
	  this.commentaireMacro = inps.readUTF();
	  this.macroLanceuse = null; // Ajout version 5.1
	};
	CMacro.prototype.write = function (oups, list) {
	  CAffichageLieAPoint.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.intitule);
	  oups.writeUTF(this.commentaireMacro);
	};

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacro = __webpack_require__(157);
	module.exports = CMacroAffectationPointLie;
	
	/**
	 * Macro envoyant un point lié sur un autre point lié au même objet.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {type} pointLieAPositionner
	 * @param {type} pointLieAssocie
	 * @returns {CMacroAffectationPointLie}
	 */
	function CMacroAffectationPointLie(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, pointLieAPositionner, pointLieAssocie) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	      this.pointLieAPositionner = pointLieAPositionner;
	      this.pointLieAssocie = pointLieAssocie;
	    }
	  }
	}
	CMacroAffectationPointLie.prototype = new CMacro();
	CMacroAffectationPointLie.prototype.constructor = CMacroAffectationPointLie;
	CMacroAffectationPointLie.prototype.superClass = "CMacro";
	CMacroAffectationPointLie.prototype.className = "CMacroAffectationPointLie";
	
	CMacroAffectationPointLie.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLieAPositionner);
	  var ind2 = listeSource.indexOf(this.pointLieAssocie);
	  var ind3 = listeSource.indexOf(this.pointLie);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CMacroAffectationPointLie(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind3, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeCible.get(ind1, "CPointLie"), listeCible.get(ind2, "CPointLie"));
	};
	CMacroAffectationPointLie.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMacro.prototype.dependDe.call(this, p) || this.pointLieAPositionner.dependDe(p) || this.pointLieAssocie.dependDe(p));
	};
	CMacroAffectationPointLie.prototype.dependDePourBoucle = function (p) {
	  return CMacro.prototype.dependDePourBoucle.call(this, p) || this.pointLieAPositionner.dependDePourBoucle(p) || this.pointLieAssocie.dependDePourBoucle(p);
	};
	CMacroAffectationPointLie.prototype.executionPossible = function () {
	  return this.pointLieAPositionner.existe && this.pointLieAssocie.existe;
	};
	CMacroAffectationPointLie.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.pointLieAPositionner.donneAbscisse(this.pointLieAssocie.abscisse);
	  this.listeProprietaire.positionne(false, dimf);
	  this.listeProprietaire.update(svg, couleurFond, transparence, true);
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroAffectationPointLie.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointLieAssocie === ancienPoint) this.pointLieAssocie = nouveauPoint;
	  if (this.pointLieAPositionner === ancienPoint) this.pointLieAPositionner = nouveauPoint;
	};
	CMacroAffectationPointLie.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.pointLieAPositionner);
	  liste.add(this.pointLieAssocie);
	};
	CMacroAffectationPointLie.prototype.read = function (inps, list) {
	  CMacro.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.pointLieAPositionner = list.get(ind1, "CPointLie");
	  var ind2 = inps.readInt();
	  this.pointLieAssocie = list.get(ind2, "CPointLie");
	};
	CMacroAffectationPointLie.prototype.write = function (oups, list) {
	  CMacro.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.pointLieAPositionner);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.pointLieAssocie);
	  oups.writeInt(ind2);
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	var CValeur = __webpack_require__(80);
	module.exports = CMacroAffectationValeurVariable;
	
	/**
	 * Macro affectant une valeur à une variable.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CValeur} valeurAssociee : La valeur à affecter à la variable.
	 * @param {CVariableBornee} variableAssociee : La variable à laquelle on affecte la valeur.
	 * @returns {CMacroAffectationValeurVariable}
	 */
	function CMacroAffectationValeurVariable(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, valeurAssociee, variableAssociee) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	      this.valeurAssociee = valeurAssociee;
	      this.variableAssociee = variableAssociee;
	    }
	  }
	  this.listeDep = new CListeObjets();
	}
	CMacroAffectationValeurVariable.prototype = new CMacro();
	CMacroAffectationValeurVariable.prototype.constructor = CMacroAffectationValeurVariable;
	CMacroAffectationValeurVariable.prototype.superClass = "CMacro";
	CMacroAffectationValeurVariable.prototype.className = "CMacroAffectationValeurVariable";
	
	CMacroAffectationValeurVariable.prototype.getClone = function (listeSource, listeCible) {
	  var valeurClone = this.valeurAssociee.getClone(listeSource, listeCible);
	  var ind1 = listeSource.indexOf(this.variableAssociee);
	  var ind2 = listeSource.indexOf(this.pointLie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  this.listeDep.initialise(listeCible.uniteAngle, listeCible.pointeurLongueurUnite);
	  return new CMacroAffectationValeurVariable(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind2, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, valeurClone, listeCible.get(ind1, "CVariableBornee"));
	};
	CMacroAffectationValeurVariable.prototype.initialisePourDependance = function () {
	  CMacro.prototype.initialisePourDependance.call(this);
	  this.valeurAssociee.initialisePourDependance();
	};
	CMacroAffectationValeurVariable.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMacro.prototype.dependDe.call(this, p) || this.variableAssociee.dependDe(p) || this.valeurAssociee.dependDe(p));
	};
	CMacroAffectationValeurVariable.prototype.dependDePourBoucle = function (p) {
	  return CMacro.prototype.dependDePourBoucle.call(this, p) || this.variableAssociee.dependDePourBoucle(p) || this.valeurAssociee.dependDePourBoucle(p);
	};
	CMacroAffectationValeurVariable.prototype.positionne = function (infoRandom, dimfen) {
	  CMacro.prototype.positionne.call(this, infoRandom, dimfen);
	  this.valeurAssociee.positionne(infoRandom, dimfen);
	  this.existe = this.existe && this.valeurAssociee.existe;
	};
	CMacroAffectationValeurVariable.prototype.agitSurVariable = function (va) {
	  return va === this.variableAssociee;
	};
	CMacroAffectationValeurVariable.prototype.affecteValeurAVariable = function (val) {
	  return this.valeurAssociee.calcul.dependDe(val);
	};
	CMacroAffectationValeurVariable.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.valeurAssociee.positionne(false, dimf);
	  var resultatValeur = this.valeurAssociee.rendValeur();
	  this.variableAssociee.donneValeur(resultatValeur);
	  this.executionEnCours = false;
	  this.listeDep.positionne(false, dimf);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  this.variableAssociee.updateDisplay(); // Pour les variables auxquelles sont associées un dialogue
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroAffectationValeurVariable.prototype.executeSimple = function (dimf) {
	  this.valeurAssociee.positionne(true, dimf);
	  var resultatValeur = this.valeurAssociee.rendValeur();
	  this.variableAssociee.donneValeur(resultatValeur);
	};
	CMacroAffectationValeurVariable.prototype.executionPossible = function () {
	  var resultat = this.valeurAssociee.existe && this.variableAssociee.existe;
	  if (resultat) {
	    var nouvelleValeur = this.valeurAssociee.rendValeur();
	    resultat = nouvelleValeur >= this.variableAssociee.valeurMini && nouvelleValeur <= this.variableAssociee.valeurMaxi;
	  }
	  return resultat;
	};
	CMacroAffectationValeurVariable.prototype.etablitListesInternes = function () {
	  this.listeDep = new CListeObjets(this.listeProprietaire.uniteAngle, this.listeProprietaire.pointeurLongueurUnite);
	  this.listeDep.ajouteObjetsDependantsSauf(this.variableAssociee, this.listeProprietaire, this);
	};
	CMacroAffectationValeurVariable.prototype.metAJour = function () {
	  this.etablitListesInternes();
	};
	CMacroAffectationValeurVariable.prototype.read = function (inps, list) {
	  CMacro.prototype.read.call(this, inps, list);
	  this.valeurAssociee = new CValeur();
	  this.valeurAssociee.read(inps, list);
	  var ind1 = inps.readInt();
	  this.variableAssociee = list.get(ind1, "CVariableBornee");
	  this.listeDep = new CListeObjets(list.uniteAngle, list.pointeurLongueurUnite);
	};
	CMacroAffectationValeurVariable.prototype.write = function (oups, list) {
	  CMacro.prototype.write.call(this, oups, list);
	  this.valeurAssociee.write(oups, list);
	  var ind1 = list.indexOf(this.variableAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacro = __webpack_require__(157);
	module.exports = CMacroAffichantTout;
	
	/**
	 * Macro recalculant la figure en réinitialisant les caluls aléatoires avec rand()
	 * et la réaffichant.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @returns {CMacroAffichantTout}
	 */
	function CMacroAffichantTout(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	    }
	  }
	}
	CMacroAffichantTout.prototype = new CMacro();
	CMacroAffichantTout.prototype.constructor = CMacroAffichantTout;
	CMacroAffichantTout.prototype.superClass = "CMacro";
	CMacroAffichantTout.prototype.className = "CMacroAffichantTout";
	
	CMacroAffichantTout.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CMacroAffichantTout(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFondAffichage, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro);
	};
	CMacroAffichantTout.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.listeProprietaire.deleteTraces();
	  this.listeProprietaire.positionne(true, dimf);
	  this.listeProprietaire.update(svg, couleurFond, transparence, true);
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	var CSousListeObjets = __webpack_require__(66);
	var CMacroAvecListe = __webpack_require__(162);
	module.exports = CMacroAnimationAvecTrace;
	
	/**
	 * Macro d'animation générée par point lié avec trace.
	 * Les objets devant laisser une trace sont contenus dans une liste.
	 * @constructor
	 * @extends CMacroAvecListe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : La liste contenant les objets qui laissent une trace.
	 * @param {mtg32.CPoinLie} pointLieAssocie : Le point lié dont les positions génèrent la trace.
	 * @param {Boolean} unCycle : Si true l'animation se fait sur un seul cycle et s'arrête.
	 * @param {Boolean} effacementFinCycle : si true les traces d'objets sont effacées à la fin de chaque cycle.
	 * @param {Boolean} animationCyclique : true si animation cyclique (si non cyclique on repart au début).
	 * @param {Integer} frequenceAnimationMacro : La fréquence d'animation en millièmes de seconde.
	 * @param {Integer} nombrePointsPourAnimation
	 * @param {Integer} dureeAnimation : Durée de l'animation en dixièmes de seconde ou null pour une animation
	 * continue (dans ce cas un clic sur l'intitulé arrête l'animation).
	 * @param {Boolean} retourDepart : trus pour que le point lié reviene à son point de départ à la fin de l'animation.
	 * @param {Boolean} inverserSens : true pour que l'animation se fasse dans l'autre sens (Le sens usuel sur les cercles est
	 * le sens trigonométrique direct).
	 * @returns {CMacroAnimationAvecTrace}
	 */
	function CMacroAnimationAvecTrace(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee, pointLieAssocie, unCycle, effacementFinCycle, animationCyclique, frequenceAnimationMacro, nombrePointsPourAnimation, dureeAnimation, retourDepart, inverserSens) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	      this.pointLieAssocie = pointLieAssocie;
	      this.unCycle = unCycle;
	      this.effacementFinCycle = effacementFinCycle;
	      this.animationCyclique = animationCyclique;
	      this.frequenceAnimationMacro = frequenceAnimationMacro;
	      this.nombrePointsPourAnimation = nombrePointsPourAnimation;
	      this.dureeAnimation = dureeAnimation;
	      this.retourDepart = retourDepart;
	      this.inverserSens = inverserSens;
	      this.listeDep = new CListeObjets(listeProprietaire);
	    }
	  }
	}
	
	CMacroAnimationAvecTrace.prototype = new CMacroAvecListe();
	CMacroAnimationAvecTrace.prototype.constructor = CMacroAnimationAvecTrace;
	CMacroAnimationAvecTrace.prototype.superClass = "CMacroAvecListe";
	CMacroAnimationAvecTrace.prototype.className = "CMacroAnimationAvecTrace";
	
	CMacroAnimationAvecTrace.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CMacroAnimationAvecTrace.prototype.getClone = function (listeSource, listeCible) {
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  var ind1 = listeSource.indexOf(this.pointLieAssocie);
	  var ind2 = listeSource.indexOf(this.pointLie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var ptelb = new CMacroAnimationAvecTrace(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind2, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone, listeCible.get(ind1, "CPointLie"), this.unCycle, this.effacementFinCycle, this.animationCyclique, this.frequenceAnimationMacro, this.nombrePointsPourAnimation, this.dureeAnimation, this.retourDepart, this.inverserSens);
	  // ptelb.listeDep = new CListeObjets(listeCible);
	  return ptelb;
	};
	CMacroAnimationAvecTrace.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMacroAvecListe.prototype.dependDe.call(this, p) || this.pointLieAssocie.dependDe(p));
	};
	CMacroAnimationAvecTrace.prototype.dependDePourBoucle = function (p) {
	  return CMacroAvecListe.prototype.dependDePourBoucle.call(this, p) || this.pointLieAssocie.dependDePourBoucle(p);
	};
	CMacroAnimationAvecTrace.prototype.typeAnimation = function () {
	  return CMacro.animationParTimer;
	};
	CMacroAnimationAvecTrace.prototype.arretParClic = function () {
	  return this.dureeAnimation === 0 || this.unCycle;
	};
	CMacroAnimationAvecTrace.prototype.metAJour = function () {
	  CMacroAvecListe.prototype.metAJour.call(this);
	  this.etablitListesInternes();
	};
	CMacroAnimationAvecTrace.prototype.etablitListesInternes = function () {
	  this.listeDep.retireTout();
	  this.listeDep.ajouteObjetsDependantsSauf(this.pointLieAssocie, this.listeProprietaire, this);
	};
	CMacroAnimationAvecTrace.prototype.executionPossible = function () {
	  return this.pointLieAssocie.existe;
	};
	CMacroAnimationAvecTrace.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.pointLieAssocie);
	  liste.ajouteElementsDe(this.listeAssociee);
	};
	CMacroAnimationAvecTrace.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointLieAssocie === ancienPoint) this.pointLieAssocie = nouveauPoint;
	};
	CMacroAnimationAvecTrace.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.listeProprietaire.initialiseTraces();
	  this.abscisseInitiale = this.pointLieAssocie.abscisse;
	  this.abscisseMini = this.pointLieAssocie.abscisseMinimale();
	  this.abscisseMaxi = this.pointLieAssocie.abscisseMaximale();
	  if (this.abscisseMini > this.abscisseMaxi) {
	    var d = this.abscisseMini;
	    this.abscisseMini = this.abscisseMaxi;
	    this.abscisseMaxi = d;
	  }
	  this.pas = (this.abscisseMaxi - this.abscisseMini) / (this.nombrePointsPourAnimation - 1);
	  if (this.inverserSens) this.pas = -this.pas;
	  this.abscisse = this.unCycle ? this.inverserSens ? this.abscisseMaxi - this.pas : this.abscisseMini - this.pas : this.abscisseMini - this.pas;
	
	  this.executionEnCours = true;
	  var timeDebut = +new Date();
	  if (this.unCycle) this.timeFin = timeDebut + 100000000;else if (this.dureeAnimation !== 0) this.timeFin = timeDebut + this.dureeAnimation * 100; // La durée est en dixièmes de secondes
	  var t = this;
	  this.timer = setInterval(function () {
	    CMacroAnimationAvecTrace.executePourTimer.call(t, svg, dimf, couleurFond, transparence);
	  }, this.frequenceAnimationMacro);
	};
	/**
	 * Fonction de callBack appelée par un timer dans execute()
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroAnimationAvecTrace.executePourTimer = function (svg, dimf, couleurFond, transparence) {
	  var d;
	  if (!this.executionEnCours) return;
	  this.abscisse = this.abscisse + this.pas;
	  if (kernel.zero13(this.abscisse - this.abscisseMaxi)) this.abscisse = this.abscisseMaxi;else if (kernel.zero13(this.abscisse - this.abscisseMini)) this.abscisse = this.abscisseMini;
	  if (this.unCycle) {
	    d = this.inverserSens ? this.abscisse - this.abscisseMini : this.abscisse - this.abscisseMaxi;
	    if (this.inverserSens) {
	      if (d < 0) {
	        this.timeFin = 0;
	        this.abscisse = this.abscisseMini;
	      }
	    } else if (d > 0) {
	      this.abscisse = this.abscisseMaxi;
	      this.timeFin = 0;
	    }
	  } else {
	    if (this.animationCyclique) {
	      if (this.inverserSens) {
	        if (this.abscisse < this.abscisseMini) {
	          this.abscisse = this.abscisseMaxi;
	          if (this.effacementFinCycle) this.effacementTraces = true;
	        }
	      } else if (this.abscisse > this.abscisseMaxi) {
	        this.abscisse = this.abscisseMini;
	        if (this.effacementFinCycle) this.effacementTraces = true;
	      }
	    } else {
	      if (this.abscisse < this.abscisseMini) {
	        this.pas = -this.pas;
	        this.abscisse = this.abscisseMini;
	        if (this.effacementFinCycle) this.effacementTraces = true;
	      } else if (this.abscisse > this.abscisseMaxi) {
	        this.pas = -this.pas;
	        this.abscisse = this.abscisseMaxi;
	        if (this.effacementFinCycle) this.effacementTraces = true;
	      }
	    }
	  }
	  if (this.effacementTraces) {
	    this.listeProprietaire.deleteTraces();
	    this.effacementTraces = false;
	  }
	  this.pointLieAssocie.donneAbscisse(this.abscisse);
	  // On déplace le point lié vers sa nouvelle position
	  this.listeDep.positionne(false, dimf);
	  this.listeProprietaire.addTraces(this.listeAssociee);
	  // this.listeProprietaire.update(svg, couleurFond, transparence, true); // Modifié version 4.9.2
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  var time = +new Date(); // Raccourci pour (new Date()).getTime()
	  /*
	  if ((this.dureeAnimation !== 0) && (time > this.timeFin))
	    this.termineAction(svg, dimf, couleurFond, transparence);
	    */
	  if (this.unCycle) {
	    if (this.inverserSens) {
	      if (kernel.zero13(this.abscisse - this.abscisseMini) || this.abscisse < this.abscisseMini) this.termineAction(svg, dimf, couleurFond, transparence);
	    } else if (kernel.zero13(this.abscisse - this.abscisseMaxi) || this.abscisse > this.abscisseMaxi) this.termineAction(svg, dimf, couleurFond, transparence);
	  } else if (this.dureeAnimation !== 0 && time > this.timeFin) this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroAnimationAvecTrace.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  if (this.timer !== null) clearInterval(this.timer);
	  this.executionEnCours = false;
	  if (this.retourDepart) this.pointLieAssocie.donneAbscisse(this.abscisseInitiale);
	  this.listeDep.positionne(false, dimf);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  this.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	};
	CMacroAnimationAvecTrace.prototype.read = function (inps, list) {
	  CMacroAvecListe.prototype.read.call(this, inps, list);
	  this.unCycle = inps.readBoolean();
	  this.effacementFinCycle = inps.readBoolean();
	  this.animationCyclique = inps.readBoolean();
	  this.frequenceAnimationMacro = inps.readInt();
	  this.nombrePointsPourAnimation = inps.readInt();
	  this.dureeAnimation = inps.readInt();
	  var ind1 = inps.readInt();
	  this.pointLieAssocie = list.get(ind1, "CPointLie");
	  if (this.nVersion < 2) {
	    this.retourDepart = true;
	    this.inverserSens = false;
	  } else {
	    this.retourDepart = inps.readBoolean();
	    this.inverserSens = inps.readBoolean();
	  }
	  // this.listeDep = new CListeObjets(list.uniteAngle, list.pointeurLongueurUnite);
	  // Pour arrêter la macro quand elle n'effectue qu'un seul cycle
	  // il ne faut pas que dureeAnimation soit nul;
	  if (this.unCycle) this.dureeAnimation = 1;
	  if (list.className !== "CPrototype") this.listeDep = new CListeObjets(this.listeProprietaire);
	};
	CMacroAnimationAvecTrace.prototype.write = function (oups, list) {
	  CMacroAvecListe.prototype.write.call(this, oups, list);
	  oups.writeBoolean(this.unCycle);
	  oups.writeBoolean(this.effacementFinCycle);
	  oups.writeBoolean(this.animationCyclique);
	  oups.writeInt(this.frequenceAnimationMacro);
	  oups.writeInt(this.nombrePointsPourAnimation);
	  oups.writeInt(this.dureeAnimation);
	  var ind1 = list.indexOf(this.pointLieAssocie);
	  oups.writeInt(ind1);
	  oups.writeBoolean(this.retourDepart);
	  oups.writeBoolean(this.inverserSens);
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacro = __webpack_require__(157);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroAvecListe;
	
	/**
	 * Macro ancêtre de toutes les macros utilisant une liste d'objets de façon intene.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : La liste interne utilisée.
	 * @returns {CMacroAvecListe}
	 */
	function CMacroAvecListe(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	      this.listeAssociee = listeAssociee;
	    }
	  }
	}
	CMacroAvecListe.prototype = new CMacro();
	CMacroAvecListe.prototype.constructor = CMacroAvecListe;
	CMacroAvecListe.prototype.superClass = "CMacro";
	CMacroAvecListe.prototype.className = "CMacroAvecListe";
	
	CMacroAvecListe.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMacro.prototype.dependDe.call(this, p) || this.listeAssociee.dependDe(p));
	};
	CMacroAvecListe.prototype.dependDePourBoucle = function (p) {
	  return CMacro.prototype.dependDePourBoucle.call(this, p) || this.listeAssociee.dependDePourBoucle(p);
	};
	CMacroAvecListe.prototype.executionPossible = function () {
	  return this.listeAssociee.existeAuMoinsUnElement();
	};
	CMacroAvecListe.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  this.listeAssociee.remplacePoint(ancienPoint, nouveauPoint);
	};
	CMacroAvecListe.prototype.read = function (inps, list) {
	  CMacro.prototype.read.call(this, inps, list);
	  this.listeAssociee = new CSousListeObjets();
	  this.listeAssociee.read(inps, list);
	};
	CMacroAvecListe.prototype.write = function (oups, list) {
	  CMacro.prototype.write.call(this, oups, list);
	  this.listeAssociee.write(oups, this.listeProprietaire);
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	module.exports = CMacroAnimationPointLie;
	
	/**
	 * Macro d'animation de la igure par les mouvement d'un point lié.
	 * @returns {CMacroAnimationPointLie}
	 */
	/**
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {Boolean} animationCyclique : : true si animation cyclique (si non cyclique on repart au début).
	 * @param {Integer} frequenceAnimationMacro : La fréquence d'animation en millièmes de seconde.
	 * @param {Integer} nombrePointsPourAnimation
	 * @param {Integer} dureeAnimation : Durée de l'animation en dixièmes de seconde ou null pour une animation
	 * @param {CPointLie} pointLieAssocie : Le point lié dont le mouvement génère l'animation.
	 * @param {Boolean} inverserSens : true pour que l'animation se fasse dans l'autre sens (Le sens usuel sur les cercles est
	 * le sens trigonométrique direct).
	 * @param {Boolean} retourDepart : trus pour que le point lié reviene à son point de départ à la fin de l'animation.
	 * @param {Boolean} unCycle : Si true l'animation se fait sur un seul cycle et s'arrête.
	 * @returns {CMacroAnimationPointLie}
	 */
	function CMacroAnimationPointLie(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, animationCyclique, frequenceAnimationMacro, nombrePointsPourAnimation, dureeAnimation, pointLieAssocie, inverserSens, retourDepart, unCycle) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	      this.animationCyclique = animationCyclique;
	      this.frequenceAnimationMacro = frequenceAnimationMacro;
	      this.nombrePointsPourAnimation = nombrePointsPourAnimation;
	      this.dureeAnimation = dureeAnimation;
	      this.pointLieAssocie = pointLieAssocie;
	      this.inverserSens = inverserSens;
	      this.retourDepart = retourDepart;
	      this.unCycle = unCycle;
	      this.listeDep = new CListeObjets(listeProprietaire);
	    }
	  }
	}
	CMacroAnimationPointLie.prototype = new CMacro();
	CMacroAnimationPointLie.prototype.constructor = CMacroAnimationPointLie;
	CMacroAnimationPointLie.prototype.superClass = "CMacro";
	CMacroAnimationPointLie.prototype.className = "CMacroAnimationPointLie";
	
	CMacroAnimationPointLie.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CMacroAnimationPointLie.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLieAssocie);
	  var ind2 = listeSource.indexOf(this.pointLie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CMacroAnimationPointLie(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind2, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, this.animationCyclique, this.frequenceAnimationMacro, this.nombrePointsPourAnimation, this.dureeAnimation, listeCible.get(ind1, "CPointLie"), this.inverserSens, this.retourDepart, this.unCycle);
	};
	CMacroAnimationPointLie.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMacro.prototype.dependDe.call(this, p) || this.pointLieAssocie.dependDe(p));
	};
	CMacroAnimationPointLie.prototype.dependDePourBoucle = function (p) {
	  return CMacro.prototype.dependDePourBoucle.call(this, p) || this.pointLieAssocie.dependDePourBoucle(p);
	};
	CMacroAnimationPointLie.prototype.typeAnimation = function () {
	  return CMacro.animationParTimer;
	};
	CMacroAnimationPointLie.prototype.frequenceAnimation = function () {
	  return this.frequenceAnimationMacro;
	};
	CMacroAnimationPointLie.prototype.arretParClic = function () {
	  return this.dureeAnimation === 0;
	};
	CMacroAnimationPointLie.prototype.metAJour = function () {
	  CMacro.prototype.metAJour.call(this);
	  this.etablitListesInternes();
	};
	CMacroAnimationPointLie.prototype.etablitListesInternes = function () {
	  this.listeDep.retireTout();
	  this.listeDep.ajouteObjetsDependantsSauf(this.pointLieAssocie, this.listeProprietaire, this);
	};
	CMacroAnimationPointLie.prototype.executionPossible = function () {
	  return this.pointLieAssocie.existe;
	};
	CMacroAnimationPointLie.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.pointLieAssocie);
	};
	CMacroAnimationPointLie.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointLieAssocie === ancienPoint) this.pointLieAssocie = nouveauPoint;
	};
	/**
	 * Lance l'exécution de la macro via un timer et une fonction de callBack.
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroAnimationPointLie.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.abscisseInitiale = this.pointLieAssocie.abscisse;
	  this.abscisseMini = this.pointLieAssocie.abscisseMinimale();
	  this.abscisseMaxi = this.pointLieAssocie.abscisseMaximale();
	  if (this.abscisseMini > this.abscisseMaxi) {
	    var d = this.abscisseMini;
	    this.abscisseMini = this.abscisseMaxi;
	    this.abscisseMaxi = d;
	  }
	  // Ligne suivante modifiée pour la version 1.8
	  this.pas = (this.abscisseMaxi - this.abscisseMini) / (this.nombrePointsPourAnimation - 1);
	  if (this.inverserSens) this.pas = -this.pas;
	  this.abscisse = this.unCycle ? this.inverserSens ? this.abscisseMaxi : this.abscisseMini : this.abscisseInitiale;
	  // this.dt = new Date();
	  var timeDebut = +new Date();
	  if (this.dureeAnimation !== 0) this.timeFin = timeDebut + this.dureeAnimation * 100; // La durée est en dixièmes de secondes
	  this.executionEnCours = true;
	  var t = this;
	  this.timer = setInterval(function () {
	    CMacroAnimationPointLie.executePourTimer.call(t, svg, dimf, couleurFond, transparence);
	  }, this.frequenceAnimationMacro);
	};
	/**
	 * Fonction de callBack appelée par un timer dans execute()
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fond de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroAnimationPointLie.executePourTimer = function (svg, dimf, couleurFond, transparence) {
	  if (!this.executionEnCours) return;
	  this.abscisse = this.abscisse + this.pas;
	  if (kernel.zero13(this.abscisse - this.abscisseMaxi)) this.abscisse = this.abscisseMaxi;else if (kernel.zero13(this.abscisse - this.abscisseMini)) this.abscisse = this.abscisseMini;
	
	  if (this.animationCyclique) {
	    if (this.inverserSens) {
	      if (this.abscisse < this.abscisseMini) this.abscisse = this.abscisseMaxi;
	    } else if (this.abscisse > this.abscisseMaxi) this.abscisse = this.abscisseMini;
	  } else {
	    if (this.abscisse > this.abscisseMaxi) {
	      this.pas = -this.pas;
	      this.abscisse = this.abscisseMaxi;
	    } else {
	      if (this.abscisse < this.abscisseMini) {
	        this.pas = -this.pas;
	        this.abscisse = this.abscisseMini;
	      }
	    }
	  }
	  this.pointLieAssocie.donneAbscisse(this.abscisse);
	  this.listeDep.positionne(false, dimf);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  var time = +new Date(); // Raccourci pour (new Date()).getTime()
	  if (this.unCycle) {
	    if (this.inverserSens) {
	      if (kernel.zero13(this.abscisse - this.abscisseMini) || this.abscisse < this.abscisseMini) this.termineAction(svg, dimf, couleurFond, transparence);
	    } else if (kernel.zero13(this.abscisse - this.abscisseMaxi) || this.abscisse > this.abscisseMaxi) this.termineAction(svg, dimf, couleurFond, transparence);
	  } else if (this.dureeAnimation !== 0 && time > this.timeFin) this.termineAction(svg, dimf, couleurFond, transparence);
	};
	/**
	 * Fonction appelée à la fin de l'animation.
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroAnimationPointLie.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  clearInterval(this.timer);
	  this.executionEnCours = false;
	  if (this.retourDepart) this.pointLieAssocie.donneAbscisse(this.abscisseInitiale);
	  this.listeDep.positionne(false, dimf);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  this.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	};
	CMacroAnimationPointLie.prototype.read = function (inps, list) {
	  CMacro.prototype.read.call(this, inps, list);
	  this.animationCyclique = inps.readBoolean();
	  this.frequenceAnimationMacro = inps.readInt();
	  this.nombrePointsPourAnimation = inps.readInt();
	  this.dureeAnimation = inps.readInt();
	  var ind1 = inps.readInt();
	  this.pointLieAssocie = list.get(ind1, "CPointLie");
	  if (this.nVersion < 2) {
	    this.inverserSens = false;
	    this.retourDepart = true;
	    this.unCycle = false;
	  } else {
	    this.inverserSens = inps.readBoolean();
	    this.retourDepart = inps.readBoolean();
	    this.unCycle = inps.readBoolean();
	  }
	  if (list.className !== "CPrototype") this.listeDep = new CListeObjets(this.listeProprietaire);
	};
	CMacroAnimationPointLie.prototype.write = function (oups, list) {
	  CMacro.prototype.write.call(this, oups, list);
	  oups.writeBoolean(this.animationCyclique);
	  oups.writeInt(this.frequenceAnimationMacro);
	  oups.writeInt(this.nombrePointsPourAnimation);
	  oups.writeInt(this.dureeAnimation);
	  var ind1 = list.indexOf(this.pointLieAssocie);
	  oups.writeInt(ind1);
	  oups.writeBoolean(this.inverserSens);
	  oups.writeBoolean(this.retourDepart);
	  oups.writeBoolean(this.unCycle);
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacro = __webpack_require__(157);
	var CMacroAvecListe = __webpack_require__(162);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroApparition;
	
	/**
	 * Macro rendant visibles des objets de la figure.
	 * @constructor
	 * @extends CMacroAvecListe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : La liste des objets à démasquer.
	 * @param {Boolean} clicPourObjetSuivant : Si true, les objets sont démasqués au fur et à mesure des clics de souris.
	 * @returns {CMacroApparition}
	 */
	function CMacroApparition(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee, clicPourObjetSuivant) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	      this.clicPourObjetSuivant = clicPourObjetSuivant;
	    }
	  }
	}
	CMacroApparition.prototype = new CMacroAvecListe();
	CMacroApparition.prototype.constructor = CMacroApparition;
	CMacroApparition.prototype.superClass = "CMacroAvecListe";
	CMacroApparition.prototype.className = "CMacroApparition";
	
	CMacroApparition.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  return new CMacroApparition(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone, this.clicPourObjetSuivant);
	};
	CMacroApparition.prototype.initialise = function () {
	  // Ajout version 5.1 pour que macroEnCours de la liste proprietaite pointe sur this
	  CMacro.prototype.initialise.call(this);
	  //
	  if (this.clicPourObjetSuivant) this.indiceDernierObjetTraite = -1;
	};
	CMacroApparition.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  if (this.clicPourObjetSuivant && this.indiceDernierObjetTraite !== this.listeAssociee.longueur() - 1) this.executionEnCours = true;else {
	    // this.executionEnCours = false;
	    // this.indiceDernierObjetTraite = -1;
	    CMacroAvecListe.prototype.termineAction.call(this, svg, dimf, couleurFond, transparence);
	  }
	};
	/**
	 * Lance l'exécution de la macro.
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroApparition.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  var el;
	  var list = this.listeProprietaire;
	  if (!list.documentProprietaire.modeTraceActive) list.deleteTraces(); // Ajout version 4.9.2
	  // Pas d'apparition pas à pas pour la version JavaScript
	  if (this.clicPourObjetSuivant && this.listeAssociee.longueur() !== 1) {
	    // Modification par rapport à la version C++. On saute les objets déjà visibles
	    this.indiceDernierObjetTraite++;
	    el = this.listeAssociee.get(this.indiceDernierObjetTraite);
	    if (!el.masque) {
	      while (this.indiceDernierObjetTraite < this.listeAssociee.longueur()) {
	        el = this.listeAssociee.get(this.indiceDernierObjetTraite);
	        if (el.masque) break;else this.indiceDernierObjetTraite++;
	      }
	      if (this.indiceDernierObjetTraite === this.listeAssociee.longueur()) {
	        this.indiceDernierObjetTraite--;
	        this.termineAction(svg, dimf, couleurFond, transparence);
	        return;
	      }
	    }
	    el.montre();
	    el.setReady4MathJaxUpdate();
	    // el.update(svg, couleurFond, transparence, true);
	    MathJax.Hub.Queue([this.listeProprietaire.callBack, el, svg, couleurFond, transparence, false]);
	    if (this.indiceDernierObjetTraite === this.listeAssociee.longueur() - 1) this.termineAction(svg, dimf, couleurFond, transparence);
	  } else {
	    this.listeAssociee.montreTout(true);
	    this.executionEnCours = false;
	    this.listeAssociee.update(svg, couleurFond, transparence, true);
	    this.termineAction(svg, dimf, couleurFond, transparence);
	  }
	};
	/**
	 * Fonction appelée pour les CMacroSuiteMacros.
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroApparition.prototype.passageMacroSuiv = function (svg, dimf, couleurFond, transparence) {
	  if (this.clicPourObjetSuivant && this.listeAssociee.longueur() !== 1) {
	    if (this.indiceDernierObjetTraite === this.listeAssociee.longueur() - 1) CMacro.passageMacroSuiv.call(this, svg, dimf, couleurFond, transparence);
	  } else CMacro.passageMacroSuiv.call(this, svg, dimf, couleurFond, transparence);
	};
	CMacroApparition.prototype.ajouteAntecedents = function (liste) {
	  liste.ajouteElementsDe(this.listeAssociee);
	};
	CMacroApparition.prototype.read = function (inps, list) {
	  CMacroAvecListe.prototype.read.call(this, inps, list);
	  this.clicPourObjetSuivant = inps.readBoolean();
	};
	CMacroApparition.prototype.write = function (oups, list) {
	  CMacroAvecListe.prototype.write.call(this, oups, list);
	  oups.writeBoolean(this.clicPourObjetSuivant);
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	module.exports = CMacroBoucleAvecAnimation;
	
	/**
	 * Macro animant la figure en donnant des valeurs à une variable allant
	 * de sa valeur mini à sa valeur maxi.
	 * Avant l'animation, la macro macroAvanatBoucles est exécutée.
	 * A la fin de chaque boucle, la macro macroFinBoucle est exécutée.
	 * Ce type de macro sert à faire des expériences aléatoires animées.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {Integer} frequenceAnimation : La fréquence d'animation en millièmes de seconde.
	 * @param {Boolean} animationVisible : si false, on fait les boucles sans réafficher la figure.
	 * @param {mtg32?CVariableBornee} variableAssociee : La variable dont les valeurs génèrent l'animation.
	 * @param {CMacro} macroAvantBoucles : La macro d'initialisation avant de commencer les boucles.
	 * @param {CMacro} macroFinBoucle : La macro à exécuter à la fin de chaque boucle.
	 * @returns {CMacroBoucleAvecAnimation}
	 */
	function CMacroBoucleAvecAnimation(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, frequenceAnimation, animationVisible, variableAssociee, macroAvantBoucles, macroFinBoucle) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	      this.frequenceAnimation = frequenceAnimation;
	      this.animationVisible = animationVisible;
	      this.variableAssociee = variableAssociee;
	      this.macroAvantBoucles = macroAvantBoucles;
	      this.macroFinBoucle = macroFinBoucle;
	    }
	    this.listeElementsDependants = new CListeObjets(listeProprietaire);
	    this.listeElementsDependantMacroFin = new CListeObjets(listeProprietaire);
	    this.listeElementsAReafficher = new CListeObjets(listeProprietaire); // Spécial JavaScript
	    this.listeVariablesModifiees = new CListeObjets(listeProprietaire);
	  }
	}
	CMacroBoucleAvecAnimation.prototype = new CMacro();
	CMacroBoucleAvecAnimation.prototype.constructor = CMacroBoucleAvecAnimation;
	CMacroBoucleAvecAnimation.prototype.superClass = "CMacro";
	CMacroBoucleAvecAnimation.prototype.className = "CMacroBoucleAvecAnimation ";
	
	CMacroBoucleAvecAnimation.prototype.getClone = function (listeSource, listeCible) {
	  var mac2, mac3, ind1, ind2, ind3, ind4, ind5;
	  ind1 = listeSource.indexOf(this.variableAssociee);
	  if (this.macroAvantBoucles === null) mac2 = null;else {
	    ind2 = listeSource.indexOf(this.macroAvantBoucles);
	    mac2 = listeCible.get(ind2, "CMacro");
	  }
	  if (this.macroFinBoucle === null) mac3 = null;else {
	    ind3 = listeSource.indexOf(this.macroFinBoucle);
	    mac3 = listeCible.get(ind3, "CMacro");
	  }
	  ind4 = listeSource.indexOf(this.pointLie);
	  ind5 = listeSource.indexOf(this.impProto);
	  return new CMacroBoucleAvecAnimation(listeCible, listeCible.get(ind5, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind4, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, this.frequenceAnimation, this.animationVisible, listeCible.get(ind1, "CVariableBornee"), mac2, mac3);
	};
	CMacroBoucleAvecAnimation.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  var resultat = false;
	  if (this.macroAvantBoucles !== null) resultat |= this.macroAvantBoucles.dependDe(p);
	  if (this.macroFinBoucle !== null) resultat |= this.macroFinBoucle.dependDe(p);
	  return this.memoriseDependance(resultat || CMacro.prototype.dependDe.call(this, p));
	};
	CMacroBoucleAvecAnimation.prototype.dependDePourBoucle = function (p) {
	  var resultat = false;
	  if (this.macroAvantBoucles !== null) resultat |= this.macroAvantBoucles.dependDePourBoucle(p);
	  if (this.macroFinBoucle !== null) resultat |= this.macroFinBoucle.dependDePourBoucle(p);
	  return resultat || CMacro.prototype.dependDePourBoucle.call(this, p);
	};
	CMacroBoucleAvecAnimation.prototype.metAJour = function () {
	  CMacro.prototype.metAJour.call(this);
	  this.etablitListesInternes();
	};
	CMacroBoucleAvecAnimation.prototype.etablitListesInternes = function () {
	  var i, ptb1, j, ptv2;
	  var lp = this.listeProprietaire;
	  this.listeElementsDependants.retireTout();
	  this.listeVariablesModifiees.retireTout();
	  this.listeElementsDependantMacroFin.retireTout();
	  for (i = 0; i < lp.longueur(); i++) {
	    ptb1 = lp.get(i);
	    if (ptb1.dependDePourBoucle(this.variableAssociee)) this.listeElementsDependants.add(ptb1);
	  }
	  if (this.macroFinBoucle !== null) {
	    for (i = 0; i < lp.longueur(); i++) {
	      ptb1 = lp.get(i);
	      if (ptb1.getNatureCalcul() === NatCal.NVariable) {
	        if (ptb1 !== this.variableAssociee && this.macroFinBoucle.agitSurVariable(ptb1)) this.listeVariablesModifiees.add(ptb1);
	      }
	    }
	    // Il faut aussi créer la liste des éléments dépendants
	    // d'une variable sur laquelle agit la macro
	    // exécutée à la fin de chaque liste
	    for (i = 0; i < lp.longueur(); i++) {
	      ptb1 = lp.get(i);
	      if (ptb1.getNature() !== NatObj.NMacro) {
	        for (j = 0; j < this.listeVariablesModifiees.longueur(); j++) {
	          ptv2 = this.listeVariablesModifiees.get(j);
	          if (ptb1.dependDe(ptv2)) {
	            if (!this.listeElementsDependantMacroFin.contains(ptb1)) {
	              if (ptb1.estDeNatureCalcul(NatCal.NTteValRSaufConst)) {
	                if (!this.macroFinBoucle.affecteValeurAVariable(ptb1)) this.listeElementsDependantMacroFin.add(ptb1);
	              } else this.listeElementsDependantMacroFin.add(ptb1);
	            }
	          }
	        }
	      }
	    }
	    this.listeElementsAReafficher.ajouteElementsDe(this.listeElementsDependants);
	    for (i = 0; i < this.listeElementsDependantMacroFin.longueur(); i++) {
	      ptb1 = this.listeElementsDependantMacroFin.get(i);
	      if (!this.listeElementsAReafficher.contains(ptb1)) this.listeElementsAReafficher.add(ptb1);
	    }
	  }
	};
	// Doit renvoyer true car il peut n'y avoir qu'un objet à tracer qui peut ne pas exister au début des boucles
	CMacroBoucleAvecAnimation.prototype.executionPossible = function () {
	  return true;
	};
	/**
	 * Lance l'exécution de la macro via un timer et une fonction de callBack.
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroBoucleAvecAnimation.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  if (this.macroAvantBoucles !== null) {
	    if (this.macroAvantBoucles.executionPossible()) this.macroAvantBoucles.executeSimple(dimf);
	  }
	  this.pas = this.variableAssociee.valeurPas;
	  this.valeurMinimale = this.variableAssociee.valeurMini;
	  this.valeurMaximale = this.variableAssociee.valeurMaxi;
	  this.valeurCourante = this.valeurMinimale;
	  this.executionEnCours = true;
	  var t = this;
	  if (!this.animationVisible && this.frequenceAnimation === 0) this.timer = setInterval(function () {
	    CMacroBoucleAvecAnimation.executePourTimerSpeed.call(t, svg, dimf, couleurFond, transparence);
	  }, this.frequenceAnimation);else this.timer = setInterval(function () {
	    CMacroBoucleAvecAnimation.executePourTimer.call(t, svg, dimf, couleurFond, transparence);
	  }, this.frequenceAnimation);
	};
	/**
	 * Fonction de callBack appelée par un timer dans execute()
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fond de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroBoucleAvecAnimation.executePourTimer = function (svg, dimf, couleurFond, transparence) {
	  if (!this.executionEnCours) return;
	  this.variableAssociee.donneValeur(this.valeurCourante);
	  // Générera des valeurs aléatoires dans les appels de Rand()
	  this.listeElementsDependants.positionne(true, dimf);
	  // On exécute la macro de fin de boucle
	  if (this.macroFinBoucle !== null && this.valeurCourante <= this.valeurMaximale) {
	    if (this.macroFinBoucle.executionPossible()) this.macroFinBoucle.executeSimple(dimf);
	    this.listeElementsDependantMacroFin.positionne(false, dimf);
	    this.listeElementsAReafficher.update(svg, couleurFond, transparence, true);
	    //this.listeElementsDependantMacroFin.update(svg, couleurFond, transparence, true);
	  }
	  this.valeurCourante += this.pas;
	  if (this.valeurCourante > this.valeurMaximale) this.termineAction(svg, dimf, couleurFond, transparence);
	};
	/**
	 * Fonction de callBack appelée lors de l'animation sans que les animations intermédiaires soient affichées.
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fond de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroBoucleAvecAnimation.executePourTimerSpeed = function (svg, dimf, couleurFond, transparence) {
	  if (!this.executionEnCours) return;
	  for (var i = 0; i < 100 && this.valeurCourante <= this.valeurMaximale; i++) {
	    this.variableAssociee.donneValeur(this.valeurCourante);
	    // Générera des valeurs aléatoires dans les appels de Rand()
	    this.listeElementsDependants.positionne(true, dimf);
	    // On exécute la macro de fin de boucle
	    if (this.macroFinBoucle !== null) {
	      if (this.macroFinBoucle.executionPossible()) this.macroFinBoucle.executeSimple(dimf);
	      this.listeElementsDependantMacroFin.positionne(false, dimf);
	    }
	    this.valeurCourante += this.pas;
	  }
	  if (this.valeurCourante > this.valeurMaximale) {
	    this.termineAction(svg, dimf, couleurFond, transparence);
	    this.listeElementsAReafficher.update(svg, couleurFond, transparence, true);
	  }
	};
	CMacroBoucleAvecAnimation.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  clearInterval(this.timer);
	  this.executionEnCours = false;
	  this.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	};
	CMacroBoucleAvecAnimation.prototype.agitSurVariable = function (va) {
	  return this.macroAvantBoucles.agitSurVariable(va) || this.macroFinBoucle.agitSurVariable(va);
	};
	CMacroBoucleAvecAnimation.prototype.typeAnimation = function () {
	  if (this.animationVisible && this.frequenceAnimation !== 0) return CMacro.animationParTimer;else return CMacro.animationParThread;
	};
	CMacroBoucleAvecAnimation.prototype.read = function (inps, list) {
	  CMacro.prototype.read.call(this, inps, list);
	  this.animationVisible = inps.readBoolean();
	  this.frequenceAnimation = inps.readInt();
	  var ind1 = inps.readInt();
	  this.variableAssociee = list.get(ind1, "CVariableBornee");
	  var ind2 = inps.readInt();
	  if (ind2 === -1) this.macroAvantBoucles = null;else this.macroAvantBoucles = list.get(ind2, "CMacro");
	  var ind3 = inps.readInt();
	  if (ind3 === -1) this.macroFinBoucle = null;else this.macroFinBoucle = list.get(ind3, "CMacro");
	  // Spécial JavaScript. La vitesse maximum pour une animation est le millième de seconde
	  if (this.animationVisible && this.frequenceAnimation === 0) this.frequenceAnimation = 1;
	  if (list.className !== "CPrototype") {
	    this.listeElementsDependants = new CListeObjets(this.listeProprietaire);
	    this.listeElementsDependantMacroFin = new CListeObjets(this.listeProprietaire);
	    this.listeElementsAReafficher = new CListeObjets(this.listeProprietaire);
	    this.listeVariablesModifiees = new CListeObjets(this.listeProprietaire);
	  }
	};
	CMacroBoucleAvecAnimation.prototype.write = function (oups, list) {
	  CMacro.prototype.write.call(this, oups, list);
	  oups.writeBoolean(this.animationVisible);
	  oups.writeInt(this.frequenceAnimation);
	  var ind1 = list.indexOf(this.variableAssociee);
	  oups.writeInt(ind1);
	  var ind2;
	  if (this.macroAvantBoucles === null) ind2 = -1;else ind2 = list.indexOf(this.macroAvantBoucles);
	  oups.writeInt(ind2);
	  var ind3;
	  if (this.macroFinBoucle === null) ind3 = -1;else ind3 = list.indexOf(this.macroFinBoucle);
	  oups.writeInt(ind3);
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	var CMacroAvecListe = __webpack_require__(162);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroBoucleAvecTrace;
	
	/**
	 * Macro animant la figure en donnant des valeurs à une variable allant
	 * de sa valeur mini à sa valeur maxi. A cg=haue boucle, les objets de listeAssociee
	 * laissent une trace.
	 * Avant l'animation, la macro macroAvanatBoucles est exécutée.
	 * A la fin de chaque boucle, la macro macroFinBoucle est exécutée.
	 * Ce type de macro sert à faire des expériences aléatoires animées.
	 * @constructor
	 * @extends CMacroAvecListe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : La liste des objets qui laissent une trace.
	 * @param {Integer} frequenceAnimation : La fréquence d'animation en millièmes de seconde.
	 * @param {Boolean} animationVisible : si false, on fait les boucles sans réafficher la figure.
	 * @param {mtg32?CVariableBornee} variableAssociee : La variable dont les valeurs génèrent l'animation.
	 * @param {CMacro} macroAvantBoucles : La macro d'initialisation avant de commencer les boucles.
	 * @param {CMacro} macroFinBoucle : La macro à exécuter à la fin de chaque boucle.
	  * @returns {CMacroBoucleAvecTrace}
	 */
	function CMacroBoucleAvecTrace(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee, frequenceAnimation, animationVisible, variableAssociee, macroAvantBoucles, macroFinBoucle) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	      this.frequenceAnimation = frequenceAnimation;
	      this.animationVisible = animationVisible;
	      this.variableAssociee = variableAssociee;
	      this.macroAvantBoucles = macroAvantBoucles;
	      this.macroFinBoucle = macroFinBoucle;
	    }
	    this.listeElementsDependants = new CListeObjets(listeProprietaire);
	    this.listeElementsDependantMacroFin = new CListeObjets(listeProprietaire);
	    this.listeElementsAReafficher = new CListeObjets(listeProprietaire); // Spécial JavaScript
	    this.listeVariablesModifiees = new CListeObjets(listeProprietaire);
	  }
	}
	CMacroBoucleAvecTrace.prototype = new CMacroAvecListe();
	CMacroBoucleAvecTrace.prototype.constructor = CMacroBoucleAvecTrace;
	CMacroBoucleAvecTrace.prototype.superClass = "CMacroAvecListe";
	CMacroBoucleAvecTrace.prototype.className = "CMacroBoucleAvecTrace";
	
	CMacroBoucleAvecTrace.prototype.getClone = function (listeSource, listeCible) {
	  var mac2, mac3;
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  var ind1 = listeSource.indexOf(this.variableAssociee);
	  if (this.macroAvantBoucles === null) mac2 = null;else {
	    var ind2 = listeSource.indexOf(this.macroAvantBoucles);
	    mac2 = listeCible.get(ind2, "CMacro");
	  }
	  if (this.macroFinBoucle === null) mac3 = null;else {
	    var ind3 = listeSource.indexOf(this.macroFinBoucle);
	    mac3 = listeCible.get(ind3, "CMacro");
	  }
	  var ind4 = listeSource.indexOf(this.pointLie);
	  var ind5 = listeSource.indexOf(this.impProto);
	  return new CMacroBoucleAvecTrace(listeCible, listeCible.get(ind5, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind4, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone, this.frequenceAnimation, this.animationVisible, listeCible.get(ind1, "CVariableBornee"), mac2, mac3);
	};
	CMacroBoucleAvecTrace.prototype.agitSurVariable = function (va) {
	  return this.macroAvantBoucles.agitSurVariable(va) || this.macroFinBoucle.agitSurVariable(va);
	};
	CMacroBoucleAvecTrace.prototype.typeAnimation = function () {
	  if (this.animationVisible && this.frequenceAnimation !== 0) return CMacro.animationParTimer;else return CMacro.animationParThread;
	};
	CMacroBoucleAvecTrace.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  var res = false;
	  if (this.macroAvantBoucles !== null) res |= this.macroAvantBoucles.dependDe(p);
	  if (this.macroFinBoucle !== null) res |= this.macroFinBoucle.dependDe(p);
	  return this.memoriseDependance(res || CMacroAvecListe.prototype.dependDe.call(this, p));
	};
	CMacroBoucleAvecTrace.prototype.dependDePourBoucle = function (p) {
	  var res = false;
	  if (this.macroAvantBoucles !== null) res |= this.macroAvantBoucles.dependDePourBoucle(p);
	  if (this.macroFinBoucle !== null) res |= this.macroFinBoucle.dependDePourBoucle(p);
	  return res || CMacroAvecListe.prototype.dependDePourBoucle.call(this, p);
	};
	CMacroBoucleAvecTrace.prototype.metAJour = function () {
	  CMacroAvecListe.prototype.metAJour.call(this);
	  this.etablitListesInternes();
	};
	CMacroBoucleAvecTrace.prototype.etablitListesInternes = function () {
	  var i, ptb1, j, ptv2;
	  var lp = this.listeProprietaire;
	  this.listeElementsDependants.retireTout();
	  this.listeElementsDependantMacroFin.retireTout();
	  this.listeVariablesModifiees.retireTout();
	  for (i = 0; i < lp.longueur(); i++) {
	    ptb1 = lp.get(i);
	    if (ptb1.dependDePourBoucle(this.variableAssociee)) {
	      this.listeElementsDependants.add(ptb1);
	    }
	  }
	  if (this.macroFinBoucle !== null) {
	    for (i = 0; i < lp.longueur(); i++) {
	      ptb1 = lp.get(i);
	      if (ptb1.getNatureCalcul() === NatCal.NVariable) {
	        // CVariableBornee ptv1 = (CVariableBornee) ptb1;
	        if (ptb1 !== this.variableAssociee && this.macroFinBoucle.agitSurVariable(ptb1)) this.listeVariablesModifiees.add(ptb1);
	      }
	    }
	    // Il faut aussi créer la liste des éléments dépendants
	    // d'une variable sur laquelle agit la macro
	    // exécutée à la fin de chaque liste
	    for (i = 0; i < lp.longueur(); i++) {
	      ptb1 = lp.get(i);
	      if (ptb1.getNature() !== NatObj.NMacro) {
	        for (j = 0; j < this.listeVariablesModifiees.longueur(); j++) {
	          ptv2 = this.listeVariablesModifiees.get(j);
	          if (ptb1.dependDe(ptv2)) {
	            if (this.listeElementsDependantMacroFin.indexOf(ptb1) === -1) if (ptb1.estDeNatureCalcul(NatCal.NTteValRSaufConst)) {
	              if (!this.macroFinBoucle.affecteValeurAVariable(ptb1)) this.listeElementsDependantMacroFin.add(ptb1);
	            } else this.listeElementsDependantMacroFin.add(ptb1);
	          }
	        }
	      }
	    }
	    this.listeElementsAReafficher.ajouteElementsDe(this.listeElementsDependants);
	    for (i = 0; i < this.listeElementsDependantMacroFin.longueur(); i++) {
	      ptb1 = this.listeElementsDependantMacroFin.get(i);
	      if (!this.listeElementsAReafficher.contains(ptb1)) this.listeElementsAReafficher.add(ptb1);
	    }
	  }
	};
	// Doit renvoyer true car il peut n'y avoir qu'un objet à tracer qui peut ne pas exister au début des boucles
	CMacroBoucleAvecTrace.prototype.executionPossible = function () {
	  return true;
	};
	/**
	 * Lance l'exécution de la macro via un timer et une fonction de callBack.
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroBoucleAvecTrace.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.listeProprietaire.initialiseTraces();
	  if (this.macroAvantBoucles !== null) {
	    if (this.macroAvantBoucles.executionPossible()) this.macroAvantBoucles.executeSimple(dimf);
	  }
	  // Control.InvalideControl();
	  this.pas = this.variableAssociee.valeurPas;
	  this.valeurMinimale = this.variableAssociee.valeurMini;
	  this.valeurMaximale = this.variableAssociee.valeurMaxi;
	  this.valeurCourante = this.valeurMinimale;
	  this.executionEnCours = true;
	  var t = this;
	  if (!this.animationVisible && this.frequenceAnimation === 0) this.timer = setInterval(function () {
	    CMacroBoucleAvecTrace.executePourTimerSpeed.call(t, svg, dimf, couleurFond, transparence);
	  }, this.frequenceAnimation);else this.timer = setInterval(function () {
	    CMacroBoucleAvecTrace.executePourTimer.call(t, svg, dimf, couleurFond, transparence);
	  }, this.frequenceAnimation);
	};
	/**
	 * Fonction de callBack appelée par un timer dans execute()
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fond de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroBoucleAvecTrace.executePourTimer = function (svg, dimf, couleurFond, transparence) {
	  if (!this.executionEnCours) return;
	  this.variableAssociee.donneValeur(this.valeurCourante);
	  this.listeElementsDependants.positionne(true, dimf);
	  this.listeProprietaire.addTraces(this.listeAssociee);
	  //listeAssociee.afficheToutMemeMasquesPourTrace(cadre.tbuffer, cadre.dimf, doc.couleurFond, doc.opacity,
	  //    cadre.frame.pref_antialiasing);
	  if (this.macroFinBoucle !== null && this.valeurCourante <= this.valeurMaximale) {
	    if (this.macroFinBoucle.executionPossible()) this.macroFinBoucle.executeSimple(dimf);
	    this.listeElementsDependantMacroFin.positionne(false, dimf);
	    this.listeElementsAReafficher.update(svg, couleurFond, transparence, true);
	  }
	  this.valeurCourante += this.pas;
	  if (this.valeurCourante > this.valeurMaximale) {
	    this.termineAction(svg, dimf, couleurFond, transparence);
	  }
	};
	/**
	 * Fonction de callBack appelée lors de l'animation sans que les animations intermédiaires soient affichées.
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fond de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroBoucleAvecTrace.executePourTimerSpeed = function (svg, dimf, couleurFond, transparence) {
	  if (!this.executionEnCours) return;
	  for (var i = 0; i < 100 && this.valeurCourante <= this.valeurMaximale; i++) {
	    this.variableAssociee.donneValeur(this.valeurCourante);
	    this.listeElementsDependants.positionne(true, dimf);
	    this.listeProprietaire.addTraces(this.listeAssociee);
	    if (this.macroFinBoucle !== null && this.valeurCourante <= this.valeurMaximale) {
	      if (this.macroFinBoucle.executionPossible()) this.macroFinBoucle.executeSimple(dimf);
	      this.listeElementsDependantMacroFin.positionne(false, dimf);
	    }
	    this.valeurCourante += this.pas;
	  }
	  if (this.valeurCourante > this.valeurMaximale) {
	    this.termineAction(svg, dimf, couleurFond, transparence);
	    this.listeElementsAReafficher.update(svg, couleurFond, transparence, true);
	  }
	};
	CMacroBoucleAvecTrace.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  clearInterval(this.timer);
	  this.executionEnCours = false;
	  this.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	};
	CMacroBoucleAvecTrace.prototype.ajouteAntecedents = function (liste) {
	  liste.ajouteElementsDe(this.listeAssociee);
	};
	CMacroBoucleAvecTrace.prototype.read = function (inps, list) {
	  CMacroAvecListe.prototype.read.call(this, inps, list);
	  this.animationVisible = inps.readBoolean();
	  this.frequenceAnimation = inps.readInt();
	  // Fréquence à vitesse maxi remplacée par 1/1000 de seconde
	  // Modifié version 4.7.6.1. Seulement pour l'applet
	  // if (frequenceAnimation === 0)
	  // frequenceAnimation = 1;
	  var ind1 = inps.readInt();
	  this.variableAssociee = list.get(ind1, "CVariableBornee");
	  var ind2 = inps.readInt();
	  if (ind2 === -1) this.macroAvantBoucles = null;else this.macroAvantBoucles = list.get(ind2, "CMacro");
	  var ind3 = inps.readInt();
	  if (ind3 === -1) this.macroFinBoucle = null;else this.macroFinBoucle = list.get(ind3, "CMacro");
	  if (list.className !== "CPrototype") {
	    this.listeElementsDependants = new CListeObjets(this.listeProprietaire);
	    this.listeElementsDependantMacroFin = new CListeObjets(this.listeProprietaire);
	    this.listeElementsAReafficher = new CListeObjets(this.listeProprietaire);
	    this.listeVariablesModifiees = new CListeObjets(this.listeProprietaire);
	  }
	};
	CMacroBoucleAvecTrace.prototype.write = function (oups, list) {
	  CMacroAvecListe.prototype.write.call(this, oups, list);
	  oups.writeBoolean(this.animationVisible);
	  oups.writeInt(this.frequenceAnimation);
	  var ind1 = list.indexOf(this.variableAssociee);
	  oups.writeInt(ind1);
	  var ind2;
	  if (this.macroAvantBoucles === null) ind2 = -1;else ind2 = list.indexOf(this.macroAvantBoucles);
	  oups.writeInt(ind2);
	  var ind3;
	  if (this.macroFinBoucle === null) ind3 = -1;else ind3 = list.indexOf(this.macroFinBoucle);
	  oups.writeInt(ind3);
	};

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacro = __webpack_require__(157);
	var CMacroAvecListe = __webpack_require__(162);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroClignotement;
	
	/**
	 * Macro faisant clignoter des objets sur la figure.
	 * @constructor
	 * @extends CMacroAvecListe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : La liste des objets qui doivent clignoter
	 * @param {Integer} dureeAnimation ; La durée de clignotement en secondes, 0 pour un clignotement
	 * jusqu'au prochain clic de souris.
	 * @returns {CMacroClignotement}
	 */
	function CMacroClignotement(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee, dureeAnimation) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	      this.dureeAnimation = dureeAnimation;
	    }
	  }
	}
	CMacroClignotement.prototype = new CMacroAvecListe();
	CMacroClignotement.prototype.constructor = CMacroClignotement;
	CMacroClignotement.prototype.superClass = "CMacroAvecListe";
	CMacroClignotement.prototype.className = "CMacroClignotement";
	
	CMacroClignotement.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  return new CMacroClignotement(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, this.pointLie, this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone, this.dureeAnimation);
	};
	CMacroClignotement.prototype.typeAnimation = function () {
	  return CMacro.animationParTimer;
	};
	CMacroClignotement.prototype.arretParClic = function () {
	  return this.dureeAnimation === 0;
	};
	CMacroClignotement.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  clearInterval(this.timer);
	  this.executionEnCours = false;
	  this.listeAssociee.montreTout(true);
	  // this.listeAssociee.updateComposants(svg, couleurFond, transparence);
	  this.listeAssociee.update(svg, couleurFond, transparence, true);
	  this.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	};
	CMacroClignotement.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  var timeDebut = +new Date();
	  if (this.dureeAnimation !== 0) this.timeFin = timeDebut + this.dureeAnimation * 100; // La durée est en dixièmes de secondes
	  this.executionEnCours = true;
	  this.nombrePairClignotements = true;
	  var t = this;
	  this.timer = setInterval(function () {
	    CMacroClignotement.executePourTimer.call(t, svg, dimf, couleurFond, transparence);
	  }, 500);
	};
	/**
	 * Fonction de callBack appelée par un timer dans execute()
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fond de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroClignotement.executePourTimer = function (svg, dimf, couleurFond, transparence) {
	  if (!this.executionEnCours) return;
	  this.nombrePairClignotements = !this.nombrePairClignotements;
	  this.listeAssociee.montreTout(this.nombrePairClignotements);
	  this.listeAssociee.update(svg, couleurFond, transparence, true);
	  var time = +new Date(); // Raccourci pour (new Date()).getTime()
	  if (time > this.timeFin) this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroClignotement.prototype.ajouteAntecedents = function (liste) {
	  liste.ajouteElementsDe(this.listeAssociee);
	};
	CMacroClignotement.prototype.read = function (inps, list) {
	  CMacroAvecListe.prototype.read.call(this, inps, list);
	  this.dureeAnimation = inps.readInt();
	};
	CMacroClignotement.prototype.write = function (oups, list) {
	  CMacroAvecListe.prototype.write.call(this, oups, list);
	  oups.writeInt(this.dureeAnimation);
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Color = __webpack_require__(6);
	var StyleRemplissage = __webpack_require__(115);
	var StyleTrait = __webpack_require__(78);
	var CPolygone = __webpack_require__(169);
	var CImplementationProto = __webpack_require__(64);
	var CLigneBrisee = __webpack_require__(154);
	var CMacroAvecListe = __webpack_require__(162);
	var CSurfacePolygone = __webpack_require__(170);
	var CNoeudPointeurSurPoint = __webpack_require__(65);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroConstructionIterative;
	
	/**
	 * Macro lançant une construction itérative.
	 * @constructor
	 * @extends CMacroAvecListe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : liste contenant les éléments à utiliser comme objets sources
	 * pour la première implémentation de prototype.
	 * @param {CPrototype} proto : La construction à utiliser.
	 * @param {Integer} nbIter : Le nombre d'iérations souhaité.
	 * @param {Integer} nbSourcesPourIter : Le nombre d'éléments sources qui sont communs à
	 * toutes les implémentations.
	 * @param {Boolean} imposerCouleur : si true, tous les objets finaux devront prendre la couleur couleurImp.
	 * @param {Color} couleurImp : La couleur des objets finaux si imposerCouleur est true.
	 * @param {Integer} choixLigne : Si 0, les points finaux ne sont pas reliés, si 1 ils sont reliés
	 * par un polygone et si 2 reliés par une ligne brisée.
	 * @param {StyleTrait} styleLigne : Le style de trait utilisé si choixLigne n'est pas 0.
	 * @param {Color} couleurLigne : La couleur utilisé pour la ligne si choixLigne n'est pas 0.
	 * @param {Boolean} polygoneRempli : trus si choixLigne vaut 1 et qu'on souhaite que le polygone soit rempli.
	 * @returns {CMacroConstructionIterative}
	 */
	function CMacroConstructionIterative(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee, proto, nbIter, nbSourcesPourIter, imposerCouleur, couleurImp, choixLigne, styleLigne, couleurLigne, polygoneRempli) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	      this.proto = proto;
	      this.nbIter = nbIter;
	      this.nbSourcesPourIter = nbSourcesPourIter;
	      this.imposerCouleur = imposerCouleur;
	      this.couleurImp = couleurImp;
	      this.choixLigne = choixLigne;
	      this.styleLigne = styleLigne;
	      this.couleurLigne = couleurLigne;
	      this.polygoneRempli = polygoneRempli;
	    }
	  }
	  this.dejaExecute = false;
	}
	CMacroConstructionIterative.prototype = new CMacroAvecListe();
	CMacroConstructionIterative.prototype.constructor = CMacroConstructionIterative;
	CMacroConstructionIterative.prototype.superClass = "CMacroAvecListe";
	CMacroConstructionIterative.prototype.className = "CMacroConstructionIterative";
	
	CMacroConstructionIterative.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  return new CMacroConstructionIterative(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone, this.proto, this.nbIter, this.nbSourcesPourIter, this.imposerCouleur, this.couleurImp, this.choixLigne, this.styleLigne, this.couleurLigne, this.polygoneRempli);
	};
	// Version 4.9.7 : On rajoute un paramètre affichage. Les objets ne sont affichés que si le paramètre est présent et true
	CMacroConstructionIterative.prototype.execute = function (svg, dimf, couleurFond, transparence, affichage) {
	  var i, liste, listePoints, gen, impProto, indiceImp, indiceImpInitial, elb, k, poly, ligne;
	  // On implémente la construction de façon itérative
	  // La liste associée contient les pointeurs sur les objets sources
	  // On affecte ces éléments aux objets sources du prototype
	  for (i = 0; i < this.proto.nbObjSources; i++) {
	    this.proto.get(i).elementAssocie = this.listeAssociee.get(i);
	  }liste = this.listeProprietaire;
	  listePoints = []; // Utilisé si on veut que les points créés soient reliés.
	  if (this.choixLigne !== 0) {
	    for (i = 0; i < this.proto.nbObjSources; i++) {
	      gen = this.proto.get(i);
	      if (gen.estDeNature(NatObj.NTtPoint)) {
	        listePoints.push(new CNoeudPointeurSurPoint(liste, gen.elementAssocie));
	        break;
	      }
	    }
	  }
	  // Version 4.8 : Dans le cas où une (ou plusieurs) implémentation itérative de la construction a déjà été faite, lorsque de nouveaux points nommés
	  // ou calculs sont créés il faut leur générer un nom. Pour éviter de gros ralentissements lors de l'implémentation, il faut générer ces
	  // noms avec un suffixe numérique qui commence au nombre d'implémentations plus 1.
	  impProto = new CImplementationProto(liste, this.proto);
	  // On implémente la construction une première fois.
	  indiceImp = liste.longueur();
	  indiceImpInitial = indiceImp;
	  impProto.implementePourIter(dimf, liste, this.proto); // Modifié version 4.8
	  liste.reconstruitChainesCalcul(indiceImpInitial + 1, indiceImpInitial + this.proto.longueur() - this.proto.nbObjSources);
	  if (this.imposerCouleur) {
	    for (i = liste.indexOf(impProto) + 1; i < liste.longueur(); i++) {
	      elb = liste.get(i);
	      if (elb.estElementFinal && elb.estDeNature(NatObj.NTtObj)) {
	        elb.donneCouleur(this.couleurImp);
	      }
	    }
	  }
	  for (k = 1; k < this.nbIter; k++) {
	    // On implémente avec les objets finaux sauf ceux qui sont communs aux implémentations
	    for (i = this.nbSourcesPourIter; i < this.proto.nbObjSources; i++) {
	      elb = liste.getFinal(indiceImp, i - this.nbSourcesPourIter);
	      gen = this.proto.get(i);
	      gen.elementAssocie = elb;
	    }
	    indiceImp = liste.longueur();
	    impProto = new CImplementationProto(liste, this.proto);
	    impProto.implementePourIter(dimf, liste, this.proto); // Modifié version 4.8
	    if (this.choixLigne !== 0) {
	      for (i = indiceImp; i < liste.longueur(); i++) {
	        elb = liste.get(i);
	        if (elb.estElementFinal && elb.estDeNature(NatObj.NTtPoint)) {
	          listePoints.push(new CNoeudPointeurSurPoint(liste, elb));
	          break;
	        }
	      }
	    }
	    if (this.imposerCouleur) {
	      // On regarde tous les objets finaux et s'ils sont graphiques, on leur donne le style actif
	      for (i = liste.indexOf(impProto) + 1; i < liste.longueur(); i++) {
	        elb = liste.get(i);
	        if (elb.estElementFinal && elb.estDeNature(NatObj.NTtObj)) {
	          elb.donneCouleur(this.couleurImp);
	        }
	      }
	    }
	  }
	  liste.traiteImplementationsProtoSuccessivesIter(indiceImpInitial, this.proto, this.proto.longueur() - this.proto.nbObjSources);
	  // Si demandé dans la boîte de dialogue, on relie tous les points créés par un polygone ou une ligne brisée
	  if (this.choixLigne !== 0) {
	    if (this.choixLigne === 1) {
	      listePoints.push(new CNoeudPointeurSurPoint(liste, listePoints[0].pointeurSurPoint));
	      poly = new CPolygone(liste, null, false, this.couleurLigne, false, this.styleLigne, listePoints);
	      poly.positionne(false, dimf);
	      liste.add(poly);
	      if (this.polygoneRempli) {
	        var s = new CSurfacePolygone(liste, null, false, this.couleurLigne, false, StyleRemplissage.quadrillagePleinTransp, poly);
	        s.positionne(false, dimf);
	        liste.add(s);
	      }
	    } else {
	      ligne = new CLigneBrisee(liste, null, false, this.couleurLigne, false, this.styleLigne, listePoints);
	      liste.add(ligne);
	      ligne.positionne(false, dimf);
	    }
	  }
	  if (arguments.length <= 4 || affichage) this.listeProprietaire.afficheTout(indiceImpInitial, svg, true, couleurFond, transparence); // Pour créer les éléments graphiques
	  this.termineAction(svg, dimf, couleurFond, transparence);
	  this.dejaExecute = true;
	  // Spécial JavaScript. Dans la version Java c'est fait lors de la sauvegarde de la figure
	  this.listeProprietaire.etablitListesInternesMacros();
	};
	
	CMacroConstructionIterative.prototype.executionPossible = function () {
	  return !this.dejaExecute;
	};
	
	CMacroConstructionIterative.prototype.read = function (inps, list) {
	  var indProto, r, g, b;
	  CMacroAvecListe.prototype.read.call(this, inps, list);
	  indProto = inps.readInt();
	  this.proto = list.documentProprietaire.tablePrototypes[indProto];
	  this.nbIter = inps.readInt();
	  this.nbSourcesPourIter = inps.readInt();
	  this.imposerCouleur = inps.readBoolean();
	  if (this.imposerCouleur) {
	    r = inps.readByte();
	    g = inps.readByte();
	    b = inps.readByte();
	    this.couleurImp = new Color(r, g, b);
	  }
	  this.choixLigne = inps.readInt();
	  if (this.choixLigne !== 0) {
	    r = inps.readByte();
	    g = inps.readByte();
	    b = inps.readByte();
	    this.couleurLigne = new Color(r, g, b);
	    this.styleLigne = new StyleTrait(list);
	    if (list.numeroVersion < 15) this.styleLigne.readOld(inps, list, false);else this.styleLigne.read(inps, list);
	    if (this.choixLigne === 1) // Polygone
	      this.polygoneRempli = inps.readBoolean();
	  }
	};
	CMacroConstructionIterative.prototype.write = function (oups, list) {
	  CMacroAvecListe.prototype.write.call(this, oups, list);
	  // On enregistre l'indice du prototype utilisé dans la table des prototype du document
	  oups.writeInt(list.documentProprietaire.tablePrototypes.indexOf(this.proto));
	  oups.writeInt(this.nbIter);
	  oups.writeInt(this.nbSourcesPourIter);
	  oups.writeBoolean(this.imposerCouleur);
	  if (this.imposerCouleur) {
	    oups.writeByte(this.couleurImp.getRed());
	    oups.writeByte(this.couleurImp.getGreen());
	    oups.writeByte(this.couleurImp.getBlue());
	  }
	  oups.writeInt(this.choixLigne);
	  if (this.choixLigne !== 0) {
	    oups.writeByte(this.couleurLigne.getRed());
	    oups.writeByte(this.couleurLigne.getGreen());
	    oups.writeByte(this.couleurLigne.getBlue());
	    oups.writeInt(this.styleLigne);
	    if (this.styleLigne === 1) oups.writeBoolean(this.polygoneRempli);
	  }
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CLignePolygonaleAncetre = __webpack_require__(155);
	module.exports = CPolygone;
	
	/**
	 * Classe polygone.
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style du tracé.
	 * @param {Array} colPoints :  Tableau de CNoeudPointeurSurPoint qui donne les sommets.
	 * @returns {CPolygone}
	 */
	function CPolygone(listeProprietaire, impProto, estElementFinal, couleur, masque, style, colPoints) {
	  if (arguments.length === 1) CLignePolygonaleAncetre.call(this, listeProprietaire);else CLignePolygonaleAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, colPoints);
	}
	CPolygone.prototype = new CLignePolygonaleAncetre();
	CPolygone.prototype.constructor = CPolygone;
	CPolygone.prototype.superClass = "CLignePolygonaleAncetre";
	CPolygone.prototype.className = "CPolygone";
	
	CPolygone.prototype.getClone = function (listeSource, listeCible) {
	  var colClone = new Array(this.nombrePoints);
	  for (var i = 0; i < this.nombrePoints; i++) {
	    var noeud = this.colPoints[i];
	    colClone[i] = noeud.getClone(listeSource, listeCible);
	  }
	  var ind1 = listeSource.indexOf(this.impProto);
	  return new CPolygone(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, colClone);
	};
	CPolygone.prototype.createg = function () {
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  // style += "stroke:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	  style += "stroke:" + this.color + ";";
	  style += "fill:none";
	  return kernel.cens("polygon", {
	    points: this.getPoints(),
	    style: style,
	    "pointer-events": "none"
	  });
	};
	CPolygone.prototype.getPoints = function () {
	  var points = "";
	  // Pour un polygone, le dernier point est le même que le premier mais pas pour svg
	  for (var i = 0; i < this.nombrePoints - 1; i++) {
	    points += this.abscissesCoordonneesPoints[i] + "," + this.ordonneesCoordonneesPoints[i] + " ";
	  }
	  return points;
	};
	// Version JavaScript : trace est spécifique pour CPolygone et CLigneBrisee
	CPolygone.prototype.trace = function (svg) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CPolygone.prototype.update = function () {
	  var g = this.g;
	  g.setAttribute("points", this.getPoints());
	};
	CPolygone.prototype.confonduAvec = function (p) {
	  var ptp1, ptp2, i, j, resultat;
	
	  if (p.className === this.className) {
	    var nombrePoints = this.nombrePoints;
	    if (nombrePoints !== p.nombrePoints) return false;
	    // On regarde si un polynôme a déjà été créé avec les mêmes sommets
	    // dans le	même ordre. On ne regarde pas le dernier sommet qui
	    // est le même que le premier}
	    nombrePoints--;
	    j = 0;
	    do {
	      ptp1 = this.colPoints[0].pointeurSurPoint;
	      ptp2 = p.colPoints[j % nombrePoints].pointeurSurPoint;
	      resultat = ptp1 === ptp2;
	      i = 1;
	      while (resultat && i <= nombrePoints - 1) {
	        ptp1 = this.colPoints[i].pointeurSurPoint;
	        ptp2 = p.colPoints[(i + j) % nombrePoints].pointeurSurPoint;
	        resultat = resultat && ptp1 === ptp2;
	        i++;
	      }
	      j++;
	    } while (j !== nombrePoints && !resultat);
	
	    if (resultat) return true;
	    // On regarde en tournant dans l'autre sens
	    j = 0;
	    do {
	      ptp1 = this.colPoints[nombrePoints - 1].pointeurSurPoint;
	      ptp2 = p.colPoints[j % nombrePoints].pointeurSurPoint;
	      resultat = ptp1 === ptp2;
	      i = 1;
	      while (resultat && i <= nombrePoints - 1) {
	        ptp1 = this.colPoints[nombrePoints - 1 - i].pointeurSurPoint;
	        ptp2 = p.colPoints[(i + j) % nombrePoints].pointeurSurPoint;
	        resultat = resultat && ptp1 === ptp2;
	        i++;
	      }
	      j++;
	    } while (j !== nombrePoints && !resultat);
	    return resultat;
	  } else return false;
	};
	
	CPolygone.prototype.abscisseMinimale = function () {
	  return 0;
	};
	CPolygone.prototype.abscisseMaximale = function () {
	  return 1 - 1e-12;
	};
	CPolygone.prototype.getNature = function () {
	  return NatObj.NPolygone;
	};
	CPolygone.prototype.lieALigneFermee = function () {
	  return true;
	};
	/**
	 * Fonction renvoyant true si le point de coordonnées (x; y) est intérieur au polygône
	 * c'est à dire s'il est sur un des côtés ou si la somme des mesures principales d'angle orienté
	 * est un multiple impair de 2*pi.
	 */
	CPolygone.prototype.pointInterieur = function (x, y) {
	  var sommeang = 0;
	  var taille = this.colPoints.length;
	  for (var i = 0; i < taille - 1; i++) {
	    var noeud1 = this.colPoints[i];
	    var x1 = noeud1.pointeurSurPoint.x;
	    var y1 = noeud1.pointeurSurPoint.y;
	    var noeud2 = this.colPoints[i + 1];
	    var x2 = noeud2.pointeurSurPoint.x;
	    var y2 = noeud2.pointeurSurPoint.y;
	    if (kernel.appartientSegment(x, y, x1, y1, x2, y2)) return true;
	    var u = new Vect(x, y, x1, y1);
	    var v = new Vect(x, y, x2, y2);
	    sommeang += u.mesureAngleVecteurs(v);
	  }
	  var q = Math.floor(sommeang / (2 * Math.PI) + 0.5);
	  // Modifié version 4.8
	  // return q != 2*Math.floor(q/2);
	  return !kernel.zero13(q - 2 * Math.floor(q / 2));
	};
	CPolygone.prototype.determinePositionInterieure = function (x, y, indicePremierSommet, estSurCote, alpha, beta, gamma) {
	  var i, nbSommets, nd1, nd2, nd3, nd4, a, b, c, d, e;
	  nbSommets = this.nombrePoints - 1;
	  for (i = 0; i < nbSommets; i++) {
	    nd1 = this.colPoints[i];
	    b = nd1.pointeurSurPoint;
	    nd2 = this.colPoints[i + 1];
	    c = nd2.pointeurSurPoint;
	    if (kernel.appartientSegment(x, y, b.x, b.y, c.x, c.y)) {
	      indicePremierSommet.setValue(i);
	      kernel.coefficientsPointSurSegment(x, y, b.x, b.y, c.x, c.y, alpha, beta);
	      estSurCote.setValue(true);
	      return true;
	    }
	  }
	  var nda = this.colPoints[0];
	  a = nda.pointeurSurPoint;
	  for (i = 1; i < nbSommets - 1; i++) {
	    nd3 = this.colPoints[i];
	    d = nd3.pointeurSurPoint;
	    nd4 = this.colPoints[i + 1];
	    e = nd4.pointeurSurPoint;
	    if (kernel.estInterieurATriangle(x, y, a.x, a.y, d.x, d.y, e.x, e.y)) {
	      indicePremierSommet.setValue(i);
	      // En appelant I le point d'intersection on calcule les coordonnées barycentriques du point
	      // de coordonnées (x; y) par rapport au triangle ICD
	      kernel.coefficientsPointInterieur(x, y, a.x, a.y, d.x, d.y, e.x, e.y, alpha, beta, gamma);
	      estSurCote.setValue(false);
	      return true;
	    }
	  }
	  return false;
	};
	CPolygone.prototype.chaineDesignation = function () {
	  return "desPolygone";
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Color = __webpack_require__(6);
	var StyleTrait = __webpack_require__(78);
	var CPolygone = __webpack_require__(169);
	var CSurface = __webpack_require__(114);
	module.exports = CSurfacePolygone;
	
	/**
	 * Classe repésentant une surface intérieure à un polygone.
	 * Le polygone ne doit pas de préférence être croisé.
	 * @constructor
	 * @extends CSurface
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 * @param {CPolygone} bord : Le polygone qui borde la surface.
	 * @returns {CSurfacePolygone}
	 */
	function CSurfacePolygone(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord) {
	  if (arguments.length === 1) CSurface.call(this, listeProprietaire);else {
	    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
	    this.polygone = new CPolygone(null, null, false, new Color(0, 0, 0), true, StyleTrait.traitFin, bord.colPoints);
	  }
	}
	CSurfacePolygone.prototype = new CSurface();
	CSurfacePolygone.prototype.constructor = CSurfacePolygone;
	CSurfacePolygone.prototype.superClass = "CSurface";
	CSurfacePolygone.prototype.className = "CSurfacePolygone";
	
	CSurfacePolygone.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.bord);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CSurfacePolygone(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CPolygone"));
	};
	CSurfacePolygone.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.bord);
	};
	CSurfacePolygone.prototype.positionne = function (infoRandom, dimfen) {
	  CSurface.prototype.positionne.call(this, infoRandom, dimfen);
	  this.polygone.setClone(this.bord);
	};
	CSurfacePolygone.prototype.setClone = function (ptel) {
	  CSurface.prototype.setClone.call(this, ptel);
	  this.polygone.setClone(ptel.polygone);
	};
	/**
	 * Fonction renvoyant une chaîne de caractères utilisée dans le svg élément
	 * représentant la surface.
	 * @returns {String}
	 */
	CSurfacePolygone.prototype.creePoints = function () {
	  var i,
	      points = "";
	  // Pour un polygone, le dernier point est le même que le premier mais pas pour svg
	  for (i = 0; i < this.polygone.nombrePoints - 1; i++) {
	    points += this.polygone.abscissesCoordonneesPoints[i] + "," + this.polygone.ordonneesCoordonneesPoints[i] + " ";
	  }
	  return points;
	};
	CSurfacePolygone.prototype.read = function (inps, list) {
	  CSurface.prototype.read.call(this, inps, list);
	  this.polygone = new CPolygone(null, null, false, new Color(0, 0, 0), true, new StyleTrait(list, StyleTrait.styleTraitContinu, 1), this.bord.colPoints);
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Color = __webpack_require__(6);
	var StyleRemplissage = __webpack_require__(115);
	var StyleTrait = __webpack_require__(78);
	var CPolygone = __webpack_require__(169);
	var CImplementationProto = __webpack_require__(64);
	var CLigneBrisee = __webpack_require__(154);
	var CListeObjets = __webpack_require__(17);
	var CMacroAvecListe = __webpack_require__(162);
	var CSurfacePolygone = __webpack_require__(170);
	var CNoeudPointeurSurPoint = __webpack_require__(65);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroConstructionRecursive;
	
	/**
	 * Macro lançant une construction récursive.
	 * @constructor
	 * @extends CMacroAvecListe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : liste contenant les éléments à utiliser comme objets sources
	 * pour la première itération.
	 * @param {Array} tableProto : Array of CPrototype qui donnent la construction à utiliser suivant le
	 * niveau de récursion en cours.
	 * @param {Integer} pasRec : Le nombre d'objets à sauter avant de réimpleménter la construction
	 * dans un même niveau de récursion.
	 * @param {Integer} nbImp : Le nombre de fois que la construction doit être imlémentée
	 * dans un même niveau de récursion.
	 * @param {Integer} nbSourcesPourIter : Le nombre d'objets sources qui sont communs à toules
	 * les implémentations de construction.
	 * @param {Boolean} creationNiveauMax : true si on ne crée les objets finaux que pour le niveau
	 * maximum de récursions
	 * @param {Boolean} imposerCouleur : si true, tous les objets finaux devront prendre la couleur couleurImp.
	 * @param {Color} couleurImp : La couleur des objets finaux si imposerCouleur est true.
	 * @param {Integer} choixLigne : Si 0, les points finaux ne sont pas reliés, si 1 ils sont reliés
	 * par un polygone et si 2 reliés par une ligne brisée.
	 * @param {StyleTrait} styleLigne : Le style de trait utilisé si choixLigne n'est pas 0.
	 * @param {Color} couleurLigne : La couleur utilisé pour la ligne si choixLigne n'est pas 0.
	 * @param {Boolean} polygoneRempli : trus si choixLigne vaut 1 et qu'on souhaite que le polygone soit rempli.
	 */
	function CMacroConstructionRecursive(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee, tableProto, pasRec, nbImp, nbSourcesPourIter, creationNiveauMax, imposerCouleur, couleurImp, choixLigne, styleLigne, couleurLigne, polygoneRempli) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	      this.tableProto = tableProto;
	      this.pasRec = pasRec;
	      this.nbImp = nbImp;
	      this.nbSourcesPourIter = nbSourcesPourIter;
	      this.creationNiveauMax = creationNiveauMax;
	      this.imposerCouleur = imposerCouleur;
	      this.couleurImp = couleurImp;
	      this.choixLigne = choixLigne;
	      this.styleLigne = styleLigne;
	      this.couleurLigne = couleurLigne;
	      this.polygoneRempli = polygoneRempli;
	    }
	  }
	  this.dejaExecute = false;
	}
	CMacroConstructionRecursive.prototype = new CMacroAvecListe();
	CMacroConstructionRecursive.prototype.constructor = CMacroConstructionRecursive;
	CMacroConstructionRecursive.prototype.superClass = "CMacroAvecListe";
	CMacroConstructionRecursive.prototype.className = "CMacroConstructionRecursive";
	
	CMacroConstructionRecursive.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  return new CMacroConstructionRecursive(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone, this.tableProto, this.pasRec, this.nbImp, this.nbSourcesPourIter, this.creationNiveauMax, this.imposerCouleur, this.couleurImp, this.choixLigne, this.styleLigne, this.couleurLigne, this.polygoneRempli);
	};
	// Version 4.9.7 : On rajoute un paramètre affichage. Les objets ne sont affichés que si le paramètre est présent et true
	CMacroConstructionRecursive.prototype.execute = function (svg, dimf, couleurFond, transparence, affichage) {
	  // On implémente la construction de façon itérative
	  // La liste associée contient les pointeurs sur les objets sources
	  // On affecte ces éléments aux objets sources du prototype
	  var i, j, proto, liste, listePoints, impProto, listeObjetsSourcesConst, eg, listeObjetsSourcesVar, gen, indprot, profond, proto0, poly, ligne, elb;
	  proto0 = this.tableProto[0];
	  for (j = 0; j <= this.profondMax; j++) {
	    proto = this.tableProto[j];
	    for (i = 0; i < proto.nbObjSources; i++) {
	      proto.get(i).elementAssocie = this.listeAssociee.get(i);
	    }
	  }
	  liste = this.listeProprietaire;
	  listePoints = this.choixLigne === 0 ? null : []; // Pour joindre éventuellement les points de dernière génération
	  // Version 4.8 : Dans le cas où une (ou plusieurs) implémentation itérative de la construction a déjà été faite, lorsque de nouveaux points nommés
	  // ou calculs sont créés il faut leur générer un nom. Pour éviter de gros ralentissements lors de l'implémentation, il faut générer ces
	  // noms avec un suffixe numérique qui commence au nombre d'implémentations plus 1.
	  // CLongueur ancienneLongueurUnite = liste.pointeurLongueurUnite;
	  impProto = new CImplementationProto(liste, proto0);
	  // On crée une liste formée des objets sources fixes et une autre formée des objets sources variables.
	  listeObjetsSourcesConst = new CListeObjets();
	  for (i = 0; i < this.nbSourcesPourIter; i++) {
	    eg = proto0.get(i);
	    listeObjetsSourcesConst.add(eg.elementAssocie);
	  }
	  listeObjetsSourcesVar = new CListeObjets();
	  for (i = this.nbSourcesPourIter; i < proto0.nbObjSources; i++) {
	    gen = proto0.get(i);
	    listeObjetsSourcesVar.add(gen.elementAssocie);
	  }
	  indprot = liste.longueur();
	  profond = 0;
	  impProto.implementeRecursif(dimf, liste, this.tableProto, listeObjetsSourcesConst, listeObjetsSourcesVar, this.pasRec, this.nbImp, this.creationNiveauMax, profond, this.profondMax, listePoints);
	  liste.traiteImplementationsProtoSuccessivesRecur(indprot, proto0);
	  // liste.reconstruitChainesCalcul(indprot + 1, indprot + proto0.longueur() - proto0.nbObjSources);
	  if (this.imposerCouleur) {
	    for (i = liste.indexOf(impProto) + 1; i < liste.longueur(); i++) {
	      elb = liste.get(i);
	      if (elb.estElementFinal && elb.estDeNature(NatObj.NTtObj)) {
	        elb.donneCouleur(this.couleurImp);
	      }
	    }
	  }
	  // On regarde si on moins un des objets finaux créés existe
	  // Si demandé un polygone ou une ligne on joint tous les points créés.
	  if (this.choixLigne !== 0) {
	    if (this.choixLigne === 1) {
	      listePoints.push(new CNoeudPointeurSurPoint(liste, listePoints[0].pointeurSurPoint));
	      poly = new CPolygone(liste, null, false, this.couleurLigne, false, this.styleLigne, listePoints);
	      liste.add(poly);
	      poly.positionne(false, dimf);
	      if (this.polygoneRempli) {
	        var s = new CSurfacePolygone(liste, null, false, this.couleurLigne, false, StyleRemplissage.quadrillagePleinTransp, poly);
	        s.positionne(false, dimf);
	        liste.add(s);
	      }
	    } else {
	      ligne = new CLigneBrisee(liste, null, false, this.couleurLigne, false, this.styleLigne, listePoints);
	      liste.add(ligne);
	      ligne.positionne(false, dimf);
	    }
	  }
	  if (arguments.length <= 4 || affichage) this.listeProprietaire.afficheTout(indprot, svg, true, couleurFond, transparence); // Pour créer les éléments graphiques
	  this.termineAction(svg, dimf, couleurFond, transparence);
	  this.dejaExecute = true;
	  // Spécial JavaScript. Dans la version Java c'est fait lors de la sauvegarde de la figure
	  this.listeProprietaire.etablitListesInternesMacros();
	};
	
	CMacroConstructionRecursive.prototype.executionPossible = function () {
	  return !this.dejaExecute;
	};
	
	CMacroConstructionRecursive.prototype.read = function (inps, list) {
	  var i, indProto, r, g, b;
	  CMacroAvecListe.prototype.read.call(this, inps, list);
	  this.profondMax = inps.readInt();
	  this.tableProto = [];
	  for (i = 0; i <= this.profondMax; i++) {
	    indProto = inps.readInt();
	    this.tableProto.push(list.documentProprietaire.tablePrototypes[indProto]);
	  }
	  this.pasRec = inps.readInt();
	  this.nbImp = inps.readInt();
	  this.nbSourcesPourIter = inps.readInt();
	  this.creationNiveauMax = inps.readBoolean();
	  this.imposerCouleur = inps.readBoolean();
	  if (this.imposerCouleur) {
	    r = inps.readByte();
	    g = inps.readByte();
	    b = inps.readByte();
	    this.couleurImp = new Color(r, g, b);
	  }
	  this.choixLigne = inps.readInt();
	  if (this.choixLigne !== 0) {
	    r = inps.readByte();
	    g = inps.readByte();
	    b = inps.readByte();
	    this.couleurLigne = new Color(r, g, b);
	    this.styleLigne = new StyleTrait(list);
	    if (list.numeroVersion < 15) this.styleLigne.readOld(inps, list, false);else this.styleLigne.read(inps, list);
	    if (this.choixLigne === 1) // Polygone
	      this.polygoneRempli = inps.readBoolean();
	  }
	};
	CMacroConstructionRecursive.prototype.write = function (oups, list) {
	  CMacroAvecListe.prototype.write.call(this, oups, list);
	  oups.writeInt(this.profondMax);
	  // On enregistre l'indice du prototype utilisé dans la table des prototype du document
	  for (var i = 0; i <= this.profondMax; i++) {
	    oups.writeInt(list.documentProprietaire.tablePrototypes.indexOf(this.tableProto[i]));
	  }oups.writeInt(this.pasRec);
	  oups.writeInt(this.nbImp);
	  oups.writeInt(this.nbSourcesPourIter);
	  oups.writeBoolean(this.creationNiveauMax);
	  oups.writeBoolean(this.imposerCouleur);
	  if (this.imposerCouleur) {
	    oups.writeByte(this.couleurImp.getRed());
	    oups.writeByte(this.couleurImp.getGreen());
	    oups.writeByte(this.couleurImp.getBlue());
	  }
	  oups.writeInt(this.choixLigne);
	  if (this.choixLigne !== 0) {
	    oups.writeByte(this.couleurLigne.getRed());
	    oups.writeByte(this.couleurLigne.getGreen());
	    oups.writeByte(this.couleurLigne.getBlue());
	    oups.writeInt(this.styleLigne);
	    if (this.styleLigne === 1) oups.writeBoolean(this.polygoneRempli);
	  }
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	var CMacroIncrementationVariable = __webpack_require__(173);
	module.exports = CMacroDecrementationVariable;
	
	/**
	 * Macro décrémentant une variable de la valeur de son pas.
	 * @constructor
	 * @extends CMacroIncrementationVariable
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CVariableBornee} variableAssociee : La variable que la macro décrémente.
	 * @returns {CMacroDecrementationVariable}
	 */
	function CMacroDecrementationVariable(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, variableAssociee) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) {
	      CMacro.call(this, listeProprietaire);
	      this.listeDep = new CListeObjets();
	    } else {
	      CMacroIncrementationVariable.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, variableAssociee);
	    }
	  }
	}
	CMacroDecrementationVariable.prototype = new CMacroIncrementationVariable();
	CMacroDecrementationVariable.prototype.constructor = CMacroDecrementationVariable;
	CMacroDecrementationVariable.prototype.superClass = "CMacroIncrementationVariable";
	CMacroDecrementationVariable.prototype.className = "CMacroDecrementationVariable";
	
	CMacroDecrementationVariable.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.variableAssociee);
	  var ind2 = listeSource.indexOf(this.pointLie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  this.listeDep.initialise(listeCible.uniteAngle, listeCible.pointeurLongueurUnite);
	  return new CMacroDecrementationVariable(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind2, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeCible.get(ind1, "CVariableBornee"));
	};
	CMacroDecrementationVariable.prototype.executionPossible = function () {
	  var nouvelleValeur = this.variableAssociee.rendValeur() - this.variableAssociee.valeurPas;
	  return nouvelleValeur >= this.variableAssociee.valeurMini && nouvelleValeur <= this.variableAssociee.valeurMaxi;
	};
	CMacroDecrementationVariable.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.variableAssociee.decremente();
	  this.listeDep.positionne(true, dimf);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  this.variableAssociee.updateDisplay(); // Pour les variables auxquelles sont associées un dialogue
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroDecrementationVariable.prototype.executeSimple = function () {
	  this.variableAssociee.decremente();
	};

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	module.exports = CMacroIncrementationVariable;
	
	/**
	 *
	 * Macro incrémentant une variable de la valeur de son pas.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CVariableBornee} variableAssociee : La variable que la macro incrémente.
	 * @returns {CMacroIncrementationVariable}
	 */
	function CMacroIncrementationVariable(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, variableAssociee) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	      this.variableAssociee = variableAssociee;
	    }
	  }
	  this.listeDep = new CListeObjets();
	}
	CMacroIncrementationVariable.prototype = new CMacro();
	CMacroIncrementationVariable.prototype.constructor = CMacroIncrementationVariable;
	CMacroIncrementationVariable.prototype.superClass = "CMacro";
	CMacroIncrementationVariable.prototype.className = "CMacroIncrementationVariable";
	
	CMacroIncrementationVariable.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.variableAssociee);
	  var ind2 = listeSource.indexOf(this.pointLie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  this.listeDep.initialise(listeCible.uniteAngle, listeCible.pointeurLongueurUnite);
	  return new CMacroIncrementationVariable(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind2, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeCible.get(ind1, "CVariableBornee"));
	};
	CMacroIncrementationVariable.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMacro.prototype.dependDe.call(this, p) || this.variableAssociee.dependDe(p));
	};
	CMacroIncrementationVariable.prototype.dependDePourBoucle = function (p) {
	  return CMacro.prototype.dependDePourBoucle.call(this, p) || this.variableAssociee.dependDePourBoucle(p);
	};
	CMacroIncrementationVariable.prototype.agitSurVariable = function (va) {
	  return va === this.variableAssociee;
	};
	CMacroIncrementationVariable.prototype.executionPossible = function () {
	  var nouvelleValeur = this.variableAssociee.rendValeur() + this.variableAssociee.valeurPas;
	  return nouvelleValeur >= this.variableAssociee.valeurMini && nouvelleValeur <= this.variableAssociee.valeurMaxi;
	};
	CMacroIncrementationVariable.prototype.executionPossible = function () {
	  var nouvelleValeur = this.variableAssociee.rendValeur() + this.variableAssociee.valeurPas;
	  return nouvelleValeur >= this.variableAssociee.valeurMini && nouvelleValeur <= this.variableAssociee.valeurMaxi;
	};
	CMacroIncrementationVariable.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.variableAssociee.incremente();
	  this.listeDep.positionne(true, dimf);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  this.variableAssociee.updateDisplay(); // Pour les variables auxquelles sont associées un dialogue
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroIncrementationVariable.prototype.executeSimple = function (dimf) {
	  this.variableAssociee.incremente();
	};
	CMacroIncrementationVariable.prototype.etablitListesInternes = function () {
	  this.listeDep = new CListeObjets(this.listeProprietaire.uniteAngle, this.listeProprietaire.pointeurLongueurUnite);
	  this.listeDep.ajouteObjetsDependantsSauf(this.variableAssociee, this.listeProprietaire, this);
	};
	CMacroIncrementationVariable.prototype.metAJour = function () {
	  this.etablitListesInternes();
	};
	CMacroIncrementationVariable.prototype.read = function (inps, list) {
	  CMacro.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.variableAssociee = list.get(ind1, "CVariableBornee");
	  this.listeDep = new CListeObjets(list.uniteAngle, list.pointeurLongueurUnite);
	};
	CMacroIncrementationVariable.prototype.write = function (oups, list) {
	  CMacro.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.variableAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacroAvecListe = __webpack_require__(162);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroDisparition;
	
	/**
	 * Macro masquant des objets de la figure.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : La liste des objets à masquer.
	 * @returns {CMacroDisparition}
	 */
	function CMacroDisparition(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	    }
	  }
	}
	CMacroDisparition.prototype = new CMacroAvecListe();
	CMacroDisparition.prototype.constructor = CMacroDisparition;
	CMacroDisparition.prototype.superClass = "CMacroAvecListe";
	CMacroDisparition.prototype.className = "CMacroDisparition";
	
	CMacroDisparition.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  return new CMacroDisparition(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone);
	};
	CMacroDisparition.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  // Pas d'apparition pas à pas pour la version JavaScript
	  var list = this.listeProprietaire;
	  if (!list.documentProprietaire.modeTraceActive) list.deleteTraces(); // Ajout version 4.9.2
	  this.listeAssociee.montreTout(false);
	  this.executionEnCours = false;
	  this.listeAssociee.update(svg, couleurFond, transparence, true);
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	* MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	* http://www.mathgraph32.org/
	* @Author Yves Biton (yves.biton@sesamath.net)
	* @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	*/
	var kernel = __webpack_require__(8);
	var CMacro = __webpack_require__(157);
	module.exports = CMacroJouantSon;
	
	/**
	 * Macro jouant un fichier sonore. Ce constructeur ne peut être appelé que pour cloner un
	 * objet déjà chargé par read.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {String} wavePath : Le chemin d'accès au fichier sonore (qui doit être un sous chemin
	 * de la page html contenant le svg de la figure.
	 * @param {type} audio : constuit par document.createElement("audio")
	 * @returns {CMacroJouantSon}
	 */
	function CMacroJouantSon(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, wavePath, audio) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	      this.wavePath = wavePath;
	      this.audio = audio;
	    }
	  }
	}
	CMacroJouantSon.prototype = new CMacro();
	CMacroJouantSon.prototype.constructor = CMacroJouantSon;
	CMacroJouantSon.prototype.superClass = "CMacro";
	CMacroJouantSon.prototype.className = "CMacroJouantSon";
	
	CMacroJouantSon.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CMacroJouantSon(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, this.wavePath, this.audio);
	};
	CMacroJouantSon.prototype.executionPossible = function () {
	  return this.audio !== null;
	};
	CMacroJouantSon.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.audio.play();
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroJouantSon.prototype.prepareAudio = function () {
	  var ind;
	  var ch = this.wavePath;
	  if ((ind = ch.indexOf('.')) !== 0) ch = ch.substring(0, ind);
	  this.audio = kernel.ce("audio");
	  if (this.audio.canPlayType("audio/mp3") !== "") ch = ch + ".mp3";else ch = ch + ".ogg";
	  this.audio.setAttribute('src', ch);
	};
	CMacroJouantSon.prototype.read = function (inps, list) {
	  CMacro.prototype.read.call(this, inps, list);
	  this.wavePath = inps.readUTF();
	  this.prepareAudio();
	  this.audio.load();
	};
	CMacroJouantSon.prototype.write = function (oups, list) {
	  CMacro.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.wavePath);
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacro = __webpack_require__(157);
	module.exports = CMacroModeTraceActivation;
	
	/**
	 * Macro activant le mode trace de la figure.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @returns {CMacroModeTraceActivation}
	 */
	function CMacroModeTraceActivation(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	    }
	  }
	}
	CMacroModeTraceActivation.prototype = new CMacro();
	CMacroModeTraceActivation.prototype.constructor = CMacroModeTraceActivation;
	CMacroModeTraceActivation.prototype.superClass = "CMacro";
	CMacroModeTraceActivation.prototype.className = "CMacroModeTraceActivation";
	
	CMacroModeTraceActivation.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CMacroModeTraceActivation(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro);
	};
	CMacroModeTraceActivation.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  var liste = this.listeProprietaire;
	  liste.deleteTraces();
	  liste.documentProprietaire.modeTraceActive = true;
	  liste.positionne(true, dimf);
	  liste.update(svg, couleurFond, transparence, true);
	  // Quand la macro est éxécutée dans l'application et pas dans le player mtg32 il faut aciver l'icone
	  var app = liste.documentProprietaire.app;
	  if (app) {
	    var btn = app["buttonModeTrace"];
	    btn.activate(true);
	  }
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacro = __webpack_require__(157);
	module.exports = CMacroModeTraceDesactivation;
	
	/**
	 * Macro désactivant le mode trace de la figure.
	 * @constructor
	 * @extends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @returns {CMacroModeTraceDesactivation}
	 */
	function CMacroModeTraceDesactivation(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	    }
	  }
	}
	CMacroModeTraceDesactivation.prototype = new CMacro();
	CMacroModeTraceDesactivation.prototype.constructor = CMacroModeTraceDesactivation;
	CMacroModeTraceDesactivation.prototype.superClass = "CMacro";
	CMacroModeTraceDesactivation.prototype.className = "CMacroModeTraceDesactivation";
	
	CMacroModeTraceDesactivation.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CMacroModeTraceDesactivation(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro);
	};
	CMacroModeTraceDesactivation.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  var liste = this.listeProprietaire;
	  liste.deleteTraces();
	  liste.documentProprietaire.modeTraceActive = false;
	  liste.positionne(true, dimf);
	  liste.update(svg, couleurFond, transparence, true);
	  var app = liste.documentProprietaire.app;
	  // Quand la macro est éxécutée dans l'application et pas dans le player mtg32 il faut aciver l'icone
	  if (app) {
	    var btn = app.buttonModeTrace;
	    btn.activate(false);
	  }
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	var CValeur = __webpack_require__(80);
	module.exports = CMacroModificationVariable;
	
	/**
	 *
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CValeur} valMin : La valeur mini qu'on donne à la variable.
	 * @param {CValeur} valMax : La valeur maxi qu'on donne à la variable.
	 * @param {CValeur} valPas : La valeur du pas qu'on donne à la variable.
	 * @param {CValeur} valAct : La valeur actuelle qu'on donne à la variable.
	 * @param {CVariableBornee} variableAssociee : La variable que la macro modifie.
	 * @returns {CMacroModificationVariable}
	 */
	function CMacroModificationVariable(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, valMin, valMax, valPas, valAct, variableAssociee) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	      this.variableAssociee = variableAssociee;
	      this.valMin = valMin;
	      this.valMax = valMax;
	      this.valPas = valPas;
	      this.valAct = valAct;
	    }
	  }
	  this.listeDep = new CListeObjets();
	}
	CMacroModificationVariable.prototype = new CMacro();
	CMacroModificationVariable.prototype.constructor = CMacroModificationVariable;
	CMacroModificationVariable.prototype.superClass = "CMacro";
	CMacroModificationVariable.prototype.className = "CMacroModificationVariable";
	
	CMacroModificationVariable.prototype.getClone = function (listeSource, listeCible) {
	  var valeurMiniClone = this.valMin.getClone(listeSource, listeCible);
	  var valeurMaxiClone = this.valMax.getClone(listeSource, listeCible);
	  var valeurPasClone = this.valPas.getClone(listeSource, listeCible);
	  var valeurActuelleClone = this.valAct.getClone(listeSource, listeCible);
	  var ind1 = listeSource.indexOf(this.variableAssociee);
	  var ind2 = listeSource.indexOf(this.pointLie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  this.listeDep.initialise(listeCible.uniteAngle, listeCible.pointeurLongueurUnite);
	  return new CMacroModificationVariable(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind2, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, valeurMiniClone, valeurMaxiClone, valeurPasClone, valeurActuelleClone, listeCible.get(ind1, "CVariableBornee"));
	  // On ne peut pas à ce niveau faire une image de la liste ListeDep dans la liste clonée car tous
	  // les éléments n'ont pas encoré été chargés.
	  //((CMacroModificationVariable)ptelb).listeDep.setImage(listeDep, listeProprietaire,
	  //  ptelb.listeProprietaire);
	};
	CMacroModificationVariable.prototype.initialisePourDependance = function () {
	  CMacro.prototype.initialisePourDependance.call(this);
	  this.valMin.initialisePourDependance();
	  this.valMax.initialisePourDependance();
	  this.valPas.initialisePourDependance();
	  this.valAct.initialisePourDependance();
	};
	CMacroModificationVariable.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMacro.prototype.dependDe.call(this, p) || this.variableAssociee.dependDe(p) || this.valMin.dependDe(p) || this.valMax.dependDe(p) || this.valPas.dependDe(p) || this.valAct.dependDe(p));
	};
	CMacroModificationVariable.prototype.dependDePourBoucle = function (p) {
	  return CMacro.prototype.dependDePourBoucle.call(this, p) || this.variableAssociee.dependDePourBoucle(p) || this.valMin.dependDePourBoucle(p) || this.valMax.dependDePourBoucle(p) || this.valPas.dependDePourBoucle(p) || this.valAct.dependDePourBoucle(p);
	};
	CMacroModificationVariable.prototype.positionne = function (infoRandom, dimfen) {
	  CMacro.prototype.positionne.call(this, infoRandom, dimfen);
	  this.valMin.positionne(infoRandom, dimfen);
	  this.valMax.positionne(infoRandom, dimfen);
	  this.valPas.positionne(infoRandom, dimfen);
	  this.valAct.positionne(infoRandom, dimfen);
	  this.existe = this.existe && this.valMin.existe && this.valMax.existe && this.valPas.existe && this.valAct.existe;
	};
	CMacroModificationVariable.prototype.agitSurVariable = function (va) {
	  return va === this.variableAssociee;
	};
	CMacroModificationVariable.prototype.affecteValeurAVariable = function (val) {
	  return this.valMin.calcul.dependDe(val) || this.valMax.calcul.dependDe(val) || this.valPas.calcul.dependDe(val) || this.valAct.calcul.dependDe(val);
	};
	CMacroModificationVariable.prototype.executionPossible = function () {
	  var resultat = this.valMin.existe && this.valMax.existe && this.valPas.existe && this.valAct.existe && this.variableAssociee.existe;
	  if (resultat) {
	    var nouvelleValeurMini = this.valMin.rendValeur();
	    var nouvelleValeurMaxi = this.valMax.rendValeur();
	    var nouvelleValeurPas = this.valPas.rendValeur();
	    var nouvelleValeurActuelle = this.valAct.rendValeur();
	    resultat = nouvelleValeurMini < nouvelleValeurMaxi && nouvelleValeurPas < nouvelleValeurMaxi - nouvelleValeurMini && nouvelleValeurActuelle >= nouvelleValeurMini && nouvelleValeurActuelle <= nouvelleValeurMaxi;
	  }
	  return resultat;
	};
	CMacroModificationVariable.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.valMin.positionne(false, dimf);
	  this.valMax.positionne(false, dimf);
	  this.valPas.positionne(false, dimf);
	  this.valAct.positionne(false, dimf);
	  var resultatValeurActuelle = this.valAct.rendValeur();
	  var nouvelleValeurMini = this.valMin.rendValeur();
	  this.variableAssociee.valeurMini = nouvelleValeurMini;
	  if (this.valMin.estConstant) this.variableAssociee.chaineValeurMini = this.valMin.chaineInfo();else {
	    this.variableAssociee.chaineValeurMini = kernel.chaineNombre(nouvelleValeurMini, 12);
	  }
	  var nouvelleValeurMaxi = this.valMax.rendValeur();
	  this.variableAssociee.valeurMaxi = nouvelleValeurMaxi;
	  if (this.valMax.estConstant) this.variableAssociee.chaineValeurMaxi = this.valMax.chaineInfo();else this.variableAssociee.chaineValeurMaxi = kernel.chaineNombre(nouvelleValeurMaxi, 12);
	  this.variableAssociee.valeurPas = this.valPas.rendValeur(false);
	  if (this.valPas.estConstant) this.variableAssociee.chaineValeurPas = this.valPas.chaineInfo();else this.variableAssociee.chaineValeurPas = kernel.chaineNombre(nouvelleValeurMini, 12);
	  this.variableAssociee.donneValeur(resultatValeurActuelle);
	  this.listeDep.positionne(false, dimf);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  this.variableAssociee.updateDisplay(); // Pour les variables auxquelles sont associées un dialogue
	  this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroModificationVariable.prototype.executeSimple = function (dimf) {
	  this.valMin.positionne(true, dimf);
	  this.valMax.positionne(true, dimf);
	  this.valPas.positionne(true, dimf);
	  this.valAct.positionne(true, dimf);
	  var resultatValeurActuelle = this.valAct.rendValeur(false);
	  var nouvelleValeurMini = this.valMin.rendValeur(false);
	  this.variableAssociee.valeurMini = nouvelleValeurMini;
	  if (this.valMin.estConstant) this.variableAssociee.chaineValeurMini = this.valMin.chaineInfo();else {
	    this.variableAssociee.chaineValeurMini = kernel.chaineNombre(nouvelleValeurMini, 12);
	  }
	  var nouvelleValeurMaxi = this.valMax.rendValeur(false);
	  this.variableAssociee.valeurMaxi = nouvelleValeurMaxi;
	  if (this.valMax.estConstant) this.variableAssociee.chaineValeurMaxi = this.valMax.chaineInfo();else this.variableAssociee.chaineValeurMaxi = kernel.chaineNombre(nouvelleValeurMaxi, 12);
	  this.variableAssociee.valeurPas = this.valPas.rendValeur();
	  if (this.valPas.estConstant) this.variableAssociee.chaineValeurPas = this.valPas.chaineInfo();else this.variableAssociee.chaineValeurPas = kernel.chaineNombre(nouvelleValeurMini, 12);
	  this.variableAssociee.donneValeur(resultatValeurActuelle);
	};
	CMacroModificationVariable.prototype.metAJour = function () {
	  this.etablitListesInternes();
	};
	CMacroModificationVariable.prototype.etablitListesInternes = function () {
	  this.listeDep = new CListeObjets(this.listeProprietaire.uniteAngle, this.listeProprietaire.pointeurLongueurUnite);
	  this.listeDep.ajouteObjetsDependantsSauf(this.variableAssociee, this.listeProprietaire, this);
	};
	CMacroModificationVariable.prototype.read = function (inps, list) {
	  CMacro.prototype.read.call(this, inps, list);
	  this.valMin = new CValeur();
	  this.valMin.read(inps, list);
	  this.valMax = new CValeur();
	  this.valMax.read(inps, list);
	  this.valPas = new CValeur();
	  this.valPas.read(inps, list);
	  this.valAct = new CValeur();
	  this.valAct.read(inps, list);
	  var ind1 = inps.readInt();
	  this.variableAssociee = list.get(ind1, "CVariableBornee");
	  // Il faut créer la liste des éléments dépendant de la variable modifiée
	  // Pour cette liste, on fait pointer la longueur unité éventuelle sur la lsite mère
	  this.listeDep = new CListeObjets(list.uniteAngle, list.pointeurLongueurUnite);
	};
	CMacroModificationVariable.prototype.write = function (oups, list) {
	  CMacro.prototype.write.call(this, oups, list);
	  this.valMin.write(oups, list);
	  this.valMax.write(oups, list);
	  this.valPas.write(oups, list);
	  this.valAct.write(oups, list);
	  var ind1 = list.indexOf(this.variableAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacro = __webpack_require__(157);
	module.exports = CMacroPause;
	
	/**
	 * Macro faisant une pause dans un animation. La durée est dureePause en secondes.
	 * @constructor
	 * @etends CMacro
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {Integer} dureePause : La durée de la pause en secondes.
	 * @returns {CMacroPause}
	 */
	function CMacroPause(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, dureePause) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacro.call(this, listeProprietaire);else {
	      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro);
	      this.dureePause = dureePause;
	    }
	  }
	}
	CMacroPause.prototype = new CMacro();
	CMacroPause.prototype.constructor = CMacroPause;
	CMacroPause.prototype.superClass = "CMacro";
	CMacroPause.prototype.className = "CMacroPause";
	
	CMacroPause.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CMacroPause(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, this.dureePause);
	};
	CMacroPause.prototype.typeAnimation = function () {
	  return this.dureePause !== 0 ? CMacro.animationParTimer : CMacro.sansAnimation;
	};
	CMacroPause.prototype.arretParClic = function () {
	  return false;
	};
	CMacroPause.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  clearInterval(this.timer);
	  this.executionEnCours = false;
	  this.passageMacroSuiv(svg, dimf, couleurFond, transparence, true);
	};
	CMacroPause.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.executionEnCours = true;
	  if (this.dureePause !== 0) {
	    var timeDebut = +new Date();
	    this.timeFin = timeDebut + this.dureePause * 1000; // La durée est en secondes
	    var t = this;
	    this.timer = setInterval(function () {
	      CMacroPause.executePourTimer.call(t, svg, dimf, couleurFond, transparence);
	    }, 50); // Timer au 5 centième de seconde
	  }
	};
	/**
	 * Fonction de callBack appelée par un timer dans execute()
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroPause.executePourTimer = function (svg, dimf, couleurFond, transparence) {
	  if (!this.executionEnCours) return;
	  var time = +new Date(); // Raccourci pour (new Date()).getTime()
	  if (time > this.timeFin) this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroPause.prototype.read = function (inps, list) {
	  CMacro.prototype.read.call(this, inps, list);
	  this.dureePause = inps.readInt();
	};
	CMacroPause.prototype.write = function (oups, list) {
	  CMacroPause.prototype.write.call(this, oups, list);
	  oups.writeInt(this.dureePause);
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CMacro = __webpack_require__(157);
	var CMacroAvecListe = __webpack_require__(162);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroSuiteMacros;
	
	/**
	 * Macro exécutant à la suite les une des autres une liste de macros.
	 * @constructor
	 * @extends CMacroAvecListe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : Liste contenant les macros à exécuter.
	 * @returns {CMacroSuiteMacros}
	 */
	function CMacroSuiteMacros(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	    }
	  }
	}
	CMacroSuiteMacros.prototype = new CMacroAvecListe();
	CMacroSuiteMacros.prototype.constructor = CMacroSuiteMacros;
	CMacroSuiteMacros.prototype.superClass = "CMacroAvecListe";
	CMacroSuiteMacros.prototype.className = "CMacroSuiteMacros";
	
	CMacroSuiteMacros.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  return new CMacroSuiteMacros(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind1, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone);
	};
	CMacroSuiteMacros.prototype.macroEnCours = function () {
	  if (this.indiceMacroEnCours < this.listeAssociee.longueur()) return this.listeAssociee.get(this.indiceMacroEnCours).macroEnCours();else return this;
	};
	/**
	 * Ajout version 5.1
	 * Il faut mettre indiceMacroEnCours à 0 car une macro peut déjà avoir été utilisée dans une autre macro
	 * @param {type} mac
	 * @returns {undefined}
	 */
	CMacroSuiteMacros.prototype.setMacroLanceuse = function (mac) {
	  CMacro.prototype.setMacroLanceuse.call(this, mac);
	  this.indiceMacroEnCours = 0;
	};
	
	CMacroSuiteMacros.prototype.initialise = function () {
	  var ptMacro = this.listeAssociee.get(0);
	  ptMacro.initialise();
	  ptMacro.setMacroLanceuse(this);
	  this.indiceMacroEnCours = 0;
	  this.executionEnCours = true;
	  var mac = this.macroEnCours();
	  mac.initialise();
	  mac.executionEnCours = true;
	};
	CMacroSuiteMacros.prototype.typeAnimation = function () {
	  if (this.indiceMacroEnCours < this.listeAssociee.longueur()) return this.macroEnCours().typeAnimation();else return CMacro.sansAnimation;
	};
	/**
	 * Fait passer à l'exécution de la macro suivante de la liste.
	 * @param {svg} svg : Le svg de la figure.
	 * @param {mtg32.dimf} dimf : Les dimensions du svg
	 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
	 * @param {Integer} transparence : Le coeficient de transparence de la figure.
	 * @returns {undefined}
	 */
	CMacroSuiteMacros.prototype.passageMacroSuiv = function (svg, dimf, couleurFond, transparence) {
	  // Modification java : si la macro en cours est une macro d'apparition d'objets avec clic pour
	  // passer à l'objet suivant, on ne passe à la macro suivante qui si le dernier objet a été affiché.
	  // Sinon on fait apparaitre l'objet suivant
	  var mac = this.macroEnCours();
	  if (mac.className === "CMacroApparition") {
	    if (mac.clicPourObjetSuivant && mac.indiceDernierObjetTraite < mac.listeAssociee.longueur() - 1) {
	      this.listeProprietaire.update(svg, couleurFond, transparence, true);
	      return;
	    }
	  }
	  // mac.termineAction(svg, dimf, couleurFond, transparence);
	  this.indiceMacroEnCours++;
	  if (this.indiceMacroEnCours < this.listeAssociee.longueur()) {
	    mac = this.listeAssociee.get(this.indiceMacroEnCours); // Puet pointer sur une CMacroSuiteMacros
	    mac.setMacroLanceuse(this);
	    mac.initialise();
	    mac = this.macroEnCours();
	    mac.initialise();
	    //if (macroEnCours().typeAnimation() == CMacro.sansAnimation) cadre.paneFigure.repaint();
	    //executionEnCours = true;
	    mac.execute(svg, dimf, couleurFond, transparence, true);
	  } else {
	    /* Modification version 5.0
	    this.listeProprietaire.macroEnCours = null;
	    this.executionEnCours = false;
	    */
	    this.executionEnCours = false;
	    if (this.macroLanceuse === null) {
	      this.listeProprietaire.macroEnCours = null;
	    } else {
	      this.macroLanceuse.passageMacroSuiv(svg, dimf, couleurFond, transparence);
	    }
	  }
	};
	CMacroSuiteMacros.prototype.agitSurVariable = function (va) {
	  var resultat = false;
	  for (var i = 0; i < this.listeAssociee.longueur(); i++) {
	    var ptMacro = this.listeAssociee.get(i);
	    resultat = resultat || ptMacro.agitSurVariable(va);
	  }
	  return resultat;
	};
	CMacroSuiteMacros.prototype.affecteValeurAVariable = function (val) {
	  var resultat = false;
	  for (var i = 0; i < this.listeAssociee.longueur(); i++) {
	    var ptMacro = this.listeAssociee.get(i);
	    resultat = resultat || ptMacro.affecteValeurAVariable(val);
	  }
	  return resultat;
	};
	CMacroSuiteMacros.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  var mac;
	  // Modification version 5.1 : On informe chaque macro de la liste de la macro qui la lance
	  for (var i = 0; i < this.listeAssociee.longueur(); i++) {
	    mac = this.listeAssociee.get(i);
	    mac.setMacroLanceuse(this);
	  }
	  //
	  mac = this.listeAssociee.get(0);
	  mac.execute(svg, dimf, couleurFond, transparence);
	};
	CMacroSuiteMacros.prototype.executeSimple = function (dimf) {
	  for (var i = 0; i < this.listeAssociee.longueur(); i++) {
	    var mac = this.listeAssociee.get(i);
	    mac.executeSimple(dimf);
	  }
	};
	CMacroSuiteMacros.prototype.executionPossible = function () {
	  var resultat = true;
	  for (var i = 0; i < this.listeAssociee.longueur(); i++) {
	    var ptMacro = this.listeAssociee.get(i);
	    resultat = resultat && ptMacro.executionPossible();
	  }
	  return resultat;
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	var CMacroAvecListe = __webpack_require__(162);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroTraceAuto;
	
	/**
	 * Macro faisant apparaître une trace des objets contenus dans listeAssociee
	 * générée par les déplacements d'un point lié, sans animation.
	 * @constructor
	 * @extends CMacroAvecListe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : Liste contenant les objets qui doivet laisser une trace.
	 * @param {CPointLie} pointLieAssocie : Le point lié dont les positions génèrent la trace.
	 * @param {Integer} nombrePointsPourTrace : Le nombre de positions du point lié pour générer la trace.
	 * @param {Integer} frequenceAnimationMacro : Donne la fréquence d'animation en millièmes de deconde.
	 * @returns {CMacroTraceAuto}
	 */
	function CMacroTraceAuto(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee, pointLieAssocie, nombrePointsPourTrace, frequenceAnimationMacro) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	      this.pointLieAssocie = pointLieAssocie;
	      this.nombrePointsPourTrace = nombrePointsPourTrace;
	      this.frequenceAnimationMacro = frequenceAnimationMacro;
	      this.listeDep = new CListeObjets(listeProprietaire);
	    }
	  }
	}
	CMacroTraceAuto.prototype = new CMacroAvecListe();
	CMacroTraceAuto.prototype.constructor = CMacroTraceAuto;
	CMacroTraceAuto.prototype.superClass = "CMacroAvecListe";
	CMacroTraceAuto.prototype.className = "CMacroTraceAuto";
	
	CMacroTraceAuto.prototype.getClone = function (listeSource, listeCible) {
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  var ind1 = listeSource.indexOf(this.pointLieAssocie);
	  var ind2 = listeSource.indexOf(this.pointLie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var ptelb = new CMacroTraceAuto(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind2, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone, listeCible.get(ind1, "CPointLie"), this.nombrePointsPourTrace, this.frequenceAnimationMacro);
	  ptelb.listeDep = new CListeObjets(listeCible.uniteAngle, listeCible.pointeurLongueurUnite);
	  return ptelb;
	};
	CMacroTraceAuto.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMacroAvecListe.prototype.dependDe.call(this, p) || this.pointLieAssocie.dependDe(p));
	};
	CMacroTraceAuto.prototype.dependDePourBoucle = function (p) {
	  return CMacroAvecListe.prototype.dependDePourBoucle.call(this, p) || this.pointLieAssocie.dependDePourBoucle(p);
	};
	CMacroTraceAuto.prototype.executionPossible = function () {
	  return this.pointLieAssocie.existe;
	};
	CMacroTraceAuto.prototype.etablitListesInternes = function () {
	  this.listeDep.retireTout();
	  this.listeDep.ajouteObjetsDependantsSauf(this.pointLieAssocie, this.listeProprietaire, this);
	};
	CMacroTraceAuto.prototype.metAJour = function () {
	  CMacroAvecListe.prototype.metAJour.call(this);
	  this.etablitListesInternes();
	};
	CMacroTraceAuto.prototype.typeAnimation = function () {
	  if (this.frequenceAnimationMacro === 0) return CMacro.sansAnimation;else return CMacro.animationParTimer;
	};
	CMacroTraceAuto.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointLieAssocie === ancienPoint) this.pointLieAssocie = nouveauPoint;
	};
	CMacroTraceAuto.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.pointLieAssocie);
	  liste.ajouteElementsDe(this.listeAssociee);
	};
	CMacroTraceAuto.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.listeProprietaire.initialiseTraces();
	  this.abscisseInitiale = this.pointLieAssocie.abscisse;
	  this.abscisseMini = this.pointLieAssocie.abscisseMinimale();
	  this.abscisseMaxi = this.pointLieAssocie.abscisseMaximale();
	  if (this.abscisseMini > this.abscisseMaxi) {
	    var d = this.abscisseMini;
	    this.abscisseMini = this.abscisseMaxi;
	    this.abscisseMaxi = d;
	  }
	  // Modification pour la version 1.9.5
	  var nbValeurs;
	  // Modification pour la version 1.9.5
	  if (this.pointLieAssocie.lieALigneFermee()) nbValeurs = this.nombrePointsPourTrace;else nbValeurs = this.nombrePointsPourTrace - 1;
	
	  this.pas = (this.abscisseMaxi - this.abscisseMini) / nbValeurs;
	  this.abscisse = this.abscisseMini - this.pas;
	  this.indicePointEnCours = 0; // Pour le cas où la fréquence est non nulle
	  this.executionEnCours = true;
	  if (this.frequenceAnimationMacro === 0) {
	    for (var i = 1; i <= this.nombrePointsPourTrace; i++) {
	      this.abscisse = this.abscisse + this.pas;
	      this.pointLieAssocie.donneAbscisse(this.abscisse);
	      this.listeDep.positionne(false, dimf);
	      this.listeProprietaire.addTraces(this.listeAssociee);
	    }
	    this.termineAction(svg, dimf, couleurFond, transparence);
	  } else {
	    var t = this;
	    this.timer = setInterval(function () {
	      CMacroTraceAuto.executePourTimer.call(t, svg, dimf, couleurFond, transparence);
	    }, this.frequenceAnimationMacro);
	  }
	};
	CMacroTraceAuto.executePourTimer = function (svg, dimf, couleurFond, transparence) {
	  this.indicePointEnCours++;
	  if (this.indicePointEnCours >= this.nombrePointsPourTrace) this.abscisse = this.abscisseMaxi;else this.abscisse = this.abscisse + this.pas;
	  this.pointLieAssocie.donneAbscisse(this.abscisse);
	  this.listeDep.positionne(false.infRand, dimf);
	  this.listeProprietaire.addTraces(this.listeAssociee);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  if (this.indicePointEnCours === this.nombrePointsPourTrace) this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroTraceAuto.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  if (this.timer !== null) clearInterval(this.timer);
	  this.executionEnCours = false;
	  this.pointLieAssocie.donneAbscisse(this.abscisseInitiale);
	  this.listeDep.positionne(false, dimf);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  this.passageMacroSuiv(svg, dimf, couleurFond, transparence, true);
	};
	CMacroTraceAuto.prototype.read = function (inps, list) {
	  CMacroAvecListe.prototype.read.call(this, inps, list);
	  this.nombrePointsPourTrace = inps.readInt();
	  this.frequenceAnimationMacro = inps.readInt();
	  var ind1 = inps.readInt();
	  this.pointLieAssocie = list.get(ind1, "CPointLie");
	  if (list.classsName !== "CPrototype") this.listeDep = new CListeObjets(this.listeProprietaire);
	};
	CMacroTraceAuto.prototype.write = function (oups, list) {
	  CListeObjets.prototype.write.call(this, oups, list);
	  oups.writeInt(this.nombrePointsPourTrace);
	  oups.writeInt(this.frequenceAnimationMacro);
	  var ind1 = list.indexOf(this.pointLieAssocie);
	  oups.writeInt(ind1);
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CListeObjets = __webpack_require__(17);
	var CMacro = __webpack_require__(157);
	var CMacroAvecListe = __webpack_require__(162);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CMacroTraceAutoParVariable;
	
	/**
	 * Macro faisant apparaître une trace des objets contenus dans listeAssociee
	 * générée par les déplacements d'une variable, sans animation.
	 * @constructor
	 * @extends CMacroAvecListe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {Float} x_nom : L'abscisse d'affichage de la macro
	 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
	 * @param {Integer} dec_x : Décalage horizontal du nom
	 * @param {Integer} dec_y : Décalage vertical du nom
	 * @param {Boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
	 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {String} intitule : Le titre de la macro
	 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
	 * @param {CListeObjets} listeAssociee : Liste contenant les objets qui doivet laisser une trace.
	 * @param {CVariableBornee} variableAssociee : La variable dont les valeurs génèrent la trace.
	 * @param {Integer} nombrePointsPourTrace : Le nombre de positions du point lié pour générer la trace.
	 * @param {Integer} frequenceAnimationMacro : Donne la fréquence d'animation en millièmes de deconde.
	 * @returns {CMacroTraceAutoParVariable}
	 */
	function CMacroTraceAutoParVariable(listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee, variableAssociee, nombrePointsPourTrace, frequenceAnimationMacro) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CMacroAvecListe.call(this, listeProprietaire);else {
	      CMacroAvecListe.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond, alignementHorizontal, alignementVertical, intitule, commentaireMacro, listeAssociee);
	      this.variableAssociee = variableAssociee;
	      this.nombrePointsPourTrace = nombrePointsPourTrace;
	      this.frequenceAnimationMacro = frequenceAnimationMacro;
	      this.listeDep = new CListeObjets(listeProprietaire);
	    }
	  }
	}
	CMacroTraceAutoParVariable.prototype = new CMacroAvecListe();
	CMacroTraceAutoParVariable.prototype.constructor = CMacroTraceAutoParVariable;
	CMacroTraceAutoParVariable.prototype.superClass = "CMacroAvecListe";
	CMacroTraceAutoParVariable.prototype.className = "CMacroTraceAutoParVariable";
	
	CMacroTraceAutoParVariable.prototype.getClone = function (listeSource, listeCible) {
	  var listeAssocieeClone = new CSousListeObjets();
	  listeAssocieeClone.setImage(this.listeAssociee, listeSource, listeCible);
	  var ind1 = listeSource.indexOf(this.variableAssociee);
	  var ind2 = listeSource.indexOf(this.pointLie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var ptelb = new CMacroTraceAutoParVariable(listeCible, listeCible.get(ind3, "CImplementationProto.class"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind2, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, this.intitule, this.commentaireMacro, listeAssocieeClone, listeCible.get(ind1, "CVariableBornee"), this.frequenceAnimationMacro);
	  ptelb.listeDep = new CListeObjets(listeCible.uniteAngle, listeCible.pointeurLongueurUnite);
	  return ptelb;
	};
	CMacroTraceAutoParVariable.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMacroAvecListe.prototype.dependDe.call(this, p) || this.variableAssociee.dependDe(p));
	};
	CMacroTraceAutoParVariable.prototype.dependDePourBoucle = function (p) {
	  return CMacroAvecListe.prototype.dependDePourBoucle.call(this, p) || this.variableAssociee.dependDePourBoucle(p);
	};
	CMacroTraceAutoParVariable.prototype.executionPossible = function () {
	  return this.variableAssociee.existe;
	};
	CMacroTraceAutoParVariable.prototype.etablitListesInternes = function () {
	  this.listeDep.retireTout();
	  this.listeDep.ajouteObjetsDependantsSauf(this.variableAssociee, this.listeProprietaire, this);
	};
	CMacroTraceAutoParVariable.prototype.metAJour = function () {
	  CMacroAvecListe.prototype.metAJour.call(this);
	  this.etablitListesInternes();
	};
	CMacroTraceAutoParVariable.prototype.typeAnimation = function () {
	  if (this.frequenceAnimationMacro === 0) return CMacro.sansAnimation;else return CMacro.animationParTimer;
	};
	CMacroTraceAutoParVariable.prototype.ajouteAntecedents = function (liste) {
	  liste.ajouteElementsDe(this.listeAssociee);
	};
	CMacroTraceAutoParVariable.prototype.execute = function (svg, dimf, couleurFond, transparence) {
	  this.listeProprietaire.initialiseTraces();
	  this.pas = this.variableAssociee.valeurPas;
	  this.valeurMini = this.variableAssociee.valeurMini;
	  this.valeurMaxi = this.variableAssociee.valeurMaxi;
	  this.valeurInitiale = this.variableAssociee.valeurActuelle;
	  this.executionEnCours = true;
	  if (this.frequenceAnimationMacro === 0) {
	    this.valeur = this.valeurMini;
	    while (this.valeur <= this.valeurMaxi) {
	      this.variableAssociee.donneValeur(this.valeur);
	      this.listeDep.positionne(false, dimf);
	      this.listeProprietaire.addTraces(this.listeAssociee);
	      this.valeur = this.valeur + this.pas;
	    }
	    this.termineAction(svg, dimf, couleurFond, transparence);
	  } else {
	    this.valeur = this.valeurMini - this.pas;
	    var t = this;
	    this.timer = setInterval(function () {
	      CMacroTraceAutoParVariable.executePourTimer.call(t, svg, dimf, couleurFond, transparence);
	    }, this.frequenceAnimationMacro);
	  }
	};
	CMacroTraceAutoParVariable.executePourTimer = function (svg, dimf, couleurFond, transparence) {
	  this.valeur = this.valeur + this.pas;
	  if (this.valeur > this.valeurMaxi) this.valeur = this.valeurMaxi;
	  this.variableAssociee.donneValeur(this.valeur);
	  this.listeDep.positionne(false, dimf);
	  this.listeProprietaire.addTraces(this.listeAssociee);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  if (this.valeur >= this.valeurMaxi) this.termineAction(svg, dimf, couleurFond, transparence);
	};
	CMacroTraceAutoParVariable.prototype.termineAction = function (svg, dimf, couleurFond, transparence) {
	  if (this.timer !== null) clearInterval(this.timer);
	  this.executionEnCours = false;
	  this.variableAssociee.donneValeur(this.valeurInitiale);
	  this.listeDep.positionne(false, dimf);
	  this.listeDep.update(svg, couleurFond, transparence, true);
	  this.passageMacroSuiv(svg, dimf, couleurFond, transparence, true);
	};
	CMacroTraceAutoParVariable.prototype.read = function (inps, list) {
	  CMacroAvecListe.prototype.read.call(this, inps, list);
	  this.frequenceAnimationMacro = inps.readInt();
	  var ind1 = inps.readInt();
	  this.variableAssociee = list.get(ind1, "CVariableBornee");
	  if (list.className !== "CPrototype") this.listeDep = new CListeObjets(this.listeProprietaire);
	};
	CMacroTraceAutoParVariable.prototype.write = function (oups, list) {
	  CMacroAvecListe.prototype.write.call(this, oups, list);
	  oups.writeInt(this.frequenceAnimationMacro);
	  var ind1 = list.indexOf(this.variableAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var StyleMarqueAngle = __webpack_require__(184);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CCercle = __webpack_require__(75);
	var CMarqueSegment = __webpack_require__(186);
	var CSegment = __webpack_require__(134);
	var CPointBase = __webpack_require__(85);
	module.exports = CMarqueAngleAncetre;
	
	/**
	 * Classe ancêtre de toutes les marques d'angle.
	 * @constructor
	 * @extends CCercle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StleTrait} style : Donne le style trait utilisé.
	 * @param {StyleMarqueAngle} styleMarque : Donne le style de la marque.
	 * @param {Float} rayon : Le rayon de l'arc.
	 * @returns {CMarqueAngleAncetre}
	 */
	function CMarqueAngleAncetre(listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CCercle.call(this, listeProprietaire);else {
	    CCercle.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style);
	    this.styleMarque = styleMarque;
	    this.rayon = rayon;
	  }
	  this.u = new Vect();
	  this.v = new Vect();
	  this.point1 = new CPointBase();
	  this.point2 = new CPointBase();
	  this.pointc = new CPointBase();
	  this.segment1 = new CSegment(this.point2, this.pointc);
	  this.marqueSegment = new CMarqueSegment(listeProprietaire, null, false, null, false, style, StyleMarqueAngle.styleMarqueSegment(styleMarque), this.segment1);
	}
	CMarqueAngleAncetre.prototype = new CCercle();
	CMarqueAngleAncetre.prototype.constructor = CMarqueAngleAncetre;
	CMarqueAngleAncetre.prototype.superClass = "CCercle";
	CMarqueAngleAncetre.prototype.className = "CMarqueAngleAncetre";
	
	CMarqueAngleAncetre.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CMarqueAngleAncetre.prototype.setClone = function (ptel) {
	  CCercle.prototype.setClone.call(this, ptel);
	  ptel.u.setCopy(this.u);
	  ptel.v.setCopy(this.v);
	  this.point1.placeEn(ptel.point1);
	  this.point2.placeEn(ptel.point2);
	  this.pointc.placeEn(ptel.pointc);
	  this.ang1rad = ptel.ang1rad;
	  this.ang2rad = ptel.ang2rad;
	};
	CMarqueAngleAncetre.prototype.getNature = function () {
	  return NatObj.NMarqueAngle;
	};
	/**
	 * Utilisé lorsque l'angle est droit.
	 * @returns {undefined}
	 */
	CMarqueAngleAncetre.prototype.prepareAngleDroit = function () {
	  var normeu, normev, u1, v1;
	  u1 = new Vect();
	  v1 = new Vect();
	  normeu = this.u.norme();
	  normev = this.v.norme();
	  u1.x = this.u.x / normeu * this.rayon;
	  u1.y = this.u.y / normeu * this.rayon;
	  v1.x = this.v.x / normev * this.rayon;
	  v1.y = this.v.y / normev * this.rayon;
	  this.point1.x = this.centre_x + v1.x;
	  this.point1.y = this.centre_y + v1.y;
	  this.pointc.x = this.point1.x + u1.x;
	  this.pointc.y = this.point1.y + u1.y;
	  this.point2.x = this.centre_x + u1.x;
	  this.point2.y = this.centre_y + u1.y;
	};
	/**
	 * Renvoie le svg element qui représente la marque d'angle quand l'angle est droit.
	 * @param {Float} transparence : La transparence utilisée quand la marque d'anglee est remplie.
	 * @returns {svgElement}
	 */
	CMarqueAngleAncetre.prototype.creategAngleDroit = function (transparence) {
	  var g, line, pol, points;
	  g = kernel.cens("g", {
	    "pointer-events": "none"
	  });
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  // style += "stroke:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	  style += "stroke:" + this.color + ";";
	  line = kernel.cens("line", {
	    x1: this.point1.x,
	    y1: this.point1.y,
	    x2: this.pointc.x,
	    y2: this.pointc.y,
	    style: style
	  });
	  g.appendChild(line);
	  line = kernel.cens("line", {
	    x1: this.point2.x,
	    y1: this.point2.y,
	    x2: this.pointc.x,
	    y2: this.pointc.y,
	    style: style
	  });
	  g.appendChild(line);
	  if ((this.styleMarque & StyleMarqueAngle.marqueRemplie) !== 0) {
	    points = this.centre_x + "," + this.centre_y + " " + this.point1.x + "," + this.point1.y + " " + this.pointc.x + "," + this.pointc.y + " " + this.point2.x + " " + this.point2.y;
	    style = "stroke:none;";
	    style += "fill-opacity:" + transparence + ";";
	    // style += "fill:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	    style += "fill:" + this.color + ";";
	    pol = kernel.cens("polygon", {
	      style: style,
	      points: points
	    });
	    g.appendChild(pol);
	  }
	  return g;
	};
	/**
	 * Renvoie le svg element qui représente la marque d'angle quand l'angle n'est pas droit.
	 * @param {Float} xdeb : Abscisse du point de départ de l'angle.
	 * @param {Float} ydeb : Ordonnée du point de départ de l'angle.
	 * @param {Float} xcentre : Abscisse du centre de l'arc.
	 * @param {Float} ycentre : Ordonnée du centre de l'arc.
	 * @param {Float} ang : L'angle au centre.
	 * @returns {svgElement}
	 */
	CMarqueAngleAncetre.prototype.creategMarqueAngle = function (xdeb, ydeb, xcentre, ycentre, ang) {
	  var g, line, xmilieu, ymilieu, xc1, yc1, ang2, nvec, demilong;
	  g = kernel.cens("g");
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  // style += "stroke:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	  style += "stroke:" + this.color + ";";
	  var vec1 = new Vect(xcentre, ycentre, xdeb, ydeb);
	  var vec = new Vect();
	  var vect2 = new Vect();
	  vec1.tourne(ang / 2, vec);
	  nvec = vec.norme();
	  vec.x = vec.x / nvec;
	  vec.y = vec.y / nvec;
	  // Modification version 5.0 pour tenir compte des figures haute résolution
	  // demilong = 5;
	  demilong = 5;
	  switch (this.styleMarque) {
	    case StyleMarqueAngle.marqueSimple1Trait:
	    case StyleMarqueAngle.marquePleine1Trait:
	      xmilieu = this.centre_x + vec.x * this.rayon;
	      ymilieu = this.centre_y + vec.y * this.rayon;
	      line = kernel.cens("line", {
	        x1: xmilieu - vec.x * demilong,
	        y1: ymilieu - vec.y * demilong,
	        x2: xmilieu + vec.x * demilong,
	        y2: ymilieu + vec.y * demilong,
	        style: style
	      });
	      g.appendChild(line);
	      break;
	    case StyleMarqueAngle.marqueSimple2Traits:
	    case StyleMarqueAngle.marquePleine2Traits:
	      ang2 = Math.atan(3 / this.rayon); // Environ 10 pixels entre les deux traits
	      vec.tourne(ang2, vect2);
	      xc1 = this.centre_x + vect2.x * this.rayon;
	      yc1 = this.centre_y + vect2.y * this.rayon;
	      line = kernel.cens("line", {
	        x1: xc1 - vec.x * demilong,
	        y1: yc1 - vec.y * demilong,
	        x2: xc1 + vec.x * demilong,
	        y2: yc1 + vec.y * demilong,
	        style: style
	      });
	      g.appendChild(line);
	      vec.tourne(-ang2, vect2);
	      xc1 = this.centre_x + vect2.x * this.rayon;
	      yc1 = this.centre_y + vect2.y * this.rayon;
	      line = kernel.cens("line", {
	        x1: xc1 - vec.x * demilong,
	        y1: yc1 - vec.y * demilong,
	        x2: xc1 + vec.x * demilong,
	        y2: yc1 + vec.y * demilong,
	        style: style
	      });
	      g.appendChild(line);
	      break;
	    case StyleMarqueAngle.marqueSimple3Traits:
	    case StyleMarqueAngle.marquePleine3Traits:
	      xmilieu = this.centre_x + vec.x * this.rayon;
	      ymilieu = this.centre_y + vec.y * this.rayon;
	      line = kernel.cens("line", {
	        x1: xmilieu - vec.x * demilong,
	        y1: ymilieu - vec.y * demilong,
	        x2: xmilieu + vec.x * demilong,
	        y2: ymilieu + vec.y * demilong,
	        style: style
	      });
	      g.appendChild(line);
	      ang2 = Math.atan(5 / this.rayon); // Environ 5 pixels entre les deux traits
	      vec.tourne(ang2, vect2);
	      xc1 = this.centre_x + vect2.x * this.rayon;
	      yc1 = this.centre_y + vect2.y * this.rayon;
	      line = kernel.cens("line", {
	        x1: xc1 - vec.x * demilong,
	        y1: yc1 - vec.y * demilong,
	        x2: xc1 + vec.x * demilong,
	        y2: yc1 + vec.y * demilong,
	        style: style
	      });
	      g.appendChild(line);
	      vec.tourne(-ang2, vect2);
	      xc1 = this.centre_x + vect2.x * this.rayon;
	      yc1 = this.centre_y + vect2.y * this.rayon;
	      line = kernel.cens("line", {
	        x1: xc1 - vec.x * demilong,
	        y1: yc1 - vec.y * demilong,
	        x2: xc1 + vec.x * demilong,
	        y2: yc1 + vec.y * demilong,
	        style: style
	      });
	      g.appendChild(line);
	      break;
	    case StyleMarqueAngle.marqueSimpleCroix:
	    case StyleMarqueAngle.marquePleineCroix:
	      xmilieu = this.centre_x + vec.x * this.rayon;
	      ymilieu = this.centre_y + vec.y * this.rayon;
	      vec.tourne(Math.PI / 4, vect2);
	      line = kernel.cens("line", {
	        x1: xmilieu - vect2.x * demilong,
	        y1: ymilieu - vect2.y * demilong,
	        x2: xmilieu + vect2.x * demilong,
	        y2: ymilieu + vect2.y * demilong,
	        style: style
	      });
	      g.appendChild(line);
	      vec.tourne(-Math.PI / 4, vect2);
	      line = kernel.cens("line", {
	        x1: xmilieu - vect2.x * demilong,
	        y1: ymilieu - vect2.y * demilong,
	        x2: xmilieu + vect2.x * demilong,
	        y2: ymilieu + vect2.y * demilong,
	        style: style
	      });
	      g.appendChild(line);
	  }
	  g.setAttribute("pointer-events", "none");
	  return g;
	};
	CMarqueAngleAncetre.prototype.createg = function (svg, couleurFond, transparence) {
	  var g, p, path, p2, path2, style, stroke;
	  var n = this.className;
	  var skipRightAngle = n === "CMarqueAngleOrienteDirecte" && this.angleDroit && this.angle < 0 || n === "CMarqueAngleOrienteIndirecte" && this.angleDroit && this.angle > 0;
	  if (this.angleDroit && !skipRightAngle) return CMarqueAngleAncetre.prototype.creategAngleDroit.call(this, transparence);
	  var mesureAngle = this.anglePourArc();
	  g = kernel.cens("g", {
	    "pointer-events": "none"
	  });
	  p = this.path(mesureAngle);
	  style = "";
	  stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  // style += "stroke:"+this.couleur.rgb()+";fill:none"; Modifié version 4.9.9.4
	  style += "stroke:" + this.color + ";fill:none";
	  path = kernel.cens("path", {
	    d: p,
	    style: style
	  });
	  g.appendChild(path);
	  p2 = p + "L" + this.o.x + "," + this.o.y + "Z";
	  style = "stroke:none;";
	  if ((this.styleMarque & StyleMarqueAngle.marqueRemplie) !== 0) {
	    style += "fill-opacity:" + transparence + ";";
	    // style += "fill:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	    style += "fill:" + this.color + ";";
	  } else style += "fill:none";
	  path2 = kernel.cens("path", {
	    d: p2,
	    style: style
	  });
	  g.appendChild(path2);
	  if ((this.styleMarque & StyleMarqueAngle.marqueAvecTrait) !== 0) {
	    g.appendChild(this.creategMarqueAngle(this.a.x, this.a.y, this.o.x, this.o.y, mesureAngle));
	  }
	  return g;
	};
	/**
	 * Renvoie l'angle au centre pour tracer l'arc.
	 * @returns {Float}
	 */
	CMarqueAngleAncetre.prototype.anglePourArc = function () {
	  var mes = this.u.mesureAngleVecteurs(this.v);
	  if (kernel.zeroAngle(Math.PI - Math.abs(mes))) mes = Math.PI;
	  return mes;
	};
	CMarqueAngleAncetre.prototype.chaineDesignation = function () {
	  return "desMarqueAngle";
	};
	CMarqueAngleAncetre.prototype.read = function (inps, list) {
	  CCercle.prototype.read.call(this, inps, list);
	  this.styleMarque = inps.readInt();
	  this.rayon = inps.readDouble();
	};
	CMarqueAngleAncetre.prototype.write = function (oups, list) {
	  CCercle.prototype.write.call(this, oups, list);
	  oups.writeInt(this.styleMarque);
	  oups.writeDouble(this.rayon);
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _StyleMarqueSegment = __webpack_require__(185);
	
	var _StyleMarqueSegment2 = _interopRequireDefault(_StyleMarqueSegment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sett à définir les différents types de marques d'angle.
	 * @type StyleMarqueAngle
	 */
	var StyleMarqueAngle = {
		marqueSimple: 1,
		marqueSimple1Trait: 1 << 1,
		marqueSimple2Traits: 1 << 2,
		marqueSimple3Traits: 1 << 3,
		marqueSimpleCroix: 1 << 4,
		marquePleine: 1 << 5,
		marquePleine1Trait: 1 << 6,
		marquePleine2Traits: 1 << 7,
		marquePleine3Traits: 1 << 8,
		marquePleineCroix: 1 << 9,
	
		styleMarqueSegment: function styleMarqueSegment(style) {
			switch (style) {
				case StyleMarqueAngle.marqueSimple1Trait:
				case StyleMarqueAngle.marquePleine1Trait:
					return _StyleMarqueSegment2.default.marqueSimple;
				case StyleMarqueAngle.marqueSimple2Traits:
				case StyleMarqueAngle.marquePleine2Traits:
					return _StyleMarqueSegment2.default.marqueDouble;
				case StyleMarqueAngle.marqueSimple3Traits:
				case StyleMarqueAngle.marquePleine3Traits:
					return _StyleMarqueSegment2.default.marqueTriple;
				case StyleMarqueAngle.marqueSimpleCroix:
				case StyleMarqueAngle.marquePleineCroix:
					return _StyleMarqueSegment2.default.marqueCroix;
				default:
					return _StyleMarqueSegment2.default.marqueSimple;
			}
		}
	}; /* 
	    * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	    * http://www.mathgraph32.org/
	    * @Author Yves Biton (yves.biton@sesamath.net)
	    * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	    */
	
	StyleMarqueAngle.marqueRemplie = StyleMarqueAngle.marquePleine | StyleMarqueAngle.marquePleine1Trait | StyleMarqueAngle.marquePleine2Traits | StyleMarqueAngle.marquePleine3Traits | StyleMarqueAngle.marquePleineCroix;
	StyleMarqueAngle.marqueAvecTrait = StyleMarqueAngle.marqueSimple1Trait | StyleMarqueAngle.marqueSimple2Traits | StyleMarqueAngle.marqueSimple3Traits | StyleMarqueAngle.marquePleine1Trait | StyleMarqueAngle.marquePleine2Traits | StyleMarqueAngle.marquePleine3Traits | StyleMarqueAngle.marqueSimpleCroix | StyleMarqueAngle.marquePleineCroix;
	
	module.exports = StyleMarqueAngle;

/***/ },
/* 185 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Sert à définir les difféents types de marques de segments.
	 * @type StyleMarqueSegment
	 */
	var StyleMarqueSegment = {
	  marqueSimple: 0,
	  marqueDouble: 1,
	  marqueTriple: 2,
	  marqueCroix: 3
	};
	// on pourrait tout faire en une ligne avec `export default {props}` mais on remet le nom ici
	// (pour la recherche dans le code)
	module.exports = StyleMarqueSegment;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var StyleMarqueSegment = __webpack_require__(185);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CElementLigne = __webpack_require__(77);
	var CSegment = __webpack_require__(134);
	var CPointBase = __webpack_require__(85);
	module.exports = CMarqueSegment;
	
	/**
	 * Classe représentant une marque de segment.
	 * @constructor
	 * @extends CElementLigne
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg332.StyleTraint} style : Le style de trait utilisé.
	 * @param {StyleMarqueSegment} motif : Le motif de la marque.
	 * @param {CSegment} segmentAssocie : Le segment sur lequel est tracée la marque.
	 * @returns {CMarqueSegment}
	 */
	function CMarqueSegment(listeProprietaire, impProto, estElementFinal, couleur, masque, style, motif, segmentAssocie) {
	  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	    CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 16, style);
	    this.motif = motif;
	    this.segmentAssocie = segmentAssocie;
	  }
	  this.origine1 = new CPointBase();
	  this.origine2 = new CPointBase();
	  this.origine3 = new CPointBase();
	  this.extremite1 = new CPointBase();
	  this.extremite2 = new CPointBase();
	  this.extremite3 = new CPointBase();
	  this.segment1 = new CSegment(this.origine1, this.extremite1);
	  this.segment2 = new CSegment(this.origine2, this.extremite2);
	  this.segment3 = new CSegment(this.origine3, this.extremite3);
	}
	CMarqueSegment.prototype = new CElementLigne();
	CMarqueSegment.prototype.constructor = CMarqueSegment;
	CMarqueSegment.prototype.superClass = "CElementLigne";
	CMarqueSegment.prototype.className = "CMarqueSegment";
	
	CMarqueSegment.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.segmentAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CMarqueSegment(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, this.motif, listeCible.get(ind1, "CSegment"));
	};
	CMarqueSegment.prototype.setClone = function (ptel) {
	  CElementLigne.prototype.setClone.call(this, ptel);
	  this.origine1.placeEn(ptel.origine1);
	  this.origine2.placeEn(ptel.origine2);
	  this.origine3.placeEn(ptel.origine3);
	  this.extremite1.placeEn(ptel.extremite1);
	  this.extremite2.placeEn(ptel.extremite2);
	  this.extremite3.placeEn(ptel.extremite3);
	  /** Supprimé version mtgApp. Inutile
	  this.segment1.donneStyle(ptel.style);
	  this.segment2.donneStyle(ptel.style);
	  this.segment3.donneStyle(ptel.style);
	  this.segment1.donneCouleur(ptel.couleur);
	  this.segment2.donneCouleur(ptel.couleur);
	  this.segment3.donneCouleur(ptel.couleur);
	  this.segment1.setClone(ptel.segment1);
	  this.segment2.setClone(ptel.segment2);
	  this.segment3.setClone(ptel.segment3);
	   */
	};
	/**
	 * Donne à ma marque le motif motif.
	 * @param {StyleMarqueSegment} motif
	 * @returns {undefined}
	 */
	CMarqueSegment.prototype.donneMotif = function (motif) {
	  this.motif = motif;
	};
	CMarqueSegment.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CElementLigne.prototype.dependDe.call(this, p) || this.segmentAssocie.dependDe(p));
	};
	CMarqueSegment.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.segmentAssocie.dependDePourBoucle(p);
	};
	CMarqueSegment.prototype.positionne = function (infoRandom, dimfen) {
	  var xmil, ymil, nor, xext1, yext1, xext2, yext2;
	  if (!this.segmentAssocie.existe || this.segmentAssocie.horsFenetre) {
	    this.existe = false;
	    return;
	  }
	  this.segment1.donneStyle(this.style);
	  this.segment2.donneStyle(this.style);
	  this.segment3.donneStyle(this.style);
	  this.segment1.donneCouleur(this.couleur);
	  this.segment2.donneCouleur(this.couleur);
	  this.segment3.donneCouleur(this.couleur);
	  xmil = (this.segmentAssocie.point1.x + this.segmentAssocie.point2.x) / 2;
	  ymil = (this.segmentAssocie.point1.y + this.segmentAssocie.point2.y) / 2;
	  var u = new Vect(xmil, ymil, this.segmentAssocie.point2.x, this.segmentAssocie.point2.y);
	  nor = u.norme();
	  u.x = u.x / nor;
	  u.y = u.y / nor;
	  var v = new Vect();
	  u.tourne(Math.PI / 2, v);
	  v.x = v.x * 5;
	  v.y = v.y * 5;
	  switch (this.motif) {
	    case StyleMarqueSegment.marqueSimple:
	
	      xext1 = xmil + v.x;
	      yext1 = ymil + v.y;
	      xext2 = xmil - v.x;
	      yext2 = ymil - v.y;
	      this.origine1.placeEn(xext1, yext1);
	      this.extremite1.placeEn(xext2, yext2);
	      this.segment1.positionne(infoRandom, dimfen);
	      this.segment2.existe = false;
	      this.segment3.existe = false;
	      break;
	
	    case StyleMarqueSegment.marqueDouble:
	      xext1 = xmil + v.x + 2 * u.x; //on rajoute 2 pixels par rapport au milieu
	      yext1 = ymil + v.y + 2 * u.y;
	      xext2 = xmil - v.x + 2 * u.x;
	      yext2 = ymil - v.y + 2 * u.y;
	      this.origine1.placeEn(xext1, yext1);
	      this.extremite1.placeEn(xext2, yext2);
	      this.segment1.positionne(infoRandom, dimfen);
	      xext1 = xmil + v.x - 2 * u.x; //on retranche 3 pixels par rapport au milieu
	      yext1 = ymil + v.y - 2 * u.y;
	      xext2 = xmil - v.x - 2 * u.x;
	      yext2 = ymil - v.y - 2 * u.y;
	      this.origine2.placeEn(xext1, yext1);
	      this.extremite2.placeEn(xext2, yext2);
	      this.segment2.positionne(infoRandom, dimfen);
	      this.segment3.existe = false;
	      break;
	
	    case StyleMarqueSegment.marqueTriple:
	      xext1 = xmil + v.x;
	      yext1 = ymil + v.y;
	      xext2 = xmil - v.x;
	      yext2 = ymil - v.y;
	      this.origine1.placeEn(xext1, yext1);
	      this.extremite1.placeEn(xext2, yext2);
	      this.segment1.positionne(infoRandom, dimfen);
	      xext1 += 4 * u.x;
	      yext1 += 4 * u.y;
	      xext2 += 4 * u.x;
	      yext2 += 4 * u.y;
	      this.origine2.placeEn(xext1, yext1);
	      this.extremite2.placeEn(xext2, yext2);
	      this.segment2.positionne(infoRandom, dimfen);
	      xext1 -= 8 * u.x;
	      yext1 -= 8 * u.y;
	      xext2 -= 8 * u.x;
	      yext2 -= 8 * u.y;
	      this.origine3.placeEn(xext1, yext1);
	      this.extremite3.placeEn(xext2, yext2);
	      this.segment3.positionne(infoRandom, dimfen);
	      break;
	
	    case StyleMarqueSegment.marqueCroix:
	      var w = new Vect();
	      u.tourne(Math.PI / 4, w);
	      w.x = w.x * 5;
	      w.y = w.y * 5;
	      xext1 = xmil + w.x;
	      yext1 = ymil + w.y;
	      xext2 = xmil - w.x;
	      yext2 = ymil - w.y;
	      this.origine1.placeEn(xext1, yext1);
	      this.extremite1.placeEn(xext2, yext2);
	      this.segment1.positionne(infoRandom, dimfen);
	      u.tourne(-Math.PI / 4, w);
	      w.x = w.x * 5;
	      w.y = w.y * 5;
	      xext1 = xmil + w.x;
	      yext1 = ymil + w.y;
	      xext2 = xmil - w.x;
	      yext2 = ymil - w.y;
	      this.origine2.placeEn(xext1, yext1);
	      this.extremite2.placeEn(xext2, yext2);
	      this.segment2.positionne(infoRandom, dimfen);
	      this.segment3.existe = false;
	      break;
	  }
	  this.existe = true;
	};
	CMarqueSegment.prototype.createg = function () {
	  var g = kernel.cens("g");
	  if (this.segment1.existe) g.appendChild(this.segment1.createg());
	  if (this.segment2.existe) g.appendChild(this.segment2.createg());
	  if (this.segment3.existe) g.appendChild(this.segment3.createg());
	  g.setAttribute("pointer-events", "none");
	  return g;
	};
	CMarqueSegment.prototype.trace = function (svg) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CMarqueSegment.prototype.update = function (svg) {
	  var oldg = this.g;
	  var g = this.createg();
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CMarqueSegment.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.motif === p.motif && this.segmentAssocie === p.segmentAssocie;
	  } else return false;
	};
	CMarqueSegment.prototype.getNature = function () {
	  return NatObj.NMarqueSegment;
	};
	CMarqueSegment.prototype.chaineDesignation = function () {
	  return "desMarqueSegment";
	};
	CMarqueSegment.prototype.read = function (inps, list) {
	  CElementLigne.prototype.read.call(this, inps, list);
	  this.motif = inps.readByte();
	  var ind1 = inps.readInt();
	  this.segmentAssocie = list.get(ind1, "CSegment");
	};
	CMarqueSegment.prototype.write = function (oups, list) {
	  CElementLigne.prototype.write.call(this, oups, list);
	  oups.writeByte(this.motif);
	  var ind1 = list.indexOf(this.segmentAssocie);
	  oups.writeInt(ind1);
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CMarqueAngleAncetre = __webpack_require__(183);
	module.exports = CMarqueAngleDroit;
	
	/**
	 * Classe représentant une marque d'angle droit.
	 * @constructor
	 * @extends CMarqueAngleAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StleTrait} style : Donne le style trait utilisé.
	 * @param {StyleMarqueAngle} styleMarque : Donne le style de la marque.
	 * @param {Float} rayon : Le rayon de l'arc.
	 * @param {CDroitePerpendiculaire} perp : La droite perpendiculaire
	 * associée.
	 * @returns {CMarqueAngleDroit}
	 */
	function CMarqueAngleDroit(listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon, perp) {
	  if (arguments.length === 1) CMarqueAngleAncetre.call(this, listeProprietaire);else {
	    CMarqueAngleAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon);
	    this.perp = perp;
	  }
	}
	CMarqueAngleDroit.prototype = new CMarqueAngleAncetre();
	CMarqueAngleDroit.prototype.constructor = CMarqueAngleDroit;
	CMarqueAngleDroit.prototype.superClass = "CMarqueAngleAncetre";
	CMarqueAngleDroit.prototype.className = "CMarqueAngleDroit";
	
	CMarqueAngleDroit.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.perp);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CMarqueAngleDroit(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, this.styleMarque, this.rayon, listeCible.get(ind1, "CDroitePerpendiculaire"));
	};
	CMarqueAngleDroit.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.perp);
	};
	CMarqueAngleDroit.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMarqueAngleAncetre.prototype.dependDe.call(this, p) || this.perp.dependDe(p));
	};
	CMarqueAngleDroit.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.perp.dependDePourBoucle(p);
	};
	CMarqueAngleDroit.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.perp.existe;
	  if (!this.existe) return;
	  var intersection = {};
	  kernel.intersectionDroitesSecantes(this.perp.a.x, this.perp.a.y, this.perp.vect, this.perp.d.point_x, this.perp.d.point_y, this.perp.d.vect, intersection);
	  this.centre_x = intersection.x;
	  this.centre_y = intersection.y;
	  this.perp.vect.setCopy(this.u);
	  this.perp.d.vect.setCopy(this.v);
	  this.ang1rad = this.u.angleRad();
	  this.ang2rad = this.v.angleRad();
	  this.prepareAngleDroit();
	  CMarqueAngleAncetre.prototype.positionne.call(this, infoRandom, dimfen);
	};
	CMarqueAngleDroit.prototype.createg = function (svg, couleurFond, transparence) {
	  return CMarqueAngleAncetre.prototype.creategAngleDroit.call(this, transparence);
	};
	CMarqueAngleDroit.prototype.update = function (svg, couleurFond, transparence) {
	  var oldg = this.g;
	  var g = this.createg(svg, couleurFond, transparence);
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CMarqueAngleDroit.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.perp === p.perp;else return false;
	};
	CMarqueAngleDroit.prototype.read = function (inps, list) {
	  CMarqueAngleAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.perp = list.get(ind1, "CDroitePerpendiculaire");
	};
	CMarqueAngleDroit.prototype.write = function (oups, list) {
	  CMarqueAngleAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.perp);
	  oups.writeInt(ind1);
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var StyleMarqueSegment = __webpack_require__(185);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CMarqueAngleAncetre = __webpack_require__(183);
	var StyleMarqueAngle = __webpack_require__(184);
	module.exports = CMarqueAngleGeometrique;
	
	/**
	 * Classe représentant une marque d'angle non orienté.
	 * @constructor
	 * @extends CMarqueAngleAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StleTrait} style : Donne le style trait utilisé.
	 * @param {StyleMarqueAngle} styleMarque : Donne le style de la marque.
	 * @param {Float} rayon : Le rayon de l'arc.
	 * @param {CPt} a : Le premier point
	 * @param {CPt} o : Le point sommet de l'angle définissant l'arc.
	 * @param {CPt} b : Le troisième point.
	 * @returns {CMarqueAngleGeometrique}
	 */
	function CMarqueAngleGeometrique(listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon, a, o, b) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CMarqueAngleAncetre.call(this, listeProprietaire);else {
	    CMarqueAngleAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon);
	    this.a = a;
	    this.o = o;
	    this.b = b;
	  }
	}
	CMarqueAngleGeometrique.prototype = new CMarqueAngleAncetre();
	CMarqueAngleGeometrique.prototype.constructor = CMarqueAngleGeometrique;
	CMarqueAngleGeometrique.prototype.superClass = "CMarqueAngleAncetre";
	CMarqueAngleGeometrique.prototype.className = "CMarqueAngleGeometrique";
	
	CMarqueAngleGeometrique.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.o);
	  var ind3 = listeSource.indexOf(this.b);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CMarqueAngleGeometrique(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, this.styleMarque, this.rayon, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"));
	};
	CMarqueAngleGeometrique.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.a);
	  liste.add(this.o);
	  liste.add(this.b);
	};
	CMarqueAngleGeometrique.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CMarqueAngleAncetre.prototype.dependDe.call(this, p) || this.a.dependDe(p) || this.o.dependDe(p) || this.b.dependDe(p));
	};
	CMarqueAngleGeometrique.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.o.dependDePourBoucle(p) || this.b.dependDePourBoucle(p);
	};
	CMarqueAngleGeometrique.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.o.existe && this.a.existe && this.b.existe && !this.o.presqueEgal(this.a) && !this.o.presqueEgal(this.b);
	  if (!this.existe) return;
	  this.centre_x = this.o.x;
	  this.centre_y = this.o.y;
	  this.u.setVecteur(this.o, this.a);
	  this.v.setVecteur(this.o, this.b);
	  this.ang1rad = this.u.angleRad();
	  this.ang2rad = this.v.angleRad();
	  if (kernel.zeroAngle(this.ang1rad - this.ang2rad)) {
	    this.existe = false;
	    return;
	  }
	  if (kernel.testAngleDroit(this.ang1rad, this.ang2rad)) {
	    this.prepareAngleDroit();
	    this.point2.positionne(infoRandom, dimfen);
	    this.pointc.positionne(infoRandom, dimfen);
	    this.segment1.positionne(infoRandom, dimfen);
	    this.marqueSegment.donneStyle(this.style);
	    this.marqueSegment.donneCouleur(this.couleur);
	    switch (this.styleMarque) {
	      case StyleMarqueAngle.marqueSimple1Trait:
	      case StyleMarqueAngle.marquePleine1Trait:
	        this.marqueSegment.donneMotif(StyleMarqueSegment.marqueSimple);
	        this.marqueSegment.positionne(false, dimfen);
	        break;
	      case StyleMarqueAngle.marqueSimple2Traits:
	      case StyleMarqueAngle.marquePleine2Traits:
	        this.marqueSegment.donneMotif(StyleMarqueSegment.marqueDouble);
	        this.marqueSegment.positionne(false, dimfen);
	        break;
	      case StyleMarqueAngle.marqueSimple3Traits:
	      case StyleMarqueAngle.marquePleine3Traits:
	        this.marqueSegment.donneMotif(StyleMarqueSegment.marqueTriple);
	        this.marqueSegment.positionne(false, dimfen);
	        break;
	      case StyleMarqueAngle.marqueSimpleCroix:
	      case StyleMarqueAngle.marquePleineCroix:
	        this.marqueSegment.donneMotif(StyleMarqueSegment.marqueCroix);
	        this.marqueSegment.positionne(false, dimfen);
	        break;
	      default:
	        this.marqueSegment.existe = false;
	    }
	    this.angleDroit = true;
	  } else this.angleDroit = false;
	  CMarqueAngleAncetre.prototype.positionne.call(this, infoRandom, dimfen);
	};
	/**
	 * Renvoie le path servant à créer le svg element associé.
	 * @param {Float} mesang : L'angle utilisé.
	 * @returns {String}
	 */
	CMarqueAngleGeometrique.prototype.path = function (mesang) {
	  var u1, v1, xo, yo, xf, yf;
	  u1 = new Vect();
	  this.u.vecteurColineaire(this.rayon, u1);
	  v1 = new Vect();
	  this.v.vecteurColineaire(this.rayon, v1);
	  xo = this.centre_x + u1.x;
	  yo = this.centre_y + u1.y;
	  xf = this.centre_x + v1.x;
	  yf = this.centre_y + v1.y;
	  var sweepflag = mesang < 0 ? "1 " : "0 ";
	  return "M " + xo.toString() + " " + yo + "A" + this.rayon + "," + this.rayon + " 0 0 " + sweepflag + xf.toString() + "," + yf.toString();
	};
	CMarqueAngleGeometrique.prototype.trace = function (svg, couleurFond, transparence) {
	  // if (this.a.horsEcran || this.o.horsEcran || this.b.horsEcran) return;
	  var g = this.createg(svg, couleurFond, transparence);
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CMarqueAngleGeometrique.prototype.update = function (svg, couleurFond, transparence) {
	  // if (this.a.horsEcran || this.o.horsEcran || this.b.horsEcran) return;
	  var oldg = this.g;
	  var g = this.createg(svg, couleurFond, transparence);
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CMarqueAngleGeometrique.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	  if (this.b === ancienPoint) this.b = nouveauPoint;
	  if (this.o === ancienPoint) this.o = nouveauPoint;
	};
	
	/**
	 *
	 * Renvoie true si le nom de la valeur commence par la chaîne st
	 * @param st
	 * @return
	 */
	CMarqueAngleGeometrique.prototype.nomCommencePar = function (st) {
	  if (CValDyn.prototype.nomCommencePar.call(this, st)) return true;
	  var ch = this.b.nom + this.o.nom + this.a.nom;
	  return ch.indexOf(st) === 0;
	};
	
	CMarqueAngleGeometrique.prototype.read = function (inps, list) {
	  CMarqueAngleAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.a = list.get(ind1, "CPt");
	  this.o = list.get(ind2, "CPt");
	  this.b = list.get(ind3, "CPt");
	};
	CMarqueAngleGeometrique.prototype.write = function (oups, list) {
	  CMarqueAngleAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.a);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.o);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.b);
	  oups.writeInt(ind3);
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var StyleFleche = __webpack_require__(190);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CMarqueAngleGeometrique = __webpack_require__(188);
	module.exports = CMarqueAngleOriente;
	
	/**
	 * Classe représentant une marque d'angle orienté.
	 * @constructor
	 * @extends CMarqueAngleGeometrique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StleTrait} style : Donne le style trait utilisé.
	 * @param {StyleMarqueAngle} styleMarque : Donne le style de la marque.
	 * @param {Float} rayon : Le rayon de l'arc.
	 * @param {CPt} a : Le premier point
	 * @param {CPt} o : Le point sommet de l'angle définissant l'arc.
	 * @param {CPt} b : Le troisième point.
	 * @param {StyleFleche} motifFleche : Le style utilisé pour la flèche finissant l'arc.
	 * @returns {CMarqueAngleOriente}
	 */
	function CMarqueAngleOriente(listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon, a, o, b, motifFleche) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CMarqueAngleGeometrique.call(this, listeProprietaire);else {
	    CMarqueAngleGeometrique.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon, a, o, b);
	    this.motifFleche = motifFleche;
	  }
	  this.xdeb = 0; // Les coordonnées du point de début de l'arc
	  this.ydeb = 0;
	  this.v0 = new Vect(); // Vect de longueur rayon colinéaire à OB
	  this.vecteurDirection = new Vect(); // Vect définissant la direction inverse de l'arc
	}
	CMarqueAngleOriente.prototype = new CMarqueAngleGeometrique();
	CMarqueAngleOriente.prototype.constructor = CMarqueAngleOriente;
	CMarqueAngleOriente.prototype.superClass = "CMarqueAngleGeometrique";
	CMarqueAngleOriente.prototype.className = "CMarqueAngleOriente";
	
	CMarqueAngleOriente.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.o);
	  var ind3 = listeSource.indexOf(this.b);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CMarqueAngleOriente(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, this.styleMarque, this.rayon, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"), this.motifFleche);
	};
	CMarqueAngleOriente.prototype.setClone = function (ptel) {
	  CMarqueAngleGeometrique.prototype.setClone.call(this, ptel);
	  ptel.vecteurDirection.setCopy(this.vecteurDirection);
	  this.xdeb = ptel.xdeb;
	  this.ydeb = ptel.ydeb;
	};
	CMarqueAngleOriente.prototype.positionne = function (infoRandom, dimfen) {
	  var petitAngle; // Représente l'angle de correction pour la direction de la flèche
	  // due à la longueur de la flèche
	  CMarqueAngleGeometrique.prototype.positionne.call(this, infoRandom, dimfen);
	  if (!this.existe) return;
	  // Optimisation pour la version 1.9.5
	  var longueurFleche = StyleFleche.longeurFlechePourArc(this.motifFleche, this.listeProprietaire);
	  this.v.vecteurColineaire(this.rayon, this.v0);
	  var angle = this.u.mesureAngleVecteurs(this.v);
	  if (kernel.zeroAngle(Math.abs(angle) - Math.PI / 2)) petitAngle = 0;
	  // Modifié version 5.3. Meilleur quand la marque est petite
	  // else petitAngle = Math.atan(longueurFleche/this.rayon);
	  else petitAngle = Math.atan(longueurFleche / this.rayon) / 2;
	  if (kernel.zero(angle)) {
	    this.existe = false;
	    return;
	  } else {
	    if (kernel.zeroAngle(Math.abs(angle) - Math.PI)) this.v0.tourne(-Math.PI / 2, this.vecteurDirection);else {
	      if (angle <= 0) this.v0.tourne(Math.PI / 2 + petitAngle, this.vecteurDirection);else this.v0.tourne(-Math.PI / 2 - petitAngle, this.vecteurDirection);
	    }
	  }
	  this.xdeb = this.o.x + this.v0.x;
	  this.ydeb = this.o.y + this.v0.y;
	};
	CMarqueAngleOriente.prototype.createg = function (svg, couleurFond, transparence) {
	  var g = CMarqueAngleGeometrique.prototype.createg.call(this, svg, couleurFond, transparence);
	  g.appendChild(this.creeFlechePourArc());
	  g.setAttribute("pointer-events", "none");
	  return g;
	};
	// Procédure dessinant la flèche en bout d'une marque d'angle orienté
	// Le Vect u désigne la direction opposée à celle de la flèche
	// et (xa, ya) le point extrémité de la flèche
	/**
	 * Fonction créant le svg element représentant la flèche de l'arc.
	 * Le Vect u désigne la direction opposée à celle de la flèche
	 * et (xa, ya) le point extrémité de la flèche.
	 * @returns {svg.Element}
	 */
	CMarqueAngleOriente.prototype.creeFlechePourArc = function () {
	  var abs0, ord0, abs2, ord2, u1, u2, longueurFleche;
	  var path = kernel.cens("path");
	  var style = "";
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  // style += "stroke:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	  style += "stroke:" + this.color + ";";
	  u1 = new Vect();
	  u2 = new Vect();
	  longueurFleche = StyleFleche.longeurFlechePourArc(this.motifFleche, this.listeProprietaire);
	  this.vecteurDirection.vecteurColineaire(longueurFleche, u1);
	  // On fait tourner le Vect u1 de -pi/6 pour avoir u2
	  u2.x = u1.x * kernel.cos30 - u1.y * kernel.sin30;
	  u2.y = u1.x * kernel.sin30 + u1.y * kernel.cos30;
	  abs0 = Math.round(this.xdeb + u2.x);
	  ord0 = Math.round(this.ydeb + u2.y);
	  // On fait tourner le Vect u1 de pi/6 pour avoir u2
	  u2.x = u1.x * kernel.cos30 + u1.y * kernel.sin30;
	  u2.y = -u1.x * kernel.sin30 + u1.y * kernel.cos30;
	  abs2 = this.xdeb + u2.x;
	  ord2 = this.ydeb + u2.y;
	  switch (this.motifFleche) {
	    case StyleFleche.FlecheLonguePleine:
	    case StyleFleche.FlecheCourtePleine:
	      // style += "fill:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	      style += "fill:" + this.color + ";";
	      path.setAttribute("d", "M" + abs2 + " " + ord2 + "L" + this.xdeb + " " + this.ydeb + "L" + abs0 + " " + ord0 + "Z");
	      break;
	    case StyleFleche.FlecheLongueSimple:
	    case StyleFleche.FlecheCourteSimple:
	      style += "fill:none;";
	      path.setAttribute("d", "M" + abs2 + " " + ord2 + "L" + this.xdeb + " " + this.ydeb + "L" + abs0 + " " + ord0);
	  }
	  path.setAttribute("style", style);
	  return path;
	};
	/**
	 *
	 * Renvoie true si le nom de la valeur commence par la chaîne st
	 * @param st
	 * @return
	 */
	CMarqueAngleOriente.prototype.nomCommencePar = function (st) {
	  if (CValDyn.prototype.nomCommencePar.call(this, st)) return true;
	  var ch = this.point2.nom + this.point1.nom;
	  return ch.indexOf(st) === 0;
	};
	
	CMarqueAngleOriente.prototype.read = function (inps, list) {
	  CMarqueAngleGeometrique.prototype.read.call(this, inps, list);
	  this.motifFleche = inps.readByte();
	};
	CMarqueAngleOriente.prototype.write = function (oups, list) {
	  CMarqueAngleGeometrique.prototype.write.call(this, oups, list);
	  oups.writeByte(this.motifFleche);
	};

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	/**
	 * Set à définir les styles de flèches utilisés pour les vecteurs et marques d'angle orientées.
	 * @type StyleFleche
	 */
	var StyleFleche = {
	  FlecheLonguePleine: 0,
	  FlecheCourtePleine: 1,
	  FlecheLongueSimple: 2,
	  FlecheCourteSimple: 3,
	
	  // Modifié version 5.0 pour tenir compte des figures de haute définition et dans ce cas agrandir les flèches
	  longeurFlechePourVecteur: function longeurFlechePourVecteur(motif, liste) {
	    switch (motif) {
	      case StyleFleche.FlecheLonguePleine:
	      case StyleFleche.FlecheLongueSimple:
	        return 8;
	      case StyleFleche.FlecheCourtePleine:
	      case StyleFleche.FlecheCourteSimple:
	        return 6;
	      default:
	        return 6;
	    }
	  },
	  // Modifié version 5.0 pour tenir compte des figures de haute définition et dans ce cas agrandir les flèches
	  longeurFlechePourArc: function longeurFlechePourArc(motif, liste) {
	    switch (motif) {
	      case StyleFleche.FlecheLonguePleine:
	      case StyleFleche.FlecheLongueSimple:
	        return 8;
	      case StyleFleche.FlecheCourtePleine:
	      case StyleFleche.FlecheCourteSimple:
	        return 5;
	      default:
	        return 5;
	    }
	  },
	  // Spécifique version JavaScript
	  creeFleche: function creeFleche(xa, ya, xb, yb, motifFleche, liste, couleur, style) {
	    var g;
	    var u0 = new Vect();
	    var u1 = new Vect();
	    var u2 = new Vect();
	    var u3 = new Vect();
	    var longueurFleche = StyleFleche.longeurFlechePourVecteur(motifFleche, liste);
	
	    u0.setVecteur(xb, yb, xa, ya);
	    u0.vecteurColineaire(longueurFleche, u1);
	    // On fait tourner le Vect u1 de -pi/6 pour avoir u2
	    u2.x = u1.x * kernel.cos30 - u1.y * kernel.sin30;
	    u2.y = u1.x * kernel.sin30 + u1.y * kernel.cos30;
	    u3.x = u1.x * kernel.cos30 + u1.y * kernel.sin30;
	    u3.y = -u1.x * kernel.sin30 + u1.y * kernel.cos30;
	    var points = (xb + u2.x).toString() + " " + (yb + u2.y).toString() + "," + xb + " " + yb + "," + (xb + u3.x).toString() + " " + (yb + u3.y).toString();
	    switch (motifFleche) {
	      case StyleFleche.FlecheLonguePleine:
	      case StyleFleche.FlecheCourtePleine:
	        g = kernel.cens("polygon", {
	          style: style + "fill:" + couleur
	        });
	        break;
	      case StyleFleche.FlecheLongueSimple:
	      case StyleFleche.FlecheCourteSimple:
	        g = kernel.cens("polyline", {
	          style: style + "fill:none"
	        });
	    }
	    g.setAttribute("points", points);
	    return g;
	  },
	  // Procédure dessinant la flèche en bout d'une marque d'angle orienté
	  // Le Vect u désigne la direction opposée à celle de la flèche
	  // et (xa, ya) le point extrémité de la flèche
	  creeFlechePourArc: function creeFlechePourArc(color, xa, ya, u, motifFleche, liste) {
	    var abs0, ord0, abs2, ord2, u1, u2, longueurFleche;
	    var path = kernel.cens("path");
	    var style = "";
	    var stroke = this.style.stroke;
	    if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	    var strokewidth = this.style.strokeWidth;
	    style += "stroke-width:" + strokewidth + ";";
	    // style += "stroke:"+this.couleur.rgb()+";"; Modifié version 4.9.9.4
	    style += "stroke:" + this.color + ";";
	    u1 = new Vect();
	    u2 = new Vect();
	    longueurFleche = StyleFleche.longeurFlechePourArc(motifFleche, liste);
	    u.vecteurColineaire(longueurFleche, u1);
	    u2.x = u1.x * kernel.cos30 - u1.y * kernel.sin30;
	    u2.y = u1.x * kernel.sin30 + u1.y * kernel.cos30;
	    abs0 = Math.round(xa + u2.x);
	    ord0 = Math.round(ya + u2.y);
	    // On fait tourner le Vect u1 de pi/6 pour avoir u2
	    u2.x = u1.x * kernel.cos30 + u1.y * kernel.sin30;
	    u2.y = -u1.x * kernel.sin30 + u1.y * kernel.cos30;
	    abs2 = Math.round(xa + u2.x);
	    ord2 = Math.round(ya + u2.y);
	    switch (motifFleche) {
	      case FlecheLonguePleine:
	      case FlecheCourtePleine:
	        style += "fill:" + color.rgb() + ";";
	        path.setAttribute("path", "M" + abs2 + " " + ord2 + "L" + xa + " " + ya + "L" + abs0 + " " + ord0 + "Z");
	        break;
	      case FlecheLongueSimple:
	      case FlecheCourteSimple:
	        style += "fill:none;";
	        path.setAttribute("path", "M" + abs2 + " " + ord2 + "L" + xa + " " + ya + "L" + abs0 + " " + ord0);
	    }
	    path.setAttribute("style", style);
	    return path;
	  }
	};
	module.exports = StyleFleche;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var StyleFleche = __webpack_require__(190);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CMarqueAngleGeometrique = __webpack_require__(188);
	var CMarqueAngleOriente = __webpack_require__(189);
	module.exports = CMarqueAngleOrienteDirecte;
	
	/**
	 * Classe représentant une marque d'angle orienté de sens direct.
	 * @constructor
	 * @extends CMarqueAngleOriente
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StleTrait} style : Donne le style trait utilisé.
	 * @param {StyleMarqueAngle} styleMarque : Donne le style de la marque.
	 * @param {Float} rayon : Le rayon de l'arc.
	 * @param {CPt} a : Le premier point
	 * @param {CPt} o : Le point sommet de l'angle définissant l'arc.
	 * @param {CPt} b : Le troisième point.
	 * @param {StyleFleche} motifFleche : Le style utilisé pour la flèche finissant l'arc.
	 * @returns {CMarqueAngleOrienteDirecte}
	 */
	function CMarqueAngleOrienteDirecte(listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon, a, o, b, motifFleche) {
	  if (arguments.length === 1) CMarqueAngleOriente.call(this, listeProprietaire);else {
	    CMarqueAngleOriente.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon, a, o, b);
	    this.motifFleche = motifFleche;
	  }
	}
	CMarqueAngleOrienteDirecte.prototype = new CMarqueAngleOriente();
	CMarqueAngleOrienteDirecte.prototype.constructor = CMarqueAngleOrienteDirecte;
	CMarqueAngleOrienteDirecte.prototype.superClass = "CMarqueAngleOriente";
	CMarqueAngleOrienteDirecte.prototype.className = "CMarqueAngleOrienteDirecte";
	
	CMarqueAngleOrienteDirecte.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.o);
	  var ind3 = listeSource.indexOf(this.b);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CMarqueAngleOrienteDirecte(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, this.styleMarque, this.rayon, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"), this.motifFleche);
	};
	CMarqueAngleOrienteDirecte.prototype.positionne = function (infoRandom, dimfen) {
	  var petitAngle, longueurFleche;
	  // Ici ne pas appeler la fonction de l'ancêtre direct
	  CMarqueAngleGeometrique.prototype.positionne.call(this, infoRandom, dimfen);
	  if (!this.existe) return;
	  // Optimisation pour la version 1.9.5
	  longueurFleche = StyleFleche.longeurFlechePourArc(this.motifFleche, this.listeProprietaire);
	  this.v.vecteurColineaire(this.rayon, this.v0);
	  this.angle = this.u.mesureAngleVecteurs(this.v);
	  if (kernel.zeroAngle(this.angle - Math.PI / 2)) petitAngle = 0;
	  // Modifié version 5.3. Meilleur quand la marque est petite
	  // else petitAngle = longueurFleche/this.rayon;
	  else petitAngle = Math.atan(longueurFleche / this.rayon / 2);
	  if (kernel.zero(this.angle)) {
	    this.existe = false;
	    return;
	  } else {
	    this.v0.tourne(-Math.PI / 2 - petitAngle, this.vecteurDirection);
	  }
	  this.xdeb = this.o.x + this.v0.x;
	  this.ydeb = this.o.y + this.v0.y;
	};
	CMarqueAngleOrienteDirecte.prototype.anglePourArc = function () {
	  return this.angle >= 0 ? this.angle : 2 * Math.PI + this.angle;
	};
	CMarqueAngleOrienteDirecte.prototype.path = function (mesang) {
	  var u1, v1, xo, yo, xf, yf;
	  u1 = new Vect();
	  this.u.vecteurColineaire(this.rayon, u1);
	  v1 = new Vect();
	  this.v.vecteurColineaire(this.rayon, v1);
	  xo = this.centre_x + u1.x;
	  yo = this.centre_y + u1.y;
	  xf = this.centre_x + v1.x;
	  yf = this.centre_y + v1.y;
	  var largearcflag = this.angle >= 0 ? "0 " : "1 ";
	  return "M " + xo.toString() + " " + yo + "A" + this.rayon + "," + this.rayon + " 0 " + largearcflag + " 0 " + xf.toString() + "," + yf.toString();
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var StyleFleche = __webpack_require__(190);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CMarqueAngleGeometrique = __webpack_require__(188);
	var CMarqueAngleOriente = __webpack_require__(189);
	module.exports = CMarqueAngleOrienteIndirecte;
	
	/**
	 * Classe représentant une marque d'angle orienté de sens iddirect.
	 * @constructor
	 * @extends CMarqueAngleOriente
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StleTrait} style : Donne le style trait utilisé.
	 * @param {StyleMarqueAngle} styleMarque : Donne le style de la marque.
	 * @param {Float} rayon : Le rayon de l'arc.
	 * @param {CPt} a : Le premier point
	 * @param {CPt} o : Le point sommet de l'angle définissant l'arc.
	 * @param {CPt} b : Le troisième point.
	 * @param {StyleFleche} motifFleche : Le style utilisé pour la flèche finissant l'arc.
	 * @returns {CMarqueAngleOrienteIndirecte}
	 */
	function CMarqueAngleOrienteIndirecte(listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon, a, o, b, motifFleche) {
	  if (arguments.length === 1) CMarqueAngleOriente.call(this, listeProprietaire);else {
	    CMarqueAngleOriente.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, styleMarque, rayon, a, o, b);
	    this.motifFleche = motifFleche;
	  }
	}
	CMarqueAngleOrienteIndirecte.prototype = new CMarqueAngleOriente();
	CMarqueAngleOrienteIndirecte.prototype.constructor = CMarqueAngleOrienteIndirecte;
	CMarqueAngleOrienteIndirecte.prototype.superClass = "CMarqueAngleOriente";
	CMarqueAngleOrienteIndirecte.prototype.className = "CMarqueAngleOrienteIndirecte";
	
	CMarqueAngleOrienteIndirecte.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.o);
	  var ind3 = listeSource.indexOf(this.b);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CMarqueAngleOrienteIndirecte(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, this.styleMarque, this.rayon, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"), this.motifFleche);
	};
	
	CMarqueAngleOrienteIndirecte.prototype.positionne = function (infoRandom, dimfen) {
	  var petitAngle; // Représente l'angle de correction pour la direction de la flèche
	  // due à la longueur de la flèche
	  CMarqueAngleGeometrique.prototype.positionne.call(this, infoRandom, dimfen);
	  if (!this.existe) return;
	  // Optimisation pour la version 1.9.5
	  var longueurFleche = StyleFleche.longeurFlechePourArc(this.motifFleche, this.listeProprietaire);
	  this.v.vecteurColineaire(this.rayon, this.v0);
	  this.angle = this.u.mesureAngleVecteurs(this.v);
	  if (kernel.zeroAngle(this.angle + Math.PI / 2)) petitAngle = 0;
	  // Modifié version 5.3. Meilleur quand la marque est petite
	  // else petitAngle = longueurFleche/this.rayon;
	  else petitAngle = Math.atan(longueurFleche / this.rayon / 2);
	  if (kernel.zero(this.angle)) {
	    this.existe = false;
	    return;
	  } else {
	    this.v0.tourne(Math.PI / 2 + petitAngle, this.vecteurDirection);
	  }
	  this.xdeb = this.o.x + this.v0.x;
	  this.ydeb = this.o.y + this.v0.y;
	};
	// Spécifique version JavaScript
	CMarqueAngleOrienteIndirecte.prototype.anglePourArc = function () {
	  return this.angle <= 0 ? this.angle : -2 * Math.PI + this.angle;
	};
	CMarqueAngleOrienteIndirecte.prototype.path = function (mesang) {
	  var u1, v1, xo, yo, xf, yf;
	  u1 = new Vect();
	  this.u.vecteurColineaire(this.rayon, u1);
	  v1 = new Vect();
	  this.v.vecteurColineaire(this.rayon, v1);
	  xo = this.centre_x + u1.x;
	  yo = this.centre_y + u1.y;
	  xf = this.centre_x + v1.x;
	  yf = this.centre_y + v1.y;
	  var largearcflag = this.angle <= 0 ? "0 " : "1 ";
	  return "M " + xo.toString() + " " + yo + "A" + this.rayon + "," + this.rayon + " 0 " + largearcflag + " 1 " + xf.toString() + "," + yf.toString();
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Color = __webpack_require__(6);
	var kernel = __webpack_require__(8);
	var CListeObjets = __webpack_require__(17);
	var CPrototype = __webpack_require__(194);
	var DataInputStream = __webpack_require__(24);
	var DataOutputStream = __webpack_require__(195);
	module.exports = CMathGraphDoc;
	
	/**
	 * Classe contenant des informations sur la figure et un array de CPrototype
	 * (qui peut être vide) ainis que la CListeObjets contenant les objets proprement dits
	 * graphiques et non graphiques.
	 * Version réservée à mtgApp
	 * @constructor
	 * @param {String} idDoc : L'id du document ui est celui du svg contenant la figure.
	 * @param {Boolean} displayOnLoad : true si la figure doit être affichée
	 * dès que son chargement est terminé.
	 * @param {Boolean} isActive : true si la figure est active et répond aux actions souris et clavier.
	 * @param opacity : Nombre décimale définissant l'opacité des surfaces de la figure
	 * @returns {CMathGraphDoc}
	 */
	function CMathGraphDoc(idDoc, displayOnLoad, isActive, opacity) {
	  this.idDoc = idDoc;
	  this.displayOnLoad = arguments.length > 1 ? displayOnLoad : true; // Pas utilisé pour le moment
	  this.isActive = arguments.length > 2 ? isActive : true;
	  this.numeroVersion = DataInputStream.numeroVersionActif;
	  this.listePrincipale = new CListeObjets("radian", idDoc);
	  this.listePrincipale.associeA(this);
	  this.langage = kernel.userLan();
	  this.texteFigure = "";
	  this.tablePrototypes = [];
	  this.isDirty = false;
	  this.pointCapture = null;
	  this.couleurFond = Color.white;
	  this.imageFond = null;
	  this.imageFondVisible = true;
	  this.itemsCochesInterdits = true;
	  this.listeIdMenus = [];
	  this.opacity = arguments.length > 3 ? opacity : 0.2;
	  this.type = ""; // Pour les événements souris
	  // Des événements mousemove ne sont pas générés sur les périphériques uniquement tactiles
	  // à la différece des événements mousedown
	  this.hasMouse = false; // Sera mis à true si un mousemove event estr rencontré
	}
	/**
	 * Fonction chargeant les éventuelles constructions de la figure (CPrototype)
	 * @param {DataInputStream} inps
	 * @param nVersion : Le n° de version de la liste dans laquelle on lit les prototypes
	 * @returns {undefined}
	 */
	// Modifié version 5.2. On passe un paramètre nVersion qui représente le N° de version de la liste à partir de laquelle le prototype est chargé
	
	CMathGraphDoc.prototype.readPrototypes = function (inps, nVersion) {
	  // On lit d'abord le nombre de prototypes
	  var nbProt = inps.readInt();
	  for (var i = 0; i < nbProt; i++) {
	    var prot = new CPrototype(this.listePrincipale);
	    prot.read(inps, nVersion);
	    this.tablePrototypes.push(prot);
	  }
	};
	/**
	 * Fonction renvoyant la construction de la figure de nom nomProto
	 * @param nomProto : String
	 * @returns {*} null s'il n'y a pas de prototype de ce nom
	 */
	CMathGraphDoc.prototype.getPrototype = function (nomProto) {
	  for (var i = 0; i < this.tablePrototypes.length; i++) {
	    if (this.tablePrototypes[i].nom === nomProto) return this.tablePrototypes[i];
	  }
	  return null;
	};
	/**
	 * Fonction enregistrant les pprototypes (constructions) de la figure.
	 * @param {DataOutputStream} oups
	 * @returns {undefined}
	 */
	CMathGraphDoc.prototype.writePrototypes = function (oups) {
	  oups.writeInt(this.tablePrototypes.length);
	  for (var i = 0; i < this.tablePrototypes.length; i++) {
	    var prot = this.tablePrototypes[i];
	    prot.write(oups);
	  }
	};
	/**
	 * Fonction lisant le document depuis un flux de données binaires.
	 * @param {DataInputStream} inps
	 * @returns {undefined}
	 */
	CMathGraphDoc.prototype.read = function (inps) {
	  // On saute les 17 premiers octets qui contiennent une chaine
	  inps.skip(16);
	  this.numeroVersion = inps.readInt();
	  // Ligne suivante pour corriger un oubli dans la première version où le numéro de document
	  // était nul
	  if (this.numeroVersion === 0) this.numeroVersion = 5;
	  if (this.numeroVersion > DataInputStream.numeroVersionActif) {
	    // Amélioré version 4.4
	    throw new Error("IOException");
	  }
	  if (this.numeroVersion >= 6) this.opacity = inps.readFloat();else this.opacity = 1; //pas de transparence pour les anciennes figures. A modifier dans Options Figure en cours
	  this.langage = inps.readUTF(); // la langue dans laquelle a été créé le document
	  // Changements pour la version 1.8 (version 3)
	  // Changement pour version 2.0 : on enregistre le degré de transparence des surfaces pleines dans un float
	  var couleurRouge, couleurVert, couleurBleu;
	  couleurRouge = inps.readByte(); // initialement readUnsignedByte()
	  couleurVert = inps.readByte();
	  couleurBleu = inps.readByte();
	  this.couleurFond = new Color(couleurRouge, couleurVert, couleurBleu);
	  this.imageFondVisible = inps.readBoolean(); // Nouveau version 4.4
	  this.modeTraceActive = inps.readBoolean(); // Nouveau version 4.4
	  this.natImageFond = inps.readByte();
	  if (this.natImageFond !== DataOutputStream.nat_noImage) {
	    this.imageFond = inps.readBufferedImage();
	    if (this.numeroVersion > 10) {
	      this.widthImageFond = inps.readInt();
	      this.heightImageFond = inps.readInt();
	    } else {
	      this.widthImageFond = svg.getAttribute("width");
	      this.heightImageFond = svg.getAttribute("height");
	    }
	  } else this.imageFond = null;
	  /* Supprimé version 5.3. Devenu inutile
	  var svg = (this.idDoc !== null) ? document.getElementById(this.idDoc) : null;
	  if (svg !== null) {
	    // On créée un g destiné à contenir les traces d'objets
	    this.gTraces = kernel.cens("g",{
	      id : this.idDoc+"Traces"
	    });
	    svg.appendChild(this.gTraces);
	    // this.indexOfFirstElement = svg.childNodes.length; Supprimé version mtgApp. Inutile
	  }
	  */
	  // On lit un booléen indiquant si les codes d'items de menu correspondent à
	  // des items interdits ou non
	  this.itemsCochesInterdits = inps.readBoolean();
	  // On charge l'éventuelle liste d'items de menus
	  var nombreItems = inps.readInt();
	  this.listeIdMenus = [];
	  if (nombreItems !== 0) {
	    for (var i = 0; i < nombreItems; i++) {
	      var a = inps.readInt();
	      this.listeIdMenus.push(a); // à revoir
	    }
	  }
	  //motDePasseFigure = inps.readUTF();
	  // this.motDePasseFigure = inps.readUTF(); Modifié version 5.0
	  /* Modifié version 5.0
	  this.protectionOptions = inps.readBoolean();
	  this.protectionCopie = inps.readBoolean();
	  this.protectionFigure = inps.readBoolean();
	  this.protectionMenus = inps.readBoolean();
	  this.protectionSecret = inps.readBoolean();
	  */
	  if (this.numeroVersion < 15) {
	    inps.readUTF();
	    inps.skip(5);
	  }
	  this.texteFigure = inps.readUTF();
	  this.sizeWindowx = inps.readInt();
	  this.sizeWindowy = inps.readInt();
	  this.affichagesFiges = inps.readBoolean();
	  this.marquesAnglesFigees = inps.readBoolean();
	  // Nouveau pour la version 4.6 : Deux boolean disant si les champs d'édition peuvent avoir des boutons
	  // Valeur et Fontions prédéfinies
	  if (this.numeroVersion >= 10) {
	    this.buttonValueAllowed = inps.readBoolean();
	    this.buttonFunctionAllowed = inps.readBoolean();
	  }
	  this.readPrototypes(inps, this.numeroVersion);
	  // Nouveauté pour la version 2.5 : La liste doit être au courant du n° de
	  // version
	  // de document
	  this.listePrincipale.numeroVersion = this.numeroVersion;
	  this.listePrincipale.associeA(this); // Modifié version 4.8
	  this.listePrincipale.read(inps);
	  this.listePrincipale.numeroVersion = DataInputStream.numeroVersionActif;
	  this.numeroVersion = DataInputStream.numeroVersionActif;
	};
	/**
	 * Fonction enregistrant le document dans un flux de données binaire.
	 * @param {DataOutputStream} oups
	 * @returns {undefined}
	 */
	CMathGraphDoc.prototype.write = function (oups) {
	  oups.writeCString("MathGraphJava1.0");
	  oups.writeInt(this.numeroVersion);
	  // Changement pour version 2.0 : on enregistre le degré de transparence des surfaces pleines dans un float
	  oups.writeFloat(this.opacity);
	  oups.writeUTF(this.langage);
	  oups.writeByte(this.couleurFond.getRed());
	  oups.writeByte(this.couleurFond.getGreen());
	  oups.writeByte(this.couleurFond.getBlue());
	  oups.writeBoolean(this.imageFondVisible);
	  // Nouveau version 4.4 : un boolean disant si le mode trace est activé
	  oups.writeBoolean(this.modeTraceActive);
	  if (this.imageFond !== null) {
	    oups.writeByte(this.natImageFond);
	    oups.writeBufferedImage(this.imageFond, this.natImageFond); // Si pas d'image Fond un int de valeur nulle est enregistré dans le flux.
	    oups.writeInt(this.widthImageFond);
	    oups.writeInt(this.heightImageFond);
	  } else oups.writeByte(DataOutputStream.nat_noImage);
	  // On lit un booléen indiquant si les codes d'items de menu correspondent à
	  // des items interdits ou non
	  oups.writeBoolean(this.itemsCochesInterdits);
	  // On enregistre l'éventuelle liste d'items de menus
	  var nombreItems = this.listeIdMenus.length;
	  oups.writeInt(nombreItems);
	  if (nombreItems !== 0) {
	    for (var i = 0; i < nombreItems; i++) {
	      oups.writeInt(this.listeIdMenus[i]);
	    }
	  }
	  oups.writeUTF(this.texteFigure);
	  oups.writeInt(this.dimf.x);
	  oups.writeInt(this.dimf.y);
	  oups.writeBoolean(this.affichagesFiges);
	  oups.writeBoolean(this.marquesAnglesFigees);
	  oups.writeBoolean(this.buttonValueAllowed);
	  oups.writeBoolean(this.buttonFunctionAllowed);
	  this.writePrototypes(oups);
	  this.listePrincipale.write(oups);
	};
	
	CMathGraphDoc.prototype.getBase64Code = function () {
	  var oups = new DataOutputStream();
	  this.write(oups);
	  return kernel.base64Encode(oups.ba, false);
	};
	
	/**
	 * Ajout version 5.0.
	 * Renvoie un coefficient qui servira à agrandir les marques de segment, d'angles et les points
	 * pour les écrans de haute résolution.
	 * @return
	 */
	// Abandonné
	// CMathGraphDoc.prototype.coefForPointsAndMarks = function() {
	// On considère une figure de taille 600x400 comme la norme et au-delà on applique un coefficient
	// proportionnel à l'aire de la figure
	/*
	var d = Math.sqrt(this.sizeWindowx*this.sizeWindowy/800000);
	if (d < 1) return 1; else if (d > 2.5) return 2.5; else return d;
	*/
	// Pour la version js, toujours égal à 1
	//  return 1;
	// };
	
	/**
	 * Fonction changeant l'état du document
	 * @param {boolean} val : true si le document a changé et false sinon
	 */
	
	CMathGraphDoc.prototype.setDirty = function (val) {
	  this.isDirty = val;
	};
	
	/**
	 * Fonction renvoyant true si l'outil d'inex index est autorisé par le document
	 * @param index
	 * @returns {boolean}
	 */
	CMathGraphDoc.prototype.toolDispo = function (index) {
	  if (index === -1) return true;
	  var b = false;
	  for (var i = 0; i < this.listeIdMenus.length; i++) {
	    b |= this.listeIdMenus[i] === index;
	  }
	  return this.itemsCochesInterdits ? !b : b;
	};

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CListeObjets = __webpack_require__(17);
	var numeroVersionPrototypes = 6; // Numéro de version correspondant à la version Java 5.2.2
	module.exports = CPrototype;
	
	/**
	 * Classe représentant une macro construction.
	 * Les éventuels prototypes de la figure sont enregistrés par CMathGraphDoc.
	 * @constructor
	 * @extends CListeObjets
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @returns {CPrototype}
	 */
	function CPrototype(listeProprietaire) {
	  CListeObjets.call(this, listeProprietaire);
	}
	CPrototype.prototype = new CListeObjets();
	CPrototype.prototype.constructor = CPrototype;
	CPrototype.prototype.superClass = "CListeObjets";
	CPrototype.prototype.className = "CPrototype";
	
	CPrototype.prototype.indexOf = function (o) {
	  var elb = o;
	  if (elb === null) return -1;
	  if (elb.elementGeneriqueAssocie !== null) elb = elb.elementGeneriqueAssocie;
	  var ind = CListeObjets.prototype.indexOf.call(this, elb);
	  var liste = this.listePourImplementation;
	  if (liste === null) return ind;
	  if (ind < this.nbObjSources) {
	    var eltbase = elb.elementAssocie;
	    return liste.indexOf(eltbase);
	  } else return this.indicePremierObjetPourImplementation + ind - this.nbObjSources;
	};
	// Modifié version 5.2. On passe un paramètre nVersion qui représente le N° de version de la liste à partir de laquelle le prototype est chargé
	CPrototype.prototype.read = function (inps, nVersion) {
	  this.numeroVersionPrototype = inps.readInt();
	  if (this.numeroVersionPrototype < 3) this.numeroVersion = 7; // Version 4.4
	  else if (this.numeroVersionPrototype === 4) this.numeroVersion = 11;else if (this.numeroVersionPrototype === 5) this.numeroVersion = 15;else this.numeroVersion = nVersion;
	
	  this.nom = inps.readUTF();
	  this.commentaire = inps.readUTF();
	  this.nbObjSources = inps.readInt();
	  this.nbObjFinaux = inps.readInt();
	  this.natureSources = inps.readByte();
	  CListeObjets.prototype.readPourProtoDepuisFlux.call(this, inps);
	};
	CPrototype.prototype.write = function (oups) {
	  // Important : quand on enregistre le prototype dans un flux il faut que son membre
	  // listePourImplementation soit null car sinon ce ne sont pas les bons indices des objets
	  // contenus dans le prototype qui vont être enregistrés.
	  this.listePourImplementation = null;
	  oups.writeInt(numeroVersionPrototypes);
	  oups.writeUTF(this.nom);
	  oups.writeUTF(this.commentaire);
	  oups.writeInt(this.nbObjSources);
	  oups.writeInt(this.nbObjFinaux);
	  oups.writeByte(this.natureSources);
	  CListeObjets.prototype.writePourProtoDepuisFlux.call(this, oups);
	};
	// Ajout vesion 4.8
	/**
	 * Affecte listePourImplementation à this.listePourImplementation
	 * @param {CListeObjets} listePourImplementationInit
	 * @returns {undefined}
	 */
	CPrototype.prototype.setListePourImplementation = function (listePourImplementationInit) {
	  this.listePourImplementation = listePourImplementationInit;
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	// import Utf8Utils from '../outilsExternes/Utf8Utils/Utf8Utils'
	// const utf8 = require('utf8')
	var utf8 = __webpack_require__(196);
	// lui utilise la syntaxe d'export es6, c'est l'export par défaut qu'on veut
	// const BinaryParser = require('../../outilsExternes/binaryParser/binary-parser').default
	var BinaryParser = __webpack_require__(25).default;
	
	module.exports = DataOutputStream;
	
	/**
	 * Classe servant à enregistrer une figure depuis un flux binaire base 64
	 * contenu dans un tableau de bytes.
	 * @constructor
	 * @returns {undefined}
	 */
	function DataOutputStream() {
	  this.bp = new BinaryParser(true, true); // Poids forts en premeir et exceptions gérées
	  this.listeNomsClasse = []; // Liste contenant les noms des classes des objets de la liste enregistrée
	  this.ba = [];
	}
	DataOutputStream.nat_png = 0;
	DataOutputStream.nat_gif = 1;
	DataOutputStream.nat_jpg = 2;
	DataOutputStream.nat_noImage = 255; // Non signé en java
	
	/**
	 * Enregistrement d'un entier sur 4 octets dans le flux
	 * @param {Integer} ent
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeInt = function (ent) {
	  // Corrigé version mtgApp. Ne marche pas
	  var i;
	  if (ent === -1) {
	    for (i = 0; i < 4; i++) {
	      this.ba.push(255);
	    }
	  } else {
	    var r = this.bp.fromInt(ent);
	    for (i = 0; i < r.length; i++) {
	      this.ba.push(r.charCodeAt(i));
	    }
	  }
	};
	/**
	 * Enregistrement d'un entier sur 2 octets dans le flux
	 * @param {Integer} ent
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeShortInt = function (ent) {
	  // Corrigé version mtgApp. Ne marche pas
	  var i;
	  if (ent === -1) for (i = 0; i < 2; i++) {
	    this.ba.push(255);
	  } else {
	    var r = this.bp.fromShort(ent);
	    for (i = 0; i < r.length; i++) {
	      this.ba.push(r.charCodeAt(i));
	    }
	  }
	};
	/**
	 * Enregistrement d'un byte dans le flux
	 * @param {type} b
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeByte = function (b) {
	  this.ba.push(b);
	};
	/**
	 * Enregistrement d'un booléen dans le flux
	 * @param {type} b
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeBoolean = function (b) {
	  this.ba.push(b ? 1 : 0);
	};
	/**
	 * Enregistrement d'un double dans le flux
	 * @param {type} d
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeDouble = function (d) {
	  var r = this.bp.fromDouble(d);
	  for (var i = 0; i < r.length; i++) {
	    this.ba.push(r.charCodeAt(i));
	  }
	};
	/**
	 * Enregistrement d'un float dans le flux.
	 * @param {double} d
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeFloat = function (d) {
	  var r = this.bp.fromFloat(d);
	  for (var i = 0; i < r.length; i++) {
	    this.ba.push(r.charCodeAt(i));
	  }
	};
	/**
	 * Enregistremet d'un tableau d'entiers décrivant une image dans le flux
	 * @param {Array} im
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeBufferedImage = function (im) {
	  this.writeInt(im.length);
	  this.ba = this.ba.concat(im);
	};
	/**
	 * Enregistrement d'une chaîne de caractères dans le flux
	 * La longueur de la chaîne est d'abod enregistrée
	 * @param {type} ch
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeUTF = function (ch) {
	  var st = utf8.encode(ch);
	  this.writeShortInt(st.length);
	  for (var i = 0; i < st.length; i++) {
	    this.ba.push(st[i]);
	  }
	};
	/**
	 * Enregistrement d'une chaîne de caractères dans le flux
	 * La longueur de la chaîne n'est pas enregistrée.
	 * @param {type} ch
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeCString = function (ch) {
	  for (var i = 0; i < ch.length; i++) {
	    this.writeByte(ch.charCodeAt(i));
	  }
	};
	/**
	 * Enregistrement d'un objet dans le flux
	 * Si une m^ême classe a déjà été enregistrée, on enregistre l'indice du nom
	 * de la classe de cet objet dans le flux et sinon on enregistre -1 suivi du
	 * numéro de version de l'objet et du nom de la classe.
	 * L'objet s'enregistre ensuite dans le flux.
	 * @param {COb} ob
	 * @returns {undefined}
	 */
	DataOutputStream.prototype.writeObject = function (ob) {
	  var i;
	  var nomClasse = ob.className;
	  var numVer = ob.numeroVersion(); // Numéro de version
	  // On regarde d'abord si un objet de cette classe a déjà été enregistré dans le flux.
	  // Si oui on enregistre dans le flux son indice dans la liste des classes déjà
	  // chargées dans la liste listeNomsClasses.
	  // Sinon on enregistre un short FFFF suivi du numéro de version de l'objet
	  // suivi du nom de la classe
	  var trouve = false;
	  for (i = 0; i < this.listeNomsClasse.length && !trouve; i++) {
	    var ch = this.listeNomsClasse[i];
	    if (ch === nomClasse) {
	      trouve = true;
	      break;
	    }
	  }
	  if (trouve) {
	    this.writeInt(i);
	  } else {
	    this.writeInt(-1);
	    this.writeInt(numVer);
	    this.writeUTF(nomClasse);
	    this.listeNomsClasse.push(nomClasse);
	  }
	  ob.write(this, ob.listeProprietaire);
	};
	
	/**
	 * Fonction renvoyant le code de nature d'iamge correspondant à l'extension ext
	 * @param ext
	 * @returns {number}
	 */
	DataOutputStream.getNatImage = function (ext) {
	  switch (ext) {
	    case "jpg":
	    case "jpeg":
	      return DataOutputStream.nat_jpg;
	    case "gif":
	      return DataOutputStream.nat_gif;
	    default:
	      return DataOutputStream.nat_png;
	  }
	};

/***/ },
/* 196 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	//************************************************************************************
	// UTF-8 Encoding helpers.
	// based on the code at http://www.webtoolkit.info
	//************************************************************************************
	/**
	 * Fonction servant à décoder une chaîne UTF contenue dans un flux binaire.
	 * @type obj
	 */
	module.exports = function Utf8Utils() {
	    function _encode(stringToEncode, insertBOM) {
	        stringToEncode = stringToEncode.replace(/\r\n/g, "\n");
	        var utftext = [];
	        if (insertBOM == true) {
	            utftext[0] = 0xef;
	            utftext[1] = 0xbb;
	            utftext[2] = 0xbf;
	        }
	
	        for (var n = 0; n < stringToEncode.length; n++) {
	
	            var c = stringToEncode.charCodeAt(n);
	
	            if (c < 128) {
	                utftext[utftext.length] = c;
	            } else if (c > 127 && c < 2048) {
	                utftext[utftext.length] = c >> 6 | 192;
	                utftext[utftext.length] = c & 63 | 128;
	            } else {
	                utftext[utftext.length] = c >> 12 | 224;
	                utftext[utftext.length] = c >> 6 & 63 | 128;
	                utftext[utftext.length] = c & 63 | 128;
	            }
	        }
	        return utftext;
	    }
	
	    return {
	        /**
	         * Encode javascript string as utf8 byte array
	         */
	        encode: function encode(stringToEncode) {
	            return _encode(stringToEncode, false);
	        },
	
	        /**
	         * Encode javascript string as utf8 byte array, with a BOM at the start
	         */
	        encodeWithBOM: function encodeWithBOM(stringToEncode) {
	            return _encode(stringToEncode, true);
	        },
	
	        /**
	         * Decode utf8 byte array to javascript string....
	         */
	        decode: function decode(dotNetBytes) {
	            var result = "";
	            var i = 0;
	            var c = 0;
	            var c2 = 0;
	            var c3 = 0;
	
	            // Perform byte-order check.
	            if (dotNetBytes.length >= 3) {
	                if ((dotNetBytes[0] & 0xef) == 0xef && (dotNetBytes[1] & 0xbb) == 0xbb && (dotNetBytes[2] & 0xbf) == 0xbf) {
	                    // Hmm byte stream has a BOM at the start, we'll skip this.
	                    i = 3;
	                }
	            }
	
	            while (i < dotNetBytes.length) {
	                c = dotNetBytes[i] & 0xff;
	
	                if (c < 128) {
	                    result += String.fromCharCode(c);
	                    i++;
	                } else if (c > 191 && c < 224) {
	                    if (i + 1 >= dotNetBytes.length) throw "Un-expected encoding error, UTF-8 stream truncated, or incorrect";
	                    c2 = dotNetBytes[i + 1] & 0xff;
	                    result += String.fromCharCode((c & 31) << 6 | c2 & 63);
	                    i += 2;
	                } else {
	                    if (i + 2 >= dotNetBytes.length || i + 1 >= dotNetBytes.length) throw "Un-expected encoding error, UTF-8 stream truncated, or incorrect";
	                    c2 = dotNetBytes[i + 1] & 0xff;
	                    c3 = dotNetBytes[i + 2] & 0xff;
	                    result += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
	                    i += 3;
	                }
	            }
	            return result;
	        }
	    };
	}();

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalculAncetre = __webpack_require__(35);
	var CValeur = __webpack_require__(80);
	module.exports = CMaxFonc;
	
	/**
	 * Classe représentant le calcul du minimum d'une fonction sur un intervalle.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou a construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction
	 * @param {String} nomCalcul : Le nom donné au calcul.
	 * @param {CFonc} fonctionAssociee : La fonction utilistauer dont on cherche le maximum.
	 * @param {CValeur} a : La borne inférieure de l'intervalle de recherche.
	 * @param {CValeur} b : La borne supérieure de l'intervalle de recherche.
	 * @param {CValeur} incertitude : L'incertitude demandée.
	 * @returns {CMaxFonc}
	 */
	function CMaxFonc(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, a, b, incertitude) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);else {
	      CCalculAncetre.call(this, this.listeProprietaire, impProto, estElementFinal, nomCalcul);
	      this.fonctionAssociee = fonctionAssociee;
	      this.a = a;
	      this.b = b;
	      this.incertitude = incertitude;
	    }
	  }
	}
	CMaxFonc.prototype = new CCalculAncetre();
	CMaxFonc.prototype.constructor = CMaxFonc;
	CMaxFonc.prototype.superClass = "CCalculAncetre";
	CMaxFonc.prototype.className = "CMaxFonc";
	
	CMaxFonc.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var aClone = this.a.getClone(listeSource, listeCible);
	  var bClone = this.b.getClone(listeSource, listeCible);
	  var incertitudeClone = this.incertitude.getClone(listeSource, listeCible);
	  return new CMaxFonc(listeCible, listeCible.get(ind2, "CImplementationProto.class"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CFonc"), aClone, bClone, incertitudeClone);
	};
	CMaxFonc.prototype.getNatureCalcul = function () {
	  return NatCal.NMaximumFonction;
	};
	CMaxFonc.prototype.initialisePourDependance = function () {
	  CCalculAncetre.prototype.initialisePourDependance.call(this);
	  this.a.initialisePourDependance();
	  this.b.initialisePourDependance();
	  this.incertitude.initialisePourDependance();
	};
	CMaxFonc.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe(p) || this.a.dependDe(p) || this.b.dependDe(p) || this.incertitude.dependDe(p) || this.fonctionAssociee.dependDe(p));
	};
	CMaxFonc.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.b.dependDePourBoucle(p) || this.incertitude.dependDePourBoucle(p) || this.fonctionAssociee.dependDePourBoucle(p);
	};
	CMaxFonc.prototype.positionne = function (infoRandom, dimfen) {
	  var x1, x2, xa, xb, y1, y2, e, h, temp, i;
	  this.a.positionne(infoRandom, dimfen);
	  this.b.positionne(infoRandom, dimfen);
	  this.incertitude.positionne(infoRandom, dimfen);
	  this.existe = this.fonctionAssociee.existe && this.a.existe && this.b.existe && this.incertitude.existe;
	  if (!this.existe) return;
	  xa = this.a.rendValeur();
	  xb = this.b.rendValeur();
	  e = this.incertitude.rendValeur();
	  if (xa > xb) {
	    temp = xa;
	    xa = xb;
	    xb = temp;
	  }
	  var nBoucles = Math.floor(Math.log(Math.abs(xb - xa) / e) / Math.log(1.5)) + 1;
	  if (nBoucles > 1000) {
	    this.existe = false;
	    return;
	  }
	  h = (xb - xa) / 3;
	  x1 = xa + h;
	  x2 = xb - h;
	  for (i = 1; i <= nBoucles; i++) {
	    h = (xb - xa) / 3;
	    x1 = xa + h;
	    x2 = xb - h;
	    try {
	      y1 = this.fonctionAssociee.rendValeurFonction(infoRandom, x1);
	      y2 = this.fonctionAssociee.rendValeurFonction(infoRandom, x2);
	    } catch (err) {
	      this.existe = false;
	      return;
	    }
	    if (y1 > y2) xb = x2;else xa = x1;
	  }
	  this.existe = true;
	  this.valeur = (x1 + x2) / 2; // Ne pas employer valeur contrairement version Java
	};
	CMaxFonc.prototype.rendValeur = function () {
	  return this.valeur;
	};
	CMaxFonc.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.fonctionAssociee = list.get(ind1, "CFonc");
	  this.a = new CValeur();
	  this.a.read(inps, list);
	  this.b = new CValeur();
	  this.b.read(inps, list);
	  this.incertitude = new CValeur();
	  this.incertitude.read(inps, list);
	};
	CMaxFonc.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.fonctionAssociee);
	  oups.writeInt(ind1);
	  this.a.write(oups, list);
	  this.b.write(oups, list);
	  this.incertitude.write(oups, list);
	};
	CMaxFonc.prototype.estConstant = function () {
	  return this.a.estConstant() && this.b.estConstant() && this.incertitude.estConstant() && this.fonctionAssociee.estConstant();
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var CDroite = __webpack_require__(98);
	module.exports = CMediatrice;
	
	/**
	 * Classe médiatrice donnée par la donnée de deux points.
	 * @constructor
	 * @extends CDroite
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction.
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Décalage en abscisses du nom.
	 * @param {Integer} dec_y : Décalage en ordonnées du nom.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {String} nom : Le nom de l'objet. Seules les droites peuvent être nommées,
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {mtg32.StyleTrait} style : Le style de trait utilisé
	 * @param {Number} abscisseNom : Abscisse du nom par rapport à la droite.
	 * @param {CPt} point1 : Premier point.
	 * @param {type} point2 : Deuxième point.
	 * @returns {CMediatrice}
	 */
	function CMediatrice(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom, point1, point2) {
	  if (arguments.length === 1) CDroite.call(this, listeProprietaire);else {
	    CDroite.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, style, abscisseNom);
	    this.point1 = point1;
	    this.point2 = point2;
	  }
	}
	CMediatrice.prototype = new CDroite();
	CMediatrice.prototype.constructor = CMediatrice;
	CMediatrice.prototype.superClass = "CDroite";
	CMediatrice.prototype.className = "CMediatrice";
	
	CMediatrice.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.point1);
	  var ind2 = listeSource.indexOf(this.point2);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CMediatrice(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.style, this.abscisseNom, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"));
	};
	CMediatrice.prototype.ajouteAntecedents = function (frame, liste) {
	  liste.add(this.point1);
	  liste.add(this.point2);
	};
	CMediatrice.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CDroite.prototype.dependDe.call(this, p) || this.point1.dependDe(p) || this.point2.dependDe(p));
	};
	CMediatrice.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.point1.dependDePourBoucle(p) || this.point2.dependDePourBoucle(p);
	};
	CMediatrice.prototype.positionne = function (infoRandom, dimfen) {
	  var v = new Vect();
	  this.existe = this.point1.existe && this.point2.existe;
	  if (!this.existe) return;
	  this.point_x = (this.point1.x + this.point2.x) / 2;
	  this.point_y = (this.point1.y + this.point2.y) / 2;
	  v.setVecteur(this.point1, this.point2);
	  if (v.x === 0 && v.y === 0) this.existe = false;else {
	    v.getOrthogonal(this.vect);
	    CDroite.prototype.positionne.call(this, infoRandom, dimfen);
	  }
	};
	CMediatrice.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.point1 === p.point1 && this.point2 === p.point2 || this.point2 === p.point1 && this.point1 === p.point2;
	  } else return false;
	};
	CMediatrice.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.point1 === ancienPoint) this.point1 = nouveauPoint;
	  if (this.point2 === ancienPoint) this.point2 = nouveauPoint;
	};
	CMediatrice.prototype.read = function (inps, list) {
	  CDroite.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.point1 = list.get(ind1, "CPt");
	  this.point2 = list.get(ind2, "CPt");
	};
	CMediatrice.prototype.write = function (oups, list) {
	  CDroite.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.point1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.point2);
	  oups.writeInt(ind2);
	};
	CMediatrice.prototype.estPerpendiculaireParDefinition = function (dte) {
	  return this.listeProprietaire.sontParDefinitionSurParallele(this.point1, this.point2, dte);
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CValDyn = __webpack_require__(29);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CMesureAbscisse;
	
	/**
	 * Classe représentant l'abscisse d'un point sur une droite dans un repère formé par deux points.
	 * Pour que l'objet existe, les points doivent être alignés (à epsilon près).
	 * @constructor
	 * @extends CValDyn
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} origine: : Le point origine pour la mesure.
	 * @param {CPt} extremite : Le point d'abscisse 1 pour la mesure.
	 * @param {CPt} pointMesure : Le point dont on mesure l'abscisse.
	 * @returns {CMesureAbscisse}
	 */
	function CMesureAbscisse(listeProprietaire, impProto, estElementFinal, origine, extremite, pointMesure, nomCalcul) {
	  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.origine = origine;
	    this.extremite = extremite;
	    this.pointMesure = pointMesure;
	    this.abscisse = 0;
	  }
	}
	CMesureAbscisse.prototype = new CCalculAncetre();
	CMesureAbscisse.prototype.constructor = CMesureAbscisse;
	CMesureAbscisse.prototype.superClass = "CCalculAncetre";
	CMesureAbscisse.prototype.className = "CMesureAbscisse";
	
	// Ajout version 5.0
	CMesureAbscisse.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CMesureAbscisse.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.origine);
	  var ind2 = listeSource.indexOf(this.extremite);
	  var ind3 = listeSource.indexOf(this.pointMesure);
	  var ind4 = listeSource.indexOf(this.impProto);
	  // Ajout version 5.0
	  var nomCalc = this.nomCalcul.length === 0 ? listeCible.genereNomPourCalcul(debutNom()) : this.nomCalcul;
	  //
	  return new CMesureAbscisse(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"), nomCalc);
	};
	CMesureAbscisse.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureAbscisseSurDroite;
	};
	CMesureAbscisse.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.origine);
	  liste.add(this.extremite);
	  liste.add(this.pointMesure);
	};
	CMesureAbscisse.prototype.setClone = function (ptel) {
	  this.abscisse = ptel.abscisse;
	};
	CMesureAbscisse.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CValDyn.prototype.dependDe.call(this, p) || this.origine.dependDe(p) || this.extremite.dependDe(p) || this.pointMesure.dependDe(p));
	};
	CMesureAbscisse.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.origine.dependDePourBoucle(p) || this.extremite.dependDePourBoucle(p) || this.pointMesure.dependDePourBoucle(p);
	};
	CMesureAbscisse.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.origine.existe && this.extremite.existe && this.pointMesure.existe && !this.origine.egal(this.extremite);
	  this.existe = this.existe && kernel.aligne(this.origine.x, this.origine.y, this.extremite.x, this.extremite.y, this.pointMesure.x, this.pointMesure.y);
	  if (!this.existe) return;
	  // L'orientation sur l'écran est l'inverse de celle du repère
	  // choisi.Il faut donc permuter les rôles de u et v}
	  var v = new Vect(this.origine, this.extremite);
	  var u = new Vect(this.origine, this.pointMesure);
	  // Nouvelle modif
	  if (Math.abs(v.x) > Math.abs(v.y)) this.abscisse = u.x / v.x;else this.abscisse = u.y / v.y;
	};
	CMesureAbscisse.prototype.nomIndispensable = function (el) {
	  return el === this.origine || el === this.extremite || el === this.pointMesure;
	};
	CMesureAbscisse.prototype.rendValeur = function () {
	  return this.abscisse;
	};
	CMesureAbscisse.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.origine === p.origine && this.extremite === p.extremite && this.pointMesure === p.pointMesure;
	  } else return false;
	};
	CMesureAbscisse.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.origine === ancienPoint) this.origine = nouveauPoint;
	  if (this.extremite === ancienPoint) this.extremite = nouveauPoint;
	  if (this.pointMesure === ancienPoint) this.pointMesure = nouveauPoint;
	};
	CMesureAbscisse.prototype.read = function (inps, list) {
	  // CValDyn.prototype.read.call(this, inps, list); Modifié version 5.0
	  if (this.nVersion >= 2) CCalculAncetre.prototype.read.call(this, inps, list);else {
	    CValDyn.prototype.read.call(this, inps, list);
	    if (this.listeProprietaire.className === "CPrototype") this.nomCalcul = "";else this.nomCalcul = this.listeProprietaire.genereNomPourCalcul("abs");
	  }
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.origine = list.get(ind1, "CPt");
	  this.extremite = list.get(ind2, "CPt");
	  this.pointMesure = list.get(ind3, "CPt");
	};
	CMesureAbscisse.prototype.write = function (oups, list) {
	  // CValDyn.prototype.write.call(this, oups, list); Modifié version 5.0
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.origine);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.extremite);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.pointMesure);
	  oups.writeInt(ind3);
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Complexe = __webpack_require__(30);
	var Vect = __webpack_require__(12);
	var CValDyn = __webpack_require__(29);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CMesureAffixe;
	
	/**
	 * Classe représentant la mesure de l'affixe complexe d'un point dans un repère.
	 * @constructor
	 * @extends CValDyn
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {boolean} estElementFinal : true si élément final de construction.
	 * @param {CRepere} repereAssocie : Le repère dans lequel se fait la mesure
	 * @param {CPt} pointMesure : Le point dont on mesure l'affixe.
	 * @param {string} nomCalcul : Le nom du calcul
	 * @constructor
	 */
	function CMesureAffixe(listeProprietaire, impProto, estElementFinal, repereAssocie, pointMesure, nomCalcul) {
	  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else {
	    CValDyn.call(this, listeProprietaire, impProto, estElementFinal);
	    this.repereAssocie = repereAssocie;
	    this.pointMesure = pointMesure;
	    this.nomCalcul = nomCalcul;
	  }
	  this.affixe = new Complexe();
	}
	CMesureAffixe.prototype = new CCalculAncetre();
	CMesureAffixe.prototype.constructor = CMesureAffixe;
	CMesureAffixe.prototype.superClass = "CCalculAncetre";
	CMesureAffixe.prototype.className = "CMesureAffixe";
	
	CMesureAffixe.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CMesureAffixe.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.repereAssocie);
	  var ind2 = listeSource.indexOf(this.pointMesure);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CMesureAffixe(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CRepere"), listeCible.get(ind2, "CPt"), this.nomCalcul);
	};
	CMesureAffixe.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureAffixe;
	};
	CMesureAffixe.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CValDyn.prototype.dependDe.call(this, p) || this.repereAssocie.dependDe(p) || this.pointMesure.dependDe(p));
	};
	CMesureAffixe.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.repereAssocie.dependDePourBoucle(p) || this.pointMesure.dependDePourBoucle(p);
	};
	CMesureAffixe.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.repereAssocie.existe && this.pointMesure.existe;
	  if (!this.existe) return;
	  // L'orientation sur l'écran est l'inverse de celle du repère
	  // choisi.Il faut donc permuter les rôles de u et v}
	  var u = new Vect(this.repereAssocie.o, this.repereAssocie.i);
	  var v = new Vect(this.repereAssocie.o, this.repereAssocie.j);
	  // Calcul des	abscisses et ordonnées de l'origine réelle du repère dans le repère de base
	  var absOrigine = this.repereAssocie.valAbscisseOrigine / this.repereAssocie.unitex;
	  var ordOrigine = this.repereAssocie.valOrdonneeOrigine / this.repereAssocie.unitey;
	  var xno = this.repereAssocie.o.x - u.x * absOrigine - v.x * ordOrigine;
	  var yno = this.repereAssocie.o.y - u.y * absOrigine - v.y * ordOrigine;
	  // Calcul de l'abscisse et de l'ordonnée par résolution d'un système linéaire
	  var det = u.x * v.y - v.x * u.y;
	  this.affixe.x = (v.y * (this.pointMesure.x - xno) - v.x * (this.pointMesure.y - yno)) / det * this.repereAssocie.unitex;
	  this.affixe.y = (u.x * (this.pointMesure.y - yno) - u.y * (this.pointMesure.x - xno)) / det * this.repereAssocie.unitey;
	};
	CMesureAffixe.prototype.nomIndispensable = function (el) {
	  return el === this.pointMesure;
	};
	CMesureAffixe.prototype.rendValeurComplexe = function (zRes) {
	  zRes.set(this.affixe.x, this.affixe.y);
	};
	CMesureAffixe.prototype.rendChaineValeurPourCommentaire = function (nbDecimales) {
	  return this.rendChaineValeurComplexe(nbDecimales);
	};
	CMesureAffixe.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.repereAssocie === p.repereAssocie && this.pointMesure === p.pointMesure;
	  } else return false;
	};
	CMesureAffixe.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.pointMesure);
	};
	CMesureAffixe.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointMesure === ancienPoint) this.pointMesure = nouveauPoint;
	};
	CMesureAffixe.prototype.read = function (inps, list) {
	  // CValDyn.prototype.read.call(this, inps, list); Modifié version 5.0
	  if (this.nVersion >= 2) CCalculAncetre.prototype.read.call(this, inps, list);else {
	    CValDyn.prototype.read.call(this, inps, list);
	    if (this.listeProprietaire.className === "CPrototype") this.nomCalcul = "";else this.nomCalcul = this.listeProprietaire.genereNomPourCalcul("aff");
	  }
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.repereAssocie = list.get(ind1, "CRepere");
	  this.pointMesure = list.get(ind2, "CPt");
	};
	CMesureAffixe.prototype.write = function (oups, list) {
	  CValDyn.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.repereAssocie);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this, this.pointMesure);
	  oups.writeInt(ind2);
	};

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CValDyn = __webpack_require__(29);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CMesureAire;
	
	/**
	 * Classe représentant la mesure de l'aire d'un polygone.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPolygone} polygoneAssocie : Le polygone dont on mesure l'aire.
	 * @param {String} nomCalcul : Le nom.
	 * @returns {CMesureAire}
	 */
	function CMesureAire(listeProprietaire, impProto, estElementFinal, nomCalcul, polygoneAssocie) {
	  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.polygoneAssocie = polygoneAssocie;
	    this.aire = 0;
	  }
	}
	CMesureAire.prototype = new CCalculAncetre();
	CMesureAire.prototype.constructor = CMesureAire;
	CMesureAire.prototype.superClass = "CCalculAncetre";
	CMesureAire.prototype.className = "CMesureAire";
	
	CMesureAire.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.polygoneAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CMesureAire(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CPolygone"));
	};
	CMesureAire.prototype.setClone = function (ptel) {
	  this.aire = ptel.aire;
	};
	CMesureAire.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.polygoneAssocie);
	};
	CMesureAire.prototype.nomIndispensable = function (el) {
	  for (var i = 0; i < this.polygoneAssocie.collectionPoints.length; i++) {
	    var nd = this.polygoneAssocie.collectionPoints.get(i);
	    if (nd.pointeurSurPoint === el) return true;
	  }
	  return false;
	};
	CMesureAire.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureAirePolygone;
	};
	CMesureAire.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.polygoneAssocie.dependDe(p) || this.listeProprietaire.pointeurLongueurUnite.dependDe(p));
	};
	CMesureAire.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.polygoneAssocie.dependDePourBoucle(p) || this.listeProprietaire.pointeurLongueurUnite.dependDePourBoucle(p);
	};
	CMesureAire.prototype.rendValeur = function () {
	  return this.aire;
	};
	CMesureAire.prototype.positionne = function (infoRandom, dimfen) {
	  var pLongUnite = this.listeProprietaire.pointeurLongueurUnite;
	  this.existe = this.polygoneAssocie.existe && pLongUnite.existe;
	  if (!this.existe) return;
	  var longueurUnite = pLongUnite.rendLongueur();
	  // Si la longueur unité est nulle, pLongUnite n'existe pas
	  var aire = 0;
	  var array = this.polygoneAssocie.colPoints;
	  for (var i = 0; i < array.length - 1; i++) {
	    var ptp1 = array[i].pointeurSurPoint;
	    var ptp2 = array[i + 1].pointeurSurPoint;
	    aire += (ptp1.x * ptp2.y - ptp1.y * ptp2.x) / 2;
	  }
	  this.aire = Math.abs(aire) / (longueurUnite * longueurUnite);
	};
	CMesureAire.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.polygoneAssocie === p.polygoneAssocie;
	  } else return false;
	};
	CMesureAire.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.polygoneAssocie = list.get(ind1, "CPolygone");
	};
	CMesureAire.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.polygoneAssocie);
	  oups.writeInt(ind1);
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CValDyn = __webpack_require__(29);
	module.exports = CMesureAngleGeometrique;
	
	/**
	 * Classe représentant la mesure d'un angle non orienté donné par trois points.
	 * @constructor
	 * @extends CValDyn
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} a : Premier point (angle aob)
	 * @param {CPt} o : Le sommet de l'angle
	 * @param {CPt} b : Le troisème point (angle aob)
	 * @returns {CMesureAngleGeometrique}
	 */
	function CMesureAngleGeometrique(listeProprietaire, impProto, estElementFinal, a, o, b) {
	  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else {
	    CValDyn.call(this, listeProprietaire, impProto, estElementFinal);
	    this.a = a;
	    this.o = o;
	    this.b = b;
	    this.mesure = 0;
	  }
	}
	CMesureAngleGeometrique.prototype = new CValDyn();
	CMesureAngleGeometrique.prototype.constructor = CMesureAngleGeometrique;
	CMesureAngleGeometrique.prototype.superClass = "CValDyn";
	CMesureAngleGeometrique.prototype.className = "CMesureAngleGeometrique";
	
	CMesureAngleGeometrique.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.o);
	  var ind3 = listeSource.indexOf(this.b);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CMesureAngleGeometrique(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"));
	};
	CMesureAngleGeometrique.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureAngleNonOriente;
	};
	CMesureAngleGeometrique.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.a);
	  liste.add(this.o);
	  liste.add(this.b);
	};
	CMesureAngleGeometrique.prototype.setClone = function (ptel) {
	  this.mesure = ptel.mesure;
	};
	CMesureAngleGeometrique.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CValDyn.prototype.dependDe.call(this, p) || this.a.dependDe(p) || this.o.dependDe(p) || this.b.dependDe(p));
	};
	CMesureAngleGeometrique.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.o.dependDePourBoucle(p) || this.b.dependDePourBoucle(p);
	};
	CMesureAngleGeometrique.prototype.getNom = function () {
	  return this.a.nom + this.o.nom + this.b.nom;
	};
	CMesureAngleGeometrique.prototype.positionne = function (infoRandom, dimfen) {
	  var prosca, deter, tangente, resul;
	
	  this.existe = this.a.existe && this.o.existe && this.b.existe && !this.o.egal(this.a) && !this.o.egal(this.b);
	  if (!this.existe) return;
	  // L'orientation sur l'écran est l'inverse de celle du
	  // repère choisi.Il faut donc permuter les rôles de u et v}
	  var v = new Vect(this.o, this.a);
	  var u = new Vect(this.o, this.b);
	  prosca = u.x * v.x + u.y * v.y;
	  deter = Math.abs(u.x * v.y - u.y * v.x);
	  if (prosca === 0) resul = Math.PI / 2;else {
	    tangente = deter / prosca;
	    if (prosca > 0) resul = Math.atan(tangente);else {
	      resul = Math.PI - Math.atan(-tangente);
	      if (resul > Math.PI) resul = resul - 2 * Math.PI;
	    }
	    resul = Math.abs(resul);
	  }
	  if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) this.mesure = resul;else this.mesure = resul * kernel.ConvRadDeg;
	};
	CMesureAngleGeometrique.prototype.nomIndispensable = function (el) {
	  return el === this.a || el === this.o || el === this.b;
	};
	CMesureAngleGeometrique.prototype.rendValeur = function () {
	  return this.mesure;
	};
	CMesureAngleGeometrique.prototype.chaineCommenceParNom = function (pChaine, longueurNom) {
	  // Pour une longueur AB par exemple, le nom BA est équivalent
	  if (CValDyn.prototype.chaineCommenceParNom.call(this, pChaine, longueurNom)) {
	    return true;
	  } else {
	    var chaineNom = this.b.nom + this.o.nom + this.a.nom;
	    longueurNom.x = chaineNom.length;
	    var longueurChaine2 = pChaine.length;
	    if (longueurChaine2 < longueurNom.x) return false;else return chaineNom === pChaine.substring(0, longueurNom.x);
	  }
	};
	CMesureAngleGeometrique.prototype.chaineEgaleANom = function (ch) {
	  if (CValDyn.prototype.chaineEgaleANom.call(this, ch)) return true;
	  var ch2 = this.b.rendNom() + this.o.rendNom() + this.a.rendNom();
	  return ch === ch2;
	};
	
	CMesureAngleGeometrique.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.o === p.o && (this.a === p.a && this.b === p.b || this.a === p.b && this.b === p.a);
	  } else return false;
	};
	CMesureAngleGeometrique.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	  if (this.o === ancienPoint) this.o = nouveauPoint;
	  if (this.b === ancienPoint) this.b = nouveauPoint;
	};
	CMesureAngleGeometrique.prototype.read = function (inps, list) {
	  CValDyn.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.a = list.get(ind1, "CPt");
	  this.o = list.get(ind2, "CPt");
	  this.b = list.get(ind3, "CPt");
	};
	CMesureAngleGeometrique.prototype.write = function (oups, list) {
	  CValDyn.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.a);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.o);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.b);
	  oups.writeInt(ind3);
	};

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CValDyn = __webpack_require__(29);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CMesureAngleOriente;
	
	/**
	 * Classe représentant la mesure d'un angle orienté donné par trois points.
	 * @constructor
	 * @extends CMesureAngleGeometrique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} a : Premier point (angle aob)
	 * @param {CPt} o : Le sommet de l'angle
	 * @param {CPt} b : Le troisème point (angle aob)
	 * @returns {CMesureAngleOriente}
	 */
	function CMesureAngleOriente(listeProprietaire, impProto, estElementFinal, a, o, b, nomCalcul) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.a = a;
	    this.o = o;
	    this.b = b;
	  }
	}
	CMesureAngleOriente.prototype = new CCalculAncetre();
	CMesureAngleOriente.prototype.constructor = CMesureAngleOriente;
	CMesureAngleOriente.prototype.superClass = "CCalculAncetre";
	CMesureAngleOriente.prototype.className = "CMesureAngleOriente";
	
	// Ajout version 5.0
	CMesureAngleOriente.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CMesureAngleOriente.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.o);
	  var ind3 = listeSource.indexOf(this.b);
	  var ind4 = listeSource.indexOf(this.impProto);
	  // Ajout version 5.0
	  var nomCalc = this.nomCalcul.length === 0 ? listeCible.genereNomPourCalcul(debutNom()) : this.nomCalcul;
	  //
	  return new CMesureAngleOriente(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"), nomCalc);
	};
	CMesureAngleOriente.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureAngleOriente;
	};
	CMesureAngleOriente.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CValDyn.prototype.dependDe.call(this, p) || this.a.dependDe(p) || this.o.dependDe(p) || this.b.dependDe(p));
	};
	CMesureAngleOriente.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.o.dependDePourBoucle(p) || this.b.dependDePourBoucle(p);
	};
	CMesureAngleOriente.prototype.rendValeur = function () {
	  return this.mesure;
	};
	CMesureAngleOriente.prototype.positionne = function (infoRandom, dimfen) {
	  var prosca, deter, tangente, resul;
	
	  this.existe = this.a.existe && this.o.existe && this.b.existe && !this.o.egal(this.a) && !this.o.egal(this.b);
	  if (!this.existe) return;
	  // L'orientation sur l'écran est l'inverse de celle du repère
	  // choisi.Il faut donc permuter les rôles de U et V
	  var v = new Vect(this.o, this.a);
	  var u = new Vect(this.o, this.b);
	  prosca = u.x * v.x + u.y * v.y;
	  deter = u.x * v.y - u.y * v.x;
	  if (prosca === 0) {
	    if (deter > 0) resul = Math.PI / 2;else resul = -Math.PI / 2;
	  } else {
	    tangente = deter / prosca;
	    if (prosca > 0) resul = Math.atan(tangente);else {
	      if (deter >= 0) resul = Math.atan(tangente) + Math.PI;else resul = Math.atan(tangente) - Math.PI;
	    }
	  }
	  // Nouveau pour version 1.3.6 : on regarde si l'angle est très proche de - pi. Si oui on renvoie pi
	  if (Math.abs(resul + Math.PI) < 1e-13) resul = Math.PI;
	  if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.radian) this.mesure = resul;else this.mesure = resul * kernel.ConvRadDeg;
	};
	CMesureAngleOriente.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.o === p.o && this.a === p.a && this.b === p.b;
	  } else return false;
	};
	// Ajouts version 5.0 car maintenant dérive de CCalculAncetre
	CMesureAngleOriente.prototype.read = function (inps, list) {
	  if (this.nVersion >= 2) CCalculAncetre.prototype.read.call(this, inps, list);else {
	    CValDyn.prototype.read.call(this, inps, list);
	    if (this.listeProprietaire.className === "CPrototype") this.nomCalcul = "";else this.nomCalcul = this.listeProprietaire.genereNomPourCalcul("ang");
	  }
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.a = list.get(ind1, "CPt");
	  this.o = list.get(ind2, "CPt");
	  this.b = list.get(ind3, "CPt");
	};
	CMesureAngleOriente.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.a);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.o);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.b);
	  oups.writeInt(ind3);
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CValDyn = __webpack_require__(29);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CMesureCoefDir;
	
	/**
	 * Classe représentant une mesure de coefficient directeur de droite dans un repère.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nom : Le nom du calcul.
	 * @param {CRepere} rep : Le repère dans lequel se fait la mesure.
	 * @param {CDroite} d : La droite dont on mesure le coefficient directeur.
	 * @returns {CMesureCoefDir}
	 */
	function CMesureCoefDir(listeProprietaire, impProto, estElementFinal, nom, rep, d) {
	  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nom);
	    this.rep = rep;
	    this.d = d;
	    this.coef = 0;
	  }
	}
	CMesureCoefDir.prototype = new CCalculAncetre();
	CMesureCoefDir.prototype.constructor = CMesureCoefDir;
	CMesureCoefDir.prototype.superClass = "CCalculAncetre";
	CMesureCoefDir.prototype.className = "CMesureCoefDir";
	
	CMesureCoefDir.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.d);
	  var ind2 = listeSource.indexOf(this.rep);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CMesureCoefDir(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind2, "CRepere"), listeCible.get(ind1, "CDroite"));
	};
	CMesureCoefDir.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureCoefDir;
	};
	CMesureCoefDir.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.d);
	};
	CMesureCoefDir.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.rep.dependDe(p) || this.d.dependDe(p));
	};
	CMesureCoefDir.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.rep.dependDePourBoucle(p) || this.d.dependDePourBoucle(p);
	};
	CMesureCoefDir.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.rep.existe && this.d.existe;
	  if (!this.existe) return;
	  // On calcule les coordonnées du Vect directeur de la droite dans le repère à un coeff près
	  var a = this.d.vect.x; // Première coordonnée du Vect directeur de la droite
	  var b = this.d.vect.y; // Deuxième coordonnée
	  var x = this.rep.v.y * a - this.rep.v.x * b;
	  var y = this.rep.u.x * b - this.rep.u.y * a;
	  if (x === 0) {
	    this.existe = false;
	    return;
	  }
	  this.coef = y / x / this.rep.unitex * this.rep.unitey;
	};
	CMesureCoefDir.prototype.rendValeur = function (infoRandom) {
	  return this.coef;
	};
	CMesureCoefDir.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.rep === p.rep && this.d === p.d;
	  } else return false;
	};
	CMesureCoefDir.prototype.nomIndispensable = function (el) {
	  return el === this.d;
	};
	CMesureCoefDir.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.rep = list.get(ind1, "CRepere");
	  this.d = list.get(ind2, "CDroite");
	};
	CMesureCoefDir.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.rep);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.d);
	  oups.writeInt(ind2);
	};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Vect = __webpack_require__(12);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CMesureLongueurLigne;
	
	/**
	 * Classe représentant une mesure de longueur d'une ligne : ligne brisée ou polygone.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CLignePolygonaleAncetre} ligneAssociee : La ligne brisée ou le polygone dont on mesure la longueur.
	 * @constructor
	 */
	function CMesureLongueurLigne(listeProprietaire, impProto, estElementFinal, nomCalcul, ligneAssociee) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.ligneAssociee = ligneAssociee;
	  }
	  this.u = new Vect();
	  this.longueur = 0;
	}
	CMesureLongueurLigne.prototype = new CCalculAncetre();
	CMesureLongueurLigne.prototype.constructor = CMesureLongueurLigne;
	CMesureLongueurLigne.prototype.superClass = "CCalculAncetre";
	CMesureLongueurLigne.prototype.className = "CMesureLongueurLigne";
	
	CMesureLongueurLigne.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.ligneAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CMesureLongueurLigne(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CLignePolygonaleAncetre"), this.nomCalcul);
	};
	CMesureLongueurLigne.prototype.nomIndispensable = function (el) {
	  for (var i = 0; i < this.ligneAssociee.colPoints.length; i++) {
	    var nd = this.ligneAssociee.colPoints.get(i);
	    if (nd.pointeurSurPoint === el) return true;
	  }
	  return false;
	};
	CMesureLongueurLigne.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureLongueurLigne;
	};
	CMesureLongueurLigne.prototype.setClone = function (ptel) {
	  this.longueur = ptel.longueur;
	};
	CMesureLongueurLigne.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.ligneAssociee);
	};
	CMesureLongueurLigne.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.ligneAssociee.dependDe(p) || this.listeProprietaire.pointeurLongueurUnite.dependDe(p));
	};
	CMesureLongueurLigne.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.ligneAssociee.dependDePourBoucle(p) || this.listeProprietaire.pointeurLongueurUnite.dependDePourBoucle(p);
	};
	CMesureLongueurLigne.prototype.rendValeur = function () {
	  return this.longueur;
	};
	CMesureLongueurLigne.prototype.positionne = function (infoRandom, dimfen) {
	  var pLongUnite = this.listeProprietaire.pointeurLongueurUnite;
	  this.existe = this.ligneAssociee.existe && pLongUnite.existe;
	  if (!this.existe) return;
	  var longueurUnite = pLongUnite.rendLongueur();
	  // Si la longueur unité est nulle, pLongUnite n'existe pas
	  this.longueur = 0;
	  var array = this.ligneAssociee.colPoints;
	  for (var i = 0; i < array.length - 1; i++) {
	    var ptp1 = array[i].pointeurSurPoint;
	    var ptp2 = array[i + 1].pointeurSurPoint;
	    this.u.x = ptp2.x - ptp1.x;
	    this.u.y = ptp2.y - ptp1.y;
	    this.longueur += this.u.norme();
	  }
	  this.longueur /= longueurUnite;
	};
	CMesureLongueurLigne.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.ligneAssociee === p.ligneAssociee;
	  } else return false;
	};
	CMesureLongueurLigne.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.ligneAssociee = list.get(ind1, "CLignePolygonaleAncetre");
	};
	CMesureLongueurLigne.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.ligneAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Vect = __webpack_require__(12);
	var CValDyn = __webpack_require__(29);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CMesureX;
	
	/**
	 * Classe représentant la mesure de l'abscisse d'un point dans un repère.
	 * @constructor
	 * @extends CValDyn
	 * @param {CListeObjets} listeProprietaire : la liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CRepere} repereAssocie : Le repère dans lequel on fait la mesure.
	 * @param {CPt} pointMesure : Le point dont on mesure l'abscisse.
	 * @returns {CMesureX}
	 */
	function CMesureX(listeProprietaire, impProto, estElementFinal, nomCalcul, repereAssocie, pointMesure) {
	  if (arguments.length === 0) return; // Ajout version WebPack
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.repereAssocie = repereAssocie;
	    this.pointMesure = pointMesure;
	  }
	}
	
	// CMesureX.prototype = new CValDyn(); Modifié version 5.0
	CMesureX.prototype = new CCalculAncetre();
	CMesureX.prototype.constructor = CMesureX;
	// CMesureX.prototype.superClass = "CValDyn"; Modifié version 5.0
	CMesureX.prototype.superClass = "CCalculAncetre";
	CMesureX.prototype.className = "CMesureX";
	
	// Ajout version 5.0
	CMesureX.prototype.numeroVersion = function () {
	  return 2;
	};
	// Ajout version 5.0
	CMesureX.prototype.debutNom = function () {
	  return "xCoord";
	};
	
	CMesureX.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.repereAssocie);
	  var ind2 = listeSource.indexOf(this.pointMesure);
	  var ind3 = listeSource.indexOf(this.impProto);
	  // Ajout version 5.0
	  var nomCalc = this.nomCalcul.length === 0 ? listeCible.genereNomPourCalcul(this.debutNom()) : this.nomCalcul;
	  //
	  return new CMesureX(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, nomCalc, listeCible.get(ind1, "CRepere"), listeCible.get(ind2, "CPt"));
	};
	CMesureX.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureAbscisseRepere;
	};
	CMesureX.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.pointMesure);
	};
	CMesureX.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CValDyn.prototype.dependDe.call(this, p) || this.repereAssocie.dependDe(p) || this.pointMesure.dependDe(p));
	};
	CMesureX.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.repereAssocie.dependDePourBoucle(p) || this.pointMesure.dependDePourBoucle(p);
	};
	CMesureX.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.repereAssocie.existe && this.pointMesure.existe;
	  if (!this.existe) return;
	  // L'orientation sur l'écran est l'inverse de celle du repère
	  // choisi.Il faut donc permuter les rôles de u et v}
	  var u = new Vect(this.repereAssocie.o, this.repereAssocie.i);
	  var v = new Vect(this.repereAssocie.o, this.repereAssocie.j);
	  // Calcul des	abscisses et ordonnées de l'origine réelle du repère dans le repère de base
	  var absOrigine = this.repereAssocie.valAbscisseOrigine / this.repereAssocie.unitex;
	  var ordOrigine = this.repereAssocie.valOrdonneeOrigine / this.repereAssocie.unitey;
	
	  var xno = this.repereAssocie.o.x - u.x * absOrigine - v.x * ordOrigine;
	  var yno = this.repereAssocie.o.y - u.y * absOrigine - v.y * ordOrigine;
	  // Calcul de l'abscisse par résolution d'un système linéaire
	  var det = u.x * v.y - v.x * u.y;
	  this.abscisse = (v.y * (this.pointMesure.x - xno) - v.x * (this.pointMesure.y - yno)) / det * this.repereAssocie.unitex;
	};
	CMesureX.prototype.rendValeur = function () {
	  return this.abscisse;
	};
	CMesureX.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointMesure === ancienPoint) this.pointMesure = nouveauPoint;
	};
	CMesureX.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.repereAssocie === p.repereAssocie && this.pointMesure === p.pointMesure;
	  } else return false;
	};
	CMesureX.prototype.nomIndispensable = function (el) {
	  return el === this.pointMesure;
	};
	CMesureX.prototype.read = function (inps, list) {
	  if (this.nVersion >= 2) CCalculAncetre.prototype.read.call(this, inps, list);else {
	    CValDyn.prototype.read.call(this, inps, list);
	    if (this.listeProprietaire.className === "CPrototype") this.nomCalcul = "";else this.nomCalcul = this.listeProprietaire.genereNomPourCalcul(this.debutNom());
	  }
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.repereAssocie = list.get(ind1, "CRepere");
	  this.pointMesure = list.get(ind2, "CPt");
	};
	CMesureX.prototype.write = function (oups, list) {
	  // CValDyn.prototype.write.call(this, oups, list); Modifié version 5.0
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.repereAssocie);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.pointMesure);
	  oups.writeInt(ind2);
	};

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Vect = __webpack_require__(12);
	var CMesureX = __webpack_require__(206);
	module.exports = CMesureY;
	
	/**
	 *
	 * Classe représentant la mesure de l'ordonnnée d'un point dans un repère.
	 * @constructor
	 * @extends CValDyn
	 * @param {CListeObjets} listeProprietaire : la liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {string} nomCalcul : Le nom du calcul
	 * @param {CRepere} repereAssocie : Le repère dans lequel on fait la mesure.
	 * @param {CPt} pointMesure : Le point dont on mesure l'abscisse.
	 * @returns {CMesureY}
	 */
	function CMesureY(listeProprietaire, impProto, estElementFinal, nomCalcul, repereAssocie, pointMesure) {
	  if (arguments.length === 1) CMesureX.call(this, listeProprietaire);else CMesureX.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, repereAssocie, pointMesure);
	}
	CMesureY.prototype = new CMesureX();
	CMesureY.prototype.constructor = CMesureY;
	CMesureY.prototype.superClass = "CMesureX";
	CMesureY.prototype.className = "CMesureY";
	
	// Ajout version 5.0
	CMesureY.prototype.debutNom = function () {
	  return "yCoord";
	};
	
	CMesureY.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.repereAssocie);
	  var ind2 = listeSource.indexOf(this.pointMesure);
	  var ind3 = listeSource.indexOf(this.impProto);
	  // Ajout version 5.0
	  var nomCalc = this.nomCalcul.length === 0 ? listeCible.genereNomPourCalcul(this.debutNom()) : this.nomCalcul;
	  //
	  return new CMesureY(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, nomCalc, listeCible.get(ind1, "CRepere"), listeCible.get(ind2, "CPt"));
	};
	CMesureY.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureOrdonneeRepere;
	};
	CMesureY.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.repereAssocie.existe && this.pointMesure.existe;
	  if (!this.existe) return;
	  // L'orientation sur l'écran est l'inverse de celle du repère
	  // choisi.Il faut donc permuter les rôles de u et v}
	  var u = new Vect(this.repereAssocie.o, this.repereAssocie.i);
	  var v = new Vect(this.repereAssocie.o, this.repereAssocie.j);
	  // Calcul des	abscisses et ordonnées de l'origine réelle du repère dans le repère de base
	  var absOrigine = this.repereAssocie.valAbscisseOrigine / this.repereAssocie.unitex;
	  var ordOrigine = this.repereAssocie.valOrdonneeOrigine / this.repereAssocie.unitey;
	  var xno = this.repereAssocie.o.x - u.x * absOrigine - v.x * ordOrigine;
	  var yno = this.repereAssocie.o.y - u.y * absOrigine - v.y * ordOrigine;
	  // Calcul de l'abscisse par résolution d'un système linéaire
	  var det = u.x * v.y - v.x * u.y;
	  this.abscisse = (u.x * (this.pointMesure.y - yno) - u.y * (this.pointMesure.x - xno)) / det * this.repereAssocie.unitey;
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CPt = __webpack_require__(87);
	module.exports = CMilieu;
	
	/**
	 * Classe point milieu donné par deux points.
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CPt} point1 : Le premier point.
	 * @param {CPt} point2 : Le deuxième point.
	 * @returns {CMilieu}
	 */
	function CMilieu(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, point1, point2) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.point1 = point1;
	    this.point2 = point2;
	  }
	}
	CMilieu.prototype = new CPt();
	CMilieu.prototype.constructor = CMilieu;
	CMilieu.prototype.superClass = "CPt";
	CMilieu.prototype.className = "CMilieu";
	
	CMilieu.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.point1);
	  var ind2 = listeSource.indexOf(this.point2);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CMilieu(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"));
	};
	CMilieu.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.point1);
	  liste.add(this.point2);
	};
	CMilieu.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.point1.existe && this.point2.existe;
	  if (this.existe) {
	    CPt.prototype.placeEn.call(this, (this.point1.x + this.point2.x) / 2, (this.point1.y + this.point2.y) / 2);
	    CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajouté version 4.6.4
	  }
	};
	CMilieu.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.point1.dependDe(p) || this.point2.dependDe(p));
	};
	CMilieu.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.point1.dependDePourBoucle(p) || this.point2.dependDePourBoucle(p);
	};
	CMilieu.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.point1 === p.point1 && this.point2 === p.point2 || this.point2 === p.point1 && this.point1 === p.point2;
	  } else return false;
	};
	CMilieu.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.point1 === ancienPoint) this.point1 = nouveauPoint;
	  if (this.point2 === ancienPoint) this.point2 = nouveauPoint;
	};
	CMilieu.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.point1 = list.get(ind1, "CPt");
	  this.point2 = list.get(ind2, "CPt");
	};
	CMilieu.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.point1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.point2);
	  oups.writeInt(ind2);
	};
	CMilieu.prototype.appartientDroiteParDefinition = function (droite) {
	  return this.point1.appartientDroiteParDefinition(droite) && this.point2.appartientDroiteParDefinition(droite);
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalculAncetre = __webpack_require__(35);
	var CMaxFonc = __webpack_require__(197);
	module.exports = CMinFonc;
	
	/**
	 * Classe représentant le calcul du minimum d'une fonction sur un intervalle.
	 * @constructor
	 * @extends CMaxFonc
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou a construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction
	 * @param {String} nomCalcul : Le nom donné au calcul.
	 * @param {CFonc} fonctionAssociee : La fonction utilistauer dont on cherche le minimum.
	 * @param {CValeur} a : La borne inférieure de l'intervalle de recherche.
	 * @param {CValeur} b : La borne supérieure de l'intervalle de recherche.
	 * @param {CValeur} incertitude : L'incertitude demandée.
	 * @returns {CMinFonc}
	 */
	// a, b et incertitude doivente être du type CValeurassocieeVariable, equation du type Ccb
	// fonction doit être du tye Ccb et représenter une équation de inconnue
	// Pas paramètre fonction par cette version
	function CMinFonc(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, a, b, incertitude) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);else CMaxFonc.call(this, this.listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, a, b, incertitude);
	  }
	}
	CMinFonc.prototype = new CMaxFonc();
	CMinFonc.prototype.constructor = CMinFonc;
	CMinFonc.prototype.superClass = "CMaxFonc";
	CMinFonc.prototype.className = "CMinFonc";
	
	CMinFonc.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var aClone = this.a.getClone(listeSource, listeCible);
	  var bClone = this.b.getClone(listeSource, listeCible);
	  var incertitudeClone = this.incertitude.getClone(listeSource, listeCible);
	  return new CMinFonc(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CFonc"), aClone, bClone, incertitudeClone);
	};
	CMinFonc.prototype.getNatureCalcul = function () {
	  return NatCal.NMinimumFonction;
	};
	CMinFonc.prototype.positionne = function (infoRandom, dimfen) {
	  var x1, x2, xa, xb, y1, y2, e, h, temp, i;
	  this.a.positionne(infoRandom, dimfen);
	  this.b.positionne(infoRandom, dimfen);
	  this.incertitude.positionne(infoRandom, dimfen);
	  this.existe = this.fonctionAssociee.existe && this.a.existe && this.b.existe && this.incertitude.existe;
	  if (!this.existe) return;
	  xa = this.a.rendValeur();
	  xb = this.b.rendValeur();
	  e = this.incertitude.rendValeur();
	  if (xa > xb) {
	    temp = xa;
	    xa = xb;
	    xb = temp;
	  }
	  var nBoucles = Math.floor(Math.log(Math.abs(xb - xa) / e) / Math.log(1.5)) + 1;
	  if (nBoucles > 1000) {
	    this.existe = false;
	    return;
	  }
	  h = (xb - xa) / 3;
	  x1 = xa + h;
	  x2 = xb - h;
	  for (i = 1; i <= nBoucles; i++) {
	    h = (xb - xa) / 3;
	    x1 = xa + h;
	    x2 = xb - h;
	    try {
	      y1 = this.fonctionAssociee.rendValeurFonction(infoRandom, x1);
	      y2 = this.fonctionAssociee.rendValeurFonction(infoRandom, x2);
	    } catch (err) {
	      this.existe = false;
	      return;
	    }
	    if (y1 < y2) xb = x2;else xa = x1;
	  }
	  this.existe = true;
	  this.valeur = (x1 + x2) / 2;
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CPartieReelle = __webpack_require__(90);
	module.exports = CModule;
	
	/**
	 * Objet calcul donnant comme résultat le module d'un calcul complexe.
	 * @constructor
	 * @extends CPartieReelle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul
	 * @param {CValDyn} complexeAssocie : Le complexe dont on calcule le module.
	 * @returns {CModule}
	 */
	function CModule(listeProprietaire, impProto, estElementFinal, nomCalcul, complexeAssocie) {
	  if (arguments.length === 1) CPartieReelle.call(this, listeProprietaire);else CPartieReelle.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, complexeAssocie);
	}
	CModule.prototype = new CPartieReelle();
	CModule.prototype.constructor = CModule;
	CModule.prototype.superClass = "CPartieReelle";
	CModule.prototype.className = "CModule";
	
	CModule.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.complexeAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CModule(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CValDyn"));
	};
	CModule.prototype.getNatureCalcul = function () {
	  return NatCal.NModule;
	};
	CModule.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.complexeAssocie.existe;
	  if (!this.existe) return;
	  this.complexeAssocie.rendValeurComplexe(this.z1);
	  this.resultat = this.z1.module();
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CElementGraphique = __webpack_require__(39);
	module.exports = CObjetDuplique;
	
	/**
	 * Classe représentant un objet dupliqué d'un autre objet.
	 * Sert à redessiner l'objet une nouvelle fois quand il a été recouvert par d'autres objets.
	 * @constructor
	 * @extends CElementGraphique
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom de l'objet.
	 * @param {Integer} tailleNom : Indice donnant la taille du nom.
	 * @param {CElementGraphique} elementDuplique : L'objet qui est dupliqé.
	 * @returns {CObjetDuplique}
	 */
	function CObjetDuplique(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, elementDuplique) {
	  if (arguments.length === 1) CElementGraphique.call(this, listeProprietaire);else {
	    CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom);
	    this.elementDuplique = elementDuplique;
	    // Ajout version 5.0.4. Sert pour les objets dupliqués de CLaTeX
	    this.elementDuplique.hasDuplicate = true;
	  }
	}
	CObjetDuplique.prototype = new CElementGraphique();
	CObjetDuplique.prototype.constructor = CObjetDuplique;
	CObjetDuplique.prototype.superClass = "CElementGraphique";
	CObjetDuplique.prototype.className = "CObjetDuplique";
	
	CObjetDuplique.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.elementDuplique);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CObjetDuplique(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, listeCible.get(ind1, "CElementGraphique"));
	};
	CObjetDuplique.prototype.getNature = function () {
	  return NatObj.NObjetDuplique;
	};
	CObjetDuplique.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.elementDuplique === p.elementDuplique;
	  } else return false;
	};
	CObjetDuplique.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.elementDuplique);
	};
	CObjetDuplique.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CElementGraphique.prototype.dependDe.call(this, p) || this.elementDuplique.dependDe(p));
	};
	CObjetDuplique.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.elementDuplique.dependDePourBoucle(p);
	};
	CObjetDuplique.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.elementDuplique.existe;
	};
	CObjetDuplique.prototype.afficheNom = function (svg) {
	  if (!this.masque) this.elementDuplique.afficheNom(svg);
	};
	CObjetDuplique.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.elementDuplique === ancienPoint) this.elementDuplique = nouveauPoint;
	};
	CObjetDuplique.prototype.createg = function (svg, couleurFond, transparence) {
	  // Modifié version 5.0.4
	  // return this.elementDuplique.createg(svg, couleurFond, transparence);
	  if (this.elementDuplique.masque) return this.elementDuplique.createg(svg, couleurFond, transparence);else return this.elementDuplique.g.cloneNode(true);
	};
	CObjetDuplique.prototype.trace = function (svg, couleurFond, transparence) {
	  // var m = this.elementDuplique.masque;
	  // this.elementDuplique.masque = false;
	  var g = this.createg(svg, couleurFond, transparence);
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	  // this.elementDuplique.masque = m;
	};
	CObjetDuplique.prototype.hasg = function (masquage) {
	  return CElementGraphique.prototype.hasg.call(this, masquage) && !this.elementDuplique.horsCadre();
	};
	CObjetDuplique.prototype.update = function (svg, couleurFond, transparence) {
	  var oldg = this.g;
	  var g = this.createg(svg, couleurFond, transparence);
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CObjetDuplique.prototype.chaineDesignation = function () {
	  return "desObjetDuplique";
	};
	CObjetDuplique.prototype.read = function (inps, list) {
	  CElementGraphique.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.elementDuplique = list.get(ind1, "CElementGraphique");
	  // Ajout version 5.0.4. Sert pour les objets dupliqués de CLaTeX
	  this.elementDuplique.hasDuplicate = true;
	};
	CObjetDuplique.prototype.write = function (oups, list) {
	  CElementGraphique.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.elementDuplique);
	  oups.writeInt(ind1);
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CAbscisseOrigineRep = __webpack_require__(28);
	module.exports = COrdonneeOrigineRep;
	/**
	 * Classe représentant l'ordonnée à l'origine d'un repère.
	 * @constructor
	 * @extends CAbscisseOrigineRep
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul représentatant l'objet.
	 * @param {CRepere} rep : Le repère.
	 * @returns {COrdonneeOrigineRep}
	 */
	function COrdonneeOrigineRep(listeProprietaire, impProto, estElementFinal, nomCalcul, rep) {
	  if (arguments.length === 1) CAbscisseOrigineRep.call(this, listeProprietaire);else {
	    CAbscisseOrigineRep.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, rep);
	  }
	}
	COrdonneeOrigineRep.prototype = new CAbscisseOrigineRep();
	COrdonneeOrigineRep.prototype.constructor = COrdonneeOrigineRep;
	COrdonneeOrigineRep.prototype.superClass = "CAbscisseOrigineRep";
	COrdonneeOrigineRep.prototype.className = "COrdonneeOrigineRep";
	
	COrdonneeOrigineRep.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new COrdonneeOrigineRep(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CRepere"));
	};
	COrdonneeOrigineRep.prototype.getNatureCalcul = function () {
	  return NatCal.NOrdonneeOrigineRep;
	};
	COrdonneeOrigineRep.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.rep.existe;
	  this.abscisseOrigine = this.rep.valOrdonneeOrigine;
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CPartieReelle = __webpack_require__(90);
	module.exports = CPartieImaginaire;
	
	/**
	 * Objet calcul donnant comme résultat la partie imaginaire d'un calcul complexe.
	 * @constructor
	 * @extends CPartieReelle
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul
	 * @param {CValDyn} complexeAssocie : Le complexe dont on calcule la partie imaginaire.
	 * @returns {CPartieImaginaire}
	 */
	function CPartieImaginaire(listeProprietaire, impProto, estElementFinal, nomCalcul, complexeAssocie) {
	  if (arguments.length === 1) CPartieReelle.call(this, listeProprietaire);else CPartieReelle.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, complexeAssocie);
	}
	CPartieImaginaire.prototype = new CPartieReelle();
	CPartieImaginaire.prototype.constructor = CPartieImaginaire;
	CPartieImaginaire.prototype.superClass = "CPartieReelle";
	CPartieImaginaire.prototype.className = "CPartieImaginaire";
	
	CPartieImaginaire.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.complexeAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPartieImaginaire(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CValDyn"));
	};
	CPartieImaginaire.prototype.getNatureCalcul = function () {
	  return NatCal.NPartieImaginaire;
	};
	CPartieImaginaire.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.complexeAssocie.existe;
	  if (!this.existe) return;
	  this.complexeAssocie.rendValeurComplexe(this.z1);
	  this.resultat = this.z1.y;
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CPointAncetrePointsMobiles = __webpack_require__(86);
	var CValeur = __webpack_require__(80);
	module.exports = CPointBaseEnt;
	
	/**
	 * Point libre à coordonnées entières dans un repère.
	 * @constructor
	 * @extends CPointAncetrePointsMobiles
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si le point n'est pas punaisé
	 * @param {CRepere} rep : Le repère associé.
	 * @param {Boolean} absLibres : true si le point est libre horizontalement
	 * @param {Boolean} ordLibres : true si le point est libre verticalement
	 * @param {mtg32.CValeurAssocieAVariable} absMin : abscisse mini quand le point n'est pas libre horizontalement
	 * @param {mtg32.CValeurAssocieAVariable} absMax : abscisse maxi quand le point n'est pas libre horizontalement
	 * @param {mtg32.CValeurAssocieAVariable} ordMin : ordonnée mini quand le point n'est pas libre verticalement
	 * @param {mtg32.CValeurAssocieAVariable} ordMax : Ordonnée maxi quand le point n'est pas libre verticalement
	 * @param {Number} abs : L'abscisse  (entière)
	 * @param {Number} ord : L'ordonnée (entière)
	 * @returns {undefined}
	 */
	function CPointBaseEnt(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, rep, absLibres, ordLibres, absMin, absMax, ordMin, ordMax, abs, ord) {
	  if (arguments.length === 1) CPointAncetrePointsMobiles.call(this, listeProprietaire);else {
	    CPointAncetrePointsMobiles.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre);
	    this.rep = rep;
	    this.absLibres = absLibres;
	    this.ordLibres = ordLibres;
	    this.absMin = absMin;
	    this.absMax = absMax;
	    this.ordMin = ordMin;
	    this.ordMax = ordMax;
	    this.abs = abs;
	    this.ord = ord;
	  }
	}
	CPointBaseEnt.prototype = new CPointAncetrePointsMobiles();
	CPointBaseEnt.prototype.constructor = CPointBaseEnt;
	CPointBaseEnt.prototype.superClass = "CPointAncetrePointsMobiles";
	CPointBaseEnt.prototype.className = "CPointBaseEnt";
	
	CPointBaseEnt.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var absMinClone = this.absMin.getClone(listeSource, listeCible);
	  var absMaxClone = this.absMax.getClone(listeSource, listeCible);
	  var ordMinClone = this.ordMin.getClone(listeSource, listeCible);
	  var ordMaxClone = this.ordMax.getClone(listeSource, listeCible);
	
	  return new CPointBaseEnt(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, this.pointLibre, listeCible.get(ind1, "CRepere"), this.absLibres, this.ordLibres, absMinClone, absMaxClone, ordMinClone, ordMaxClone, this.abs, this.ord);
	};
	
	CPointBaseEnt.prototype.getNature = function () {
	  return NatObj.NPointBaseEnt;
	};
	
	CPointBaseEnt.prototype.initialisePourDependance = function () {
	  CPointAncetrePointsMobiles.prototype.initialisePourDependance.call(this);
	  if (!this.absLibres) {
	    this.absMin.initialisePourDependance();
	    this.absMax.initialisePourDependance();
	  }
	  if (!this.ordLibres) {
	    this.ordMin.initialisePourDependance();
	    this.ordMax.initialisePourDependance();
	  }
	};
	
	CPointBaseEnt.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  var res = CPointAncetrePointsMobiles.prototype.dependDe.call(this, p) || this.rep.dependDe(p);
	  if (!this.absLibres) res = res || this.absMin.dependDe(p) || this.absMax.dependDe(p);
	  if (!this.ordLibres) res = res || this.ordMin.dependDe(p) || this.ordMax.dependDe(p);
	  return this.memoriseDependance(res);
	};
	
	CPointBaseEnt.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.rep.dependDePourBoucle(p);
	};
	
	CPointBaseEnt.prototype.positionne = function (infoRandom, dimfen) {
	  var min, max, absor, ordor;
	  this.existe = this.rep.existe;
	  if (!this.existe) return;
	  if (!this.absLibres) {
	    this.absMin.positionne(infoRandom, dimfen);
	    this.absMax.positionne(infoRandom, dimfen);
	    this.existe = this.existe && this.absMin.existe && this.absMax.existe;
	    if (this.existe) {
	      min = this.absMin.rendValeur();
	      max = this.absMax.rendValeur();
	      absor = this.rep.abscisseOrigine.rendValeur();
	      this.absmin = Math.round((min - absor) / this.rep.unitex);
	      this.absmax = Math.round((max - absor) / this.rep.unitex);
	      this.existe = this.absmin <= this.absmax;
	      if (this.existe) {
	        if (this.abs < this.absmin) this.abs = this.absmin;else {
	          if (this.abs > this.absmax) this.abs = this.absmax;
	        }
	      } else return;
	    } else return;
	  }
	  if (!this.ordLibres) {
	    this.ordMin.positionne(infoRandom, dimfen);
	    this.ordMax.positionne(infoRandom, dimfen);
	    this.existe = this.existe && this.ordMin.existe && this.ordMax.existe;
	    if (this.existe) {
	      min = this.ordMin.rendValeur();
	      max = this.ordMax.rendValeur();
	      ordor = this.rep.ordonneeOrigine.rendValeur();
	      this.ordmin = Math.round((min - ordor) / this.rep.unitey);
	      this.ordmax = Math.round((max - ordor) / this.rep.unitey);
	      this.existe = this.ordmin <= this.ordmax;
	      if (this.existe) {
	        if (this.ord < this.ordmin) this.ord = this.ordmin;else {
	          if (this.ord > this.ordmax) this.ord = this.ordmax;
	        }
	      } else return;
	    } else return;
	  }
	  var vec = new Vect();
	  vec.x = this.abs * this.rep.u.x + this.ord * this.rep.v.x;
	  vec.y = this.abs * this.rep.u.y + this.ord * this.rep.v.y;
	  this.x = this.rep.o.x + vec.x;
	  this.y = this.rep.o.y + vec.y;
	  CPointAncetrePointsMobiles.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CPointBaseEnt.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  var x1 = new Array(4);
	  var y1 = new Array(4);
	  var xr, yr;
	
	  if (!this.testFenetre(dimfen, xtest, ytest)) return false;
	  var ux = this.rep.u.x;
	  var uy = this.rep.u.y;
	  var vx = this.rep.v.x;
	  var vy = this.rep.v.y;
	  var d = ux * vy - uy * vx;
	  var ox = this.rep.o.x;
	  var oy = this.rep.o.y;
	
	  var x2 = xtest - ox;
	  var y2 = ytest - oy;
	  var ab = (vy * x2 - vx * y2) / d;
	  var or = (ux * y2 - uy * x2) / d;
	  var abint = Math.floor(ab);
	  var orint = Math.floor(or);
	  if (ab - abint <= 0.5) xr = abint;else xr = abint + 1;
	  if (or - orint <= 0.5) yr = orint;else yr = orint + 1;
	  var vec = new Vect();
	  vec.x = xr * ux + yr * vx;
	  vec.y = xr * uy + yr * vy;
	  var xt = ox + vec.x;
	  var yt = oy + vec.y;
	  if (!this.testFenetre(dimfen, xt, yt)) {
	    x1[0] = abint;
	    y1[0] = orint;
	    x1[1] = abint + 1;
	    y1[1] = orint;
	    x1[2] = abint + 1;
	    y1[2] = orint + 1;
	    x1[3] = abint;
	    y1[3] = orint + 1;
	    var dis = 1; // La distance mini est au plus égale à 1
	    var ind = 0;
	    for (var i = 0; i < 4; i++) {
	      if (this.testFenetre(dimfen, x1[i], y1[i])) {
	        var d1 = kernel.distancePointPoint(ab, or, x1[i], y1[i]);
	        if (d1 < dis) {
	          ind = i;
	          dis = d1;
	        }
	      }
	    }
	    xr = x1[ind];
	    yr = y1[ind];
	  }
	  if (!this.absLibres) {
	    if (xr < this.absmin) xr = this.absmin;else {
	      if (xr > this.absmax) xr = this.absmax;
	    }
	  }
	  if (!this.ordLibres) {
	    if (yr < this.ordmin) yr = this.ordmin;else {
	      if (yr > this.ordmax) yr = this.ordmax;
	    }
	  }
	  pointr.x = xr;
	  pointr.y = yr;
	  return true;
	};
	
	CPointBaseEnt.prototype.placeEn = function (xn, yn) {
	  this.existe = true;
	  this.abs = xn;
	  this.ord = yn;
	  this.horsEcran = !this.testToile();
	  this.positionneNom();
	};
	
	CPointBaseEnt.prototype.read = function (inps, list) {
	  CPointAncetrePointsMobiles.prototype.read.call(this, inps, list);
	  this.absMin = new CValeur();
	  this.absMax = new CValeur();
	  this.ordMin = new CValeur();
	  this.ordMax = new CValeur();
	  var ind1 = inps.readInt();
	  this.rep = list.get(ind1, "CRepere");
	  this.abs = inps.readDouble();
	  this.ord = inps.readDouble();
	  this.absLibres = inps.readBoolean();
	  this.ordLibres = inps.readBoolean();
	  if (!this.absLibres) {
	    this.absMin.read(inps, list);
	    this.absMax.read(inps, list);
	  } else {
	    this.absMin.donneValeur(-5);
	    this.absMax.donneValeur(5);
	  }
	  if (!this.ordLibres) {
	    this.ordMin.read(inps, list);
	    this.ordMax.read(inps, list);
	  } else {
	    this.ordMin.donneValeur(-5);
	    this.ordMax.donneValeur(5);
	  }
	};
	
	CPointBaseEnt.prototype.write = function (oups, list) {
	  CPointAncetrePointsMobiles.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.rep);
	  oups.writeInt(ind1);
	  oups.writeDouble(this.abs);
	  oups.writeDouble(this.ord);
	  oups.writeBoolean(this.absLibres);
	  oups.writeBoolean(this.ordLibres);
	  if (!this.absLibres) {
	    this.absMin.write(oups, list);
	    this.absMax.write(oups, list);
	  }
	  if (!this.ordLibres) {
	    this.ordMin.write(oups, list);
	    this.ordMax.write(oups, list);
	  }
	};

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CPt = __webpack_require__(87);
	module.exports = CPointClone;
	
	/**
	 * Classe représentant un point clone d'un point existant.
	 * Il a ses éléments graphisques propres mais est placé aux coordonnées de point
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CPt} point : point dont l'objet est clone
	 * @returns {undefined}
	 */
	function CPointClone(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, point) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.point = point;
	  }
	}
	CPointClone.prototype = new CPt();
	CPointClone.prototype.constructor = CPointClone;
	CPointClone.prototype.superClass = "CPt";
	CPointClone.prototype.className = "CPointClone";
	
	CPointClone.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var ind2 = listeSource.indexOf(this.point);
	  return new CPointClone(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind2, "CPt"));
	};
	
	CPointClone.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.point.dependDe(p));
	};
	CPointClone.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.point.dependDePourBoucle(p);
	};
	
	CPointClone.prototype.positionne = function (infoRandom, dimfen) {
	
	  this.existe = this.point.existe;
	  this.x = this.point.x;
	  this.y = this.point.y;
	  CPt.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CPointClone.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.point);
	};
	
	CPointClone.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.point = list.get(ind1, "CPt");
	};
	
	CPointClone.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.point);
	  oups.writeInt(ind1);
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Point = __webpack_require__(15);
	var CPt = __webpack_require__(87);
	module.exports = CPointImage;
	
	/**
	 * Point image d'un autre point par une transformation.
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CPt} antecedent : le point dont le point est image
	 * @param {CTransformation} transformation
	 * @returns {undefined}
	 */
	function CPointImage(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, antecedent, transformation) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.antecedent = antecedent;
	    this.transformation = transformation;
	  }
	}
	CPointImage.prototype = new CPt();
	CPointImage.prototype.constructor = CPointImage;
	CPointImage.prototype.superClass = "CPt";
	CPointImage.prototype.className = "CPointImage";
	
	CPointImage.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.antecedent);
	  var ind2 = listeSource.indexOf(this.transformation);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CPointImage(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CTransformation"));
	};
	
	CPointImage.prototype.ajouteAntecedents = function (liste, app) {
	  liste.add(this.antecedent);
	  this.transformation.ajouteAntecedents(liste, app);
	};
	
	CPointImage.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.antecedent.dependDe(p) || this.transformation.dependDe(p));
	};
	
	CPointImage.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.antecedent.dependDePourBoucle(p) || this.transformation.dependDePourBoucle(p);
	};
	
	CPointImage.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.transformation.existe && this.antecedent.existe;
	  if (!this.existe) return;
	  if (!this.transformation.pointAUneImage(this.antecedent)) {
	    this.existe = false;
	    return;
	  }
	  var pointim = new Point();
	  this.transformation.transformePoint(this.antecedent.x, this.antecedent.y, pointim);
	  CPt.prototype.placeEn.call(this, pointim.x, pointim.y);
	  CPt.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CPointImage.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.transformation.confonduAvec(p.transformation) && this.antecedent.confonduAvec(p.antecedent);
	  } else return false;
	};
	
	CPointImage.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.antecedent === ancienPoint) this.antecedent = nouveauPoint;
	};
	
	CPointImage.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.antecedent = list.get(ind1, "CPt");
	  this.transformation = list.get(ind2, "CTransformation");
	};
	
	CPointImage.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.antecedent);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.transformation);
	  oups.writeInt(ind2);
	};
	
	CPointImage.prototype.estPointImage = function () {
	  return true;
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CPointAncetrePointsMobiles = __webpack_require__(86);
	module.exports = CPointInterieurCercle;
	
	/**
	 * Point interieur à un cercle.
	 * @constructor
	 * @extends CPointAncetrePointsMobiles
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si le point n'est pas punaisé
	 * @param {CCercle} cercleAssocie : le cercle auquel le point est intérieur
	 * @param {Number} rapportHomothetie : le quotient entre la distance au centre et le rayon
	 * @param {Number} anglePolaire : l'angle polaire avec l'horizontale
	 * @returns {undefined}
	 */
	function CPointInterieurCercle(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, cercleAssocie, rapportHomothetie, anglePolaire) {
	  if (arguments.length === 1) CPointAncetrePointsMobiles.call(this, listeProprietaire);else {
	    CPointAncetrePointsMobiles.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre);
	    this.cercleAssocie = cercleAssocie;
	    this.rapportHomothetie = rapportHomothetie;
	    this.anglePolaire = anglePolaire;
	  }
	}
	CPointInterieurCercle.prototype = new CPointAncetrePointsMobiles();
	CPointInterieurCercle.prototype.constructor = CPointInterieurCercle;
	CPointInterieurCercle.prototype.superClass = "CPointAncetrePointsMobiles";
	CPointInterieurCercle.prototype.className = "CPointInterieurCercle";
	
	CPointInterieurCercle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.cercleAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPointInterieurCercle(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, this.pointLibre, listeCible.get(ind1, "CCercle"), this.rapportHomothetie, this.anglePolaire);
	};
	
	CPointInterieurCercle.prototype.getNature = function () {
	  return NatObj.NPointInterieurCercle;
	};
	
	CPointInterieurCercle.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.cercleAssocie);
	};
	
	CPointInterieurCercle.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPointAncetrePointsMobiles.prototype.dependDe.call(this, p) || this.cercleAssocie.dependDe(p));
	};
	
	CPointInterieurCercle.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.cercleAssocie.dependDePourBoucle(p);
	};
	
	CPointInterieurCercle.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.cercleAssocie.existe;
	  if (!this.existe) return;
	  if (this.rapportHomothetie === 0) CPointAncetrePointsMobiles.prototype.placeEn.call(this, this.cercleAssocie.centre_x, this.cercleAssocie.centre_y);else {
	    var vec = new Vect();
	    vec.x = this.rapportHomothetie * this.cercleAssocie.rayon;
	    vec.y = 0;
	    var vec2 = new Vect();
	    vec.tourne(this.anglePolaire, vec2);
	    CPointAncetrePointsMobiles.prototype.placeEn.call(this, this.cercleAssocie.centre_x + vec2.x, this.cercleAssocie.centre_y + vec2.y);
	  }
	  CPointAncetrePointsMobiles.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	};
	
	CPointInterieurCercle.prototype.placeEn = function (xn, yn) {
	  CPointAncetrePointsMobiles.prototype.placeEn.call(this, xn, yn);
	  var vec = new Vect(this.cercleAssocie.centre_x, this.cercleAssocie.centre_y, xn, yn);
	  if (vec.nul()) {
	    this.rapportHomothetie = 0;
	    this.anglePolaire = 0;
	  } else {
	    this.anglePolaire = vec.angleRad();
	    this.rapportHomothetie = vec.norme() / this.cercleAssocie.rayon;
	  }
	};
	
	CPointInterieurCercle.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  // On regarde si le point testé est bien intérieur au polygone
	  if (kernel.distancePointPoint(xtest, ytest, this.cercleAssocie.centre_x, this.cercleAssocie.centre_y) <= this.cercleAssocie.rayon) {
	    pointr.x = xtest;
	    pointr.y = ytest;
	    return true;
	  } else return false;
	};
	
	CPointInterieurCercle.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    if (kernel.zero(p.x - this.x) && kernel.zero(p.y - this.y)) return this.cercleAssocie === p.cercleAssocie;else return false;
	  } else return false;
	};
	
	CPointInterieurCercle.prototype.read = function (inps, list) {
	  CPointAncetrePointsMobiles.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.cercleAssocie = list.get(ind1, "CCercle");
	  this.rapportHomothetie = inps.readDouble();
	  this.anglePolaire = inps.readDouble();
	};
	
	CPointInterieurCercle.prototype.write = function (oups, list) {
	  CPointAncetrePointsMobiles.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.cercleAssocie);
	  oups.writeInt(ind1);
	  oups.writeDouble(this.rapportHomothetie);
	  oups.writeDouble(this.anglePolaire);
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Pointeur = __webpack_require__(16);
	var kernel = __webpack_require__(8);
	var CPointAncetrePointsMobiles = __webpack_require__(86);
	module.exports = CPointInterieurPolygone;
	
	/**
	 * Point intérieur à un polygone
	 * @constructor
	 * @extends CPointAncetrePointsMobiles
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si le point n'est pas punaisé
	 * @param {CPolygone} polygoneAssocie : Le polygone auquel le point est lié
	 * @param {Boolean} estSurCote : true si le point est sur un côté
	 * @param {Integer} indicePremierSommet : L'indice du premier segment sur lequel est le point ou alors l'indice
	 * du premier des trois sommets du type BCD tels que le point soit intérieur à BCD et CDE
	 * @param {Number} alpha : Le coefficient barycentrique normalisé du premier point
	 * @param {Numer} beta : Le coefficient barycentrique normalisé du second point
	 * @param {Numer} gamma : Le coefficient barycentrique normalisé du troisième point
	 * @returns {undefined}
	 */
	function CPointInterieurPolygone(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, polygoneAssocie, estSurCote, indicePremierSommet, alpha, beta, gamma) {
	  if (arguments.length === 1) CPointAncetrePointsMobiles.call(this, listeProprietaire);else {
	    CPointAncetrePointsMobiles.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre);
	    this.polygoneAssocie = polygoneAssocie;
	    this.estSurCote = estSurCote;
	    this.indicePremierSommet = indicePremierSommet;
	    this.alpha = alpha;
	    this.beta = beta;
	    this.gamma = gamma;
	  }
	}
	CPointInterieurPolygone.prototype = new CPointAncetrePointsMobiles();
	CPointInterieurPolygone.prototype.constructor = CPointInterieurPolygone;
	CPointInterieurPolygone.prototype.superClass = "CPointAncetrePointsMobiles";
	CPointInterieurPolygone.prototype.className = "CPointInterieurPolygone";
	
	CPointInterieurPolygone.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.polygoneAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPointInterieurPolygone(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, this.pointLibre, listeCible.get(ind1, "CPolygone"), this.estSurCote, this.indicePremierSommet, this.alpha, this.beta, this.gamma);
	};
	
	CPointInterieurPolygone.prototype.getNature = function () {
	  return NatObj.NPointInterieurPolygone;
	};
	
	CPointInterieurPolygone.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.polygoneAssocie);
	};
	
	CPointInterieurPolygone.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPointAncetrePointsMobiles.prototype.dependDe.call(this, p) || this.polygoneAssocie.dependDe(p));
	};
	
	CPointInterieurPolygone.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.polygoneAssocie.dependDePourBoucle(p);
	};
	CPointInterieurPolygone.prototype.positionne = function (infoRandom, dimfen) {
	  var xn, yn;
	  this.existe = this.polygoneAssocie.existe;
	  if (!this.existe) return;
	  var n = this.polygoneAssocie.colPoints[0];
	  var a = n.pointeurSurPoint;
	  n = this.polygoneAssocie.colPoints[this.indicePremierSommet];
	  var b = n.pointeurSurPoint;
	  n = this.polygoneAssocie.colPoints[this.indicePremierSommet + 1];
	  var c = n.pointeurSurPoint;
	  if (this.estSurCote) {
	    xn = b.x * this.alpha + c.x * this.beta;
	    yn = b.y * this.alpha + c.y * this.beta;
	    CPointAncetrePointsMobiles.prototype.placeEn.call(this, xn, yn);
	  } else {
	    xn = a.x * this.alpha + b.x * this.beta + c.x * this.gamma;
	    yn = a.y * this.alpha + b.y * this.beta + c.y * this.gamma;
	    if (!this.polygoneAssocie.pointInterieur(xn, yn)) {
	      var d = this.beta + this.gamma;
	      xn = (b.x * this.beta + c.x * this.gamma) / d;
	      yn = (b.y * this.beta + c.y * this.gamma) / d;
	    }
	    CPointAncetrePointsMobiles.prototype.placeEn.call(this, xn, yn);
	  }
	  CPointAncetrePointsMobiles.prototype.positionne.call(this, infoRandom, dimfen); // Ajouté version 4.6.4
	};
	
	CPointInterieurPolygone.prototype.placeEn = function (xn, yn) {
	  var estSurCote1 = new Pointeur(false);
	  var indicePremierSommet1 = new Pointeur(0);
	  var alpha1 = new Pointeur(0);
	  var beta1 = new Pointeur(0);
	  var gamma1 = new Pointeur(0);
	  this.polygoneAssocie.determinePositionInterieure(xn, yn, indicePremierSommet1, estSurCote1, alpha1, beta1, gamma1);
	  this.estSurCote = estSurCote1.getValue();
	  this.indicePremierSommet = indicePremierSommet1.getValue();
	  this.alpha = alpha1.getValue();
	  this.beta = beta1.getValue();
	  this.gamma = gamma1.getValue();
	  CPointAncetrePointsMobiles.prototype.placeEn.call(this, xn, yn);
	};
	
	CPointInterieurPolygone.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  // On regarde si le point testé est bien intérieur au polygone
	  if (this.polygoneAssocie.pointInterieur(xtest, ytest)) {
	    pointr.x = xtest;
	    pointr.y = ytest;
	    return true;
	  } else return false;
	};
	
	CPointInterieurPolygone.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    if (kernel.zero(p.x - this.x) && kernel.zero(p.y - this.y)) return this.polygoneAssocie === p.polygoneAssocie;else return false;
	  } else return false;
	};
	
	CPointInterieurPolygone.prototype.read = function (inps, list) {
	  CPointAncetrePointsMobiles.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.polygoneAssocie = list.get(ind1, "CDroiteAncetre");
	  this.estSurCote = inps.readBoolean();
	  this.indicePremierSommet = inps.readInt();
	  this.alpha = inps.readDouble();
	  this.beta = inps.readDouble();
	  this.gamma = inps.readDouble();
	};
	
	CPointInterieurPolygone.prototype.write = function (oups, list) {
	  CPointAncetrePointsMobiles.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.polygoneAssocie);
	  oups.writeInt(ind1);
	  oups.writeBoolean(this.estSurCote);
	  oups.writeInt(this.indicePremierSommet);
	  oups.writeDouble(this.alpha);
	  oups.writeDouble(this.beta);
	  oups.writeDouble(this.gamma);
	};

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var kernel = __webpack_require__(8);
	var CPointAncetrePointsMobiles = __webpack_require__(86);
	module.exports = CPointLie;
	
	/**
	 * @constructor
	 * @extends CPointAncetrePointsMobiles
	 * Classe ancêtre de tous les points liés
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si lepoint n'est pas punaisé
	 * @param {Number} abscisse : L'abscisse sur l'objet
	 * @returns {undefined}
	 */
	function CPointLie(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CPointAncetrePointsMobiles.call(this, listeProprietaire);else {
	    CPointAncetrePointsMobiles.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre);
	    this.abscisse = abscisse;
	  }
	}
	CPointLie.prototype = new CPointAncetrePointsMobiles();
	CPointLie.prototype.constructor = CPointLie;
	CPointLie.prototype.superClass = "CPointAncetrePointsMobiles";
	CPointLie.prototype.className = "CPointLie";
	
	CPointLie.prototype.setClone = function (ptel) {
	  CPointAncetrePointsMobiles.prototype.setClone.call(this, ptel);
	  this.abscisse = ptel.abscisse;
	};
	/**
	 * Fonction donnant au point l'abscisse ab sur l'objet auquel il est lié.
	 * @param {Number} ab
	 * @returns {undefined}
	 */
	CPointLie.prototype.donneAbscisse = function (ab) {
	  this.abscisse = ab;
	};
	
	CPointLie.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return kernel.zero(this.abscisse - p.abscisse);else return false;
	};
	
	CPointLie.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  return false;
	};
	
	CPointLie.prototype.getNature = function () {
	  return NatObj.NPointLie;
	};
	/**
	 * Fonction renvoyant true i le point est lié à une ligne fermée : cercle, polygône,
	 * lieu de points fermé.
	 * @returns {Boolean}
	 */
	CPointLie.prototype.lieALigneFermee = function () {
	  return false;
	};
	
	CPointLie.prototype.read = function (inps, list) {
	  CPointAncetrePointsMobiles.prototype.read.call(this, inps, list);
	  this.abscisse = inps.readDouble();
	};
	
	CPointLie.prototype.write = function (oups, list) {
	  CPointAncetrePointsMobiles.prototype.write.call(this, oups, list);
	  oups.writeDouble(this.abscisse);
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CPt = __webpack_require__(87);
	module.exports = CPointLieBipoint;
	
	/**
	 * Point d'intersection de deux cercles ou d'une droite et un cercle
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CBipoint} ptBipoint : Le bipoint associé
	 * @param {Integer} indiceDansBipoint : L'indice 1 ou 2 dans le bipoint
	 * @returns {undefined}
	 */
	function CPointLieBipoint(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, ptBipoint, indiceDansBipoint) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.ptBipoint = ptBipoint;
	    this.indiceDansBipoint = indiceDansBipoint;
	  }
	}
	CPointLieBipoint.prototype = new CPt();
	CPointLieBipoint.prototype.constructor = CPointLieBipoint;
	CPointLieBipoint.prototype.superClass = "CPt";
	CPointLieBipoint.prototype.className = "CPointLieBipoint";
	
	CPointLieBipoint.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.ptBipoint);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPointLieBipoint(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CBipoint"), this.indiceDansBipoint);
	};
	
	CPointLieBipoint.prototype.ajouteAntecedents = function (frame, liste) {
	  this.ptBipoint.ajouteAntecedents(frame, liste);
	};
	
	CPointLieBipoint.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.ptBipoint.dependDe(p));
	};
	
	CPointLieBipoint.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.ptBipoint.dependDePourBoucle(p);
	};
	
	CPointLieBipoint.prototype.positionne = function (infoRandom, dimfen) {
	  var ptp;
	  switch (this.indiceDansBipoint) {
	    case 1:
	      ptp = this.ptBipoint.point1;
	      break;
	    case 2:
	      ptp = this.ptBipoint.point2;
	      break;
	  }
	  this.existe = ptp.existe;
	  if (!this.existe) return;
	  CPt.prototype.placeEn.call(this, ptp.x, ptp.y);
	  CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	};
	
	// Attention : Nom différentié par rapport à la verrsion Java
	CPointLieBipoint.prototype.appartientDroiteParDefinition = function (droite) {
	  return CPt.prototype.appartientDroiteParDefinition.call(this, droite) || this.ptBipoint.estDefiniPar(droite);
	};
	// Attention : Nom différentié par rapport à la verrsion Java
	CPointLieBipoint.prototype.appartientCercleParDefinition = function (cercle) {
	  return CPt.prototype.appartientCercleParDefinition.call(this, cercle) || this.ptBipoint.estDefiniPar(cercle);
	};
	
	CPointLieBipoint.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  this.indiceDansBipoint = inps.readByte();
	  var ind1 = inps.readInt();
	  this.ptBipoint = list.get(ind1, "CBipoint");
	};
	
	CPointLieBipoint.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  oups.writeByte(this.indiceDansBipoint);
	  var ind1 = list.indexOf(this.ptBipoint);
	  oups.writeInt(ind1);
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatArc = __webpack_require__(73);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CPointLie = __webpack_require__(219);
	module.exports = CPointLieCercle;
	
	/**
	 * Point lié à un cercle (ou un arc de cercle).
	 * @constructor
	 * @extends CPointLie
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si non punaisé
	 * @param {Number} abscisse
	 * @param {CCercle} cercleLie : Le cercle ou arc de cercle auquel le point est lié
	 * @returns {undefined}
	 */
	function CPointLieCercle(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse, cercleLie) {
	  if (arguments.length === 1) CPointLie.call(this, listeProprietaire);else {
	    CPointLie.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse);
	    this.cercleLie = cercleLie;
	  }
	}
	CPointLieCercle.prototype = new CPointLie();
	CPointLieCercle.prototype.constructor = CPointLieCercle;
	CPointLieCercle.prototype.superClass = "CPointLie";
	CPointLieCercle.prototype.className = "CPointLieCercle";
	
	CPointLieCercle.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.cercleLie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPointLieCercle(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, this.pointLibre, this.abscisse, listeCible.get(ind1, "CCercle"));
	};
	
	CPointLieCercle.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.cercleLie);
	};
	
	CPointLieCercle.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPointLie.prototype.dependDe.call(this, p) || this.cercleLie.dependDe(p));
	};
	
	CPointLieCercle.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.cercleLie.dependDePourBoucle(p);
	};
	
	CPointLieCercle.prototype.positionne = function (infoRandom, dimfen) {
	  var xn, yn, angrot;
	  var u = new Vect();
	  var v = new Vect();
	
	  this.existe = this.cercleLie.existe;
	  if (!this.existe) return;
	  switch (this.cercleLie.natureArc()) {
	    case NatArc.PetitArc:
	      u.setVecteur(this.cercleLie.centre_x, this.cercleLie.centre_y, this.cercleLie.origine_x, this.cercleLie.origine_y);
	      angrot = this.cercleLie.valeurAngleAuCentre;
	      u.tourne(this.abscisse * angrot, v);
	      break;
	    case NatArc.GrandArc:
	      u.setVecteur(this.cercleLie.centre_x, this.cercleLie.centre_y, this.cercleLie.origine_x, this.cercleLie.origine_y);
	      angrot = this.cercleLie.valeurAngleAuCentre;
	      if (kernel.zeroAngle(Math.abs(angrot) - Math.PI) || angrot >= 0) u.tourne(-this.abscisse * (2 * Math.PI - Math.abs(angrot)), v);else u.tourne(this.abscisse * (2 * Math.PI - Math.abs(angrot)), v);
	      break;
	    case NatArc.ArcDirect:
	      u.setVecteur(this.cercleLie.centre_x, this.cercleLie.centre_y, this.cercleLie.origine_x, this.cercleLie.origine_y);
	      angrot = this.cercleLie.valeurAngleAuCentre;
	      if (angrot < 0) angrot = angrot + 2 * Math.PI;
	      u.tourne(this.abscisse * angrot, v);
	      break;
	    case NatArc.ArcIndirect:
	      u.setVecteur(this.cercleLie.centre_x, this.cercleLie.centre_y, this.cercleLie.origine_x, this.cercleLie.origine_y);
	      angrot = this.cercleLie.valeurAngleAuCentre;
	      var w = new Vect();
	      u.tourne(angrot, w);
	      angrot = -angrot;
	      if (angrot < 0) angrot = angrot + 2 * Math.PI;
	      w.tourne(this.abscisse * angrot, v);
	      break;
	    case NatArc.ArcCercle:
	    default:
	      u.x = this.cercleLie.rayon;
	      u.y = 0;
	      u.tourne(this.abscisse, v);
	  }
	  xn = this.cercleLie.centre_x + v.x;
	  yn = this.cercleLie.centre_y + v.y;
	  if (this.cercleLie.surArc(xn, yn)) {
	    this.existe = true;
	    CPointLie.prototype.placeEn.call(this, xn, yn);
	    CPointLie.prototype.positionne.call(this, infoRandom, dimfen);
	  } else this.existe = false;
	};
	
	CPointLieCercle.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  var valable;
	
	  var u = new Vect(this.cercleLie.centre_x, this.cercleLie.centre_y, xtest, ytest);
	  var v = new Vect();
	  u.vecteurColineaire(this.cercleLie.rayon, v);
	  if (!u.nul() && this.cercleLie.surArc(xtest, ytest)) {
	    pointr.x = this.cercleLie.centre_x + v.x;
	    pointr.y = this.cercleLie.centre_y + v.y;
	    valable = dimfen.dansFenetre(pointr.x, pointr.y);
	    // Si c'est un arc de cercle, il s'agira d'une abscisse curviligne
	    // comprise entre 0 et 1
	    var ang = v.angleRad();
	    abscr.setValue(this.cercleLie.abscisseCurviligne(ang));
	  } else valable = false;
	  return valable;
	};
	
	CPointLieCercle.prototype.abscisseMinimale = function () {
	  return this.cercleLie.abscisseMinimale();
	};
	
	CPointLieCercle.prototype.abscisseMaximale = function () {
	  return this.cercleLie.abscisseMaximale();
	};
	
	CPointLieCercle.prototype.confonduAvec = function (p) {
	  var res = CPointLie.prototype.confonduAvec.call(this, p);
	  if (!res) return false;
	  return this.cercleLie === p.cercleLie;
	};
	CPointLieCercle.prototype.lieALigneFermee = function () {
	  return this.cercleLie.abscisseMinimale() === 0 && this.cercleLie.abscisseMaximale() === 2 * Math.PI;
	};
	
	CPointLieCercle.prototype.read = function (inps, list) {
	  CPointLie.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.cercleLie = list.get(ind1, "CCercle");
	};
	
	CPointLieCercle.prototype.write = function (oups, list) {
	  CPointLie.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.cercleLie);
	  oups.writeInt(ind1);
	};
	
	CPointLieCercle.prototype.appartientCercleParDefinition = function (cercle) {
	  return CPointLie.prototype.appartientCercleParDefinition.call(this, cercle) || this.cercleLie === cercle;
	};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CPointLie = __webpack_require__(219);
	module.exports = CPointLieDroite;
	
	/**
	 * Point lié à une droite (ou segment ou demi-droite ou vecteur)
	 * @constructor
	 * @extends CPointLie
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si non punaisé
	 * @param {Number} abscisse
	 * @param {CDroiteAncetre} droiteLiee : objet auquel le point est lié
	 * @returns {undefined}
	 */
	function CPointLieDroite(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse, droiteLiee) {
	  if (arguments.length === 1) CPointLie.call(this, listeProprietaire);else {
	    CPointLie.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse);
	    this.droiteLiee = droiteLiee;
	  }
	}
	CPointLieDroite.prototype = new CPointLie();
	CPointLieDroite.prototype.constructor = CPointLieDroite;
	CPointLieDroite.prototype.superClass = "CPointLie";
	CPointLieDroite.prototype.className = "CPointLieDroite";
	
	CPointLieDroite.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.droiteLiee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPointLieDroite(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, this.pointLibre, this.abscisse, listeCible.get(ind1, "CDroiteAncetre"));
	};
	
	CPointLieDroite.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.droiteLiee);
	};
	
	CPointLieDroite.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPointLie.prototype.dependDe.call(this, p) || this.droiteLiee.dependDe(p));
	};
	
	CPointLieDroite.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.droiteLiee.dependDePourBoucle(p);
	};
	
	CPointLieDroite.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.droiteLiee.existe;
	  if (!this.existe) return;
	  var xn = this.droiteLiee.point_x + this.abscisse * this.droiteLiee.vect.x;
	  var yn = this.droiteLiee.point_y + this.abscisse * this.droiteLiee.vect.y;
	  CPointLie.prototype.placeEn.call(this, xn, yn);
	  CPointLie.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	};
	
	CPointLieDroite.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  kernel.projetteOrtho(xtest, ytest, this.droiteLiee.point_x, this.droiteLiee.point_y, this.droiteLiee.vect, pointr);
	  var valable = this.droiteLiee.appartientA(pointr.x, pointr.y) && dimfen.dansFenetre(pointr.x, pointr.y);
	  if (!valable) return false;
	  var absx = Math.abs(this.droiteLiee.vect.x);
	  var absy = Math.abs(this.droiteLiee.vect.y);
	  if (absx === 0 && absy === 0) valable = false;else {
	    if (absx > absy) abscr.setValue((pointr.x - this.droiteLiee.point_x) / this.droiteLiee.vect.x);else abscr.setValue((pointr.y - this.droiteLiee.point_y) / this.droiteLiee.vect.y);
	  }
	  return valable;
	};
	
	CPointLieDroite.prototype.abscisseMinimale = function () {
	  return this.droiteLiee.abscisseMinimale();
	};
	
	CPointLieDroite.prototype.abscisseMaximale = function () {
	  return this.droiteLiee.abscisseMaximale();
	};
	
	CPointLieDroite.prototype.confonduAvec = function (p) {
	  var res = CPointLie.prototype.confonduAvec.call(this, p);
	  if (!res) return false;
	  return this.droiteLiee === p.droiteLiee;
	};
	
	CPointLieDroite.prototype.read = function (inps, list) {
	  CPointLie.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.droiteLiee = list.get(ind1, "CDroiteAncetre");
	};
	
	CPointLieDroite.prototype.write = function (oups, list) {
	  CPointLie.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.droiteLiee);
	  oups.writeInt(ind1);
	};
	
	CPointLieDroite.prototype.appartientDroiteParDefinition = function (droite) {
	  return CPointLie.prototype.appartientDroiteParDefinition.call(this, droite) || droite === this.droiteLiee;
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var kernel = __webpack_require__(8);
	var CPointLie = __webpack_require__(219);
	module.exports = CPointLieLieuAncetre;
	
	/**
	 * Classe ancêtre de tous les points liés à un lieu de points.
	 * @constructor
	 * @extends CPointLie
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si le point n'est pas punaisé
	 * @param {Number} abscisse : L'abscisse du point sur l'objet
	 * @param {CLieuDeBase} lieuAssocie : Le lieu de points
	 * @returns {undefined}
	 */
	function CPointLieLieuAncetre(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse, lieuAssocie) {
	  if (arguments.length === 0) return; // Ajout version 4.9.9.4
	  if (arguments.length === 1) CPointLie.call(this, listeProprietaire);else {
	    CPointLie.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse);
	    this.lieuAssocie = lieuAssocie;
	  }
	}
	CPointLieLieuAncetre.prototype = new CPointLie();
	CPointLieLieuAncetre.prototype.constructor = CPointLieLieuAncetre;
	CPointLieLieuAncetre.prototype.superClass = "CPointLie";
	CPointLieLieuAncetre.prototype.className = "CPointLieLieuAncetre";
	
	CPointLieLieuAncetre.prototype.getNature = function () {
	  return NatObj.NPointLie;
	};
	
	CPointLieLieuAncetre.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.lieuAssocie);
	};
	
	CPointLieLieuAncetre.prototype.dependDe = function (p) {
	  return CPointLie.prototype.dependDe.call(this, p) || this.lieuAssocie.dependDe(p);
	};
	
	CPointLieLieuAncetre.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.lieuAssocie.dependDePourBoucle(p);
	};
	
	CPointLieLieuAncetre.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return kernel.zero(this.abscisse - p.abscisse);
	  } else return false;
	};
	
	CPointLieLieuAncetre.prototype.read = function (inps, list) {
	  CPointLie.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.lieuAssocie = list.get(ind1, "CLieuDeBase");
	  this.abscisse = inps.readDouble();
	};
	
	CPointLieLieuAncetre.prototype.write = function (oups, list) {
	  CPointLie.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.lieuAssocie);
	  oups.writeInt(ind1);
	  oups.writeDouble(this.abscisse);
	};

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CPointLieLieuAncetre = __webpack_require__(223);
	module.exports = CPointLieLieuParPtLie;
	
	/**
	 * Point lié à une lieu de points généré par un point lié.
	 * @constructor
	 * @extends CPointLieLieuAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si non punaisé
	 * @param {Number} abscisse : L'abscisse du point sur le lieu
	 * @param {CLieuDeBase} lieuAssocie : Le lieu auquel le point est lié
	 * @returns {undefined}
	 */
	function CPointLieLieuParPtLie(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse, lieuAssocie) {
	  if (arguments.length === 1) CPointLieLieuAncetre.call(this, listeProprietaire);else {
	    CPointLieLieuAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse, lieuAssocie);
	  }
	}
	CPointLieLieuParPtLie.prototype = new CPointLieLieuAncetre();
	CPointLieLieuParPtLie.prototype.constructor = CPointLieLieuParPtLie;
	CPointLieLieuParPtLie.prototype.superClass = "CPointLieLieuAncetre";
	CPointLieLieuParPtLie.prototype.className = "CPointLieLieuParPtLie";
	
	CPointLieLieuParPtLie.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.lieuAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPointLieLieuParPtLie(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, this.pointLibre, this.abscisse, listeCible.get(ind1, "CLieuDePoints"));
	};
	
	CPointLieLieuParPtLie.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.lieuAssocie.existe;
	  if (!this.existe) return;
	  var ptLie = this.lieuAssocie.pointLieGenerateur;
	  var ptGenerateurTrace = this.lieuAssocie.pointATracer;
	  // On mémorise l'abscisse actuelle du point lié qui génère le lieu auquel le point est lié
	  var ancienneAbscisse = ptLie.abscisse;
	  ptLie.donneAbscisse(this.abscisse);
	  this.lieuAssocie.listeElementsAncetres.positionne(infoRandom, dimfen);
	  this.existe = ptGenerateurTrace.existe;
	  if (!this.existe) return;
	  CPointLieLieuAncetre.prototype.placeEn.call(this, ptGenerateurTrace.x, ptGenerateurTrace.y);
	  ptLie.donneAbscisse(ancienneAbscisse);
	  this.lieuAssocie.listeElementsAncetres.positionne(infoRandom, dimfen);
	  CPointLieLieuAncetre.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	};
	
	CPointLieLieuParPtLie.prototype.abscisseMaximale = function () {
	  return this.lieuAssocie.pointLieGenerateur.abscisseMaximale();
	};
	
	CPointLieLieuParPtLie.prototype.abscisseMinimale = function () {
	  return this.lieuAssocie.pointLieGenerateur.abscisseMinimale();
	};
	
	CPointLieLieuParPtLie.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  var nbValeurs, pas, dis, indDistMini, j, k, k1, d, nombrePoints, indPremPoint, x, y;
	  var info = this.lieuAssocie.infoLieu;
	  var pointLie = this.lieuAssocie.pointLieGenerateur;
	  var abscisseMini = pointLie.abscisseMinimale();
	  var abscisseMaxi = pointLie.abscisseMaximale();
	  // On ordonne l'abscisse minimale et maximale
	  if (abscisseMini > abscisseMaxi) {
	    var w = abscisseMini;
	    abscisseMini = abscisseMaxi;
	    abscisseMaxi = w;
	  }
	  // Modification pour la version 1.9.5
	  if (this.lieuAssocie.pointLieGenerateur.lieALigneFermee()) nbValeurs = info.nombreDePoints;else nbValeurs = info.nombreDePoints - 1;
	  pas = (abscisseMaxi - abscisseMini) / nbValeurs;
	  dis = kernel.Max_VALUE;
	  indDistMini = 0;
	  for (j = 0; j < this.lieuAssocie.nombreLignes; j++) {
	    nombrePoints = this.lieuAssocie.infoLignes[j].nombrePoints;
	    // Optimisé version 3.9 On trace maintenant les points isolés du lieu
	    indPremPoint = this.lieuAssocie.infoLignes[j].indicePremierPoint;
	    for (k = 0; k < nombrePoints; k++) {
	      k1 = indPremPoint + k;
	      x = this.lieuAssocie.abscissesCoordonneesPoints[k1];
	      y = this.lieuAssocie.ordonneesCoordonneesPoints[k1];
	      if (dimfen.dansFenetre(x, y)) {
	        d = kernel.distancePointPoint(xtest, ytest, this.lieuAssocie.abscissesCoordonneesPoints[k1], this.lieuAssocie.ordonneesCoordonneesPoints[k1]);
	        if (d < dis) {
	          dis = d;
	          indDistMini = k1;
	        }
	      }
	    }
	  }
	  abscr.setValue(abscisseMini + indDistMini * pas);
	  // Il est inutile ici de donner des valeurs à pointr qui n'est pas utilisé par l'outil correspondant
	  return true;
	};

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CPointLieLieuAncetre = __webpack_require__(223);
	module.exports = CPointLieLieuParVar;
	
	/**
	 * Point lié à un lieu de points généré par une variable
	 * @constructor
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si non punaisé
	 * @param {Number} abscisse : L'abscisse du point sur le lieu
	 * @param {CLieuDeBase} lieuAssocie : Le lieu auquel le point est lié
	 * @returns {undefined}
	 */
	function CPointLieLieuParVar(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse, lieuAssocie) {
	  if (arguments.length === 1) CPointLieLieuAncetre.call(this, listeProprietaire);else {
	    CPointLieLieuAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse, lieuAssocie);
	  }
	}
	CPointLieLieuParVar.prototype = new CPointLieLieuAncetre();
	CPointLieLieuParVar.prototype.constructor = CPointLieLieuParVar;
	CPointLieLieuParVar.prototype.superClass = "CPointLieLieuAncetre";
	CPointLieLieuParVar.prototype.className = "CPointLieLieuParVar";
	
	CPointLieLieuParVar.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.lieuAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPointLieLieuParVar(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, this.pointLibre, this.abscisse, listeCible.get(ind1, "CLieuParVariable"));
	};
	
	CPointLieLieuParVar.prototype.positionne = function (infoRandom, dimfen) {
	  var vari, ptGenerateurTrace, ancienneAbscisse;
	  this.existe = this.lieuAssocie.existe;
	  if (!this.existe) return;
	  vari = this.lieuAssocie.variableGeneratrice;
	  ptGenerateurTrace = this.lieuAssocie.pointATracer;
	  // On mémorise la valeur actuelle de la variable qui génère le lieu auquel le point est lié
	  ancienneAbscisse = vari.valeurActuelle;
	  vari.donneValeur(this.abscisse);
	  this.lieuAssocie.listeElementsAncetres.positionne(infoRandom, dimfen);
	  this.existe = ptGenerateurTrace.existe;
	  if (!this.existe) return;
	  CPointLieLieuAncetre.prototype.placeEn.call(this, ptGenerateurTrace.x, ptGenerateurTrace.y);
	  vari.donneValeur(ancienneAbscisse);
	  this.lieuAssocie.listeElementsAncetres.positionne(infoRandom, dimfen);
	  CPointLieLieuAncetre.prototype.positionne.call(this, infoRandom, dimfen); // Ajout version 4.6.4
	};
	
	CPointLieLieuParVar.prototype.abscisseMaximale = function () {
	  return this.lieuAssocie.variableGeneratrice.valeurMini;
	};
	
	CPointLieLieuParVar.prototype.abscisseMinimale = function () {
	  return this.lieuAssocie.variableGeneratrice.valeurMaxi;
	};
	
	CPointLieLieuParVar.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  var vari, abscisseMini, abscisseMaxi, w, pas, dis, indDistMini, i, d;
	  vari = this.lieuAssocie.variableGeneratrice;
	  var info = this.lieuAssocie.infoLieu;
	  abscisseMini = vari.valeurMini;
	  abscisseMaxi = vari.valeurMaxi;
	  // On ordonne l'abscisse minimale et maximale
	  if (abscisseMini > abscisseMaxi) {
	    w = abscisseMini;
	    abscisseMini = abscisseMaxi;
	    abscisseMaxi = w;
	  }
	  // Modification pour la version 1.9.5
	  pas = (abscisseMaxi - abscisseMini) / (info.nombreDePoints - 1);
	  dis = kernel.Max_VALUE;
	  indDistMini = 0;
	  for (i = 0; i < info.nombreDePoints; i++) {
	    d = kernel.distancePointPoint(xtest, ytest, this.lieuAssocie.abscissesCoordonneesPoints[i], this.lieuAssocie.ordonneesCoordonneesPoints[i]);
	    if (d < dis) {
	      dis = d;
	      indDistMini = i;
	    }
	  }
	  abscr.setValue(abscisseMini + indDistMini * pas);
	  // Il est inutile ici de donner des valeurs à pointr qui n'est pas utilisé par l'outil correspondant
	  return true;
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Color = __webpack_require__(6);
	var Point = __webpack_require__(15);
	var StyleTrait = __webpack_require__(78);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CPointLie = __webpack_require__(219);
	var CSegment = __webpack_require__(134);
	var CPointBase = __webpack_require__(85);
	module.exports = CPointLieLigne;
	
	/**
	 * Point lié à une ligne brisée ou un polygone.
	 * @constructor
	 * @extends CPointLie
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {Boolean} pointLibre : true si non punaisé
	 * @param {Number} abscisse : L'abscisse sur la ligne ou le polygone
	 * @param {type} ligneLiee : La ligne brisée ou polygone auquel le point est lié
	 * @returns {undefined}
	 */
	function CPointLieLigne(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse, ligneLiee) {
	  if (arguments.length === 1) CPointLie.call(this, listeProprietaire);else {
	    CPointLie.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointLibre, abscisse);
	    this.ligneLiee = ligneLiee;
	    if (listeProprietaire.className !== "CPrototype") this.tableauLongueurs = new Array(ligneLiee.colPoints.length - 1);
	  }
	  this.point1 = new CPointBase(null);
	  this.point2 = new CPointBase(null);
	  this.seg = new CSegment(listeProprietaire, null, false, new Color(0, 0, 0), true, StyleTrait.traitFin, this.point1, this.point2);
	  this.pointres = new Point();
	}
	CPointLieLigne.prototype = new CPointLie();
	CPointLieLigne.prototype.constructor = CPointLieLigne;
	CPointLieLigne.prototype.superClass = "CPointLie";
	CPointLieLigne.prototype.className = "CPointLieLigne";
	
	CPointLieLigne.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.ligneLiee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPointLieLigne(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, this.pointLibre, this.abscisse, listeCible.get(ind1, "CLignePolygonaleAncetre"));
	};
	
	CPointLieLigne.prototype.setClone = function (ptel) {
	  CPointLie.prototype.setClone.call(this, ptel);
	  // Il faut copier les valeurs du tableau de longueurs et la longueur totale
	  this.longueurTotale = ptel.longueurTotale;
	  for (var i = 0; i < this.tableauLongueurs.length - 1; i++) {
	    this.tableauLongueurs[i] = ptel.tableauLongueurs[i];
	  }
	};
	
	CPointLieLigne.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.ligneLiee);
	};
	
	CPointLieLigne.prototype.confonduAvec = function (p) {
	  var res = CPointLie.prototype.confonduAvec.call(this, p);
	  if (!res) return false;
	  return this.ligneLiee === p.ligneLiee;
	};
	
	CPointLieLigne.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPointLie.prototype.dependDe.call(this, p) || this.ligneLiee.dependDe(p));
	};
	
	CPointLieLigne.prototype.dependDePourBoucle = function (p) {
	  return CPointLie.prototype.dependDePourBoucle.call(this, p) || this.ligneLiee.dependDePourBoucle(p);
	};
	
	CPointLieLigne.prototype.positionne = function (infoRandom, dimfen) {
	  var i;
	
	  this.existe = this.ligneLiee.existe;
	  if (!this.existe) return;
	  this.calculeLongueurs();
	  if (this.longueurTotale === 0) {
	    this.existe = false;
	    return;
	  }
	  // On cherche maintenant sur quel segment est situé le point lié
	  // Java : a été remanié par rapport au C++
	  var longueurPartielle = 0;
	  var longueurJusqueDebSegment = 0;
	  var nbSommets = this.ligneLiee.colPoints.length;
	  for (i = 0; i < nbSommets - 1; i++) {
	    longueurJusqueDebSegment = longueurPartielle;
	    longueurPartielle += this.tableauLongueurs[i];
	    if (longueurPartielle / this.longueurTotale >= this.abscisse) break;
	  }
	  // Juste par précaution
	  if (i === nbSommets - 1) i = nbSommets - 2;
	  var n1 = this.ligneLiee.colPoints[i];
	  var ptp1 = n1.pointeurSurPoint;
	  var n2 = this.ligneLiee.colPoints[i + 1];
	  var ptp2 = n2.pointeurSurPoint;
	  var abscisseSurSegment;
	  if (this.tableauLongueurs[i] === 0) abscisseSurSegment = 0;else abscisseSurSegment = (this.longueurTotale * this.abscisse - longueurJusqueDebSegment) / this.tableauLongueurs[i];
	  var xn = ptp1.x + abscisseSurSegment * (ptp2.x - ptp1.x);
	  var yn = ptp1.y + abscisseSurSegment * (ptp2.y - ptp1.y);
	  CPointLie.prototype.placeEn.call(this, xn, yn);
	  CPointLie.prototype.positionne.call(this, infoRandom, dimfen);
	};
	/**
	 * Renvoie l'abscisse minimale de la ligne auquel le point est lié
	 * @returns {Number}
	 */
	CPointLieLigne.prototype.abscisseMinimale = function () {
	  return this.ligneLiee.abscisseMinimale();
	};
	/**
	 * Renvoie l'ordonnée minimale de la ligne auquel le point est lié
	 * @returns {Number}
	 */
	CPointLieLigne.prototype.abscisseMaximale = function () {
	  return this.ligneLiee.abscisseMaximale();
	};
	/**
	 * Fonction calculant les longueurs des côtés de la ligne brisée ou du polygone
	 * et les mettant dans this.tableauLongueurs.
	 * La longueur totale de laligen est mise dans this.longueurTotale.
	 * @returns {undefined}
	 */
	CPointLieLigne.prototype.calculeLongueurs = function () {
	  this.longueurTotale = 0;
	  for (var i = 0; i < this.ligneLiee.colPoints.length - 1; i++) {
	    var n1 = this.ligneLiee.colPoints[i];
	    var n2 = this.ligneLiee.colPoints[i + 1];
	
	    var ptp1 = n1.pointeurSurPoint;
	    var ptp2 = n2.pointeurSurPoint;
	    var u = new Vect(ptp1, ptp2);
	    var longueurSegment = u.norme();
	    this.tableauLongueurs[i] = longueurSegment;
	    this.longueurTotale += longueurSegment;
	  }
	};
	
	CPointLieLigne.prototype.testDeplacement = function (dimfen, xtest, ytest, pointr, abscr) {
	  var ptPointProche = null;
	  var distMin = 2147483647;
	  // On calcule les longueurs des côtés et la longueur totale
	  // de la ligne polygonale cliquée
	  this.calculeLongueurs();
	
	  var indiceDistMin = -1;
	  var valable = false;
	  for (var i = 0; i < this.ligneLiee.colPoints.length - 1; i++) {
	    var n1 = this.ligneLiee.colPoints[i];
	    var n2 = this.ligneLiee.colPoints[i + 1];
	
	    var ptp1 = n1.pointeurSurPoint;
	    var ptp2 = n2.pointeurSurPoint;
	    this.point1.placeEn(ptp1.x, ptp1.y);
	    this.point1.positionne(false, dimfen); // Spécial JavaScript
	    this.point2.placeEn(ptp2.x, ptp2.y);
	    this.point2.positionne(false, dimfen); // Spécial JavaScript
	    this.seg.positionne();
	    kernel.projetteOrtho(xtest, ytest, ptp1.x, ptp1.y, this.seg.vect, this.pointres);
	    if (this.seg.appartientA(this.pointres.x, this.pointres.y)) {
	      valable = true;
	      var u = new Vect(this.pointres.x, this.pointres.y, xtest, ytest);
	      var dist = u.norme();
	      if (dist < distMin) {
	        ptPointProche = ptp1;
	        distMin = dist;
	        indiceDistMin = i;
	        pointr.x = this.pointres.x;
	        pointr.y = this.pointres.y;
	      }
	    } else {
	      var d1 = kernel.distancePointPoint(ptp1.x, ptp1.y, xtest, ytest);
	      if (d1 < distMin) {
	        valable = true;
	        ptPointProche = ptp1;
	        distMin = d1;
	        indiceDistMin = i;
	        pointr.x = ptp1.x;
	        pointr.y = ptp1.y;
	      }
	    }
	  }
	  if (valable) {
	    // Il faut calculer l'abscisse du point
	    var longueurDebutLigne = 0;
	    for (var j = 0; j < indiceDistMin; j++) {
	      longueurDebutLigne += this.tableauLongueurs[j];
	    }
	    var v = new Vect(ptPointProche.x, ptPointProche.y, pointr.x, pointr.y);
	    longueurDebutLigne += v.norme();
	    abscr.setValue(longueurDebutLigne / this.longueurTotale);
	  }
	  return valable;
	};
	
	CPointLieLigne.prototype.read = function (inps, list) {
	  CPointLie.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.ligneLiee = list.get(ind1, "CLignePolygonaleAncetre");
	  // Pas de réservation en mémoire pour le chargement des prototypes
	  if (list.className !== "CPrototype") this.tableauLongueurs = new Array(this.ligneLiee.colPoints.length - 1);
	};
	
	CPointLieLigne.prototype.write = function (oups, list) {
	  CPointLie.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.ligneLiee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var CPt = __webpack_require__(87);
	module.exports = CPointLiePoint;
	
	/**
	 * Point lié à un point.
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CPt} pointAssocie : le point auquel le point est lié
	 * @returns {undefined}
	 */
	function CPointLiePoint(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, pointAssocie) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.pointAssocie = pointAssocie;
	  }
	}
	CPointLiePoint.prototype = new CPt();
	CPointLiePoint.prototype.constructor = CPointLiePoint;
	CPointLiePoint.prototype.superClass = "CPt";
	CPointLiePoint.prototype.className = "CPointLiePoint";
	
	CPointLiePoint.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.pointAssocie);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CPointLiePoint(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CPt"));
	};
	
	CPointLiePoint.prototype.getNature = function () {
	  return NatObj.NPointLiePoint;
	};
	
	CPointLiePoint.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.pointAssocie);
	};
	
	CPointLiePoint.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.pointAssocie.dependDe(p));
	};
	
	CPointLiePoint.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.pointAssocie.dependDePourBoucle(p);
	};
	
	CPointLiePoint.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.pointAssocie.existe;
	  if (this.existe) {
	    CPt.prototype.placeEn.call(this, this.pointAssocie.x, this.pointAssocie.y);
	    CPt.prototype.positionne.call(this, infoRandom, dimfen);
	  }
	};
	
	CPointLiePoint.prototype.confonduAvec = function (p) {
	  if (p.className === this.classname) return this.pointAssocie === p.pointAssocie;else return false;
	};
	CPointLiePoint.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.pointAssocie === ancienPoint) this.pointAssocie = nouveauPoint;
	};
	
	CPointLiePoint.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.pointAssocie = list.get(ind1, "CPt");
	};
	
	CPointLiePoint.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.pointAssocie);
	  oups.writeInt(ind1);
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var CDroiteAncetre = __webpack_require__(99);
	var CPt = __webpack_require__(87);
	var CValeur = __webpack_require__(80);
	module.exports = CPointParAbscisse;
	
	/**
	 * Point défini par son abscisse relative à deux points distincts
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CPt} origine : Le point origine
	 * @param {CPt} extremite : Le point d'abscisse 1
	 * @param {CValeur} abscisse : L'abscisse du point
	 * @returns {undefined}
	 */
	function CPointParAbscisse(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, origine, extremite, abscisse) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.origine = origine;
	    this.extremite = extremite;
	    this.abscisse = abscisse;
	  }
	}
	CPointParAbscisse.prototype = new CPt();
	CPointParAbscisse.prototype.constructor = CPointParAbscisse;
	CPointParAbscisse.prototype.superClass = "CPt";
	CPointParAbscisse.prototype.className = "CPointParAbscisse";
	
	CPointParAbscisse.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.origine);
	  var ind2 = listeSource.indexOf(this.extremite);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var abscisseClone = this.abscisse.getClone(listeSource, listeCible);
	  return new CPointParAbscisse(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), abscisseClone);
	};
	
	CPointParAbscisse.prototype.nomIndispensable = function (el) {
	  return el === this.origine || el === this.extremite;
	};
	
	CPointParAbscisse.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.origine);
	  liste.add(this.extremite);
	};
	
	CPointParAbscisse.prototype.initialisePourDependance = function () {
	  CPt.prototype.initialisePourDependance.call(this);
	  this.abscisse.initialisePourDependance();
	};
	
	CPointParAbscisse.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.origine.dependDe(p) || this.extremite.dependDe(p) || this.abscisse.dependDe(p));
	};
	
	CPointParAbscisse.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.origine.dependDePourBoucle(p) || this.extremite.dependDePourBoucle(p) || this.abscisse.dependDePourBoucle(p);
	};
	
	CPointParAbscisse.prototype.positionne = function (infoRandom, dimfen) {
	  this.abscisse.positionne(infoRandom, dimfen);
	  this.existe = this.abscisse.existe && this.origine.existe && this.extremite.existe;
	  if (!this.existe) return;
	  var u = new Vect(this.origine, this.extremite);
	  var k1 = this.abscisse.rendValeur();
	  var vec = new Vect();
	  vec.x = k1 * u.x;
	  vec.y = k1 * u.y;
	  this.x = this.origine.x + vec.x;
	  this.y = this.origine.y + vec.y;
	  CPt.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CPointParAbscisse.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.origine === p.origine && this.extremite === p.extremite && this.abscisse.confonduAvec(p.abscisse);
	  } else return false;
	};
	
	CPointParAbscisse.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.origine === ancienPoint) this.origine = nouveauPoint;
	  if (this.extremite === ancienPoint) this.extremite = nouveauPoint;
	};
	
	CPointParAbscisse.prototype.appartientDroiteParDefinition = function (droite) {
	  return CDroiteAncetre.prototype.appartientDroiteParDefinition.call(this, droite) || this.origine.appartientDroiteParDefinition(droite) && this.extremite.appartientDroiteParDefinition(droite);
	};
	
	CPointParAbscisse.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.origine = list.get(ind1, "CPt");
	  var ind2 = inps.readInt();
	  this.extremite = list.get(ind2, "CPt");
	  this.abscisse = new CValeur(list);
	  this.abscisse.read(inps, list);
	};
	
	CPointParAbscisse.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.origine);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.extremite);
	  oups.writeInt(ind2);
	  this.abscisse.write(oups, list);
	};

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var Complexe = __webpack_require__(30);
	var Vect = __webpack_require__(12);
	var CPt = __webpack_require__(87);
	var CValeurComp = __webpack_require__(230);
	module.exports = CPointParAffixe;
	
	/**
	 * Point défini par son affixe dans un repère.
	 * @constructor
	 * @extends CPt;
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CRepere} rep : Le point dans lequel l'affixe est donnée
	 * @param {mtg32.CValeurAssocieeAVariableComp} affixe : L'affixe
	 * @returns {undefined}
	 */
	function CPointParAffixe(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, rep, affixe) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.rep = rep;
	    this.affixe = affixe;
	  }
	  this.z1 = new Complexe();
	}
	CPointParAffixe.prototype = new CPt();
	CPointParAffixe.prototype.constructor = CPointParAffixe;
	CPointParAffixe.prototype.superClass = "CPt";
	CPointParAffixe.prototype.className = "CPointParAffixe";
	
	CPointParAffixe.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var affixeClone = this.affixe.getClone(listeSource, listeCible);
	  return new CPointParAffixe(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CRepere"), affixeClone);
	};
	
	CPointParAffixe.prototype.initialisePourDependance = function () {
	  CPt.prototype.initialisePourDependance.call(this);
	  this.affixe.initialisePourDependance();
	};
	
	CPointParAffixe.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.rep.dependDe(p) || this.affixe.dependDe(p));
	};
	
	CPointParAffixe.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.rep.dependDePourBoucle(p) || this.affixe.dependDePourBoucle(p);
	};
	
	CPointParAffixe.prototype.positionne = function (infoRandom, dimfen) {
	  this.affixe.positionne(infoRandom, dimfen);
	  this.existe = this.affixe.existe && this.rep.existe;
	  if (!this.existe) return;
	  this.affixe.rendValeurComplexe(this.z1);
	  var vec = new Vect();
	  var unitex = this.rep.unitex;
	  var unitey = this.rep.unitey;
	  vec.x = this.z1.x * this.rep.u.x / unitex + this.z1.y * this.rep.v.x / unitey;
	  vec.y = this.z1.x * this.rep.u.y / unitex + this.z1.y * this.rep.v.y / unitey;
	  this.x = this.rep.origine.x + vec.x;
	  this.y = this.rep.origine.y + vec.y;
	  CPt.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CPointParAffixe.prototype.getNature = function () {
	  return NatObj.NPointParAffixe;
	};
	
	CPointParAffixe.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.rep === p.rep && this.affixe.confonduAvec(p.affixe);
	  } else return false;
	};
	
	CPointParAffixe.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.rep = list.get(ind1, "CRepere");
	  this.affixe = new CValeurComp();
	  this.affixe.read(inps, list);
	};
	
	CPointParAffixe.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.rep);
	  oups.writeInt(ind1);
	  this.affixe.write(oups, list);
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var COb = __webpack_require__(34);
	var Complexe = __webpack_require__(30);
	module.exports = CValeurComp;
	
	/**
	 * Classe représentant une valeur dynamique complexe définie par un calcul sur des objets
	 * numériques de la figure.
	 * Appellée CValeurAssocieeComp dans la version Java.
	 * Si le cacul associé est constant (ne dépend d'aucun objet dynamique),
	 * le calcul n'est fait qu'une fois et le résultat est stocké dans this.valeur
	 * sinon le calcul est refait à chaque recalcul de la figure
	 * et le résultat stocké dans this.valeur
	 * @constructor
	 * @extends COb
	 * @param {CListeObjets} listeProprietaire
	 * @param {CCb} calcul
	 * @returns {undefined}
	 */
	function CValeurComp(listeProprietaire, calcul) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) {
	      if (arguments[0].className === "CListeObjets") COb.call(this, listeProprietaire);else {
	        // Construction à partir d'un autre CValeur
	        var cvaav = arguments[0];
	        COb.call(this, cvaav.listeProprietaire);
	        this.calcul = cvaav.calcul.getClone(listeProprietaire, listeProprietaire);
	        this.estConstant = cvaav.estConstant;
	        if (this.estConstant) this.valeurComplexe = new Complexe(cvaav.valeurComplexe);
	        this.existe = cvaav.existe;
	        this.dejaPositionne = cvaav.dejaPositionne;
	      }
	    } else {
	      COb.call(this, listeProprietaire);
	      this.calcul = calcul;
	      this.dejaPositionne = false;
	    }
	  } else {
	    this.dejaPositionne = false;
	  }
	  this.valeurComplexe = new Complexe();
	}
	CValeurComp.prototype = new COb();
	CValeurComp.prototype.constructor = CValeurComp;
	CValeurComp.prototype.superClass = "COb";
	CValeurComp.prototype.className = "CValeurComp";
	
	/**
	 * Fonction renvoyant un clone de l'objet
	 * @param {CListeObjets} listeSource
	 * @param {CListeObjets} listeCible
	 * @returns {CValeurComp}
	 */
	CValeurComp.prototype.getClone = function (listeSource, listeCible) {
	  var calculClone = this.calcul.getClone(listeSource, listeCible);
	  var va = new CValeurComp(listeCible, calculClone);
	  va.dejaPositionne = this.dejaPositionne;
	  va.estConstant = this.estConstant;
	  va.valeurComplexe.x = this.valeurComplexe.x;
	  va.valeurComplexe.y = this.valeurComplexe.y;
	  va.existe = this.existe;
	  return va;
	};
	CValeurComp.prototype.initialisePourDependance = function () {
	  this.calcul.initialisePourDependance();
	};
	/**
	 * Fonction donnant à l'objet une valeur constante
	 * @param {type} c
	 * @returns {undefined}
	 */
	CValeurComp.prototype.donneValeur = function (c) {
	  this.valeurComplexe.x = c.x;
	  this.valeurComplexe.y = c.y;
	  this.calcul = null;
	  this.dejaPositionne = true;
	  this.estConstant = true;
	};
	/**
	 * Fonction renvoyant une chaîne de caractères représentant le calcul associé
	 * @returns {unresolved}
	 */
	CValeurComp.prototype.chaineInfo = function () {
	  return this.calcul.chaineCalculSansPar(null);
	};
	/**
	 *
	 * Fonction recalculant le calcul associé et affectant la valeur du résultat à this.valeur
	 * this.existe est mis à true si le calcul existe
	 * @param {Boolean} infoRandom : true pour que les éventuels appels à la fonction
	 * rand soient réactualisés.
	 * @returns {undefined}
	 */
	CValeurComp.prototype.positionne = function (infoRandom) {
	  if (!this.dejaPositionne) {
	    if (this.calcul.estConstant()) {
	      this.estConstant = true;
	      this.existe = this.calcul.existe(infoRandom);
	      if (!this.existe) return;
	      try {
	        this.listeProprietaire.initialiseNombreIterations();
	        this.calcul.resultatComplexe(infoRandom, this.valeurComplexe);
	      } catch (e) {
	        this.existe = false;
	        this.valeurComplexe.x = 0;
	        this.valeurComplexe.y = 0;
	      }
	      if (!isFinite(this.valeurComplexe.x) || !isFinite(this.valeurComplexe.y)) this.existe = false;
	    } else this.estConstant = false;
	    this.dejaPositionne = true;
	  }
	  if (!this.estConstant) {
	    this.existe = this.calcul.existe(infoRandom);
	    if (!this.existe) return;
	    // A revoir en java pour la gestion des erreurs de calcul
	    // AnnuleErreurDeCalcul();	// Pour détecter une éventuelle erreur de
	    //                         // calcul lors de l'appel
	    try {
	      this.listeProprietaire.initialiseNombreIterations();
	      this.calcul.resultatComplexe(infoRandom, this.valeurComplexe);
	    } catch (e) {
	      this.existe = false;
	      this.valeurComplexe.x = 0;
	      this.valeurComplexe.y = 0;
	    }
	    if (!isFinite(this.valeurComplexe.x) || !isFinite(this.valeurComplexe.y)) this.existe = false;
	  }
	};
	/**
	 * Fonction renvoyant true si le calcul depend de p
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CValeurComp.prototype.dependDe = function (p) {
	  return this.calcul.dependDe(p);
	};
	/**
	 * Fonction renvoyant true ii le calcul depend de p pour les boucles de macro
	 * @param {CElementBase} p
	 * @returns {Boolean}
	 */
	CValeurComp.prototype.dependDePourBoucle = function (p) {
	  return this.calcul.dependDePourBoucle(p);
	};
	/**
	 * Fonction renvoyant dans zRes le résultat complexe du calcul.
	 * @param {Complexe} zRes
	 * @returns {undefined}
	 */
	CValeurComp.prototype.rendValeurComplexe = function (zRes) {
	  zRes.set(this.valeurComplexe.x, this.valeurComplexe.y);
	};
	/**
	 * Fonction renvoyant true si p est aussi un CValeurAssoceAVariable
	 * constant ayant la même valeur ou si le calcul est un résultat de valeur
	 * pointant sur la même valeur que this.
	 * @param {COb} p
	 * @returns {Boolean}
	 */
	CValeurComp.prototype.confonduAvec = function (p) {
	  if (p.nomClasse === this.nomClasse) {
	    if (this.estConstant) return this.valeurComplexe.x === p.valeurComplexe.x && this.valeurComplexe.y === p.valeurComplexe.y;else return false;
	  } else return false;
	};
	/**
	 * Fonction lisant l'objet depuis un flux de données binaire.
	 * @param {DataInputStream} inps
	 * @param {CListeObjets} list
	 * @returns {undefined}
	 */
	CValeurComp.prototype.read = function (inps, list) {
	  COb.prototype.read.call(this, inps, list);
	  this.calcul = inps.readObject(list);
	};
	/**
	 * Fonction rnregistrant l'objet dans un flux de données binaire.
	 * @param {DataOutputStream} oups
	 * @param {CListeObjets} list
	 * @returns {undefined}
	 */
	CValeurComp.prototype.write = function (oups, list) {
	  COb.prototype.write.call(this, oups, list);
	  oups.writeObject(this.calcul);
	};
	/**
	 * Fonction renvoyant true si le calcul associé est constant, c'est à dire ne
	 * dépend d'aucun objet dynamique
	 * @returns {Boolean}
	 */
	CValeurComp.prototype.estConstant = function () {
	  return this.estConstant;
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CPt = __webpack_require__(87);
	var CValeur = __webpack_require__(80);
	module.exports = CPointParMultVect;
	
	/**
	 * Point M défini par vect(AM) = coef*vect ou A est pointé par antecedent
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CPointAncetre} antecedent : Le point A tel qu'on aura vect(AM)=coef*vect
	 * @param {CVecteur} vect : Le vecteur
	 * @param {CValeur} coef : Le coefficient de multiplication
	 * @returns {undefined}
	 */
	function CPointParMultVect(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, antecedent, vect, coef) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.antecedent = antecedent;
	    this.vect = vect;
	    this.coef = coef;
	  }
	}
	CPointParMultVect.prototype = new CPt();
	CPointParMultVect.prototype.constructor = CPointParMultVect;
	CPointParMultVect.prototype.superClass = "CPt";
	CPointParMultVect.prototype.className = "CPointParMultVect";
	
	CPointParMultVect.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.antecedent);
	  var ind2 = listeSource.indexOf(this.vect);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var coefClone = this.coef.getClone(listeSource, listeCible);
	
	  return new CPointParMultVect(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CVecteur"), coefClone);
	};
	
	CPointParMultVect.prototype.initialisePourDependance = function () {
	  CPt.prototype.initialisePourDependance.call(this);
	  this.coef.initialisePourDependance();
	};
	
	CPointParMultVect.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.antecedent.dependDe(p) || this.vect.dependDe(p) || this.coef.dependDe(p));
	};
	
	CPointParMultVect.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.antecedent.dependDePourBoucle(p) || this.vect.dependDePourBoucle(p) || this.coef.dependDePourBoucle(p);
	};
	
	CPointParMultVect.prototype.positionne = function (infoRandom, dimfen) {
	  this.coef.positionne(infoRandom, dimfen);
	  this.existe = this.antecedent.existe && this.vect.existe && this.coef.existe;
	  if (!this.existe) return;
	  var k = this.coef.rendValeur();
	  CPt.prototype.placeEn.call(this, this.antecedent.x + k * (this.vect.x2 - this.vect.x1), this.antecedent.y + k * (this.vect.y2 - this.vect.y1));
	  CPt.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CPointParMultVect.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.antecedent === p.antecedent && this.vect === p.vect && this.coef.confonduAvec(p.coef);
	  } else return false;
	};
	
	CPointParMultVect.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.antecedent === ancienPoint) this.antecedent = nouveauPoint;
	};
	CPointParMultVect.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.antecedent = list.get(ind1, "CPt");
	  this.vect = list.get(ind2, "CVecteur");
	  this.coef = new CValeur();
	  this.coef.read(inps, list);
	};
	
	CPointParMultVect.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.antecedent);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.vect);
	  oups.writeInt(ind2);
	  this.coef.write(oups, list);
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CPt = __webpack_require__(87);
	module.exports = CPointParSommeVect;
	
	/**
	 * Point défini par vect(AM) = vecteur1 + vecteur2, où A est pointé par antecedent
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CPt} antecedent
	 * @param {CVecteur} vecteur1
	 * @param {CVecteur} vecteur2
	 * @returns {undefined}
	 */
	function CPointParSommeVect(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, antecedent, vecteur1, vecteur2) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.antecedent = antecedent;
	    this.vecteur1 = vecteur1;
	    this.vecteur2 = vecteur2;
	  }
	}
	CPointParSommeVect.prototype = new CPt();
	CPointParSommeVect.prototype.constructor = CPointParSommeVect;
	CPointParSommeVect.prototype.superClass = "CPt";
	CPointParSommeVect.prototype.className = "CPointParSommeVect";
	
	CPointParSommeVect.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.antecedent);
	  var ind2 = listeSource.indexOf(this.vecteur1);
	  var ind3 = listeSource.indexOf(this.vecteur2);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CPointParSommeVect(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CVecteur"), listeCible.get(ind3, "CVecteur"), this.marquePourTrace);
	};
	
	CPointParSommeVect.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.antecedent.dependDe(p) || this.vecteur1.dependDe(p) || this.vecteur2.dependDe(p));
	};
	
	CPointParSommeVect.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.antecedent.dependDePourBoucle(p) || this.vecteur1.dependDePourBoucle(p) || this.vecteur2.dependDePourBoucle(p);
	};
	
	CPointParSommeVect.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.antecedent.existe && this.vecteur1.existe && this.vecteur2.existe;
	  if (!this.existe) return;
	  CPt.prototype.placeEn.call(this, this.antecedent.x + this.vecteur1.x2 - this.vecteur1.x1 + this.vecteur2.x2 - this.vecteur2.x1, this.antecedent.y + this.vecteur1.y2 - this.vecteur1.y1 + this.vecteur2.y2 - this.vecteur2.y1);
	  CPt.prototype.positionne.call(this, infoRandom, dimfen);
	};
	
	CPointParSommeVect.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.antecedent.confonduAvec(p.antecedent) && (this.vecteur1.confonduAvec(p.vecteur1) && this.vecteur2.confonduAvec(p.vecteur2) || this.vecteur1.confonduAvec(p.vecteur2) && this.vecteur2.confonduAvec(p.vecteur1));
	  } else return false;
	};
	
	CPointParSommeVect.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.antecedent === ancienPoint) this.antecedent = nouveauPoint;
	};
	
	CPointParSommeVect.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.antecedent = list.get(ind1, "CPt");
	  this.vecteur1 = list.get(ind2, "CVecteur");
	  this.vecteur2 = list.get(ind3, "CVecteur");
	};
	
	CPointParSommeVect.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.antecedent);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.vecteur1);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.vecteur2);
	  oups.writeInt(ind3);
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Point = __webpack_require__(15);
	var kernel = __webpack_require__(8);
	var CPt = __webpack_require__(87);
	module.exports = CPointProjete;
	
	/**
	 * Point projeté orthogonal d'un point a sur une droite d (ou segment ou demi-droite)
	 * @constructor
	 * @extends CPt
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
	 * @param {Integer} dec_x : Decalage horizontal du nom
	 * @param {Integer} dec_y : Decalage vertical du nom
	 * @param {Boolean} masque : true si l'objet est masque
	 * @param {String} nom : Le nom eventuel de l'objet
	 * @param {Integer} tailleNom : Indice de la taille du nom (voir mtg32.Fonte)
	 * @param {mtg32.MotifPoint} motif : Le motif du point
	 * @param {Boolean} marquePourTrace : true si le point est marqué pour la trace
	 * @param {CPointAncetre} a : le poit  qu'on projette
	 * @param {CDroite} d : La droite sur laquelle on projette
	 * @returns {undefined}
	 */
	function CPointProjete(listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace, a, d) {
	  if (arguments.length === 1) CPt.call(this, listeProprietaire);else {
	    CPt.call(this, listeProprietaire, impProto, estElementFinal, couleur, nomMasque, dec_x, dec_y, masque, nom, tailleNom, motif, marquePourTrace);
	    this.a = a;
	    this.d = d;
	  }
	}
	CPointProjete.prototype = new CPt();
	CPointProjete.prototype.constructor = CPointProjete;
	CPointProjete.prototype.superClass = "CPt";
	CPointProjete.prototype.className = "CPointProjete";
	
	CPointProjete.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.a);
	  var ind2 = listeSource.indexOf(this.d);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CPointProjete(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.nomMasque, this.dec_x, this.dec_y, this.masque, this.nom, this.tailleNom, this.motif, this.marquePourTrace, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CDroiteAncetre"));
	};
	
	CPointProjete.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.a);
	  liste.add(this.d);
	};
	
	CPointProjete.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CPt.prototype.dependDe.call(this, p) || this.a.dependDe(p) || this.d.dependDe(p));
	};
	
	CPointProjete.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.d.dependDePourBoucle(p);
	};
	
	CPointProjete.prototype.positionne = function (infoRandom, dimfen) {
	  var point;
	  this.existe = this.a.existe && this.d.existe;
	  if (this.existe) {
	    point = new Point();
	    kernel.projetteOrtho(this.a.x, this.a.y, this.d.point_x, this.d.point_y, this.d.vect, point);
	    var xp = point.x;
	    var yp = point.y;
	    this.existe = this.existe && this.d.appartientA(xp, yp);
	    if (this.existe) {
	      CPt.prototype.placeEn.call(this, xp, yp);
	      CPt.prototype.positionne.call(this, infoRandom, dimfen); // Ajouté version 4.6.4
	    }
	  }
	};
	
	CPointProjete.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.a === p.a && this.d === p.d;
	  } else return false;
	};
	
	CPointProjete.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.a === ancienPoint) this.a = nouveauPoint;
	};
	
	CPointProjete.prototype.read = function (inps, list) {
	  CPt.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.a = list.get(ind1, "CPt");
	  this.d = list.get(ind2, "CDroiteAncetre");
	};
	
	CPointProjete.prototype.write = function (oups, list) {
	  CPt.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.a);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.d);
	  oups.writeInt(ind2);
	};
	
	CPointProjete.prototype.appartientDroiteParDefinition = function (droite) {
	  return CPt.prototype.appartientDroiteParDefinition.call(this, droite) || droite === this.d;
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalculAncetre = __webpack_require__(35);
	var CValeur = __webpack_require__(80);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CProduit;
	
	// Attention : Ordre des 3 derniers paramètres inversés par rapport à version Java
	/**
	 * Classe calculant la somme de la valeur de valeurAssomer suivant les valeurs
	 * de la variable indice prenant ses valeurs de indiceMin jusquà indiceMax.
	 * valeurAssommerpeut dépendre d'éléments graphiques.
	 * Lors de chaque boucle, les éléments dépendant de la figure sont recalculés.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire
	 * @param {CImplementationProto} impProto : null ou la construcction propriétaire
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom.
	 * @param {CVariableBornee} indice : Le nome de la variable qui joue le rôel d'indice
	 * @param {CValDyn} valeurAMultiplier
	 * @param {CValeur} indiceMin
	 * @param {CValeur} indiceMax
	 * @returns {CProduit}
	 */
	function CProduit(listeProprietaire, impProto, estElementFinal, nomCalcul, indice, valeurAMultiplier, indiceMin, indiceMax) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.indice = indice;
	    this.valeurAMultiplier = valeurAMultiplier;
	    this.indiceMin = indiceMin;
	    this.indiceMax = indiceMax;
	  }
	  this.listeElementsAncetres = new CSousListeObjets();
	}
	CProduit.prototype = new CCalculAncetre();
	CProduit.prototype.constructor = CProduit;
	CProduit.prototype.superClass = "CCalculAncetre";
	CProduit.prototype.className = "CProduit";
	
	CProduit.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CProduit.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.indice);
	  var ind2 = listeSource.indexOf(this.valeurAMultiplier);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var indiceMinClone = this.indiceMin.getClone(listeSource, listeCible);
	  var indiceMaxClone = this.indiceMax.getClone(listeSource, listeCible);
	  var ptelb = new CProduit(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CVariableBornee"), listeCible.get(ind2, "CValDyn"), indiceMinClone, indiceMaxClone);
	  if (listeCible.className !== "CPrototype") ptelb.listeElementsAncetres.setImage(this.listeElementsAncetres, this.listeProprietaire, ptelb.listeProprietaire);
	  return ptelb;
	};
	
	CProduit.prototype.getNatureCalcul = function () {
	  return NatCal.NProduitIndice;
	};
	
	CProduit.prototype.initialisePourDependance = function () {
	  CCalculAncetre.prototype.initialisePourDependance.call(this);
	  this.indiceMin.initialisePourDependance();
	  this.indiceMax.initialisePourDependance();
	};
	
	CProduit.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.indice.dependDe(p) || this.valeurAMultiplier.dependDe(p) || this.indiceMin.dependDe(p) || this.indiceMax.dependDe(p));
	};
	
	CProduit.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.indice.dependDePourBoucle(p) || this.valeurAMultiplier.dependDePourBoucle(p) || this.indiceMin.dependDePourBoucle(p) || this.indiceMax.dependDePourBoucle(p);
	};
	
	CProduit.prototype.positionne = function (infoRandom, dimfen) {
	  this.indiceMin.positionne(infoRandom, dimfen);
	  this.indiceMax.positionne(infoRandom, dimfen);
	  this.existe = this.indiceMin.existe && this.indiceMax.existe;
	  if (!this.existe) return;
	  // On arrondit les indices de départ et de fin à l'entier le plus proche
	  var indmin = Math.floor(this.indiceMin.rendValeur() + 0.5);
	  var indmax = Math.floor(this.indiceMax.rendValeur() + 0.5);
	  this.existe = indmin <= indmax && indmax - indmin < 5000;
	  if (!this.existe) return;
	  var sauveIndice = this.indice.rendValeur();
	  this.valeurProduit = 1;
	  // à revoir : faut-il que la variable de boucle soit double ?
	  for (var i = indmin; i <= indmax; i++) {
	    this.indice.valeurActuelle = i;
	    this.listeElementsAncetres.positionneFull(infoRandom, dimfen);
	    this.existe = this.existe && this.valeurAMultiplier.existe;
	    this.valeurProduit *= this.valeurAMultiplier.rendValeur();
	  }
	  this.indice.donneValeur(sauveIndice);
	  this.listeElementsAncetres.metAJour();
	  this.listeElementsAncetres.positionne(infoRandom, dimfen);
	};
	
	CProduit.prototype.rendValeur = function () {
	  return this.valeurProduit;
	};
	
	CProduit.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  // Il faut créer la liste des éléments dont dépend le point à tracer
	  // Pour cette liste, on fait pointer la longueur unité éventuelle sur la liste mère
	  var ind1 = inps.readInt();
	  this.indice = list.get(ind1, "CVariableBornee");
	  var ind2 = inps.readInt();
	  this.valeurAMultiplier = list.get(ind2, "CValDyn");
	  this.indiceMin = new CValeur();
	  this.indiceMin.read(inps, list);
	  this.indiceMax = new CValeur();
	  this.indiceMax.read(inps, list);
	  // Modification pour la version 2.5.
	  // Certaines choses pas à faire pour le chargement d'un prototype
	  this.listeElementsAncetres.read(inps, list);
	};
	CProduit.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.indice);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.valeurAMultiplier);
	  oups.writeInt(ind2);
	  this.indiceMin.write(oups, list);
	  this.indiceMax.write(oups, list);
	  this.listeElementsAncetres.write(oups, this.listeProprietaire);
	};

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	var NatCal = __webpack_require__(5);
	var Vect = __webpack_require__(12);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CProduitScalaire;
	
	/**
	 * Classe représentant le résultat du produit scalaire de deux vecteurs.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul
	 * @param {CVecteur} vect1 : Le premier vecteur du produit scalaire.
	 * @param {CVecteur} vect2 : Le deuxième vecteur du produit scalaire.
	 * @returns {CProduitScalaire}
	 */
	function CProduitScalaire(listeProprietaire, impProto, estElementFinal, nomCalcul, vect1, vect2) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.vect1 = vect1;
	    this.vect2 = vect2;
	  }
	}
	CProduitScalaire.prototype = new CCalculAncetre();
	CProduitScalaire.prototype.constructor = CProduitScalaire;
	CProduitScalaire.prototype.superClass = "CCalculAncetre";
	CProduitScalaire.prototype.className = "CProduitScalaire";
	
	CProduitScalaire.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.vect1);
	  var ind2 = listeSource.indexOf(this.vect2);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CProduitScalaire(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CVecteur"), listeCible.get(ind2, "CVecteur"));
	};
	CProduitScalaire.prototype.getNatureCalcul = function () {
	  return NatCal.NMesureProduitScalaire;
	};
	CProduitScalaire.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.vect1.point1);
	  liste.add(this.vect1.point2);
	  liste.add(this.vect1);
	  liste.add(this.vect2.point1);
	  liste.add(this.vect2.point2);
	  liste.add(this.vect2);
	};
	CProduitScalaire.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.vect1.dependDe(p) || this.vect2.dependDe(p) || this.listeProprietaire.pointeurLongueurUnite.dependDe(p));
	};
	CProduitScalaire.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.vect1.dependDePourBoucle(p) || this.vect2.dependDePourBoucle(p) || this.listeProprietaire.pointeurLongueurUnite.dependDePourBoucle(p);
	};
	CProduitScalaire.prototype.positionne = function (infoRandom, dimfen) {
	  var pLongUnite = this.listeProprietaire.pointeurLongueurUnite;
	  this.existe = this.vect1.existe && this.vect2.existe && pLongUnite.existe;
	  if (!this.existe) return;
	  var longueurUnite = pLongUnite.rendLongueur();
	  // Si la longueur unité est nulle, pLongUnite n'existe pas
	  var v1 = new Vect(this.vect1.point1, this.vect1.point2);
	  var v2 = new Vect(this.vect2.point1, this.vect2.point2);
	  var n1 = v1.norme() / longueurUnite;
	  var n2 = v2.norme() / longueurUnite;
	  if (n1 === 0 || n2 === 0) {
	    this.prosca = 0;
	    return;
	  }
	  var ang = v1.mesureAngleVecteurs(v2);
	  this.prosca = n1 * n2 * Math.cos(ang);
	};
	CProduitScalaire.prototype.rendValeur = function () {
	  return this.prosca;
	};
	CProduitScalaire.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.vect1 === p.vect1 && this.vect2 === p.vect2 || this.vect1 === p.vect2 && this.vect2 === p.vect1;
	  } else return false;
	};
	CProduitScalaire.prototype.nomIndispensable = function (el) {
	  return el === this.vect1.point1 || el === this.vect1.point2 || el === this.vect2.point1 || el === this.vect2.point2;
	};
	CProduitScalaire.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.vect1 = list.get(ind1, "CVecteur");
	  this.vect2 = list.get(ind2, "CVecteur");
	};
	CProduitScalaire.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.vect1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.vect2);
	  oups.writeInt(ind2);
	};

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var Point = __webpack_require__(15);
	var StyleTrait = __webpack_require__(78);
	var Vect = __webpack_require__(12);
	var kernel = __webpack_require__(8);
	var CElementLigne = __webpack_require__(77);
	var CDroite = __webpack_require__(98);
	var CValeur = __webpack_require__(80);
	module.exports = CRepere;
	
	/**
	 * Classe représentant un repère.
	 * @constructor
	 * @extends CElementLigne
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet
	 * @param {Boolean} masque : true si le repère est masqué.
	 * @param {StyleTrait} style : Le style de trait pour le quadrillage.
	 * @param {CPt} o : L'origine du repère.
	 * @param {CPt} i : Le point de coordonnées (1;0).
	 * @param {CPt} j : Le point de coordonnées (0;1).
	 * @param {CValeur} abscisseOrigine : L'abscisse à l'origine.
	 * @param {CValeur} ordonneeOrigine : L'ordonnée à l'origine.
	 * @param {Boolean} quadrillageHorizontal : true pour des droites verticales de quadrillage.
	 * @param {Boolean} quadrillageVertical : true pour des droites horizontales de quadrillage.
	 * @param {Boolean} pointilles : true si on veut que les points à coordonnées entières soient représentés
	 * par des petits points.
	 * @param {CValeur} unite_x : L'unité sur l'axe des abcsisses.
	 * @param {CValeur} unite_y : L'unité sur l'axe des ordonnées.
	 * @returns {CRepere}
	 */
	function CRepere(listeProprietaire, impProto, estElementFinal, couleur, masque, style, o, i, j, abscisseOrigine, ordonneeOrigine, quadrillageHorizontal, quadrillageVertical, pointilles, unite_x, unite_y) {
	  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);else {
	    CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur, false, 0, 0, masque, "", 0, style);
	
	    this.o = o;
	    this.i = i;
	    this.j = j;
	    this.abscisseOrigine = abscisseOrigine;
	    this.ordonneeOrigine = ordonneeOrigine;
	    this.quadrillageHorizontal = quadrillageHorizontal;
	    this.quadrillageVertical = quadrillageVertical;
	    this.pointilles = pointilles;
	    this.unite_x = unite_x;
	    this.unite_y = unite_y;
	    this.u = new Vect();
	    this.v = new Vect();
	    this.droiteQuadrillage = new CDroite(listeProprietaire);
	    this.droiteQuadrillage.montre();
	    this.origine = {};
	    this.pointint = new Array(4);
	    for (var k = 0; k < 4; k++) {
	      this.pointint[k] = {};
	    }
	  }
	  this.vect = new Vect();
	}
	CRepere.prototype = new CElementLigne();
	CRepere.prototype.constructor = CRepere;
	CRepere.prototype.superClass = "CElementLigne";
	CRepere.prototype.className = "CRepere";
	
	CRepere.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CRepere.prototype.setClone = function (ptel) {
	  CElementLigne.prototype.setClone.call(this, ptel);
	  this.absMiniH = ptel.absMiniH;
	  this.absMaxiH = ptel.absMaxiH;
	  this.absMiniV = ptel.absMiniV;
	  this.absMaxiV = ptel.absMaxiV;
	  this.infoSurRandom = ptel.infoSurRandom;
	  this.Dimf = ptel.Dimf;
	  this.origine.x = ptel.origine.x;
	  this.origine.y = ptel.origine.y;
	  ptel.u.setCopy(this.u);
	  ptel.v.setCopy(this.v);
	  this.unitex = ptel.unitex;
	  this.unitey = ptel.unitey;
	};
	CRepere.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.o);
	  var ind2 = listeSource.indexOf(this.i);
	  var ind3 = listeSource.indexOf(this.j);
	  var ind4 = listeSource.indexOf(this.impProto);
	  var abscisseOrigineClone = this.abscisseOrigine.getClone(listeSource, listeCible);
	  var ordonneeOrigineClone = this.ordonneeOrigine.getClone(listeSource, listeCible);
	  var unite_xClone = this.unite_x.getClone(listeSource, listeCible);
	  var unite_yClone = this.unite_y.getClone(listeSource, listeCible);
	
	  return new CRepere(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"), abscisseOrigineClone, ordonneeOrigineClone, this.quadrillageHorizontal, this.quadrillageVertical, this.pointilles, unite_xClone, unite_yClone);
	};
	CRepere.prototype.initialisePourDependance = function () {
	  CElementLigne.prototype.initialisePourDependance.call(this);
	  this.abscisseOrigine.initialisePourDependance();
	  this.ordonneeOrigine.initialisePourDependance();
	  this.unite_x.initialisePourDependance();
	  this.unite_y.initialisePourDependance();
	};
	CRepere.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CElementLigne.prototype.dependDe.call(this, p) || this.o.dependDe(p) || this.i.dependDe(p) || this.j.dependDe(p) || this.abscisseOrigine.dependDe(p) || this.ordonneeOrigine.dependDe(p) || this.unite_x.dependDe(p) || this.unite_y.dependDe(p));
	};
	CRepere.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.o.dependDePourBoucle(p) || this.i.dependDePourBoucle(p) || this.j.dependDePourBoucle(p) || this.abscisseOrigine.dependDePourBoucle(p) || this.ordonneeOrigine.dependDePourBoucle(p) || this.unite_x.dependDePourBoucle(p) || this.unite_y.dependDePourBoucle(p);
	};
	CRepere.prototype.nomIndispensable = function (el) {
	  return el === this.o || el === this.i || el === this.j;
	};
	CRepere.prototype.positionne = function (infoRandom, dimfen) {
	  this.unite_x.positionne(infoRandom, dimfen);
	  this.unite_y.positionne(infoRandom, dimfen);
	  this.unitex = this.unite_x.rendValeur();
	  this.unitey = this.unite_y.rendValeur();
	
	  this.abscisseOrigine.positionne(infoRandom, dimfen);
	  this.ordonneeOrigine.positionne(infoRandom, dimfen);
	  this.existe = this.o.existe && this.i.existe && this.j.existe && this.abscisseOrigine.existe && this.ordonneeOrigine.existe && this.unite_x.existe && this.unite_y.existe && this.unitex > 0 && this.unitey > 0 && !kernel.aligne(this.x, this.o.y, this.i.x, this.i.y, this.j.x, this.j.y);
	  if (this.existe) {
	    // On mémorise les valeurs de l'abscisse à l'origine et de l'ordonnée à l'origine.
	    this.valAbscisseOrigine = this.abscisseOrigine.rendValeur();
	    this.valOrdonneeOrigine = this.ordonneeOrigine.rendValeur();
	    var abs = new Array(4);
	    var pointIndices = new Point(); // Contiendra les indices des valeurs minimalse et maximales
	    // Java : différence par rapport au C++. Nécessaire de mémoriser infoRandom et dimfen
	    // pour lengthtracé de la droite servant au quadrillage
	    this.infoSurRandom = infoRandom;
	    this.Dimf = dimfen;
	    this.u.setVecteur(this.o, this.i);
	    this.v.setVecteur(this.o, this.j);
	    // On calcule les réelles coordonnées de l'origine
	    this.origine.x = this.o.x - this.u.x * this.valAbscisseOrigine / this.unitex - this.v.x * this.valOrdonneeOrigine / this.unitey;
	    this.origine.y = this.o.y - this.u.y * this.valAbscisseOrigine / this.unitex - this.v.y * this.valOrdonneeOrigine / this.unitey;
	    // Préparation du quadrillage vertical éventuel;
	    if (this.quadrillageVertical || this.pointilles) {
	      kernel.intersectionDroitesSecantes(0, 0, this.u, this.o.x, this.o.y, this.v, this.pointint[0]);
	      kernel.intersectionDroitesSecantes(0, dimfen.y, this.u, this.o.x, this.o.y, this.v, this.pointint[1]);
	      kernel.intersectionDroitesSecantes(dimfen.x, 0, this.u, this.o.x, this.o.y, this.v, this.pointint[2]);
	      kernel.intersectionDroitesSecantes(dimfen.x, dimfen.y, this.u, this.o.x, this.o.y, this.v, this.pointint[3]);
	      if (this.v.y !== 0) {
	        abs[0] = (this.pointint[0].y - this.o.y) / this.v.y;
	        abs[1] = (this.pointint[1].y - this.o.y) / this.v.y;
	        abs[2] = (this.pointint[2].y - this.o.y) / this.v.y;
	        abs[3] = (this.pointint[3].y - this.o.y) / this.v.y;
	      } else {
	        abs[0] = (this.pointint[0].x - this.o.x) / this.v.x;
	        abs[1] = (this.pointint[1].x - this.o.x) / this.v.x;
	        abs[2] = (this.pointint[2].x - this.o.x) / this.v.x;
	        abs[3] = (this.pointint[3].x - this.o.x) / this.v.x;
	      }
	      kernel.indiceMiniMaxi(3, abs, pointIndices);
	      this.absMiniV = Math.floor(abs[pointIndices.x] + 1);
	      this.absMaxiV = Math.floor(abs[pointIndices.y]);
	    }
	    if (this.quadrillageHorizontal || this.pointilles) {
	      kernel.intersectionDroitesSecantes(0, 0, this.v, this.o.x, this.o.y, this.u, this.pointint[0]);
	      kernel.intersectionDroitesSecantes(0, dimfen.y, this.v, this.o.x, this.o.y, this.u, this.pointint[1]);
	      kernel.intersectionDroitesSecantes(dimfen.x, 0, this.v, this.o.x, this.o.y, this.u, this.pointint[2]);
	      kernel.intersectionDroitesSecantes(dimfen.x, dimfen.y, this.v, this.o.x, this.o.y, this.u, this.pointint[3]);
	      if (this.u.x !== 0) {
	        abs[0] = (this.pointint[0].x - this.o.x) / this.u.x;
	        abs[1] = (this.pointint[1].x - this.o.x) / this.u.x;
	        abs[2] = (this.pointint[2].x - this.o.x) / this.u.x;
	        abs[3] = (this.pointint[3].x - this.o.x) / this.u.x;
	      } else {
	        abs[0] = (this.pointint[0].y - this.o.y) / this.u.y;
	        abs[1] = (this.pointint[1].y - this.o.y) / this.u.y;
	        abs[2] = (this.pointint[2].y - this.o.y) / this.u.y;
	        abs[3] = (this.pointint[3].y - this.o.y) / this.u.y;
	      }
	      kernel.indiceMiniMaxi(3, abs, pointIndices);
	      this.absMiniH = Math.floor(abs[pointIndices.x] + 1);
	      this.absMaxiH = Math.floor(abs[pointIndices.y]);
	    }
	  }
	};
	CRepere.prototype.createg = function () {
	  var p, q, x1, y1, cerc, style, styleCer, coul, path;
	  var g = kernel.cens("g");
	  style = "";
	  // coul = this.couleur.rgb() Modifié version 4.9.9.4
	  coul = this.color;
	  var stroke = this.style.stroke;
	  if (stroke.length !== 0) style += "stroke-dasharray:" + stroke + ";";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  style += "stroke:" + coul + ";";
	  var d = "";
	  if (this.quadrillageVertical) {
	    this.droiteQuadrillage.donneCouleur(this.couleur);
	    this.droiteQuadrillage.donneStyle(this.style); // Contrairement à la version java les repères ont un style
	    if (this.absMaxiV - this.absMiniV <= 200) {
	      this.droiteQuadrillage.vect.x = this.u.x;
	      this.droiteQuadrillage.vect.y = this.u.y;
	      for (p = this.absMiniV; p <= this.absMaxiV; p++) {
	        if (p !== 0) {
	          this.droiteQuadrillage.point_x = this.o.x + p * this.v.x;
	          this.droiteQuadrillage.point_y = this.o.y + p * this.v.y;
	          // Les paramètres d'appel ne servent pas.
	          this.droiteQuadrillage.positionne(this.infoSurRandom, this.Dimf);
	          d += "M" + this.droiteQuadrillage.xext1 + " " + this.droiteQuadrillage.yext1;
	          d += "L" + this.droiteQuadrillage.xext2 + " " + this.droiteQuadrillage.yext2;
	        }
	      }
	    }
	  }
	  if (this.quadrillageHorizontal) {
	    this.droiteQuadrillage.donneCouleur(this.couleur);
	    this.droiteQuadrillage.donneStyle(this.style);
	    if (this.absMaxiH - this.absMiniH <= 200) {
	      this.droiteQuadrillage.vect.x = this.v.x;
	      this.droiteQuadrillage.vect.y = this.v.y;
	      for (p = this.absMiniH; p <= this.absMaxiH; p++) {
	        if (p !== 0) {
	          this.droiteQuadrillage.point_x = this.o.x + p * this.u.x;
	          this.droiteQuadrillage.point_y = this.o.y + p * this.u.y;
	          this.droiteQuadrillage.positionne(this.infoSurRandom, this.Dimf);
	          d += "M" + this.droiteQuadrillage.xext1 + " " + this.droiteQuadrillage.yext1;
	          d += "L" + this.droiteQuadrillage.xext2 + " " + this.droiteQuadrillage.yext2;
	        }
	      }
	    }
	  }
	  if (d.length !== 0) {
	    path = kernel.cens("path", {
	      d: d,
	      style: style
	    });
	    g.appendChild(path);
	  }
	  if (this.pointilles) {
	    /* Modifié version 5.0
	    stroke = StyleTrait.stroke(StyleTrait.traitFin);
	    styleCer = "stroke-dasharray:"+stroke+";"+"stroke-width:1"+"stroke:"+coul+";"+"fill:"+coul;
	    */
	    styleCer = "stroke-width:1;stroke:" + coul + ";" + "fill:" + coul + ";";
	
	    if (this.absMaxiH - this.absMiniH <= 200 && this.absMaxiV - this.absMiniV <= 200) {
	      for (p = this.absMiniH; p <= this.absMaxiH; p++) {
	        for (q = this.absMiniV; q <= this.absMaxiV; q++) {
	          x1 = this.o.x + p * this.u.x + q * this.v.x;
	          y1 = this.o.y + p * this.u.y + q * this.v.y;
	          cerc = kernel.cens("circle", {
	            style: styleCer,
	            cx: x1,
	            cy: y1,
	            // r : 1 // Modifié version 5.4
	            r: 0.5
	          });
	          g.appendChild(cerc);
	        }
	      }
	    }
	  }
	  g.setAttribute("pointer-events", "none");
	  return g;
	};
	CRepere.prototype.trace = function (svg, couleurFond, transparence) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CRepere.prototype.update = function (svg) {
	  var oldg = this.g;
	  var g = this.createg();
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CRepere.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.o === p.o && this.i === p.i && this.j === p.j;else return false;
	};
	CRepere.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.o === ancienPoint) this.o = nouveauPoint;
	  if (this.i === ancienPoint) this.i = nouveauPoint;
	  if (this.j === ancienPoint) this.j = nouveauPoint;
	};
	CRepere.prototype.getNatureCalcul = function () {
	  return NatCal.NRepere;
	};
	CRepere.prototype.getNature = function () {
	  return NatObj.NRepere;
	};
	CRepere.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.o);
	  liste.add(this.i);
	  liste.add(this.j);
	};
	CRepere.prototype.getNom = function () {
	  return "(" + this.o.rendNom() + "," + this.i.rendNom() + "," + this.j.rendNom() + ")";
	};
	CRepere.prototype.read = function (inps, list) {
	  CElementLigne.prototype.read.call(this, inps, list);
	  this.abscisseOrigine = new CValeur(list, 0);
	  this.ordonneeOrigine = new CValeur(list, 0);
	  this.u = new Vect();
	  this.v = new Vect();
	  this.droiteQuadrillage = new CDroite(list);
	  this.droiteQuadrillage.donneStyle(StyleTrait.traitPointille);
	  this.droiteQuadrillage.montre();
	  this.origine = new Point();
	  this.pointint = new Array(4);
	  // Créer le tableau ne suffit pas, il faut instancier chaque membre
	  for (var i = 0; i < 4; i++) {
	    this.pointint[i] = new Point();
	  }var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  var ind3 = inps.readInt();
	  this.o = list.get(ind1, "CPt");
	  this.i = list.get(ind2, "CPt");
	  this.j = list.get(ind3, "CPt");
	  this.quadrillageVertical = inps.readBoolean();
	  this.quadrillageHorizontal = inps.readBoolean();
	  this.pointilles = inps.readBoolean();
	  this.abscisseOrigine = new CValeur();
	  this.abscisseOrigine.read(inps, list);
	  this.ordonneeOrigine = new CValeur();
	  this.ordonneeOrigine.read(inps, list);
	  // Ajout version 3.9.5 : unité sur l'axe des abscisses et l'axe des ordonnées
	  this.unite_x = new CValeur();
	  this.unite_x.read(inps, list);
	  this.unite_y = new CValeur();
	  this.unite_y.read(inps, list);
	};
	CRepere.prototype.write = function (oups, list) {
	  CElementLigne.prototype.write.call(this, oups, list);
	  // Créer le tableau ne suffit pas, il faut instancier chaque membre
	  // for (var i = 0; i < 4; i++) this.pointint[i] = new Point();
	  var ind1 = list.indexOf(this.o);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.i);
	  oups.writeInt(ind2);
	  var ind3 = list.indexOf(this.j);
	  oups.writeInt(ind3);
	  oups.writeBoolean(this.quadrillageVertical);
	  oups.writeBoolean(this.quadrillageHorizontal);
	  oups.writeBoolean(this.pointilles);
	  this.abscisseOrigine.write(oups, list);
	  this.ordonneeOrigine.write(oups, list);
	  this.unite_x.write(oups, list);
	  this.unite_y.write(oups, list);
	};

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var CTransformation = __webpack_require__(100);
	var CValeurAngle = __webpack_require__(79);
	module.exports = CRotation;
	
	/**
	 * Classe définition une rotation définie par son centre et son angle.
	 * @constructor
	 * @extends CTransformation
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} centre : Le point centre de la rotation.
	 * @param {CValeurAngle} angle : L'angle de la rotation.
	 * @returns {CRotation}
	 */
	function CRotation(listeProprietaire, impProto, estElementFinal, centre, angle) {
	  if (arguments.length === 1) CTransformation.call(this, listeProprietaire);else {
	    CTransformation.call(this, listeProprietaire, impProto, estElementFinal);
	    this.centre = centre;
	    this.angle = angle;
	  }
	}
	CRotation.prototype = new CTransformation();
	CRotation.prototype.constructor = CRotation;
	CRotation.prototype.superClass = "CTransformation";
	CRotation.prototype.className = "CRotation";
	
	/**
	 * Indique la nature de la transformation
	 * @returns {CTransformation.translation}
	 */
	CRotation.prototype.natureTransformation = function () {
	  return CTransformation.rotation;
	};
	
	CRotation.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.centre);
	  var angleClone = this.angle.getClone(listeSource, listeCible);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CRotation(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt"), angleClone);
	};
	CRotation.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CTransformation.prototype.dependDe.call(this, p) || this.centre.dependDe(p) || this.angle.dependDe(p));
	};
	CRotation.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.centre.dependDePourBoucle(p) || this.angle.dependDePourBoucle(p);
	};
	CRotation.prototype.positionne = function (infoRandom) {
	  this.angle.positionne(infoRandom);
	  this.existe = this.centre.existe && this.angle.existe;
	  if (this.existe) this.valeurAngle = this.angle.rendValeurRadian();
	};
	CRotation.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.centre.confonduAvec(p.centre) && this.angle.confonduAvec(p.angle);
	  } else return false;
	};
	/**
	 * Renvoie dans pointr.x et pointr.y les coordonnées du point image du point de coordonnées (x,y).
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Object} pointr
	 * @returns {undefined}
	 */
	CRotation.prototype.transformePoint = function (x, y, pointr) {
	
	  var u = new Vect(this.centre.x, this.centre.y, x, y);
	  var v = new Vect();
	  u.tourne(this.valeurAngle, v);
	  pointr.x = this.centre.x + v.x;
	  pointr.y = this.centre.y + v.y;
	};
	/**
	 * Renvoie dans le vecteur ur les coordonnées du vecteur image du vecteur u.
	 * @param {Vect} u
	 * @param {Vect} ur
	 * @returns {undefined}
	 */
	CRotation.prototype.transformeVecteur = function (u, ur) {
	  u.tourne(this.valeurAngle, ur);
	};
	CRotation.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.centre === ancienPoint) this.centre = nouveauPoint;
	};
	CRotation.prototype.read = function (inps, list) {
	  CTransformation.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.centre = list.get(ind1, "CPt");
	  this.angle = new CValeurAngle();
	  this.angle.read(inps, list);
	};
	CRotation.prototype.write = function (oups, list) {
	  CTransformation.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.centre);
	  oups.writeInt(ind1);
	  this.angle.write(oups, list);
	};

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CSegment = __webpack_require__(134);
	module.exports = CSegmentClone;
	
	/**
	 * Classe représentant le clone d'un segment déjà existant.
	 * Il est la réplque exacte de celui qu'il clone mais peut avoir sa ppropre couleur
	 * et son propre style de trait.
	 * Principalement utilisé pour les constructtions itératives et récursives.
	 * @constructor
	 * @extends CSegment
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {mtg32.CImplemtationProto} impProto
	 * @param {Boolean} estElementFinal : true si objet final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué
	 * @param {mtg32.StyleTrait} style : Le style de tracé.
	 * @param {CSegment} segment : Le segment qui est cloné.
	 * @returns {CSegmentClone}
	 */
	function CSegmentClone(listeProprietaire, impProto, estElementFinal, couleur, masque, style, segment) {
	  if (arguments.length === 1) CSegment.call(this, listeProprietaire);else CSegment.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, segment.point1, segment.point2);
	}
	CSegmentClone.prototype = new CSegment();
	CSegmentClone.prototype.constructor = CSegmentClone;
	CSegmentClone.prototype.superClass = "CSegment";
	CSegmentClone.prototype.className = "CSegmentClone";
	
	CSegmentClone.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.segment);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CSegment(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind1, "CSegment"));
	};
	CSegmentClone.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CSegment.prototype.dependDe.call(this, p) || this.segment.dependDe(p));
	};
	CSegmentClone.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.segment.dependDePourBoucle(p);
	};
	CSegmentClone.prototype.positionne = function () {
	  var b = this.masque;
	  this.setClone(this.segment);
	  this.masque = b;
	};
	CSegmentClone.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.segment);
	};
	CSegmentClone.prototype.read = function (inps, list) {
	  CSegment.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.droite = list.get(ind1, "CDroite");
	};
	CSegmentClone.prototype.write = function (oups, list) {
	  CSegment.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.droite);
	  oups.writeInt(ind1);
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var CValeur = __webpack_require__(80);
	var CRotation = __webpack_require__(237);
	module.exports = CSimilitude;
	
	/**
	 * Classe représentant une similitude (transformation).
	 * @constructor
	 * @extends CRotation
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} centre : Le centre de la similitude.
	 * @param {mtg32.CValeurAsscocieeAVariable} angle : L'angle de la similitude.
	 * @param {mtg32.CValeurAsscocieeAVariable} rapport : Le rappot de la similitude.
	 * @returns {CSimilitude}
	 */
	function CSimilitude(listeProprietaire, impProto, estElementFinal, centre, angle, rapport) {
	  if (arguments.length === 1) CRotation.call(this, listeProprietaire);else {
	    CRotation.call(this, listeProprietaire, impProto, estElementFinal, centre, angle);
	    this.rapport = rapport;
	  }
	}
	CSimilitude.prototype = new CRotation();
	CSimilitude.prototype.constructor = CSimilitude;
	CSimilitude.prototype.superClass = "CRotation";
	CSimilitude.prototype.className = "CSimilitude";
	/**
	 * Indique la nature de la transformation
	 * @returns {CSimilitude.similitude}
	 */
	CSimilitude.prototype.natureTransformation = function () {
	  return this.similitude;
	};
	CSimilitude.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.centre);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var angleClone = this.angle.getClone(listeSource, listeCible);
	  var rapportClone = this.rapport.getClone(listeSource, listeCible);
	  return new CSimilitude(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt"), angleClone, rapportClone);
	};
	CSimilitude.prototype.initialisePourDependance = function () {
	  CRotation.prototype.initialisePourDependance.call(this);
	  this.rapport.initialisePourDependance();
	};
	CSimilitude.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CRotation.prototype.dependDe.call(this, p) || this.rapport.dependDe(p));
	};
	CSimilitude.prototype.dependDePourBoucle = function (p) {
	  return CRotation.prototype.dependDePourBoucle.call(this, p) || this.rapport.dependDePourBoucle(p);
	};
	CSimilitude.prototype.positionne = function (infoRandom) {
	  CRotation.prototype.positionne.call(this, infoRandom);
	  this.rapport.positionne(infoRandom);
	  this.existe = this.existe && this.rapport.existe;
	  if (this.existe) this.valeurRapport = this.rapport.rendValeur();
	};
	CSimilitude.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.centre.confonduAvec(p.centre) && this.angle.confonduAvec(p.angle) && this.rapport.confonduAvec(p.rapport);else return false;
	};
	CSimilitude.prototype.transformeLongueur = function (l) {
	  return Math.abs(this.valeurRapport) * l;
	};
	/**
	 * Renvoie dans pointr.x et pointr.y les coordonnées du point image du point de coordonnées (x,y).
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Object} pointr
	 * @returns {undefined}
	 */
	CSimilitude.prototype.transformePoint = function (x, y, pointr) {
	  // On crée d'abord l'image par l'objet rotation dont CSimilitude
	  // hérite puis on prend l'image par une homothétie de rapport k
	  var point1 = {};
	  CRotation.prototype.transformePoint.call(this, x, y, point1);
	  pointr.x = this.centre.x + this.valeurRapport * (point1.x - this.centre.x);
	  pointr.y = this.centre.y + this.valeurRapport * (point1.y - this.centre.y);
	};
	/**
	 * Renvoie dans le vecteur ur les coordonnées du vecteur image du vecteur u.
	 * @param {Vect} u
	 * @param {Vect} ur
	 * @returns {undefined}
	 */
	CSimilitude.prototype.transformeVecteur = function (u, ur) {
	  var v = new Vect();
	  CRotation.prototype.transformeVecteur.call(this, u, v);
	  ur.x = this.valeurRapport * v.x;
	  ur.y = this.valeurRapport * v.y;
	};
	CSimilitude.prototype.read = function (inps, list) {
	  CRotation.prototype.read.call(this, inps, list);
	  this.rapport = new CValeur();
	  this.rapport.read(inps, list);
	};
	CSimilitude.prototype.write = function (oups, list) {
	  CRotation.prototype.write.call(this, oups, list);
	  this.rapport.write(oups, list);
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Ope = __webpack_require__(32);
	var CCalculAncetre = __webpack_require__(35);
	var CAppelFonction = __webpack_require__(42);
	var CConstante = __webpack_require__(45);
	var COp = __webpack_require__(51);
	var CValeur = __webpack_require__(80);
	var CVariableFormelle = __webpack_require__(57);
	module.exports = CSolutionEquation;
	
	/**
	 * Classe repésentant une valeur approchée d'équation sur un intervalle.
	 * L'équation doit correspondre à une fonction strictement monotone telle que f(a) et f(b)
	 * soient de signes contraires, sinon l'objet n'existe pas.
	 * Si le calcul nécessite plus de 1000 boucles, l'élément est considéré comme non existant.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CValeur} a : La borne inférieure de recherche.
	 * @param {CValeur} b : La borne supérieure de recherche.
	 * @param {CValeur} incertitude
	 * @param {String} inconnue : Chaîne représentant l'inconnue dans l'équation.
	 * @param {CCb} equation :L'équation à résoudre.
	 * @returns {CSolutionEquation}
	 */
	function CSolutionEquation(listeProprietaire, impProto, estElementFinal, nomCalcul, a, b, incertitude, inconnue, equation) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);else {
	      CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	      this.a = a;
	      this.b = b;
	      this.incertitude = incertitude;
	      this.inconnue = inconnue;
	      this.equation = equation;
	      this.fonction = new COp(listeProprietaire, equation.membreGauche(), equation.membreDroit(), Ope.Moin);
	    }
	  }
	  this.solution = 0;
	}
	CSolutionEquation.prototype = new CCalculAncetre();
	CSolutionEquation.prototype.constructor = CSolutionEquation;
	CSolutionEquation.prototype.superClass = "CCalculAncetre";
	CSolutionEquation.prototype.className = "CSolutionEquation";
	
	CSolutionEquation.prototype.numeroVersion = function () {
	  return 2;
	};
	CSolutionEquation.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var aClone = this.a.getClone(listeSource, listeCible);
	  var bClone = this.b.getClone(listeSource, listeCible);
	  var incertitudeClone = this.incertitude.getClone(listeSource, listeCible);
	  var equationClone = this.equation.getClone(listeSource, listeCible);
	  var fonctionClone = this.fonction.getClone(listeSource, listeCible);
	  return new CSolutionEquation(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, aClone, bClone, incertitudeClone, this.inconnue, equationClone, fonctionClone);
	};
	CSolutionEquation.prototype.getNatureCalcul = function () {
	  return NatCal.NSolutionEquation;
	};
	CSolutionEquation.prototype.initialisePourDependance = function () {
	  CCalculAncetre.prototype.initialisePourDependance.call(this);
	  this.a.initialisePourDependance();
	  this.b.initialisePourDependance();
	  this.incertitude.initialisePourDependance();
	};
	CSolutionEquation.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.a.dependDe(p) || this.b.dependDe(p) || this.incertitude.dependDe(p) || this.equation.dependDe(p));
	};
	CSolutionEquation.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.a.dependDePourBoucle(p) || this.b.dependDePourBoucle(p) || this.incertitude.dependDePourBoucle(p) || this.equation.dependDePourBoucle(p);
	};
	CSolutionEquation.prototype.positionne = function (infoRandom, dimfen) {
	  var xm, xa, xb, ya, yb, ym, e, temp, i;
	  this.a.positionne(infoRandom, dimfen);
	  this.b.positionne(infoRandom, dimfen);
	  this.incertitude.positionne(infoRandom, dimfen);
	  this.existe = this.equation.existe(infoRandom) && this.a.existe && this.b.existe && this.incertitude.existe;
	  if (!this.existe) return;
	  xa = this.a.rendValeur();
	  xb = this.b.rendValeur();
	  e = this.incertitude.rendValeur();
	  if (xa > xb) {
	    temp = xa;
	    xa = xb;
	    xb = temp;
	  }
	  try {
	    ya = this.fonction.resultatFonction(infoRandom, xa);
	    yb = this.fonction.resultatFonction(infoRandom, xb);
	    if (ya * yb > 0 || e <= 0) {
	      this.existe = false;
	      return;
	    }
	  } catch (err) {
	    this.existe = false;
	    return;
	  }
	  var nBoucles = Math.floor(Math.log(Math.abs(xb - xa) / e) / Math.log(2)) + 1;
	  if (nBoucles > 1000) {
	    this.existe = false;
	    return;
	  }
	  xm = (xa + xb) / 2;
	  for (i = 1; i <= nBoucles; i++) {
	    xm = (xa + xb) / 2;
	    try {
	      ym = this.fonction.resultatFonction(infoRandom, xm);
	    } catch (err) {
	      this.existe = false;
	      return;
	    }
	    if (ym * ya > 0) xa = xm;else xb = xm;
	  }
	  this.existe = true;
	  this.solution = xm;
	};
	CSolutionEquation.prototype.rendValeur = function () {
	  return this.solution;
	};
	CSolutionEquation.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  if (this.nVersion < 2) {
	    var ind1 = inps.readInt();
	    var fonc = list.get(ind1, "CFonc");
	    this.fonction = fonc.calcul;
	    this.inconnue = fonc.chaineVariable;
	    this.equation = new COp(list, new CAppelFonction(list, fonc, new CVariableFormelle(list, 0)), new CConstante(list, 0), Ope.Egalite);
	  } else {
	    this.inconnue = inps.readUTF();
	    this.equation = inps.readObject(list);
	    this.fonction = inps.readObject(list);
	  }
	  this.a = new CValeur();
	  this.a.read(inps, list);
	  this.b = new CValeur();
	  this.b.read(inps, list);
	  this.incertitude = new CValeur();
	  this.incertitude.read(inps, list);
	};
	CSolutionEquation.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.inconnue);
	  oups.writeObject(this.equation);
	  oups.writeObject(this.fonction);
	  this.a.write(oups, list);
	  this.b.write(oups, list);
	  this.incertitude.write(oups, list);
	};
	CSolutionEquation.prototype.estConstant = function () {
	  return this.a.estConstant() && this.b.estConstant() && this.incertitude.estConstant() && this.equation.estConstant();
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalculAncetre = __webpack_require__(35);
	var CValeur = __webpack_require__(80);
	var CSousListeObjets = __webpack_require__(66);
	module.exports = CSomme;
	
	// Attention : Ordre des 3 derniers paramètres inversés par rapport à version Java
	/**
	 * Classe calculant la somme de la valeur de valeurAssomer suivant les valeurs
	 * de la variable indice prenant ses valeurs de indiceMin jusquà indiceMax.
	 * valeurAssommerpeut dépendre d'éléments graphiques.
	 * Lors de chaque boucle, les éléments dépendant de la figure sont recalculés.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire
	 * @param {CImplementationProto} impProto : null ou la construcction propriétaire
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom.
	 * @param {CVariableBornee} indice : Le nome de la variable qui joue le rôel d'indice
	 * @param {CValDyn} valeurASommer
	 * @param {CValeur} indiceMin
	 * @param {CValeur} indiceMax
	 * @returns {CSomme}
	 */
	function CSomme(listeProprietaire, impProto, estElementFinal, nomCalcul, indice, valeurASommer, indiceMin, indiceMax) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.indice = indice;
	    this.valeurASommer = valeurASommer;
	    this.indiceMin = indiceMin;
	    this.indiceMax = indiceMax;
	  }
	  this.listeElementsAncetres = new CSousListeObjets();
	}
	CSomme.prototype = new CCalculAncetre();
	CSomme.prototype.constructor = CSomme;
	CSomme.prototype.superClass = "CCalculAncetre";
	CSomme.prototype.className = "CSomme";
	
	CSomme.prototype.numeroVersion = function () {
	  return 2;
	};
	
	CSomme.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.indice);
	  var ind2 = listeSource.indexOf(this.valeurASommer);
	  var ind3 = listeSource.indexOf(this.impProto);
	  var indiceMinClone = this.indiceMin.getClone(listeSource, listeCible);
	  var indiceMaxClone = this.indiceMax.getClone(listeSource, listeCible);
	  var ptelb = new CSomme(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CVariableBornee"), listeCible.get(ind2, "CValDyn"), indiceMinClone, indiceMaxClone);
	  if (listeCible.className !== "CPrototype") ptelb.listeElementsAncetres.setImage(this.listeElementsAncetres, this.listeProprietaire, ptelb.listeProprietaire);
	  return ptelb;
	};
	
	CSomme.prototype.getNatureCalcul = function () {
	  return NatCal.NSommeIndicee;
	};
	
	CSomme.prototype.initialisePourDependance = function () {
	  CCalculAncetre.prototype.initialisePourDependance.call(this);
	  this.indiceMin.initialisePourDependance();
	  this.indiceMax.initialisePourDependance();
	};
	
	CSomme.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.indice.dependDe(p) || this.valeurASommer.dependDe(p) || this.indiceMin.dependDe(p) || this.indiceMax.dependDe(p));
	};
	
	CSomme.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.indice.dependDePourBoucle(p) || this.valeurASommer.dependDePourBoucle(p) || this.indiceMin.dependDePourBoucle(p) || this.indiceMax.dependDePourBoucle(p);
	};
	CSomme.prototype.positionne = function (infoRandom, dimfen) {
	  this.indiceMin.positionne(infoRandom, dimfen);
	  this.indiceMax.positionne(infoRandom, dimfen);
	  this.existe = this.indiceMin.existe && this.indiceMax.existe;
	  if (!this.existe) return;
	  // On arrondit les indices de départ et de fin à l'entier le plus proche
	  var indmin = Math.floor(this.indiceMin.rendValeur() + 0.5);
	  var indmax = Math.floor(this.indiceMax.rendValeur() + 0.5);
	  this.existe = indmin <= indmax && indmax - indmin < 5000;
	  if (!this.existe) return;
	  var sauveIndice = this.indice.rendValeur();
	  this.valeurSomme = 0;
	  // à revoir : faut-il que la variable de boucle soit double ?
	  for (var i = indmin; i <= indmax; i++) {
	    this.indice.valeurActuelle = i;
	    this.listeElementsAncetres.positionneFull(infoRandom, dimfen);
	    this.existe = this.existe && this.valeurASommer.existe;
	    this.valeurSomme += this.valeurASommer.rendValeur();
	  }
	  this.indice.donneValeur(sauveIndice);
	  this.listeElementsAncetres.metAJour();
	  this.listeElementsAncetres.positionne(infoRandom, dimfen);
	};
	
	CSomme.prototype.rendValeur = function () {
	  return this.valeurSomme;
	};
	
	CSomme.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  // Il faut créer la liste des éléments dont dépend le point à tracer
	  // Pour cette liste, on fait pointer la longueur unité éventuelle sur la liste mère
	  var ind1 = inps.readInt();
	  this.indice = list.get(ind1, "CVariableBornee");
	  var ind2 = inps.readInt();
	  this.valeurASommer = list.get(ind2, "CValDyn");
	  this.indiceMin = new CValeur();
	  this.indiceMin.read(inps, list);
	  this.indiceMax = new CValeur();
	  this.indiceMax.read(inps, list);
	  // Modification pour la version 2.5.
	  // Certaines choses pas à faire pour le chargement d'un prototype
	  this.listeElementsAncetres.read(inps, list);
	};
	
	CSomme.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.indice);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.valeurASommer);
	  oups.writeInt(ind2);
	  this.indiceMin.write(oups, list);
	  this.indiceMax.write(oups, list);
	  this.listeElementsAncetres.write(oups, this.listeProprietaire);
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var kernel = __webpack_require__(8);
	var CCalculAncetre = __webpack_require__(35);
	var CValeur = __webpack_require__(80);
	module.exports = CSuiteRec;
	
	/**
	 * Classe représentant une suite récurrente de la forme u(n+1)=f[u(n)]
	 * Pour utiliser un terme de la suite dans un calcul, utiliser une syntae de la forme
	 * u(n) où u est le nom de la suite.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom de la suite.
	 * @param {CFonc} fonctionAssociee : La fonction réelle d'une variable associée (fonction utilisateur).
	 * @param {CValeur} nombreTermes : Le nombre de termes de la suite (dynamique).
	 * @param {CValeur} premierTerme : Le premier terme de la suite.
	 * @returns {CSuiteRec}
	 */
	function CSuiteRec(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme) {
	  if (arguments.length === 0) return;
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	    this.fonctionAssociee = fonctionAssociee;
	    this.nombreTermes = nombreTermes;
	    this.premierTerme = premierTerme;
	    this.metAJourNombreTermes();
	  }
	}
	CSuiteRec.prototype = new CCalculAncetre();
	CSuiteRec.prototype.constructor = CSuiteRec;
	CSuiteRec.prototype.superClass = "CCalculAncetre";
	CSuiteRec.prototype.className = "CSuiteRec";
	
	CSuiteRec.prototype.metAJourNombreTermes = function () {
	  var val = this.nombreTermes.rendValeur();
	  if (val === Math.floor(val) && val >= 1 && val <= kernel.NombreMaxiTermesSuiteRec) this.nbt = val;else this.nbt = 2; // Pas d'importance car dans ce cas la suite n'existe pas
	  this.valeurs = new Array(this.nbt);
	};
	CSuiteRec.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var premierTermeClone = this.premierTerme.getClone(listeSource, listeCible);
	  var nombreTermesClone = this.nombreTermes.getClone(listeSource, listeCible);
	  return new CSuiteRec(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CSuiteRec"), nombreTermesClone, premierTermeClone);
	};
	CSuiteRec.prototype.setClone = function (ptel) {
	  CCalculAncetre.prototype.setClone.call(this, ptel);
	  this.indiceDernierTermeExistant = ptel.indiceDernierTermeExistant;
	  var nbt = ptel.valeurs.length;
	  if (this.valeurs.length !== nbt) this.valeurs = new Array(nbt);
	  for (var i = 0; i <= this.indiceDernierTermeExistant; i++) {
	    this.valeurs[i] = ptel.valeurs[i];
	  }
	};
	CSuiteRec.prototype.nombreVariables = function () {
	  return 1;
	};
	CSuiteRec.prototype.initialisePourDependance = function () {
	  CCalculAncetre.prototype.initialisePourDependance.call(this);
	  this.nombreTermes.initialisePourDependance();
	  this.premierTerme.initialisePourDependance();
	};
	CSuiteRec.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.premierTerme.dependDe(p) || this.fonctionAssociee.dependDe(p) || this.nombreTermes.dependDe(p));
	};
	CSuiteRec.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.premierTerme.dependDePourBoucle(p) || this.fonctionAssociee.dependDePourBoucle(p) || this.nombreTermes.dependDePourBoucle(p);
	};
	CSuiteRec.prototype.positionne = function (infoRandom, dimfen) {
	  var u, v;
	  this.nombreTermes.positionne(infoRandom, dimfen);
	  this.premierTerme.positionne(infoRandom, dimfen);
	  this.existe = this.fonctionAssociee.existe && this.premierTerme.existe && this.nombreTermes.existe;
	  if (!this.existe) return;
	  var dnbt = Math.floor(this.nombreTermes.rendValeur() + 0.5);
	  this.existe = dnbt >= 1 && dnbt <= kernel.NombreMaxiTermesSuiteRec;
	  if (!this.existe) return;
	  if (dnbt !== this.nbt) {
	    this.nbt = dnbt;
	    this.metAJourNombreTermes();
	  }
	  u = this.premierTerme.rendValeur();
	  this.valeurs[0] = u;
	  this.indiceDernierTermeExistant = 0;
	  var i = 1;
	  while (i < this.nbt) {
	    try {
	      this.listeProprietaire.initialiseNombreIterations();
	      // v = fonctionAssociee.calcul.resultatFonction(infoRandom, u);
	      v = this.fonctionAssociee.calcul.resultatFonction(true, u);
	      if (!isFinite(v)) break;
	      u = v;
	      this.valeurs[i] = u;
	      i++;
	    } catch (e) {
	      break;
	    }
	  }
	  i--;
	  this.indiceDernierTermeExistant = i;
	};
	CSuiteRec.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.fonctionAssociee === p.fonctionAssociee && this.premierTerme.confonduAvec(p.premierTerme) && this.nombreTermes.confonduAvec(p.nombreTermes);
	  } else return false;
	};
	CSuiteRec.prototype.rendValeurFonction = function (infoRandom, parametre) {
	  if (!this.existe || parametre < 0 || parametre !== Math.floor(parametre) || parametre > this.indiceDernierTermeExistant) {
	    throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  } else return this.valeurs[parametre];
	};
	CSuiteRec.prototype.getNatureCalcul = function () {
	  return NatCal.NSuiteRecurrenteReelle;
	};
	CSuiteRec.prototype.estFonctionOuSuite = function () {
	  return true;
	};
	CSuiteRec.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  this.nombreTermes = new CValeur();
	  this.nombreTermes.read(inps, list);
	  this.premierTerme = new CValeur();
	  this.premierTerme.read(inps, list);
	  var ind1 = inps.readInt();
	  this.fonctionAssociee = list.get(ind1, "CSuiteRec");
	  // metAJourNombreTermes();
	  // Le nombre de valeurs étant dynamique, on ne peut pas le connaître au chargement
	  // On met 1 terme arbitrairement et cela sera rectifié dans positionne();
	  this.nbt = 1;
	  this.valeurs = new Array(1);
	};
	CSuiteRec.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  this.nombreTermes.write(oups, list);
	  this.premierTerme.write(oups, list);
	  var ind1 = list.indexOf(this.fonctionAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var kernel = __webpack_require__(8);
	var CSuiteRec = __webpack_require__(242);
	module.exports = CSuiteRec2;
	
	/**
	 * Suite récurrente réelle de la forme u(n+1)=f[n,u(n)] où f est une fonction
	 * utilisateur réelle de deux variables.
	 * @constructor
	 * @extends CSuiteRec
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom de la suite.
	 * @param {CFonc} fonctionAssociee : La fonction réelle de deux variables associée.
	 * @param {CValeur} nombreTermes : Le nombre de termes de la suite (dynamique).
	 * @param {CValeur} premierTerme : Le premier terme de la suite.
	 * @returns {CSuiteRec2}
	 */
	function CSuiteRec2(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme) {
	  if (arguments.length === 1) CSuiteRec.call(this, listeProprietaire);else CSuiteRec.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme);
	}
	CSuiteRec2.prototype = new CSuiteRec();
	CSuiteRec2.prototype.constructor = CSuiteRec2;
	CSuiteRec2.prototype.superClass = "CSuiteRec";
	CSuiteRec2.prototype.className = "CSuiteRec2";
	
	CSuiteRec2.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var premierTermeClone = this.premierTerme.getClone(listeSource, listeCible);
	  var nombreTermesClone = this.nombreTermes.getClone(listeSource, listeCible);
	  return new CSuiteRec2(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CSuiteRec2"), nombreTermesClone, premierTermeClone);
	};
	CSuiteRec2.prototype.positionne = function (infoRandom, dimfen) {
	  var u, v, i;
	  this.nombreTermes.positionne(infoRandom, dimfen);
	  this.premierTerme.positionne(infoRandom, dimfen);
	  this.existe = this.fonctionAssociee.existe && this.premierTerme.existe && this.nombreTermes.existe;
	  if (!this.existe) return;
	  var dnbt = Math.floor(this.nombreTermes.rendValeur() + 0.5);
	  this.existe = dnbt >= 1 && dnbt <= kernel.NombreMaxiTermesSuiteRec;
	  if (!this.existe) return;
	  if (dnbt !== this.nbt) {
	    this.nbt = dnbt;
	    this.metAJourNombreTermes();
	  }
	  u = this.premierTerme.rendValeur();
	  this.valeurs[0] = u;
	  this.indiceDernierTermeExistant = 0;
	  i = 1;
	  while (i < this.nbt) {
	    try {
	      this.listeProprietaire.initialiseNombreIterations();
	      // v = fonctionAssociee.calcul.resultatFonction(infoRandom, u);
	      var arg = new Array(2);
	      arg[0] = i - 1;
	      arg[1] = u;
	      v = this.fonctionAssociee.calcul.resultatFonction(true, arg);
	      if (!isFinite(v)) break;
	      u = v;
	      this.valeurs[i] = u;
	      i++;
	    } catch (e) {
	      break;
	    }
	  }
	  i--;
	  this.indiceDernierTermeExistant = i;
	};
	CSuiteRec2.prototype.getNatureCalcul = function () {
	  return NatCal.NSuiteRecurrenteReelle2;
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var kernel = __webpack_require__(8);
	var CValeur = __webpack_require__(80);
	var CSuiteRec = __webpack_require__(242);
	module.exports = CSuiteRec3;
	
	/**
	 * Suite récurrente réelle de la forme u(n+2)=f[n,u(n+1),u(n)] où f est une fonction réelle de trois variables.
	 * @constructor
	 * @extends CSuiteRec
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom de la suite.
	 * @param {CFonc} fonctionAssociee : La fonction réelle de deux variables associée.
	 * @param {CValeur} nombreTermes : Le nombre de termes de la suite (dynamique).
	 * @param {CValeur} premierTerme : Le premier terme de la suite.
	 * @param {CValeur} deuxiemeTerme : Le deuxième terme de la suite.
	 * @returns {CSuiteRec3}
	 */
	function CSuiteRec3(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme, deuxiemeTerme) {
	  if (arguments.length === 1) CSuiteRec.call(this, listeProprietaire);else {
	    CSuiteRec.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme);
	    this.deuxiemeTerme = deuxiemeTerme;
	  }
	}
	CSuiteRec3.prototype = new CSuiteRec();
	CSuiteRec3.prototype.constructor = CSuiteRec3;
	CSuiteRec3.prototype.superClass = "CSuiteRec";
	CSuiteRec3.prototype.className = "CSuiteRec3";
	
	CSuiteRec3.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var premierTermeClone = this.premierTerme.getClone(listeSource, listeCible);
	  var deuxiemeTermeClone = this.deuxiemeTerme.getClone(listeSource, listeCible);
	  var nombreTermesClone = this.nombreTermes.getClone(listeSource, listeCible);
	  return new CSuiteRec3(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CFoncNVar"), nombreTermesClone, premierTermeClone, deuxiemeTermeClone);
	};
	CSuiteRec3.prototype.initialisePourDependance = function () {
	  CSuiteRec.prototype.initialisePourDependance.call(this);
	  this.deuxiemeTerme.initialisePourDependance();
	};
	CSuiteRec3.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CSuiteRec.prototype.dependDe.call(this, p) || this.deuxiemeTerme.dependDe(p));
	};
	CSuiteRec.prototype.dependDePourBoucle = function (p) {
	  return CSuiteRec.prototype.dependDePourBoucle.call(this, p) || this.deuxiemeTerme.dependDePourBoucle(p);
	};
	CSuiteRec3.prototype.positionne = function (infoRandom, dimfen) {
	  var u, v, w, i;
	  this.nombreTermes.positionne(infoRandom, dimfen);
	  this.premierTerme.positionne(infoRandom, dimfen);
	  this.deuxiemeTerme.positionne(infoRandom, dimfen);
	  this.existe = this.fonctionAssociee.existe && this.premierTerme.existe && this.nombreTermes.existe;
	  if (!this.existe) return;
	  var dnbt = Math.floor(this.nombreTermes.rendValeur(false) + 0.5);
	  this.existe = dnbt >= 1 && dnbt <= kernel.NombreMaxiTermesSuiteRec;
	  if (!this.existe) return;
	  if (dnbt !== this.nbt) {
	    this.nbt = dnbt;
	    this.metAJourNombreTermes();
	  }
	
	  u = this.premierTerme.rendValeur();
	  this.valeurs[0] = u;
	  v = this.deuxiemeTerme.rendValeur();
	  this.valeurs[1] = v;
	  this.indiceDernierTermeExistant = 0;
	  i = 2;
	  while (i < this.nbt) {
	    try {
	      this.listeProprietaire.initialiseNombreIterations();
	      // v = fonctionAssociee.calcul.resultatFonction(infoRandom, u);
	      var arg = new Array(3);
	      arg[0] = i - 2;
	      arg[1] = v;
	      arg[2] = u;
	      w = this.fonctionAssociee.calcul.resultatFonction(true, arg);
	      if (!isFinite(v)) break;
	      u = v;
	      v = w;
	      this.valeurs[i] = w;
	      i++;
	    } catch (e) {
	      break;
	    }
	  }
	  i--;
	  this.indiceDernierTermeExistant = i;
	};
	CSuiteRec3.prototype.getNatureCalcul = function () {
	  return NatCal.NSuiteRecurrenteReelle3;
	};
	CSuiteRec3.prototype.read = function (inps, list) {
	  CSuiteRec.prototype.read.call(this, inps, list);
	  this.deuxiemeTerme = new CValeur();
	  this.deuxiemeTerme.read(inps, list);
	};
	CSuiteRec3.prototype.write = function (oups, list) {
	  CSuiteRec.prototype.write.call(this, oups, list);
	  this.deuxiemeTerme.write(oups, list);
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Complexe = __webpack_require__(30);
	var kernel = __webpack_require__(8);
	var CCalculAncetre = __webpack_require__(35);
	var CValeur = __webpack_require__(80);
	var CValeurComp = __webpack_require__(230);
	module.exports = CSuiteRecComplexe;
	
	/**
	 * Classe représentant une suite récurrente complexe de la forme u(n+1)=f[u(n)]
	 * où f est une fonction numérique complexe d'une variable.
	 * Pour utiliser un terme de la suite dans un calcul, utiliser une syntaxe de la forme
	 * u(n) où u est le nom de la suite.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom de la suite.
	 * @param {CFonc} fonctionAssociee : La fonction complexe d'une variable associée (fonction utilisateur).
	 * @param {CValeur} nombreTermes : Le nombre de termes de la suite (dynamique).
	 * @param {CValeur} premierTerme : Le premier terme de la suite (complexe ou réel).
	 * @returns {CSuiteRecComplexe}
	 */
	function CSuiteRecComplexe(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme) {
	  if (arguments.length !== 0) {
	    if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	      CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	      this.fonctionAssociee = fonctionAssociee;
	      this.nombreTermes = nombreTermes;
	      this.premierTerme = premierTerme;
	      this.metAJourNombreTermes();
	    }
	  }
	  this.u = new Complexe();
	  this.v = new Complexe();
	}
	CSuiteRecComplexe.prototype = new CCalculAncetre();
	CSuiteRecComplexe.prototype.constructor = CSuiteRecComplexe;
	CSuiteRecComplexe.prototype.superClass = "CCalculAncetre";
	CSuiteRecComplexe.prototype.className = "CSuiteRecComplexe";
	
	CSuiteRecComplexe.prototype.metAJourNombreTermes = function () {
	  var val = this.nombreTermes.rendValeur();
	  if (val === Math.floor(val) && val >= 1 && val <= kernel.NombreMaxiTermesSuiteRec) this.nbt = val;else this.nbt = 2; // Pas d'importance car dans ce cas la suite n'existe pas
	  this.valeurs = new Array(this.nbt);
	  for (var i = 0; i < this.nbt; i++) {
	    this.valeurs[i] = new Complexe();
	  }
	};
	CSuiteRecComplexe.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var premierTermeClone = this.premierTerme.getClone(listeSource, listeCible);
	  var nombreTermesClone = this.nombreTermes.getClone(listeSource, listeCible);
	  return new CSuiteRecComplexe(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CFoncComplexe"), nombreTermesClone, premierTermeClone);
	};
	CSuiteRecComplexe.prototype.setClone = function (ptel) {
	  var i;
	  CCalculAncetre.prototype.setClone.call(this, ptel);
	  this.indiceDernierTermeExistant = ptel.indiceDernierTermeExistant;
	  var nbt = ptel.valeurs.length;
	  if (this.valeurs.length !== nbt) {
	    this.valeurs = new Complexe[nbt]();
	    for (i = 0; i < nbt; i++) {
	      this.valeurs[i] = new Complexe();
	    }
	  }
	  for (i = 0; i <= this.indiceDernierTermeExistant; i++) {
	    this.valeurs[i].set(ptel.valeurs[i]);
	  }
	};
	CSuiteRecComplexe.prototype.nombreVariables = function () {
	  return 1;
	};
	CSuiteRecComplexe.prototype.initialisePourDependance = function () {
	  CCalculAncetre.prototype.initialisePourDependance.call(this);
	  this.premierTerme.initialisePourDependance();
	};
	CSuiteRecComplexe.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.premierTerme.dependDe(p) || this.fonctionAssociee.dependDe(p) || this.nombreTermes.dependDe(p));
	};
	CSuiteRecComplexe.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.premierTerme.dependDePourBoucle(p) || this.fonctionAssociee.dependDePourBoucle(p) || this.nombreTermes.dependDePourBoucle(p);
	};
	CSuiteRecComplexe.prototype.positionne = function (infoRandom, dimfen) {
	  this.premierTerme.positionne(infoRandom, dimfen);
	  this.nombreTermes.positionne(infoRandom, dimfen);
	  this.existe = this.fonctionAssociee.existe && this.premierTerme.existe && this.nombreTermes.existe;
	  if (!this.existe) return;
	  var dnbt = Math.floor(this.nombreTermes.rendValeur() + 0.5);
	  this.existe = dnbt >= 1 && dnbt <= kernel.NombreMaxiTermesSuiteRec;
	  if (!this.existe) return;
	  if (dnbt !== this.nbt) {
	    this.nbt = dnbt;
	    this.metAJourNombreTermes();
	  }
	  this.premierTerme.rendValeurComplexe(this.u);
	  this.valeurs[0].set(this.u);
	  this.indiceDernierTermeExistant = 0;
	  var i = 1;
	  while (i < this.nbt) {
	    try {
	      this.listeProprietaire.initialiseNombreIterations();
	      // fonctionAssociee.calcul.resultatFonctionComplexe(infoRandom, u, v);
	      this.fonctionAssociee.calcul.resultatFonctionComplexe(true, this.u, this.v);
	      if (this.v.isNanOrInfinite()) break;
	      this.u.set(this.v);
	      this.valeurs[i].set(this.u);
	      i++;
	    } catch (e) {
	      break;
	    }
	  }
	  i--;
	  this.indiceDernierTermeExistant = i;
	};
	CSuiteRecComplexe.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.fonctionAssociee === p.fonctionAssociee && this.premierTerme.confonduAvec(p.premierTerme) && this.nombreTermes.confonduAvec(p.nombreTermes);
	  } else return false;
	};
	CSuiteRecComplexe.prototype.rendValeurFonctionComplexe = function (infoRandom, parametre, zRes) {
	  if (!this.existe || parametre.y !== 0 || parametre.x !== Math.floor(parametre.x) || parametre.x < 0 || parametre.x > this.indiceDernierTermeExistant) {
	    throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
	  } else zRes.set(this.valeurs[parametre.x]);
	};
	CSuiteRecComplexe.prototype.getNatureCalcul = function () {
	  return NatCal.NSuiteRecurrenteComplexe;
	};
	CSuiteRecComplexe.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  this.nombreTermes = new CValeur();
	  this.nombreTermes.read(inps, list);
	  this.premierTerme = new CValeurComp();
	  this.premierTerme.read(inps, list);
	  var ind1 = inps.readInt();
	  this.fonctionAssociee = list.get(ind1, "CFoncComplexe");
	  this.nbt = 1;
	  this.valeurs = new Array(1);
	};
	CSuiteRecComplexe.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  this.nombreTermes.write(oups, list);
	  this.premierTerme.write(oups, list);
	  var ind1 = list.indexOf(this.fonctionAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Complexe = __webpack_require__(30);
	var kernel = __webpack_require__(8);
	var CSuiteRecComplexe = __webpack_require__(245);
	module.exports = CSuiteRecComplexe2;
	
	/**
	 * Suite récurrente réelle de la forme u(n+1)=f[n,u(n)] où f est une fonction
	 * utilisateur complexe de deux variables.
	 * @constructor
	 * @extends CSuiteRecComplexe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom de la suite.
	 * @param {CFonc} fonctionAssociee : La fonction compelxe de deux variables associée.
	 * @param {CValeur} nombreTermes : Le nombre de termes de la suite (dynamique).
	 * @param {CValeur} premierTerme : Le premier terme de la suite (complexe ou réel).
	 * @returns {CSuiteRecComplexe2}
	 */
	function CSuiteRecComplexe2(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme) {
	  if (arguments.length === 1) CSuiteRecComplexe.call(this, listeProprietaire);else CSuiteRecComplexe.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme);
	}
	CSuiteRecComplexe2.prototype = new CSuiteRecComplexe();
	CSuiteRecComplexe2.prototype.constructor = CSuiteRecComplexe2;
	CSuiteRecComplexe2.prototype.superClass = "CSuiteRecComplexe";
	CSuiteRecComplexe2.prototype.className = "CSuiteRecComplexe2";
	
	CSuiteRecComplexe2.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var premierTermeClone = this.premierTerme.getClone(listeSource, listeCible);
	  var nombreTermesClone = this.nombreTermes.getClone(listeSource, listeCible);
	  return new CSuiteRecComplexe2(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CFoncComplexeNVar"), nombreTermesClone, premierTermeClone);
	};
	CSuiteRecComplexe2.prototype.positionne = function (infoRandom, dimfen) {
	  var i;
	  this.premierTerme.positionne(infoRandom, dimfen);
	  this.nombreTermes.positionne(infoRandom, dimfen);
	  this.existe = this.fonctionAssociee.existe && this.premierTerme.existe && this.nombreTermes.existe;
	  if (!this.existe) return;
	  var dnbt = Math.floor(this.nombreTermes.rendValeur() + 0.5);
	  this.existe = dnbt >= 1 && dnbt <= kernel.NombreMaxiTermesSuiteRec;
	  if (!this.existe) return;
	  if (dnbt !== this.nbt) {
	    this.nbt = dnbt;
	    this.metAJourNombreTermes();
	  }
	  // Modifié version 3.1.2 pour autoriser la remise à jour des valeurs renvoyées par rand
	  // premierTerme.rendValeurComplexe(infoRandom, u);
	  this.premierTerme.rendValeurComplexe(this.u);
	  this.valeurs[0].set(this.u);
	  this.indiceDernierTermeExistant = 0;
	  i = 1;
	  while (i < this.nbt) {
	    try {
	      this.listeProprietaire.initialiseNombreIterations();
	      // fonctionAssociee.calcul.resultatFonctionComplexe(infoRandom, u, v);
	      var arg = new Array(2);
	      arg[0] = new Complexe();
	      arg[0].x = i - 1;
	      arg[0].y = 0;
	      arg[1] = new Complexe(this.u);
	      this.fonctionAssociee.calcul.resultatFonctionComplexe(true, arg, this.v);
	      if (this.v.isNanOrInfinite()) break;
	      this.u.set(this.v);
	      this.valeurs[i].set(this.u);
	      i++;
	    } catch (e) {
	      break;
	    }
	  }
	  i--;
	  this.indiceDernierTermeExistant = i;
	};
	CSuiteRecComplexe2.prototype.getNatureCalcul = function () {
	  return NatCal.NSuiteRecurrenteComplexe2;
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Complexe = __webpack_require__(30);
	var kernel = __webpack_require__(8);
	var CValeurComp = __webpack_require__(230);
	var CSuiteRecComplexe = __webpack_require__(245);
	module.exports = CSuiteRecComplexe3;
	
	/**
	 * Suite récurrente complexe de la forme u(n+2)=f[n,u(n+1),u(n)] où f est une fonction complexe de trois variables.
	 * @constructor
	 * @extends CSuiteRecComplexe
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom de la suite.
	 * @param {CFonc} fonctionAssociee : La fonction réelle de deux variables associée.
	 * @param {CValeur} nombreTermes : Le nombre de termes de la suite (dynamique).
	 * @param {CValeur} premierTerme : Le premier terme de la suite (complexe ou réel).
	 * @param {CValeur} deuxiemeTerme : Le deuxième terme de la suite (complexe ou réel).
	 * @returns {CSuiteRecComplexe3}
	 */
	function CSuiteRecComplexe3(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme, deuxiemeTerme) {
	  if (arguments.length === 1) CSuiteRecComplexe.call(this, listeProprietaire);else {
	    CSuiteRecComplexe.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, nombreTermes, premierTerme);
	    this.deuxiemeTerme = deuxiemeTerme;
	  }
	  this.w = new Complexe();
	}
	CSuiteRecComplexe3.prototype = new CSuiteRecComplexe();
	CSuiteRecComplexe3.prototype.constructor = CSuiteRecComplexe3;
	CSuiteRecComplexe3.prototype.superClass = "CSuiteRecComplexe";
	CSuiteRecComplexe3.prototype.className = "CSuiteRecComplexe3";
	
	CSuiteRecComplexe3.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var premierTermeClone = this.premierTerme.getClone(listeSource, listeCible);
	  var deuxiemeTermeClone = this.deuxiemeTerme.getClone(listeSource, listeCible);
	  var nombreTermesClone = this.nombreTermes.getClone(listeSource, listeCible);
	  return new CSuiteRecComplexe3(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CFoncComplexeNVar"), nombreTermesClone, premierTermeClone, deuxiemeTermeClone);
	};
	CSuiteRecComplexe3.prototype.initialisePourDependance = function () {
	  CSuiteRecComplexe.prototype.initialisePourDependance.call(this);
	  this.deuxiemeTerme.initialisePourDependance();
	};
	CSuiteRecComplexe3.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CSuiteRecComplexe.prototype.dependDe.call(this, p) || this.deuxiemeTerme.dependDe(p));
	};
	CSuiteRecComplexe3.prototype.dependDePourBoucle = function (p) {
	  return CSuiteRecComplexe.dependDePourBoucle.call(this, p) || this.deuxiemeTerme.dependDePourBoucle(p);
	};
	CSuiteRecComplexe3.prototype.positionne = function (infoRandom, dimfen) {
	  var i;
	  this.premierTerme.positionne(infoRandom, dimfen);
	  this.deuxiemeTerme.positionne(infoRandom, dimfen);
	  this.nombreTermes.positionne(infoRandom, dimfen);
	  this.existe = this.fonctionAssociee.existe && this.premierTerme.existe && this.deuxiemeTerme.existe && this.nombreTermes.existe;
	  if (!this.existe) return;
	  var dnbt = Math.floor(this.nombreTermes.rendValeur() + 0.5);
	  this.existe = dnbt >= 2 && dnbt <= kernel.NombreMaxiTermesSuiteRec;
	  if (!this.existe) return;
	  if (dnbt !== this.nbt) {
	    this.nbt = dnbt;
	    this.metAJourNombreTermes();
	  }
	  this.premierTerme.rendValeurComplexe(this.u);
	  this.valeurs[0].set(this.u);
	  this.deuxiemeTerme.rendValeurComplexe(this.v);
	  this.valeurs[1].set(this.v);
	  this.indiceDernierTermeExistant = 0;
	  i = 2;
	  while (i < this.nbt) {
	    try {
	      this.listeProprietaire.initialiseNombreIterations();
	      var arg = new Array(3);
	      arg[0] = new Complexe();
	      arg[0].x = i - 2;
	      arg[0].y = 0;
	      arg[1] = new Complexe(this.v);
	      arg[2] = new Complexe(this.u);
	
	      this.fonctionAssociee.calcul.resultatFonctionComplexe(true, arg, this.w);
	      if (this.w.isNanOrInfinite()) break;
	      this.u.set(this.v);
	      this.v.set(this.w);
	      this.valeurs[i].set(this.w);
	      i++;
	    } catch (e) {
	      break;
	    }
	  }
	  i--;
	  this.indiceDernierTermeExistant = i;
	};
	CSuiteRecComplexe3.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.fonctionAssociee === p.fonctionAssociee && this.premierTerme.confonduAvec(p.premierTerme) && this.deuxiemeTerme.confonduAvec(p.deuxiemeTerme) && this.nombreTermes.confonduAvec(p.nombreTermes);
	  } else return false;
	};
	CSuiteRecComplexe3.prototype.getNatureCalcul = function () {
	  return NatCal.NSuiteRecurrenteComplexe3;
	};
	CSuiteRecComplexe3.prototype.read = function (inps, list) {
	  CSuiteRecComplexe.read.call(this, inps, list);
	  this.deuxiemeTerme = new CValeurComp();
	  this.deuxiemeTerme.read(inps, list);
	};
	CSuiteRecComplexe3.prototype.write = function (oups, list) {
	  CSuiteRecComplexe.write.call(this, oups, list);
	  this.deuxiemeTerme.write(oups, list);
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CSurface = __webpack_require__(114);
	var CSegment = __webpack_require__(134);
	var CPointBase = __webpack_require__(85);
	module.exports = CSurfaceDeuxLieux;
	
	/**
	 * Classe représentant une surface délimitée par deux mieux de points.
	 * @constructor
	 * @extends CSurface
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 * @param {CElementGraphique} bord : Le premier bord de la surface (lieu de points).
	 * @param {CLieuDeBase} deuxiemeLieu :Le deuxième bord (lieu de points).
	 * @returns {CSurfaceDeuxLieux}
	 */
	function CSurfaceDeuxLieux(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord, deuxiemeLieu) {
	  if (arguments.length === 1) CSurface.call(this, listeProprietaire);else {
	    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
	    this.deuxiemeLieu = deuxiemeLieu;
	    this.abscisses = new Array(bord.infoLieu.nombreDePoints + 4);
	    this.ordonnees = new Array(bord.infoLieu.nombreDePoints + 4);
	  }
	  this.pointDebutLieu1 = new CPointBase();
	  this.pointDebutLieu2 = new CPointBase();
	  this.pointFinLieu1 = new CPointBase();
	  this.pointFinLieu2 = new CPointBase();
	  this.segmentDebut = new CSegment(this.pointDebutLieu1, this.pointDebutLieu2);
	  this.segmentFin = new CSegment(this.pointFinLieu1, this.pointFinLieu2);
	}
	CSurfaceDeuxLieux.prototype = new CSurface();
	CSurfaceDeuxLieux.prototype.constructor = CSurfaceDeuxLieux;
	CSurfaceDeuxLieux.prototype.superClass = "CSurface";
	CSurfaceDeuxLieux.prototype.className = "CSurfaceDeuxLieux";
	
	CSurfaceDeuxLieux.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.bord);
	  var ind2 = listeSource.indexOf(this.deuxiemeLieu);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CSurfaceDeuxLieux(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CLieuDeBase"), listeCible.get(ind2, "CLieuDeBase"));
	};
	CSurfaceDeuxLieux.prototype.setClone = function (ptel) {
	  CSurface.prototype.setClone.call(this, ptel);
	  if (ptel.existe) {
	    this.nombrePointsTraces = ptel.nombrePointsTraces;
	    for (var i = 0; i < this.nombrePointsTraces; i++) {
	      this.abscisses[i] = ptel.abscisses[i];
	      this.ordonnees[i] = ptel.ordonnees[i];
	    }
	  }
	};
	CSurfaceDeuxLieux.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.bord);
	  liste.add(this.deuxiemeLieu);
	};
	CSurfaceDeuxLieux.prototype.confonduAvec = function (p) {
	  var res = CSurface.prototype.confonduAvec.call(this, p);
	  if (!res) return false;
	  return this.deuxiemeLieu === p.deuxiemeLieu;
	};
	CSurfaceDeuxLieux.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CSurface.prototype.dependDe.call(this, p) || this.deuxiemeLieu.dependDe(p));
	};
	CSurfaceDeuxLieux.prototype.dependDePourBoucle = function (p) {
	  return CSurface.prototype.dependDePourBoucle.call(this, p) || this.deuxiemeLieu.dependDePourBoucle(p);
	};
	CSurfaceDeuxLieux.prototype.dependDePourCapture = function (p) {
	  return CSurface.prototype.dependDePourCapture.call(this, p) || this.deuxiemeLieu.dependDePourCapture(p);
	};
	CSurfaceDeuxLieux.prototype.positionne = function (infoRandom, dimfen) {
	  var i, x1, x2, x3, x4, y1, y2, y3, y4, ideb, deb, indicePremierPointLieu1, indiceDernierPointLieu1, indicePremierPointLieu2, indiceDernierPointLieu2, nombrePointsTracesPremierLieu, nombrePointsTracesDeuxiemeLieu;
	  this.existe = this.bord.existe && this.deuxiemeLieu.existe;
	  if (!this.existe) return;
	  // Les surfaces délimitant le bord ne doivent être formées
	  // que d'une seule ligne
	  if (!(this.bord.contientUneSeuleLigne() && this.deuxiemeLieu.contientUneSeuleLigne())) {
	    this.existe = false;
	    return;
	  }
	
	  nombrePointsTracesPremierLieu = this.bord.infoLignes[this.bord.indicePremiereLigne].nombrePoints;
	  nombrePointsTracesDeuxiemeLieu = this.deuxiemeLieu.infoLignes[this.deuxiemeLieu.indicePremiereLigne].nombrePoints;
	  this.nombrePointsTraces = nombrePointsTracesPremierLieu + nombrePointsTracesDeuxiemeLieu;
	  indicePremierPointLieu1 = this.bord.infoLignes[this.bord.indicePremiereLigne].indicePremierPoint;
	  indiceDernierPointLieu1 = this.bord.infoLignes[this.bord.indicePremiereLigne].indicePremierPoint + this.bord.infoLignes[this.bord.indicePremiereLigne].nombrePoints - 1;
	  indicePremierPointLieu2 = this.deuxiemeLieu.infoLignes[this.deuxiemeLieu.indicePremiereLigne].indicePremierPoint;
	  indiceDernierPointLieu2 = this.deuxiemeLieu.infoLignes[this.deuxiemeLieu.indicePremiereLigne].indicePremierPoint + this.deuxiemeLieu.infoLignes[this.deuxiemeLieu.indicePremiereLigne].nombrePoints - 1;
	  x1 = this.bord.abscissesCoordonneesPoints[indicePremierPointLieu1];
	  y1 = this.bord.ordonneesCoordonneesPoints[indicePremierPointLieu1];
	  x4 = this.bord.abscissesCoordonneesPoints[indiceDernierPointLieu1];
	  y4 = this.bord.ordonneesCoordonneesPoints[indiceDernierPointLieu1];
	  x3 = this.deuxiemeLieu.abscissesCoordonneesPoints[indiceDernierPointLieu2];
	  y3 = this.deuxiemeLieu.ordonneesCoordonneesPoints[indiceDernierPointLieu2];
	  x2 = this.deuxiemeLieu.abscissesCoordonneesPoints[indicePremierPointLieu2];
	  y2 = this.deuxiemeLieu.ordonneesCoordonneesPoints[indicePremierPointLieu2];
	  this.pointDebutLieu1.placeEn(x1, y1);
	  this.pointFinLieu2.placeEn(x4, y4);
	  // On recopie les coordonnées du premier lieu
	  ideb = this.bord.infoLignes[this.bord.indicePremiereLigne].indicePremierPoint;
	  for (i = 0; i < nombrePointsTracesPremierLieu; i++) {
	    this.abscisses[i] = this.bord.abscissesCoordonneesPoints[ideb + i];
	    this.ordonnees[i] = this.bord.ordonneesCoordonneesPoints[ideb + i];
	  }
	  deb = this.deuxiemeLieu.infoLignes[this.deuxiemeLieu.indicePremiereLigne].indicePremierPoint;
	  for (i = 0; i <= nombrePointsTracesDeuxiemeLieu - 1; i++) {
	    this.abscisses[nombrePointsTracesPremierLieu + i] = this.deuxiemeLieu.abscissesCoordonneesPoints[deb + nombrePointsTracesDeuxiemeLieu - i - 1];
	    this.ordonnees[nombrePointsTracesPremierLieu + i] = this.deuxiemeLieu.ordonneesCoordonneesPoints[deb + nombrePointsTracesDeuxiemeLieu - i - 1];
	  }
	  this.pointDebutLieu2.placeEn(x2, y2);
	  this.pointFinLieu1.placeEn(x3, y3);
	  this.segmentDebut.positionne(infoRandom, dimfen);
	  this.segmentFin.positionne(infoRandom, dimfen);
	  this.existe = this.segmentDebut.existe && this.segmentFin.existe;
	};
	/**
	 * Fonction renvoyant une chaîne de caractères utilisée dans le svg élément
	 * représentant la surface.
	 * @returns {String}
	 */
	CSurfaceDeuxLieux.prototype.creePoints = function () {
	  var j,
	      points = "";
	  for (j = 0; j < this.nombrePointsTraces; j++) {
	    points = points + this.abscisses[j] + ",";
	    points = points + this.ordonnees[j] + " ";
	  }
	  return points;
	};
	CSurfaceDeuxLieux.prototype.read = function (inps, list) {
	  CSurface.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.deuxiemeLieu = list.get(ind1, "CLieuDeBase");
	  if (list.className !== "CPrototype") {
	    this.abscisses = new Array(this.bord.infoLieu.nombreDePoints + this.deuxiemeLieu.infoLieu.nombreDePoints + 2);
	    this.ordonnees = new Array(this.bord.infoLieu.nombreDePoints + this.deuxiemeLieu.infoLieu.nombreDePoints + 2);
	  }
	};
	CSurfaceDeuxLieux.prototype.write = function (oups, list) {
	  CSurface.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.deuxiemeLieu);
	  oups.writeInt(ind1);
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var StyleRemplissage = __webpack_require__(115);
	var kernel = __webpack_require__(8);
	var CCercle = __webpack_require__(75);
	var CSurfaceAncetre = __webpack_require__(116);
	var CSurface = __webpack_require__(114);
	module.exports = CSurfaceDisque;
	
	/**
	 * Surface délimité par un cercle.
	 * @constructor
	 * @extends CSurface
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 * @param {CCercle} bord : Le cercle bord de la surface.
	 * @returns {CSurfaceDisque}
	 */
	function CSurfaceDisque(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord) {
	  if (arguments.length === 1) CSurface.call(this, listeProprietaire);else {
	    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
	  }
	  this.cercle = new CCercle(null);
	}
	CSurfaceDisque.prototype = new CSurface();
	CSurfaceDisque.prototype.constructor = CSurfaceDisque;
	CSurfaceDisque.prototype.superClass = "CSurface";
	CSurfaceDisque.prototype.className = "CSurfaceDisque";
	
	CSurfaceDisque.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.bord);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CSurfaceDisque(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CCercle"));
	};
	CSurfaceDisque.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.bord);
	};
	CSurfaceDisque.prototype.positionne = function (infoRandom, dimfen) {
	  CSurface.prototype.positionne.call(this, infoRandom, dimfen);
	  this.cercle.setClone(this.bord);
	};
	CSurfaceDisque.prototype.setClone = function (ptel) {
	  CSurfaceAncetre.prototype.setClone.call(this, ptel);
	  this.cercle.setClone(ptel.cercle);
	};
	CSurfaceDisque.prototype.createg = function (svg, couleurFond, transparence) {
	  var styleRemplissageEffectif, g, opacity, style, color;
	  // color = this.couleur.rgb() Modifié vesion 4.9.9.4
	  color = this.color;
	  if (this.masque) styleRemplissageEffectif = StyleRemplissage.QuadrillageCroise;else styleRemplissageEffectif = this.styleRemplissage;
	  g = kernel.cens("circle", {
	    cx: this.cercle.centre_x,
	    cy: this.cercle.centre_y,
	    r: this.cercle.rayon
	  });
	  switch (styleRemplissageEffectif) {
	    case StyleRemplissage.quadrillagePleinTransp:
	    case StyleRemplissage.quadrillagePlein:
	      opacity = styleRemplissageEffectif === StyleRemplissage.quadrillagePleinTransp ? transparence : 1;
	      style = "stroke:none;";
	      style += "fill-opacity:" + opacity + ";";
	      style += "fill:" + color + ";";
	      g.setAttribute("style", style);
	      break;
	    default:
	      style = "stroke:none;" + "fill:url(#" + this.index + "mtg32pattern);";
	      this.createPattern();
	      g.setAttribute("style", style);
	  }
	  g.setAttribute("pointer-events", "none");
	  return g;
	};
	CSurfaceDisque.prototype.update = function (svg, couleurFond, transparence) {
	  var g = this.g;
	  // svg.replaceChild(this.createg(transparence),g)
	  g.removeAttribute("cx");
	  g.removeAttribute("cx");
	  g.removeAttribute("r");
	  g.setAttribute("cx", this.cercle.centre_x);
	  g.setAttribute("cy", this.cercle.centre_y);
	  g.setAttribute("r", this.cercle.rayon);
	};
	CSurfaceDisque.prototype.read = function (inps, list) {
	  CSurface.prototype.read.call(this, inps, list);
	  this.cercle = new CCercle(null);
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CSurface = __webpack_require__(114);
	module.exports = CSurfaceLieu;
	
	/**
	 * Surface délimité par un lieu de points.
	 * Existe seulement si le lieu est fermé.
	 * @constructor
	 * @extends CSurface
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 * @param {CLieuDeBase} bord : Le lieu de points bord de la surface.
	 * @returns {CSurfaceLieu}
	 */
	function CSurfaceLieu(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord) {
	  if (arguments.length === 1) CSurface.call(this, listeProprietaire);else {
	    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
	    this.abscisses = new Array(this.bord.infoLieu.nombreDePoints + 1);
	    this.ordonnees = new Array(this.bord.infoLieu.nombreDePoints + 1);
	  }
	}
	CSurfaceLieu.prototype = new CSurface();
	CSurfaceLieu.prototype.constructor = CSurfaceLieu;
	CSurfaceLieu.prototype.superClass = "CSurface";
	CSurfaceLieu.prototype.className = "CSurfaceLieu";
	
	CSurfaceLieu.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.bord);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CSurfaceLieu(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CLieuDeBase"));
	};
	// Version Jaja : les coordonénes des sommets sont dans le membre points du bord
	CSurfaceLieu.prototype.setClone = function (ptel) {
	  CSurface.prototype.setClone.call(this, ptel);
	  if (ptel.existe) {
	    this.nbPointsLigne = ptel.nbPointsLigne;
	    for (var i = 0; i < this.nbPointsLigne; i++) {
	      this.abscisses[i] = ptel.abscisses[i];
	      this.ordonnees[i] = ptel.ordonnees[i];
	    }
	  }
	};
	CSurfaceLieu.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.bord);
	};
	CSurfaceLieu.prototype.positionne = function (infoRandom, dimfen) {
	  var j, k, k1;
	  CSurface.prototype.positionne.call(this, infoRandom, dimfen);
	  this.existe = this.existe && this.bord.contientAuMoinsUneLigne();
	  if (this.existe) {
	    this.nbPointsLigne = 0;
	    for (j = 0; j < this.bord.nombreLignes; j++) {
	      var nombrePoints = this.bord.infoLignes[j].nombrePoints;
	      var indPremPoint = this.bord.infoLignes[j].indicePremierPoint;
	      for (k = 0; k < nombrePoints; k++) {
	        k1 = k + this.nbPointsLigne;
	        this.abscisses[k1] = this.bord.abscissesCoordonneesPoints[indPremPoint + k];
	        this.ordonnees[k1] = this.bord.ordonneesCoordonneesPoints[indPremPoint + k];
	      }
	      this.nbPointsLigne += nombrePoints;
	    }
	  }
	};
	/**
	 * Fonction renvoyant une chaîne de caractères utilisée dans le svg élément
	 * représentant la surface.
	 * @returns {String}
	 */
	CSurfaceLieu.prototype.creePoints = function () {
	  var j,
	      points = "";
	  for (j = 0; j < this.nbPointsLigne; j++) {
	    points = points + this.abscisses[j] + ",";
	    points = points + this.ordonnees[j] + " ";
	  }
	  return points;
	};
	CSurfaceLieu.prototype.read = function (inps, list) {
	  CSurface.prototype.read.call(this, inps, list);
	  if (list.className !== "CPrototype") {
	    this.abscisses = new Array(this.bord.infoLieu.nombreDePoints + 1);
	    this.ordonnees = new Array(this.bord.infoLieu.nombreDePoints + 1);
	  }
	};

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var kernel = __webpack_require__(8);
	var CSurface = __webpack_require__(114);
	var CSegment = __webpack_require__(134);
	var CPointBase = __webpack_require__(85);
	module.exports = CSurfaceLieuDeuxPoints;
	
	/**
	 * Classe représentant une surface délimitée par un lieu de points et deux points.
	 * Utile pour représenter graphiquement des intégrales.
	 * Les points sont reliés à chaque extrémité du lieu (qui ne doit pas être fermé) et reliés entre eux.
	 * @constructor
	 * @extends CSurface
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 * @param {CLieuDeBase} bord : Le lieu de points bord de la surface.
	 * @param {CPt} point1 : Le premier point définissant le bord.
	 * @param {CPt} point2 : Le deuxième point définissant le bord.
	 * @returns {CSurfaceLieuDeuxPoints}
	 */
	function CSurfaceLieuDeuxPoints(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord, point1, point2) {
	  if (arguments.length === 1) {
	    CSurface.call(this, listeProprietaire);
	    this.pointDebutLieu = new CPointBase();
	    this.pointFinLieu = new CPointBase();
	    /** Modifié version MtgApp
	    this.segmentDebut = new CSegment();
	    this.segmentFin = new CSegment();
	    this.segmentDroite = new CSegment();
	     */
	    this.segmentDebut = new CSegment(null, null);
	    this.segmentFin = new CSegment(null, null);
	    this.segmentDroite = new CSegment(null, null);
	  } else {
	    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
	    this.point1 = point1;
	    this.point2 = point2;
	    this.abscisses = new Array(bord.infoLieu.nombreDePoints + 3);
	    this.ordonnees = new Array(bord.infoLieu.nombreDePoints + 3);
	    this.pointDebutLieu = new CPointBase();
	    this.pointFinLieu = new CPointBase();
	    this.segmentDebut = new CSegment(this.pointDebutLieu, point1);
	    this.segmentFin = new CSegment(point2, this.pointFinLieu);
	    this.segmentDroite = new CSegment(point1, point2);
	  }
	}
	CSurfaceLieuDeuxPoints.prototype = new CSurface();
	CSurfaceLieuDeuxPoints.prototype.constructor = CSurfaceLieuDeuxPoints;
	CSurfaceLieuDeuxPoints.prototype.superClass = "CSurface";
	CSurfaceLieuDeuxPoints.prototype.className = "CSurfaceLieuDeuxPoints";
	
	CSurfaceLieuDeuxPoints.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.bord);
	  var ind2 = listeSource.indexOf(this.point1);
	  var ind3 = listeSource.indexOf(this.point2);
	  var ind4 = listeSource.indexOf(this.impProto);
	  return new CSurfaceLieuDeuxPoints(listeCible, listeCible.get(ind4, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CLieuDeBase"), listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"));
	};
	CSurfaceLieuDeuxPoints.prototype.setClone = function (ptel) {
	  CSurface.prototype.setClone.call(this, ptel);
	  if (ptel.existe) {
	    this.nombrePointsLigne = ptel.nombrePointsLigne;
	    var nbPointsADecaler = this.nombrePointsLigne + 2;
	    for (var i = 0; i < nbPointsADecaler; i++) {
	      this.abscisses[i] = ptel.abscisses[i];
	      this.ordonnees[i] = ptel.ordonnees[i];
	    }
	  }
	};
	CSurfaceLieuDeuxPoints.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.bord);
	  liste.add(this.point1);
	  liste.add(this.point2);
	};
	CSurfaceLieuDeuxPoints.prototype.confonduAvec = function (p) {
	  var res = CSurface.prototype.confonduAvec.call(this, p);
	  if (!res) return false;
	  return this.point1 === p.point1 && this.point2 === p.point2;
	};
	CSurfaceLieuDeuxPoints.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CSurface.prototype.dependDe.call(this, p) || this.point1.dependDe(p) || this.point2.dependDe(p));
	};
	CSurfaceLieuDeuxPoints.prototype.dependDePourBoucle = function (p) {
	  return CSurface.prototype.dependDePourBoucle.call(this, p) || this.point1.dependDePourBoucle(p) || this.point2.dependDePourBoucle(p);
	};
	CSurfaceLieuDeuxPoints.prototype.dependDePourCapture = function (p) {
	  return CSurface.prototype.dependDePourCapture.call(this, p) || this.point1.dependDePourCapture(p) || this.point2.dependDePourCapture(p);
	};
	CSurfaceLieuDeuxPoints.prototype.positionne = function (infoRandom, dimfen) {
	  var x4, y4, xaux, yaux, i;
	  this.existe = this.bord.existe && this.point1.existe && this.point2.existe;
	  if (!this.existe) return;
	  if (!this.bord.contientUneSeuleLigne()) {
	    this.existe = false;
	    return;
	  }
	  // On recopie les coordonnées des points du lieu
	  var ideb = this.bord.infoLignes[this.bord.indicePremiereLigne].indicePremierPoint;
	  this.nombrePointsLigne = this.bord.infoLignes[this.bord.indicePremiereLigne].nombrePoints;
	  for (i = 0; i < this.nombrePointsLigne; i++) {
	    this.abscisses[i] = this.bord.abscissesCoordonneesPoints[ideb + i];
	    this.ordonnees[i] = this.bord.ordonneesCoordonneesPoints[ideb + i];
	  }
	  var indicePremierPoint = this.bord.infoLignes[this.bord.indicePremiereLigne].indicePremierPoint;
	  var indiceDernierPoint = this.bord.infoLignes[this.bord.indicePremiereLigne].indicePremierPoint + this.bord.infoLignes[this.bord.indicePremiereLigne].nombrePoints - 1;
	  this.x1 = this.bord.abscissesCoordonneesPoints[indicePremierPoint];
	  this.y1 = this.bord.ordonneesCoordonneesPoints[indicePremierPoint];
	  x4 = this.bord.abscissesCoordonneesPoints[indiceDernierPoint];
	  y4 = this.bord.ordonneesCoordonneesPoints[indiceDernierPoint];
	  this.pointDebutLieu.placeEn(this.x1, this.y1);
	  this.pointFinLieu.placeEn(x4, y4);
	  this.x2 = this.point1.x;
	  this.y2 = this.point1.y;
	  this.x3 = this.point2.x;
	  this.y3 = this.point2.y;
	  // Dans la mesure du posible, on s'arrange pour que le lieu soit
	  // convexe
	  if (kernel.distancePointPoint(this.x1, this.y1, this.x3, this.y3) < kernel.distancePointPoint(this.x1, this.y1, this.x2, this.y2) && kernel.distancePointPoint(x4, y4, this.x2, this.y2) < kernel.distancePointPoint(x4, y4, this.x3, this.y3)) {
	    xaux = this.x3;
	    yaux = this.y3;
	    this.x3 = this.x2;
	    this.y3 = this.y2;
	    this.x2 = xaux;
	    this.y2 = yaux;
	    this.segmentDebut.point2 = this.point2;
	    this.segmentFin.point1 = this.point1;
	  }
	  this.abscisses[this.nombrePointsLigne] = Math.round(this.x3);
	  this.ordonnees[this.nombrePointsLigne] = Math.round(this.y3);
	  this.abscisses[this.nombrePointsLigne + 1] = Math.round(this.x2);
	  this.ordonnees[this.nombrePointsLigne + 1] = Math.round(this.y2);
	  this.segmentDebut.positionne(infoRandom, dimfen);
	  this.segmentDroite.positionne(infoRandom, dimfen);
	  this.segmentFin.positionne(infoRandom, dimfen);
	  this.existe = this.segmentDebut.existe && this.segmentDroite.existe && this.segmentFin.existe;
	};
	/**
	 * Fonction renvoyant une chaîne de caractères utilisée dans le svg élément
	 * représentant la surface.
	 * @returns {String}
	 */
	CSurfaceLieuDeuxPoints.prototype.creePoints = function () {
	  var j,
	      points = "";
	  for (j = 0; j < this.nombrePointsLigne + 2; j++) {
	    points = points + this.abscisses[j] + ",";
	    points = points + this.ordonnees[j] + " ";
	  }
	  return points;
	};
	CSurfaceLieuDeuxPoints.prototype.read = function (inps, list) {
	  CSurface.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.point1 = list.get(ind1, "CPt");
	  this.point2 = list.get(ind2, "CPt");
	  this.segmentDebut.point1 = this.pointDebutLieu;
	  this.segmentDebut.point2 = this.point1;
	  this.segmentFin.point1 = this.point2;
	  this.segmentFin.point2 = this.pointFinLieu;
	  this.segmentDroite.point1 = this.point1;
	  this.segmentDroite.point2 = this.point2;
	  if (list.className !== "CPrototype") {
	    this.abscisses = new Array(this.bord.infoLieu.nombreDePoints + 2);
	    this.ordonnees = new Array(this.bord.infoLieu.nombreDePoints + 2);
	  }
	};
	CSurfaceLieuDeuxPoints.prototype.write = function (oups, list) {
	  CSurface.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.point1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.point2);
	  oups.writeInt(ind2);
	};

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Point = __webpack_require__(15);
	var kernel = __webpack_require__(8);
	var CSurface = __webpack_require__(114);
	var CSegment = __webpack_require__(134);
	var CPointBase = __webpack_require__(85);
	module.exports = CSurfaceLieuDroite;
	
	/**
	 * Classe repésentant une surface délimitée par un lieu de points (non fermé)
	 * et une droite. Les extrémités du lieu sotn projetés orthogonalement sur l'axe
	 * des abscisses pour délimiter le bord.
	 * @constructor
	 * @extends CSurface
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 * @param {CLieuDeBase} bord : Le lieu de points bord de la surface.
	 * @param {CDroite} droiteAssociee : La droite sur laquelle on projette les extrémités du lieu.
	 * @returns {CSurfaceLieuDroite}
	 */
	function CSurfaceLieuDroite(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord, droiteAssociee) {
	  if (arguments.length === 1) CSurface.call(this, listeProprietaire);else {
	    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
	    this.droiteAssociee = droiteAssociee;
	    this.abscisses = new Array(bord.infoLieu.nombreDePoints + 4);
	    this.ordonnees = new Array(bord.infoLieu.nombreDePoints + 4);
	  }
	  this.pointDebut = new CPointBase();
	  this.pointProjeteDebut = new CPointBase();
	  this.pointFin = new CPointBase();
	  this.pointProjeteFin = new CPointBase();
	  this.segmentDebut = new CSegment(this.pointDebut, this.pointProjeteDebut);
	  this.segmentFin = new CSegment(this.pointFin, this.pointProjeteFin);
	  this.segmentDroite = new CSegment(this.pointProjeteDebut, this.pointProjeteFin);
	  this.point2 = new Point();
	  this.point3 = new Point();
	  // On crée les tableaux devant recevoir les coordonnées. Le + 3 est du aux deux points projetés
	  // sur la droite
	}
	CSurfaceLieuDroite.prototype = new CSurface();
	CSurfaceLieuDroite.prototype.constructor = CSurfaceLieuDroite;
	CSurfaceLieuDroite.prototype.superClass = "CSurface";
	CSurfaceLieuDroite.prototype.className = "CSurfaceLieuDroite";
	
	CSurfaceLieuDroite.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.bord);
	  var ind2 = listeSource.indexOf(this.droiteAssociee);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CSurfaceLieuDroite(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CLieuDeBase"), listeCible.get(ind2, "CDroite"));
	};
	CSurfaceLieuDroite.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.bord);
	  var ind2 = listeSource.indexOf(this.droiteAssociee);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CSurfaceLieuDroite(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CLieuDeBase"), listeCible.get(ind2, "CDroite"));
	};
	CSurfaceLieuDroite.prototype.setClone = function (ptel) {
	  CSurface.prototype.setClone.call(this, ptel);
	  if (ptel.existe) {
	    this.nbPointsLigne = ptel.nbPointsLigne;
	    var nbPointsADecaler = this.nbPointsLigne + 3;
	    for (var i = 0; i < nbPointsADecaler; i++) {
	      this.abscisses[i] = ptel.abscisses[i];
	      this.ordonnees[i] = ptel.ordonnees[i];
	    }
	  }
	};
	CSurfaceLieuDroite.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.bord);
	  liste.add(this.droiteAssociee);
	};
	CSurfaceLieuDroite.prototype.confonduAvec = function (p) {
	  var res = CSurface.prototype.confonduAvec.call(this, p);
	  if (!res) return false;
	  return this.droiteAssociee === p.droiteAssociee;
	};
	CSurfaceLieuDroite.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CSurface.prototype.dependDe.call(this, p) || this.droiteAssociee.dependDe(p));
	};
	CSurfaceLieuDroite.prototype.dependDePourBoucle = function (p) {
	  return CSurface.prototype.dependDePourBoucle.call(this, p) || this.droiteAssociee.dependDePourBoucle(p);
	};
	CSurfaceLieuDroite.prototype.dependDePourCapture = function (p) {
	  return CSurface.prototype.dependDePourCapture.call(this, p) || this.droiteAssociee.dependDePourCapture(p);
	};
	CSurfaceLieuDroite.prototype.positionne = function (infoRandom, dimfen) {
	  var x1, y1, x4, y4, i;
	  this.existe = this.bord.existe && this.droiteAssociee.existe;
	  if (!this.existe) return;
	  // Le bord doit être formé d'une seule ligne
	  if (!this.bord.contientUneSeuleLigne()) {
	    this.existe = false;
	    return;
	  }
	  // On recopie les coordonnées des points du bord
	  this.nbPointsLigne = this.bord.infoLignes[this.bord.indicePremiereLigne].nombrePoints;
	  var ideb = this.bord.infoLignes[this.bord.indicePremiereLigne].indicePremierPoint;
	  for (i = 0; i < this.nbPointsLigne; i++) {
	    this.abscisses[i] = this.bord.abscissesCoordonneesPoints[ideb + i];
	    this.ordonnees[i] = this.bord.ordonneesCoordonneesPoints[ideb + i];
	  }
	  var indicePremierPoint = this.bord.infoLignes[this.bord.indicePremiereLigne].indicePremierPoint;
	  var indiceDernierPoint = this.bord.infoLignes[this.bord.indicePremiereLigne].indicePremierPoint + this.nbPointsLigne - 1;
	  x1 = this.bord.abscissesCoordonneesPoints[indicePremierPoint];
	  y1 = this.bord.ordonneesCoordonneesPoints[indicePremierPoint];
	  kernel.projetteOrtho(x1, y1, this.droiteAssociee.point_x, this.droiteAssociee.point_y, this.droiteAssociee.vect, this.point2);
	  x4 = this.bord.abscissesCoordonneesPoints[indiceDernierPoint];
	  y4 = this.bord.ordonneesCoordonneesPoints[indiceDernierPoint];
	  kernel.projetteOrtho(x4, y4, this.droiteAssociee.point_x, this.droiteAssociee.point_y, this.droiteAssociee.vect, this.point3);
	  this.pointDebut.placeEn(x1, y1);
	  this.pointProjeteDebut.placeEn(this.point2.x, this.point2.y);
	  this.pointFin.placeEn(x4, y4);
	  this.pointProjeteFin.placeEn(this.point3.x, this.point3.y);
	  this.abscisses[this.nbPointsLigne] = Math.round(this.point3.x);
	  this.ordonnees[this.nbPointsLigne] = Math.round(this.point3.y);
	  this.abscisses[this.nbPointsLigne + 1] = Math.round(this.point2.x);
	  this.ordonnees[this.nbPointsLigne + 1] = Math.round(this.point2.y);
	  this.abscisses[this.nbPointsLigne + 2] = Math.round(x1);
	  this.ordonnees[this.nbPointsLigne + 2] = Math.round(y1);
	  this.segmentDebut.positionne(infoRandom, dimfen);
	  this.segmentDroite.positionne(infoRandom, dimfen);
	  this.segmentFin.positionne(infoRandom, dimfen);
	  this.existe = this.segmentDebut.existe & this.segmentDroite.existe && this.segmentFin.existe;
	};
	/**
	 * Fonction renvoyant une chaîne de caractères utilisée dans le svg élément
	 * représentant la surface.
	 * @returns {String}
	 */
	CSurfaceLieuDroite.prototype.creePoints = function () {
	  var j,
	      points = "";
	  for (j = 0; j < this.nbPointsLigne + 3; j++) {
	    points = points + this.abscisses[j] + ",";
	    points = points + this.ordonnees[j] + " ";
	  }
	  return points;
	};
	CSurfaceLieuDroite.prototype.read = function (inps, list) {
	  CSurface.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.droiteAssociee = list.get(ind1, "CDroite");
	  // On crée les tableaux devant recevoir les coordonnées. Le + 4 est du aux deux points projetés
	  // sur la droite et au cas d'un lieu fermé
	  this.abscisses = new Array(this.bord.infoLieu.nombreDePoints + 4);
	  this.ordonnees = new Array(this.bord.infoLieu.nombreDePoints + 4);
	};
	CSurfaceLieuDroite.prototype.write = function (oups, list) {
	  CSurface.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.droiteAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var StyleRemplissage = __webpack_require__(115);
	var kernel = __webpack_require__(8);
	var CSurface = __webpack_require__(114);
	module.exports = CSurfaceSecteurCirculaire;
	
	/**
	 * Classe représentant un surface remplissant un secteur circulaire.
	 * Elle est délimitée par un arc de cercle.
	 * @constructor
	 * @extends CSurface
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {mtg32.Color} couleur : La couleur.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
	 * @param {CArcDeCercleAncetre} bord : L'arc de cercle qui donne le bord.
	 * @returns {CSurfaceSecteurCirculaire}
	 */
	function CSurfaceSecteurCirculaire(listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord) {
	  if (arguments.length === 1) CSurface.call(this, listeProprietaire);else {
	    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
	    this.arc = bord.getClone(listeProprietaire, listeProprietaire);
	  }
	}
	CSurfaceSecteurCirculaire.prototype = new CSurface();
	CSurfaceSecteurCirculaire.prototype.constructor = CSurfaceSecteurCirculaire;
	CSurfaceSecteurCirculaire.prototype.superClass = "CSurface";
	CSurfaceSecteurCirculaire.prototype.className = "CSurfaceSecteurCirculaire";
	
	CSurfaceSecteurCirculaire.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.bord);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CSurfaceSecteurCirculaire(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CArcDeCercleAncetre"));
	};
	CSurfaceSecteurCirculaire.prototype.ajouteAntecedents = function (liste) {
	  liste.add(this.bord);
	};
	CSurfaceSecteurCirculaire.prototype.positionne = function (infoRandom, dimfen) {
	  CSurface.prototype.positionne.call(this, infoRandom, dimfen);
	  this.arc.setClone(this.bord);
	  this.natureArcBord = this.bord.natureArc();
	};
	CSurfaceSecteurCirculaire.prototype.setClone = function (ptel) {
	  CSurface.prototype.setClone.call(this, ptel);
	  this.arc.setClone(ptel.arc);
	  this.natureArcBord = ptel.natureArcBord;
	};
	CSurfaceSecteurCirculaire.prototype.createg = function (svg, couleurFond, transparence) {
	  var color, path, style, styleRemplissageEffectif, opacity;
	  // color = this.couleur.rgb() Modifié version 4.9.9.4
	  color = this.color;
	  if (this.masque) styleRemplissageEffectif = StyleRemplissage.QuadrillageCroise;else styleRemplissageEffectif = this.styleRemplissage;
	  path = kernel.cens("path", {
	    d: this.arc.path() + "L" + this.arc.centre_x + "," + this.arc.centre_y + "Z"
	  });
	  switch (styleRemplissageEffectif) {
	    case StyleRemplissage.quadrillagePleinTransp:
	    case StyleRemplissage.quadrillagePlein:
	      opacity = styleRemplissageEffectif === StyleRemplissage.quadrillagePleinTransp ? transparence : 1;
	      style = "stroke:none;";
	      style += "fill-opacity:" + opacity + ";";
	      style += "fill:" + color + ";";
	      path.setAttribute("style", style);
	      break;
	    default:
	      style = "stroke:none;" + "fill:url(#" + this.index + "mtg32pattern);";
	      this.createPattern();
	      path.setAttribute("style", style);
	  }
	  if (this.listeProprietaire !== null) path.setAttribute("id", this.id);
	  path.setAttribute("pointer-events", "none");
	  return path;
	};
	CSurfaceSecteurCirculaire.prototype.read = function (inps, list) {
	  CSurface.prototype.read.call(this, inps, list);
	  this.arc = this.bord.getClone(this.listeProprietaire, this.listeProprietaire);
	};

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var CTransformation = __webpack_require__(100);
	module.exports = CSymetrieAxiale;
	
	/**
	 * Classe représentant une symétrie axiale (transformation)
	 * @constructor
	 * @extends CTransformation
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CDroiteAncetre} axe : L'axe de symétrie (peutêtre aussi un segment ou une demi-droite)
	 * @returns {CSymetrieAxiale}
	 */
	function CSymetrieAxiale(listeProprietaire, impProto, estElementFinal, axe) {
	  if (arguments.length === 1) CTransformation.call(this, listeProprietaire);else {
	    CTransformation.call(this, listeProprietaire, impProto, estElementFinal);
	    this.axe = axe;
	  }
	}
	CSymetrieAxiale.prototype = new CTransformation();
	CSymetrieAxiale.prototype.constructor = CSymetrieAxiale;
	CSymetrieAxiale.prototype.superClass = "CTransformation";
	CSymetrieAxiale.prototype.className = "CSymetrieAxiale";
	/**
	 * Indique la nature de la transformation
	 * @returns {CTransformation.symetrieAxiale}
	 */
	CSymetrieAxiale.prototype.natureTransformation = function () {
	  return CTransformation.symetrieAxiale;
	};
	CSymetrieAxiale.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.axe);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CSymetrieAxiale(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CDroiteAncetre"));
	};
	CSymetrieAxiale.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CTransformation.prototype.dependDe.call(this, p) || this.axe.dependDe(p));
	};
	CSymetrieAxiale.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.axe.dependDePourBoucle(p);
	};
	CSymetrieAxiale.prototype.positionne = function () {
	  this.existe = this.axe.existe;
	};
	CSymetrieAxiale.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.axe === p.axe;else return false;
	};
	/**
	 * Renvoie dans pointr.x et pointr.y les coordonnées du point image du point de coordonnées (x,y).
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Object} pointr
	 * @returns {undefined}
	 */
	CSymetrieAxiale.prototype.transformePoint = function (x, y, pointr) {
	
	  var u = new Vect(this.axe.point_x, this.axe.point_y, x, y);
	  var uimage = new Vect();
	  this.transformeVecteur(u, uimage);
	  pointr.x = this.axe.point_x + uimage.x;
	  pointr.y = this.axe.point_y + uimage.y;
	};
	CSymetrieAxiale.prototype.transformeAngle = function (ang, pointeur) {
	  pointeur.setValue(-ang);
	};
	/**
	 * Renvoie dans le vecteur ur les coordonnées du vecteur image du vecteur u.
	 * @param {Vect} u
	 * @param {Vect} ur
	 * @returns {undefined}
	 */
	CSymetrieAxiale.prototype.transformeVecteur = function (u, ur) {
	  var norm2, ax, ay, x, y, k1, k2;
	  x = u.x;
	  y = u.y;
	  ax = this.axe.vect.x;
	  ay = this.axe.vect.y;
	  norm2 = ax * ax + ay * ay;
	  k1 = ax * ax - ay * ay;
	  k2 = 2 * ax * ay;
	  ur.x = (k1 * x + k2 * y) / norm2;
	  ur.y = (k2 * x - k1 * y) / norm2;
	};
	CSymetrieAxiale.prototype.read = function (inps, list) {
	  CTransformation.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.axe = list.get(ind1, "CDroiteAncetre");
	};
	CSymetrieAxiale.prototype.write = function (oups, list) {
	  CTransformation.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.axe);
	  oups.writeInt(ind1);
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CTransformation = __webpack_require__(100);
	module.exports = CSymetrieCentrale;
	
	/**
	 * Classe représentant une symétrie centrale (transformation)
	 * @constructor
	 * @extends CTransformation
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} centre : L centre de la symétrie.
	 * @returns {CSymetrieCentrale}
	 */
	function CSymetrieCentrale(listeProprietaire, impProto, estElementFinal, centre) {
	  if (arguments.length === 1) CTransformation.call(this, listeProprietaire);else {
	    CTransformation.call(this, listeProprietaire, impProto, estElementFinal);
	    this.centre = centre;
	  }
	}
	CSymetrieCentrale.prototype = new CTransformation();
	CSymetrieCentrale.prototype.constructor = CSymetrieCentrale;
	CSymetrieCentrale.prototype.superClass = "CTransformation";
	CSymetrieCentrale.prototype.className = "CSymetrieCentrale";
	
	/**
	 * Indique la nature de la transformation
	 * @returns {CTransformation.symetrieCentrale}
	 */
	CSymetrieCentrale.prototype.natureTransformation = function () {
	  return CTransformation.symetrieCentrale;
	};
	CSymetrieCentrale.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.centre);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CSymetrieCentrale(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt"));
	};
	CSymetrieCentrale.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CTransformation.prototype.dependDe.call(this, p) || this.centre.dependDe(p));
	};
	CSymetrieCentrale.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.centre.dependDePourBoucle(p);
	};
	CSymetrieCentrale.prototype.positionne = function () {
	  this.existe = this.centre.existe;
	};
	CSymetrieCentrale.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.centre === p.centre;
	  } else return false;
	};
	/**
	 * Renvoie dans pointr.x et pointr.y les coordonnées du point image du point de coordonnées (x,y).
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Object} pointr
	 * @returns {undefined}
	 */
	CSymetrieCentrale.prototype.transformePoint = function (x, y, pointr) {
	  pointr.x = 2 * this.centre.x - x;
	  pointr.y = 2 * this.centre.y - y;
	};
	/**
	 * Renvoie dans le vecteur ur les coordonnées du vecteur image du vecteur u.
	 * @param {mtg32.vect} u
	 * @param {mtg32.vect} ur
	 * @returns {undefined}
	 */
	CSymetrieCentrale.prototype.transformeVecteur = function (u, ur) {
	  ur.x = -u.x;
	  ur.y = -u.y;
	};
	CSymetrieCentrale.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.centre === ancienPoint) this.centre = nouveauPoint;
	};
	CSymetrieCentrale.prototype.read = function (inps, list) {
	  CTransformation.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.centre = list.get(ind1, "CPt");
	};
	CSymetrieCentrale.prototype.write = function (oups, list) {
	  CTransformation.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.centre);
	  oups.writeInt(ind1);
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CTestDependanceVariable;
	
	/**
	 * Classe représentant un test de dépendance d'une fonction par rapport à une variable.
	 * Renvoie 1 si la formule de la fonction dépend de la variable et 0 sinon.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CCalcul} fonctionAssociee : Fonction de une, deux ou trois variables d'une
	 * variable réelle ou complexe.
	 * @param {Integer} indiceVariable : Indide de la variable (0 pour une fonction de une variable).
	 * @returns {CTestDependanceVariable}
	 */
	function CTestDependanceVariable(listeProprietaire, impProto, estElementFinal, nomCalcul, fonctionAssociee, indiceVariable) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);else {
	      CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	      this.fonctionAssociee = fonctionAssociee;
	      this.indiceVariable = indiceVariable;
	    }
	  }
	  this.existe = true;
	}
	CTestDependanceVariable.prototype = new CCalculAncetre();
	CTestDependanceVariable.prototype.constructor = CTestDependanceVariable;
	CTestDependanceVariable.prototype.superClass = "CCalculAncetre";
	CTestDependanceVariable.prototype.className = "CTestDependanceVariable";
	
	CTestDependanceVariable.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.fonctionAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CTestDependanceVariable(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CCalcul"), this.indiceVariable);
	};
	CTestDependanceVariable.prototype.getNatureCalcul = function () {
	  return NatCal.NTestDependanceVariable;
	};
	CTestDependanceVariable.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.fonctionAssociee.dependDe(p));
	};
	CTestDependanceVariable.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.fonctionAssociee.dependDePourBoucle(p);
	};
	CTestDependanceVariable.prototype.rendValeur = function () {
	  return this.resultat;
	};
	CTestDependanceVariable.prototype.positionne = function () {
	  // Existe toujours égal à true pour cet objet
	  this.resultat = this.fonctionAssociee.calcul.dependDeVariable(this.indiceVariable) ? 1 : 0;
	};
	CTestDependanceVariable.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.fonctionAssociee === p.fonctionAssociee && this.indiceVariable === p.indiceVariable;
	  } else return false;
	};
	CTestDependanceVariable.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.fonctionAssociee = list.get(ind1, "CCalcul");
	  this.indiceVariable = inps.readInt();
	};
	CTestDependanceVariable.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.fonctionAssociee);
	  oups.writeInt(ind1);
	  oups.writeInt(this.indiceVariable);
	};

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Ope = __webpack_require__(32);
	var CCalculAncetre = __webpack_require__(35);
	var CCbGlob = __webpack_require__(31);
	module.exports = CTestEqNatOp;
	
	/**
	 * Test d'équivalence de nature d'opérateur.
	 * Renvoie true sseulement si les deux calxuls ont le même opérateur principal
	 * (par exemple un test d'égalité).
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CCalcul} calcul1 : Le premier calcul testé (peut être aussi une fonction).
	 * @param {CCalcul} calcul2 : Le deuxième calcul testé (peut être aussi une fonction).
	 * @returns {CTestEqNatOp}
	 */
	function CTestEqNatOp(listeProprietaire, impProto, estElementFinal, nomCalcul, calcul1, calcul2) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);else {
	      CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	      this.calcul1 = calcul1;
	      this.calcul2 = calcul2;
	    }
	  }
	  this.existe = true;
	  this.dejaPositionne = false;
	}
	CTestEqNatOp.prototype = new CCalculAncetre();
	CTestEqNatOp.prototype.constructor = CTestEqNatOp;
	CTestEqNatOp.prototype.superClass = "CCalculAncetre";
	CTestEqNatOp.prototype.className = "CTestEqNatOp";
	
	CTestEqNatOp.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var ind2 = listeSource.indexOf(this.calcul1);
	  var ind3 = listeSource.indexOf(this.calcul2);
	  return new CTestEqNatOp(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind2, "CCalcul"), listeCible.get(ind3, "CCalcul"));
	};
	CTestEqNatOp.prototype.getNatureCalcul = function () {
	  return NatCal.NTestNatureOperateur;
	};
	CTestEqNatOp.prototype.rendValeur = function () {
	  return this.resultat;
	};
	CTestEqNatOp.prototype.positionne = function (infoRandom, dimfen) {
	  if (!this.dejaPositionne) {
	    this.metAJour();
	    this.dejaPositionne = true;
	  }
	};
	CTestEqNatOp.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.calcul1.dependDe(p) || this.calcul2.dependDe(p));
	};
	CTestEqNatOp.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.calcul1.dependDePourBoucle(p) || this.calcul2.dependDePourBoucle(p);
	};
	CTestEqNatOp.prototype.metAJour = function () {
	  this.dejaPositionne = true;
	  if (this.verifieEquivalenceNature()) {
	    this.resultat = 1;
	  } else this.resultat = 0;
	};
	CTestEqNatOp.prototype.verifieEquivalenceNature = function () {
	  if (this.calcul1.calcul.className === "CMoinsUnaire" || this.calcul2.calcul.className === "CMoinsUnaire") {
	    var cb1 = this.calcul1.calcul.className === "CMoinsUnaire" ? this.calcul1.calcul.operande : this.calcul1.calcul;
	    var cb2 = this.calcul2.calcul.className === "CMoinsUnaire" ? this.calcul2.calcul.operande : this.calcul2.calcul;
	    if (cb1.nature() === CCbGlob.natOperation && cb2.nature() === CCbGlob.natOperation) {
	      if (cb1.Ope === Ope.Mult && cb2.Ope === Ope.Mult || cb1.Ope === Ope.Divi && cb2.Ope === Ope.Divi) return true;
	    }
	  }
	  if (this.calcul1.calcul.className !== this.calcul2.calcul.className) return false;
	  // Les deux calculs sont de même classe
	  if (this.calcul1.calcul.nature() === CCbGlob.natOperation) {
	    var op1 = this.calcul1.calcul;
	    var op2 = this.calcul2.calcul;
	    if (op1.Ope === Ope.Egalite) return op2.Ope === Ope.Egalite;
	    if (op1.Ope === Ope.Sup || op1.Ope === Ope.Inf) return op2.Ope === Ope.Sup || op2.Ope === Ope.Inf;
	    if (op1.Ope === Ope.SupOuEgal || op1.Ope === Ope.InfOuEgal) return op2.Ope === Ope.SupOuEgal || op2.Ope === Ope.InfOuEgal;
	    return op1.Ope === op2.Ope;
	  } else return true;
	};
	CTestEqNatOp.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.calcul1 = list.get(ind1, "CCalcul");
	  var ind2 = inps.readInt();
	  this.calcul2 = list.get(ind2, "CCalcul");
	};
	CTestEqNatOp.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.calcul1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.calcul2);
	  oups.writeInt(ind2);
	};

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalculAncetre = __webpack_require__(35);
	var CValeur = __webpack_require__(80);
	module.exports = CTestEquivalence;
	
	/**
	 * Calcul testant si deux formules de calcul ou de fonctions sont équivalentes
	 * au sens en tenant compte de commutativité de la multiplication et de l'addition.
	 * Deux calculs comme a/b ou 1/b*a sont aussi considérés comme équivalents.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CCalcul} calcul1 : Le premier calcul (ou fonction) testé.
	 * @param {CCalcul} calcul2 : Le deuxième calcul (ou fonction) testé.
	 * @param {Boolean} remplacementValeurs1 : Si true, les résultats de valeurs utilisés dans le
	 * calcul calcul1 sont remplacés avant de tester l'équivalence des formules.
	 * @param {Boolean} remplacementValeurs2 : Si true, les résultats de valeurs utilisés dans le
	 * calcul calcul2 sont remplacés avant de tester l'équivalence des formules.
	 * @param {CValeur} test : Si différent de 1, le calcul est
	 * @param {booelan} equivalenceDecimalFracIrr : true si on accepte aussi bien les nombres décimaux
	 * que leur fraction irréductible équivalente (au plus 9 décimales)
	 * considéré comme non existant. Permet d'éviter la comparaison quand une condition n'est pas vérifiée.
	 * @returns {CTestEquivalence}
	 */
	function CTestEquivalence(listeProprietaire, impProto, estElementFinal, nomCalcul, calcul1, calcul2, remplacementValeurs1, remplacementValeurs2, test, equivalenceDecimalFracIrr) {
	  if (arguments.length === 0) return; // Ajout version WebPack
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);else {
	      CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	      this.calcul1 = calcul1;
	      this.calcul2 = calcul2;
	      this.remplacementValeurs1 = remplacementValeurs1;
	      this.remplacementValeurs2 = remplacementValeurs2;
	      this.test = test;
	      this.equivalenceDecimalFracIrr = equivalenceDecimalFracIrr;
	    }
	  }
	  this.existe = true;
	  this.dejaPositionne = false;
	}
	CTestEquivalence.prototype = new CCalculAncetre();
	CTestEquivalence.prototype.constructor = CTestEquivalence;
	CTestEquivalence.prototype.superClass = "CCalculAncetre";
	CTestEquivalence.prototype.className = "CTestEquivalence";
	
	CTestEquivalence.prototype.numeroVersion = function () {
	  return 3;
	};
	
	CTestEquivalence.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var ind2 = listeSource.indexOf(this.calcul1);
	  var ind3 = listeSource.indexOf(this.calcul2);
	  var testClone = this.test.getClone(listeSource, listeCible);
	  return new CTestEquivalence(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind2, "CCalcul"), listeCible.get(ind3, "CCalcul"), this.remplacementValeurs1, this.remplacementValeurs2, testClone, this.equivalenceDecimalFracIrr);
	};
	CTestEquivalence.prototype.getNatureCalcul = function () {
	  return NatCal.NTestEquivalence;
	};
	CTestEquivalence.prototype.rendValeur = function () {
	  return this.resultat;
	};
	CTestEquivalence.prototype.positionne = function (infoRandom, dimfen) {
	  // Existe toujours égal à true pour cet objet
	  this.test.positionne(infoRandom, dimfen);
	  if (!this.test.existe) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.test.rendValeur() !== 1) {
	    this.resultat = 0;
	    return;
	  }
	  if (!this.dejaPositionne) {
	    if (this.remplacementValeurs1) this.calculeq1 = this.calcul1.calcul.calculAvecValeursRemplacees().calculNormalise(true, true, this.equivalenceDecimalFracIrr);else this.calculeq1 = this.calcul1.calcul.calculNormalise(this.remplacementValeurs1, true, this.equivalenceDecimalFracIrr);
	    if (this.remplacementValeurs2) this.calculeq2 = this.calcul2.calcul.calculAvecValeursRemplacees().calculNormalise(true, true, this.equivalenceDecimalFracIrr);else this.calculeq2 = this.calcul2.calcul.calculNormalise(this.remplacementValeurs2, true, this.equivalenceDecimalFracIrr);
	    this.dejaPositionne = true; // Ajout version 4.7.2
	  }
	  if (!this.calcul1.existe || !this.calcul2.existe) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.calculeq1.estEquivalentA(this.calculeq2)) this.resultat = 1;else this.resultat = 0;
	};
	CTestEquivalence.prototype.positionneFull = function (infoRandom, dimfen) {
	  this.test.positionne(infoRandom, dimfen);
	  if (!this.test.existe) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.test.rendValeur() !== 1) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.remplacementValeurs1) this.calculeq1 = this.calcul1.calcul.calculAvecValeursRemplacees().calculNormalise(true, true, this.equivalenceDecimalFracIrr);else this.calculeq1 = this.calcul1.calcul.calculNormalise(this.remplacementValeurs1, true, this.equivalenceDecimalFracIrr);
	  if (this.remplacementValeurs2) this.calculeq2 = this.calcul2.calcul.calculAvecValeursRemplacees().calculNormalise(true, true, this.equivalenceDecimalFracIrr);else this.calculeq2 = this.calcul2.calcul.calculNormalise(this.remplacementValeurs2, true, this.equivalenceDecimalFracIrr);
	  this.dejaPositionne = true;
	  if (!this.calcul1.existe || !this.calcul2.existe) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.calculeq1.estEquivalentA(this.calculeq2)) this.resultat = 1;else this.resultat = 0;
	};
	CTestEquivalence.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.calcul1.dependDe(p) || this.calcul2.dependDe(p) || this.test.dependDe(p));
	};
	CTestEquivalence.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.calcul1.dependDePourBoucle(p) || this.calcul2.dependDePourBoucle(p) || this.test.dependDePourBoucle(p);
	};
	CTestEquivalence.prototype.metAJour = function () {
	  this.dejaPositionne = false;
	};
	CTestEquivalence.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.calcul1 = list.get(ind1, "CCalcul");
	  var ind2 = inps.readInt();
	  this.calcul2 = list.get(ind2, "CCalcul");
	  this.remplacementValeurs1 = inps.readBoolean();
	  this.remplacementValeurs2 = inps.readBoolean();
	  this.test = new CValeur(this.listeProprietaire);
	  if (this.nVersion < 2) this.test.donneValeur(1);else this.test.read(inps, list);
	  if (this.nVersion < 3) this.equivalenceDecimalFracIrr = false;else this.equivalenceDecimalFracIrr = inps.readBoolean();
	};
	CTestEquivalence.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.calcul1);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.calcul2);
	  oups.writeInt(ind2);
	  oups.writeBoolean(this.remplacementValeurs1);
	  oups.writeBoolean(this.remplacementValeurs2);
	  this.test.write(oups, list);
	  oups.writeBoolean(this.equivalenceDecimalFracIrr);
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalculAncetre = __webpack_require__(35);
	module.exports = CTestExistence;
	
	/**
	 * Objet de type calcul servant à savoir si un objet numérique déjà créé existe ou non.
	 * Renvoie 1 si l'objet existe et 0 sinon.
	 * @constructor
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CValDyn} valeurAssociee : La valeur dont on teste l'existence.
	 * @returns {CTestExistence}
	 */
	function CTestExistence(listeProprietaire, impProto, estElementFinal, nomCalcul, valeurAssociee) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);else {
	      CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
	      this.valeurAssociee = valeurAssociee;
	    }
	  }
	}
	CTestExistence.prototype = new CCalculAncetre();
	CTestExistence.prototype.constructor = CTestExistence;
	CTestExistence.prototype.superClass = "CCalculAncetre";
	CTestExistence.prototype.className = "CTestExistence";
	
	CTestExistence.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.valeurAssociee);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CTestExistence(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CValDyn"));
	};
	CTestExistence.prototype.getNatureCalcul = function () {
	  return NatCal.NTestExistence;
	};
	CTestExistence.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.valeurAssociee.dependDe(p));
	};
	CTestExistence.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.valeurAssociee.dependDePourBoucle(p);
	};
	CTestExistence.prototype.rendValeur = function () {
	  if (this.valeurAssociee.existe) return 1;else return 0;
	};
	CTestExistence.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.valeurAssociee === p.valeurAssociee;else return false;
	};
	CTestExistence.prototype.read = function (inps, list) {
	  CCalculAncetre.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.valeurAssociee = list.get(ind1, "CValDyn");
	};
	CTestExistence.prototype.write = function (oups, list) {
	  CCalculAncetre.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.valeurAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CCalculAncetre = __webpack_require__(35);
	var CTestEquivalence = __webpack_require__(258);
	module.exports = CTestFact;
	
	/**
	 * Objet de type aalcul destiné à savoir si un calcul est factorisé par un autre calcul.
	 * Renvoie 1 si la réponse est oui et 0 sinon.
	 * @extends CCalculAncetre
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CCalcul} calcul1 : Calcul ou fonction dont on teste s'il est factorisé par calcul2.
	 * @param {CCalcul} calcul2 : Calcul ou fonction ontenant le facteur recherché.
	 * @param {Boolean} remplacementValeurs1 : true si on veut que les résultats de calculs ou valeurs
	 * de calcul1 soient remplacés dans calcul1 avant de tester la factorisation.
	 * @param {Boolean} remplacementValeurs2 : true si on veut que les résultats de calculs ou valeurs
	 * de calcul2 soient remplacés dans calcul1 avant de tester la factorisation.
	 * @param {CValeur} test : Si différent de 1, le calcul est
	 * @param {booelan} equivalenceDecimalFracIrr : true si on accepte aussi bien les nombres décimaux
	 * que leur fraction irréductible équivalente (au plus 9 décimales)
	 * considéré comme non existant. Permet d'éviter la comparaison quand une condition n'est pas vérifiée.
	 * @returns {CTestFact}
	 */
	function CTestFact(listeProprietaire, impProto, estElementFinal, nomCalcul, calcul1, calcul2, remplacementValeurs1, remplacementValeurs2, test, equivalenceDecimalFracIrr) {
	  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);else {
	    if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);else {
	      CTestEquivalence.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, calcul1, calcul2, remplacementValeurs1, remplacementValeurs2, test, equivalenceDecimalFracIrr);
	    }
	  }
	  this.existe = true;
	  this.dejaPositionne = false;
	}
	CTestFact.prototype = new CTestEquivalence();
	CTestFact.prototype.constructor = CTestFact;
	CTestFact.prototype.superClass = "CTestEquivalence";
	CTestFact.prototype.className = "CTestFact";
	
	CTestFact.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var ind2 = listeSource.indexOf(this.calcul1);
	  var ind3 = listeSource.indexOf(this.calcul2);
	  var testClone = this.test.getClone(listeSource, listeCible);
	  return new CTestFact(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind2, "CCalcul"), listeCible.get(ind3, "CCalcul"), this.remplacementValeurs1, this.remplacementValeurs2, testClone);
	};
	CTestFact.prototype.getNatureCalcul = function () {
	  return NatCal.NTestFact;
	};
	CTestFact.prototype.positionne = function (infoRandom, dimfen) {
	  // Existe toujours égal à true pour cet objet
	  this.test.positionne(infoRandom, dimfen);
	  if (!this.test.existe) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.test.rendValeur() !== 1) {
	    this.resultat = 0;
	    return;
	  }
	  if (!this.dejaPositionne) {
	    if (this.remplacementValeurs1) this.calculeq1 = this.calcul1.calcul.calculAvecValeursRemplacees().calculNormalise(true, true, this.equivalenceDecimalFracIrr);else this.calculeq1 = this.calcul1.calcul.calculNormalise(this.remplacementValeurs1, true, this.equivalenceDecimalFracIrr);
	    if (this.remplacementValeurs2) this.calculeq2 = this.calcul2.calcul.calculAvecValeursRemplacees().calculNormalise(true, true, this.equivalenceDecimalFracIrr);else this.calculeq2 = this.calcul2.calcul.calculNormalise(this.remplacementValeurs2, true, this.equivalenceDecimalFracIrr);
	    this.dejaPositionne = true; // Ajout version 4.7.2
	  }
	  if (!this.calcul1.existe || !this.calcul2.existe) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.calculeq1.estFactorisePar(this.calculeq2)) this.resultat = 1;else this.resultat = 0;
	};
	CTestFact.prototype.positionneFull = function (infoRandom, dimfen) {
	  this.test.positionne(infoRandom, dimfen);
	  if (!this.test.existe) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.test.rendValeur() !== 1) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.remplacementValeurs1) this.calculeq1 = this.calcul1.calcul.calculAvecValeursRemplacees().calculNormalise(true, true, this.equivalenceDecimalFracIrr);else this.calculeq1 = this.calcul1.calcul.calculNormalise(this.remplacementValeurs1, true, this.equivalenceDecimalFracIrr);
	  if (this.remplacementValeurs2) this.calculeq2 = this.calcul2.calcul.calculAvecValeursRemplacees().calculNormalise(true, true, this.equivalenceDecimalFracIrr);else this.calculeq2 = this.calcul2.calcul.calculNormalise(this.remplacementValeurs2, true, this.equivalenceDecimalFracIrr);
	  this.dejaPositionne = true;
	  if (!this.calcul1.existe || !this.calcul2.existe) {
	    this.resultat = 0;
	    return;
	  }
	  if (this.calculeq1.estFactorisePar(this.calculeq2)) this.resultat = 1;else this.resultat = 0;
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var CTransformation = __webpack_require__(100);
	var COb = __webpack_require__(34);
	module.exports = CTransParVect;
	
	/**
	 * Classe représentant une translation définie par le vecteur de la translation.
	 * @constructor
	 * @extends CTransformation
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CVecteur} vecteurTrans : Le vecteur de la translation.
	 * @returns {CTransParVect}
	 */
	function CTransParVect(listeProprietaire, impProto, estElementFinal, vecteurTrans) {
	  if (arguments.length === 1) COb.call(this, listeProprietaire);else {
	    CTransformation.call(this, listeProprietaire, impProto, estElementFinal);
	    this.vecteurTrans = vecteurTrans;
	  }
	}
	CTransParVect.prototype = new CTransformation();
	CTransParVect.prototype.constructor = CTransParVect;
	CTransParVect.prototype.superClass = "CTransformation";
	CTransParVect.prototype.className = "CTransParVect";
	
	CTransParVect.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.vecteurTrans);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CTransParVect(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CVecteur"));
	};
	CTransParVect.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CTransformation.prototype.dependDe.call(this, p) || this.vecteurTrans.dependDe(p));
	};
	CTransParVect.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.vecteurTrans.dependDePourBoucle(p);
	};
	CTransParVect.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.vecteurTrans.existe;
	};
	CTransParVect.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) return this.vecteurTrans === p.vecteurTrans;else return false;
	};
	/**
	 * Renvoie dans pointr.x et pointr.y les coordonnées du point image du point de coordonnées (x,y).
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Object} pointr
	 * @returns {undefined}
	 */
	CTransParVect.prototype.transformePoint = function (x, y, pointr) {
	  pointr.x = x + this.vecteurTrans.x2 - this.vecteurTrans.x1;
	  pointr.y = y + this.vecteurTrans.y2 - this.vecteurTrans.y1;
	};
	/**
	 * Renvoie dans le vecteur ur les coordonnées du vecteur image du vecteur u.
	 * @param {mtg32.vect} u
	 * @param {mtg32.vect} ur
	 * @returns {undefined}
	 */
	CTransParVect.prototype.transformeVecteur = function (u, ur) {
	  u.setCopy(ur);
	};
	CTransParVect.prototype.read = function (inps, list) {
	  CTransformation.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.vecteurTrans = list.get(ind1, "CVecteur");
	};
	CTransParVect.prototype.write = function (oups, list) {
	  CTransformation.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.vecteurTrans);
	  oups.writeInt(ind1);
	};

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var CTransformation = __webpack_require__(100);
	module.exports = CTranslation;
	
	/**
	 * Classe représentant la transformation translation définie par deux points.
	 * @constructor
	 * @extends CTransformation
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CPt} or : Point origine du vecteur.
	 * @param {CPt} ex : Point extrémité du vecteur.
	 * @returns {CTranslation}
	 */
	function CTranslation(listeProprietaire, impProto, estElementFinal, or, ex) {
	  if (arguments.length === 1) CTransformation.call(this, listeProprietaire);else {
	    CTransformation.call(this, listeProprietaire, impProto, estElementFinal);
	    this.or = or;
	    this.ex = ex;
	    this.valeurVecteur = new Vect();
	  }
	}
	CTranslation.prototype = new CTransformation();
	CTranslation.prototype.constructor = CTranslation;
	CTranslation.prototype.superClass = "CTransformation";
	CTranslation.prototype.className = "CTranslation";
	/**
	 * Indique la nature de la transformation
	 * @returns {CTransformation.translation}
	 */
	CTranslation.prototype.natureTransformation = function () {
	  return CTransformation.translation;
	};
	
	CTranslation.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.or);
	  var ind2 = listeSource.indexOf(this.ex);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CTranslation(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, listeCible.get(ind1, "CPt"), listeCible.get(ind2, "CPt"));
	};
	CTranslation.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CTransformation.prototype.dependDe.call(this, p) || this.or.dependDe(p) || this.ex.dependDe(p));
	};
	CTranslation.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.or.dependDePourBoucle(p) || this.ex.dependDePourBoucle(p);
	};
	CTranslation.prototype.positionne = function () {
	  this.existe = this.or.existe && this.ex.existe;
	  if (this.existe) this.valeurVecteur.setVecteur(this.or, this.ex);
	};
	CTranslation.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.or === p.or && this.ex === p.ex;
	  } else return false;
	};
	/**
	 * Renvoie dans pointr.x et pointr.y les coordonnées du point image du point de coordonnées (x,y).
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Object} pointr
	 * @returns {undefined}
	 */
	CTranslation.prototype.transformePoint = function (x, y, pointr) {
	  pointr.x = x + this.valeurVecteur.x;
	  pointr.y = y + this.valeurVecteur.y;
	};
	/**
	 * Renvoie dans le vecteur ur les coordonnées du vecteur image du vecteur u.
	 * @param {Vect} u
	 * @param {Vect} ur
	 * @returns {undefined}
	 */
	CTranslation.prototype.transformeVecteur = function (u, ur) {
	  u.setCopy(ur);
	};
	CTranslation.prototype.remplacePoint = function (ancienPoint, nouveauPoint) {
	  if (this.or === ancienPoint) this.or = nouveauPoint;
	  if (this.ex === ancienPoint) this.ex = nouveauPoint;
	};
	CTranslation.prototype.read = function (inps, list) {
	  CTransformation.prototype.read.call(this, inps, list);
	  this.valeurVecteur = new Vect();
	  var ind1 = inps.readInt();
	  var ind2 = inps.readInt();
	  this.or = list.get(ind1, "CPt");
	  this.ex = list.get(ind2, "CPt");
	};
	CTranslation.prototype.write = function (oups, list) {
	  CTransformation.prototype.write.call(this, oups, list);
	  var ind1 = list.indexOf(this.or);
	  oups.writeInt(ind1);
	  var ind2 = list.indexOf(this.ex);
	  oups.writeInt(ind2);
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var Vect = __webpack_require__(12);
	var CTransformation = __webpack_require__(100);
	var CValeur = __webpack_require__(80);
	module.exports = CTranslationParCoord;
	
	/**
	 * Classe représenntant une translation définie par un repère et les coordonnées du
	 * vecteur de la translation.
	 * @constructor
	 * @extends CTransformation
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {CValeur} x : La première coordonnée du vecteur de la transaltion
	 * @param {CValeur} y : La deuxième coordonnée du vecteur de la transaltion
	 * @param {CRepere} rep : Le repère.
	 * @returns {CTranslationParCoord}
	 */
	function CTranslationParCoord(listeProprietaire, impProto, estElementFinal, x, y, rep) {
	  if (arguments.length === 1) CTransformation.call(this, listeProprietaire);else {
	    CTransformation.call(this, listeProprietaire, impProto, estElementFinal);
	    this.x = x;
	    this.y = y;
	    this.rep = rep;
	    this.valeurVecteur = new Vect();
	  }
	  this.valeurVecteur = new Vect();
	}
	CTranslationParCoord.prototype = new CTransformation();
	CTranslationParCoord.prototype.constructor = CTranslationParCoord;
	CTranslationParCoord.prototype.superClass = "CTransformation";
	CTranslationParCoord.prototype.className = "CTranslationParCoord";
	
	/**
	 * Indique la nature de la transformation
	 * @returns {CTransformation.translationParCoord}
	 */
	CTranslationParCoord.prototype.natureTransformation = function () {
	  return CTransformation.translationParCoord;
	};
	CTranslationParCoord.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.impProto);
	  var xClone = this.x.getClone(listeSource, listeCible);
	  var yClone = this.y.getClone(listeSource, listeCible);
	  return new CTranslationParCoord(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, xClone, yClone, listeCible.get(ind1, "CRepere"));
	};
	CTranslationParCoord.prototype.initialisePourDependance = function () {
	  CTransformation.prototype.initialisePourDependance.call(this);
	  this.x.initialisePourDependance();
	  this.y.initialisePourDependance();
	};
	CTranslationParCoord.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CTransformation.prototype.dependDe.call(this, p) || this.rep.dependDe(p) || this.x.dependDe(p) || this.y.dependDe(p));
	};
	CTranslationParCoord.prototype.dependDePourBoucle = function (p) {
	  return p === this || this.rep.dependDePourBoucle(p) || this.x.dependDePourBoucle(p) || this.y.dependDePourBoucle(p);
	};
	CTranslationParCoord.prototype.positionne = function (infoRandom, dimfen) {
	  this.x.positionne(infoRandom, dimfen);
	  this.y.positionne(infoRandom, dimfen);
	  this.existe = this.rep.existe && this.x.existe && this.y.existe;
	  if (this.existe) {
	    this.valeurVecteur.x = this.x.rendValeur() / this.rep.unitex;
	    this.valeurVecteur.y = this.y.rendValeur() / this.rep.unitey;
	  }
	};
	CTranslationParCoord.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.rep === p.rep && this.x.confonduAvec(p.x) && this.y.confonduAvec(p.y);
	  } else return false;
	};
	/**
	 * Renvoie dans pointr.x et pointr.y les coordonnées du point image du point de coordonnées (x,y).
	 * @param {Float} x
	 * @param {Float} y
	 * @param {Object} pointr
	 * @returns {undefined}
	 */
	CTranslationParCoord.prototype.transformePoint = function (x, y, pointr) {
	  pointr.x = x + this.valeurVecteur.x * this.rep.u.x + this.valeurVecteur.y * this.rep.v.x;
	  pointr.y = y + this.valeurVecteur.x * this.rep.u.y + this.valeurVecteur.y * this.rep.v.y;
	};
	/**
	 * Renvoie dans le vecteur ur les coordonnées du vecteur image du vecteur u.
	 * @param {Vect} u
	 * @param {Vect} ur
	 * @returns {undefined}
	 */
	CTranslationParCoord.prototype.transformeVecteur = function (u, ur) {
	  u.setCopy(ur);
	};
	CTranslationParCoord.prototype.read = function (inps, list) {
	  CTransformation.prototype.read.call(this, inps, list);
	  var ind1 = inps.readInt();
	  this.rep = list.get(ind1, "CRepere");
	  this.x = new CValeur();
	  this.y = new CValeur();
	  this.x.read(inps, list);
	  this.y.read(inps, list);
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CAbscisseOrigineRep = __webpack_require__(28);
	var CValDyn = __webpack_require__(29);
	module.exports = CUnitexRep;
	/**
	 * Calcul renvoyant comme valeur l'unité d'un repère sur l'axe des abscisses.
	 * @constructor
	 * @extends mtg32.CAbscisseOrigineRep
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CRepere} rep : Le repère associé.
	 * @returns {CUnitexRep}
	 */
	function CUnitexRep(listeProprietaire, impProto, estElementFinal, nomCalcul, rep) {
	  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else {
	    CAbscisseOrigineRep.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, rep);
	  }
	}
	CUnitexRep.prototype = new CAbscisseOrigineRep();
	CUnitexRep.prototype.constructor = CUnitexRep;
	CUnitexRep.prototype.superClass = "CAbscisseOrigineRep";
	CUnitexRep.prototype.className = "CUnitexRep";
	
	CUnitexRep.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CUnitexRep(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CRepere"));
	};
	CUnitexRep.prototype.getNatureCalcul = function () {
	  return NatCal.NUnitexRep;
	};
	CUnitexRep.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.rep.existe;
	  this.abscisseOrigine = this.rep.unitex;
	};

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var CAbscisseOrigineRep = __webpack_require__(28);
	var CValDyn = __webpack_require__(29);
	module.exports = CUniteyRep;
	/**
	 * Calcul renvoyant comme valeur l'unité d'un repère sur l'axe des ordonnées.
	 * @constructor
	 * @extends mtg32.CAbscisseOrigineRep
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {Boolean} estElementFinal : true si élément final de construction.
	 * @param {String} nomCalcul : Le nom du calcul.
	 * @param {CRepere} rep : Le repère associé.
	 * @returns {CUniteyRep}
	 */
	function CUniteyRep(listeProprietaire, impProto, estElementFinal, nomCalcul, rep) {
	  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else {
	    CAbscisseOrigineRep.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, rep);
	  }
	}
	CUniteyRep.prototype = new CAbscisseOrigineRep();
	CUniteyRep.prototype.constructor = CUniteyRep;
	CUniteyRep.prototype.superClass = "CAbscisseOrigineRep";
	CUniteyRep.prototype.className = "CUniteyRep";
	
	CUniteyRep.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.rep);
	  var ind2 = listeSource.indexOf(this.impProto);
	  return new CUniteyRep(listeCible, listeCible.get(ind2, "CImplementationProto"), this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CRepere"));
	};
	CUniteyRep.prototype.getNatureCalcul = function () {
	  return NatCal.NUniteyRep;
	};
	CUniteyRep.prototype.positionne = function (infoRandom, dimfen) {
	  this.existe = this.rep.existe;
	  this.abscisseOrigine = this.rep.unitey;
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var NatCal = __webpack_require__(5);
	var CAffichageLieAPoint = __webpack_require__(36);
	var CLatex = __webpack_require__(40);
	module.exports = CValeurAffichee;
	
	/**
	 * Classe représentant une valeur affichée sur la figure.
	 * @constructor
	 * @extends CAffichageLieAPoint
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
	 * @param {boolean} estElementFinal : true si l'objet est un élément final de construction.
	 * @param {Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
	 * @param {float} x_Nom : L'abscisse d'affichage de l'éditeur
	 * @param {float} y_Nom : L'ordonnée d'affichage de l'éditeur
	 * @param {int} dec_x : Décalage horizontal du nom
	 * @param {int} dec_y : Décalage vertical du nom
	 * @param {boolean} masque : true si l'éditeur est masqué
	 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
	 * @param {int} taillePolice : Indice de la taiile de police utilisée
	 * @param {boolean} encadrement : true si encadré.
	 * @param {boolean} effacementFond : true si on efface le fond de l'en-tête.
	 * @param {Color} couleurFond : La couleur de fond de l'en-tête.
	 * @param {int} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
	 * @param {int} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
	 * @param {CValDyn} valeurAssociee : La valeur à afficher
	 * @param {string} enTete : le texte qui doit précéder l'affichage de valeur.
	 * Encadrer de deux $ pour avoir un affichage LaTeX.
	 * @param {string} postChaine : Le texet qui doit suivre l'affichage de la valeur.
	 * @param {int} nombreDecimales : Le nombre de décimales du résultat.
	 * @constructor
	 */
	function CValeurAffichee(listeProprietaire, impProto, estElementFinal, couleur, x_Nom, y_Nom, dec_x, dec_y, masque, pointLie, taillePolice, encadrement, effacementFond, couleurFond, alignementHorizontal, alignementVertical, valeurAssociee, enTete, postChaine, nombreDecimales) {
	  if (arguments.length === 1) CAffichageLieAPoint.call(this, listeProprietaire);else {
	    CAffichageLieAPoint.call(this, listeProprietaire, impProto, estElementFinal, couleur, x_Nom, y_Nom, dec_x, dec_y, masque, pointLie, taillePolice, encadrement, effacementFond, couleurFond, alignementHorizontal, alignementVertical);
	    this.valeurAssociee = valeurAssociee;
	    this.enTete = enTete;
	    this.postChaine = postChaine;
	    this.nombreDecimales = nombreDecimales;
	  }
	}
	CValeurAffichee.prototype = new CAffichageLieAPoint();
	CValeurAffichee.prototype.constructor = CValeurAffichee;
	CValeurAffichee.prototype.superClass = "CAffichageLieAPoint";
	CValeurAffichee.prototype.className = "CValeurAffichee";
	
	CValeurAffichee.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.valeurAssociee);
	  var ind2 = listeSource.indexOf(this.pointLie);
	  var ind3 = listeSource.indexOf(this.impProto);
	  return new CValeurAffichee(listeCible, listeCible.get(ind3, "CImplementationProto"), this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque, listeCible.get(ind2, "CPt"), this.taillePolice, this.encadrement, this.effacementFond, this.couleurFond, this.alignementHorizontal, this.alignementVertical, listeCible.get(ind1, "CValDyn"), this.enTete, this.postChaine, this.nombreDecimales);
	};
	
	CValeurAffichee.prototype.getNature = function () {
	  return NatObj.NValeurAffichee;
	};
	
	CValeurAffichee.prototype.dependDe = function (p) {
	  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
	  return this.memoriseDependance(CAffichageLieAPoint.prototype.dependDe.call(this, p) || this.valeurAssociee.dependDe(p));
	};
	
	CValeurAffichee.prototype.dependDePourBoucle = function (p) {
	  return CAffichageLieAPoint.prototype.dependDePourBoucle.call(this, p) || this.valeurAssociee.dependDePourBoucle(p);
	};
	
	CValeurAffichee.prototype.positionne = function (infoRandom, dimf) {
	  CAffichageLieAPoint.prototype.positionne.call(this, infoRandom, dimf);
	  this.existe = this.existe && this.valeurAssociee.existe;
	};
	
	CValeurAffichee.prototype.rendChaineAffichage = function () {
	  if (this.valeurAssociee.estDeNatureCalcul(NatCal.NTteValC)) {
	    return this.enTete + this.valeurAssociee.rendChaineValeurComplexe(this.nombreDecimales) + this.postChaine;
	  } else {
	    return this.enTete + this.valeurAssociee.rendChaineValeur(this.nombreDecimales) + this.postChaine;
	  }
	};
	
	CValeurAffichee.prototype.chaineDesignation = function () {
	  return "desAffichageValeur";
	};
	
	CValeurAffichee.prototype.read = function (inps, list) {
	  CAffichageLieAPoint.prototype.read.call(this, inps, list);
	  this.enTete = CLatex.traiteAccents(inps.readUTF());
	  this.postChaine = CLatex.traiteAccents(inps.readUTF());
	  this.nombreDecimales = inps.readByte();
	  var ind1 = inps.readInt();
	  this.valeurAssociee = list.get(ind1, "CValDyn");
	};
	
	CValeurAffichee.prototype.write = function (oups, list) {
	  CAffichageLieAPoint.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.enTete);
	  oups.writeUTF(this.postChaine);
	  oups.writeByte(this.nombreDecimales);
	  var ind1 = list.indexOf(this.valeurAssociee);
	  oups.writeInt(ind1);
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatCal = __webpack_require__(5);
	var Dimf = __webpack_require__(7);
	var kernel = __webpack_require__(8);
	var CValDyn = __webpack_require__(29);
	var constantes = __webpack_require__(268);
	module.exports = CVariableBornee;
	
	/**
	 * Classe représentant une variable définie par sa valeur actuelle, ses valeurs mini
	 * eet maxi et son pas d'incrémentation.
	 * @constructor
	 * @extends CValDyn
	 * @param {CListeObjets} listeProprietaire : La liste proprétaire de l'objet
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire
	 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction
	 * @param {String} nomCalcul : Le nom de la variable.
	 * @param {Number} valeurActuelle : La valeur actuelle de la variable
	 * @param {Number} valeurMini : La valeur mini de la variable
	 * @param {Number} valeurMaxi : La valeur maxi de la variable
	 * @param {Number} valeurPas : Le pas d'incrémentation
	 * @param {String} chaineValeurMini  : Chaîne de caractères représentant le calcul donnant la valeur mini.
	 * Ce calcul doit être constant.
	 * @param {String} chaineValeurMaxi : Chaîne de caractères représentant le calcul donnant la valeur maxi.
	 * Ce calcul doit être constant.
	 * @param {String} chaineValeurPas : Chaîne de caractères représentant le calcul donnant le pas.
	 * Ce calcul doit être constant.
	 * @param {Boolean} dialogueAssocie : true si la figure doit contenir en bas et à droite une boîte
	 *  de dialogue comportant des boutons + - et = pour modifier la variable.
	 * @returns {CVariableBornee}
	 */
	function CVariableBornee(listeProprietaire, impProto, estElementFinal, nomCalcul, valeurActuelle, valeurMini, valeurMaxi, valeurPas, chaineValeurMini, chaineValeurMaxi, chaineValeurPas, dialogueAssocie) {
	  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);else {
	    CValDyn.call(this, listeProprietaire, impProto, estElementFinal);
	    this.nomCalcul = nomCalcul;
	    this.valeurActuelle = valeurActuelle;
	    this.valeurMini = valeurMini;
	    this.valeurMaxi = valeurMaxi;
	    this.valeurPas = valeurPas;
	    this.chaineValeurMini = chaineValeurMini;
	    this.chaineValeurMaxi = chaineValeurMaxi;
	    this.chaineValeurPas = chaineValeurPas;
	    this.dialogueAssocie = dialogueAssocie;
	  }
	}
	CVariableBornee.prototype = new CValDyn();
	CVariableBornee.prototype.constructor = CVariableBornee;
	CVariableBornee.prototype.superClass = "CValDyn";
	CVariableBornee.prototype.className = "CVariableBornee";
	
	CVariableBornee.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  return new CVariableBornee(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.nomCalcul, this.valeurActuelle, this.valeurMini, this.valeurMaxi, this.valeurPas, this.chaineValeurMini, this.chaineValeurMaxi, this.chaineValeurPas, this.dialogueAssocie);
	};
	
	CVariableBornee.prototype.setClone = function (ptel) {
	  this.valeurActuelle = ptel.valeurActuelle;
	  this.valeurMini = ptel.valeurMini;
	  this.valeurMaxi = ptel.valeurMaxi;
	  this.valeurPas = ptel.valeurPas;
	};
	
	CVariableBornee.prototype.getNatureCalcul = function () {
	  return NatCal.NVariable;
	};
	
	CVariableBornee.prototype.donneNom = function (nouveauNom) {
	  this.nom = nouveauNom;
	};
	
	CVariableBornee.prototype.rendValeur = function () {
	  return this.valeurActuelle;
	};
	/**
	 * Fonction incrémentant la valeur actuelle de la valeur du pas si le résultat
	 * est inférieur à la valeur maxi.
	 * @returns {undefined}
	 */
	CVariableBornee.prototype.incremente = function () {
	  var nouv = this.valeurActuelle + this.valeurPas;
	  if (nouv >= this.valeurMini && nouv <= this.valeurMaxi) this.valeurActuelle = nouv;
	};
	/**
	 * Fonction décrémentant la valeur actuelle de la valeur du pas si le résultat
	 * est supérieur à la valeur mini.
	 * @returns {undefined}
	 */
	CVariableBornee.prototype.decremente = function () {
	  var nouv = this.valeurActuelle - this.valeurPas;
	  if (nouv >= this.valeurMini && nouv <= this.valeurMaxi) this.valeurActuelle = nouv;
	};
	/**
	 * Fonction donnant à la valeur actuelle la valeur valeur, sans vérifier
	 * si cette valeur est comprise entre le valeurs mini et maxi.
	 * @param {type} valeur
	 * @returns {undefined}
	 */
	CVariableBornee.prototype.donneValeur = function (valeur) {
	  this.valeurActuelle = valeur;
	};
	
	// A revoir. Utilisé ?
	CVariableBornee.prototype.getNom = function () {
	  return this.nomCalcul;
	};
	
	CVariableBornee.prototype.read = function (inps, list) {
	  CValDyn.prototype.read.call(this, inps, list);
	  this.nomCalcul = inps.readUTF();
	  this.valeurActuelle = inps.readDouble();
	  this.valeurMini = inps.readDouble();
	  this.valeurMaxi = inps.readDouble();
	  this.valeurPas = inps.readDouble();
	  this.dialogueAssocie = inps.readBoolean();
	  this.chaineValeurMini = inps.readUTF();
	  this.chaineValeurMaxi = inps.readUTF();
	  this.chaineValeurPas = inps.readUTF();
	};
	
	CVariableBornee.prototype.write = function (oups, list) {
	  CValDyn.prototype.write.call(this, oups, list);
	  oups.writeUTF(this.nomCalcul);
	  oups.writeDouble(this.valeurActuelle);
	  oups.writeDouble(this.valeurMini);
	  oups.writeDouble(this.valeurMaxi);
	  oups.writeDouble(this.valeurPas);
	  oups.writeBoolean(this.dialogueAssocie);
	  oups.writeUTF(this.chaineValeurMini);
	  oups.writeUTF(this.chaineValeurMaxi);
	  oups.writeUTF(this.chaineValeurPas);
	};
	// Fonction créant dans le document un Div associé contenant l'affichage de la valeur de la variable
	// et deux boutons + et - pour l'incrémenter et la décrémenter
	// ind est l'indice dans la liste des variables associées à des boutons
	/**
	 * Fonction créant dans le document un Div associé contenant l'affichage de la valeur de la variable
	 * et deux boutons + et - pour l'incrémenter et la décrémenter.
	 * N'est appelée que si this.dialogueAssocie est true.
	 * @param {type} ind : L'indice de cette variable dans la liste des variables ayant un dialue associé
	 * en bas et à droite de la figure.
	 * @returns {undefined}
	 */
	CVariableBornee.prototype.creeDiv = function (ind) {
	  var x, y, w, h, t, svg, par, style, decx, decy;
	  this.div = kernel.ce("div");
	  // Il est nécessaire d'utiliser un tableau avec des td car sur tablettes les boutons se retrouvent à la ligne
	  var tab = kernel.ce("table");
	  this.div.appendChild(tab);
	  var tr = kernel.ce("tr");
	  tab.appendChild(tr);
	  var td = kernel.ce("td", {
	    style: "padding:0px"
	  });
	  tr.appendChild(td);
	  this.editeur = kernel.ce("input", {
	    readOnly: "true",
	    style: "font-Size:9pt;padding:0px;"
	  });
	  td.appendChild(this.editeur);
	  this.editeur.name = this.listeProprietaire.id + this.nomCalcul;
	  this.updateDisplay();
	  td = kernel.ce("td", {
	    style: "padding:0px"
	  });
	  tr.appendChild(td);
	  // Attentino : Utiliser des inputs car si on utilise des buttons il ne faut pas utiliser value mais innerHtml
	  this.buttonplus = kernel.ce("input", {
	    type: "button",
	    value: "+"
	  });
	  td.appendChild(this.buttonplus);
	  t = this;
	  this.buttonplus.onclick = function (ev) {
	    CVariableBornee.onClickPlus.call(t);
	  };
	  td = kernel.ce("td", {
	    style: "padding:0px"
	  });
	  tr.appendChild(td);
	  this.buttonmoins = kernel.ce("input", {
	    type: "button",
	    value: "-"
	  });
	  td.appendChild(this.buttonmoins);
	  this.buttonmoins.onclick = function (ev) {
	    CVariableBornee.onClickMoins.call(t);
	  };
	  td = kernel.ce("td", {
	    style: "padding:0px"
	  });
	  tr.appendChild(td);
	  this.buttonegal = kernel.ce("input", {
	    type: "button",
	    value: "="
	  });
	  td.appendChild(this.buttonegal);
	  this.buttonegal.onclick = function () {
	    CVariableBornee.onClickEgal.call(t);
	  };
	  // this.div.appendChild(this.editeur);
	  // this.div.appendChild(this.buttonmoins);
	  // this.div.appendChild(this.buttonplus);
	  // this.div.appendChild(this.buttonegal);
	  // Nécessaire d'afficher le div en deux temps pour certaines nvaigateurs'
	  svg = document.getElementById(this.listeProprietaire.id);
	  par = svg.parentNode; // Le parent du svg doit être un div
	  // Modification version mtgApp : Dans le cas d'une mtgApp, le parent du svg de la figure est un autre svg
	  // et c'est son div parent qu'il faut utiliser
	  if (par.tagName.toLowerCase() !== "div") {
	    par = par.parentNode;
	    decx = constantes.svgPanelWidth;
	    decy = constantes.topIconSize;
	  } else {
	    decx = 0;
	    decy = 0;
	  }
	
	  // pos = mtg32.getPosition2FirstNonStatic(par);
	  // Modifié version 4.9.9.3
	  // x = pos.x + parseInt(svg.getAttribute("width"));
	  // y = pos.y + parseInt(svg.getAttribute("height"));
	  x = parseInt(svg.getAttribute("width")) + decx;
	  y = parseInt(svg.getAttribute("height")) + decy;
	
	  // style= "left:"+x+"px;"+"top:"+y+"px;"+"position:absolute;margin:0px;";
	  // this.div.setAttribute("style", style);
	  // if (par.style.position === "") par.style.position = "relative"; // Modifié version mtgApp
	  // Modification version MtgApp pour compatibilité avec les ongelts de Spip
	  // Il se peut que le div parent ne soit pas visible et n'ait pas de dimensions.
	  // On ajoute d'abord le div au document.body pour connaître sa taille puis on le retire pour l'affecter
	  // au div parent de la figure
	  style = "left:" + x + "px;" + "top:" + y + "px;" + "position:absolute;margin:0px;";
	  this.div.setAttribute("style", style);
	  document.body.appendChild(this.div);
	  // var bb = document.getElementById(this.listeProprietaire.id).getBoundingClientRect();
	  // w = this.editeur.offsetWidth + this.buttonplus.offsetWidth*3;
	  // h = Math.max(this.editeur.offsetHeight, this.buttonplus.offsetHeight) + 1;
	  w = this.div.offsetWidth;
	  h = this.div.offsetHeight;
	  x = x - w;
	  y = y - h * (ind + 1);
	  style = "left:" + x + "px;" + "top:" + y + "px;" + "position:absolute;margin:0px;";
	  this.div.setAttribute("style", style);
	  document.body.removeChild(this.div);
	  par.appendChild(this.div);
	  // document.body.appendChild(div);
	};
	/**
	 * Fonction appelée quand l'utilisateur clique sur le bouton + du dialoge associé
	 * à la variable (si this.dialogueAssocie est true).
	 * Augmente la variable de la valeur de son pas.
	 * @returns {undefined}
	 */
	CVariableBornee.onClickPlus = function () {
	  var liste, doc, svg, dimf;
	  liste = this.listeProprietaire;
	  doc = liste.documentProprietaire;
	  svg = document.getElementById(liste.id);
	  dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	  this.incremente();
	  liste.positionneDependantsDe(false, dimf, this);
	  liste.setDependantsReady4MathJaxUpdate(this); // Ajout version 5.0.6
	  liste.updateDependants(this, svg, doc.couleurFond, doc.opacity, true);
	  this.updateDisplay();
	};
	/**
	 * Fonction appelée quand l'utilisateur clique sur le bouton - du dialoge associé
	 * à la variable (si this.dialogueAssocie est true).
	 * Diminue la variable de la valeur de son pas.
	 * @returns {undefined}
	 */
	CVariableBornee.onClickMoins = function () {
	  var liste, doc, svg, dimf;
	  liste = this.listeProprietaire;
	  doc = liste.documentProprietaire;
	  svg = document.getElementById(liste.id);
	  dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	  this.decremente();
	  liste.positionneDependantsDe(false, dimf, this);
	  liste.setDependantsReady4MathJaxUpdate(this); // Ajout version 5.0.6
	  liste.updateDependants(this, svg, doc.couleurFond, doc.opacity, true);
	  this.updateDisplay();
	};
	/**
	 * Fonction appelée quand l'utilisateur clique sur le bouton = du dialoge associé
	 * à la variable (si this.dialogueAssocie est true).
	 * Fait apparaître une boîte de dialogue permettant de modifier la valeur actuelle
	 * de la variable. La valeur entrée n'est affectée à valeurActuelle que si elle est
	 *  comprise entre les valeurs mini et maxi.
	 * @returns {undefined}
	 */
	CVariableBornee.onClickEgal = function () {
	  var liste, doc, svg, dimf, va, ch, val;
	  ch = kernel.getString("var1") + this.nomCalcul + "\n" + kernel.getString("var2") + this.valeurMini + kernel.getString("et") + this.valeurMaxi;
	  va = prompt(ch, this.valeurActuelle);
	  if (va === null) return;
	  val = parseFloat(va);
	  if (!isFinite(val) || val < this.valeurMini || val > this.valeurMaxi) {
	    alert(kernel.getString('incorrect'));
	    return;
	  }
	  this.donneValeur(val);
	  liste = this.listeProprietaire;
	  doc = liste.documentProprietaire;
	  svg = document.getElementById(liste.id);
	  dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
	  liste.positionneDependantsDe(false, dimf, this);
	  liste.setDependantsReady4MathJaxUpdate(this); // Ajout version 5.0.6
	  liste.updateDependants(this, svg, doc.couleurFond, doc.opacity, true);
	  this.updateDisplay();
	};
	/**
	 * Fonction remettant à jour l'affichage en bas et à droite de la figure du dialogue associé
	 * à la variable (ne peut être appelé que si this.dialogueAssocie est true).
	 * @returns {undefined}
	 */
	CVariableBornee.prototype.updateDisplay = function () {
	  if (this.dialogueAssocie) this.editeur.value = this.nomCalcul + " = " + this.rendChaineValeur(12);
	};
	/**
	 * Fonction détruisant le div représentant le dialogue affiché en bas et à droite de la figure et associé
	 * à la variable, avec les bouton +, - et = associés.
	 * Ne peut être appelée que si this.dialogeAssocie est true.
	 * @param {type} svg
	 * @returns {undefined}
	 */
	CVariableBornee.prototype.deleteComponent = function (svg) {
	  try {
	    var par = svg.parentNode;
	    // Modification version WepPack. Dans cette version le parent peut être un svg
	    if (par.tagName.toLowerCase() !== "div") par = par.parentNode;
	    par.removeChild(this.div);
	  } catch (ex) {}
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by yvesb on 23/10/2016.
	 */
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @version 5.1.2
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var StyleTrait = __webpack_require__(78);
	
	var constantes = {
	  // Constante contenant une chaîne de caractères formée des constructions utilisées
	  constructions: "TWF0aEdyYXBoSmF2YTEuMAAAABE+TMzNAANmcmH###8BAP8BAAAAAAAAAAAFhQAAAxIAAAAAAAAAEwAAAAYAC0NhcnJlRGlyZWN0AAAAAAACAAAAAgAAAAAJ#####wAAAAEAEUNFbGVtZW50R2VuZXJpcXVlAAAAAAAA#####wAAAAAAAAAAAAD##########wAAAAEACENTZWdtZW50AP####8BAAAAAAoAAAEAAQAAAAAAAAAB#####wAAAAEAFkNEcm9pdGVQZXJwZW5kaWN1bGFpcmUA#####wAAAAAADQAAAQEBAAAAAAAAAAL#####AAAAAQAJQ0NlcmNsZU9BAP####8AAAAAAQEAAAAAAAAAAf####8AAAABABBDSW50RHJvaXRlQ2VyY2xlAP####8AAAADAAAABP####8AAAABABBDUG9pbnRMaWVCaXBvaW50Af####8AAAAAAA0AAAEFAAIAAAAF#####wAAAAEADENUcmFuc2xhdGlvbgD#####AAAAAAAAAAH#####AAAAAQALQ1BvaW50SW1hZ2UB#####wAAAAAADQAAAQUAAAAABgAAAAcAAAAGAApUcmlhbmdsZUVxAAAAAAACAAAAAQAAAAAGAAAAAAAAAAAAAP####8AAAAAAAAAAAAA#####wAAAAMA#####wEAAAABAQAAAAAAAAABAAAAAwD#####AQAAAAEBAAAAAQAAAAD#####AAAAAQAQQ0ludENlcmNsZUNlcmNsZQD#####AAAAAwAAAAIAAAAFAf####8AAAAAAA0AAAEFAAEAAAAEAAAABgAUR3JhZHVhdGlvbkF4ZXNSZXBlcmUAAAAAAAMAAAAIAgAAACYAAAAAAAAAAAAeAAAAGgAAAAAAB25iZ3JhZHj#####AAAAAQAAAAAAB25iZ3JhZHn#####AAAAAf####8AAAABABNDQWJzY2lzc2VPcmlnaW5lUmVwAP####8ABWFic29yAAAAAP####8AAAABABNDT3Jkb25uZWVPcmlnaW5lUmVwAP####8ABW9yZG9yAAAAAP####8AAAABAApDVW5pdGV4UmVwAP####8ABnVuaXRleAAAAAD#####AAAAAQAKQ1VuaXRleVJlcAD#####AAZ1bml0ZXkAAAAA#####wAAAAEAEENQb2ludERhbnNSZXBlcmUA#####wAAAAAADgAAAQUAAAAAAP####8AAAABAA9DUmVzdWx0YXRWYWxldXIAAAADAAAADgAAAAQAAAANAP####8AAAAAAA4AAAEFAAAAAAD#####AAAAAQAKQ09wZXJhdGlvbgAAAAAOAAAAAwAAAA4AAAAFAAAADgAAAAQAAAANAP####8AAAAAAA4AAAEFAAAAAAAAAAAOAAAAAwAAAA8AAAAADgAAAAQAAAAOAAAABv####8AAAABAAtDSG9tb3RoZXRpZQD#####AAAABwAAAA4AAAABAAAABwD#####AAAAAAAOAAABBQAAAAAIAAAACgAAABAA#####wAAAAcAAAAOAAAAAgAAAAcA#####wAAAAAADgAAAQUAAAAACQAAAAwAAAABAP####8BAAAAAAoAAAEAAQAAAAgAAAALAAAAAQD#####AQAAAAAKAAABAAEAAAAJAAAADf####8AAAABAA9DUG9pbnRMaWVEcm9pdGUA#####wEAAAAACwABVwDAFAAAAAAAAMA0AAAAAAAABQABP9xWeJq83w4AAAAO#####wAAAAIACENNZXN1cmVYAP####8AAAAAAAAAAAAQ#####wAAAAEAB0NDYWxjdWwA#####wAFYWJzdzEAD3hDb29yZChXLE8sSSxKKQAAAA4AAAAR#####wAAAAIAEkNMaWV1T2JqZXRQYXJQdExpZQH#####AGZmZgAAABAAAAAOAAAAAQAAABAAAAAAAAAAEwD#####AAVhYnN3MgANMiphYnNvci1hYnN3MQAAAA8BAAAADwL#####AAAAAQAKQ0NvbnN0YW50ZUAAAAAAAAAAAAAADgAAAAMAAAAOAAAAEgAAAA0A#####wEAAAAACwAAAQUAAAAAAAAAAA4AAAAUAAAADgAAAAQAAAAUAf####8AZmZmAAAAFQAAAA4AAAABAAAAEAAAAAAAAAARAP####8BAAAAAAsAAVIAQCAAAAAAAADAIAAAAAAAAAUAAT#RG06BtOgfAAAAD#####8AAAACAAhDTWVzdXJlWQD#####AAAAAAAAAAAAFwAAABMA#####wAFb3JkcjEAD3lDb29yZChSLE8sSSxKKQAAAA4AAAAYAAAAFAH#####AGZmZgAAABcAAAAOAAAAAgAAABcAAAAAAAAAEwD#####AAVvcmRyMgANMipvcmRvci1vcmRyMQAAAA8BAAAADwIAAAAVQAAAAAAAAAAAAAAOAAAABAAAAA4AAAAZAAAADQD#####AQAAAAALAAABBQAAAAAAAAAADgAAAAMAAAAOAAAAGwAAABQB#####wBmZmYAAAAcAAAADgAAAAIAAAAXAAAAAP####8AAAACAAxDQ29tbWVudGFpcmUA#####wFmZmYAAAAAAAAAAABAGAAAAAAAAAAAABALAAH###8AAAABAAAAAAALI1ZhbChhYnN3MSkAAAAUAf####8AZmZmAAAAHgAAAA4AAAABAAAAEAAAAAAAAAAXAP####8BZmZmAAAAAAAAAAAAQBgAAAAAAAAAAAAVCwAB####AAAAAQAAAAAACyNWYWwoYWJzdzIpAAAAFAH#####AGZmZgAAACAAAAAOAAAAAQAAABAAAAAAAAAAFwD#####AWZmZgDAIAAAAAAAAD#wAAAAAAAAAAAAFwsAAf###wAAAAIAAAABAAsjVmFsKG9yZHIxKQAAABQB#####wBmZmYAAAAiAAAADgAAAAIAAAAXAAAAAAAAABcA#####wFmZmYAwBwAAAAAAAAAAAAAAAAAAAAAABwLAAH###8AAAACAAAAAQALI1ZhbChvcmRyMikAAAAUAf####8AZmZmAAAAJAAAAA4AAAACAAAAFwAAAAAAAAAGABlHcmFkdWF0aW9uUmVwZXJlUG91clRyaWdvAAAAAAADAAAACAIAAAAyAAAAAAAAAAAAHgAAABoAAAAAAAduYmdyYWR4#####wAAAAEAAAAAAAduYmdyYWR5#####wAAAAEAAAAMAP####8ABnVuaXRleQAAAAD#####AAAAAQAKQ0NhbGNDb25zdAD#####AANwaTEAFjMuMTQxNTkyNjUzNTg5NzkzMjM4NDYAAAAVQAkh+1RELRgAAAAJAP####8ABWFic29yAAAAAAAAAAoA#####wAFb3Jkb3IAAAAAAAAADQD#####AGZmZgALAAABBQAAAAAAAAAADgAAAAUAAAAOAAAABgAAAA0A#####wBmZmYACwAAAQUAAAAAAAAAAA8AAAAADgAAAAUAAAAVP#AAAAAAAAAAAAAOAAAABgAAABAA#####wAAAAcAAAAOAAAABAAAAAcA#####wAAAAAACwAAAQUAAAAACAAAAAkAAAAQAP####8AAAAHAAAADgAAAAEAAAAHAP####8AAAAAAAsAAAEFAAAAAAoAAAALAAAAAQD#####AQAAAAAKAAABAAEAAAAKAAAADAAAABEA#####wEAAAAACwABVwDAGAAAAAAAAMAyAAAAAAAABQABP9cBAsIHNvcAAAANAAAAEgD#####AAAAAAAAAAAADgAAABMA#####wAGZ3JhZHBpABN4Q29vcmQoVyxPLEksSikvcGkxAAAADwMAAAAOAAAADwAAAA4AAAAEAAAAEwD#####AAV0ZXN0MwAVYWJzKGdyYWRwaSk8MC4wMDAwMDAxAAAADwT#####AAAAAgAJQ0ZvbmN0aW9uAAAAAA4AAAAQAAAAFT561#KavK9IAAAAEwD#####AAdncmFkcGknABIyKmFic29yL3BpMS1ncmFkcGkAAAAPAQAAAA8DAAAADwIAAAAVQAAAAAAAAAAAAAAOAAAABQAAAA4AAAAEAAAADgAAABAAAAATAP####8ABXRlc3Q0ABZhYnMoZ3JhZHBpJyk8MC4wMDAwMDAxAAAADwQAAAAZAAAAAA4AAAASAAAAFT561#KavK9IAAAAEwD#####AAV0ZXN0MgAYYWJzKGdyYWRwaScrMSk8MC4wMDAwMDAxAAAADwQAAAAZAAAAAA8AAAAADgAAABIAAAAVP#AAAAAAAAAAAAAVPnrX8pq8r0gAAAATAP####8ABXRlc3QxABdhYnMoZ3JhZHBpLTEpPDAuMDAwMDAwMQAAAA8EAAAAGQAAAAAPAQAAAA4AAAAQAAAAFT#wAAAAAAAAAAAAFT561#KavK9I#####wAAAAIABkNMYXRleAD#####AAAAAAAAAAAAAAAAAEAYAAAAAAAAAAAADgsAAf###wAAAAEAAAAAAC9cSWZ7dGVzdDN9ezB9e1xJZnt0ZXN0MX17XHBpfXtcVmFse2dyYWRwaX1ccGl9fQAAABQB#####wAAAAAAAAAWAAAADgAAAAEAAAAOAAAAAP####8AAAABABFDU3ltZXRyaWVDZW50cmFsZQD#####AAAABwAAAAcA#####wEAAAAACwAAAQUAAAAADgAAABgAAAAaAP####8AAAAAAAAAAAAAAAAAQBgAAAAAAAAAAAAZCwAB####AAAAAQAAAAAAMVxJZnt0ZXN0NH17MH17XElme3Rlc3QyfXstXHBpfXtcVmFse2dyYWRwaSd9XHBpfX0AAAAUAf####8AAAAAAAAAGgAAAA4AAAABAAAADgAAAAAAAAABAP####8BAAAAAAoAAAEAAQAAAAcAAAAMAAAAEQD#####AQAAAAALAAFSAMAAAAAAAAAAwDQAAAAAAAAFAAE#xbreUvleaAAAABwAAAAUAf####8AZmZmAAAAHQAAAA8AAAAADwIAAAAOAAAAAQAAABVAAAAAAAAAAAAAABU#8AAAAAAAAAAAAB0AAAAAAAAABwD#####AQAAAAALAAABBQAAAAAdAAAAGAAAABQB#####wBmZmYAAAAfAAAADwAAAAAPAgAAAA4AAAABAAAAFUAAAAAAAAAAAAAAFT#wAAAAAAAAAAAAHQAAAAAAAAAQAP####8AAAAHAAAADgAAAAMAAAAQAP####8AAAAHAAAADgAAAAIAAAANAP####8AAAAAAAsAAAEFAAAAAAAAAAAOAAAABQAAAA8AAAAADgAAAAYAAAAVP#AAAAAAAAAAAAAHAP####8AAAAAAAsAAAEFAAAAACMAAAAhAAAABwD#####AAAAAAALAAABBQAAAAAkAAAAIgAAAAEA#####wEAAAAACgAAAQABAAAAJAAAACUAAAARAP####8AAAAAAAsAAVQAQCAAAAAAAADAIgAAAAAAAAUAAT#ij1wo9cKXAAAAJgAAABYA#####wAAAAAAAAAAACcAAAATAP####8ABG9yZHQAD3lDb29yZChULE8sSSxKKQAAAA4AAAAoAAAAEwD#####AAV5Z3JhZAAMMipvcmRvci1vcmR0AAAADwEAAAAPAgAAABVAAAAAAAAAAAAAAA4AAAAGAAAADgAAACkAAAAHAP####8AAAAAAAsAAAEFAAAAACcAAAAYAAAAFAH#####AGZmZgAAACcAAAAOAAAAAgAAACcAAAAAAAAAFAH#####AGZmZgAAACsAAAAOAAAAAgAAACcAAAAAAAAAFwD#####AQAAAADAIAAAAAAAAD#wAAAAAAAAAAAAJwsAAf###wAAAAIAAAABAAojVmFsKG9yZHQpAAAAFAH#####AGZmZgAAAC4AAAAOAAAAAgAAACcAAAAAAAAAFwD#####AWZmZgDAIAAAAAAAAAAAAAAAAAAAAAAAKwsAAf###wAAAAIAAAABAAsjVmFsKHlncmFkKQAAABQB#####wBmZmYAAAAwAAAADgAAAAIAAAAnAAAAAAAAAAYADk1lc3VyZUxvbmd1ZXVyAAAAAAACAAAAAgAAAAAJAAAAAAABQQAAAAD#####AAAAAAABQgAAAAD##########wAAAAEAC0NNZWRpYXRyaWNlAP####8BAAAAAA0AAAEAAQAAAAAAAAAB#####wAAAAEAB0NNaWxpZXUA#####wEAAAAADQAAAQUAAAAAAAAAAAH#####AAAAAgAJQ0NlcmNsZU9SAP####8BAAAAAAEAAAADAAAAFUAwAAAAAAAAAQAAAAQA#####wAAAAIAAAAEAAAABQD#####AQAAAAANAAABBQABAAAABf####8AAAABAAlDTG9uZ3VldXIB#####wAAAAAAAAAB#####wAAAAEAD0NWYWxldXJBZmZpY2hlZQH#####AAAAAAEAAAAGEQAAAAAAAQAAAAEAAAAAAQAAAAcAAAAGAAtNZXN1cmVBbmdsZQAAAAAAAwAAAAMAAAAACAAAAAAAAUEAAAAA#####wAAAAAAAU8AAAAA#####wAAAAAAAUIAAAAA##########8AAAABAAxDQmlzc2VjdHJpY2UA#####wEAAAAADQAAAQABAAAAAAAAAAEAAAACAAAAEQD#####AQAAAAANAAABBQABQGgekZlBlrgAAAAD#####wAAAAEAF0NNZXN1cmVBbmdsZUdlb21ldHJpcXVlAf####8AAAAAAAAAAQAAAAL#####AAAAAgAXQ01hcnF1ZUFuZ2xlR2VvbWV0cmlxdWUB#####wAAAAAAAgAAAABAQUUZN7DnQQAAAAAAAAABAAAAAgAAACAB#####wAAAAAAQAgAAAAAAAAAAAAAAAAAAAAAAAQRAAAAAAABAAAAAQAAAALCsAAAAAAFAAAABgASTWVzdXJlQW5nbGVPcmllbnRlAAAAAAADAAAAAwAAAAAIAAAAAAAAAAAAAP####8AAAAAAAAAAAAA#####wAAAAAAAAAAAAD#####AAAAIQD#####AQAAAAALAAABAAEAAAACAAAAAQAAAAAAAAARAP####8BAAAAAAsAAAAAAAAAAAAAAD#jMzMzMzMzBQABQGQvxGBod8MAAAAD#####wAAAAIAE0NNZXN1cmVBbmdsZU9yaWVudGUB#####wADYW5nAAAAAAAAAAEAAAACAAAAIAH#####AAAAAABACAAAAAAAAD#wAAAAAAAAAAAABBEAAAAAAAEAAAABAAAAAsKwAAAAAAX#####AAAAAgATQ01hcnF1ZUFuZ2xlT3JpZW50ZQH#####AAAAAAABAAAAAEBBNGP6NwFOAAAAAAAAAAEAAAACAAAAAAYACFRhbmdlbnRlAAAAAAADAAAAAgIAAAAIAAAAAAAA#####wAAABYAAAAAAAF4#####wAAAAEAAAAAAAAAAAAeAAAAGgAAABMA#####wABeQAEZih4Kf####8AAAABAA5DQXBwZWxGb25jdGlvbgAAAAAAAAAOAAAAAQAAAA0A#####wAAAAAADQAAAQUAAAAAAgAAAA4AAAABAAAADgAAAAP#####AAAAAQAIQ0Rlcml2ZWUA#####wACZicAAAAAAAAAEwH#####AAFtAAVmJyh4KQAAACYAAAAFAAAADgAAAAH#####AAAAAQAJQ0Ryb2l0ZU9tAf####8AAAAAAAoAAAEAAQAAAAIAAAAEAAAADgAAAAYAAAAGABJTZWdtZW50UGFyTG9uZ3VldXIAAAAAAAIAAAADAQAAAAsAAAAAAARsb25n#####wAAAAEAAAAAAAAAAAAA#####wAAAB4A#####wEAAAAAAQAAAAEAAAAOAAAAAAD#####AAAAAQAPQ1BvaW50TGllQ2VyY2xlAf####8AAAAAABAAAAEFAAGAAAAAAAAAAAAAAAIAAAABAf####8AAAAAAA0AAAEAAQAAAAEAAAADAAAAHQD#####AQAAAAANAAABBQAAAAABAAAAAwAAABwA#####wEAAAAADQAAAQABAAAAAQAAAAMAAAAeAP####8BAAAAAAEAAAAFAAAAFUAwAAAAAAAAAQAAAAQA#####wAAAAYAAAAHAAAABQD#####AQAAAAANAAABBQABAAAACAAAACAB#####wAAAAABAAAACQ4AAAAAAAEAAAABAAAAAAEAAAAAAAAABgAgR3JhZHVhdGlvblJlcGVyZVBvdXJUcmlnb0F2ZWNQYXMAAAAAAAQAAAAIAgAAADIAAAAAAAAAAAAeAAAAGgAAAAAAB25iZ3JhZHj#####AAAAAQAAAAAABWdyYWR5#####wAAAAEAAAAAAAduYmdyYWR5#####wAAAAEAAAAYAP####8AA3BpMQAWMy4xNDE1OTI2NTM1ODk3OTMyMzg0NgAAABVACSH7VEQtGAAAAAkA#####wAFYWJzb3IAAAAAAAAACgD#####AAVvcmRvcgAAAAAAAAANAP####8AZmZmAAsAAAEFAAAAAAAAAAAOAAAABQAAAA4AAAAGAAAADQD#####AGZmZgALAAABBQAAAAAAAAAADwAAAAAOAAAABQAAABU#8AAAAAAAAAAAAA4AAAAGAAAAEAD#####AAAABwAAAA4AAAAEAAAABwD#####AAAAAAALAAABBQAAAAAIAAAACQAAABAA#####wAAAAcAAAAOAAAAAQAAAAcA#####wAAAAAACwAAAQUAAAAACgAAAAsAAAABAP####8BAAAAAAoAAAEAAQAAAAoAAAAMAAAAEQD#####AQAAAAALAAFXAMAYAAAAAAAAwDIAAAAAAAAFAAE#1wECwgc29wAAAA0AAAASAP####8AAAAAAAAAAAAOAAAAEwD#####AAZncmFkcGkAE3hDb29yZChXLE8sSSxKKS9waTEAAAAPAwAAAA4AAAAPAAAADgAAAAQAAAATAP####8ABXRlc3QzABVhYnMoZ3JhZHBpKTwwLjAwMDAwMDEAAAAPBAAAABkAAAAADgAAABAAAAAVPnrX8pq8r0gAAAATAP####8AB2dyYWRwaScAEjIqYWJzb3IvcGkxLWdyYWRwaQAAAA8BAAAADwMAAAAPAgAAABVAAAAAAAAAAAAAAA4AAAAFAAAADgAAAAQAAAAOAAAAEAAAABMA#####wAFdGVzdDQAFmFicyhncmFkcGknKTwwLjAwMDAwMDEAAAAPBAAAABkAAAAADgAAABIAAAAVPnrX8pq8r0gAAAATAP####8ABXRlc3QyABhhYnMoZ3JhZHBpJysxKTwwLjAwMDAwMDEAAAAPBAAAABkAAAAADwAAAAAOAAAAEgAAABU#8AAAAAAAAAAAABU+etfymryvSAAAABMA#####wAFdGVzdDEAF2FicyhncmFkcGktMSk8MC4wMDAwMDAxAAAADwQAAAAZAAAAAA8BAAAADgAAABAAAAAVP#AAAAAAAAAAAAAVPnrX8pq8r0gAAAAaAP####8BAAAAAAAAAAAAAAAAQBgAAAAAAAAAAAAOCwAB####AAAAAQAAAAAAL1xJZnt0ZXN0M317MH17XElme3Rlc3QxfXtccGl9e1xWYWx7Z3JhZHBpfVxwaX19AAAAFAH#####AAAAAAAAABYAAAAOAAAAAQAAAA4AAAAAAAAAGwD#####AAAABwAAAAcA#####wEAAAAACwAAAQUAAAAADgAAABgAAAAaAP####8BAAAAAAAAAAAAAAAAQBgAAAAAAAAAAAAZCwAB####AAAAAQAAAAAAMVxJZnt0ZXN0NH17MH17XElme3Rlc3QyfXstXHBpfXtcVmFse2dyYWRwaSd9XHBpfX0AAAAUAf####8AAAAAAAAAGgAAAA4AAAABAAAADgAAAAAAAAABAP####8BAAAAAAoAAAEAAQAAAAcAAAAMAAAAEQD#####AQAAAAALAAFSAMAAAAAAAAAAwDQAAAAAAAAFAAE#xbreUvleaAAAABwAAAAUAf####8AZmZmAAAAHQAAAA8AAAAADwIAAAAOAAAAAQAAABVAAAAAAAAAAAAAABU#8AAAAAAAAAAAAB0AAAAAAAAABwD#####AAAAAAALAAABBQAAAAAdAAAAGAAAABQB#####wBmZmYAAAAfAAAADwAAAAAPAgAAAA4AAAABAAAAFUAAAAAAAAAAAAAAFT#wAAAAAAAAAAAAHQAAAAAAAAAQAP####8AAAAHAAAADgAAAAIAAAAQAP####8AAAAHAAAADgAAAAMAAAANAP####8AAAAAAAsAAAEFAAAAAAAAAAAOAAAABQAAAA8AAAAADgAAAAYAAAAVP#AAAAAAAAAAAAAHAP####8AAAAAAAsAAAEFAAAAACMAAAAhAAAABwD#####AAAAAAALAAABBQAAAAAkAAAAIgAAAAEA#####wEAAAAACgAAAQABAAAAJAAAACUAAAARAP####8BAAAAAAsAAVQAQCAAAAAAAADAIgAAAAAAAAUAAT#ij1wo9cKXAAAAJgAAABYA#####wAAAAAAAAAAACcAAAATAP####8ABG9yZHQAD3lDb29yZChULE8sSSxKKQAAAA4AAAAoAAAAFAH#####AGZmZgAAACcAAAAOAAAAAwAAACcAAAAAAAAAEwD#####AAV5Z3JhZAAMMipvcmRvci1vcmR0AAAADwEAAAAPAgAAABVAAAAAAAAAAAAAAA4AAAAGAAAADgAAACkAAAAHAP####8BAAAAAAsAAAEFAAAAACcAAAAYAAAAFAH#####AGZmZgAAACwAAAAOAAAAAwAAACcAAAAAAAAAFwD#####AWZmZgDAHAAAAAAAAAAAAAAAAAAAAAAAJwsAAf###wAAAAIAAAABAAojVmFsKG9yZHQpAAAAFAH#####AGZmZgAAAC4AAAAOAAAAAwAAACcAAAAAAAAAFwD#####AWZmZgDAHAAAAAAAAD#wAAAAAAAAAAAALAsAAf###wAAAAIAAAABAAsjVmFsKHlncmFkKQAAABQB#####wBmZmYAAAAwAAAADgAAAAMAAAAnAAAAAAAAAAYAG0dyYWR1YXRpb25BeGVzUmVwZXJlQXZlY1BhcwAAAAAABQAAAAgCAAAAKgAAAAAAAAAAAB4AAAAaAAAAAAAEcGFzeP####8AAAABAAAAAAAHbmJncmFkeP####8AAAABAAAAAAAEcGFzef####8AAAABAAAAAAAHbmJncmFkef####8AAAABAAAACQD#####AAVhYnNvcgAAAAAAAAAKAP####8ABW9yZG9yAAAAAAAAAA0A#####wAAAAAACwAAAQUAAAAAAAAAAA4AAAAFAAAADgAAAAYAAAANAP####8AAAAAAAsAAAEFAAAAAAAAAAAPAAAAAA4AAAAFAAAAFT#wAAAAAAAAAAAADgAAAAYAAAAQAP####8AAAAHAAAADgAAAAEAAAAHAP####8AAAAAAAsAAAEFAAAAAAgAAAAJAAAAEAD#####AAAABwAAAA4AAAACAAAABwD#####AAAAAAALAAABBQAAAAAKAAAACwAAAAEA#####wEAAP8ACgAAAQABAAAACgAAAAwAAAARAP####8BAAAAAAsAAlcxAMAcAAAAAAAAwDQAAAAAAAAFAAE#znnnnnnnkQAAAA0AAAASAP####8AAAAAAAAAAAAOAAAAEwD#####AAVhYnN3MQAQeENvb3JkKFcxLE8sSSxKKQAAAA4AAAAPAAAAEwD#####AAVhYnN3MgANMiphYnNvci1hYnN3MQAAAA8BAAAADwIAAAAVQAAAAAAAAAAAAAAOAAAABQAAAA4AAAAQAAAADQD#####AAAAAAALAAABBQAAAAAAAAAADgAAAAUAAAAPAAAAAA4AAAAGAAAAFT#wAAAAAAAAAAAADQD#####AQAAAAALAAABBQAAAAAAAAAADgAAABEAAAAOAAAABgAAABQB#####wBmZmYAAAAOAAAADgAAAAIAAAAOAAAAAAAAABQB#####wBmZmYAAAATAAAADgAAAAIAAAAOAAAAAAAAABAA#####wAAAAcAAAAOAAAAAwAAAAcA#####wAAAAAACwAAAQUAAAAAEgAAABYAAAAQAP####8AAAAHAAAADgAAAAQAAAAHAP####8AAAAAAAsAAAEFAAAAABcAAAAYAAAAAQD#####AQAA#wAKAAABAAEAAAAXAAAAGQAAABEA#####wEAAAAACwABUgBAHAAAAAAAAMAgAAAAAAAABQABP9omCMby1YkAAAAaAAAAFgD#####AAAAAAAAAAAAGwAAABMA#####wAFb3JkcjEAD3lDb29yZChSLE8sSSxKKQAAAA4AAAAcAAAAEwD#####AAVvcmRyMgANMipvcmRvci1vcmRyMQAAAA8BAAAADwIAAAAVQAAAAAAAAAAAAAAOAAAABgAAAA4AAAAdAAAADQD#####AQAAAAALAAABBQAAAAAAAAAADgAAAAUAAAAOAAAAHgAAABQB#####wBmZmYAAAAbAAAADgAAAAQAAAAbAAAAAAAAABQB#####wBmZmYAAAAfAAAADgAAAAQAAAAbAAAAAAAAABcA#####wFmZmYAQAAAAAAAAABAFAAAAAAAAAAAAA4LAAH###8AAAABAAAAAAALI1ZhbChhYnN3MSkAAAAUAf####8AZmZmAAAAIgAAAA4AAAACAAAADgAAAAAAAAAXAP####8BZmZmAL#wAAAAAAAAQBQAAAAAAAAAAAATCwAB####AAAAAQAAAAAACyNWYWwoYWJzdzIpAAAAFAH#####AGZmZgAAACQAAAAOAAAAAgAAAA4AAAAAAAAAFwD#####AWZmZgDAIAAAAAAAAAAAAAAAAAAAAAAAGwsAAf###wAAAAIAAAABAAsjVmFsKG9yZHIxKQAAABQB#####wBmZmYAAAAmAAAADgAAAAQAAAAbAAAAAAAAABcA#####wFmZmYAwCAAAAAAAAAAAAAAAAAAAAAAAB8LAAH###8AAAACAAAAAQALI1ZhbChvcmRyMikAAAAUAf####8AZmZmAAAAKAAAAA4AAAAEAAAAGwAAAAAAAAAGABFDdXJzZXVyRGlzY3JldEhvcgAAAAAABAAAAAYBAAAAFAAAAAAABG1pbmn#####AAAAAQAAAAAABG1heGn#####AAAAAQAAAAAAA3Bhc#####8AAAABAAAAAAAAAAAAAP##########AAAAAQAUQ0Ryb2l0ZURpcmVjdGlvbkZpeGUA#####wEAAAAADwAAAQABAAAAAwE#8AAAAAAAAAAAABEB#####wAAAAAADwAAAAAAAAAAAAAAQAgAAAAAAAAFAAFAYYAAAAAAAAAAAAQAAAATAP####8AB25iZ3JhZDAAGmludCgobWF4aS1taW5pKS9wYXMrMC41KSsxAAAADwAAAAAZAgAAAA8AAAAADwMAAAAPAQAAAA4AAAABAAAADgAAAAAAAAAOAAAAAgAAABU#4AAAAAAAAAAAABU#8AAAAAAAAP####8AAAABAAtDUG9pbnRDbG9uZQD#####AQAAAAALAAJPMQDAOAAAAAAAAD#wAAAAAAAAAQAAAAADAAAAAQH#####AAAAAAANAAABAAEAAAAHAAAABQAAAAIA#####wEAAAAADwAAAQABAAAABwAAAAgAAAARAP####8BAAAAAAsAAkoxAMA2AAAAAAAAwC4AAAAAAAABAAG#vhkUx7D9WQAAAAkAAAAQAP####8AAAAHAAAADwMAAAAOAAAAAgAAAA8BAAAADgAAAAEAAAAOAAAAAAAAAAcA#####wEAAAAACwACSTEAAAAAAAAAAABAAAAAAAAAAAEAAAAABQAAAAv#####AAAAAgAHQ1JlcGVyZQD#####AAAAAAEBAAAABwAAAAwAAAAKAAAAAAAADgAAAAAAAAAVAAAAAAAAAAAAAAAOAAAAAgAAABU#8AAAAAAAAAAAABEA#####wEAAAAACwACVzEAwCAAAAAAAADAOwAAAAAAAAUAAT#hGDFObkU6AAAACAAAABQB#####wAAAAAAAAAOAAAADgAAAAYAAAAOAAAAAP####8AAAABAA1DUG9pbnRCYXNlRW50Af####8A#wAAAQsAAlQxAAAAAAAAAAAAQAgAAAAAAAABAAEAAAANQBQAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAOAAAAAQAAABUAAAAAAAAAAAAAABUAAAAAAAAAAAAAABIA#####wAFbWVzYWIAAAANAAAAEAAAABMB#####wACYWIAJGludChtZXNhYioxMDAwMDAwMDAwKzAuNSkvMTAwMDAwMDAwMAAAAA8DAAAAGQIAAAAPAAAAAA8CAAAADgAAABEAAAAVQc3NZQAAAAAAAAAVP+AAAAAAAAAAAAAVQc3NZQAAAAAAAAAgAf####8A#wAAAAAAAAAAAAAAwCAAAAAAAAAAAAAQDwAAAAAAAQAAAAIAAAAACQAAABIAAAAGABdDdXJzZXVyRGlzY3JldEhvckdyYWR1ZQAAAAAABQAAAAcBAAAAGgAAAAAABG1pbmn#####AAAAAQAAAAAABG1heGn#####AAAAAQAAAAAAA3Bhc#####8AAAABAAAAAAAHcGFzZ3JhZP####8AAAABAAAAAAAAAAAAAP####8AAAAqAP####8BAAAAAA8AAAEAAQAAAAQBP#AAAAAAAAAAAAARAf####8AAAAAAA8AAAAAAAAAAAAAAEAIAAAAAAAABQABQGGAAAAAAAAAAAAFAAAAEwD#####AAduYmdyYWQwABppbnQoKG1heGktbWluaSkvcGFzKzAuNSkrMQAAAA8AAAAAGQIAAAAPAAAAAA8DAAAADwEAAAAOAAAAAQAAAA4AAAAAAAAADgAAAAIAAAAVP+AAAAAAAAAAAAAVP#AAAAAAAAAAAAATAP####8ACm5iZ3JhZHBhczAAHmludCgobWF4aS1taW5pKS9wYXNncmFkKzAuNSkrMQAAAA8AAAAAGQIAAAAPAAAAAA8DAAAADwEAAAAOAAAAAQAAAA4AAAAAAAAADgAAAAMAAAAVP+AAAAAAAAAAAAAVP#AAAAAAAAAAAAArAP####8BAAAAAAsAAk8xAMA4AAAAAAAAP#AAAAAAAAABAAAAAAQAAAABAf####8AAAAAAA0AAAEAAQAAAAkAAAAGAAAAAgD#####AQAAAAAPAAABAAEAAAAJAAAACgAAABEA#####wEAAAAACwACSjEAwDYAAAAAAADALgAAAAAAAAEAAb++GRTHsP1ZAAAACwAAABAA#####wAAAAkAAAAPAwAAAA4AAAACAAAADwEAAAAOAAAAAQAAAA4AAAAAAAAABwD#####AQAAAAALAAJJMQAAAAAAAAAAAEAAAAAAAAAAAQAAAAAGAAAADQAAACwA#####wAAAAABAQAAAAkAAAAOAAAADAAAAAAAAA4AAAAAAAAAFQAAAAAAAAAAAAAADgAAAAIAAAAVP#AAAAAAAAAAAAARAP####8BAAAAAAsAAlcxAMAgAAAAAAAAwDsAAAAAAAAFAAE#4RgxTm5FOgAAAAoAAAAUAf####8AAAAAAAAAEAAAAA4AAAAHAAAAEAAAAAAAAAASAP####8ABGFic3cAAAAPAAAAEAAAABMA#####wAHYWJzd0FycgAjaW50KGFic3cqMTAwMDAwMDAwMCswLjUpLzEwMDAwMDAwMDAAAAAPAwAAABkCAAAADwAAAAAPAgAAAA4AAAASAAAAFUHNzWUAAAAAAAAAFT#gAAAAAAAAAAAAFUHNzWUAAAAAAAAAIAD#####AQAAAAAAAAAAAAAAAEAYAAAAAAAAAAAAEAsAAAAAAAEAAAAAAAAAAAkAAAATAAAAFAH#####AAAAAAAAABQAAAAOAAAACAAAABAAAAAAAAAALQH#####AP8AAAELAAJUMQAAAAAAAAAAAEAIAAAAAAAAAQABAAAAD0AUAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAADgAAAAEAAAAVAAAAAAAAAAAAAAAVAAAAAAAAAAAAAAASAP####8ABW1lc2FiAAAADwAAABYAAAATAf####8AAmFiACRpbnQobWVzYWIqMTAwMDAwMDAwMCswLjUpLzEwMDAwMDAwMDAAAAAPAwAAABkCAAAADwAAAAAPAgAAAA4AAAAXAAAAFUHNzWUAAAAAAAAAFT#gAAAAAAAAAAAAFUHNzWUAAAAAAAAAIAH#####AP8AAAAAAAAAAAAAAMAgAAAAAAAAAAAAFg8AAAAAAAEAAAACAAAAAAkAAAAYAAAABgARQ3Vyc2V1ckRpc2NyZXRWZXIAAAAAAAQAAAAGAQAAABQAAAAAAARtaW5p#####wAAAAEAAAAAAARtYXhp#####wAAAAEAAAAAAANwYXP#####AAAAAQAAAAAAAAAAAAD#####AAAAEwD#####AAduYmdyYWQwABppbnQoKG1heGktbWluaSkvcGFzKzAuNSkrMQAAAA8AAAAAGQIAAAAPAAAAAA8DAAAADwEAAAAOAAAAAQAAAA4AAAAAAAAADgAAAAIAAAAVP+AAAAAAAAAAAAAVP#AAAAAAAAAAAAArAP####8BAAAAAAsAAk8xAMA4AAAAAAAAP#AAAAAAAAABAAAAAAMAAAAQAP####8AAAAFAAAADwMAAAAOAAAAAgAAAA8BAAAADgAAAAEAAAAOAAAAAAAAACoA#####wEAAAAADwAAAQABAAAAAwA#8AAAAAAAAAAAABEB#####wAAAAAADwAAAAAAAAAAAAAAQAgAAAAAAAAFAAFAXwAAAAAAAAAAAAcAAAABAf####8AAAAAAA0AAAEAAQAAAAUAAAAIAAAAAgD#####AQAAAAAPAAABAAEAAAAFAAAACQAAABEA#####wEAAAAACwACSjEAwDYAAAAAAADALgAAAAAAAAEAAb++GRTHsP1ZAAAACgAAAAcA#####wEAAAAACwACSTEAAAAAAAAAAABAAAAAAAAAAAEAAAAACAAAAAYAAAAsAP####8AAAAAAQEAAAAFAAAADAAAAAsAAAAAAAAOAAAAAAAAABUAAAAAAAAAAAAAAA4AAAACAAAAFT#wAAAAAAAAAAAAEQD#####AQAAAAALAAJXMQDAIAAAAAAAAMA7AAAAAAAABQABP+EYMU5uRToAAAAJAAAAFAH#####AAAAAAAAAA4AAAAOAAAABAAAAA4AAAAAAAAALQH#####AP8AAAELAAJUMQAAAAAAAAAAAEAIAAAAAAAAAQABAAAADUAUAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAADgAAAAEAAAAVAAAAAAAAAAAAAAAVAAAAAAAAAAAAAAASAP####8ABm1lc2FicwAAAA0AAAAQAAAAEwH#####AAJhYgAlaW50KG1lc2FicyoxMDAwMDAwMDAwKzAuNSkvMTAwMDAwMDAwMAAAAA8DAAAAGQIAAAAPAAAAAA8CAAAADgAAABEAAAAVQc3NZQAAAAAAAAAVP+AAAAAAAAAAAAAVQc3NZQAAAAAAAAAgAf####8A#wAAAEAkAAAAAAAAAAAAAAAAAAAAAAAQDwAAAAAAAAAAAAEAAAAACQAAABIAAAAGAApDdXJzZXVySG9yAAAAAAADAAAABQEAAAANAAAAAAAEbWluaf####8AAAABAAAAAAAEbWF4af####8AAAABAAAAAAAAAAAAAP####8AAAAqAP####8BAAAAAA8AAAEAAQAAAAIBP#AAAAAAAAAAAAARAf####8AAAAAAA8AAADACAAAAAAAAD#wAAAAAAAABQAAQF1AAAAAAAAAAAADAAAAEAD#####AAAAAgAAAA8DAAAADgAAAAAAAAAPAQAAAA4AAAAAAAAADgAAAAEAAAAHAP####8BAAAAAA0AAk8xAMAQAAAAAAAAQBAAAAAAAAAFAAAAAAQAAAAFAAAAEAD#####AAAAAgAAAA8DAAAADwEAAAAVP#AAAAAAAAAAAAAOAAAAAAAAAA8BAAAADgAAAAEAAAAOAAAAAAAAAAcA#####wEAAAAADQACSTEAwAAAAAAAAABACAAAAAAAAAUAAAAABAAAAAcAAAABAf####8AAAAAAA0AAAEAAQAAAAIAAAAEAAAAEQH#####AP8AAAERAAJrMQDAAAAAAAAAAEAAAAAAAAAAAQABP98t8t8t8t8AAAAJ#####wAAAAIAD0NNZXN1cmVBYnNjaXNzZQH#####AAFrAAAABgAAAAgAAAAKAAAAIAH#####AP8AAAAAAAAAAAAAAMAYAAAAAAAAAAAACg8AAAAAAAEAAAACAAAAAAIAAAALAAAABgAQQ3Vyc2V1ckhvckdyYWR1ZQAAAAAABAAAAAcBAAAAFQAAAAAABG1pbmn#####AAAAAQAAAAAABG1heGn#####AAAAAQAAAAAAB3Bhc2dyYWT#####AAAAAQAAAAAAAAAAAAD#####AAAAKgD#####AQAAAAAPAAABAAEAAAADAT#wAAAAAAAAAAAAEQH#####AAAAAAAPAAAAwAgAAAAAAAA#8AAAAAAAAAUAAUBcgAAAAAAAAAAABAAAABAA#####wAAAAMAAAAPAwAAAA4AAAAAAAAADwEAAAAOAAAAAAAAAA4AAAABAAAABwD#####AQAAAAANAAJPMQDAEAAAAAAAAEAQAAAAAAAABQAAAAAFAAAABgAAABAA#####wAAAAMAAAAPAwAAAA8BAAAAFT#wAAAAAAAAAAAADgAAAAAAAAAPAQAAAA4AAAABAAAADgAAAAAAAAAHAP####8BAAAAAA0AAkkxAMAAAAAAAAAAQAgAAAAAAAAFAAAAAAUAAAAIAAAAAQH#####AAAAAAANAAABAAEAAAADAAAABQAAABMA#####wAHbmJnZ3JhZAAeaW50KChtYXhpLW1pbmkpL3Bhc2dyYWQrMC41KSsxAAAADwAAAAAZAgAAAA8AAAAADwMAAAAPAQAAAA4AAAABAAAADgAAAAAAAAAOAAAAAgAAABU#4AAAAAAAAAAAABU#8AAAAAAAAAAAABEA#####wEAAAAAEQABVwAAAAAAAAAAAEAIAAAAAAAABQABP82J2J2J2J4AAAAKAAAALgD#####AARhYnN3AAAABwAAAAkAAAAMAAAAEwD#####AAdhYnN3QXJyACNpbnQoYWJzdyoxMDAwMDAwMDAwKzAuNSkvMTAwMDAwMDAwMAAAAA8DAAAAGQIAAAAPAAAAAA8CAAAADgAAAA0AAAAVQc3NZQAAAAAAAAAVP+AAAAAAAAAAAAAVQc3NZQAAAAAAAAAgAP####8BAAAAAAAAAAAAAAAAQBgAAAAAAAAAAAAMCwAAAAAAAQAAAAAAAAAACQAAAA4AAAAUAf####8AAAAAAAAADAAAAA4AAAALAAAADAAAAAAAAAAUAf####8AAAAAAAAADwAAAA4AAAALAAAADAAAAAAAAAARAf####8A#wAAAREAAmsxAMAAAAAAAAAAQAAAAAAAAAABAAE#4AAAAAAAAAAAAAoAAAAuAf####8AAWsAAAAHAAAACQAAABIAAAAgAf####8A#wAAAAAAAAAAAAAAwBgAAAAAAAAAAAASDwAAAAAAAQAAAAIAAAAAAgAAABMAAAAGAApDdXJzZXVyVmVyAAAAAAADAAAABQEAAAANAAAAAAAEbWluaf####8AAAABAAAAAAAEbWF4af####8AAAABAAAAAAAAAAAAAP####8AAAAQAP####8AAAACAAAADwMAAAAOAAAAAAAAAA8BAAAADgAAAAAAAAAOAAAAAQAAABAA#####wAAAAIAAAAPAwAAAA8BAAAAFT#wAAAAAAAAAAAADgAAAAAAAAAPAQAAAA4AAAABAAAADgAAAAAAAAAqAP####8BAAAAAA8AAAEAAQAAAAIAP#AAAAAAAAAAAAARAf####8AAAAAAA8AAADACAAAAAAAAD#wAAAAAAAABQABQF4AAAAAAAAAAAAFAAAABwD#####AQAAAAANAAJPMQDAEAAAAAAAAEAQAAAAAAAABQAAAAAGAAAAAwAAAAcA#####wEAAAAADQACSTEAwAAAAAAAAABACAAAAAAAAAUAAAAABgAAAAQAAAABAf####8AAAAAAA0AAAEAAQAAAAIAAAAGAAAAEQH#####AP8AAAERAAJrMQDAAAAAAAAAAEAAAAAAAAAAAQABP98t8t8t8t8AAAAJAAAALgH#####AAFrAAAABwAAAAgAAAAKAAAAIAH#####AP8AAADAIAAAAAAAAMAAAAAAAAAAAAAACg8AAAAAAAIAAAABAAAAAAIAAAALAAAABgAQQ3Vyc2V1clZlckdyYWR1ZQAAAAAABAAAAAcBAAAAFQAAAAAABG1pbmn#####AAAAAQAAAAAABG1heGn#####AAAAAQAAAAAAB3Bhc2dyYWT#####AAAAAQAAAAAAAAAAAAD#####AAAAEAD#####AAAAAwAAAA8DAAAADgAAAAAAAAAPAQAAAA4AAAAAAAAADgAAAAEAAAAQAP####8AAAADAAAADwMAAAAPAQAAABU#8AAAAAAAAAAAAA4AAAAAAAAADwEAAAAOAAAAAQAAAA4AAAAAAAAAEwD#####AAduYmdncmFkAB5pbnQoKG1heGktbWluaSkvcGFzZ3JhZCswLjUpKzEAAAAPAAAAABkCAAAADwAAAAAPAwAAAA8BAAAADgAAAAEAAAAOAAAAAAAAAA4AAAACAAAAFT#gAAAAAAAAAAAAFT#wAAAAAAAAAAAAKgD#####AQAAAAAPAAABAAEAAAADAD#wAAAAAAAAAAAAEQH#####AAAAAAAPAAAAwAgAAAAAAAA#8AAAAAAAAAUAAUBeAAAAAAAAAAAABwAAAAcA#####wEAAAAADQACTzEAwBAAAAAAAABAEAAAAAAAAAUAAAAACAAAAAQAAAAHAP####8BAAAAAA0AAkkxAMAAAAAAAAAAQAgAAAAAAAAFAAAAAAgAAAAFAAAAAQH#####AAAAAAANAAABAAEAAAADAAAACAAAABEA#####wEAAAAAEQABVwAAAAAAAAAAAEAIAAAAAAAABQABP82J2J2J2J4AAAALAAAALgD#####AARhYnN3AAAACQAAAAoAAAAMAAAAEwD#####AAdhYnN3QXJyACNpbnQoYWJzdyoxMDAwMDAwMDAwKzAuNSkvMTAwMDAwMDAwMAAAAA8DAAAAGQIAAAAPAAAAAA8CAAAADgAAAA0AAAAVQc3NZQAAAAAAAAAVP+AAAAAAAAAAAAAVQc3NZQAAAAAAAAAgAP####8BAAAAAMAYAAAAAAAAAAAAAAAAAAAAAAAMCwAAAAAAAgAAAAEAAAAACQAAAA4AAAAUAf####8AAAAAAAAADAAAAA4AAAAGAAAADAAAAAAAAAAUAf####8AAAAAAAAADwAAAA4AAAAGAAAADAAAAAAAAAARAf####8A#wAAAREAAmsxAMAAAAAAAAAAQAAAAAAAAAABAAE#33BH3BH3BAAAAAsAAAAuAf####8AAWsAAAAJAAAACgAAABIAAAAgAf####8A#wAAAEAkAAAAAAAAAAAAAAAAAAAAAAASDwAAAAAAAAAAAAEAAAAAAgAAABMAAAAGABdDdXJzZXVyRGlzY3JldFZlckdyYWR1ZQAAAAAABQAAAAcBAAAAGgAAAAAABG1pbmn#####AAAAAQAAAAAABG1heGn#####AAAAAQAAAAAAA3Bhc#####8AAAABAAAAAAAHcGFzZ3JhZP####8AAAABAAAAAAAAAAAAAP####8AAAATAP####8AB25iZ3JhZDAAGmludCgobWF4aS1taW5pKS9wYXMrMC41KSsxAAAADwAAAAAZAgAAAA8AAAAADwMAAAAPAQAAAA4AAAABAAAADgAAAAAAAAAOAAAAAgAAABU#4AAAAAAAAAAAABU#8AAAAAAAAAAAABMA#####wAKbmJncmFkcGFzMAAeaW50KChtYXhpLW1pbmkpL3Bhc2dyYWQrMC41KSsxAAAADwAAAAAZAgAAAA8AAAAADwMAAAAPAQAAAA4AAAABAAAADgAAAAAAAAAOAAAAAwAAABU#4AAAAAAAAAAAABU#8AAAAAAAAAAAACsA#####wEAAAAACwACTzEAwDgAAAAAAAA#8AAAAAAAAAEAAAAABAAAABAA#####wAAAAcAAAAPAwAAAA4AAAACAAAADwEAAAAOAAAAAQAAAA4AAAAAAAAAKgD#####AQAAAAAPAAABAAEAAAAEAD#wAAAAAAAAAAAAEQH#####AAAAAAAPAAAAAAAAAAAAAABACAAAAAAAAAUAAUBfAAAAAAAAAAAACQAAAAEB#####wAAAAAADQAAAQABAAAABwAAAAoAAAACAP####8BAAAAAA8AAAEAAQAAAAcAAAALAAAAEQD#####AQAAAAALAAJKMQDANgAAAAAAAMAuAAAAAAAAAQABv74ZFMew#VkAAAAMAAAABwD#####AQAAAAALAAJJMQAAAAAAAAAAAEAAAAAAAAAAAQAAAAAKAAAACAAAACwA#####wAAAAABAQAAAAcAAAAOAAAADQAAAAAAAA4AAAAAAAAAFQAAAAAAAAAAAAAADgAAAAIAAAAVP#AAAAAAAAAAAAARAP####8BAAAAAAsAAlcxAMAgAAAAAAAAwDsAAAAAAAAFAAE#4RgxTm5FOgAAAAsAAAAUAf####8AAAAAAAAAEAAAAA4AAAAFAAAAEAAAAAAAAAASAP####8ABGFic3cAAAAPAAAAEAAAABMA#####wAHYWJzd0FycgAjaW50KGFic3cqMTAwMDAwMDAwMCswLjUpLzEwMDAwMDAwMDAAAAAPAwAAABkCAAAADwAAAAAPAgAAAA4AAAASAAAAFUHNzWUAAAAAAAAAFT#gAAAAAAAAAAAAFUHNzWUAAAAAAAAAIAD#####AQAAAADAGAAAAAAAAAAAAAAAAAAAAAAAEAsAAAAAAAIAAAABAAAAAAkAAAATAAAAFAH#####AAAAAAAAABQAAAAOAAAABgAAABAAAAAAAAAALQH#####AP8AAAELAAJUMQAAAAAAAAAAAEAIAAAAAAAAAQABAAAAD0AUAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAADgAAAAEAAAAVAAAAAAAAAAAAAAAVAAAAAAAAAAAAAAASAP####8ABm1lc2FicwAAAA8AAAAWAAAAEwH#####AAFrACVpbnQobWVzYWJzKjEwMDAwMDAwMDArMC41KS8xMDAwMDAwMDAwAAAADwMAAAAZAgAAAA8AAAAADwIAAAAOAAAAFwAAABVBzc1lAAAAAAAAABU#4AAAAAAAAAAAABVBzc1lAAAAAAAAACAB#####wD#AAAAQCQAAAAAAAAAAAAAAAAAAAAAABYPAAAAAAAAAAAAAQAAAAAJAAAAGAAAAAEAAAABAAAAGAD#####AAJwaQAWMy4xNDE1OTI2NTM1ODk3OTMyMzg0NgAAABVACSH7VEQtGP###############w==",
	  // Un tableau contenant les chaînes Base64 correspondant au filtarge des outils
	  // Indice 0 : Chaine Base64 correspondant au niveau élémentaire
	  // Indice 1 : Chaine Base64 correspondant au niveau collège
	  // Indice 2 : Chaine Base64 correspondant au niveau lycée sans nombres complexes
	  // Indice 3 : Chaine Base64 correspondant au niveau lycée avec nombres complexes
	  levels: ["TWF0aEdyYXBoSmF2YTEuMAAAABA+TMzNAANmcmH###8BAP8BAAAAWwAAgScAAIAMAACAeQAAgHoAAIB7AACAJAAAgPEAAIGDAACBcQAAgOoAAIDpAACAZQAAfRAAAIDrAACAFAAAgVIAAIFTAACAGwAAgBwAAIAbAACAGQAAgQsAAIAjAACAIQAAgMcAAIEEAACBIAAAgOgAAIDYAACA7AAAgO0AAIFiAACBZAAAgHIAAIF5AACAZwAAgGMAAIBoAACAyQAAgEoAAIEXAACBFwAAfQoAAH0LAAB9DgAAfQ8AAH0kAACAUAAAgK8AAIEsAACAcAAAgOQAAIDnAACBbAAAgN0AAH0ZAAB9GAAAgPAAAIEIAACAcQAAfSsAAH0tAAB9JgAAfSUAAIEiAAB9JwAAfSkAAIGjAACBpAAAgW8AAIFwAACBeAAAgXcAAIFtAACBbgAAgOUAAIDuAACBcgAAfSoAAH0sAACAMQAAgC4AAIDyAACBdQAAgaUAAH0fAAB9IAAAfSEAAH0iAACAuwAAgLwAAAAAAiYAAAGYAAAAAAAAAAAAAAABAAAAAf####8AAAABAApDQ2FsY0NvbnN0AP####8AAnBpABYzLjE0MTU5MjY1MzU4OTc5MzIzODQ2#####wAAAAEACkNDb25zdGFudGVACSH7VEQtGP###############w==", "TWF0aEdyYXBoSmF2YTEuMAAAABA+TMzNAANmcmH###8BAP8BAAAAVwAAgScAAIAMAACAeQAAgHoAAIB7AACAJAAAgPEAAIGDAACBcQAAgOoAAIDpAACAZQAAfRAAAIDrAACAFAAAgVIAAIFTAACAGwAAgBwAAIAbAACAGQAAgQsAAIAjAACAIQAAgMcAAIEEAACA2AAAgOwAAIDtAACBYgAAgWQAAIByAACBeQAAgGcAAIBjAACAaAAAgMkAAIBKAACBFwAAgRcAAH0KAAB9CwAAfQ4AAH0PAAB9JAAAgFAAAICvAACBLAAAgHAAAIDkAACA5wAAgWwAAIDdAAB9GQAAfRgAAIDwAACBCAAAgHEAAH0rAAB9LQAAfSYAAH0lAACBIgAAfScAAH0pAACBowAAgaQAAIFvAACBcAAAgXgAAIF3AACBbQAAgW4AAIDlAACA7gAAgXIAAH0qAAB9LAAAgDEAAIAuAACA8gAAgXUAAIGlAAB9HwAAfSAAAH0hAAB9IgAAAAACJgAAAZwAAAAAAAAAAAAAAAEAAAAB#####wAAAAEACkNDYWxjQ29uc3QA#####wACcGkAFjMuMTQxNTkyNjUzNTg5NzkzMjM4NDb#####AAAAAQAKQ0NvbnN0YW50ZUAJIftURC0Y################", "TWF0aEdyYXBoSmF2YTEuMAAAABA+TMzNAANmcmH###8BAP8BAAAADgAAgXEAAIF5AACBbwAAgXAAAIF4AACBdwAAgW0AAIFuAACA5QAAgO4AAIFyAAB9KgAAfSwAAIF1AAAAAAImAAABmAAAAAAAAAAAAAAAAQAAAAH#####AAAAAQAKQ0NhbGNDb25zdAD#####AAJwaQAWMy4xNDE1OTI2NTM1ODk3OTMyMzg0Nv####8AAAABAApDQ29uc3RhbnRlQAkh+1RELRj###############8=", "TWF0aEdyYXBoSmF2YTEuMAAAABA+TMzNAANmcmH###8BAP8BAAAAAAAAAAACJgAAAZgAAAAAAAAAAAAAAAEAAAAB#####wAAAAEACkNDYWxjQ29uc3QA#####wACcGkAFjMuMTQxNTkyNjUzNTg5NzkzMjM4NDb#####AAAAAQAKQ0NvbnN0YW50ZUAJIftURC0Y################"],
	
	  topIconSize: 32,
	  leftIconSize: 34,
	  arrowIconWidth: 16,
	  indicationSize: 20,
	  buttonStopWidth: 48,
	  buttonBackGroundColor: "#F4F4F5",
	  buttonFrameColor: "#BCBCBF",
	  buttonActivatedBackGroundColor: "#B8E2E5",
	  buttonStroke: "#BCBCBF",
	  buttonFill: "#F4F4F5",
	  rightPanelWidth: 92, // De préférence un multiple de 4 plus 4
	  colorButtonHeight: 18,
	  sliderThickness: 1,
	  lineStyle: StyleTrait.styleTraitContinu, // Style de trait au démarrage
	  sliderColor: "black",
	  sliderButtonColor: "blue",
	  sliderRadius: 4,
	  sliderDigitsFontSize: 13,
	  sliderGap: 4, // L'espace en pixels entre le segment et le bord gauche
	  sliderHeight: 20,
	  colorChoicePanelHeight: 24
	};
	constantes.svgPanelWidth = constantes.leftIconSize + constantes.arrowIconWidth;
	constantes.toolbarHeight = constantes.topIconSize + 2;
	constantes.colorButtonWidth = (constantes.rightPanelWidth - 4) / 4;
	constantes.lineStyleWidth = 0.6 * constantes.rightPanelWidth;
	constantes.buttonStyleWidth = (constantes.rightPanelWidth - constantes.lineStyleWidth) / 2;
	constantes.lineStyleButtonHeight = 5 * constantes.buttonStyleWidth / 6;
	constantes.buttonMarqueWidth = constantes.rightPanelWidth / 5;
	constantes.buttonFillWidth = constantes.rightPanelWidth / 3;
	constantes.buttonFillHeight = 15;
	constantes.rapportZoomPlus = 1.2;
	constantes.rapportZoomMoins = 1 / constantes.rapportZoomPlus;
	constantes.tableStyleTrait = [[StyleTrait.styleTraitContinu, "traitContinu"], [StyleTrait.styleTraitPointille, "traitPointille"], [StyleTrait.styleTraitTrait, "traitTrait"], [StyleTrait.styleTraitPointPoint, "traitPointPoint"], [StyleTrait.styleTraitPointPointPoint, "traitPointPointPoint"], [StyleTrait.styleTraitTraitLongTrait, "traitLongTrait"]];
	constantes.colorPalette = [["#FFFFFF", "#FAFAFA", "##F2F2F2", "#E6E6E6", "#D8D8D8", "#BDBDBD", "#A4A4A4", "#848484"], ["#FBEFF2", "#F8E0E6", "#F6CED8", "#F5A9BC", "#F7819F", "#FA5882", "#FE2E64", "#FF0040"], ["#FBEFFB", "#F8E0F7", "#F6CEF5", "#F5A9F2", "#F781F3", "#FA58F4", "#FE2EF7", "#FF00FF"], ["#F5EFFB", "#ECE0F8", "#E3CEF6", "#D0A9F5", "#BE81F7", "#AC58FA", "#9A2EFE", "#8000FF"], ["#EFEFFB", "#E0E0F8", "#CECEF6", "#A9A9F5", "#8181F7", "#5858FA", "#2E2EFE", "#0000FF"], ["#EFFBFB", "#E0F8F7", "#CEF6F5", "#A9F5F2", "#81F7F3", "#58FAF4", "#2EFEF7", "#00FFFF"], ["#F2FBEF", "#F5FBEF", "#ECF8E0", "#E3F6CE", "#D0F5A9", "#BEF781", "#ACFA58", "#9AFE2E"], ["#FBFBEF", "#F7F8E0", "#F5F6CE", "#F2F5A9", "#F3F781", "#F4FA58", "#F7FE2E", "#FFFF00"], ["#FBF8EF", "#F7F2E0", "#F5ECCE", "#F3E2A9", "#F5DA81", "#F7D358", "#FACC2E", "#FFBF00"]];
	module.exports = constantes;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	var NatObj = __webpack_require__(3);
	var StyleFleche = __webpack_require__(190);
	var kernel = __webpack_require__(8);
	var CSegment = __webpack_require__(134);
	module.exports = CVecteur;
	
	/**
	 * Classe représentant un vecteur tracé sur le figure défini à l'aide de deux points
	 * donnant l'origine et l'extrémité.
	 * @constructor
	 * @extends CSegment
	 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
	 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
	 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
	 * @param {mtg32.Color} couleur : La couleur de l'objet.
	 * @param {Boolean} masque : true si l'objet est masqué.
	 * @param {mtg32.StyleTrait} style : Le style de tracé.
	 * @param {CPt} point1 : L'origine du vecteur.
	 * @param {CPt} point2 : L'extrémité du vecteur.
	 * @param {StyleFleche} motifFleche : Donne le style utilisé pour la flèche.
	 * @returns {CVecteur}
	 */
	function CVecteur(listeProprietaire, impProto, estElementFinal, couleur, masque, style, point1, point2, motifFleche) {
	  if (arguments.length === 1) CSegment.call(this, listeProprietaire);else {
	    CSegment.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, style, point1, point2);
	    this.motifFleche = motifFleche;
	  }
	}
	CVecteur.prototype = new CSegment();
	CVecteur.prototype.constructor = CVecteur;
	CVecteur.prototype.superClass = "CSegment";
	CVecteur.prototype.className = "CVecteur";
	
	CVecteur.prototype.getClone = function (listeSource, listeCible) {
	  var ind1 = listeSource.indexOf(this.impProto);
	  var ind2 = listeSource.indexOf(this.point1);
	  var ind3 = listeSource.indexOf(this.point2);
	  return new CVecteur(listeCible, listeCible.get(ind1, "CImplementationProto"), this.estElementFinal, this.couleur, this.masque, this.style, listeCible.get(ind2, "CPt"), listeCible.get(ind3, "CPt"), this.motifFleche);
	};
	CVecteur.prototype.confonduAvec = function (p) {
	  if (p.className === this.className) {
	    return this.point1 === p.point1 && this.point2 === p.point2;
	  } else return false;
	};
	CVecteur.prototype.createg = function () {
	  var g = kernel.cens("g", {
	    "pointer-events": "none"
	  });
	  // var couleur = this.couleur.rgb(); Modifié version 4.9.9.4
	  var couleur = this.color;
	  var style = "";
	  var strokewidth = this.style.strokeWidth;
	  style += "stroke-width:" + strokewidth + ";";
	  style += "stroke:" + couleur + ";";
	  var g1 = CSegment.prototype.createg.call(this);
	  g.appendChild(g1);
	  g.appendChild(StyleFleche.creeFleche(this.x1, this.y1, this.x2, this.y2, this.motifFleche, this.listeProprietaire, couleur, style));
	  return g;
	};
	CVecteur.prototype.trace = function (svg, couleurFond, transparence) {
	  var g = this.createg();
	  g.setAttribute("id", this.id);
	  svg.appendChild(g);
	  this.g = g;
	};
	CVecteur.prototype.update = function (svg) {
	  var oldg = this.g;
	  var g = this.createg();
	  svg.replaceChild(g, oldg);
	  g.setAttribute("id", this.id);
	  this.g = g;
	};
	CVecteur.prototype.getNature = function () {
	  return NatObj.NVecteur;
	};
	CVecteur.prototype.chaineDesignation = function () {
	  return "desVecteur";
	};
	CVecteur.prototype.read = function (inps, list) {
	  CSegment.prototype.read.call(this, inps, list);
	  this.motifFleche = inps.readByte();
	};
	CVecteur.prototype.write = function (oups, list) {
	  CSegment.prototype.write.call(this, oups, list);
	  oups.writeByte(this.motifFleche);
	};

/***/ },
/* 270 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Contient les textes utilisés dans le logiciel en langue Française
	 * @type mtg32.texte_fr
	 */
	var texte_fr = {
	  step: "pas",
	  var1: "Changement de la valeur de la variable ",
	  var2: "Entrez une valeur comprise entre ",
	  et: " et ",
	  Incorrect: "Entrée non valide",
	  //Chaînes servant suivant la langue à reconstruire les formules mathématiques
	  abs: "abs",
	  intgr: "int",
	  sqrt: "sqrt",
	  rac: "rac",
	  sin: "sin",
	  cos: "cos",
	  tan: "tan",
	  ln: "ln",
	  exp: "exp",
	  arctan: "arctan",
	  arccos: "arccos",
	  arcsin: "arcsin",
	  ch: "ch",
	  sh: "sh",
	  th: "th",
	  argch: "argch",
	  argsh: "argsh",
	  argth: "argth",
	  rand: "rand",
	  conj: "conj",
	  arg: "arg",
	  re: "re",
	  im: "im",
	  maxi: "max",
	  mini: "min",
	  gcd: "pgcd",
	  lcm: "ppcm",
	  ncr: "nCr",
	  npr: "nPr",
	  mod: "mod",
	  si: "si",
	  integrale: "integrale",
	  fact: "fact",
	  somme: "somme",
	  produit: "produit",
	  left: "gauche",
	  right: "droit"
	
	};
	
	module.exports = texte_fr;

/***/ },
/* 271 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Contient les textes utilisés dans le logiciel en langue espagnole.
	 * @type type
	 */
	var texte_es = {
	  step: "paso",
	  var1: "Nuevo valor para la variable ",
	  var2: "Entre un valor comprendido entre ",
	  et: " y ",
	  incorrect: "Entrada incorrecta",
	  //Chaînes servant suivant la langue à reconstruire les formules mathématiques
	  abs: "abs",
	  intgr: "int",
	  sqrt: "sqrt",
	  rac: "rac",
	  sin: "sen",
	  cos: "cos",
	  tan: "tan",
	  ln: "ln",
	  exp: "exp",
	  arctan: "arctan",
	  arccos: "arccos",
	  arcsin: "arcsen",
	  ch: "cosh",
	  sh: "senh",
	  th: "tanh",
	  argch: "argcosh",
	  argsh: "argsenh",
	  argth: "argtanh",
	  rand: "rand",
	  conj: "conj",
	  arg: "arg",
	  re: "re",
	  im: "im",
	
	  maxi: "máx",
	  mini: "mín",
	  gcd: "mcd",
	  lcm: "mcm",
	  ncr: "nCr",
	  npr: "nPr",
	  mod: "mod",
	  si: "si",
	  integrale: "integral",
	  fact: "fact",
	  somme: "suma",
	  produit: "producto",
	  left: "izquierda",
	  right: "derecha"
	};
	
	module.exports = texte_es;

/***/ },
/* 272 */
/***/ function(module, exports) {

	"use strict";
	
	/* 
	 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
	 * http://www.mathgraph32.org/
	 * @Author Yves Biton (yves.biton@sesamath.net)
	 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
	 */
	
	/**
	 * Contient les textes utilisés dans le logiciel en langue anglaise
	 * @type mtg32.texte_en
	 */
	var texte_en = {
	  step: "pas",
	  var1: "New value for variable ",
	  var2: "Enter a value between ",
	  et: " and ",
	  //Chaînes servant suivant la langue à reconstruire les formules mathématiques
	
	
	  abs: "abs",
	  intgr: "int",
	  sqrt: "sqrt",
	  rac: "sqrt",
	  sin: "sin",
	  cos: "cos",
	  tan: "tan",
	  ln: "log",
	  exp: "exp",
	  arctan: "atan",
	  arccos: "acos",
	  arcsin: "asin",
	  ch: "cosh",
	  sh: "sinh",
	  th: "tanh",
	  argch: "acosh",
	  argsh: "asinh",
	  argth: "atanh",
	  rand: "rand",
	  conj: "conj",
	  arg: "angle",
	  re: "re",
	  im: "im",
	
	  maxi: "max",
	  mini: "min",
	  gcd: "gcd",
	  lcm: "lcm",
	  ncr: "nCr",
	  npr: "nPr",
	  mod: "mod",
	  si: "if",
	  integrale: "integral",
	  fact: "fact",
	  somme: "sum",
	  produit: "prod",
	  left: "left",
	  right: "right"
	
	};
	
	module.exports = texte_en;

/***/ },
/* 273 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// mtg32jsmin.js